import { ref as dt, toRef as Ga, computed as _t, watch as di, onMounted as cf, onUnmounted as g4, nextTick as Ta, defineComponent as cl, useSlots as nL, resolveComponent as El, openBlock as Qe, createBlock as _l, Transition as du, withCtx as kl, withDirectives as pi, createElementVNode as qn, normalizeClass as xt, createElementBlock as yn, createVNode as dl, createCommentVNode as st, toDisplayString as It, unref as Zr, renderSlot as el, vShow as Pi, inject as _s, normalizeStyle as Hi, onUpdated as foe, provide as vs, h as sw, mergeProps as Ni, normalizeProps as doe, createTextVNode as Ir, Fragment as Ii, renderList as ru, resolveDynamicComponent as ap, withModifiers as Oi, pushScopeId as tL, popScopeId as lL, onBeforeUpdate as poe, resolveDirective as w4, withKeys as Ei, watchEffect as ga, mergeDefaults as xz, reactive as p1, createSlots as Sz, toRefs as w3, isRef as om, getCurrentInstance as v4, Teleport as v3, toHandlers as AO, onBeforeUnmount as moe, onActivated as goe, onDeactivated as woe, useCssVars as Ez, createApp as rL } from "vue";
const ow = (e, n) => n in e ? dt(e[n]) : null;
var _r = /* @__PURE__ */ ((e) => (e.NEUTRAL = "neutral", e.PRIMARY = "primary", e.SECONDARY = "secondary", e.SUCCESS = "success", e.DANGER = "danger", e.ERROR = "error", e.WARNING = "warning", e.BLACK = "black", e))(_r || {}), sl = /* @__PURE__ */ ((e) => (e.B = "bottom", e.BL = "bottom-left", e.BR = "bottom-right", e.L = "left", e.LT = "left-top", e.LB = "left-bottom", e.R = "right", e.RT = "right-top", e.RB = "right-bottom", e.T = "top", e.TL = "top-left", e.TR = "top-right", e.C = "center", e))(sl || {});
function oY(e) {
  if (e === "top") return "bottom";
  if (e === "bottom") return "top";
  if (e === "left") return "right";
  if (e === "right") return "left";
}
var Oz = /* @__PURE__ */ ((e) => (e.BIG = "lg", e.NORMAL = "md", e.SMALL = "sm", e))(Oz || {}), ex = /* @__PURE__ */ ((e) => (e.UP = "up", e.DOWN = "down", e))(ex || {});
const l2 = (e) => {
  const n = dt(!1), t = dt(null), l = Ga(e, "disabled") || dt(!1), r = Ga(e, "hoverable") || dt(!1), u = _t(
    () => t.value ? `fade-${t.value.split("-")[0]}` : ""
  ), o = dt(null), a = dt(e.permanent), h = dt(e.autoposition), s = Ga(e, "popover") || dt(null), d = Ga(e, "trigger") || dt(null);
  di(
    () => e.popover,
    (xe) => {
      s.value = xe;
    }
  ), di(
    () => e.trigger,
    (xe) => {
      d.value = xe;
    }
  );
  const p = dt({
    x: 0,
    y: 0
  });
  function _(xe) {
    l.value || xe.target === s.value && !r.value || (G(), clearTimeout(o.value));
  }
  function R(xe) {
    a.value || (o.value = setTimeout(() => {
      L(xe);
    }, 400));
  }
  function F(xe) {
    if (!xe) return !1;
    const $e = xe?.relatedTarget ?? xe?.target;
    return !$e || xe.type === "click" && ($e === d.value || d.value.contains($e)) ? !1 : [
      $e === s.value,
      s.value.contains($e),
      ...(e.allowedMouseOverTransitionElements ?? []).map(
        (E) => !!$e?.closest(E)
      )
    ].some((E) => E);
  }
  function L(xe, $e = !1) {
    if (xe.stopPropagation(), $e && (n.value = !1), n.value) {
      if (F(xe))
        return;
      n.value = !1;
    }
  }
  function G() {
    !n.value && !l.value && (n.value = !0, J());
  }
  async function J() {
    await Ta();
    const xe = s.value, $e = d.value;
    if (!(!xe || !$e)) {
      if (h.value) {
        const [je, E] = aY(
          $e,
          xe,
          e.placement.value ?? e.placement,
          1,
          !0,
          e.arrowCalculation
        );
        t.value = je, p.value = E;
      } else if (e.placement) {
        const [, je] = aY(
          $e,
          xe,
          e.placement.value ?? e.placement,
          1,
          !1,
          e.arrowCalculation
        );
        t.value = e.placement, p.value = je;
      }
      if (!e.disableSetPosition || e.isDropdown) {
        const je = $e.getBoundingClientRect(), E = xe.querySelector("ul.menu-pop-up")?.getBoundingClientRect(), P = t.value?.includes("-right");
        $e.clientWidth + (P ? (E?.width ?? 0) + (je.width - (E?.width ?? 0)) : 0), xe.style.top = `${p.value.y}px`, xe.style.left = e.isDropdown ? `${p.value.x + (P ? (E?.width ?? 0) * -1 : 0)}px` : `${p.value.x}px`;
      }
    }
  }
  let we;
  function ce() {
    clearTimeout(we), we = setTimeout(
      () => requestAnimationFrame(J),
      400
    );
  }
  return cf(() => {
    window.addEventListener("resize", ce), window.addEventListener("scroll", ce);
  }), g4(() => {
    window.removeEventListener("resize", ce), window.removeEventListener("scroll", ce);
  }), {
    show: n,
    placement: t,
    disabled: l,
    clickable: r,
    transition: u,
    visionTimer: o,
    popover: s,
    trigger: d,
    position: p,
    permanent: a,
    handleMouseEnter: _,
    handleMouseLeave: R,
    hidePopover: L,
    showPopover: G,
    setPopoverPosition: J
  };
};
function aY(e, n, t = null, l = 15, r = !0, u = !0) {
  const o = e.getBoundingClientRect(), a = n.getBoundingClientRect(), h = window.pageYOffset || document.documentElement.scrollTop, s = window.pageXOffset || document.documentElement.scrollLeft, d = window.innerWidth || document.documentElement.clientWidth, p = window.innerHeight || document.documentElement.clientHeight, _ = u ? u_(3) : 0, R = u ? u_(3) : 0, F = u ? u_(2) : 0, L = u ? u_(1) : 0, G = u ? u_(1) : 0, J = r ? [
    .../* @__PURE__ */ new Set([
      ...t ? [t] : [sl.C],
      sl.T,
      sl.B,
      sl.R,
      sl.L,
      ...Object.values(sl)
    ])
  ] : t ? [t] : [sl.C];
  let we = 0, ce = 0;
  for (const je of J) {
    switch (we = 0, ce = 0, je) {
      case sl.T:
        we = o.top - a.height - l + h - L, ce = o.left + o.width / 2 - a.width / 2 - s;
        break;
      case sl.RT:
        we = o.top - a.height - l + h + L + F, ce = o.right + l - s + G;
        break;
      case sl.TR:
        we = o.top - a.height - l + h - L, ce = o.right + l - s - _;
        break;
      case sl.RB:
        we = o.bottom + l + h - L - F, ce = o.right + l - s + G;
        break;
      case sl.R:
        we = o.top + o.height / 2 - a.height / 2 + h, ce = o.right + l - s + G;
        break;
      case sl.BR:
        we = o.bottom + l + h + L, ce = o.right + l - s - _;
        break;
      case sl.BL:
        we = o.bottom + l + h + L, ce = o.left - a.width - l - s + R;
        break;
      case sl.B:
        we = o.bottom + l + h + L, ce = o.left + o.width / 2 - a.width / 2 - s;
        break;
      case sl.LB:
        we = o.bottom + l + h - L - F, ce = o.left - a.width - l - s - L;
        break;
      case sl.L:
        we = o.top + o.height / 2 - a.height / 2 + h, ce = o.left - a.width - l - s - G;
        break;
      case sl.LT:
        we = o.top - a.height - l + h + L + F, ce = o.left - a.width - l - s - L;
        break;
      case sl.TL:
        we = o.top - a.height - l + h - L, ce = o.left - a.width - l - s + R;
        break;
      default:
        continue;
    }
    if (!r || h < we && s < ce && we + h >= l && we + a.height <= h + p - l && ce + s >= l && ce + a.width <= s + d - l)
      return [
        je,
        {
          x: ce,
          y: we
        }
      ];
  }
  const xe = (p - a.height) / 2, $e = (d - a.width) / 2;
  return [
    sl.C,
    {
      x: $e,
      y: xe
    }
  ];
}
function u_(e) {
  const n = getComputedStyle(document.documentElement), t = e * parseFloat(n.fontSize);
  return Number.isNaN(t) ? 1 : t;
}
const voe = {
  [_r.PRIMARY]: "sms",
  [_r.SUCCESS]: "check-circle",
  [_r.WARNING]: "warning",
  [_r.DANGER]: "error"
};
_r.PRIMARY, _r.SUCCESS, _r.DANGER, _r.WARNING;
const yoe = {
  key: 0,
  class: "lp-alert-iconbox"
}, _oe = {
  key: 0,
  class: "lp-alert-title"
}, xoe = {
  key: 1,
  class: "lp-alert-slot"
}, Soe = {
  key: 2,
  class: "lp-alert-slot"
}, I_ = /* @__PURE__ */ cl({
  name: "lp-alert",
  __name: "LpAlert",
  props: {
    type: { default: _r.PRIMARY },
    showIcon: { type: Boolean, default: !0 },
    closable: { type: Boolean, default: !1 },
    iconbox: { type: Boolean, default: !1 },
    visible: { type: Boolean, default: !0 },
    title: {},
    body: {}
  },
  emits: ["on-close"],
  setup(e, { emit: n }) {
    const t = e, l = n, r = nL(), u = ow(r, "default"), o = () => l("on-close"), a = _t(() => voe[t.type]), h = _t(() => [
      "lp-alert",
      `lp-alert-${t.type}`,
      !t.body && !u?.value && "lp-alert-sm"
    ]);
    return (s, d) => {
      const p = El("lp-icon");
      return Qe(), _l(du, { name: "fade" }, {
        default: kl(() => [
          pi(qn("div", {
            class: xt(h.value)
          }, [
            s.showIcon ? (Qe(), yn("div", yoe, [
              dl(p, {
                box: s.iconbox,
                class: "lp-alert-icon",
                name: a.value
              }, null, 8, ["box", "name"])
            ])) : st("", !0),
            qn("div", null, [
              s.title ? (Qe(), yn("p", _oe, It(s.title), 1)) : st("", !0),
              !Zr(u) && s.body ? (Qe(), yn("p", xoe, It(s.body), 1)) : st("", !0),
              Zr(u) ? (Qe(), yn("p", Soe, [
                el(s.$slots, "default")
              ])) : st("", !0)
            ]),
            s.closable ? (Qe(), _l(p, {
              key: 1,
              name: "close",
              class: "lp-alert-close text-dark-muted",
              onClick: o
            })) : st("", !0)
          ], 2), [
            [Pi, s.visible]
          ])
        ]),
        _: 3
      });
    };
  }
});
I_.install = (e) => {
  e.component(I_.name, I_);
};
const Eoe = (e = "", n = 1) => e ? e.split(" ").splice(0, n).reduce((l, r) => l += r[0], "").toUpperCase() : "", Ooe = ["src"], koe = {
  key: 1,
  class: "lp-avatar-text"
}, boe = {
  key: 2,
  class: "lp-avatar-icon",
  viewBox: "64 64 896 896"
}, Toe = /* @__PURE__ */ qn("path", { d: "M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z" }, null, -1), joe = [
  Toe
], GS = /* @__PURE__ */ cl({
  name: "lp-avatar",
  __name: "LpAvatar",
  props: {
    src: { default: "" },
    text: { default: "" },
    color: { default: "" },
    size: { default: "40px" },
    square: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = _s("square", null), l = _s("size", null), r = _t(() => Eoe(n.text, 2)), u = _t(() => l || n.size), o = _t(() => ({
      "lp-avatar-sq": t || n.square
    })), a = _t(() => ({
      "background-color": n.color || "",
      "line-height": u.value,
      width: u.value,
      height: u.value
    }));
    return (h, s) => (Qe(), yn("span", {
      class: xt(["lp-avatar", o.value]),
      style: Hi(a.value)
    }, [
      h.src ? (Qe(), yn("img", {
        key: 0,
        class: "lp-avatar-img",
        src: h.src,
        alt: ""
      }, null, 8, Ooe)) : h.text ? (Qe(), yn("span", koe, It(r.value), 1)) : (Qe(), yn("svg", boe, joe))
    ], 6));
  }
});
GS.install = (e) => {
  e.component(GS.name, GS);
};
const cY = (e) => e().reduce((n, t) => {
  const l = t.children?.length ? t.children : [t];
  return [...n, ...l];
}, []), Aoe = (e, n) => {
  const t = dt(
    n.default ? cY(n.default) : []
  );
  foe(() => {
    const u = n.default ? cY(n.default) : [];
    u.length !== t.value.length && (t.value = u);
  });
  const l = _t(
    () => t.value.slice(0, e.max || t.value.length)
  ), r = _t(() => ({
    show: e.max ? t.value.length > e.max : !1,
    count: e.max ? t.value.length - e.max : 0
  }));
  return {
    totalChildrenVNodes: l,
    label: r
  };
}, ZS = cl({
  name: "lp-avatar-group",
  props: {
    vertical: { type: Boolean },
    square: { type: Boolean },
    max: { type: Number, default: null },
    size: { type: String, default: "40px" }
  },
  setup(e, { slots: n }) {
    vs("square", e.square), vs("size", e.size);
    const { totalChildrenVNodes: t, label: l } = Aoe(
      e,
      n
    ), r = _t(() => ({
      "lp-avatar-group": !0,
      "lp-avatar-group-v": e.vertical,
      "lp-avatar-group-h": !e.vertical
    }));
    return () => sw(
      "div",
      {
        class: r.value
      },
      [
        t.value,
        l.value.show ? sw(
          "div",
          {
            class: ["lp-avatar-group-max"],
            style: { width: e.size, height: e.size }
          },
          [sw("span", `+${l.value.count}`)]
        ) : null
      ]
    );
  }
});
ZS.install = (e) => {
  e.component(ZS.name, ZS);
};
const Doe = { key: 0 }, Ioe = { class: "block-subheader bg-white shadow p-2" }, Roe = { class: "block-tabs bg-white shadow p-2" }, Noe = {
  key: 1,
  class: "mb-1"
}, Coe = {
  name: "lp-blueprint",
  inheritAttrs: !1
}, XS = /* @__PURE__ */ cl({
  ...Coe,
  props: {
    showLeftPanel: { type: Boolean, default: !1 },
    showRightPanel: { type: Boolean, default: !1 },
    showHeader: { type: Boolean, default: !1 },
    showNav: { type: Boolean, default: !1 },
    title: {}
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    return (t, l) => {
      const r = El("lp-grid");
      return Qe(), _l(r, Ni({
        container: "",
        class: ["layout-container blueprint", [
          !t.showLeftPanel && "collapse-left",
          !t.showRightPanel && "collapse-right"
        ]],
        gap: "0",
        padding: "0",
        bg: "gray-light",
        "no-gap": ""
      }, t.$attrs), {
        default: kl(() => [
          dl(du, { name: "drop-left" }, {
            default: kl(() => [
              pi(dl(r, {
                class: "smart-panel-l",
                bg: "white",
                gap: "0",
                shadow: ""
              }, {
                default: kl(() => [
                  el(t.$slots, "panelLeft")
                ]),
                _: 3
              }, 512), [
                [Pi, t.showLeftPanel]
              ])
            ]),
            _: 3
          }),
          dl(r, {
            class: "panel-main",
            direction: "col"
          }, {
            default: kl(() => [
              t.$slots.header || t.$slots.nav ? (Qe(), yn("div", Doe, [
                el(t.$slots, "header", {}, () => [
                  dl(du, { name: "drop-bottom" }, {
                    default: kl(() => [
                      pi(qn("div", Ioe, " Sub-header ", 512), [
                        [Pi, t.showHeader]
                      ])
                    ]),
                    _: 1
                  })
                ]),
                el(t.$slots, "nav", {}, () => [
                  dl(du, { name: "drop-bottom" }, {
                    default: kl(() => [
                      pi(qn("div", Roe, " Tabs ", 512), [
                        [Pi, t.showNav]
                      ])
                    ]),
                    _: 1
                  })
                ])
              ])) : st("", !0),
              t.title ? (Qe(), yn("h3", Noe, It(t.title), 1)) : st("", !0),
              el(t.$slots, "default")
            ]),
            _: 3
          }),
          dl(du, { name: "drop-left" }, {
            default: kl(() => [
              pi(dl(r, {
                class: "smart-panel-r",
                bg: "white",
                gap: "0",
                shadow: ""
              }, {
                default: kl(() => [
                  el(t.$slots, "panelRight")
                ]),
                _: 3
              }, 512), [
                [Pi, t.showRightPanel]
              ])
            ]),
            _: 3
          })
        ]),
        _: 3
      }, 16, ["class"]);
    };
  }
});
XS.install = (e) => {
  e.component(XS.name, XS);
};
const Moe = /* @__PURE__ */ cl({
  __name: "LpBreadcrumbsWrapper",
  props: {
    enabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => n.enabled ? (Qe(), yn("div", Ni({
      key: 0,
      class: "styled-breadcrumb-wrapper"
    }, n.$attrs), [
      el(n.$slots, "default", {}, void 0, !0)
    ], 16)) : el(n.$slots, "default", doe(Ni({ key: 1 }, n.$attrs)), void 0, !0);
  }
}), Cr = (e, n) => {
  const t = e.__vccOpts || e;
  for (const [l, r] of n)
    t[l] = r;
  return t;
}, Poe = /* @__PURE__ */ Cr(Moe, [["__scopeId", "data-v-5e800c35"]]), $oe = { class: "icon-text" }, Af = /* @__PURE__ */ cl({
  name: "lp-icon",
  __name: "LpIcon",
  props: {
    name: { default: null },
    color: { default: "" },
    box: { type: Boolean, default: !1 },
    compact: { type: Boolean },
    boxColor: { default: "" },
    roundSize: { default: void 0 },
    size: { default: "sm" }
  },
  setup(e) {
    const n = e, t = _t(() => [
      n.roundSize && `icon-round-${n.roundSize}`,
      n.boxColor && `text-${n.boxColor}`,
      n.compact && "compact"
    ]);
    return (l, r) => (Qe(), yn("span", {
      class: xt(t.value)
    }, [
      qn("i", {
        class: xt(["lp-icon", [
          l.box && "lp-icon-box",
          l.name ? `lpi-${l.name}` : "",
          l.color && `text-${l.color}`,
          l.size && `lpi-${l.size}`
        ]]),
        style: Hi({
          "background-color": l.box && l.boxColor ? l.boxColor : ""
        }),
        "aria-hidden": "true"
      }, [
        el(l.$slots, "default")
      ], 6),
      qn("span", $oe, It(l.name), 1)
    ], 2));
  }
}), Loe = ["href"], Boe = /* @__PURE__ */ cl({
  __name: "LpBreadcrumbsBackButton",
  props: {
    icon: { default: "chevron-left" },
    label: {},
    href: { default: null },
    onClick: { type: [Function, null], default: null }
  },
  setup(e) {
    function n() {
      history.go(-1);
    }
    return (t, l) => t.href ? (Qe(), yn("a", {
      key: 0,
      href: t.href,
      class: "lp-breadcrumb-button btn-link"
    }, [
      dl(Af, { name: t.icon }, null, 8, ["name"]),
      Ir(" " + It(t.label), 1)
    ], 8, Loe)) : t.onClick ? (Qe(), yn("button", {
      key: 1,
      class: "lp-breadcrumb-button btn-link",
      onClick: l[0] || (l[0] = //@ts-ignore
      (...r) => t.onClick && t.onClick(...r))
    }, [
      dl(Af, { name: t.icon }, null, 8, ["name"]),
      Ir(" " + It(t.label), 1)
    ])) : (Qe(), yn("button", {
      key: 2,
      class: "lp-breadcrumb-button btn-link",
      onClick: n
    }, [
      dl(Af, { name: t.icon }, null, 8, ["name"]),
      Ir(" " + It(t.label), 1)
    ]));
  }
});
Af.install = (e) => {
  e.component(Af.name, Af);
};
const Foe = ["data-ua-value"], Voe = {
  key: 1,
  class: "ly-row breadcrumbs-items-list mb-0",
  "data-ua-value": "ua-breadcrumbs-items-list"
}, QS = /* @__PURE__ */ cl({
  name: "lp-breadcrumbs",
  inheritAttrs: !1,
  __name: "LpBreadcrumbs",
  props: {
    back: { type: [Boolean, String, Object], default: !1 },
    title: { default: void 0 },
    wrapper: { type: Boolean, default: !1 },
    breadcrumbs: { default: void 0 },
    titleComponent: { default: "p" },
    titleClass: { default: "text-black-90" }
  },
  emits: ["click"],
  setup(e, { emit: n }) {
    const t = e, l = n, r = _t(() => {
      const d = {
        label: typeof t.back == "object" ? t.back.label : typeof t.back == "boolean" ? "Back" : t.back
      };
      return t.back && typeof t.back == "object" && (t.back.href && (d.href = t.back.href), t.back.onClick && (d.onClick = t.back.onClick)), d;
    });
    function u(d) {
      return Array.isArray(d) && d.every((p) => "label" in p);
    }
    const o = _t(() => t.breadcrumbs ? typeof t.breadcrumbs.at(0) == "string" ? t.breadcrumbs : t.breadcrumbs && Array.isArray(t.breadcrumbs) && t.breadcrumbs.length > 0 && u(t.breadcrumbs) && t.breadcrumbs.every((d) => typeof d.order == "number") ? [...t.breadcrumbs].sort((d, p) => {
      const _ = Number(d.order), R = Number(p.order);
      return _ > R ? 1 : R > _ ? -1 : 0;
    }) : t.breadcrumbs : []);
    function a(d) {
      return d.onClick ? "button" : "a";
    }
    function h(d) {
      const p = {};
      return d.href && (p.href = d.href), d.onClick && (p.onClick = d.onClick), p;
    }
    function s(d) {
      l("click", d);
    }
    return (d, p) => (Qe(), _l(Poe, {
      class: "lp-breadcrumb-wrapper",
      "data-ua-value": "breadcrumbs-wrapper",
      enabled: d.wrapper
    }, {
      default: kl((_) => [
        qn("div", Ni({ class: "w-full" }, _, {
          "data-ua-value": _["data-ua-value"]
        }), [
          d.back ? (Qe(), _l(Boe, Ni({
            key: 0,
            "data-ua-value": "breadcrumbs-back-button"
          }, r.value), null, 16)) : d.breadcrumbs ? (Qe(), yn("ul", Voe, [
            (Qe(!0), yn(Ii, null, ru(o.value, (R, F) => (Qe(), yn("li", {
              key: typeof R == "object" ? R.label : R,
              "data-ua-value": "ua-breadcrumbs-item",
              class: "m-0"
            }, [
              typeof R == "object" ? (Qe(), _l(ap(a(R)), Ni(
                {
                  key: 0,
                  class: F !== d.breadcrumbs.length - 1 ? "text-indigo-100" : "text-black-60",
                  ref_for: !0
                },
                typeof R == "object" && h(R),
                {
                  onClick: (L) => R.route && s(R.route)
                }
              ), {
                default: kl(() => [
                  Ir(It(R && typeof R == "object" && "label" in R ? R.label : R) + " ", 1),
                  F !== d.breadcrumbs.length - 1 ? (Qe(), _l(Zr(Af), {
                    key: 0,
                    name: "chevron-right",
                    color: "black-100",
                    class: "mx-half"
                  })) : st("", !0)
                ]),
                _: 2
              }, 1040, ["class", "onClick"])) : st("", !0)
            ]))), 128))
          ])) : st("", !0),
          el(d.$slots, "title", {}, () => [
            d.title ? (Qe(), _l(ap(d.titleComponent), {
              key: 0,
              "data-ua-value": "breadcrumb-title",
              class: xt(["lead font-weight-bold", d.titleClass])
            }, {
              default: kl(() => [
                Ir(It(d.title), 1)
              ]),
              _: 1
            }, 8, ["class"])) : st("", !0)
          ])
        ], 16, Foe)
      ]),
      _: 3
    }, 8, ["enabled"]));
  }
});
QS.install = (e) => {
  e.component(QS.name, QS);
};
const Yoe = ["disabled"], Uoe = {
  key: 1,
  class: "lp-btn-text"
}, qoe = { class: "lp-btn-wrap-loading" }, R_ = /* @__PURE__ */ cl({
  name: "lp-button",
  __name: "LpButton",
  props: {
    type: { default: _r.NEUTRAL },
    size: { default: Oz.NORMAL },
    iconAfter: { type: Boolean },
    disabled: { type: Boolean },
    outlined: { type: Boolean },
    round: { type: Boolean },
    pulse: { type: Boolean },
    loading: { type: Boolean },
    block: { type: Boolean },
    text: { type: Boolean },
    link: { type: Boolean },
    icon: { default: null }
  },
  setup(e) {
    const n = e, t = nL(), l = _t(() => [
      {
        pulse: n.pulse,
        "lp-btn--empty": !t.default,
        "btn-block": n.block,
        "btn-noborder": n.text,
        "btn-link": n.link,
        "lp-btn--loading": n.loading,
        [`btn-${n.size}`]: n.size,
        ...n.type ? { [`btn-${n.type}`]: !0 } : { "": !0 },
        ...n.icon ? {
          [n.iconAfter ? "btn-icon-after" : "btn-icon-before"]: !0
        } : null
      }
    ]);
    return (r, u) => {
      const o = El("lp-icon"), a = El("lp-loading");
      return Qe(), yn("button", {
        class: xt(["btn", l.value]),
        disabled: r.disabled
      }, [
        r.icon ? (Qe(), _l(o, {
          key: 0,
          class: xt(["lp-btn-icon", [r.$slots.default && (r.iconAfter ? "" : "mr-half")]]),
          name: r.icon,
          compact: !r.$slots.default,
          color: r.type
        }, null, 8, ["name", "compact", "color", "class"])) : st("", !0),
        r.$slots.default ? (Qe(), yn("span", Uoe, [
          el(r.$slots, "default")
        ])) : st("", !0),
        qn("span", qoe, [
          r.loading ? (Qe(), _l(a, {
            key: 0,
            color: "#fff",
            radius: 10,
            stroke: 3
          })) : st("", !0)
        ])
      ], 10, Yoe);
    };
  }
});
R_.install = (e) => {
  e.component(R_.name, R_);
};
const Woe = cl({
  name: "lp-button-group",
  props: {
    vertical: { type: Boolean }
  }
});
function Hoe(e, n, t, l, r, u) {
  return Qe(), yn("div", {
    class: xt(["lp-button-group", e.vertical ? "lp-button-group-v" : "lp-button-group-h"])
  }, [
    el(e.$slots, "default")
  ], 2);
}
const JS = /* @__PURE__ */ Cr(Woe, [["render", Hoe]]);
JS.install = (e) => {
  e.component(JS.name, JS);
};
const eE = /* @__PURE__ */ cl({
  name: "lp-badge",
  __name: "LpBadge",
  props: {
    type: { default: _r.DANGER },
    position: { default: sl.TR },
    value: { default: null },
    maxValue: { default: null },
    show: { type: Boolean, default: !0 },
    point: { type: Boolean, default: !1 },
    square: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = nL(), l = _t(() => {
      if (!(n.point || !n.value))
        return n.maxValue !== null && Number(n.value) > n.maxValue ? `${n.maxValue}+` : n.value;
    }), r = _t(() => ({
      "lp-badge-sq": n.square
    })), u = _t(() => ({
      ...t.default ? { [`lp-badge-body-corner-${n.position}`]: !0 } : null,
      "lp-badge-body-sq": n.square,
      "lp-badge-body-point": n.point,
      [`lp-badge-body-${n.type}`]: !0
    }));
    return (o, a) => (Qe(), yn("span", {
      class: xt(["lp-badge", r.value])
    }, [
      el(o.$slots, "default"),
      o.show ? (Qe(), yn("span", {
        key: 0,
        class: xt(["lp-badge-body", u.value])
      }, It(l.value), 3)) : st("", !0)
    ], 2));
  }
});
eE.install = (e) => {
  e.component(eE.name, eE);
};
function sr(e) {
  const n = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && n === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || n === "[object Number]" || typeof e == "string" || n === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function lu(e, n) {
  return e instanceof Date ? new e.constructor(n) : new Date(n);
}
function kz(e, n) {
  const t = sr(e);
  return isNaN(n) ? lu(e, NaN) : (n && t.setDate(t.getDate() + n), t);
}
function y4(e, n) {
  const t = sr(e);
  if (isNaN(n)) return lu(e, NaN);
  if (!n)
    return t;
  const l = t.getDate(), r = lu(e, t.getTime());
  r.setMonth(t.getMonth() + n + 1, 0);
  const u = r.getDate();
  return l >= u ? r : (t.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    l
  ), t);
}
function zoe(e, n) {
  const t = +sr(e);
  return lu(e, t + n);
}
const bz = 6048e5, Koe = 864e5, _4 = 6e4, iL = 36e5, Goe = 1e3;
let Zoe = {};
function m1() {
  return Zoe;
}
function If(e, n) {
  const t = m1(), l = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, r = sr(e), u = r.getDay(), o = (u < l ? 7 : 0) + u - l;
  return r.setDate(r.getDate() - o), r.setHours(0, 0, 0, 0), r;
}
function hy(e) {
  return If(e, { weekStartsOn: 1 });
}
function Tz(e) {
  const n = sr(e), t = n.getFullYear(), l = lu(e, 0);
  l.setFullYear(t + 1, 0, 4), l.setHours(0, 0, 0, 0);
  const r = hy(l), u = lu(e, 0);
  u.setFullYear(t, 0, 4), u.setHours(0, 0, 0, 0);
  const o = hy(u);
  return n.getTime() >= r.getTime() ? t + 1 : n.getTime() >= o.getTime() ? t : t - 1;
}
function fy(e) {
  const n = sr(e);
  return n.setHours(0, 0, 0, 0), n;
}
function DO(e) {
  const n = sr(e), t = new Date(
    Date.UTC(
      n.getFullYear(),
      n.getMonth(),
      n.getDate(),
      n.getHours(),
      n.getMinutes(),
      n.getSeconds(),
      n.getMilliseconds()
    )
  );
  return t.setUTCFullYear(n.getFullYear()), +e - +t;
}
function Xoe(e, n) {
  const t = fy(e), l = fy(n), r = +t - DO(t), u = +l - DO(l);
  return Math.round((r - u) / Koe);
}
function Qoe(e) {
  const n = Tz(e), t = lu(e, 0);
  return t.setFullYear(n, 0, 4), t.setHours(0, 0, 0, 0), hy(t);
}
function jz(e, n) {
  return zoe(e, n * _4);
}
function uL(e, n) {
  return y4(e, n * 12);
}
function ch(e, n) {
  const t = fy(e), l = fy(n);
  return +t == +l;
}
function Joe(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Mu(e) {
  if (!Joe(e) && typeof e != "number")
    return !1;
  const n = sr(e);
  return !isNaN(Number(n));
}
function eae(e) {
  return (n) => {
    const l = (e ? Math[e] : Math.trunc)(n);
    return l === 0 ? 0 : l;
  };
}
function Az(e) {
  const n = sr(e);
  return n.setHours(23, 59, 59, 999), n;
}
function sL(e) {
  const n = sr(e), t = n.getMonth();
  return n.setFullYear(n.getFullYear(), t + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function Dz(e, n) {
  const t = sr(e.start), l = sr(e.end);
  let r = +t > +l;
  const u = r ? +t : +l, o = r ? l : t;
  o.setHours(0, 0, 0, 0);
  let a = 1;
  const h = [];
  for (; +o <= u; )
    h.push(sr(o)), o.setDate(o.getDate() + a), o.setHours(0, 0, 0, 0);
  return r ? h.reverse() : h;
}
function nae(e, n) {
  const t = sr(e.start), l = sr(e.end);
  let r = +t > +l;
  const u = r ? +t : +l, o = r ? l : t;
  o.setHours(0, 0, 0, 0), o.setDate(1);
  let a = 1;
  const h = [];
  for (; +o <= u; )
    h.push(sr(o)), o.setMonth(o.getMonth() + a);
  return r ? h.reverse() : h;
}
function x4(e) {
  const n = sr(e);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function tae(e) {
  const n = sr(e), t = n.getFullYear();
  return n.setFullYear(t + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function Iz(e) {
  const n = sr(e), t = lu(e, 0);
  return t.setFullYear(n.getFullYear(), 0, 1), t.setHours(0, 0, 0, 0), t;
}
function lae(e, n) {
  const t = sr(e.start), l = sr(e.end);
  let r = +t > +l;
  const u = r ? +t : +l, o = r ? l : t;
  o.setHours(0, 0, 0, 0), o.setMonth(0, 1);
  let a = 1;
  const h = [];
  for (; +o <= u; )
    h.push(sr(o)), o.setFullYear(o.getFullYear() + a);
  return r ? h.reverse() : h;
}
function rae(e) {
  const n = sr(e), t = n.getFullYear(), l = 9 + Math.floor(t / 10) * 10;
  return n.setFullYear(l, 11, 31), n.setHours(23, 59, 59, 999), n;
}
function Rz(e, n) {
  const t = m1(), l = n?.weekStartsOn ?? n?.locale?.options?.weekStartsOn ?? t.weekStartsOn ?? t.locale?.options?.weekStartsOn ?? 0, r = sr(e), u = r.getDay(), o = (u < l ? -7 : 0) + 6 - (u - l);
  return r.setDate(r.getDate() + o), r.setHours(23, 59, 59, 999), r;
}
const iae = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, uae = (e, n, t) => {
  let l;
  const r = iae[e];
  return typeof r == "string" ? l = r : n === 1 ? l = r.one : l = r.other.replace("{{count}}", n.toString()), t?.addSuffix ? t.comparison && t.comparison > 0 ? "in " + l : l + " ago" : l;
};
function dA(e) {
  return (n = {}) => {
    const t = n.width ? String(n.width) : e.defaultWidth;
    return e.formats[t] || e.formats[e.defaultWidth];
  };
}
const sae = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, oae = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, aae = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, cae = {
  date: dA({
    formats: sae,
    defaultWidth: "full"
  }),
  time: dA({
    formats: oae,
    defaultWidth: "full"
  }),
  dateTime: dA({
    formats: aae,
    defaultWidth: "full"
  })
}, hae = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, fae = (e, n, t, l) => hae[e];
function s_(e) {
  return (n, t) => {
    const l = t?.context ? String(t.context) : "standalone";
    let r;
    if (l === "formatting" && e.formattingValues) {
      const o = e.defaultFormattingWidth || e.defaultWidth, a = t?.width ? String(t.width) : o;
      r = e.formattingValues[a] || e.formattingValues[o];
    } else {
      const o = e.defaultWidth, a = t?.width ? String(t.width) : e.defaultWidth;
      r = e.values[a] || e.values[o];
    }
    const u = e.argumentCallback ? e.argumentCallback(n) : n;
    return r[u];
  };
}
const dae = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, pae = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, mae = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, gae = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, wae = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, vae = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, yae = (e, n) => {
  const t = Number(e), l = t % 100;
  if (l > 20 || l < 10)
    switch (l % 10) {
      case 1:
        return t + "st";
      case 2:
        return t + "nd";
      case 3:
        return t + "rd";
    }
  return t + "th";
}, _ae = {
  ordinalNumber: yae,
  era: s_({
    values: dae,
    defaultWidth: "wide"
  }),
  quarter: s_({
    values: pae,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: s_({
    values: mae,
    defaultWidth: "wide"
  }),
  day: s_({
    values: gae,
    defaultWidth: "wide"
  }),
  dayPeriod: s_({
    values: wae,
    defaultWidth: "wide",
    formattingValues: vae,
    defaultFormattingWidth: "wide"
  })
};
function o_(e) {
  return (n, t = {}) => {
    const l = t.width, r = l && e.matchPatterns[l] || e.matchPatterns[e.defaultMatchWidth], u = n.match(r);
    if (!u)
      return null;
    const o = u[0], a = l && e.parsePatterns[l] || e.parsePatterns[e.defaultParseWidth], h = Array.isArray(a) ? Sae(a, (p) => p.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      xae(a, (p) => p.test(o))
    );
    let s;
    s = e.valueCallback ? e.valueCallback(h) : h, s = t.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      t.valueCallback(s)
    ) : s;
    const d = n.slice(o.length);
    return { value: s, rest: d };
  };
}
function xae(e, n) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t) && n(e[t]))
      return t;
}
function Sae(e, n) {
  for (let t = 0; t < e.length; t++)
    if (n(e[t]))
      return t;
}
function Eae(e) {
  return (n, t = {}) => {
    const l = n.match(e.matchPattern);
    if (!l) return null;
    const r = l[0], u = n.match(e.parsePattern);
    if (!u) return null;
    let o = e.valueCallback ? e.valueCallback(u[0]) : u[0];
    o = t.valueCallback ? t.valueCallback(o) : o;
    const a = n.slice(r.length);
    return { value: o, rest: a };
  };
}
const Oae = /^(\d+)(th|st|nd|rd)?/i, kae = /\d+/i, bae = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Tae = {
  any: [/^b/i, /^(a|c)/i]
}, jae = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Aae = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Dae = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Iae = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Rae = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Nae = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Cae = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Mae = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Pae = {
  ordinalNumber: Eae({
    matchPattern: Oae,
    parsePattern: kae,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: o_({
    matchPatterns: bae,
    defaultMatchWidth: "wide",
    parsePatterns: Tae,
    defaultParseWidth: "any"
  }),
  quarter: o_({
    matchPatterns: jae,
    defaultMatchWidth: "wide",
    parsePatterns: Aae,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: o_({
    matchPatterns: Dae,
    defaultMatchWidth: "wide",
    parsePatterns: Iae,
    defaultParseWidth: "any"
  }),
  day: o_({
    matchPatterns: Rae,
    defaultMatchWidth: "wide",
    parsePatterns: Nae,
    defaultParseWidth: "any"
  }),
  dayPeriod: o_({
    matchPatterns: Cae,
    defaultMatchWidth: "any",
    parsePatterns: Mae,
    defaultParseWidth: "any"
  })
}, Nz = {
  code: "en-US",
  formatDistance: uae,
  formatLong: cae,
  formatRelative: fae,
  localize: _ae,
  match: Pae,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function $ae(e) {
  const n = sr(e);
  return Xoe(n, Iz(n)) + 1;
}
function Cz(e) {
  const n = sr(e), t = +hy(n) - +Qoe(n);
  return Math.round(t / bz) + 1;
}
function oL(e, n) {
  const t = sr(e), l = t.getFullYear(), r = m1(), u = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, o = lu(e, 0);
  o.setFullYear(l + 1, 0, u), o.setHours(0, 0, 0, 0);
  const a = If(o, n), h = lu(e, 0);
  h.setFullYear(l, 0, u), h.setHours(0, 0, 0, 0);
  const s = If(h, n);
  return t.getTime() >= a.getTime() ? l + 1 : t.getTime() >= s.getTime() ? l : l - 1;
}
function Lae(e, n) {
  const t = m1(), l = n?.firstWeekContainsDate ?? n?.locale?.options?.firstWeekContainsDate ?? t.firstWeekContainsDate ?? t.locale?.options?.firstWeekContainsDate ?? 1, r = oL(e, n), u = lu(e, 0);
  return u.setFullYear(r, 0, l), u.setHours(0, 0, 0, 0), If(u, n);
}
function Mz(e, n) {
  const t = sr(e), l = +If(t, n) - +Lae(t, n);
  return Math.round(l / bz) + 1;
}
function qi(e, n) {
  const t = e < 0 ? "-" : "", l = Math.abs(e).toString().padStart(n, "0");
  return t + l;
}
const Jp = {
  // Year
  y(e, n) {
    const t = e.getFullYear(), l = t > 0 ? t : 1 - t;
    return qi(n === "yy" ? l % 100 : l, n.length);
  },
  // Month
  M(e, n) {
    const t = e.getMonth();
    return n === "M" ? String(t + 1) : qi(t + 1, 2);
  },
  // Day of the month
  d(e, n) {
    return qi(e.getDate(), n.length);
  },
  // AM or PM
  a(e, n) {
    const t = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.toUpperCase();
      case "aaa":
        return t;
      case "aaaaa":
        return t[0];
      case "aaaa":
      default:
        return t === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, n) {
    return qi(e.getHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H(e, n) {
    return qi(e.getHours(), n.length);
  },
  // Minute
  m(e, n) {
    return qi(e.getMinutes(), n.length);
  },
  // Second
  s(e, n) {
    return qi(e.getSeconds(), n.length);
  },
  // Fraction of second
  S(e, n) {
    const t = n.length, l = e.getMilliseconds(), r = Math.trunc(
      l * Math.pow(10, t - 3)
    );
    return qi(r, n.length);
  }
}, tv = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, hY = {
  // Era
  G: function(e, n, t) {
    const l = e.getFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return t.era(l, { width: "abbreviated" });
      case "GGGGG":
        return t.era(l, { width: "narrow" });
      case "GGGG":
      default:
        return t.era(l, { width: "wide" });
    }
  },
  // Year
  y: function(e, n, t) {
    if (n === "yo") {
      const l = e.getFullYear(), r = l > 0 ? l : 1 - l;
      return t.ordinalNumber(r, { unit: "year" });
    }
    return Jp.y(e, n);
  },
  // Local week-numbering year
  Y: function(e, n, t, l) {
    const r = oL(e, l), u = r > 0 ? r : 1 - r;
    if (n === "YY") {
      const o = u % 100;
      return qi(o, 2);
    }
    return n === "Yo" ? t.ordinalNumber(u, { unit: "year" }) : qi(u, n.length);
  },
  // ISO week-numbering year
  R: function(e, n) {
    const t = Tz(e);
    return qi(t, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, n) {
    const t = e.getFullYear();
    return qi(t, n.length);
  },
  // Quarter
  Q: function(e, n, t) {
    const l = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(l);
      case "QQ":
        return qi(l, 2);
      case "Qo":
        return t.ordinalNumber(l, { unit: "quarter" });
      case "QQQ":
        return t.quarter(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return t.quarter(l, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return t.quarter(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, n, t) {
    const l = Math.ceil((e.getMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(l);
      case "qq":
        return qi(l, 2);
      case "qo":
        return t.ordinalNumber(l, { unit: "quarter" });
      case "qqq":
        return t.quarter(l, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return t.quarter(l, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return t.quarter(l, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, n, t) {
    const l = e.getMonth();
    switch (n) {
      case "M":
      case "MM":
        return Jp.M(e, n);
      case "Mo":
        return t.ordinalNumber(l + 1, { unit: "month" });
      case "MMM":
        return t.month(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return t.month(l, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return t.month(l, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, n, t) {
    const l = e.getMonth();
    switch (n) {
      case "L":
        return String(l + 1);
      case "LL":
        return qi(l + 1, 2);
      case "Lo":
        return t.ordinalNumber(l + 1, { unit: "month" });
      case "LLL":
        return t.month(l, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return t.month(l, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return t.month(l, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, n, t, l) {
    const r = Mz(e, l);
    return n === "wo" ? t.ordinalNumber(r, { unit: "week" }) : qi(r, n.length);
  },
  // ISO week of year
  I: function(e, n, t) {
    const l = Cz(e);
    return n === "Io" ? t.ordinalNumber(l, { unit: "week" }) : qi(l, n.length);
  },
  // Day of the month
  d: function(e, n, t) {
    return n === "do" ? t.ordinalNumber(e.getDate(), { unit: "date" }) : Jp.d(e, n);
  },
  // Day of year
  D: function(e, n, t) {
    const l = $ae(e);
    return n === "Do" ? t.ordinalNumber(l, { unit: "dayOfYear" }) : qi(l, n.length);
  },
  // Day of week
  E: function(e, n, t) {
    const l = e.getDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return t.day(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return t.day(l, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return t.day(l, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return t.day(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, n, t, l) {
    const r = e.getDay(), u = (r - l.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(u);
      case "ee":
        return qi(u, 2);
      case "eo":
        return t.ordinalNumber(u, { unit: "day" });
      case "eee":
        return t.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return t.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return t.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return t.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, n, t, l) {
    const r = e.getDay(), u = (r - l.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(u);
      case "cc":
        return qi(u, n.length);
      case "co":
        return t.ordinalNumber(u, { unit: "day" });
      case "ccc":
        return t.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return t.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return t.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return t.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, n, t) {
    const l = e.getDay(), r = l === 0 ? 7 : l;
    switch (n) {
      case "i":
        return String(r);
      case "ii":
        return qi(r, n.length);
      case "io":
        return t.ordinalNumber(r, { unit: "day" });
      case "iii":
        return t.day(l, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return t.day(l, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return t.day(l, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return t.day(l, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, n, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, n, t) {
    const l = e.getHours();
    let r;
    switch (l === 12 ? r = tv.noon : l === 0 ? r = tv.midnight : r = l / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, n, t) {
    const l = e.getHours();
    let r;
    switch (l >= 17 ? r = tv.evening : l >= 12 ? r = tv.afternoon : l >= 4 ? r = tv.morning : r = tv.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return t.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return t.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return t.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, n, t) {
    if (n === "ho") {
      let l = e.getHours() % 12;
      return l === 0 && (l = 12), t.ordinalNumber(l, { unit: "hour" });
    }
    return Jp.h(e, n);
  },
  // Hour [0-23]
  H: function(e, n, t) {
    return n === "Ho" ? t.ordinalNumber(e.getHours(), { unit: "hour" }) : Jp.H(e, n);
  },
  // Hour [0-11]
  K: function(e, n, t) {
    const l = e.getHours() % 12;
    return n === "Ko" ? t.ordinalNumber(l, { unit: "hour" }) : qi(l, n.length);
  },
  // Hour [1-24]
  k: function(e, n, t) {
    let l = e.getHours();
    return l === 0 && (l = 24), n === "ko" ? t.ordinalNumber(l, { unit: "hour" }) : qi(l, n.length);
  },
  // Minute
  m: function(e, n, t) {
    return n === "mo" ? t.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Jp.m(e, n);
  },
  // Second
  s: function(e, n, t) {
    return n === "so" ? t.ordinalNumber(e.getSeconds(), { unit: "second" }) : Jp.s(e, n);
  },
  // Fraction of second
  S: function(e, n) {
    return Jp.S(e, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, n, t) {
    const l = e.getTimezoneOffset();
    if (l === 0)
      return "Z";
    switch (n) {
      case "X":
        return dY(l);
      case "XXXX":
      case "XX":
        return tw(l);
      case "XXXXX":
      case "XXX":
      default:
        return tw(l, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, n, t) {
    const l = e.getTimezoneOffset();
    switch (n) {
      case "x":
        return dY(l);
      case "xxxx":
      case "xx":
        return tw(l);
      case "xxxxx":
      case "xxx":
      default:
        return tw(l, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, n, t) {
    const l = e.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + fY(l, ":");
      case "OOOO":
      default:
        return "GMT" + tw(l, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, n, t) {
    const l = e.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + fY(l, ":");
      case "zzzz":
      default:
        return "GMT" + tw(l, ":");
    }
  },
  // Seconds timestamp
  t: function(e, n, t) {
    const l = Math.trunc(e.getTime() / 1e3);
    return qi(l, n.length);
  },
  // Milliseconds timestamp
  T: function(e, n, t) {
    const l = e.getTime();
    return qi(l, n.length);
  }
};
function fY(e, n = "") {
  const t = e > 0 ? "-" : "+", l = Math.abs(e), r = Math.trunc(l / 60), u = l % 60;
  return u === 0 ? t + String(r) : t + String(r) + n + qi(u, 2);
}
function dY(e, n) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + qi(Math.abs(e) / 60, 2) : tw(e, n);
}
function tw(e, n = "") {
  const t = e > 0 ? "-" : "+", l = Math.abs(e), r = qi(Math.trunc(l / 60), 2), u = qi(l % 60, 2);
  return t + r + n + u;
}
const pY = (e, n) => {
  switch (e) {
    case "P":
      return n.date({ width: "short" });
    case "PP":
      return n.date({ width: "medium" });
    case "PPP":
      return n.date({ width: "long" });
    case "PPPP":
    default:
      return n.date({ width: "full" });
  }
}, Pz = (e, n) => {
  switch (e) {
    case "p":
      return n.time({ width: "short" });
    case "pp":
      return n.time({ width: "medium" });
    case "ppp":
      return n.time({ width: "long" });
    case "pppp":
    default:
      return n.time({ width: "full" });
  }
}, Bae = (e, n) => {
  const t = e.match(/(P+)(p+)?/) || [], l = t[1], r = t[2];
  if (!r)
    return pY(e, n);
  let u;
  switch (l) {
    case "P":
      u = n.dateTime({ width: "short" });
      break;
    case "PP":
      u = n.dateTime({ width: "medium" });
      break;
    case "PPP":
      u = n.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      u = n.dateTime({ width: "full" });
      break;
  }
  return u.replace("{{date}}", pY(l, n)).replace("{{time}}", Pz(r, n));
}, PD = {
  p: Pz,
  P: Bae
}, Fae = /^D+$/, Vae = /^Y+$/, Yae = ["D", "DD", "YY", "YYYY"];
function $z(e) {
  return Fae.test(e);
}
function Lz(e) {
  return Vae.test(e);
}
function $D(e, n, t) {
  const l = Uae(e, n, t);
  if (console.warn(l), Yae.includes(e)) throw new RangeError(l);
}
function Uae(e, n, t) {
  const l = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${n}\`) for formatting ${l} to the input \`${t}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const qae = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Wae = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Hae = /^'([^]*?)'?$/, zae = /''/g, Kae = /[a-zA-Z]/;
function Wo(e, n, t) {
  const l = m1(), r = t?.locale ?? l.locale ?? Nz, u = t?.firstWeekContainsDate ?? t?.locale?.options?.firstWeekContainsDate ?? l.firstWeekContainsDate ?? l.locale?.options?.firstWeekContainsDate ?? 1, o = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? l.weekStartsOn ?? l.locale?.options?.weekStartsOn ?? 0, a = sr(e);
  if (!Mu(a))
    throw new RangeError("Invalid time value");
  let h = n.match(Wae).map((d) => {
    const p = d[0];
    if (p === "p" || p === "P") {
      const _ = PD[p];
      return _(d, r.formatLong);
    }
    return d;
  }).join("").match(qae).map((d) => {
    if (d === "''")
      return { isToken: !1, value: "'" };
    const p = d[0];
    if (p === "'")
      return { isToken: !1, value: Gae(d) };
    if (hY[p])
      return { isToken: !0, value: d };
    if (p.match(Kae))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + p + "`"
      );
    return { isToken: !1, value: d };
  });
  r.localize.preprocessor && (h = r.localize.preprocessor(a, h));
  const s = {
    firstWeekContainsDate: u,
    weekStartsOn: o,
    locale: r
  };
  return h.map((d) => {
    if (!d.isToken) return d.value;
    const p = d.value;
    (!t?.useAdditionalWeekYearTokens && Lz(p) || !t?.useAdditionalDayOfYearTokens && $z(p)) && $D(p, n, String(e));
    const _ = hY[p[0]];
    return _(a, p, r.localize, s);
  }).join("");
}
function Gae(e) {
  const n = e.match(Hae);
  return n ? n[1].replace(zae, "'") : e;
}
function xS(e) {
  const t = sr(e).getFullYear();
  return Math.floor(t / 10) * 10;
}
function Zae() {
  return Object.assign({}, m1());
}
function Xae(e) {
  let t = sr(e).getDay();
  return t === 0 && (t = 7), t;
}
function Ch(e) {
  return sr(e).getFullYear();
}
function Rw(e, n) {
  const t = sr(e), l = sr(n);
  return t.getTime() > l.getTime();
}
function Nw(e, n) {
  const t = sr(e), l = sr(n);
  return +t < +l;
}
function Qae(e, n) {
  const t = n instanceof Date ? lu(n, 0) : new n(0);
  return t.setFullYear(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), t.setHours(
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ), t;
}
const Jae = 10;
class Bz {
  subPriority = 0;
  validate(n, t) {
    return !0;
  }
}
class ece extends Bz {
  constructor(n, t, l, r, u) {
    super(), this.value = n, this.validateValue = t, this.setValue = l, this.priority = r, u && (this.subPriority = u);
  }
  validate(n, t) {
    return this.validateValue(n, this.value, t);
  }
  set(n, t, l) {
    return this.setValue(n, t, this.value, l);
  }
}
class nce extends Bz {
  priority = Jae;
  subPriority = -1;
  set(n, t) {
    return t.timestampIsSet ? n : lu(n, Qae(n, Date));
  }
}
class Bi {
  run(n, t, l, r) {
    const u = this.parse(n, t, l, r);
    return u ? {
      setter: new ece(
        u.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: u.rest
    } : null;
  }
  validate(n, t, l) {
    return !0;
  }
}
class tce extends Bi {
  priority = 140;
  parse(n, t, l) {
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return l.era(n, { width: "abbreviated" }) || l.era(n, { width: "narrow" });
      case "GGGGG":
        return l.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return l.era(n, { width: "wide" }) || l.era(n, { width: "abbreviated" }) || l.era(n, { width: "narrow" });
    }
  }
  set(n, t, l) {
    return t.era = l, n.setFullYear(l, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = ["R", "u", "t", "T"];
}
const Es = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, Ef = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function Os(e, n) {
  return e && {
    value: n(e.value),
    rest: e.rest
  };
}
function Pu(e, n) {
  const t = n.match(e);
  return t ? {
    value: parseInt(t[0], 10),
    rest: n.slice(t[0].length)
  } : null;
}
function Of(e, n) {
  const t = n.match(e);
  if (!t)
    return null;
  if (t[0] === "Z")
    return {
      value: 0,
      rest: n.slice(1)
    };
  const l = t[1] === "+" ? 1 : -1, r = t[2] ? parseInt(t[2], 10) : 0, u = t[3] ? parseInt(t[3], 10) : 0, o = t[5] ? parseInt(t[5], 10) : 0;
  return {
    value: l * (r * iL + u * _4 + o * Goe),
    rest: n.slice(t[0].length)
  };
}
function Fz(e) {
  return Pu(Es.anyDigitsSigned, e);
}
function is(e, n) {
  switch (e) {
    case 1:
      return Pu(Es.singleDigit, n);
    case 2:
      return Pu(Es.twoDigits, n);
    case 3:
      return Pu(Es.threeDigits, n);
    case 4:
      return Pu(Es.fourDigits, n);
    default:
      return Pu(new RegExp("^\\d{1," + e + "}"), n);
  }
}
function IO(e, n) {
  switch (e) {
    case 1:
      return Pu(Es.singleDigitSigned, n);
    case 2:
      return Pu(Es.twoDigitsSigned, n);
    case 3:
      return Pu(Es.threeDigitsSigned, n);
    case 4:
      return Pu(Es.fourDigitsSigned, n);
    default:
      return Pu(new RegExp("^-?\\d{1," + e + "}"), n);
  }
}
function aL(e) {
  switch (e) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function Vz(e, n) {
  const t = n > 0, l = t ? n : 1 - n;
  let r;
  if (l <= 50)
    r = e || 100;
  else {
    const u = l + 50, o = Math.trunc(u / 100) * 100, a = e >= u % 100;
    r = e + o - (a ? 100 : 0);
  }
  return t ? r : 1 - r;
}
function Yz(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
class lce extends Bi {
  priority = 130;
  incompatibleTokens = ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"];
  parse(n, t, l) {
    const r = (u) => ({
      year: u,
      isTwoDigitYear: t === "yy"
    });
    switch (t) {
      case "y":
        return Os(is(4, n), r);
      case "yo":
        return Os(
          l.ordinalNumber(n, {
            unit: "year"
          }),
          r
        );
      default:
        return Os(is(t.length, n), r);
    }
  }
  validate(n, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(n, t, l) {
    const r = n.getFullYear();
    if (l.isTwoDigitYear) {
      const o = Vz(
        l.year,
        r
      );
      return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const u = !("era" in t) || t.era === 1 ? l.year : 1 - l.year;
    return n.setFullYear(u, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class rce extends Bi {
  priority = 130;
  parse(n, t, l) {
    const r = (u) => ({
      year: u,
      isTwoDigitYear: t === "YY"
    });
    switch (t) {
      case "Y":
        return Os(is(4, n), r);
      case "Yo":
        return Os(
          l.ordinalNumber(n, {
            unit: "year"
          }),
          r
        );
      default:
        return Os(is(t.length, n), r);
    }
  }
  validate(n, t) {
    return t.isTwoDigitYear || t.year > 0;
  }
  set(n, t, l, r) {
    const u = oL(n, r);
    if (l.isTwoDigitYear) {
      const a = Vz(
        l.year,
        u
      );
      return n.setFullYear(
        a,
        0,
        r.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), If(n, r);
    }
    const o = !("era" in t) || t.era === 1 ? l.year : 1 - l.year;
    return n.setFullYear(o, 0, r.firstWeekContainsDate), n.setHours(0, 0, 0, 0), If(n, r);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
class ice extends Bi {
  priority = 130;
  parse(n, t) {
    return IO(t === "R" ? 4 : t.length, n);
  }
  set(n, t, l) {
    const r = lu(n, 0);
    return r.setFullYear(l, 0, 4), r.setHours(0, 0, 0, 0), hy(r);
  }
  incompatibleTokens = [
    "G",
    "y",
    "Y",
    "u",
    "Q",
    "q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
class uce extends Bi {
  priority = 130;
  parse(n, t) {
    return IO(t === "u" ? 4 : t.length, n);
  }
  set(n, t, l) {
    return n.setFullYear(l, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"];
}
class sce extends Bi {
  priority = 120;
  parse(n, t, l) {
    switch (t) {
      case "Q":
      case "QQ":
        return is(t.length, n);
      case "Qo":
        return l.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return l.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQQ":
        return l.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return l.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || l.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, t) {
    return t >= 1 && t <= 4;
  }
  set(n, t, l) {
    return n.setMonth((l - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class oce extends Bi {
  priority = 120;
  parse(n, t, l) {
    switch (t) {
      case "q":
      case "qq":
        return is(t.length, n);
      case "qo":
        return l.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return l.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || l.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqqq":
        return l.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return l.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || l.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || l.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, t) {
    return t >= 1 && t <= 4;
  }
  set(n, t, l) {
    return n.setMonth((l - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class ace extends Bi {
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "L",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
  priority = 110;
  parse(n, t, l) {
    const r = (u) => u - 1;
    switch (t) {
      case "M":
        return Os(
          Pu(Es.month, n),
          r
        );
      case "MM":
        return Os(is(2, n), r);
      case "Mo":
        return Os(
          l.ordinalNumber(n, {
            unit: "month"
          }),
          r
        );
      case "MMM":
        return l.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.month(n, { width: "narrow", context: "formatting" });
      case "MMMMM":
        return l.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return l.month(n, { width: "wide", context: "formatting" }) || l.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, t) {
    return t >= 0 && t <= 11;
  }
  set(n, t, l) {
    return n.setMonth(l, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class cce extends Bi {
  priority = 110;
  parse(n, t, l) {
    const r = (u) => u - 1;
    switch (t) {
      case "L":
        return Os(
          Pu(Es.month, n),
          r
        );
      case "LL":
        return Os(is(2, n), r);
      case "Lo":
        return Os(
          l.ordinalNumber(n, {
            unit: "month"
          }),
          r
        );
      case "LLL":
        return l.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || l.month(n, { width: "narrow", context: "standalone" });
      case "LLLLL":
        return l.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return l.month(n, { width: "wide", context: "standalone" }) || l.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || l.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, t) {
    return t >= 0 && t <= 11;
  }
  set(n, t, l) {
    return n.setMonth(l, 1), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function hce(e, n, t) {
  const l = sr(e), r = Mz(l, t) - n;
  return l.setDate(l.getDate() - r * 7), l;
}
class fce extends Bi {
  priority = 100;
  parse(n, t, l) {
    switch (t) {
      case "w":
        return Pu(Es.week, n);
      case "wo":
        return l.ordinalNumber(n, { unit: "week" });
      default:
        return is(t.length, n);
    }
  }
  validate(n, t) {
    return t >= 1 && t <= 53;
  }
  set(n, t, l, r) {
    return If(hce(n, l, r), r);
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "i",
    "t",
    "T"
  ];
}
function dce(e, n) {
  const t = sr(e), l = Cz(t) - n;
  return t.setDate(t.getDate() - l * 7), t;
}
class pce extends Bi {
  priority = 100;
  parse(n, t, l) {
    switch (t) {
      case "I":
        return Pu(Es.week, n);
      case "Io":
        return l.ordinalNumber(n, { unit: "week" });
      default:
        return is(t.length, n);
    }
  }
  validate(n, t) {
    return t >= 1 && t <= 53;
  }
  set(n, t, l) {
    return hy(dce(n, l));
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "e",
    "c",
    "t",
    "T"
  ];
}
const mce = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], gce = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class wce extends Bi {
  priority = 90;
  subPriority = 1;
  parse(n, t, l) {
    switch (t) {
      case "d":
        return Pu(Es.date, n);
      case "do":
        return l.ordinalNumber(n, { unit: "date" });
      default:
        return is(t.length, n);
    }
  }
  validate(n, t) {
    const l = n.getFullYear(), r = Yz(l), u = n.getMonth();
    return r ? t >= 1 && t <= gce[u] : t >= 1 && t <= mce[u];
  }
  set(n, t, l) {
    return n.setDate(l), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "w",
    "I",
    "D",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
class vce extends Bi {
  priority = 90;
  subpriority = 1;
  parse(n, t, l) {
    switch (t) {
      case "D":
      case "DD":
        return Pu(Es.dayOfYear, n);
      case "Do":
        return l.ordinalNumber(n, { unit: "date" });
      default:
        return is(t.length, n);
    }
  }
  validate(n, t) {
    const l = n.getFullYear();
    return Yz(l) ? t >= 1 && t <= 366 : t >= 1 && t <= 365;
  }
  set(n, t, l) {
    return n.setMonth(0, l), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "Y",
    "R",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "I",
    "d",
    "E",
    "i",
    "e",
    "c",
    "t",
    "T"
  ];
}
function y3(e, n, t) {
  const l = m1(), r = t?.weekStartsOn ?? t?.locale?.options?.weekStartsOn ?? l.weekStartsOn ?? l.locale?.options?.weekStartsOn ?? 0, u = sr(e), o = u.getDay(), h = (n % 7 + 7) % 7, s = 7 - r, d = n < 0 || n > 6 ? n - (o + s) % 7 : (h + s) % 7 - (o + s) % 7;
  return kz(u, d);
}
class yce extends Bi {
  priority = 90;
  parse(n, t, l) {
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return l.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.day(n, { width: "short", context: "formatting" }) || l.day(n, { width: "narrow", context: "formatting" });
      case "EEEEE":
        return l.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return l.day(n, { width: "short", context: "formatting" }) || l.day(n, { width: "narrow", context: "formatting" });
      case "EEEE":
      default:
        return l.day(n, { width: "wide", context: "formatting" }) || l.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.day(n, { width: "short", context: "formatting" }) || l.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, t) {
    return t >= 0 && t <= 6;
  }
  set(n, t, l, r) {
    return n = y3(n, l, r), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = ["D", "i", "e", "c", "t", "T"];
}
class _ce extends Bi {
  priority = 90;
  parse(n, t, l, r) {
    const u = (o) => {
      const a = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + a;
    };
    switch (t) {
      case "e":
      case "ee":
        return Os(is(t.length, n), u);
      case "eo":
        return Os(
          l.ordinalNumber(n, {
            unit: "day"
          }),
          u
        );
      case "eee":
        return l.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.day(n, { width: "short", context: "formatting" }) || l.day(n, { width: "narrow", context: "formatting" });
      case "eeeee":
        return l.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return l.day(n, { width: "short", context: "formatting" }) || l.day(n, { width: "narrow", context: "formatting" });
      case "eeee":
      default:
        return l.day(n, { width: "wide", context: "formatting" }) || l.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.day(n, { width: "short", context: "formatting" }) || l.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, t) {
    return t >= 0 && t <= 6;
  }
  set(n, t, l, r) {
    return n = y3(n, l, r), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "c",
    "t",
    "T"
  ];
}
class xce extends Bi {
  priority = 90;
  parse(n, t, l, r) {
    const u = (o) => {
      const a = Math.floor((o - 1) / 7) * 7;
      return (o + r.weekStartsOn + 6) % 7 + a;
    };
    switch (t) {
      case "c":
      case "cc":
        return Os(is(t.length, n), u);
      case "co":
        return Os(
          l.ordinalNumber(n, {
            unit: "day"
          }),
          u
        );
      case "ccc":
        return l.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || l.day(n, { width: "short", context: "standalone" }) || l.day(n, { width: "narrow", context: "standalone" });
      case "ccccc":
        return l.day(n, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return l.day(n, { width: "short", context: "standalone" }) || l.day(n, { width: "narrow", context: "standalone" });
      case "cccc":
      default:
        return l.day(n, { width: "wide", context: "standalone" }) || l.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || l.day(n, { width: "short", context: "standalone" }) || l.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, t) {
    return t >= 0 && t <= 6;
  }
  set(n, t, l, r) {
    return n = y3(n, l, r), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "y",
    "R",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "I",
    "d",
    "D",
    "E",
    "i",
    "e",
    "t",
    "T"
  ];
}
function Sce(e, n) {
  const t = sr(e), l = Xae(t), r = n - l;
  return kz(t, r);
}
class Ece extends Bi {
  priority = 90;
  parse(n, t, l) {
    const r = (u) => u === 0 ? 7 : u;
    switch (t) {
      case "i":
      case "ii":
        return is(t.length, n);
      case "io":
        return l.ordinalNumber(n, { unit: "day" });
      case "iii":
        return Os(
          l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiiii":
        return Os(
          l.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiiiii":
        return Os(
          l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
      case "iiii":
      default:
        return Os(
          l.day(n, {
            width: "wide",
            context: "formatting"
          }) || l.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || l.day(n, {
            width: "short",
            context: "formatting"
          }) || l.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          r
        );
    }
  }
  validate(n, t) {
    return t >= 1 && t <= 7;
  }
  set(n, t, l) {
    return n = Sce(n, l), n.setHours(0, 0, 0, 0), n;
  }
  incompatibleTokens = [
    "y",
    "Y",
    "u",
    "q",
    "Q",
    "M",
    "L",
    "w",
    "d",
    "D",
    "E",
    "e",
    "c",
    "t",
    "T"
  ];
}
class Oce extends Bi {
  priority = 80;
  parse(n, t, l) {
    switch (t) {
      case "a":
      case "aa":
      case "aaa":
        return l.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return l.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return l.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || l.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, t, l) {
    return n.setHours(aL(l), 0, 0, 0), n;
  }
  incompatibleTokens = ["b", "B", "H", "k", "t", "T"];
}
class kce extends Bi {
  priority = 80;
  parse(n, t, l) {
    switch (t) {
      case "b":
      case "bb":
      case "bbb":
        return l.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return l.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return l.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || l.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, t, l) {
    return n.setHours(aL(l), 0, 0, 0), n;
  }
  incompatibleTokens = ["a", "B", "H", "k", "t", "T"];
}
class bce extends Bi {
  priority = 80;
  parse(n, t, l) {
    switch (t) {
      case "B":
      case "BB":
      case "BBB":
        return l.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return l.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return l.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || l.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || l.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, t, l) {
    return n.setHours(aL(l), 0, 0, 0), n;
  }
  incompatibleTokens = ["a", "b", "t", "T"];
}
class Tce extends Bi {
  priority = 70;
  parse(n, t, l) {
    switch (t) {
      case "h":
        return Pu(Es.hour12h, n);
      case "ho":
        return l.ordinalNumber(n, { unit: "hour" });
      default:
        return is(t.length, n);
    }
  }
  validate(n, t) {
    return t >= 1 && t <= 12;
  }
  set(n, t, l) {
    const r = n.getHours() >= 12;
    return r && l < 12 ? n.setHours(l + 12, 0, 0, 0) : !r && l === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(l, 0, 0, 0), n;
  }
  incompatibleTokens = ["H", "K", "k", "t", "T"];
}
class jce extends Bi {
  priority = 70;
  parse(n, t, l) {
    switch (t) {
      case "H":
        return Pu(Es.hour23h, n);
      case "Ho":
        return l.ordinalNumber(n, { unit: "hour" });
      default:
        return is(t.length, n);
    }
  }
  validate(n, t) {
    return t >= 0 && t <= 23;
  }
  set(n, t, l) {
    return n.setHours(l, 0, 0, 0), n;
  }
  incompatibleTokens = ["a", "b", "h", "K", "k", "t", "T"];
}
class Ace extends Bi {
  priority = 70;
  parse(n, t, l) {
    switch (t) {
      case "K":
        return Pu(Es.hour11h, n);
      case "Ko":
        return l.ordinalNumber(n, { unit: "hour" });
      default:
        return is(t.length, n);
    }
  }
  validate(n, t) {
    return t >= 0 && t <= 11;
  }
  set(n, t, l) {
    return n.getHours() >= 12 && l < 12 ? n.setHours(l + 12, 0, 0, 0) : n.setHours(l, 0, 0, 0), n;
  }
  incompatibleTokens = ["h", "H", "k", "t", "T"];
}
class Dce extends Bi {
  priority = 70;
  parse(n, t, l) {
    switch (t) {
      case "k":
        return Pu(Es.hour24h, n);
      case "ko":
        return l.ordinalNumber(n, { unit: "hour" });
      default:
        return is(t.length, n);
    }
  }
  validate(n, t) {
    return t >= 1 && t <= 24;
  }
  set(n, t, l) {
    const r = l <= 24 ? l % 24 : l;
    return n.setHours(r, 0, 0, 0), n;
  }
  incompatibleTokens = ["a", "b", "h", "H", "K", "t", "T"];
}
class Ice extends Bi {
  priority = 60;
  parse(n, t, l) {
    switch (t) {
      case "m":
        return Pu(Es.minute, n);
      case "mo":
        return l.ordinalNumber(n, { unit: "minute" });
      default:
        return is(t.length, n);
    }
  }
  validate(n, t) {
    return t >= 0 && t <= 59;
  }
  set(n, t, l) {
    return n.setMinutes(l, 0, 0), n;
  }
  incompatibleTokens = ["t", "T"];
}
class Rce extends Bi {
  priority = 50;
  parse(n, t, l) {
    switch (t) {
      case "s":
        return Pu(Es.second, n);
      case "so":
        return l.ordinalNumber(n, { unit: "second" });
      default:
        return is(t.length, n);
    }
  }
  validate(n, t) {
    return t >= 0 && t <= 59;
  }
  set(n, t, l) {
    return n.setSeconds(l, 0), n;
  }
  incompatibleTokens = ["t", "T"];
}
class Nce extends Bi {
  priority = 30;
  parse(n, t) {
    const l = (r) => Math.trunc(r * Math.pow(10, -t.length + 3));
    return Os(is(t.length, n), l);
  }
  set(n, t, l) {
    return n.setMilliseconds(l), n;
  }
  incompatibleTokens = ["t", "T"];
}
class Cce extends Bi {
  priority = 10;
  parse(n, t) {
    switch (t) {
      case "X":
        return Of(
          Ef.basicOptionalMinutes,
          n
        );
      case "XX":
        return Of(Ef.basic, n);
      case "XXXX":
        return Of(
          Ef.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return Of(
          Ef.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return Of(Ef.extended, n);
    }
  }
  set(n, t, l) {
    return t.timestampIsSet ? n : lu(
      n,
      n.getTime() - DO(n) - l
    );
  }
  incompatibleTokens = ["t", "T", "x"];
}
class Mce extends Bi {
  priority = 10;
  parse(n, t) {
    switch (t) {
      case "x":
        return Of(
          Ef.basicOptionalMinutes,
          n
        );
      case "xx":
        return Of(Ef.basic, n);
      case "xxxx":
        return Of(
          Ef.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return Of(
          Ef.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return Of(Ef.extended, n);
    }
  }
  set(n, t, l) {
    return t.timestampIsSet ? n : lu(
      n,
      n.getTime() - DO(n) - l
    );
  }
  incompatibleTokens = ["t", "T", "X"];
}
class Pce extends Bi {
  priority = 40;
  parse(n) {
    return Fz(n);
  }
  set(n, t, l) {
    return [lu(n, l * 1e3), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
class $ce extends Bi {
  priority = 20;
  parse(n) {
    return Fz(n);
  }
  set(n, t, l) {
    return [lu(n, l), { timestampIsSet: !0 }];
  }
  incompatibleTokens = "*";
}
const Lce = {
  G: new tce(),
  y: new lce(),
  Y: new rce(),
  R: new ice(),
  u: new uce(),
  Q: new sce(),
  q: new oce(),
  M: new ace(),
  L: new cce(),
  w: new fce(),
  I: new pce(),
  d: new wce(),
  D: new vce(),
  E: new yce(),
  e: new _ce(),
  c: new xce(),
  i: new Ece(),
  a: new Oce(),
  b: new kce(),
  B: new bce(),
  h: new Tce(),
  H: new jce(),
  K: new Ace(),
  k: new Dce(),
  m: new Ice(),
  s: new Rce(),
  S: new Nce(),
  X: new Cce(),
  x: new Mce(),
  t: new Pce(),
  T: new $ce()
}, Bce = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Fce = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Vce = /^'([^]*?)'?$/, Yce = /''/g, Uce = /\S/, qce = /[a-zA-Z]/;
function N_(e, n, t, l) {
  const r = Zae(), u = r.locale ?? Nz, o = r.firstWeekContainsDate ?? r.locale?.options?.firstWeekContainsDate ?? 1, a = r.weekStartsOn ?? r.locale?.options?.weekStartsOn ?? 0;
  if (n === "")
    return e === "" ? sr(t) : lu(t, NaN);
  const h = {
    firstWeekContainsDate: o,
    weekStartsOn: a,
    locale: u
  }, s = [new nce()], d = n.match(Fce).map((L) => {
    const G = L[0];
    if (G in PD) {
      const J = PD[G];
      return J(L, u.formatLong);
    }
    return L;
  }).join("").match(Bce), p = [];
  for (let L of d) {
    Lz(L) && $D(L, n, e), $z(L) && $D(L, n, e);
    const G = L[0], J = Lce[G];
    if (J) {
      const { incompatibleTokens: we } = J;
      if (Array.isArray(we)) {
        const xe = p.find(
          ($e) => we.includes($e.token) || $e.token === G
        );
        if (xe)
          throw new RangeError(
            `The format string mustn't contain \`${xe.fullToken}\` and \`${L}\` at the same time`
          );
      } else if (J.incompatibleTokens === "*" && p.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${L}\` and any other token at the same time`
        );
      p.push({ token: G, fullToken: L });
      const ce = J.run(
        e,
        L,
        u.match,
        h
      );
      if (!ce)
        return lu(t, NaN);
      s.push(ce.setter), e = ce.rest;
    } else {
      if (G.match(qce))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + G + "`"
        );
      if (L === "''" ? L = "'" : G === "'" && (L = Wce(L)), e.indexOf(L) === 0)
        e = e.slice(L.length);
      else
        return lu(t, NaN);
    }
  }
  if (e.length > 0 && Uce.test(e))
    return lu(t, NaN);
  const _ = s.map((L) => L.priority).sort((L, G) => G - L).filter((L, G, J) => J.indexOf(L) === G).map(
    (L) => s.filter((G) => G.priority === L).sort((G, J) => J.subPriority - G.subPriority)
  ).map((L) => L[0]);
  let R = sr(t);
  if (isNaN(R.getTime()))
    return lu(t, NaN);
  const F = {};
  for (const L of _) {
    if (!L.validate(R, h))
      return lu(t, NaN);
    const G = L.set(R, F, h);
    Array.isArray(G) ? (R = G[0], Object.assign(F, G[1])) : R = G;
  }
  return lu(t, R);
}
function Wce(e) {
  return e.match(Vce)[1].replace(Yce, "'");
}
function nx(e, n) {
  const t = sr(e), l = sr(n);
  return t.getFullYear() === l.getFullYear() && t.getMonth() === l.getMonth();
}
function mY(e, n) {
  const t = sr(e), l = sr(n);
  return t.getFullYear() === l.getFullYear();
}
function Uz(e, n) {
  const t = +sr(e), [l, r] = [
    +sr(n.start),
    +sr(n.end)
  ].sort((u, o) => u - o);
  return t >= l && t <= r;
}
function Hce(e, n) {
  const l = Zce(e);
  let r;
  if (l.date) {
    const h = Xce(l.date, 2);
    r = Qce(h.restDateString, h.year);
  }
  if (!r || isNaN(r.getTime()))
    return /* @__PURE__ */ new Date(NaN);
  const u = r.getTime();
  let o = 0, a;
  if (l.time && (o = Jce(l.time), isNaN(o)))
    return /* @__PURE__ */ new Date(NaN);
  if (l.timezone) {
    if (a = ehe(l.timezone), isNaN(a))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    const h = new Date(u + o), s = /* @__PURE__ */ new Date(0);
    return s.setFullYear(
      h.getUTCFullYear(),
      h.getUTCMonth(),
      h.getUTCDate()
    ), s.setHours(
      h.getUTCHours(),
      h.getUTCMinutes(),
      h.getUTCSeconds(),
      h.getUTCMilliseconds()
    ), s;
  }
  return new Date(u + o + a);
}
const SS = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, zce = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Kce = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, Gce = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function Zce(e) {
  const n = {}, t = e.split(SS.dateTimeDelimiter);
  let l;
  if (t.length > 2)
    return n;
  if (/:/.test(t[0]) ? l = t[0] : (n.date = t[0], l = t[1], SS.timeZoneDelimiter.test(n.date) && (n.date = e.split(SS.timeZoneDelimiter)[0], l = e.substr(
    n.date.length,
    e.length
  ))), l) {
    const r = SS.timezone.exec(l);
    r ? (n.time = l.replace(r[1], ""), n.timezone = r[1]) : n.time = l;
  }
  return n;
}
function Xce(e, n) {
  const t = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + n) + "})|(\\d{2}|[+-]\\d{" + (2 + n) + "})$)"
  ), l = e.match(t);
  if (!l) return { year: NaN, restDateString: "" };
  const r = l[1] ? parseInt(l[1]) : null, u = l[2] ? parseInt(l[2]) : null;
  return {
    year: u === null ? r : u * 100,
    restDateString: e.slice((l[1] || l[2]).length)
  };
}
function Qce(e, n) {
  if (n === null) return /* @__PURE__ */ new Date(NaN);
  const t = e.match(zce);
  if (!t) return /* @__PURE__ */ new Date(NaN);
  const l = !!t[4], r = a_(t[1]), u = a_(t[2]) - 1, o = a_(t[3]), a = a_(t[4]), h = a_(t[5]) - 1;
  if (l)
    return ihe(n, a, h) ? nhe(n, a, h) : /* @__PURE__ */ new Date(NaN);
  {
    const s = /* @__PURE__ */ new Date(0);
    return !lhe(n, u, o) || !rhe(n, r) ? /* @__PURE__ */ new Date(NaN) : (s.setUTCFullYear(n, u, Math.max(r, o)), s);
  }
}
function a_(e) {
  return e ? parseInt(e) : 1;
}
function Jce(e) {
  const n = e.match(Kce);
  if (!n) return NaN;
  const t = pA(n[1]), l = pA(n[2]), r = pA(n[3]);
  return uhe(t, l, r) ? t * iL + l * _4 + r * 1e3 : NaN;
}
function pA(e) {
  return e && parseFloat(e.replace(",", ".")) || 0;
}
function ehe(e) {
  if (e === "Z") return 0;
  const n = e.match(Gce);
  if (!n) return 0;
  const t = n[1] === "+" ? -1 : 1, l = parseInt(n[2]), r = n[3] && parseInt(n[3]) || 0;
  return she(l, r) ? t * (l * iL + r * _4) : NaN;
}
function nhe(e, n, t) {
  const l = /* @__PURE__ */ new Date(0);
  l.setUTCFullYear(e, 0, 4);
  const r = l.getUTCDay() || 7, u = (n - 1) * 7 + t + 1 - r;
  return l.setUTCDate(l.getUTCDate() + u), l;
}
const the = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function qz(e) {
  return e % 400 === 0 || e % 4 === 0 && e % 100 !== 0;
}
function lhe(e, n, t) {
  return n >= 0 && n <= 11 && t >= 1 && t <= (the[n] || (qz(e) ? 29 : 28));
}
function rhe(e, n) {
  return n >= 1 && n <= (qz(e) ? 366 : 365);
}
function ihe(e, n, t) {
  return n >= 1 && n <= 53 && t >= 0 && t <= 6;
}
function uhe(e, n, t) {
  return e === 24 ? n === 0 && t === 0 : t >= 0 && t < 60 && n >= 0 && n < 60 && e >= 0 && e < 25;
}
function she(e, n) {
  return n >= 0 && n <= 59;
}
function ohe(e, n) {
  const t = n?.nearestTo ?? 1;
  if (t < 1 || t > 30) return lu(e, NaN);
  const l = sr(e), r = l.getSeconds() / 60, u = l.getMilliseconds() / 1e3 / 60, o = l.getMinutes() + r + u, a = n?.roundingMethod ?? "round", s = eae(a)(o / t) * t, d = lu(e, l);
  return d.setMinutes(s, 0, 0), d;
}
function ahe(e) {
  const n = sr(e), t = n.getFullYear(), l = Math.floor(t / 10) * 10;
  return n.setFullYear(l, 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Wz(e, n) {
  return y4(e, -n);
}
function che(e, n) {
  return jz(e, -n);
}
function Hz(e, n) {
  return uL(e, -n);
}
function zz(e, n, t = []) {
  return t.length >= n ? e(...t.slice(0, n).reverse()) : (...l) => zz(e, n, t.concat(l));
}
const cL = zz(Wo, 3), hhe = cl({
  props: {
    headingClickable: {
      type: Boolean,
      default: !1
    },
    leftDisabled: {
      type: Boolean,
      default: !1
    },
    rightDisabled: {
      type: Boolean,
      default: !1
    },
    columnCount: {
      type: Number,
      default: 7
    },
    items: {
      type: Array,
      default: () => []
    },
    highlights: {
      type: Array,
      default: () => []
    },
    placement: {
      type: String,
      default: sl.T,
      validator: (e) => Object.values(sl).includes(e)
    },
    permanent: Boolean,
    autoposition: { type: Boolean, default: !0 }
  },
  emits: {
    elementClick: (e) => Mu(e),
    left: () => !0,
    right: () => !0,
    heading: () => !0
  },
  setup(e) {
    const n = dt(null), t = dt(null), {
      show: l,
      placement: r,
      disabled: u,
      clickable: o,
      transition: a,
      visionTimer: h,
      position: s,
      handleMouseEnter: d,
      handleMouseLeave: p,
      hidePopover: _,
      showPopover: R,
      setPopoverPosition: F
    } = l2({
      ...e,
      popover: n,
      trigger: t,
      arrowCalculation: !1
    });
    return {
      show: l,
      placement: r,
      disabled: u,
      clickable: o,
      transition: a,
      visionTimer: h,
      popover: n,
      trigger: t,
      position: s,
      handleMouseEnter: d,
      handleMouseLeave: p,
      hidePopover: _,
      showPopover: R,
      setPopoverPosition: F,
      isSameDay: ch,
      hasHighlight: (G) => e.highlights.find(
        (J) => ch(J.date, G)
      )
    };
  }
}), fhe = (e) => (tL("data-v-49819f78"), e = e(), lL(), e), dhe = { class: "lp-calendar-heading pt-1" }, phe = { class: "lp-calendar-body" }, mhe = { class: "lp-calendar-subheading" }, ghe = /* @__PURE__ */ fhe(() => /* @__PURE__ */ qn("hr", { class: "lp-calendar-divider" }, null, -1)), whe = { class: "lp-calendar-elements" }, vhe = ["disabled", "data-ua-value", "aria-label", "onClick"], yhe = {
  key: 0,
  class: "notification-dot-container datepicker-notifications"
}, _he = {
  key: 0,
  class: "lp-highlight-datepicker-tags p-1"
};
function xhe(e, n, t, l, r, u) {
  const o = El("lp-icon");
  return Qe(), yn("div", {
    ref: "popover",
    class: "lp-calendar-popout",
    style: Hi({ "--popout-column-definition": `repeat(${e.columnCount}, 1fr)` }),
    onMousedown: n[0] || (n[0] = Oi(() => {
    }, ["prevent"]))
  }, [
    qn("div", dhe, [
      (Qe(), _l(ap("div"), { class: "lp-calendar-heading-center" }, {
        default: kl(() => [
          el(e.$slots, "heading", {}, void 0, !0)
        ]),
        _: 3
      }))
    ]),
    qn("div", phe, [
      "subheading" in e.$slots ? (Qe(), yn(Ii, { key: 0 }, [
        qn("div", mhe, [
          el(e.$slots, "subheading", {}, void 0, !0)
        ]),
        ghe
      ], 64)) : st("", !0),
      qn("div", whe, [
        el(e.$slots, "body", {}, () => [
          (Qe(!0), yn(Ii, null, ru(e.items, (a) => (Qe(), yn("button", {
            key: a.key,
            disabled: a.disabled,
            class: xt({ selected: a.selected }),
            "data-ua-multiple-id": "ua-datepicker-option",
            "data-ua-value": a.display,
            "aria-label": a.value.toLocaleDateString("en-us", {
              weekday: "long",
              year: "numeric",
              month: "short",
              day: "numeric"
            }),
            onClick: Oi((h) => e.$emit("elementClick", a.value), ["stop", "prevent"])
          }, [
            Ir(It(a.display) + " ", 1),
            e.hasHighlight(a.value) ? (Qe(), yn("div", yhe, [
              (Qe(!0), yn(Ii, null, ru(e.highlights, (h) => (Qe(), yn("div", {
                key: h.date,
                style: Hi(`${e.isSameDay(h.date, a.value) ? "" : "display: none;"}`),
                class: xt(["notification-dot-sm", `bg-${h.color}`])
              }, null, 6))), 128))
            ])) : st("", !0)
          ], 10, vhe))), 128))
        ], !0)
      ])
    ]),
    e.highlights.length ? (Qe(), yn("div", _he, [
      (Qe(!0), yn(Ii, null, ru(e.highlights, (a) => (Qe(), yn("span", {
        key: a.date,
        class: xt(["tag", `tag-${a.color}`])
      }, It(a.label), 3))), 128))
    ])) : st("", !0),
    dl(o, { name: "" })
  ], 36);
}
const She = /* @__PURE__ */ Cr(hhe, [["render", xhe], ["__scopeId", "data-v-49819f78"]]), Ehe = cl({
  components: {
    PickerPopup: She
  },
  props: {
    highlights: {
      type: Array,
      default: () => []
    },
    selected: {
      type: [Date, Array],
      required: !1,
      default: () => null
    },
    pageDate: {
      type: Date,
      required: !0
    },
    format: {
      type: String,
      required: !1,
      default: "d"
    },
    headingFormat: {
      type: String,
      required: !1,
      default: "LLL"
    },
    weekdayFormat: {
      type: String,
      required: !1,
      default: "EEE"
    },
    locale: {
      type: Object,
      required: !1
    },
    weekStartsOn: {
      type: Number,
      required: !1,
      default: 1,
      validator: (e) => typeof e == "number" && Number.isInteger(e) && e >= 0 && e <= 6
    },
    lowerLimit: {
      type: Date,
      required: !1
    },
    upperLimit: {
      type: Date,
      required: !1
    },
    disabledDates: {
      type: Object,
      required: !1
    }
  },
  emits: {
    "update:pageDate": (e) => Mu(e),
    select: (e) => Mu(e),
    back: () => !0
  },
  setup(e, { emit: n }) {
    const t = _t(
      () => cL({
        locale: e.locale,
        weekStartsOn: e.weekStartsOn
      })
    ), l = _t(() => x4(e.pageDate)), r = _t(() => sL(e.pageDate)), u = _t(() => ({
      start: l.value,
      end: r.value
    })), o = _t(() => ({
      start: If(l.value, {
        weekStartsOn: e.weekStartsOn
      }),
      end: Rz(r.value, {
        weekStartsOn: e.weekStartsOn
      })
    })), a = _t(() => {
      const L = e.weekStartsOn, G = t.value(e.weekdayFormat);
      return Array.from(Array(7)).map((J, we) => (L + we) % 7).map(
        (J) => y3(/* @__PURE__ */ new Date(), J, {
          weekStartsOn: e.weekStartsOn
        })
      ).map(G);
    }), h = (L, G, J, we) => we?.dates?.some((ce) => ch(L, ce)) || we?.predicate?.(L) ? !1 : !G && !J ? !0 : !(G && Nw(L, fy(G)) || J && Rw(L, Az(J))), s = _t(() => {
      const L = t.value(e.format);
      return Dz(o.value).map((G) => {
        const J = !!e.selected && (!Array.isArray(e.selected) && ch(e.selected, G) || e.selected && Array.isArray(e.selected) && e.selected.some(
          (we) => ch(we, G)
        ));
        return {
          value: G,
          display: L(G),
          selected: J,
          disabled: !Uz(G, u.value) || !h(
            G,
            e.lowerLimit,
            e.upperLimit,
            e.disabledDates
          ),
          key: t.value("yyyy-MM-dd", G)
        };
      });
    }), d = _t(
      () => t.value(e.headingFormat)(e.pageDate)
    ), p = _t(
      () => e.lowerLimit && (nx(e.lowerLimit, e.pageDate) || Nw(e.pageDate, e.lowerLimit))
    ), _ = _t(
      () => e.upperLimit && (nx(e.upperLimit, e.pageDate) || Rw(e.pageDate, e.upperLimit))
    );
    return {
      weekDays: a,
      days: s,
      heading: d,
      leftDisabled: p,
      rightDisabled: _,
      previousPage: () => n("update:pageDate", Wz(e.pageDate, 1)),
      nextPage: () => n("update:pageDate", y4(e.pageDate, 1))
    };
  }
}), Ohe = { class: "font-weight-bold" };
function khe(e, n, t, l, r, u) {
  const o = El("picker-popup");
  return Qe(), _l(o, {
    items: e.days,
    highlights: e.highlights,
    onElementClick: n[0] || (n[0] = (a) => e.$emit("select", a))
  }, {
    heading: kl(() => [
      qn("span", Ohe, It(e.heading.toUpperCase()), 1)
    ]),
    subheading: kl(() => [
      (Qe(!0), yn(Ii, null, ru(e.weekDays, (a) => (Qe(), yn("span", { key: a }, It(a), 1))), 128))
    ]),
    _: 1
  }, 8, ["items", "highlights"]);
}
const bhe = /* @__PURE__ */ Cr(Ehe, [["render", khe]]), S4 = {
  beforeMount(e, n) {
    let t = !1;
    e.clickStarted = (l) => {
      e.contains(l.target) && (t = !0);
    }, e.clickOutsideHandler = (l) => {
      !e.contains(l.target) && n.value && !t && n.value(l), t = !1;
    }, document.addEventListener("mousedown", e.clickStarted), document.addEventListener("mouseup", e.clickOutsideHandler);
  },
  unmounted(e) {
    document.removeEventListener("mouseup", e.clickOutsideHandler), document.removeEventListener("mousedown", e.clickOutsideHandler);
  }
}, The = ({
  duration: e,
  array: n,
  curIndex: t
}) => ({
  [ex.UP]: t <= 0 ? n.length - 1 : t - 1,
  [ex.DOWN]: t === n.length - 1 ? 0 : t + 1
})[e], Kz = [
  sl.T,
  sl.B,
  sl.L,
  sl.R,
  sl.TL,
  sl.TR,
  sl.BL,
  sl.BR
], Gz = "lp-select-option-focused", jhe = 55, hL = (e, n, t) => {
  const l = dt(-1), r = dt([]), u = dt(void 0);
  let o = -1;
  const a = dt(!1);
  poe(() => r.value = []);
  const h = () => {
    const xe = r.value[o];
    u.value !== void 0 && (u.value.scrollTop = xe?.offsetTop - jhe);
  }, s = (xe) => typeof xe == "object" ? xe[e.labelBy] ? xe[e.labelBy] : xe.name : xe, d = (xe) => typeof xe == "object" ? xe[e.trackBy] : xe, p = (xe, $e) => {
    xe && (r.value[$e] = xe);
  }, _ = (xe) => {
    xe && (u.value = xe);
  }, R = (xe = !1) => {
    a.value = xe;
  }, F = async () => {
    if (e.disabled) {
      R(!1);
      return;
    }
    a.value ? R(!1) : (G(), R(!0), await Ta(), e.modelValue && h());
  }, L = (xe, $e = null) => {
    const je = e.options[xe];
    o = xe, l.value = xe;
    const E = typeof je == "object" ? je[e.trackBy] : je, P = typeof je == "object" ? je[e.labelBy] : je, K = String($e);
    n("update:model-value", E, je), t && (t.handleModelChange(E, je, P, K), t.handleGroupChange(K, E, je));
  }, G = () => {
    l.value !== -1 && (l.value = -1);
  }, J = async (xe) => {
    if (!a.value || !e.options.length) return;
    l.value = The({
      duration: xe,
      array: e.options,
      curIndex: l.value
    }), await Ta(), r.value.find(
      (je) => je.className.includes(Gz)
    )?.scrollIntoView({ block: "nearest", inline: "start" });
  }, we = () => {
    if (!a.value || l.value === -1) {
      F();
      return;
    }
    L(l.value), R(!1);
  };
  return {
    wrappedValue: _t(() => {
      const xe = e.modelValue, $e = { name: "", [e.trackBy]: "" };
      if (xe === null)
        return $e;
      if (typeof xe == "object")
        return xe;
      const je = e.options.find(
        (E) => E[e.trackBy] === xe
      );
      return $e.name = typeof je == "object" ? e.labelBy ? je[e.labelBy] : je.name : xe, $e[e.trackBy] = xe, $e;
    }),
    getOptionValue: d,
    getOptionName: s,
    setOptionRef: p,
    indexFocusedOption: l,
    optionsRefs: r,
    show: a,
    handleEnterKey: we,
    setOpen: R,
    toggleDropdown: F,
    selectOption: L,
    setSelectListRef: _,
    handleKey: J
  };
};
let mA = 0;
function fm(e) {
  mA++;
  try {
    return `${e && e.length > 0 ? `${e}-` : ""}10000000-1000-4000-8000-100000000000-${mA}`.replace(/[018]/g, (n) => {
      const t = parseInt(n);
      return (t ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> t / 4).toString(16);
    });
  } catch {
    const t = Date.now(), l = Math.floor(Math.random() * 1e9);
    return e + "_" + l + mA + String(t);
  }
}
const Ahe = cl({
  name: "lp-select",
  directives: {
    clickoutside: S4
  },
  inheritAttrs: !1,
  props: {
    clearable: { type: Boolean, default: !0 },
    compact: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    divided: { type: Boolean, default: !1 },
    fontStyle: { type: String, default: "regular" },
    helper: { type: String, default: null },
    id: {
      type: String,
      default: fm("select")
    },
    inlineLabel: { type: Boolean, default: !1 },
    labelBy: { type: String, default: "name" },
    labelTop: { type: String, default: null },
    loading: { type: Boolean, default: !1 },
    loadingIconRadius: { type: Number, default: 10 },
    loadingIconStroke: { type: Number, default: 2 },
    loadingLabel: { type: String, default: "Loading" },
    message: { type: String, default: null },
    modelValue: { type: [String, Number, Boolean, Object], default: null },
    options: { type: Array, default: () => [] },
    placeholder: { type: String, default: "Select option" },
    placement: {
      type: String,
      default: sl.B,
      validator: (e) => Kz.includes(e)
    },
    prefix: { type: String, default: "prefix" },
    preview: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    search: { type: Boolean, default: !1 },
    searchFilter: { type: Boolean, default: !0 },
    searchPlaceholder: { type: String, default: "Filter options..." },
    searchValue: { type: String, default: "" },
    showLoadingCentered: { type: Boolean, default: !0 },
    showLoadingLabel: { type: Boolean, default: !1 },
    showNull: { type: Boolean, default: !1 },
    singleValue: { type: Boolean, default: !1 },
    status: { type: String, default: "neutral" },
    suffix: { type: String, default: "suffix" },
    trackBy: { type: String, default: "value" },
    triggerOnly: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:model-value", "update:searchValue"],
  setup(e, { emit: n, slots: t }) {
    const l = ow(t, "label-top") !== null, r = !1, u = dt(e.searchValue), {
      wrappedValue: o,
      getOptionName: a,
      getOptionValue: h,
      setOptionRef: s,
      indexFocusedOption: d,
      optionsRefs: p,
      show: _,
      handleEnterKey: R,
      setOpen: F,
      setSelectListRef: L,
      toggleDropdown: G,
      selectOption: J,
      handleKey: we
    } = hL(e, n), ce = _t(() => ({
      "lp-select-selection-disabled": e.disabled,
      "lp-select-selection-active": _.value,
      "lp-select-trigger-only": e.triggerOnly
    })), xe = _t(() => ({
      [e.placement ? `lp-select-dropdown-${e.placement}` : `lp-select-dropdown-${sl.B}`]: !0,
      "lp-select-dropdown-divided": e.divided
    })), $e = _t(() => e.loading ? [
      {
        [e.labelBy]: e.showLoadingLabel ? e.loadingLabel : "",
        [e.trackBy]: null,
        disabled: !0,
        loadingState: !0
      }
    ] : e.showNull ? [
      typeof e.options[0] != "object" ? null : { [e.labelBy]: e.placeholder, [e.trackBy]: null },
      ...e.options
    ] : e.options);
    return {
      labelTopSlotExist: l,
      CLASS_SELECTED_OPTION: Gz,
      wrappedValue: o,
      getOptionName: a,
      getOptionValue: h,
      setOptionRef: s,
      indexFocusedOption: d,
      optionsRefs: p,
      show: _,
      handleEnterKey: R,
      setOpen: F,
      setSelectListRef: L,
      toggleDropdown: G,
      selectOption: J,
      handleKey: we,
      selectionClasses: ce,
      dropdownClasses: xe,
      props: e,
      EDirections: ex,
      modal: r,
      computedOptions: $e,
      searchValueRef: u,
      clearSearch: () => {
        u.value = "";
      },
      isClickOutside: (H) => {
        if (H.target) {
          const U = H.target;
          !U.classList.contains("lp-input") && !U.classList.contains("lpi-close") && F(!1);
        }
      },
      isOptionDisabled: (H, U) => {
        H.disabled ? _.value = !1 : J(U);
      },
      handleSearchInput: () => {
        n("update:searchValue", u.value);
      }
    };
  }
}), Dhe = { class: "lp-select" }, Ihe = {
  key: 0,
  class: "lp-input-label font-weight-medium"
}, Rhe = {
  key: 0,
  class: "text-blue"
}, Nhe = { key: 1 }, Che = ["aria-label", "aria-activedescendant", "tabindex"], Mhe = {
  key: 0,
  class: "lp-select-selected"
}, Phe = { key: 0 }, $he = {
  key: 1,
  class: "lp-select-placeholder"
}, Lhe = {
  key: 0,
  class: "lp-select-search-wrapper"
}, Bhe = { class: "clearable" }, Fhe = ["id", "aria-selected", "data-ua-value", "aria-label", "onClick", "onKeydown"], Vhe = { class: "ly-row ly-start-center mb-half" }, Yhe = ["innerHTML"], Uhe = { class: "lp-select-option-label" }, qhe = ["innerHTML"], Whe = ["innerHTML"], Hhe = { class: "ly-row" }, zhe = {
  key: 1,
  class: "lp-input-message mt-half text-gray"
};
function Khe(e, n, t, l, r, u) {
  const o = El("lp-icon"), a = El("lp-input"), h = El("lp-loading"), s = w4("clickoutside");
  return Qe(), yn("div", Dhe, [
    !e.inlineLabel && (e.labelTop || e.labelTopSlotExist) ? (Qe(), yn("span", Ihe, [
      el(e.$slots, "label-top", { props: e.props }, () => [
        qn("span", null, It(e.labelTop), 1),
        !e.preview && e.required ? (Qe(), yn("span", Rhe, "*")) : st("", !0)
      ])
    ])) : st("", !0),
    e.preview ? (Qe(), yn("span", Nhe, It(e.wrappedValue.name), 1)) : (Qe(), yn("div", {
      key: 2,
      class: xt(["lp-select-inner", [
        e.message ? "lp-input-wrapper-danger" : e.status && `lp-input-wrapper-${e.status}`,
        e.disabled && "lp-input-wrapper-disabled"
      ]]),
      style: Hi(e.compact || e.message || e.helper ? "" : "margin-bottom: 22px;")
    }, [
      pi((Qe(), yn("div", Ni({
        ref: "trigger",
        role: "listbox",
        "aria-label": e.wrappedValue.name ?? e.wrappedValue,
        "aria-activedescendant": `${e.id}--option-${e.indexFocusedOption}`,
        tabindex: e.disabled ? -1 : 0,
        class: ["lp-select-selection form-faux-select", e.selectionClasses]
      }, e.$attrs, {
        onClick: n[0] || (n[0] = (...d) => e.toggleDropdown && e.toggleDropdown(...d)),
        onKeydown: [
          n[1] || (n[1] = Ei(() => e.setOpen(!1), ["tab"])),
          n[2] || (n[2] = Ei(Oi((d) => e.handleKey(e.EDirections.DOWN), ["stop", "prevent"]), ["down"])),
          n[3] || (n[3] = Ei(Oi((d) => e.handleKey(e.EDirections.UP), ["stop", "prevent"]), ["up"])),
          n[4] || (n[4] = Ei(Oi(() => e.setOpen(!1), ["stop", "prevent"]), ["esc"])),
          n[5] || (n[5] = Ei(Oi((...d) => e.handleEnterKey && e.handleEnterKey(...d), ["stop", "prevent"]), ["enter"]))
        ]
      }), [
        (e.wrappedValue[e.trackBy] || typeof e.wrappedValue[e.trackBy] == "boolean" || e.wrappedValue[e.trackBy] === 0) && !e.triggerOnly ? (Qe(), yn("span", Mhe, [
          el(e.$slots, "selected-option", { props: e.props }, () => [
            e.inlineLabel ? (Qe(), yn("span", Phe, It(e.labelTop) + ":", 1)) : st("", !0),
            qn("span", {
              class: xt(`font-weight-${e.fontStyle}`)
            }, It(e.wrappedValue.name ?? e.wrappedValue), 3)
          ])
        ])) : e.triggerOnly ? st("", !0) : (Qe(), yn("span", $he, [
          el(e.$slots, "placeholder", { props: e.props }, () => [
            Ir(It(e.placeholder), 1)
          ])
        ])),
        el(e.$slots, "icon", { props: e.props }, () => [
          dl(o, {
            name: "chevron-down",
            "aria-hidden": "true",
            class: xt(e.show && "lp-select-arrowactive")
          }, null, 8, ["class"])
        ])
      ], 16, Che)), [
        [s, (d) => e.isClickOutside(d)]
      ]),
      dl(du, { name: "drop-bottom" }, {
        default: kl(() => [
          e.show ? (Qe(), yn("div", {
            key: 0,
            class: xt(["lp-select-dropdown", e.dropdownClasses])
          }, [
            qn("div", {
              ref: (d) => e.setSelectListRef(d),
              class: "lp-select-list menu-pop-up"
            }, [
              e.search ? (Qe(), yn("div", Lhe, [
                dl(a, {
                  modelValue: e.searchValueRef,
                  "onUpdate:modelValue": n[7] || (n[7] = (d) => e.searchValueRef = d),
                  placeholder: e.searchPlaceholder,
                  "prefix-icon": "search",
                  "prefix-icon-aria-hidden": "true",
                  compact: "",
                  onKeyup: e.handleSearchInput
                }, {
                  clear: kl(() => [
                    pi(qn("div", Bhe, [
                      el(e.$slots, "clear", { onClear: e.clearSearch }, () => [
                        dl(o, {
                          class: "lp-input-icon-wrapper",
                          name: "close",
                          role: "button",
                          onClick: n[6] || (n[6] = Oi((d) => e.clearSearch(), ["stop", "prevent"]))
                        })
                      ])
                    ], 512), [
                      [Pi, e.searchValueRef]
                    ])
                  ]),
                  _: 3
                }, 8, ["modelValue", "placeholder", "onKeyup"])
              ])) : st("", !0),
              (Qe(!0), yn(Ii, null, ru(e.computedOptions, (d, p) => (Qe(), yn("li", {
                id: `${e.id}--option-${p}`,
                key: p,
                ref_for: !0,
                ref: (_) => e.setOptionRef(_, p),
                class: xt(["lp-select-option ly-col", [
                  e.indexFocusedOption === p && e.CLASS_SELECTED_OPTION,
                  e.wrappedValue[e.trackBy] === e.getOptionValue(d) && "lp-select-option-selected",
                  d.disabled && "lp-select-option-disabled",
                  d.divided && "border-top border-gray-medium",
                  d.loadingState && e.props.showLoadingCentered && "ly-spacearound-center"
                ]]),
                role: "option",
                tabindex: "0",
                "aria-selected": e.indexFocusedOption === p ? "true" : "false",
                "data-ua-multiple-id": "ua-select-option",
                "data-ua-value": e.getOptionName(d),
                "aria-label": d.loadingState ? e.props.loadingLabel : e.getOptionName(d),
                onClick: (_) => e.isOptionDisabled(d, p),
                onKeydown: Ei(Oi((_) => e.isOptionDisabled(d, p), ["stop", "prevent"]), ["enter"])
              }, [
                qn("div", Vhe, [
                  typeof d[e.prefix] == "string" && d[e.prefix] ? (Qe(), yn("span", {
                    key: 0,
                    class: "lp-select-option-prefix",
                    innerHTML: d[e.prefix]
                  }, null, 8, Yhe)) : (Qe(), _l(ap(d[e.prefix]), { key: 1 })),
                  qn("span", {
                    class: xt(["ly-col ly-spacearound-start", [
                      e.searchFilter && !d.loadingState && !e.getOptionName(d).toString().toLowerCase().includes(e.searchValueRef) && "lp-select-option-hidden",
                      d.loadingState && "lp-select-option--loading",
                      d.loadingState && e.props.showLoadingLabel && "lp-select-option--loading-with-text"
                    ]])
                  }, [
                    el(e.$slots, "option", {
                      props: e.props,
                      option: d
                    }, () => [
                      qn("span", Uhe, [
                        Ir(It(e.getOptionName(d)) + " ", 1),
                        d.loadingState ? (Qe(), _l(h, {
                          key: 0,
                          "aria-label": e.loadingLabel,
                          stroke: e.loadingIconStroke,
                          radius: e.loadingIconRadius
                        }, null, 8, ["aria-label", "stroke", "radius"])) : st("", !0)
                      ])
                    ])
                  ], 2),
                  typeof d[e.suffix] == "string" && d[e.suffix] ? (Qe(), yn("span", {
                    key: 2,
                    class: "lp-select-option-suffix",
                    innerHTML: d[e.suffix]
                  }, null, 8, qhe)) : (Qe(), _l(ap(d[e.suffix]), { key: 3 }))
                ]),
                d.helper ? (Qe(), yn("p", {
                  key: 0,
                  innerHTML: d.helper
                }, null, 8, Whe)) : st("", !0)
              ], 42, Fhe))), 128))
            ], 512)
          ], 2)) : st("", !0)
        ]),
        _: 3
      })
    ], 6)),
    dl(du, { name: "fade-bottom" }, {
      default: kl(() => [
        qn("div", Hhe, [
          e.message ? (Qe(), yn("span", {
            key: 0,
            class: xt(["lp-input-message mt-half d-flex", [
              e.message ? "lp-input-message-danger" : e.status && `lp-input-message-${e.status}`,
              e.disabled && "lp-input-message-disabled"
            ]])
          }, It(e.message), 3)) : (Qe(), yn("span", zhe, It(e.helper), 1))
        ])
      ]),
      _: 1
    })
  ]);
}
const fL = /* @__PURE__ */ Cr(Ahe, [["render", Khe]]);
var nh = /* @__PURE__ */ ((e) => (e.Currency = "currency", e.Integer = "integer", e.Decimal = "decimal", e.Percentage = "percentage", e.SocialSecurity = "ssn", e.Zip = "zip", e))(nh || {});
const Ghe = /(\d{5})(\d{4})/, Zhe = /(\d{3})(\d{2})(\d{4})/, RO = (e) => `${new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD"
}).format(e)}`, dL = (e) => `${new Intl.NumberFormat("en-US").format(Math.round(e))}`, LD = (e) => `${new Intl.NumberFormat("en-US").format(e)}`, Xhe = (e) => `${e.toString().replace(Ghe, "$1-$2")}`, Qhe = (e) => `${e.toString().replace(Zhe, "$1-$2-$3")}`, gY = (e, n = "decimal") => {
  const t = n === "currency" ? RO : n === "integer" ? dL : LD, l = e[0] !== null, r = e[1] !== null;
  return e[0] === e[1] ? `${t(e[0])}` : l && r ? `${t(e[0])} - ${t(
    e[1]
  )}` : !l && r ? `less than ${t(e[1])}` : `more than ${t(e[0])}`;
}, Jhe = { class: "lp-number-field-wrapper" }, efe = { class: "ly-row ly-spacebetween-center" }, nfe = {
  key: 0,
  class: "lp-input-label font-weight-medium"
}, tfe = {
  key: 0,
  class: "text-blue"
}, lfe = { key: 1 }, rfe = { class: "lp-number-field" }, ife = {
  key: 0,
  class: "lp-input-icon-wrapper compact"
}, ufe = { class: "lp-input-stacked-values w-100" }, sfe = ["value", "disabled", "max", "min", "placeholder", "onKeydown"], ofe = {
  key: 1,
  class: "lp-input-icon-wrapper"
}, afe = {
  key: 1,
  class: "lp-input-message mt-half d-flex text-gray"
}, C_ = /* @__PURE__ */ cl({
  name: "lp-number-input",
  inheritAttrs: !1,
  __name: "LpNumberInput",
  props: {
    min: { default: -1 / 0 },
    max: { default: 999999999 },
    maxLength: { default: 9 },
    step: { default: 1 },
    status: { default: "neutral" },
    message: { default: null },
    helper: { default: null },
    placeholder: { default: null },
    disabled: { type: Boolean, default: !1 },
    labelTop: { default: null },
    modelValue: { default: null },
    optionValue: { default: null },
    options: { default: void 0 },
    optionsTrackBy: { default: "value" },
    optionsLabelBy: { default: "name" },
    optionsAmountBy: { default: "amount" },
    optionsPlaceholder: { default: "Select option" },
    format: { default: nh.Decimal },
    required: { type: [Boolean, null], default: !1 },
    preview: { type: [Boolean, null], default: !1 },
    showOptionValue: { type: [Boolean, null], default: !1 },
    compact: { type: Boolean },
    noFormat: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "update:optionValue"],
  setup(e, { emit: n }) {
    const t = n, l = e, r = dt(l.optionValue), u = dt(l.optionsPlaceholder), o = dt(null), a = dt(!1), h = dt(null);
    function s(G) {
      if (l.disabled) return;
      let J = Number(l.modelValue);
      const we = Number(l.step);
      switch (G) {
        case "plus":
          J += we;
          break;
        case "minus":
          J -= we;
          break;
      }
      J > l.max && (J = l.max), J < l.min && (J = l.min), t("update:modelValue", Number(J.toFixed(10)));
    }
    function d() {
      l.disabled || Number(l.modelValue) >= l.max || s("plus");
    }
    function p() {
      l.disabled || Number(l.modelValue) <= l.min || s("minus");
    }
    function _(G) {
      const J = G.target.value, we = Number(J);
      let ce = J.trim() === "" ? null : we;
      switch (G.data) {
        case "-":
        case "+":
        case "e":
          G.target.value = String(l.modelValue), ce = Number(l.modelValue);
          break;
      }
      if (J.length <= l.maxLength) {
        t("update:modelValue", ce);
        return;
      } else {
        const xe = Number(J.slice(0, l.maxLength));
        h.value.value = xe, G.target.value = xe.toString(), t("update:modelValue", xe);
        return;
      }
    }
    const R = _t(() => {
      if (l.modelValue === null) return null;
      if (l.noFormat) return l.modelValue;
      switch (l.format) {
        case nh.Currency:
          return RO(Number(l.modelValue)).replace("$", "");
        case nh.Integer:
          return dL(Number(l.modelValue));
        case nh.Zip:
          return Xhe(Number(l.modelValue));
        case nh.SocialSecurity:
          return Qhe(Number(l.modelValue));
        case nh.Decimal:
          return LD(Number(l.modelValue));
        case nh.Percentage:
          return LD(Number(l.modelValue));
      }
      return Number(l.modelValue);
    }), F = () => {
      a.value = !0, Ta().then(() => {
        h.value?.focus();
      });
    };
    function L(G, J) {
      u.value = J[l.optionsLabelBy], t("update:modelValue", J[l.optionsAmountBy]);
    }
    return (G, J) => {
      const we = El("lp-icon");
      return Qe(), yn("div", Jhe, [
        qn("div", efe, [
          G.labelTop ? (Qe(), yn("span", nfe, [
            qn("span", null, It(G.labelTop), 1),
            !G.preview && G.required ? (Qe(), yn("span", tfe, "*")) : st("", !0)
          ])) : st("", !0),
          G.options && G.showOptionValue ? (Qe(), yn("span", lfe, It(u.value), 1)) : st("", !0)
        ]),
        qn("div", rfe, [
          qn("div", {
            class: xt(["lp-number-input lp-input-wrapper xpx-3 ly-row ly-center-center ly-no-gap", [
              G.disabled && "lp-number-input-disabled",
              G.message ? "lp-input-wrapper-danger" : G.status && `lp-input-wrapper-${G.status}`,
              G.disabled && "lp-input-wrapper-disabled",
              G.preview && "lp-number-input-preview"
            ]])
          }, [
            G.format === Zr(nh).Currency ? (Qe(), yn("span", ife, [
              dl(we, {
                class: "lp-input-icon",
                name: "dollar",
                compact: ""
              })
            ])) : st("", !0),
            qn("div", ufe, [
              G.preview ? st("", !0) : (Qe(), yn("input", Ni({
                key: 0,
                ref_key: "input",
                ref: h,
                type: "number",
                value: G.modelValue,
                class: "lp-number-input-original",
                disabled: G.disabled,
                max: G.max,
                min: G.min,
                placeholder: G.placeholder
              }, G.$attrs, {
                onInput: _,
                onKeydown: [
                  Ei(Oi(d, ["stop", "prevent"]), ["up"]),
                  Ei(Oi(p, ["stop", "prevent"]), ["down"])
                ],
                onFocus: J[0] || (J[0] = (ce) => a.value = !0),
                onBlur: J[1] || (J[1] = (ce) => a.value = !1)
              }), null, 16, sfe)),
              G.preview || !a.value ? (Qe(), yn("span", {
                key: 1,
                ref_key: "buffer",
                ref: o,
                class: "lp-number-input-buffer ly-row ly-start-center ml-1 no-events",
                onClick: J[2] || (J[2] = (ce) => G.disabled ? null : F)
              }, It(R.value), 513)) : st("", !0)
            ]),
            G.format === Zr(nh).Percentage ? (Qe(), yn("span", ofe, [
              dl(we, {
                class: "lp-input-icon",
                name: "percentage"
              })
            ])) : st("", !0)
          ], 2),
          G.options && !G.preview ? (Qe(), _l(fL, {
            key: 0,
            modelValue: r.value,
            "onUpdate:modelValue": [
              J[3] || (J[3] = (ce) => r.value = ce),
              L
            ],
            "label-by": G.optionsLabelBy,
            options: G.options,
            "track-by": G.optionsTrackBy,
            disabled: G.disabled,
            "trigger-only": ""
          }, null, 8, ["modelValue", "label-by", "options", "track-by", "disabled"])) : st("", !0)
        ]),
        G.message ? (Qe(), yn("span", {
          key: 0,
          class: xt(["lp-input-message mt-half d-flex", [
            G.message ? "lp-input-message-danger" : G.status && `lp-input-message-${G.status}`,
            G.disabled && "lp-input-message-disabled"
          ]])
        }, It(G.message), 3)) : st("", !0),
        G.message ? st("", !0) : (Qe(), yn("span", afe, It(G.helper), 1))
      ]);
    };
  }
}), ES = ["day", "month", "year"], cfe = cl({
  name: "lp-calendar",
  components: {
    LpNumberInput: C_,
    LpSelect: fL,
    DayPicker: bhe
  },
  inheritAttrs: !1,
  props: {
    status: { type: String, default: "neutral" },
    message: { type: String, default: null },
    /**
     * `v-model` for selected date
     */
    modelValue: {
      required: !1,
      type: [Date, Array],
      default: () => null
    },
    /**
     * Dates not available for picking
     */
    disabledDates: {
      type: Object,
      required: !1
    },
    /**
     * Upper limit for available dates for picking
     */
    upperLimit: {
      type: Date,
      required: !1
    },
    /**
     * Lower limit for available dates for picking
     */
    lowerLimit: {
      type: Date,
      required: !1
    },
    /**
     * View on which the date picker should open. Can be either `year`, `month`, or `day`
     */
    startingView: {
      type: String,
      required: !1,
      default: "day",
      validate: (e) => typeof e == "string" && ES.includes(e)
    },
    /**
     * `date-fns`-type formatting for a month view heading
     */
    monthHeadingFormat: {
      type: String,
      required: !1,
      default: "LLLL yyyy"
    },
    /**
     * `date-fns`-type formatting for the month picker view
     */
    monthListFormat: {
      type: String,
      required: !1,
      default: "LLL"
    },
    /**
     * `date-fns`-type formatting for a line of weekdays on day view
     */
    weekdayFormat: {
      type: String,
      required: !1,
      default: "EE"
    },
    /**
     * `date-fns`-type format in which the string in the input should be both
     * parsed and displayed
     */
    inputFormat: {
      type: String,
      required: !1,
      default: "MM/dd/yy"
    },
    placeholder: {
      type: String,
      required: !1,
      default: null
    },
    /**
     * [`date-fns` locale object](https://date-fns.org/v2.16.1/docs/I18n#usage).
     * Used in string formatting (see default `monthHeadingFormat`)
     */
    locale: {
      type: Object,
      required: !1
    },
    /**
     * Day on which the week should start.
     *
     * Number from 0 to 6, where 0 is Sunday and 6 is Saturday.
     * Week starts with a Monday (1) by default
     */
    weekStartsOn: {
      type: Number,
      required: !1,
      default: 0,
      validator: (e) => [0, 1, 2, 3, 4, 5, 6].includes(e)
    },
    /**
     * Disables datepicker and prevents it's opening
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Clears selected date
     */
    clearable: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /*
     * Allows user to input date manually
     */
    typeable: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * If set, lower-level views won't show
     */
    minimumView: {
      type: String,
      required: !1,
      default: "day",
      validate: (e) => typeof e == "string" && ES.includes(e)
    },
    highlights: {
      type: Array,
      default: () => []
    },
    preview: {
      type: Boolean,
      required: !1,
      default: !1
    },
    dataUaUniqueId: {
      type: String,
      required: !1,
      default: "ua-datepicker-wrapper"
    },
    labelTop: {
      type: String,
      required: !1,
      default: null
    },
    required: {
      type: Boolean
    },
    yearSelector: {
      type: Boolean,
      default: !0
    },
    currentYear: {
      type: Number,
      required: !1,
      default: () => (/* @__PURE__ */ new Date()).getFullYear()
    }
  },
  emits: {
    "update:modelValue": (e) => e == null || Array.isArray(e) && e.every((n) => Mu(n)) || Mu(e),
    "update:currentYear": (e) => e > 0
  },
  setup(e, { emit: n }) {
    const t = Ga(e.modelValue), l = dt("none"), r = dt(/* @__PURE__ */ new Date()), u = dt(null), o = dt(""), a = dt(e.message), h = dt(e.message), s = dt(e.currentYear);
    ga(() => {
      if (u.value) {
        const xe = N_(o.value, e.inputFormat, /* @__PURE__ */ new Date());
        Mu(xe) ? (r.value = xe, h.value = a.value) : o.value.length > e.inputFormat.length && (o.value = "", n("update:modelValue", null), h.value = "Date is not valid. Please try again.");
      }
    }), ga(
      () => o.value = e.modelValue && Mu(e.modelValue) ? Wo(e.modelValue, e.inputFormat, {
        locale: e.locale
      }) : ""
    ), ga(() => {
      a.value = e.message, h.value = a.value;
    });
    const d = (xe = "none") => {
      e.disabled || (l.value = xe, e.modelValue || (r.value = /* @__PURE__ */ new Date()));
    };
    ga(() => {
      e.disabled && (l.value = "none");
    });
    const p = (xe) => {
      r.value = xe, e.minimumView === "year" ? (l.value = "none", n("update:modelValue", xe)) : l.value = "month";
    }, _ = (xe) => {
      r.value = xe, e.minimumView === "month" ? (l.value = "none", n("update:modelValue", xe)) : l.value = "day";
    }, R = (xe) => {
      let $e = t.value;
      Array.isArray(t.value) && Array.isArray(e.modelValue) && Array.isArray($e) ? t.value.some(
        (je) => ch(je, xe)
      ) ? $e = t.value.filter(
        (je) => !ch(je, xe)
      ) : $e.push(xe) : !$e || $e instanceof Date && !ch($e, xe) ? $e = [xe] : $e = null, t.value = $e, n("update:modelValue", $e), l.value = "none";
    }, F = () => {
      e.clearable && n("update:modelValue", null);
    }, L = (xe) => {
      const $e = xe.code ? xe.code : xe.button;
      if ([
        27,
        // escape
        13
        // enter
      ].includes($e) && u.value?.blur(), e.typeable && o.value.length === e.inputFormat.length) {
        const E = N_(o.value, e.inputFormat, /* @__PURE__ */ new Date());
        Mu(E) && n("update:modelValue", E);
      }
      d();
    }, G = _t(() => {
      const xe = ES.indexOf(e.startingView), $e = ES.indexOf(e.minimumView);
      return xe < $e ? e.minimumView : e.startingView;
    }), J = (xe) => new Date(s.value, xe), we = _t(() => {
      const xe = e.lowerLimit && Mu(e.lowerLimit) ? e.lowerLimit.getFullYear() : (/* @__PURE__ */ new Date()).getFullYear(), je = (e.upperLimit && Mu(e.upperLimit) ? e.upperLimit.getFullYear() : (/* @__PURE__ */ new Date()).getFullYear()) - xe + 1;
      return new Array(je > 0 ? je : 1).fill(1).map((E, P) => {
        const K = xe + P;
        return {
          name: K,
          value: K
        };
      });
    });
    return {
      input: o,
      inputRef: u,
      pageDate: r,
      renderView: d,
      selectYear: p,
      selectMonth: _,
      selectDay: R,
      keyUp: L,
      viewShown: l,
      clearModelValue: F,
      initialView: G,
      messageValue: h,
      startOfMonth: x4,
      getMonth: J,
      selectedDates: t,
      yearOptions: we,
      currentYearRef: s,
      validateYear: (xe) => {
        s.value.toString().length >= 4 && (s.value = Mu(
          N_(s.value?.toString(), "yyyy", /* @__PURE__ */ new Date())
        ) ? s.value : null);
      }
    };
  }
}), hfe = ["data-ua-unique-id"], ffe = { class: "lp-datepicker--header" }, dfe = {
  key: 0,
  class: "lp-datepicker--header--year-selector ly-col ly-spacebetween-start"
}, pfe = {
  key: 0,
  class: "lp-input-label font-weight-medium"
}, mfe = {
  key: 0,
  class: "text-blue"
}, gfe = { class: "ly-even-4 ly-no-gap" };
function wfe(e, n, t, l, r, u) {
  const o = El("lp-number-input"), a = El("day-picker");
  return Qe(), yn("div", {
    class: xt(["lp-datepicker", [e.preview && "lp-datepicker-preview"]]),
    "data-ua-unique-id": e.dataUaUniqueId
  }, [
    qn("div", ffe, [
      e.yearSelector ? (Qe(), yn("div", dfe, [
        e.labelTop ? (Qe(), yn("span", pfe, [
          Ir(It(e.labelTop) + " ", 1),
          !e.preview && e.required ? (Qe(), yn("span", mfe, "*")) : st("", !0)
        ])) : st("", !0),
        el(e.$slots, "year-selector", {}, () => [
          dl(o, {
            modelValue: e.currentYearRef,
            "onUpdate:modelValue": n[0] || (n[0] = (h) => e.currentYearRef = h),
            class: "ly-no-grow ly-shrink",
            compact: "",
            format: "integer",
            "no-format": "",
            onKeyup: e.validateYear
          }, null, 8, ["modelValue", "onKeyup"])
        ])
      ])) : st("", !0)
    ]),
    qn("div", gfe, [
      (Qe(!0), yn(Ii, null, ru(Array.from({ length: 12 }), (h, s) => (Qe(), _l(a, {
        key: s,
        "page-date": e.getMonth(s),
        selected: e.selectedDates,
        "week-starts-on": e.weekStartsOn,
        "disabled-dates": e.disabledDates,
        locale: e.locale,
        "weekday-format": e.weekdayFormat,
        highlights: e.highlights,
        "data-ua-value": s,
        "data-ua-multiple-id": "ua-datepicker-daypicker",
        onSelect: e.selectDay
      }, null, 8, ["page-date", "selected", "week-starts-on", "disabled-dates", "locale", "weekday-format", "highlights", "data-ua-value", "onSelect"]))), 128))
    ])
  ], 10, hfe);
}
const nE = /* @__PURE__ */ Cr(cfe, [["render", wfe]]);
nE.install = (e) => {
  e.component(nE.name, nE);
};
const Zz = {
  alignH: "",
  alignV: "",
  alignment: "left",
  bg: "",
  borderColor: "",
  col: "",
  color: "",
  direction: "",
  evenItems: "",
  flex: !0,
  gap: "1",
  lg: "",
  margin: "",
  md: "",
  padding: "2",
  sm: "",
  width: "100",
  xl: ""
}, Xz = (e) => ({
  propClasses: _t(() => [
    {
      [`text-${e.alignment}`]: e.alignment,
      "g-row w-100": e.container,
      "d-grid": e.grid,
      "d-flex": e.flex,
      [`col-${e.col}`]: e.col,
      [`col-sm-${e.sm}`]: e.sm,
      [`col-md-${e.md}`]: e.md,
      [`col-lg-${e.lg}`]: e.lg,
      [`col-xl-${e.xl}`]: e.xl,
      "ly-wrap": e.wrap,
      [`ly-${e.direction}`]: e.direction,
      "ly-even": e.even && !e.container,
      [`ly-even-${e.evenItems}`]: e.evenItems && !e.container,
      "ly-grow": e.grow,
      "ly-shrink": e.shrink,
      [`ly-${e.alignH || "start"}-${e.alignV || "start"}`]: e.alignH || e.alignV,
      "ly-no-gap": e.noGap,
      [`p-${e.padding}`]: e.padding,
      [`pt-${e.paddingTop}`]: e.paddingTop,
      [`pb-${e.paddingBottom}`]: e.paddingBottom,
      [`pr-${e.paddingRight}`]: e.paddingRight,
      [`pl-${e.paddingLeft}`]: e.paddingLeft,
      [`m-${e.margin}`]: e.margin,
      [`mt-${e.marginTop}`]: e.marginTop,
      [`mb-${e.marginBottom}`]: e.marginBottom,
      [`mr-${e.marginRight}`]: e.marginRight,
      [`ml-${e.marginLeft}`]: e.marginLeft,
      rounded: e.rounded,
      "rounded-sm": e.roundedSm,
      "rounded-lg": e.roundedLg,
      "rounded-full": e.roundedFull,
      shadow: e.shadow,
      "shadow-lg": e.shadowLg,
      border: e.border,
      [`border-${e.borderColor}`]: e.borderColor,
      "border-top": e.borderTop,
      "border-right": e.borderRight,
      "border-bottom": e.borderBottom,
      "border-left": e.borderLeft,
      [`text-${e.color}`]: e.color,
      [`bg-${e.bg}`]: e.bg,
      [`w-${e.width}`]: e.width
    }
  ])
}), tE = /* @__PURE__ */ cl({
  name: "lp-card",
  __name: "LpCard",
  props: /* @__PURE__ */ xz({
    alignH: {},
    alignV: {},
    alignment: {},
    bg: {},
    border: { type: Boolean },
    borderBottom: { type: Boolean },
    borderColor: {},
    borderLeft: { type: Boolean },
    borderRight: { type: Boolean },
    borderTop: { type: Boolean },
    col: {},
    color: {},
    container: { type: Boolean },
    direction: {},
    even: { type: Boolean },
    evenItems: {},
    flex: { type: Boolean },
    gap: {},
    grid: { type: Boolean },
    grow: { type: Boolean },
    lg: {},
    margin: {},
    marginBottom: { type: Boolean },
    marginLeft: { type: Boolean },
    marginRight: { type: Boolean },
    marginTop: { type: Boolean },
    md: {},
    noGap: { type: Boolean },
    padding: {},
    paddingBottom: { type: Boolean },
    paddingLeft: { type: Boolean },
    paddingRight: { type: Boolean },
    paddingTop: { type: Boolean },
    rounded: { type: Boolean },
    roundedFull: { type: Boolean },
    roundedLg: { type: Boolean },
    roundedSm: { type: Boolean },
    shadow: { type: Boolean },
    shadowColor: {},
    shadowLg: { type: Boolean },
    shrink: { type: Boolean },
    sm: {},
    width: {},
    wrap: { type: Boolean },
    xl: {}
  }, Zz),
  setup(e) {
    const n = e, { propClasses: t } = Xz(n), l = _s("onFlip", () => {
    });
    return (r, u) => (Qe(), yn("div", Ni(r.$attrs, {
      class: ["lp-card card", Zr(t)]
    }), [
      el(r.$slots, "default", { onFlip: Zr(l) })
    ], 16));
  }
});
tE.install = (e) => {
  e.component(tE.name, tE);
};
const vfe = ["aria-label"], yfe = ["id", "checked", "disabled", "indeterminate"], _fe = { class: "ly-row lp-checkbox-label-group" }, lE = /* @__PURE__ */ cl({
  name: "lp-checkbox",
  inheritAttrs: !1,
  __name: "LpCheckbox",
  props: {
    type: { default: _r.PRIMARY },
    label: { default: null },
    id: { default: null },
    subLabel: { default: null },
    pulse: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    indeterminate: { type: Boolean, default: !1 },
    lineThrough: { type: Boolean, default: !1 },
    check: { default: "check" },
    icon: { default: null },
    iconColor: { default: null },
    color: { default: null },
    modelValue: { type: Boolean, default: !1 },
    pinned: { type: Boolean, default: !1 },
    message: { default: null }
  },
  emits: { "update:modelValue": null },
  setup(e, { emit: n }) {
    const t = e, l = n, r = dt(null), u = dt(t.pinned);
    function o() {
      if (t.disabled)
        return;
      const d = !t.modelValue;
      l("update:modelValue", d);
    }
    const a = _s(
      "searchEmitValue",
      dt(void 0)
    ), h = _s("searchFilter", dt(!0)), s = _t(() => u.value || !h.value || a.value === void 0 ? !1 : !t.label?.toLowerCase().includes(a.value));
    return (d, p) => {
      const _ = El("lp-icon");
      return Qe(), yn(Ii, null, [
        pi(qn("label", {
          class: xt(["lp-checkbox-wrapper", s.value ? "lp-checkbox-hidden" : "lp-checkbox-visible"]),
          "aria-label": d.label
        }, [
          qn("span", {
            class: xt(["lp-checkbox-check-wrapper", [d.pulse && !d.disabled && "pulse"]])
          }, [
            qn("input", Ni({
              id: d.id,
              ref_key: "checkboxInput",
              ref: r,
              type: "checkbox"
            }, d.$attrs, {
              class: "lp-checkbox-input",
              checked: d.modelValue,
              disabled: d.disabled,
              indeterminate: d.indeterminate,
              onClick: Oi(o, ["stop"])
            }), null, 16, yfe),
            qn("span", {
              class: xt(["lp-checkbox", [
                `lp-checkbox-${d.type}`,
                (d.indeterminate || d.modelValue) && `lp-checkbox-${d.type}-checked`,
                d.disabled && "lp-checkbox-disabled",
                d.disabled && d.modelValue && "lp-checkbox-disabled-checked"
              ]])
            }, [
              d.indeterminate ? (Qe(), _l(_, {
                key: 0,
                style: { "font-size": "1rem" },
                name: "minus",
                color: "white"
              })) : st("", !0),
              d.modelValue && !d.indeterminate ? (Qe(), _l(_, {
                key: 1,
                style: { "font-size": "1rem" },
                name: d.check,
                color: "white"
              }, null, 8, ["name"])) : st("", !0)
            ], 2)
          ], 2),
          qn("span", _fe, [
            d.label && !d.$slots.default ? (Qe(), yn("span", {
              key: 0,
              class: xt(["lp-checkbox-label", [
                d.lineThrough && d.modelValue && "lp-checkbox-label-linethrough",
                d.disabled && "lp-checkbox-label-disabled"
              ]])
            }, [
              el(d.$slots, "pre"),
              d.icon ? (Qe(), _l(_, {
                key: 0,
                name: d.icon,
                class: xt([d.iconColor && `text-${d.iconColor}`])
              }, null, 8, ["name", "class"])) : st("", !0),
              Ir(" " + It(d.label), 1)
            ], 2)) : st("", !0),
            d.subLabel && !d.$slots.sublabel ? (Qe(), yn("span", {
              key: 1,
              class: xt(["lp-checkbox-label lp-checkbox-label-sub", [d.disabled && "lp-checkbox-label-disabled"]])
            }, It(d.subLabel), 3)) : st("", !0),
            d.$slots.default ? (Qe(), yn("span", {
              key: 2,
              class: xt(["lp-checkbox-label", [
                d.lineThrough && d.modelValue && "lp-checkbox-label-linethrough",
                d.disabled && "lp-checkbox-label-disabled"
              ]])
            }, [
              el(d.$slots, "default")
            ], 2)) : st("", !0),
            d.$slots.sublabel ? (Qe(), yn("span", {
              key: 3,
              class: xt(["lp-checkbox-label lp-checkbox-label-sub", [d.disabled && "lp-checkbox-label-disabled"]])
            }, [
              el(d.$slots, "sublabel")
            ], 2)) : st("", !0)
          ])
        ], 10, vfe), [
          [Pi, !s.value]
        ]),
        dl(du, { name: "fade-bottom" }, {
          default: kl(() => [
            d.message ? (Qe(), yn("span", {
              key: 0,
              class: xt(["lp-input-message mt-half d-flex", [
                d.type && `lp-input-message-${d.type}`,
                d.disabled && "lp-input-message-disabled"
              ]])
            }, It(d.message), 3)) : st("", !0)
          ]),
          _: 1
        })
      ], 64);
    };
  }
});
lE.install = (e) => {
  e.component(lE.name, lE);
};
const xfe = cl({
  name: "lp-checkbox-group",
  props: {
    label: { type: String, default: "All" },
    id: { type: Number, default: null },
    // NOTE: groupValue and options should be of same types in order to use this option
    groupValue: { type: Object },
    options: {
      type: Object,
      required: !0,
      default: []
    },
    showParent: { type: Boolean, default: !0 },
    uaLocatorOption: { type: String, default: "ua-checkboxgroup-option" }
  },
  emits: ["update:model-value"],
  setup(e) {
    const n = Ga(e, "options"), t = Ga(e, "groupValue"), l = _s("addOptions", () => {
    }), r = _s("onToggle", () => {
    }), u = _s("onGroupToggle", () => {
    }), o = _s("isSelected", () => {
    }), a = _s("isGroupSelected", () => !1), h = _s("getLabel", () => {
    }), s = _t(
      () => a(
        n.value?.filter((_) => !_.disabled),
        e.groupValue
      )
    );
    di(
      [n, t],
      () => {
        t.value ? l([...n.value, t.value]) : l(n.value);
      },
      { immediate: !0 }
    );
    function d() {
      let _ = [];
      !n.value.length && t.value ? _ = [t.value] : _ = n.value, u(s.value, _, e.id);
    }
    const p = _t(() => n.value?.length ? !!n.value?.every((_) => _.disabled) : !1);
    return {
      options: n,
      addOptions: l,
      onToggle: r,
      isSelected: o,
      getLabel: h,
      onGroupCheck: d,
      allChecked: s,
      isDisabled: p
    };
  }
}), Sfe = { class: "lp-checkbox-group-wrapper" };
function Efe(e, n, t, l, r, u) {
  const o = El("lp-checkbox");
  return Qe(), yn("div", Sfe, [
    e.showParent ? (Qe(), _l(o, {
      key: 0,
      style: { "font-weight": "bold" },
      "model-value": e.allChecked,
      type: "primary",
      label: e.label,
      disabled: e.isDisabled,
      "data-ua-multiple-id": "ua-checkboxgroup-parent",
      "data-ua-value": e.label,
      onChange: e.onGroupCheck
    }, null, 8, ["model-value", "label", "disabled", "data-ua-value", "onChange"])) : st("", !0),
    qn("div", {
      class: xt(["lp-checkbox-group", e.showParent && "ml-1"])
    }, [
      (Qe(!0), yn(Ii, null, ru(e.options, (a, h) => (Qe(), _l(o, {
        key: h,
        "model-value": a.disabled ? !1 : e.isSelected(a),
        label: e.getLabel(a),
        disabled: a.disabled,
        "data-ua-multiple-id": "ua-checkboxgroup-child",
        "data-ua-value": e.getLabel(a),
        "onUpdate:modelValue": (s) => e.onToggle(a)
      }, {
        pre: kl(() => [
          el(e.$slots, "decorator", { option: a })
        ]),
        _: 2
      }, 1032, ["model-value", "label", "disabled", "data-ua-value", "onUpdate:modelValue"]))), 128))
    ], 2)
  ]);
}
const Ofe = /* @__PURE__ */ Cr(xfe, [["render", Efe]]), kfe = /* @__PURE__ */ cl({
  name: "lp-multiselect",
  inheritAttrs: !1,
  __name: "LpMultiselect",
  props: {
    type: { default: "primary" },
    placeholder: { default: "Select option" },
    label: { default: "All" },
    trackBy: { default: "id" },
    labelBy: { default: "label" },
    message: { default: "" },
    groupValue: { default: null },
    modelValue: { default: null },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !0 },
    searchFilter: { type: Boolean, default: !0 }
  },
  emits: [
    "update:model-value",
    "update:group-value",
    "update:model-label",
    "update:searchValue"
  ],
  setup(e, { emit: n }) {
    const t = e, l = n, r = /* @__PURE__ */ new Map(), u = Ga(t, "modelValue"), o = _t(() => new Set(u.value)), a = p1({
      value: ""
    }), h = _t(() => !!t.groupValue), s = dt(""), d = (U, Me, le, Ce) => {
      s.value = le, l("update:model-value", U, Me, le, Ce);
    }, p = (U, Me, le) => {
      l("update:group-value", U, Me, le);
    }, _ = (U) => {
      s.value = U;
    };
    vs("wrapperValue", Ga(t, "modelValue")), vs("modelGroupValue", Ga(t, "groupValue")), vs("emitHandlers", {
      handleGroupChange: p,
      handleModelChange: d,
      handleLabelChange: _
    }), vs("addOptions", R), vs("onToggle", F), vs("onGroupToggle", je), vs("isSelected", L), vs("getLabel", J), vs("isGroupSelected", G), vs(
      "searchEmitValue",
      _t(() => a.value?.toLowerCase())
    ), vs("searchFilter", Ga(t, "searchFilter"));
    function R(U) {
      U.forEach((Me) => {
        r.set(we(Me), Me);
      });
    }
    function F(U) {
      L(U) ? xe(U) : $e(U), ce();
    }
    function L(U) {
      return o.value.has(we(U));
    }
    function G(U, Me) {
      return U.length ? U.every(L) : Me ? L(Me) : !1;
    }
    function J(U) {
      return U[t.labelBy];
    }
    function we(U) {
      return U[t.trackBy];
    }
    function ce() {
      const U = Array.from(o.value), Me = U.map((le) => r.get(le));
      l("update:model-value", U, Me);
    }
    function xe(U) {
      o.value.delete(we(U));
    }
    function $e(U) {
      o.value.add(we(U));
    }
    function je(U, Me, le) {
      Me.filter((Ce) => !Ce.disabled).forEach(U ? xe : $e), le && (U ? xe({ [t.trackBy]: le }) : $e({ [t.trackBy]: le })), ce();
    }
    const E = (U) => {
      a.value = U, l("update:searchValue", a.value);
    }, P = _t(() => t.disabled), K = _t(() => u.value?.length), H = _t(() => h.value ? s.value ? s.value : u.value && typeof u.value == "object" ? u.value[t.labelBy] ? u.value[t.labelBy] : u.value.name : u.value : `(${K.value}) Selected`);
    return (U, Me) => {
      const le = El("lp-base-select");
      return Qe(), _l(le, Ni({
        disabled: P.value,
        search: "",
        "label-top": U.label,
        placeholder: U.placeholder,
        message: U.message,
        required: U.required,
        clearable: U.clearable,
        "is-options-group": h.value
      }, U.$attrs, { onSearchEmit: E }), Sz({
        default: kl(() => [
          el(U.$slots, "default")
        ]),
        _: 2
      }, [
        K.value || h.value && H.value ? {
          name: "placeholder",
          fn: kl(() => [
            Ir(It(H.value), 1)
          ]),
          key: "0"
        } : void 0
      ]), 1040, ["disabled", "label-top", "placeholder", "message", "required", "clearable", "is-options-group"]);
    };
  }
}), rE = {
  CheckboxGroup: Ofe,
  MultiSelect: kfe
};
for (const e in rE)
  if (rE.hasOwnProperty(e)) {
    const n = rE[e];
    n.install = (t) => {
      t.component(n.name, n);
    };
  }
const Xo = {};
Xo[0] = function(e, n, t, l) {
  function r(Pe) {
    let C = -1;
    for (let re of Pe) C += re.length + 1;
    return C;
  }
  function u(Pe, C, re = 0, ge = 1e9) {
    for (let Z = 0, Y = 0, oe = !0; Y < Pe.length && Z <= ge; Y++) {
      let ke = Pe[Y], De = Z + ke.length;
      De >= re && (De > ge && (ke = ke.slice(0, ge - Z)), Z < re && (ke = ke.slice(re - Z)), oe ? (C[C.length - 1] += ke, oe = !1) : C.push(ke)), Z = De + 1;
    }
    return C;
  }
  function o(Pe) {
    return 127462 <= Pe && 127487 >= Pe;
  }
  function a(Pe, C, re = !0, ge = !0) {
    return (re ? h : s)(Pe, C, ge);
  }
  function h(Pe, C, re) {
    if (C == Pe.length) return C;
    var ge;
    for ((ge = C) && (ge = Pe.charCodeAt(C), ge = 56320 <= ge && 57344 > ge), ge && (ge = Pe.charCodeAt(C - 1), ge = 55296 <= ge && 56320 > ge), ge && C--, ge = d(Pe, C), C += p(ge); C < Pe.length; ) {
      var Z = d(Pe, C), Y;
      if (!(Y = ge == 8205 || Z == 8205) && (Y = re)) e: {
        for (Y = 1; Y < fn.length; Y += 2) if (fn[Y] > Z) {
          Y = fn[Y - 1] <= Z;
          break e;
        }
        Y = !1;
      }
      if (Y) C += p(Z), ge = Z;
      else if (o(Z)) {
        for (Z = 0, Y = C - 2; 0 <= Y && o(d(Pe, Y)); ) Z++, Y -= 2;
        if (Z % 2 == 0) break;
        C += 2;
      } else break;
    }
    return C;
  }
  function s(Pe, C, re) {
    for (; 0 < C; ) {
      let ge = h(Pe, C - 2, re);
      if (ge < C) return ge;
      C--;
    }
    return 0;
  }
  function d(Pe, C) {
    let re = Pe.charCodeAt(C);
    return !(55296 <= re && 56320 > re) || C + 1 == Pe.length ? re : (Pe = Pe.charCodeAt(C + 1), 56320 <= Pe && 57344 > Pe ? (re - 55296 << 10) + (Pe - 56320) + 65536 : re);
  }
  function p(Pe) {
    return 65536 > Pe ? 1 : 2;
  }
  function _(Pe, C, re, ge = !1) {
    if (!(C == 0 && 0 >= re)) {
      var Z = Pe.length - 2;
      0 <= Z && 0 >= re && re == Pe[Z + 1] ? Pe[Z] += C : C == 0 && Pe[Z] == 0 ? Pe[Z + 1] += re : ge ? (Pe[Z] += C, Pe[Z + 1] += re) : Pe.push(C, re);
    }
  }
  function R(Pe, C, re) {
    if (re.length != 0) if (C = C.length - 2 >> 1, C < Pe.length) Pe[Pe.length - 1] = Pe[Pe.length - 1].append(re);
    else {
      for (; Pe.length < C; ) Pe.push(pn.empty);
      Pe.push(re);
    }
  }
  function F(Pe, C, re) {
    let ge = Pe.inserted;
    for (let Z = 0, Y = 0, oe = 0; oe < Pe.sections.length; ) {
      let ke = Pe.sections[oe++], De = Pe.sections[oe++];
      if (0 > De) Z += ke, Y += ke;
      else {
        let un = Z, gn = Y, Tn = pn.empty;
        for (; un += ke, gn += De, De && ge && (Tn = Tn.append(ge[oe - 2 >> 1])), !(re || oe == Pe.sections.length || 0 > Pe.sections[oe + 1]); )
          ke = Pe.sections[oe++], De = Pe.sections[oe++];
        C(Z, un, Y, gn, Tn), Z = un, Y = gn;
      }
    }
  }
  function L(Pe, C, re, ge = !1) {
    let Z = [];
    ge = ge ? [] : null, Pe = new En(Pe), C = new En(C);
    for (let ke = -1; ; ) if (Pe.ins == -1 && C.ins == -1) {
      var Y = Math.min(Pe.len, C.len);
      _(Z, Y, -1), Pe.forward(Y), C.forward(Y);
    } else if (0 <= C.ins && (0 > Pe.ins || ke == Pe.i || Pe.off == 0 && (C.len < Pe.len || C.len == Pe.len && !re))) {
      for (Y = C.len, _(Z, C.ins, -1); Y; ) {
        var oe = Math.min(
          Pe.len,
          Y
        );
        0 <= Pe.ins && ke < Pe.i && Pe.len <= oe && (_(Z, 0, Pe.ins), ge && R(ge, Z, Pe.text), ke = Pe.i), Pe.forward(oe), Y -= oe;
      }
      C.next();
    } else if (0 <= Pe.ins) {
      for (Y = 0, oe = Pe.len; oe; ) if (C.ins == -1) {
        let De = Math.min(oe, C.len);
        Y += De, oe -= De, C.forward(De);
      } else if (C.ins == 0 && C.len < oe) oe -= C.len, C.next();
      else break;
      _(Z, Y, ke < Pe.i ? Pe.ins : 0), ge && ke < Pe.i && R(ge, Z, Pe.text), ke = Pe.i, Pe.forward(Pe.len - oe);
    } else {
      if (Pe.done && C.done) return ge ? an.createSet(Z, ge) : Ve.create(Z);
      throw Error("Mismatched change set lengths");
    }
  }
  function G(Pe, C, re = !1) {
    let ge = [];
    re = re ? [] : null, Pe = new En(Pe), C = new En(C);
    for (let Z = !1; ; ) {
      if (Pe.done && C.done) return re ? an.createSet(ge, re) : Ve.create(ge);
      if (Pe.ins == 0) _(ge, Pe.len, 0, Z), Pe.next();
      else if (C.len != 0 || C.done) {
        if (Pe.done || C.done) throw Error("Mismatched change set lengths");
        let Y = Math.min(Pe.len2, C.len), oe = ge.length;
        if (Pe.ins == -1) {
          let ke = C.ins == -1 ? -1 : C.off ? 0 : C.ins;
          _(ge, Y, ke, Z), re && ke && R(re, ge, C.text);
        } else C.ins == -1 ? (_(ge, Pe.off ? 0 : Pe.len, Y, Z), re && R(re, ge, Pe.textBit(Y))) : (_(ge, Pe.off ? 0 : Pe.len, C.off ? 0 : C.ins, Z), re && !C.off && R(re, ge, C.text));
        Z = (Pe.ins > Y || 0 <= C.ins && C.len > Y) && (Z || ge.length > oe), Pe.forward2(Y), C.forward(Y);
      } else _(
        ge,
        0,
        C.ins,
        Z
      ), re && R(re, ge, C.text), C.next();
    }
  }
  function J(Pe, C) {
    for (let re of Pe.ranges) if (re.to > C) throw new RangeError("Selection points outside of document");
  }
  function we(Pe, C) {
    return Pe == C || Pe.length == C.length && Pe.every((re, ge) => re === C[ge]);
  }
  function ce(Pe, C, re) {
    if (Pe.length != C.length) return !1;
    for (let ge = 0; ge < Pe.length; ge++) if (!re(Pe[ge], C[ge])) return !1;
    return !0;
  }
  function xe(Pe, C) {
    let re = !1;
    for (let ge of C) P(Pe, ge) & 1 && (re = !0);
    return re;
  }
  function $e(Pe, C, re) {
    function ge(De) {
      let un = [];
      for (let gn = 0; gn < Z.length; gn++) {
        let Tn = K(De, Z[gn]);
        if (Y[gn] == 2) for (let ft of Tn) un.push(ft);
        else un.push(Tn);
      }
      return C.combine(un);
    }
    let Z = re.map((De) => Pe[De.id]), Y = re.map((De) => De.type), oe = Z.filter((De) => !(De & 1)), ke = Pe[C.id] >> 1;
    return { create(De) {
      for (let un of Z) P(De, un);
      return De.values[ke] = ge(De), 1;
    }, update(De, un) {
      return !xe(De, oe) || (un = ge(De), C.compare(un, De.values[ke])) ? 0 : (De.values[ke] = un, 1);
    }, reconfigure(De, un) {
      var gn = xe(De, Z);
      let Tn = un.config.facets[C.id];
      return un = un.facet(C), Tn && !gn && we(re, Tn) || (gn = ge(De), C.compare(gn, un)) ? (De.values[ke] = un, 0) : (De.values[ke] = gn, 1);
    } };
  }
  function je(Pe) {
    return (C) => new pr(C, Pe);
  }
  function E(Pe, C, re) {
    function ge(oe, ke) {
      var De = Y.get(oe);
      if (De != null) {
        if (De <= ke) return;
        let un = Z[De].indexOf(oe);
        -1 < un && Z[De].splice(un, 1), oe instanceof Rr && re.delete(oe.compartment);
      }
      if (Y.set(oe, ke), Array.isArray(oe)) for (let un of oe) ge(un, ke);
      else if (oe instanceof Rr) {
        if (re.has(oe.compartment)) throw new RangeError("Duplicate use of compartment in extensions");
        De = C.get(oe.compartment) || oe.inner, re.set(oe.compartment, De), ge(De, ke);
      } else if (oe instanceof pr) ge(oe.inner, oe.prec);
      else if (oe instanceof ol) Z[ke].push(oe), oe.provides && ge(oe.provides, ke);
      else if (oe instanceof zt) Z[ke].push(oe), oe.facet.extensions && ge(oe.facet.extensions, St.default);
      else {
        if (De = oe.extension, !De) throw Error(`Unrecognized extension value in extension set (${oe}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
        ge(De, ke);
      }
    }
    let Z = [[], [], [], [], []], Y = /* @__PURE__ */ new Map();
    return ge(Pe, St.default), Z.reduce((oe, ke) => oe.concat(ke));
  }
  function P(Pe, C) {
    if (C & 1) return 2;
    C >>= 1;
    var re = Pe.status[C];
    if (re == 4) throw Error("Cyclic dependency between fields and/or facets");
    return re & 2 ? re : (Pe.status[C] = 4, re = Pe.computeSlot(Pe, Pe.config.dynamicSlots[C]), Pe.status[C] = 2 | re);
  }
  function K(Pe, C) {
    return C & 1 ? Pe.config.staticValues[C >> 1] : Pe.values[C >> 1];
  }
  function H(Pe, C, re) {
    var ge;
    let Z, Y;
    return re ? (re = C.changes, Z = an.empty(C.changes.length), Y = Pe.changes.compose(C.changes)) : (re = C.changes.map(Pe.changes), Z = Pe.changes.mapDesc(C.changes, !0), Y = Pe.changes.compose(re)), { changes: Y, selection: C.selection ? C.selection.map(Z) : (ge = Pe.selection) === null || ge === void 0 ? void 0 : ge.map(re), effects: Kt.mapEffects(
      Pe.effects,
      re
    ).concat(Kt.mapEffects(C.effects, Z)), annotations: Pe.annotations.length ? Pe.annotations.concat(C.annotations) : C.annotations, scrollIntoView: Pe.scrollIntoView || C.scrollIntoView };
  }
  function U(Pe, C, re) {
    let ge = C.selection, Z = le(C.annotations);
    return C.userEvent && (Z = Z.concat(nl.userEvent.of(C.userEvent))), { changes: C.changes instanceof an ? C.changes : an.of(C.changes || [], re, Pe.facet(bl)), selection: ge && (ge instanceof Vn ? ge : Vn.single(ge.anchor, ge.head)), effects: le(C.effects), annotations: Z, scrollIntoView: !!C.scrollIntoView };
  }
  function Me(Pe, C, re) {
    var ge = U(Pe, C.length ? C[0] : {}, Pe.doc.length);
    C.length && C[0].filter === !1 && (re = !1);
    for (var Z = 1; Z < C.length; Z++) {
      C[Z].filter === !1 && (re = !1);
      var Y = !!C[Z].sequential;
      ge = H(ge, U(Pe, C[Z], Y ? ge.changes.newLength : Pe.doc.length), Y);
    }
    if (Pe = nl.create(Pe, ge.changes, ge.selection, ge.effects, ge.annotations, ge.scrollIntoView), re) {
      re = Pe.startState, C = !0;
      for (oe of re.facet(tl)) {
        if (ge = oe(Pe), ge === !1) {
          C = !1;
          break;
        }
        if (Array.isArray(ge)) if (C === !0) C = ge;
        else e: {
          Z = [];
          for (let ke = 0, De = 0; ; ) {
            let un;
            if (ke < C.length && (De == ge.length || ge[De] >= C[ke])) Y = C[ke++], un = C[ke++];
            else if (De < ge.length) Y = ge[De++], un = ge[De++];
            else {
              C = Z;
              break e;
            }
            !Z.length || Z[Z.length - 1] < Y ? Z.push(Y, un) : Z[Z.length - 1] < un && (Z[Z.length - 1] = un);
          }
        }
      }
      if (C !== !0) {
        if (C === !1) {
          C = Pe.changes.invertedDesc;
          var oe = an.empty(re.doc.length);
        } else C = Pe.changes.filter(C), oe = C.changes, C = C.filtered.mapDesc(C.changes).invertedDesc;
        Pe = nl.create(re, oe, Pe.selection && Pe.selection.map(C), Kt.mapEffects(Pe.effects, C), Pe.annotations, Pe.scrollIntoView);
      }
      for (oe = re.facet(Zt), C = oe.length - 1; 0 <= C; C--) Pe = oe[C](Pe), Pe = Pe instanceof nl ? Pe : Array.isArray(Pe) && Pe.length == 1 && Pe[0] instanceof nl ? Pe[0] : Me(re, le(Pe), !1);
      oe = Pe;
    } else oe = Pe;
    for (re = oe.startState, Pe = re.facet(Ql), C = oe, ge = Pe.length - 1; 0 <= ge; ge--) (Z = Pe[ge](oe)) && Object.keys(Z).length && (C = H(C, U(re, Z, oe.changes.newLength), !0));
    return C == oe ? oe : nl.create(re, oe.changes, oe.selection, C.effects, C.annotations, C.scrollIntoView);
  }
  function le(Pe) {
    return Pe == null ? Pr : Array.isArray(Pe) ? Pe : [Pe];
  }
  function Ce(Pe) {
    return (C) => {
      if (!/\S/.test(C)) return l.CharCategory.Space;
      e: if (Ar) var re = Ar.test(C);
      else {
        for (re = 0; re < C.length; re++) {
          let ge = C[re];
          if (/\w/.test(ge) || "" < ge && (ge.toUpperCase() != ge.toLowerCase() || ii.test(ge))) {
            re = !0;
            break e;
          }
        }
        re = !1;
      }
      if (re) return l.CharCategory.Word;
      for (re = 0; re < Pe.length; re++) if (-1 < C.indexOf(Pe[re])) return l.CharCategory.Word;
      return l.CharCategory.Other;
    };
  }
  function Ye(Pe, C) {
    return Pe.from - C.from || Pe.value.startSide - C.value.startSide;
  }
  function B(Pe) {
    if (1 < Pe.length) for (let C = Pe[0], re = 1; re < Pe.length; re++) {
      let ge = Pe[re];
      if (0 < Ye(C, ge)) return Pe.slice().sort(Ye);
      C = ge;
    }
    return Pe;
  }
  function q(Pe, C, re) {
    let ge = /* @__PURE__ */ new Map();
    for (var Z of Pe) for (Pe = 0; Pe < Z.chunk.length; Pe++) 0 >= Z.chunk[Pe].maxPoint && ge.set(Z.chunk[Pe], Z.chunkPos[Pe]);
    Z = /* @__PURE__ */ new Set();
    for (let Y of C) for (C = 0; C < Y.chunk.length; C++) Pe = ge.get(Y.chunk[C]), Pe == null || (re ? re.mapPos(Pe) : Pe) != Y.chunkPos[C] || re != null && re.touchesRange(Pe, Pe + Y.chunk[C].length) || Z.add(Y.chunk[C]);
    return Z;
  }
  function me(Pe, C) {
    for (let re = Pe[C]; ; ) {
      let ge = (C << 1) + 1;
      if (ge >= Pe.length) break;
      let Z = Pe[ge];
      if (ge + 1 < Pe.length && 0 <= Z.compare(Pe[ge + 1]) && (Z = Pe[ge + 1], ge++), 0 > re.compare(Z)) break;
      Pe[ge] = re, Pe[C] = Z, C = ge;
    }
  }
  function Ae(Pe, C, re, ge, Z, Y) {
    Pe.goto(C), re.goto(ge), Z = ge + Z;
    let oe = ge;
    for (C = ge - C; ; ) {
      ge = Pe.to + C - re.to || Pe.endSide - re.endSide;
      let ke = 0 > ge ? Pe.to + C : re.to, De = Math.min(ke, Z);
      if (Pe.point || re.point ? Pe.point && re.point && (Pe.point == re.point || Pe.point.eq(re.point)) && Fe(Pe.activeForPoint(Pe.to), re.activeForPoint(re.to)) || Y.comparePoint(oe, De, Pe.point, re.point) : De > oe && !Fe(Pe.active, re.active) && Y.compareRange(oe, De, Pe.active, re.active), ke > Z) break;
      oe = ke, 0 >= ge && Pe.next(), 0 <= ge && re.next();
    }
  }
  function Fe(Pe, C) {
    if (Pe.length != C.length) return !1;
    for (let re = 0; re < Pe.length; re++) if (Pe[re] != C[re] && !Pe[re].eq(C[re])) return !1;
    return !0;
  }
  function ln(Pe, C) {
    for (let re = C, ge = Pe.length - 1; re < ge; re++) Pe[re] = Pe[re + 1];
    Pe.pop();
  }
  function Be(Pe, C, re) {
    for (let ge = Pe.length - 1; ge >= C; ge--) Pe[ge + 1] = Pe[ge];
    Pe[C] = re;
  }
  function Ze(Pe, C) {
    let re = -1, ge = 1e9;
    for (let Z = 0; Z < C.length; Z++) 0 > (C[Z] - ge || Pe[Z].endSide - Pe[re].endSide) && (re = Z, ge = C[Z]);
    return re;
  }
  class pn {
    lineAt(C) {
      if (0 > C || C > this.length) throw new RangeError(`Invalid position ${C} in document of length ${this.length}`);
      return this.lineInner(C, !1, 1, 0);
    }
    line(C) {
      if (1 > C || C > this.lines) throw new RangeError(`Invalid line number ${C} in ${this.lines}-line document`);
      return this.lineInner(C, !0, 1, 0);
    }
    replace(C, re, ge) {
      let Z = [];
      return this.decompose(
        0,
        C,
        Z,
        2
      ), ge.length && ge.decompose(0, ge.length, Z, 3), this.decompose(re, this.length, Z, 1), Nn.from(Z, this.length - (re - C) + ge.length);
    }
    append(C) {
      return this.replace(this.length, this.length, C);
    }
    slice(C, re = this.length) {
      let ge = [];
      return this.decompose(C, re, ge, 0), Nn.from(ge, re - C);
    }
    eq(C) {
      if (C == this) return !0;
      if (C.length != this.length || C.lines != this.lines) return !1;
      let re = this.scanIdentical(C, 1), ge = this.length - this.scanIdentical(C, -1), Z = new at(this);
      C = new at(C);
      for (let Y = re, oe = re; ; ) {
        if (Z.next(Y), C.next(Y), Y = 0, Z.lineBreak != C.lineBreak || Z.done != C.done || Z.value != C.value) return !1;
        if (oe += Z.value.length, Z.done || oe >= ge) return !0;
      }
    }
    iter(C = 1) {
      return new at(this, C);
    }
    iterRange(C, re = this.length) {
      return new Yt(this, C, re);
    }
    iterLines(C, re) {
      return C == null ? re = this.iter() : (re == null && (re = this.lines + 1), C = this.line(C).from, re = this.iterRange(C, Math.max(C, re == this.lines + 1 ? this.length : 1 >= re ? 0 : this.line(re - 1).to))), new jt(re);
    }
    toString() {
      return this.sliceString(0);
    }
    toJSON() {
      let C = [];
      return this.flatten(C), C;
    }
    constructor() {
    }
    static of(C) {
      if (C.length == 0) throw new RangeError("A document must have at least one line");
      return C.length != 1 || C[0] ? 32 >= C.length ? new xn(C) : Nn.from(xn.split(C, [])) : pn.empty;
    }
  }
  class xn extends pn {
    constructor(C, re = r(C)) {
      super(), this.text = C, this.length = re;
    }
    get lines() {
      return this.text.length;
    }
    get children() {
      return null;
    }
    lineInner(C, re, ge, Z) {
      for (let Y = 0; ; Y++) {
        let oe = this.text[Y], ke = Z + oe.length;
        if ((re ? ge : ke) >= C) return new Cl(Z, ke, ge, oe);
        Z = ke + 1, ge++;
      }
    }
    decompose(C, re, ge, Z) {
      C = 0 >= C && re >= this.length ? this : new xn(u(this.text, [""], C, re), Math.min(re, this.length) - Math.max(0, C)), Z & 1 ? (re = ge.pop(), Z = u(C.text, re.text.slice(), 0, C.length), 32 >= Z.length ? ge.push(new xn(Z, re.length + C.length)) : (C = Z.length >> 1, ge.push(new xn(Z.slice(0, C)), new xn(Z.slice(C))))) : ge.push(C);
    }
    replace(C, re, ge) {
      if (!(ge instanceof xn)) return super.replace(C, re, ge);
      let Z = u(this.text, u(ge.text, u(this.text, [""], 0, C)), re);
      return C = this.length + ge.length - (re - C), 32 >= Z.length ? new xn(Z, C) : Nn.from(xn.split(Z, []), C);
    }
    sliceString(C, re = this.length, ge = `
`) {
      let Z = "";
      for (let Y = 0, oe = 0; Y <= re && oe < this.text.length; oe++) {
        let ke = this.text[oe], De = Y + ke.length;
        Y > C && oe && (Z += ge), C < De && re > Y && (Z += ke.slice(Math.max(
          0,
          C - Y
        ), re - Y)), Y = De + 1;
      }
      return Z;
    }
    flatten(C) {
      for (let re of this.text) C.push(re);
    }
    scanIdentical() {
      return 0;
    }
    static split(C, re) {
      let ge = [], Z = -1;
      for (let Y of C) ge.push(Y), Z += Y.length + 1, ge.length == 32 && (re.push(new xn(ge, Z)), ge = [], Z = -1);
      return -1 < Z && re.push(new xn(ge, Z)), re;
    }
  }
  class Nn extends pn {
    constructor(C, re) {
      super(), this.children = C, this.length = re, this.lines = 0;
      for (let ge of C) this.lines += ge.lines;
    }
    lineInner(C, re, ge, Z) {
      for (let Y = 0; ; Y++) {
        let oe = this.children[Y], ke = Z + oe.length, De = ge + oe.lines - 1;
        if ((re ? De : ke) >= C) return oe.lineInner(C, re, ge, Z);
        Z = ke + 1, ge = De + 1;
      }
    }
    decompose(C, re, ge, Z) {
      for (let Y = 0, oe = 0; oe <= re && Y < this.children.length; Y++) {
        let ke = this.children[Y], De = oe + ke.length;
        if (C <= De && re >= oe) {
          let un = Z & ((oe <= C ? 1 : 0) | (De >= re ? 2 : 0));
          oe >= C && De <= re && !un ? ge.push(ke) : ke.decompose(C - oe, re - oe, ge, un);
        }
        oe = De + 1;
      }
    }
    replace(C, re, ge) {
      if (ge.lines < this.lines) for (let oe = 0, ke = 0; oe < this.children.length; oe++) {
        var Z = this.children[oe], Y = ke + Z.length;
        if (C >= ke && re <= Y) {
          let De = Z.replace(C - ke, re - ke, ge);
          return Z = this.lines - Z.lines + De.lines, De.lines < Z >> 4 && De.lines > Z >> 6 ? (Y = this.children.slice(), Y[oe] = De, new Nn(Y, this.length - (re - C) + ge.length)) : super.replace(ke, Y, De);
        }
        ke = Y + 1;
      }
      return super.replace(C, re, ge);
    }
    sliceString(C, re = this.length, ge = `
`) {
      let Z = "";
      for (let Y = 0, oe = 0; Y < this.children.length && oe <= re; Y++) {
        let ke = this.children[Y], De = oe + ke.length;
        oe > C && Y && (Z += ge), C < De && re > oe && (Z += ke.sliceString(C - oe, re - oe, ge)), oe = De + 1;
      }
      return Z;
    }
    flatten(C) {
      for (let re of this.children) re.flatten(C);
    }
    scanIdentical(C, re) {
      if (!(C instanceof Nn)) return 0;
      let ge = 0, [Z, Y, oe, ke] = 0 < re ? [0, 0, this.children.length, C.children.length] : [this.children.length - 1, C.children.length - 1, -1, -1];
      for (; ; Z += re, Y += re) {
        if (Z == oe || Y == ke) return ge;
        let De = this.children[Z], un = C.children[Y];
        if (De != un) return ge + De.scanIdentical(un, re);
        ge += De.length + 1;
      }
    }
    static from(C, re = C.reduce((ge, Z) => ge + Z.length + 1, -1)) {
      function ge(gt) {
        let Gt;
        if (gt.lines > ke && gt instanceof Nn) for (let zl of gt.children) ge(zl);
        else gt.lines > De && (gn > De || !gn) ? (Z(), un.push(gt)) : gt instanceof xn && gn && (Gt = ft[ft.length - 1]) instanceof xn && 32 >= gt.lines + Gt.lines ? (gn += gt.lines, Tn += gt.length + 1, ft[ft.length - 1] = new xn(Gt.text.concat(gt.text), Gt.length + 1 + gt.length)) : (gn + gt.lines > oe && Z(), gn += gt.lines, Tn += gt.length + 1, ft.push(gt));
      }
      function Z() {
        gn != 0 && (un.push(ft.length == 1 ? ft[0] : Nn.from(ft, Tn)), Tn = -1, gn = ft.length = 0);
      }
      var Y = 0;
      for (let gt of C) Y += gt.lines;
      if (32 > Y) {
        Y = [];
        for (let gt of C) gt.flatten(Y);
        return new xn(Y, re);
      }
      let oe = Math.max(32, Y >> 5), ke = oe << 1, De = oe >> 1, un = [], gn = 0, Tn = -1, ft = [];
      for (let gt of C) ge(gt);
      return Z(), un.length == 1 ? un[0] : new Nn(un, re);
    }
  }
  pn.empty = new xn([""], 0);
  class at {
    constructor(C, re = 1) {
      this.dir = re, this.lineBreak = this.done = !1, this.value = "", this.nodes = [C], this.offsets = [0 < re ? 1 : (C instanceof xn ? C.text.length : C.children.length) << 1];
    }
    nextInner(C, re) {
      for (this.done = this.lineBreak = !1; ; ) {
        let Z = this.nodes.length - 1;
        var ge = this.nodes[Z];
        let Y = this.offsets[Z], oe = Y >> 1, ke = ge instanceof xn ? ge.text.length : ge.children.length;
        if (oe == (0 < re ? ke : 0)) {
          if (Z == 0) return this.done = !0, this.value = "", this;
          0 < re && this.offsets[Z - 1]++, this.nodes.pop(), this.offsets.pop();
        } else if ((Y & 1) == (0 < re ? 0 : 1)) {
          if (this.offsets[Z] += re, C == 0) return this.lineBreak = !0, this.value = `
`, this;
          C--;
        } else if (ge instanceof xn) {
          if (ge = ge.text[oe + (0 > re ? -1 : 0)], this.offsets[Z] += re, ge.length > Math.max(0, C)) return this.value = C == 0 ? ge : 0 < re ? ge.slice(C) : ge.slice(0, ge.length - C), this;
          C -= ge.length;
        } else ge = ge.children[oe + (0 > re ? -1 : 0)], C > ge.length ? (C -= ge.length, this.offsets[Z] += re) : (0 > re && this.offsets[Z]--, this.nodes.push(ge), this.offsets.push(0 < re ? 1 : (ge instanceof xn ? ge.text.length : ge.children.length) << 1));
      }
    }
    next(C = 0) {
      return 0 > C && (this.nextInner(-C, -this.dir), C = this.value.length), this.nextInner(C, this.dir);
    }
  }
  class Yt {
    constructor(C, re, ge) {
      this.value = "", this.done = !1, this.cursor = new at(C, re > ge ? -1 : 1), this.pos = re > ge ? C.length : 0, this.from = Math.min(re, ge), this.to = Math.max(re, ge);
    }
    nextInner(C, re) {
      if (0 > re ? this.pos <= this.from : this.pos >= this.to) return this.value = "", this.done = !0, this;
      C += Math.max(0, 0 > re ? this.pos - this.to : this.from - this.pos);
      let ge = 0 > re ? this.pos - this.from : this.to - this.pos;
      C > ge && (C = ge), ge -= C;
      let { value: Z } = this.cursor.next(C);
      return this.pos += (Z.length + C) * re, this.value = Z.length <= ge ? Z : 0 > re ? Z.slice(Z.length - ge) : Z.slice(0, ge), this.done = !this.value, this;
    }
    next(C = 0) {
      return 0 > C ? C = Math.max(C, this.from - this.pos) : 0 < C && (C = Math.min(C, this.to - this.pos)), this.nextInner(C, this.cursor.dir);
    }
    get lineBreak() {
      return this.cursor.lineBreak && this.value != "";
    }
  }
  class jt {
    constructor(C) {
      this.inner = C, this.afterBreak = !0, this.value = "", this.done = !1;
    }
    next(C = 0) {
      let { done: re, lineBreak: ge, value: Z } = this.inner.next(C);
      return re ? (this.done = !0, this.value = "") : ge ? this.afterBreak ? this.value = "" : (this.afterBreak = !0, this.next()) : (this.value = Z, this.afterBreak = !1), this;
    }
    get lineBreak() {
      return !1;
    }
  }
  typeof Symbol < "u" && (pn.prototype[Symbol.iterator] = function() {
    return this.iter();
  }, at.prototype[Symbol.iterator] = Yt.prototype[Symbol.iterator] = jt.prototype[Symbol.iterator] = function() {
    return this;
  });
  class Cl {
    constructor(C, re, ge, Z) {
      this.from = C, this.to = re, this.number = ge, this.text = Z;
    }
    get length() {
      return this.to - this.from;
    }
  }
  let fn = "lc 34 7n 7 7b 19    2  2   20 b 1c l g  2t 7 2 6 2 2  4 z  u r 2j b 1m 9 9  o 4  9  3  5 17 3 3b f  w 1j    4 8 4  3 7 a 2 t  1m    2 4 8  9  a 2 q  2 2 1l  4 2 4 2 2 3 3  u 2 3  b 2 1l  4 5  2 4  k 2 m 6   1m   2  4 8  7 3 a 2 u  1n    c  9  14  3  1l 3 5 3  4 7 2 b 2 t  1m  2  2  3  5 2 7 2 b 2 s 2 1l 2   2 4 8  9  a 2 t  20  4  2 3   8  29  2 7 c 8 2q  2 9 b 6 22 2 r      1j e  5  2 5 b  10 9  2u 4  6  2 2 2 p 2 4 3 g 4 d  2 2 6  f  jj 3 qa 3 t 3 t 2 u 2 1s 2  7 8  2 b 9  19 3 3b 2 y  3a 3 4 2 9  6 3 63 2 2  1m   7     2 8 6 a 2  1c h 1r 4 1c 7   5  14 9 c 2 w 4 2 2  3 1k   2 3   3 1m 8 2 2 48 3  d  7 4  6  3 2 5i 1m  5 ek  5f x 2da 3 3x  2o w fe 6 2x 2 n9w 4  a w 2 28 2 7k  3  4  p 2 5  47 2 q i d  12 8 p b 1a 3 1c  2 4 2 2 13  1v 6 2 2 2 2 c  8  1b  1f   3 2 2 5 2   16 2 8  6m  2  4  fn4  kh g g g a6 2 gt  6a  45 5 1ae 3  2 5 4 14 3 4  4l 2 fx 4 ar 2 49 b 4w  1i f 1k 3 1d 4 2 2 1x 3 10 5  8 1q  c 2 1g 9 a 4 2  2n 3 2   2 6  4g  3 8 l 2 1l 2     m  e 7 3 5 5f 8 2 3   n  29  2 6   2   2  2 6j  2 4 6 2  2 r 2 2d 8 2   2 2y    2 6   2t 3 2 4  5 77 9  2 6t  a 2   4  40 4 2 2 4  w a 14 6 2 4 8  9 6 2 3 1a d  2 ba 7  6   2a m 2 7  2  2 3e 6 3   2  7   20 2 3    9n 2 f0b 5 1n 7 t4  1r 4 29  f5k 2 43q   3 4 5 8 8 2 7 u 4 44 3 1iz 1j 4 1e 8  e  m 5  f 11s 7  h 2 7  2  5 79 7 c5 4 15s 7 31 7 240 5 gx7k 2o 3k 6o".split(" ").map((Pe) => Pe ? parseInt(Pe, 36) : 1);
  for (e = 1; e < fn.length; e++) fn[e] += fn[e - 1];
  const _e = /\r\n?|\n/;
  l.MapMode = void 0, function(Pe) {
    Pe[Pe.Simple = 0] = "Simple", Pe[Pe.TrackDel = 1] = "TrackDel", Pe[Pe.TrackBefore = 2] = "TrackBefore", Pe[Pe.TrackAfter = 3] = "TrackAfter";
  }(l.MapMode || (l.MapMode = {}));
  class Ve {
    constructor(C) {
      this.sections = C;
    }
    get length() {
      let C = 0;
      for (let re = 0; re < this.sections.length; re += 2) C += this.sections[re];
      return C;
    }
    get newLength() {
      let C = 0;
      for (let re = 0; re < this.sections.length; re += 2) {
        let ge = this.sections[re + 1];
        C += 0 > ge ? this.sections[re] : ge;
      }
      return C;
    }
    get empty() {
      return this.sections.length == 0 || this.sections.length == 2 && 0 > this.sections[1];
    }
    iterGaps(C) {
      for (let re = 0, ge = 0, Z = 0; re < this.sections.length; ) {
        let Y = this.sections[re++], oe = this.sections[re++];
        0 > oe ? (C(ge, Z, Y), Z += Y) : Z += oe, ge += Y;
      }
    }
    iterChangedRanges(C, re = !1) {
      F(this, C, re);
    }
    get invertedDesc() {
      let C = [];
      for (let re = 0; re < this.sections.length; ) {
        let ge = this.sections[re++], Z = this.sections[re++];
        0 > Z ? C.push(ge, Z) : C.push(Z, ge);
      }
      return new Ve(C);
    }
    composeDesc(C) {
      return this.empty ? C : C.empty ? this : G(this, C);
    }
    mapDesc(C, re = !1) {
      return C.empty ? this : L(this, C, re);
    }
    mapPos(C, re = -1, ge = l.MapMode.Simple) {
      let Z = 0, Y = 0;
      for (let oe = 0; oe < this.sections.length; ) {
        let ke = this.sections[oe++], De = this.sections[oe++], un = Z + ke;
        if (0 > De) {
          if (un > C) return Y + (C - Z);
          Y += ke;
        } else {
          if (ge != l.MapMode.Simple && un >= C && (ge == l.MapMode.TrackDel && Z < C && un > C || ge == l.MapMode.TrackBefore && Z < C || ge == l.MapMode.TrackAfter && un > C)) return null;
          if (un > C || un == C && 0 > re && !ke) return C == Z || 0 > re ? Y : Y + De;
          Y += De;
        }
        Z = un;
      }
      if (C > Z) throw new RangeError(`Position ${C} is out of range for changeset of length ${Z}`);
      return Y;
    }
    touchesRange(C, re = C) {
      for (let Z = 0, Y = 0; Z < this.sections.length && Y <= re; ) {
        var ge = this.sections[Z++];
        let oe = this.sections[Z++];
        if (ge = Y + ge, 0 <= oe && Y <= re && ge >= C) return Y < C && ge > re ? "cover" : !0;
        Y = ge;
      }
      return !1;
    }
    toString() {
      let C = "";
      for (let re = 0; re < this.sections.length; ) {
        let ge = this.sections[re++], Z = this.sections[re++];
        C += (C ? " " : "") + ge + (0 <= Z ? ":" + Z : "");
      }
      return C;
    }
    toJSON() {
      return this.sections;
    }
    static fromJSON(C) {
      if (!Array.isArray(C) || C.length % 2 || C.some((re) => typeof re != "number")) throw new RangeError("Invalid JSON representation of ChangeDesc");
      return new Ve(C);
    }
    static create(C) {
      return new Ve(C);
    }
  }
  class an extends Ve {
    constructor(C, re) {
      super(C), this.inserted = re;
    }
    apply(C) {
      if (this.length != C.length) throw new RangeError("Applying change set to a document with the wrong length");
      return F(this, (re, ge, Z, Y, oe) => C = C.replace(Z, Z + (ge - re), oe), !1), C;
    }
    mapDesc(C, re = !1) {
      return L(this, C, re, !0);
    }
    invert(C) {
      let re = this.sections.slice(), ge = [];
      for (let Y = 0, oe = 0; Y < re.length; Y += 2) {
        let ke = re[Y];
        var Z = re[Y + 1];
        if (0 <= Z) {
          for (re[Y] = Z, re[Y + 1] = ke, Z = Y >> 1; ge.length < Z; ) ge.push(pn.empty);
          ge.push(ke ? C.slice(oe, oe + ke) : pn.empty);
        }
        oe += ke;
      }
      return new an(re, ge);
    }
    compose(C) {
      return this.empty ? C : C.empty ? this : G(this, C, !0);
    }
    map(C, re = !1) {
      return C.empty ? this : L(this, C, re, !0);
    }
    iterChanges(C, re = !1) {
      F(this, C, re);
    }
    get desc() {
      return Ve.create(this.sections);
    }
    filter(C) {
      let re = [], ge = [], Z = [], Y = new En(this);
      e: for (let De = 0, un = 0; ; ) {
        for (var oe = De == C.length ? 1e9 : C[De++]; un < oe || un == oe && Y.len == 0; ) {
          if (Y.done) break e;
          var ke = Math.min(Y.len, oe - un);
          _(Z, ke, -1);
          let gn = Y.ins == -1 ? -1 : Y.off == 0 ? Y.ins : 0;
          _(re, ke, gn), 0 < gn && R(ge, re, Y.text), Y.forward(ke), un += ke;
        }
        for (oe = C[De++]; un < oe; ) {
          if (Y.done) break e;
          ke = Math.min(Y.len, oe - un), _(re, ke, -1), _(Z, ke, Y.ins == -1 ? -1 : Y.off == 0 ? Y.ins : 0), Y.forward(ke), un += ke;
        }
      }
      return { changes: new an(re, ge), filtered: Ve.create(Z) };
    }
    toJSON() {
      let C = [];
      for (let re = 0; re < this.sections.length; re += 2) {
        let ge = this.sections[re], Z = this.sections[re + 1];
        0 > Z ? C.push(ge) : Z == 0 ? C.push([ge]) : C.push([ge].concat(this.inserted[re >> 1].toJSON()));
      }
      return C;
    }
    static of(C, re, ge) {
      function Z(gn = !1) {
        (gn || oe.length) && (De < re && _(oe, re - De, -1), gn = new an(oe, ke), un = un ? un.compose(gn.map(un)) : gn, oe = [], ke = [], De = 0);
      }
      function Y(gn) {
        if (Array.isArray(gn)) for (var Tn of gn) Y(Tn);
        else if (gn instanceof an) {
          if (gn.length != re) throw new RangeError(`Mismatched change set length (got ${gn.length}, expected ${re})`);
          Z(), un = un ? un.compose(gn.map(un)) : gn;
        } else {
          let { from: ft, to: gt = ft, insert: Gt } = gn;
          if (ft > gt || 0 > ft || gt > re) throw new RangeError(`Invalid change range ${ft} to ${gt} (in doc of length ${re})`);
          gn = Gt ? typeof Gt == "string" ? pn.of(Gt.split(ge || _e)) : Gt : pn.empty, Tn = gn.length, (ft != gt || Tn != 0) && (ft < De && Z(), ft > De && _(oe, ft - De, -1), _(oe, gt - ft, Tn), R(ke, oe, gn), De = gt);
        }
      }
      let oe = [], ke = [], De = 0, un = null;
      return Y(C), Z(!un), un;
    }
    static empty(C) {
      return new an(C ? [C, -1] : [], []);
    }
    static fromJSON(C) {
      if (!Array.isArray(C)) throw new RangeError("Invalid JSON representation of ChangeSet");
      let re = [], ge = [];
      for (let Z = 0; Z < C.length; Z++) {
        let Y = C[Z];
        if (typeof Y == "number") re.push(Y, -1);
        else {
          if (!Array.isArray(Y) || typeof Y[0] != "number" || Y.some((oe, ke) => ke && typeof oe != "string")) throw new RangeError("Invalid JSON representation of ChangeSet");
          if (Y.length == 1) re.push(Y[0], 0);
          else {
            for (; ge.length < Z; ) ge.push(pn.empty);
            ge[Z] = pn.of(Y.slice(1)), re.push(Y[0], ge[Z].length);
          }
        }
      }
      return new an(re, ge);
    }
    static createSet(C, re) {
      return new an(C, re);
    }
  }
  class En {
    constructor(C) {
      this.set = C, this.i = 0, this.next();
    }
    next() {
      let { sections: C } = this.set;
      this.i < C.length ? (this.len = C[this.i++], this.ins = C[this.i++]) : (this.len = 0, this.ins = -2), this.off = 0;
    }
    get done() {
      return this.ins == -2;
    }
    get len2() {
      return 0 > this.ins ? this.len : this.ins;
    }
    get text() {
      let { inserted: C } = this.set, re = this.i - 2 >> 1;
      return re >= C.length ? pn.empty : C[re];
    }
    textBit(C) {
      let { inserted: re } = this.set, ge = this.i - 2 >> 1;
      return ge >= re.length && !C ? pn.empty : re[ge].slice(this.off, C == null ? void 0 : this.off + C);
    }
    forward(C) {
      C == this.len ? this.next() : (this.len -= C, this.off += C);
    }
    forward2(C) {
      this.ins == -1 ? this.forward(C) : C == this.ins ? this.next() : (this.ins -= C, this.off += C);
    }
  }
  class Qn {
    constructor(C, re, ge) {
      this.from = C, this.to = re, this.flags = ge;
    }
    get anchor() {
      return this.flags & 32 ? this.to : this.from;
    }
    get head() {
      return this.flags & 32 ? this.from : this.to;
    }
    get empty() {
      return this.from == this.to;
    }
    get assoc() {
      return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
    }
    get bidiLevel() {
      let C = this.flags & 7;
      return C == 7 ? null : C;
    }
    get goalColumn() {
      let C = this.flags >> 6;
      return C == 16777215 ? void 0 : C;
    }
    map(C, re = -1) {
      return this.empty ? re = C = C.mapPos(this.from, re) : (re = C.mapPos(this.from, 1), C = C.mapPos(
        this.to,
        -1
      )), re == this.from && C == this.to ? this : new Qn(re, C, this.flags);
    }
    extend(C, re = C) {
      return C <= this.anchor && re >= this.anchor ? Vn.range(C, re) : Vn.range(this.anchor, Math.abs(C - this.anchor) > Math.abs(re - this.anchor) ? C : re);
    }
    eq(C) {
      return this.anchor == C.anchor && this.head == C.head;
    }
    toJSON() {
      return { anchor: this.anchor, head: this.head };
    }
    static fromJSON(C) {
      if (!C || typeof C.anchor != "number" || typeof C.head != "number") throw new RangeError("Invalid JSON representation for SelectionRange");
      return Vn.range(C.anchor, C.head);
    }
    static create(C, re, ge) {
      return new Qn(C, re, ge);
    }
  }
  class Vn {
    constructor(C, re) {
      this.ranges = C, this.mainIndex = re;
    }
    map(C, re = -1) {
      return C.empty ? this : Vn.create(this.ranges.map((ge) => ge.map(C, re)), this.mainIndex);
    }
    eq(C) {
      if (this.ranges.length != C.ranges.length || this.mainIndex != C.mainIndex) return !1;
      for (let re = 0; re < this.ranges.length; re++) if (!this.ranges[re].eq(C.ranges[re])) return !1;
      return !0;
    }
    get main() {
      return this.ranges[this.mainIndex];
    }
    asSingle() {
      return this.ranges.length == 1 ? this : new Vn([this.main], 0);
    }
    addRange(C, re = !0) {
      return Vn.create(
        [C].concat(this.ranges),
        re ? 0 : this.mainIndex + 1
      );
    }
    replaceRange(C, re = this.mainIndex) {
      let ge = this.ranges.slice();
      return ge[re] = C, Vn.create(ge, this.mainIndex);
    }
    toJSON() {
      return { ranges: this.ranges.map((C) => C.toJSON()), main: this.mainIndex };
    }
    static fromJSON(C) {
      if (!C || !Array.isArray(C.ranges) || typeof C.main != "number" || C.main >= C.ranges.length) throw new RangeError("Invalid JSON representation for EditorSelection");
      return new Vn(C.ranges.map((re) => Qn.fromJSON(re)), C.main);
    }
    static single(C, re = C) {
      return new Vn([Vn.range(C, re)], 0);
    }
    static create(C, re = 0) {
      if (C.length == 0) throw new RangeError("A selection needs at least one range");
      for (let ge = 0, Z = 0; Z < C.length; Z++) {
        let Y = C[Z];
        if (Y.empty ? Y.from <= ge : Y.from < ge) return Vn.normalized(C.slice(), re);
        ge = Y.to;
      }
      return new Vn(C, re);
    }
    static cursor(C, re = 0, ge, Z) {
      return Qn.create(C, C, (re == 0 ? 0 : 0 > re ? 8 : 16) | (ge == null ? 7 : Math.min(6, ge)) | (Z ?? 16777215) << 6);
    }
    static range(C, re, ge, Z) {
      return ge = (ge ?? 16777215) << 6 | (Z == null ? 7 : Math.min(6, Z)), re < C ? Qn.create(re, C, 48 | ge) : Qn.create(C, re, (re > C ? 8 : 0) | ge);
    }
    static normalized(C, re = 0) {
      re = C[re], C.sort((Z, Y) => Z.from - Y.from), re = C.indexOf(re);
      for (let Z = 1; Z < C.length; Z++) {
        let Y = C[Z];
        var ge = C[Z - 1];
        if (Y.empty ? Y.from <= ge.to : Y.from < ge.to) {
          let oe = ge.from;
          ge = Math.max(Y.to, ge.to), Z <= re && re--, C.splice(--Z, 2, Y.anchor > Y.head ? Vn.range(ge, oe) : Vn.range(oe, ge));
        }
      }
      return new Vn(C, re);
    }
  }
  let ot = 0;
  class Nt {
    constructor(C, re, ge, Z, Y) {
      this.combine = C, this.compareInput = re, this.compare = ge, this.isStatic = Z, this.id = ot++, this.default = C([]), this.extensions = typeof Y == "function" ? Y(this) : Y;
    }
    get reader() {
      return this;
    }
    static define(C = {}) {
      return new Nt(C.combine || ((re) => re), C.compareInput || ((re, ge) => re === ge), C.compare || (C.combine ? (re, ge) => re === ge : we), !!C.static, C.enables);
    }
    of(C) {
      return new zt([], this, 0, C);
    }
    compute(C, re) {
      if (this.isStatic) throw Error("Can't compute a static facet");
      return new zt(C, this, 1, re);
    }
    computeN(C, re) {
      if (this.isStatic) throw Error("Can't compute a static facet");
      return new zt(C, this, 2, re);
    }
    from(C, re) {
      return re ||= (ge) => ge, this.compute([C], (ge) => re(ge.field(C)));
    }
  }
  class zt {
    constructor(C, re, ge, Z) {
      this.dependencies = C, this.facet = re, this.type = ge, this.value = Z, this.id = ot++;
    }
    dynamicSlot(C) {
      var re;
      let ge = this.value, Z = this.facet.compareInput, Y = this.id, oe = C[Y] >> 1, ke = this.type == 2, De = !1, un = !1, gn = [];
      for (let Tn of this.dependencies) Tn == "doc" ? De = !0 : Tn == "selection" ? un = !0 : !(((re = C[Tn.id]) !== null && re !== void 0 ? re : 1) & 1) && gn.push(C[Tn.id]);
      return { create(Tn) {
        return Tn.values[oe] = ge(Tn), 1;
      }, update(Tn, ft) {
        return (De && ft.docChanged || un && (ft.docChanged || ft.selection) || xe(Tn, gn)) && (ft = ge(Tn), ke ? !ce(ft, Tn.values[oe], Z) : !Z(ft, Tn.values[oe])) ? (Tn.values[oe] = ft, 1) : 0;
      }, reconfigure: (Tn, ft) => {
        let gt;
        var Gt = ft.config.address[Y];
        if (Gt != null) {
          if (Gt = K(ft, Gt), this.dependencies.every((zl) => zl instanceof Nt ? ft.facet(zl) === Tn.facet(zl) : zl instanceof ol ? ft.field(zl, !1) == Tn.field(zl, !1) : !0) || (ke ? ce(gt = ge(Tn), Gt, Z) : Z(gt = ge(Tn), Gt))) return Tn.values[oe] = Gt, 0;
        } else gt = ge(Tn);
        return Tn.values[oe] = gt, 1;
      } };
    }
  }
  const Pt = Nt.define({ static: !0 });
  class ol {
    constructor(C, re, ge, Z, Y) {
      this.id = C, this.createF = re, this.updateF = ge, this.compareF = Z, this.spec = Y, this.provides = void 0;
    }
    static define(C) {
      let re = new ol(ot++, C.create, C.update, C.compare || ((ge, Z) => ge === Z), C);
      return C.provide && (re.provides = C.provide(re)), re;
    }
    create(C) {
      let re = C.facet(Pt).find((ge) => ge.field == this);
      return (re?.create || this.createF)(C);
    }
    slot(C) {
      let re = C[this.id] >> 1;
      return { create: (ge) => (ge.values[re] = this.create(ge), 1), update: (ge, Z) => {
        let Y = ge.values[re];
        return Z = this.updateF(Y, Z), this.compareF(Y, Z) ? 0 : (ge.values[re] = Z, 1);
      }, reconfigure: (ge, Z) => Z.config.address[this.id] != null ? (ge.values[re] = Z.field(this), 0) : (ge.values[re] = this.create(ge), 1) };
    }
    init(C) {
      return [this, Pt.of({ field: this, create: C })];
    }
    get extension() {
      return this;
    }
  }
  const St = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
  e = { highest: je(St.highest), high: je(St.high), default: je(St.default), low: je(St.low), lowest: je(St.lowest) };
  class pr {
    constructor(C, re) {
      this.inner = C, this.prec = re;
    }
  }
  class ul {
    of(C) {
      return new Rr(this, C);
    }
    reconfigure(C) {
      return ul.reconfigure.of({ compartment: this, extension: C });
    }
    get(C) {
      return C.config.compartments.get(this);
    }
  }
  class Rr {
    constructor(C, re) {
      this.compartment = C, this.inner = re;
    }
  }
  class ql {
    constructor(C, re, ge, Z, Y, oe) {
      for (this.base = C, this.compartments = re, this.dynamicSlots = ge, this.address = Z, this.staticValues = Y, this.facets = oe, this.statusTemplate = []; this.statusTemplate.length < ge.length; ) this.statusTemplate.push(0);
    }
    staticFacet(C) {
      let re = this.address[C.id];
      return re == null ? C.default : this.staticValues[re >> 1];
    }
    static resolve(C, re, ge) {
      var Z = [];
      let Y = /* @__PURE__ */ Object.create(null), oe = /* @__PURE__ */ new Map();
      for (var ke of E(C, re, oe)) ke instanceof ol ? Z.push(ke) : (Y[ke.facet.id] || (Y[ke.facet.id] = [])).push(ke);
      let De = /* @__PURE__ */ Object.create(null);
      re = [], ke = [];
      for (let gn of Z) De[gn.id] = ke.length << 1, ke.push((Tn) => gn.slot(Tn));
      Z = ge?.config.facets;
      for (let gn in Y) {
        let Tn = Y[gn], ft = Tn[0].facet;
        var un = Z && Z[gn] || [];
        if (Tn.every((gt) => gt.type == 0)) De[ft.id] = re.length << 1 | 1, we(un, Tn) ? re.push(ge.facet(ft)) : (un = ft.combine(Tn.map((gt) => gt.value)), re.push(ge && ft.compare(un, ge.facet(ft)) ? ge.facet(ft) : un));
        else {
          for (let gt of Tn) gt.type == 0 ? (De[gt.id] = re.length << 1 | 1, re.push(gt.value)) : (De[gt.id] = ke.length << 1, ke.push((Gt) => gt.dynamicSlot(Gt)));
          De[ft.id] = ke.length << 1, ke.push((gt) => $e(gt, ft, Tn));
        }
      }
      return ge = ke.map((gn) => gn(De)), new ql(C, oe, ge, De, re, Y);
    }
  }
  const Mr = Nt.define(), wi = Nt.define({ combine: (Pe) => Pe.some((C) => C), static: !0 }), bl = Nt.define({ combine: (Pe) => Pe.length ? Pe[0] : void 0, static: !0 }), tl = Nt.define(), Zt = Nt.define(), Ql = Nt.define(), jl = Nt.define({ combine: (Pe) => Pe.length ? Pe[0] : !1 });
  class Sl {
    constructor(C, re) {
      this.type = C, this.value = re;
    }
    static define() {
      return new gl();
    }
  }
  class gl {
    of(C) {
      return new Sl(this, C);
    }
  }
  class jr {
    constructor(C) {
      this.map = C;
    }
    of(C) {
      return new Kt(this, C);
    }
  }
  class Kt {
    constructor(C, re) {
      this.type = C, this.value = re;
    }
    map(C) {
      return C = this.type.map(this.value, C), C === void 0 ? void 0 : C == this.value ? this : new Kt(
        this.type,
        C
      );
    }
    is(C) {
      return this.type == C;
    }
    static define(C = {}) {
      return new jr(C.map || ((re) => re));
    }
    static mapEffects(C, re) {
      if (!C.length) return C;
      let ge = [];
      for (let Z of C) (C = Z.map(re)) && ge.push(C);
      return ge;
    }
  }
  Kt.reconfigure = Kt.define(), Kt.appendConfig = Kt.define();
  class nl {
    constructor(C, re, ge, Z, Y, oe) {
      this.startState = C, this.changes = re, this.selection = ge, this.effects = Z, this.annotations = Y, this.scrollIntoView = oe, this._state = this._doc = null, ge && J(ge, re.newLength), Y.some((ke) => ke.type == nl.time) || (this.annotations = Y.concat(nl.time.of(Date.now())));
    }
    static create(C, re, ge, Z, Y, oe) {
      return new nl(C, re, ge, Z, Y, oe);
    }
    get newDoc() {
      return this._doc || (this._doc = this.changes.apply(this.startState.doc));
    }
    get newSelection() {
      return this.selection || this.startState.selection.map(this.changes);
    }
    get state() {
      return this._state || this.startState.applyTransaction(this), this._state;
    }
    annotation(C) {
      for (let re of this.annotations) if (re.type == C) return re.value;
    }
    get docChanged() {
      return !this.changes.empty;
    }
    get reconfigured() {
      return this.startState.config != this.state.config;
    }
    isUserEvent(C) {
      let re = this.annotation(nl.userEvent);
      return !(!re || !(re == C || re.length > C.length && re.slice(0, C.length) == C && re[C.length] == "."));
    }
  }
  nl.time = Sl.define(), nl.userEvent = Sl.define(), nl.addToHistory = Sl.define(), nl.remote = Sl.define();
  const Pr = [];
  l.CharCategory = void 0, function(Pe) {
    Pe[Pe.Word = 0] = "Word", Pe[Pe.Space = 1] = "Space", Pe[Pe.Other = 2] = "Other";
  }(l.CharCategory || (l.CharCategory = {}));
  const ii = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
  let Ar;
  try {
    Ar = RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
  } catch {
  }
  class Ml {
    constructor(C, re, ge, Z, Y, oe) {
      for (this.config = C, this.doc = re, this.selection = ge, this.values = Z, this.status = C.statusTemplate.slice(), this.computeSlot = Y, oe && (oe._state = this), C = 0; C < this.config.dynamicSlots.length; C++) P(this, C << 1);
      this.computeSlot = null;
    }
    field(C, re = !0) {
      if (C = this.config.address[C.id], C == null) {
        if (re) throw new RangeError("Field is not present in this state");
      } else return P(this, C), K(this, C);
    }
    update(...C) {
      return Me(this, C, !0);
    }
    applyTransaction(C) {
      let re = this.config, { base: ge, compartments: Z } = re;
      for (var Y of C.effects) Y.is(ul.reconfigure) ? (re && (Z = /* @__PURE__ */ new Map(), re.compartments.forEach((oe, ke) => Z.set(ke, oe)), re = null), Z.set(Y.value.compartment, Y.value.extension)) : Y.is(Kt.reconfigure) ? (re = null, ge = Y.value) : Y.is(Kt.appendConfig) && (re = null, ge = le(ge).concat(Y.value));
      re ? Y = C.startState.values.slice() : (re = ql.resolve(ge, Z, this), Y = new Ml(re, this.doc, this.selection, re.dynamicSlots.map(() => null), (oe, ke) => ke.reconfigure(oe, this), null).values), new Ml(re, C.newDoc, C.newSelection, Y, (oe, ke) => ke.update(oe, C), C);
    }
    replaceSelection(C) {
      return typeof C == "string" && (C = this.toText(C)), this.changeByRange((re) => ({ changes: { from: re.from, to: re.to, insert: C }, range: Vn.cursor(re.from + C.length) }));
    }
    changeByRange(C) {
      let re = this.selection;
      var ge = C(re.ranges[0]);
      let Z = this.changes(ge.changes), Y = [ge.range];
      ge = le(ge.effects);
      for (let ke = 1; ke < re.ranges.length; ke++) {
        let De = C(re.ranges[ke]);
        var oe = this.changes(De.changes);
        let un = oe.map(Z);
        for (let gn = 0; gn < ke; gn++) Y[gn] = Y[gn].map(un);
        oe = Z.mapDesc(oe, !0), Y.push(De.range.map(oe)), Z = Z.compose(un), ge = Kt.mapEffects(ge, un).concat(Kt.mapEffects(le(De.effects), oe));
      }
      return { changes: Z, selection: Vn.create(Y, re.mainIndex), effects: ge };
    }
    changes(C = []) {
      return C instanceof an ? C : an.of(C, this.doc.length, this.facet(Ml.lineSeparator));
    }
    toText(C) {
      return pn.of(C.split(this.facet(Ml.lineSeparator) || _e));
    }
    sliceDoc(C = 0, re = this.doc.length) {
      return this.doc.sliceString(C, re, this.lineBreak);
    }
    facet(C) {
      let re = this.config.address[C.id];
      return re == null ? C.default : (P(this, re), K(this, re));
    }
    toJSON(C) {
      let re = { doc: this.sliceDoc(), selection: this.selection.toJSON() };
      if (C) for (let ge in C) {
        let Z = C[ge];
        Z instanceof ol && this.config.address[Z.id] != null && (re[ge] = Z.spec.toJSON(
          this.field(C[ge]),
          this
        ));
      }
      return re;
    }
    static fromJSON(C, re = {}, ge) {
      if (!C || typeof C.doc != "string") throw new RangeError("Invalid JSON representation for EditorState");
      let Z = [];
      if (ge) {
        for (let Y in ge) if (Object.prototype.hasOwnProperty.call(C, Y)) {
          let oe = ge[Y], ke = C[Y];
          Z.push(oe.init((De) => oe.spec.fromJSON(ke, De)));
        }
      }
      return Ml.create({ doc: C.doc, selection: Vn.fromJSON(C.selection), extensions: re.extensions ? Z.concat([re.extensions]) : Z });
    }
    static create(C = {}) {
      let re = ql.resolve(C.extensions || [], /* @__PURE__ */ new Map()), ge = C.doc instanceof pn ? C.doc : pn.of((C.doc || "").split(re.staticFacet(Ml.lineSeparator) || _e));
      return C = C.selection ? C.selection instanceof Vn ? C.selection : Vn.single(C.selection.anchor, C.selection.head) : Vn.single(0), J(C, ge.length), re.staticFacet(wi) || (C = C.asSingle()), new Ml(re, ge, C, re.dynamicSlots.map(() => null), (Z, Y) => Y.create(Z), null);
    }
    get tabSize() {
      return this.facet(Ml.tabSize);
    }
    get lineBreak() {
      return this.facet(Ml.lineSeparator) || `
`;
    }
    get readOnly() {
      return this.facet(jl);
    }
    phrase(C, ...re) {
      for (let ge of this.facet(Ml.phrases)) if (Object.prototype.hasOwnProperty.call(ge, C)) {
        C = ge[C];
        break;
      }
      return re.length && (C = C.replace(/\$(\$|\d*)/g, (ge, Z) => Z == "$" ? "$" : (Z = +(Z || 1), !Z || Z > re.length ? ge : re[Z - 1]))), C;
    }
    languageDataAt(C, re, ge = -1) {
      let Z = [];
      for (let Y of this.facet(Mr)) for (let oe of Y(this, re, ge)) Object.prototype.hasOwnProperty.call(oe, C) && Z.push(oe[C]);
      return Z;
    }
    charCategorizer(C) {
      return Ce(this.languageDataAt("wordChars", C).join(""));
    }
    wordAt(C) {
      let { text: re, from: ge, length: Z } = this.doc.lineAt(C), Y = this.charCategorizer(C), oe = C - ge;
      for (C -= ge; 0 < oe; ) {
        var ke = a(re, oe, !1);
        if (Y(re.slice(ke, oe)) != l.CharCategory.Word) break;
        oe = ke;
      }
      for (; C < Z && (ke = a(re, C), Y(re.slice(C, ke)) == l.CharCategory.Word); )
        C = ke;
      return oe == C ? null : Vn.range(oe + ge, C + ge);
    }
  }
  Ml.allowMultipleSelections = wi, Ml.tabSize = Nt.define({ combine: (Pe) => Pe.length ? Pe[0] : 4 }), Ml.lineSeparator = bl, Ml.readOnly = jl, Ml.phrases = Nt.define({ compare(Pe, C) {
    let re = Object.keys(Pe), ge = Object.keys(C);
    return re.length == ge.length && re.every((Z) => Pe[Z] == C[Z]);
  } }), Ml.languageData = Mr, Ml.changeFilter = tl, Ml.transactionFilter = Zt, Ml.transactionExtender = Ql, ul.reconfigure = Kt.define();
  class Rl {
    eq(C) {
      return this == C;
    }
    range(C, re = C) {
      return Se.create(
        C,
        re,
        this
      );
    }
  }
  Rl.prototype.startSide = Rl.prototype.endSide = 0, Rl.prototype.point = !1, Rl.prototype.mapMode = l.MapMode.TrackDel;
  class Se {
    constructor(C, re, ge) {
      this.from = C, this.to = re, this.value = ge;
    }
    static create(C, re, ge) {
      return new Se(C, re, ge);
    }
  }
  class se {
    constructor(C, re, ge, Z) {
      this.from = C, this.to = re, this.value = ge, this.maxPoint = Z;
    }
    get length() {
      return this.to[this.to.length - 1];
    }
    findIndex(C, re, ge, Z = 0) {
      let Y = ge ? this.to : this.from;
      for (let oe = Z, ke = Y.length; ; ) {
        if (oe == ke) return oe;
        Z = oe + ke >> 1;
        let De = Y[Z] - C || (ge ? this.value[Z].endSide : this.value[Z].startSide) - re;
        if (Z == oe) return 0 <= De ? oe : ke;
        0 <= De ? ke = Z : oe = Z + 1;
      }
    }
    between(C, re, ge, Z) {
      for (let Y = this.findIndex(re, -1e9, !0), oe = this.findIndex(ge, 1e9, !1, Y); Y < oe; Y++) if (Z(this.from[Y] + C, this.to[Y] + C, this.value[Y]) === !1) return !1;
    }
    map(C, re) {
      let ge = [], Z = [], Y = [], oe = -1, ke = -1;
      for (let gn = 0; gn < this.value.length; gn++) {
        let Tn = this.value[gn], ft = this.from[gn] + C;
        var De = this.to[gn] + C, un = void 0;
        if (ft == De) {
          if (un = re.mapPos(ft, Tn.startSide, Tn.mapMode), un == null || (un = De = un, Tn.startSide != Tn.endSide && (De = re.mapPos(ft, Tn.endSide), De < un))) continue;
        } else if (un = re.mapPos(
          ft,
          Tn.startSide
        ), De = re.mapPos(De, Tn.endSide), un > De || un == De && 0 < Tn.startSide && 0 >= Tn.endSide) continue;
        0 > (De - un || Tn.endSide - Tn.startSide) || (0 > oe && (oe = un), Tn.point && (ke = Math.max(ke, De - un)), ge.push(Tn), Z.push(un - oe), Y.push(De - oe));
      }
      return { mapped: ge.length ? new se(Z, Y, ge, ke) : null, pos: oe };
    }
  }
  class Ee {
    constructor(C, re, ge, Z) {
      this.chunkPos = C, this.chunk = re, this.nextLayer = ge, this.maxPoint = Z;
    }
    static create(C, re, ge, Z) {
      return new Ee(C, re, ge, Z);
    }
    get length() {
      let C = this.chunk.length - 1;
      return 0 > C ? 0 : Math.max(this.chunkEnd(C), this.nextLayer.length);
    }
    get size() {
      if (this.isEmpty) return 0;
      let C = this.nextLayer.size;
      for (let re of this.chunk) C += re.value.length;
      return C;
    }
    chunkEnd(C) {
      return this.chunkPos[C] + this.chunk[C].length;
    }
    update(C) {
      let { add: re = [], sort: ge = !1, filterFrom: Z = 0, filterTo: Y = this.length } = C;
      if (C = C.filter, re.length == 0 && !C) return this;
      if (ge && (re = re.slice().sort(Ye)), this.isEmpty) return re.length ? Ee.of(re) : this;
      let oe = new vn(this, null, -1).goto(0), ke = 0, De = [], un = new Ge();
      for (; oe.value || ke < re.length; ) if (ke < re.length && 0 <= (oe.from - re[ke].from || oe.startSide - re[ke].value.startSide)) {
        let gn = re[ke++];
        un.addInner(
          gn.from,
          gn.to,
          gn.value
        ) || De.push(gn);
      } else oe.rangeIndex == 1 && oe.chunkIndex < this.chunk.length && (ke == re.length || this.chunkEnd(oe.chunkIndex) < re[ke].from) && (!C || Z > this.chunkEnd(oe.chunkIndex) || Y < this.chunkPos[oe.chunkIndex]) && un.addChunk(this.chunkPos[oe.chunkIndex], this.chunk[oe.chunkIndex]) ? oe.nextChunk() : ((!C || Z > oe.to || Y < oe.from || C(oe.from, oe.to, oe.value)) && (un.addInner(oe.from, oe.to, oe.value) || De.push(Se.create(oe.from, oe.to, oe.value))), oe.next());
      return un.finishInner(this.nextLayer.isEmpty && !De.length ? Ee.empty : this.nextLayer.update({
        add: De,
        filter: C,
        filterFrom: Z,
        filterTo: Y
      }));
    }
    map(C) {
      if (C.empty || this.isEmpty) return this;
      let re = [], ge = [], Z = -1;
      for (let Y = 0; Y < this.chunk.length; Y++) {
        let oe = this.chunkPos[Y], ke = this.chunk[Y], De = C.touchesRange(oe, oe + ke.length);
        if (De === !1) Z = Math.max(Z, ke.maxPoint), re.push(ke), ge.push(C.mapPos(oe));
        else if (De === !0) {
          let { mapped: un, pos: gn } = ke.map(oe, C);
          un && (Z = Math.max(Z, un.maxPoint), re.push(un), ge.push(gn));
        }
      }
      return C = this.nextLayer.map(C), re.length == 0 ? C : new Ee(ge, re, C || Ee.empty, Z);
    }
    between(C, re, ge) {
      if (!this.isEmpty) {
        for (let Z = 0; Z < this.chunk.length; Z++) {
          let Y = this.chunkPos[Z], oe = this.chunk[Z];
          if (re >= Y && C <= Y + oe.length && oe.between(Y, C - Y, re - Y, ge) === !1) return;
        }
        this.nextLayer.between(C, re, ge);
      }
    }
    iter(C = 0) {
      return Kn.from([this]).goto(C);
    }
    get isEmpty() {
      return this.nextLayer == this;
    }
    static iter(C, re = 0) {
      return Kn.from(C).goto(re);
    }
    static compare(C, re, ge, Z, Y = -1) {
      C = C.filter((un) => 0 < un.maxPoint || !un.isEmpty && un.maxPoint >= Y), re = re.filter((un) => 0 < un.maxPoint || !un.isEmpty && un.maxPoint >= Y);
      let oe = q(C, re, ge), ke = new Un(C, oe, Y), De = new Un(re, oe, Y);
      ge.iterGaps((un, gn, Tn) => Ae(ke, un, De, gn, Tn, Z)), ge.empty && ge.length == 0 && Ae(
        ke,
        0,
        De,
        0,
        0,
        Z
      );
    }
    static eq(C, re, ge = 0, Z) {
      Z == null && (Z = 999999999);
      var Y = C.filter((De) => !De.isEmpty && 0 > re.indexOf(De));
      let oe = re.filter((De) => !De.isEmpty && 0 > C.indexOf(De));
      if (Y.length != oe.length) return !1;
      if (!Y.length) return !0;
      let ke = q(Y, oe);
      for (Y = new Un(Y, ke, 0).goto(ge), ge = new Un(oe, ke, 0).goto(ge); ; ) {
        if (Y.to != ge.to || !Fe(Y.active, ge.active) || Y.point && (!ge.point || !Y.point.eq(ge.point))) return !1;
        if (Y.to > Z) return !0;
        Y.next(), ge.next();
      }
    }
    static spans(C, re, ge, Z, Y = -1) {
      C = new Un(C, null, Y).goto(re), Y = re;
      let oe = C.openStart;
      for (; ; ) {
        let ke = Math.min(
          C.to,
          ge
        );
        if (C.point) {
          let De = C.activeForPoint(C.to);
          Z.point(Y, ke, C.point, De, C.pointFrom < re ? De.length + 1 : Math.min(De.length, oe), C.pointRank), oe = Math.min(C.openEnd(ke), De.length);
        } else ke > Y && (Z.span(Y, ke, C.active, oe), oe = C.openEnd(ke));
        if (C.to > ge) return oe + (C.point && C.to > ge ? 1 : 0);
        Y = C.to, C.next();
      }
    }
    static of(C, re = !1) {
      let ge = new Ge();
      for (let Z of C instanceof Se ? [C] : re ? B(C) : C) ge.add(Z.from, Z.to, Z.value);
      return ge.finish();
    }
  }
  Ee.empty = new Ee([], [], null, -1), Ee.empty.nextLayer = Ee.empty;
  class Ge {
    finishChunk(C) {
      this.chunks.push(new se(
        this.from,
        this.to,
        this.value,
        this.maxPoint
      )), this.chunkPos.push(this.chunkStart), this.chunkStart = -1, this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint), this.maxPoint = -1, C && (this.from = [], this.to = [], this.value = []);
    }
    constructor() {
      this.chunks = [], this.chunkPos = [], this.chunkStart = -1, this.last = null, this.lastTo = this.lastFrom = -1e9, this.from = [], this.to = [], this.value = [], this.setMaxPoint = this.maxPoint = -1, this.nextLayer = null;
    }
    add(C, re, ge) {
      this.addInner(C, re, ge) || (this.nextLayer || (this.nextLayer = new Ge())).add(C, re, ge);
    }
    addInner(C, re, ge) {
      let Z = C - this.lastTo || ge.startSide - this.last.endSide;
      if (0 >= Z && 0 > (C - this.lastFrom || ge.startSide - this.last.startSide)) throw Error("Ranges must be added sorted by `from` position and `startSide`");
      return 0 > Z ? !1 : (this.from.length == 250 && this.finishChunk(!0), 0 > this.chunkStart && (this.chunkStart = C), this.from.push(C - this.chunkStart), this.to.push(re - this.chunkStart), this.last = ge, this.lastFrom = C, this.lastTo = re, this.value.push(ge), ge.point && (this.maxPoint = Math.max(this.maxPoint, re - C)), !0);
    }
    addChunk(C, re) {
      if (0 > (C - this.lastTo || re.value[0].startSide - this.last.endSide)) return !1;
      this.from.length && this.finishChunk(!0), this.setMaxPoint = Math.max(this.setMaxPoint, re.maxPoint), this.chunks.push(re), this.chunkPos.push(C);
      let ge = re.value.length - 1;
      return this.last = re.value[ge], this.lastFrom = re.from[ge] + C, this.lastTo = re.to[ge] + C, !0;
    }
    finish() {
      return this.finishInner(Ee.empty);
    }
    finishInner(C) {
      return this.from.length && this.finishChunk(!1), this.chunks.length == 0 || (C = Ee.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(C) : C, this.setMaxPoint), this.from = null), C;
    }
  }
  class vn {
    constructor(C, re, ge, Z = 0) {
      this.layer = C, this.skip = re, this.minPoint = ge, this.rank = Z;
    }
    get startSide() {
      return this.value ? this.value.startSide : 0;
    }
    get endSide() {
      return this.value ? this.value.endSide : 0;
    }
    goto(C, re = -1e9) {
      return this.chunkIndex = this.rangeIndex = 0, this.gotoInner(C, re, !1), this;
    }
    gotoInner(C, re, ge) {
      for (; this.chunkIndex < this.layer.chunk.length; ) {
        let Z = this.layer.chunk[this.chunkIndex];
        if (!(this.skip && this.skip.has(Z) || this.layer.chunkEnd(this.chunkIndex) < C || Z.maxPoint < this.minPoint)) break;
        this.chunkIndex++, ge = !1;
      }
      this.chunkIndex < this.layer.chunk.length && (C = this.layer.chunk[this.chunkIndex].findIndex(C - this.layer.chunkPos[this.chunkIndex], re, !0), (!ge || this.rangeIndex < C) && this.setRangeIndex(C)), this.next();
    }
    forward(C, re) {
      0 > (this.to - C || this.endSide - re) && this.gotoInner(C, re, !0);
    }
    next() {
      for (; ; ) if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9, this.value = null;
        break;
      } else {
        let C = this.layer.chunkPos[this.chunkIndex], re = this.layer.chunk[this.chunkIndex];
        if (this.from = C + re.from[this.rangeIndex], this.to = C + re.to[this.rangeIndex], this.value = re.value[this.rangeIndex], this.setRangeIndex(this.rangeIndex + 1), 0 > this.minPoint || this.value.point && this.to - this.from >= this.minPoint) break;
      }
    }
    setRangeIndex(C) {
      if (C == this.layer.chunk[this.chunkIndex].value.length) {
        if (this.chunkIndex++, this.skip) for (; this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]); ) this.chunkIndex++;
        this.rangeIndex = 0;
      } else this.rangeIndex = C;
    }
    nextChunk() {
      this.chunkIndex++, this.rangeIndex = 0, this.next();
    }
    compare(C) {
      return this.from - C.from || this.startSide - C.startSide || this.rank - C.rank || this.to - C.to || this.endSide - C.endSide;
    }
  }
  class Kn {
    constructor(C) {
      this.heap = C;
    }
    static from(C, re = null, ge = -1) {
      let Z = [];
      for (let Y = 0; Y < C.length; Y++) for (let oe = C[Y]; !oe.isEmpty; oe = oe.nextLayer) oe.maxPoint >= ge && Z.push(new vn(oe, re, ge, Y));
      return Z.length == 1 ? Z[0] : new Kn(Z);
    }
    get startSide() {
      return this.value ? this.value.startSide : 0;
    }
    goto(C, re = -1e9) {
      for (let ge of this.heap) ge.goto(C, re);
      for (C = this.heap.length >> 1; 0 <= C; C--) me(
        this.heap,
        C
      );
      return this.next(), this;
    }
    forward(C, re) {
      for (var ge of this.heap) ge.forward(C, re);
      for (ge = this.heap.length >> 1; 0 <= ge; ge--) me(this.heap, ge);
      0 > (this.to - C || this.value.endSide - re) && this.next();
    }
    next() {
      if (this.heap.length == 0) this.from = this.to = 1e9, this.value = null, this.rank = -1;
      else {
        let C = this.heap[0];
        this.from = C.from, this.to = C.to, this.value = C.value, this.rank = C.rank, C.value && C.next(), me(this.heap, 0);
      }
    }
  }
  class Un {
    constructor(C, re, ge) {
      this.minPoint = ge, this.active = [], this.activeTo = [], this.activeRank = [], this.minActive = -1, this.point = null, this.pointRank = this.pointFrom = 0, this.to = -1e9, this.endSide = 0, this.openStart = -1, this.cursor = Kn.from(C, re, ge);
    }
    goto(C, re = -1e9) {
      return this.cursor.goto(C, re), this.active.length = this.activeTo.length = this.activeRank.length = 0, this.minActive = -1, this.to = C, this.endSide = re, this.openStart = -1, this.next(), this;
    }
    forward(C, re) {
      for (; -1 < this.minActive && 0 > (this.activeTo[this.minActive] - C || this.active[this.minActive].endSide - re); ) this.removeActive(this.minActive);
      this.cursor.forward(C, re);
    }
    removeActive(C) {
      ln(this.active, C), ln(this.activeTo, C), ln(this.activeRank, C), this.minActive = Ze(this.active, this.activeTo);
    }
    addActive(C) {
      let re = 0, { value: ge, to: Z, rank: Y } = this.cursor;
      for (; re < this.activeRank.length && this.activeRank[re] <= Y; ) re++;
      Be(this.active, re, ge), Be(this.activeTo, re, Z), Be(this.activeRank, re, Y), C && Be(C, re, this.cursor.from), this.minActive = Ze(this.active, this.activeTo);
    }
    next() {
      let C = this.to;
      var re = this.point;
      this.point = null;
      let ge = 0 > this.openStart ? [] : null;
      for (; ; ) {
        var Z = this.minActive;
        if (-1 < Z && 0 > (this.activeTo[Z] - this.cursor.from || this.active[Z].endSide - this.cursor.startSide)) {
          if (this.activeTo[Z] > C) {
            this.to = this.activeTo[Z], this.endSide = this.active[Z].endSide;
            break;
          }
          this.removeActive(Z), ge && ln(ge, Z);
        } else if (this.cursor.value) if (this.cursor.from > C) {
          this.to = this.cursor.from, this.endSide = this.cursor.startSide;
          break;
        } else if (Z = this.cursor.value, Z.point) if (re && this.cursor.to == this.to && this.cursor.from < this.cursor.to) this.cursor.next();
        else {
          this.point = Z, this.pointFrom = this.cursor.from, this.pointRank = this.cursor.rank, this.to = this.cursor.to, this.endSide = Z.endSide, this.cursor.next(), this.forward(this.to, this.endSide);
          break;
        }
        else this.addActive(ge), this.cursor.next();
        else {
          this.to = this.endSide = 1e9;
          break;
        }
      }
      if (ge) for (this.openStart = 0, re = ge.length - 1; 0 <= re && ge[re] < C; re--) this.openStart++;
    }
    activeForPoint(C) {
      if (!this.active.length) return this.active;
      let re = [];
      for (let ge = this.active.length - 1; 0 <= ge && !(this.activeRank[ge] < this.pointRank); ge--) (this.activeTo[ge] > C || this.activeTo[ge] == C && this.active[ge].endSide >= this.point.endSide) && re.push(this.active[ge]);
      return re.reverse();
    }
    openEnd(C) {
      let re = 0;
      for (let ge = this.activeTo.length - 1; 0 <= ge && this.activeTo[ge] > C; ge--) re++;
      return re;
    }
  }
  l.Annotation = Sl, l.AnnotationType = gl, l.ChangeDesc = Ve, l.ChangeSet = an, l.Compartment = ul, l.EditorSelection = Vn, l.EditorState = Ml, l.Facet = Nt, l.Line = Cl, l.Prec = e, l.Range = Se, l.RangeSet = Ee, l.RangeSetBuilder = Ge, l.RangeValue = Rl, l.SelectionRange = Qn, l.StateEffect = Kt, l.StateEffectType = jr, l.StateField = ol, l.Text = pn, l.Transaction = nl, l.codePointAt = d, l.codePointSize = p, l.combineConfig = function(Pe, C, re = {}) {
    let ge = {};
    for (let Z of Pe) for (let Y of Object.keys(Z)) {
      Pe = Z[Y];
      let oe = ge[Y];
      if (oe === void 0) ge[Y] = Pe;
      else if (oe !== Pe && Pe !== void 0) if (Object.hasOwnProperty.call(re, Y)) ge[Y] = re[Y](oe, Pe);
      else throw Error("Config merge conflict for field " + Y);
    }
    for (let Z in C) ge[Z] === void 0 && (ge[Z] = C[Z]);
    return ge;
  }, l.countColumn = function(Pe, C, re = Pe.length) {
    let ge = 0;
    for (let Z = 0; Z < re; ) Pe.charCodeAt(Z) == 9 ? (ge += C - ge % C, Z++) : (ge++, Z = a(Pe, Z));
    return ge;
  }, l.findClusterBreak = a, l.findColumn = function(Pe, C, re, ge) {
    for (let Z = 0, Y = 0; ; ) {
      if (Y >= C) return Z;
      if (Z == Pe.length) break;
      Y += Pe.charCodeAt(Z) == 9 ? re - Y % re : 1, Z = a(Pe, Z);
    }
    return ge === !0 ? -1 : Pe.length;
  }, l.fromCodePoint = function(Pe) {
    return 65535 >= Pe ? String.fromCharCode(Pe) : (Pe -= 65536, String.fromCharCode((Pe >> 10) + 55296, (Pe & 1023) + 56320));
  };
};
Xo[1] = function(e, n, t, l) {
  var r = typeof Symbol > "u" ? "__ͼ" : Symbol.for("ͼ"), u = typeof Symbol > "u" ? "__styleSet" + Math.floor(1e8 * Math.random()) : Symbol("styleSet"), o = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : {};
  e = l.StyleModule = function(s, d) {
    function p(L) {
      return /^@/.test(L) ? [L] : L.split(/,\s*/);
    }
    function _(L, G, J, we) {
      var ce = [], xe = /^@(\w+)\b/.exec(L[0]), $e = xe && xe[1] == "keyframes";
      if (xe && G == null) return J.push(L[0] + ";");
      for (var je in G) {
        var E = G[je];
        if (/&/.test(je)) _(je.split(/,\s*/).map(function(P) {
          return L.map(function(K) {
            return P.replace(/&/, K);
          });
        }).reduce(function(P, K) {
          return P.concat(K);
        }), E, J);
        else if (E && typeof E == "object") {
          if (!xe) throw new RangeError("The value of a property (" + je + ") should be a primitive value.");
          _(p(je), E, ce, $e);
        } else E != null && ce.push(je.replace(/_.*/, "").replace(/[A-Z]/g, function(P) {
          return "-" + P.toLowerCase();
        }) + ": " + E + ";");
      }
      (ce.length || $e) && J.push((!R || xe || we ? L : L.map(R)).join(", ") + " {" + ce.join(" ") + "}");
    }
    this.rules = [];
    var R = (d || {}).finish, F;
    for (F in s) _(p(F), s[F], this.rules);
  }, e.prototype.getRules = function() {
    return this.rules.join(`
`);
  }, e.newName = function() {
    var s = o[r] || 1;
    return o[r] = s + 1, "ͼ" + s.toString(36);
  }, e.mount = function(s, d, p) {
    var _ = s[u];
    p = p && p.nonce, _ ? p && _.setNonce(p) : _ = new h(s, p), _.mount(Array.isArray(d) ? d : [d]);
  };
  var a = /* @__PURE__ */ new Map(), h = function(s, d) {
    var p = s.ownerDocument || s, _ = p.defaultView;
    if (!s.head && s.adoptedStyleSheets && _.CSSStyleSheet) {
      if (d = a.get(p)) return s.adoptedStyleSheets = [d.sheet].concat(s.adoptedStyleSheets), s[u] = d;
      this.sheet = new _.CSSStyleSheet(), s.adoptedStyleSheets = [this.sheet].concat(s.adoptedStyleSheets), a.set(p, this);
    } else this.styleTag = p.createElement("style"), d && this.styleTag.setAttribute("nonce", d), p = s.head || s, p.insertBefore(this.styleTag, p.firstChild);
    this.modules = [], s[u] = this;
  };
  h.prototype.mount = function(s) {
    for (var d = this.sheet, p = 0, _ = 0, R = 0; R < s.length; R++) {
      var F = s[R], L = this.modules.indexOf(F);
      if (L < _ && -1 < L && (this.modules.splice(L, 1), _--, L = -1), L == -1) {
        if (this.modules.splice(_++, 0, F), d) for (L = 0; L < F.rules.length; L++) d.insertRule(F.rules[L], p++);
      } else {
        for (; _ < L; ) p += this.modules[_++].rules.length;
        p += F.rules.length, _++;
      }
    }
    if (!d) {
      for (s = "", d = 0; d < this.modules.length; d++) s += this.modules[d].getRules() + `
`;
      this.styleTag.textContent = s;
    }
  }, h.prototype.setNonce = function(s) {
    this.styleTag && this.styleTag.getAttribute("nonce") != s && this.styleTag.setAttribute("nonce", s);
  };
};
Xo[2] = function(e, n, t, l) {
  Object.defineProperty(l, "__esModule", { value: !0 });
  var r = {
    8: "Backspace",
    9: "Tab",
    10: "Enter",
    12: "NumLock",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    44: "PrintScreen",
    45: "Insert",
    46: "Delete",
    59: ";",
    61: "=",
    91: "Meta",
    92: "Meta",
    106: "*",
    107: "+",
    108: ",",
    109: "-",
    110: ".",
    111: "/",
    144: "NumLock",
    145: "ScrollLock",
    160: "Shift",
    161: "Shift",
    162: "Control",
    163: "Control",
    164: "Alt",
    165: "Alt",
    173: "-",
    186: ";",
    187: "=",
    188: ",",
    189: "-",
    190: ".",
    191: "/",
    192: "`",
    219: "[",
    220: "\\",
    221: "]",
    222: "'"
  }, u = { 48: ")", 49: "!", 50: "@", 51: "#", 52: "$", 53: "%", 54: "^", 55: "&", 56: "*", 57: "(", 59: ":", 61: "+", 173: "_", 186: ":", 187: "+", 188: "<", 189: "_", 190: ">", 191: "?", 192: "~", 219: "{", 220: "|", 221: "}", 222: '"' }, o = typeof navigator < "u" && /Mac/.test(navigator.platform), a = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
  for (e = 0; 10 > e; e++) r[48 + e] = r[96 + e] = String(e);
  for (e = 1; 24 >= e; e++) r[e + 111] = "F" + e;
  for (e = 65; 90 >= e; e++) r[e] = String.fromCharCode(e + 32), u[e] = String.fromCharCode(e);
  for (var h in r) u.hasOwnProperty(h) || (u[h] = r[h]);
  l.base = r, l.keyName = function(s) {
    return s = !(o && s.metaKey && s.shiftKey && !s.ctrlKey && !s.altKey || a && s.shiftKey && s.key && s.key.length == 1 || s.key == "Unidentified") && s.key || (s.shiftKey ? u : r)[s.keyCode] || s.key || "Unidentified", s == "Esc" && (s = "Escape"), s == "Del" && (s = "Delete"), s == "Left" && (s = "ArrowLeft"), s == "Up" && (s = "ArrowUp"), s == "Right" && (s = "ArrowRight"), s == "Down" && (s = "ArrowDown"), s;
  }, l.shift = u;
};
Xo[3] = function(e, n, t, l) {
  function r(N) {
    return (N.nodeType == 11 ? N.getSelection ? N : N.ownerDocument : N).getSelection();
  }
  function u(N, c) {
    return c ? N == c || N.contains(c.nodeType != 1 ? c.parentNode : c) : !1;
  }
  function o(N, c) {
    if (!c.anchorNode) return !1;
    try {
      return u(N, c.anchorNode);
    } catch {
      return !1;
    }
  }
  function a(N) {
    return N.nodeType == 3 ? L(N, 0, N.nodeValue.length).getClientRects() : N.nodeType == 1 ? N.getClientRects() : [];
  }
  function h(N, c, m, k) {
    return m ? d(N, c, m, k, -1) || d(N, c, m, k, 1) : !1;
  }
  function s(N) {
    for (var c = 0; ; c++) if (N = N.previousSibling, !N) return c;
  }
  function d(N, c, m, k, M) {
    for (; ; ) {
      if (N == m && c == k) return !0;
      if (c == (0 > M ? 0 : p(N))) {
        if (N.nodeName == "DIV") return !1;
        let Q = N.parentNode;
        if (!Q || Q.nodeType != 1) return !1;
        c = s(N) + (0 > M ? 0 : 1), N = Q;
      } else if (N.nodeType == 1) {
        if (N = N.childNodes[c + (0 > M ? -1 : 0)], N.nodeType == 1 && N.contentEditable == "false") return !1;
        c = 0 > M ? p(N) : 0;
      } else return !1;
    }
  }
  function p(N) {
    return N.nodeType == 3 ? N.nodeValue.length : N.childNodes.length;
  }
  function _(N, c) {
    return c = c ? N.left : N.right, { left: c, right: c, top: N.top, bottom: N.bottom };
  }
  function R(N) {
    let c = N.ownerDocument;
    for (N = N.parentNode; N && N != c.body; ) if (N.nodeType == 1) {
      if (N.scrollHeight > N.clientHeight || N.scrollWidth > N.clientWidth) return N;
      N = N.assignedSlot || N.parentNode;
    } else if (N.nodeType == 11) N = N.host;
    else break;
    return null;
  }
  function F(N) {
    if (N.setActive) return N.setActive();
    if (Hs) return N.focus(Hs);
    let c = [];
    for (var m = N; m && (c.push(m, m.scrollTop, m.scrollLeft), m != m.ownerDocument); m = m.parentNode) ;
    if (N.focus(Hs == null ? { get preventScroll() {
      return Hs = { preventScroll: !0 }, !0;
    } } : void 0), !Hs) for (Hs = !1, N = 0; N < c.length; ) {
      m = c[N++];
      let k = c[N++], M = c[N++];
      m.scrollTop != k && (m.scrollTop = k), m.scrollLeft != M && (m.scrollLeft = M);
    }
  }
  function L(N, c, m = c) {
    let k = vu ||= document.createRange();
    return k.setEnd(N, m), k.setStart(N, c), k;
  }
  function G(N, c, m) {
    return m = { key: c, code: c, keyCode: m, which: m, cancelable: !0 }, c = new KeyboardEvent("keydown", m), c.synthetic = !0, N.dispatchEvent(c), m = new KeyboardEvent("keyup", m), m.synthetic = !0, N.dispatchEvent(m), c.defaultPrevented || m.defaultPrevented;
  }
  function J(N) {
    for (; N; ) {
      if (N && (N.nodeType == 9 || N.nodeType == 11 && N.host)) return N;
      N = N.assignedSlot || N.parentNode;
    }
    return null;
  }
  function we(N) {
    for (; N.attributes.length; ) N.removeAttributeNode(N.attributes[0]);
  }
  function ce(N) {
    return N.scrollTop > Math.max(1, N.scrollHeight - N.clientHeight - 4);
  }
  function xe(N) {
    let c = N.nextSibling;
    return N.parentNode.removeChild(N), c;
  }
  function $e(N, c, m, k, M, Q, pe, Ie, nn) {
    let { children: Xe } = N, cn = Xe.length ? Xe[c] : null, kn = Q.length ? Q[Q.length - 1] : null, jn = kn ? kn.breakAfter : pe;
    if (!(c == k && cn && !pe && !jn && 2 > Q.length && cn.merge(m, M, Q.length ? kn : null, m == 0, Ie, nn))) {
      if (k < Xe.length) {
        let Pn = Xe[k];
        Pn && (M < Pn.length || Pn.breakAfter && (kn != null && kn.breakAfter)) ? (c == k && (Pn = Pn.split(M), M = 0), !jn && kn && Pn.merge(0, M, kn, !0, 0, nn) ? Q[Q.length - 1] = Pn : ((M || Pn.children.length && !Pn.children[0].length) && Pn.merge(0, M, null, !1, 0, nn), Q.push(Pn))) : Pn != null && Pn.breakAfter && (kn ? kn.breakAfter = 1 : pe = 1), k++;
      }
      for (cn && (cn.breakAfter = pe, 0 < m && (!pe && Q.length && cn.merge(m, cn.length, Q[0], !1, Ie, 0) ? cn.breakAfter = Q.shift().breakAfter : (m < cn.length || cn.children.length && cn.children[cn.children.length - 1].length == 0) && cn.merge(m, cn.length, null, !1, Ie, 0), c++)); c < k && Q.length; ) if (Xe[k - 1].become(Q[Q.length - 1])) k--, Q.pop(), nn = Q.length ? 0 : Ie;
      else if (Xe[c].become(Q[0])) c++, Q.shift(), Ie = Q.length ? 0 : nn;
      else break;
      !Q.length && c && k < Xe.length && !Xe[c - 1].breakAfter && Xe[k].merge(0, 0, Xe[c - 1], !1, Ie, nn) && c--, (c < k || Q.length) && N.replaceChildren(c, k, Q);
    }
  }
  function je(N, c, m, k, M, Q) {
    let pe = N.childCursor(), { i: Ie, off: nn } = pe.findPos(m, 1), { i: Xe, off: cn } = pe.findPos(c, -1);
    c -= m;
    for (let kn of k) c += kn.length;
    N.length += c, $e(N, Xe, cn, Ie, nn, k, 0, M, Q);
  }
  function E(N, c, m) {
    let k = N.nodeValue.length;
    c > k && (c = k);
    let M = c, Q = c, pe = 0;
    return c == 0 && 0 > m || c == k && 0 <= m ? X.chrome || X.gecko || (c ? (M--, pe = 1) : Q < k && (Q++, pe = -1)) : 0 > m ? M-- : Q < k && Q++, N = L(N, M, Q).getClientRects(), N.length ? (m = N[(pe ? 0 > pe : 0 <= m) ? 0 : N.length - 1], X.safari && !pe && m.width == 0 && (m = Array.prototype.find.call(N, (Ie) => Ie.width) || m), pe ? _(m, 0 > pe) : m || null) : null;
  }
  function P(N, c) {
    let m = N.dom;
    ({ children: N } = N);
    for (var k = 0, M = 0; k < N.length; k++) {
      let Q = N[k], pe = M + Q.length;
      if (!(pe == M && 0 >= Q.getSide())) {
        if (c > M && c < pe && Q.dom.parentNode == m) return Q.domAtPos(c - M);
        if (c <= M) break;
        M = pe;
      }
    }
    for (c = k; 0 < c; c--) if (M = N[c - 1], M.dom.parentNode == m) return M.domAtPos(M.length);
    for (; k < N.length; k++) if (c = N[k], c.dom.parentNode == m) return c.domAtPos(0);
    return new Ji(m, 0);
  }
  function K(N, c, m) {
    let k, { children: M } = N;
    0 < m && c instanceof $n && M.length && (k = M[M.length - 1]) instanceof $n && k.mark.eq(c.mark) ? K(k, c.children[0], m - 1) : (M.push(c), c.setParent(N)), N.length += c.length;
  }
  function H(N, c, m) {
    function k(nn, Xe) {
      for (let cn = 0, kn = 0; cn < nn.children.length && kn <= Xe; cn++) {
        let jn = nn.children[cn], Pn = kn + jn.length;
        Pn >= Xe && (jn.children.length ? k(jn, Xe - kn) : (!pe || pe.isHidden && 0 < m) && (Pn > Xe || kn == Pn && 0 < jn.getSide()) ? (pe = jn, Ie = Xe - kn) : (kn < Xe || kn == Pn && 0 > jn.getSide() && !jn.isHidden) && (M = jn, Q = Xe - kn)), kn = Pn;
      }
    }
    let M = null, Q = -1, pe = null, Ie = -1;
    return k(N, c), (c = (0 > m ? M : pe) || M || pe) ? c.coordsAt(Math.max(0, c == M ? Q : Ie), m) : U(N);
  }
  function U(N) {
    let c = N.dom.lastChild;
    return c ? (N = a(c), N[N.length - 1] || null) : N.dom.getBoundingClientRect();
  }
  function Me(N, c) {
    for (let m in N) m == "class" && c.class ? c.class += " " + N.class : m == "style" && c.style ? c.style += ";" + N.style : c[m] = N[m];
    return c;
  }
  function le(N, c, m) {
    if (N == c) return !0;
    N ||= Oe, c ||= Oe;
    let k = Object.keys(N), M = Object.keys(c);
    if (k.length - (m && -1 < k.indexOf(m) ? 1 : 0) != M.length - (m && -1 < M.indexOf(m) ? 1 : 0)) return !1;
    for (let Q of k) if (Q != m && (M.indexOf(Q) == -1 || N[Q] !== c[Q])) return !1;
    return !0;
  }
  function Ce(N, c, m) {
    let k = !1;
    if (c) for (let M in c) m && M in m || (k = !0, M == "style" ? N.style.cssText = "" : N.removeAttribute(M));
    if (m) for (let M in m) c && c[M] == m[M] || (k = !0, M == "style" ? N.style.cssText = m[M] : N.setAttribute(M, m[M]));
    return k;
  }
  function Ye(N, c = !1) {
    let { inclusiveStart: m, inclusiveEnd: k } = N;
    return m == null && (m = N.inclusive), k == null && (k = N.inclusive), { start: m ?? c, end: k ?? c };
  }
  function B(N, c, m, k = 0) {
    let M = m.length - 1;
    0 <= M && m[M] + k >= N ? m[M] = Math.max(m[M], c) : m.push(N, c);
  }
  function q(N, c) {
    for (let m of c) N = new $n(m, [N], N.length);
    return N;
  }
  function me(N, c, m) {
    N = N.facet($r), N.length ? N[0](c) : window.onerror ? window.onerror(String(c), m, void 0, void 0, c) : m ? console.error(m + ":", c) : console.error(c);
  }
  function Ae(N, c, m) {
    var k = N.state.facet(Kc);
    if (!k.length) return k;
    k = k.map((Q) => Q instanceof Function ? Q(N) : Q);
    let M = [];
    return Wn.RangeSet.spans(k, c, m, { point() {
    }, span(Q, pe, Ie, nn) {
      let Xe = M;
      for (let kn = Ie.length - 1; 0 <= kn; kn--, nn--) {
        var cn = Ie[kn].spec.bidiIsolate;
        let jn;
        cn != null && (0 < nn && Xe.length && (jn = Xe[Xe.length - 1]).to == Q && jn.direction == cn ? (jn.to = pe, Xe = jn.inner) : (cn = { from: Q, to: pe, direction: cn, inner: [] }, Xe.push(cn), Xe = cn.inner));
      }
    } }), M;
  }
  function Fe(N) {
    let c = 0, m = 0, k = 0, M = 0;
    for (let Q of N.state.facet(Pp)) {
      let pe = Q(N);
      pe && (pe.left != null && (c = Math.max(c, pe.left)), pe.right != null && (m = Math.max(m, pe.right)), pe.top != null && (k = Math.max(k, pe.top)), pe.bottom != null && (M = Math.max(M, pe.bottom)));
    }
    return { left: c, right: m, top: k, bottom: M };
  }
  function ln(N) {
    let c = [];
    for (let m = 0; m < N.length; m++) c.push(1 << +N[m]);
    return c;
  }
  function Be(N, c) {
    if (N.length != c.length) return !1;
    for (let m = 0; m < N.length; m++) {
      let k = N[m], M = c[m];
      if (k.from != M.from || k.to != M.to || k.direction != M.direction || !Be(k.inner, M.inner)) return !1;
    }
    return !0;
  }
  function Ze(N, c, m, k, M, Q, pe) {
    let Ie = k % 2 ? 2 : 1;
    if (k % 2 == M % 2) for (let Pn = c, Ct = 0; Pn < m; ) {
      c = !0;
      var nn = !1;
      if (Ct == Q.length || Pn < Q[Ct].from) {
        var Xe = Kl[Pn];
        Xe != Ie && (c = !1, nn = Xe == 16);
      }
      Xe = c || Ie != 1 ? null : [];
      var cn = c ? k : k + 1, kn = Pn;
      e: for (; ; ) if (Ct < Q.length && kn == Q[Ct].from) {
        if (nn) break e;
        var jn = Q[Ct];
        if (!c) for (let Wt = jn.to, Mt = Ct + 1; ; ) {
          if (Wt == m) break e;
          if (Mt < Q.length && Q[Mt].from == Wt) Wt = Q[Mt++].to;
          else {
            if (Kl[Wt] == Ie) break e;
            break;
          }
        }
        Ct++, Xe ? Xe.push(jn) : (jn.from > Pn && pe.push(new bo(Pn, jn.from, cn)), pn(N, jn.direction == Wu != !(cn % 2) ? k + 1 : k, M, jn.inner, jn.from, jn.to, pe), Pn = jn.to), kn = jn.to;
      } else {
        if (kn == m || (c ? Kl[kn] != Ie : Kl[kn] == Ie)) break;
        kn++;
      }
      Xe ? Ze(N, Pn, kn, k + 1, M, Xe, pe) : Pn < kn && pe.push(new bo(Pn, kn, cn)), Pn = kn;
    }
    else for (let Pn = m, Ct = Q.length; Pn > c; ) {
      m = !0, nn = !1, (!Ct || Pn > Q[Ct - 1].to) && (Xe = Kl[Pn - 1], Xe != Ie && (m = !1, nn = Xe == 16)), Xe = m || Ie != 1 ? null : [], cn = m ? k : k + 1, kn = Pn;
      e: for (; ; ) if (Ct && kn == Q[Ct - 1].to) {
        if (nn) break e;
        if (jn = Q[--Ct], !m) for (let Wt = jn.from, Mt = Ct; ; ) {
          if (Wt == c) break e;
          if (Mt && Q[Mt - 1].to == Wt) Wt = Q[--Mt].from;
          else {
            if (Kl[Wt - 1] == Ie) break e;
            break;
          }
        }
        Xe ? Xe.push(jn) : (jn.to < Pn && pe.push(new bo(jn.to, Pn, cn)), pn(
          N,
          jn.direction == Wu != !(cn % 2) ? k + 1 : k,
          M,
          jn.inner,
          jn.from,
          jn.to,
          pe
        ), Pn = jn.from), kn = jn.from;
      } else {
        if (kn == c || (m ? Kl[kn - 1] != Ie : Kl[kn - 1] == Ie)) break;
        kn--;
      }
      Xe ? Ze(N, kn, Pn, k + 1, M, Xe, pe) : kn < Pn && pe.push(new bo(kn, Pn, cn)), Pn = kn;
    }
  }
  function pn(N, c, m, k, M, Q, pe) {
    let Ie = c % 2 ? 2 : 1;
    for (var nn = 0; nn <= k.length; nn++) {
      var Xe = nn ? k[nn - 1].to : M, cn = nn < k.length ? k[nn].from : Q, kn = nn ? 256 : Ie;
      for (let Pn = Xe, Ct = kn, Wt = kn; Pn < cn; Pn++) {
        var jn = N.charCodeAt(Pn);
        jn = 247 >= jn ? ko[jn] : 1424 <= jn && 1524 >= jn ? 2 : 1536 <= jn && 1785 >= jn ? R1[jn - 1536] : 1774 <= jn && 2220 >= jn ? 4 : 8192 <= jn && 8203 >= jn ? 256 : 64336 <= jn && 65023 >= jn ? 4 : jn == 8204 ? 256 : 1, jn == 512 ? jn = Ct : jn == 8 && Wt == 4 && (jn = 16), Kl[Pn] = jn == 4 ? 2 : jn, jn & 7 && (Wt = jn), Ct = jn;
      }
      for (let Pn = Xe, Ct = kn, Wt = kn; Pn < cn; Pn++) {
        if (Xe = Kl[Pn], Xe == 128) Pn < cn - 1 && Ct == Kl[Pn + 1] && Ct & 24 ? Xe = Kl[Pn] = Ct : Kl[Pn] = 256;
        else if (Xe == 64) {
          for (kn = Pn + 1; kn < cn && Kl[kn] == 64; ) kn++;
          jn = Pn && Ct == 8 || kn < Q && Kl[kn] == 8 ? Wt == 1 ? 1 : 8 : 256;
          for (let Mt = Pn; Mt < kn; Mt++) Kl[Mt] = jn;
          Pn = kn - 1;
        } else Xe == 8 && Wt == 1 && (Kl[Pn] = 1);
        Ct = Xe, Xe & 7 && (Wt = Xe);
      }
    }
    nn = Ie == 1 ? 2 : 1;
    for (let Pn = 0, Ct = 0, Wt = 0; Pn <= k.length; Pn++) {
      Xe = Pn ? k[Pn - 1].to : M, cn = Pn < k.length ? k[Pn].from : Q;
      for (let Mt = Xe, wl, rl, _i; Mt < cn; Mt++) if (rl = ad[wl = N.charCodeAt(Mt)]) if (0 > rl) {
        for (Xe = Ct - 3; 0 <= Xe; Xe -= 3)
          if (Hu[Xe + 1] == -rl) {
            kn = Hu[Xe + 2], (kn = kn & 2 ? Ie : kn & 4 ? kn & 1 ? nn : Ie : 0) && (Kl[Mt] = Kl[Hu[Xe]] = kn), Ct = Xe;
            break;
          }
      } else {
        if (Hu.length == 189) break;
        Hu[Ct++] = Mt, Hu[Ct++] = wl, Hu[Ct++] = Wt;
      }
      else if ((_i = Kl[Mt]) == 2 || _i == 1) for (Wt = (Xe = _i == Ie) ? 0 : 1, kn = Ct - 3; 0 <= kn && (jn = Hu[kn + 2], !(jn & 2)); kn -= 3)
        if (Xe) Hu[kn + 2] |= 2;
        else {
          if (jn & 4) break;
          Hu[kn + 2] |= 4;
        }
    }
    for (let Pn = 0, Ct = Ie; Pn <= k.length; Pn++) for (cn = Pn ? k[Pn - 1].to : M, nn = Pn < k.length ? k[Pn].from : Q; cn < nn; ) if (Xe = Kl[cn], Xe == 256) {
      for (Xe = cn + 1; ; ) if (Xe == nn) {
        if (Pn == k.length) break;
        Xe = k[Pn++].to, nn = Pn < k.length ? k[Pn].from : Q;
      } else if (Kl[Xe] == 256) Xe++;
      else break;
      kn = Ct == 1, kn = kn == ((Xe < Q ? Kl[Xe] : Ie) == 1) ? kn ? 1 : 2 : Ie;
      for (let Wt = Xe, Mt = Pn, wl = Mt ? k[Mt - 1].to : M; Wt > cn; ) Wt == wl && (Wt = k[--Mt].from, wl = Mt ? k[Mt - 1].to : M), Kl[--Wt] = kn;
      cn = Xe;
    } else Ct = Xe, cn++;
    Ze(N, M, Q, c, m, k, pe);
  }
  function xn(N, c, m) {
    if (!N) return [new bo(0, 0, c == Ig ? 1 : 0)];
    if (c == Wu && !m.length && !cd.test(N)) return [new bo(0, N.length, 0)];
    if (m.length) for (; N.length > Kl.length; ) Kl[Kl.length] = 256;
    let k = [];
    return c = c == Wu ? 0 : 1, pn(N, c, c, m, 0, N.length, k), k;
  }
  function Nn(N, c, m, k, M) {
    var Q;
    let pe = k.head - N.from, Ie = -1;
    if (pe == 0) {
      if (!M || !N.length) return null;
      c[0].level != m && (pe = c[0].side(!1, m), Ie = 0);
    } else if (pe == N.length) {
      if (M) return null;
      var nn = c[c.length - 1];
      nn.level != m && (pe = nn.side(!0, m), Ie = c.length - 1);
    }
    return 0 > Ie && (Ie = bo.find(c, pe, (Q = k.bidiLevel) !== null && Q !== void 0 ? Q : -1, k.assoc)), k = c[Ie], pe == k.side(M, m) && (k = c[Ie += M ? 1 : -1], pe = k.side(!M, m)), nn = M == (k.dir == m), Q = Wn.findClusterBreak(N.text, pe, nn), Ba = N.text.slice(Math.min(pe, Q), Math.max(pe, Q)), Q != k.side(M, m) ? Wn.EditorSelection.cursor(Q + N.from, nn ? -1 : 1, k.level) : (c = Ie == (M ? c.length - 1 : 0) ? null : c[Ie + (M ? 1 : -1)]) || k.level == m ? c && c.level < k.level ? Wn.EditorSelection.cursor(c.side(!M, m) + N.from, M ? 1 : -1, c.level) : Wn.EditorSelection.cursor(Q + N.from, M ? -1 : 1, k.level) : Wn.EditorSelection.cursor(M ? N.to : N.from, M ? -1 : 1, m);
  }
  function at(N, c) {
    return N = N.observer.selectionRange, N = N.focusNode && jt(N.focusNode, N.focusOffset, 0), N ? (c -= N.offset, { from: c, to: c + N.node.nodeValue.length, node: N.node }) : null;
  }
  function Yt(N, c, m) {
    if (m = at(N, m), !m) return null;
    let { node: k, from: M, to: Q } = m;
    var pe = k.nodeValue;
    if (/[\n\r]/.test(pe) || N.state.doc.sliceString(m.from, m.to) != pe) return null;
    for (c = c.invertedDesc, c = new zs(c.mapPos(M), c.mapPos(Q), M, Q), m = [], pe = k.parentNode; ; pe = pe.parentNode) {
      var Ie = li.get(pe);
      if (Ie instanceof $n) m.push({ node: pe, deco: Ie.mark });
      else {
        if (Ie instanceof Ke || pe.nodeName == "DIV" && pe.parentNode == N.contentDOM) return { range: c, text: k, marks: m, line: pe };
        if (pe != N.contentDOM) {
          Ie = m;
          var nn = Ie.push, Xe = pe, cn = pe;
          let kn = /* @__PURE__ */ Object.create(null);
          for (let jn = 0; jn < cn.attributes.length; jn++) {
            let Pn = cn.attributes[jn];
            kn[Pn.name] = Pn.value;
          }
          nn.call(
            Ie,
            { node: Xe, deco: new An({ inclusive: !0, attributes: kn, tagName: pe.tagName.toLowerCase() }) }
          );
        } else return null;
      }
    }
  }
  function jt(N, c, m) {
    if (0 >= m) for (let k = N, M = c; ; ) {
      if (k.nodeType == 3) return { node: k, offset: M };
      if (k.nodeType == 1 && 0 < M) k = k.childNodes[M - 1], M = p(k);
      else break;
    }
    if (0 <= m) for (let k = N, M = c; ; ) {
      if (k.nodeType == 3) return { node: k, offset: M };
      if (k.nodeType == 1 && M < k.childNodes.length && 0 <= m) k = k.childNodes[M], M = 0;
      else break;
    }
    return null;
  }
  function Cl(N, c, m) {
    let k = new $p();
    return Wn.RangeSet.compare(N, c, m, k), k.changes;
  }
  function fn(N, c) {
    let m = !1;
    return c && N.iterChangedRanges((k, M) => {
      k < c.to && M > c.from && (m = !0);
    }), m;
  }
  function _e(N, c, m = 1) {
    let k = N.charCategorizer(c);
    N = N.doc.lineAt(c);
    var M = c - N.from;
    if (N.length == 0) return Wn.EditorSelection.cursor(c);
    M == 0 ? m = 1 : M == N.length && (m = -1);
    let Q = c = M;
    for (0 > m ? c = Wn.findClusterBreak(N.text, M, !1) : Q = Wn.findClusterBreak(N.text, M), m = k(N.text.slice(c, Q)); 0 < c && (M = Wn.findClusterBreak(N.text, c, !1), k(N.text.slice(M, c)) == m); )
      c = M;
    for (; Q < N.length && (M = Wn.findClusterBreak(N.text, Q), k(N.text.slice(Q, M)) == m); )
      Q = M;
    return Wn.EditorSelection.range(c + N.from, Q + N.from);
  }
  function Ve(N, c) {
    return N.top < c.bottom - 1 && N.bottom > c.top + 1;
  }
  function an(N, c) {
    return c < N.top ? { top: c, left: N.left, right: N.right, bottom: N.bottom } : N;
  }
  function En(N, c) {
    return c > N.bottom ? { top: N.top, left: N.left, right: N.right, bottom: c } : N;
  }
  function Qn(N, c, m) {
    let k, M, Q;
    var pe = !1;
    let Ie, nn, Xe, cn;
    for (let jn = N.firstChild; jn; jn = jn.nextSibling) {
      let Pn = a(jn);
      for (let Ct = 0; Ct < Pn.length; Ct++) {
        let Wt = Pn[Ct];
        M && Ve(M, Wt) && (Wt = an(En(Wt, M.bottom), M.top));
        let Mt = Wt.left > c ? Wt.left - c : Math.max(0, c - Wt.right), wl = Wt.top > m ? Wt.top - m : Math.max(0, m - Wt.bottom);
        if (Mt == 0 && wl == 0) return jn.nodeType == 3 ? Vn(jn, c, m) : Qn(jn, c, m);
        if (!k || Q > wl || Q == wl && kn > Mt) {
          k = jn, M = Wt;
          var kn = Mt;
          pe = (Q = wl) ? m < Wt.top ? -1 : 1 : Mt ? c < Wt.left ? -1 : 1 : 0, pe = !pe || (0 < pe ? Ct < Pn.length - 1 : 0 < Ct);
        }
        Mt == 0 ? m > Wt.bottom && (!Xe || Xe.bottom < Wt.bottom) ? (Ie = jn, Xe = Wt) : m < Wt.top && (!cn || cn.top > Wt.top) && (nn = jn, cn = Wt) : Xe && Ve(Xe, Wt) ? Xe = En(Xe, Wt.bottom) : cn && Ve(cn, Wt) && (cn = an(cn, Wt.top));
      }
    }
    return Xe && Xe.bottom >= m ? (k = Ie, M = Xe) : cn && cn.top <= m && (k = nn, M = cn), k ? (kn = Math.max(M.left, Math.min(M.right, c)), k.nodeType == 3 ? Vn(k, kn, m) : pe && k.contentEditable != "false" ? Qn(k, kn, m) : (c = Array.prototype.indexOf.call(N.childNodes, k) + (c >= (M.left + M.right) / 2 ? 1 : 0), { node: N, offset: c })) : { node: N, offset: 0 };
  }
  function Vn(N, c, m) {
    let k = N.nodeValue.length;
    var M = -1, Q = 1e9;
    let pe = 0;
    for (let Ie = 0; Ie < k; Ie++) {
      let nn = L(N, Ie, Ie + 1).getClientRects();
      for (let Xe = 0; Xe < nn.length; Xe++) {
        let cn = nn[Xe];
        if (cn.top == cn.bottom) continue;
        pe ||= c - cn.left;
        let kn = (cn.top > m ? cn.top - m : m - cn.bottom) - 1;
        if (cn.left - 1 <= c && cn.right + 1 >= c && kn < Q) {
          if (Q = M = c >= (cn.left + cn.right) / 2, (X.chrome || X.gecko) && L(N, Ie).getBoundingClientRect().left == cn.right && (Q = !M), 0 >= kn) return { node: N, offset: Ie + (Q ? 1 : 0) };
          M = Ie + (Q ? 1 : 0), Q = kn;
        }
      }
    }
    return { node: N, offset: -1 < M ? M : 0 < pe ? N.nodeValue.length : 0 };
  }
  function ot(N, c, m, k = -1) {
    var M, Q, pe = N.contentDOM.getBoundingClientRect(), Ie = pe.top + N.viewState.paddingTop;
    let nn;
    var { docHeight: Xe } = N.viewState;
    let { x: cn, y: kn } = c, jn = kn - Ie;
    if (0 > jn) return 0;
    if (jn > Xe) return N.state.doc.length;
    for (let Wt = N.viewState.heightOracle.textHeight / 2, Mt = !1; nn = N.elementAtHeight(jn), nn.type != l.BlockType.Text; )
      for (; jn = 0 < k ? nn.bottom + Wt : nn.top - Wt, !(0 <= jn && jn <= Xe); ) {
        if (Mt) return m ? null : 0;
        Mt = !0, k = -k;
      }
    if (kn = Ie + jn, k = nn.from, k < N.viewport.from) return N.viewport.from == 0 ? 0 : m ? null : Nt(N, pe, nn, cn, kn);
    if (k > N.viewport.to) return N.viewport.to == N.state.doc.length ? N.state.doc.length : m ? null : Nt(N, pe, nn, cn, kn);
    m = N.dom.ownerDocument, Xe = N.root.elementFromPoint ? N.root : m, (Ie = Xe.elementFromPoint(cn, kn)) && !N.contentDOM.contains(Ie) && (Ie = null), Ie || (cn = Math.max(pe.left + 1, Math.min(pe.right - 1, cn)), (Ie = Xe.elementFromPoint(cn, kn)) && !N.contentDOM.contains(Ie) && (Ie = null));
    var Pn;
    if (pe = -1, Ie && ((M = N.docView.nearest(Ie)) === null || M === void 0 ? void 0 : M.isEditable) != 0) {
      if (m.caretPositionFromPoint) {
        var Ct = m.caretPositionFromPoint(cn, kn);
        Ct && ({ offsetNode: Pn, offset: pe } = Ct);
      } else if (m.caretRangeFromPoint && (M = m.caretRangeFromPoint(cn, kn))) {
        if ({ startContainer: Pn, startOffset: pe } = M, !(M = !N.contentDOM.contains(Pn)) && (M = X.safari)) e: if (M = cn, Pn.nodeType != 3 || pe != (Ct = Pn.nodeValue.length)) M = !1;
        else {
          for (m = Pn.nextSibling; m; m = m.nextSibling) if (m.nodeType != 1 || m.nodeName != "BR") {
            M = !1;
            break e;
          }
          M = L(Pn, Ct - 1, Ct).getBoundingClientRect().left > M;
        }
        if (!(Ct = M) && (Ct = X.chrome)) e: if (M = Pn, Ct = cn, pe != 0) Ct = !1;
        else {
          for (m = M; ; ) {
            if (Ie = m.parentNode, !Ie || Ie.nodeType != 1 || Ie.firstChild != m) {
              Ct = !1;
              break e;
            }
            if (Ie.classList.contains("cm-line")) break;
            m = Ie;
          }
          M = M.nodeType == 1 ? M.getBoundingClientRect() : L(M, 0, Math.max(M.nodeValue.length, 1)).getBoundingClientRect(), Ct = 5 < Ct - M.left;
        }
        Ct && (Pn = void 0);
      }
    }
    if (!Pn || !N.docView.dom.contains(Pn)) {
      if (Pn = Ke.find(N.docView, k), !Pn) return jn > nn.top + nn.height / 2 ? nn.to : nn.from;
      ({ node: Pn, offset: pe } = Qn(Pn.dom, cn, kn));
    }
    return N = N.docView.nearest(Pn), N ? N.isWidget && ((Q = N.dom) === null || Q === void 0 ? void 0 : Q.nodeType) == 1 ? (Q = N.dom.getBoundingClientRect(), c.y < Q.top || c.y <= Q.bottom && c.x <= (Q.left + Q.right) / 2 ? N.posAtStart : N.posAtEnd) : N.localPosFromDOM(Pn, pe) + N.posAtStart : null;
  }
  function Nt(N, c, m, k, M) {
    return c = Math.round((k - c.left) * N.defaultCharacterWidth), N.lineWrapping && m.height > 1.5 * N.defaultLineHeight && (k = N.viewState.heightOracle.textHeight, c += Math.floor((M - m.top - 0.5 * (N.defaultLineHeight - k)) / k) * N.viewState.heightOracle.lineLength), M = N.state.sliceDoc(m.from, m.to), m.from + Wn.findColumn(M, c, N.state.tabSize);
  }
  function zt(N, c) {
    if (N = N.lineBlockAt(c), Array.isArray(N.type)) {
      for (let m of N.type) if (m.to > c || m.to == c && (m.to == N.to || m.type == l.BlockType.Text)) return m;
    }
    return N;
  }
  function Pt(N, c, m, k) {
    let M = N.state.doc.lineAt(c.head), Q = N.bidiSpans(M), pe = N.textDirectionAt(M.from);
    for (let Ie = c, nn = null; ; ) {
      c = Nn(M, Q, pe, Ie, m);
      let Xe = Ba;
      if (!c) {
        if (M.number == (m ? N.state.doc.lines : 1)) return Ie;
        Xe = `
`, M = N.state.doc.line(M.number + (m ? 1 : -1)), Q = N.bidiSpans(M), c = Wn.EditorSelection.cursor(m ? M.from : M.to);
      }
      if (nn) {
        if (!nn(Xe)) return Ie;
      } else {
        if (!k) return c;
        nn = k(Xe);
      }
      Ie = c;
    }
  }
  function ol(N, c, m) {
    let k = N.state.charCategorizer(c), M = k(m);
    return (Q) => (Q = k(Q), M == Wn.CharCategory.Space && (M = Q), M == Q);
  }
  function St(N, c, m) {
    for (; ; ) {
      let k = 0;
      for (let M of N) M.between(c - 1, c + 1, (Q, pe, Ie) => {
        c > Q && c < pe && (Ie = k || m || (c - Q < pe - c ? -1 : 1), c = 0 > Ie ? Q : pe, k = Ie);
      });
      if (!k) return c;
    }
  }
  function pr(N, c, m) {
    return c = St(N.state.facet(od).map((k) => k(N)), m.from, c.head > m.from ? -1 : 1), c == m.from ? m : Wn.EditorSelection.cursor(c, c < m.from ? 1 : -1);
  }
  function ul(N, c) {
    return (m, k) => {
      try {
        return c.call(N, k, m);
      } catch (M) {
        me(m.state, M);
      }
    };
  }
  function Rr(N) {
    function c(M) {
      return m[M] || (m[M] = { observers: [], handlers: [] });
    }
    let m = /* @__PURE__ */ Object.create(null);
    for (let M of N) {
      if ((N = M.spec) && N.domEventHandlers) for (let Q in N.domEventHandlers) {
        var k = N.domEventHandlers[Q];
        k && c(Q).handlers.push(ul(M.value, k));
      }
      if (N && N.domEventObservers) for (let Q in N.domEventObservers) (k = N.domEventObservers[Q]) && c(Q).observers.push(ul(
        M.value,
        k
      ));
    }
    for (let M in ro) c(M).handlers.push(ro[M]);
    for (let M in ds) c(M).observers.push(ds[M]);
    return m;
  }
  function ql(N, c) {
    return N = N.state.facet(hi), N.length ? N[0](c) : X.mac ? c.metaKey : c.ctrlKey;
  }
  function Mr(N, c) {
    var { main: m } = N.state.selection;
    if (m.empty) return !1;
    if (N = r(N.root), !N || N.rangeCount == 0) return !0;
    for (N = N.getRangeAt(0).getClientRects(), m = 0; m < N.length; m++) {
      let k = N[m];
      if (k.left <= c.clientX && k.right >= c.clientX && k.top <= c.clientY && k.bottom >= c.clientY) return !0;
    }
    return !1;
  }
  function wi(N, c) {
    if (!c.bubbles) return !0;
    if (c.defaultPrevented) return !1;
    for (let m = c.target, k; m != N.contentDOM; m = m.parentNode) if (!m || m.nodeType == 11 || (k = li.get(m)) && k.ignoreEvent(c)) return !1;
    return !0;
  }
  function bl(N) {
    let c = N.dom.parentNode;
    if (c) {
      var m = c.appendChild(document.createElement("textarea"));
      m.style.cssText = "position: fixed; left: -10000px; top: 10px", m.focus(), setTimeout(() => {
        N.focus(), m.remove(), tl(N, m.value);
      }, 50);
    }
  }
  function tl(N, c) {
    let { state: m } = N, k, M = 1, Q = m.toText(c), pe = Q.lines == m.selection.ranges.length;
    if (pd != null && m.selection.ranges.every((Ie) => Ie.empty) && pd == Q.toString()) {
      let Ie = -1;
      k = m.changeByRange((nn) => {
        let Xe = m.doc.lineAt(nn.from);
        if (Xe.from == Ie) return { range: nn };
        Ie = Xe.from;
        let cn = m.toText((pe ? Q.line(M++).text : c) + m.lineBreak);
        return { changes: { from: Xe.from, insert: cn }, range: Wn.EditorSelection.cursor(nn.from + cn.length) };
      });
    } else k = pe ? m.changeByRange((Ie) => {
      let nn = Q.line(M++);
      return { changes: { from: Ie.from, to: Ie.to, insert: nn.text }, range: Wn.EditorSelection.cursor(Ie.from + nn.length) };
    }) : m.replaceSelection(Q);
    N.dispatch(k, { userEvent: "input.paste", scrollIntoView: !0 });
  }
  function Zt(N, c, m, k) {
    return k == 1 ? Wn.EditorSelection.cursor(c, m) : k == 2 ? _e(N.state, c, m) : (m = Ke.find(N.docView, c), c = N.state.doc.lineAt(m ? m.posAtEnd : c), k = m ? m.posAtStart : c.from, m = m ? m.posAtEnd : c.to, m < N.state.doc.length && m == c.to && m++, Wn.EditorSelection.range(k, m));
  }
  function Ql(N, c) {
    let m = N.posAtCoords({ x: c.clientX, y: c.clientY }, !1);
    {
      var k = c.clientX;
      c = c.clientY;
      let pe = Ke.find(N.docView, m);
      if (pe) {
        var M = m - pe.posAtStart;
        if (M == 0) k = 1;
        else if (M == pe.length) k = -1;
        else {
          N = pe.coordsAt(M, -1);
          var Q;
          (Q = N) && (Q = c >= N.top && c <= N.bottom && k >= N.left && k <= N.right), Q ? k = -1 : ((Q = M = pe.coordsAt(M, 1)) && (Q = c >= M.top && c <= M.bottom && k >= M.left && k <= M.right), k = Q ? 1 : N && c >= N.top && c <= N.bottom ? -1 : 1);
        }
      } else k = 1;
    }
    return { pos: m, bias: k };
  }
  function jl(N) {
    if (!Pg) return N.detail;
    let c = Bp, m = dd;
    return Bp = N, dd = Date.now(), fd = !c || m > Date.now() - 400 && 2 > Math.abs(c.clientX - N.clientX) && 2 > Math.abs(c.clientY - N.clientY) ? (fd + 1) % 3 : 1;
  }
  function Sl(N, c) {
    let m = Ql(N, c), k = jl(c), M = N.state.selection;
    return { update(Q) {
      Q.docChanged && (m.pos = Q.changes.mapPos(m.pos), M = M.map(Q.changes));
    }, get(Q, pe, Ie) {
      var nn = Ql(N, Q);
      if (Q = Zt(N, nn.pos, nn.bias, k), m.pos != nn.pos && !pe) {
        var Xe = Zt(N, m.pos, m.bias, k);
        let kn = Math.min(Xe.from, Q.from);
        Xe = Math.max(Xe.to, Q.to), Q = kn < Q.from ? Wn.EditorSelection.range(kn, Xe) : Wn.EditorSelection.range(Xe, kn);
      }
      if (pe) return M.replaceRange(M.main.extend(Q.from, Q.to));
      if (pe = Ie && k == 1 && 1 < M.ranges.length) {
        e: {
          var cn = M;
          for (nn = nn.pos, pe = 0; pe < cn.ranges.length; pe++) {
            let { from: kn, to: jn } = cn.ranges[pe];
            if (kn <= nn && jn >= nn) {
              nn = Wn.EditorSelection.create(cn.ranges.slice(0, pe).concat(cn.ranges.slice(pe + 1)), cn.mainIndex == pe ? 0 : cn.mainIndex - (cn.mainIndex > pe ? 1 : 0));
              break e;
            }
          }
          nn = null;
        }
        pe = cn = nn;
      }
      return pe ? cn : Ie ? M.addRange(Q) : Wn.EditorSelection.create([Q]);
    } };
  }
  function gl(N, c, m, k) {
    if (m) {
      var M = N.posAtCoords({ x: c.clientX, y: c.clientY }, !1), { mouseSelection: Q } = N.inputState;
      (k = k && Q && Q.dragging) && (k = N.state.facet(Oo), k = k.length ? k[0](c) : X.mac ? !c.altKey : !c.ctrlKey), c = k ? { from: Q.dragging.from, to: Q.dragging.to } : null, m = { from: M, insert: m }, m = N.state.changes(c ? [c, m] : m), N.focus(), N.dispatch({
        changes: m,
        selection: { anchor: m.mapPos(M, -1), head: m.mapPos(M, 1) },
        userEvent: c ? "move.drop" : "input.drop"
      });
    }
  }
  function jr(N, c) {
    let m = N.dom.parentNode;
    if (m) {
      var k = m.appendChild(document.createElement("textarea"));
      k.style.cssText = "position: fixed; left: -10000px; top: 10px", k.value = c, k.focus(), k.selectionEnd = c.length, k.selectionStart = 0, setTimeout(() => {
        k.remove(), N.focus();
      }, 50);
    }
  }
  function Kt(N, c) {
    let m = [];
    for (let k of N.facet(Tg)) {
      let M = k(N, c);
      M && m.push(M);
    }
    return m ? N.update({ effects: m, annotations: $g.of(!0) }) : null;
  }
  function nl(N) {
    setTimeout(() => {
      var c = N.hasFocus;
      c != N.inputState.notifiedFocused && ((c = Kt(N.state, c)) ? N.dispatch(c) : N.update([]));
    }, 10);
  }
  function Pr(N) {
    md.has(N) || (md.add(N), N.addEventListener("copy", () => {
    }), N.addEventListener("cut", () => {
    }));
  }
  function ii(N, c) {
    let m, k;
    N[c] == null && (m = N[c - 1]) instanceof Ks && (k = N[c + 1]) instanceof Ks && N.splice(c - 1, 3, new Ks(m.length + 1 + k.length));
  }
  function Ar(N, c, m) {
    let k = new dj();
    return Wn.RangeSet.compare(N, c, m, k, 0), k.changes;
  }
  function Ml(N, c) {
    let m = N.getBoundingClientRect(), k = N.ownerDocument;
    var M = k.defaultView || window;
    let Q = Math.max(0, m.left), pe = Math.min(
      M.innerWidth,
      m.right
    ), Ie = Math.max(0, m.top);
    M = Math.min(M.innerHeight, m.bottom);
    for (let nn = N.parentNode; nn && nn != k.body; ) if (nn.nodeType == 1) {
      let Xe = nn, cn = window.getComputedStyle(Xe);
      if ((Xe.scrollHeight > Xe.clientHeight || Xe.scrollWidth > Xe.clientWidth) && cn.overflow != "visible") {
        let kn = Xe.getBoundingClientRect();
        Q = Math.max(Q, kn.left), pe = Math.min(pe, kn.right), Ie = Math.max(Ie, kn.top), M = nn == N.parentNode ? kn.bottom : Math.min(M, kn.bottom);
      }
      nn = cn.position == "absolute" || cn.position == "fixed" ? Xe.offsetParent : Xe.parentNode;
    } else if (nn.nodeType == 11) nn = nn.host;
    else break;
    return { left: Q - m.left, right: Math.max(Q, pe) - m.left, top: Ie - (m.top + c), bottom: Math.max(Ie, M) - (m.top + c) };
  }
  function Rl(N, c) {
    return N = N.getBoundingClientRect(), { left: 0, right: N.right - N.left, top: c, bottom: N.bottom - (N.top + c) };
  }
  function Se(N, c, m) {
    let k = [], M = N, Q = 0;
    return Wn.RangeSet.spans(m, N, c, { span() {
    }, point(pe, Ie) {
      pe > M && (k.push({ from: M, to: pe }), Q += pe - M), M = Ie;
    } }, 20), M < c && (k.push({ from: M, to: c }), Q += c - M), { total: Q, ranges: k };
  }
  function se({ total: N, ranges: c }, m) {
    if (0 >= m) return c[0].from;
    if (1 <= m) return c[c.length - 1].to;
    for (N = Math.floor(N * m), m = 0; ; m++) {
      let { from: k, to: M } = c[m], Q = M - k;
      if (N <= Q) return k + N;
      N -= Q;
    }
  }
  function Ee(N, c) {
    let m = 0;
    for (let { from: k, to: M } of N.ranges) {
      if (c <= M) {
        m += c - k;
        break;
      }
      m += M - k;
    }
    return m / N.total;
  }
  function Ge(N, c) {
    for (let m of N) if (c(m)) return m;
  }
  function vn(N, c) {
    if (c.scale == 1) return N;
    let m = c.toDOM(N.top), k = c.toDOM(N.bottom);
    return new Gi(N.from, N.length, m, k - m, Array.isArray(N._content) ? N._content.map((M) => vn(M, c)) : N._content);
  }
  function Kn(N, c, m) {
    return new cs.StyleModule(c, { finish(k) {
      return /&/.test(k) ? k.replace(/&\w*/, (M) => {
        if (M == "&") return N;
        if (!m || !m[M]) throw new RangeError(`Unsupported selector: ${M}`);
        return m[M];
      }) : N + " " + k;
    } });
  }
  function Un(N) {
    return N.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(N.nodeName);
  }
  function Pe(N, c) {
    let m, { newSel: k } = c;
    var M = N.state.selection.main;
    let Q = N.inputState.lastKeyTime > Date.now() - 100 ? N.inputState.lastKeyCode : -1;
    if (c.bounds) {
      let { from: Ie, to: nn } = c.bounds;
      var pe = M.from;
      let Xe = null;
      (Q === 8 || X.android && c.text.length < nn - Ie) && (pe = M.to, Xe = "end"), (pe = re(N.state.doc.sliceString(
        Ie,
        nn,
        "￿"
      ), c.text, pe - Ie, Xe)) && (X.chrome && Q == 13 && pe.toB == pe.from + 2 && c.text.slice(pe.from, pe.toB) == "￿￿" && pe.toB--, m = { from: Ie + pe.from, to: Ie + pe.toA, insert: Wn.Text.of(c.text.slice(pe.from, pe.toB).split("￿")) });
    } else k && (!N.hasFocus && N.state.facet(gf) || k.main.eq(M)) && (k = null);
    if (!m && !k) return !1;
    if (!m && c.typeOver && !M.empty && k && k.main.empty ? m = { from: M.from, to: M.to, insert: N.state.doc.slice(M.from, M.to) } : m && m.from >= M.from && m.to <= M.to && (m.from != M.from || m.to != M.to) && 4 >= M.to - M.from - (m.to - m.from) ? m = { from: M.from, to: M.to, insert: N.state.doc.slice(
      M.from,
      m.from
    ).append(m.insert).append(N.state.doc.slice(m.to, M.to)) } : (X.mac || X.android) && m && m.from == m.to && m.from == M.head - 1 && /^\. ?$/.test(m.insert.toString()) && N.contentDOM.getAttribute("autocorrect") == "off" ? (k && m.insert.length == 2 && (k = Wn.EditorSelection.single(k.main.anchor - 1, k.main.head - 1)), m = { from: M.from, to: M.to, insert: Wn.Text.of([" "]) }) : X.chrome && m && m.from == m.to && m.from == M.head && m.insert.toString() == `
 ` && N.lineWrapping && (k &&= Wn.EditorSelection.single(k.main.anchor - 1, k.main.head - 1), m = {
      from: M.from,
      to: M.to,
      insert: Wn.Text.of([" "])
    }), m) {
      if (X.ios && N.inputState.flushIOSKey() || X.android && (m.from == M.from && m.to == M.to && m.insert.length == 1 && m.insert.lines == 2 && G(N.contentDOM, "Enter", 13) || (m.from == M.from - 1 && m.to == M.to && m.insert.length == 0 || Q == 8 && m.insert.length < m.to - m.from && m.to > M.head) && G(N.contentDOM, "Backspace", 8) || m.from == M.from && m.to == M.to + 1 && m.insert.length == 0 && G(N.contentDOM, "Delete", 46))) return !0;
      let Ie = m.insert.toString();
      0 <= N.inputState.composing && N.inputState.composing++;
      let nn, Xe = () => nn ||= C(N, m, k);
      return N.state.facet(bh).some((cn) => cn(N, m.from, m.to, Ie, Xe)) || N.dispatch(Xe()), !0;
    }
    return k && !k.main.eq(M) ? (c = !1, M = "select", N.inputState.lastSelectionTime > Date.now() - 50 && (N.inputState.lastSelectionOrigin == "select" && (c = !0), M = N.inputState.lastSelectionOrigin), N.dispatch({ selection: k, scrollIntoView: c, userEvent: M }), !0) : !1;
  }
  function C(N, c, m) {
    let k = N.state, M = k.selection.main;
    if (c.from >= M.from && c.to <= M.to && c.to - c.from >= (M.to - M.from) / 3 && (!m || m.main.empty && m.main.from == c.from + c.insert.length) && 0 > N.inputState.composing) {
      m = M.from < c.from ? k.sliceDoc(M.from, c.from) : "";
      var Q = M.to > c.to ? k.sliceDoc(c.to, M.to) : "";
      m = k.replaceSelection(N.state.toText(m + c.insert.sliceString(0, void 0, N.state.lineBreak) + Q));
    } else {
      let pe = k.changes(c), Ie = m && m.main.to <= pe.newLength ? m.main : void 0;
      if (1 < k.selection.ranges.length && 0 <= N.inputState.composing && c.to <= M.to && c.to >= M.to - 10) {
        let nn = N.state.sliceDoc(c.from, c.to), Xe;
        Xe = (m = m && at(N, m.main.head)) ? { from: m.from, to: m.to - (c.insert.length - (c.to - c.from)) } : N.state.doc.lineAt(M.head);
        let cn = M.to - c.to, kn = M.to - M.from;
        m = k.changeByRange((jn) => {
          if (jn.from == M.from && jn.to == M.to) return { changes: pe, range: Ie || jn.map(pe) };
          var Pn = jn.to - cn, Ct = Pn - nn.length;
          return jn.to - jn.from != kn || N.state.sliceDoc(Ct, Pn) != nn || jn.to >= Xe.from && jn.from <= Xe.to ? { range: jn } : (Pn = k.changes({ from: Ct, to: Pn, insert: c.insert }), Ct = jn.to - M.to, { changes: Pn, range: Ie ? Wn.EditorSelection.range(Math.max(0, Ie.anchor + Ct), Math.max(0, Ie.head + Ct)) : jn.map(Pn) });
        });
      } else m = { changes: pe, selection: Ie && k.selection.replaceRange(Ie) };
    }
    return Q = "input.type", (N.composing || N.inputState.compositionPendingChange && N.inputState.compositionEndedAt > Date.now() - 50) && (N.inputState.compositionPendingChange = !1, Q += ".compose", N.inputState.compositionFirstChange && (Q += ".start", N.inputState.compositionFirstChange = !1)), k.update(m, { userEvent: Q, scrollIntoView: !0 });
  }
  function re(N, c, m, k) {
    var M = Math.min(N.length, c.length);
    let Q = 0;
    for (; Q < M && N.charCodeAt(Q) == c.charCodeAt(Q); ) Q++;
    if (Q == M && N.length == c.length) return null;
    M = N.length;
    let pe = c.length;
    for (; 0 < M && 0 < pe && N.charCodeAt(M - 1) == c.charCodeAt(pe - 1); ) M--, pe--;
    return k == "end" && (m -= M + Math.max(
      0,
      Q - Math.min(M, pe)
    ) - Q), M < Q && N.length < c.length ? (Q -= m <= Q && m >= M ? Q - m : 0, pe = Q + (pe - M), M = Q) : pe < Q && (Q -= m <= Q && m >= pe ? Q - m : 0, M = Q + (M - pe), pe = Q), { from: Q, toA: M, toB: pe };
  }
  function ge(N, c, m) {
    for (; c; ) {
      var k = li.get(c);
      if (k && k.parent == N) return k;
      k = c.parentNode, c = k != N.dom ? k : 0 < m ? c.nextSibling : c.previousSibling;
    }
    return null;
  }
  function Z(N) {
    function c(Ie) {
      Ie.preventDefault(), Ie.stopImmediatePropagation(), m = Ie.getTargetRanges()[0];
    }
    let m = null;
    if (N.contentDOM.addEventListener("beforeinput", c, !0), N.dom.ownerDocument.execCommand("indent"), N.contentDOM.removeEventListener(
      "beforeinput",
      c,
      !0
    ), !m) return null;
    let k = m.startContainer, M = m.startOffset, Q = m.endContainer, pe = m.endOffset;
    return N = N.docView.domAtPos(N.state.selection.main.anchor), h(N.node, N.offset, Q, pe) && ([k, M, Q, pe] = [Q, pe, k, M]), { anchorNode: k, anchorOffset: M, focusNode: Q, focusOffset: pe };
  }
  function Y(N, c, m) {
    for (let k = N.state.facet(c), M = k.length - 1; 0 <= M; M--) c = k[M], (c = typeof c == "function" ? c(N) : c) && Me(c, m);
    return m;
  }
  function oe(N, c, m) {
    return c.altKey && (N = "Alt-" + N), c.ctrlKey && (N = "Ctrl-" + N), c.metaKey && (N = "Meta-" + N), m !== !1 && c.shiftKey && (N = "Shift-" + N), N;
  }
  function ke(N) {
    N = N.facet(yr);
    let c = vi.get(N);
    return c || vi.set(N, c = De(N.reduce((m, k) => m.concat(k), []))), c;
  }
  function De(N, c = pt) {
    let m = /* @__PURE__ */ Object.create(null), k = /* @__PURE__ */ Object.create(null), M = (Ie, nn) => {
      let Xe = k[Ie];
      if (Xe == null) k[Ie] = nn;
      else if (Xe != nn) throw Error("Key binding " + Ie + " is used both as a regular binding and as a multi-stroke prefix");
    }, Q = (Ie, nn, Xe, cn, kn) => {
      var jn, Pn, Ct = m[Ie] || (m[Ie] = /* @__PURE__ */ Object.create(null));
      nn = nn.split(/ (?!$)/).map((Wt) => {
        Wt = Wt.split(/-(?!$)/);
        let Mt = Wt[Wt.length - 1];
        Mt == "Space" && (Mt = " ");
        let wl, rl, _i, Ci;
        for (let Is = 0; Is < Wt.length - 1; ++Is) {
          const To = Wt[Is];
          if (/^(cmd|meta|m)$/i.test(To)) Ci = !0;
          else if (/^a(lt)?$/i.test(To)) wl = !0;
          else if (/^(c|ctrl|control)$/i.test(To)) rl = !0;
          else if (/^s(hift)?$/i.test(To)) _i = !0;
          else if (/^mod$/i.test(To)) c == "mac" ? Ci = !0 : rl = !0;
          else throw Error("Unrecognized modifier name: " + To);
        }
        return wl && (Mt = "Alt-" + Mt), rl && (Mt = "Ctrl-" + Mt), Ci && (Mt = "Meta-" + Mt), _i && (Mt = "Shift-" + Mt), Mt;
      });
      for (let Wt = 1; Wt < nn.length; Wt++) {
        let Mt = nn.slice(0, Wt).join(" ");
        M(Mt, !0), Ct[Mt] || (Ct[Mt] = {
          preventDefault: !0,
          stopPropagation: !1,
          run: [(wl) => {
            let rl = Zi = { view: wl, prefix: Mt, scope: Ie };
            return setTimeout(() => {
              Zi == rl && (Zi = null);
            }, 4e3), !0;
          }]
        });
      }
      nn = nn.join(" "), M(nn, !1), Ct = Ct[nn] || (Ct[nn] = { preventDefault: !1, stopPropagation: !1, run: ((Pn = (jn = Ct._any) === null || jn === void 0 ? void 0 : jn.run) === null || Pn === void 0 ? void 0 : Pn.slice()) || [] }), Xe && Ct.run.push(Xe), cn && (Ct.preventDefault = !0), kn && (Ct.stopPropagation = !0);
    };
    for (let Ie of N) {
      if (N = Ie.scope ? Ie.scope.split(" ") : ["editor"], Ie.any) for (let nn of N) {
        var pe = m[nn] || (m[nn] = /* @__PURE__ */ Object.create(null));
        pe._any || (pe._any = { preventDefault: !1, stopPropagation: !1, run: [] });
        for (let Xe in pe) pe[Xe].run.push(Ie.any);
      }
      if (pe = Ie[c] || Ie.key) for (let nn of N) Q(nn, pe, Ie.run, Ie.preventDefault, Ie.stopPropagation), Ie.shift && Q(nn, "Shift-" + pe, Ie.shift, Ie.preventDefault, Ie.stopPropagation);
    }
    return m;
  }
  function un(N, c, m, k) {
    let M = Ds.keyName(c);
    var Q = Wn.codePointAt(M, 0);
    Q = Wn.codePointSize(Q) == M.length && M != " ";
    let pe = "", Ie = !1, nn = !1, Xe = !1;
    Zi && Zi.view == m && Zi.scope == k && (pe = Zi.prefix + " ", 0 > Ng.indexOf(c.keyCode) && (nn = !0, Zi = null));
    let cn = /* @__PURE__ */ new Set(), kn = (Ct) => {
      if (Ct) {
        for (let Wt of Ct.run) if (!cn.has(Wt) && (cn.add(Wt), Wt(m, c))) return Ct.stopPropagation && (Xe = !0), !0;
        Ct.preventDefault && (Ct.stopPropagation && (Xe = !0), nn = !0);
      }
      return !1;
    };
    N = N[k];
    let jn, Pn;
    return N && (kn(N[pe + oe(M, c, !Q)]) ? Ie = !0 : Q && (c.altKey || c.metaKey || c.ctrlKey) && !(X.windows && c.ctrlKey && c.altKey) && (jn = Ds.base[c.keyCode]) && jn != M ? (kn(N[pe + oe(jn, c, !0)]) || c.shiftKey && (Pn = Ds.shift[c.keyCode]) != M && Pn != jn && kn(N[pe + oe(Pn, c, !1)])) && (Ie = !0) : Q && c.shiftKey && kn(N[pe + oe(M, c, !0)]) && (Ie = !0), !Ie && kn(N._any) && (Ie = !0)), nn && (Ie = !0), Ie && Xe && c.stopPropagation(), Ie;
  }
  function gn(N) {
    let c = N.scrollDOM.getBoundingClientRect();
    return { left: (N.textDirection == l.Direction.LTR ? c.left : c.right - N.scrollDOM.clientWidth * N.scaleX) - N.scrollDOM.scrollLeft * N.scaleX, top: c.top - N.scrollDOM.scrollTop * N.scaleY };
  }
  function Tn(N, c, m) {
    return c = Wn.EditorSelection.cursor(c), { from: Math.max(m.from, N.moveToLineBoundary(c, !1, !0).from), to: Math.min(m.to, N.moveToLineBoundary(c, !0, !0).from), type: l.BlockType.Text };
  }
  function ft(N, c, m) {
    function k(rl, _i, Ci, Is) {
      return new yi(c, rl - jn.left, _i - jn.top - 0.01, Ci - rl, Is - _i + 0.01);
    }
    function M({
      top: rl,
      bottom: _i,
      horizontal: Ci
    }) {
      let Is = [];
      for (let To = 0; To < Ci.length; To += 2) Is.push(k(Ci[To], rl, Ci[To + 1], _i));
      return Is;
    }
    function Q(rl, _i, Ci) {
      function Is(ha, wf, Fa, Sd, Gg) {
        ha = N.coordsAtPos(ha, ha == Ci.to ? -2 : 2), Fa = N.coordsAtPos(Fa, Fa == Ci.from ? 2 : -2), ha && Fa && (To = Math.min(ha.top, Fa.top, To), Ih = Math.max(ha.bottom, Fa.bottom, Ih), Gg == l.Direction.LTR ? z1.push(Xe && wf ? Pn : ha.left, Xe && Sd ? Ct : Fa.right) : z1.push(!Xe && Sd ? Pn : Fa.left, !Xe && wf ? Ct : ha.right));
      }
      let To = 1e9, Ih = -1e9, z1 = [], K1 = rl ?? Ci.from, Vo = _i ?? Ci.to;
      for (let ha of N.visibleRanges) if (ha.to > K1 && ha.from < Vo) for (let wf = Math.max(ha.from, K1), Fa = Math.min(ha.to, Vo); ; ) {
        let Sd = N.state.doc.lineAt(wf);
        for (let Gg of N.bidiSpans(Sd)) {
          let G1 = Gg.from + Sd.from, Z1 = Gg.to + Sd.from;
          if (G1 >= Fa) break;
          Z1 > wf && Is(Math.max(G1, wf), rl == null && G1 <= K1, Math.min(Z1, Fa), _i == null && Z1 >= Vo, Gg.dir);
        }
        if (wf = Sd.to + 1, wf >= Fa) break;
      }
      return z1.length == 0 && Is(K1, rl == null, Vo, _i == null, N.textDirection), { top: To, bottom: Ih, horizontal: z1 };
    }
    function pe(rl, _i) {
      return rl = kn.top + (_i ? rl.top : rl.bottom), {
        top: rl,
        bottom: rl,
        horizontal: []
      };
    }
    if (m.to <= N.viewport.from || m.from >= N.viewport.to) return [];
    var Ie = Math.max(m.from, N.viewport.from), nn = Math.min(m.to, N.viewport.to);
    let Xe = N.textDirection == l.Direction.LTR;
    var cn = N.contentDOM;
    let kn = cn.getBoundingClientRect(), jn = gn(N);
    cn = (cn = cn.querySelector(".cm-line")) && window.getComputedStyle(cn);
    let Pn = kn.left + (cn ? parseInt(cn.paddingLeft) + Math.min(0, parseInt(cn.textIndent)) : 0), Ct = kn.right - (cn ? parseInt(cn.paddingRight) : 0);
    cn = zt(N, Ie);
    let Wt = zt(N, nn), Mt = cn.type == l.BlockType.Text ? cn : null, wl = Wt.type == l.BlockType.Text ? Wt : null;
    return Mt && (N.lineWrapping || cn.widgetLineBreaks) && (Mt = Tn(N, Ie, Mt)), wl && (N.lineWrapping || Wt.widgetLineBreaks) && (wl = Tn(N, nn, wl)), Mt && wl && Mt.from == wl.from ? M(Q(m.from, m.to, Mt)) : (Ie = Mt ? Q(m.from, null, Mt) : pe(cn, !1), m = wl ? Q(null, m.to, wl) : pe(Wt, !0), nn = [], (Mt || cn).to < (wl || Wt).from - (Mt && wl ? 1 : 0) || 1 < cn.widgetLineBreaks && Ie.bottom + N.defaultLineHeight / 2 < m.top ? nn.push(k(Pn, Ie.bottom, Ct, m.top)) : Ie.bottom < m.top && N.elementAtHeight((Ie.bottom + m.top) / 2).type == l.BlockType.Text && (Ie.bottom = m.top = (Ie.bottom + m.top) / 2), M(Ie).concat(nn).concat(M(m)));
  }
  function gt(N) {
    return [_u.define((c) => new Y2(c, N)), P1.of(N)];
  }
  function Gt(N) {
    return N.startState.facet(Gc) != N.state.facet(Gc);
  }
  function zl(N, c, m, k, M) {
    c.lastIndex = 0;
    for (let Q = N.iterRange(m, k), pe = m, Ie; !Q.next().done; pe += Q.value.length) if (!Q.lineBreak) for (; Ie = c.exec(Q.value); ) M(pe + Ie.index, Ie);
  }
  function qe(N, c) {
    let m = N.visibleRanges;
    if (m.length == 1 && m[0].from == N.viewport.from && m[0].to == N.viewport.to) return m;
    let k = [];
    for (let { from: M, to: Q } of m) M = Math.max(
      N.state.doc.lineAt(M).from,
      M - c
    ), Q = Math.min(N.state.doc.lineAt(Q).to, Q + c), k.length && k[k.length - 1].to >= M ? k[k.length - 1].to = Q : k.push({ from: M, to: Q });
    return k;
  }
  function ae() {
    var N;
    return (N = Vg) || (N = Vg = _u.fromClass(class {
      constructor(c) {
        this.view = c, this.decorations = On.none, this.decorationCache = /* @__PURE__ */ Object.create(null), this.decorator = this.makeDecorator(c.state.facet(pc)), this.decorations = this.decorator.createDeco(c);
      }
      makeDecorator(c) {
        return new vd({ regexp: c.specialChars, decoration: (m, k, M) => {
          var { doc: Q } = k.state;
          return m = Wn.codePointAt(m[0], 0), m == 9 ? (Q = Q.lineAt(M), k = k.state.tabSize, M = Wn.countColumn(Q.text, k, M - Q.from), On.replace({ widget: new L1((k - M % k) * this.view.defaultCharacterWidth / this.view.scaleX) })) : this.decorationCache[m] || (this.decorationCache[m] = On.replace({ widget: new H5(c, m) }));
        }, boundary: c.replaceTabs ? void 0 : /[^]/ });
      }
      update(c) {
        let m = c.state.facet(pc);
        c.startState.facet(pc) != m ? (this.decorator = this.makeDecorator(m), this.decorations = this.decorator.createDeco(c.view)) : this.decorations = this.decorator.updateDeco(c, this.decorations);
      }
    }, { decorations: (c) => c.decorations })), N;
  }
  function Ue(N, c) {
    var m = N.posAtCoords({ x: c.clientX, y: c.clientY }, !1);
    let k = N.state.doc.lineAt(m), M = m - k.from;
    return 2e3 < M ? N = -1 : M == k.length ? (c = c.clientX, N = (m = N.coordsAtPos(N.viewport.from)) ? Math.round(Math.abs((m.left - c) / N.defaultCharacterWidth)) : -1) : N = Wn.countColumn(k.text, N.state.tabSize, m - k.from), { line: k.number, col: N, off: M };
  }
  function ze(N, c) {
    let m = Ue(N, c), k = N.state.selection;
    return m ? { update(M) {
      if (M.docChanged) {
        var Q = M.changes.mapPos(M.startState.doc.line(m.line).from);
        Q = M.state.doc.lineAt(Q), m = { line: Q.number, col: m.col, off: Math.min(m.off, Q.length) }, k = k.map(M.changes);
      }
    }, get(M, Q, pe) {
      var Ie = Ue(N, M);
      if (!Ie) return k;
      M = N.state;
      var nn = m, Xe = Math.min(nn.line, Ie.line);
      Q = Math.max(nn.line, Ie.line);
      let cn = [];
      if (2e3 < nn.off || 2e3 < Ie.off || 0 > nn.col || 0 > Ie.col) {
        var kn = Math.min(nn.off, Ie.off);
        for (Ie = Math.max(nn.off, Ie.off); Xe <= Q; Xe++) nn = M.doc.line(Xe), nn.length <= Ie && cn.push(Wn.EditorSelection.range(nn.from + kn, nn.to + Ie));
      } else for (kn = Math.min(nn.col, Ie.col), Ie = Math.max(nn.col, Ie.col); Xe <= Q; Xe++) {
        nn = M.doc.line(Xe);
        let jn = Wn.findColumn(
          nn.text,
          kn,
          M.tabSize,
          !0
        );
        if (0 > jn) cn.push(Wn.EditorSelection.cursor(nn.to));
        else {
          let Pn = Wn.findColumn(nn.text, Ie, M.tabSize);
          cn.push(Wn.EditorSelection.range(nn.from + jn, nn.from + Pn));
        }
      }
      return cn.length ? pe ? Wn.EditorSelection.create(cn.concat(k.ranges)) : Wn.EditorSelection.create(cn) : k;
    } } : null;
  }
  function dn(N) {
    return { win: N } = N, { top: 0, left: 0, bottom: N.innerHeight, right: N.innerWidth };
  }
  function ut(N) {
    for (; N; N = N.parentNode) if (N.nodeType == 1 && N.classList.contains("cm-tooltip")) return !0;
    return !1;
  }
  function Zn(N) {
    let c = N.nextSibling;
    return N.remove(), c;
  }
  function ht(N) {
    let c = [zg];
    return N && N.fixed === !1 && c.push(_d.of(!0)), c;
  }
  function ct(N) {
    return Array.isArray(N) ? N : [N];
  }
  function Hl(N, c, m) {
    for (; N.value && N.from <= m; ) N.from == m && c.push(N.value), N.next();
  }
  function Pl(N, c) {
    return N.state.facet(Hp).formatNumber(c, N.state);
  }
  function Fn(N) {
    let c = 9;
    for (; c < N; ) c = 10 * c + 9;
    return c;
  }
  function br(N) {
    return _u.define((c) => ({ decorations: N.createDeco(c), update(m) {
      this.decorations = N.updateDeco(m, this.decorations);
    } }), { decorations: (c) => c.decorations });
  }
  var Wn = n(0), cs = n(1), Ds = n(2);
  class ac {
    constructor() {
      this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
    }
    eq(c) {
      return this.anchorNode == c.anchorNode && this.anchorOffset == c.anchorOffset && this.focusNode == c.focusNode && this.focusOffset == c.focusOffset;
    }
    setRange(c) {
      let { anchorNode: m, focusNode: k } = c;
      this.set(m, Math.min(c.anchorOffset, m ? p(m) : 0), k, Math.min(c.focusOffset, k ? p(k) : 0));
    }
    set(c, m, k, M) {
      this.anchorNode = c, this.anchorOffset = m, this.focusNode = k, this.focusOffset = M;
    }
  }
  let Hs = null, vu;
  class Ji {
    constructor(c, m, k = !0) {
      this.node = c, this.offset = m, this.precise = k;
    }
    static before(c, m) {
      return new Ji(c.parentNode, s(c), m);
    }
    static after(c, m) {
      return new Ji(c.parentNode, s(c) + 1, m);
    }
  }
  const hs = [];
  class li {
    constructor() {
      this.dom = this.parent = null, this.flags = 2;
    }
    get overrideDOMText() {
      return null;
    }
    get posAtStart() {
      return this.parent ? this.parent.posBefore(this) : 0;
    }
    get posAtEnd() {
      return this.posAtStart + this.length;
    }
    posBefore(c) {
      let m = this.posAtStart;
      for (let k of this.children) {
        if (k == c) return m;
        m += k.length + k.breakAfter;
      }
      throw new RangeError("Invalid child in posBefore");
    }
    posAfter(c) {
      return this.posBefore(c) + c.length;
    }
    sync(c, m) {
      if (this.flags & 2) {
        var k = this.dom;
        let M = null, Q;
        for (let pe of this.children) {
          if (pe.flags & 7) {
            if (!pe.dom && (Q = M ? M.nextSibling : k.firstChild)) {
              let Ie = li.get(Q);
              (!Ie || !Ie.parent && Ie.canReuseDOM(pe)) && pe.reuseDOM(Q);
            }
            pe.sync(c, m), pe.flags &= -8;
          }
          if (Q = M ? M.nextSibling : k.firstChild, m && !m.written && m.node == k && Q != pe.dom && (m.written = !0), pe.dom.parentNode == k) for (; Q && Q != pe.dom; ) Q = xe(Q);
          else k.insertBefore(pe.dom, Q);
          M = pe.dom;
        }
        for ((Q = M ? M.nextSibling : k.firstChild) && m && m.node == k && (m.written = !0); Q; ) Q = xe(Q);
      } else if (this.flags & 1) for (k of this.children) k.flags & 7 && (k.sync(c, m), k.flags &= -8);
    }
    reuseDOM(c) {
    }
    localPosFromDOM(c, m) {
      if (c == this.dom) c = this.dom.childNodes[m];
      else {
        for (m = p(c) == 0 ? 0 : m == 0 ? -1 : 1; ; ) {
          let k = c.parentNode;
          if (k == this.dom) break;
          m == 0 && k.firstChild != k.lastChild && (m = c == k.firstChild ? -1 : 1), c = k;
        }
        c = 0 > m ? c : c.nextSibling;
      }
      if (c == this.dom.firstChild) return 0;
      for (; c && !li.get(c); ) c = c.nextSibling;
      if (!c) return this.length;
      for (let k = 0, M = 0; ; k++) {
        if (m = this.children[k], m.dom == c) return M;
        M += m.length + m.breakAfter;
      }
    }
    domBoundsAround(c, m, k = 0) {
      let M = -1, Q = -1, pe = -1, Ie = -1;
      for (let nn = 0, Xe = k, cn = k; nn < this.children.length; nn++) {
        let kn = this.children[nn], jn = Xe + kn.length;
        if (Xe < c && jn > m) return kn.domBoundsAround(c, m, Xe);
        if (jn >= c && M == -1 && (M = nn, Q = Xe), Xe > m && kn.dom.parentNode == this.dom) {
          pe = nn, Ie = cn;
          break;
        }
        cn = jn, Xe = jn + kn.breakAfter;
      }
      return { from: Q, to: 0 > Ie ? k + this.length : Ie, startDOM: (M ? this.children[M - 1].dom.nextSibling : null) || this.dom.firstChild, endDOM: pe < this.children.length && 0 <= pe ? this.children[pe].dom : null };
    }
    markDirty(c = !1) {
      this.flags |= 2, this.markParentsDirty(c);
    }
    markParentsDirty(c) {
      for (let m = this.parent; m && (c && (m.flags |= 2), !(m.flags & 1)); m = m.parent)
        m.flags |= 1, c = !1;
    }
    setParent(c) {
      this.parent != c && (this.parent = c, this.flags & 7 && this.markParentsDirty(!0));
    }
    setDOM(c) {
      this.dom != c && (this.dom && (this.dom.cmView = null), this.dom = c, c.cmView = this);
    }
    get rootView() {
      for (let c = this; ; ) {
        let m = c.parent;
        if (!m) return c;
        c = m;
      }
    }
    replaceChildren(c, m, k = hs) {
      this.markDirty();
      for (let M = c; M < m; M++) {
        let Q = this.children[M];
        Q.parent == this && Q.destroy();
      }
      for (this.children.splice(c, m - c, ...k), c = 0; c < k.length; c++) k[c].setParent(this);
    }
    ignoreMutation(c) {
      return !1;
    }
    ignoreEvent(c) {
      return !1;
    }
    childCursor(c = this.length) {
      return new cc(this.children, c, this.children.length);
    }
    childPos(c, m = 1) {
      return this.childCursor().findPos(c, m);
    }
    toString() {
      let c = this.constructor.name.replace("View", "");
      return c + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (c == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
    }
    static get(c) {
      return c.cmView;
    }
    get isEditable() {
      return !0;
    }
    get isWidget() {
      return !1;
    }
    get isHidden() {
      return !1;
    }
    merge(c, m, k, M, Q, pe) {
      return !1;
    }
    become(c) {
      return !1;
    }
    canReuseDOM(c) {
      return c.constructor == this.constructor && !((this.flags | c.flags) & 8);
    }
    getSide() {
      return 0;
    }
    destroy() {
      this.parent = null;
    }
  }
  li.prototype.breakAfter = 0;
  class cc {
    constructor(c, m, k) {
      this.children = c, this.pos = m, this.i = k, this.off = 0;
    }
    findPos(c, m = 1) {
      for (; ; ) {
        if (c > this.pos || c == this.pos && (0 < m || this.i == 0 || this.children[this.i - 1].breakAfter)) return this.off = c - this.pos, this;
        let k = this.children[--this.i];
        this.pos -= k.length + k.breakAfter;
      }
    }
  }
  let eu = typeof navigator < "u" ? navigator : { userAgent: "", vendor: "", platform: "" }, $a = typeof document < "u" ? document : { documentElement: { style: {} } };
  const oa = /Edge\/(\d+)/.exec(eu.userAgent), hc = /MSIE \d/.test(eu.userAgent), aa = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(eu.userAgent), Eo = !!(hc || aa || oa), be = !Eo && /gecko\/(\d+)/i.test(eu.userAgent), b = !Eo && /Chrome\/(\d+)/.exec(eu.userAgent), w = "webkitFontSmoothing" in $a.documentElement.style, i = !Eo && /Apple Computer/.test(eu.vendor), x = i && (/Mobile\/\w+/.test(eu.userAgent) || 2 < eu.maxTouchPoints);
  var X = {
    mac: x || /Mac/.test(eu.platform),
    windows: /Win/.test(eu.platform),
    linux: /Linux|X11/.test(eu.platform),
    ie: Eo,
    ie_version: hc ? $a.documentMode || 6 : aa ? +aa[1] : oa ? +oa[1] : 0,
    gecko: be,
    gecko_version: be ? +(/Firefox\/(\d+)/.exec(eu.userAgent) || [0, 0])[1] : 0,
    chrome: !!b,
    chrome_version: b ? +b[1] : 0,
    ios: x,
    android: /Android\b/.test(eu.userAgent),
    webkit: w,
    safari: i,
    webkit_version: w ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0,
    tabSize: $a.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
  };
  class He extends li {
    constructor(c) {
      super(), this.text = c;
    }
    get length() {
      return this.text.length;
    }
    createDOM(c) {
      this.setDOM(c || document.createTextNode(this.text));
    }
    sync(c, m) {
      this.dom || this.createDOM(), this.dom.nodeValue != this.text && (m && m.node == this.dom && (m.written = !0), this.dom.nodeValue = this.text);
    }
    reuseDOM(c) {
      c.nodeType == 3 && this.createDOM(c);
    }
    merge(c, m, k) {
      return this.flags & 8 || k && (!(k instanceof He) || 256 < this.length - (m - c) + k.length || k.flags & 8) ? !1 : (this.text = this.text.slice(0, c) + (k ? k.text : "") + this.text.slice(m), this.markDirty(), !0);
    }
    split(c) {
      let m = new He(this.text.slice(c));
      return this.text = this.text.slice(0, c), this.markDirty(), m.flags |= this.flags & 8, m;
    }
    localPosFromDOM(c, m) {
      return c == this.dom ? m : m ? this.text.length : 0;
    }
    domAtPos(c) {
      return new Ji(this.dom, c);
    }
    domBoundsAround(c, m, k) {
      return { from: k, to: k + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
    }
    coordsAt(c, m) {
      return E(this.dom, c, m);
    }
  }
  class $n extends li {
    constructor(c, m = [], k = 0) {
      super(), this.mark = c, this.children = m, this.length = k;
      for (let M of m) M.setParent(this);
    }
    setAttrs(c) {
      if (we(c), this.mark.class && (c.className = this.mark.class), this.mark.attrs) for (let m in this.mark.attrs) c.setAttribute(
        m,
        this.mark.attrs[m]
      );
      return c;
    }
    canReuseDOM(c) {
      return super.canReuseDOM(c) && !((this.flags | c.flags) & 8);
    }
    reuseDOM(c) {
      c.nodeName == this.mark.tagName.toUpperCase() && (this.setDOM(c), this.flags |= 6);
    }
    sync(c, m) {
      this.dom ? this.flags & 4 && this.setAttrs(this.dom) : this.setDOM(this.setAttrs(document.createElement(this.mark.tagName))), super.sync(c, m);
    }
    merge(c, m, k, M, Q, pe) {
      return k && (!(k instanceof $n && k.mark.eq(this.mark)) || c && 0 >= Q || m < this.length && 0 >= pe) ? !1 : (je(this, c, m, k ? k.children : [], Q - 1, pe - 1), this.markDirty(), !0);
    }
    split(c) {
      let m = [];
      var k = 0;
      let M = -1, Q = 0;
      for (let pe of this.children) {
        let Ie = k + pe.length;
        Ie > c && m.push(k < c ? pe.split(c - k) : pe), 0 > M && k >= c && (M = Q), k = Ie, Q++;
      }
      return k = this.length - c, this.length = c, -1 < M && (this.children.length = M, this.markDirty()), new $n(this.mark, m, k);
    }
    domAtPos(c) {
      return P(this, c);
    }
    coordsAt(c, m) {
      return H(this, c, m);
    }
  }
  class Xt extends li {
    static create(c, m, k) {
      return new Xt(c, m, k);
    }
    constructor(c, m, k) {
      super(), this.widget = c, this.length = m, this.side = k, this.prevWidget = null;
    }
    split(c) {
      let m = Xt.create(this.widget, this.length - c, this.side);
      return this.length -= c, m;
    }
    sync(c) {
      this.dom && this.widget.updateDOM(this.dom, c) || (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(c)), this.dom.contentEditable = "false");
    }
    getSide() {
      return this.side;
    }
    merge(c, m, k, M, Q, pe) {
      return k && (!(k instanceof Xt && this.widget.compare(k.widget)) || 0 < c && 0 >= Q || m < this.length && 0 >= pe) ? !1 : (this.length = c + (k ? k.length : 0) + (this.length - m), !0);
    }
    become(c) {
      return c instanceof Xt && c.side == this.side && this.widget.constructor == c.widget.constructor ? (this.widget.compare(c.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = c.widget, this.length = c.length, !0) : !1;
    }
    ignoreMutation() {
      return !0;
    }
    ignoreEvent(c) {
      return this.widget.ignoreEvent(c);
    }
    get overrideDOMText() {
      if (this.length == 0) return Wn.Text.empty;
      for (var c = this; c.parent; ) c = c.parent;
      ({ view: c } = c), c = c && c.state.doc;
      let m = this.posAtStart;
      return c ? c.slice(m, m + this.length) : Wn.Text.empty;
    }
    domAtPos(c) {
      return (this.length ? c == 0 : 0 < this.side) ? Ji.before(this.dom) : Ji.after(this.dom, c == this.length);
    }
    domBoundsAround() {
      return null;
    }
    coordsAt(c, m) {
      if (m = this.widget.coordsAt(this.dom, c, m)) return m;
      m = this.dom.getClientRects();
      let k;
      if (!m.length) return null;
      let M = this.side ? 0 > this.side : 0 < c;
      for (let Q = M ? m.length - 1 : 0; k = m[Q], !(0 < c ? Q == 0 : Q == m.length - 1 || k.top < k.bottom); Q += M ? -1 : 1) ;
      return _(k, !M);
    }
    get isEditable() {
      return !1;
    }
    get isWidget() {
      return !0;
    }
    get isHidden() {
      return this.widget.isHidden;
    }
    destroy() {
      super.destroy(), this.dom && this.widget.destroy(this.dom);
    }
  }
  class $l extends li {
    constructor(c) {
      super(), this.side = c;
    }
    get length() {
      return 0;
    }
    merge() {
      return !1;
    }
    become(c) {
      return c instanceof $l && c.side == this.side;
    }
    split() {
      return new $l(this.side);
    }
    sync() {
      if (!this.dom) {
        let c = document.createElement("img");
        c.className = "cm-widgetBuffer", c.setAttribute("aria-hidden", "true"), this.setDOM(c);
      }
    }
    getSide() {
      return this.side;
    }
    domAtPos(c) {
      return 0 < this.side ? Ji.before(this.dom) : Ji.after(this.dom);
    }
    localPosFromDOM() {
      return 0;
    }
    domBoundsAround() {
      return null;
    }
    coordsAt(c) {
      return this.dom.getBoundingClientRect();
    }
    get overrideDOMText() {
      return Wn.Text.empty;
    }
    get isHidden() {
      return !0;
    }
  }
  He.prototype.children = Xt.prototype.children = $l.prototype.children = hs;
  const Oe = /* @__PURE__ */ Object.create(null);
  class Ke extends li {
    constructor() {
      super(...arguments), this.children = [], this.length = 0, this.prevAttrs = void 0, this.attrs = null, this.breakAfter = 0;
    }
    merge(c, m, k, M, Q, pe) {
      if (k) {
        if (!(k instanceof Ke)) return !1;
        this.dom || k.transferDOM(this);
      }
      return M && this.setDeco(k ? k.attrs : null), je(this, c, m, k ? k.children : [], Q, pe), !0;
    }
    split(c) {
      let m = new Ke();
      if (m.breakAfter = this.breakAfter, this.length == 0) return m;
      let { i: k, off: M } = this.childPos(c);
      M && (m.append(this.children[k].split(M), 0), this.children[k].merge(M, this.children[k].length, null, !1, 0, 0), k++);
      for (let Q = k; Q < this.children.length; Q++) m.append(this.children[Q], 0);
      for (; 0 < k && this.children[k - 1].length == 0; ) this.children[--k].destroy();
      return this.children.length = k, this.markDirty(), this.length = c, m;
    }
    transferDOM(c) {
      this.dom && (this.markDirty(), c.setDOM(this.dom), c.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs, this.prevAttrs = void 0, this.dom = null);
    }
    setDeco(c) {
      le(this.attrs, c) || (this.dom && (this.prevAttrs = this.attrs, this.markDirty()), this.attrs = c);
    }
    append(c, m) {
      K(this, c, m);
    }
    addLineDeco(c) {
      let m = c.spec.attributes;
      c = c.spec.class, m && (this.attrs = Me(m, this.attrs || {})), c && (this.attrs = Me({ class: c }, this.attrs || {}));
    }
    domAtPos(c) {
      return P(this, c);
    }
    reuseDOM(c) {
      c.nodeName == "DIV" && (this.setDOM(c), this.flags |= 6);
    }
    sync(c, m) {
      var k;
      for (this.dom ? this.flags & 4 && (we(this.dom), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0) : (this.setDOM(document.createElement("div")), this.dom.className = "cm-line", this.prevAttrs = this.attrs ? null : void 0), this.prevAttrs !== void 0 && (Ce(this.dom, this.prevAttrs, this.attrs), this.dom.classList.add("cm-line"), this.prevAttrs = void 0), super.sync(c, m), c = this.dom.lastChild; c && li.get(c) instanceof $n; ) c = c.lastChild;
      c && this.length && (c.nodeName == "BR" || ((k = li.get(c)) === null || k === void 0 ? void 0 : k.isEditable) != 0 || X.ios && this.children.some((M) => M instanceof He)) || (k = document.createElement("BR"), k.cmIgnore = !0, this.dom.appendChild(k));
    }
    measureTextSize() {
      if (this.children.length == 0 || 20 < this.length) return null;
      let c = 0;
      for (let k of this.children) {
        if (!(k instanceof He) || /[^ -~]/.test(k.text)) return null;
        var m = a(k.dom);
        if (m.length != 1) return null;
        c += m[0].width, m = m[0].height;
      }
      return c ? { lineHeight: this.dom.getBoundingClientRect().height, charWidth: c / this.length, textHeight: m } : null;
    }
    coordsAt(c, m) {
      if (c = H(this, c, m), !this.children.length && c && this.parent) {
        ({ heightOracle: m } = this.parent.view.viewState);
        let k = c.bottom - c.top;
        if (2 > Math.abs(k - m.lineHeight) && m.textHeight < k) return m = (k - m.textHeight) / 2, { top: c.top + m, bottom: c.bottom - m, left: c.left, right: c.left };
      }
      return c;
    }
    become(c) {
      return !1;
    }
    covers() {
      return !0;
    }
    static find(c, m) {
      for (let k = 0, M = 0; k < c.children.length; k++) {
        let Q = c.children[k], pe = M + Q.length;
        if (pe >= m) {
          if (Q instanceof Ke) return Q;
          if (pe > m) break;
        }
        M = pe + Q.breakAfter;
      }
      return null;
    }
  }
  class mn extends li {
    constructor(c, m, k) {
      super(), this.widget = c, this.length = m, this.deco = k, this.breakAfter = 0, this.prevWidget = null;
    }
    merge(c, m, k, M, Q, pe) {
      return k && (!(k instanceof mn && this.widget.compare(k.widget)) || 0 < c && 0 >= Q || m < this.length && 0 >= pe) ? !1 : (this.length = c + (k ? k.length : 0) + (this.length - m), !0);
    }
    domAtPos(c) {
      return c == 0 ? Ji.before(this.dom) : Ji.after(this.dom, c == this.length);
    }
    split(c) {
      let m = this.length - c;
      return this.length = c, c = new mn(this.widget, m, this.deco), c.breakAfter = this.breakAfter, c;
    }
    get children() {
      return hs;
    }
    sync(c) {
      this.dom && this.widget.updateDOM(this.dom, c) || (this.dom && this.prevWidget && this.prevWidget.destroy(this.dom), this.prevWidget = null, this.setDOM(this.widget.toDOM(c)), this.dom.contentEditable = "false");
    }
    get overrideDOMText() {
      return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : Wn.Text.empty;
    }
    domBoundsAround() {
      return null;
    }
    become(c) {
      return c instanceof mn && c.widget.constructor == this.widget.constructor ? (c.widget.compare(this.widget) || this.markDirty(!0), this.dom && !this.prevWidget && (this.prevWidget = this.widget), this.widget = c.widget, this.length = c.length, this.deco = c.deco, this.breakAfter = c.breakAfter, !0) : !1;
    }
    ignoreMutation() {
      return !0;
    }
    ignoreEvent(c) {
      return this.widget.ignoreEvent(c);
    }
    get isEditable() {
      return !1;
    }
    get isWidget() {
      return !0;
    }
    coordsAt(c, m) {
      return this.widget.coordsAt(this.dom, c, m);
    }
    destroy() {
      super.destroy(), this.dom && this.widget.destroy(this.dom);
    }
    covers(c) {
      let { startSide: m, endSide: k } = this.deco;
      return m == k ? !1 : 0 > c ? 0 > m : 0 < k;
    }
  }
  class wn {
    eq(c) {
      return !1;
    }
    updateDOM(c, m) {
      return !1;
    }
    compare(c) {
      return this == c || this.constructor == c.constructor && this.eq(c);
    }
    get estimatedHeight() {
      return -1;
    }
    get lineBreaks() {
      return 0;
    }
    ignoreEvent(c) {
      return !0;
    }
    coordsAt(c, m, k) {
      return null;
    }
    get isHidden() {
      return !1;
    }
    destroy(c) {
    }
  }
  l.BlockType = void 0, function(N) {
    N[N.Text = 0] = "Text", N[N.WidgetBefore = 1] = "WidgetBefore", N[N.WidgetAfter = 2] = "WidgetAfter", N[N.WidgetRange = 3] = "WidgetRange";
  }(l.BlockType || (l.BlockType = {}));
  class On extends Wn.RangeValue {
    constructor(c, m, k, M) {
      super(), this.startSide = c, this.endSide = m, this.widget = k, this.spec = M;
    }
    get heightRelevant() {
      return !1;
    }
    static mark(c) {
      return new An(c);
    }
    static widget(c) {
      let m = Math.max(-1e4, Math.min(1e4, c.side || 0)), k = !!c.block;
      return m += k && !c.inlineOrder ? 0 < m ? 3e8 : -4e8 : 0 < m ? 1e8 : -1e8, new Ot(c, m, m, k, c.widget || null, !1);
    }
    static replace(c) {
      let m = !!c.block, k, M;
      if (c.isBlockGap) k = -5e8, M = 4e8;
      else {
        let { start: Q, end: pe } = Ye(c, m);
        k = (Q ? m ? -3e8 : -1 : 5e8) - 1, M = (pe ? m ? 2e8 : 1 : -6e8) + 1;
      }
      return new Ot(c, k, M, m, c.widget || null, !0);
    }
    static line(c) {
      return new mt(c);
    }
    static set(c, m = !1) {
      return Wn.RangeSet.of(c, m);
    }
    hasHeight() {
      return this.widget ? -1 < this.widget.estimatedHeight : !1;
    }
  }
  On.none = Wn.RangeSet.empty;
  class An extends On {
    constructor(c) {
      let { start: m, end: k } = Ye(c);
      super(m ? -1 : 5e8, k ? 1 : -6e8, null, c), this.tagName = c.tagName || "span", this.class = c.class || "", this.attrs = c.attributes || null;
    }
    eq(c) {
      var m, k;
      return this == c || c instanceof An && this.tagName == c.tagName && (this.class || ((m = this.attrs) === null || m === void 0 ? void 0 : m.class)) == (c.class || ((k = c.attrs) === null || k === void 0 ? void 0 : k.class)) && le(this.attrs, c.attrs, "class");
    }
    range(c, m = c) {
      if (c >= m) throw new RangeError("Mark decorations may not be empty");
      return super.range(c, m);
    }
  }
  An.prototype.point = !1;
  class mt extends On {
    constructor(c) {
      super(-2e8, -2e8, null, c);
    }
    eq(c) {
      return c instanceof mt && this.spec.class == c.spec.class && le(this.spec.attributes, c.spec.attributes);
    }
    range(c, m = c) {
      if (m != c) throw new RangeError("Line decoration ranges must be zero-length");
      return super.range(c, m);
    }
  }
  mt.prototype.mapMode = Wn.MapMode.TrackBefore, mt.prototype.point = !0;
  class Ot extends On {
    constructor(c, m, k, M, Q, pe) {
      super(m, k, Q, c), this.block = M, this.isReplace = pe, this.mapMode = M ? 0 >= m ? Wn.MapMode.TrackBefore : Wn.MapMode.TrackAfter : Wn.MapMode.TrackDel;
    }
    get type() {
      return this.startSide != this.endSide ? l.BlockType.WidgetRange : 0 >= this.startSide ? l.BlockType.WidgetBefore : l.BlockType.WidgetAfter;
    }
    get heightRelevant() {
      return this.block || !!this.widget && (5 <= this.widget.estimatedHeight || 0 < this.widget.lineBreaks);
    }
    eq(c) {
      var m;
      if (m = c instanceof Ot) {
        m = this.widget;
        var k = c.widget;
        m = m == k || !!(m && k && m.compare(k));
      }
      return m && this.block == c.block && this.startSide == c.startSide && this.endSide == c.endSide;
    }
    range(c, m = c) {
      if (this.isReplace && (c > m || c == m && 0 < this.startSide && 0 >= this.endSide)) throw new RangeError("Invalid range for replacement decoration");
      if (!this.isReplace && m != c) throw new RangeError("Widget decorations can only have zero-length ranges");
      return super.range(
        c,
        m
      );
    }
  }
  Ot.prototype.point = !0;
  class ll {
    constructor(c, m, k, M) {
      this.doc = c, this.pos = m, this.end = k, this.disallowBlockEffectsFor = M, this.content = [], this.curLine = null, this.pendingBuffer = this.breakAtStart = 0, this.bufferMarks = [], this.atCursorPos = !0, this.openEnd = this.openStart = -1, this.text = "", this.textOff = 0, this.cursor = c.iter(), this.skip = m;
    }
    posCovered() {
      if (this.content.length == 0) return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
      let c = this.content[this.content.length - 1];
      return !(c.breakAfter || c instanceof mn && 0 > c.deco.endSide);
    }
    getLine() {
      return this.curLine || (this.content.push(this.curLine = new Ke()), this.atCursorPos = !0), this.curLine;
    }
    flushBuffer(c = this.bufferMarks) {
      this.pendingBuffer && (this.curLine.append(q(new $l(-1), c), c.length), this.pendingBuffer = 0);
    }
    addBlockWidget(c) {
      this.flushBuffer(), this.curLine = null, this.content.push(c);
    }
    finish(c) {
      this.pendingBuffer && c <= this.bufferMarks.length ? this.flushBuffer() : this.pendingBuffer = 0, this.posCovered() || c && this.content.length && this.content[this.content.length - 1] instanceof mn || this.getLine();
    }
    buildText(c, m, k) {
      for (; 0 < c; ) {
        if (this.textOff == this.text.length) {
          let { value: Q, lineBreak: pe, done: Ie } = this.cursor.next(this.skip);
          if (this.skip = 0, Ie) throw Error("Ran out of text content when drawing inline views");
          if (pe) {
            this.posCovered() || this.getLine(), this.content.length ? this.content[this.content.length - 1].breakAfter = 1 : this.breakAtStart = 1, this.flushBuffer(), this.curLine = null, this.atCursorPos = !0, c--;
            continue;
          } else this.text = Q, this.textOff = 0;
        }
        let M = Math.min(
          this.text.length - this.textOff,
          c,
          512
        );
        this.flushBuffer(m.slice(m.length - k)), this.getLine().append(q(new He(this.text.slice(this.textOff, this.textOff + M)), m), k), this.atCursorPos = !0, this.textOff += M, c -= M, k = 0;
      }
    }
    span(c, m, k, M) {
      this.buildText(m - c, k, M), this.pos = m, 0 > this.openStart && (this.openStart = M);
    }
    point(c, m, k, M, Q, pe) {
      if (this.disallowBlockEffectsFor[pe] && k instanceof Ot) {
        if (k.block) throw new RangeError("Block decorations may not be specified via plugins");
        if (m > this.doc.lineAt(this.pos).to) throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
      }
      if (pe = m - c, k instanceof Ot) if (k.block) 0 < k.startSide && !this.posCovered() && this.getLine(), this.addBlockWidget(new mn(k.widget || new Nr("div"), pe, k));
      else {
        let Ie = Xt.create(k.widget || new Nr("span"), pe, pe ? 0 : k.startSide), nn = this.atCursorPos && !Ie.isEditable && Q <= M.length && (c < m || 0 < k.startSide);
        k = !Ie.isEditable && (c < m || Q > M.length || 0 >= k.startSide);
        let Xe = this.getLine();
        this.pendingBuffer != 2 || nn || Ie.isEditable || (this.pendingBuffer = 0), this.flushBuffer(M), nn && (Xe.append(q(new $l(1), M), Q), Q = M.length + Math.max(0, Q - M.length)), Xe.append(q(
          Ie,
          M
        ), Q), (this.pendingBuffer = (this.atCursorPos = k) ? c < m || Q > M.length ? 1 : 2 : 0) && (this.bufferMarks = M.slice());
      }
      else this.doc.lineAt(this.pos).from == this.pos && this.getLine().addLineDeco(k);
      pe && (this.textOff + pe <= this.text.length ? this.textOff += pe : (this.skip += pe - (this.text.length - this.textOff), this.text = "", this.textOff = 0), this.pos = m), 0 > this.openStart && (this.openStart = Q);
    }
    static build(c, m, k, M, Q) {
      return c = new ll(c, m, k, Q), c.openEnd = Wn.RangeSet.spans(M, m, k, c), 0 > c.openStart && (c.openStart = c.openEnd), c.finish(c.openEnd), c;
    }
  }
  class Nr extends wn {
    constructor(c) {
      super(), this.tag = c;
    }
    eq(c) {
      return c.tag == this.tag;
    }
    toDOM() {
      return document.createElement(this.tag);
    }
    updateDOM(c) {
      return c.nodeName.toLowerCase() == this.tag;
    }
    get isHidden() {
      return !0;
    }
  }
  const hi = Wn.Facet.define(), Oo = Wn.Facet.define(), yu = Wn.Facet.define(), $r = Wn.Facet.define(), ri = Wn.Facet.define(), bh = Wn.Facet.define(), Tg = Wn.Facet.define(), jg = Wn.Facet.define({ combine: (N) => N.some((c) => c) }), Ag = Wn.Facet.define({ combine: (N) => N.some((c) => c) });
  class sd {
    constructor(c, m = "nearest", k = "nearest", M = 5, Q = 5) {
      this.range = c, this.y = m, this.x = k, this.yMargin = M, this.xMargin = Q;
    }
    map(c) {
      return c.empty ? this : new sd(this.range.map(c), this.y, this.x, this.yMargin, this.xMargin);
    }
  }
  const Dg = Wn.StateEffect.define({ map: (N, c) => N.map(c) }), gf = Wn.Facet.define({ combine: (N) => N.length ? N[0] : !0 });
  let I1 = 0;
  const au = Wn.Facet.define();
  class _u {
    constructor(c, m, k, M, Q) {
      this.id = c, this.create = m, this.domEventHandlers = k, this.domEventObservers = M, this.extension = Q(this);
    }
    static define(c, m) {
      const { eventHandlers: k, eventObservers: M, provide: Q, decorations: pe } = m || {};
      return new _u(I1++, c, k, M, (Ie) => {
        let nn = [au.of(Ie)];
        return pe && nn.push(fs.of((Xe) => (Xe = Xe.plugin(Ie)) ? pe(Xe) : On.none)), Q && nn.push(Q(Ie)), nn;
      });
    }
    static fromClass(c, m) {
      return _u.define((k) => new c(k), m);
    }
  }
  class La {
    constructor(c) {
      this.spec = c, this.value = this.mustUpdate = null;
    }
    update(c) {
      if (this.value) {
        if (this.mustUpdate && (c = this.mustUpdate, this.mustUpdate = null, this.value.update)) try {
          this.value.update(c);
        } catch (m) {
          if (me(c.state, m, "CodeMirror plugin crashed"), this.value.destroy) try {
            this.value.destroy();
          } catch {
          }
          this.deactivate();
        }
      } else if (this.spec) try {
        this.value = this.spec.create(c);
      } catch (m) {
        me(c.state, m, "CodeMirror plugin crashed"), this.deactivate();
      }
      return this;
    }
    destroy(c) {
      var m;
      if (!((m = this.value) === null || m === void 0) && m.destroy) try {
        this.value.destroy();
      } catch (k) {
        me(c.state, k, "CodeMirror plugin crashed");
      }
    }
    deactivate() {
      this.spec = this.value = null;
    }
  }
  const Mp = Wn.Facet.define(), Th = Wn.Facet.define(), fs = Wn.Facet.define(), od = Wn.Facet.define(), Kc = Wn.Facet.define(), Pp = Wn.Facet.define(), jh = Wn.Facet.define();
  class zs {
    constructor(c, m, k, M) {
      this.fromA = c, this.toA = m, this.fromB = k, this.toB = M;
    }
    join(c) {
      return new zs(Math.min(
        this.fromA,
        c.fromA
      ), Math.max(this.toA, c.toA), Math.min(this.fromB, c.fromB), Math.max(this.toB, c.toB));
    }
    addToSet(c) {
      let m = c.length, k = this;
      for (; 0 < m; m--) {
        let M = c[m - 1];
        if (!(M.fromA > k.toA)) {
          if (M.toA < k.fromA) break;
          k = k.join(M), c.splice(m - 1, 1);
        }
      }
      return c.splice(m, 0, k), c;
    }
    static extendWithRanges(c, m) {
      if (m.length == 0) return c;
      let k = [];
      for (let M = 0, Q = 0, pe = 0, Ie = 0; ; M++) {
        let nn = M == c.length ? null : c[M], Xe = pe - Ie, cn = nn ? nn.fromB : 1e9;
        for (; Q < m.length && m[Q] < cn; ) {
          let kn = m[Q + 1], jn = Math.max(Ie, m[Q]), Pn = Math.min(cn, kn);
          if (jn <= Pn && new zs(jn + Xe, Pn + Xe, jn, Pn).addToSet(k), kn > cn) break;
          Q += 2;
        }
        if (!nn) return k;
        new zs(nn.fromA, nn.toA, nn.fromB, nn.toB).addToSet(k), pe = nn.toA, Ie = nn.toB;
      }
    }
  }
  class Ah {
    constructor(c, m, k) {
      this.view = c, this.state = m, this.transactions = k, this.flags = 0, this.startState = c.state, this.changes = Wn.ChangeSet.empty(this.startState.doc.length);
      for (let Q of k) this.changes = this.changes.compose(Q.changes);
      let M = [];
      this.changes.iterChangedRanges((Q, pe, Ie, nn) => M.push(new zs(Q, pe, Ie, nn))), this.changedRanges = M;
    }
    static create(c, m, k) {
      return new Ah(c, m, k);
    }
    get viewportChanged() {
      return 0 < (this.flags & 4);
    }
    get heightChanged() {
      return 0 < (this.flags & 2);
    }
    get geometryChanged() {
      return this.docChanged || 0 < (this.flags & 10);
    }
    get focusChanged() {
      return 0 < (this.flags & 1);
    }
    get docChanged() {
      return !this.changes.empty;
    }
    get selectionSet() {
      return this.transactions.some((c) => c.selection);
    }
    get empty() {
      return this.flags == 0 && this.transactions.length == 0;
    }
  }
  l.Direction = void 0, function(N) {
    N[N.LTR = 0] = "LTR", N[N.RTL = 1] = "RTL";
  }(l.Direction || (l.Direction = {}));
  const Wu = l.Direction.LTR, Ig = l.Direction.RTL, ko = ln("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008"), R1 = ln("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333"), ad = /* @__PURE__ */ Object.create(null), Hu = [];
  for (let N of ["()", "[]", "{}"]) {
    let c = N.charCodeAt(0), m = N.charCodeAt(1);
    ad[c] = m, ad[m] = -c;
  }
  const cd = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
  class bo {
    get dir() {
      return this.level % 2 ? Ig : Wu;
    }
    constructor(c, m, k) {
      this.from = c, this.to = m, this.level = k;
    }
    side(c, m) {
      return this.dir == m == c ? this.to : this.from;
    }
    static find(c, m, k, M) {
      let Q = -1;
      for (let pe = 0; pe < c.length; pe++) {
        let Ie = c[pe];
        if (Ie.from <= m && Ie.to >= m) {
          if (Ie.level == k) return pe;
          (0 > Q || (M != 0 ? 0 > M ? Ie.from < m : Ie.to > m : c[Q].level > Ie.level)) && (Q = pe);
        }
      }
      if (0 > Q) throw new RangeError("Index out of range");
      return Q;
    }
  }
  const Kl = [];
  let Ba = "";
  class hd extends li {
    get length() {
      return this.view.state.doc.length;
    }
    constructor(c) {
      super(), this.view = c, this.decorations = [], this.dynamicDecorationMap = [], this.hasComposition = this.domChanged = null, this.markedForComposition = /* @__PURE__ */ new Set(), this.minWidthTo = this.minWidthFrom = this.minWidth = 0, this.impreciseHead = this.impreciseAnchor = null, this.forceSelection = !1, this.lastUpdate = Date.now(), this.setDOM(c.contentDOM), this.children = [new Ke()], this.children[0].setParent(this), this.updateDeco(), this.updateInner([new zs(0, 0, 0, c.state.doc.length)], 0, null);
    }
    update(c) {
      var m;
      let k = c.changedRanges;
      0 < this.minWidth && k.length && (k.every(({ fromA: pe, toA: Ie }) => Ie < this.minWidthFrom || pe > this.minWidthTo) ? (this.minWidthFrom = c.changes.mapPos(this.minWidthFrom, 1), this.minWidthTo = c.changes.mapPos(this.minWidthTo, 1)) : this.minWidth = this.minWidthFrom = this.minWidthTo = 0);
      var M = -1;
      if (0 <= this.view.inputState.composing && (!((m = this.domChanged) === null || m === void 0) && m.newSel ? M = this.domChanged.newSel.head : fn(c.changes, this.hasComposition) || c.selectionSet || (M = c.state.selection.main.head)), m = -1 < M ? Yt(this.view, c.changes, M) : null, this.domChanged = null, this.hasComposition) {
        this.markedForComposition.clear();
        let { from: pe, to: Ie } = this.hasComposition;
        k = new zs(pe, Ie, c.changes.mapPos(pe, -1), c.changes.mapPos(Ie, 1)).addToSet(k.slice());
      }
      this.hasComposition = m ? { from: m.range.fromB, to: m.range.toB } : null, (X.ie || X.chrome) && !m && c && c.state.doc.lines != c.startState.doc.lines && (this.forceSelection = !0), M = this.decorations;
      let Q = this.updateDeco();
      return M = Cl(M, Q, c.changes), k = zs.extendWithRanges(k, M), this.flags & 7 || k.length != 0 ? (this.updateInner(k, c.startState.doc.length, m), c.transactions.length && (this.lastUpdate = Date.now()), !0) : !1;
    }
    updateInner(c, m, k) {
      this.view.viewState.mustMeasureContent = !0, this.updateChildren(c, m, k);
      let { observer: M } = this.view;
      if (M.ignore(() => {
        this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px", this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
        let Q = X.chrome || X.ios ? { node: M.selectionRange.focusNode, written: !1 } : void 0;
        this.sync(this.view, Q), this.flags &= -8, Q && (Q.written || M.selectionRange.focusNode != Q.node) && (this.forceSelection = !0), this.dom.style.height = "";
      }), this.markedForComposition.forEach((Q) => Q.flags &= -9), c = [], this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) for (let Q of this.children) Q instanceof mn && Q.widget instanceof Rg && c.push(Q.dom);
      M.updateGaps(c);
    }
    updateChildren(c, m, k) {
      c = k ? k.range.addToSet(c.slice()) : c, m = this.childCursor(m);
      for (let pe = c.length - 1; ; pe--) {
        var M = 0 <= pe ? c[pe] : null;
        if (!M) break;
        let { fromA: Ie, toA: nn, fromB: Xe, toB: cn } = M;
        var Q = void 0;
        let kn, jn;
        if (k && k.range.fromB < cn && k.range.toB > Xe) {
          Q = ll.build(this.view.state.doc, Xe, k.range.fromB, this.decorations, this.dynamicDecorationMap);
          let wl = ll.build(
            this.view.state.doc,
            k.range.toB,
            cn,
            this.decorations,
            this.dynamicDecorationMap
          );
          M = Q.breakAtStart, kn = Q.openStart, jn = wl.openEnd;
          let rl = this.compositionView(k);
          wl.breakAtStart ? rl.breakAfter = 1 : wl.content.length && rl.merge(rl.length, rl.length, wl.content[0], !1, wl.openStart, 0) && (rl.breakAfter = wl.content[0].breakAfter, wl.content.shift()), Q.content.length && rl.merge(0, 0, Q.content[Q.content.length - 1], !0, 0, Q.openEnd) && Q.content.pop(), Q = Q.content.concat(rl).concat(wl.content);
        } else ({ content: Q, breakAtStart: M, openStart: kn, openEnd: jn } = ll.build(this.view.state.doc, Xe, cn, this.decorations, this.dynamicDecorationMap));
        let { i: Pn, off: Ct } = m.findPos(nn, 1), { i: Wt, off: Mt } = m.findPos(Ie, -1);
        $e(this, Wt, Mt, Pn, Ct, Q, M, kn, jn);
      }
      k && this.fixCompositionDOM(k);
    }
    compositionView(c) {
      let m = new He(c.text.nodeValue);
      m.flags |= 8;
      for (let { deco: k } of c.marks) m = new $n(k, [m], m.length);
      return c = new Ke(), c.append(m, 0), c;
    }
    fixCompositionDOM(c) {
      let m = (Q, pe) => {
        pe.flags = pe.flags | 8 | (pe.children.some((nn) => nn.flags & 7) ? 1 : 0), this.markedForComposition.add(pe);
        let Ie = li.get(Q);
        Ie && Ie != pe && (Ie.dom = null), pe.setDOM(Q);
      }, k = this.childPos(c.range.fromB, 1), M = this.children[k.i];
      m(c.line, M);
      for (let Q = c.marks.length - 1; -1 <= Q; Q--) k = M.childPos(k.off, 1), M = M.children[k.i], m(0 <= Q ? c.marks[Q].node : c.text, M);
    }
    updateSelection(c = !1, m = !1) {
      !c && this.view.observer.selectionRange.focusNode || this.view.observer.readSelectionRange();
      let k = this.view.root.activeElement;
      c = k == this.dom;
      let M = !c && o(this.dom, this.view.observer.selectionRange) && !(k && this.dom.contains(k));
      if (c || m || M) {
        m = this.forceSelection, this.forceSelection = !1;
        var Q = this.view.state.selection.main, pe = this.moveToLine(this.domAtPos(Q.anchor)), Ie = Q.empty ? pe : this.moveToLine(this.domAtPos(Q.head));
        if (X.gecko && Q.empty && !this.hasComposition && pe.node.nodeType == 1 && pe.node.firstChild && (pe.offset == 0 || pe.node.childNodes[pe.offset - 1].contentEditable == "false") && (pe.offset == pe.node.childNodes.length || pe.node.childNodes[pe.offset].contentEditable == "false")) {
          let Xe = document.createTextNode("");
          this.view.observer.ignore(() => pe.node.insertBefore(Xe, pe.node.childNodes[pe.offset] || null)), pe = Ie = new Ji(
            Xe,
            0
          ), m = !0;
        }
        var nn = this.view.observer.selectionRange;
        !m && nn.focusNode && h(pe.node, pe.offset, nn.anchorNode, nn.anchorOffset) && h(Ie.node, Ie.offset, nn.focusNode, nn.focusOffset) || (this.view.observer.ignore(() => {
          var Xe;
          if (Xe = X.android && X.chrome && this.dom.contains(nn.focusNode)) e: {
            for (Xe = nn.focusNode; Xe && Xe != this.dom; Xe = Xe.assignedSlot || Xe.parentNode) if (Xe.nodeType == 1 && Xe.contentEditable == "false") {
              Xe = !0;
              break e;
            }
            Xe = !1;
          }
          if (Xe && (this.dom.blur(), this.dom.focus({ preventScroll: !0 })), Xe = r(this.view.root)) if (Q.empty) {
            if (X.gecko) {
              var cn = pe.node, kn = pe.offset;
              cn = cn.nodeType != 1 ? 0 : (kn && cn.childNodes[kn - 1].contentEditable == "false" ? 1 : 0) | (kn < cn.childNodes.length && cn.childNodes[kn].contentEditable == "false" ? 2 : 0), cn && cn != 3 && (cn = jt(pe.node, pe.offset, cn == 1 ? 1 : -1)) && (pe = new Ji(cn.node, cn.offset));
            }
            Xe.collapse(pe.node, pe.offset), Q.bidiLevel != null && Xe.caretBidiLevel !== void 0 && (Xe.caretBidiLevel = Q.bidiLevel);
          } else if (Xe.extend) {
            Xe.collapse(pe.node, pe.offset);
            try {
              Xe.extend(Ie.node, Ie.offset);
            } catch {
            }
          } else cn = document.createRange(), Q.anchor > Q.head && ([pe, Ie] = [Ie, pe]), cn.setEnd(
            Ie.node,
            Ie.offset
          ), cn.setStart(pe.node, pe.offset), Xe.removeAllRanges(), Xe.addRange(cn);
          M && this.view.root.activeElement == this.dom && (this.dom.blur(), k && k.focus());
        }), this.view.observer.setSelectionRange(pe, Ie)), this.impreciseAnchor = pe.precise ? null : new Ji(nn.anchorNode, nn.anchorOffset), this.impreciseHead = Ie.precise ? null : new Ji(nn.focusNode, nn.focusOffset);
      }
    }
    enforceCursorAssoc() {
      if (!this.hasComposition) {
        var { view: c } = this, m = c.state.selection.main, k = r(c.root), { anchorNode: M, anchorOffset: Q } = c.observer.selectionRange;
        if (k && m.empty && m.assoc && k.modify) {
          var pe = Ke.find(this, m.head);
          if (pe) {
            var Ie = pe.posAtStart;
            m.head != Ie && m.head != Ie + pe.length && (pe = this.coordsAt(m.head, -1), Ie = this.coordsAt(m.head, 1), !pe || !Ie || pe.bottom > Ie.top || (pe = this.domAtPos(m.head + m.assoc), k.collapse(pe.node, pe.offset), k.modify("move", 0 > m.assoc ? "forward" : "backward", "lineboundary"), c.observer.readSelectionRange(), pe = c.observer.selectionRange, c.docView.posFromDOM(pe.anchorNode, pe.anchorOffset) != m.from && k.collapse(M, Q)));
          }
        }
      }
    }
    moveToLine(c) {
      let m = this.dom, k;
      if (c.node != m) return c;
      for (var M = c.offset; !k && M < m.childNodes.length; M++) {
        var Q = li.get(m.childNodes[M]);
        Q instanceof Ke && (k = Q.domAtPos(0));
      }
      for (M = c.offset - 1; !k && 0 <= M; M--) Q = li.get(m.childNodes[M]), Q instanceof Ke && (k = Q.domAtPos(Q.length));
      return k ? new Ji(k.node, k.offset, !0) : c;
    }
    nearest(c) {
      for (; c; ) {
        let m = li.get(c);
        if (m && m.rootView == this) return m;
        c = c.parentNode;
      }
      return null;
    }
    posFromDOM(c, m) {
      let k = this.nearest(c);
      if (!k) throw new RangeError("Trying to find position for a DOM position outside of the document");
      return k.localPosFromDOM(c, m) + k.posAtStart;
    }
    domAtPos(c) {
      let {
        i: m,
        off: k
      } = this.childCursor().findPos(c, -1);
      for (; m < this.children.length - 1 && (c = this.children[m], !(k < c.length || c instanceof Ke)); )
        m++, k = 0;
      return this.children[m].domAtPos(k);
    }
    coordsAt(c, m) {
      let k = null, M = 0;
      for (let Q = this.length, pe = this.children.length - 1; 0 <= pe; pe--) {
        let Ie = this.children[pe], nn = Q - Ie.breakAfter, Xe = nn - Ie.length;
        if (nn < c) break;
        Xe <= c && (Xe < c || Ie.covers(-1)) && (nn > c || Ie.covers(1)) && (!k || Ie instanceof Ke && !(k instanceof Ke && 0 <= m)) && (k = Ie, M = Xe), Q = Xe;
      }
      return k ? k.coordsAt(c - M, m) : null;
    }
    coordsForChar(c) {
      let { i: m, off: k } = this.childPos(
        c,
        1
      );
      if (c = this.children[m], !(c instanceof Ke)) return null;
      for (; c.children.length; ) {
        let { i: Q, off: pe } = c.childPos(k, 1);
        for (; ; Q++) {
          if (Q == c.children.length) return null;
          if ((c = c.children[Q]).length) break;
        }
        k = pe;
      }
      if (!(c instanceof He)) return null;
      var M = Wn.findClusterBreak(c.text, k);
      if (M == k) return null;
      for (c = L(c.dom, k, M).getClientRects(), M = 0; M < c.length; M++) {
        let Q = c[M];
        if (M == c.length - 1 || Q.top < Q.bottom && Q.left < Q.right) return Q;
      }
      return null;
    }
    measureVisibleLineHeights(c) {
      let m = [], { from: k, to: M } = c;
      c = this.view.contentDOM.clientWidth;
      let Q = c > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1, pe = -1, Ie = this.view.textDirection == l.Direction.LTR;
      for (let cn = 0, kn = 0; kn < this.children.length; kn++) {
        let jn = this.children[kn], Pn = cn + jn.length;
        if (Pn > M) break;
        if (cn >= k) {
          var nn = jn.dom.getBoundingClientRect();
          if (m.push(nn.height), Q) {
            var Xe = jn.dom.lastChild;
            Xe = Xe ? a(Xe) : [], Xe.length && (Xe = Xe[Xe.length - 1], nn = Ie ? Xe.right - nn.left : nn.right - Xe.left, nn > pe && (pe = nn, this.minWidth = c, this.minWidthFrom = cn, this.minWidthTo = Pn));
          }
        }
        cn = Pn + jn.breakAfter;
      }
      return m;
    }
    textDirectionAt(c) {
      return { i: c } = this.childPos(c, 1), getComputedStyle(this.children[c].dom).direction == "rtl" ? l.Direction.RTL : l.Direction.LTR;
    }
    measureTextSize() {
      for (let Q of this.children) if (Q instanceof Ke) {
        let pe = Q.measureTextSize();
        if (pe) return pe;
      }
      let c = document.createElement("div"), m, k, M;
      return c.className = "cm-line", c.style.width = "99999px", c.style.position = "absolute", c.textContent = "abc def ghi jkl mno pqr stu", this.view.observer.ignore(() => {
        this.dom.appendChild(c);
        let Q = a(c.firstChild)[0];
        m = c.getBoundingClientRect().height, k = Q ? Q.width / 27 : 7, M = Q ? Q.height : m, c.remove();
      }), { lineHeight: m, charWidth: k, textHeight: M };
    }
    childCursor(c = this.length) {
      let m = this.children.length;
      return m && (c -= this.children[--m].length), new cc(this.children, c, m);
    }
    computeBlockGapDeco() {
      let c = [], m = this.view.viewState;
      for (let k = 0, M = 0; ; M++) {
        let Q = M == m.viewports.length ? null : m.viewports[M], pe = Q ? Q.from - 1 : this.length;
        if (pe > k) {
          let Ie = (m.lineBlockAt(pe).bottom - m.lineBlockAt(k).top) / this.view.scaleY;
          c.push(On.replace({ widget: new Rg(Ie), block: !0, inclusive: !0, isBlockGap: !0 }).range(
            k,
            pe
          ));
        }
        if (!Q) break;
        k = Q.to + 1;
      }
      return On.set(c);
    }
    updateDeco() {
      let c = this.view.state.facet(fs).map((m, k) => (this.dynamicDecorationMap[k] = typeof m == "function") ? m(this.view) : m);
      for (let m = c.length; m < c.length + 3; m++) this.dynamicDecorationMap[m] = !1;
      return this.decorations = [...c, this.computeBlockGapDeco(), this.view.viewState.lineGapDeco];
    }
    scrollIntoView(c) {
      var { range: m } = c, k = this.coordsAt(m.head, m.empty ? m.assoc : m.head > m.anchor ? -1 : 1), M;
      if (k) {
        !m.empty && (M = this.coordsAt(m.anchor, m.anchor > m.head ? -1 : 1)) && (k = { left: Math.min(
          k.left,
          M.left
        ), top: Math.min(k.top, M.top), right: Math.max(k.right, M.right), bottom: Math.max(k.bottom, M.bottom) }), M = Fe(this.view);
        var Q = this.view.scrollDOM;
        k = { left: k.left - M.left, top: k.top - M.top, right: k.right + M.right, bottom: k.bottom + M.bottom }, m = m.head < m.anchor ? -1 : 1, M = c.x;
        var pe = c.y, Ie = c.xMargin;
        c = c.yMargin;
        var nn = this.view.textDirection == l.Direction.LTR, Xe = Q.ownerDocument, cn = Xe.defaultView || window;
        for (let rl = Q, _i = !1; rl && !_i; ) if (rl.nodeType == 1) {
          Q = rl == Xe.body;
          let Ci = 1;
          var kn = 1;
          if (Q)
            var jn = 0, Pn = cn.innerWidth, Ct = 0, Wt = cn.innerHeight;
          else {
            if (/^(fixed|sticky)$/.test(getComputedStyle(rl).position) && (_i = !0), rl.scrollHeight <= rl.clientHeight && rl.scrollWidth <= rl.clientWidth) {
              rl = rl.assignedSlot || rl.parentNode;
              continue;
            }
            var Mt = rl.getBoundingClientRect();
            Ci = Mt.width / rl.offsetWidth, kn = Mt.height / rl.offsetHeight, jn = Mt.left, Pn = Mt.left + rl.clientWidth * Ci, Ct = Mt.top, Wt = Mt.top + rl.clientHeight * kn;
          }
          var wl = Mt = 0;
          if (pe == "nearest" ? k.top < Ct ? (wl = -(Ct - k.top + c), 0 < m && k.bottom > Wt + wl && (wl = k.bottom - Wt + wl + c)) : k.bottom > Wt && (wl = k.bottom - Wt + c, 0 > m && k.top - wl < Ct && (wl = -(Ct + wl - k.top + c))) : (wl = k.bottom - k.top, Wt -= Ct, wl = (pe == "center" && wl <= Wt ? k.top + wl / 2 - Wt / 2 : pe == "start" || pe == "center" && 0 > m ? k.top - c : k.bottom - Wt + c) - Ct), M == "nearest" ? k.left < jn ? (Mt = -(jn - k.left + Ie), 0 < m && k.right > Pn + Mt && (Mt = k.right - Pn + Mt + Ie)) : k.right > Pn && (Mt = k.right - Pn + Ie, 0 > m && k.left < jn + Mt && (Mt = -(jn + Mt - k.left + Ie))) : Mt = (M == "center" ? k.left + (k.right - k.left) / 2 - (Pn - jn) / 2 : M == "start" == nn ? k.left - Ie : k.right - (Pn - jn) + Ie) - jn, (Mt || wl) && (Q ? cn.scrollBy(Mt, wl) : (Pn = jn = 0, wl && (Pn = rl.scrollTop, rl.scrollTop += wl / kn, Pn = (rl.scrollTop - Pn) * kn), Mt && (kn = rl.scrollLeft, rl.scrollLeft += Mt / Ci, jn = (rl.scrollLeft - kn) * Ci), k = { left: k.left - jn, top: k.top - Pn, right: k.right - jn, bottom: k.bottom - Pn }, jn && 1 > Math.abs(jn - Mt) && (M = "nearest"), Pn && 1 > Math.abs(Pn - wl) && (pe = "nearest"))), Q) break;
          rl = rl.assignedSlot || rl.parentNode;
        } else if (rl.nodeType == 11) rl = rl.host;
        else break;
      }
    }
  }
  class Rg extends wn {
    constructor(c) {
      super(), this.height = c;
    }
    toDOM() {
      let c = document.createElement("div");
      return this.updateDOM(c), c;
    }
    eq(c) {
      return c.height == this.height;
    }
    updateDOM(c) {
      return c.style.height = this.height + "px", !0;
    }
    get estimatedHeight() {
      return this.height;
    }
  }
  let $p = class {
    constructor() {
      this.changes = [];
    }
    compareRange(N, c) {
      B(N, c, this.changes);
    }
    comparePoint(N, c) {
      B(N, c, this.changes);
    }
  };
  class N1 {
    setSelectionOrigin(c) {
      this.lastSelectionOrigin = c, this.lastSelectionTime = Date.now();
    }
    constructor(c) {
      this.view = c, this.lastScrollLeft = this.lastScrollTop = this.lastFocusTime = this.lastTouchTime = this.lastKeyTime = this.lastKeyCode = 0, this.pendingIOSKey = void 0, this.lastSelectionOrigin = null, this.lastContextMenu = this.lastEscPress = this.lastSelectionTime = 0, this.scrollHandlers = [], this.handlers = /* @__PURE__ */ Object.create(null), this.composing = -1, this.compositionFirstChange = null, this.compositionEndedAt = 0, this.compositionPendingChange = this.compositionPendingKey = !1, this.mouseSelection = null, this.handleEvent = this.handleEvent.bind(this), this.notifiedFocused = c.hasFocus, X.safari && c.contentDOM.addEventListener("input", () => null), X.gecko && Pr(c.contentDOM.ownerDocument);
    }
    handleEvent(c) {
      wi(this.view, c) && !this.ignoreDuringComposition(c) && (c.type == "keydown" && this.keydown(c) || this.runHandlers(c.type, c));
    }
    runHandlers(c, m) {
      if (c = this.handlers[c]) {
        for (let k of c.observers) k(this.view, m);
        for (let k of c.handlers) {
          if (m.defaultPrevented) break;
          if (k(this.view, m)) {
            m.preventDefault();
            break;
          }
        }
      }
    }
    ensureHandlers(c) {
      c = Rr(c);
      let m = this.handlers, k = this.view.contentDOM;
      for (let M in c) if (M != "scroll") {
        let Q = !c[M].handlers.length, pe = m[M];
        pe && Q != !pe.handlers.length && (k.removeEventListener(M, this.handleEvent), pe = null), pe || k.addEventListener(M, this.handleEvent, { passive: Q });
      }
      for (let M in m) M == "scroll" || c[M] || k.removeEventListener(M, this.handleEvent);
      this.handlers = c;
    }
    keydown(c) {
      if (this.lastKeyCode = c.keyCode, this.lastKeyTime = Date.now(), c.keyCode == 9 && Date.now() < this.lastEscPress + 2e3) return !0;
      if (c.keyCode != 27 && 0 > Ng.indexOf(c.keyCode) && (this.view.inputState.lastEscPress = 0), X.android && X.chrome && !c.synthetic && (c.keyCode == 13 || c.keyCode == 8)) return this.view.observer.delayAndroidKey(c.key, c.keyCode), !0;
      let m;
      return X.ios && !c.synthetic && !c.altKey && !c.metaKey && ((m = Lp.find((k) => k.keyCode == c.keyCode)) && !c.ctrlKey || -1 < "dthko".indexOf(c.key) && c.ctrlKey && !c.shiftKey) ? (this.pendingIOSKey = m || c, setTimeout(() => this.flushIOSKey(), 250), !0) : (c.keyCode != 229 && this.view.observer.forceFlush(), !1);
    }
    flushIOSKey() {
      let c = this.pendingIOSKey;
      return c ? (this.pendingIOSKey = void 0, G(this.view.contentDOM, c.key, c.keyCode)) : !1;
    }
    ignoreDuringComposition(c) {
      return /^key/.test(c.type) ? 0 < this.composing ? !0 : X.safari && !X.ios && this.compositionPendingKey && 100 > Date.now() - this.compositionEndedAt ? (this.compositionPendingKey = !1, !0) : !1 : !1;
    }
    startMouseSelection(c) {
      this.mouseSelection && this.mouseSelection.destroy(), this.mouseSelection = c;
    }
    update(c) {
      this.mouseSelection && this.mouseSelection.update(c), c.transactions.length && (this.lastKeyCode = this.lastSelectionTime = 0);
    }
    destroy() {
      this.mouseSelection && this.mouseSelection.destroy();
    }
  }
  const Lp = [{ key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" }, { key: "Enter", keyCode: 13, inputType: "insertParagraph" }, { key: "Enter", keyCode: 13, inputType: "insertLineBreak" }, { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }], Ng = [16, 17, 18, 20, 91, 92, 224, 225];
  class Cg {
    constructor(c, m, k, M) {
      this.view = c, this.startEvent = m, this.style = k, this.mustSelect = M, this.scrollSpeed = { x: 0, y: 0 }, this.scrolling = -1, this.lastEvent = m, this.scrollParent = R(c.contentDOM), this.atoms = c.state.facet(od).map((Q) => Q(c)), k = c.contentDOM.ownerDocument, k.addEventListener("mousemove", this.move = this.move.bind(this)), k.addEventListener("mouseup", this.up = this.up.bind(this)), this.extend = m.shiftKey, this.multiple = c.state.facet(Wn.EditorState.allowMultipleSelections) && ql(c, m), this.dragging = Mr(c, m) && jl(m) == 1 ? null : !1;
    }
    start(c) {
      this.dragging === !1 && this.select(c);
    }
    move(c) {
      var m;
      if (c.buttons == 0) return this.destroy();
      var k;
      if (!(k = this.dragging) && (k = this.dragging == null) && (k = this.startEvent, k = 10 > Math.max(Math.abs(k.clientX - c.clientX), Math.abs(k.clientY - c.clientY))), !k) {
        this.select(this.lastEvent = c);
        var M = k = 0, Q = ((m = this.scrollParent) === null || m === void 0 ? void 0 : m.getBoundingClientRect()) || { left: 0, top: 0, right: this.view.win.innerWidth, bottom: this.view.win.innerHeight };
        m = Fe(this.view), c.clientX - m.left <= Q.left + 6 ? k = -(0.7 * Math.max(0, Q.left - c.clientX) + 8) : c.clientX + m.right >= Q.right - 6 && (k = 0.7 * Math.max(0, c.clientX - Q.right) + 8), c.clientY - m.top <= Q.top + 6 ? M = -(0.7 * Math.max(0, Q.top - c.clientY) + 8) : c.clientY + m.bottom >= Q.bottom - 6 && (M = 0.7 * Math.max(0, c.clientY - Q.bottom) + 8), this.setScrollSpeed(k, M);
      }
    }
    up(c) {
      this.dragging == null && this.select(this.lastEvent), this.dragging || c.preventDefault(), this.destroy();
    }
    destroy() {
      this.setScrollSpeed(0, 0);
      let c = this.view.contentDOM.ownerDocument;
      c.removeEventListener(
        "mousemove",
        this.move
      ), c.removeEventListener("mouseup", this.up), this.view.inputState.mouseSelection = null;
    }
    setScrollSpeed(c, m) {
      this.scrollSpeed = { x: c, y: m }, c || m ? 0 > this.scrolling && (this.scrolling = setInterval(() => this.scroll(), 50)) : -1 < this.scrolling && (clearInterval(this.scrolling), this.scrolling = -1);
    }
    scroll() {
      this.scrollParent ? (this.scrollParent.scrollLeft += this.scrollSpeed.x, this.scrollParent.scrollTop += this.scrollSpeed.y) : this.view.win.scrollBy(this.scrollSpeed.x, this.scrollSpeed.y), this.dragging === !1 && this.select(this.lastEvent);
    }
    skipAtoms(c) {
      let m = null;
      for (let M = 0; M < c.ranges.length; M++) {
        let Q = c.ranges[M], pe = null;
        if (Q.empty) {
          var k = St(this.atoms, Q.from, 0);
          k != Q.from && (pe = Wn.EditorSelection.cursor(k, -1));
        } else {
          k = St(this.atoms, Q.from, -1);
          let Ie = St(this.atoms, Q.to, 1);
          (k != Q.from || Ie != Q.to) && (pe = Wn.EditorSelection.range(Q.from == Q.anchor ? k : Ie, Q.from == Q.head ? k : Ie));
        }
        pe && (m ||= c.ranges.slice(), m[M] = pe);
      }
      return m ? Wn.EditorSelection.create(m, c.mainIndex) : c;
    }
    select(c) {
      let { view: m } = this;
      c = this.skipAtoms(this.style.get(c, this.extend, this.multiple)), (this.mustSelect || !c.eq(m.state.selection) || c.main.assoc != m.state.selection.main.assoc && this.dragging === !1) && this.view.dispatch({ selection: c, userEvent: "select.pointer" }), this.mustSelect = !1;
    }
    update(c) {
      c.docChanged && this.dragging && (this.dragging = this.dragging.map(c.changes)), this.style.update(c) && setTimeout(() => this.select(this.lastEvent), 20);
    }
  }
  const ro = /* @__PURE__ */ Object.create(null), ds = /* @__PURE__ */ Object.create(null), Mg = X.ie && 15 > X.ie_version || X.ios && 604 > X.webkit_version;
  ds.scroll = (N) => {
    N.inputState.lastScrollTop = N.scrollDOM.scrollTop, N.inputState.lastScrollLeft = N.scrollDOM.scrollLeft;
  }, ro.keydown = (N, c) => (N.inputState.setSelectionOrigin("select"), c.keyCode == 27 && (N.inputState.lastEscPress = Date.now()), !1), ds.touchstart = (N, c) => {
    N.inputState.lastTouchTime = Date.now(), N.inputState.setSelectionOrigin("select.pointer");
  }, ds.touchmove = (N) => {
    N.inputState.setSelectionOrigin("select.pointer");
  }, ro.mousedown = (N, c) => {
    if (N.observer.flush(), N.inputState.lastTouchTime > Date.now() - 2e3) return !1;
    var m = null;
    for (var k of N.state.facet(yu)) if (m = k(N, c)) break;
    return m || c.button != 0 || (m = Sl(N, c)), m && (k = !N.hasFocus, N.inputState.startMouseSelection(new Cg(N, c, m, k)), k && N.observer.ignore(() => F(N.contentDOM)), m = N.inputState.mouseSelection) ? (m.start(c), m.dragging === !1) : !1;
  };
  const Pg = X.ie && 11 >= X.ie_version;
  let Bp = null, fd = 0, dd = 0;
  ro.dragstart = (N, c) => {
    let { selection: { main: m } } = N.state, { mouseSelection: k } = N.inputState;
    return k && (k.dragging = m), c.dataTransfer && (c.dataTransfer.setData("Text", N.state.sliceDoc(m.from, m.to)), c.dataTransfer.effectAllowed = "copyMove"), !1;
  }, ro.drop = (N, c) => {
    if (!c.dataTransfer) return !1;
    if (N.state.readOnly) return !0;
    let m = c.dataTransfer.files;
    if (m && m.length) {
      let M = Array(m.length), Q = 0, pe = () => {
        ++Q == m.length && gl(N, c, M.filter((Ie) => Ie != null).join(N.state.lineBreak), !1);
      };
      for (let Ie = 0; Ie < m.length; Ie++) {
        let nn = new FileReader();
        nn.onerror = pe, nn.onload = () => {
          /[\x00-\x08\x0e-\x1f]{2}/.test(nn.result) || (M[Ie] = nn.result), pe();
        }, nn.readAsText(m[Ie]);
      }
      return !0;
    }
    let k = c.dataTransfer.getData("Text");
    return k ? (gl(N, c, k, !0), !0) : !1;
  }, ro.paste = (N, c) => N.state.readOnly ? !0 : (N.observer.flush(), (c = Mg ? null : c.clipboardData) ? (tl(N, c.getData("text/plain") || c.getData("text/uri-text")), !0) : (bl(N), !1));
  let pd = null;
  ro.copy = ro.cut = (N, c) => {
    var m = N.state;
    let k = [], M = [];
    var Q = !1;
    for (var pe of m.selection.ranges) pe.empty || (k.push(m.sliceDoc(pe.from, pe.to)), M.push(pe));
    if (!k.length) {
      Q = -1;
      for (let { from: cn } of m.selection.ranges) pe = m.doc.lineAt(cn), pe.number > Q && (k.push(pe.text), M.push({ from: pe.from, to: Math.min(m.doc.length, pe.to + 1) })), Q = pe.number;
      Q = !0;
    }
    m = { text: k.join(m.lineBreak), ranges: M, linewise: Q };
    let { text: Ie, ranges: nn, linewise: Xe } = m;
    return !Ie && !Xe ? !1 : (pd = Xe ? Ie : null, c.type != "cut" || N.state.readOnly || N.dispatch({ changes: nn, scrollIntoView: !0, userEvent: "delete.cut" }), (c = Mg ? null : c.clipboardData) ? (c.clearData(), c.setData("text/plain", Ie), !0) : (jr(N, Ie), !1));
  };
  const $g = Wn.Annotation.define();
  ds.focus = (N) => {
    N.inputState.lastFocusTime = Date.now(), N.scrollDOM.scrollTop || !N.inputState.lastScrollTop && !N.inputState.lastScrollLeft || (N.scrollDOM.scrollTop = N.inputState.lastScrollTop, N.scrollDOM.scrollLeft = N.inputState.lastScrollLeft), nl(N);
  }, ds.blur = (N) => {
    N.observer.clearSelectionRange(), nl(N);
  }, ds.compositionstart = ds.compositionupdate = (N) => {
    N.inputState.compositionFirstChange == null && (N.inputState.compositionFirstChange = !0), 0 > N.inputState.composing && (N.inputState.composing = 0);
  }, ds.compositionend = (N) => {
    N.inputState.composing = -1, N.inputState.compositionEndedAt = Date.now(), N.inputState.compositionPendingKey = !0, N.inputState.compositionPendingChange = 0 < N.observer.pendingRecords().length, N.inputState.compositionFirstChange = null, X.chrome && X.android ? N.observer.flushSoon() : N.inputState.compositionPendingChange ? Promise.resolve().then(() => N.observer.flush()) : setTimeout(() => {
      0 > N.inputState.composing && N.docView.hasComposition && N.update([]);
    }, 50);
  }, ds.contextmenu = (N) => {
    N.inputState.lastContextMenu = Date.now();
  }, ro.beforeinput = (N, c) => {
    var m;
    let k;
    if (X.chrome && X.android && (k = Lp.find((M) => M.inputType == c.inputType)) && (N.observer.delayAndroidKey(k.key, k.keyCode), k.key == "Backspace" || k.key == "Delete")) {
      let M = ((m = window.visualViewport) === null || m === void 0 ? void 0 : m.height) || 0;
      setTimeout(() => {
        var Q;
        (((Q = window.visualViewport) === null || Q === void 0 ? void 0 : Q.height) || 0) > M + 10 && N.hasFocus && (N.contentDOM.blur(), N.focus());
      }, 100);
    }
    return !1;
  };
  const md = /* @__PURE__ */ new Set(), gd = ["pre-wrap", "normal", "pre-line", "break-spaces"];
  class Lg {
    constructor(c) {
      this.lineWrapping = c, this.doc = Wn.Text.empty, this.heightSamples = {}, this.lineHeight = 14, this.charWidth = 7, this.textHeight = 14, this.lineLength = 30, this.heightChanged = !1;
    }
    heightForGap(c, m) {
      let k = this.doc.lineAt(m).number - this.doc.lineAt(c).number + 1;
      return this.lineWrapping && (k += Math.max(0, Math.ceil((m - c - k * this.lineLength * 0.5) / this.lineLength))), this.lineHeight * k;
    }
    heightForLine(c) {
      return this.lineWrapping ? (1 + Math.max(0, Math.ceil((c - this.lineLength) / (this.lineLength - 5)))) * this.lineHeight : this.lineHeight;
    }
    setDoc(c) {
      return this.doc = c, this;
    }
    mustRefreshForWrapping(c) {
      return -1 < gd.indexOf(c) != this.lineWrapping;
    }
    mustRefreshForHeights(c) {
      let m = !1;
      for (let k = 0; k < c.length; k++) {
        let M = c[k];
        0 > M ? k++ : this.heightSamples[Math.floor(10 * M)] || (m = !0, this.heightSamples[Math.floor(10 * M)] = !0);
      }
      return m;
    }
    refresh(c, m, k, M, Q, pe) {
      let Ie = -1 < gd.indexOf(c);
      if (c = Math.round(m) != Math.round(this.lineHeight) || this.lineWrapping != Ie, this.lineWrapping = Ie, this.lineHeight = m, this.charWidth = k, this.textHeight = M, this.lineLength = Q, c) for (this.heightSamples = {}, m = 0; m < pe.length; m++) k = pe[m], 0 > k ? m++ : this.heightSamples[Math.floor(10 * k)] = !0;
      return c;
    }
  }
  class Fp {
    constructor(c, m) {
      this.from = c, this.heights = m, this.index = 0;
    }
    get more() {
      return this.index < this.heights.length;
    }
  }
  class Gi {
    constructor(c, m, k, M, Q) {
      this.from = c, this.length = m, this.top = k, this.height = M, this._content = Q;
    }
    get type() {
      return typeof this._content == "number" ? l.BlockType.Text : Array.isArray(this._content) ? this._content : this._content.type;
    }
    get to() {
      return this.from + this.length;
    }
    get bottom() {
      return this.top + this.height;
    }
    get widget() {
      return this._content instanceof Ot ? this._content.widget : null;
    }
    get widgetLineBreaks() {
      return typeof this._content == "number" ? this._content : 0;
    }
    join(c) {
      let m = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(c._content) ? c._content : [c]);
      return new Gi(this.from, this.length + c.length, this.top, this.height + c.height, m);
    }
  }
  var bi;
  (function(N) {
    N[N.ByPos = 0] = "ByPos", N[N.ByHeight = 1] = "ByHeight", N[N.ByPosNoHeight = 2] = "ByPosNoHeight";
  })(bi ||= {});
  class xu {
    constructor(c, m, k = 2) {
      this.length = c, this.height = m, this.flags = k;
    }
    get outdated() {
      return 0 < (this.flags & 2);
    }
    set outdated(c) {
      this.flags = (c ? 2 : 0) | this.flags & -3;
    }
    setHeight(c, m) {
      this.height != m && (1e-3 < Math.abs(this.height - m) && (c.heightChanged = !0), this.height = m);
    }
    replace(c, m, k) {
      return xu.of(k);
    }
    decomposeLeft(c, m) {
      m.push(this);
    }
    decomposeRight(c, m) {
      m.push(this);
    }
    applyChanges(c, m, k, M) {
      let Q = this, pe = k.doc;
      for (let nn = M.length - 1; 0 <= nn; nn--) {
        let { fromA: Xe, toA: cn, fromB: kn, toB: jn } = M[nn];
        var Ie = Q.lineAt(Xe, bi.ByPosNoHeight, k.setDoc(m), 0, 0);
        let Pn = Ie.to >= cn ? Ie : Q.lineAt(cn, bi.ByPosNoHeight, k, 0, 0);
        for (jn += Pn.to - cn, cn = Pn.to; 0 < nn && Ie.from <= M[nn - 1].toA; ) Xe = M[nn - 1].fromA, kn = M[nn - 1].fromB, nn--, Xe < Ie.from && (Ie = Q.lineAt(Xe, bi.ByPosNoHeight, k, 0, 0));
        kn += Ie.from - Xe, Xe = Ie.from, Ie = L2.build(k.setDoc(pe), c, kn, jn), Q = Q.replace(Xe, cn, Ie);
      }
      return Q.updateHeight(k, 0);
    }
    static empty() {
      return new io(0, 0);
    }
    static of(c) {
      if (c.length == 1) return c[0];
      let m = 0, k = c.length;
      var M = 0;
      let Q = 0;
      for (; ; ) if (m == k) if (M > 2 * Q) {
        var pe = c[m - 1];
        pe.break ? c.splice(--m, 1, pe.left, null, pe.right) : c.splice(--m, 1, pe.left, pe.right), k += 1 + pe.break, M -= pe.size;
      } else if (Q > 2 * M) pe = c[k], pe.break ? c.splice(k, 1, pe.left, null, pe.right) : c.splice(k, 1, pe.left, pe.right), k += 2 + pe.break, Q -= pe.size;
      else break;
      else M < Q ? (pe = c[m++]) && (M += pe.size) : (pe = c[--k]) && (Q += pe.size);
      return M = 0, c[m - 1] == null ? (M = 1, m--) : c[m] == null && (M = 1, k++), new fj(xu.of(c.slice(0, m)), M, xu.of(c.slice(k)));
    }
  }
  xu.prototype.size = 1;
  class Vp extends xu {
    constructor(c, m, k) {
      super(
        c,
        m
      ), this.deco = k;
    }
    blockAt(c, m, k, M) {
      return new Gi(M, this.length, k, this.height, this.deco || 0);
    }
    lineAt(c, m, k, M, Q) {
      return this.blockAt(0, k, M, Q);
    }
    forEachLine(c, m, k, M, Q, pe) {
      c <= Q + this.length && m >= Q && pe(this.blockAt(0, k, M, Q));
    }
    updateHeight(c, m = 0, k, M) {
      return M && M.from <= m && M.more && this.setHeight(c, M.heights[M.index++]), this.outdated = !1, this;
    }
    toString() {
      return `block(${this.length})`;
    }
  }
  class io extends Vp {
    constructor(c, m) {
      super(c, m, null), this.breaks = this.widgetHeight = this.collapsed = 0;
    }
    blockAt(c, m, k, M) {
      return new Gi(
        M,
        this.length,
        k,
        this.height,
        this.breaks
      );
    }
    replace(c, m, k) {
      return c = k[0], k.length == 1 && (c instanceof io || c instanceof Ks && c.flags & 4) && 10 > Math.abs(this.length - c.length) ? (c instanceof Ks ? c = new io(c.length, this.height) : c.height = this.height, this.outdated || (c.outdated = !1), c) : xu.of(k);
    }
    updateHeight(c, m = 0, k = !1, M) {
      return M && M.from <= m && M.more ? this.setHeight(c, M.heights[M.index++]) : (k || this.outdated) && this.setHeight(c, Math.max(this.widgetHeight, c.heightForLine(this.length - this.collapsed)) + this.breaks * c.lineHeight), this.outdated = !1, this;
    }
    toString() {
      return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
    }
  }
  class Ks extends xu {
    constructor(c) {
      super(c, 0);
    }
    heightMetrics(c, m) {
      let k = c.doc.lineAt(m).number;
      m = c.doc.lineAt(m + this.length).number;
      let M = m - k + 1, Q = 0;
      if (c.lineWrapping) {
        let pe = Math.min(this.height, c.lineHeight * M);
        c = pe / M, this.length > M + 1 && (Q = (this.height - pe) / (this.length - M - 1));
      } else c = this.height / M;
      return { firstLine: k, lastLine: m, perLine: c, perChar: Q };
    }
    blockAt(c, m, k, M) {
      let {
        firstLine: Q,
        lastLine: pe,
        perLine: Ie,
        perChar: nn
      } = this.heightMetrics(m, M);
      if (m.lineWrapping) return m = m.doc.lineAt(M + Math.round(Math.max(0, Math.min(1, (c - k) / this.height)) * this.length)), M = Ie + m.length * nn, new Gi(m.from, m.length, Math.max(k, c - M / 2), M, 0);
      c = Math.max(0, Math.min(pe - Q, Math.floor((c - k) / Ie)));
      let { from: Xe, length: cn } = m.doc.line(Q + c);
      return new Gi(Xe, cn, k + Ie * c, Ie, 0);
    }
    lineAt(c, m, k, M, Q) {
      if (m == bi.ByHeight) return this.blockAt(c, k, M, Q);
      if (m == bi.ByPosNoHeight) {
        let { from: Xe, to: cn } = k.doc.lineAt(c);
        return new Gi(Xe, cn - Xe, 0, 0, 0);
      }
      let {
        firstLine: pe,
        perLine: Ie,
        perChar: nn
      } = this.heightMetrics(k, Q);
      return c = k.doc.lineAt(c), m = Ie + c.length * nn, k = c.number - pe, new Gi(c.from, c.length, Math.max(M, Math.min(M + Ie * k + nn * (c.from - Q - k), M + this.height - m)), m, 0);
    }
    forEachLine(c, m, k, M, Q, pe) {
      c = Math.max(c, Q), m = Math.min(m, Q + this.length);
      let { firstLine: Ie, perLine: nn, perChar: Xe } = this.heightMetrics(k, Q);
      for (let kn = c, jn = M; kn <= m; ) {
        if (M = k.doc.lineAt(kn), kn == c) {
          var cn = M.number - Ie;
          jn += nn * cn + Xe * (c - Q - cn);
        }
        cn = nn + Xe * M.length, pe(new Gi(M.from, M.length, jn, cn, 0)), jn += cn, kn = M.to + 1;
      }
    }
    replace(c, m, k) {
      if (m = this.length - m, 0 < m) {
        let M = k[k.length - 1];
        M instanceof Ks ? k[k.length - 1] = new Ks(M.length + m) : k.push(null, new Ks(m - 1));
      }
      return 0 < c && (m = k[0], m instanceof Ks ? k[0] = new Ks(c + m.length) : k.unshift(new Ks(c - 1), null)), xu.of(k);
    }
    decomposeLeft(c, m) {
      m.push(new Ks(c - 1), null);
    }
    decomposeRight(c, m) {
      m.push(null, new Ks(this.length - c - 1));
    }
    updateHeight(c, m = 0, k = !1, M) {
      let Q = m + this.length;
      if (M && M.from <= m + this.length && M.more) {
        let Ie = [], nn = Math.max(m, M.from);
        for (k = -1, M.from > m && Ie.push(new Ks(M.from - m - 1).updateHeight(c, m)); nn <= Q && M.more; ) {
          let Xe = c.doc.lineAt(nn).length;
          Ie.length && Ie.push(null);
          var pe = M.heights[M.index++];
          k == -1 ? k = pe : 1e-3 <= Math.abs(pe - k) && (k = -2), pe = new io(Xe, pe), pe.outdated = !1, Ie.push(pe), nn += Xe + 1;
        }
        return nn <= Q && Ie.push(null, new Ks(Q - nn).updateHeight(c, nn)), M = xu.of(Ie), (0 > k || 1e-3 <= Math.abs(M.height - this.height) || 1e-3 <= Math.abs(k - this.heightMetrics(c, m).perLine)) && (c.heightChanged = !0), M;
      }
      return (k || this.outdated) && (this.setHeight(c, c.heightForGap(m, m + this.length)), this.outdated = !1), this;
    }
    toString() {
      return `gap(${this.length})`;
    }
  }
  class fj extends xu {
    constructor(c, m, k) {
      super(c.length + m + k.length, c.height + k.height, m | (c.outdated || k.outdated ? 2 : 0)), this.left = c, this.right = k, this.size = c.size + k.size;
    }
    get break() {
      return this.flags & 1;
    }
    blockAt(c, m, k, M) {
      let Q = k + this.left.height;
      return c < Q ? this.left.blockAt(c, m, k, M) : this.right.blockAt(c, m, Q, M + this.left.length + this.break);
    }
    lineAt(c, m, k, M, Q) {
      let pe = M + this.left.height, Ie = Q + this.left.length + this.break, nn = m == bi.ByHeight ? c < pe : c < Ie;
      return c = nn ? this.left.lineAt(c, m, k, M, Q) : this.right.lineAt(c, m, k, pe, Ie), this.break || (nn ? c.to < Ie : c.from > Ie) ? c : (m = m == bi.ByPosNoHeight ? bi.ByPosNoHeight : bi.ByPos, nn ? c.join(this.right.lineAt(Ie, m, k, pe, Ie)) : this.left.lineAt(Ie, m, k, M, Q).join(c));
    }
    forEachLine(c, m, k, M, Q, pe) {
      let Ie = M + this.left.height, nn = Q + this.left.length + this.break;
      if (this.break) c < nn && this.left.forEachLine(c, m, k, M, Q, pe), m >= nn && this.right.forEachLine(c, m, k, Ie, nn, pe);
      else {
        let Xe = this.lineAt(nn, bi.ByPos, k, M, Q);
        c < Xe.from && this.left.forEachLine(c, Xe.from - 1, k, M, Q, pe), Xe.to >= c && Xe.from <= m && pe(Xe), m > Xe.to && this.right.forEachLine(Xe.to + 1, m, k, Ie, nn, pe);
      }
    }
    replace(c, m, k) {
      var M = this.left.length + this.break;
      if (m < M) return this.balanced(this.left.replace(c, m, k), this.right);
      if (c > this.left.length) return this.balanced(this.left, this.right.replace(c - M, m - M, k));
      M = [], 0 < c && this.decomposeLeft(c, M);
      let Q = M.length;
      for (let pe of k) M.push(pe);
      return 0 < c && ii(M, Q - 1), m < this.length && (c = M.length, this.decomposeRight(m, M), ii(M, c)), xu.of(M);
    }
    decomposeLeft(c, m) {
      let k = this.left.length;
      if (c <= k) return this.left.decomposeLeft(c, m);
      m.push(this.left), this.break && (k++, c >= k && m.push(null)), c > k && this.right.decomposeLeft(
        c - k,
        m
      );
    }
    decomposeRight(c, m) {
      let k = this.left.length, M = k + this.break;
      if (c >= M) return this.right.decomposeRight(c - M, m);
      c < k && this.left.decomposeRight(c, m), this.break && c < M && m.push(null), m.push(this.right);
    }
    balanced(c, m) {
      return c.size > 2 * m.size || m.size > 2 * c.size ? xu.of(this.break ? [c, null, m] : [c, m]) : (this.left = c, this.right = m, this.height = c.height + m.height, this.outdated = c.outdated || m.outdated, this.size = c.size + m.size, this.length = c.length + this.break + m.length, this);
    }
    updateHeight(c, m = 0, k = !1, M) {
      let { left: Q, right: pe } = this, Ie = m + Q.length + this.break, nn = null;
      return M && M.from <= m + Q.length && M.more ? nn = Q = Q.updateHeight(c, m, k, M) : Q.updateHeight(c, m, k), M && M.from <= Ie + pe.length && M.more ? nn = pe = pe.updateHeight(c, Ie, k, M) : pe.updateHeight(c, Ie, k), nn ? this.balanced(Q, pe) : (this.height = this.left.height + this.right.height, this.outdated = !1, this);
    }
    toString() {
      return this.left + (this.break ? " " : "-") + this.right;
    }
  }
  class L2 {
    constructor(c, m) {
      this.pos = c, this.oracle = m, this.nodes = [], this.lineEnd = this.lineStart = -1, this.covering = null, this.writtenTo = c;
    }
    get isCovered() {
      return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
    }
    span(c, m) {
      if (-1 < this.lineStart) {
        c = Math.min(m, this.lineEnd);
        let k = this.nodes[this.nodes.length - 1];
        k instanceof io ? k.length += c - this.pos : (c > this.pos || !this.isCovered) && this.nodes.push(new io(c - this.pos, -1)), this.writtenTo = c, m > c && (this.nodes.push(null), this.writtenTo++, this.lineStart = -1);
      }
      this.pos = m;
    }
    point(c, m, k) {
      if (c < m || k.heightRelevant) {
        let M = k.widget ? k.widget.estimatedHeight : 0, Q = k.widget ? k.widget.lineBreaks : 0;
        0 > M && (M = this.oracle.lineHeight), c = m - c, k.block ? this.addBlock(new Vp(c, M, k)) : (c || Q || 5 <= M) && this.addLineDeco(M, Q, c);
      } else m > c && this.span(c, m);
      -1 < this.lineEnd && this.lineEnd < this.pos && (this.lineEnd = this.oracle.doc.lineAt(this.pos).to);
    }
    enterLine() {
      if (!(-1 < this.lineStart)) {
        var { from: c, to: m } = this.oracle.doc.lineAt(this.pos);
        this.lineStart = c, this.lineEnd = m, this.writtenTo < c && ((this.writtenTo < c - 1 || this.nodes[this.nodes.length - 1] == null) && this.nodes.push(this.blankContent(this.writtenTo, c - 1)), this.nodes.push(null)), this.pos > c && this.nodes.push(new io(this.pos - c, -1)), this.writtenTo = this.pos;
      }
    }
    blankContent(c, m) {
      let k = new Ks(m - c);
      return this.oracle.doc.lineAt(c).to == m && (k.flags |= 4), k;
    }
    ensureLine() {
      this.enterLine();
      var c = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
      return c instanceof io || (c = new io(0, -1), this.nodes.push(c)), c;
    }
    addBlock(c) {
      this.enterLine();
      let m = c.deco;
      m && 0 < m.startSide && !this.isCovered && this.ensureLine(), this.nodes.push(c), this.writtenTo = this.pos += c.length, m && 0 < m.endSide && (this.covering = c);
    }
    addLineDeco(c, m, k) {
      let M = this.ensureLine();
      M.length += k, M.collapsed += k, M.widgetHeight = Math.max(M.widgetHeight, c), M.breaks += m, this.writtenTo = this.pos += k;
    }
    finish(c) {
      let m = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
      !(-1 < this.lineStart) || m instanceof io || this.isCovered ? (this.writtenTo < this.pos || m == null) && this.nodes.push(this.blankContent(this.writtenTo, this.pos)) : this.nodes.push(new io(0, -1));
      for (let k of this.nodes) k instanceof io && k.updateHeight(this.oracle, c), c += k ? k.length : 1;
      return this.nodes;
    }
    static build(c, m, k, M) {
      return c = new L2(k, c), Wn.RangeSet.spans(m, k, M, c, 0), c.finish(k);
    }
  }
  class dj {
    constructor() {
      this.changes = [];
    }
    compareRange() {
    }
    comparePoint(c, m, k, M) {
      (c < m || k && k.heightRelevant || M && M.heightRelevant) && B(c, m, this.changes, 5);
    }
  }
  class B2 {
    constructor(c, m, k) {
      this.from = c, this.to = m, this.size = k;
    }
    static same(c, m) {
      if (c.length != m.length) return !1;
      for (let k = 0; k < c.length; k++) {
        let M = c[k], Q = m[k];
        if (M.from != Q.from || M.to != Q.to || M.size != Q.size) return !1;
      }
      return !0;
    }
    draw(c, m) {
      return On.replace({ widget: new Yp(this.size * (m ? c.scaleY : c.scaleX), m) }).range(
        this.from,
        this.to
      );
    }
  }
  class Yp extends wn {
    constructor(c, m) {
      super(), this.size = c, this.vertical = m;
    }
    eq(c) {
      return c.size == this.size && c.vertical == this.vertical;
    }
    toDOM() {
      let c = document.createElement("div");
      return this.vertical ? c.style.height = this.size + "px" : (c.style.width = this.size + "px", c.style.height = "2px", c.style.display = "inline-block"), c;
    }
    get estimatedHeight() {
      return this.vertical ? this.size : -1;
    }
  }
  class B5 {
    constructor(c) {
      this.state = c, this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 }, this.inView = !0, this.scrollTop = this.editorWidth = this.editorHeight = this.contentDOMHeight = this.contentDOMWidth = this.paddingBottom = this.paddingTop = 0, this.scrolledToBottom = !0, this.scaleY = this.scaleX = 1, this.scrollAnchorPos = 0, this.scrollAnchorHeight = -1, this.scaler = M1, this.scrollTarget = null, this.printing = !1, this.mustMeasureContent = !0, this.defaultTextDirection = l.Direction.LTR, this.visibleRanges = [], this.mustEnforceCursorAssoc = !1;
      let m = c.facet(Th).some((k) => typeof k != "function" && k.class == "cm-lineWrapping");
      this.heightOracle = new Lg(m), this.stateDeco = c.facet(fs).filter((k) => typeof k != "function"), this.heightMap = xu.empty().applyChanges(this.stateDeco, Wn.Text.empty, this.heightOracle.setDoc(c.doc), [new zs(0, 0, 0, c.doc.length)]), this.viewport = this.getViewport(0, null), this.updateViewportLines(), this.updateForViewport(), this.lineGaps = this.ensureLineGaps([]), this.lineGapDeco = On.set(this.lineGaps.map((k) => k.draw(this, !1))), this.computeVisibleRanges();
    }
    updateForViewport() {
      let c = [this.viewport], { main: m } = this.state.selection;
      for (let k = 0; 1 >= k; k++) {
        let M = k ? m.head : m.anchor;
        if (!c.some(({ from: Q, to: pe }) => M >= Q && M <= pe)) {
          let { from: Q, to: pe } = this.lineBlockAt(M);
          c.push(new C1(Q, pe));
        }
      }
      this.viewports = c.sort((k, M) => k.from - M.from), this.scaler = 7e6 >= this.heightMap.height ? M1 : new F5(this.heightOracle, this.heightMap, this.viewports);
    }
    updateViewportLines() {
      this.viewportLines = [], this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (c) => {
        this.viewportLines.push(this.scaler.scale == 1 ? c : vn(c, this.scaler));
      });
    }
    update(c, m = null) {
      this.state = c.state;
      var k = this.stateDeco;
      this.stateDeco = this.state.facet(fs).filter((pe) => typeof pe != "function"), k = zs.extendWithRanges(c.changedRanges, Ar(k, this.stateDeco, c ? c.changes : Wn.ChangeSet.empty(this.state.doc.length)));
      var M = this.heightMap.height;
      let Q = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
      this.heightMap = this.heightMap.applyChanges(this.stateDeco, c.startState.doc, this.heightOracle.setDoc(this.state.doc), k), this.heightMap.height != M && (c.flags |= 2), Q ? (this.scrollAnchorPos = c.changes.mapPos(
        Q.from,
        -1
      ), this.scrollAnchorHeight = Q.top) : (this.scrollAnchorPos = -1, this.scrollAnchorHeight = this.heightMap.height), k = k.length ? this.mapViewport(this.viewport, c.changes) : this.viewport, (m && (m.range.head < k.from || m.range.head > k.to) || !this.viewportIsAppropriate(k)) && (k = this.getViewport(0, m)), M = !c.changes.empty || c.flags & 2 || k.from != this.viewport.from || k.to != this.viewport.to, this.viewport = k, this.updateForViewport(), M && this.updateViewportLines(), (this.lineGaps.length || 4e3 < this.viewport.to - this.viewport.from) && this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(
        this.lineGaps,
        c.changes
      ))), c.flags |= this.computeVisibleRanges(), m && (this.scrollTarget = m), !this.mustEnforceCursorAssoc && c.selectionSet && c.view.lineWrapping && c.state.selection.main.empty && c.state.selection.main.assoc && !c.state.facet(Ag) && (this.mustEnforceCursorAssoc = !0);
    }
    measure(c) {
      var m = c.contentDOM, k = window.getComputedStyle(m), M = this.heightOracle, Q = k.whiteSpace;
      this.defaultTextDirection = k.direction == "rtl" ? l.Direction.RTL : l.Direction.LTR;
      let pe = this.heightOracle.mustRefreshForWrapping(Q);
      var Ie = m.getBoundingClientRect();
      let nn = pe || this.mustMeasureContent || this.contentDOMHeight != Ie.height;
      this.contentDOMHeight = Ie.height, this.mustMeasureContent = !1;
      let Xe = 0, cn = 0;
      if (Ie.width && Ie.height) {
        var kn = Ie.width / m.offsetWidth;
        let jn = Ie.height / m.offsetHeight;
        (0.995 < kn && 1.005 > kn || !isFinite(kn) || 1 > Math.abs(Ie.width - m.offsetWidth)) && (kn = 1), (0.995 < jn && 1.005 > jn || !isFinite(jn) || 1 > Math.abs(Ie.height - m.offsetHeight)) && (jn = 1), (this.scaleX != kn || this.scaleY != jn) && (this.scaleX = kn, this.scaleY = jn, Xe |= 8, pe = nn = !0);
      }
      if (kn = (parseInt(k.paddingTop) || 0) * this.scaleY, k = (parseInt(k.paddingBottom) || 0) * this.scaleY, (this.paddingTop != kn || this.paddingBottom != k) && (this.paddingTop = kn, this.paddingBottom = k, Xe |= 10), this.editorWidth != c.scrollDOM.clientWidth && (M.lineWrapping && (nn = !0), this.editorWidth = c.scrollDOM.clientWidth, Xe |= 8), k = c.scrollDOM.scrollTop * this.scaleY, this.scrollTop != k && (this.scrollAnchorHeight = -1, this.scrollTop = k), this.scrolledToBottom = ce(c.scrollDOM), kn = (this.printing ? Rl : Ml)(m, this.paddingTop), m = kn.top - this.pixelViewport.top, k = kn.bottom - this.pixelViewport.bottom, this.pixelViewport = kn, kn = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left, kn != this.inView && (this.inView = kn) && (nn = !0), !this.inView && !this.scrollTarget) return 0;
      if (kn = Ie.width, (this.contentDOMWidth != kn || this.editorHeight != c.scrollDOM.clientHeight) && (this.contentDOMWidth = Ie.width, this.editorHeight = c.scrollDOM.clientHeight, Xe |= 8), nn) {
        if (Ie = c.docView.measureVisibleLineHeights(this.viewport), M.mustRefreshForHeights(Ie) && (pe = !0), pe || M.lineWrapping && Math.abs(kn - this.contentDOMWidth) > M.charWidth) {
          let {
            lineHeight: jn,
            charWidth: Pn,
            textHeight: Ct
          } = c.docView.measureTextSize();
          (pe = 0 < jn && M.refresh(Q, jn, Pn, Ct, kn / Pn, Ie)) && (c.docView.minWidth = 0, Xe |= 8);
        }
        0 < m && 0 < k ? cn = Math.max(m, k) : 0 > m && 0 > k && (cn = Math.min(m, k)), M.heightChanged = !1;
        for (let jn of this.viewports) Q = jn.from == this.viewport.from ? Ie : c.docView.measureVisibleLineHeights(jn), this.heightMap = (pe ? xu.empty().applyChanges(this.stateDeco, Wn.Text.empty, this.heightOracle, [new zs(0, 0, 0, c.state.doc.length)]) : this.heightMap).updateHeight(M, 0, pe, new Fp(jn.from, Q));
        M.heightChanged && (Xe |= 2);
      }
      return (M = !this.viewportIsAppropriate(this.viewport, cn) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to)) && (this.viewport = this.getViewport(cn, this.scrollTarget)), this.updateForViewport(), (Xe & 2 || M) && this.updateViewportLines(), (this.lineGaps.length || 4e3 < this.viewport.to - this.viewport.from) && this.updateLineGaps(this.ensureLineGaps(pe ? [] : this.lineGaps, c)), Xe |= this.computeVisibleRanges(), this.mustEnforceCursorAssoc && (this.mustEnforceCursorAssoc = !1, c.docView.enforceCursorAssoc()), Xe;
    }
    get visibleTop() {
      return this.scaler.fromDOM(this.pixelViewport.top);
    }
    get visibleBottom() {
      return this.scaler.fromDOM(this.pixelViewport.bottom);
    }
    getViewport(c, m) {
      var k = 0.5 - Math.max(-0.5, Math.min(0.5, c / 1e3 / 2));
      c = this.heightMap;
      let M = this.heightOracle, { visibleTop: Q, visibleBottom: pe } = this, Ie = new C1(c.lineAt(Q - 1e3 * k, bi.ByHeight, M, 0, 0).from, c.lineAt(pe + 1e3 * (1 - k), bi.ByHeight, M, 0, 0).to);
      if (m) {
        let { head: nn } = m.range;
        if (nn < Ie.from || nn > Ie.to) {
          k = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
          let Xe = c.lineAt(nn, bi.ByPos, M, 0, 0);
          m = m.y == "center" ? (Xe.top + Xe.bottom) / 2 - k / 2 : m.y == "start" || m.y == "nearest" && nn < Ie.from ? Xe.top : Xe.bottom - k, Ie = new C1(c.lineAt(m - 500, bi.ByHeight, M, 0, 0).from, c.lineAt(m + k + 500, bi.ByHeight, M, 0, 0).to);
        }
      }
      return Ie;
    }
    mapViewport(c, m) {
      let k = m.mapPos(c.from, -1);
      return c = m.mapPos(c.to, 1), new C1(this.heightMap.lineAt(k, bi.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(c, bi.ByPos, this.heightOracle, 0, 0).to);
    }
    viewportIsAppropriate({ from: c, to: m }, k = 0) {
      if (!this.inView) return !0;
      let { top: M } = this.heightMap.lineAt(c, bi.ByPos, this.heightOracle, 0, 0), { bottom: Q } = this.heightMap.lineAt(m, bi.ByPos, this.heightOracle, 0, 0), { visibleTop: pe, visibleBottom: Ie } = this;
      return (c == 0 || M <= pe - Math.max(10, Math.min(-k, 250))) && (m == this.state.doc.length || Q >= Ie + Math.max(10, Math.min(k, 250))) && M > pe - 2e3 && Q < Ie + 2e3;
    }
    mapLineGaps(c, m) {
      if (!c.length || m.empty) return c;
      let k = [];
      for (let M of c) m.touchesRange(M.from, M.to) || k.push(new B2(m.mapPos(M.from), m.mapPos(M.to), M.size));
      return k;
    }
    ensureLineGaps(c, m) {
      let k = this.heightOracle.lineWrapping, M = k ? 1e4 : 2e3, Q = M >> 1, pe = M << 1;
      if (this.defaultTextDirection != l.Direction.LTR && !k) return [];
      let Ie = [], nn = (jn, Pn, Ct, Wt) => {
        if (!(Pn - jn < Q)) {
          var Mt = this.state.selection.main, wl = [Mt.from];
          Mt.empty || wl.push(Mt.to);
          for (let rl of wl) if (rl > jn && rl < Pn) {
            nn(jn, rl - 10, Ct, Wt), nn(rl + 10, Pn, Ct, Wt);
            return;
          }
          Mt = Ge(c, (rl) => rl.from >= Ct.from && rl.to <= Ct.to && Math.abs(rl.from - jn) < Q && Math.abs(rl.to - Pn) < Q && !wl.some((_i) => rl.from < _i && rl.to > _i)), Mt || (Pn < Ct.to && m && k && m.visibleRanges.some((rl) => rl.from <= Pn && rl.to >= Pn) && (Mt = m.moveToLineBoundary(
            Wn.EditorSelection.cursor(Pn),
            !1,
            !0
          ).head, Mt > jn && (Pn = Mt)), Mt = new B2(jn, Pn, this.gapSize(Ct, jn, Pn, Wt))), Ie.push(Mt);
        }
      };
      for (let jn of this.viewportLines) {
        if (jn.length < pe) continue;
        let Pn = Se(jn.from, jn.to, this.stateDeco);
        if (!(Pn.total < pe)) {
          var Xe = this.scrollTarget ? this.scrollTarget.range.head : null, cn = void 0;
          if (k) {
            if (cn = M / this.heightOracle.lineLength * this.heightOracle.lineHeight, Xe != null) {
              var kn = Ee(Pn, Xe);
              cn = ((this.visibleBottom - this.visibleTop) / 2 + cn) / jn.height, Xe = kn - cn, cn = kn + cn;
            } else Xe = (this.visibleTop - jn.top - cn) / jn.height, cn = (this.visibleBottom - jn.top + cn) / jn.height;
            Xe = se(Pn, Xe), cn = se(Pn, cn);
          } else {
            if (cn = Pn.total * this.heightOracle.charWidth, kn = M * this.heightOracle.charWidth, Xe != null) {
              let Ct = Ee(Pn, Xe);
              cn = ((this.pixelViewport.right - this.pixelViewport.left) / 2 + kn) / cn, Xe = Ct - cn, cn = Ct + cn;
            } else Xe = (this.pixelViewport.left - kn) / cn, cn = (this.pixelViewport.right + kn) / cn;
            Xe = se(Pn, Xe), cn = se(Pn, cn);
          }
          Xe > jn.from && nn(jn.from, Xe, jn, Pn), cn < jn.to && nn(cn, jn.to, jn, Pn);
        }
      }
      return Ie;
    }
    gapSize(c, m, k, M) {
      return m = Ee(M, k) - Ee(M, m), this.heightOracle.lineWrapping ? c.height * m : M.total * this.heightOracle.charWidth * m;
    }
    updateLineGaps(c) {
      B2.same(
        c,
        this.lineGaps
      ) || (this.lineGaps = c, this.lineGapDeco = On.set(c.map((m) => m.draw(this, this.heightOracle.lineWrapping))));
    }
    computeVisibleRanges() {
      var c = this.stateDeco;
      this.lineGaps.length && (c = c.concat(this.lineGapDeco));
      let m = [];
      return Wn.RangeSet.spans(c, this.viewport.from, this.viewport.to, { span(k, M) {
        m.push({ from: k, to: M });
      }, point() {
      } }, 20), c = m.length != this.visibleRanges.length || this.visibleRanges.some((k, M) => k.from != m[M].from || k.to != m[M].to), this.visibleRanges = m, c ? 4 : 0;
    }
    lineBlockAt(c) {
      return c >= this.viewport.from && c <= this.viewport.to && this.viewportLines.find((m) => m.from <= c && m.to >= c) || vn(this.heightMap.lineAt(c, bi.ByPos, this.heightOracle, 0, 0), this.scaler);
    }
    lineBlockAtHeight(c) {
      return vn(this.heightMap.lineAt(this.scaler.fromDOM(c), bi.ByHeight, this.heightOracle, 0, 0), this.scaler);
    }
    scrollAnchorAt(c) {
      let m = this.lineBlockAtHeight(c + 8);
      return m.from >= this.viewport.from || 200 < this.viewportLines[0].top - c ? m : this.viewportLines[0];
    }
    elementAtHeight(c) {
      return vn(this.heightMap.blockAt(
        this.scaler.fromDOM(c),
        this.heightOracle,
        0,
        0
      ), this.scaler);
    }
    get docHeight() {
      return this.scaler.toDOM(this.heightMap.height);
    }
    get contentHeight() {
      return this.docHeight + this.paddingTop + this.paddingBottom;
    }
  }
  class C1 {
    constructor(c, m) {
      this.from = c, this.to = m;
    }
  }
  const M1 = { toDOM(N) {
    return N;
  }, fromDOM(N) {
    return N;
  }, scale: 1 };
  class F5 {
    constructor(c, m, k) {
      let M = 0, Q = 0, pe = 0;
      this.viewports = k.map(({ from: Ie, to: nn }) => {
        let Xe = m.lineAt(Ie, bi.ByPos, c, 0, 0).top, cn = m.lineAt(nn, bi.ByPos, c, 0, 0).bottom;
        return M += cn - Xe, { from: Ie, to: nn, top: Xe, bottom: cn, domTop: 0, domBottom: 0 };
      }), this.scale = (7e6 - M) / (m.height - M);
      for (let Ie of this.viewports) Ie.domTop = pe + (Ie.top - Q) * this.scale, pe = Ie.domBottom = Ie.domTop + (Ie.bottom - Ie.top), Q = Ie.bottom;
    }
    toDOM(c) {
      for (let m = 0, k = 0, M = 0; ; m++) {
        let Q = m < this.viewports.length ? this.viewports[m] : null;
        if (!Q || c < Q.top) return M + (c - k) * this.scale;
        if (c <= Q.bottom) return Q.domTop + (c - Q.top);
        k = Q.bottom, M = Q.domBottom;
      }
    }
    fromDOM(c) {
      for (let m = 0, k = 0, M = 0; ; m++) {
        let Q = m < this.viewports.length ? this.viewports[m] : null;
        if (!Q || c < Q.domTop) return k + (c - M) / this.scale;
        if (c <= Q.domBottom) return Q.top + (c - Q.domTop);
        k = Q.bottom, M = Q.domBottom;
      }
    }
  }
  const fc = Wn.Facet.define({ combine: (N) => N.join(" ") }), Up = Wn.Facet.define({ combine: (N) => -1 < N.indexOf(!0) }), F2 = cs.StyleModule.newName(), V5 = cs.StyleModule.newName(), Y5 = cs.StyleModule.newName(), wd = { "&light": "." + V5, "&dark": "." + Y5 }, dc = Kn("." + F2, {
    "&": { position: "relative !important", boxSizing: "border-box", "&.cm-focused": { outline: "1px dotted #212121" }, display: "flex !important", flexDirection: "column" },
    ".cm-scroller": {
      display: "flex !important",
      alignItems: "flex-start !important",
      fontFamily: "monospace",
      lineHeight: 1.4,
      height: "100%",
      overflowX: "auto",
      position: "relative",
      zIndex: 0
    },
    ".cm-content": { margin: 0, flexGrow: 2, flexShrink: 0, display: "block", whiteSpace: "pre", wordWrap: "normal", boxSizing: "border-box", minHeight: "100%", padding: "4px 0", outline: "none", "&[contenteditable=true]": { WebkitUserModify: "read-write-plaintext-only" } },
    ".cm-lineWrapping": { whiteSpace_fallback: "pre-wrap", whiteSpace: "break-spaces", wordBreak: "break-word", overflowWrap: "anywhere", flexShrink: 1 },
    "&light .cm-content": { caretColor: "black" },
    "&dark .cm-content": { caretColor: "white" },
    ".cm-line": { display: "block", padding: "0 2px 0 6px" },
    ".cm-layer": { position: "absolute", left: 0, top: 0, contain: "size style", "& > *": { position: "absolute" } },
    "&light .cm-selectionBackground": { background: "#d9d9d9" },
    "&dark .cm-selectionBackground": { background: "#222" },
    "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": { background: "#d7d4f0" },
    "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": { background: "#233" },
    ".cm-cursorLayer": { pointerEvents: "none" },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer": { animation: "steps(1) cm-blink 1.2s infinite" },
    "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
    "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
    ".cm-cursor, .cm-dropCursor": { borderLeft: "1.2px solid black", marginLeft: "-0.6px", pointerEvents: "none" },
    ".cm-cursor": { display: "none" },
    "&dark .cm-cursor": { borderLeftColor: "#444" },
    ".cm-dropCursor": { position: "absolute" },
    "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": { display: "block" },
    "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
    "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
    "&light .cm-specialChar": { color: "red" },
    "&dark .cm-specialChar": { color: "#f78" },
    ".cm-gutters": { flexShrink: 0, display: "flex", height: "100%", boxSizing: "border-box", insetInlineStart: 0, zIndex: 200 },
    "&light .cm-gutters": { backgroundColor: "#f5f5f5", color: "#6c6c6c", borderRight: "1px solid #ddd" },
    "&dark .cm-gutters": { backgroundColor: "#333338", color: "#ccc" },
    ".cm-gutter": {
      display: "flex !important",
      flexDirection: "column",
      flexShrink: 0,
      boxSizing: "border-box",
      minHeight: "100%",
      overflow: "hidden"
    },
    ".cm-gutterElement": { boxSizing: "border-box" },
    ".cm-lineNumbers .cm-gutterElement": { padding: "0 3px 0 5px", minWidth: "20px", textAlign: "right", whiteSpace: "nowrap" },
    "&light .cm-activeLineGutter": { backgroundColor: "#e2f2ff" },
    "&dark .cm-activeLineGutter": { backgroundColor: "#222227" },
    ".cm-panels": { boxSizing: "border-box", position: "sticky", left: 0, right: 0 },
    "&light .cm-panels": { backgroundColor: "#f5f5f5", color: "black" },
    "&light .cm-panels-top": { borderBottom: "1px solid #ddd" },
    "&light .cm-panels-bottom": { borderTop: "1px solid #ddd" },
    "&dark .cm-panels": { backgroundColor: "#333338", color: "white" },
    ".cm-tab": { display: "inline-block", overflow: "hidden", verticalAlign: "bottom" },
    ".cm-widgetBuffer": { verticalAlign: "text-top", height: "1em", width: 0, display: "inline" },
    ".cm-placeholder": { color: "#888", display: "inline-block", verticalAlign: "top" },
    ".cm-highlightSpace:before": {
      content: "attr(data-display)",
      position: "absolute",
      pointerEvents: "none",
      color: "#888"
    },
    ".cm-highlightTab": { backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`, backgroundSize: "auto 100%", backgroundPosition: "right 90%", backgroundRepeat: "no-repeat" },
    ".cm-trailingSpace": { backgroundColor: "#ff332255" },
    ".cm-button": {
      verticalAlign: "middle",
      color: "inherit",
      fontSize: "70%",
      padding: ".2em 1em",
      borderRadius: "1px"
    },
    "&light .cm-button": { backgroundImage: "linear-gradient(#eff1f5, #d9d9df)", border: "1px solid #888", "&:active": { backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)" } },
    "&dark .cm-button": { backgroundImage: "linear-gradient(#393939, #111)", border: "1px solid #888", "&:active": { backgroundImage: "linear-gradient(#111, #333)" } },
    ".cm-textfield": { verticalAlign: "middle", color: "inherit", fontSize: "70%", border: "1px solid silver", padding: ".2em .5em" },
    "&light .cm-textfield": { backgroundColor: "white" },
    "&dark .cm-textfield": { border: "1px solid #555", backgroundColor: "inherit" }
  }, wd);
  class U5 {
    constructor(c, m) {
      this.points = c, this.text = "", this.lineSeparator = m.facet(Wn.EditorState.lineSeparator);
    }
    append(c) {
      this.text += c;
    }
    lineBreak() {
      this.text += "￿";
    }
    readRange(c, m) {
      if (!c) return this;
      let k = c.parentNode;
      for (; ; ) {
        this.findPointBefore(k, c);
        let M = this.text.length;
        this.readNode(c);
        let Q = c.nextSibling;
        if (Q == m) break;
        let pe = li.get(c), Ie = li.get(Q);
        (pe && Ie ? pe.breakAfter : (pe ? pe.breakAfter : Un(c)) || Un(Q) && (c.nodeName != "BR" || c.cmIgnore) && this.text.length > M) && this.lineBreak(), c = Q;
      }
      return this.findPointBefore(k, m), this;
    }
    readTextNode(c) {
      let m = c.nodeValue;
      for (var k of this.points) k.node == c && (k.pos = this.text.length + Math.min(k.offset, m.length));
      for (let M = 0, Q = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
        k = -1;
        let pe = 1, Ie;
        if (this.lineSeparator ? (k = m.indexOf(this.lineSeparator, M), pe = this.lineSeparator.length) : (Ie = Q.exec(m)) && (k = Ie.index, pe = Ie[0].length), this.append(m.slice(M, 0 > k ? m.length : k)), 0 > k) break;
        if (this.lineBreak(), 1 < pe) for (let nn of this.points) nn.node == c && nn.pos > this.text.length && (nn.pos -= pe - 1);
        M = k + pe;
      }
    }
    readNode(c) {
      if (!c.cmIgnore) {
        var m = li.get(c);
        if (m = m && m.overrideDOMText, m != null) for (this.findPointInside(c, m.length), c = m.iter(); !c.next().done; ) c.lineBreak ? this.lineBreak() : this.append(c.value);
        else c.nodeType == 3 ? this.readTextNode(c) : c.nodeName == "BR" ? c.nextSibling && this.lineBreak() : c.nodeType == 1 && this.readRange(c.firstChild, null);
      }
    }
    findPointBefore(c, m) {
      for (let k of this.points) k.node == c && c.childNodes[k.offset] == m && (k.pos = this.text.length);
    }
    findPointInside(c, m) {
      for (let nn of this.points) if (c.nodeType == 3 ? nn.node == c : c.contains(nn.node)) {
        var k = nn, M = this.text.length;
        e:
          for (var Q = c, pe = nn.node, Ie = nn.offset; ; ) {
            if (!pe || Ie < p(pe)) {
              Q = !1;
              break e;
            }
            if (pe == Q) {
              Q = !0;
              break e;
            }
            Ie = s(pe) + 1, pe = pe.parentNode;
          }
        k.pos = M + (Q ? m : 0);
      }
    }
  }
  class q5 {
    constructor(c, m) {
      this.node = c, this.offset = m, this.pos = -1;
    }
  }
  class pj {
    constructor(c, m, k, M) {
      this.typeOver = M, this.bounds = null, this.text = "";
      let { impreciseHead: Q, impreciseAnchor: pe } = c.docView;
      if (c.state.readOnly && -1 < m) this.newSel = null;
      else if (-1 < m && (this.bounds = c.docView.domBoundsAround(
        m,
        k,
        0
      ))) {
        if (Q || pe) m = [];
        else if (m = [], c.root.activeElement == c.contentDOM) {
          var { anchorNode: Ie, anchorOffset: nn, focusNode: Xe, focusOffset: cn } = c.observer.selectionRange;
          Ie && (m.push(new q5(Ie, nn)), Xe == Ie && cn == nn || m.push(new q5(Xe, cn)));
        }
        c = new U5(m, c.state), c.readRange(this.bounds.startDOM, this.bounds.endDOM), this.text = c.text, c = this.bounds.from, m.length == 0 ? c = null : (k = m[0].pos, m = m.length == 2 ? m[1].pos : k, c = -1 < k && -1 < m ? Wn.EditorSelection.single(k + c, m + c) : null), this.newSel = c;
      } else k = c.observer.selectionRange, m = Q && Q.node == k.focusNode && Q.offset == k.focusOffset || !u(c.contentDOM, k.focusNode) ? c.state.selection.main.head : c.docView.posFromDOM(k.focusNode, k.focusOffset), c = pe && pe.node == k.anchorNode && pe.offset == k.anchorOffset || !u(c.contentDOM, k.anchorNode) ? c.state.selection.main.anchor : c.docView.posFromDOM(k.anchorNode, k.anchorOffset), this.newSel = Wn.EditorSelection.single(c, m);
    }
  }
  const mj = { childList: !0, characterData: !0, subtree: !0, attributes: !0, characterDataOldValue: !0 }, V2 = X.ie && 11 >= X.ie_version;
  class gj {
    constructor(c) {
      this.view = c, this.active = !1, this.selectionRange = new ac(), this.selectionChanged = !1, this.resizeTimeout = this.delayedFlush = -1, this.queue = [], this.delayedAndroidKey = null, this.flushingAndroidKey = -1, this.lastChange = 0, this.scrollTargets = [], this.resizeContent = this.resizeScroll = this.intersection = null, this.intersecting = !1, this.gapIntersection = null, this.gaps = [], this.parentCheck = -1, this.dom = c.contentDOM, this.observer = new MutationObserver((m) => {
        for (let k of m) this.queue.push(k);
        (X.ie && 11 >= X.ie_version || X.ios && c.composing) && m.some((k) => k.type == "childList" && k.removedNodes.length || k.type == "characterData" && k.oldValue.length > k.target.nodeValue.length) ? this.flushSoon() : this.flush();
      }), V2 && (this.onCharData = (m) => {
        this.queue.push({ target: m.target, type: "characterData", oldValue: m.prevValue }), this.flushSoon();
      }), this.onSelectionChange = this.onSelectionChange.bind(this), this.onResize = this.onResize.bind(this), this.onPrint = this.onPrint.bind(this), this.onScroll = this.onScroll.bind(this), typeof ResizeObserver == "function" && (this.resizeScroll = new ResizeObserver(() => {
        var m;
        ((m = this.view.docView) === null || m === void 0 ? void 0 : m.lastUpdate) < Date.now() - 75 && this.onResize();
      }), this.resizeScroll.observe(c.scrollDOM), this.resizeContent = new ResizeObserver(() => this.view.requestMeasure()), this.resizeContent.observe(c.contentDOM)), this.addWindowListeners(this.win = c.win), this.start(), typeof IntersectionObserver == "function" && (this.intersection = new IntersectionObserver((m) => {
        0 > this.parentCheck && (this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3)), 0 < m.length && 0 < m[m.length - 1].intersectionRatio != this.intersecting && (this.intersecting = !this.intersecting, this.intersecting != this.view.inView) && this.onScrollChanged(document.createEvent("Event"));
      }, { threshold: [0, 1e-3] }), this.intersection.observe(this.dom), this.gapIntersection = new IntersectionObserver((m) => {
        0 < m.length && 0 < m[m.length - 1].intersectionRatio && this.onScrollChanged(document.createEvent("Event"));
      }, {})), this.listenForScroll(), this.readSelectionRange();
    }
    onScrollChanged(c) {
      this.view.inputState.runHandlers(
        "scroll",
        c
      ), this.intersecting && this.view.measure();
    }
    onScroll(c) {
      this.intersecting && this.flush(!1), this.onScrollChanged(c);
    }
    onResize() {
      0 > this.resizeTimeout && (this.resizeTimeout = setTimeout(() => {
        this.resizeTimeout = -1, this.view.requestMeasure();
      }, 50));
    }
    onPrint() {
      this.view.viewState.printing = !0, this.view.measure(), setTimeout(() => {
        this.view.viewState.printing = !1, this.view.requestMeasure();
      }, 500);
    }
    updateGaps(c) {
      if (this.gapIntersection && (c.length != this.gaps.length || this.gaps.some((m, k) => m != c[k]))) {
        this.gapIntersection.disconnect();
        for (let m of c) this.gapIntersection.observe(m);
        this.gaps = c;
      }
    }
    onSelectionChange(c) {
      let m = this.selectionChanged;
      if (this.readSelectionRange() && !this.delayedAndroidKey) {
        var { view: k } = this, M = this.selectionRange;
        if (k.state.facet(gf) ? k.root.activeElement == this.dom : o(k.dom, M)) {
          var Q = M.anchorNode && k.docView.nearest(M.anchorNode);
          Q && Q.ignoreEvent(c) ? m || (this.selectionChanged = !1) : (X.ie && 11 >= X.ie_version || X.android && X.chrome) && !k.state.selection.main.empty && M.focusNode && h(
            M.focusNode,
            M.focusOffset,
            M.anchorNode,
            M.anchorOffset
          ) ? this.flushSoon() : this.flush(!1);
        }
      }
    }
    readSelectionRange() {
      let { view: c } = this;
      var m;
      if (m = X.safari && c.root.nodeType == 11) {
        for (m = this.dom.ownerDocument.activeElement; m && m.shadowRoot; ) m = m.shadowRoot.activeElement;
        m = m == this.dom;
      }
      if (m = m && Z(this.view) || r(c.root), !m || this.selectionRange.eq(m)) return !1;
      let k = o(this.dom, m);
      var M;
      if (M = k && !this.selectionChanged && c.inputState.lastFocusTime > Date.now() - 200 && c.inputState.lastTouchTime < Date.now() - 300) e: {
        M = this.dom;
        let Q = m.focusNode, pe = m.focusOffset;
        if (Q && m.anchorNode == Q && m.anchorOffset == pe) for (pe = Math.min(pe, p(Q)); ; ) if (pe) {
          if (Q.nodeType != 1) {
            M = !1;
            break e;
          }
          let Ie = Q.childNodes[pe - 1];
          Ie.contentEditable == "false" ? pe-- : (Q = Ie, pe = p(Q));
        } else if (Q == M) {
          M = !0;
          break e;
        } else pe = s(Q), Q = Q.parentNode;
        else M = !1;
      }
      return M ? (this.view.inputState.lastFocusTime = 0, c.docView.updateSelection(), !1) : (this.selectionRange.setRange(m), k && (this.selectionChanged = !0), !0);
    }
    setSelectionRange(c, m) {
      this.selectionRange.set(c.node, c.offset, m.node, m.offset), this.selectionChanged = !1;
    }
    clearSelectionRange() {
      this.selectionRange.set(
        null,
        0,
        null,
        0
      );
    }
    listenForScroll() {
      this.parentCheck = -1;
      let c = 0, m = null;
      for (let k = this.dom; k; ) if (k.nodeType == 1) !m && c < this.scrollTargets.length && this.scrollTargets[c] == k ? c++ : m ||= this.scrollTargets.slice(0, c), m && m.push(k), k = k.assignedSlot || k.parentNode;
      else if (k.nodeType == 11) k = k.host;
      else break;
      if (c < this.scrollTargets.length && !m && (m = this.scrollTargets.slice(0, c)), m) {
        for (let k of this.scrollTargets) k.removeEventListener("scroll", this.onScroll);
        for (let k of this.scrollTargets = m) k.addEventListener("scroll", this.onScroll);
      }
    }
    ignore(c) {
      if (!this.active) return c();
      try {
        return this.stop(), c();
      } finally {
        this.start(), this.clear();
      }
    }
    start() {
      this.active || (this.observer.observe(this.dom, mj), V2 && this.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.active = !0);
    }
    stop() {
      this.active && (this.active = !1, this.observer.disconnect(), V2 && this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData));
    }
    clear() {
      this.processRecords(), this.queue.length = 0, this.selectionChanged = !1;
    }
    delayAndroidKey(c, m) {
      var k;
      this.delayedAndroidKey || (this.flushingAndroidKey = this.view.win.requestAnimationFrame(() => {
        let M = this.delayedAndroidKey;
        M && (this.clearDelayedAndroidKey(), this.view.inputState.lastKeyCode = M.keyCode, this.view.inputState.lastKeyTime = Date.now(), !this.flush() && M.force && G(this.dom, M.key, M.keyCode));
      })), this.delayedAndroidKey && c != "Enter" || (this.delayedAndroidKey = { key: c, keyCode: m, force: this.lastChange < Date.now() - 50 || !((k = this.delayedAndroidKey) === null || k === void 0 || !k.force) });
    }
    clearDelayedAndroidKey() {
      this.win.cancelAnimationFrame(this.flushingAndroidKey), this.delayedAndroidKey = null, this.flushingAndroidKey = -1;
    }
    flushSoon() {
      0 > this.delayedFlush && (this.delayedFlush = this.view.win.requestAnimationFrame(() => {
        this.delayedFlush = -1, this.flush();
      }));
    }
    forceFlush() {
      0 <= this.delayedFlush && (this.view.win.cancelAnimationFrame(this.delayedFlush), this.delayedFlush = -1), this.flush();
    }
    pendingRecords() {
      for (let c of this.observer.takeRecords()) this.queue.push(c);
      return this.queue;
    }
    processRecords() {
      var c = this.pendingRecords();
      c.length && (this.queue = []);
      let m = -1, k = -1, M = !1;
      for (let Q of c) (c = this.readMutation(Q)) && (c.typeOver && (M = !0), m == -1 ? { from: m, to: k } = c : (m = Math.min(c.from, m), k = Math.max(c.to, k)));
      return { from: m, to: k, typeOver: M };
    }
    readChange() {
      let { from: c, to: m, typeOver: k } = this.processRecords();
      var M = this.selectionChanged && o(this.dom, this.selectionRange);
      return 0 > c && !M ? null : (-1 < c && (this.lastChange = Date.now()), this.view.inputState.lastFocusTime = 0, this.selectionChanged = !1, M = new pj(this.view, c, m, k), this.view.docView.domChanged = { newSel: M.newSel ? M.newSel.main : null }, M);
    }
    flush(c = !0) {
      if (0 <= this.delayedFlush || this.delayedAndroidKey) return !1;
      c && this.readSelectionRange();
      var m = this.readChange();
      return m ? (c = this.view.state, m = Pe(this.view, m), this.view.state == c && this.view.update([]), m) : (this.view.requestMeasure(), !1);
    }
    readMutation(c) {
      let m = this.view.docView.nearest(c.target);
      if (!m || m.ignoreMutation(c)) return null;
      if (m.markDirty(c.type == "attributes"), c.type == "attributes" && (m.flags |= 4), c.type == "childList") {
        let k = ge(m, c.previousSibling || c.target.previousSibling, -1);
        return c = ge(
          m,
          c.nextSibling || c.target.nextSibling,
          1
        ), { from: k ? m.posAfter(k) : m.posAtStart, to: c ? m.posBefore(c) : m.posAtEnd, typeOver: !1 };
      }
      return c.type == "characterData" ? { from: m.posAtStart, to: m.posAtEnd, typeOver: c.target.nodeValue == c.oldValue } : null;
    }
    setWindow(c) {
      c != this.win && (this.removeWindowListeners(this.win), this.win = c, this.addWindowListeners(this.win));
    }
    addWindowListeners(c) {
      c.addEventListener("resize", this.onResize), c.addEventListener("beforeprint", this.onPrint), c.addEventListener("scroll", this.onScroll), c.document.addEventListener(
        "selectionchange",
        this.onSelectionChange
      );
    }
    removeWindowListeners(c) {
      c.removeEventListener("scroll", this.onScroll), c.removeEventListener("resize", this.onResize), c.removeEventListener("beforeprint", this.onPrint), c.document.removeEventListener("selectionchange", this.onSelectionChange);
    }
    destroy() {
      var c, m, k, M;
      this.stop(), (c = this.intersection) === null || c === void 0 || c.disconnect(), (m = this.gapIntersection) === null || m === void 0 || m.disconnect(), (k = this.resizeScroll) === null || k === void 0 || k.disconnect(), (M = this.resizeContent) === null || M === void 0 || M.disconnect();
      for (let Q of this.scrollTargets) Q.removeEventListener("scroll", this.onScroll);
      this.removeWindowListeners(this.win), clearTimeout(this.parentCheck), clearTimeout(this.resizeTimeout), this.win.cancelAnimationFrame(this.delayedFlush), this.win.cancelAnimationFrame(this.flushingAndroidKey);
    }
  }
  class Hr {
    get state() {
      return this.viewState.state;
    }
    get viewport() {
      return this.viewState.viewport;
    }
    get visibleRanges() {
      return this.viewState.visibleRanges;
    }
    get inView() {
      return this.viewState.inView;
    }
    get composing() {
      return 0 < this.inputState.composing;
    }
    get compositionStarted() {
      return 0 <= this.inputState.composing;
    }
    get root() {
      return this._root;
    }
    get win() {
      return this.dom.ownerDocument.defaultView || window;
    }
    constructor(c = {}) {
      this.plugins = [], this.pluginMap = /* @__PURE__ */ new Map(), this.editorAttrs = {}, this.contentAttrs = {}, this.bidiCache = [], this.destroyed = !1, this.updateState = 2, this.measureScheduled = -1, this.measureRequests = [], this.contentDOM = document.createElement("div"), this.scrollDOM = document.createElement("div"), this.scrollDOM.tabIndex = -1, this.scrollDOM.className = "cm-scroller", this.scrollDOM.appendChild(this.contentDOM), this.announceDOM = document.createElement("div"), this.announceDOM.style.cssText = "position: fixed; top: -10000px", this.announceDOM.setAttribute("aria-live", "polite"), this.dom = document.createElement("div"), this.dom.appendChild(this.announceDOM), this.dom.appendChild(this.scrollDOM);
      let { dispatch: m } = c;
      this.dispatchTransactions = c.dispatchTransactions || m && ((k) => k.forEach((M) => m(M, this))) || ((k) => this.update(k)), this.dispatch = this.dispatch.bind(this), this._root = c.root || J(c.parent) || document, this.viewState = new B5(c.state || Wn.EditorState.create(c)), this.plugins = this.state.facet(au).map((k) => new La(k));
      for (let k of this.plugins) k.update(this);
      this.observer = new gj(this), this.inputState = new N1(this), this.inputState.ensureHandlers(this.plugins), this.docView = new hd(this), this.mountStyles(), this.updateAttrs(), this.updateState = 0, this.requestMeasure(), c.parent && c.parent.appendChild(this.dom);
    }
    dispatch(...c) {
      c = c.length == 1 && c[0] instanceof Wn.Transaction ? c : c.length == 1 && Array.isArray(c[0]) ? c[0] : [this.state.update(...c)], this.dispatchTransactions(c, this);
    }
    update(c) {
      if (this.updateState != 0) throw Error("Calls to EditorView.update are not allowed while an update is in progress");
      let m = !1, k = !1;
      var M = this.state;
      for (var Q of c) {
        if (Q.startState != M) throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
        M = Q.state;
      }
      if (this.destroyed) this.viewState.state = M;
      else {
        var pe = this.hasFocus;
        Q = 0;
        var Ie = null;
        c.some((cn) => cn.annotation($g)) ? (this.inputState.notifiedFocused = pe, Q = 1) : pe != this.inputState.notifiedFocused && (this.inputState.notifiedFocused = pe, (Ie = Kt(M, pe)) || (Q = 1));
        var nn = this.observer.delayedAndroidKey, Xe = null;
        if (nn ? (this.observer.clearDelayedAndroidKey(), ((Xe = this.observer.readChange()) && !this.state.doc.eq(M.doc) || !this.state.selection.eq(M.selection)) && (Xe = null)) : this.observer.clear(), M.facet(Wn.EditorState.phrases) != this.state.facet(Wn.EditorState.phrases)) return this.setState(M);
        M = Ah.create(this, M, c), M.flags |= Q, Q = this.viewState.scrollTarget;
        try {
          this.updateState = 2;
          for (let cn of c) {
            if (Q &&= Q.map(cn.changes), cn.scrollIntoView) {
              let { main: kn } = cn.state.selection;
              Q = new sd(kn.empty ? kn : Wn.EditorSelection.cursor(kn.head, kn.head > kn.anchor ? -1 : 1));
            }
            for (let kn of cn.effects) kn.is(Dg) && (Q = kn.value);
          }
          this.viewState.update(M, Q), this.bidiCache = vt.update(this.bidiCache, M.changes), M.empty || (this.updatePlugins(M), this.inputState.update(M)), m = this.docView.update(M), this.state.facet(jh) != this.styleModules && this.mountStyles(), k = this.updateAttrs(), this.showAnnouncements(c), this.docView.updateSelection(m, c.some((cn) => cn.isUserEvent("select.pointer")));
        } finally {
          this.updateState = 0;
        }
        if (M.startState.facet(fc) != M.state.facet(fc) && (this.viewState.mustMeasureContent = !0), (m || k || Q || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent) && this.requestMeasure(), !M.empty) for (let cn of this.state.facet(ri)) cn(M);
        (Ie || Xe) && Promise.resolve().then(() => {
          Ie && this.state == Ie.startState && this.dispatch(Ie), Xe && !Pe(this, Xe) && nn.force && G(this.contentDOM, nn.key, nn.keyCode);
        });
      }
    }
    setState(c) {
      if (this.updateState != 0) throw Error("Calls to EditorView.setState are not allowed while an update is in progress");
      if (this.destroyed) this.viewState.state = c;
      else {
        this.updateState = 2;
        var m = this.hasFocus;
        try {
          for (let k of this.plugins) k.destroy(this);
          this.viewState = new B5(c), this.plugins = c.facet(au).map((k) => new La(k)), this.pluginMap.clear();
          for (let k of this.plugins) k.update(this);
          this.docView = new hd(this), this.inputState.ensureHandlers(this.plugins), this.mountStyles(), this.updateAttrs(), this.bidiCache = [];
        } finally {
          this.updateState = 0;
        }
        m && this.focus(), this.requestMeasure();
      }
    }
    updatePlugins(c) {
      let m = c.startState.facet(au), k = c.state.facet(au);
      if (m != k) {
        var M = [];
        for (let pe of k) {
          var Q = m.indexOf(pe);
          0 > Q ? M.push(new La(pe)) : (Q = this.plugins[Q], Q.mustUpdate = c, M.push(Q));
        }
        for (let pe of this.plugins) pe.mustUpdate != c && pe.destroy(this);
        this.plugins = M, this.pluginMap.clear();
      } else for (M of this.plugins) M.mustUpdate = c;
      for (c = 0; c < this.plugins.length; c++) this.plugins[c].update(this);
      m != k && this.inputState.ensureHandlers(this.plugins);
    }
    measure(c = !0) {
      if (!this.destroyed) if (-1 < this.measureScheduled && this.win.cancelAnimationFrame(this.measureScheduled), this.observer.delayedAndroidKey) this.measureScheduled = -1, this.requestMeasure();
      else {
        this.measureScheduled = 0, c && this.observer.forceFlush(), c = null;
        var m = this.scrollDOM, k = m.scrollTop * this.scaleY, { scrollAnchorPos: M, scrollAnchorHeight: Q } = this.viewState;
        1 < Math.abs(k - this.viewState.scrollTop) && (Q = -1), this.viewState.scrollAnchorHeight = -1;
        try {
          for (let pe = 0; ; pe++) {
            if (0 > Q) if (ce(m)) M = -1, Q = this.viewState.heightMap.height;
            else {
              let jn = this.viewState.scrollAnchorAt(k);
              M = jn.from, Q = jn.top;
            }
            this.updateState = 1;
            let Ie = this.viewState.measure(this);
            if (!Ie && !this.measureRequests.length && this.viewState.scrollTarget == null) break;
            if (5 < pe) {
              console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
              break;
            }
            let nn = [];
            Ie & 4 || ([this.measureRequests, nn] = [nn, this.measureRequests]);
            let Xe = nn.map((jn) => {
              try {
                return jn.read(this);
              } catch (Pn) {
                return me(this.state, Pn), Hn;
              }
            }), cn = Ah.create(this, this.state, []), kn = !1;
            cn.flags |= Ie, c ? c.flags |= Ie : c = cn, this.updateState = 2, cn.empty || (this.updatePlugins(cn), this.inputState.update(cn), this.updateAttrs(), kn = this.docView.update(cn));
            for (let jn = 0; jn < nn.length; jn++) if (Xe[jn] != Hn) try {
              let Pn = nn[jn];
              Pn.write && Pn.write(Xe[jn], this);
            } catch (Pn) {
              me(this.state, Pn);
            }
            if (kn && this.docView.updateSelection(!0), !cn.viewportChanged && this.measureRequests.length == 0) {
              if (this.viewState.editorHeight) if (this.viewState.scrollTarget) {
                this.docView.scrollIntoView(this.viewState.scrollTarget), this.viewState.scrollTarget = null;
                continue;
              } else {
                let jn = (0 > M ? this.viewState.heightMap.height : this.viewState.lineBlockAt(M).top) - Q;
                if (1 < jn || -1 > jn) {
                  k += jn, m.scrollTop = k / this.scaleY, Q = -1;
                  continue;
                }
              }
              break;
            }
          }
        } finally {
          this.updateState = 0, this.measureScheduled = -1;
        }
        if (c && !c.empty) for (let pe of this.state.facet(ri)) pe(c);
      }
    }
    get themeClasses() {
      return F2 + " " + (this.state.facet(Up) ? Y5 : V5) + " " + this.state.facet(fc);
    }
    updateAttrs() {
      let c = Y(this, Mp, { class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses }), m = { spellcheck: "false", autocorrect: "off", autocapitalize: "off", translate: "no", contenteditable: this.state.facet(gf) ? "true" : "false", class: "cm-content", style: `${X.tabSize}: ${this.state.tabSize}`, role: "textbox", "aria-multiline": "true" };
      this.state.readOnly && (m["aria-readonly"] = "true"), Y(this, Th, m);
      let k = this.observer.ignore(() => {
        let M = Ce(this.contentDOM, this.contentAttrs, m), Q = Ce(this.dom, this.editorAttrs, c);
        return M || Q;
      });
      return this.editorAttrs = c, this.contentAttrs = m, k;
    }
    showAnnouncements(c) {
      let m = !0;
      for (let k of c) for (let M of k.effects) M.is(Hr.announce) && (m && (this.announceDOM.textContent = ""), m = !1, this.announceDOM.appendChild(document.createElement("div")).textContent = M.value);
    }
    mountStyles() {
      this.styleModules = this.state.facet(jh);
      let c = this.state.facet(Hr.cspNonce);
      cs.StyleModule.mount(this.root, this.styleModules.concat(dc).reverse(), c ? { nonce: c } : void 0);
    }
    readMeasured() {
      if (this.updateState == 2) throw Error("Reading the editor layout isn't allowed during an update");
      this.updateState == 0 && -1 < this.measureScheduled && this.measure(!1);
    }
    requestMeasure(c) {
      if (0 > this.measureScheduled && (this.measureScheduled = this.win.requestAnimationFrame(() => this.measure())), c && !(-1 < this.measureRequests.indexOf(c))) {
        if (c.key != null) {
          for (let m = 0; m < this.measureRequests.length; m++) if (this.measureRequests[m].key === c.key) {
            this.measureRequests[m] = c;
            return;
          }
        }
        this.measureRequests.push(c);
      }
    }
    plugin(c) {
      let m = this.pluginMap.get(c);
      return (m === void 0 || m && m.spec != c) && this.pluginMap.set(c, m = this.plugins.find((k) => k.spec == c) || null), m && m.update(this).value;
    }
    get documentTop() {
      return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
    }
    get documentPadding() {
      return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
    }
    get scaleX() {
      return this.viewState.scaleX;
    }
    get scaleY() {
      return this.viewState.scaleY;
    }
    elementAtHeight(c) {
      return this.readMeasured(), this.viewState.elementAtHeight(c);
    }
    lineBlockAtHeight(c) {
      return this.readMeasured(), this.viewState.lineBlockAtHeight(c);
    }
    get viewportLineBlocks() {
      return this.viewState.viewportLines;
    }
    lineBlockAt(c) {
      return this.viewState.lineBlockAt(c);
    }
    get contentHeight() {
      return this.viewState.contentHeight;
    }
    moveByChar(c, m, k) {
      return pr(this, c, Pt(this, c, m, k));
    }
    moveByGroup(c, m) {
      return pr(this, c, Pt(this, c, m, (k) => ol(this, c.head, k)));
    }
    moveToLineBoundary(c, m, k = !0) {
      e: {
        let M = zt(this, c.head);
        if (c = k && M.type == l.BlockType.Text && (this.lineWrapping || M.widgetLineBreaks) ? this.coordsAtPos(0 > c.assoc && c.head > M.from ? c.head - 1 : c.head) : null) {
          k = this.dom.getBoundingClientRect();
          let Q = this.textDirectionAt(M.from);
          if (c = this.posAtCoords({ x: m == (Q == l.Direction.LTR) ? k.right - 1 : k.left + 1, y: (c.top + c.bottom) / 2 }), c != null) {
            m = Wn.EditorSelection.cursor(c, m ? -1 : 1);
            break e;
          }
        }
        m = Wn.EditorSelection.cursor(m ? M.to : M.from, m ? -1 : 1);
      }
      return m;
    }
    moveVertically(c, m, k) {
      e: {
        var M = c.head;
        let Xe = m ? 1 : -1;
        if (M == (m ? this.state.doc.length : 0)) m = Wn.EditorSelection.cursor(M, c.assoc);
        else {
          m = c.goalColumn;
          var Q = this.contentDOM.getBoundingClientRect(), pe = this.coordsAtPos(M, c.assoc || -1), Ie = this.documentTop;
          pe ? (m == null && (m = pe.left - Q.left), Ie = 0 > Xe ? pe.top : pe.bottom) : (pe = this.viewState.lineBlockAt(M), m == null && (m = Math.min(Q.right - Q.left, this.defaultCharacterWidth * (M - pe.from))), Ie = (0 > Xe ? pe.top : pe.bottom) + Ie), pe = Q.left + m;
          var nn = k ?? this.viewState.heightOracle.textHeight >> 1;
          for (let cn = 0; ; cn += 10) {
            k = Ie + (nn + cn) * Xe;
            let kn = ot(this, { x: pe, y: k }, !1, Xe);
            if (k < Q.top || k > Q.bottom || (0 > Xe ? kn < M : kn > M)) {
              M = this.docView.coordsForChar(kn), m = Wn.EditorSelection.cursor(kn, !M || k < M.top ? -1 : 1, void 0, m);
              break e;
            }
          }
        }
      }
      return pr(this, c, m);
    }
    domAtPos(c) {
      return this.docView.domAtPos(c);
    }
    posAtDOM(c, m = 0) {
      return this.docView.posFromDOM(c, m);
    }
    posAtCoords(c, m = !0) {
      return this.readMeasured(), ot(this, c, m);
    }
    coordsAtPos(c, m = 1) {
      this.readMeasured();
      let k = this.docView.coordsAt(c, m);
      if (!k || k.left == k.right) return k;
      let M = this.state.doc.lineAt(c), Q = this.bidiSpans(M);
      return c = Q[bo.find(Q, c - M.from, -1, m)], _(k, c.dir == l.Direction.LTR == 0 < m);
    }
    coordsForChar(c) {
      return this.readMeasured(), this.docView.coordsForChar(c);
    }
    get defaultCharacterWidth() {
      return this.viewState.heightOracle.charWidth;
    }
    get defaultLineHeight() {
      return this.viewState.heightOracle.lineHeight;
    }
    get textDirection() {
      return this.viewState.defaultTextDirection;
    }
    textDirectionAt(c) {
      return !this.state.facet(jg) || c < this.viewport.from || c > this.viewport.to ? this.textDirection : (this.readMeasured(), this.docView.textDirectionAt(c));
    }
    get lineWrapping() {
      return this.viewState.heightOracle.lineWrapping;
    }
    bidiSpans(c) {
      if (4096 < c.length) return [new bo(0, c.length, 0)];
      let m = this.textDirectionAt(c.from), k;
      for (var M of this.bidiCache) if (M.from == c.from && M.dir == m && (M.fresh || Be(M.isolates, k = Ae(this, c.from, c.to)))) return M.order;
      return k ||= Ae(this, c.from, c.to), M = xn(c.text, m, k), this.bidiCache.push(new vt(c.from, c.to, m, k, !0, M)), M;
    }
    get hasFocus() {
      var c;
      return (this.dom.ownerDocument.hasFocus() || X.safari && ((c = this.inputState) === null || c === void 0 ? void 0 : c.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
    }
    focus() {
      this.observer.ignore(() => {
        F(this.contentDOM), this.docView.updateSelection();
      });
    }
    setRoot(c) {
      this._root != c && (this._root = c, this.observer.setWindow((c.nodeType == 9 ? c : c.ownerDocument).defaultView || window), this.mountStyles());
    }
    destroy() {
      for (let c of this.plugins) c.destroy(this);
      this.plugins = [], this.inputState.destroy(), this.dom.remove(), this.observer.destroy(), -1 < this.measureScheduled && this.win.cancelAnimationFrame(this.measureScheduled), this.destroyed = !0;
    }
    static scrollIntoView(c, m = {}) {
      return Dg.of(new sd(typeof c == "number" ? Wn.EditorSelection.cursor(c) : c, m.y, m.x, m.yMargin, m.xMargin));
    }
    static domEventHandlers(c) {
      return _u.define(() => ({}), { eventHandlers: c });
    }
    static domEventObservers(c) {
      return _u.define(() => ({}), { eventObservers: c });
    }
    static theme(c, m) {
      let k = cs.StyleModule.newName();
      return c = [fc.of(k), jh.of(Kn(`.${k}`, c))], m && m.dark && c.push(Up.of(!0)), c;
    }
    static baseTheme(c) {
      return Wn.Prec.lowest(jh.of(Kn("." + F2, c, wd)));
    }
    static findFromDOM(c) {
      var m;
      let k = c.querySelector(".cm-content");
      return c = k && li.get(k) || li.get(c), ((m = c?.rootView) === null || m === void 0 ? void 0 : m.view) || null;
    }
  }
  Hr.styleModule = jh, Hr.inputHandler = bh, Hr.focusChangeEffect = Tg, Hr.perLineTextDirection = jg, Hr.exceptionSink = $r, Hr.updateListener = ri, Hr.editable = gf, Hr.mouseSelectionStyle = yu, Hr.dragMovesSelection = Oo, Hr.clickAddsSelectionRange = hi, Hr.decorations = fs, Hr.atomicRanges = od, Hr.bidiIsolatedRanges = Kc, Hr.scrollMargins = Pp, Hr.darkTheme = Up, Hr.cspNonce = Wn.Facet.define({ combine: (N) => N.length ? N[0] : "" }), Hr.contentAttributes = Th, Hr.editorAttributes = Mp, Hr.lineWrapping = Hr.contentAttributes.of({ class: "cm-lineWrapping" }), Hr.announce = Wn.StateEffect.define();
  const Hn = {};
  class vt {
    constructor(c, m, k, M, Q, pe) {
      this.from = c, this.to = m, this.dir = k, this.isolates = M, this.fresh = Q, this.order = pe;
    }
    static update(c, m) {
      if (m.empty && !c.some((Q) => Q.fresh)) return c;
      let k = [], M = c.length ? c[c.length - 1].dir : l.Direction.LTR;
      for (let Q = Math.max(0, c.length - 10); Q < c.length; Q++) {
        let pe = c[Q];
        pe.dir != M || m.touchesRange(pe.from, pe.to) || k.push(new vt(m.mapPos(pe.from, 1), m.mapPos(pe.to, -1), pe.dir, pe.isolates, !1, pe.order));
      }
      return k;
    }
  }
  const pt = X.mac ? "mac" : X.windows ? "win" : X.linux ? "linux" : "key", Tl = Wn.Prec.default(Hr.domEventHandlers({ keydown(N, c) {
    return un(ke(c.state), N, c, "editor");
  } })), yr = Wn.Facet.define({ enables: Tl }), vi = /* @__PURE__ */ new WeakMap();
  let Zi = null;
  class yi {
    constructor(c, m, k, M, Q) {
      this.className = c, this.left = m, this.top = k, this.width = M, this.height = Q;
    }
    draw() {
      let c = document.createElement("div");
      return c.className = this.className, this.adjust(c), c;
    }
    update(c, m) {
      return m.className != this.className ? !1 : (this.adjust(c), !0);
    }
    adjust(c) {
      c.style.left = this.left + "px", c.style.top = this.top + "px", this.width != null && (c.style.width = this.width + "px"), c.style.height = this.height + "px";
    }
    eq(c) {
      return this.left == c.left && this.top == c.top && this.width == c.width && this.height == c.height && this.className == c.className;
    }
    static forRange(c, m, k) {
      return k.empty ? (k = c.coordsAtPos(k.head, k.assoc || 1), k ? (c = gn(c), [new yi(m, k.left - c.left, k.top - c.top, null, k.bottom - k.top)]) : []) : ft(c, m, k);
    }
  }
  class Y2 {
    constructor(c, m) {
      this.view = c, this.layer = m, this.drawn = [], this.scaleY = this.scaleX = 1, this.measureReq = {
        read: this.measure.bind(this),
        write: this.draw.bind(this)
      }, this.dom = c.scrollDOM.appendChild(document.createElement("div")), this.dom.classList.add("cm-layer"), m.above && this.dom.classList.add("cm-layer-above"), m.class && this.dom.classList.add(m.class), this.scale(), this.dom.setAttribute("aria-hidden", "true"), this.setOrder(c.state), c.requestMeasure(this.measureReq), m.mount && m.mount(this.dom, c);
    }
    update(c) {
      c.startState.facet(P1) != c.state.facet(P1) && this.setOrder(c.state), (this.layer.update(c, this.dom) || c.geometryChanged) && (this.scale(), c.view.requestMeasure(this.measureReq));
    }
    setOrder(c) {
      let m = 0;
      for (c = c.facet(P1); m < c.length && c[m] != this.layer; ) m++;
      this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - m);
    }
    measure() {
      return this.layer.markers(this.view);
    }
    scale() {
      let { scaleX: c, scaleY: m } = this.view;
      (c != this.scaleX || m != this.scaleY) && (this.scaleX = c, this.scaleY = m, this.dom.style.transform = `scale(${1 / c}, ${1 / m})`);
    }
    draw(c) {
      if (c.length != this.drawn.length || c.some((k, M) => (M = this.drawn[M], !(k.constructor == M.constructor && k.eq(M))))) {
        let k = this.dom.firstChild;
        var m = 0;
        for (let M of c) M.update && k && M.constructor && this.drawn[m].constructor && M.update(k, this.drawn[m]) ? (k = k.nextSibling, m++) : this.dom.insertBefore(M.draw(), k);
        for (; k; ) m = k.nextSibling, k.remove(), k = m;
        this.drawn = c;
      }
    }
    destroy() {
      this.layer.destroy && this.layer.destroy(this.dom, this.view), this.dom.remove();
    }
  }
  const P1 = Wn.Facet.define(), ca = !X.ios, Gc = Wn.Facet.define({ combine(N) {
    return Wn.combineConfig(N, { cursorBlinkRate: 1200, drawRangeCursor: !0 }, { cursorBlinkRate: (c, m) => Math.min(c, m), drawRangeCursor: (c, m) => c || m });
  } }), wj = gt({ above: !0, markers(N) {
    let { state: c } = N, m = c.facet(Gc), k = [];
    for (let Q of c.selection.ranges) {
      var M = Q == c.selection.main;
      if (Q.empty ? !M || ca : m.drawRangeCursor) {
        M = M ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
        let pe = Q.empty ? Q : Wn.EditorSelection.cursor(Q.head, Q.head > Q.anchor ? -1 : 1);
        for (let Ie of yi.forRange(N, M, pe)) k.push(Ie);
      }
    }
    return k;
  }, update(N, c) {
    N.transactions.some((k) => k.selection) && (c.style.animationName = c.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink");
    let m = Gt(N);
    return m && (c.style.animationDuration = N.state.facet(Gc).cursorBlinkRate + "ms"), N.docChanged || N.selectionSet || m;
  }, mount(N, c) {
    N.style.animationDuration = c.state.facet(Gc).cursorBlinkRate + "ms";
  }, class: "cm-cursorLayer" }), qp = gt({ above: !1, markers(N) {
    return N.state.selection.ranges.map((c) => c.empty ? [] : yi.forRange(N, "cm-selectionBackground", c)).reduce((c, m) => c.concat(m));
  }, update(N, c) {
    return N.docChanged || N.selectionSet || N.viewportChanged || Gt(N);
  }, class: "cm-selectionLayer" }), Bg = { ".cm-line": {
    "& ::selection": { backgroundColor: "transparent !important" },
    "&::selection": { backgroundColor: "transparent !important" }
  } };
  ca && (Bg[".cm-line"].caretColor = "transparent !important");
  const $1 = Wn.Prec.highest(Hr.theme(Bg)), Ti = Wn.StateEffect.define({ map(N, c) {
    return N == null ? null : c.mapPos(N);
  } }), Fg = Wn.StateField.define({ create() {
    return null;
  }, update(N, c) {
    return N != null && (N = c.changes.mapPos(N)), c.effects.reduce((m, k) => k.is(Ti) ? k.value : m, N);
  } }), W5 = _u.fromClass(class {
    constructor(N) {
      this.view = N, this.cursor = null, this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
    }
    update(N) {
      var c;
      let m = N.state.field(Fg);
      m == null ? this.cursor != null && ((c = this.cursor) === null || c === void 0 || c.remove(), this.cursor = null) : (this.cursor || (this.cursor = this.view.scrollDOM.appendChild(document.createElement("div")), this.cursor.className = "cm-dropCursor"), (N.startState.field(Fg) != m || N.docChanged || N.geometryChanged) && this.view.requestMeasure(this.measureReq));
    }
    readPos() {
      let { view: N } = this;
      var c = N.state.field(Fg);
      if (c = c != null && N.coordsAtPos(c), !c) return null;
      let m = N.scrollDOM.getBoundingClientRect();
      return { left: c.left - m.left + N.scrollDOM.scrollLeft * N.scaleX, top: c.top - m.top + N.scrollDOM.scrollTop * N.scaleY, height: c.bottom - c.top };
    }
    drawCursor(N) {
      if (this.cursor) {
        let { scaleX: c, scaleY: m } = this.view;
        N ? (this.cursor.style.left = N.left / c + "px", this.cursor.style.top = N.top / m + "px", this.cursor.style.height = N.height / m + "px") : this.cursor.style.left = "-100000px";
      }
    }
    destroy() {
      this.cursor && this.cursor.remove();
    }
    setDropPos(N) {
      this.view.state.field(Fg) != N && this.view.dispatch({ effects: Ti.of(N) });
    }
  }, { eventObservers: { dragover(N) {
    this.setDropPos(this.view.posAtCoords({
      x: N.clientX,
      y: N.clientY
    }));
  }, dragleave(N) {
    N.target != this.view.contentDOM && this.view.contentDOM.contains(N.relatedTarget) || this.setDropPos(null);
  }, dragend() {
    this.setDropPos(null);
  }, drop() {
    this.setDropPos(null);
  } } });
  class vd {
    constructor(c) {
      const { regexp: m, decoration: k, decorate: M, boundary: Q, maxLength: pe = 1e3 } = c;
      if (!m.global) throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
      if (this.regexp = m, M) this.addMatch = (Ie, nn, Xe, cn) => M(cn, Xe, Xe + Ie[0].length, Ie, nn);
      else if (typeof k == "function") this.addMatch = (Ie, nn, Xe, cn) => {
        (nn = k(Ie, nn, Xe)) && cn(Xe, Xe + Ie[0].length, nn);
      };
      else if (k) this.addMatch = (Ie, nn, Xe, cn) => cn(Xe, Xe + Ie[0].length, k);
      else throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
      this.boundary = Q, this.maxLength = pe;
    }
    createDeco(c) {
      let m = new Wn.RangeSetBuilder(), k = m.add.bind(m);
      for (let { from: M, to: Q } of qe(c, this.maxLength)) zl(c.state.doc, this.regexp, M, Q, (pe, Ie) => this.addMatch(Ie, c, pe, k));
      return m.finish();
    }
    updateDeco(c, m) {
      let k = 1e9, M = -1;
      return c.docChanged && c.changes.iterChanges((Q, pe, Ie, nn) => {
        nn > c.view.viewport.from && Ie < c.view.viewport.to && (k = Math.min(Ie, k), M = Math.max(nn, M));
      }), c.viewportChanged || 1e3 < M - k ? this.createDeco(c.view) : -1 < M ? this.updateRange(c.view, m.map(c.changes), k, M) : m;
    }
    updateRange(c, m, k, M) {
      for (let Q of c.visibleRanges) {
        let pe = Math.max(Q.from, k), Ie = Math.min(Q.to, M);
        if (Ie > pe) {
          let nn = c.state.doc.lineAt(pe), Xe = nn.to < Ie ? c.state.doc.lineAt(Ie) : nn, cn = Math.max(Q.from, nn.from), kn = Math.min(Q.to, Xe.to);
          if (this.boundary) {
            for (; pe > nn.from; pe--) if (this.boundary.test(nn.text[pe - 1 - nn.from])) {
              cn = pe;
              break;
            }
            for (; Ie < Xe.to; Ie++) if (this.boundary.test(Xe.text[Ie - Xe.from])) {
              kn = Ie;
              break;
            }
          }
          let jn = [], Pn, Ct = (Wt, Mt, wl) => jn.push(wl.range(Wt, Mt));
          if (nn == Xe) for (this.regexp.lastIndex = cn - nn.from; (Pn = this.regexp.exec(nn.text)) && Pn.index < kn - nn.from; ) this.addMatch(Pn, c, Pn.index + nn.from, Ct);
          else zl(c.state.doc, this.regexp, cn, kn, (Wt, Mt) => this.addMatch(Mt, c, Wt, Ct));
          m = m.update({ filterFrom: cn, filterTo: kn, filter: (Wt, Mt) => Wt < cn || Mt > kn, add: jn });
        }
      }
      return m;
    }
  }
  const U2 = /x/.unicode != null ? "gu" : "g", vj = RegExp(`[\0-\b
--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]`, U2), yj = {
    0: "null",
    7: "bell",
    8: "backspace",
    10: "newline",
    11: "vertical tab",
    13: "carriage return",
    27: "escape",
    8203: "zero width space",
    8204: "zero width non-joiner",
    8205: "zero width joiner",
    8206: "left-to-right mark",
    8207: "right-to-left mark",
    8232: "line separator",
    8237: "left-to-right override",
    8238: "right-to-left override",
    8294: "left-to-right isolate",
    8295: "right-to-left isolate",
    8297: "pop directional isolate",
    8233: "paragraph separator",
    65279: "zero width no-break space",
    65532: "object replacement"
  };
  let Wp = null;
  const pc = Wn.Facet.define({ combine(N) {
    N = Wn.combineConfig(N, {
      render: null,
      specialChars: vj,
      addSpecialChars: null
    });
    var c;
    if (Wp == null && typeof document < "u" && document.body) {
      let m = document.body.style;
      Wp = ((c = m.tabSize) !== null && c !== void 0 ? c : m.MozTabSize) != null;
    }
    return (N.replaceTabs = !Wp) && (N.specialChars = new RegExp("	|" + N.specialChars.source, U2)), N.addSpecialChars && (N.specialChars = new RegExp(N.specialChars.source + "|" + N.addSpecialChars.source, U2)), N;
  } });
  let Vg = null;
  class H5 extends wn {
    constructor(c, m) {
      super(), this.options = c, this.code = m;
    }
    eq(c) {
      return c.code == this.code;
    }
    toDOM(c) {
      var m = this.code;
      m = 32 <= m ? "•" : m == 10 ? "␤" : String.fromCharCode(9216 + m), c = c.state.phrase("Control character") + " " + (yj[this.code] || "0x" + this.code.toString(16));
      var k = this.options.render && this.options.render(this.code, c, m);
      return k || (k = document.createElement("span"), k.textContent = m, k.title = c, k.setAttribute("aria-label", c), k.className = "cm-specialChar", k);
    }
    ignoreEvent() {
      return !1;
    }
  }
  class L1 extends wn {
    constructor(c) {
      super(), this.width = c;
    }
    eq(c) {
      return c.width == this.width;
    }
    toDOM() {
      let c = document.createElement("span");
      return c.textContent = "	", c.className = "cm-tab", c.style.width = this.width + "px", c;
    }
    ignoreEvent() {
      return !1;
    }
  }
  const q2 = _u.fromClass(class {
    constructor() {
      this.height = 1e3, this.attrs = { style: "padding-bottom: 1000px" };
    }
    update(N) {
      ({ view: N } = N), N = N.viewState.editorHeight * N.scaleY - N.defaultLineHeight - N.documentPadding.top - 0.5, 0 <= N && N != this.height && (this.height = N, this.attrs = { style: `padding-bottom: ${N}px` });
    }
  }), z5 = On.line({ class: "cm-activeLine" }), B1 = _u.fromClass(class {
    constructor(N) {
      this.decorations = this.getDeco(N);
    }
    update(N) {
      (N.docChanged || N.selectionSet) && (this.decorations = this.getDeco(N.view));
    }
    getDeco(N) {
      let c = -1, m = [];
      for (let k of N.state.selection.ranges) {
        let M = N.lineBlockAt(k.head);
        M.from > c && (m.push(z5.range(M.from)), c = M.from);
      }
      return On.set(m);
    }
  }, { decorations: (N) => N.decorations });
  class K5 extends wn {
    constructor(c) {
      super(), this.content = c;
    }
    toDOM() {
      let c = document.createElement("span");
      return c.className = "cm-placeholder", c.style.pointerEvents = "none", c.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : this.content), typeof this.content == "string" ? c.setAttribute("aria-label", "placeholder " + this.content) : c.setAttribute("aria-hidden", "true"), c;
    }
    coordsAt(c) {
      var m = c.firstChild ? a(c.firstChild) : [];
      return m.length ? (c = window.getComputedStyle(c.parentNode), m = _(m[0], c.direction != "rtl"), c = parseInt(c.lineHeight), m.bottom - m.top > 1.5 * c ? { left: m.left, right: m.right, top: m.top, bottom: m.top + c } : m) : null;
    }
    ignoreEvent() {
      return !1;
    }
  }
  const Yg = { Alt: [18, (N) => !!N.altKey], Control: [17, (N) => !!N.ctrlKey], Shift: [16, (N) => !!N.shiftKey], Meta: [91, (N) => !!N.metaKey] }, yd = { style: "cursor: crosshair" };
  class Ug {
    constructor(c, m, k) {
      this.facet = m, this.createTooltipView = k, this.input = c.state.facet(m), this.tooltips = this.input.filter((M) => M), this.tooltipViews = this.tooltips.map(k);
    }
    update(c, m) {
      var k;
      let M = c.state.facet(this.facet), Q = M.filter((Xe) => Xe);
      if (M === this.input) {
        for (var pe of this.tooltipViews) pe.update && pe.update(c);
        return !1;
      }
      pe = [];
      let Ie = m ? [] : null;
      for (let Xe = 0; Xe < Q.length; Xe++) {
        var nn = Q[Xe];
        let cn = -1;
        if (nn) {
          for (let kn = 0; kn < this.tooltips.length; kn++) {
            let jn = this.tooltips[kn];
            jn && jn.create == nn.create && (cn = kn);
          }
          0 > cn ? (pe[Xe] = this.createTooltipView(nn), Ie && (Ie[Xe] = !!nn.above)) : (nn = pe[Xe] = this.tooltipViews[cn], Ie && (Ie[Xe] = m[cn]), nn.update && nn.update(c));
        }
      }
      for (let Xe of this.tooltipViews) 0 > pe.indexOf(Xe) && (Xe.dom.remove(), (k = Xe.destroy) === null || k === void 0 || k.call(Xe));
      return m && (Ie.forEach((Xe, cn) => m[cn] = Xe), m.length = Ie.length), this.input = M, this.tooltips = Q, this.tooltipViews = pe, !0;
    }
  }
  const F1 = Wn.Facet.define({ combine: (N) => {
    var c, m, k;
    return { position: X.ios ? "absolute" : ((c = N.find((M) => M.position)) === null || c === void 0 ? void 0 : c.position) || "fixed", parent: ((m = N.find((M) => M.parent)) === null || m === void 0 ? void 0 : m.parent) || null, tooltipSpace: ((k = N.find((M) => M.tooltipSpace)) === null || k === void 0 ? void 0 : k.tooltipSpace) || dn };
  } }), G5 = /* @__PURE__ */ new WeakMap(), W2 = _u.fromClass(class {
    constructor(N) {
      this.view = N, this.above = [], this.inView = !0, this.madeAbsolute = !1, this.lastTransaction = 0, this.measureTimeout = -1;
      let c = N.state.facet(F1);
      this.position = c.position, this.parent = c.parent, this.classes = N.themeClasses, this.createContainer(), this.measureReq = {
        read: this.readMeasure.bind(this),
        write: this.writeMeasure.bind(this),
        key: this
      }, this.manager = new Ug(N, qg, (m) => this.createTooltip(m)), this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((m) => {
        Date.now() > this.lastTransaction - 50 && 0 < m.length && 1 > m[m.length - 1].intersectionRatio && this.measureSoon();
      }, { threshold: [1] }) : null, this.observeIntersection(), N.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this)), this.maybeMeasure();
    }
    createContainer() {
      this.parent ? (this.container = document.createElement("div"), this.container.style.position = "relative", this.container.className = this.view.themeClasses, this.parent.appendChild(this.container)) : this.container = this.view.dom;
    }
    observeIntersection() {
      if (this.intersectionObserver) {
        this.intersectionObserver.disconnect();
        for (let N of this.manager.tooltipViews) this.intersectionObserver.observe(N.dom);
      }
    }
    measureSoon() {
      0 > this.measureTimeout && (this.measureTimeout = setTimeout(() => {
        this.measureTimeout = -1, this.maybeMeasure();
      }, 50));
    }
    update(N) {
      N.transactions.length && (this.lastTransaction = Date.now());
      var c = this.manager.update(N, this.above);
      if (c && this.observeIntersection(), c = c || N.geometryChanged, N = N.state.facet(F1), N.position != this.position && !this.madeAbsolute) {
        this.position = N.position;
        for (let m of this.manager.tooltipViews) m.dom.style.position = this.position;
        c = !0;
      }
      if (N.parent != this.parent) {
        this.parent && this.container.remove(), this.parent = N.parent, this.createContainer();
        for (let m of this.manager.tooltipViews) this.container.appendChild(m.dom);
        c = !0;
      } else this.parent && this.view.themeClasses != this.classes && (this.classes = this.container.className = this.view.themeClasses);
      c && this.maybeMeasure();
    }
    createTooltip(N) {
      let c = N.create(this.view);
      return c.dom.classList.add("cm-tooltip"), N.arrow && !c.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow") && (N = document.createElement("div"), N.className = "cm-tooltip-arrow", c.dom.appendChild(N)), c.dom.style.position = this.position, c.dom.style.top = "-10000px", this.container.appendChild(c.dom), c.mount && c.mount(this.view), c;
    }
    destroy() {
      var N, c;
      this.view.win.removeEventListener(
        "resize",
        this.measureSoon
      );
      for (let m of this.manager.tooltipViews) m.dom.remove(), (N = m.destroy) === null || N === void 0 || N.call(m);
      this.parent && this.container.remove(), (c = this.intersectionObserver) === null || c === void 0 || c.disconnect(), clearTimeout(this.measureTimeout);
    }
    readMeasure() {
      let N = this.view.dom.getBoundingClientRect(), c = 1, m = 1;
      var k = !1;
      if (this.position == "fixed" && this.manager.tooltipViews.length && ({ offsetParent: k } = this.manager.tooltipViews[0].dom, k = !(!k || k == this.container.ownerDocument.body)), k || this.position == "absolute") if (this.parent) {
        let M = this.parent.getBoundingClientRect();
        M.width && M.height && (c = M.width / this.parent.offsetWidth, m = M.height / this.parent.offsetHeight);
      } else ({ scaleX: c, scaleY: m } = this.view.viewState);
      return {
        editor: N,
        parent: this.parent ? this.container.getBoundingClientRect() : N,
        pos: this.manager.tooltips.map((M, Q) => (Q = this.manager.tooltipViews[Q], Q.getCoords ? Q.getCoords(M.pos) : this.view.coordsAtPos(M.pos))),
        size: this.manager.tooltipViews.map(({ dom: M }) => M.getBoundingClientRect()),
        space: this.view.state.facet(F1).tooltipSpace(this.view),
        scaleX: c,
        scaleY: m,
        makeAbsolute: k
      };
    }
    writeMeasure(N) {
      var c;
      if (N.makeAbsolute) {
        this.madeAbsolute = !0, this.position = "absolute";
        for (var m of this.manager.tooltipViews) m.dom.style.position = "absolute";
      }
      let { editor: k, space: M, scaleX: Q, scaleY: pe } = N;
      m = [];
      for (let Xe = 0; Xe < this.manager.tooltips.length; Xe++) {
        var Ie = this.manager.tooltips[Xe];
        let cn = this.manager.tooltipViews[Xe], { dom: kn } = cn, jn = N.pos[Xe], Pn = N.size[Xe];
        if (!jn || jn.bottom <= Math.max(k.top, M.top) || jn.top >= Math.min(
          k.bottom,
          M.bottom
        ) || jn.right < Math.max(k.left, M.left) - 0.1 || jn.left > Math.min(k.right, M.right) + 0.1) {
          kn.style.top = "-10000px";
          continue;
        }
        let Ct = Ie.arrow ? cn.dom.querySelector(".cm-tooltip-arrow") : null, Wt = Ct ? 7 : 0;
        var nn = Pn.right - Pn.left;
        let Mt = (c = G5.get(cn)) !== null && c !== void 0 ? c : Pn.bottom - Pn.top, wl = cn.offset || Y1, rl = this.view.textDirection == l.Direction.LTR, _i = Pn.width > M.right - M.left ? rl ? M.left : M.right - Pn.width : rl ? Math.min(jn.left - (Ct ? 14 : 0) + wl.x, M.right - nn) : Math.max(M.left, jn.left - nn + (Ct ? 14 : 0) - wl.x), Ci = this.above[Xe];
        if (!Ie.strictSide && (Ci ? jn.top - (Pn.bottom - Pn.top) - wl.y < M.top : jn.bottom + (Pn.bottom - Pn.top) + wl.y > M.bottom) && Ci == M.bottom - jn.bottom > jn.top - M.top && (Ci = this.above[Xe] = !Ci), Ie = (Ci ? jn.top - M.top : M.bottom - jn.bottom) - Wt, Ie < Mt && cn.resize !== !1) {
          if (Ie < this.view.defaultLineHeight) {
            kn.style.top = "-10000px";
            continue;
          }
          G5.set(cn, Mt), kn.style.height = (Mt = Ie) / pe + "px";
        } else kn.style.height && (kn.style.height = "");
        if (Ie = Ci ? jn.top - Mt - Wt - wl.y : jn.bottom + Wt + wl.y, nn = _i + nn, cn.overlap !== !0) for (let Is of m) Is.left < nn && Is.right > _i && Is.top < Ie + Mt && Is.bottom > Ie && (Ie = Ci ? Is.top - Mt - 2 - Wt : Is.bottom + Wt + 2);
        this.position == "absolute" ? (kn.style.top = (Ie - N.parent.top) / pe + "px", kn.style.left = (_i - N.parent.left) / Q + "px") : (kn.style.top = Ie / pe + "px", kn.style.left = _i / Q + "px"), Ct && (Ct.style.left = (jn.left + (rl ? wl.x : -wl.x) - (_i + 14 - 7)) / Q + "px"), cn.overlap !== !0 && m.push({ left: _i, top: Ie, right: nn, bottom: Ie + Mt }), kn.classList.toggle("cm-tooltip-above", Ci), kn.classList.toggle("cm-tooltip-below", !Ci), cn.positioned && cn.positioned(N.space);
      }
    }
    maybeMeasure() {
      if (this.manager.tooltips.length && (this.view.inView && this.view.requestMeasure(this.measureReq), this.inView != this.view.inView && (this.inView = this.view.inView, !this.inView))) for (let N of this.manager.tooltipViews) N.dom.style.top = "-10000px";
    }
  }, { eventObservers: { scroll() {
    this.maybeMeasure();
  } } }), V1 = Hr.baseTheme({ ".cm-tooltip": { zIndex: 100, boxSizing: "border-box" }, "&light .cm-tooltip": { border: "1px solid #bbb", backgroundColor: "#f5f5f5" }, "&light .cm-tooltip-section:not(:first-child)": { borderTop: "1px solid #bbb" }, "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  }, ".cm-tooltip-arrow": { height: "7px", width: "14px", position: "absolute", zIndex: -1, overflow: "hidden", "&:before, &:after": { content: "''", position: "absolute", width: 0, height: 0, borderLeft: "7px solid transparent", borderRight: "7px solid transparent" }, ".cm-tooltip-above &": { bottom: "-7px", "&:before": { borderTop: "7px solid #bbb" }, "&:after": { borderTop: "7px solid #f5f5f5", bottom: "1px" } }, ".cm-tooltip-below &": { top: "-7px", "&:before": { borderBottom: "7px solid #bbb" }, "&:after": {
    borderBottom: "7px solid #f5f5f5",
    top: "1px"
  } } }, "&dark .cm-tooltip .cm-tooltip-arrow": { "&:before": { borderTopColor: "#333338", borderBottomColor: "#333338" }, "&:after": { borderTopColor: "transparent", borderBottomColor: "transparent" } } }), Y1 = { x: 0, y: 0 }, qg = Wn.Facet.define({ enables: [W2, V1] }), Wg = Wn.Facet.define();
  class U1 {
    static create(c) {
      return new U1(c);
    }
    constructor(c) {
      this.view = c, this.mounted = !1, this.dom = document.createElement("div"), this.dom.classList.add("cm-tooltip-hover"), this.manager = new Ug(c, Wg, (m) => this.createHostedView(m));
    }
    createHostedView(c) {
      return c = c.create(this.view), c.dom.classList.add("cm-tooltip-section"), this.dom.appendChild(c.dom), this.mounted && c.mount && c.mount(this.view), c;
    }
    mount(c) {
      for (let m of this.manager.tooltipViews) m.mount && m.mount(c);
      this.mounted = !0;
    }
    positioned(c) {
      for (let m of this.manager.tooltipViews) m.positioned && m.positioned(c);
    }
    update(c) {
      this.manager.update(c);
    }
    destroy() {
      var c;
      for (let m of this.manager.tooltipViews) (c = m.destroy) === null || c === void 0 || c.call(m);
    }
  }
  const _j = qg.compute([Wg], (N) => (N = N.facet(Wg).filter((c) => c), N.length === 0 ? null : { pos: Math.min(...N.map((c) => c.pos)), end: Math.max(...N.filter((c) => c.end != null).map((c) => c.end)), create: U1.create, above: N[0].above, arrow: N.some((c) => c.arrow) }));
  class xj {
    constructor(c, m, k, M, Q) {
      this.view = c, this.source = m, this.field = k, this.setHover = M, this.hoverTime = Q, this.restartTimeout = this.hoverTimeout = -1, this.pending = null, this.lastMove = { x: 0, y: 0, target: c.dom, time: 0 }, this.checkHover = this.checkHover.bind(this), c.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this)), c.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
    }
    update() {
      this.pending && (this.pending = null, clearTimeout(this.restartTimeout), this.restartTimeout = setTimeout(() => this.startHover(), 20));
    }
    get active() {
      return this.view.state.field(this.field);
    }
    checkHover() {
      if (this.hoverTimeout = -1, !this.active) {
        var c = Date.now() - this.lastMove.time;
        c < this.hoverTime ? this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - c) : this.startHover();
      }
    }
    startHover() {
      clearTimeout(this.restartTimeout);
      let {
        view: c,
        lastMove: m
      } = this;
      var k = c.docView.nearest(m.target);
      if (k) {
        var M = 1;
        if (k instanceof Xt) var Q = k.posAtStart;
        else {
          if (Q = c.posAtCoords(m), Q == null || (k = c.coordsAtPos(Q), !k || m.y < k.top || m.y > k.bottom || m.x < k.left - c.defaultCharacterWidth || m.x > k.right + c.defaultCharacterWidth)) return;
          M = (M = c.bidiSpans(c.state.doc.lineAt(Q)).find((pe) => pe.from <= Q && pe.to >= Q)) && M.dir == l.Direction.RTL ? -1 : 1, M = m.x < k.left ? -M : M;
        }
        if (k = this.source(c, Q, M), k != null && k.then) {
          let pe = this.pending = { pos: Q };
          k.then((Ie) => {
            this.pending == pe && (this.pending = null, Ie && c.dispatch({ effects: this.setHover.of(Ie) }));
          }, (Ie) => me(c.state, Ie, "hover tooltip"));
        } else k && c.dispatch({ effects: this.setHover.of(k) });
      }
    }
    mousemove(c) {
      var m;
      this.lastMove = { x: c.clientX, y: c.clientY, target: c.target, time: Date.now() }, 0 > this.hoverTimeout && (this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime));
      var k = this.active;
      if (k && !ut(this.lastMove.target) || this.pending) {
        var { pos: M } = k || this.pending;
        if (k = (m = k?.end) !== null && m !== void 0 ? m : M, M == k) m = this.view.posAtCoords(this.lastMove) != M;
        else {
          {
            m = this.view;
            var Q = c.clientX;
            c = c.clientY;
            let pe = m.scrollDOM.getBoundingClientRect(), Ie = m.documentTop + m.documentPadding.top + m.contentHeight;
            pe.left > Q || pe.right < Q || pe.top > c || Math.min(pe.bottom, Ie) < c ? m = !1 : (m = m.posAtCoords({ x: Q, y: c }, !1), m = m >= M && m <= k);
          }
          m = !m;
        }
        m && (this.view.dispatch({ effects: this.setHover.of(null) }), this.pending = null);
      }
    }
    mouseleave(c) {
      clearTimeout(this.hoverTimeout), this.hoverTimeout = -1, this.active && !ut(c.relatedTarget) && this.view.dispatch({ effects: this.setHover.of(null) });
    }
    destroy() {
      clearTimeout(this.hoverTimeout), this.view.dom.removeEventListener("mouseleave", this.mouseleave), this.view.dom.removeEventListener("mousemove", this.mousemove);
    }
  }
  const zu = Wn.StateEffect.define(), uo = zu.of(null), H2 = Wn.Facet.define({ combine(N) {
    let c, m;
    for (let k of N) c = c || k.topContainer, m = m || k.bottomContainer;
    return { topContainer: c, bottomContainer: m };
  } }), Z5 = _u.fromClass(class {
    constructor(N) {
      this.input = N.state.facet(z2), this.specs = this.input.filter((m) => m), this.panels = this.specs.map((m) => m(N));
      let c = N.state.facet(H2);
      this.top = new Hg(N, !0, c.topContainer), this.bottom = new Hg(N, !1, c.bottomContainer), this.top.sync(this.panels.filter((m) => m.top)), this.bottom.sync(this.panels.filter((m) => !m.top));
      for (let m of this.panels) m.dom.classList.add("cm-panel"), m.mount && m.mount();
    }
    update(N) {
      var c = N.state.facet(H2);
      if (this.top.container != c.topContainer && (this.top.sync([]), this.top = new Hg(N.view, !0, c.topContainer)), this.bottom.container != c.bottomContainer && (this.bottom.sync([]), this.bottom = new Hg(N.view, !1, c.bottomContainer)), this.top.syncClasses(), this.bottom.syncClasses(), c = N.state.facet(z2), c != this.input) {
        var m = c.filter((Ie) => Ie);
        c = [];
        let M = [], Q = [], pe = [];
        for (let Ie of m) {
          var k = this.specs.indexOf(Ie);
          0 > k ? (k = Ie(N.view), pe.push(k)) : (k = this.panels[k], k.update && k.update(N)), c.push(k), (k.top ? M : Q).push(k);
        }
        this.specs = m, this.panels = c, this.top.sync(M), this.bottom.sync(Q);
        for (let Ie of pe) Ie.dom.classList.add("cm-panel"), Ie.mount && Ie.mount();
      } else for (m of this.panels) m.update && m.update(N);
    }
    destroy() {
      this.top.sync([]), this.bottom.sync([]);
    }
  }, { provide: (N) => Hr.scrollMargins.of((c) => (c = c.plugin(N)) && { top: c.top.scrollMargin(), bottom: c.bottom.scrollMargin() }) });
  class Hg {
    constructor(c, m, k) {
      this.view = c, this.top = m, this.container = k, this.dom = void 0, this.classes = "", this.panels = [], this.syncClasses();
    }
    sync(c) {
      for (let m of this.panels) m.destroy && 0 > c.indexOf(m) && m.destroy();
      this.panels = c, this.syncDOM();
    }
    syncDOM() {
      if (this.panels.length == 0) this.dom && (this.dom.remove(), this.dom = void 0);
      else {
        if (!this.dom) {
          this.dom = document.createElement("div"), this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom", this.dom.style[this.top ? "top" : "bottom"] = "0";
          var c = this.container || this.view.dom;
          c.insertBefore(this.dom, this.top ? c.firstChild : null);
        }
        c = this.dom.firstChild;
        for (let m of this.panels) if (m.dom.parentNode == this.dom) {
          for (; c != m.dom; ) c = Zn(c);
          c = c.nextSibling;
        } else this.dom.insertBefore(m.dom, c);
        for (; c; ) c = Zn(c);
      }
    }
    scrollMargin() {
      return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
    }
    syncClasses() {
      if (this.container && this.classes != this.view.themeClasses) {
        for (let c of this.classes.split(" ")) c && this.container.classList.remove(c);
        for (let c of (this.classes = this.view.themeClasses).split(" ")) c && this.container.classList.add(c);
      }
    }
  }
  const z2 = Wn.Facet.define({ enables: Z5 });
  class mc extends Wn.RangeValue {
    compare(c) {
      return this == c || this.constructor == c.constructor && this.eq(c);
    }
    eq(c) {
      return !1;
    }
    destroy(c) {
    }
  }
  mc.prototype.elementClass = "", mc.prototype.toDOM = void 0, mc.prototype.mapMode = Wn.MapMode.TrackBefore, mc.prototype.startSide = mc.prototype.endSide = -1, mc.prototype.point = !0;
  const Dh = Wn.Facet.define(), K2 = { class: "", renderEmptyElements: !1, elementStyle: "", markers: () => Wn.RangeSet.empty, lineMarker: () => null, widgetMarker: () => null, lineMarkerChange: null, initialSpacer: null, updateSpacer: null, domEventHandlers: {} }, Zc = Wn.Facet.define(), _d = Wn.Facet.define({ combine: (N) => N.some((c) => c) }), zg = _u.fromClass(class {
    constructor(N) {
      this.view = N, this.prevViewport = N.viewport, this.dom = document.createElement("div"), this.dom.className = "cm-gutters", this.dom.setAttribute("aria-hidden", "true"), this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px", this.gutters = N.state.facet(Zc).map((c) => new xd(N, c));
      for (let c of this.gutters) this.dom.appendChild(c.dom);
      (this.fixed = !N.state.facet(_d)) && (this.dom.style.position = "sticky"), this.syncGutters(!1), N.scrollDOM.insertBefore(this.dom, N.contentDOM);
    }
    update(N) {
      if (this.updateGutters(N)) {
        let c = this.prevViewport, m = N.view.viewport;
        this.syncGutters(Math.min(c.to, m.to) - Math.max(c.from, m.from) < 0.8 * (m.to - m.from));
      }
      N.geometryChanged && (this.dom.style.minHeight = this.view.contentHeight + "px"), this.view.state.facet(_d) != !this.fixed && (this.fixed = !this.fixed, this.dom.style.position = this.fixed ? "sticky" : ""), this.prevViewport = N.view.viewport;
    }
    syncGutters(N) {
      let c = this.dom.nextSibling;
      N && this.dom.remove();
      let m = Wn.RangeSet.iter(this.view.state.facet(Dh), this.view.viewport.from), k = [], M = this.gutters.map((Q) => new q1(Q, this.view.viewport, -this.view.documentPadding.top));
      for (let Q of this.view.viewportLineBlocks) if (k.length && (k = []), Array.isArray(Q.type)) {
        let pe = !0;
        for (let Ie of Q.type) if (Ie.type == l.BlockType.Text && pe) {
          Hl(m, k, Ie.from);
          for (let nn of M) nn.line(this.view, Ie, k);
          pe = !1;
        } else if (Ie.widget) for (let nn of M) nn.widget(this.view, Ie);
      } else if (Q.type == l.BlockType.Text) {
        Hl(m, k, Q.from);
        for (let pe of M) pe.line(this.view, Q, k);
      } else if (Q.widget) for (let pe of M) pe.widget(this.view, Q);
      for (let Q of M) Q.finish();
      N && this.view.scrollDOM.insertBefore(this.dom, c);
    }
    updateGutters(N) {
      let c = N.startState.facet(Zc);
      var m = N.state.facet(Zc);
      let k = N.docChanged || N.heightChanged || N.viewportChanged || !Wn.RangeSet.eq(N.startState.facet(Dh), N.state.facet(Dh), N.view.viewport.from, N.view.viewport.to);
      if (c == m) for (var M of this.gutters) M.update(N) && (k = !0);
      else {
        k = !0, M = [];
        for (let Q of m) m = c.indexOf(Q), 0 > m ? M.push(new xd(this.view, Q)) : (this.gutters[m].update(N), M.push(this.gutters[m]));
        for (let Q of this.gutters) Q.dom.remove(), 0 > M.indexOf(Q) && Q.destroy();
        for (let Q of M) this.dom.appendChild(Q.dom);
        this.gutters = M;
      }
      return k;
    }
    destroy() {
      for (let N of this.gutters) N.destroy();
      this.dom.remove();
    }
  }, { provide: (N) => Hr.scrollMargins.of((c) => {
    let m = c.plugin(N);
    return m && m.gutters.length != 0 && m.fixed ? c.textDirection == l.Direction.LTR ? { left: m.dom.offsetWidth * c.scaleX } : { right: m.dom.offsetWidth * c.scaleX } : null;
  }) });
  class q1 {
    constructor(c, m, k) {
      this.gutter = c, this.height = k, this.i = 0, this.cursor = Wn.RangeSet.iter(c.markers, m.from);
    }
    addElement(c, m, k) {
      let { gutter: M } = this, Q = (m.top - this.height) / c.scaleY, pe = m.height / c.scaleY;
      this.i == M.elements.length ? (c = new X5(c, pe, Q, k), M.elements.push(c), M.dom.appendChild(c.dom)) : M.elements[this.i].update(c, pe, Q, k), this.height = m.bottom, this.i++;
    }
    line(c, m, k) {
      let M = [];
      Hl(this.cursor, M, m.from), k.length && (M = M.concat(k)), (k = this.gutter.config.lineMarker(c, m, M)) && M.unshift(k), k = this.gutter, (M.length != 0 || k.config.renderEmptyElements) && this.addElement(c, m, M);
    }
    widget(c, m) {
      let k = this.gutter.config.widgetMarker(c, m.widget, m);
      k && this.addElement(c, m, [k]);
    }
    finish() {
      let c = this.gutter;
      for (; c.elements.length > this.i; ) {
        let m = c.elements.pop();
        c.dom.removeChild(m.dom), m.destroy();
      }
    }
  }
  class xd {
    constructor(c, m) {
      this.view = c, this.config = m, this.elements = [], this.spacer = null, this.dom = document.createElement("div"), this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
      for (let k in m.domEventHandlers) this.dom.addEventListener(k, (M) => {
        var Q = M.target;
        if (Q != this.dom && this.dom.contains(Q)) {
          for (; Q.parentNode != this.dom; ) Q = Q.parentNode;
          Q = Q.getBoundingClientRect(), Q = (Q.top + Q.bottom) / 2;
        } else Q = M.clientY;
        Q = c.lineBlockAtHeight(Q - c.documentTop), m.domEventHandlers[k](c, Q, M) && M.preventDefault();
      });
      this.markers = ct(m.markers(c)), m.initialSpacer && (this.spacer = new X5(c, 0, 0, [m.initialSpacer(c)]), this.dom.appendChild(this.spacer.dom), this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none");
    }
    update(c) {
      let m = this.markers;
      if (this.markers = ct(this.config.markers(c.view)), this.spacer && this.config.updateSpacer) {
        var k = this.config.updateSpacer(this.spacer.markers[0], c);
        k != this.spacer.markers[0] && this.spacer.update(c.view, 0, 0, [k]);
      }
      return k = c.view.viewport, !Wn.RangeSet.eq(this.markers, m, k.from, k.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(c) : !1);
    }
    destroy() {
      for (let c of this.elements) c.destroy();
    }
  }
  class X5 {
    constructor(c, m, k, M) {
      this.height = -1, this.above = 0, this.markers = [], this.dom = document.createElement("div"), this.dom.className = "cm-gutterElement", this.update(c, m, k, M);
    }
    update(c, m, k, M) {
      this.height != m && (this.height = m, this.dom.style.height = m + "px"), this.above != k && (this.dom.style.marginTop = (this.above = k) ? k + "px" : "");
      e: if (m = this.markers, m.length != M.length) m = !1;
      else {
        for (k = 0; k < m.length; k++) if (!m[k].compare(M[k])) {
          m = !1;
          break e;
        }
        m = !0;
      }
      m || this.setMarkers(c, M);
    }
    setMarkers(c, m) {
      let k = "cm-gutterElement", M = this.dom.firstChild;
      for (let pe = 0, Ie = 0; ; ) {
        let nn = Ie, Xe = pe < m.length ? m[pe++] : null, cn = !1;
        if (Xe) {
          var Q = Xe.elementClass;
          for (Q && (k += " " + Q), Q = Ie; Q < this.markers.length; Q++) if (this.markers[Q].compare(Xe)) {
            nn = Q, cn = !0;
            break;
          }
        } else nn = this.markers.length;
        for (; Ie < nn; ) Q = this.markers[Ie++], Q.toDOM && (Q.destroy(M), Q = M.nextSibling, M.remove(), M = Q);
        if (!Xe) break;
        Xe.toDOM && (cn ? M = M.nextSibling : this.dom.insertBefore(Xe.toDOM(c), M)), cn && Ie++;
      }
      this.dom.className = k, this.markers = m;
    }
    destroy() {
      this.setMarkers(null, []);
    }
  }
  const Q5 = Wn.Facet.define(), Hp = Wn.Facet.define({ combine(N) {
    return Wn.combineConfig(N, { formatNumber: String, domEventHandlers: {} }, { domEventHandlers(c, m) {
      c = Object.assign({}, c);
      for (let k in m) {
        let M = c[k], Q = m[k];
        c[k] = M ? (pe, Ie, nn) => M(pe, Ie, nn) || Q(pe, Ie, nn) : Q;
      }
      return c;
    } });
  } });
  class G2 extends mc {
    constructor(c) {
      super(), this.number = c;
    }
    eq(c) {
      return this.number == c.number;
    }
    toDOM() {
      return document.createTextNode(this.number);
    }
  }
  const Sj = Zc.compute([Hp], (N) => ({
    class: "cm-lineNumbers",
    renderEmptyElements: !1,
    markers(c) {
      return c.state.facet(Q5);
    },
    lineMarker(c, m, k) {
      return k.some((M) => M.toDOM) ? null : new G2(Pl(c, c.state.doc.lineAt(m.from).number));
    },
    widgetMarker: () => null,
    lineMarkerChange: (c) => c.startState.facet(Hp) != c.state.facet(Hp),
    initialSpacer(c) {
      return new G2(Pl(c, Fn(c.state.doc.lines)));
    },
    updateSpacer(c, m) {
      return m = Pl(m.view, Fn(m.view.state.doc.lines)), m == c.number ? c : new G2(m);
    },
    domEventHandlers: N.facet(Hp).domEventHandlers
  })), W1 = new class extends mc {
    constructor() {
      super(...arguments), this.elementClass = "cm-activeLineGutter";
    }
  }(), Kg = Dh.compute(["selection"], (N) => {
    let c = [], m = -1;
    for (let k of N.selection.ranges) {
      let M = N.doc.lineAt(k.head).from;
      M > m && (m = M, c.push(W1.range(M)));
    }
    return Wn.RangeSet.of(c);
  }), Z2 = /* @__PURE__ */ new Map(), Je = br(new vd({ regexp: /\t| +/g, decoration: (N) => {
    N = N[0];
    let c = Z2.get(N);
    return c || Z2.set(N, c = On.mark({ attributes: N === "	" ? { class: "cm-highlightTab" } : { class: "cm-highlightSpace", "data-display": N.replace(/ /g, "·") } })), c;
  }, boundary: /\S/ })), zp = br(new vd({ regexp: /\s+$/g, decoration: On.mark({ class: "cm-trailingSpace" }), boundary: /\S/ })), H1 = { HeightMap: xu, HeightOracle: Lg, MeasuredHeights: Fp, QueryType: bi, ChangedRange: zs, computeOrder: xn, moveVisually: Nn };
  l.BidiSpan = bo, l.BlockInfo = Gi, l.Decoration = On, l.EditorView = Hr, l.GutterMarker = mc, l.MatchDecorator = vd, l.RectangleMarker = yi, l.ViewPlugin = _u, l.ViewUpdate = Ah, l.WidgetType = wn, l.__test = H1, l.closeHoverTooltips = uo, l.crosshairCursor = function(N = {}) {
    let [c, m] = Yg[N.key || "Alt"], k = _u.fromClass(
      class {
        constructor(M) {
          this.view = M, this.isDown = !1;
        }
        set(M) {
          this.isDown != M && (this.isDown = M, this.view.update([]));
        }
      },
      { eventObservers: { keydown(M) {
        this.set(M.keyCode == c || m(M));
      }, keyup(M) {
        M.keyCode != c && m(M) || this.set(!1);
      }, mousemove(M) {
        this.set(m(M));
      } } }
    );
    return [k, Hr.contentAttributes.of((M) => {
      var Q;
      return !((Q = M.plugin(k)) === null || Q === void 0) && Q.isDown ? yd : null;
    })];
  }, l.drawSelection = function(N = {}) {
    return [Gc.of(N), wj, qp, $1, Ag.of(!0)];
  }, l.dropCursor = function() {
    return [Fg, W5];
  }, l.getDrawSelectionConfig = function(N) {
    return N.facet(Gc);
  }, l.getPanel = function(N, c) {
    return c = (N = N.plugin(Z5)) ? N.specs.indexOf(c) : -1, -1 < c ? N.panels[c] : null;
  }, l.getTooltip = function(N, c) {
    return N = N.plugin(W2), N ? (c = N.manager.tooltips.indexOf(c), 0 > c ? null : N.manager.tooltipViews[c]) : null;
  }, l.gutter = function(N) {
    return [ht(), Zc.of(Object.assign(Object.assign({}, K2), N))];
  }, l.gutterLineClass = Dh, l.gutters = ht, l.hasHoverTooltips = function(N) {
    return N.facet(Wg).some((c) => c);
  }, l.highlightActiveLine = function() {
    return B1;
  }, l.highlightActiveLineGutter = function() {
    return Kg;
  }, l.highlightSpecialChars = function(N = {}) {
    return [pc.of(N), ae()];
  }, l.highlightTrailingWhitespace = function() {
    return zp;
  }, l.highlightWhitespace = function() {
    return Je;
  }, l.hoverTooltip = function(N, c = {}) {
    let m = Wn.StateEffect.define(), k = Wn.StateField.define({ create() {
      return null;
    }, update(M, Q) {
      if (M && (c.hideOnChange && (Q.docChanged || Q.selection) || c.hideOn && c.hideOn(Q, M))) return null;
      if (M && Q.docChanged) {
        let pe = Q.changes.mapPos(M.pos, -1, Wn.MapMode.TrackDel);
        if (pe == null) return null;
        let Ie = Object.assign(/* @__PURE__ */ Object.create(null), M);
        Ie.pos = pe, M.end != null && (Ie.end = Q.changes.mapPos(M.end)), M = Ie;
      }
      for (let pe of Q.effects) pe.is(m) && (M = pe.value), pe.is(zu) && (M = null);
      return M;
    }, provide: (M) => Wg.from(M) });
    return [k, _u.define((M) => new xj(M, N, k, m, c.hoverTime || 300)), _j];
  }, l.keymap = yr, l.layer = gt, l.lineNumberMarkers = Q5, l.lineNumbers = function(N = {}) {
    return [Hp.of(N), ht(), Sj];
  }, l.logException = me, l.panels = function(N) {
    return N ? [H2.of(N)] : [];
  }, l.placeholder = function(N) {
    return _u.fromClass(
      class {
        constructor(c) {
          this.view = c, this.placeholder = N ? On.set([On.widget({ widget: new K5(N), side: 1 }).range(0)]) : On.none;
        }
        get decorations() {
          return this.view.state.doc.length ? On.none : this.placeholder;
        }
      },
      { decorations: (c) => c.decorations }
    );
  }, l.rectangularSelection = function(N) {
    let c = N?.eventFilter || ((m) => m.altKey && m.button == 0);
    return Hr.mouseSelectionStyle.of((m, k) => c(k) ? ze(m, k) : null);
  }, l.repositionTooltips = function(N) {
    (N = N.plugin(W2)) && N.maybeMeasure();
  }, l.runScopeHandlers = function(N, c, m) {
    return un(ke(N.state), c, N, m);
  }, l.scrollPastEnd = function() {
    return [q2, Th.of((N) => {
      var c;
      return ((c = N.plugin(q2)) === null || c === void 0 ? void 0 : c.attrs) || null;
    })];
  }, l.showPanel = z2, l.showTooltip = qg, l.tooltips = function(N = {}) {
    return F1.of(N);
  };
};
Xo[4] = function(e, n, t, l) {
  function r(fn, _e, Ve, an) {
    switch (fn) {
      case -2:
        return Ve < _e;
      case -1:
        return an >= _e && Ve < _e;
      case 0:
        return Ve < _e && an > _e;
      case 1:
        return Ve <= _e && an > _e;
      case 2:
        return an > _e;
      case 4:
        return !0;
    }
  }
  function u(fn, _e, Ve, an) {
    for (var En; fn.from == fn.to || (1 > Ve ? fn.from >= _e : fn.from > _e) || (-1 < Ve ? fn.to <= _e : fn.to < _e); ) {
      var Qn = !an && fn instanceof Ye && 0 > fn.index ? null : fn.parent;
      if (!Qn) return fn;
      fn = Qn;
    }
    if (Qn = an ? 0 : l.IterMode.IgnoreOverlays, an) for (let Vn = fn, ot = Vn.parent; ot; Vn = ot, ot = Vn.parent) Vn instanceof Ye && 0 > Vn.index && ((En = ot.enter(_e, Ve, Qn)) === null || En === void 0 ? void 0 : En.from) != Vn.from && (fn = ot);
    for (; ; ) {
      if (an = fn.enter(_e, Ve, Qn), !an) return fn;
      fn = an;
    }
  }
  function o(fn, _e, Ve, an) {
    fn = fn.cursor();
    let En = [];
    if (!fn.firstChild()) return En;
    if (Ve != null) {
      for (; !fn.type.is(Ve); ) if (!fn.nextSibling()) return En;
    }
    for (; ; ) {
      if (an != null && fn.type.is(an)) return En;
      if (fn.type.is(_e) && En.push(fn.node), !fn.nextSibling()) return an == null ? En : [];
    }
  }
  function a(fn, _e, Ve = _e.length - 1) {
    for (fn = fn.parent; 0 <= Ve; fn = fn.parent) {
      if (!fn) return !1;
      if (!fn.type.isAnonymous) {
        if (_e[Ve] && _e[Ve] != fn.name) return !1;
        Ve--;
      }
    }
    return !0;
  }
  function h(fn) {
    if (!fn.length) return null;
    if (fn.length == 1) return fn[0];
    let _e = 0, Ve = fn[0];
    for (var an = 1; an < fn.length; an++) {
      let En = fn[an];
      (En.from > Ve.from || En.to < Ve.to) && (Ve = En, _e = an);
    }
    return an = Ve instanceof Ye && 0 > Ve.index ? null : Ve.parent, fn = fn.slice(), an ? fn[_e] = an : fn.splice(_e, 1), new me(fn, Ve);
  }
  function s(fn) {
    return fn.children.some((_e) => _e instanceof le || !_e.type.isAnonymous || s(_e));
  }
  function d(fn) {
    function _e(bl, tl, Zt, Ql, jl) {
      let { id: Sl, start: gl, end: jr, size: Kt } = St;
      for (var nl = Rr; 0 > Kt; ) {
        if (St.next(), Kt == -1) {
          Zt.push(Pt[Sl]), Ql.push(gl - bl);
          return;
        }
        if (Kt == -3) {
          ul = Sl;
          return;
        }
        if (Kt == -4) {
          Rr = Sl;
          return;
        }
        throw new RangeError(`Unrecognized record size: ${Kt}`);
      }
      var Pr = pr[Sl], ii = gl - bl, Ar;
      if (Ar = jr - gl <= zt) {
        var Ml = St.pos - tl;
        tl = St.fork();
        var Rl = Ar = 0;
        let Se = 0, se = tl.end - zt, Ee = { size: 0, start: 0, skip: 0 };
        e: for (let Ge = tl.pos - Ml; tl.pos > Ge; ) {
          let vn = tl.size;
          if (tl.id == jl && 0 <= vn) {
            Ee.size = Ar, Ee.start = Rl, Ee.skip = Se, Se += 4, Ar += 4, tl.next();
            continue;
          }
          let Kn = tl.pos - vn;
          if (0 > vn || Kn < Ge || tl.start < se) break;
          let Un = tl.id >= ol ? 4 : 0, Pe = tl.start;
          for (tl.next(); tl.pos > Kn; ) {
            if (0 > tl.size) if (tl.size == -3) Un += 4;
            else break e;
            else tl.id >= ol && (Un += 4);
            tl.next();
          }
          Rl = Pe, Ar += vn, Se += Un;
        }
        (0 > jl || Ar == Ml) && (Ee.size = Ar, Ee.start = Rl, Ee.skip = Se), Ar = Ml = 4 < Ee.size ? Ee : void 0;
      }
      if (Ar) {
        for (ii = new Uint16Array(Ml.size - Ml.skip), Pr = St.pos - Ml.size, nl = ii.length; St.pos > Pr; ) nl = Qn(Ml.start, ii, nl);
        Pr = new le(ii, jr - Ml.start, Nt), ii = Ml.start - bl;
      } else {
        for (Ml = St.pos - Kt, St.next(), bl = [], jl = [], tl = Sl >= ol ? Sl : -1, Ar = 0, Rl = jr; St.pos > Ml; ) 0 <= tl && St.id == tl && 0 <= St.size ? (St.end <= Rl - zt && (an(bl, jl, gl, Ar, St.end, Rl, tl, nl), Ar = bl.length, Rl = St.end), St.next()) : _e(gl, Ml, bl, jl, tl);
        0 <= tl && 0 < Ar && Ar < bl.length && an(bl, jl, gl, Ar, gl, Rl, tl, nl), bl.reverse(), jl.reverse(), -1 < tl && 0 < Ar ? (nl = Ve(Pr), Pr = _(Pr, bl, jl, 0, bl.length, 0, jr - gl, nl, nl)) : Pr = En(Pr, bl, jl, jr - gl, nl - jr);
      }
      Zt.push(Pr), Ql.push(ii);
    }
    function Ve(bl) {
      return (tl, Zt, Ql) => {
        let jl = 0, Sl = tl.length - 1, gl, jr;
        if (0 <= Sl && (gl = tl[Sl]) instanceof U) {
          if (!Sl && gl.type == bl && gl.length == Ql) return gl;
          (jr = gl.prop(xe.lookAhead)) && (jl = Zt[Sl] + gl.length + jr);
        }
        return En(bl, tl, Zt, Ql, jl);
      };
    }
    function an(bl, tl, Zt, Ql, jl, Sl, gl, jr) {
      let Kt = [], nl = [];
      for (; bl.length > Ql; ) Kt.push(bl.pop()), nl.push(tl.pop() + Zt - jl);
      bl.push(En(Nt.types[gl], Kt, nl, Sl - jl, jr - Sl)), tl.push(jl - Zt);
    }
    function En(bl, tl, Zt, Ql, jl = 0, Sl) {
      if (ul) {
        let gl = [xe.contextHash, ul];
        Sl = Sl ? [gl].concat(Sl) : [gl];
      }
      return 25 < jl && (jl = [xe.lookAhead, jl], Sl = Sl ? [jl].concat(Sl) : [jl]), new U(bl, tl, Zt, Ql, Sl);
    }
    function Qn(bl, tl, Zt) {
      let { id: Ql, start: jl, end: Sl, size: gl } = St;
      if (St.next(), 0 <= gl && Ql < ol) {
        let jr = Zt;
        if (4 < gl) {
          let Kt = St.pos - (gl - 4);
          for (; St.pos > Kt; ) Zt = Qn(bl, tl, Zt);
        }
        tl[--Zt] = jr, tl[--Zt] = Sl - bl, tl[--Zt] = jl - bl, tl[--Zt] = Ql;
      } else gl == -3 ? ul = Ql : gl == -4 && (Rr = Ql);
      return Zt;
    }
    var Vn;
    let { buffer: ot, nodeSet: Nt, maxBufferLength: zt = 1024, reused: Pt = [], minRepeatType: ol = Nt.types.length } = fn, St = Array.isArray(ot) ? new Me(ot, ot.length) : ot, pr = Nt.types, ul = 0, Rr = 0, ql = [], Mr = [];
    for (; 0 < St.pos; ) _e(fn.start || 0, fn.bufferStart || 0, ql, Mr, -1);
    let wi = (Vn = fn.length) !== null && Vn !== void 0 ? Vn : ql.length ? Mr[0] + ql[0].length : 0;
    return new U(pr[fn.topID], ql.reverse(), Mr.reverse(), wi);
  }
  function p(fn, _e) {
    if (!fn.isAnonymous || _e instanceof le || _e.type != fn) return 1;
    let Ve = Fe.get(_e);
    if (Ve == null) {
      Ve = 1;
      for (let an of _e.children) {
        if (an.type != fn || !(an instanceof U)) {
          Ve = 1;
          break;
        }
        Ve += p(fn, an);
      }
      Fe.set(_e, Ve);
    }
    return Ve;
  }
  function _(fn, _e, Ve, an, En, Qn, Vn, ot, Nt) {
    function zt(ul, Rr, ql, Mr, wi) {
      for (; ql < Mr; ) {
        let tl = ql;
        var bl = Rr[ql];
        let Zt = p(fn, ul[ql]);
        for (ql++; ql < Mr; ql++) {
          let Ql = p(fn, ul[ql]);
          if (Zt + Ql >= ol) break;
          Zt += Ql;
        }
        if (ql == tl + 1) {
          if (Zt > ol) {
            bl = ul[tl], zt(bl.children, bl.positions, 0, bl.children.length, Rr[tl] + wi);
            continue;
          }
          St.push(ul[tl]);
        } else St.push(_(fn, ul, Rr, tl, ql, bl, Rr[ql - 1] + ul[ql - 1].length - bl, null, Nt));
        pr.push(bl + wi - Qn);
      }
    }
    let Pt = 0;
    for (let ul = an; ul < En; ul++) Pt += p(fn, _e[ul]);
    let ol = Math.ceil(1.5 * Pt / 8), St = [], pr = [];
    return zt(_e, Ve, an, En, 0), (ot || Nt)(St, pr, Vn);
  }
  function R(fn, _e, Ve) {
    for (let an of fn) {
      if (an.from >= Ve) break;
      if (an.to > _e) return an.from <= _e && an.to >= Ve ? 2 : 1;
    }
    return 0;
  }
  function F(fn) {
    function _e(zt, Pt, ol, St, pr) {
      for (var ul = zt; Nt[ul + 2] + Vn <= Ve.from; ) ul = Nt[ul + 3];
      let Rr = [], ql = [];
      if (zt < ul) {
        var Mr = ot.buffer[zt + 1];
        Rr.push(ot.slice(zt, ul, Mr)), ql.push(Mr - St);
      }
      return zt = Nt[ul + 1], Mr = Nt[ul + 2], Rr.push(zt + Vn == Ve.from && Mr + Vn == Ve.to && Nt[ul] == Ve.type.id ? Ve.toTree() : _e(
        ul + 4,
        Nt[ul + 3],
        ot.set.types[Nt[ul]],
        zt,
        Mr - zt
      )), ql.push(zt - St), ul = Nt[ul + 3], ul < Pt && (zt = ot.buffer[ul + 1], Rr.push(ot.slice(ul, Pt, zt)), ql.push(zt - St)), new U(ol, Rr, ql, pr);
    }
    let { node: Ve } = fn, an = 0;
    do
      fn.parent(), an++;
    while (!fn.tree);
    var En = 0;
    let Qn = fn.tree, Vn = 0;
    for (; Vn = Qn.positions[En] + fn.from, !(Vn <= Ve.from && Vn + Qn.children[En].length >= Ve.to); En++) ;
    let ot = Qn.children[En], Nt = ot.buffer;
    for (Qn.children[En] = _e(0, Nt.length, E.none, 0, ot.length), En = 0; En <= an; En++) fn.childAfter(Ve.from);
  }
  function L(fn, _e) {
    let Ve = null, an = _e;
    for (let En = 1, Qn = 0; En < fn.length; En++) {
      let Vn = fn[En - 1].to, ot = fn[En].from;
      for (; Qn < an.length; Qn++) {
        let Nt = an[Qn];
        if (Nt.from >= ot) break;
        Nt.to <= Vn || (Ve || (an = Ve = _e.slice()), Nt.from < Vn ? (Ve[Qn] = new ce(Nt.from, Vn), Nt.to > ot && Ve.splice(Qn + 1, 0, new ce(ot, Nt.to))) : Nt.to > ot ? Ve[Qn--] = new ce(ot, Nt.to) : Ve.splice(Qn--, 1));
      }
    }
    return an;
  }
  function G(fn, _e, Ve, an) {
    let En = 0, Qn = 0, Vn = !1, ot = !1;
    var Nt = -1e9;
    let zt = [];
    for (; ; ) {
      let Pt = En == fn.length ? 1e9 : Vn ? fn[En].to : fn[En].from, ol = Qn == _e.length ? 1e9 : ot ? _e[Qn].to : _e[Qn].from;
      if (Vn != ot) {
        Nt = Math.max(Nt, Ve);
        let St = Math.min(Pt, ol, an);
        Nt < St && zt.push(new ce(
          Nt,
          St
        ));
      }
      if (Nt = Math.min(Pt, ol), Nt == 1e9) break;
      Pt == Nt && (Vn ? (Vn = !1, En++) : Vn = !0), ol == Nt && (ot ? (ot = !1, Qn++) : ot = !0);
    }
    return zt;
  }
  function J(fn, _e) {
    let Ve = [];
    for (let { pos: Qn, mount: Vn, frag: ot } of fn) {
      fn = Qn + (Vn.overlay ? Vn.overlay[0].from : 0);
      var an = fn + Vn.tree.length, En = Math.max(ot.from, fn);
      let Nt = Math.min(ot.to, an);
      if (Vn.overlay) {
        an = Vn.overlay.map((zt) => new ce(zt.from + Qn, zt.to + Qn)), an = G(_e, an, En, Nt);
        for (let zt = 0, Pt = En; ; zt++) {
          let ol = (En = zt == an.length) ? Nt : an[zt].from;
          if (ol > Pt && Ve.push(new Be(
            Pt,
            ol,
            Vn.tree,
            -fn,
            ot.from >= Pt || ot.openStart,
            ot.to <= ol || ot.openEnd
          )), En) break;
          Pt = an[zt].to;
        }
      } else Ve.push(new Be(En, Nt, Vn.tree, -fn, ot.from >= fn || ot.openStart, ot.to <= an || ot.openEnd));
    }
    return Ve;
  }
  let we = 0;
  class ce {
    constructor(_e, Ve) {
      this.from = _e, this.to = Ve;
    }
  }
  class xe {
    constructor(_e = {}) {
      this.id = we++, this.perNode = !!_e.perNode, this.deserialize = _e.deserialize || (() => {
        throw Error("This node type doesn't define a deserialize function");
      });
    }
    add(_e) {
      if (this.perNode) throw new RangeError("Can't add per-node props to node types");
      return typeof _e != "function" && (_e = E.match(_e)), (Ve) => (Ve = _e(Ve), Ve === void 0 ? null : [this, Ve]);
    }
  }
  xe.closedBy = new xe({ deserialize: (fn) => fn.split(" ") }), xe.openedBy = new xe({ deserialize: (fn) => fn.split(" ") }), xe.group = new xe({ deserialize: (fn) => fn.split(" ") }), xe.contextHash = new xe({ perNode: !0 }), xe.lookAhead = new xe({ perNode: !0 }), xe.mounted = new xe({ perNode: !0 });
  class $e {
    constructor(_e, Ve, an) {
      this.tree = _e, this.overlay = Ve, this.parser = an;
    }
    static get(_e) {
      return _e && _e.props && _e.props[xe.mounted.id];
    }
  }
  const je = /* @__PURE__ */ Object.create(null);
  class E {
    constructor(_e, Ve, an, En = 0) {
      this.name = _e, this.props = Ve, this.id = an, this.flags = En;
    }
    static define(_e) {
      let Ve = _e.props && _e.props.length ? /* @__PURE__ */ Object.create(null) : je, an = new E(_e.name || "", Ve, _e.id, (_e.top ? 1 : 0) | (_e.skipped ? 2 : 0) | (_e.error ? 4 : 0) | (_e.name == null ? 8 : 0));
      if (_e.props) {
        for (let En of _e.props) if (Array.isArray(En) || (En = En(an)), En) {
          if (En[0].perNode) throw new RangeError("Can't store a per-node prop on a node type");
          Ve[En[0].id] = En[1];
        }
      }
      return an;
    }
    prop(_e) {
      return this.props[_e.id];
    }
    get isTop() {
      return 0 < (this.flags & 1);
    }
    get isSkipped() {
      return 0 < (this.flags & 2);
    }
    get isError() {
      return 0 < (this.flags & 4);
    }
    get isAnonymous() {
      return 0 < (this.flags & 8);
    }
    is(_e) {
      if (typeof _e == "string") {
        if (this.name == _e) return !0;
        let Ve = this.prop(xe.group);
        return Ve ? -1 < Ve.indexOf(_e) : !1;
      }
      return this.id == _e;
    }
    static match(_e) {
      let Ve = /* @__PURE__ */ Object.create(null);
      for (let an in _e) for (let En of an.split(" ")) Ve[En] = _e[an];
      return (an) => {
        for (let En = an.prop(xe.group), Qn = -1; Qn < (En ? En.length : 0); Qn++) {
          let Vn = Ve[0 > Qn ? an.name : En[Qn]];
          if (Vn) return Vn;
        }
      };
    }
  }
  E.none = new E("", /* @__PURE__ */ Object.create(null), 0, 8);
  class P {
    constructor(_e) {
      this.types = _e;
      for (let Ve = 0; Ve < _e.length; Ve++) if (_e[Ve].id != Ve) throw new RangeError("Node type ids should correspond to array positions when creating a node set");
    }
    extend(..._e) {
      let Ve = [];
      for (let an of this.types) {
        let En = null;
        for (let Qn of _e) {
          let Vn = Qn(an);
          Vn && (En ||= Object.assign({}, an.props), En[Vn[0].id] = Vn[1]);
        }
        Ve.push(En ? new E(an.name, En, an.id, an.flags) : an);
      }
      return new P(Ve);
    }
  }
  const K = /* @__PURE__ */ new WeakMap(), H = /* @__PURE__ */ new WeakMap();
  l.IterMode = void 0, function(fn) {
    fn[fn.ExcludeBuffers = 1] = "ExcludeBuffers", fn[fn.IncludeAnonymous = 2] = "IncludeAnonymous", fn[fn.IgnoreMounts = 4] = "IgnoreMounts", fn[fn.IgnoreOverlays = 8] = "IgnoreOverlays";
  }(l.IterMode || (l.IterMode = {}));
  class U {
    constructor(_e, Ve, an, En, Qn) {
      if (this.type = _e, this.children = Ve, this.positions = an, this.length = En, this.props = null, Qn && Qn.length) {
        this.props = /* @__PURE__ */ Object.create(null);
        for (let [Vn, ot] of Qn) this.props[typeof Vn == "number" ? Vn : Vn.id] = ot;
      }
    }
    toString() {
      var _e = $e.get(this);
      if (_e && !_e.overlay) return _e.tree.toString();
      _e = "";
      for (let Ve of this.children) {
        let an = Ve.toString();
        an && (_e && (_e += ","), _e += an);
      }
      return this.type.name ? (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (_e.length ? "(" + _e + ")" : "") : _e;
    }
    cursor(_e = 0) {
      return new Ae(this.topNode, _e);
    }
    cursorAt(_e, Ve = 0, an) {
      return an = K.get(this) || this.topNode, an = new Ae(an), an.moveTo(_e, Ve), K.set(this, an._tree), an;
    }
    get topNode() {
      return new Ye(this, 0, 0, null);
    }
    resolve(_e, Ve = 0) {
      return _e = u(K.get(this) || this.topNode, _e, Ve, !1), K.set(this, _e), _e;
    }
    resolveInner(_e, Ve = 0) {
      return _e = u(H.get(this) || this.topNode, _e, Ve, !0), H.set(this, _e), _e;
    }
    resolveStack(_e, Ve = 0) {
      let an = this.resolveInner(_e, Ve), En = null;
      for (var Qn = an instanceof Ye ? an : an.context.parent; Qn; Qn = Qn.parent) if (0 > Qn.index) Qn = Qn.parent, (En ||= [an]).push(Qn.resolve(_e, Ve));
      else {
        var Vn = $e.get(Qn.tree);
        Vn && Vn.overlay && Vn.overlay[0].from <= _e && Vn.overlay[Vn.overlay.length - 1].to >= _e && (Vn = new Ye(Vn.tree, Vn.overlay[0].from + Qn.from, 0, null), (En ||= [an]).push(u(Vn, _e, Ve, !1)));
      }
      return En ? h(En) : an;
    }
    iterate(_e) {
      let { enter: Ve, leave: an, from: En = 0, to: Qn = this.length } = _e;
      var Vn = _e.mode || 0;
      for (_e = 0 < (Vn & l.IterMode.IncludeAnonymous), Vn = this.cursor(Vn | l.IterMode.IncludeAnonymous); ; ) {
        let ot = !1;
        if (Vn.from <= Qn && Vn.to >= En && (!_e && Vn.type.isAnonymous || Ve(Vn) !== !1)) {
          if (Vn.firstChild()) continue;
          ot = !0;
        }
        for (; ot && an && (_e || !Vn.type.isAnonymous) && an(Vn), !Vn.nextSibling(); ) {
          if (!Vn.parent()) return;
          ot = !0;
        }
      }
    }
    prop(_e) {
      return _e.perNode ? this.props ? this.props[_e.id] : void 0 : this.type.prop(_e);
    }
    get propValues() {
      let _e = [];
      if (this.props) for (let Ve in this.props) _e.push([+Ve, this.props[Ve]]);
      return _e;
    }
    balance(_e = {}) {
      return 8 >= this.children.length ? this : _(
        E.none,
        this.children,
        this.positions,
        0,
        this.children.length,
        0,
        this.length,
        (Ve, an, En) => new U(this.type, Ve, an, En, this.propValues),
        _e.makeTree || ((Ve, an, En) => new U(E.none, Ve, an, En))
      );
    }
    static build(_e) {
      return d(_e);
    }
  }
  U.empty = new U(E.none, [], [], 0);
  class Me {
    constructor(_e, Ve) {
      this.buffer = _e, this.index = Ve;
    }
    get id() {
      return this.buffer[this.index - 4];
    }
    get start() {
      return this.buffer[this.index - 3];
    }
    get end() {
      return this.buffer[this.index - 2];
    }
    get size() {
      return this.buffer[this.index - 1];
    }
    get pos() {
      return this.index;
    }
    next() {
      this.index -= 4;
    }
    fork() {
      return new Me(this.buffer, this.index);
    }
  }
  class le {
    constructor(_e, Ve, an) {
      this.buffer = _e, this.length = Ve, this.set = an;
    }
    get type() {
      return E.none;
    }
    toString() {
      let _e = [];
      for (let Ve = 0; Ve < this.buffer.length; ) _e.push(this.childString(Ve)), Ve = this.buffer[Ve + 3];
      return _e.join(",");
    }
    childString(_e) {
      let Ve = this.buffer[_e + 3];
      var an = this.set.types[this.buffer[_e]];
      let En = an.name;
      if (/\W/.test(En) && !an.isError && (En = JSON.stringify(En)), _e += 4, Ve == _e) return En;
      for (an = []; _e < Ve; ) an.push(this.childString(_e)), _e = this.buffer[_e + 3];
      return En + "(" + an.join(",") + ")";
    }
    findChild(_e, Ve, an, En, Qn) {
      let { buffer: Vn } = this, ot = -1;
      for (; _e != Ve && !(r(Qn, En, Vn[_e + 1], Vn[_e + 2]) && (ot = _e, 0 < an)); _e = Vn[_e + 3]) ;
      return ot;
    }
    slice(_e, Ve, an) {
      let En = this.buffer, Qn = new Uint16Array(Ve - _e), Vn = 0;
      for (let ot = _e, Nt = 0; ot < Ve; ) {
        Qn[Nt++] = En[ot++], Qn[Nt++] = En[ot++] - an;
        let zt = Qn[Nt++] = En[ot++] - an;
        Qn[Nt++] = En[ot++] - _e, Vn = Math.max(Vn, zt);
      }
      return new le(Qn, Vn, this.set);
    }
  }
  class Ce {
    cursor(_e = 0) {
      return new Ae(this, _e);
    }
    getChild(_e, Ve = null, an = null) {
      return _e = o(this, _e, Ve, an), _e.length ? _e[0] : null;
    }
    getChildren(_e, Ve = null, an = null) {
      return o(this, _e, Ve, an);
    }
    resolve(_e, Ve = 0) {
      return u(this, _e, Ve, !1);
    }
    resolveInner(_e, Ve = 0) {
      return u(this, _e, Ve, !0);
    }
    matchContext(_e) {
      return a(this, _e);
    }
    enterUnfinishedNodesBefore(_e) {
      _e = this.childBefore(_e);
      let Ve = this;
      for (; _e; ) {
        let an = _e.lastChild;
        if (!an || an.to != _e.to) break;
        an.type.isError && an.from == an.to ? (Ve = _e, _e = an.prevSibling) : _e = an;
      }
      return Ve;
    }
    get node() {
      return this;
    }
    get next() {
      return this.parent;
    }
  }
  class Ye extends Ce {
    constructor(_e, Ve, an, En) {
      super(), this._tree = _e, this.from = Ve, this.index = an, this._parent = En;
    }
    get type() {
      return this._tree.type;
    }
    get name() {
      return this._tree.type.name;
    }
    get to() {
      return this.from + this._tree.length;
    }
    nextChild(_e, Ve, an, En, Qn = 0) {
      for (let Vn = this; ; ) {
        for (let { children: ot, positions: Nt } = Vn._tree, zt = 0 < Ve ? ot.length : -1; _e != zt; _e += Ve) {
          let Pt = ot[_e], ol = Nt[_e] + Vn.from;
          if (r(En, an, ol, ol + Pt.length)) {
            if (Pt instanceof le) {
              if (Qn & l.IterMode.ExcludeBuffers) continue;
              let St = Pt.findChild(0, Pt.buffer.length, Ve, an - ol, En);
              if (-1 < St) return new q(new B(Vn, Pt, _e, ol), null, St);
            } else if (Qn & l.IterMode.IncludeAnonymous || !Pt.type.isAnonymous || s(Pt)) {
              let St;
              return !(Qn & l.IterMode.IgnoreMounts) && (St = $e.get(Pt)) && !St.overlay ? new Ye(St.tree, ol, _e, Vn) : (_e = new Ye(Pt, ol, _e, Vn), Qn & l.IterMode.IncludeAnonymous || !_e.type.isAnonymous ? _e : _e.nextChild(0 > Ve ? Pt.children.length - 1 : 0, Ve, an, En));
            }
          }
        }
        if (Qn & l.IterMode.IncludeAnonymous || !Vn.type.isAnonymous || (_e = 0 <= Vn.index ? Vn.index + Ve : 0 > Ve ? -1 : Vn._parent._tree.children.length, Vn = Vn._parent, !Vn)) return null;
      }
    }
    get firstChild() {
      return this.nextChild(0, 1, 0, 4);
    }
    get lastChild() {
      return this.nextChild(this._tree.children.length - 1, -1, 0, 4);
    }
    childAfter(_e) {
      return this.nextChild(0, 1, _e, 2);
    }
    childBefore(_e) {
      return this.nextChild(this._tree.children.length - 1, -1, _e, -2);
    }
    enter(_e, Ve, an = 0) {
      let En;
      if (!(an & l.IterMode.IgnoreOverlays) && (En = $e.get(this._tree)) && En.overlay) {
        let Qn = _e - this.from;
        for (let { from: Vn, to: ot } of En.overlay) if ((0 < Ve ? Vn <= Qn : Vn < Qn) && (0 > Ve ? ot >= Qn : ot > Qn)) return new Ye(En.tree, En.overlay[0].from + this.from, -1, this);
      }
      return this.nextChild(0, 1, _e, Ve, an);
    }
    nextSignificantParent() {
      let _e = this;
      for (; _e.type.isAnonymous && _e._parent; ) _e = _e._parent;
      return _e;
    }
    get parent() {
      return this._parent ? this._parent.nextSignificantParent() : null;
    }
    get nextSibling() {
      return this._parent && 0 <= this.index ? this._parent.nextChild(this.index + 1, 1, 0, 4) : null;
    }
    get prevSibling() {
      return this._parent && 0 <= this.index ? this._parent.nextChild(this.index - 1, -1, 0, 4) : null;
    }
    get tree() {
      return this._tree;
    }
    toTree() {
      return this._tree;
    }
    toString() {
      return this._tree.toString();
    }
  }
  class B {
    constructor(_e, Ve, an, En) {
      this.parent = _e, this.buffer = Ve, this.index = an, this.start = En;
    }
  }
  class q extends Ce {
    get name() {
      return this.type.name;
    }
    get from() {
      return this.context.start + this.context.buffer.buffer[this.index + 1];
    }
    get to() {
      return this.context.start + this.context.buffer.buffer[this.index + 2];
    }
    constructor(_e, Ve, an) {
      super(), this.context = _e, this._parent = Ve, this.index = an, this.type = _e.buffer.set.types[_e.buffer.buffer[an]];
    }
    child(_e, Ve, an) {
      let { buffer: En } = this.context;
      return _e = En.findChild(this.index + 4, En.buffer[this.index + 3], _e, Ve - this.context.start, an), 0 > _e ? null : new q(this.context, this, _e);
    }
    get firstChild() {
      return this.child(1, 0, 4);
    }
    get lastChild() {
      return this.child(-1, 0, 4);
    }
    childAfter(_e) {
      return this.child(1, _e, 2);
    }
    childBefore(_e) {
      return this.child(-1, _e, -2);
    }
    enter(_e, Ve, an = 0) {
      return an & l.IterMode.ExcludeBuffers ? null : ({ buffer: an } = this.context, _e = an.findChild(this.index + 4, an.buffer[this.index + 3], 0 < Ve ? 1 : -1, _e - this.context.start, Ve), 0 > _e ? null : new q(this.context, this, _e));
    }
    get parent() {
      return this._parent || this.context.parent.nextSignificantParent();
    }
    externalSibling(_e) {
      return this._parent ? null : this.context.parent.nextChild(this.context.index + _e, _e, 0, 4);
    }
    get nextSibling() {
      let { buffer: _e } = this.context, Ve = _e.buffer[this.index + 3];
      return Ve < (this._parent ? _e.buffer[this._parent.index + 3] : _e.buffer.length) ? new q(this.context, this._parent, Ve) : this.externalSibling(1);
    }
    get prevSibling() {
      let { buffer: _e } = this.context, Ve = this._parent ? this._parent.index + 4 : 0;
      return this.index == Ve ? this.externalSibling(-1) : new q(this.context, this._parent, _e.findChild(Ve, this.index, -1, 0, 4));
    }
    get tree() {
      return null;
    }
    toTree() {
      let _e = [], Ve = [], { buffer: an } = this.context, En = this.index + 4, Qn = an.buffer[this.index + 3];
      return Qn > En && (_e.push(an.slice(En, Qn, an.buffer[this.index + 1])), Ve.push(0)), new U(this.type, _e, Ve, this.to - this.from);
    }
    toString() {
      return this.context.buffer.childString(this.index);
    }
  }
  class me {
    constructor(_e, Ve) {
      this.heads = _e, this.node = Ve;
    }
    get next() {
      return h(this.heads);
    }
  }
  class Ae {
    get name() {
      return this.type.name;
    }
    constructor(_e, Ve = 0) {
      if (this.mode = Ve, this.buffer = null, this.stack = [], this.index = 0, this.bufferNode = null, _e instanceof Ye) this.yieldNode(_e);
      else {
        for (this._tree = _e.context.parent, this.buffer = _e.context, Ve = _e._parent; Ve; Ve = Ve._parent) this.stack.unshift(Ve.index);
        this.bufferNode = _e, this.yieldBuf(_e.index);
      }
    }
    yieldNode(_e) {
      return _e ? (this._tree = _e, this.type = _e.type, this.from = _e.from, this.to = _e.to, !0) : !1;
    }
    yieldBuf(_e, Ve) {
      this.index = _e;
      let { start: an, buffer: En } = this.buffer;
      return this.type = Ve || En.set.types[En.buffer[_e]], this.from = an + En.buffer[_e + 1], this.to = an + En.buffer[_e + 2], !0;
    }
    yield(_e) {
      return _e ? _e instanceof Ye ? (this.buffer = null, this.yieldNode(_e)) : (this.buffer = _e.context, this.yieldBuf(_e.index, _e.type)) : !1;
    }
    toString() {
      return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
    }
    enterChild(_e, Ve, an) {
      if (!this.buffer) return this.yield(this._tree.nextChild(0 > _e ? this._tree._tree.children.length - 1 : 0, _e, Ve, an, this.mode));
      let { buffer: En } = this.buffer;
      return _e = En.findChild(this.index + 4, En.buffer[this.index + 3], _e, Ve - this.buffer.start, an), 0 > _e ? !1 : (this.stack.push(this.index), this.yieldBuf(_e));
    }
    firstChild() {
      return this.enterChild(1, 0, 4);
    }
    lastChild() {
      return this.enterChild(-1, 0, 4);
    }
    childAfter(_e) {
      return this.enterChild(1, _e, 2);
    }
    childBefore(_e) {
      return this.enterChild(-1, _e, -2);
    }
    enter(_e, Ve, an = this.mode) {
      return this.buffer ? an & l.IterMode.ExcludeBuffers ? !1 : this.enterChild(1, _e, Ve) : this.yield(this._tree.enter(_e, Ve, an));
    }
    parent() {
      if (!this.buffer) return this.yieldNode(this.mode & l.IterMode.IncludeAnonymous ? this._tree._parent : this._tree.parent);
      if (this.stack.length) return this.yieldBuf(this.stack.pop());
      let _e = this.mode & l.IterMode.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
      return this.buffer = null, this.yieldNode(_e);
    }
    sibling(_e) {
      if (!this.buffer) return this._tree._parent ? this.yield(0 > this._tree.index ? null : this._tree._parent.nextChild(this._tree.index + _e, _e, 0, 4, this.mode)) : !1;
      let { buffer: Ve } = this.buffer, an = this.stack.length - 1;
      if (0 > _e) {
        var En = 0 > an ? 0 : this.stack[an] + 4;
        if (this.index != En) return this.yieldBuf(Ve.findChild(En, this.index, -1, 0, 4));
      } else if (En = Ve.buffer[this.index + 3], En < (0 > an ? Ve.buffer.length : Ve.buffer[this.stack[an] + 3])) return this.yieldBuf(En);
      return 0 > an ? this.yield(this.buffer.parent.nextChild(this.buffer.index + _e, _e, 0, 4, this.mode)) : !1;
    }
    nextSibling() {
      return this.sibling(1);
    }
    prevSibling() {
      return this.sibling(-1);
    }
    atLastNode(_e) {
      var Ve, an;
      if ({ buffer: an } = this, an) {
        if (0 < _e) {
          if (this.index < an.buffer.buffer.length) return !1;
        } else for (Ve = 0; Ve < this.index; Ve++) if (an.buffer.buffer[Ve + 3] < this.index) return !1;
        ({ index: Ve, parent: an } = an);
      } else ({ index: Ve, _parent: an } = this._tree);
      for (; an; { index: Ve, _parent: an } = an) if (-1 < Ve) {
        for (let En = Ve + _e, Qn = 0 > _e ? -1 : an._tree.children.length; En != Qn; En += _e) if (Ve = an._tree.children[En], this.mode & l.IterMode.IncludeAnonymous || Ve instanceof le || !Ve.type.isAnonymous || s(Ve)) return !1;
      }
      return !0;
    }
    move(_e, Ve) {
      if (Ve && this.enterChild(_e, 0, 4)) return !0;
      for (; ; ) {
        if (this.sibling(_e)) return !0;
        if (this.atLastNode(_e) || !this.parent()) return !1;
      }
    }
    next(_e = !0) {
      return this.move(1, _e);
    }
    prev(_e = !0) {
      return this.move(-1, _e);
    }
    moveTo(_e, Ve = 0) {
      for (; (this.from == this.to || (1 > Ve ? this.from >= _e : this.from > _e) || (-1 < Ve ? this.to <= _e : this.to < _e)) && this.parent(); ) ;
      for (; this.enterChild(1, _e, Ve); ) ;
      return this;
    }
    get node() {
      if (!this.buffer) return this._tree;
      var _e = this.bufferNode;
      let Ve = null, an = 0;
      if (_e && _e.context == this.buffer) e: for (let En = this.index, Qn = this.stack.length; 0 <= Qn; ) {
        for (let Vn = _e; Vn; Vn = Vn._parent) if (Vn.index == En) {
          if (En == this.index) return Vn;
          Ve = Vn, an = Qn + 1;
          break e;
        }
        En = this.stack[--Qn];
      }
      for (_e = an; _e < this.stack.length; _e++) Ve = new q(this.buffer, Ve, this.stack[_e]);
      return this.bufferNode = new q(
        this.buffer,
        Ve,
        this.index
      );
    }
    get tree() {
      return this.buffer ? null : this._tree._tree;
    }
    iterate(_e, Ve) {
      for (let an = 0; ; ) {
        let En = !1;
        if (this.type.isAnonymous || _e(this) !== !1) {
          if (this.firstChild()) {
            an++;
            continue;
          }
          this.type.isAnonymous || (En = !0);
        }
        for (; En && Ve && Ve(this), !this.nextSibling(); ) {
          if (!an) return;
          this.parent(), an--, En = !0;
        }
      }
    }
    matchContext(_e) {
      if (!this.buffer) return a(this.node, _e);
      let { buffer: Ve } = this.buffer, { types: an } = Ve.set;
      for (let En = _e.length - 1, Qn = this.stack.length - 1; 0 <= En; Qn--) {
        if (0 > Qn) return a(this.node, _e, En);
        let Vn = an[Ve.buffer[this.stack[Qn]]];
        if (!Vn.isAnonymous) {
          if (_e[En] && _e[En] != Vn.name) return !1;
          En--;
        }
      }
      return !0;
    }
  }
  const Fe = /* @__PURE__ */ new WeakMap();
  class ln {
    constructor() {
      this.map = /* @__PURE__ */ new WeakMap();
    }
    setBuffer(_e, Ve, an) {
      let En = this.map.get(_e);
      En || this.map.set(_e, En = /* @__PURE__ */ new Map()), En.set(Ve, an);
    }
    getBuffer(_e, Ve) {
      return (_e = this.map.get(_e)) && _e.get(Ve);
    }
    set(_e, Ve) {
      _e instanceof q ? this.setBuffer(_e.context.buffer, _e.index, Ve) : _e instanceof Ye && this.map.set(_e.tree, Ve);
    }
    get(_e) {
      return _e instanceof q ? this.getBuffer(_e.context.buffer, _e.index) : _e instanceof Ye ? this.map.get(_e.tree) : void 0;
    }
    cursorSet(_e, Ve) {
      _e.buffer ? this.setBuffer(_e.buffer.buffer, _e.index, Ve) : this.map.set(_e.tree, Ve);
    }
    cursorGet(_e) {
      return _e.buffer ? this.getBuffer(_e.buffer.buffer, _e.index) : this.map.get(_e.tree);
    }
  }
  class Be {
    constructor(_e, Ve, an, En, Qn = !1, Vn = !1) {
      this.from = _e, this.to = Ve, this.tree = an, this.offset = En, this.open = (Qn ? 1 : 0) | (Vn ? 2 : 0);
    }
    get openStart() {
      return 0 < (this.open & 1);
    }
    get openEnd() {
      return 0 < (this.open & 2);
    }
    static addTree(_e, Ve = [], an = !1) {
      an = [new Be(0, _e.length, _e, 0, !1, an)];
      for (let En of Ve) En.to > _e.length && an.push(En);
      return an;
    }
    static applyChanges(_e, Ve, an = 128) {
      if (!Ve.length) return _e;
      let En = [], Qn = 1, Vn = _e.length ? _e[0] : null;
      for (let ot = 0, Nt = 0, zt = 0; ; ot++) {
        let Pt = ot < Ve.length ? Ve[ot] : null, ol = Pt ? Pt.fromA : 1e9;
        if (ol - Nt >= an) for (; Vn && Vn.from < ol; ) {
          let St = Vn;
          if (Nt >= St.from || ol <= St.to || zt) {
            let pr = Math.max(St.from, Nt) - zt, ul = Math.min(St.to, ol) - zt;
            St = pr >= ul ? null : new Be(pr, ul, St.tree, St.offset + zt, 0 < ot, !!Pt);
          }
          if (St && En.push(St), Vn.to > ol) break;
          Vn = Qn < _e.length ? _e[Qn++] : null;
        }
        if (!Pt) break;
        Nt = Pt.toA, zt = Pt.toA - Pt.toB;
      }
      return En;
    }
  }
  class Ze {
    startParse(_e, Ve, an) {
      return typeof _e == "string" && (_e = new pn(_e)), an = an ? an.length ? an.map((En) => new ce(En.from, En.to)) : [new ce(0, 0)] : [new ce(0, _e.length)], this.createParse(_e, Ve || [], an);
    }
    parse(_e, Ve, an) {
      for (_e = this.startParse(_e, Ve, an); ; ) if (Ve = _e.advance()) return Ve;
    }
  }
  class pn {
    constructor(_e) {
      this.string = _e;
    }
    get length() {
      return this.string.length;
    }
    chunk(_e) {
      return this.string.slice(_e);
    }
    get lineChunks() {
      return !1;
    }
    read(_e, Ve) {
      return this.string.slice(_e, Ve);
    }
  }
  class xn {
    constructor(_e, Ve, an, En, Qn) {
      if (this.parser = _e, this.parse = Ve, this.overlay = an, this.target = En, this.ranges = Qn, !Qn.length || Qn.some((Vn) => Vn.from >= Vn.to)) throw new RangeError("Invalid inner parse ranges given: " + JSON.stringify(Qn));
    }
  }
  class Nn {
    constructor(_e, Ve, an, En, Qn, Vn, ot) {
      this.parser = _e, this.predicate = Ve, this.mounts = an, this.index = En, this.start = Qn, this.target = Vn, this.prev = ot, this.depth = 0, this.ranges = [];
    }
  }
  const at = new xe({ perNode: !0 });
  class Yt {
    constructor(_e, Ve, an, En, Qn) {
      this.nest = Ve, this.input = an, this.fragments = En, this.ranges = Qn, this.inner = [], this.innerDone = 0, this.stoppedAt = this.baseTree = null, this.baseParse = _e;
    }
    advance() {
      if (this.baseParse) {
        var _e = this.baseParse.advance();
        if (!_e) return null;
        if (this.baseParse = null, this.baseTree = _e, this.startInner(), this.stoppedAt != null) for (var Ve of this.inner) Ve.parse.stopAt(this.stoppedAt);
      }
      if (this.innerDone == this.inner.length) return _e = this.baseTree, this.stoppedAt != null && (_e = new U(_e.type, _e.children, _e.positions, _e.length, _e.propValues.concat([[at, this.stoppedAt]]))), _e;
      if (_e = this.inner[this.innerDone], Ve = _e.parse.advance()) {
        this.innerDone++;
        let an = Object.assign(/* @__PURE__ */ Object.create(null), _e.target.props);
        an[xe.mounted.id] = new $e(
          Ve,
          _e.overlay,
          _e.parser
        ), _e.target.props = an;
      }
      return null;
    }
    get parsedPos() {
      if (this.baseParse) return 0;
      let _e = this.input.length;
      for (let Ve = this.innerDone; Ve < this.inner.length; Ve++) this.inner[Ve].ranges[0].from < _e && (_e = Math.min(_e, this.inner[Ve].parse.parsedPos));
      return _e;
    }
    stopAt(_e) {
      if (this.stoppedAt = _e, this.baseParse) this.baseParse.stopAt(_e);
      else for (let Ve = this.innerDone; Ve < this.inner.length; Ve++) this.inner[Ve].parse.stopAt(_e);
    }
    startInner() {
      let _e = new Cl(this.fragments), Ve = null, an = null, En = new Ae(new Ye(
        this.baseTree,
        this.ranges[0].from,
        0,
        null
      ), l.IterMode.IncludeAnonymous | l.IterMode.IgnoreMounts);
      e: for (let Vn, ot; this.stoppedAt == null || En.from < this.stoppedAt; ) {
        var Qn = !0;
        let Nt;
        if (_e.hasNode(En)) {
          if (Ve && (Qn = Ve.mounts.find((zt) => zt.frag.from <= En.from && zt.frag.to >= En.to && zt.mount.overlay))) for (let zt of Qn.mount.overlay) {
            let Pt = zt.from + Qn.pos, ol = zt.to + Qn.pos;
            Pt >= En.from && ol <= En.to && !Ve.ranges.some((St) => St.from < ol && St.to > Pt) && Ve.ranges.push({ from: Pt, to: ol });
          }
          Qn = !1;
        } else if (an && (ot = R(an.ranges, En.from, En.to))) Qn = ot != 2;
        else if (!En.type.isAnonymous && En.from < En.to && (Vn = this.nest(En, this.input))) {
          En.tree || F(En);
          let zt = _e.findMounts(En.from, Vn.parser);
          if (typeof Vn.overlay == "function") Ve = new Nn(Vn.parser, Vn.overlay, zt, this.inner.length, En.from, En.tree, Ve);
          else {
            let Pt = L(this.ranges, Vn.overlay || [new ce(En.from, En.to)]);
            Pt.length && this.inner.push(new xn(Vn.parser, Vn.parser.startParse(this.input, J(zt, Pt), Pt), Vn.overlay ? Vn.overlay.map((ol) => new ce(ol.from - En.from, ol.to - En.from)) : null, En.tree, Pt)), Vn.overlay ? Pt.length && (an = { ranges: Pt, depth: 0, prev: an }) : Qn = !1;
          }
        } else Ve && (Nt = Ve.predicate(En)) && (Nt === !0 && (Nt = new ce(En.from, En.to)), Nt.from < Nt.to && Ve.ranges.push(Nt));
        if (Qn && En.firstChild()) Ve && Ve.depth++, an && an.depth++;
        else for (; !En.nextSibling(); ) {
          if (!En.parent()) break e;
          Ve && !--Ve.depth && (Qn = L(this.ranges, Ve.ranges), Qn.length && this.inner.splice(Ve.index, 0, new xn(Ve.parser, Ve.parser.startParse(this.input, J(Ve.mounts, Qn), Qn), Ve.ranges.map((zt) => new ce(zt.from - Ve.start, zt.to - Ve.start)), Ve.target, Qn)), Ve = Ve.prev), an && !--an.depth && (an = an.prev);
        }
      }
    }
  }
  class jt {
    constructor(_e, Ve) {
      this.offset = Ve, this.done = !1, this.cursor = _e.cursor(l.IterMode.IncludeAnonymous | l.IterMode.IgnoreMounts);
    }
    moveTo(_e) {
      let { cursor: Ve } = this, an = _e - this.offset;
      for (; !this.done && Ve.from < an; ) Ve.to >= _e && Ve.enter(an, 1, l.IterMode.IgnoreOverlays | l.IterMode.ExcludeBuffers) || Ve.next(!1) || (this.done = !0);
    }
    hasNode(_e) {
      if (this.moveTo(_e.from), !this.done && this.cursor.from + this.offset == _e.from && this.cursor.tree) for (let Ve = this.cursor.tree; ; ) {
        if (Ve == _e.tree) return !0;
        if (Ve.children.length && Ve.positions[0] == 0 && Ve.children[0] instanceof U) Ve = Ve.children[0];
        else break;
      }
      return !1;
    }
  }
  class Cl {
    constructor(_e) {
      var Ve;
      this.fragments = _e, this.fragI = this.curTo = 0, _e.length ? (_e = this.curFrag = _e[0], this.curTo = (Ve = _e.tree.prop(at)) !== null && Ve !== void 0 ? Ve : _e.to, this.inner = new jt(_e.tree, -_e.offset)) : this.curFrag = this.inner = null;
    }
    hasNode(_e) {
      for (; this.curFrag && _e.from >= this.curTo; ) this.nextFrag();
      return this.curFrag && this.curFrag.from <= _e.from && this.curTo >= _e.to && this.inner.hasNode(_e);
    }
    nextFrag() {
      var _e;
      if (this.fragI++, this.fragI == this.fragments.length) this.curFrag = this.inner = null;
      else {
        let Ve = this.curFrag = this.fragments[this.fragI];
        this.curTo = (_e = Ve.tree.prop(at)) !== null && _e !== void 0 ? _e : Ve.to, this.inner = new jt(Ve.tree, -Ve.offset);
      }
    }
    findMounts(_e, Ve) {
      var an;
      let En = [];
      if (this.inner) for (this.inner.cursor.moveTo(_e, 1), _e = this.inner.cursor.node; _e; _e = _e.parent) {
        let Qn = (an = _e.tree) === null || an === void 0 ? void 0 : an.prop(xe.mounted);
        if (Qn && Qn.parser == Ve) for (let Vn = this.fragI; Vn < this.fragments.length; Vn++) {
          let ot = this.fragments[Vn];
          if (ot.from >= _e.to) break;
          ot.tree == this.curFrag.tree && En.push({
            frag: ot,
            pos: _e.from - ot.offset,
            mount: Qn
          });
        }
      }
      return En;
    }
  }
  l.DefaultBufferLength = 1024, l.MountedTree = $e, l.NodeProp = xe, l.NodeSet = P, l.NodeType = E, l.NodeWeakMap = ln, l.Parser = Ze, l.Tree = U, l.TreeBuffer = le, l.TreeCursor = Ae, l.TreeFragment = Be, l.parseMixed = function(fn) {
    return (_e, Ve, an, En) => new Yt(_e, fn, Ve, an, En);
  };
};
Xo[5] = function(e, n, t, l) {
  function r(le, Ce) {
    return le.length == Ce.length && le.every((Ye, B) => Ye == Ce[B]);
  }
  function u(le) {
    let Ce = [[]];
    for (let Ye = 0; Ye < le.length; Ye++) for (let B = 0, q = Ce.length; B < q; B++) Ce.push(Ce[B].concat(le[Ye]));
    return Ce.sort((Ye, B) => B.length - Ye.length);
  }
  function o(le, Ce) {
    let Ye = /* @__PURE__ */ Object.create(null);
    for (let me of le) if (Array.isArray(me.tag)) for (let Ae of me.tag) Ye[Ae.id] = me.class;
    else Ye[me.tag.id] = me.class;
    let { scope: B, all: q = null } = Ce || {};
    return { style: (me) => {
      let Ae = q;
      for (let Fe of me) for (let ln of Fe.set) if (me = Ye[ln.id]) {
        Ae = Ae ? Ae + " " + me : me;
        break;
      }
      return Ae;
    }, scope: B };
  }
  function a(le, Ce) {
    let Ye = null;
    for (let B of le) (le = B.style(Ce)) && (Ye = Ye ? Ye + " " + le : le);
    return Ye;
  }
  function h(le) {
    let Ce = le.type.prop(F);
    for (; Ce && Ce.context && !le.matchContext(Ce.context); ) Ce = Ce.next;
    return Ce || null;
  }
  Object.defineProperty(l, "__esModule", { value: !0 });
  var s = n(4);
  let d = 0;
  class p {
    constructor(Ce, Ye, B) {
      this.set = Ce, this.base = Ye, this.modified = B, this.id = d++;
    }
    static define(Ce) {
      if (Ce != null && Ce.base) throw Error("Can not derive from a modified tag");
      let Ye = new p([], null, []);
      if (Ye.set.push(Ye), Ce) for (let B of Ce.set) Ye.set.push(B);
      return Ye;
    }
    static defineModifier() {
      let Ce = new R();
      return (Ye) => -1 < Ye.modified.indexOf(Ce) ? Ye : R.get(Ye.base || Ye, Ye.modified.concat(Ce).sort((B, q) => B.id - q.id));
    }
  }
  let _ = 0;
  class R {
    constructor() {
      this.instances = [], this.id = _++;
    }
    static get(Ce, Ye) {
      if (!Ye.length) return Ce;
      var B = Ye[0].instances.find((Ae) => Ae.base == Ce && r(Ye, Ae.modified));
      if (B) return B;
      B = [];
      let q = new p(B, Ce, Ye);
      for (var me of Ye) me.instances.push(q);
      me = u(Ye);
      for (let Ae of Ce.set) if (!Ae.modified.length) for (let Fe of me) B.push(R.get(
        Ae,
        Fe
      ));
      return q;
    }
  }
  const F = new s.NodeProp();
  class L {
    constructor(Ce, Ye, B, q) {
      this.tags = Ce, this.mode = Ye, this.context = B, this.next = q;
    }
    get opaque() {
      return this.mode == 0;
    }
    get inherit() {
      return this.mode == 1;
    }
    sort(Ce) {
      return !Ce || Ce.depth < this.depth ? (this.next = Ce, this) : (Ce.next = this.sort(Ce.next), Ce);
    }
    get depth() {
      return this.context ? this.context.length : 0;
    }
  }
  L.empty = new L([], 2, null);
  class G {
    constructor(Ce, Ye, B) {
      this.at = Ce, this.highlighters = Ye, this.span = B, this.class = "";
    }
    startSpan(Ce, Ye) {
      Ye != this.class && (this.flush(Ce), Ce > this.at && (this.at = Ce), this.class = Ye);
    }
    flush(Ce) {
      Ce > this.at && this.class && this.span(this.at, Ce, this.class);
    }
    highlightRange(Ce, Ye, B, q, me) {
      let { type: Ae, from: Fe, to: ln } = Ce;
      if (!(Fe >= B || ln <= Ye)) {
        Ae.isTop && (me = this.highlighters.filter((Nn) => !Nn.scope || Nn.scope(Ae)));
        var Be = q, Ze = h(Ce) || L.empty, pn = a(me, Ze.tags);
        if (pn && (Be && (Be += " "), Be += pn, Ze.mode == 1 && (q += (q ? " " : "") + pn)), this.startSpan(Math.max(Ye, Fe), Be), !Ze.opaque) {
          var xn = Ce.tree && Ce.tree.prop(s.NodeProp.mounted);
          if (xn && xn.overlay) {
            Ze = Ce.node.enter(xn.overlay[0].from + Fe, 1), pn = this.highlighters.filter((at) => !at.scope || at.scope(xn.tree.type));
            let Nn = Ce.firstChild();
            for (let at = 0, Yt = Fe; ; at++) {
              let jt = at < xn.overlay.length ? xn.overlay[at] : null, Cl = jt ? jt.from + Fe : ln, fn = Math.max(Ye, Yt), _e = Math.min(B, Cl);
              if (fn < _e && Nn) for (; Ce.from < _e && (this.highlightRange(Ce, fn, _e, q, me), this.startSpan(Math.min(_e, Ce.to), Be), !(Ce.to >= Cl) && Ce.nextSibling()); ) ;
              if (!jt || Cl > B) break;
              Yt = jt.to + Fe, Yt > Ye && (this.highlightRange(Ze.cursor(), Math.max(Ye, jt.from + Fe), Math.min(B, Yt), "", pn), this.startSpan(Math.min(B, Yt), Be));
            }
            Nn && Ce.parent();
          } else if (Ce.firstChild()) {
            xn && (q = "");
            do
              if (!(Ce.to <= Ye)) {
                if (Ce.from >= B) break;
                this.highlightRange(Ce, Ye, B, q, me), this.startSpan(Math.min(B, Ce.to), Be);
              }
            while (Ce.nextSibling());
            Ce.parent();
          }
        }
      }
    }
  }
  e = p.define, n = e(), t = e();
  const J = e(t), we = e(t), ce = e(), xe = e(ce), $e = e(ce), je = e(), E = e(je), P = e(), K = e(), H = e(), U = e(H), Me = e();
  e = {
    comment: n,
    lineComment: e(n),
    blockComment: e(n),
    docComment: e(n),
    name: t,
    variableName: e(t),
    typeName: J,
    tagName: e(J),
    propertyName: we,
    attributeName: e(we),
    className: e(t),
    labelName: e(t),
    namespace: e(t),
    macroName: e(t),
    literal: ce,
    string: xe,
    docString: e(xe),
    character: e(xe),
    attributeValue: e(xe),
    number: $e,
    integer: e($e),
    float: e($e),
    bool: e(ce),
    regexp: e(ce),
    escape: e(ce),
    color: e(ce),
    url: e(ce),
    keyword: P,
    self: e(P),
    null: e(P),
    atom: e(P),
    unit: e(P),
    modifier: e(P),
    operatorKeyword: e(P),
    controlKeyword: e(P),
    definitionKeyword: e(P),
    moduleKeyword: e(P),
    operator: K,
    derefOperator: e(K),
    arithmeticOperator: e(K),
    logicOperator: e(K),
    bitwiseOperator: e(K),
    compareOperator: e(K),
    updateOperator: e(K),
    definitionOperator: e(K),
    typeOperator: e(K),
    controlOperator: e(K),
    punctuation: H,
    separator: e(H),
    bracket: U,
    angleBracket: e(U),
    squareBracket: e(U),
    paren: e(U),
    brace: e(U),
    content: je,
    heading: E,
    heading1: e(E),
    heading2: e(E),
    heading3: e(E),
    heading4: e(E),
    heading5: e(E),
    heading6: e(E),
    contentSeparator: e(je),
    list: e(je),
    quote: e(je),
    emphasis: e(je),
    strong: e(je),
    link: e(je),
    monospace: e(je),
    strikethrough: e(je),
    inserted: e(),
    deleted: e(),
    changed: e(),
    invalid: e(),
    meta: Me,
    documentMeta: e(Me),
    annotation: e(Me),
    processingInstruction: e(Me),
    definition: p.defineModifier(),
    constant: p.defineModifier(),
    function: p.defineModifier(),
    standard: p.defineModifier(),
    local: p.defineModifier(),
    special: p.defineModifier()
  }, n = o([
    { tag: e.link, class: "tok-link" },
    { tag: e.heading, class: "tok-heading" },
    { tag: e.emphasis, class: "tok-emphasis" },
    { tag: e.strong, class: "tok-strong" },
    { tag: e.keyword, class: "tok-keyword" },
    { tag: e.atom, class: "tok-atom" },
    { tag: e.bool, class: "tok-bool" },
    { tag: e.url, class: "tok-url" },
    { tag: e.labelName, class: "tok-labelName" },
    { tag: e.inserted, class: "tok-inserted" },
    { tag: e.deleted, class: "tok-deleted" },
    { tag: e.literal, class: "tok-literal" },
    { tag: e.string, class: "tok-string" },
    { tag: e.number, class: "tok-number" },
    { tag: [e.regexp, e.escape, e.special(e.string)], class: "tok-string2" },
    { tag: e.variableName, class: "tok-variableName" },
    { tag: e.local(e.variableName), class: "tok-variableName tok-local" },
    { tag: e.definition(e.variableName), class: "tok-variableName tok-definition" },
    {
      tag: e.special(e.variableName),
      class: "tok-variableName2"
    },
    { tag: e.definition(e.propertyName), class: "tok-propertyName tok-definition" },
    { tag: e.typeName, class: "tok-typeName" },
    { tag: e.namespace, class: "tok-namespace" },
    { tag: e.className, class: "tok-className" },
    { tag: e.macroName, class: "tok-macroName" },
    { tag: e.propertyName, class: "tok-propertyName" },
    { tag: e.operator, class: "tok-operator" },
    { tag: e.comment, class: "tok-comment" },
    { tag: e.meta, class: "tok-meta" },
    { tag: e.invalid, class: "tok-invalid" },
    { tag: e.punctuation, class: "tok-punctuation" }
  ]), l.Tag = p, l.classHighlighter = n, l.getStyleTags = h, l.highlightTree = function(le, Ce, Ye, B = 0, q = le.length) {
    Ce = new G(B, Array.isArray(Ce) ? Ce : [Ce], Ye), Ce.highlightRange(le.cursor(), B, q, "", Ce.highlighters), Ce.flush(q);
  }, l.styleTags = function(le) {
    let Ce = /* @__PURE__ */ Object.create(null);
    for (let me in le) {
      let Ae = le[me];
      Array.isArray(Ae) || (Ae = [Ae]);
      for (let Fe of me.split(" ")) if (Fe) {
        var Ye = [];
        let ln = 2;
        for (var B = Fe, q = 0; ; ) {
          if (B == "..." && 0 < q && q + 3 == Fe.length) {
            ln = 1;
            break;
          }
          if (B = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(B), !B) throw new RangeError("Invalid path: " + Fe);
          if (Ye.push(B[0] == "*" ? "" : B[0][0] == '"' ? JSON.parse(B[0]) : B[0]), q += B[0].length, q == Fe.length) break;
          if (B = Fe[q++], q == Fe.length && B == "!") {
            ln = 0;
            break;
          }
          if (B != "/") throw new RangeError("Invalid path: " + Fe);
          B = Fe.slice(q);
        }
        if (B = Ye.length - 1, q = Ye[B], !q) throw new RangeError("Invalid path: " + Fe);
        Ye = new L(Ae, ln, 0 < B ? Ye.slice(0, B) : null), Ce[q] = Ye.sort(Ce[q]);
      }
    }
    return F.add(Ce);
  }, l.tagHighlighter = o, l.tags = e;
};
Xo[6] = function(e, n, t, l) {
  function r(qe) {
    return pn.Facet.define({ combine: qe ? (ae) => ae.concat(qe) : void 0 });
  }
  function u(qe, ae, Ue) {
    var ze = qe.facet(zt);
    if (qe = o(qe).topNode, !ze || ze.allowsNesting) for (ze = qe; ze; ze = ze.enter(ae, Ue, Ze.IterMode.ExcludeBuffers)) ze.type.isTop && (qe = ze);
    return qe;
  }
  function o(qe) {
    return (qe = qe.field(fn.state, !1)) ? qe.tree : Ze.Tree.empty;
  }
  function a(qe, ae, Ue = 50) {
    var ze;
    return qe = (ze = qe.field(fn.state, !1)) === null || ze === void 0 ? void 0 : ze.context, qe ? (ze = qe.viewport, qe.updateViewport({ from: 0, to: ae }), ae = qe.isDone(ae) || qe.work(Ue, ae) ? qe.tree : null, qe.updateViewport(ze), ae) : null;
  }
  function h(qe, ae, Ue) {
    return Ze.TreeFragment.applyChanges(qe, [{ fromA: ae, toA: Ue, fromB: ae, toB: Ue }]);
  }
  function s(qe) {
    let ae = qe.facet(pr);
    return ae.charCodeAt(0) == 9 ? qe.tabSize * ae.length : ae.length;
  }
  function d(qe, ae) {
    let Ue = "";
    var ze = qe.tabSize;
    if (qe = qe.facet(pr)[0], qe == "	") {
      for (; ae >= ze; ) Ue += "	", ae -= ze;
      qe = " ";
    }
    for (ze = 0; ze < ae; ze++) Ue += qe;
    return Ue;
  }
  function p(qe, ae) {
    qe instanceof pn.EditorState && (qe = new ul(qe));
    for (var Ue of qe.state.facet(St)) {
      var ze = Ue(qe, ae);
      if (ze !== void 0) return ze;
    }
    if (Ue = o(qe.state), Ue.length >= ae) {
      Ue = Ue.resolveStack(ae);
      var dn = Ue.node.enterUnfinishedNodesBefore(ae);
      if (dn != Ue.node) {
        for (ze = []; dn != Ue.node; dn = dn.parent) ze.push(dn);
        for (dn = ze.length - 1; 0 <= dn; dn--) Ue = { node: ze[dn], next: Ue };
      }
      ae = _(Ue, qe, ae);
    } else ae = null;
    return ae;
  }
  function _(qe, ae, Ue) {
    for (; qe; qe = qe.next) {
      let ze = R(qe.node);
      if (ze) return ze(ql.create(ae, Ue, qe));
    }
    return 0;
  }
  function R(qe) {
    var ae = qe.type.prop(Rr);
    if (ae) return ae;
    ae = qe.firstChild;
    let Ue;
    if (ae && (Ue = ae.type.prop(Ze.NodeProp.closedBy))) {
      let ze = qe.lastChild, dn = ze && -1 < Ue.indexOf(ze.name);
      return (ut) => L(
        ut,
        !0,
        1,
        void 0,
        !dn || ut.pos == ut.options.simulateBreak && ut.options.simulateDoubleBreak ? void 0 : ze.from
      );
    }
    return qe.parent == null ? F : null;
  }
  function F() {
    return 0;
  }
  function L(qe, ae, Ue, ze, dn) {
    var ut = qe.textAfter, Zn = ut.match(/^\s*/)[0].length;
    if (ze = ze && ut.slice(Zn, Zn + ze.length) == ze || dn == qe.pos + Zn, ae) e: if (ae = qe.node, dn = ae.childAfter(ae.from), ut = ae.lastChild, dn) {
      Zn = qe.options.simulateBreak;
      var ht = qe.state.doc.lineAt(dn.from);
      for (Zn = Zn == null || Zn <= ht.from ? ht.to : Math.min(ht.to, Zn), ht = dn.to; ; ) {
        if (ht = ae.childAfter(ht), !ht || ht == ut) {
          ae = null;
          break e;
        }
        if (!ht.type.isSkipped) {
          ae = ht.from < Zn ? dn : null;
          break e;
        }
        ht = ht.to;
      }
    } else ae = null;
    else ae = null;
    return ae ? ze ? qe.column(ae.from) : qe.column(ae.to) : qe.baseIndent + (ze ? 0 : qe.unit * Ue);
  }
  function G(qe, ae, Ue) {
    for (var ze of qe.facet(Mr)) {
      var dn = ze(qe, ae, Ue);
      if (dn) return dn;
    }
    if (dn = o(qe), dn.length < Ue) qe = null;
    else {
      var ut = dn.resolveStack(Ue, 1);
      for (ze = null; ut; ut = ut.next) {
        var Zn = ut.node;
        if (Zn.to <= Ue || Zn.from > Ue) continue;
        if (ze && Zn.from < ae) break;
        let ct = Zn.type.prop(wi);
        var ht;
        (ht = ct) && !(ht = Zn.to < dn.length - 50 || dn.length == qe.doc.length) && (ht = Zn.lastChild, ht = !(ht && ht.to == Zn.to && ht.type.isError)), ht && (Zn = ct(Zn, qe)) && Zn.from <= Ue && Zn.from >= ae && Zn.to > Ue && (ze = Zn);
      }
      qe = ze;
    }
    return qe;
  }
  function J(qe, ae) {
    let Ue = ae.mapPos(qe.from, 1);
    return qe = ae.mapPos(qe.to, -1), Ue >= qe ? void 0 : { from: Ue, to: qe };
  }
  function we(qe) {
    let ae = [];
    for (let { head: Ue } of qe.state.selection.ranges) ae.some((ze) => ze.from <= Ue && ze.to >= Ue) || ae.push(qe.lineBlockAt(Ue));
    return ae;
  }
  function ce(qe, ae, Ue) {
    var ze;
    let dn = null;
    return (ze = qe.field(Zt, !1)) === null || ze === void 0 || ze.between(ae, Ue, (ut, Zn) => {
      (!dn || dn.from > ut) && (dn = { from: ut, to: Zn });
    }), dn;
  }
  function xe(qe, ae, Ue) {
    let ze = !1;
    return qe.between(ae, ae, (dn, ut) => {
      dn == ae && ut == Ue && (ze = !0);
    }), ze;
  }
  function $e(qe, ae) {
    return qe.field(Zt, !1) ? ae : ae.concat(pn.StateEffect.appendConfig.of(E()));
  }
  function je(qe, ae, Ue = !0) {
    let ze = qe.state.doc.lineAt(ae.from).number;
    return ae = qe.state.doc.lineAt(ae.to).number, xn.EditorView.announce.of(`${qe.state.phrase(Ue ? "Folded lines" : "Unfolded lines")} ${ze} ${qe.state.phrase("to")} ${ae}.`);
  }
  function E(qe) {
    let ae = [Zt, Rl];
    return qe && ae.push(nl.of(qe)), ae;
  }
  function P(qe, ae) {
    let { state: Ue } = qe, ze = Ue.facet(nl), dn = (ut) => {
      var Zn = qe.lineBlockAt(qe.posAtDOM(ut.target));
      (Zn = ce(qe.state, Zn.from, Zn.to)) && qe.dispatch({ effects: tl.of(Zn) }), ut.preventDefault();
    };
    return ze.placeholderDOM ? ze.placeholderDOM(qe, dn, ae) : (ae = document.createElement("span"), ae.textContent = ze.placeholderText, ae.setAttribute("aria-label", Ue.phrase("folded code")), ae.title = Ue.phrase("unfold"), ae.className = "cm-foldPlaceholder", ae.onclick = dn, ae);
  }
  function K(qe) {
    let ae = qe.facet(se);
    return ae.length ? ae : qe.facet(Ee);
  }
  function H(qe) {
    let ae = [], Ue = qe.matched ? C : re;
    return ae.push(Ue.range(qe.start.from, qe.start.to)), qe.end && ae.push(Ue.range(
      qe.end.from,
      qe.end.to
    )), ae;
  }
  function U(qe, ae, Ue) {
    let ze = qe.prop(0 > ae ? Ze.NodeProp.openedBy : Ze.NodeProp.closedBy);
    return ze || (qe.name.length == 1 && (qe = Ue.indexOf(qe.name), -1 < qe && qe % 2 == (0 > ae ? 1 : 0)) ? [Ue[qe + ae]] : null);
  }
  function Me(qe) {
    let ae = qe.type.prop(Z);
    return ae ? ae(qe.node) : qe;
  }
  function le(qe, ae, Ue, ze = {}) {
    var dn = ze.maxScanDistance || 1e4;
    ze = ze.brackets || "()[]{}";
    for (var ut = o(qe), Zn = ut.resolveInner(ae, Ue), ht = Zn; ht; ht = ht.parent) {
      var ct = U(ht.type, Ue, ze);
      if (ct && ht.from < ht.to) {
        var Hl = Me(ht);
        if (Hl && (0 < Ue ? ae >= Hl.from && ae < Hl.to : ae > Hl.from && ae <= Hl.to)) {
          e: {
            if (ae = Ue, Ue = ht, dn = ct, ut = ze, qe = Ue.parent, ze = { from: Hl.from, to: Hl.to }, Hl = 0, (qe = qe?.cursor()) && (0 > ae ? qe.childBefore(Ue.from) : qe.childAfter(Ue.to)))
              do
                if (0 > ae ? qe.to <= Ue.from : qe.from >= Ue.to) {
                  if (Hl == 0 && -1 < dn.indexOf(qe.type.name) && qe.from < qe.to) {
                    ae = Me(qe), ze = { start: ze, end: ae ? { from: ae.from, to: ae.to } : void 0, matched: !0 };
                    break e;
                  } else if (U(qe.type, ae, ut)) Hl++;
                  else if (U(qe.type, -ae, ut)) {
                    if (Hl == 0) {
                      ae = Me(qe), ze = { start: ze, end: ae && ae.from < ae.to ? { from: ae.from, to: ae.to } : void 0, matched: !1 };
                      break e;
                    }
                    Hl--;
                  }
                }
              while (0 > ae ? qe.prevSibling() : qe.nextSibling());
            ze = { start: ze, matched: !1 };
          }
          return ze;
        }
      }
    }
    e: if (Hl = Zn.type, ct = 0 > Ue ? qe.sliceDoc(ae - 1, ae) : qe.sliceDoc(ae, ae + 1), ht = ze.indexOf(ct), 0 > ht || ht % 2 == 0 != 0 < Ue) ze = null;
    else {
      ct = { from: 0 > Ue ? ae - 1 : ae, to: 0 < Ue ? ae + 1 : ae }, qe = qe.doc.iterRange(ae, 0 < Ue ? qe.doc.length : 0), Zn = 0;
      for (let Pl = 0; !qe.next().done && Pl <= dn; ) {
        let Fn = qe.value;
        0 > Ue && (Pl += Fn.length);
        let br = ae + Pl * Ue;
        for (let Wn = 0 < Ue ? 0 : Fn.length - 1, cs = 0 < Ue ? Fn.length : -1; Wn != cs; Wn += Ue) {
          let Ds = ze.indexOf(Fn[Wn]);
          if (!(0 > Ds || ut.resolveInner(br + Wn, 1).type != Hl)) if (Ds % 2 == 0 == 0 < Ue) Zn++;
          else if (Zn == 1) {
            ze = { start: ct, end: { from: br + Wn, to: br + Wn + 1 }, matched: Ds >> 1 == ht >> 1 };
            break e;
          } else Zn--;
        }
        0 < Ue && (Pl += Fn.length);
      }
      ze = qe.done ? { start: ct, matched: !1 } : null;
    }
    return ze;
  }
  function Ce(qe, ae, Ue, ze = 0, dn = 0) {
    for (ae == null && (ae = qe.search(/[^\s\u00a0]/), ae == -1 && (ae = qe.length)); ze < ae; ze++) qe.charCodeAt(ze) == 9 ? dn += Ue - dn % Ue : dn++;
    return dn;
  }
  function Ye(qe) {
    return { name: qe.name || "", token: qe.token, blankLine: qe.blankLine || (() => {
    }), startState: qe.startState || (() => !0), copyState: qe.copyState || B, indent: qe.indent || (() => null), languageData: qe.languageData || {}, tokenTable: qe.tokenTable || un };
  }
  function B(qe) {
    if (typeof qe != "object") return qe;
    let ae = {};
    for (let Ue in qe) {
      let ze = qe[Ue];
      ae[Ue] = ze instanceof Array ? ze.slice() : ze;
    }
    return ae;
  }
  function q(qe, ae, Ue, ze, dn) {
    var ut = Ue >= ze && Ue + ae.length <= dn && ae.prop(qe.stateAfter);
    if (ut) return { state: qe.streamParser.copyState(ut), pos: Ue + ae.length };
    for (ut = ae.children.length - 1; 0 <= ut; ut--) {
      var Zn = ae.children[ut];
      let ht = Ue + ae.positions[ut];
      if (Zn = Zn instanceof Ze.Tree && ht < dn && q(qe, Zn, ht, ze, dn)) return Zn;
    }
    return null;
  }
  function me(qe, ae, Ue, ze, dn) {
    if (dn && 0 >= Ue && ze >= ae.length) return ae;
    dn || ae.type != qe.topNode || (dn = !0);
    for (let ut = ae.children.length - 1; 0 <= ut; ut--) {
      let Zn = ae.positions[ut], ht = ae.children[ut];
      if (Zn < ze && ht instanceof Ze.Tree) {
        if (!(qe = me(qe, ht, Ue - Zn, ze - Zn, dn))) break;
        return dn ? new Ze.Tree(ae.type, ae.children.slice(0, ut).concat(qe), ae.positions.slice(0, ut + 1), Zn + qe.length) : qe;
      }
    }
    return null;
  }
  function Ae(qe, ae, Ue) {
    ae.start = ae.pos;
    for (let ze = 0; 10 > ze; ze++) {
      let dn = qe(ae, Ue);
      if (ae.pos > ae.start) return dn;
    }
    throw Error("Stream parser failed to advance stream.");
  }
  function Fe(qe, ae) {
    -1 < ft.indexOf(qe) || (ft.push(qe), console.warn(ae));
  }
  function ln(qe, ae) {
    var Ue = null;
    for (let ze of ae.split(".")) {
      let dn = qe[ze] || Nn.tags[ze];
      dn ? typeof dn == "function" ? Ue ? Ue = dn(Ue) : Fe(ze, `Modifier ${ze} used at start of tag`) : Ue ? Fe(ze, `Tag ${ze} used as modifier`) : Ue = dn : Fe(ze, `Unknown highlighting tag ${ze}`);
    }
    return Ue ? (qe = ae.replace(/ /g, "_"), Ue = Ze.NodeType.define({ id: gn.length, name: qe, props: [Nn.styleTags({ [qe]: Ue })] }), gn.push(Ue), Ue.id) : 0;
  }
  function Be(qe) {
    let ae = Ze.NodeType.define({ id: gn.length, name: "Document", props: [jt.add(() => qe)], top: !0 });
    return gn.push(ae), ae;
  }
  var Ze = n(4), pn = n(0), xn = n(3), Nn = n(5), at = n(1), Yt;
  const jt = new Ze.NodeProp(), Cl = new Ze.NodeProp();
  class fn {
    constructor(ae, Ue, ze = [], dn = "") {
      this.data = ae, this.name = dn, pn.EditorState.prototype.hasOwnProperty("tree") || Object.defineProperty(pn.EditorState.prototype, "tree", { get() {
        return o(this);
      } }), this.parser = Ue, this.extension = [zt.of(this), pn.EditorState.languageData.of((ut, Zn, ht) => {
        let ct = u(ut, Zn, ht);
        var Hl = ct.type.prop(jt);
        if (!Hl) return [];
        Hl = ut.facet(Hl);
        let Pl = ct.type.prop(Cl);
        if (Pl) {
          Zn = ct.resolve(Zn - ct.from, ht);
          for (let Fn of Pl) if (Fn.test(Zn, ut)) return ut = ut.facet(Fn.facet), Fn.type == "replace" ? ut : ut.concat(Hl);
        }
        return Hl;
      })].concat(ze);
    }
    isActiveAt(ae, Ue, ze = -1) {
      return u(ae, Ue, ze).type.prop(jt) == this.data;
    }
    findRegions(ae) {
      let Ue = ae.facet(zt);
      if (Ue?.data == this.data) return [{ from: 0, to: ae.doc.length }];
      if (!Ue || !Ue.allowsNesting) return [];
      let ze = [], dn = (ut, Zn) => {
        if (ut.prop(jt) == this.data) ze.push({ from: Zn, to: Zn + ut.length });
        else {
          var ht = ut.prop(Ze.NodeProp.mounted);
          if (ht) {
            if (ht.tree.prop(jt) == this.data) {
              if (ht.overlay) for (var ct of ht.overlay) ze.push({ from: ct.from + Zn, to: ct.to + Zn });
              else ze.push({
                from: Zn,
                to: Zn + ut.length
              });
              return;
            }
            if (ht.overlay && (ct = ze.length, dn(ht.tree, ht.overlay[0].from + Zn), ze.length > ct)) return;
          }
          for (ht = 0; ht < ut.children.length; ht++) ct = ut.children[ht], ct instanceof Ze.Tree && dn(ct, ut.positions[ht] + Zn);
        }
      };
      return dn(o(ae), 0), ze;
    }
    get allowsNesting() {
      return !0;
    }
  }
  fn.setState = pn.StateEffect.define();
  class _e extends fn {
    constructor(ae, Ue, ze) {
      super(ae, Ue, [], ze), this.parser = Ue;
    }
    static define(ae) {
      let Ue = r(ae.languageData);
      return new _e(Ue, ae.parser.configure({ props: [jt.add((ze) => ze.isTop ? Ue : void 0)] }), ae.name);
    }
    configure(ae, Ue) {
      return new _e(
        this.data,
        this.parser.configure(ae),
        Ue || this.name
      );
    }
    get allowsNesting() {
      return this.parser.hasWrappers();
    }
  }
  class Ve {
    constructor(ae) {
      this.doc = ae, this.cursorPos = 0, this.string = "", this.cursor = ae.iter();
    }
    get length() {
      return this.doc.length;
    }
    syncTo(ae) {
      return this.string = this.cursor.next(ae - this.cursorPos).value, this.cursorPos = ae + this.string.length, this.cursorPos - this.string.length;
    }
    chunk(ae) {
      return this.syncTo(ae), this.string;
    }
    get lineChunks() {
      return !0;
    }
    read(ae, Ue) {
      let ze = this.cursorPos - this.string.length;
      return ae < ze || Ue >= this.cursorPos ? this.doc.sliceString(ae, Ue) : this.string.slice(ae - ze, Ue - ze);
    }
  }
  let an = null;
  class En {
    constructor(ae, Ue, ze = [], dn, ut, Zn, ht, ct) {
      this.parser = ae, this.state = Ue, this.fragments = ze, this.tree = dn, this.treeLen = ut, this.viewport = Zn, this.skipped = ht, this.scheduleOn = ct, this.parse = null, this.tempSkipped = [];
    }
    static create(ae, Ue, ze) {
      return new En(ae, Ue, [], Ze.Tree.empty, 0, ze, [], null);
    }
    startParse() {
      return this.parser.startParse(new Ve(this.state.doc), this.fragments);
    }
    work(ae, Ue) {
      return Ue != null && Ue >= this.state.doc.length && (Ue = void 0), this.tree != Ze.Tree.empty && this.isDone(Ue ?? this.state.doc.length) ? (this.takeTree(), !0) : this.withContext(() => {
        var ze;
        if (typeof ae == "number") {
          let dn = Date.now() + ae;
          ae = () => Date.now() > dn;
        }
        for (this.parse || (this.parse = this.startParse()), Ue != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > Ue) && Ue < this.state.doc.length && this.parse.stopAt(Ue); ; ) {
          let dn = this.parse.advance();
          if (dn) if (this.fragments = this.withoutTempSkipped(Ze.TreeFragment.addTree(dn, this.fragments, this.parse.stoppedAt != null)), this.treeLen = (ze = this.parse.stoppedAt) !== null && ze !== void 0 ? ze : this.state.doc.length, this.tree = dn, this.parse = null, this.treeLen < (Ue ?? this.state.doc.length)) this.parse = this.startParse();
          else return !0;
          if (ae()) return !1;
        }
      });
    }
    takeTree() {
      let ae, Ue;
      this.parse && (ae = this.parse.parsedPos) >= this.treeLen && ((this.parse.stoppedAt == null || this.parse.stoppedAt > ae) && this.parse.stopAt(ae), this.withContext(() => {
        for (; !(Ue = this.parse.advance()); ) ;
      }), this.treeLen = ae, this.tree = Ue, this.fragments = this.withoutTempSkipped(Ze.TreeFragment.addTree(
        this.tree,
        this.fragments,
        !0
      )), this.parse = null);
    }
    withContext(ae) {
      let Ue = an;
      an = this;
      try {
        return ae();
      } finally {
        an = Ue;
      }
    }
    withoutTempSkipped(ae) {
      for (let Ue; Ue = this.tempSkipped.pop(); ) ae = h(ae, Ue.from, Ue.to);
      return ae;
    }
    changes(ae, Ue) {
      let { fragments: ze, tree: dn, treeLen: ut, viewport: Zn, skipped: ht } = this;
      if (this.takeTree(), !ae.empty) {
        let ct = [];
        if (ae.iterChangedRanges((Hl, Pl, Fn, br) => ct.push({ fromA: Hl, toA: Pl, fromB: Fn, toB: br })), ze = Ze.TreeFragment.applyChanges(ze, ct), dn = Ze.Tree.empty, ut = 0, Zn = { from: ae.mapPos(Zn.from, -1), to: ae.mapPos(Zn.to, 1) }, this.skipped.length) {
          ht = [];
          for (let Hl of this.skipped) {
            let Pl = ae.mapPos(Hl.from, 1), Fn = ae.mapPos(Hl.to, -1);
            Pl < Fn && ht.push({ from: Pl, to: Fn });
          }
        }
      }
      return new En(this.parser, Ue, ze, dn, ut, Zn, ht, this.scheduleOn);
    }
    updateViewport(ae) {
      if (this.viewport.from == ae.from && this.viewport.to == ae.to) return !1;
      this.viewport = ae;
      let Ue = this.skipped.length;
      for (let ze = 0; ze < this.skipped.length; ze++) {
        let { from: dn, to: ut } = this.skipped[ze];
        dn < ae.to && ut > ae.from && (this.fragments = h(this.fragments, dn, ut), this.skipped.splice(ze--, 1));
      }
      return this.skipped.length >= Ue ? !1 : (this.reset(), !0);
    }
    reset() {
      this.parse && (this.takeTree(), this.parse = null);
    }
    skipUntilInView(ae, Ue) {
      this.skipped.push({ from: ae, to: Ue });
    }
    static getSkippingParser(ae) {
      return new class extends Ze.Parser {
        createParse(Ue, ze, dn) {
          let ut = dn[0].from, Zn = dn[dn.length - 1].to;
          return { parsedPos: ut, advance() {
            let ht = an;
            if (ht) {
              for (let ct of dn) ht.tempSkipped.push(ct);
              ae && (ht.scheduleOn = ht.scheduleOn ? Promise.all([ht.scheduleOn, ae]) : ae);
            }
            return this.parsedPos = Zn, new Ze.Tree(Ze.NodeType.none, [], [], Zn - ut);
          }, stoppedAt: null, stopAt() {
          } };
        }
      }();
    }
    isDone(ae) {
      ae = Math.min(
        ae,
        this.state.doc.length
      );
      let Ue = this.fragments;
      return this.treeLen >= ae && Ue.length && Ue[0].from == 0 && Ue[0].to >= ae;
    }
    static get() {
      return an;
    }
  }
  class Qn {
    constructor(ae) {
      this.context = ae, this.tree = ae.tree;
    }
    apply(ae) {
      if (!ae.docChanged && this.tree == this.context.tree) return this;
      let Ue = this.context.changes(ae.changes, ae.state);
      return ae = this.context.treeLen == ae.startState.doc.length ? void 0 : Math.max(ae.changes.mapPos(this.context.treeLen), Ue.viewport.to), Ue.work(20, ae) || Ue.takeTree(), new Qn(Ue);
    }
    static init(ae) {
      let Ue = Math.min(3e3, ae.doc.length);
      return ae = En.create(ae.facet(zt).parser, ae, { from: 0, to: Ue }), ae.work(20, Ue) || ae.takeTree(), new Qn(ae);
    }
  }
  fn.state = pn.StateField.define({ create: Qn.init, update(qe, ae) {
    for (let Ue of ae.effects) if (Ue.is(fn.setState)) return Ue.value;
    return ae.startState.facet(zt) != ae.state.facet(zt) ? Qn.init(ae.state) : qe.apply(ae);
  } });
  let Vn = (qe) => {
    let ae = setTimeout(() => qe(), 500);
    return () => clearTimeout(ae);
  };
  typeof requestIdleCallback < "u" && (Vn = (qe) => {
    let ae = -1, Ue = setTimeout(() => {
      ae = requestIdleCallback(qe, { timeout: 400 });
    }, 100);
    return () => 0 > ae ? clearTimeout(Ue) : cancelIdleCallback(ae);
  });
  const ot = typeof navigator < "u" && (!((Yt = navigator.scheduling) === null || Yt === void 0) && Yt.isInputPending) ? () => navigator.scheduling.isInputPending() : null, Nt = xn.ViewPlugin.fromClass(class {
    constructor(qe) {
      this.view = qe, this.working = null, this.workScheduled = 0, this.chunkBudget = this.chunkEnd = -1, this.work = this.work.bind(this), this.scheduleWork();
    }
    update(qe) {
      let ae = this.view.state.field(fn.state).context;
      (ae.updateViewport(qe.view.viewport) || this.view.viewport.to > ae.treeLen) && this.scheduleWork(), (qe.docChanged || qe.selectionSet) && (this.view.hasFocus && (this.chunkBudget += 50), this.scheduleWork()), this.checkAsyncSchedule(ae);
    }
    scheduleWork() {
      if (!this.working) {
        var { state: qe } = this.view, ae = qe.field(fn.state);
        ae.tree == ae.context.tree && ae.context.isDone(qe.doc.length) || (this.working = Vn(this.work));
      }
    }
    work(qe) {
      this.working = null;
      let ae = Date.now();
      if (this.chunkEnd < ae && (0 > this.chunkEnd || this.view.hasFocus) && (this.chunkEnd = ae + 3e4, this.chunkBudget = 3e3), !(0 >= this.chunkBudget)) {
        var { state: Ue, viewport: { to: ze } } = this.view, dn = Ue.field(fn.state);
        if (dn.tree != dn.context.tree || !dn.context.isDone(ze + 1e5)) {
          var ut = Date.now() + Math.min(this.chunkBudget, 100, qe && !ot ? Math.max(25, qe.timeRemaining() - 5) : 1e9);
          qe = dn.context.treeLen < ze && Ue.doc.length > ze + 1e3;
          var Zn = dn.context.work(() => ot && ot() || Date.now() > ut, ze + (qe ? 0 : 1e5));
          this.chunkBudget -= Date.now() - ae, (Zn || 0 >= this.chunkBudget) && (dn.context.takeTree(), this.view.dispatch({ effects: fn.setState.of(new Qn(dn.context)) })), 0 < this.chunkBudget && (!Zn || qe) && this.scheduleWork(), this.checkAsyncSchedule(dn.context);
        }
      }
    }
    checkAsyncSchedule(qe) {
      qe.scheduleOn && (this.workScheduled++, qe.scheduleOn.then(() => this.scheduleWork()).catch((ae) => xn.logException(this.view.state, ae)).then(() => this.workScheduled--), qe.scheduleOn = null);
    }
    destroy() {
      this.working && this.working();
    }
    isWorking() {
      return !!(this.working || 0 < this.workScheduled);
    }
  }, { eventHandlers: { focus() {
    this.scheduleWork();
  } } }), zt = pn.Facet.define({ combine(qe) {
    return qe.length ? qe[0] : null;
  }, enables: (qe) => [fn.state, Nt, xn.EditorView.contentAttributes.compute([qe], (ae) => (ae = ae.facet(qe)) && ae.name ? { "data-language": ae.name } : {})] });
  class Pt {
    constructor(ae, Ue = []) {
      this.language = ae, this.support = Ue, this.extension = [ae, Ue];
    }
  }
  class ol {
    constructor(ae, Ue, ze, dn, ut, Zn) {
      this.name = ae, this.alias = Ue, this.extensions = ze, this.filename = dn, this.loadFunc = ut, this.support = Zn, this.loading = null;
    }
    load() {
      return this.loading || (this.loading = this.loadFunc().then((ae) => this.support = ae, (ae) => {
        throw this.loading = null, ae;
      }));
    }
    static of(ae) {
      let { load: Ue, support: ze } = ae;
      if (!Ue) {
        if (!ze) throw new RangeError("Must pass either 'load' or 'support' to LanguageDescription.of");
        Ue = () => Promise.resolve(ze);
      }
      return new ol(
        ae.name,
        (ae.alias || []).concat(ae.name).map((dn) => dn.toLowerCase()),
        ae.extensions || [],
        ae.filename,
        Ue,
        ze
      );
    }
    static matchFilename(ae, Ue) {
      for (let ze of ae) if (ze.filename && ze.filename.test(Ue)) return ze;
      if (Ue = /\.([^.]+)$/.exec(Ue)) {
        for (let ze of ae) if (-1 < ze.extensions.indexOf(Ue[1])) return ze;
      }
      return null;
    }
    static matchLanguageName(ae, Ue, ze = !0) {
      Ue = Ue.toLowerCase();
      for (let dn of ae) if (dn.alias.some((ut) => ut == Ue)) return dn;
      if (ze) {
        for (let dn of ae) for (let ut of dn.alias) if (ae = Ue.indexOf(ut), -1 < ae && (2 < ut.length || !/\w/.test(Ue[ae - 1]) && !/\w/.test(Ue[ae + ut.length]))) return dn;
      }
      return null;
    }
  }
  const St = pn.Facet.define(), pr = pn.Facet.define({ combine: (qe) => {
    if (!qe.length) return "  ";
    let ae = qe[0];
    if (!ae || /\S/.test(ae) || Array.from(ae).some((Ue) => Ue != ae[0])) throw Error("Invalid indent unit: " + JSON.stringify(qe[0]));
    return ae;
  } });
  class ul {
    constructor(ae, Ue = {}) {
      this.state = ae, this.options = Ue, this.unit = s(ae);
    }
    lineAt(ae, Ue = 1) {
      let ze = this.state.doc.lineAt(ae), { simulateBreak: dn, simulateDoubleBreak: ut } = this.options;
      return dn != null && dn >= ze.from && dn <= ze.to ? ut && dn == ae ? { text: "", from: ae } : (0 > Ue ? dn < ae : dn <= ae) ? {
        text: ze.text.slice(dn - ze.from),
        from: dn
      } : { text: ze.text.slice(0, dn - ze.from), from: ze.from } : ze;
    }
    textAfterPos(ae, Ue = 1) {
      if (this.options.simulateDoubleBreak && ae == this.options.simulateBreak) return "";
      let { text: ze, from: dn } = this.lineAt(ae, Ue);
      return ze.slice(ae - dn, Math.min(ze.length, ae + 100 - dn));
    }
    column(ae, Ue = 1) {
      let { text: ze, from: dn } = this.lineAt(ae, Ue);
      return ae = this.countColumn(ze, ae - dn), Ue = this.options.overrideIndentation ? this.options.overrideIndentation(dn) : -1, -1 < Ue && (ae += Ue - this.countColumn(ze, ze.search(/\S|$/))), ae;
    }
    countColumn(ae, Ue = ae.length) {
      return pn.countColumn(
        ae,
        this.state.tabSize,
        Ue
      );
    }
    lineIndent(ae, Ue = 1) {
      let { text: ze, from: dn } = this.lineAt(ae, Ue);
      return (ae = this.options.overrideIndentation) && (ae = ae(dn), -1 < ae) ? ae : this.countColumn(ze, ze.search(/\S|$/));
    }
    get simulatedBreak() {
      return this.options.simulateBreak || null;
    }
  }
  const Rr = new Ze.NodeProp();
  class ql extends ul {
    constructor(ae, Ue, ze) {
      super(ae.state, ae.options), this.base = ae, this.pos = Ue, this.context = ze;
    }
    get node() {
      return this.context.node;
    }
    static create(ae, Ue, ze) {
      return new ql(ae, Ue, ze);
    }
    get textAfter() {
      return this.textAfterPos(this.pos);
    }
    get baseIndent() {
      return this.baseIndentFor(this.node);
    }
    baseIndentFor(ae) {
      let Ue = this.state.doc.lineAt(ae.from);
      for (; ; ) {
        let dn = ae.resolve(Ue.from);
        for (; dn.parent && dn.parent.from == dn.from; ) dn = dn.parent;
        var ze;
        e: {
          for (ze = ae; ze; ze = ze.parent) if (dn == ze) {
            ze = !0;
            break e;
          }
          ze = !1;
        }
        if (ze) break;
        Ue = this.state.doc.lineAt(dn.from);
      }
      return this.lineIndent(Ue.from);
    }
    continue() {
      return _(this.context.next, this.base, this.pos);
    }
  }
  const Mr = pn.Facet.define(), wi = new Ze.NodeProp(), bl = pn.StateEffect.define({ map: J }), tl = pn.StateEffect.define({ map: J }), Zt = pn.StateField.define({ create() {
    return xn.Decoration.none;
  }, update(qe, ae) {
    qe = qe.map(ae.changes);
    for (let ze of ae.effects) if (ze.is(bl) && !xe(qe, ze.value.from, ze.value.to)) {
      var { preparePlaceholder: Ue } = ae.state.facet(nl);
      Ue = Ue ? xn.Decoration.replace({ widget: new ii(Ue(ae.state, ze.value)) }) : Pr, qe = qe.update({ add: [Ue.range(ze.value.from, ze.value.to)] });
    } else ze.is(tl) && (qe = qe.update({ filter: (dn, ut) => ze.value.from != dn || ze.value.to != ut, filterFrom: ze.value.from, filterTo: ze.value.to }));
    if (ae.selection) {
      let ze = !1, { head: dn } = ae.selection.main;
      qe.between(dn, dn, (ut, Zn) => {
        ut < dn && Zn > dn && (ze = !0);
      }), ze && (qe = qe.update({ filterFrom: dn, filterTo: dn, filter: (ut, Zn) => Zn <= dn || ut >= dn }));
    }
    return qe;
  }, provide: (qe) => xn.EditorView.decorations.from(qe), toJSON(qe, ae) {
    let Ue = [];
    return qe.between(0, ae.doc.length, (ze, dn) => {
      Ue.push(ze, dn);
    }), Ue;
  }, fromJSON(qe) {
    if (!Array.isArray(qe) || qe.length % 2) throw new RangeError("Invalid JSON for fold state");
    let ae = [];
    for (let Ue = 0; Ue < qe.length; ) {
      let ze = qe[Ue++], dn = qe[Ue++];
      if (typeof ze != "number" || typeof dn != "number") throw new RangeError("Invalid JSON for fold state");
      ae.push(Pr.range(ze, dn));
    }
    return xn.Decoration.set(ae, !0);
  } }), Ql = (qe) => {
    for (let ae of we(qe)) {
      let Ue = G(
        qe.state,
        ae.from,
        ae.to
      );
      if (Ue) return qe.dispatch({ effects: $e(qe.state, [bl.of(Ue), je(qe, Ue)]) }), !0;
    }
    return !1;
  }, jl = (qe) => {
    if (!qe.state.field(Zt, !1)) return !1;
    let ae = [];
    for (let Ue of we(qe)) {
      let ze = ce(qe.state, Ue.from, Ue.to);
      ze && ae.push(tl.of(ze), je(qe, ze, !1));
    }
    return ae.length && qe.dispatch({ effects: ae }), 0 < ae.length;
  }, Sl = (qe) => {
    let { state: ae } = qe, Ue = [];
    for (var ze = 0; ze < ae.doc.length; ) {
      ze = qe.lineBlockAt(ze);
      let dn = G(ae, ze.from, ze.to);
      dn && Ue.push(bl.of(dn)), ze = (dn ? qe.lineBlockAt(dn.to) : ze).to + 1;
    }
    return Ue.length && qe.dispatch({ effects: $e(qe.state, Ue) }), !!Ue.length;
  }, gl = (qe) => {
    let ae = qe.state.field(Zt, !1);
    if (!ae || !ae.size) return !1;
    let Ue = [];
    return ae.between(0, qe.state.doc.length, (ze, dn) => {
      Ue.push(tl.of({ from: ze, to: dn }));
    }), qe.dispatch({ effects: Ue }), !0;
  }, jr = [{ key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: Ql }, { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: jl }, { key: "Ctrl-Alt-[", run: Sl }, { key: "Ctrl-Alt-]", run: gl }], Kt = { placeholderDOM: null, preparePlaceholder: null, placeholderText: "…" }, nl = pn.Facet.define({ combine(qe) {
    return pn.combineConfig(qe, Kt);
  } }), Pr = xn.Decoration.replace({ widget: new class extends xn.WidgetType {
    toDOM(qe) {
      return P(
        qe,
        null
      );
    }
  }() });
  class ii extends xn.WidgetType {
    constructor(ae) {
      super(), this.value = ae;
    }
    eq(ae) {
      return this.value == ae.value;
    }
    toDOM(ae) {
      return P(ae, this.value);
    }
  }
  const Ar = { openText: "⌄", closedText: "›", markerDOM: null, domEventHandlers: {}, foldingChanged: () => !1 };
  class Ml extends xn.GutterMarker {
    constructor(ae, Ue) {
      super(), this.config = ae, this.open = Ue;
    }
    eq(ae) {
      return this.config == ae.config && this.open == ae.open;
    }
    toDOM(ae) {
      if (this.config.markerDOM) return this.config.markerDOM(this.open);
      let Ue = document.createElement("span");
      return Ue.textContent = this.open ? this.config.openText : this.config.closedText, Ue.title = ae.state.phrase(this.open ? "Fold line" : "Unfold line"), Ue;
    }
  }
  const Rl = xn.EditorView.baseTheme({ ".cm-foldPlaceholder": { backgroundColor: "#eee", border: "1px solid #ddd", color: "#888", borderRadius: ".2em", margin: "0 1px", padding: "0 1px", cursor: "pointer" }, ".cm-foldGutter span": { padding: "0 1px", cursor: "pointer" } });
  class Se {
    constructor(ae, Ue) {
      function ze(ht) {
        let ct = at.StyleModule.newName();
        return (dn ||= /* @__PURE__ */ Object.create(null))["." + ct] = ht, ct;
      }
      this.specs = ae;
      let dn;
      const ut = typeof Ue.all == "string" ? Ue.all : Ue.all ? ze(Ue.all) : void 0, Zn = Ue.scope;
      this.scope = Zn instanceof fn ? (ht) => ht.prop(jt) == Zn.data : Zn ? (ht) => ht == Zn : void 0, this.style = Nn.tagHighlighter(ae.map((ht) => ({ tag: ht.tag, class: ht.class || ze(Object.assign({}, ht, { tag: null })) })), { all: ut }).style, this.module = dn ? new at.StyleModule(dn) : null, this.themeType = Ue.themeType;
    }
    static define(ae, Ue) {
      return new Se(ae, Ue || {});
    }
  }
  const se = pn.Facet.define(), Ee = pn.Facet.define({ combine(qe) {
    return qe.length ? [qe[0]] : null;
  } });
  class Ge {
    constructor(ae) {
      this.markCache = /* @__PURE__ */ Object.create(null), this.tree = o(ae.state), this.decorations = this.buildDeco(ae, K(ae.state));
    }
    update(ae) {
      let Ue = o(ae.state), ze = K(ae.state), dn = ze != K(ae.startState);
      Ue.length < ae.view.viewport.to && !dn && Ue.type == this.tree.type ? this.decorations = this.decorations.map(ae.changes) : (Ue != this.tree || ae.viewportChanged || dn) && (this.tree = Ue, this.decorations = this.buildDeco(ae.view, ze));
    }
    buildDeco(ae, Ue) {
      if (!Ue || !this.tree.length) return xn.Decoration.none;
      let ze = new pn.RangeSetBuilder();
      for (let { from: dn, to: ut } of ae.visibleRanges) Nn.highlightTree(
        this.tree,
        Ue,
        (Zn, ht, ct) => {
          ze.add(Zn, ht, this.markCache[ct] || (this.markCache[ct] = xn.Decoration.mark({ class: ct })));
        },
        dn,
        ut
      );
      return ze.finish();
    }
  }
  const vn = pn.Prec.high(xn.ViewPlugin.fromClass(Ge, { decorations: (qe) => qe.decorations })), Kn = Se.define([
    { tag: Nn.tags.meta, color: "#404740" },
    { tag: Nn.tags.link, textDecoration: "underline" },
    { tag: Nn.tags.heading, textDecoration: "underline", fontWeight: "bold" },
    { tag: Nn.tags.emphasis, fontStyle: "italic" },
    { tag: Nn.tags.strong, fontWeight: "bold" },
    { tag: Nn.tags.strikethrough, textDecoration: "line-through" },
    { tag: Nn.tags.keyword, color: "#708" },
    { tag: [Nn.tags.atom, Nn.tags.bool, Nn.tags.url, Nn.tags.contentSeparator, Nn.tags.labelName], color: "#219" },
    { tag: [Nn.tags.literal, Nn.tags.inserted], color: "#164" },
    { tag: [Nn.tags.string, Nn.tags.deleted], color: "#a11" },
    { tag: [Nn.tags.regexp, Nn.tags.escape, Nn.tags.special(Nn.tags.string)], color: "#e40" },
    { tag: Nn.tags.definition(Nn.tags.variableName), color: "#00f" },
    { tag: Nn.tags.local(Nn.tags.variableName), color: "#30a" },
    { tag: [Nn.tags.typeName, Nn.tags.namespace], color: "#085" },
    {
      tag: Nn.tags.className,
      color: "#167"
    },
    { tag: [Nn.tags.special(Nn.tags.variableName), Nn.tags.macroName], color: "#256" },
    { tag: Nn.tags.definition(Nn.tags.propertyName), color: "#00c" },
    { tag: Nn.tags.comment, color: "#940" },
    { tag: Nn.tags.invalid, color: "#f00" }
  ]), Un = xn.EditorView.baseTheme({ "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" }, "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" } }), Pe = pn.Facet.define({ combine(qe) {
    return pn.combineConfig(qe, {
      afterCursor: !0,
      brackets: "()[]{}",
      maxScanDistance: 1e4,
      renderMatch: H
    });
  } }), C = xn.Decoration.mark({ class: "cm-matchingBracket" }), re = xn.Decoration.mark({ class: "cm-nonmatchingBracket" }), ge = [pn.StateField.define({ create() {
    return xn.Decoration.none;
  }, update(qe, ae) {
    if (!ae.docChanged && !ae.selection) return qe;
    qe = [];
    let Ue = ae.state.facet(Pe);
    for (let ze of ae.state.selection.ranges) {
      if (!ze.empty) continue;
      let dn = le(ae.state, ze.head, -1, Ue) || 0 < ze.head && le(ae.state, ze.head - 1, 1, Ue) || Ue.afterCursor && (le(ae.state, ze.head, 1, Ue) || ze.head < ae.state.doc.length && le(ae.state, ze.head + 1, -1, Ue));
      dn && (qe = qe.concat(Ue.renderMatch(
        dn,
        ae.state
      )));
    }
    return xn.Decoration.set(qe, !0);
  }, provide: (qe) => xn.EditorView.decorations.from(qe) }), Un], Z = new Ze.NodeProp();
  class Y {
    constructor(ae, Ue, ze, dn) {
      this.string = ae, this.tabSize = Ue, this.indentUnit = ze, this.overrideIndent = dn, this.lastColumnValue = this.lastColumnPos = this.start = this.pos = 0;
    }
    eol() {
      return this.pos >= this.string.length;
    }
    sol() {
      return this.pos == 0;
    }
    peek() {
      return this.string.charAt(this.pos) || void 0;
    }
    next() {
      if (this.pos < this.string.length) return this.string.charAt(this.pos++);
    }
    eat(ae) {
      let Ue = this.string.charAt(this.pos);
      if (typeof ae == "string" ? Ue == ae : Ue && (ae instanceof RegExp ? ae.test(Ue) : ae(Ue))) return ++this.pos, Ue;
    }
    eatWhile(ae) {
      let Ue = this.pos;
      for (; this.eat(ae); ) ;
      return this.pos > Ue;
    }
    eatSpace() {
      let ae = this.pos;
      for (; /[\s\u00a0]/.test(this.string.charAt(this.pos)); ) ++this.pos;
      return this.pos > ae;
    }
    skipToEnd() {
      this.pos = this.string.length;
    }
    skipTo(ae) {
      if (ae = this.string.indexOf(ae, this.pos), -1 < ae) return this.pos = ae, !0;
    }
    backUp(ae) {
      this.pos -= ae;
    }
    column() {
      return this.lastColumnPos < this.start && (this.lastColumnValue = Ce(
        this.string,
        this.start,
        this.tabSize,
        this.lastColumnPos,
        this.lastColumnValue
      ), this.lastColumnPos = this.start), this.lastColumnValue;
    }
    indentation() {
      var ae;
      return (ae = this.overrideIndent) !== null && ae !== void 0 ? ae : Ce(this.string, null, this.tabSize);
    }
    match(ae, Ue, ze) {
      if (typeof ae == "string") {
        var dn = this.string.substr(this.pos, ae.length);
        return dn = ze ? dn.toLowerCase() : dn, ze = ze ? ae.toLowerCase() : ae, dn == ze ? (Ue !== !1 && (this.pos += ae.length), !0) : null;
      }
      return (ae = this.string.slice(this.pos).match(ae)) && 0 < ae.index ? null : (ae && Ue !== !1 && (this.pos += ae[0].length), ae);
    }
    current() {
      return this.string.slice(
        this.start,
        this.pos
      );
    }
  }
  const oe = /* @__PURE__ */ new WeakMap();
  class ke extends fn {
    constructor(ae) {
      let Ue = r(ae.languageData), ze = Ye(ae), dn, ut = new class extends Ze.Parser {
        createParse(Zn, ht, ct) {
          return new De(dn, Zn, ht, ct);
        }
      }();
      super(Ue, ut, [St.of((Zn, ht) => this.getIndent(Zn, ht))], ae.name), this.topNode = Be(Ue), dn = this, this.streamParser = ze, this.stateAfter = new Ze.NodeProp({ perNode: !0 }), this.tokenTable = ae.tokenTable ? new Gt(ze.tokenTable) : zl;
    }
    static define(ae) {
      return new ke(ae);
    }
    getIndent(ae, Ue) {
      for (var ze = o(ae.state), dn = ze.resolve(Ue); dn && dn.type != this.topNode; ) dn = dn.parent;
      if (!dn) return null;
      let ut, { overrideIndentation: Zn } = ae.options;
      if (Zn && (ut = oe.get(ae.state), ut != null && ut < Ue - 1e4 && (ut = void 0)), (dn = q(this, ze, 0, dn.from, ut ?? Ue)) ? (ze = dn.state, dn = dn.pos + 1) : (ze = this.streamParser.startState(ae.unit), dn = 0), 1e4 < Ue - dn) return null;
      for (; dn < Ue; ) {
        dn = ae.state.doc.lineAt(dn);
        let ct = Math.min(Ue, dn.to);
        if (dn.length) {
          var ht = Zn ? Zn(dn.from) : -1;
          for (ht = new Y(dn.text, ae.state.tabSize, ae.unit, 0 > ht ? void 0 : ht); ht.pos < ct - dn.from; ) Ae(this.streamParser.token, ht, ze);
        } else this.streamParser.blankLine(
          ze,
          ae.unit
        );
        if (ct == Ue) break;
        dn = dn.to + 1;
      }
      return Ue = ae.lineAt(Ue), Zn && ut == null && oe.set(ae.state, Ue.from), this.streamParser.indent(ze, /^\s*(.*)/.exec(Ue.text)[1], ae);
    }
    get allowsNesting() {
      return !1;
    }
  }
  class De {
    constructor(ae, Ue, ze, dn) {
      this.lang = ae, this.input = Ue, this.fragments = ze, this.ranges = dn, this.stoppedAt = null, this.chunks = [], this.chunkPos = [], this.chunk = [], this.chunkReused = void 0, this.rangeIndex = 0, this.to = dn[dn.length - 1].to, Ue = En.get(), dn = dn[0].from;
      e: {
        var ut = Ue?.state;
        for (let ct of ze) {
          ze = ct.to - (ct.openEnd ? 25 : 0), ze = ct.from + (ct.openStart ? 25 : 0) <= dn && ze > dn && q(ae, ct.tree, 0 - ct.offset, dn, ze);
          let Hl;
          if (ze && (Hl = me(ae, ct.tree, dn + ct.offset, ze.pos + ct.offset, !1))) {
            ae = { state: ze.state, tree: Hl };
            break e;
          }
        }
        ae = { state: ae.streamParser.startState(ut ? s(ut) : 4), tree: Ze.Tree.empty };
      }
      let { state: Zn, tree: ht } = ae;
      for (this.state = Zn, this.parsedPos = this.chunkStart = dn + ht.length, ae = 0; ae < ht.children.length; ae++) this.chunks.push(ht.children[ae]), this.chunkPos.push(ht.positions[ae]);
      Ue && this.parsedPos < Ue.viewport.from - 1e5 && (this.state = this.lang.streamParser.startState(s(Ue.state)), Ue.skipUntilInView(this.parsedPos, Ue.viewport.from), this.parsedPos = Ue.viewport.from), this.moveRangeIndex();
    }
    advance() {
      let ae = En.get(), Ue = this.stoppedAt == null ? this.to : Math.min(this.to, this.stoppedAt), ze = Math.min(Ue, this.chunkStart + 2048);
      for (ae && (ze = Math.min(ze, ae.viewport.to)); this.parsedPos < ze; ) this.parseLine(ae);
      return this.chunkStart < this.parsedPos && this.finishChunk(), this.parsedPos >= Ue ? this.finish() : ae && this.parsedPos >= ae.viewport.to ? (ae.skipUntilInView(this.parsedPos, Ue), this.finish()) : null;
    }
    stopAt(ae) {
      this.stoppedAt = ae;
    }
    lineAfter(ae) {
      let Ue = this.input.chunk(ae);
      if (this.input.lineChunks) Ue == `
` && (Ue = "");
      else {
        let ze = Ue.indexOf(`
`);
        -1 < ze && (Ue = Ue.slice(0, ze));
      }
      return ae + Ue.length <= this.to ? Ue : Ue.slice(0, this.to - ae);
    }
    nextLine() {
      var ae = this.parsedPos;
      let Ue = this.lineAfter(ae);
      var ze = ae + Ue.length;
      for (ae = this.rangeIndex; ; ) {
        var dn = this.ranges[ae].to;
        if (dn >= ze || (Ue = Ue.slice(0, dn - (ze - Ue.length)), ae++, ae == this.ranges.length)) break;
        ze = this.ranges[ae].from, dn = this.lineAfter(ze), Ue += dn, ze += dn.length;
      }
      return { line: Ue, end: ze };
    }
    skipGapsTo(ae, Ue, ze) {
      for (; ; ) {
        let ut = this.ranges[this.rangeIndex].to;
        var dn = ae + Ue;
        if (0 < ze ? ut > dn : ut >= dn) break;
        dn = this.ranges[++this.rangeIndex].from, Ue += dn - ut;
      }
      return Ue;
    }
    moveRangeIndex() {
      for (; this.ranges[this.rangeIndex].to < this.parsedPos; ) this.rangeIndex++;
    }
    emitToken(ae, Ue, ze, dn, ut) {
      if (1 < this.ranges.length) {
        ut = this.skipGapsTo(Ue, ut, 1), Ue += ut;
        let Zn = this.chunk.length;
        ut = this.skipGapsTo(ze, ut, -1), ze += ut, dn += this.chunk.length - Zn;
      }
      return this.chunk.push(ae, Ue, ze, dn), ut;
    }
    parseLine(ae) {
      let { line: Ue, end: ze } = this.nextLine(), dn = 0, { streamParser: ut } = this.lang;
      if (ae = new Y(Ue, ae ? ae.state.tabSize : 4, ae ? s(ae.state) : 2), ae.eol()) ut.blankLine(this.state, ae.indentUnit);
      else for (; !ae.eol(); ) {
        let Zn = Ae(ut.token, ae, this.state);
        if (Zn && (dn = this.emitToken(this.lang.tokenTable.resolve(Zn), this.parsedPos + ae.start, this.parsedPos + ae.pos, 4, dn)), 1e4 < ae.start) break;
      }
      this.parsedPos = ze, this.moveRangeIndex(), this.parsedPos < this.to && this.parsedPos++;
    }
    finishChunk() {
      let ae = Ze.Tree.build({ buffer: this.chunk, start: this.chunkStart, length: this.parsedPos - this.chunkStart, nodeSet: Tn, topID: 0, maxBufferLength: 2048, reused: this.chunkReused });
      ae = new Ze.Tree(
        ae.type,
        ae.children,
        ae.positions,
        ae.length,
        [[this.lang.stateAfter, this.lang.streamParser.copyState(this.state)]]
      ), this.chunks.push(ae), this.chunkPos.push(this.chunkStart - this.ranges[0].from), this.chunk = [], this.chunkReused = void 0, this.chunkStart = this.parsedPos;
    }
    finish() {
      return new Ze.Tree(this.lang.topNode, this.chunks, this.chunkPos, this.parsedPos - this.ranges[0].from).balance();
    }
  }
  const un = /* @__PURE__ */ Object.create(null), gn = [Ze.NodeType.none], Tn = new Ze.NodeSet(gn), ft = [], gt = /* @__PURE__ */ Object.create(null);
  for (let [qe, ae] of [
    ["variable", "variableName"],
    ["variable-2", "variableName.special"],
    ["string-2", "string.special"],
    ["def", "variableName.definition"],
    ["tag", "tagName"],
    ["attribute", "attributeName"],
    ["type", "typeName"],
    ["builtin", "variableName.standard"],
    ["qualifier", "modifier"],
    ["error", "invalid"],
    ["header", "heading"],
    ["property", "propertyName"]
  ]) gt[qe] = ln(un, ae);
  class Gt {
    constructor(ae) {
      this.extra = ae, this.table = Object.assign(/* @__PURE__ */ Object.create(null), gt);
    }
    resolve(ae) {
      return ae ? this.table[ae] || (this.table[ae] = ln(this.extra, ae)) : 0;
    }
  }
  const zl = new Gt(un);
  l.DocInput = Ve, l.HighlightStyle = Se, l.IndentContext = ul, l.LRLanguage = _e, l.Language = fn, l.LanguageDescription = ol, l.LanguageSupport = Pt, l.ParseContext = En, l.StreamLanguage = ke, l.StringStream = Y, l.TreeIndentContext = ql, l.bracketMatching = function(qe = {}) {
    return [Pe.of(qe), ge];
  }, l.bracketMatchingHandle = Z, l.codeFolding = E, l.continuedIndent = function({ except: qe, units: ae = 1 } = {}) {
    return (Ue) => {
      let ze = qe && qe.test(Ue.textAfter);
      return Ue.baseIndent + (ze ? 0 : ae * Ue.unit);
    };
  }, l.defaultHighlightStyle = Kn, l.defineLanguageFacet = r, l.delimitedIndent = function({
    closing: qe,
    align: ae = !0,
    units: Ue = 1
  }) {
    return (ze) => L(ze, ae, Ue, qe);
  }, l.ensureSyntaxTree = a, l.flatIndent = (qe) => qe.baseIndent, l.foldAll = Sl, l.foldCode = Ql, l.foldEffect = bl, l.foldGutter = function(qe = {}) {
    let ae = Object.assign(Object.assign({}, Ar), qe), Ue = new Ml(ae, !0), ze = new Ml(ae, !1), dn = xn.ViewPlugin.fromClass(class {
      constructor(Zn) {
        this.from = Zn.viewport.from, this.markers = this.buildMarkers(Zn);
      }
      update(Zn) {
        (Zn.docChanged || Zn.viewportChanged || Zn.startState.facet(zt) != Zn.state.facet(zt) || Zn.startState.field(Zt, !1) != Zn.state.field(Zt, !1) || o(Zn.startState) != o(Zn.state) || ae.foldingChanged(Zn)) && (this.markers = this.buildMarkers(Zn.view));
      }
      buildMarkers(Zn) {
        let ht = new pn.RangeSetBuilder();
        for (let ct of Zn.viewportLineBlocks) {
          let Hl = ce(Zn.state, ct.from, ct.to) ? ze : G(Zn.state, ct.from, ct.to) ? Ue : null;
          Hl && ht.add(ct.from, ct.from, Hl);
        }
        return ht.finish();
      }
    }), { domEventHandlers: ut } = ae;
    return [dn, xn.gutter({ class: "cm-foldGutter", markers(Zn) {
      var ht;
      return ((ht = Zn.plugin(dn)) === null || ht === void 0 ? void 0 : ht.markers) || pn.RangeSet.empty;
    }, initialSpacer() {
      return new Ml(ae, !1);
    }, domEventHandlers: Object.assign(Object.assign(
      {},
      ut
    ), { click: (Zn, ht, ct) => ut.click && ut.click(Zn, ht, ct) ? !0 : (ct = ce(Zn.state, ht.from, ht.to)) ? (Zn.dispatch({ effects: tl.of(ct) }), !0) : (ht = G(Zn.state, ht.from, ht.to)) ? (Zn.dispatch({ effects: bl.of(ht) }), !0) : !1 }) }), E()];
  }, l.foldInside = function(qe) {
    let ae = qe.firstChild, Ue = qe.lastChild;
    return ae && ae.to < Ue.from ? { from: ae.to, to: Ue.type.isError ? qe.to : Ue.from } : null;
  }, l.foldKeymap = jr, l.foldNodeProp = wi, l.foldService = Mr, l.foldState = Zt, l.foldable = G, l.foldedRanges = function(qe) {
    return qe.field(Zt, !1) || pn.RangeSet.empty;
  }, l.forceParsing = function(qe, ae = qe.viewport.to, Ue = 100) {
    return ae = a(qe.state, ae, Ue), ae != o(qe.state) && qe.dispatch({}), !!ae;
  }, l.getIndentUnit = s, l.getIndentation = p, l.highlightingFor = function(qe, ae, Ue) {
    var ze = K(qe);
    if (qe = null, ze) for (let dn of ze) (!dn.scope || Ue && dn.scope(Ue)) && (ze = dn.style(ae)) && (qe = qe ? qe + " " + ze : ze);
    return qe;
  }, l.indentNodeProp = Rr, l.indentOnInput = function() {
    return pn.EditorState.transactionFilter.of((qe) => {
      if (!qe.docChanged || !qe.isUserEvent("input.type") && !qe.isUserEvent("input.complete")) return qe;
      var ae = qe.startState.languageDataAt(
        "indentOnInput",
        qe.startState.selection.main.head
      );
      if (!ae.length) return qe;
      var Ue = qe.newDoc, { head: ze } = qe.newSelection.main, dn = Ue.lineAt(ze);
      if (ze > dn.from + 200) return qe;
      let ut = Ue.sliceString(dn.from, ze);
      if (!ae.some((ht) => ht.test(ut))) return qe;
      ({ state: ae } = qe), Ue = -1, ze = [];
      for (let { head: ht } of ae.selection.ranges) {
        if (dn = ae.doc.lineAt(ht), dn.from == Ue) continue;
        Ue = dn.from;
        var Zn = p(ae, dn.from);
        if (Zn == null) continue;
        let ct = /^\s*/.exec(dn.text)[0];
        Zn = d(ae, Zn), ct != Zn && ze.push({ from: dn.from, to: dn.from + ct.length, insert: Zn });
      }
      return ze.length ? [qe, {
        changes: ze,
        sequential: !0
      }] : qe;
    });
  }, l.indentRange = function(qe, ae, Ue) {
    let ze = /* @__PURE__ */ Object.create(null), dn = new ul(qe, { overrideIndentation: (Zn) => {
      var ht;
      return (ht = ze[Zn]) !== null && ht !== void 0 ? ht : -1;
    } }), ut = [];
    for (; ae <= Ue; ) {
      let Zn = qe.doc.lineAt(ae);
      ae = Zn.to + 1;
      let ht = p(dn, Zn.from);
      if (ht == null) continue;
      /\S/.test(Zn.text) || (ht = 0);
      let ct = /^\s*/.exec(Zn.text)[0], Hl = d(qe, ht);
      ct != Hl && (ze[Zn.from] = ht, ut.push({ from: Zn.from, to: Zn.from + ct.length, insert: Hl }));
    }
    return qe.changes(ut);
  }, l.indentService = St, l.indentString = d, l.indentUnit = pr, l.language = zt, l.languageDataProp = jt, l.matchBrackets = le, l.sublanguageProp = Cl, l.syntaxHighlighting = function(qe, ae) {
    let Ue = [vn], ze;
    return qe instanceof Se && (qe.module && Ue.push(xn.EditorView.styleModule.of(qe.module)), ze = qe.themeType), ae != null && ae.fallback ? Ue.push(Ee.of(qe)) : ze ? Ue.push(se.computeN([xn.EditorView.darkTheme], (dn) => dn.facet(xn.EditorView.darkTheme) == (ze == "dark") ? [qe] : [])) : Ue.push(se.of(qe)), Ue;
  }, l.syntaxParserRunning = function(qe) {
    var ae;
    return ((ae = qe.plugin(Nt)) === null || ae === void 0 ? void 0 : ae.isWorking()) || !1;
  }, l.syntaxTree = o, l.syntaxTreeAvailable = function(qe, ae = qe.doc.length) {
    var Ue;
    return ((Ue = qe.field(fn.state, !1)) === null || Ue === void 0 ? void 0 : Ue.context.isDone(ae)) || !1;
  }, l.toggleFold = (qe) => {
    let ae = [];
    for (let dn of we(qe)) {
      var Ue = ce(qe.state, dn.from, dn.to);
      if (Ue) ae.push(tl.of(Ue), je(qe, Ue, !1));
      else {
        e: {
          Ue = qe;
          var ze = dn;
          for (let ut = ze; ; ) {
            let Zn = G(Ue.state, ut.from, ut.to);
            if (Zn && Zn.to > ze.from) {
              Ue = Zn;
              break e;
            }
            if (!ut.from) {
              Ue = null;
              break e;
            }
            ut = Ue.lineBlockAt(ut.from - 1);
          }
        }
        Ue && ae.push(bl.of(Ue), je(qe, Ue));
      }
    }
    return 0 < ae.length && qe.dispatch({ effects: $e(qe.state, ae) }), !!ae.length;
  }, l.unfoldAll = gl, l.unfoldCode = jl, l.unfoldEffect = tl;
};
Xo[7] = function(e, n, t, l) {
  function r(Oe, Ke) {
    return ({ state: mn, dispatch: wn }) => {
      if (mn.readOnly) return !1;
      let On = Oe(Ke, mn);
      return On ? (wn(mn.update(On)), !0) : !1;
    };
  }
  function u(Oe, Ke) {
    return Oe = Oe.languageDataAt("commentTokens", Ke), Oe.length ? Oe[0] : {};
  }
  function o(Oe, { open: Ke, close: mn }, wn, On) {
    var An = Oe.sliceDoc(wn - 50, wn), mt = Oe.sliceDoc(On, On + 50), Ot = /\s*$/.exec(An)[0].length, ll = /^\s*/.exec(mt)[0].length;
    let Nr = An.length - Ot;
    return An.slice(Nr - Ke.length, Nr) == Ke && mt.slice(ll, ll + mn.length) == mn ? { open: { pos: wn - Ot, margin: Ot && 1 }, close: { pos: On + ll, margin: ll && 1 } } : (100 >= On - wn ? An = Oe = Oe.sliceDoc(wn, On) : (An = Oe.sliceDoc(wn, wn + 50), Oe = Oe.sliceDoc(On - 50, On)), mt = /^\s*/.exec(An)[0].length, Ot = /\s*$/.exec(Oe)[0].length, ll = Oe.length - Ot - mn.length, An.slice(mt, mt + Ke.length) == Ke && Oe.slice(ll, ll + mn.length) == mn ? { open: { pos: wn + mt + Ke.length, margin: /\s/.test(An.charAt(mt + Ke.length)) ? 1 : 0 }, close: { pos: On - Ot - mn.length, margin: /\s/.test(Oe.charAt(ll - 1)) ? 1 : 0 } } : null);
  }
  function a(Oe, Ke, mn = Ke.selection.ranges) {
    let wn = mn.map((An) => u(Ke, An.from).block);
    if (!wn.every((An) => An)) return null;
    let On = mn.map((An, mt) => o(Ke, wn[mt], An.from, An.to));
    if (Oe != 2 && !On.every((An) => An)) return { changes: Ke.changes(mn.map((An, mt) => On[mt] ? [] : [{ from: An.from, insert: wn[mt].open + " " }, { from: An.to, insert: " " + wn[mt].close }])) };
    if (Oe != 1 && On.some((An) => An)) {
      Oe = [];
      for (let An = 0, mt; An < On.length; An++) if (mt = On[An]) {
        mn = wn[An];
        let { open: Ot, close: ll } = mt;
        Oe.push({ from: Ot.pos - mn.open.length, to: Ot.pos + Ot.margin }, { from: ll.pos - ll.margin, to: ll.pos + mn.close.length });
      }
      return { changes: Oe };
    }
    return null;
  }
  function h(Oe, Ke, mn = Ke.selection.ranges) {
    var wn = [];
    let On = -1;
    for (let { from: Ot, to: ll } of mn) {
      mn = wn.length;
      let Nr = 1e9;
      var An = u(Ke, Ot).line;
      if (An) {
        for (var mt = Ot; mt <= ll; ) {
          if (mt = Ke.doc.lineAt(mt), mt.from > On && (Ot == ll || ll > mt.from)) {
            On = mt.from;
            let hi = /^\s*/.exec(mt.text)[0].length, Oo = hi == mt.length, yu = mt.text.slice(hi, hi + An.length) == An ? hi : -1;
            hi < mt.text.length && hi < Nr && (Nr = hi), wn.push({ line: mt, comment: yu, token: An, indent: hi, empty: Oo, single: !1 });
          }
          mt = mt.to + 1;
        }
        if (1e9 > Nr) for (An = mn; An < wn.length; An++) wn[An].indent < wn[An].line.text.length && (wn[An].indent = Nr);
        wn.length == mn + 1 && (wn[mn].single = !0);
      }
    }
    if (Oe != 2 && wn.some((Ot) => 0 > Ot.comment && (!Ot.empty || Ot.single))) {
      Oe = [];
      for (let { line: Ot, token: ll, indent: Nr, empty: hi, single: Oo } of wn) !Oo && hi || Oe.push({ from: Ot.from + Nr, insert: ll + " " });
      return wn = Ke.changes(Oe), { changes: wn, selection: Ke.selection.map(wn, 1) };
    }
    if (Oe != 1 && wn.some((Ot) => 0 <= Ot.comment)) {
      Ke = [];
      for (let { line: Ot, comment: ll, token: Nr } of wn) 0 <= ll && (wn = Ot.from + ll, Oe = wn + Nr.length, Ot.text[Oe - Ot.from] == " " && Oe++, Ke.push({ from: wn, to: Oe }));
      return { changes: Ke };
    }
    return null;
  }
  function s(Oe) {
    let Ke = 0;
    return Oe.iterChangedRanges((mn, wn) => Ke = wn), Ke;
  }
  function d(Oe, Ke) {
    return function({ state: mn, dispatch: wn }) {
      if (!Ke && mn.readOnly) return !1;
      let On = mn.field(ql, !1);
      return !On || (mn = On.pop(Oe, mn, Ke), !mn) ? !1 : (wn(mn), !0);
    };
  }
  function p(Oe) {
    return function(Ke) {
      return Ke = Ke.field(ql, !1), Ke ? (Ke = Oe == 0 ? Ke.done : Ke.undone, Ke.length - (Ke.length && !Ke[0].changes ? 1 : 0)) : 0;
    };
  }
  function _(Oe, Ke, mn, wn) {
    return Oe = Oe.slice(Ke + 1 > mn + 20 ? Ke - mn - 1 : 0, Ke), Oe.push(wn), Oe;
  }
  function R(Oe, Ke) {
    let mn = [], wn = !1;
    return Oe.iterChangedRanges((On, An) => mn.push(On, An)), Ke.iterChangedRanges((On, An, mt, Ot) => {
      for (On = 0; On < mn.length; ) {
        An = mn[On++];
        let ll = mn[On++];
        Ot >= An && mt <= ll && (wn = !0);
      }
    }), wn;
  }
  function F(Oe, Ke) {
    return Oe.ranges.length == Ke.ranges.length && Oe.ranges.filter((mn, wn) => mn.empty != Ke.ranges[wn].empty).length === 0;
  }
  function L(Oe, Ke) {
    return Oe.length ? Ke.length ? Oe.concat(Ke) : Oe : Ke;
  }
  function G(Oe, Ke) {
    if (Oe.length) {
      let mn = Oe[Oe.length - 1], wn = mn.selectionsAfter.slice(Math.max(0, mn.selectionsAfter.length - 200));
      return wn.length && wn[wn.length - 1].eq(Ke) ? Oe : (wn.push(Ke), _(Oe, Oe.length - 1, 1e9, mn.setSelAfter(wn)));
    }
    return [Sl.selection([Ke])];
  }
  function J(Oe, Ke) {
    if (!Oe.length) return Oe;
    let mn = Oe.length;
    for (var wn = gl; mn; ) {
      if (wn = we(Oe[mn - 1], Ke, wn), wn.changes && !wn.changes.empty || wn.effects.length) return Oe = Oe.slice(0, mn), Oe[mn - 1] = wn, Oe;
      Ke = wn.mapped, mn--, wn = wn.selectionsAfter;
    }
    return wn.length ? [Sl.selection(wn)] : gl;
  }
  function we(Oe, Ke, mn) {
    if (mn = L(Oe.selectionsAfter.length ? Oe.selectionsAfter.map((mt) => mt.map(Ke)) : gl, mn), !Oe.changes) return Sl.selection(mn);
    let wn = Oe.changes.map(Ke), On = Ke.mapDesc(Oe.changes, !0), An = Oe.mapped ? Oe.mapped.composeDesc(On) : On;
    return new Sl(
      wn,
      fn.StateEffect.mapEffects(Oe.effects, Ke),
      An,
      Oe.startSelection.map(On),
      mn
    );
  }
  function ce(Oe, Ke) {
    return fn.EditorSelection.create(Oe.ranges.map(Ke), Oe.mainIndex);
  }
  function xe(Oe, Ke) {
    return Oe.update({ selection: Ke, scrollIntoView: !0, userEvent: "select" });
  }
  function $e({ state: Oe, dispatch: Ke }, mn) {
    return mn = ce(Oe.selection, mn), mn.eq(Oe.selection) ? !1 : (Ke(xe(Oe, mn)), !0);
  }
  function je(Oe, Ke) {
    return fn.EditorSelection.cursor(Ke ? Oe.to : Oe.from);
  }
  function E(Oe, Ke) {
    return $e(Oe, (mn) => mn.empty ? Oe.moveByChar(mn, Ke) : je(mn, Ke));
  }
  function P(Oe) {
    return Oe.textDirectionAt(Oe.state.selection.main.head) == _e.Direction.LTR;
  }
  function K(Oe, Ke) {
    return $e(Oe, (mn) => mn.empty ? Oe.moveByGroup(mn, Ke) : je(mn, Ke));
  }
  function H(Oe, Ke, mn) {
    let wn = Oe.state.charCategorizer(Ke.from), On = fn.CharCategory.Space, An = Ke.from, mt = 0, Ot = !1, ll = !1, Nr = !1, hi = ($r) => {
      if (Ot) return !1;
      An += mn ? $r.length : -$r.length;
      let ri = wn($r), bh;
      if (ri == fn.CharCategory.Word && 128 > $r.charCodeAt(0) && /[\W_]/.test($r) && (ri = -1), On == fn.CharCategory.Space && (On = ri), On != ri) return !1;
      if (On == fn.CharCategory.Word) if ($r.toLowerCase() == $r) {
        if (!mn && ll) return !1;
        Nr = !0;
      } else if (Nr) {
        if (mn) return !1;
        Ot = !0;
      } else {
        if (ll && mn && wn(bh = Oe.state.sliceDoc(An, An + 1)) == fn.CharCategory.Word && bh.toLowerCase() == bh) return !1;
        ll = !0;
      }
      return mt++, !0;
    }, Oo = Oe.moveByChar(Ke, mn, ($r) => (hi($r), hi));
    if (Rl && On == fn.CharCategory.Word && Oo.from == Ke.from + mt * (mn ? 1 : -1)) {
      var yu = Oe.state.sliceDoc(Math.min(Ke.head, Oo.head), Math.max(Ke.head, Oo.head));
      if (1 < yu.length && /[\u4E00-\uffff]/.test(yu) && (yu = Array.from(Rl.segment(yu)), 1 < yu.length)) return mn ? fn.EditorSelection.cursor(Ke.head + yu[1].index, -1) : fn.EditorSelection.cursor(Oo.head + yu[yu.length - 1].index, 1);
    }
    return Oo;
  }
  function U(Oe, Ke) {
    return $e(Oe, (mn) => mn.empty ? H(Oe, mn, Ke) : je(mn, Ke));
  }
  function Me(Oe, Ke, mn) {
    let wn = Ve.syntaxTree(Oe).resolveInner(Ke.head), On = mn ? an.NodeProp.closedBy : an.NodeProp.openedBy;
    for (Ke = Ke.head; ; ) {
      let ll = mn ? wn.childAfter(Ke) : wn.childBefore(Ke);
      if (!ll) break;
      e: {
        var An = Oe, mt = ll;
        if (mt.type.prop(On)) {
          An = !0;
          break e;
        }
        let Nr = mt.to - mt.from;
        An = Nr && (2 < Nr || /[^\s,.;:]/.test(An.sliceDoc(mt.from, mt.to))) || mt.firstChild;
      }
      An ? wn = ll : Ke = mn ? ll.to : ll.from;
    }
    let Ot;
    return Oe = wn.type.prop(On) && (Ot = mn ? Ve.matchBrackets(
      Oe,
      wn.from,
      1
    ) : Ve.matchBrackets(Oe, wn.to, -1)) && Ot.matched ? mn ? Ot.end.to : Ot.end.from : mn ? wn.to : wn.from, fn.EditorSelection.cursor(Oe, mn ? -1 : 1);
  }
  function le(Oe, Ke) {
    return $e(Oe, (mn) => {
      if (!mn.empty) return je(mn, Ke);
      let wn = Oe.moveVertically(mn, Ke);
      return wn.head != mn.head ? wn : Oe.moveToLineBoundary(mn, Ke);
    });
  }
  function Ce(Oe) {
    let Ke = Oe.scrollDOM.clientHeight < Oe.scrollDOM.scrollHeight - 2, mn = 0, wn = 0;
    if (Ke) {
      for (On of Oe.state.facet(_e.EditorView.scrollMargins)) {
        let An = On(Oe);
        An != null && An.top && (mn = Math.max(An?.top, mn)), An != null && An.bottom && (wn = Math.max(An?.bottom, wn));
      }
      var On = Oe.scrollDOM.clientHeight - mn - wn;
    } else On = (Oe.dom.ownerDocument.defaultView || window).innerHeight;
    return { marginTop: mn, marginBottom: wn, selfScroll: Ke, height: Math.max(Oe.defaultLineHeight, On - 5) };
  }
  function Ye(Oe, Ke) {
    let mn = Ce(Oe), { state: wn } = Oe, On = ce(wn.selection, (Ot) => Ot.empty ? Oe.moveVertically(Ot, Ke, mn.height) : je(Ot, Ke));
    if (On.eq(wn.selection)) return !1;
    let An;
    if (mn.selfScroll) {
      let Ot = Oe.coordsAtPos(wn.selection.main.head);
      var mt = Oe.scrollDOM.getBoundingClientRect();
      let ll = mt.top + mn.marginTop;
      mt = mt.bottom - mn.marginBottom, Ot && Ot.top > ll && Ot.bottom < mt && (An = _e.EditorView.scrollIntoView(On.main.head, { y: "start", yMargin: Ot.top - ll }));
    }
    return Oe.dispatch(xe(wn, On), { effects: An }), !0;
  }
  function B(Oe, Ke, mn) {
    let wn = Oe.lineBlockAt(Ke.head), On = Oe.moveToLineBoundary(Ke, mn);
    return On.head == Ke.head && On.head != (mn ? wn.to : wn.from) && (On = Oe.moveToLineBoundary(Ke, mn, !1)), !mn && On.head == wn.from && wn.length && (Oe = /^\s*/.exec(Oe.state.sliceDoc(wn.from, Math.min(
      wn.from + 100,
      wn.to
    )))[0].length) && Ke.head != wn.from + Oe && (On = fn.EditorSelection.cursor(wn.from + Oe)), On;
  }
  function q(Oe, Ke, mn) {
    let wn = !1, On = ce(Oe.selection, (An) => {
      var mt = Ve.matchBrackets(Oe, An.head, -1) || Ve.matchBrackets(Oe, An.head, 1) || 0 < An.head && Ve.matchBrackets(Oe, An.head - 1, 1) || An.head < Oe.doc.length && Ve.matchBrackets(Oe, An.head + 1, -1);
      return !mt || !mt.end ? An : (wn = !0, mt = mt.start.from == An.head ? mt.end.to : mt.end.from, mn ? fn.EditorSelection.range(An.anchor, mt) : fn.EditorSelection.cursor(mt));
    });
    return wn ? (Ke(xe(Oe, On)), !0) : !1;
  }
  function me(Oe, Ke) {
    let mn = ce(Oe.state.selection, (wn) => {
      let On = Ke(wn);
      return fn.EditorSelection.range(wn.anchor, On.head, On.goalColumn, On.bidiLevel || void 0);
    });
    return mn.eq(Oe.state.selection) ? !1 : (Oe.dispatch(xe(Oe.state, mn)), !0);
  }
  function Ae(Oe, Ke) {
    return me(Oe, (mn) => Oe.moveByChar(mn, Ke));
  }
  function Fe(Oe, Ke) {
    return me(Oe, (mn) => Oe.moveByGroup(mn, Ke));
  }
  function ln(Oe, Ke) {
    return me(Oe, (mn) => H(Oe, mn, Ke));
  }
  function Be(Oe, Ke) {
    return me(Oe, (mn) => Oe.moveVertically(mn, Ke));
  }
  function Ze(Oe, Ke) {
    return me(Oe, (mn) => Oe.moveVertically(mn, Ke, Ce(Oe).height));
  }
  function pn(Oe, Ke) {
    if (Oe.state.readOnly) return !1;
    let mn = "delete.selection", { state: wn } = Oe, On = wn.changeByRange((An) => {
      let { from: mt, to: Ot } = An;
      if (mt == Ot) {
        let ll = Ke(An);
        ll < mt ? (mn = "delete.backward", ll = xn(Oe, ll, !1)) : ll > mt && (mn = "delete.forward", ll = xn(Oe, ll, !0)), mt = Math.min(mt, ll), Ot = Math.max(Ot, ll);
      } else mt = xn(Oe, mt, !1), Ot = xn(Oe, Ot, !0);
      return mt == Ot ? { range: An } : { changes: { from: mt, to: Ot }, range: fn.EditorSelection.cursor(mt, mt < An.head ? -1 : 1) };
    });
    return On.changes.empty ? !1 : (Oe.dispatch(wn.update(On, { scrollIntoView: !0, userEvent: mn, effects: mn == "delete.selection" ? _e.EditorView.announce.of(wn.phrase("Selection deleted")) : void 0 })), !0);
  }
  function xn(Oe, Ke, mn) {
    if (Oe instanceof _e.EditorView) for (let wn of Oe.state.facet(_e.EditorView.atomicRanges).map((On) => On(Oe))) wn.between(Ke, Ke, (On, An) => {
      On < Ke && An > Ke && (Ke = mn ? An : On);
    });
    return Ke;
  }
  function Nn(Oe) {
    let Ke = [];
    var mn = -1;
    for (let wn of Oe.selection.ranges) {
      let On = Oe.doc.lineAt(wn.from), An = Oe.doc.lineAt(wn.to);
      wn.empty || wn.to != An.from || (An = Oe.doc.lineAt(wn.to - 1)), mn >= On.number ? (mn = Ke[Ke.length - 1], mn.to = An.to, mn.ranges.push(wn)) : Ke.push({
        from: On.from,
        to: An.to,
        ranges: [wn]
      }), mn = An.number + 1;
    }
    return Ke;
  }
  function at(Oe, Ke, mn) {
    if (Oe.readOnly) return !1;
    let wn = [], On = [];
    for (let An of Nn(Oe)) {
      if (mn ? An.to == Oe.doc.length : An.from == 0) continue;
      let mt = Oe.doc.lineAt(mn ? An.to + 1 : An.from - 1), Ot = mt.length + 1;
      if (mn) {
        wn.push({ from: An.to, to: mt.to }, { from: An.from, insert: mt.text + Oe.lineBreak });
        for (let ll of An.ranges) On.push(fn.EditorSelection.range(Math.min(Oe.doc.length, ll.anchor + Ot), Math.min(Oe.doc.length, ll.head + Ot)));
      } else {
        wn.push({ from: mt.from, to: An.from }, { from: An.to, insert: Oe.lineBreak + mt.text });
        for (let ll of An.ranges) On.push(fn.EditorSelection.range(ll.anchor - Ot, ll.head - Ot));
      }
    }
    return wn.length ? (Ke(Oe.update({ changes: wn, scrollIntoView: !0, selection: fn.EditorSelection.create(On, Oe.selection.mainIndex), userEvent: "move.line" })), !0) : !1;
  }
  function Yt(Oe, Ke, mn) {
    if (Oe.readOnly) return !1;
    let wn = [];
    for (let On of Nn(Oe)) mn ? wn.push({ from: On.from, insert: Oe.doc.slice(On.from, On.to) + Oe.lineBreak }) : wn.push({ from: On.to, insert: Oe.lineBreak + Oe.doc.slice(On.from, On.to) });
    return Ke(Oe.update({
      changes: wn,
      scrollIntoView: !0,
      userEvent: "input.copyline"
    })), !0;
  }
  function jt(Oe) {
    return ({ state: Ke, dispatch: mn }) => {
      if (Ke.readOnly) return !1;
      let wn = Ke.changeByRange((On) => {
        let { from: An, to: mt } = On;
        On = Ke.doc.lineAt(An);
        var Ot;
        if (Ot = !Oe && An == mt) if (Ot = An, /\(\)|\[\]|\{\}/.test(Ke.sliceDoc(Ot - 1, Ot + 1))) Ot = { from: Ot, to: Ot };
        else {
          var ll = Ve.syntaxTree(Ke).resolveInner(Ot), Nr = ll.childBefore(Ot);
          ll = ll.childAfter(Ot);
          var hi;
          Ot = Nr && ll && Nr.to <= Ot && ll.from >= Ot && (hi = Nr.type.prop(an.NodeProp.closedBy)) && -1 < hi.indexOf(ll.name) && Ke.doc.lineAt(Nr.to).from == Ke.doc.lineAt(ll.from).from && !/\S/.test(Ke.sliceDoc(Nr.to, ll.from)) ? { from: Nr.to, to: ll.from } : null;
        }
        for (hi = Ot, Oe && (An = mt = (mt <= On.to ? On : Ke.doc.lineAt(mt)).to), Nr = new Ve.IndentContext(Ke, { simulateBreak: An, simulateDoubleBreak: !!hi }), Ot = Ve.getIndentation(Nr, An), Ot == null && (Ot = fn.countColumn(/^\s*/.exec(Ke.doc.lineAt(An).text)[0], Ke.tabSize)); mt < On.to && /\s/.test(On.text[mt - On.from]); ) mt++;
        return hi ? { from: An, to: mt } = hi : An > On.from && An < On.from + 100 && !/\S/.test(On.text.slice(0, An)) && (An = On.from), Ot = ["", Ve.indentString(Ke, Ot)], hi && Ot.push(Ve.indentString(Ke, Nr.lineIndent(
          On.from,
          -1
        ))), { changes: { from: An, to: mt, insert: fn.Text.of(Ot) }, range: fn.EditorSelection.cursor(An + 1 + Ot[1].length) };
      });
      return mn(Ke.update(wn, { scrollIntoView: !0, userEvent: "input" })), !0;
    };
  }
  function Cl(Oe, Ke) {
    let mn = -1;
    return Oe.changeByRange((wn) => {
      let On = [];
      for (var An = wn.from; An <= wn.to; ) An = Oe.doc.lineAt(An), An.number > mn && (wn.empty || wn.to > An.from) && (Ke(An, On, wn), mn = An.number), An = An.to + 1;
      return An = Oe.changes(On), { changes: On, range: fn.EditorSelection.range(An.mapPos(wn.anchor, 1), An.mapPos(wn.head, 1)) };
    });
  }
  var fn = n(0), _e = n(3), Ve = n(6), an = n(4);
  const En = (Oe) => {
    var { state: Ke } = Oe;
    return Ke = Ke.doc.lineAt(Ke.selection.main.from), Ke = u(Oe.state, Ke.from), Ke.line ? Qn(Oe) : Ke.block ? ol(Oe) : !1;
  }, Qn = r(h, 0), Vn = r(h, 1), ot = r(h, 2), Nt = r(a, 0), zt = r(a, 1), Pt = r(a, 2), ol = r((Oe, Ke) => {
    let mn = [];
    for (let wn of Ke.selection.ranges) {
      let On = Ke.doc.lineAt(wn.from), An = wn.to <= On.to ? On : Ke.doc.lineAt(wn.to), mt = mn.length - 1;
      0 <= mt && mn[mt].to > On.from ? mn[mt].to = An.to : mn.push({ from: On.from + /^\s*/.exec(On.text)[0].length, to: An.to });
    }
    return a(Oe, Ke, mn);
  }, 0), St = fn.Annotation.define(), pr = fn.Annotation.define(), ul = fn.Facet.define(), Rr = fn.Facet.define({ combine(Oe) {
    return fn.combineConfig(Oe, { minDepth: 100, newGroupDelay: 500, joinToEvent: (Ke, mn) => mn }, { minDepth: Math.max, newGroupDelay: Math.min, joinToEvent: (Ke, mn) => (wn, On) => Ke(wn, On) || mn(wn, On) });
  } }), ql = fn.StateField.define({ create() {
    return Kt.empty;
  }, update(Oe, Ke) {
    let mn = Ke.state.facet(Rr);
    var wn = Ke.annotation(St);
    if (wn) {
      var On = Ke.docChanged ? fn.EditorSelection.single(s(Ke.changes)) : void 0;
      On = Sl.fromTransaction(Ke, On);
      var An = wn.side;
      return Oe = An == 0 ? Oe.undone : Oe.done, Oe = On ? _(Oe, Oe.length, mn.minDepth, On) : G(Oe, Ke.startState.selection), new Kt(An == 0 ? wn.rest : Oe, An == 0 ? Oe : wn.rest);
    }
    if (wn = Ke.annotation(pr), (wn == "full" || wn == "before") && (Oe = Oe.isolate()), Ke.annotation(fn.Transaction.addToHistory) === !1) return Ke.changes.empty ? Oe : Oe.addMapping(Ke.changes.desc);
    On = Sl.fromTransaction(Ke), An = Ke.annotation(fn.Transaction.time);
    let mt = Ke.annotation(fn.Transaction.userEvent);
    return On ? Oe = Oe.addChanges(On, An, mt, mn, Ke) : Ke.selection && (Oe = Oe.addSelection(Ke.startState.selection, An, mt, mn.newGroupDelay)), (wn == "full" || wn == "after") && (Oe = Oe.isolate()), Oe;
  }, toJSON(Oe) {
    return { done: Oe.done.map((Ke) => Ke.toJSON()), undone: Oe.undone.map((Ke) => Ke.toJSON()) };
  }, fromJSON(Oe) {
    return new Kt(Oe.done.map(Sl.fromJSON), Oe.undone.map(Sl.fromJSON));
  } }), Mr = ql, wi = d(0, !1), bl = d(1, !1), tl = d(0, !0), Zt = d(1, !0), Ql = p(0), jl = p(1);
  class Sl {
    constructor(Ke, mn, wn, On, An) {
      this.changes = Ke, this.effects = mn, this.mapped = wn, this.startSelection = On, this.selectionsAfter = An;
    }
    setSelAfter(Ke) {
      return new Sl(this.changes, this.effects, this.mapped, this.startSelection, Ke);
    }
    toJSON() {
      var Ke, mn, wn;
      return { changes: (Ke = this.changes) === null || Ke === void 0 ? void 0 : Ke.toJSON(), mapped: (mn = this.mapped) === null || mn === void 0 ? void 0 : mn.toJSON(), startSelection: (wn = this.startSelection) === null || wn === void 0 ? void 0 : wn.toJSON(), selectionsAfter: this.selectionsAfter.map((On) => On.toJSON()) };
    }
    static fromJSON(Ke) {
      return new Sl(Ke.changes && fn.ChangeSet.fromJSON(Ke.changes), [], Ke.mapped && fn.ChangeDesc.fromJSON(Ke.mapped), Ke.startSelection && fn.EditorSelection.fromJSON(Ke.startSelection), Ke.selectionsAfter.map(fn.EditorSelection.fromJSON));
    }
    static fromTransaction(Ke, mn) {
      let wn = gl;
      for (let On of Ke.startState.facet(ul)) {
        let An = On(Ke);
        An.length && (wn = wn.concat(An));
      }
      return !wn.length && Ke.changes.empty ? null : new Sl(Ke.changes.invert(Ke.startState.doc), wn, void 0, mn || Ke.startState.selection, gl);
    }
    static selection(Ke) {
      return new Sl(void 0, gl, void 0, void 0, Ke);
    }
  }
  const gl = [], jr = /^(input\.type|delete)($|\.)/;
  class Kt {
    constructor(Ke, mn, wn = 0, On) {
      this.done = Ke, this.undone = mn, this.prevTime = wn, this.prevUserEvent = On;
    }
    isolate() {
      return this.prevTime ? new Kt(this.done, this.undone) : this;
    }
    addChanges(Ke, mn, wn, On, An) {
      let mt = this.done, Ot = mt[mt.length - 1];
      return mt = Ot && Ot.changes && !Ot.changes.empty && Ke.changes && (!wn || jr.test(wn)) && (!Ot.selectionsAfter.length && mn - this.prevTime < On.newGroupDelay && On.joinToEvent(An, R(Ot.changes, Ke.changes)) || wn == "input.type.compose") ? _(mt, mt.length - 1, On.minDepth, new Sl(Ke.changes.compose(Ot.changes), L(Ke.effects, Ot.effects), Ot.mapped, Ot.startSelection, gl)) : _(mt, mt.length, On.minDepth, Ke), new Kt(mt, gl, mn, wn);
    }
    addSelection(Ke, mn, wn, On) {
      let An = this.done.length ? this.done[this.done.length - 1].selectionsAfter : gl;
      return 0 < An.length && mn - this.prevTime < On && wn == this.prevUserEvent && wn && /^select($|\.)/.test(wn) && F(An[An.length - 1], Ke) ? this : new Kt(G(this.done, Ke), this.undone, mn, wn);
    }
    addMapping(Ke) {
      return new Kt(J(this.done, Ke), J(this.undone, Ke), this.prevTime, this.prevUserEvent);
    }
    pop(Ke, mn, wn) {
      var On = Ke == 0 ? this.done : this.undone;
      if (On.length == 0) return null;
      var An = On[On.length - 1];
      if (wn && An.selectionsAfter.length) {
        wn = mn.update, An = An.selectionsAfter[An.selectionsAfter.length - 1];
        var mt = St.of;
        let Ot = On[On.length - 1], ll = On.slice();
        return ll[On.length - 1] = Ot.setSelAfter(Ot.selectionsAfter.slice(0, Ot.selectionsAfter.length - 1)), wn.call(mn, { selection: An, annotations: mt.call(St, { side: Ke, rest: ll }), userEvent: Ke == 0 ? "select.undo" : "select.redo", scrollIntoView: !0 });
      }
      return An.changes ? (On = On.length == 1 ? gl : On.slice(0, On.length - 1), An.mapped && (On = J(On, An.mapped)), mn.update({ changes: An.changes, selection: An.startSelection, effects: An.effects, annotations: St.of({ side: Ke, rest: On }), filter: !1, userEvent: Ke == 0 ? "undo" : "redo", scrollIntoView: !0 })) : null;
    }
  }
  Kt.empty = new Kt(gl, gl);
  const nl = [{ key: "Mod-z", run: wi, preventDefault: !0 }, { key: "Mod-y", mac: "Mod-Shift-z", run: bl, preventDefault: !0 }, { linux: "Ctrl-Shift-z", run: bl, preventDefault: !0 }, { key: "Mod-u", run: tl, preventDefault: !0 }, { key: "Alt-u", mac: "Mod-Shift-u", run: Zt, preventDefault: !0 }], Pr = (Oe) => E(Oe, !P(Oe)), ii = (Oe) => E(Oe, P(Oe)), Ar = (Oe) => K(Oe, !P(Oe)), Ml = (Oe) => K(Oe, P(Oe)), Rl = typeof Intl < "u" && Intl.Segmenter ? new Intl.Segmenter(void 0, { granularity: "word" }) : null, Se = (Oe) => $e(Oe, (Ke) => Me(Oe.state, Ke, !P(Oe))), se = (Oe) => $e(Oe, (Ke) => Me(
    Oe.state,
    Ke,
    P(Oe)
  )), Ee = (Oe) => le(Oe, !1), Ge = (Oe) => le(Oe, !0), vn = (Oe) => Ye(Oe, !1), Kn = (Oe) => Ye(Oe, !0), Un = (Oe) => $e(Oe, (Ke) => B(Oe, Ke, !0)), Pe = (Oe) => $e(Oe, (Ke) => B(Oe, Ke, !1)), C = (Oe) => $e(Oe, (Ke) => B(Oe, Ke, !P(Oe))), re = (Oe) => $e(Oe, (Ke) => B(Oe, Ke, P(Oe))), ge = (Oe) => $e(Oe, (Ke) => fn.EditorSelection.cursor(Oe.lineBlockAt(Ke.head).from, 1)), Z = (Oe) => $e(Oe, (Ke) => fn.EditorSelection.cursor(Oe.lineBlockAt(Ke.head).to, -1)), Y = ({ state: Oe, dispatch: Ke }) => q(Oe, Ke, !1), oe = (Oe) => Ae(Oe, !P(Oe)), ke = (Oe) => Ae(Oe, P(Oe)), De = (Oe) => Fe(Oe, !P(Oe)), un = (Oe) => Fe(Oe, P(Oe)), gn = (Oe) => me(Oe, (Ke) => Me(Oe.state, Ke, !P(Oe))), Tn = (Oe) => me(Oe, (Ke) => Me(Oe.state, Ke, P(Oe))), ft = (Oe) => Be(Oe, !1), gt = (Oe) => Be(Oe, !0), Gt = (Oe) => Ze(Oe, !1), zl = (Oe) => Ze(Oe, !0), qe = (Oe) => me(Oe, (Ke) => B(Oe, Ke, !0)), ae = (Oe) => me(Oe, (Ke) => B(Oe, Ke, !1)), Ue = (Oe) => me(Oe, (Ke) => B(Oe, Ke, !P(Oe))), ze = (Oe) => me(Oe, (Ke) => B(Oe, Ke, P(Oe))), dn = (Oe) => me(Oe, (Ke) => fn.EditorSelection.cursor(Oe.lineBlockAt(Ke.head).from)), ut = (Oe) => me(Oe, (Ke) => fn.EditorSelection.cursor(Oe.lineBlockAt(Ke.head).to)), Zn = ({ state: Oe, dispatch: Ke }) => (Ke(xe(Oe, { anchor: 0 })), !0), ht = ({ state: Oe, dispatch: Ke }) => (Ke(xe(Oe, { anchor: Oe.doc.length })), !0), ct = ({ state: Oe, dispatch: Ke }) => (Ke(xe(Oe, { anchor: Oe.selection.main.anchor, head: 0 })), !0), Hl = ({ state: Oe, dispatch: Ke }) => (Ke(xe(Oe, { anchor: Oe.selection.main.anchor, head: Oe.doc.length })), !0), Pl = ({ state: Oe, dispatch: Ke }) => (Ke(Oe.update({ selection: { anchor: 0, head: Oe.doc.length }, userEvent: "select" })), !0), Fn = ({ state: Oe, dispatch: Ke }) => {
    let mn = Nn(Oe).map(({ from: wn, to: On }) => fn.EditorSelection.range(wn, Math.min(On + 1, Oe.doc.length)));
    return Ke(Oe.update({ selection: fn.EditorSelection.create(mn), userEvent: "select" })), !0;
  }, br = ({ state: Oe, dispatch: Ke }) => {
    let mn = ce(Oe.selection, (wn) => {
      for (var On, An = Ve.syntaxTree(Oe).resolveStack(wn.from, 1); An; An = An.next) {
        let { node: mt } = An;
        if ((mt.from < wn.from && mt.to >= wn.to || mt.to > wn.to && mt.from <= wn.from) && (!((On = mt.parent) === null || On === void 0) && On.parent)) return fn.EditorSelection.range(mt.to, mt.from);
      }
      return wn;
    });
    return Ke(xe(Oe, mn)), !0;
  }, Wn = ({ state: Oe, dispatch: Ke }) => {
    let mn = Oe.selection, wn = null;
    return 1 < mn.ranges.length ? wn = fn.EditorSelection.create([mn.main]) : mn.main.empty || (wn = fn.EditorSelection.create([fn.EditorSelection.cursor(mn.main.head)])), wn ? (Ke(xe(Oe, wn)), !0) : !1;
  }, cs = (Oe, Ke) => pn(Oe, (mn) => {
    mn = mn.from;
    var { state: wn } = Oe, On = wn.doc.lineAt(mn), An;
    if (!Ke && mn > On.from && mn < On.from + 200 && !/[^ \t]/.test(An = On.text.slice(0, mn - On.from))) {
      if (An[An.length - 1] == "	") return mn - 1;
      for (wn = fn.countColumn(An, wn.tabSize) % Ve.getIndentUnit(wn) || Ve.getIndentUnit(wn), On = 0; On < wn && An[An.length - 1 - On] == " "; On++) mn--;
      An = mn;
    } else An = fn.findClusterBreak(On.text, mn - On.from, Ke, Ke) + On.from, An == mn && On.number != (Ke ? wn.doc.lines : 1) && (An += Ke ? 1 : -1);
    return An;
  }), Ds = (Oe) => cs(Oe, !1), ac = (Oe) => cs(Oe, !0), Hs = (Oe, Ke) => pn(Oe, (mn) => {
    let wn = mn.head, { state: On } = Oe, An = On.doc.lineAt(wn), mt = On.charCategorizer(wn);
    for (let Ot = null; ; ) {
      if (wn == (Ke ? An.to : An.from)) {
        wn == mn.head && An.number != (Ke ? On.doc.lines : 1) && (wn += Ke ? 1 : -1);
        break;
      }
      let ll = fn.findClusterBreak(An.text, wn - An.from, Ke) + An.from, Nr = An.text.slice(Math.min(wn, ll) - An.from, Math.max(wn, ll) - An.from), hi = mt(Nr);
      if (Ot != null && hi != Ot) break;
      (Nr != " " || wn != mn.head) && (Ot = hi), wn = ll;
    }
    return wn;
  }), vu = (Oe) => Hs(Oe, !1), Ji = (Oe) => Hs(Oe, !0), hs = (Oe) => pn(Oe, (Ke) => {
    let mn = Oe.lineBlockAt(Ke.head).to;
    return Ke.head < mn ? mn : Math.min(Oe.state.doc.length, Ke.head + 1);
  }), li = (Oe) => pn(Oe, (Ke) => {
    let mn = Oe.moveToLineBoundary(Ke, !1).head;
    return Ke.head > mn ? mn : Math.max(0, Ke.head - 1);
  }), cc = (Oe) => pn(Oe, (Ke) => {
    let mn = Oe.moveToLineBoundary(Ke, !0).head;
    return Ke.head < mn ? mn : Math.min(Oe.state.doc.length, Ke.head + 1);
  }), eu = ({ state: Oe, dispatch: Ke }) => {
    if (Oe.readOnly) return !1;
    let mn = Oe.changeByRange((wn) => ({ changes: { from: wn.from, to: wn.to, insert: fn.Text.of(["", ""]) }, range: fn.EditorSelection.cursor(wn.from) }));
    return Ke(Oe.update(mn, { scrollIntoView: !0, userEvent: "input" })), !0;
  }, $a = ({ state: Oe, dispatch: Ke }) => {
    if (Oe.readOnly) return !1;
    let mn = Oe.changeByRange((wn) => {
      if (!wn.empty || wn.from == 0 || wn.from == Oe.doc.length) return { range: wn };
      wn = wn.from;
      var On = Oe.doc.lineAt(wn);
      let An = wn == On.from ? wn - 1 : fn.findClusterBreak(On.text, wn - On.from, !1) + On.from;
      return On = wn == On.to ? wn + 1 : fn.findClusterBreak(On.text, wn - On.from, !0) + On.from, { changes: { from: An, to: On, insert: Oe.doc.slice(wn, On).append(Oe.doc.slice(An, wn)) }, range: fn.EditorSelection.cursor(On) };
    });
    return mn.changes.empty ? !1 : (Ke(Oe.update(mn, { scrollIntoView: !0, userEvent: "move.character" })), !0);
  }, oa = ({ state: Oe, dispatch: Ke }) => at(Oe, Ke, !1), hc = ({ state: Oe, dispatch: Ke }) => at(Oe, Ke, !0), aa = ({ state: Oe, dispatch: Ke }) => Yt(Oe, Ke, !1), Eo = ({ state: Oe, dispatch: Ke }) => Yt(Oe, Ke, !0), be = (Oe) => {
    if (Oe.state.readOnly) return !1;
    let { state: Ke } = Oe, mn = Ke.changes(Nn(Ke).map(({ from: On, to: An }) => (0 < On ? On-- : An < Ke.doc.length && An++, { from: On, to: An }))), wn = ce(Ke.selection, (On) => Oe.moveVertically(On, !0)).map(mn);
    return Oe.dispatch({ changes: mn, selection: wn, scrollIntoView: !0, userEvent: "delete.line" }), !0;
  }, b = jt(!1), w = jt(!0), i = ({ state: Oe, dispatch: Ke }) => {
    if (Oe.readOnly) return !1;
    let mn = /* @__PURE__ */ Object.create(null), wn = new Ve.IndentContext(
      Oe,
      { overrideIndentation: (An) => (An = mn[An], An ?? -1) }
    ), On = Cl(Oe, (An, mt, Ot) => {
      let ll = Ve.getIndentation(wn, An.from);
      if (ll != null) {
        /\S/.test(An.text) || (ll = 0);
        var Nr = /^\s*/.exec(An.text)[0], hi = Ve.indentString(Oe, ll);
        (Nr != hi || Ot.from < An.from + Nr.length) && (mn[An.from] = ll, mt.push({ from: An.from, to: An.from + Nr.length, insert: hi }));
      }
    });
    return On.changes.empty || Ke(Oe.update(On, { userEvent: "indent" })), !0;
  }, x = ({ state: Oe, dispatch: Ke }) => Oe.readOnly ? !1 : (Ke(Oe.update(
    Cl(Oe, (mn, wn) => {
      wn.push({ from: mn.from, insert: Oe.facet(Ve.indentUnit) });
    }),
    { userEvent: "input.indent" }
  )), !0), X = ({ state: Oe, dispatch: Ke }) => Oe.readOnly ? !1 : (Ke(Oe.update(Cl(Oe, (mn, wn) => {
    let On = /^\s*/.exec(mn.text)[0];
    if (On) {
      var An = fn.countColumn(On, Oe.tabSize), mt = 0;
      for (An = Ve.indentString(Oe, Math.max(0, An - Ve.getIndentUnit(Oe))); mt < On.length && mt < An.length && On.charCodeAt(mt) == An.charCodeAt(mt); ) mt++;
      wn.push({ from: mn.from + mt, to: mn.from + On.length, insert: An.slice(mt) });
    }
  }), { userEvent: "delete.dedent" })), !0), He = [{ key: "Ctrl-b", run: Pr, shift: oe, preventDefault: !0 }, {
    key: "Ctrl-f",
    run: ii,
    shift: ke
  }, { key: "Ctrl-p", run: Ee, shift: ft }, { key: "Ctrl-n", run: Ge, shift: gt }, { key: "Ctrl-a", run: ge, shift: dn }, { key: "Ctrl-e", run: Z, shift: ut }, { key: "Ctrl-d", run: ac }, { key: "Ctrl-h", run: Ds }, { key: "Ctrl-k", run: hs }, { key: "Ctrl-Alt-h", run: vu }, { key: "Ctrl-o", run: eu }, { key: "Ctrl-t", run: $a }, { key: "Ctrl-v", run: Kn }], $n = [
    { key: "ArrowLeft", run: Pr, shift: oe, preventDefault: !0 },
    { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: Ar, shift: De, preventDefault: !0 },
    { mac: "Cmd-ArrowLeft", run: C, shift: Ue, preventDefault: !0 },
    {
      key: "ArrowRight",
      run: ii,
      shift: ke,
      preventDefault: !0
    },
    { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: Ml, shift: un, preventDefault: !0 },
    { mac: "Cmd-ArrowRight", run: re, shift: ze, preventDefault: !0 },
    { key: "ArrowUp", run: Ee, shift: ft, preventDefault: !0 },
    { mac: "Cmd-ArrowUp", run: Zn, shift: ct },
    { mac: "Ctrl-ArrowUp", run: vn, shift: Gt },
    { key: "ArrowDown", run: Ge, shift: gt, preventDefault: !0 },
    { mac: "Cmd-ArrowDown", run: ht, shift: Hl },
    { mac: "Ctrl-ArrowDown", run: Kn, shift: zl },
    { key: "PageUp", run: vn, shift: Gt },
    { key: "PageDown", run: Kn, shift: zl },
    { key: "Home", run: Pe, shift: ae, preventDefault: !0 },
    { key: "Mod-Home", run: Zn, shift: ct },
    { key: "End", run: Un, shift: qe, preventDefault: !0 },
    { key: "Mod-End", run: ht, shift: Hl },
    { key: "Enter", run: b },
    { key: "Mod-a", run: Pl },
    { key: "Backspace", run: Ds, shift: Ds },
    { key: "Delete", run: ac },
    { key: "Mod-Backspace", mac: "Alt-Backspace", run: vu },
    { key: "Mod-Delete", mac: "Alt-Delete", run: Ji },
    { mac: "Mod-Backspace", run: li },
    { mac: "Mod-Delete", run: cc }
  ].concat(He.map((Oe) => ({ mac: Oe.key, run: Oe.run, shift: Oe.shift }))), Xt = [{ key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: Se, shift: gn }, {
    key: "Alt-ArrowRight",
    mac: "Ctrl-ArrowRight",
    run: se,
    shift: Tn
  }, { key: "Alt-ArrowUp", run: oa }, { key: "Shift-Alt-ArrowUp", run: aa }, { key: "Alt-ArrowDown", run: hc }, { key: "Shift-Alt-ArrowDown", run: Eo }, { key: "Escape", run: Wn }, { key: "Mod-Enter", run: w }, { key: "Alt-l", mac: "Ctrl-l", run: Fn }, { key: "Mod-i", run: br, preventDefault: !0 }, { key: "Mod-[", run: X }, { key: "Mod-]", run: x }, { key: "Mod-Alt-\\", run: i }, { key: "Shift-Mod-k", run: be }, { key: "Shift-Mod-\\", run: Y }, { key: "Mod-/", run: En }, { key: "Alt-A", run: Nt }].concat($n), $l = { key: "Tab", run: x, shift: X };
  l.blockComment = zt, l.blockUncomment = Pt, l.copyLineDown = Eo, l.copyLineUp = aa, l.cursorCharBackward = (Oe) => E(Oe, !1), l.cursorCharForward = (Oe) => E(Oe, !0), l.cursorCharLeft = Pr, l.cursorCharRight = ii, l.cursorDocEnd = ht, l.cursorDocStart = Zn, l.cursorGroupBackward = (Oe) => K(Oe, !1), l.cursorGroupForward = (Oe) => K(Oe, !0), l.cursorGroupLeft = Ar, l.cursorGroupRight = Ml, l.cursorLineBoundaryBackward = Pe, l.cursorLineBoundaryForward = Un, l.cursorLineBoundaryLeft = C, l.cursorLineBoundaryRight = re, l.cursorLineDown = Ge, l.cursorLineEnd = Z, l.cursorLineStart = ge, l.cursorLineUp = Ee, l.cursorMatchingBracket = Y, l.cursorPageDown = Kn, l.cursorPageUp = vn, l.cursorSubwordBackward = (Oe) => U(Oe, !1), l.cursorSubwordForward = (Oe) => U(Oe, !0), l.cursorSyntaxLeft = Se, l.cursorSyntaxRight = se, l.defaultKeymap = Xt, l.deleteCharBackward = Ds, l.deleteCharForward = ac, l.deleteGroupBackward = vu, l.deleteGroupForward = Ji, l.deleteLine = be, l.deleteLineBoundaryBackward = li, l.deleteLineBoundaryForward = cc, l.deleteToLineEnd = hs, l.deleteToLineStart = (Oe) => pn(Oe, (Ke) => {
    let mn = Oe.lineBlockAt(Ke.head).from;
    return Ke.head > mn ? mn : Math.max(0, Ke.head - 1);
  }), l.deleteTrailingWhitespace = ({ state: Oe, dispatch: Ke }) => {
    if (Oe.readOnly) return !1;
    let mn = [];
    for (let wn = 0, On = "", An = Oe.doc.iter(); ; ) {
      if (An.next(), An.lineBreak || An.done) {
        let mt = On.search(/\s+$/);
        if (-1 < mt && mn.push({ from: wn - (On.length - mt), to: wn }), An.done) break;
        On = "";
      } else On = An.value;
      wn += An.value.length;
    }
    return mn.length ? (Ke(Oe.update({ changes: mn, userEvent: "delete" })), !0) : !1;
  }, l.emacsStyleKeymap = He, l.history = function(Oe = {}) {
    return [ql, Rr.of(Oe), _e.EditorView.domEventHandlers({ beforeinput(Ke, mn) {
      let wn = Ke.inputType == "historyUndo" ? wi : Ke.inputType == "historyRedo" ? bl : null;
      return wn ? (Ke.preventDefault(), wn(mn)) : !1;
    } })];
  }, l.historyField = Mr, l.historyKeymap = nl, l.indentLess = X, l.indentMore = x, l.indentSelection = i, l.indentWithTab = $l, l.insertBlankLine = w, l.insertNewline = ({ state: Oe, dispatch: Ke }) => (Ke(Oe.update(Oe.replaceSelection(Oe.lineBreak), { scrollIntoView: !0, userEvent: "input" })), !0), l.insertNewlineAndIndent = b, l.insertTab = ({ state: Oe, dispatch: Ke }) => Oe.selection.ranges.some((mn) => !mn.empty) ? x({ state: Oe, dispatch: Ke }) : (Ke(Oe.update(Oe.replaceSelection("	"), {
    scrollIntoView: !0,
    userEvent: "input"
  })), !0), l.invertedEffects = ul, l.isolateHistory = pr, l.lineComment = Vn, l.lineUncomment = ot, l.moveLineDown = hc, l.moveLineUp = oa, l.redo = bl, l.redoDepth = jl, l.redoSelection = Zt, l.selectAll = Pl, l.selectCharBackward = (Oe) => Ae(Oe, !1), l.selectCharForward = (Oe) => Ae(Oe, !0), l.selectCharLeft = oe, l.selectCharRight = ke, l.selectDocEnd = Hl, l.selectDocStart = ct, l.selectGroupBackward = (Oe) => Fe(Oe, !1), l.selectGroupForward = (Oe) => Fe(Oe, !0), l.selectGroupLeft = De, l.selectGroupRight = un, l.selectLine = Fn, l.selectLineBoundaryBackward = ae, l.selectLineBoundaryForward = qe, l.selectLineBoundaryLeft = Ue, l.selectLineBoundaryRight = ze, l.selectLineDown = gt, l.selectLineEnd = ut, l.selectLineStart = dn, l.selectLineUp = ft, l.selectMatchingBracket = ({ state: Oe, dispatch: Ke }) => q(Oe, Ke, !0), l.selectPageDown = zl, l.selectPageUp = Gt, l.selectParentSyntax = br, l.selectSubwordBackward = (Oe) => ln(Oe, !1), l.selectSubwordForward = (Oe) => ln(Oe, !0), l.selectSyntaxLeft = gn, l.selectSyntaxRight = Tn, l.simplifySelection = Wn, l.splitLine = eu, l.standardKeymap = $n, l.toggleBlockComment = Nt, l.toggleBlockCommentByLine = ol, l.toggleComment = En, l.toggleLineComment = Qn, l.transposeChars = $a, l.undo = wi, l.undoDepth = Ql, l.undoSelection = tl;
};
Xo[8] = function(e, n, t, l) {
  function r(Z) {
    Z = Object.keys(Z).join("");
    let Y = /\w/.test(Z);
    return Y && (Z = Z.replace(/\w/g, "")), `[${Y ? "\\w" : ""}${Z.replace(/[^\w\s]/g, "\\$&")}]`;
  }
  function u(Z) {
    var Y = /* @__PURE__ */ Object.create(null);
    let oe = /* @__PURE__ */ Object.create(null);
    for (let { label: ke } of Z) for (Y[ke[0]] = !0, Z = 1; Z < ke.length; Z++) oe[ke[Z]] = !0;
    return Y = r(Y) + r(oe) + "*$", [new RegExp("^" + Y), new RegExp(Y)];
  }
  function o(Z) {
    let Y = Z.map((De) => typeof De == "string" ? { label: De } : De), [oe, ke] = Y.every((De) => /^\w+$/.test(De.label)) ? [/\w*$/, /\w+$/] : u(Y);
    return (De) => {
      let un = De.matchBefore(ke);
      return un || De.explicit ? { from: un ? un.from : De.pos, options: Y, validFor: oe } : null;
    };
  }
  function a(Z) {
    return Z.selection.main.from;
  }
  function h(Z, Y) {
    var oe;
    let { source: ke } = Z;
    Y = Y && ke[0] != "^";
    let De = ke[ke.length - 1] != "$";
    return Y || De ? new RegExp(`${Y ? "^" : ""}(?:${ke})${De ? "$" : ""}`, (oe = Z.flags) !== null && oe !== void 0 ? oe : Z.ignoreCase ? "i" : "") : Z;
  }
  function s(Z, Y, oe, ke) {
    let { main: De } = Z.selection, un = oe - De.from, gn = ke - De.from;
    return Object.assign(Object.assign({}, Z.changeByRange((Tn) => Tn != De && oe != ke && Z.sliceDoc(Tn.from + un, Tn.from + gn) != Z.sliceDoc(oe, ke) ? { range: Tn } : { changes: { from: Tn.from + un, to: ke == De.from ? Tn.to : Tn.from + gn, insert: Y }, range: Ze.EditorSelection.cursor(Tn.from + un + Y.length) })), { scrollIntoView: !0, userEvent: "input.complete" });
  }
  function d(Z) {
    if (!Array.isArray(Z)) return Z;
    let Y = jt.get(Z);
    return Y || jt.set(Z, Y = o(Z)), Y;
  }
  function p(Z, Y) {
    return Z ? Y ? Z + " " + Y : Z : Y;
  }
  function _(Z, Y, oe, ke, De, un) {
    let gn = Z = Z.textDirection == pn.Direction.RTL, Tn = !1, ft = "top";
    var gt = Y.left - De.left;
    let Gt = De.right - Y.right, zl = ke.right - ke.left;
    return ke = ke.bottom - ke.top, gn && gt < Math.min(
      zl,
      Gt
    ) ? gn = !1 : !gn && Gt < Math.min(zl, gt) && (gn = !0), zl <= (gn ? gt : Gt) ? (oe = Math.max(De.top, Math.min(oe.top, De.bottom - ke)) - Y.top, gt = Math.min(400, gn ? gt : Gt)) : (Tn = !0, gt = Math.min(400, (Z ? Y.right : De.right - Y.left) - 30), De = De.bottom - Y.bottom, De >= ke || De > Y.top ? oe = oe.bottom - Y.top : (ft = "bottom", oe = Y.bottom - oe.top)), { style: `${ft}: ${oe / ((Y.bottom - Y.top) / un.offsetHeight)}px; max-width: ${gt / ((Y.right - Y.left) / un.offsetWidth)}px`, class: "cm-completionInfo-" + (Tn ? Z ? "left-narrow" : "right-narrow" : gn ? "left" : "right") };
  }
  function R(Z) {
    let Y = Z.addToOptions.slice();
    return Z.icons && Y.push({ render(oe) {
      let ke = document.createElement("div");
      return ke.classList.add("cm-completionIcon"), oe.type && ke.classList.add(...oe.type.split(/\s+/g).map((De) => "cm-completionIcon-" + De)), ke.setAttribute("aria-hidden", "true"), ke;
    }, position: 20 }), Y.push({ render(oe, ke, De) {
      ke = document.createElement("span"), ke.className = "cm-completionLabel", oe = oe.displayLabel || oe.label;
      var un = 0;
      for (let gn = 0; gn < De.length; ) {
        let Tn = De[gn++], ft = De[gn++];
        Tn > un && ke.appendChild(document.createTextNode(oe.slice(un, Tn))), un = ke.appendChild(document.createElement("span")), un.appendChild(document.createTextNode(oe.slice(Tn, ft))), un.className = "cm-completionMatchedText", un = ft;
      }
      return un < oe.length && ke.appendChild(document.createTextNode(oe.slice(un))), ke;
    }, position: 50 }, { render(oe) {
      if (!oe.detail) return null;
      let ke = document.createElement("span");
      return ke.className = "cm-completionDetail", ke.textContent = oe.detail, ke;
    }, position: 80 }), Y.sort((oe, ke) => oe.position - ke.position).map((oe) => oe.render);
  }
  function F(Z, Y, oe) {
    return Z <= oe ? { from: 0, to: Z } : (0 > Y && (Y = 0), Y <= Z >> 1 ? (Z = Math.floor(Y / oe), { from: Z * oe, to: (Z + 1) * oe }) : (Y = Math.floor((Z - Y) / oe), { from: Z - (Y + 1) * oe, to: Z - Y * oe }));
  }
  function L(Z) {
    return 100 * (Z.boost || 0) + (Z.apply ? 10 : 0) + (Z.info ? 5 : 0) + (Z.type ? 1 : 0);
  }
  function G(Z, Y) {
    let oe = [], ke = null;
    var De = (Gt) => {
      if (oe.push(Gt), { section: Gt } = Gt.completion, Gt) {
        ke ||= [];
        let zl = typeof Gt == "string" ? Gt : Gt.name;
        ke.some((qe) => qe.name == zl) || ke.push(typeof Gt == "string" ? { name: zl } : Gt);
      }
    };
    for (var un of Z) if (un.hasResult()) if (Z = un.result.getMatch, un.result.filter === !1) for (var gn of un.result.options) De(new at(gn, un.source, Z ? Z(gn) : [], 1e9 - oe.length));
    else {
      let Gt = new _e(Y.sliceDoc(un.from, un.to));
      for (let zl of un.result.options) if (Gt.match(zl.label)) {
        let qe = zl.displayLabel ? Z ? Z(zl, Gt.matched) : [] : Gt.matched;
        De(new at(zl, un.source, qe, Gt.score + (zl.boost || 0)));
      }
    }
    if (ke) {
      De = /* @__PURE__ */ Object.create(null), un = 0, gn = (Gt, zl) => {
        var qe, ae;
        return ((qe = Gt.rank) !== null && qe !== void 0 ? qe : 1e9) - ((ae = zl.rank) !== null && ae !== void 0 ? ae : 1e9) || (Gt.name < zl.name ? -1 : 1);
      };
      for (var Tn of ke.sort(gn)) un -= 1e5, De[Tn.name] = un;
      for (var ft of oe) ({ section: Tn } = ft.completion), Tn && (ft.score += De[typeof Tn == "string" ? Tn : Tn.name]);
    }
    ft = [], Tn = null;
    let gt = Y.facet(Ve).compareCompletions;
    for (let Gt of oe.sort((zl, qe) => qe.score - zl.score || gt(zl.completion, qe.completion))) Y = Gt.completion, !Tn || Tn.label != Y.label || Tn.detail != Y.detail || Tn.type != null && Y.type != null && Tn.type != Y.type || Tn.apply != Y.apply || Tn.boost != Y.boost ? ft.push(Gt) : L(Gt.completion) > L(Tn) && (ft[ft.length - 1] = Gt), Tn = Gt.completion;
    return ft;
  }
  function J(Z, Y) {
    if (Z == Y) return !0;
    for (let oe = 0, ke = 0; ; ) {
      for (; oe < Z.length && !Z[oe].hasResult; ) oe++;
      for (; ke < Y.length && !Y[ke].hasResult; ) ke++;
      let De = oe == Z.length, un = ke == Y.length;
      if (De || un) return De == un;
      if (Z[oe++].result != Y[ke++].result) return !1;
    }
  }
  function we(Z, Y) {
    let oe = { "aria-autocomplete": "list", "aria-haspopup": "listbox", "aria-controls": Z };
    return -1 < Y && (oe["aria-activedescendant"] = Z + "-" + Y), oe;
  }
  function ce(Z) {
    return Z.isUserEvent("input.type") ? "input" : Z.isUserEvent("delete.backward") ? "delete" : null;
  }
  function xe(Z, Y) {
    const oe = Y.completion.apply || Y.completion.label;
    let ke = Z.state.field(St).active.find((De) => De.source == Y.source);
    return ke instanceof zt ? (typeof oe == "string" ? Z.dispatch(Object.assign(Object.assign({}, s(Z.state, oe, ke.from, ke.to)), { annotations: Yt.of(Y.completion) })) : oe(Z, Y.completion, ke.from, ke.to), !0) : !1;
  }
  function $e(Z, Y = "option") {
    return (oe) => {
      var ke = oe.state.field(St, !1);
      if (!ke || !ke.open || ke.open.disabled || Date.now() - ke.open.timestamp < oe.state.facet(Ve).interactionDelay) return !1;
      let De = 1;
      var un;
      return Y == "page" && (un = pn.getTooltip(oe, ke.open.tooltip)) && (De = Math.max(2, Math.floor(un.dom.offsetHeight / un.dom.querySelector("li").offsetHeight) - 1)), { length: un } = ke.open.options, ke = -1 < ke.open.selected ? ke.open.selected + De * (Z ? 1 : -1) : Z ? 0 : un - 1, 0 > ke ? ke = Y == "page" ? 0 : un - 1 : ke >= un && (ke = Y == "page" ? un - 1 : 0), oe.dispatch({ effects: ol.of(ke) }), !0;
    };
  }
  function je(Z, Y) {
    return Ze.EditorSelection.create(Z.filter((oe) => oe.field == Y).map((oe) => Ze.EditorSelection.range(oe.from, oe.to)));
  }
  function E(Z) {
    let Y = bl.parse(Z);
    return (oe, ke, De, un) => {
      let { text: gn, ranges: Tn } = Y.instantiate(oe.state, De);
      ke = { changes: { from: De, to: un, insert: Ze.Text.of(gn) }, scrollIntoView: !0, annotations: ke ? Yt.of(ke) : void 0 }, Tn.length && (ke.selection = je(Tn, 0)), 1 < Tn.length && (De = new Ql(Tn, 0), De = ke.effects = [jl.of(De)], oe.state.field(gl, !1) === void 0 && De.push(Ze.StateEffect.appendConfig.of([gl, Ar, Ml, ql]))), oe.dispatch(oe.state.update(ke));
    };
  }
  function P(Z) {
    return ({ state: Y, dispatch: oe }) => {
      let ke = Y.field(gl, !1);
      if (!ke || 0 > Z && ke.active == 0) return !1;
      let De = ke.active + Z, un = 0 < Z && !ke.ranges.some((gn) => gn.field == De + Z);
      return oe(Y.update({ selection: je(ke.ranges, De), effects: jl.of(un ? null : new Ql(ke.ranges, De)), scrollIntoView: !0 })), !0;
    };
  }
  function K(Z) {
    Z = Z.replace(/[\]\-\\]/g, "\\$&");
    try {
      return new RegExp(
        `[\\p{Alphabetic}\\p{Number}_${Z}]+`,
        "ug"
      );
    } catch {
      return new RegExp(`[w${Z}]`, "g");
    }
  }
  function H(Z, Y) {
    return new RegExp(Y(Z.source), Z.unicode ? "u" : "");
  }
  function U(Z, Y, oe, ke, De) {
    for (let un = Z.iterLines(), gn = 0; !un.next().done; ) {
      ({ value: Z } = un);
      let Tn;
      for (Y.lastIndex = 0; Tn = Y.exec(Z); ) if (!ke[Tn[0]] && gn + Tn.index != De && (oe.push({ type: "text", label: Tn[0] }), ke[Tn[0]] = !0, 2e3 <= oe.length)) return;
      gn += Z.length + 1;
    }
  }
  function Me(Z, Y, oe, ke, De) {
    let un = 1e3 <= Z.length;
    var gn = un && Y.get(Z);
    if (gn) return gn;
    gn = [];
    let Tn = /* @__PURE__ */ Object.create(null);
    if (Z.children) {
      let ft = 0;
      for (let gt of Z.children) {
        if (1e3 <= gt.length) for (let Gt of Me(gt, Y, oe, ke - ft, De - ft)) Tn[Gt.label] || (Tn[Gt.label] = !0, gn.push(Gt));
        else U(gt, oe, gn, Tn, De - ft);
        ft += gt.length + 1;
      }
    } else U(Z, oe, gn, Tn, De);
    return un && 2e3 > gn.length && Y.set(Z, gn), gn;
  }
  function le(Z) {
    for (let Y = 0; 8 > Y; Y += 2) if ("()[]{}<>".charCodeAt(Y) == Z) return "()[]{}<>".charAt(Y + 1);
    return Ze.fromCodePoint(128 > Z ? Z : Z + 1);
  }
  function Ce(Z, Y) {
    let oe = Z.languageDataAt("closeBrackets", Z.selection.main.head)[0] || Se, ke = oe.brackets || Se.brackets;
    for (let De of ke) {
      let un = le(Ze.codePointAt(De, 0));
      if (Y == De) return un == De ? Ae(Z, De, -1 < ke.indexOf(De + De + De), oe) : q(Z, De, un, oe.before || Se.before);
      if (Y == un && Ye(Z, Z.selection.main.from)) return me(Z, De, un);
    }
    return null;
  }
  function Ye(Z, Y) {
    let oe = !1;
    return Z.field(Ge).between(0, Z.doc.length, (ke) => {
      ke == Y && (oe = !0);
    }), oe;
  }
  function B(Z, Y) {
    return Z = Z.sliceString(Y, Y + 2), Z.slice(0, Ze.codePointSize(Ze.codePointAt(Z, 0)));
  }
  function q(Z, Y, oe, ke) {
    let De = null, un = Z.changeByRange((gn) => {
      if (!gn.empty) return { changes: [{ insert: Y, from: gn.from }, { insert: oe, from: gn.to }], effects: se.of(gn.to + Y.length), range: Ze.EditorSelection.range(gn.anchor + Y.length, gn.head + Y.length) };
      let Tn = B(Z.doc, gn.head);
      return !Tn || /\s/.test(Tn) || -1 < ke.indexOf(Tn) ? { changes: { insert: Y + oe, from: gn.head }, effects: se.of(gn.head + Y.length), range: Ze.EditorSelection.cursor(gn.head + Y.length) } : { range: De = gn };
    });
    return De ? null : Z.update(un, { scrollIntoView: !0, userEvent: "input.type" });
  }
  function me(Z, Y, oe) {
    let ke = null;
    return Y = Z.changeByRange((De) => De.empty && B(Z.doc, De.head) == oe ? { changes: { from: De.head, to: De.head + oe.length, insert: oe }, range: Ze.EditorSelection.cursor(De.head + oe.length) } : ke = { range: De }), ke ? null : Z.update(Y, { scrollIntoView: !0, userEvent: "input.type" });
  }
  function Ae(Z, Y, oe, ke) {
    let De = ke.stringPrefixes || Se.stringPrefixes, un = null;
    return ke = Z.changeByRange((gn) => {
      if (!gn.empty) return { changes: [{ insert: Y, from: gn.from }, { insert: Y, from: gn.to }], effects: se.of(gn.to + Y.length), range: Ze.EditorSelection.range(gn.anchor + Y.length, gn.head + Y.length) };
      let Tn = gn.head, ft = B(Z.doc, Tn), gt;
      if (ft == Y) {
        if (Fe(Z, Tn)) return { changes: { insert: Y + Y, from: Tn }, effects: se.of(Tn + Y.length), range: Ze.EditorSelection.cursor(Tn + Y.length) };
        if (Ye(Z, Tn)) return gn = oe && Z.sliceDoc(Tn, Tn + 3 * Y.length) == Y + Y + Y ? Y + Y + Y : Y, { changes: { from: Tn, to: Tn + gn.length, insert: gn }, range: Ze.EditorSelection.cursor(Tn + gn.length) };
      } else {
        if (oe && Z.sliceDoc(Tn - 2 * Y.length, Tn) == Y + Y && -1 < (gt = Be(Z, Tn - 2 * Y.length, De)) && Fe(Z, gt)) return { changes: { insert: Y + Y + Y + Y, from: Tn }, effects: se.of(Tn + Y.length), range: Ze.EditorSelection.cursor(Tn + Y.length) };
        if (Z.charCategorizer(Tn)(ft) != Ze.CharCategory.Word && -1 < Be(Z, Tn, De) && !ln(Z, Tn, Y, De)) return { changes: { insert: Y + Y, from: Tn }, effects: se.of(Tn + Y.length), range: Ze.EditorSelection.cursor(Tn + Y.length) };
      }
      return { range: un = gn };
    }), un ? null : Z.update(ke, { scrollIntoView: !0, userEvent: "input.type" });
  }
  function Fe(Z, Y) {
    return Z = xn.syntaxTree(Z).resolveInner(Y + 1), Z.parent && Z.from == Y;
  }
  function ln(Z, Y, oe, ke) {
    var De = xn.syntaxTree(Z).resolveInner(Y, -1);
    let un = ke.reduce((gn, Tn) => Math.max(gn, Tn.length), 0);
    for (let gn = 0; 5 > gn; gn++) {
      let Tn = Z.sliceDoc(De.from, Math.min(De.to, De.from + oe.length + un)), ft = Tn.indexOf(oe);
      if (!ft || -1 < ft && -1 < ke.indexOf(Tn.slice(0, ft))) {
        for (Y = De.firstChild; Y && Y.from == De.from && Y.to - Y.from > oe.length + ft; ) {
          if (Z.sliceDoc(Y.to - oe.length, Y.to) == oe) return !1;
          Y = Y.firstChild;
        }
        return !0;
      }
      if (De = De.to == Y && De.parent, !De) break;
    }
    return !1;
  }
  function Be(Z, Y, oe) {
    let ke = Z.charCategorizer(Y);
    if (ke(Z.sliceDoc(Y - 1, Y)) != Ze.CharCategory.Word) return Y;
    for (let De of oe) if (oe = Y - De.length, Z.sliceDoc(oe, Y) == De && ke(Z.sliceDoc(oe - 1, oe)) != Ze.CharCategory.Word) return oe;
    return -1;
  }
  var Ze = n(0), pn = n(3), xn = n(6);
  class Nn {
    constructor(Y, oe, ke) {
      this.state = Y, this.pos = oe, this.explicit = ke, this.abortListeners = [];
    }
    tokenBefore(Y) {
      let oe = xn.syntaxTree(this.state).resolveInner(this.pos, -1);
      for (; oe && 0 > Y.indexOf(oe.name); ) oe = oe.parent;
      return oe ? { from: oe.from, to: this.pos, text: this.state.sliceDoc(oe.from, this.pos), type: oe.type } : null;
    }
    matchBefore(Y) {
      var oe = this.state.doc.lineAt(this.pos);
      let ke = Math.max(oe.from, this.pos - 250);
      return oe = oe.text.slice(ke - oe.from, this.pos - oe.from), Y = oe.search(h(Y, !1)), 0 > Y ? null : { from: ke + Y, to: this.pos, text: oe.slice(Y) };
    }
    get aborted() {
      return this.abortListeners == null;
    }
    addEventListener(Y, oe) {
      Y == "abort" && this.abortListeners && this.abortListeners.push(oe);
    }
  }
  class at {
    constructor(Y, oe, ke, De) {
      this.completion = Y, this.source = oe, this.match = ke, this.score = De;
    }
  }
  const Yt = Ze.Annotation.define(), jt = /* @__PURE__ */ new WeakMap(), Cl = Ze.StateEffect.define(), fn = Ze.StateEffect.define();
  class _e {
    constructor(Y) {
      this.pattern = Y, this.chars = [], this.folded = [], this.any = [], this.precise = [], this.byWord = [], this.score = 0, this.matched = [];
      for (let ke = 0; ke < Y.length; ) {
        var oe = Ze.codePointAt(Y, ke);
        let De = Ze.codePointSize(oe);
        this.chars.push(oe), oe = Y.slice(ke, ke + De);
        let un = oe.toUpperCase();
        this.folded.push(Ze.codePointAt(un == oe ? oe.toLowerCase() : un, 0)), ke += De;
      }
      this.astral = Y.length != this.chars.length;
    }
    ret(Y, oe) {
      return this.score = Y, this.matched = oe, !0;
    }
    match(Y) {
      if (this.pattern.length == 0) return this.ret(-100, []);
      if (Y.length < this.pattern.length) return !1;
      let { chars: oe, folded: ke, any: De, precise: un, byWord: gn } = this;
      if (oe.length == 1) {
        var Tn = Ze.codePointAt(Y, 0), ft = Ze.codePointSize(Tn);
        if (Y = ft == Y.length ? 0 : -100, Tn != oe[0]) if (Tn == ke[0]) Y += -200;
        else return !1;
        return this.ret(Y, [0, ft]);
      }
      if (Tn = Y.indexOf(this.pattern), Tn == 0) return this.ret(Y.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
      ft = oe.length;
      var gt = 0;
      if (0 > Tn) {
        for (let ut = 0, Zn = Math.min(Y.length, 200); ut < Zn && gt < ft; ) {
          var Gt = Ze.codePointAt(Y, ut);
          (Gt == oe[gt] || Gt == ke[gt]) && (De[gt++] = ut), ut += Ze.codePointSize(Gt);
        }
        if (gt < ft) return !1;
      }
      Gt = gt = 0;
      let zl = !1, qe = 0, ae = -1, Ue = -1, ze = /[a-z]/.test(Y), dn = !0;
      for (let ut = 0, Zn = Math.min(Y.length, 200), ht = 0; ut < Zn && Gt < ft; ) {
        let ct = Ze.codePointAt(Y, ut);
        0 > Tn && (gt < ft && ct == oe[gt] && (un[gt++] = ut), qe < ft && (ct == oe[qe] || ct == ke[qe] ? (qe == 0 && (ae = ut), Ue = ut + 1, qe++) : qe = 0));
        let Hl, Pl = 255 > ct ? 48 <= ct && 57 >= ct || 97 <= ct && 122 >= ct ? 2 : 65 <= ct && 90 >= ct ? 1 : 0 : (Hl = Ze.fromCodePoint(ct)) != Hl.toLowerCase() ? 1 : Hl != Hl.toUpperCase() ? 2 : 0;
        (!ut || Pl == 1 && ze || ht == 0 && Pl != 0) && (oe[Gt] == ct || ke[Gt] == ct && (zl = !0) ? gn[Gt++] = ut : gn.length && (dn = !1)), ht = Pl, ut += Ze.codePointSize(ct);
      }
      return Gt == ft && gn[0] == 0 && dn ? this.result(-100 + (zl ? -200 : 0), gn, Y) : qe == ft && ae == 0 ? this.ret(-200 - Y.length + (Ue == Y.length ? 0 : -100), [0, Ue]) : -1 < Tn ? this.ret(-700 - Y.length, [Tn, Tn + this.pattern.length]) : qe == ft ? this.ret(-900 - Y.length, [ae, Ue]) : Gt == ft ? this.result((zl ? -200 : 0) + -800 + (dn ? 0 : -1100), gn, Y) : oe.length == 2 ? !1 : this.result((De[0] ? -700 : 0) + -1300, De, Y);
    }
    result(Y, oe, ke) {
      let De = [], un = 0;
      for (let gn of oe) oe = gn + (this.astral ? Ze.codePointSize(Ze.codePointAt(ke, gn)) : 1), un && De[un - 1] == gn ? De[un - 1] = oe : (De[un++] = gn, De[un++] = oe);
      return this.ret(Y - ke.length, De);
    }
  }
  const Ve = Ze.Facet.define({ combine(Z) {
    return Ze.combineConfig(
      Z,
      { activateOnTyping: !0, selectOnOpen: !0, override: null, closeOnBlur: !0, maxRenderedOptions: 100, defaultKeymap: !0, tooltipClass: () => "", optionClass: () => "", aboveCursor: !1, icons: !0, addToOptions: [], positionInfo: _, compareCompletions: (Y, oe) => Y.label.localeCompare(oe.label), interactionDelay: 75, updateSyncTime: 100 },
      { defaultKeymap: (Y, oe) => Y && oe, closeOnBlur: (Y, oe) => Y && oe, icons: (Y, oe) => Y && oe, tooltipClass: (Y, oe) => (ke) => p(Y(ke), oe(ke)), optionClass: (Y, oe) => (ke) => p(Y(ke), oe(ke)), addToOptions: (Y, oe) => Y.concat(oe) }
    );
  } });
  class an {
    constructor(Y, oe, ke) {
      this.view = Y, this.stateField = oe, this.applyCompletion = ke, this.infoDestroy = this.info = null, this.placeInfoReq = { read: () => this.measureInfo(), write: (Tn) => this.placeInfo(Tn), key: this }, this.space = null, this.currentClass = "", ke = Y.state.field(oe);
      let { options: De, selected: un } = ke.open, gn = Y.state.facet(Ve);
      this.optionContent = R(gn), this.optionClass = gn.optionClass, this.tooltipClass = gn.tooltipClass, this.range = F(De.length, un, gn.maxRenderedOptions), this.dom = document.createElement("div"), this.dom.className = "cm-tooltip-autocomplete", this.updateTooltipClass(Y.state), this.dom.addEventListener("mousedown", (Tn) => {
        let { options: ft } = Y.state.field(oe).open;
        for (let gt = Tn.target, Gt; gt && gt != this.dom; gt = gt.parentNode) if (gt.nodeName == "LI" && (Gt = /-(\d+)$/.exec(gt.id)) && +Gt[1] < ft.length) {
          this.applyCompletion(Y, ft[+Gt[1]]), Tn.preventDefault();
          break;
        }
      }), this.dom.addEventListener("focusout", (Tn) => {
        let ft = Y.state.field(this.stateField, !1);
        ft && ft.tooltip && Y.state.facet(Ve).closeOnBlur && Tn.relatedTarget != Y.contentDOM && Y.dispatch({ effects: fn.of(null) });
      }), this.showOptions(De, ke.id);
    }
    mount() {
      this.updateSel();
    }
    showOptions(Y, oe) {
      this.list && this.list.remove(), this.list = this.dom.appendChild(this.createListBox(Y, oe, this.range)), this.list.addEventListener("scroll", () => {
        this.info && this.view.requestMeasure(this.placeInfoReq);
      });
    }
    update(Y) {
      var oe;
      let ke = Y.state.field(this.stateField), De = Y.startState.field(this.stateField);
      if (this.updateTooltipClass(Y.state), ke != De) {
        let { options: un, selected: gn, disabled: Tn } = ke.open;
        De.open && De.open.options == un || (this.range = F(un.length, gn, Y.state.facet(Ve).maxRenderedOptions), this.showOptions(un, ke.id)), this.updateSel(), Tn != ((oe = De.open) === null || oe === void 0 ? void 0 : oe.disabled) && this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!Tn);
      }
    }
    updateTooltipClass(Y) {
      if (Y = this.tooltipClass(Y), Y != this.currentClass) {
        for (let oe of this.currentClass.split(" ")) oe && this.dom.classList.remove(oe);
        for (let oe of Y.split(" ")) oe && this.dom.classList.add(oe);
        this.currentClass = Y;
      }
    }
    positioned(Y) {
      this.space = Y, this.info && this.view.requestMeasure(this.placeInfoReq);
    }
    updateSel() {
      let Y = this.view.state.field(this.stateField);
      var oe = Y.open;
      if ((-1 < oe.selected && oe.selected < this.range.from || oe.selected >= this.range.to) && (this.range = F(oe.options.length, oe.selected, this.view.state.facet(Ve).maxRenderedOptions), this.showOptions(oe.options, Y.id)), this.updateSelectedOption(oe.selected)) {
        this.destroyInfo();
        let { completion: ke } = oe.options[oe.selected];
        ({ info: oe } = ke), oe && (oe = typeof oe == "string" ? document.createTextNode(oe) : oe(ke)) && ("then" in oe ? oe.then((De) => {
          De && this.view.state.field(this.stateField, !1) == Y && this.addInfoPane(De, ke);
        }).catch((De) => pn.logException(this.view.state, De, "completion info")) : this.addInfoPane(oe, ke));
      }
    }
    addInfoPane(Y, oe) {
      if (this.destroyInfo(), oe = this.info = document.createElement("div"), oe.className = "cm-tooltip cm-completionInfo", Y.nodeType != null) oe.appendChild(Y), this.infoDestroy = null;
      else {
        let { dom: ke, destroy: De } = Y;
        oe.appendChild(ke), this.infoDestroy = De || null;
      }
      this.dom.appendChild(oe), this.view.requestMeasure(this.placeInfoReq);
    }
    updateSelectedOption(Y) {
      let oe = null;
      for (let De = this.list.firstChild, un = this.range.from; De; De = De.nextSibling, un++) De.nodeName == "LI" && De.id ? un == Y ? De.hasAttribute("aria-selected") || (De.setAttribute("aria-selected", "true"), oe = De) : De.hasAttribute("aria-selected") && De.removeAttribute("aria-selected") : un--;
      if (oe) {
        Y = this.list;
        var ke = oe;
        let De = Y.getBoundingClientRect();
        ke = ke.getBoundingClientRect();
        let un = De.height / Y.offsetHeight;
        ke.top < De.top ? Y.scrollTop -= (De.top - ke.top) / un : ke.bottom > De.bottom && (Y.scrollTop += (ke.bottom - De.bottom) / un);
      }
      return oe;
    }
    measureInfo() {
      var Y = this.dom.querySelector("[aria-selected]");
      if (!Y || !this.info) return null;
      let oe = this.dom.getBoundingClientRect(), ke = this.info.getBoundingClientRect();
      Y = Y.getBoundingClientRect();
      var De = this.space;
      return De || (De = this.dom.ownerDocument.defaultView || window, De = { left: 0, top: 0, right: De.innerWidth, bottom: De.innerHeight }), Y.top > Math.min(De.bottom, oe.bottom) - 10 || Y.bottom < Math.max(De.top, oe.top) + 10 ? null : this.view.state.facet(Ve).positionInfo(
        this.view,
        oe,
        Y,
        ke,
        De,
        this.dom
      );
    }
    placeInfo(Y) {
      this.info && (Y ? (Y.style && (this.info.style.cssText = Y.style), this.info.className = "cm-tooltip cm-completionInfo " + (Y.class || "")) : this.info.style.cssText = "top: -1e6px");
    }
    createListBox(Y, oe, ke) {
      const De = document.createElement("ul");
      De.id = oe, De.setAttribute("role", "listbox"), De.setAttribute("aria-expanded", "true"), De.setAttribute("aria-label", this.view.state.phrase("Completions"));
      let un = null;
      for (let ft = ke.from; ft < ke.to; ft++) {
        let { completion: gt, match: Gt } = Y[ft];
        var { section: gn } = gt;
        if (gn) {
          var Tn = typeof gn == "string" ? gn : gn.name;
          Tn != un && (ft > ke.from || ke.from == 0) && (un = Tn, typeof gn != "string" && gn.header ? De.appendChild(gn.header(gn)) : De.appendChild(document.createElement("completion-section")).textContent = Tn);
        }
        gn = De.appendChild(document.createElement("li")), gn.id = oe + "-" + ft, gn.setAttribute("role", "option"), (Tn = this.optionClass(gt)) && (gn.className = Tn);
        for (let zl of this.optionContent) (Tn = zl(gt, this.view.state, Gt)) && gn.appendChild(Tn);
      }
      return ke.from && De.classList.add("cm-completionListIncompleteTop"), ke.to < Y.length && De.classList.add("cm-completionListIncompleteBottom"), De;
    }
    destroyInfo() {
      this.info && (this.infoDestroy && this.infoDestroy(), this.info.remove(), this.info = null);
    }
    destroy() {
      this.destroyInfo();
    }
  }
  class En {
    constructor(Y, oe, ke, De, un, gn) {
      this.options = Y, this.attrs = oe, this.tooltip = ke, this.timestamp = De, this.selected = un, this.disabled = gn;
    }
    setSelected(Y, oe) {
      return Y == this.selected || Y >= this.options.length ? this : new En(this.options, we(oe, Y), this.tooltip, this.timestamp, Y, this.disabled);
    }
    static build(Y, oe, ke, De, un) {
      let gn = G(Y, oe);
      if (!gn.length) return De && Y.some((Tn) => Tn.state == 1) ? new En(
        De.options,
        De.attrs,
        De.tooltip,
        De.timestamp,
        De.selected,
        !0
      ) : null;
      if (oe = oe.facet(Ve).selectOnOpen ? 0 : -1, De && De.selected != oe && De.selected != -1) {
        let Tn = De.options[De.selected].completion;
        for (let ft = 0; ft < gn.length; ft++) if (gn[ft].completion == Tn) {
          oe = ft;
          break;
        }
      }
      return new En(gn, we(ke, oe), { pos: Y.reduce((Tn, ft) => ft.hasResult() ? Math.min(Tn, ft.from) : Tn, 1e8), create: pr, above: un.aboveCursor }, De ? De.timestamp : Date.now(), oe, !1);
    }
    map(Y) {
      return new En(
        this.options,
        this.attrs,
        Object.assign(Object.assign({}, this.tooltip), { pos: Y.mapPos(this.tooltip.pos) }),
        this.timestamp,
        this.selected,
        this.disabled
      );
    }
  }
  class Qn {
    constructor(Y, oe, ke) {
      this.active = Y, this.id = oe, this.open = ke;
    }
    static start() {
      return new Qn(ot, "cm-ac-" + Math.floor(2e6 * Math.random()).toString(36), null);
    }
    update(Y) {
      let { state: oe } = Y, ke = oe.facet(Ve), De = (ke.override || oe.languageDataAt("autocomplete", a(oe)).map(d)).map((gn) => (this.active.find((Tn) => Tn.source == gn) || new Nt(gn, this.active.some((Tn) => Tn.state != 0) ? 1 : 0)).update(Y, ke));
      De.length == this.active.length && De.every((gn, Tn) => gn == this.active[Tn]) && (De = this.active);
      let un = this.open;
      un && Y.docChanged && (un = un.map(Y.changes)), Y.selection || De.some((gn) => gn.hasResult() && Y.changes.touchesRange(gn.from, gn.to)) || !J(De, this.active) ? un = En.build(De, oe, this.id, un, ke) : un && un.disabled && !De.some((gn) => gn.state == 1) && (un = null), !un && De.every((gn) => gn.state != 1) && De.some((gn) => gn.hasResult()) && (De = De.map((gn) => gn.hasResult() ? new Nt(gn.source, 0) : gn));
      for (let gn of Y.effects) gn.is(ol) && (un = un && un.setSelected(gn.value, this.id));
      return De == this.active && un == this.open ? this : new Qn(De, this.id, un);
    }
    get tooltip() {
      return this.open ? this.open.tooltip : null;
    }
    get attrs() {
      return this.open ? this.open.attrs : Vn;
    }
  }
  const Vn = { "aria-autocomplete": "list" }, ot = [];
  class Nt {
    constructor(Y, oe, ke = -1) {
      this.source = Y, this.state = oe, this.explicitPos = ke;
    }
    hasResult() {
      return !1;
    }
    update(Y, oe) {
      let ke = ce(Y), De = this;
      ke ? De = De.handleUserEvent(Y, ke, oe) : Y.docChanged ? De = De.handleChange(Y) : Y.selection && De.state != 0 && (De = new Nt(De.source, 0));
      for (let un of Y.effects) if (un.is(Cl)) De = new Nt(De.source, 1, un.value ? a(Y.state) : -1);
      else if (un.is(fn)) De = new Nt(De.source, 0);
      else if (un.is(Pt)) for (let gn of un.value) gn.source == De.source && (De = gn);
      return De;
    }
    handleUserEvent(Y, oe, ke) {
      return oe != "delete" && ke.activateOnTyping ? new Nt(this.source, 1) : this.map(Y.changes);
    }
    handleChange(Y) {
      return Y.changes.touchesRange(a(Y.startState)) ? new Nt(this.source, 0) : this.map(Y.changes);
    }
    map(Y) {
      return Y.empty || 0 > this.explicitPos ? this : new Nt(this.source, this.state, Y.mapPos(this.explicitPos));
    }
  }
  class zt extends Nt {
    constructor(Y, oe, ke, De, un) {
      super(Y, 2, oe), this.result = ke, this.from = De, this.to = un;
    }
    hasResult() {
      return !0;
    }
    handleUserEvent(Y, oe, ke) {
      var De;
      let un = Y.changes.mapPos(this.from), gn = Y.changes.mapPos(this.to, 1), Tn = a(Y.state);
      if ((0 > this.explicitPos ? Tn <= un : Tn < this.from) || Tn > gn || oe == "delete" && a(Y.startState) == this.from) return new Nt(this.source, oe == "input" && ke.activateOnTyping ? 1 : 0);
      oe = 0 > this.explicitPos ? -1 : Y.changes.mapPos(this.explicitPos);
      let ft;
      ke = this.result.validFor;
      var gt = Y.state;
      if (ke) {
        var Gt = gt.sliceDoc(un, gn);
        ke = typeof ke == "function" ? ke(Gt, un, gn, gt) : h(ke, !0).test(Gt);
      } else ke = !1;
      return ke ? new zt(this.source, oe, this.result, un, gn) : this.result.update && (ft = this.result.update(this.result, un, gn, new Nn(Y.state, Tn, 0 <= oe))) ? new zt(
        this.source,
        oe,
        ft,
        ft.from,
        (De = ft.to) !== null && De !== void 0 ? De : a(Y.state)
      ) : new Nt(this.source, 1, oe);
    }
    handleChange(Y) {
      return Y.changes.touchesRange(this.from, this.to) ? new Nt(this.source, 0) : this.map(Y.changes);
    }
    map(Y) {
      return Y.empty ? this : new zt(this.source, 0 > this.explicitPos ? -1 : Y.mapPos(this.explicitPos), this.result, Y.mapPos(this.from), Y.mapPos(this.to, 1));
    }
  }
  const Pt = Ze.StateEffect.define({ map(Z, Y) {
    return Z.map((oe) => oe.map(Y));
  } }), ol = Ze.StateEffect.define(), St = Ze.StateField.define({
    create() {
      return Qn.start();
    },
    update(Z, Y) {
      return Z.update(Y);
    },
    provide: (Z) => [pn.showTooltip.from(Z, (Y) => Y.tooltip), pn.EditorView.contentAttributes.from(Z, (Y) => Y.attrs)]
  }), pr = /* @__PURE__ */ function(Z, Y) {
    return (oe) => new an(oe, Z, Y);
  }(St, xe);
  e = (Z) => {
    let Y = Z.state.field(St, !1);
    return Z.state.readOnly || !Y || !Y.open || 0 > Y.open.selected || Y.open.disabled || Date.now() - Y.open.timestamp < Z.state.facet(Ve).interactionDelay ? !1 : xe(Z, Y.open.options[Y.open.selected]);
  }, n = (Z) => Z.state.field(St, !1) ? (Z.dispatch({ effects: Cl.of(!0) }), !0) : !1, t = (Z) => {
    let Y = Z.state.field(St, !1);
    return !Y || !Y.active.some((oe) => oe.state != 0) ? !1 : (Z.dispatch({ effects: fn.of(null) }), !0);
  };
  class ul {
    constructor(Y, oe) {
      this.active = Y, this.context = oe, this.time = Date.now(), this.updates = [], this.done = void 0;
    }
  }
  const Rr = pn.ViewPlugin.fromClass(class {
    constructor(Z) {
      this.view = Z, this.debounceUpdate = -1, this.running = [], this.debounceAccept = -1, this.composing = 0;
      for (let Y of Z.state.field(St).active) Y.state == 1 && this.startQuery(Y);
    }
    update(Z) {
      let Y = Z.state.field(St);
      if (Z.selectionSet || Z.docChanged || Z.startState.field(St) != Y) {
        var oe = Z.transactions.some((ke) => (ke.selection || ke.docChanged) && !ce(ke));
        for (let ke = 0; ke < this.running.length; ke++) {
          let De = this.running[ke];
          if (oe || 50 < De.updates.length + Z.transactions.length && 1e3 < Date.now() - De.time) {
            for (let un of De.context.abortListeners) try {
              un();
            } catch (gn) {
              pn.logException(this.view.state, gn);
            }
            De.context.abortListeners = null, this.running.splice(ke--, 1);
          } else De.updates.push(...Z.transactions);
        }
        if (-1 < this.debounceUpdate && clearTimeout(this.debounceUpdate), this.debounceUpdate = Y.active.some((ke) => ke.state == 1 && !this.running.some((De) => De.active.source == ke.source)) ? setTimeout(() => this.startUpdate(), 50) : -1, this.composing != 0) for (let ke of Z.transactions) ce(ke) == "input" ? this.composing = 2 : this.composing == 2 && ke.selection && (this.composing = 3);
      }
    }
    startUpdate() {
      this.debounceUpdate = -1;
      var { state: Z } = this.view;
      Z = Z.field(St);
      for (let Y of Z.active) Y.state != 1 || this.running.some((oe) => oe.active.source == Y.source) || this.startQuery(Y);
    }
    startQuery(Z) {
      var { state: Y } = this.view;
      let oe = a(Y);
      Y = new Nn(Y, oe, Z.explicitPos == oe);
      let ke = new ul(Z, Y);
      this.running.push(ke), Promise.resolve(Z.source(Y)).then((De) => {
        ke.context.aborted || (ke.done = De || null, this.scheduleAccept());
      }, (De) => {
        this.view.dispatch({ effects: fn.of(null) }), pn.logException(this.view.state, De);
      });
    }
    scheduleAccept() {
      this.running.every((Z) => Z.done !== void 0) ? this.accept() : 0 > this.debounceAccept && (this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(Ve).updateSyncTime));
    }
    accept() {
      var Z;
      -1 < this.debounceAccept && clearTimeout(this.debounceAccept), this.debounceAccept = -1;
      let Y = [], oe = this.view.state.facet(Ve);
      for (let De = 0; De < this.running.length; De++) {
        let un = this.running[De];
        if (un.done !== void 0) {
          if (this.running.splice(De--, 1), un.done) {
            var ke = new zt(un.active.source, un.active.explicitPos, un.done, un.done.from, (Z = un.done.to) !== null && Z !== void 0 ? Z : a(un.updates.length ? un.updates[0].startState : this.view.state));
            for (let gn of un.updates) ke = ke.update(gn, oe);
            if (ke.hasResult()) {
              Y.push(ke);
              continue;
            }
          }
          if ((ke = this.view.state.field(St).active.find((gn) => gn.source == un.active.source)) && ke.state == 1) if (un.done == null) {
            ke = new Nt(un.active.source, 0);
            for (let gn of un.updates) ke = ke.update(gn, oe);
            ke.state != 1 && Y.push(ke);
          } else this.startQuery(ke);
        }
      }
      Y.length && this.view.dispatch({ effects: Pt.of(Y) });
    }
  }, { eventHandlers: { blur(Z) {
    var Y = this.view.state.field(St, !1);
    Y && Y.tooltip && this.view.state.facet(Ve).closeOnBlur && ((Y = Y.open && pn.getTooltip(this.view, Y.open.tooltip)) && Y.dom.contains(Z.relatedTarget) || this.view.dispatch({ effects: fn.of(null) }));
  }, compositionstart() {
    this.composing = 1;
  }, compositionend() {
    this.composing == 3 && setTimeout(() => this.view.dispatch({ effects: Cl.of(!1) }), 20), this.composing = 0;
  } } }), ql = pn.EditorView.baseTheme({
    ".cm-tooltip.cm-tooltip-autocomplete": { "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": { padding: "1px 3px", lineHeight: 1.2 },
      "& > li": { overflowX: "hidden", textOverflow: "ellipsis", cursor: "pointer" },
      "& > completion-section": { display: "list-item", borderBottom: "1px solid silver", paddingLeft: "0.5em", opacity: 0.7 }
    } },
    "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
      background: "#17c",
      color: "white"
    },
    "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": { background: "#777" },
    "&dark .cm-tooltip-autocomplete ul li[aria-selected]": { background: "#347", color: "white" },
    "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": { background: "#444" },
    ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": { content: '"···"', opacity: 0.5, display: "block", textAlign: "center" },
    ".cm-tooltip.cm-completionInfo": {
      position: "absolute",
      padding: "3px 9px",
      width: "max-content",
      maxWidth: "400px",
      boxSizing: "border-box"
    },
    ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
    ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
    ".cm-completionInfo.cm-completionInfo-left-narrow": { right: "30px" },
    ".cm-completionInfo.cm-completionInfo-right-narrow": { left: "30px" },
    "&light .cm-snippetField": { backgroundColor: "#00000022" },
    "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
    ".cm-snippetFieldPosition": {
      verticalAlign: "text-top",
      width: 0,
      height: "1.15em",
      display: "inline-block",
      margin: "0 -0.7px -.7em",
      borderLeft: "1.4px dotted #888"
    },
    ".cm-completionMatchedText": { textDecoration: "underline" },
    ".cm-completionDetail": { marginLeft: "0.5em", fontStyle: "italic" },
    ".cm-completionIcon": { fontSize: "90%", width: ".8em", display: "inline-block", textAlign: "center", paddingRight: ".6em", opacity: "0.6", boxSizing: "content-box" },
    ".cm-completionIcon-function, .cm-completionIcon-method": { "&:after": { content: "'ƒ'" } },
    ".cm-completionIcon-class": { "&:after": { content: "'○'" } },
    ".cm-completionIcon-interface": { "&:after": { content: "'◌'" } },
    ".cm-completionIcon-variable": { "&:after": { content: "'𝑥'" } },
    ".cm-completionIcon-constant": { "&:after": { content: "'𝐶'" } },
    ".cm-completionIcon-type": { "&:after": { content: "'𝑡'" } },
    ".cm-completionIcon-enum": { "&:after": { content: "'∪'" } },
    ".cm-completionIcon-property": { "&:after": { content: "'□'" } },
    ".cm-completionIcon-keyword": { "&:after": { content: "'🔑︎'" } },
    ".cm-completionIcon-namespace": { "&:after": { content: "'▢'" } },
    ".cm-completionIcon-text": { "&:after": {
      content: "'abc'",
      fontSize: "50%",
      verticalAlign: "middle"
    } }
  });
  class Mr {
    constructor(Y, oe, ke, De) {
      this.field = Y, this.line = oe, this.from = ke, this.to = De;
    }
  }
  class wi {
    constructor(Y, oe, ke) {
      this.field = Y, this.from = oe, this.to = ke;
    }
    map(Y) {
      let oe = Y.mapPos(this.from, -1, Ze.MapMode.TrackDel);
      return Y = Y.mapPos(this.to, 1, Ze.MapMode.TrackDel), oe == null || Y == null ? null : new wi(this.field, oe, Y);
    }
  }
  class bl {
    constructor(Y, oe) {
      this.lines = Y, this.fieldPositions = oe;
    }
    instantiate(Y, oe) {
      let ke = [], De = [oe];
      var un = Y.doc.lineAt(oe);
      un = /^\s*/.exec(un.text)[0];
      for (let gn of this.lines) {
        if (ke.length) {
          let Tn = un, ft = /^\t*/.exec(gn)[0].length;
          for (let gt = 0; gt < ft; gt++) Tn += Y.facet(xn.indentUnit);
          De.push(oe + Tn.length - ft), gn = Tn + gn.slice(ft);
        }
        ke.push(gn), oe += gn.length + 1;
      }
      return Y = this.fieldPositions.map((gn) => new wi(gn.field, De[gn.line] + gn.from, De[gn.line] + gn.to)), { text: ke, ranges: Y };
    }
    static parse(Y) {
      let oe = [], ke = [], De = [];
      for (let gn of Y.split(/\r\n?|\n/)) {
        for (; Y = /[#$]\{(?:(\d+)(?::([^}]*))?|([^}]*))\}/.exec(gn); ) {
          let Tn = Y[1] ? +Y[1] : null, ft = Y[2] || Y[3] || "";
          var un = -1;
          for (let gt = 0; gt < oe.length; gt++) (Tn != null ? oe[gt].seq == Tn : ft && oe[gt].name == ft) && (un = gt);
          if (0 > un) {
            for (un = 0; un < oe.length && (Tn == null || oe[un].seq != null && oe[un].seq < Tn); ) un++;
            oe.splice(un, 0, { seq: Tn, name: ft });
            for (let gt of De) gt.field >= un && gt.field++;
          }
          De.push(new Mr(un, ke.length, Y.index, Y.index + ft.length)), gn = gn.slice(0, Y.index) + ft + gn.slice(Y.index + Y[0].length);
        }
        for (; Y = /\\([{}])/.exec(gn); ) {
          gn = gn.slice(0, Y.index) + Y[1] + gn.slice(Y.index + Y[0].length);
          for (let Tn of De) Tn.line == ke.length && Tn.from > Y.index && (Tn.from--, Tn.to--);
        }
        ke.push(gn);
      }
      return new bl(ke, De);
    }
  }
  let tl = pn.Decoration.widget({ widget: new class extends pn.WidgetType {
    toDOM() {
      let Z = document.createElement("span");
      return Z.className = "cm-snippetFieldPosition", Z;
    }
    ignoreEvent() {
      return !1;
    }
  }() }), Zt = pn.Decoration.mark({ class: "cm-snippetField" });
  class Ql {
    constructor(Y, oe) {
      this.ranges = Y, this.active = oe, this.deco = pn.Decoration.set(Y.map((ke) => (ke.from == ke.to ? tl : Zt).range(ke.from, ke.to)));
    }
    map(Y) {
      let oe = [];
      for (let ke of this.ranges) {
        let De = ke.map(Y);
        if (!De) return null;
        oe.push(De);
      }
      return new Ql(oe, this.active);
    }
    selectionInsideField(Y) {
      return Y.ranges.every((oe) => this.ranges.some((ke) => ke.field == this.active && ke.from <= oe.from && ke.to >= oe.to));
    }
  }
  const jl = Ze.StateEffect.define({ map(Z, Y) {
    return Z && Z.map(Y);
  } }), Sl = Ze.StateEffect.define(), gl = Ze.StateField.define({ create() {
    return null;
  }, update(Z, Y) {
    for (let oe of Y.effects) {
      if (oe.is(jl)) return oe.value;
      if (oe.is(Sl) && Z) return new Ql(Z.ranges, oe.value);
    }
    return Z && Y.docChanged && (Z = Z.map(Y.changes)), Z && Y.selection && !Z.selectionInsideField(Y.selection) && (Z = null), Z;
  }, provide: (Z) => pn.EditorView.decorations.from(Z, (Y) => Y ? Y.deco : pn.Decoration.none) }), jr = ({ state: Z, dispatch: Y }) => Z.field(gl, !1) ? (Y(Z.update({ effects: jl.of(null) })), !0) : !1, Kt = P(1), nl = P(-1), Pr = [{ key: "Tab", run: Kt, shift: nl }, { key: "Escape", run: jr }], ii = Ze.Facet.define({ combine(Z) {
    return Z.length ? Z[0] : Pr;
  } }), Ar = Ze.Prec.highest(pn.keymap.compute([ii], (Z) => Z.facet(ii))), Ml = pn.EditorView.domEventHandlers({ mousedown(Z, Y) {
    let oe = Y.state.field(gl, !1), ke;
    if (!oe || (ke = Y.posAtCoords({ x: Z.clientX, y: Z.clientY })) == null) return !1;
    let De = oe.ranges.find((un) => un.from <= ke && un.to >= ke);
    return !De || De.field == oe.active ? !1 : (Y.dispatch({
      selection: je(oe.ranges, De.field),
      effects: jl.of(oe.ranges.some((un) => un.field > De.field) ? new Ql(oe.ranges, De.field) : null),
      scrollIntoView: !0
    }), !0);
  } }), Rl = /* @__PURE__ */ Object.create(null), Se = { brackets: ["(", "[", "{", "'", '"'], before: ")]}:;>", stringPrefixes: [] }, se = Ze.StateEffect.define({ map(Z, Y) {
    return Z = Y.mapPos(Z, -1, Ze.MapMode.TrackAfter), Z ?? void 0;
  } }), Ee = new class extends Ze.RangeValue {
  }();
  Ee.startSide = 1, Ee.endSide = -1;
  const Ge = Ze.StateField.define({ create() {
    return Ze.RangeSet.empty;
  }, update(Z, Y) {
    if (Y.selection) {
      let oe = Y.state.doc.lineAt(Y.selection.main.head).from, ke = Y.startState.doc.lineAt(Y.startState.selection.main.head).from;
      oe != Y.changes.mapPos(ke, -1) && (Z = Ze.RangeSet.empty);
    }
    Z = Z.map(Y.changes);
    for (let oe of Y.effects) oe.is(se) && (Z = Z.update({ add: [Ee.range(oe.value, oe.value + 1)] }));
    return Z;
  } }), vn = typeof navigator == "object" && /Android\b/.test(navigator.userAgent), Kn = pn.EditorView.inputHandler.of((Z, Y, oe, ke) => {
    if ((vn ? Z.composing : Z.compositionStarted) || Z.state.readOnly) return !1;
    let De = Z.state.selection.main;
    return 2 < ke.length || ke.length == 2 && Ze.codePointSize(Ze.codePointAt(
      ke,
      0
    )) == 1 || Y != De.from || oe != De.to || (Y = Ce(Z.state, ke), !Y) ? !1 : (Z.dispatch(Y), !0);
  }), Un = ({ state: Z, dispatch: Y }) => {
    if (Z.readOnly) return !1;
    let oe = (Z.languageDataAt("closeBrackets", Z.selection.main.head)[0] || Se).brackets || Se.brackets, ke = null, De = Z.changeByRange((un) => {
      if (un.empty) {
        var gn = un.head;
        gn = Z.doc.sliceString(gn - 2, gn), gn = Ze.codePointSize(Ze.codePointAt(gn, 0)) == gn.length ? gn : gn.slice(1);
        for (let Tn of oe) if (Tn == gn && B(Z.doc, un.head) == le(Ze.codePointAt(Tn, 0))) return {
          changes: { from: un.head - Tn.length, to: un.head + Tn.length },
          range: Ze.EditorSelection.cursor(un.head - Tn.length)
        };
      }
      return { range: ke = un };
    });
    return ke || Y(Z.update(De, { scrollIntoView: !0, userEvent: "delete.backward" })), !ke;
  }, Pe = [{ key: "Backspace", run: Un }], C = [{ key: "Ctrl-Space", run: n }, { key: "Escape", run: t }, { key: "ArrowDown", run: $e(!0) }, { key: "ArrowUp", run: $e(!1) }, { key: "PageDown", run: $e(!0, "page") }, { key: "PageUp", run: $e(!1, "page") }, { key: "Enter", run: e }], re = Ze.Prec.highest(pn.keymap.computeN([Ve], (Z) => Z.facet(Ve).defaultKeymap ? [C] : [])), ge = /* @__PURE__ */ new WeakMap();
  l.CompletionContext = Nn, l.acceptCompletion = e, l.autocompletion = function(Z = {}) {
    return [St, Ve.of(Z), Rr, re, ql];
  }, l.clearSnippet = jr, l.closeBrackets = function() {
    return [Kn, Ge];
  }, l.closeBracketsKeymap = Pe, l.closeCompletion = t, l.completeAnyWord = (Z) => {
    let Y = Z.state.languageDataAt("wordChars", Z.pos).join(""), oe = K(Y);
    var ke = Z.matchBefore(H(oe, (De) => De + "$"));
    return !ke && !Z.explicit ? null : (ke = ke ? ke.from : Z.pos, Z = Me(Z.state.doc, Rl[Y] || (Rl[Y] = /* @__PURE__ */ new WeakMap()), oe, 5e4, ke), { from: ke, options: Z, validFor: H(oe, (De) => "^" + De) });
  }, l.completeFromList = o, l.completionKeymap = C, l.completionStatus = function(Z) {
    return (Z = Z.field(St, !1)) && Z.active.some((Y) => Y.state == 1) ? "pending" : Z && Z.active.some((Y) => Y.state != 0) ? "active" : null;
  }, l.currentCompletions = function(Z) {
    var Y;
    return Z = (Y = Z.field(St, !1)) === null || Y === void 0 ? void 0 : Y.open, !Z || Z.disabled ? [] : ((Y = ge.get(Z.options)) || ge.set(Z.options, Y = Z.options.map((oe) => oe.completion)), Y);
  }, l.deleteBracketPair = Un, l.hasNextSnippetField = function(Z) {
    let Y = Z.field(gl, !1);
    return !(!Y || !Y.ranges.some((oe) => oe.field == Y.active + 1));
  }, l.hasPrevSnippetField = function(Z) {
    return Z = Z.field(
      gl,
      !1
    ), !!(Z && 0 < Z.active);
  }, l.ifIn = function(Z, Y) {
    return (oe) => {
      for (let ke = xn.syntaxTree(oe.state).resolveInner(oe.pos, -1); ke; ke = ke.parent) {
        if (-1 < Z.indexOf(ke.name)) return Y(oe);
        if (ke.type.isTop) break;
      }
      return null;
    };
  }, l.ifNotIn = function(Z, Y) {
    return (oe) => {
      for (let ke = xn.syntaxTree(oe.state).resolveInner(oe.pos, -1); ke; ke = ke.parent) {
        if (-1 < Z.indexOf(ke.name)) return null;
        if (ke.type.isTop) break;
      }
      return Y(oe);
    };
  }, l.insertBracket = Ce, l.insertCompletionText = s, l.moveCompletionSelection = $e, l.nextSnippetField = Kt, l.pickedCompletion = Yt, l.prevSnippetField = nl, l.selectedCompletion = function(Z) {
    var Y;
    return (Z = (Y = Z.field(St, !1)) === null || Y === void 0 ? void 0 : Y.open) && !Z.disabled && 0 <= Z.selected ? Z.options[Z.selected].completion : null;
  }, l.selectedCompletionIndex = function(Z) {
    var Y;
    return (Z = (Y = Z.field(St, !1)) === null || Y === void 0 ? void 0 : Y.open) && !Z.disabled && 0 <= Z.selected ? Z.selected : null;
  }, l.setSelectedCompletion = function(Z) {
    return ol.of(Z);
  }, l.snippet = E, l.snippetCompletion = function(Z, Y) {
    return Object.assign(Object.assign({}, Y), { apply: E(Z) });
  }, l.snippetKeymap = ii, l.startCompletion = n;
};
Xo[9] = function(e, n, t, l) {
  function r() {
    throw Error("setTimeout has not been defined");
  }
  function u() {
    throw Error("clearTimeout has not been defined");
  }
  function o(we) {
    if (_ === setTimeout) return setTimeout(we, 0);
    if ((_ === r || !_) && setTimeout) return _ = setTimeout, setTimeout(we, 0);
    try {
      return _(we, 0);
    } catch {
      try {
        return _.call(null, we, 0);
      } catch {
        return _.call(this, we, 0);
      }
    }
  }
  function a(we) {
    if (R === clearTimeout) return clearTimeout(we);
    if ((R === u || !R) && clearTimeout) return R = clearTimeout, clearTimeout(we);
    try {
      return R(we);
    } catch {
      try {
        return R.call(null, we);
      } catch {
        return R.call(this, we);
      }
    }
  }
  function h() {
    L && G && (L = !1, G.length ? F = G.concat(F) : J = -1, F.length && s());
  }
  function s() {
    if (!L) {
      var we = o(h);
      L = !0;
      for (var ce = F.length; ce; ) {
        for (G = F, F = []; ++J < ce; ) G && G[J].run();
        J = -1, ce = F.length;
      }
      G = null, L = !1, a(we);
    }
  }
  function d(we, ce) {
    this.fun = we, this.array = ce;
  }
  function p() {
  }
  e = t.exports = {};
  try {
    var _ = typeof setTimeout == "function" ? setTimeout : r;
  } catch {
    _ = r;
  }
  try {
    var R = typeof clearTimeout == "function" ? clearTimeout : u;
  } catch {
    R = u;
  }
  var F = [], L = !1, G, J = -1;
  e.nextTick = function(we) {
    var ce = Array(arguments.length - 1);
    if (1 < arguments.length) for (var xe = 1; xe < arguments.length; xe++) ce[xe - 1] = arguments[xe];
    F.push(new d(we, ce)), F.length !== 1 || L || o(s);
  }, d.prototype.run = function() {
    this.fun.apply(null, this.array);
  }, e.title = "browser", e.browser = !0, e.env = {}, e.argv = [], e.version = "", e.versions = {}, e.on = p, e.addListener = p, e.once = p, e.off = p, e.removeListener = p, e.removeAllListeners = p, e.emit = p, e.prependListener = p, e.prependOnceListener = p, e.listeners = function(we) {
    return [];
  }, e.binding = function(we) {
    throw Error("process.binding is not supported");
  }, e.cwd = function() {
    return "/";
  }, e.chdir = function(we) {
    throw Error("process.chdir is not supported");
  }, e.umask = function() {
    return 0;
  };
};
Xo[10] = function(e, n, t, l) {
  function r(B, q = Uint16Array) {
    if (typeof B != "string") return B;
    let me = null;
    for (let Fe = 0, ln = 0; Fe < B.length; ) {
      let Be = 0;
      for (; ; ) {
        var Ae = B.charCodeAt(Fe++);
        let Ze = !1;
        if (Ae == 126) {
          Be = 65535;
          break;
        }
        if (92 <= Ae && Ae--, 34 <= Ae && Ae--, Ae -= 32, 46 <= Ae && (Ae -= 46, Ze = !0), Be += Ae, Ze) break;
        Be *= 46;
      }
      me ? me[ln++] = Be : me = new q(Be);
    }
    return me;
  }
  function u(B, q, me, Ae, Fe, ln) {
    var Be = 0;
    Ae = 1 << Ae, { dialect: me } = me.p.parser;
    e: for (; Ae & B[Be]; ) {
      let Yt = B[Be + 1];
      for (var Ze = Be + 3; Ze < Yt; Ze += 2) if (0 < (B[Ze + 1] & Ae)) {
        var pn = B[Ze], xn;
        if ((xn = me.allows(pn)) && !(xn = q.token.value == -1 || q.token.value == pn)) {
          xn = pn;
          var Nn = Fe, at = ln;
          let jt = o(Nn, at, q.token.value);
          xn = 0 > jt || o(Nn, at, xn) < jt;
        }
        if (xn) {
          q.acceptToken(pn);
          break;
        }
      }
      if (Ze = q.next, pn = 0, Be = B[Be + 2], 0 > q.next && Be > pn && B[Yt + 3 * Be - 3] == 65535 && B[Yt + 3 * Be - 3] == 65535) {
        Be = B[Yt + 3 * Be - 1];
        continue e;
      }
      for (; pn < Be; ) if (xn = pn + Be >> 1, Nn = Yt + xn + (xn << 1), at = B[Nn + 1] || 65536, Ze < B[Nn]) Be = xn;
      else if (Ze >= at) pn = xn + 1;
      else {
        Be = B[Nn + 2], q.advance();
        continue e;
      }
      break;
    }
  }
  function o(B, q, me) {
    for (let Ae = q, Fe; (Fe = B[Ae]) != 65535; Ae++) if (Fe == me) return Ae - q;
    return -1;
  }
  function a(B, q, me) {
    let Ae = B.cursor(_.IterMode.IncludeAnonymous);
    for (Ae.moveTo(q); ; ) if (0 > me ? !Ae.childBefore(q) : !Ae.childAfter(q)) for (; ; ) {
      if ((0 > me ? Ae.to < q : Ae.from > q) && !Ae.type.isError) return 0 > me ? Math.max(0, Math.min(Ae.to - 1, q - 25)) : Math.min(B.length, Math.max(Ae.from + 1, q + 25));
      if (0 > me ? Ae.prevSibling() : Ae.nextSibling()) break;
      if (!Ae.parent()) return 0 > me ? 0 : B.length;
    }
  }
  function h(B, q) {
    for (let me = 0; me < q.length; me++) {
      let Ae = q[me];
      if (Ae.pos == B.pos && Ae.sameState(B)) {
        q[me].score < B.score && (q[me] = B);
        return;
      }
    }
    q.push(B);
  }
  function s(B, q) {
    return B[q] | B[q + 1] << 16;
  }
  function d(B) {
    let q = null;
    for (let me of B) B = me.p.stoppedAt, (me.pos == me.p.stream.end || B != null && me.pos > B) && me.p.parser.stateFlag(me.state, 2) && (!q || q.score < me.score) && (q = me);
    return q;
  }
  function p(B) {
    if (B.external) {
      let q = B.extend ? 1 : 0;
      return (me, Ae) => B.external(me, Ae) << 1 | q;
    }
    return B.get;
  }
  e = n(9);
  var _ = n(4);
  class R {
    constructor(q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn = 0, at) {
      this.p = q, this.stack = me, this.state = Ae, this.reducePos = Fe, this.pos = ln, this.score = Be, this.buffer = Ze, this.bufferBase = pn, this.curContext = xn, this.lookAhead = Nn, this.parent = at;
    }
    toString() {
      return `[${this.stack.filter((q, me) => me % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
    }
    static start(q, me, Ae = 0) {
      let Fe = q.parser.context;
      return new R(q, [], me, Ae, Ae, 0, [], 0, Fe ? new F(Fe, Fe.start) : null, 0, null);
    }
    get context() {
      return this.curContext ? this.curContext.context : null;
    }
    pushState(q, me) {
      this.stack.push(this.state, me, this.bufferBase + this.buffer.length), this.state = q;
    }
    reduce(q) {
      var me, Ae = q >> 19;
      let Fe = q & 65535, { parser: ln } = this.p;
      var Be = ln.dynamicPrecedence(Fe);
      if (Be && (this.score += Be), Ae == 0) this.pushState(ln.getGoto(this.state, Fe, !0), this.reducePos), Fe < ln.minRepeatTerm && this.storeNode(Fe, this.reducePos, this.reducePos, 4, !0), this.reduceContext(Fe, this.reducePos);
      else {
        Be = (Ae = this.stack.length - 3 * (Ae - 1) - (q & 262144 ? 6 : 0)) ? this.stack[Ae - 2] : this.p.ranges[0].from;
        var Ze = this.reducePos - Be;
        for (2e3 <= Ze && ((me = this.p.parser.nodeSet.types[Fe]) === null || me === void 0 || !me.isAnonymous) && (Be == this.p.lastBigReductionStart ? (this.p.bigReductionCount++, this.p.lastBigReductionSize = Ze) : this.p.lastBigReductionSize < Ze && (this.p.bigReductionCount = 1, this.p.lastBigReductionStart = Be, this.p.lastBigReductionSize = Ze)), me = this.bufferBase + this.buffer.length - (Ae ? this.stack[Ae - 1] : 0), (Fe < ln.minRepeatTerm || q & 131072) && (Ze = ln.stateFlag(this.state, 1) ? this.pos : this.reducePos, this.storeNode(Fe, Be, Ze, me + 4, !0)), this.state = q & 262144 ? this.stack[Ae] : ln.getGoto(this.stack[Ae - 3], Fe, !0); this.stack.length > Ae; ) this.stack.pop();
        this.reduceContext(Fe, Be);
      }
    }
    storeNode(q, me, Ae, Fe = 4, ln = !1) {
      if (q == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
        let Be = this, Ze = this.buffer.length;
        if (Ze == 0 && Be.parent && (Ze = Be.bufferBase - Be.parent.bufferBase, Be = Be.parent), 0 < Ze && Be.buffer[Ze - 4] == 0 && -1 < Be.buffer[Ze - 1]) {
          if (me == Ae) return;
          if (Be.buffer[Ze - 2] >= me) {
            Be.buffer[Ze - 2] = Ae;
            return;
          }
        }
      }
      if (ln && this.pos != Ae) {
        if (ln = this.buffer.length, 0 < ln && this.buffer[ln - 4] != 0) for (; 0 < ln && this.buffer[ln - 2] > Ae; ) this.buffer[ln] = this.buffer[ln - 4], this.buffer[ln + 1] = this.buffer[ln - 3], this.buffer[ln + 2] = this.buffer[ln - 2], this.buffer[ln + 3] = this.buffer[ln - 1], ln -= 4, 4 < Fe && (Fe -= 4);
        this.buffer[ln] = q, this.buffer[ln + 1] = me, this.buffer[ln + 2] = Ae, this.buffer[ln + 3] = Fe;
      } else this.buffer.push(q, me, Ae, Fe);
    }
    shift(q, me, Ae, Fe) {
      if (q & 131072) this.pushState(q & 65535, this.pos);
      else if (q & 262144)
        this.pos = Fe, this.shiftContext(me, Ae), me <= this.p.parser.maxNode && this.buffer.push(me, Ae, Fe, 4);
      else {
        let { parser: ln } = this.p;
        (Fe > this.pos || me <= ln.maxNode) && (this.pos = Fe, ln.stateFlag(q, 1) || (this.reducePos = Fe)), this.pushState(q, Ae), this.shiftContext(me, Ae), me <= ln.maxNode && this.buffer.push(me, Ae, Fe, 4);
      }
    }
    apply(q, me, Ae, Fe) {
      q & 65536 ? this.reduce(q) : this.shift(q, me, Ae, Fe);
    }
    useNode(q, me) {
      let Ae = this.p.reused.length - 1;
      (0 > Ae || this.p.reused[Ae] != q) && (this.p.reused.push(q), Ae++);
      let Fe = this.pos;
      this.reducePos = this.pos = Fe + q.length, this.pushState(me, Fe), this.buffer.push(Ae, Fe, this.reducePos, -1), this.curContext && this.updateContext(this.curContext.tracker.reuse(this.curContext.context, q, this, this.p.stream.reset(this.pos - q.length)));
    }
    split() {
      let q = this;
      for (var me = q.buffer.length; 0 < me && q.buffer[me - 2] > q.reducePos; ) me -= 4;
      let Ae = q.buffer.slice(me);
      for (me = q.bufferBase + me; q && me == q.bufferBase; ) q = q.parent;
      return new R(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, Ae, me, this.curContext, this.lookAhead, q);
    }
    recoverByDelete(q, me) {
      let Ae = q <= this.p.parser.maxNode;
      Ae && this.storeNode(q, this.pos, me, 4), this.storeNode(0, this.pos, me, Ae ? 8 : 4), this.pos = this.reducePos = me, this.score -= 190;
    }
    canShift(q) {
      for (let me = new L(this); ; ) {
        let Ae = this.p.parser.stateSlot(me.state, 4) || this.p.parser.hasAction(me.state, q);
        if (Ae == 0) return !1;
        if (!(Ae & 65536)) return !0;
        me.reduce(Ae);
      }
    }
    recoverByInsert(q) {
      if (300 <= this.stack.length) return [];
      let me = this.p.parser.nextStates(this.state);
      if (8 < me.length || 120 <= this.stack.length) {
        var Ae = [];
        for (let Fe = 0, ln; Fe < me.length; Fe += 2) (ln = me[Fe + 1]) != this.state && this.p.parser.hasAction(ln, q) && Ae.push(me[Fe], ln);
        if (120 > this.stack.length) for (q = 0; 8 > Ae.length && q < me.length; q += 2) {
          let Fe = me[q + 1];
          Ae.some((ln, Be) => Be & 1 && ln == Fe) || Ae.push(me[q], Fe);
        }
        me = Ae;
      }
      for (Ae = [], q = 0; q < me.length && 4 > Ae.length; q += 2) {
        let Fe = me[q + 1];
        if (Fe == this.state) continue;
        let ln = this.split();
        ln.pushState(Fe, this.pos), ln.storeNode(0, ln.pos, ln.pos, 4, !0), ln.shiftContext(me[q], this.pos), ln.reducePos = this.pos, ln.score -= 200, Ae.push(ln);
      }
      return Ae;
    }
    forceReduce() {
      var { parser: q } = this.p;
      let me = q.stateSlot(this.state, 5);
      if (!(me & 65536)) return !1;
      if (!q.validAction(this.state, me)) {
        let Ae = this.stack.length - 3 * (me >> 19);
        if (0 > Ae || 0 > q.getGoto(this.stack[Ae], me & 65535, !1)) {
          if (q = this.findForcedReduction(), q == null) return !1;
          me = q;
        }
        this.storeNode(0, this.pos, this.pos, 4, !0), this.score -= 100;
      }
      return this.reducePos = this.pos, this.reduce(me), !0;
    }
    findForcedReduction() {
      let { parser: q } = this.p, me = [], Ae = (Fe, ln) => {
        if (!me.includes(Fe)) return me.push(Fe), q.allActions(Fe, (Be) => {
          if (!(Be & 393216)) {
            if (Be & 65536) {
              var Ze = (Be >> 19) - ln;
              if (1 < Ze) {
                Be &= 65535;
                let pn = this.stack.length - 3 * Ze;
                if (0 <= pn && 0 <= q.getGoto(this.stack[pn], Be, !1)) return Ze << 19 | 65536 | Be;
              }
            } else if (Ze = Ae(Be, ln + 1), Ze != null) return Ze;
          }
        });
      };
      return Ae(this.state, 0);
    }
    forceAll() {
      for (; !this.p.parser.stateFlag(this.state, 2); ) if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, !0);
        break;
      }
      return this;
    }
    get deadEnd() {
      if (this.stack.length != 3) return !1;
      let { parser: q } = this.p;
      return q.data[q.stateSlot(
        this.state,
        1
      )] == 65535 && !q.stateSlot(this.state, 4);
    }
    restart() {
      this.storeNode(0, this.pos, this.pos, 4, !0), this.state = this.stack[0], this.stack.length = 0;
    }
    sameState(q) {
      if (this.state != q.state || this.stack.length != q.stack.length) return !1;
      for (let me = 0; me < this.stack.length; me += 3) if (this.stack[me] != q.stack[me]) return !1;
      return !0;
    }
    get parser() {
      return this.p.parser;
    }
    dialectEnabled(q) {
      return this.p.parser.dialect.flags[q];
    }
    shiftContext(q, me) {
      this.curContext && this.updateContext(this.curContext.tracker.shift(this.curContext.context, q, this, this.p.stream.reset(me)));
    }
    reduceContext(q, me) {
      this.curContext && this.updateContext(this.curContext.tracker.reduce(this.curContext.context, q, this, this.p.stream.reset(me)));
    }
    emitContext() {
      let q = this.buffer.length - 1;
      (0 > q || this.buffer[q] != -3) && this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
    }
    emitLookAhead() {
      let q = this.buffer.length - 1;
      (0 > q || this.buffer[q] != -4) && this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
    }
    updateContext(q) {
      q != this.curContext.context && (q = new F(this.curContext.tracker, q), q.hash != this.curContext.hash && this.emitContext(), this.curContext = q);
    }
    setLookAhead(q) {
      q > this.lookAhead && (this.emitLookAhead(), this.lookAhead = q);
    }
    close() {
      this.curContext && this.curContext.tracker.strict && this.emitContext(), 0 < this.lookAhead && this.emitLookAhead();
    }
  }
  class F {
    constructor(q, me) {
      this.tracker = q, this.context = me, this.hash = q.strict ? q.hash(me) : 0;
    }
  }
  class L {
    constructor(q) {
      this.start = q, this.state = q.state, this.stack = q.stack, this.base = this.stack.length;
    }
    reduce(q) {
      let me = q & 65535;
      q >>= 19, q == 0 ? (this.stack == this.start.stack && (this.stack = this.stack.slice()), this.stack.push(
        this.state,
        0,
        0
      ), this.base += 3) : this.base -= 3 * (q - 1), this.state = this.start.p.parser.getGoto(this.stack[this.base - 3], me, !0);
    }
  }
  class G {
    constructor(q, me, Ae) {
      this.stack = q, this.pos = me, this.index = Ae, this.buffer = q.buffer, this.index == 0 && this.maybeNext();
    }
    static create(q, me = q.bufferBase + q.buffer.length) {
      return new G(q, me, me - q.bufferBase);
    }
    maybeNext() {
      let q = this.stack.parent;
      q != null && (this.index = this.stack.bufferBase - q.bufferBase, this.stack = q, this.buffer = q.buffer);
    }
    get id() {
      return this.buffer[this.index - 4];
    }
    get start() {
      return this.buffer[this.index - 3];
    }
    get end() {
      return this.buffer[this.index - 2];
    }
    get size() {
      return this.buffer[this.index - 1];
    }
    next() {
      this.index -= 4, this.pos -= 4, this.index == 0 && this.maybeNext();
    }
    fork() {
      return new G(this.stack, this.pos, this.index);
    }
  }
  class J {
    constructor() {
      this.extended = this.end = this.value = this.start = -1, this.context = this.mask = this.lookAhead = 0;
    }
  }
  const we = new J();
  class ce {
    constructor(q, me) {
      this.input = q, this.ranges = me, this.chunk = "", this.chunkOff = 0, this.chunk2 = "", this.chunk2Pos = 0, this.next = -1, this.token = we, this.rangeIndex = 0, this.pos = this.chunkPos = me[0].from, this.range = me[0], this.end = me[me.length - 1].to, this.readNext();
    }
    resolveOffset(q, me) {
      let Ae = this.range, Fe = this.rangeIndex;
      for (q = this.pos + q; q < Ae.from; ) {
        if (!Fe) return null;
        var ln = this.ranges[--Fe];
        q -= Ae.from - ln.to, Ae = ln;
      }
      for (; 0 > me ? q > Ae.to : q >= Ae.to; ) {
        if (Fe == this.ranges.length - 1) return null;
        ln = this.ranges[++Fe], q += ln.from - Ae.to, Ae = ln;
      }
      return q;
    }
    clipPos(q) {
      if (q >= this.range.from && q < this.range.to) return q;
      for (let me of this.ranges) if (me.to > q) return Math.max(q, me.from);
      return this.end;
    }
    peek(q) {
      var me = this.chunkOff + q;
      if (0 <= me && me < this.chunk.length) q = this.pos + q, me = this.chunk.charCodeAt(me);
      else {
        if (q = this.resolveOffset(q, 1), q == null) return -1;
        if (q >= this.chunk2Pos && q < this.chunk2Pos + this.chunk2.length) me = this.chunk2.charCodeAt(q - this.chunk2Pos);
        else {
          me = this.rangeIndex;
          let Ae = this.range;
          for (; Ae.to <= q; ) Ae = this.ranges[++me];
          this.chunk2 = this.input.chunk(this.chunk2Pos = q), q + this.chunk2.length > Ae.to && (this.chunk2 = this.chunk2.slice(0, Ae.to - q)), me = this.chunk2.charCodeAt(0);
        }
      }
      return q >= this.token.lookAhead && (this.token.lookAhead = q + 1), me;
    }
    acceptToken(q, me = 0) {
      if (me = me ? this.resolveOffset(me, -1) : this.pos, me == null || me < this.token.start) throw new RangeError("Token end out of bounds");
      this.token.value = q, this.token.end = me;
    }
    getChunk() {
      if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
        let { chunk: q, chunkPos: me } = this;
        this.chunk = this.chunk2, this.chunkPos = this.chunk2Pos, this.chunk2 = q, this.chunk2Pos = me, this.chunkOff = this.pos - this.chunkPos;
      } else {
        this.chunk2 = this.chunk, this.chunk2Pos = this.chunkPos;
        let q = this.input.chunk(this.pos);
        this.chunk = this.pos + q.length > this.range.to ? q.slice(0, this.range.to - this.pos) : q, this.chunkPos = this.pos, this.chunkOff = 0;
      }
    }
    readNext() {
      return this.chunkOff >= this.chunk.length && (this.getChunk(), this.chunkOff == this.chunk.length) ? this.next = -1 : this.next = this.chunk.charCodeAt(this.chunkOff);
    }
    advance(q = 1) {
      for (this.chunkOff += q; this.pos + q >= this.range.to; ) {
        if (this.rangeIndex == this.ranges.length - 1) return this.setDone();
        q -= this.range.to - this.pos, this.range = this.ranges[++this.rangeIndex], this.pos = this.range.from;
      }
      return this.pos += q, this.pos >= this.token.lookAhead && (this.token.lookAhead = this.pos + 1), this.readNext();
    }
    setDone() {
      return this.pos = this.chunkPos = this.end, this.range = this.ranges[this.rangeIndex = this.ranges.length - 1], this.chunk = "", this.next = -1;
    }
    reset(q, me) {
      if (me ? (this.token = me, me.start = q, me.lookAhead = q + 1, me.value = me.extended = -1) : this.token = we, this.pos != q) {
        if (this.pos = q, q == this.end) return this.setDone(), this;
        for (; q < this.range.from; ) this.range = this.ranges[--this.rangeIndex];
        for (; q >= this.range.to; ) this.range = this.ranges[++this.rangeIndex];
        q >= this.chunkPos && q < this.chunkPos + this.chunk.length ? this.chunkOff = q - this.chunkPos : (this.chunk = "", this.chunkOff = 0), this.readNext();
      }
      return this;
    }
    read(q, me) {
      if (q >= this.chunkPos && me <= this.chunkPos + this.chunk.length) return this.chunk.slice(q - this.chunkPos, me - this.chunkPos);
      if (q >= this.chunk2Pos && me <= this.chunk2Pos + this.chunk2.length) return this.chunk2.slice(q - this.chunk2Pos, me - this.chunk2Pos);
      if (q >= this.range.from && me <= this.range.to) return this.input.read(q, me);
      let Ae = "";
      for (let Fe of this.ranges) {
        if (Fe.from >= me) break;
        Fe.to > q && (Ae += this.input.read(Math.max(Fe.from, q), Math.min(Fe.to, me)));
      }
      return Ae;
    }
  }
  class xe {
    constructor(q, me) {
      this.data = q, this.id = me;
    }
    token(q, me) {
      let { parser: Ae } = me.p;
      u(this.data, q, me, this.id, Ae.data, Ae.tokenPrecTable);
    }
  }
  xe.prototype.contextual = xe.prototype.fallback = xe.prototype.extend = !1;
  class $e {
    constructor(q, me, Ae) {
      this.precTable = me, this.elseToken = Ae, this.data = typeof q == "string" ? r(q) : q;
    }
    token(q, me) {
      let Ae = q.pos, Fe = 0;
      for (; ; ) {
        let ln = 0 > q.next, Be = q.resolveOffset(1, 1);
        if (u(this.data, q, me, 0, this.data, this.precTable), -1 < q.token.value) break;
        if (this.elseToken == null) return;
        if (ln || Fe++, Be == null) break;
        q.reset(Be, q.token);
      }
      Fe && (q.reset(Ae, q.token), q.acceptToken(this.elseToken, Fe));
    }
  }
  $e.prototype.contextual = xe.prototype.fallback = xe.prototype.extend = !1;
  class je {
    constructor(q, me = {}) {
      this.token = q, this.contextual = !!me.contextual, this.fallback = !!me.fallback, this.extend = !!me.extend;
    }
  }
  const E = typeof e < "u" && e.env && /\bparse\b/.test(e.env.LOG);
  let P = null;
  class K {
    constructor(q, me) {
      this.fragments = q, this.nodeSet = me, this.i = 0, this.fragment = null, this.safeTo = this.safeFrom = -1, this.trees = [], this.start = [], this.index = [], this.nextFragment();
    }
    nextFragment() {
      let q = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
      if (q) {
        for (this.safeFrom = q.openStart ? a(q.tree, q.from + q.offset, 1) - q.offset : q.from, this.safeTo = q.openEnd ? a(q.tree, q.to + q.offset, -1) - q.offset : q.to; this.trees.length; ) this.trees.pop(), this.start.pop(), this.index.pop();
        this.trees.push(q.tree), this.start.push(-q.offset), this.index.push(0), this.nextStart = this.safeFrom;
      } else this.nextStart = 1e9;
    }
    nodeAt(q) {
      if (q < this.nextStart) return null;
      for (; this.fragment && this.safeTo <= q; ) this.nextFragment();
      if (!this.fragment) return null;
      for (; ; ) {
        let Fe = this.trees.length - 1;
        if (0 > Fe) return this.nextFragment(), null;
        var me = this.trees[Fe], Ae = this.index[Fe];
        if (Ae == me.children.length) {
          this.trees.pop(), this.start.pop(), this.index.pop();
          continue;
        }
        let ln = me.children[Ae];
        if (me = this.start[Fe] + me.positions[Ae], me > q) return this.nextStart = me, null;
        if (ln instanceof _.Tree) {
          if (me == q) {
            if (me < this.safeFrom) return null;
            if (Ae = me + ln.length, Ae <= this.safeTo) {
              let Be = ln.prop(_.NodeProp.lookAhead);
              if (!Be || Ae + Be < this.fragment.to) return ln;
            }
          }
          this.index[Fe]++, me + ln.length >= Math.max(this.safeFrom, q) && (this.trees.push(ln), this.start.push(me), this.index.push(0));
        } else this.index[Fe]++, this.nextStart = me + ln.length;
      }
    }
  }
  class H {
    constructor(q, me) {
      this.stream = me, this.tokens = [], this.mainToken = null, this.actions = [], this.tokens = q.tokenizers.map((Ae) => new J());
    }
    getActions(q) {
      let me = 0, Ae = null;
      var { parser: Fe } = q.p;
      let { tokenizers: ln } = Fe;
      Fe = Fe.stateSlot(q.state, 3);
      let Be = q.curContext ? q.curContext.hash : 0, Ze = 0;
      for (let pn = 0; pn < ln.length; pn++) {
        if (!(1 << pn & Fe)) continue;
        let xn = ln[pn], Nn = this.tokens[pn];
        if ((!Ae || xn.fallback) && ((xn.contextual || Nn.start != q.pos || Nn.mask != Fe || Nn.context != Be) && (this.updateCachedToken(Nn, xn, q), Nn.mask = Fe, Nn.context = Be), Nn.lookAhead > Nn.end + 25 && (Ze = Math.max(Nn.lookAhead, Ze)), Nn.value != 0)) {
          let at = me;
          if (-1 < Nn.extended && (me = this.addActions(q, Nn.extended, Nn.end, me)), me = this.addActions(q, Nn.value, Nn.end, me), !xn.extend && (Ae = Nn, me > at)) break;
        }
      }
      for (; this.actions.length > me; ) this.actions.pop();
      return Ze && q.setLookAhead(Ze), Ae || q.pos != this.stream.end || (Ae = new J(), Ae.value = q.p.parser.eofTerm, Ae.start = Ae.end = q.pos, this.addActions(q, Ae.value, Ae.end, me)), this.mainToken = Ae, this.actions;
    }
    getMainToken(q) {
      if (this.mainToken) return this.mainToken;
      let me = new J(), { pos: Ae, p: Fe } = q;
      return me.start = Ae, me.end = Math.min(Ae + 1, Fe.stream.end), me.value = Ae == Fe.stream.end ? Fe.parser.eofTerm : 0, me;
    }
    updateCachedToken(q, me, Ae) {
      var Fe = this.stream.clipPos(Ae.pos);
      if (me.token(this.stream.reset(Fe, q), Ae), -1 < q.value) {
        for ({ parser: me } = Ae.p, Fe = 0; Fe < me.specialized.length; Fe++)
          if (me.specialized[Fe] == q.value) {
            let ln = me.specializers[Fe](this.stream.read(q.start, q.end), Ae);
            if (0 <= ln && Ae.p.parser.dialect.allows(ln >> 1)) {
              ln & 1 ? q.extended = ln >> 1 : q.value = ln >> 1;
              break;
            }
          }
      } else q.value = 0, q.end = this.stream.clipPos(Fe + 1);
    }
    putAction(q, me, Ae, Fe) {
      for (let ln = 0; ln < Fe; ln += 3) if (this.actions[ln] == q) return Fe;
      return this.actions[Fe++] = q, this.actions[Fe++] = me, this.actions[Fe++] = Ae, Fe;
    }
    addActions(q, me, Ae, Fe) {
      let { state: ln } = q;
      ({ parser: q } = q.p);
      let { data: Be } = q;
      for (let Ze = 0; 2 > Ze; Ze++) for (let pn = q.stateSlot(ln, Ze ? 2 : 1); ; pn += 3) {
        if (Be[pn] == 65535) if (Be[pn + 1] == 1) pn = s(Be, pn + 2);
        else {
          Fe == 0 && Be[pn + 1] == 2 && (Fe = this.putAction(s(Be, pn + 2), me, Ae, Fe));
          break;
        }
        Be[pn] == me && (Fe = this.putAction(s(Be, pn + 1), me, Ae, Fe));
      }
      return Fe;
    }
  }
  class U {
    constructor(q, me, Ae, Fe) {
      this.parser = q, this.input = me, this.ranges = Fe, this.recovering = 0, this.nextStackID = 9812, this.minStackPos = 0, this.reused = [], this.stoppedAt = null, this.lastBigReductionStart = -1, this.bigReductionCount = this.lastBigReductionSize = 0, this.stream = new ce(me, Fe), this.tokens = new H(q, this.stream), this.topTerm = q.top[1], { from: me } = Fe[0], this.stacks = [R.start(this, q.top[0], me)], this.fragments = Ae.length && this.stream.end - me > 4 * q.bufferLength ? new K(Ae, q.nodeSet) : null;
    }
    get parsedPos() {
      return this.minStackPos;
    }
    advance() {
      var q = this.stacks;
      let me = this.minStackPos, Ae = this.stacks = [];
      if (300 < this.bigReductionCount && q.length == 1) {
        for (var [Fe] = q; Fe.forceReduce() && Fe.stack.length && Fe.stack[Fe.stack.length - 2] >= this.lastBigReductionStart; ) ;
        this.bigReductionCount = this.lastBigReductionSize = 0;
      }
      for (Fe = 0; Fe < q.length; Fe++) for (var ln = q[Fe]; ; ) {
        if (this.tokens.mainToken = null, ln.pos > me) Ae.push(ln);
        else {
          if (this.advanceStack(ln, Ae, q)) continue;
          if (!Be)
            var Be = [], Ze = [];
          Be.push(ln), ln = this.tokens.getMainToken(ln), Ze.push(ln.value, ln.end);
        }
        break;
      }
      if (!Ae.length) {
        if (q = Be && d(Be)) return E && console.log("Finish with " + this.stackID(q)), this.stackToTree(q);
        if (this.parser.strict) throw E && Be && console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none")), new SyntaxError("No parse at " + me);
        this.recovering || (this.recovering = 5);
      }
      if (this.recovering && Be && (Be = this.stoppedAt != null && Be[0].pos > this.stoppedAt ? Be[0] : this.runRecovery(Be, Ze, Ae))) return E && console.log("Force-finish " + this.stackID(Be)), this.stackToTree(Be.forceAll());
      if (this.recovering) {
        if (Be = this.recovering == 1 ? 1 : 3 * this.recovering, Ae.length > Be) for (Ae.sort((pn, xn) => xn.score - pn.score); Ae.length > Be; ) Ae.pop();
        Ae.some((pn) => pn.reducePos > me) && this.recovering--;
      } else if (1 < Ae.length) {
        e: for (Be = 0; Be < Ae.length - 1; Be++) for (Ze = Ae[Be], q = Be + 1; q < Ae.length; q++) if (Fe = Ae[q], Ze.sameState(Fe) || 500 < Ze.buffer.length && 500 < Fe.buffer.length) if (0 < (Ze.score - Fe.score || Ze.buffer.length - Fe.buffer.length)) Ae.splice(q--, 1);
        else {
          Ae.splice(Be--, 1);
          continue e;
        }
        12 < Ae.length && Ae.splice(12, Ae.length - 12);
      }
      for (this.minStackPos = Ae[0].pos, Be = 1; Be < Ae.length; Be++) Ae[Be].pos < this.minStackPos && (this.minStackPos = Ae[Be].pos);
      return null;
    }
    stopAt(q) {
      if (this.stoppedAt != null && this.stoppedAt < q) throw new RangeError("Can't move stoppedAt forward");
      this.stoppedAt = q;
    }
    advanceStack(q, me, Ae) {
      let Fe = q.pos, { parser: ln } = this, Be = E ? this.stackID(q) + " -> " : "";
      if (this.stoppedAt != null && Fe > this.stoppedAt) return q.forceReduce() ? q : null;
      if (this.fragments)
        for (var Ze = q.curContext && q.curContext.tracker.strict, pn = Ze ? q.curContext.hash : 0, xn = this.fragments.nodeAt(Fe); xn; ) {
          var Nn = this.parser.nodeSet.types[xn.type.id] == xn.type ? ln.getGoto(q.state, xn.type.id) : -1;
          if (-1 < Nn && xn.length && (!Ze || (xn.prop(_.NodeProp.contextHash) || 0) == pn)) return q.useNode(xn, Nn), E && console.log(Be + this.stackID(q) + ` (via reuse of ${ln.getName(xn.type.id)})`), !0;
          if (!(xn instanceof _.Tree) || xn.children.length == 0 || 0 < xn.positions[0]) break;
          if (Nn = xn.children[0], Nn instanceof _.Tree && xn.positions[0] == 0) xn = Nn;
          else break;
        }
      if (Ze = ln.stateSlot(q.state, 4), 0 < Ze) return q.reduce(Ze), E && console.log(Be + this.stackID(q) + ` (via always-reduce ${ln.getName(Ze & 65535)})`), !0;
      if (9e3 <= q.stack.length) for (; 6e3 < q.stack.length && q.forceReduce(); ) ;
      for (Ze = this.tokens.getActions(q), pn = 0; pn < Ze.length; ) {
        xn = Ze[pn++], Nn = Ze[pn++];
        let at = Ze[pn++], Yt = pn == Ze.length || !Ae, jt = Yt ? q : q.split(), Cl = this.tokens.mainToken;
        if (jt.apply(xn, Nn, Cl ? Cl.start : jt.pos, at), E && console.log(Be + this.stackID(jt) + ` (via ${xn & 65536 ? `reduce of ${ln.getName(xn & 65535)}` : "shift"} for ${ln.getName(Nn)} @ ${Fe}${jt == q ? "" : ", split"})`), Yt) return !0;
        jt.pos > Fe ? me.push(jt) : Ae.push(jt);
      }
      return !1;
    }
    advanceFully(q, me) {
      let Ae = q.pos;
      for (; ; ) {
        if (!this.advanceStack(q, null, null)) return !1;
        if (q.pos > Ae) return h(q, me), !0;
      }
    }
    runRecovery(q, me, Ae) {
      let Fe = null, ln = !1;
      for (let Be = 0; Be < q.length; Be++) {
        let Ze = q[Be], pn = me[Be << 1], xn = me[(Be << 1) + 1], Nn = E ? this.stackID(Ze) + " -> " : "";
        if (Ze.deadEnd && (ln || (ln = !0, Ze.restart(), E && console.log(Nn + this.stackID(Ze) + " (restarted)"), this.advanceFully(Ze, Ae))))
          continue;
        let at = Ze.split(), Yt = Nn;
        for (let jt = 0; at.forceReduce() && 10 > jt && (E && console.log(Yt + this.stackID(at) + " (via force-reduce)"), !this.advanceFully(at, Ae)); jt++)
          E && (Yt = this.stackID(at) + " -> ");
        for (let jt of Ze.recoverByInsert(pn)) E && console.log(Nn + this.stackID(jt) + " (via recover-insert)"), this.advanceFully(jt, Ae);
        this.stream.end > Ze.pos ? (xn == Ze.pos && (xn++, pn = 0), Ze.recoverByDelete(pn, xn), E && console.log(Nn + this.stackID(Ze) + ` (via recover-delete ${this.parser.getName(pn)})`), h(Ze, Ae)) : (!Fe || Fe.score < Ze.score) && (Fe = Ze);
      }
      return Fe;
    }
    stackToTree(q) {
      return q.close(), _.Tree.build({ buffer: G.create(q), nodeSet: this.parser.nodeSet, topID: this.topTerm, maxBufferLength: this.parser.bufferLength, reused: this.reused, start: this.ranges[0].from, length: q.pos - this.ranges[0].from, minRepeatType: this.parser.minRepeatTerm });
    }
    stackID(q) {
      let me = (P ||= /* @__PURE__ */ new WeakMap()).get(q);
      return me || P.set(q, me = String.fromCodePoint(this.nextStackID++)), me + q;
    }
  }
  class Me {
    constructor(q, me, Ae) {
      this.source = q, this.flags = me, this.disabled = Ae;
    }
    allows(q) {
      return !this.disabled || this.disabled[q] == 0;
    }
  }
  const le = (B) => B;
  class Ce {
    constructor(q) {
      this.start = q.start, this.shift = q.shift || le, this.reduce = q.reduce || le, this.reuse = q.reuse || le, this.hash = q.hash || (() => 0), this.strict = q.strict !== !1;
    }
  }
  class Ye extends _.Parser {
    constructor(q) {
      function me(xn, Nn, at) {
        Be[xn].push([Nn, Nn.deserialize(String(at))]);
      }
      if (super(), this.wrappers = [], q.version != 14) throw new RangeError(`Parser version (${q.version}) doesn't match runtime version (14)`);
      var Ae = q.nodeNames.split(" ");
      this.minRepeatTerm = Ae.length;
      for (var Fe = 0; Fe < q.repeatNodeCount; Fe++) Ae.push("");
      let ln = Object.keys(q.topRules).map((xn) => q.topRules[xn][1]), Be = [];
      for (Fe = 0; Fe < Ae.length; Fe++) Be.push([]);
      if (q.nodeProps) for (let xn of q.nodeProps) {
        Fe = xn[0], typeof Fe == "string" && (Fe = _.NodeProp[Fe]);
        for (let Nn = 1; Nn < xn.length; ) {
          var Ze = xn[Nn++];
          if (0 <= Ze) me(Ze, Fe, xn[Nn++]);
          else {
            let at = xn[Nn + -Ze];
            for (Ze = -Ze; 0 < Ze; Ze--) me(xn[Nn++], Fe, at);
            Nn++;
          }
        }
      }
      this.nodeSet = new _.NodeSet(Ae.map((xn, Nn) => _.NodeType.define({
        name: Nn >= this.minRepeatTerm ? void 0 : xn,
        id: Nn,
        props: Be[Nn],
        top: -1 < ln.indexOf(Nn),
        error: Nn == 0,
        skipped: q.skippedNodes && -1 < q.skippedNodes.indexOf(Nn)
      }))), q.propSources && (this.nodeSet = this.nodeSet.extend(...q.propSources)), this.strict = !1, this.bufferLength = _.DefaultBufferLength;
      let pn = r(q.tokenData);
      for (this.context = q.context, this.specializerSpecs = q.specialized || [], this.specialized = new Uint16Array(this.specializerSpecs.length), Ae = 0; Ae < this.specializerSpecs.length; Ae++) this.specialized[Ae] = this.specializerSpecs[Ae].term;
      this.specializers = this.specializerSpecs.map(p), this.states = r(q.states, Uint32Array), this.data = r(q.stateData), this.goto = r(q.goto), this.maxTerm = q.maxTerm, this.tokenizers = q.tokenizers.map((xn) => typeof xn == "number" ? new xe(pn, xn) : xn), this.topRules = q.topRules, this.dialects = q.dialects || {}, this.dynamicPrecedences = q.dynamicPrecedences || null, this.tokenPrecTable = q.tokenPrec, this.termNames = q.termNames || null, this.maxNode = this.nodeSet.types.length - 1, this.dialect = this.parseDialect(), this.top = this.topRules[Object.keys(this.topRules)[0]];
    }
    createParse(q, me, Ae) {
      let Fe = new U(this, q, me, Ae);
      for (let ln of this.wrappers) Fe = ln(Fe, q, me, Ae);
      return Fe;
    }
    getGoto(q, me, Ae = !1) {
      let Fe = this.goto;
      if (me >= Fe[0]) return -1;
      for (me = Fe[me + 1]; ; ) {
        var ln = Fe[me++];
        let Be = ln & 1, Ze = Fe[me++];
        if (Be && Ae) return Ze;
        for (ln = me + (ln >> 1); me < ln; me++) if (Fe[me] == q) return Ze;
        if (Be) return -1;
      }
    }
    hasAction(q, me) {
      let Ae = this.data;
      for (let Fe = 0; 2 > Fe; Fe++) for (let ln = this.stateSlot(q, Fe ? 2 : 1), Be; ; ln += 3) {
        if ((Be = Ae[ln]) == 65535) if (Ae[ln + 1] == 1) Be = Ae[ln = s(Ae, ln + 2)];
        else {
          if (Ae[ln + 1] == 2) return s(Ae, ln + 2);
          break;
        }
        if (Be == me || Be == 0) return s(Ae, ln + 1);
      }
      return 0;
    }
    stateSlot(q, me) {
      return this.states[6 * q + me];
    }
    stateFlag(q, me) {
      return 0 < (this.stateSlot(q, 0) & me);
    }
    validAction(q, me) {
      return !!this.allActions(q, (Ae) => Ae == me ? !0 : null);
    }
    allActions(q, me) {
      var Ae = this.stateSlot(q, 4);
      for (Ae = Ae ? me(Ae) : void 0, q = this.stateSlot(q, 1); Ae == null; q += 3) {
        if (this.data[q] == 65535) if (this.data[q + 1] == 1) q = s(this.data, q + 2);
        else break;
        Ae = me(s(this.data, q + 1));
      }
      return Ae;
    }
    nextStates(q) {
      let me = [];
      for (q = this.stateSlot(q, 1); ; q += 3) {
        if (this.data[q] == 65535) if (this.data[q + 1] == 1) q = s(this.data, q + 2);
        else break;
        if (!(this.data[q + 2] & 1)) {
          let Ae = this.data[q + 1];
          me.some((Fe, ln) => ln & 1 && Fe == Ae) || me.push(this.data[q], Ae);
        }
      }
      return me;
    }
    configure(q) {
      let me = Object.assign(Object.create(Ye.prototype), this);
      if (q.props && (me.nodeSet = this.nodeSet.extend(...q.props)), q.top) {
        let Ae = this.topRules[q.top];
        if (!Ae) throw new RangeError(`Invalid top rule name ${q.top}`);
        me.top = Ae;
      }
      return q.tokenizers && (me.tokenizers = this.tokenizers.map((Ae) => {
        let Fe = q.tokenizers.find((ln) => ln.from == Ae);
        return Fe ? Fe.to : Ae;
      })), q.specializers && (me.specializers = this.specializers.slice(), me.specializerSpecs = this.specializerSpecs.map((Ae, Fe) => {
        var ln = q.specializers.find((Be) => Be.from == Ae.external);
        return ln ? (ln = Object.assign(Object.assign({}, Ae), { external: ln.to }), me.specializers[Fe] = p(ln), ln) : Ae;
      })), q.contextTracker && (me.context = q.contextTracker), q.dialect && (me.dialect = this.parseDialect(q.dialect)), q.strict != null && (me.strict = q.strict), q.wrap && (me.wrappers = me.wrappers.concat(q.wrap)), q.bufferLength != null && (me.bufferLength = q.bufferLength), me;
    }
    hasWrappers() {
      return 0 < this.wrappers.length;
    }
    getName(q) {
      return this.termNames ? this.termNames[q] : String(q <= this.maxNode && this.nodeSet.types[q].name || q);
    }
    get eofTerm() {
      return this.maxNode + 1;
    }
    get topNode() {
      return this.nodeSet.types[this.top[1]];
    }
    dynamicPrecedence(q) {
      let me = this.dynamicPrecedences;
      return me == null ? 0 : me[q] || 0;
    }
    parseDialect(q) {
      let me = Object.keys(this.dialects), Ae = me.map(() => !1);
      if (q) for (var Fe of q.split(" ")) {
        var ln = me.indexOf(Fe);
        0 <= ln && (Ae[ln] = !0);
      }
      for (Fe = null, ln = 0; ln < me.length; ln++) if (!Ae[ln]) for (let Be = this.dialects[me[ln]], Ze; (Ze = this.data[Be++]) != 65535; ) (Fe ||= new Uint8Array(this.maxTerm + 1))[Ze] = 1;
      return new Me(q, Ae, Fe);
    }
    static deserialize(q) {
      return new Ye(q);
    }
  }
  l.ContextTracker = Ce, l.ExternalTokenizer = je, l.InputStream = ce, l.LRParser = Ye, l.LocalTokenGroup = $e, l.Stack = R;
};
Xo[11] = function(e, n, t, l) {
  Object.defineProperty(l, "__esModule", { value: !0 }), e = n(10);
  var r = n(4), u = () => new r.NodeProp({ deserialize: (d) => !0 });
  n = u(), t = u();
  const o = u(), a = u(), h = u();
  u = Object.freeze({ __proto__: null, coll: n, prefixColl: t, prefixEdge: o, sameEdge: a, prefixContainer: h });
  const s = { __proto__: null, true: 136, false: 136, nil: 138, def: 147, defn: 147, "defn-": 147, defmacro: 147, definline: 147, defonce: 147, deftest: 147, defcard: 147, ns: 155 };
  e = e.LRParser.deserialize({
    version: 14,
    states: "-zQ]QPOOP!pOPOOOOQO'#C`'#C`OOQO'#Cb'#CbO]QPO'#CcO]QPO'#CeO]QPO'#CgO]QPO'#CiO]QPO'#CkO]OPO'#CtO]OPO'#CvO!uOQO'#C|OOQO'#Dm'#DmQ]QPOOO$hQPO'#CqO$oQPO'#DUO$vQPO'#DXO$}OSO'#DZO%cOPO'#D]O%hOPO'#D`O%mOPO'#DbO%uOWO'#DdO]QPO'#DgO]QPO'#DhO%zQPO'#DjOOQO'#Dq'#DqP&SQPO'#C^POOO)C?e)C?eOOQO,58},58}OOQO,59P,59POOQO,59R,59ROOQO,59T,59TOOQO,59V,59VOOQO,59`,59`OOQO,59b,59bOOQO,59h,59hO'gOPO,59hOOQO-E7k-E7kOOQO'#Cr'#CrO!}QPO'#CsOOQO'#Dv'#DvO'lQPO'#D|O'sQPO'#DuOOQO'#DO'#DOOOQO'#Dz'#DzO'sQPO'#DyOOQO'#DQ'#DQOOQO'#D}'#D}O'lQPO'#D|OOQO'#Dt'#DtO(OQPO,59]O(TQPO,59pOOQO,59p,59pO([QPO,59sOOQO,59s,59sOOQO,59u,59uOOOO,59x,59xOOQO,59y,59yOOQO,5:Q,5:QOOQO,5:T,5:TOOQO,5:V,5:VOOQO,59w,59wOOQO,59z,59zOOQO,59|,59|OOQO,5:O,5:OOOQO,5:R,5:ROOQO,5:S,5:SOOQO,5:U,5:UPOOO,58x,58xOOQO1G/S1G/SOOQO,59_,59_OOQO,59k,59kOOQO,59m,59mOOQO'#Cx'#CxO'sQPO'#CyOOQO'#Dx'#DxO(cQPO,5:aO(jQPO,5:eO(qQPO,5:hOOQO1G.w1G.wOOQO1G/[1G/[OOQO1G/_1G/_OOQO,59e,59eO(xQPO'#CzO*`QPO1G/{O]QPO1G/{OOQO'#Cz'#CzO*gQPO1G0PO*gQPO1G0PO*nQPO7+%gO*uQPO7+%kP&SQPO'#CcP&SQPO'#CeP&SQPO'#CgP&SQPO'#CiP&SQPO'#CkP*|OPO'#DbP&SQPO'#DgP&SQPO'#Dh",
    stateData: "+[~O!dOSPOSRPQ~OTiOWSOYTO[UO^VO`WOaiObiOd^OiXOkYOoZOw_Oz`O|iO!OaO!TcO!VdO!XeO!fQO!gRO~ORjO~OosOqtO~OT!OOWSOYTO[UO^VO`WOaiObiOd^OiXOkYOoZOw_Oz`O|iO!OaO!TcO!VdO!XeO!fQO!gRO!kvO!o{O~Oc!pP~P!}Ov!UO~P]Oy!WO~P]Od^OoZOz`O!r!YO!t!]O!u!^O~Oz`O~OT!`O~OWSOd^O~O!s!bO~Ow_Oz`O~OTiOW!}OY#OO[#PO^#QO`#ROaiObiOd^OiXOkYOoZOw_Oz`O|iO!OaO!TcO!V#SO!XeO!fQO!gRO~Oo!gO~Oc!pX~P]OT!kOiXOkYO~Oc!qO~Ov!rO~P]Oy!sO~P]Oc!ia~P]Oc!ma~P]Oc!pa~P]OTnXWnXYnX[nX^nX`nXanXbnXc!eXdnXinXknXonXwnXznX|nX!OnX!TnX!VnX!XnX!fnX!gnX~Oc!ii~P]Oc!mi~P]Oc!iq~P]Oc!mq~P]OW!}Od^O~Oa!u!tT!t~",
    goto: "/]!rPP!sP!vP!v#nP!vP!vP!vP!vPPPPP$j%i%i%mP%mP&n&n&sP&yP'x'x'|'|PP(QPP({P!vP!v)|!v!vP!vP!vP!v!v!v*t!v+nP,fPPP-^PP.j.m.pP.v.m/PP.m/VRkP!kiOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#U!jiOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#UT!ad#S!jiOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#UQ![aT!ad#STx^w!UfOSTUVWXY]_`fgy!Q!T!V!n!o!p!v!w!y!z!{!|Sw^wU!lz}!la#Tj!}#O#P#Q#R#T#UV!mz}!lQ!w!nR!z!o!fiOSTUVWXY]^_`fgjwy!Q!T!V!p!v!w!y!z!{!|!}#O#P#Q#R#T#UQ!ZaQ!u!nR!x!oT|^wT!P^w!jiOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#UR!eh!jiOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#UQ!XaQ!_bR!eh!kbOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#U!YgOSTUVWXY]^_`fgwy!Q!T!V!n!o!p!v!w!y!z!{!|a#Uj!}#O#P#Q#R#T#U!khOSTUVWXY]^_`fgjwy!Q!T!V!n!o!p!v!w!y!z!{!|!}#O#P#Q#R#T#UQ]Obu]y!T!V!p!v!y!{!|Qy^Q!T_Q!V`Q!p!QQ!v!nQ!y!oQ!{!wR!|!zt[O]^_`y!Q!T!V!n!o!p!v!w!y!z!{!|SlS!}SmT#OSnU#PSoV#QSpW#RQqXQrYU!cfw#TS!dg#UR!fjR!S^R!R^Qz^R!hwQ!nzQ!o}R!t!lQ}^R!iwQ!Q^R!jw",
    nodeNames: "⚠ LineComment Discard #_ Boolean Symbol Nil Deref @ Quote ' SyntaxQuote ` Unquote ~ UnquoteSplice ~@ Number Keyword ) ( List DefLike Meta Metadata ^ ReaderMetadata #^ VarName Meta DocString \" String StringContent NS Meta Operator Meta ] [ Vector } { Map Character Set # NamespacedMap KeywordPrefix RegExp Var #' ReaderConditional #? SymbolicValue ## AnonymousFunction Meta TaggedLiteral ReaderTag ConstructorCall ConstructorPrefix Program",
    maxTerm: 83,
    nodeProps: [[
      o,
      -14,
      3,
      8,
      10,
      12,
      14,
      16,
      25,
      27,
      46,
      48,
      51,
      53,
      55,
      61,
      ""
    ], [t, -13, 7, 9, 11, 13, 15, 24, 26, 45, 47, 49, 50, 52, 56, ""], ["openedBy", 19, "(", 31, '"', 38, "[", 41, "{"], ["closedBy", 20, ")", 31, '"', 39, "]", 42, "}"], [n, -3, 21, 40, 43, ""], [h, -7, 23, 29, 35, 37, 57, 58, 60, ""], [a, 31, ""]],
    skippedNodes: [0, 1, 2, 3],
    repeatNodeCount: 1,
    tokenData: "#6x~R![OX$wX^%n^p$wpq%nqr'grs,Tst,Ytu/Yuv'gvw'gwx6Vxy6jyz6}z{'g{|7b|}%n}!O7b!O!P9t!P!Q)v!Q!R!8[!R![!>t![!]!Cp!]!^!J]!^!_'g!_!`'g!`!a'g!a!b'g!b!c!Kr!c!}/Y!}#O!LV#O#P!Lj#P#Q#3w#Q#R#4[#R#S/Y#S#T#4o#T#o/Y#o#p#5S#p#q$w#q#r#5g#r#s#5z#s#y$w#y#z%n#z$f$w$f$g%n$g##l/Y##l#BY$w#BY#BZ%n#BZ$IS$w$IS$I_%n$I_$I|$w$I|$JO%n$JO$JT$w$JT$JU%n$JU$KV$w$KV$KW%n$KW&FU$w&FU&FV%n&FV~$wQ$|SqQOr$ws#O$w#O#P%Y#P~$wQ%_TqQOr$wrs$ws#O$w#O#P%Y#P~$wR%ujqQ!dPOX$wX^%n^p$wpq%nqr$ws|$w|}%n}#O$w#O#P%Y#P#y$w#y#z%n#z$f$w$f$g%n$g#BY$w#BY#BZ%n#BZ$IS$w$IS$I_%n$I_$I|$w$I|$JO%n$JO$JT$w$JT$JU%n$JU$KV$w$KV$KW%n$KW&FU$w&FU&FV%n&FV~$w_'rpqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q!['g![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$wZ*PpqQ!sWTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![)v![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$w~,YOo~R,a[!OPqQOr$wst-Vtw$wwx-jx!a$w!a!b-}!b#O$w#O#P%Y#P#Q$w#Q#R.b#R#S.u#S~$wR-^S!XPqQOr$ws#O$w#O#P%Y#P~$wR-qS!TPqQOr$ws#O$w#O#P%Y#P~$wR.US!VPqQOr$ws#O$w#O#P%Y#P~$wR.iSkPqQOr$ws#O$w#O#P%Y#P~$wR.|SRPqQOr$ws#O$w#O#P%Y#P~$w_/epqQ!sW!tSTPOq$wqr'gst)vtu/Yuv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P1i!P!Q'g!Q![/Y![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}/Y!}#O$w#O#P%Y#P#R$w#R#S/Y#S#T$w#T#o/Y#o$g$w$g##l/Y##l~$w_1rpqQ!sWTPOq$wqr)vst)vtu3vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![)v![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!}3v!}#O$w#O#P%Y#P#R$w#R#S3v#S#T$w#T#o3v#o$g$w$g##l3v##l~$w_4RpqQ!sW!uSTPOq$wqr)vst)vtu3vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P1i!P!Q)v!Q![3v![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!}3v!}#O$w#O#P%Y#P#R$w#R#S3v#S#T$w#T#o3v#o$g$w$g##l3v##l~$wR6^SYPqQOr$ws#O$w#O#P%Y#P~$wV6qSdTqQOr$ws#O$w#O#P%Y#P~$wR7UScPqQOr$ws#O$w#O#P%Y#P~$w_7mqqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P9t!P!Q'g!Q!RHO!R![!&|![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$wZ9}pqQ!sWTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![<R![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$wZ<^tqQ!sWaPTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![<R![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!g)v!g!h>n!h!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#X)v#X#Y>n#Y#o)v#o$g$w$g##l)v##l~$wZ>wpqQ!sWTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|@{|}$w}!O@{!O!P)v!P!Q)v!Q![CY![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$wZAUpqQ!sWTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![CY![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$wZCerqQ!sWaPTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![CY![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!o)v!o!pEo!p!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$wZEzpqQ!sWaPTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![)v![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#o)v#o$g$w$g##l)v##l~$w_H]yqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!PJ|!P!Q!![!Q![!&|![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!g'g!g!h!)t!h!o'g!o!p!0{!p!q!0{!q!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#X'g#X#Y!)t#Y#l'g#l#m!3^#m#o'g#o$g$w$g##l'g##l~$wZKXvqQ!sWaPTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![J|![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!g)v!g!h>n!h!o)v!o!pMo!p!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#X)v#X#Y>n#Y#o)v#o$g$w$g##l)v##l~$wZMztqQ!sWaPTPOq$wqr)vst)vtu)vuv)vvw)vwx)vxz$wz{)v{|)v|}$w}!O)v!O!P)v!P!Q)v!Q![)v![!])v!]!^$w!^!_)v!_!`)v!`!a)v!a!b)v!b!c$w!c!g)v!g!h>n!h!})v!}#O$w#O#P%Y#P#R$w#R#S)v#S#T$w#T#X)v#X#Y>n#Y#o)v#o$g$w$g##l)v##l~$w_!!gpqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!$k![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!$xpqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!$k![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!'ZwqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!PJ|!P!Q!![!Q![!&|![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!g'g!g!h!)t!h!o'g!o!p!0{!p!q!0{!q!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#X'g#X#Y!)t#Y#o'g#o$g$w$g##l'g##l~$w_!*PpqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|!,T|}$w}!O!,T!O!P)v!P!Q'g!Q![!.d![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!,`pqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!.d![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!.qrqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!.d![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!o'g!o!p!0{!p!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!1YpqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q!['g![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#o'g#o$g$w$g##l'g##l~$w_!3irqQ!sW!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!5s![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!i!5s!i!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#Z!5s#Z#o'g#o$g$w$g##l'g##l~$w_!6QrqQ!sWaP!tSTPOq$wqr'gst)vtu'guv'gvw'gwx)vxz$wz{'g{|'g|}$w}!O'g!O!P)v!P!Q'g!Q![!5s![!])v!]!^$w!^!_'g!_!`'g!`!a'g!a!b'g!b!c$w!c!i!5s!i!}'g!}#O$w#O#P%Y#P#R$w#R#S'g#S#T$w#T#Z!5s#Z#o'g#o$g$w$g##l'g##l~$wR!8ceqQaPOr$ws!O$w!O!P!9t!P!Q!=r!Q![!>t![!g$w!g!h!:q!h!o$w!o!p!<n!p!q!<n!q#O$w#O#P%Y#P#U$w#U#V!?z#V#X$w#X#Y!:q#Y#c$w#c#d!AS#d#l$w#l#m!BU#m~$wR!9{[qQaPOr$ws!Q$w!Q![!9t![!g$w!g!h!:q!h!o$w!o!p!=R!p#O$w#O#P%Y#P#X$w#X#Y!:q#Y~$wR!:vYqQOr$ws{$w{|!;f|}$w}!O!;f!O!Q$w!Q![!;}![#O$w#O#P%Y#P~$wR!;kUqQOr$ws!Q$w!Q![!;}![#O$w#O#P%Y#P~$wR!<UWqQaPOr$ws!Q$w!Q![!;}![!o$w!o!p!<n!p#O$w#O#P%Y#P~$wR!<uSqQaPOr$ws#O$w#O#P%Y#P~$wR!=YWqQaPOr$ws!g$w!g!h!:q!h#O$w#O#P%Y#P#X$w#X#Y!:q#Y~$wR!=wUqQOr$ws!Q$w!Q![!>Z![#O$w#O#P%Y#P~$wR!>bUqQaPOr$ws!Q$w!Q![!>Z![#O$w#O#P%Y#P~$wR!>{_qQaPOr$ws!O$w!O!P!9t!P!Q!=r!Q![!>t![!g$w!g!h!:q!h!o$w!o!p!<n!p!q!<n!q#O$w#O#P%Y#P#X$w#X#Y!:q#Y~$wR!@PVqQOr$ws!Q$w!Q!R!@f!R!S!@f!S#O$w#O#P%Y#P~$wR!@mVqQaPOr$ws!Q$w!Q!R!@f!R!S!@f!S#O$w#O#P%Y#P~$wR!AXUqQOr$ws!Q$w!Q!Y!Ak!Y#O$w#O#P%Y#P~$wR!ArUqQaPOr$ws!Q$w!Q!Y!Ak!Y#O$w#O#P%Y#P~$wR!BZYqQOr$ws!Q$w!Q![!By![!c$w!c!i!By!i#O$w#O#P%Y#P#T$w#T#Z!By#Z~$wR!CQYqQaPOr$ws!Q$w!Q![!By![!c$w!c!i!By!i#O$w#O#P%Y#P#T$w#T#Z!By#Z~$wV!CyobPqQ!rSOq$wqr!Ezst$wtu!Ezuv!Ezvw!Ezwz$wz{!Ez{|!Ez|}$w}!O!Ez!O!P!Ez!P!Q!Ez!Q![$w![!]!HX!]!^$w!^!_!Ez!_!`!Ez!`!a!Ez!a!b!Ez!b!c$w!c!}!Ez!}#O$w#O#P%Y#P#R$w#R#S!Ez#S#T$w#T#o!Ez#o$g$w$g##l!Ez##l~$wV!FTpbPqQ!rSOq$wqr!Ezst!Eztu!Ezuv!Ezvw!Ezwx!Ezxz$wz{!Ez{|!Ez|}$w}!O!Ez!O!P!Ez!P!Q!Ez!Q![!Ez![!]!Ez!]!^$w!^!_!Ez!_!`!Ez!`!a!Ez!a!b!Ez!b!c$w!c!}!Ez!}#O$w#O#P%Y#P#R$w#R#S!Ez#S#T$w#T#o!Ez#o$g$w$g##l!Ez##l~$wV!HbmbPqQ!rSOq$wqr!Ezst$wtu!Ezuv!Ezvw!Ezwz$wz{!Ez{|!Ez|}$w}!O!Ez!O!P!Ez!P!Q!Ez!Q!^$w!^!_!Ez!_!`!Ez!`!a!Ez!a!b!Ez!b!c$w!c!}!Ez!}#O$w#O#P%Y#P#R$w#R#S!Ez#S#T$w#T#o!Ez#o$g$w$g##l!Ez##l~$wR!JdVPPqQOY!J]YZ$wZr!J]rs!Jys#O!J]#O#P!KU#P~!J]P!KOQPPOY!JyZ~!JyR!K]VPPqQOY!J]YZ$wZr!J]rs!J]s#O!J]#O#P!KU#P~!J]R!KySWPqQOr$ws#O$w#O#P%Y#P~$wR!L^SwPqQOr$ws#O$w#O#P%Y#P~$wR!LocqQOY!MzYZ$wZr!Mzrs!Mzs#O!Mz#O#P!N_#P#U!Mz#U#V!Nu#V#Y!Mz#Y#Z#$w#Z#b!Mz#b#c#(b#c#d#*{#d#f!Mz#f#g#,m#g#h#/W#h#i#/q#i#j#0s#j~!MzR!NRS|PqQOr$ws#O$w#O#P%Y#P~$wR!NfT|PqQOr$wrs$ws#O$w#O#P%Y#P~$wR!N|U|PqQOr$ws#O$w#O#P%Y#P#T$w#T#U# `#U~$wR# eUqQOr$ws#O$w#O#P%Y#P#V$w#V#W# w#W~$wR# |UqQOr$ws#O$w#O#P%Y#P#_$w#_#`#!`#`~$wR#!eUqQOr$ws#O$w#O#P%Y#P#g$w#g#h#!w#h~$wR#!|UqQOr$ws#O$w#O#P%Y#P#d$w#d#e##`#e~$wR##eUqQOr$ws#O$w#O#P%Y#P#T$w#T#U##w#U~$wR##|UqQOr$ws#O$w#O#P%Y#P#V$w#V#W#$`#W~$wR#$eUqQOr$ws#O$w#O#P%Y#P#X$w#X#Y!Mz#Y~$wR#%OU|PqQOr$ws#O$w#O#P%Y#P#c$w#c#d#%b#d~$wR#%gUqQOr$ws#O$w#O#P%Y#P#f$w#f#g#%y#g~$wR#&OUqQOr$ws#O$w#O#P%Y#P#a$w#a#b#&b#b~$wR#&gUqQOr$ws#O$w#O#P%Y#P#Y$w#Y#Z#&y#Z~$wR#'OUqQOr$ws#O$w#O#P%Y#P#X$w#X#Y#'b#Y~$wR#'gUqQOr$ws#O$w#O#P%Y#P#X$w#X#Y#'y#Y~$wR#(OUqQOr$ws#O$w#O#P%Y#P#W$w#W#X!Mz#X~$wR#(iU|PqQOr$ws#O$w#O#P%Y#P#X$w#X#Y#({#Y~$wR#)QUqQOr$ws#O$w#O#P%Y#P#k$w#k#l#)d#l~$wR#)iUqQOr$ws#O$w#O#P%Y#P#`$w#`#a#){#a~$wR#*QUqQOr$ws#O$w#O#P%Y#P#]$w#]#^#*d#^~$wR#*iUqQOr$ws#O$w#O#P%Y#P#b$w#b#c#$`#c~$wR#+SV|PqQOr$ws!Q$w!Q!U#+i!U!Y#,S!Y#O$w#O#P%Y#P~$wR#+pU|PqQOr$ws!Q$w!Q!Y#,S!Y#O$w#O#P%Y#P~$wR#,ZU|PqQOr$ws!Q$w!Q!Y!Mz!Y#O$w#O#P%Y#P~$wR#,tU|PqQOr$ws#O$w#O#P%Y#P#X$w#X#Y#-W#Y~$wR#-]UqQOr$ws#O$w#O#P%Y#P#h$w#h#i#-o#i~$wR#-tUqQOr$ws#O$w#O#P%Y#P#i$w#i#j#.W#j~$wR#.]UqQOr$ws#O$w#O#P%Y#P#f$w#f#g#.o#g~$wR#.tUqQOr$ws#O$w#O#P%Y#P#b$w#b#c!Mz#c~$wR#/_U|PqQOr$ws#O$w#O#P%Y#P#d$w#d#e##`#e~$wR#/xU|PqQOr$ws#O$w#O#P%Y#P#T$w#T#U#0[#U~$wR#0aUqQOr$ws#O$w#O#P%Y#P#U$w#U#V!Mz#V~$wR#0zY|PqQOr$ws!Q$w!Q![#1j![!c$w!c!i#1j!i#O$w#O#P%Y#P#T$w#T#Z#1j#Z~$wR#1oYqQOr$ws!Q$w!Q![#2_![!c$w!c!i#2_!i#O$w#O#P%Y#P#T$w#T#Z#2_#Z~$wR#2dYqQOr$ws!Q$w!Q![#3S![!c$w!c!i#3S!i#O$w#O#P%Y#P#T$w#T#Z#3S#Z~$wR#3XYqQOr$ws!Q$w!Q![!Mz![!c$w!c!i!Mz!i#O$w#O#P%Y#P#T$w#T#Z!Mz#Z~$wR#4OSvPqQOr$ws#O$w#O#P%Y#P~$wR#4cSiPqQOr$ws#O$w#O#P%Y#P~$wR#4vS[PqQOr$ws#O$w#O#P%Y#P~$wV#5ZSzTqQOr$ws#O$w#O#P%Y#P~$wR#5nSyPqQOr$ws#O$w#O#P%Y#P~$wR#6RU^PqQOr$ws!b$w!b!c#6e!c#O$w#O#P%Y#P~$wR#6lS`PqQOr$ws#O$w#O#P%Y#P~$w",
    tokenizers: [0, 1, 2, 3],
    topRules: { Program: [0, 62] },
    dynamicPrecedences: { 22: 1, 34: 2 },
    specialized: [{ term: 5, get: (d) => s[d] || -1 }],
    tokenPrec: 466
  }), l.parser = e, l.props = u;
};
Xo[12] = function(e, n, t, l) {
  function r(Se, se, Ee) {
    if (Ee.pos == Ee.text.length || Se != se.block && Ee.indent >= se.stack[Ee.depth + 1].value + Ee.baseIndent) return !0;
    if (Ee.indent >= Ee.baseIndent + 4) return !1;
    let Ge = (Se.type == Be.OrderedList ? _ : p)(Ee, se, !1);
    return 0 < Ge && (Se.type != Be.BulletList || 0 > s(Ee, se, !1)) && Ee.text.charCodeAt(Ee.pos + Ge - 1) == Se.value;
  }
  function u(Se) {
    return Se == 32 || Se == 9 || Se == 10 || Se == 13;
  }
  function o(Se, se = 0) {
    for (; se < Se.length && u(Se.charCodeAt(se)); ) se++;
    return se;
  }
  function a(Se, se, Ee) {
    for (; se > Ee && u(Se.charCodeAt(se - 1)); ) se--;
    return se;
  }
  function h(Se) {
    if (Se.next != 96 && Se.next != 126) return -1;
    let se = Se.pos + 1;
    for (; se < Se.text.length && Se.text.charCodeAt(se) == Se.next; ) se++;
    if (se < Se.pos + 3) return -1;
    if (Se.next == 96) {
      for (let Ee = se; Ee < Se.text.length; Ee++) if (Se.text.charCodeAt(Ee) == 96) return -1;
    }
    return se;
  }
  function s(Se, se, Ee) {
    if (Se.next != 42 && Se.next != 45 && Se.next != 95) return -1;
    let Ge = 1;
    for (let vn = Se.pos + 1; vn < Se.text.length; vn++) {
      let Kn = Se.text.charCodeAt(vn);
      if (Kn == Se.next) Ge++;
      else if (!u(Kn)) return -1;
    }
    return Ee && Se.next == 45 && -1 < F(Se) && Se.depth == se.stack.length || 3 > Ge ? -1 : 1;
  }
  function d(Se, se) {
    for (let Ee = Se.stack.length - 1; 0 <= Ee; Ee--) if (Se.stack[Ee].type == se) return !0;
    return !1;
  }
  function p(Se, se, Ee) {
    return Se.next != 45 && Se.next != 43 && Se.next != 42 || Se.pos != Se.text.length - 1 && !u(Se.text.charCodeAt(Se.pos + 1)) || !(!Ee || d(se, Be.BulletList) || Se.skipSpace(Se.pos + 2) < Se.text.length) ? -1 : 1;
  }
  function _(Se, se, Ee) {
    let Ge = Se.pos, vn = Se.next;
    for (; 48 <= vn && 57 >= vn; ) {
      Ge++;
      if (Ge == Se.text.length) return -1;
      vn = Se.text.charCodeAt(Ge);
    }
    return Ge == Se.pos || Ge > Se.pos + 9 || vn != 46 && vn != 41 || Ge < Se.text.length - 1 && !u(Se.text.charCodeAt(Ge + 1)) || Ee && !d(
      se,
      Be.OrderedList
    ) && (Se.skipSpace(Ge + 1) == Se.text.length || Ge > Se.pos + 1 || Se.next != 49) ? -1 : Ge + 1 - Se.pos;
  }
  function R(Se) {
    if (Se.next != 35) return -1;
    let se = Se.pos + 1;
    for (; se < Se.text.length && Se.text.charCodeAt(se) == 35; ) se++;
    return se < Se.text.length && Se.text.charCodeAt(se) != 32 ? -1 : (Se = se - Se.pos, 6 < Se ? -1 : Se);
  }
  function F(Se) {
    if (Se.next != 45 && Se.next != 61 || Se.indent >= Se.baseIndent + 4) return -1;
    let se = Se.pos + 1;
    for (; se < Se.text.length && Se.text.charCodeAt(se) == Se.next; ) se++;
    let Ee = se;
    for (; se < Se.text.length && u(Se.text.charCodeAt(se)); ) se++;
    return se == Se.text.length ? Ee : -1;
  }
  function L(Se, se, Ee) {
    if (Se.next != 60) return -1;
    Se = Se.text.slice(Se.pos);
    for (let Ge = 0, vn = Yt.length - (Ee ? 1 : 0); Ge < vn; Ge++) if (Yt[Ge][0].test(Se)) return Ge;
    return -1;
  }
  function G(Se, se) {
    let Ee = Se.countIndent(se, Se.pos, Se.indent);
    return Se = Se.countIndent(Se.skipSpace(se), se, Ee), Se >= Ee + 5 ? Ee + 1 : Se;
  }
  function J(Se, se, Ee) {
    let Ge = Se.length - 1;
    0 <= Ge && Se[Ge].to == se && Se[Ge].type == Be.CodeText ? Se[Ge].to = Ee : Se.push(E(Be.CodeText, se, Ee));
  }
  function we(Se, se) {
    for (; se < Se.length; se++) {
      let Ee = Se.charCodeAt(se);
      if (Ee == 10) break;
      if (!u(Ee)) return -1;
    }
    return se;
  }
  function ce(Se, se, Ee, Ge, vn) {
    function Kn(Z, Y) {
      for (; Y ? Z >= Un : Z > Un; ) {
        let oe = Se[se + 1].from - Un;
        Ge += oe, Z += oe, se++, Un = Se[se].to;
      }
    }
    let Un = Se[se].to, Pe = [], C = [], re = Ee.from + Ge;
    for (let Z = Ee.firstChild; Z; Z = Z.nextSibling) {
      Kn(Z.from + Ge, !0);
      let Y = Z.from + Ge;
      var ge = void 0;
      ge = vn.get(Z.tree), ge || (Z.to + Ge > Un ? (ge = ce(Se, se, Z, Ge, vn), Kn(Z.to + Ge, !1)) : ge = Z.toTree()), Pe.push(ge), C.push(Y - re);
    }
    return Kn(Ee.to + Ge, !1), new Ae.Tree(Ee.type, Pe, C, Ee.to + Ge - re, Ee.tree ? Ee.tree.propValues : void 0);
  }
  function xe(Se) {
    return Se != null && 0 < Se.length;
  }
  function $e(Se) {
    if (!Array.isArray(Se)) return Se;
    if (Se.length == 0) return null;
    let se = $e(Se[0]);
    if (Se.length == 1) return se;
    if (Se = $e(Se.slice(1)), !Se || !se) return se || Se;
    let Ee = se.wrap, Ge = Se.wrap;
    return { props: (se.props || Qn).concat(Se.props || Qn), defineNodes: (se.defineNodes || Qn).concat(Se.defineNodes || Qn), parseBlock: (se.parseBlock || Qn).concat(Se.parseBlock || Qn), parseInline: (se.parseInline || Qn).concat(Se.parseInline || Qn), remove: (se.remove || Qn).concat(Se.remove || Qn), wrap: Ee ? Ge ? (vn, Kn, Un, Pe) => Ee(Ge(vn, Kn, Un, Pe), Kn, Un, Pe) : Ee : Ge };
  }
  function je(Se, se) {
    if (Se = Se.indexOf(se), 0 > Se) throw new RangeError(`Position specified relative to unknown parser ${se}`);
    return Se;
  }
  function E(Se, se, Ee, Ge) {
    return new ot(Se, se, Ee, Ge);
  }
  function P(Se, se, Ee) {
    if (Se.charCodeAt(se) == 60) {
      for (var Ge = se + 1; Ge < Se.length; Ge++) {
        var vn = Se.charCodeAt(Ge);
        if (vn == 62) return E(Be.URL, se + Ee, Ge + 1 + Ee);
        if (vn == 60 || vn == 10) return !1;
      }
      return null;
    }
    Ge = 0, vn = se;
    for (let Kn = !1; vn < Se.length; vn++) {
      let Un = Se.charCodeAt(vn);
      if (u(Un)) break;
      if (Kn) Kn = !1;
      else if (Un == 40) Ge++;
      else if (Un == 41) {
        if (!Ge) break;
        Ge--;
      } else Un == 92 && (Kn = !0);
    }
    return vn > se ? E(Be.URL, se + Ee, vn + Ee) : vn == Se.length ? null : !1;
  }
  function K(Se, se, Ee) {
    var Ge = Se.charCodeAt(se);
    if (Ge != 39 && Ge != 34 && Ge != 40) return !1;
    Ge = Ge == 40 ? 41 : Ge;
    for (let vn = se + 1, Kn = !1; vn < Se.length; vn++) {
      let Un = Se.charCodeAt(vn);
      if (Kn) Kn = !1;
      else {
        if (Un == Ge) return E(Be.LinkTitle, se + Ee, vn + 1 + Ee);
        Un == 92 && (Kn = !0);
      }
    }
    return null;
  }
  function H(Se, se, Ee, Ge) {
    for (let vn = !1, Kn = se + 1, Un = Math.min(Se.length, Kn + 999); Kn < Un; Kn++) {
      let Pe = Se.charCodeAt(Kn);
      if (vn) vn = !1;
      else {
        if (Pe == 93) return Ge ? !1 : E(Be.LinkLabel, se + Ee, Kn + 1 + Ee);
        if (Ge && !u(Pe) && (Ge = !1), Pe == 91) return !1;
        Pe == 92 && (vn = !0);
      }
    }
    return null;
  }
  function U(Se, se) {
    if (!se.length) return Se;
    if (!Se.length) return se;
    Se = Se.slice();
    let Ee = 0;
    for (let Ge of se) {
      for (; Ee < Se.length && Se[Ee].to < Ge.to; ) Ee++;
      Ee < Se.length && Se[Ee].from < Ge.from ? (se = Se[Ee], se instanceof ot && (Se[Ee] = new ot(se.type, se.from, se.to, U(se.children, [Ge])))) : Se.splice(Ee++, 0, Ge);
    }
    return Se;
  }
  function Me(Se, se) {
    let Ee = Se;
    for (let Ge = 1; Ge < se.length; Ge++) {
      let vn = se[Ge - 1].to, Kn = se[Ge].from;
      vn < Se && (Ee -= Kn - vn);
    }
    return Ee;
  }
  function le(Se, se, Ee) {
    let Ge = [];
    for (let vn = Se.firstChild, Kn = se; Se = vn ? vn.from : Ee, Se > Kn && Ge.push({ from: Kn, to: Se }), !!vn; vn = vn.nextSibling)
      Kn = vn.to;
    return Ge;
  }
  function Ce(Se, se, Ee = 0, Ge, vn = 0) {
    let Kn = 0, Un = !0, Pe = -1, C = -1, re = !1, ge = () => {
      Ge.push(Se.elt(
        "TableCell",
        vn + Pe,
        vn + C,
        Se.parser.parseInline(se.slice(Pe, C), vn + Pe)
      ));
    };
    for (; Ee < se.length; Ee++) {
      let Z = se.charCodeAt(Ee);
      Z == 124 && !re ? ((!Un || -1 < Pe) && Kn++, Un = !1, Ge && (-1 < Pe && ge(), Ge.push(Se.elt("TableDelimiter", Ee + vn, Ee + vn + 1))), Pe = C = -1) : (re || Z != 32 && Z != 9) && (0 > Pe && (Pe = Ee), C = Ee + 1), re = !re && Z == 92;
    }
    return -1 < Pe && (Kn++, Ge && ge()), Kn;
  }
  function Ye(Se, se) {
    for (; se < Se.length; se++) {
      let Ee = Se.charCodeAt(se);
      if (Ee == 124) return !0;
      Ee == 92 && se++;
    }
    return !1;
  }
  function B(Se, se, Ee, Ge) {
    let vn = 0;
    for (; se < Ee; se++) Se[se] == Ge && vn++;
    return vn;
  }
  function q(Se, se) {
    if (Kt.lastIndex = se, Se = Kt.exec(Se), !Se) return -1;
    let Ee = Se[0][Se[0].length - 1];
    return Ee == "_" || Ee == "-" ? -1 : se + Se[0].length - (Ee == "." ? 1 : 0);
  }
  function me(Se, se, Ee) {
    return (Ge, vn, Kn) => {
      if (vn != Se || Ge.char(Kn + 1) == Se) return -1;
      vn = [Ge.elt(Ee, Kn, Kn + 1)];
      for (let Un = Kn + 1; Un < Ge.end; Un++) {
        let Pe = Ge.char(Un);
        if (Pe == Se) return Ge.addElement(Ge.elt(se, Kn, Un + 1, vn.concat(Ge.elt(Ee, Un, Un + 1))));
        if (Pe == 92 && vn.push(Ge.elt("Escape", Un, Un++ + 2)), u(Pe)) break;
      }
      return -1;
    };
  }
  Object.defineProperty(l, "__esModule", { value: !0 });
  var Ae = n(4), Fe = n(5);
  class ln {
    static create(se, Ee, Ge, vn, Kn) {
      return new ln(se, Ee, Ge, vn + (vn << 8) + se + (Ee << 4) | 0, Kn, [], []);
    }
    constructor(se, Ee, Ge, vn, Kn, Un, Pe) {
      this.type = se, this.value = Ee, this.from = Ge, this.hash = vn, this.end = Kn, this.children = Un, this.positions = Pe, this.hashProp = [[Ae.NodeProp.contextHash, vn]];
    }
    addChild(se, Ee) {
      se.prop(Ae.NodeProp.contextHash) != this.hash && (se = new Ae.Tree(se.type, se.children, se.positions, se.length, this.hashProp)), this.children.push(se), this.positions.push(Ee);
    }
    toTree(se, Ee = this.end) {
      let Ge = this.children.length - 1;
      return 0 <= Ge && (Ee = Math.max(Ee, this.positions[Ge] + this.children[Ge].length + this.from)), new Ae.Tree(
        se.types[this.type],
        this.children,
        this.positions,
        Ee - this.from
      ).balance({ makeTree: (vn, Kn, Un) => new Ae.Tree(Ae.NodeType.none, vn, Kn, Un, this.hashProp) });
    }
  }
  var Be;
  (function(Se) {
    Se[Se.Document = 1] = "Document", Se[Se.CodeBlock = 2] = "CodeBlock", Se[Se.FencedCode = 3] = "FencedCode", Se[Se.Blockquote = 4] = "Blockquote", Se[Se.HorizontalRule = 5] = "HorizontalRule", Se[Se.BulletList = 6] = "BulletList", Se[Se.OrderedList = 7] = "OrderedList", Se[Se.ListItem = 8] = "ListItem", Se[Se.ATXHeading1 = 9] = "ATXHeading1", Se[Se.ATXHeading2 = 10] = "ATXHeading2", Se[Se.ATXHeading3 = 11] = "ATXHeading3", Se[Se.ATXHeading4 = 12] = "ATXHeading4", Se[Se.ATXHeading5 = 13] = "ATXHeading5", Se[Se.ATXHeading6 = 14] = "ATXHeading6", Se[Se.SetextHeading1 = 15] = "SetextHeading1", Se[Se.SetextHeading2 = 16] = "SetextHeading2", Se[Se.HTMLBlock = 17] = "HTMLBlock", Se[Se.LinkReference = 18] = "LinkReference", Se[Se.Paragraph = 19] = "Paragraph", Se[Se.CommentBlock = 20] = "CommentBlock", Se[Se.ProcessingInstructionBlock = 21] = "ProcessingInstructionBlock", Se[Se.Escape = 22] = "Escape", Se[Se.Entity = 23] = "Entity", Se[Se.HardBreak = 24] = "HardBreak", Se[Se.Emphasis = 25] = "Emphasis", Se[Se.StrongEmphasis = 26] = "StrongEmphasis", Se[Se.Link = 27] = "Link", Se[Se.Image = 28] = "Image", Se[Se.InlineCode = 29] = "InlineCode", Se[Se.HTMLTag = 30] = "HTMLTag", Se[Se.Comment = 31] = "Comment", Se[Se.ProcessingInstruction = 32] = "ProcessingInstruction", Se[Se.URL = 33] = "URL", Se[Se.HeaderMark = 34] = "HeaderMark", Se[Se.QuoteMark = 35] = "QuoteMark", Se[Se.ListMark = 36] = "ListMark", Se[Se.LinkMark = 37] = "LinkMark", Se[Se.EmphasisMark = 38] = "EmphasisMark", Se[Se.CodeMark = 39] = "CodeMark", Se[Se.CodeText = 40] = "CodeText", Se[Se.CodeInfo = 41] = "CodeInfo", Se[Se.LinkTitle = 42] = "LinkTitle", Se[Se.LinkLabel = 43] = "LinkLabel";
  })(Be ||= {});
  class Ze {
    constructor(se, Ee) {
      this.start = se, this.content = Ee, this.marks = [], this.parsers = [];
    }
  }
  class pn {
    constructor() {
      this.text = "", this.depth = this.basePos = this.baseIndent = 0, this.markers = [], this.indent = this.pos = 0, this.next = -1;
    }
    forward() {
      this.basePos > this.pos && this.forwardInner();
    }
    forwardInner() {
      let se = this.skipSpace(this.basePos);
      this.indent = this.countIndent(se, this.pos, this.indent), this.pos = se, this.next = se == this.text.length ? -1 : this.text.charCodeAt(se);
    }
    skipSpace(se) {
      return o(this.text, se);
    }
    reset(se) {
      for (this.text = se, this.baseIndent = this.basePos = this.pos = this.indent = 0, this.forwardInner(), this.depth = 1; this.markers.length; ) this.markers.pop();
    }
    moveBase(se) {
      this.basePos = se, this.baseIndent = this.countIndent(se, this.pos, this.indent);
    }
    moveBaseColumn(se) {
      this.baseIndent = se, this.basePos = this.findColumn(se);
    }
    addMarker(se) {
      this.markers.push(se);
    }
    countIndent(se, Ee = 0, Ge = 0) {
      for (; Ee < se; Ee++) Ge += this.text.charCodeAt(Ee) == 9 ? 4 - Ge % 4 : 1;
      return Ge;
    }
    findColumn(se) {
      let Ee = 0;
      for (let Ge = 0; Ee < this.text.length && Ge < se; Ee++) Ge += this.text.charCodeAt(Ee) == 9 ? 4 - Ge % 4 : 1;
      return Ee;
    }
    scrub() {
      if (!this.baseIndent) return this.text;
      let se = "";
      for (let Ee = 0; Ee < this.basePos; Ee++) se += " ";
      return se + this.text.slice(this.basePos);
    }
  }
  e = { [Be.Blockquote](Se, se, Ee) {
    return Ee.next != 62 ? !1 : (Ee.markers.push(E(Be.QuoteMark, se.lineStart + Ee.pos, se.lineStart + Ee.pos + 1)), Ee.moveBase(Ee.pos + (u(Ee.text.charCodeAt(Ee.pos + 1)) ? 2 : 1)), Se.end = se.lineStart + Ee.text.length, !0);
  }, [Be.ListItem](Se, se, Ee) {
    return Ee.indent < Ee.baseIndent + Se.value && -1 < Ee.next ? !1 : (Ee.moveBaseColumn(Ee.baseIndent + Se.value), !0);
  }, [Be.OrderedList]: r, [Be.BulletList]: r, [Be.Document]() {
    return !0;
  } };
  const xn = /^[ \t]*$/, Nn = /--\x3e/, at = /\?>/, Yt = [[/^<(?:script|pre|style)(?:\s|>|$)/i, /<\/(?:script|pre|style)>/i], [/^\s*\x3c!--/, Nn], [/^\s*<\?/, at], [/^\s*<![A-Z]/, />/], [/^\s*<!\[CDATA\[/, /\]\]>/], [
    /^\s*<\/?(?:address|article|aside|base|basefont|blockquote|body|caption|center|col|colgroup|dd|details|dialog|dir|div|dl|dt|fieldset|figcaption|figure|footer|form|frame|frameset|h1|h2|h3|h4|h5|h6|head|header|hr|html|iframe|legend|li|link|main|menu|menuitem|nav|noframes|ol|optgroup|option|p|param|section|source|summary|table|tbody|td|tfoot|th|thead|title|tr|track|ul)(?:\s|\/?>|$)/i,
    xn
  ], [/^\s*(?:<\/[a-z][\w-]*\s*>|<[a-z][\w-]*(\s+[a-z:_][\w-.]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*>)\s*$/i, xn]], jt = { LinkReference: void 0, IndentedCode(Se, se) {
    let Ee = se.baseIndent + 4;
    if (se.indent < Ee) return !1;
    var Ge = se.findColumn(Ee);
    Ge = Se.lineStart + Ge;
    let vn = Se.lineStart + se.text.length, Kn = [], Un = [];
    for (J(Kn, Ge, vn); Se.nextLine() && se.depth >= Se.stack.length; ) if (se.pos == se.text.length) {
      J(Un, Se.lineStart - 1, Se.lineStart);
      for (let Pe of se.markers) Un.push(Pe);
    } else {
      if (se.indent < Ee) break;
      {
        if (Un.length) {
          for (let C of Un) C.type == Be.CodeText ? J(Kn, C.from, C.to) : Kn.push(C);
          Un = [];
        }
        J(Kn, Se.lineStart - 1, Se.lineStart);
        for (let C of se.markers) Kn.push(C);
        vn = Se.lineStart + se.text.length;
        let Pe = Se.lineStart + se.findColumn(se.baseIndent + 4);
        Pe < vn && J(Kn, Pe, vn);
      }
    }
    return Un.length && (Un = Un.filter((Pe) => Pe.type != Be.CodeText), Un.length && (se.markers = Un.concat(se.markers))), Se.addNode(Se.buffer.writeElements(Kn, -Ge).finish(Be.CodeBlock, vn - Ge), Ge), !0;
  }, FencedCode(Se, se) {
    var Ee = h(se);
    if (0 > Ee) return !1;
    let Ge = Se.lineStart + se.pos, vn = se.next, Kn = Ee - se.pos;
    var Un = se.skipSpace(Ee), Pe = a(
      se.text,
      se.text.length,
      Un
    );
    for (Ee = [E(Be.CodeMark, Ge, Ge + Kn)], Un < Pe && Ee.push(E(Be.CodeInfo, Se.lineStart + Un, Se.lineStart + Pe)), Un = !0; Se.nextLine() && se.depth >= Se.stack.length; Un = !1) {
      if (Pe = se.pos, 4 > se.indent - se.baseIndent) for (; Pe < se.text.length && se.text.charCodeAt(Pe) == vn; ) Pe++;
      if (Pe - se.pos >= Kn && se.skipSpace(Pe) == se.text.length) {
        for (let C of se.markers) Ee.push(C);
        Ee.push(E(Be.CodeMark, Se.lineStart + se.pos, Se.lineStart + Pe)), Se.nextLine();
        break;
      } else {
        Un || J(Ee, Se.lineStart - 1, Se.lineStart);
        for (let C of se.markers) Ee.push(C);
        Un = Se.lineStart + se.basePos, Pe = Se.lineStart + se.text.length, Un < Pe && J(Ee, Un, Pe);
      }
    }
    return Se.addNode(Se.buffer.writeElements(Ee, -Ge).finish(Be.FencedCode, Se.prevLineEnd() - Ge), Ge), !0;
  }, Blockquote(Se, se) {
    let Ee = se.next != 62 ? -1 : se.text.charCodeAt(se.pos + 1) == 32 ? 2 : 1;
    return 0 > Ee ? !1 : (Se.startContext(Be.Blockquote, se.pos), Se.addNode(Be.QuoteMark, Se.lineStart + se.pos, Se.lineStart + se.pos + 1), se.moveBase(se.pos + Ee), null);
  }, HorizontalRule(Se, se) {
    return 0 > s(se, Se, !1) ? !1 : (se = Se.lineStart + se.pos, Se.nextLine(), Se.addNode(Be.HorizontalRule, se), !0);
  }, BulletList(Se, se) {
    let Ee = p(se, Se, !1);
    if (0 > Ee) return !1;
    Se.block.type != Be.BulletList && Se.startContext(Be.BulletList, se.basePos, se.next);
    let Ge = G(se, se.pos + 1);
    return Se.startContext(Be.ListItem, se.basePos, Ge - se.baseIndent), Se.addNode(Be.ListMark, Se.lineStart + se.pos, Se.lineStart + se.pos + Ee), se.moveBaseColumn(Ge), null;
  }, OrderedList(Se, se) {
    let Ee = _(se, Se, !1);
    if (0 > Ee) return !1;
    Se.block.type != Be.OrderedList && Se.startContext(Be.OrderedList, se.basePos, se.text.charCodeAt(se.pos + Ee - 1));
    let Ge = G(se, se.pos + Ee);
    return Se.startContext(Be.ListItem, se.basePos, Ge - se.baseIndent), Se.addNode(
      Be.ListMark,
      Se.lineStart + se.pos,
      Se.lineStart + se.pos + Ee
    ), se.moveBaseColumn(Ge), null;
  }, ATXHeading(Se, se) {
    let Ee = R(se);
    if (0 > Ee) return !1;
    let Ge = se.pos, vn = Se.lineStart + Ge, Kn = a(se.text, se.text.length, Ge), Un = Kn;
    for (; Un > Ge && se.text.charCodeAt(Un - 1) == se.next; ) Un--;
    Un != Kn && Un != Ge && u(se.text.charCodeAt(Un - 1)) || (Un = se.text.length);
    let Pe = Se.buffer.write(Be.HeaderMark, 0, Ee).writeElements(Se.parser.parseInline(se.text.slice(Ge + Ee + 1, Un), vn + Ee + 1), -vn);
    return Un < se.text.length && Pe.write(Be.HeaderMark, Un - Ge, Kn - Ge), se = Pe.finish(Be.ATXHeading1 - 1 + Ee, se.text.length - Ge), Se.nextLine(), Se.addNode(
      se,
      vn
    ), !0;
  }, HTMLBlock(Se, se) {
    var Ee = L(se, Se, !1);
    if (0 > Ee) return !1;
    let Ge = Se.lineStart + se.pos, vn = Yt[Ee][1];
    Ee = [];
    let Kn = vn != xn;
    for (; !vn.test(se.text) && Se.nextLine(); ) {
      if (se.depth < Se.stack.length) {
        Kn = !1;
        break;
      }
      for (var Un of se.markers) Ee.push(Un);
    }
    return Kn && Se.nextLine(), se = vn == Nn ? Be.CommentBlock : vn == at ? Be.ProcessingInstructionBlock : Be.HTMLBlock, Un = Se.prevLineEnd(), Se.addNode(Se.buffer.writeElements(Ee, -Ge).finish(se, Un - Ge), Ge), !0;
  }, SetextHeading: void 0 };
  class Cl {
    constructor(se) {
      this.stage = 0, this.elts = [], this.pos = 0, this.start = se.start, this.advance(se.content);
    }
    nextLine(se, Ee, Ge) {
      if (this.stage == -1) return !1;
      Ee = Ge.content + `
` + Ee.scrub();
      let vn = this.advance(Ee);
      return -1 < vn && vn < Ee.length ? this.complete(se, Ge, vn) : !1;
    }
    finish(se, Ee) {
      return this.stage != 2 && this.stage != 3 || o(Ee.content, this.pos) != Ee.content.length ? !1 : this.complete(se, Ee, Ee.content.length);
    }
    complete(se, Ee, Ge) {
      return se.addLeafElement(Ee, E(Be.LinkReference, this.start, this.start + Ge, this.elts)), !0;
    }
    nextStage(se) {
      return se ? (this.pos = se.to - this.start, this.elts.push(se), this.stage++, !0) : (se === !1 && (this.stage = -1), !1);
    }
    advance(se) {
      for (; ; ) {
        if (this.stage == -1) return -1;
        if (this.stage == 0) {
          if (!this.nextStage(H(se, this.pos, this.start, !0))) return -1;
          if (se.charCodeAt(this.pos) != 58) return this.stage = -1;
          this.elts.push(E(Be.LinkMark, this.pos + this.start, this.pos + this.start + 1)), this.pos++;
        } else if (this.stage == 1) {
          if (!this.nextStage(P(se, o(se, this.pos), this.start))) return -1;
        } else {
          if (this.stage == 2) {
            var Ee = o(se, this.pos);
            let Ge = 0;
            if (Ee > this.pos && (Ee = K(se, Ee, this.start))) {
              let vn = we(se, Ee.to - this.start);
              0 < vn && (this.nextStage(Ee), Ge = vn);
            }
            return Ge ||= we(se, this.pos), 0 < Ge && Ge < se.length ? Ge : -1;
          }
          return we(se, this.pos);
        }
      }
    }
  }
  class fn {
    nextLine(se, Ee, Ge) {
      let vn = Ee.depth < se.stack.length ? -1 : F(Ee), Kn = Ee.next;
      return 0 > vn ? !1 : (Ee = E(Be.HeaderMark, se.lineStart + Ee.pos, se.lineStart + vn), se.nextLine(), se.addLeafElement(Ge, E(Kn == 61 ? Be.SetextHeading1 : Be.SetextHeading2, Ge.start, se.prevLineEnd(), [...se.parser.parseInline(Ge.content, Ge.start), Ee])), !0);
    }
    finish() {
      return !1;
    }
  }
  const _e = { LinkReference(Se, se) {
    return se.content.charCodeAt(0) == 91 ? new Cl(se) : null;
  }, SetextHeading() {
    return new fn();
  } }, Ve = {
    text: "",
    end: 0
  };
  class an {
    constructor(se, Ee, Ge, vn) {
      this.parser = se, this.input = Ee, this.ranges = vn, this.line = new pn(), this.atEnd = !1, this.reusePlaceholders = /* @__PURE__ */ new Map(), this.stoppedAt = null, this.rangeI = 0, this.to = vn[vn.length - 1].to, this.lineStart = this.absoluteLineStart = this.absoluteLineEnd = vn[0].from, this.block = ln.create(Be.Document, 0, this.lineStart, 0, 0), this.stack = [this.block], this.fragments = Ge.length ? new wi(Ge, Ee) : null, this.readLine();
    }
    get parsedPos() {
      return this.absoluteLineStart;
    }
    advance() {
      if (this.stoppedAt != null && this.absoluteLineStart > this.stoppedAt) return this.finish();
      let { line: se } = this;
      for (; ; ) {
        for (; se.depth < this.stack.length; ) this.finishContext();
        for (var Ee of se.markers) this.addNode(Ee.type, Ee.from, Ee.to);
        if (se.pos < se.text.length) break;
        if (!this.nextLine()) return this.finish();
      }
      if (this.fragments && this.reuseFragment(se.basePos)) return null;
      e: for (; ; ) {
        for (var Ge of this.parser.blockParsers) if (Ge && (Ee = Ge(this, se), Ee != 0)) {
          if (Ee == 1) return null;
          se.forward();
          continue e;
        }
        break;
      }
      Ge = new Ze(this.lineStart + se.pos, se.text.slice(se.pos));
      for (let vn of this.parser.leafBlockParsers) vn && (Ee = vn(this, Ge)) && Ge.parsers.push(Ee);
      e: for (; this.nextLine() && se.pos != se.text.length; ) {
        if (se.indent < se.baseIndent + 4) {
          for (let vn of this.parser.endLeafBlock) if (vn(this, se, Ge)) break e;
        }
        for (let vn of Ge.parsers) if (vn.nextLine(this, se, Ge)) return null;
        Ge.content += `
` + se.scrub();
        for (let vn of se.markers) Ge.marks.push(vn);
      }
      return this.finishLeaf(Ge), null;
    }
    stopAt(se) {
      if (this.stoppedAt != null && this.stoppedAt < se) throw new RangeError("Can't move stoppedAt forward");
      this.stoppedAt = se;
    }
    reuseFragment(se) {
      return !this.fragments.moveTo(this.absoluteLineStart + se, this.absoluteLineStart) || !this.fragments.matches(this.block.hash) || (se = this.fragments.takeNodes(this), !se) ? !1 : (this.absoluteLineStart += se, this.lineStart = Me(this.absoluteLineStart, this.ranges), this.moveRangeI(), this.absoluteLineStart < this.to ? (this.lineStart++, this.absoluteLineStart++) : this.atEnd = !0, this.readLine(), !0);
    }
    get depth() {
      return this.stack.length;
    }
    parentType(se = this.depth - 1) {
      return this.parser.nodeSet.types[this.stack[se].type];
    }
    nextLine() {
      return this.lineStart += this.line.text.length, this.absoluteLineEnd >= this.to ? (this.absoluteLineStart = this.absoluteLineEnd, this.atEnd = !0, this.readLine(), !1) : (this.lineStart++, this.absoluteLineStart = this.absoluteLineEnd + 1, this.moveRangeI(), this.readLine(), !0);
    }
    moveRangeI() {
      for (; this.rangeI < this.ranges.length - 1 && this.absoluteLineStart >= this.ranges[this.rangeI].to; ) this.rangeI++, this.absoluteLineStart = Math.max(this.absoluteLineStart, this.ranges[this.rangeI].from);
    }
    scanLine(se) {
      if (Ve.end = se, se >= this.to) Ve.text = "";
      else if (Ve.text = this.lineChunkAt(se), Ve.end += Ve.text.length, 1 < this.ranges.length) {
        se = this.absoluteLineStart;
        let Ee = this.rangeI;
        for (; this.ranges[Ee].to < Ve.end; ) {
          Ee++;
          let Ge = this.ranges[Ee].from, vn = this.lineChunkAt(Ge);
          Ve.end = Ge + vn.length, Ve.text = Ve.text.slice(0, this.ranges[Ee - 1].to - se) + vn, se = Ve.end - Ve.text.length;
        }
      }
      return Ve;
    }
    readLine() {
      let { line: se } = this, { text: Ee, end: Ge } = this.scanLine(this.absoluteLineStart);
      for (this.absoluteLineEnd = Ge, se.reset(Ee); se.depth < this.stack.length; se.depth++) {
        let vn = this.stack[se.depth], Kn = this.parser.skipContextMarkup[vn.type];
        if (!Kn) throw Error("Unhandled block context " + Be[vn.type]);
        if (!Kn(vn, this, se)) break;
        se.forward();
      }
    }
    lineChunkAt(se) {
      var Ee = this.input.chunk(se);
      if (this.input.lineChunks) Ee = Ee == `
` ? "" : Ee;
      else {
        let Ge = Ee.indexOf(`
`);
        Ee = 0 > Ge ? Ee : Ee.slice(0, Ge);
      }
      return se + Ee.length > this.to ? Ee.slice(0, this.to - se) : Ee;
    }
    prevLineEnd() {
      return this.atEnd ? this.lineStart : this.lineStart - 1;
    }
    startContext(se, Ee, Ge = 0) {
      this.block = ln.create(se, Ge, this.lineStart + Ee, this.block.hash, this.lineStart + this.line.text.length), this.stack.push(this.block);
    }
    startComposite(se, Ee, Ge = 0) {
      this.startContext(
        this.parser.getNodeType(se),
        Ee,
        Ge
      );
    }
    addNode(se, Ee, Ge) {
      typeof se == "number" && (se = new Ae.Tree(this.parser.nodeSet.types[se], Qn, Qn, (Ge ?? this.prevLineEnd()) - Ee)), this.block.addChild(se, Ee - this.block.from);
    }
    addElement(se) {
      this.block.addChild(se.toTree(this.parser.nodeSet), se.from - this.block.from);
    }
    addLeafElement(se, Ee) {
      this.addNode(this.buffer.writeElements(U(Ee.children, se.marks), -Ee.from).finish(Ee.type, Ee.to - Ee.from), Ee.from);
    }
    finishContext() {
      let se = this.stack.pop(), Ee = this.stack[this.stack.length - 1];
      Ee.addChild(
        se.toTree(this.parser.nodeSet),
        se.from - Ee.from
      ), this.block = Ee;
    }
    finish() {
      for (; 1 < this.stack.length; ) this.finishContext();
      return this.addGaps(this.block.toTree(this.parser.nodeSet, this.lineStart));
    }
    addGaps(se) {
      return 1 < this.ranges.length ? ce(this.ranges, 0, se.topNode, this.ranges[0].from, this.reusePlaceholders) : se;
    }
    finishLeaf(se) {
      for (var Ee of se.parsers) if (Ee.finish(this, se)) return;
      Ee = U(this.parser.parseInline(se.content, se.start), se.marks), this.addNode(this.buffer.writeElements(Ee, -se.start).finish(Be.Paragraph, se.content.length), se.start);
    }
    elt(se, Ee, Ge, vn) {
      return typeof se == "string" ? E(this.parser.getNodeType(se), Ee, Ge, vn) : new Nt(se, Ee);
    }
    get buffer() {
      return new Vn(this.parser.nodeSet);
    }
  }
  class En extends Ae.Parser {
    constructor(se, Ee, Ge, vn, Kn, Un, Pe, C, re) {
      super(), this.nodeSet = se, this.blockParsers = Ee, this.leafBlockParsers = Ge, this.blockNames = vn, this.endLeafBlock = Kn, this.skipContextMarkup = Un, this.inlineParsers = Pe, this.inlineNames = C, this.wrappers = re, this.nodeTypes = /* @__PURE__ */ Object.create(null);
      for (let ge of se.types) this.nodeTypes[ge.name] = ge.id;
    }
    createParse(se, Ee, Ge) {
      let vn = new an(this, se, Ee, Ge);
      for (let Kn of this.wrappers) vn = Kn(vn, se, Ee, Ge);
      return vn;
    }
    configure(se) {
      if (se = $e(se), !se) return this;
      let { nodeSet: Ee, skipContextMarkup: Ge } = this, vn = this.blockParsers.slice(), Kn = this.leafBlockParsers.slice(), Un = this.blockNames.slice(), Pe = this.inlineParsers.slice(), C = this.inlineNames.slice(), re = this.endLeafBlock.slice(), ge = this.wrappers;
      if (xe(se.defineNodes)) {
        Ge = Object.assign({}, Ge);
        let De = Ee.types.slice();
        for (var Z of se.defineNodes) {
          let { name: un, block: gn, composite: Tn, style: ft } = typeof Z == "string" ? { name: Z } : Z;
          if (De.some((zl) => zl.name == un)) continue;
          Tn && (Ge[De.length] = (zl, qe, ae) => Tn(qe, ae, zl.value));
          let gt = De.length, Gt = Tn ? ["Block", "BlockContext"] : gn ? gt >= Be.ATXHeading1 && gt <= Be.SetextHeading2 ? ["Block", "LeafBlock", "Heading"] : ["Block", "LeafBlock"] : void 0;
          De.push(Ae.NodeType.define({ id: gt, name: un, props: Gt && [[Ae.NodeProp.group, Gt]] })), ft && (oe ||= {}, Array.isArray(ft) || ft instanceof Fe.Tag ? oe[un] = ft : Object.assign(oe, ft));
        }
        Ee = new Ae.NodeSet(De), oe && (Ee = Ee.extend(Fe.styleTags(oe)));
      }
      if (xe(se.props) && (Ee = Ee.extend(...se.props)), xe(se.remove)) for (var Y of se.remove) {
        var oe = this.blockNames.indexOf(Y);
        Z = this.inlineNames.indexOf(Y), -1 < oe && (vn[oe] = Kn[oe] = void 0), -1 < Z && (Pe[Z] = void 0);
      }
      if (xe(se.parseBlock)) for (var ke of se.parseBlock) Y = Un.indexOf(ke.name), -1 < Y ? (vn[Y] = ke.parse, Kn[Y] = ke.leaf) : (Y = ke.before ? je(Un, ke.before) : ke.after ? je(Un, ke.after) + 1 : Un.length - 1, vn.splice(Y, 0, ke.parse), Kn.splice(Y, 0, ke.leaf), Un.splice(Y, 0, ke.name)), ke.endLeaf && re.push(ke.endLeaf);
      if (xe(se.parseInline)) for (let De of se.parseInline) ke = C.indexOf(De.name), -1 < ke ? Pe[ke] = De.parse : (ke = De.before ? je(C, De.before) : De.after ? je(C, De.after) + 1 : C.length - 1, Pe.splice(
        ke,
        0,
        De.parse
      ), C.splice(ke, 0, De.name));
      return se.wrap && (ge = ge.concat(se.wrap)), new En(Ee, vn, Kn, Un, re, Ge, Pe, C, ge);
    }
    getNodeType(se) {
      let Ee = this.nodeTypes[se];
      if (Ee == null) throw new RangeError(`Unknown node type '${se}'`);
      return Ee;
    }
    parseInline(se, Ee) {
      se = new ql(this, se, Ee);
      e: for (; Ee < se.end; ) {
        let Ge = se.char(Ee);
        for (let vn of this.inlineParsers) if (vn) {
          let Kn = vn(se, Ge, Ee);
          if (0 <= Kn) {
            Ee = Kn;
            continue e;
          }
        }
        Ee++;
      }
      return se.resolveMarkers(0);
    }
  }
  n = [Ae.NodeType.none];
  for (let Se = 1, se; se = Be[Se]; Se++) n[Se] = Ae.NodeType.define({ id: Se, name: se, props: Se >= Be.Escape ? [] : [[
    Ae.NodeProp.group,
    Se in e ? ["Block", "BlockContext"] : ["Block", "LeafBlock"]
  ]], top: se == "Document" });
  const Qn = [];
  class Vn {
    constructor(se) {
      this.nodeSet = se, this.content = [], this.nodes = [];
    }
    write(se, Ee, Ge, vn = 0) {
      return this.content.push(se, Ee, Ge, 4 + 4 * vn), this;
    }
    writeElements(se, Ee = 0) {
      for (let Ge of se) Ge.writeTo(this, Ee);
      return this;
    }
    finish(se, Ee) {
      return Ae.Tree.build({ buffer: this.content, nodeSet: this.nodeSet, reused: this.nodes, topID: se, length: Ee });
    }
  }
  class ot {
    constructor(se, Ee, Ge, vn = Qn) {
      this.type = se, this.from = Ee, this.to = Ge, this.children = vn;
    }
    writeTo(se, Ee) {
      let Ge = se.content.length;
      se.writeElements(this.children, Ee), se.content.push(this.type, this.from + Ee, this.to + Ee, se.content.length + 4 - Ge);
    }
    toTree(se) {
      return new Vn(se).writeElements(this.children, -this.from).finish(this.type, this.to - this.from);
    }
  }
  class Nt {
    constructor(se, Ee) {
      this.tree = se, this.from = Ee;
    }
    get to() {
      return this.from + this.tree.length;
    }
    get type() {
      return this.tree.type.id;
    }
    get children() {
      return Qn;
    }
    writeTo(se, Ee) {
      se.nodes.push(this.tree), se.content.push(se.nodes.length - 1, this.from + Ee, this.to + Ee, -1);
    }
    toTree() {
      return this.tree;
    }
  }
  const zt = {
    resolve: "Emphasis",
    mark: "EmphasisMark"
  }, Pt = { resolve: "Emphasis", mark: "EmphasisMark" }, ol = {}, St = {};
  class pr {
    constructor(se, Ee, Ge, vn) {
      this.type = se, this.from = Ee, this.to = Ge, this.side = vn;
    }
  }
  let ul = /[!"#$%&'()*+,\-.\/:;<=>?@\[\\\]^_`{|}~\xA1\u2010-\u2027]/;
  try {
    ul = RegExp("[\\p{Pc}|\\p{Pd}|\\p{Pe}|\\p{Pf}|\\p{Pi}|\\p{Po}|\\p{Ps}]", "u");
  } catch {
  }
  const Rr = { Escape(Se, se, Ee) {
    if (se != 92 || Ee == Se.end - 1) return -1;
    se = Se.char(Ee + 1);
    for (let Ge = 0; 32 > Ge; Ge++) if ("!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~".charCodeAt(Ge) == se) return Se.append(E(Be.Escape, Ee, Ee + 2));
    return -1;
  }, Entity(Se, se, Ee) {
    return se != 38 ? -1 : (se = /^(?:#\d+|#x[a-f\d]+|\w+);/i.exec(Se.slice(Ee + 1, Ee + 31))) ? Se.append(E(Be.Entity, Ee, Ee + 1 + se[0].length)) : -1;
  }, InlineCode(Se, se, Ee) {
    if (se != 96 || Ee && Se.char(Ee - 1) == 96) return -1;
    for (se = Ee + 1; se < Se.end && Se.char(se) == 96; ) se++;
    let Ge = se - Ee, vn = 0;
    for (; se < Se.end; se++) if (Se.char(se) == 96) {
      if (vn++, vn == Ge && Se.char(se + 1) != 96) return Se.append(E(Be.InlineCode, Ee, se + 1, [E(Be.CodeMark, Ee, Ee + Ge), E(Be.CodeMark, se + 1 - Ge, se + 1)]));
    } else vn = 0;
    return -1;
  }, HTMLTag(Se, se, Ee) {
    if (se != 60 || Ee == Se.end - 1) return -1;
    se = Se.slice(Ee + 1, Se.end);
    var Ge = /^(?:[a-z][-\w+.]+:[^\s>]+|[a-z\d.!#$%&'*+/=?^_`{|}~-]+@[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?(?:\.[a-z\d](?:[a-z\d-]{0,61}[a-z\d])?)*)>/i.exec(se);
    return Ge ? Se.append(E(Be.URL, Ee, Ee + 1 + Ge[0].length)) : (Ge = /^!--[^>](?:-[^-]|[^-])*?--\x3e/i.exec(se)) ? Se.append(E(Be.Comment, Ee, Ee + 1 + Ge[0].length)) : (Ge = /^\?[^]*?\?>/.exec(se)) ? Se.append(E(Be.ProcessingInstruction, Ee, Ee + 1 + Ge[0].length)) : (se = /^(?:![A-Z][^]*?>|!\[CDATA\[[^]*?\]\]>|\/\s*[a-zA-Z][\w-]*\s*>|\s*[a-zA-Z][\w-]*(\s+[a-zA-Z:_][\w-.:]*(?:\s*=\s*(?:[^\s"'=<>`]+|'[^']*'|"[^"]*"))?)*\s*(\/\s*)?>)/.exec(se)) ? Se.append(E(Be.HTMLTag, Ee, Ee + 1 + se[0].length)) : -1;
  }, Emphasis(Se, se, Ee) {
    if (se != 95 && se != 42) return -1;
    let Ge = Ee + 1;
    for (; Se.char(Ge) == se; ) Ge++;
    var vn = Se.slice(Ee - 1, Ee), Kn = Se.slice(Ge, Ge + 1);
    let Un = ul.test(vn), Pe = ul.test(Kn);
    vn = /\s|^$/.test(vn);
    let C = /\s|^$/.test(Kn);
    return Kn = !C && (!Pe || vn || Un), vn = !vn && (!Un || C || Pe), Se.append(new pr(se == 95 ? zt : Pt, Ee, Ge, (!Kn || se != 42 && vn && !Un ? 0 : 1) | (!vn || se != 42 && Kn && !Pe ? 0 : 2)));
  }, HardBreak(Se, se, Ee) {
    if (se == 92 && Se.char(Ee + 1) == 10) return Se.append(E(Be.HardBreak, Ee, Ee + 2));
    if (se == 32) {
      for (se = Ee + 1; Se.char(se) == 32; ) se++;
      if (Se.char(se) == 10 && se >= Ee + 2) return Se.append(E(Be.HardBreak, Ee, se + 1));
    }
    return -1;
  }, Link(Se, se, Ee) {
    return se == 91 ? Se.append(new pr(
      ol,
      Ee,
      Ee + 1,
      1
    )) : -1;
  }, Image(Se, se, Ee) {
    return se == 33 && Se.char(Ee + 1) == 91 ? Se.append(new pr(St, Ee, Ee + 2, 1)) : -1;
  }, LinkEnd(Se, se, Ee) {
    if (se != 93) return -1;
    for (se = Se.parts.length - 1; 0 <= se; se--) {
      var Ge = Se.parts[se];
      if (Ge instanceof pr && (Ge.type == ol || Ge.type == St)) {
        if (!Ge.side || Se.skipSpace(Ge.to) == Ee && !/[(\[]/.test(Se.slice(Ee + 1, Ee + 2))) {
          Se.parts[se] = null;
          break;
        }
        var vn = Se.takeContent(se), Kn = Se.parts, Un = se;
        let Y;
        var Pe = Se, C = Ge.type == ol ? Be.Link : Be.Image, re = Ge.from, ge = Ee + 1;
        let { text: oe } = Pe;
        var Z = Pe.char(ge);
        if (Ee = ge, vn.unshift(E(Be.LinkMark, re, re + (C == Be.Image ? 2 : 1))), vn.push(E(
          Be.LinkMark,
          ge - 1,
          ge
        )), Z == 40) {
          Z = Pe.skipSpace(ge + 1);
          let ke = P(oe, Z - Pe.offset, Pe.offset);
          ke && (Z = Pe.skipSpace(ke.to), (Y = K(oe, Z - Pe.offset, Pe.offset)) && (Z = Pe.skipSpace(Y.to))), Pe.char(Z) == 41 && (vn.push(E(Be.LinkMark, ge, ge + 1)), Ee = Z + 1, ke && vn.push(ke), Y && vn.push(Y), vn.push(E(Be.LinkMark, Z, Ee)));
        } else Z == 91 && (Pe = H(oe, ge - Pe.offset, Pe.offset, !1)) && (vn.push(Pe), Ee = Pe.to);
        if (Pe = E(C, re, Ee, vn), Kn = Kn[Un] = Pe, Ge.type == ol) for (Ge = 0; Ge < se; Ge++) Un = Se.parts[Ge], Un instanceof pr && Un.type == ol && (Un.side = 0);
        return Kn.to;
      }
    }
    return -1;
  } };
  class ql {
    constructor(se, Ee, Ge) {
      this.parser = se, this.text = Ee, this.offset = Ge, this.parts = [];
    }
    char(se) {
      return se >= this.end ? -1 : this.text.charCodeAt(se - this.offset);
    }
    get end() {
      return this.offset + this.text.length;
    }
    slice(se, Ee) {
      return this.text.slice(se - this.offset, Ee - this.offset);
    }
    append(se) {
      return this.parts.push(se), se.to;
    }
    addDelimiter(se, Ee, Ge, vn, Kn) {
      return this.append(new pr(se, Ee, Ge, (vn ? 1 : 0) | (Kn ? 2 : 0)));
    }
    addElement(se) {
      return this.append(se);
    }
    resolveMarkers(se) {
      for (var Ee = se; Ee < this.parts.length; Ee++) {
        var Ge = this.parts[Ee];
        if (!(Ge instanceof pr && Ge.type.resolve && Ge.side & 2)) continue;
        let Pe = Ge.type == zt || Ge.type == Pt;
        var vn = Ge.to - Ge.from;
        let C, re = Ee - 1;
        for (; re >= se; re--) {
          var Kn = this.parts[re];
          if (Kn instanceof pr && Kn.side & 1 && Kn.type == Ge.type && !(Pe && (Ge.side & 1 || Kn.side & 2) && (Kn.to - Kn.from + vn) % 3 == 0 && ((Kn.to - Kn.from) % 3 || vn % 3))) {
            C = Kn;
            break;
          }
        }
        if (!C) continue;
        let ge = Ge.type.resolve;
        var Un = [];
        Kn = C.from;
        let Z = Ge.to;
        for (Pe && (vn = Math.min(2, C.to - C.from, vn), Kn = C.to - vn, Z = Ge.from + vn, ge = vn == 1 ? "Emphasis" : "StrongEmphasis"), C.type.mark && Un.push(this.elt(C.type.mark, Kn, C.to)), vn = re + 1; vn < Ee; vn++) this.parts[vn] instanceof ot && Un.push(this.parts[vn]), this.parts[vn] = null;
        Ge.type.mark && Un.push(this.elt(Ge.type.mark, Ge.from, Z)), Un = this.elt(ge, Kn, Z, Un), this.parts[re] = Pe && C.from != Kn ? new pr(C.type, C.from, Kn, C.side) : null, (this.parts[Ee] = Pe && Ge.to != Z ? new pr(Ge.type, Z, Ge.to, Ge.side) : null) ? this.parts.splice(Ee, 0, Un) : this.parts[Ee] = Un;
      }
      for (Ee = []; se < this.parts.length; se++) Ge = this.parts[se], Ge instanceof ot && Ee.push(Ge);
      return Ee;
    }
    findOpeningDelimiter(se) {
      for (let Ee = this.parts.length - 1; 0 <= Ee; Ee--) {
        let Ge = this.parts[Ee];
        if (Ge instanceof pr && Ge.type == se) return Ee;
      }
      return null;
    }
    takeContent(se) {
      let Ee = this.resolveMarkers(se);
      return this.parts.length = se, Ee;
    }
    skipSpace(se) {
      return o(this.text, se - this.offset) + this.offset;
    }
    elt(se, Ee, Ge, vn) {
      return typeof se == "string" ? E(this.parser.getNodeType(se), Ee, Ge, vn) : new Nt(se, Ee);
    }
  }
  const Mr = [Be.CodeBlock, Be.ListItem, Be.OrderedList, Be.BulletList];
  class wi {
    constructor(se, Ee) {
      this.fragments = se, this.input = Ee, this.i = 0, this.fragment = null, this.fragmentEnd = -1, this.cursor = null, se.length && (this.fragment = se[this.i++]);
    }
    nextFragment() {
      this.fragment = this.i < this.fragments.length ? this.fragments[this.i++] : null, this.cursor = null, this.fragmentEnd = -1;
    }
    moveTo(se, Ee) {
      for (; this.fragment && this.fragment.to <= se; ) this.nextFragment();
      if (!this.fragment || this.fragment.from > (se ? se - 1 : 0)) return !1;
      if (0 > this.fragmentEnd) {
        for (var Ge = this.fragment.to; 0 < Ge && this.input.read(Ge - 1, Ge) != `
`; ) Ge--;
        this.fragmentEnd = Ge ? Ge - 1 : 0;
      }
      for (Ge = this.cursor, Ge || (Ge = this.cursor = this.fragment.tree.cursor(), Ge.firstChild()), se += this.fragment.offset; Ge.to <= se; ) if (!Ge.parent()) return !1;
      for (; ; ) {
        if (Ge.from >= se) return this.fragment.from <= Ee;
        if (!Ge.childAfter(se)) return !1;
      }
    }
    matches(se) {
      let Ee = this.cursor.tree;
      return Ee && Ee.prop(Ae.NodeProp.contextHash) == se;
    }
    takeNodes(se) {
      let Ee = this.cursor, Ge = this.fragment.offset, vn = this.fragmentEnd - (this.fragment.openEnd ? 1 : 0), Kn = se.absoluteLineStart, Un = Kn, Pe = se.block.children.length, C = Un, re = Pe;
      for (; ; ) {
        if (Ee.to - Ge > vn) {
          if (Ee.type.isAnonymous && Ee.firstChild()) continue;
          break;
        }
        let ge = Me(Ee.from - Ge, se.ranges);
        if (Ee.to - Ge <= se.ranges[se.rangeI].to) se.addNode(Ee.tree, ge);
        else {
          let Z = new Ae.Tree(se.parser.nodeSet.types[Be.Paragraph], [], [], 0, se.block.hashProp);
          se.reusePlaceholders.set(Z, Ee.tree), se.addNode(Z, ge);
        }
        if (Ee.type.is("Block") && (0 > Mr.indexOf(Ee.type.id) ? (Un = Ee.to - Ge, Pe = se.block.children.length) : (Un = C, Pe = re, C = Ee.to - Ge, re = se.block.children.length)), !Ee.nextSibling()) break;
      }
      for (; se.block.children.length > Pe; ) se.block.children.pop(), se.block.positions.pop();
      return Un - Kn;
    }
  }
  t = Fe.styleTags({
    "Blockquote/...": Fe.tags.quote,
    HorizontalRule: Fe.tags.contentSeparator,
    "ATXHeading1/... SetextHeading1/...": Fe.tags.heading1,
    "ATXHeading2/... SetextHeading2/...": Fe.tags.heading2,
    "ATXHeading3/...": Fe.tags.heading3,
    "ATXHeading4/...": Fe.tags.heading4,
    "ATXHeading5/...": Fe.tags.heading5,
    "ATXHeading6/...": Fe.tags.heading6,
    "Comment CommentBlock": Fe.tags.comment,
    Escape: Fe.tags.escape,
    Entity: Fe.tags.character,
    "Emphasis/...": Fe.tags.emphasis,
    "StrongEmphasis/...": Fe.tags.strong,
    "Link/... Image/...": Fe.tags.link,
    "OrderedList/... BulletList/...": Fe.tags.list,
    "BlockQuote/...": Fe.tags.quote,
    "InlineCode CodeText": Fe.tags.monospace,
    URL: Fe.tags.url,
    "HeaderMark HardBreak QuoteMark ListMark LinkMark EmphasisMark CodeMark": Fe.tags.processingInstruction,
    "CodeInfo LinkLabel": Fe.tags.labelName,
    LinkTitle: Fe.tags.string,
    Paragraph: Fe.tags.content
  }), e = new En(new Ae.NodeSet(n).extend(t), Object.keys(jt).map((Se) => jt[Se]), Object.keys(jt).map((Se) => _e[Se]), Object.keys(jt), [(Se, se) => 0 <= R(se), (Se, se) => 0 <= h(se), (Se, se) => 0 <= (se.next != 62 ? -1 : se.text.charCodeAt(se.pos + 1) == 32 ? 2 : 1), (Se, se) => 0 <= p(se, Se, !0), (Se, se) => 0 <= _(se, Se, !0), (Se, se) => 0 <= s(se, Se, !0), (Se, se) => 0 <= L(se, Se, !0)], e, Object.keys(Rr).map((Se) => Rr[Se]), Object.keys(Rr), []);
  const bl = { resolve: "Strikethrough", mark: "StrikethroughMark" };
  n = { defineNodes: [
    { name: "Strikethrough", style: { "Strikethrough/...": Fe.tags.strikethrough } },
    { name: "StrikethroughMark", style: Fe.tags.processingInstruction }
  ], parseInline: [{ name: "Strikethrough", parse(Se, se, Ee) {
    if (se != 126 || Se.char(Ee + 1) != 126 || Se.char(Ee + 2) == 126) return -1;
    var Ge = Se.slice(Ee - 1, Ee), vn = Se.slice(Ee + 2, Ee + 3);
    se = /\s|^$/.test(Ge);
    let Kn = /\s|^$/.test(vn);
    return Ge = ul.test(Ge), vn = ul.test(vn), Se.addDelimiter(bl, Ee, Ee + 2, !Kn && (!vn || se || Ge), !se && (!Ge || Kn || vn));
  }, after: "Emphasis" }] };
  const tl = /^\|?(\s*:?-+:?\s*\|)+(\s*:?-+:?\s*)?$/;
  class Zt {
    constructor() {
      this.rows = null;
    }
    nextLine(se, Ee, Ge) {
      if (this.rows == null) {
        this.rows = !1;
        let vn;
        if ((Ee.next == 45 || Ee.next == 58 || Ee.next == 124) && tl.test(vn = Ee.text.slice(Ee.pos))) {
          let Kn = [];
          Ce(se, Ge.content, 0, Kn, Ge.start) == Ce(se, vn, Ee.pos) && (this.rows = [se.elt("TableHeader", Ge.start, Ge.start + Ge.content.length, Kn), se.elt("TableDelimiter", se.lineStart + Ee.pos, se.lineStart + Ee.text.length)]);
        }
      } else this.rows && (Ge = [], Ce(se, Ee.text, Ee.pos, Ge, se.lineStart), this.rows.push(se.elt("TableRow", se.lineStart + Ee.pos, se.lineStart + Ee.text.length, Ge)));
      return !1;
    }
    finish(se, Ee) {
      return this.rows ? (se.addLeafElement(Ee, se.elt("Table", Ee.start, Ee.start + Ee.content.length, this.rows)), !0) : !1;
    }
  }
  t = { defineNodes: [{ name: "Table", block: !0 }, { name: "TableHeader", style: { "TableHeader/...": Fe.tags.heading } }, "TableRow", { name: "TableCell", style: Fe.tags.content }, { name: "TableDelimiter", style: Fe.tags.processingInstruction }], parseBlock: [{ name: "Table", leaf(Se, se) {
    return Ye(se.content, 0) ? new Zt() : null;
  }, endLeaf(Se, se, Ee) {
    return Ee.parsers.some((Ge) => Ge instanceof Zt) || !Ye(se.text, se.basePos) ? !1 : (Ee = Se.scanLine(Se.absoluteLineEnd + 1).text, tl.test(Ee) && Ce(Se, se.text, se.basePos) == Ce(
      Se,
      Ee,
      se.basePos
    ));
  }, before: "SetextHeading" }] };
  class Ql {
    nextLine() {
      return !1;
    }
    finish(se, Ee) {
      return se.addLeafElement(Ee, se.elt("Task", Ee.start, Ee.start + Ee.content.length, [se.elt("TaskMarker", Ee.start, Ee.start + 3), ...se.parser.parseInline(Ee.content.slice(3), Ee.start + 3)])), !0;
    }
  }
  const jl = { defineNodes: [{ name: "Task", block: !0, style: Fe.tags.list }, { name: "TaskMarker", style: Fe.tags.atom }], parseBlock: [{ name: "TaskList", leaf(Se, se) {
    return /^\[[ xX]\][ \t]/.test(se.content) && Se.parentType().name == "ListItem" ? new Ql() : null;
  }, after: "SetextHeading" }] }, Sl = /(www\.)|(https?:\/\/)|([\w.+-]+@)|(mailto:|xmpp:)/gy, gl = /[\w-]+(\.[\w-]+)+(\/[^\s<]*)?/gy, jr = /[\w-]+\.[\w-]+($|\/)/, Kt = /[\w.+-]+@[\w-]+(\.[\w.-]+)+/gy, nl = /\/[a-zA-Z\d@.]+/gy, Pr = { parseInline: [{ name: "Autolink", parse(Se, se, Ee) {
    var Ge = Ee - Se.offset;
    Sl.lastIndex = Ge;
    var vn = Sl.exec(Se.text);
    if (!vn) return -1;
    if (vn[1] || vn[2]) if (se = Se.text, vn = Ge + vn[0].length, gl.lastIndex = vn, Ge = gl.exec(se), !Ge || -1 < jr.exec(Ge[0])[0].indexOf("_")) var Kn = -1;
    else {
      for (Ge = vn + Ge[0].length; ; ) {
        let Un = se[Ge - 1];
        if (/[?!.,:*_~]/.test(Un) || Un == ")" && B(
          se,
          vn,
          Ge,
          ")"
        ) > B(se, vn, Ge, "(")) Ge--;
        else if (Un == ";" && (Kn = /&(?:#\d+|#x[a-f\d]+|\w+);$/.exec(se.slice(vn, Ge)))) Ge = vn + Kn.index;
        else break;
      }
      Kn = Ge;
    }
    else vn[3] ? Kn = q(Se.text, Ge) : (Kn = q(Se.text, Ge + vn[0].length), -1 < Kn && vn[0] == "xmpp:" && (nl.lastIndex = Kn, (vn = nl.exec(Se.text)) && (Kn = vn.index + vn[0].length)));
    return 0 > Kn ? -1 : (Se.addElement(Se.elt("URL", Ee, Kn + Se.offset)), Kn + Se.offset);
  } }] }, ii = [t, jl, n, Pr], Ar = {
    defineNodes: [{ name: "Superscript", style: Fe.tags.special(Fe.tags.content) }, { name: "SuperscriptMark", style: Fe.tags.processingInstruction }],
    parseInline: [{ name: "Superscript", parse: me(94, "Superscript", "SuperscriptMark") }]
  }, Ml = { defineNodes: [{ name: "Subscript", style: Fe.tags.special(Fe.tags.content) }, { name: "SubscriptMark", style: Fe.tags.processingInstruction }], parseInline: [{ name: "Subscript", parse: me(126, "Subscript", "SubscriptMark") }] }, Rl = { defineNodes: [{ name: "Emoji", style: Fe.tags.character }], parseInline: [{ name: "Emoji", parse(Se, se, Ee) {
    let Ge;
    return se == 58 && (Ge = /^[a-zA-Z_0-9]+:/.exec(Se.slice(Ee + 1, Se.end))) ? Se.addElement(Se.elt("Emoji", Ee, Ee + 1 + Ge[0].length)) : -1;
  } }] };
  l.Autolink = Pr, l.BlockContext = an, l.Element = ot, l.Emoji = Rl, l.GFM = ii, l.InlineContext = ql, l.LeafBlock = Ze, l.Line = pn, l.MarkdownParser = En, l.Strikethrough = n, l.Subscript = Ml, l.Superscript = Ar, l.Table = t, l.TaskList = jl, l.parseCode = function(Se) {
    let { codeParser: se, htmlParser: Ee } = Se;
    return { wrap: Ae.parseMixed((Ge, vn) => {
      let Kn = Ge.type.id;
      if (se && (Kn == Be.CodeBlock || Kn == Be.FencedCode)) {
        let Un = "";
        if (Kn == Be.FencedCode && (Ge = Ge.node.getChild(Be.CodeInfo)) && (Un = vn.read(Ge.from, Ge.to)), vn = se(Un)) return { parser: vn, overlay: (Pe) => Pe.type.id == Be.CodeText };
      } else if (Ee && (Kn == Be.HTMLBlock || Kn == Be.HTMLTag)) return { parser: Ee, overlay: le(Ge.node, Ge.from, Ge.to) };
      return null;
    }) };
  }, l.parser = e;
};
Xo[13] = function(e, n, t, l) {
  (function(r, u) {
    typeof l == "object" && typeof t < "u" ? u(l) : typeof define == "function" && define.amd ? define(["exports"], u) : (r = r || self, u(r.JSJoda = {}));
  })(this, function(r) {
    function u(be, b, w) {
      function i(x) {
        Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = Error().stack, this.message = x, b && b.apply(this, arguments), this.toString = function() {
          return this.name + ": " + this.message;
        };
      }
      return w === void 0 && (w = Error), i.prototype = Object.create(w.prototype), i.prototype.name = be, i.prototype.constructor = i;
    }
    function o(be, b) {
      be.prototype = Object.create(b.prototype), be.prototype.constructor = be, be.__proto__ = b;
    }
    function a(be) {
      if (be === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return be;
    }
    function h(be, b, w) {
      if (!be)
        throw w ? new w(b) : Error(b);
    }
    function s(be, b) {
      if (be == null) throw new $e(b + " must not be null");
      return be;
    }
    function d(be, b, w) {
      if (!(be instanceof b)) throw new ce(w + " must be an instance of " + (b.name ? b.name : b) + (be && be.constructor && be.constructor.name ? ", but is " + be.constructor.name : ""));
      return be;
    }
    function p(be) {
      throw new TypeError('abstract method "' + be + '" is not implemented');
    }
    function _(be, b) {
      var w = function(i) {
        function x() {
          return i.apply(this, arguments) || this;
        }
        return o(x, i), x;
      }(Ae);
      return w.prototype.queryFrom = b, new w(be);
    }
    function R(be, b) {
      return new $a(be, b);
    }
    function F(be, b) {
      return new oa(be, b);
    }
    var L = u("DateTimeException", function(be, b) {
      b === void 0 && (b = null), be = be || this.name, b !== null && b instanceof Error && (be += `
-------
Caused by: ` + b.stack + `
-------
`), this.message = be;
    }), G = u("DateTimeParseException", function(be, b, w, i) {
      b === void 0 && (b = ""), w === void 0 && (w = 0), i === void 0 && (i = null), be = be || this.name, be += ": " + b + ", at index: " + w, i !== null && i instanceof Error && (be += `
-------
Caused by: ` + i.stack + `
-------
`), this.message = be, this.parsedString = function() {
        return b;
      }, this.errorIndex = function() {
        return w;
      };
    }), J = u("UnsupportedTemporalTypeException", null, L), we = u("ArithmeticException"), ce = u("IllegalArgumentException"), xe = u("IllegalStateException"), $e = u("NullPointerException"), je = Object.freeze({ __proto__: null, assert: h, requireNonNull: s, requireInstance: d, abstractMethodFail: p }), E = function() {
      function be() {
      }
      return be.intDiv = function(b, w) {
        return b = be.roundDown(b / w), be.safeZero(b);
      }, be.intMod = function(b, w) {
        return b -= be.intDiv(b, w) * w, b = be.roundDown(b), be.safeZero(b);
      }, be.roundDown = function(b) {
        return 0 > b ? Math.ceil(b) : Math.floor(b);
      }, be.floorDiv = function(b, w) {
        return be.safeZero(Math.floor(b / w));
      }, be.floorMod = function(b, w) {
        return b -= be.floorDiv(b, w) * w, be.safeZero(b);
      }, be.safeAdd = function(b, w) {
        if (be.verifyInt(b), be.verifyInt(w), b === 0) return be.safeZero(w);
        if (w === 0) return be.safeZero(b);
        var i = be.safeToInt(b + w);
        if (i === b || i === w) throw new we("Invalid addition beyond MAX_SAFE_INTEGER!");
        return i;
      }, be.safeSubtract = function(b, w) {
        return be.verifyInt(b), be.verifyInt(w), b === 0 && w === 0 ? 0 : b === 0 ? be.safeZero(-1 * w) : w === 0 ? be.safeZero(b) : be.safeToInt(b - w);
      }, be.safeMultiply = function(b, w) {
        if (be.verifyInt(b), be.verifyInt(w), b === 1) return be.safeZero(w);
        if (w === 1) return be.safeZero(b);
        if (b === 0 || w === 0) return 0;
        var i = be.safeToInt(b * w);
        if (i / w !== b || b === -9007199254740991 && w === -1 || w === -9007199254740991 && b === -1) throw new we("Multiplication overflows: " + b + " * " + w);
        return i;
      }, be.parseInt = function(b) {
        function w(i) {
          return b.apply(this, arguments);
        }
        return w.toString = function() {
          return b.toString();
        }, w;
      }(function(b) {
        return b = parseInt(b), be.safeToInt(b);
      }), be.safeToInt = function(b) {
        return be.verifyInt(b), be.safeZero(b);
      }, be.verifyInt = function(b) {
        if (b == null) throw new we("Invalid value: '" + b + "', using null or undefined as argument");
        if (isNaN(b)) throw new we("Invalid int value, using NaN as argument");
        if (b % 1 !== 0) throw new we("Invalid value: '" + b + "' is a float");
        if (9007199254740991 < b || -9007199254740991 > b) throw new we("Calculation overflows an int: " + b);
      }, be.safeZero = function(b) {
        return b === 0 ? 0 : +b;
      }, be.compareNumbers = function(b, w) {
        return b < w ? -1 : b > w ? 1 : 0;
      }, be.smi = function(b) {
        return b >>> 1 & 1073741824 | b & 3221225471;
      }, be.hash = function(b) {
        if (b !== b || b === 1 / 0) return 0;
        for (var w = b; 4294967295 < b; ) b /= 4294967295, w ^= b;
        return be.smi(w);
      }, be.hashCode = function() {
        for (var b = 17, w = arguments.length, i = Array(w), x = 0; x < w; x++) i[x] = arguments[x];
        for (w = 0; w < i.length; w++) b = (b << 5) - b + be.hash(i[w]);
        return be.hash(b);
      }, be;
    }();
    E.MAX_SAFE_INTEGER = 9007199254740991, E.MIN_SAFE_INTEGER = -9007199254740991;
    var P = function() {
      function be(w) {
        this._name = w;
      }
      var b = be.prototype;
      return b.equals = function(w) {
        return this === w;
      }, b.toString = function() {
        return this._name;
      }, b.toJSON = function() {
        return this.toString();
      }, be;
    }(), K = function() {
      function be() {
      }
      var b = be.prototype;
      return b.get = function(w) {
        p("get");
      }, b.units = function() {
        p("units");
      }, b.addTo = function(w) {
        p("addTo");
      }, b.subtractFrom = function(w) {
        p("subtractFrom");
      }, be;
    }(), H = function() {
      function be() {
      }
      var b = be.prototype;
      return b.duration = function() {
        p("duration");
      }, b.isDurationEstimated = function() {
        p("isDurationEstimated");
      }, b.isDateBased = function() {
        p("isDateBased");
      }, b.isTimeBased = function() {
        p("isTimeBased");
      }, b.isSupportedBy = function(w) {
        p("isSupportedBy");
      }, b.addTo = function(w, i) {
        p("addTo");
      }, b.between = function(w, i) {
        p("between");
      }, be;
    }(), U = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return X._seconds = E.safeToInt(i), X._nanos = E.safeToInt(x), X;
      }
      o(b, be), b.ofDays = function(i) {
        return b._create(E.safeMultiply(i, Fn.SECONDS_PER_DAY), 0);
      }, b.ofHours = function(i) {
        return b._create(E.safeMultiply(i, Fn.SECONDS_PER_HOUR), 0);
      }, b.ofMinutes = function(i) {
        return b._create(E.safeMultiply(i, Fn.SECONDS_PER_MINUTE), 0);
      }, b.ofSeconds = function(i, x) {
        return x === void 0 && (x = 0), i = E.safeAdd(i, E.floorDiv(x, Fn.NANOS_PER_SECOND)), x = E.floorMod(x, Fn.NANOS_PER_SECOND), b._create(i, x);
      }, b.ofMillis = function(i) {
        var x = E.intDiv(i, 1e3);
        return i = E.intMod(i, 1e3), 0 > i && (i += 1e3, x--), b._create(x, 1e6 * i);
      }, b.ofNanos = function(i) {
        var x = E.intDiv(i, Fn.NANOS_PER_SECOND);
        return i = E.intMod(i, Fn.NANOS_PER_SECOND), 0 > i && (i += Fn.NANOS_PER_SECOND, x--), this._create(x, i);
      }, b.of = function(i, x) {
        return b.ZERO.plus(i, x);
      }, b.from = function(i) {
        s(i, "amount"), d(i, K);
        var x = b.ZERO;
        return i.units().forEach(function(X) {
          x = x.plus(i.get(X), X);
        }), x;
      }, b.between = function(i, x) {
        s(i, "startInclusive"), s(x, "endExclusive");
        var X = i.until(x, le.SECONDS), He = 0;
        if (i.isSupported(B.NANO_OF_SECOND) && x.isSupported(B.NANO_OF_SECOND)) try {
          var $n = i.getLong(B.NANO_OF_SECOND);
          if (He = x.getLong(B.NANO_OF_SECOND) - $n, 0 < X && 0 > He) He += Fn.NANOS_PER_SECOND;
          else if (0 > X && 0 < He) He -= Fn.NANOS_PER_SECOND;
          else if (X === 0 && He !== 0) {
            var Xt = x.with(B.NANO_OF_SECOND, $n);
            X = i.until(Xt, le.SECONDS);
          }
        } catch {
        }
        return this.ofSeconds(X, He);
      }, b.parse = function(i) {
        s(i, "text");
        var x = RegExp("([-+]?)P(?:([-+]?[0-9]+)D)?(T(?:([-+]?[0-9]+)H)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)(?:[.,]([0-9]{0,9}))?S)?)?", "i").exec(i);
        if (x !== null && x[3] !== "T") {
          var X = x[1] === "-", He = x[2], $n = x[4], Xt = x[5], $l = x[6];
          if (x = x[7], He != null || $n != null || Xt != null || $l != null) {
            He = b._parseNumber(i, He, Fn.SECONDS_PER_DAY, "days"), $n = b._parseNumber(i, $n, Fn.SECONDS_PER_HOUR, "hours"), Xt = b._parseNumber(i, Xt, Fn.SECONDS_PER_MINUTE, "minutes");
            var Oe = b._parseNumber(i, $l, 1, "seconds");
            $l = $l != null && $l.charAt(0) === "-", $l = b._parseFraction(i, x, $l ? -1 : 1);
            try {
              return b._create(X, He, $n, Xt, Oe, $l);
            } catch (Ke) {
              throw new G("Text cannot be parsed to a Duration: overflow", i, 0, Ke);
            }
          }
        }
        throw new G("Text cannot be parsed to a Duration", i, 0);
      }, b._parseNumber = function(i, x, X, He) {
        if (x == null) return 0;
        try {
          return x[0] === "+" && (x = x.substring(1)), E.safeMultiply(parseFloat(x), X);
        } catch ($n) {
          throw new G("Text cannot be parsed to a Duration: " + He, i, 0, $n);
        }
      }, b._parseFraction = function(i, x, X) {
        return x == null || x.length === 0 ? 0 : (x = (x + "000000000").substring(0, 9), parseFloat(x) * X);
      }, b._create = function() {
        return 2 >= arguments.length ? b._createSecondsNanos(arguments[0], arguments[1]) : b._createNegateDaysHoursMinutesSecondsNanos(
          arguments[0],
          arguments[1],
          arguments[2],
          arguments[3],
          arguments[4],
          arguments[5]
        );
      }, b._createNegateDaysHoursMinutesSecondsNanos = function(i, x, X, He, $n, Xt) {
        return x = E.safeAdd(x, E.safeAdd(X, E.safeAdd(He, $n))), i ? b.ofSeconds(x, Xt).negated() : b.ofSeconds(x, Xt);
      }, b._createSecondsNanos = function(i, x) {
        return i === void 0 && (i = 0), x === void 0 && (x = 0), i === 0 && x === 0 ? b.ZERO : new b(i, x);
      };
      var w = b.prototype;
      return w.get = function(i) {
        if (i === le.SECONDS) return this._seconds;
        if (i === le.NANOS) return this._nanos;
        throw new J("Unsupported unit: " + i);
      }, w.units = function() {
        return [le.SECONDS, le.NANOS];
      }, w.isZero = function() {
        return this._seconds === 0 && this._nanos === 0;
      }, w.isNegative = function() {
        return 0 > this._seconds;
      }, w.seconds = function() {
        return this._seconds;
      }, w.nano = function() {
        return this._nanos;
      }, w.withSeconds = function(i) {
        return b._create(i, this._nanos);
      }, w.withNanos = function(i) {
        return B.NANO_OF_SECOND.checkValidIntValue(i), b._create(this._seconds, i);
      }, w.plusDuration = function(i) {
        return s(i, "duration"), this.plus(i.seconds(), i.nano());
      }, w.plus = function(i, x) {
        return arguments.length === 1 ? this.plusDuration(i) : arguments.length === 2 && x instanceof H ? this.plusAmountUnit(i, x) : this.plusSecondsNanos(i, x);
      }, w.plusAmountUnit = function(i, x) {
        if (s(i, "amountToAdd"), s(x, "unit"), x === le.DAYS) return this.plusSecondsNanos(E.safeMultiply(i, Fn.SECONDS_PER_DAY), 0);
        if (x.isDurationEstimated()) throw new J("Unit must not have an estimated duration");
        if (i === 0) return this;
        if (x instanceof le) {
          switch (x) {
            case le.NANOS:
              return this.plusNanos(i);
            case le.MICROS:
              return this.plusSecondsNanos(1e3 * E.intDiv(i, 1e9), 1e3 * E.intMod(i, 1e9));
            case le.MILLIS:
              return this.plusMillis(i);
            case le.SECONDS:
              return this.plusSeconds(i);
          }
          return this.plusSecondsNanos(E.safeMultiply(
            x.duration().seconds(),
            i
          ), 0);
        }
        return i = x.duration().multipliedBy(i), this.plusSecondsNanos(i.seconds(), i.nano());
      }, w.plusDays = function(i) {
        return this.plusSecondsNanos(E.safeMultiply(i, Fn.SECONDS_PER_DAY), 0);
      }, w.plusHours = function(i) {
        return this.plusSecondsNanos(E.safeMultiply(i, Fn.SECONDS_PER_HOUR), 0);
      }, w.plusMinutes = function(i) {
        return this.plusSecondsNanos(E.safeMultiply(i, Fn.SECONDS_PER_MINUTE), 0);
      }, w.plusSeconds = function(i) {
        return this.plusSecondsNanos(i, 0);
      }, w.plusMillis = function(i) {
        return this.plusSecondsNanos(E.intDiv(
          i,
          1e3
        ), 1e6 * E.intMod(i, 1e3));
      }, w.plusNanos = function(i) {
        return this.plusSecondsNanos(0, i);
      }, w.plusSecondsNanos = function(i, x) {
        return s(i, "secondsToAdd"), s(x, "nanosToAdd"), i === 0 && x === 0 ? this : (i = E.safeAdd(this._seconds, i), i = E.safeAdd(i, E.intDiv(x, Fn.NANOS_PER_SECOND)), x = E.intMod(x, Fn.NANOS_PER_SECOND), x = E.safeAdd(this._nanos, x), b.ofSeconds(i, x));
      }, w.minus = function(i, x) {
        return arguments.length === 1 ? this.minusDuration(i) : this.minusAmountUnit(i, x);
      }, w.minusDuration = function(i) {
        s(i, "duration");
        var x = i.seconds();
        return i = i.nano(), x === -9007199254740991 ? this.plus(9007199254740991, -i) : this.plus(-x, -i);
      }, w.minusAmountUnit = function(i, x) {
        return s(i, "amountToSubtract"), s(x, "unit"), i === -9007199254740991 ? this.plusAmountUnit(9007199254740991, x) : this.plusAmountUnit(-i, x);
      }, w.minusDays = function(i) {
        return i === -9007199254740991 ? this.plusDays(9007199254740991) : this.plusDays(-i);
      }, w.minusHours = function(i) {
        return i === -9007199254740991 ? this.plusHours(9007199254740991) : this.plusHours(-i);
      }, w.minusMinutes = function(i) {
        return i === -9007199254740991 ? this.plusMinutes(9007199254740991) : this.plusMinutes(-i);
      }, w.minusSeconds = function(i) {
        return i === -9007199254740991 ? this.plusSeconds(9007199254740991) : this.plusSeconds(-i);
      }, w.minusMillis = function(i) {
        return i === -9007199254740991 ? this.plusMillis(9007199254740991) : this.plusMillis(-i);
      }, w.minusNanos = function(i) {
        return i === -9007199254740991 ? this.plusNanos(9007199254740991) : this.plusNanos(-i);
      }, w.multipliedBy = function(i) {
        if (i === 0) return b.ZERO;
        if (i === 1) return this;
        var x = E.safeMultiply(this._seconds, i);
        return i = E.safeMultiply(
          this._nanos,
          i
        ), x += E.intDiv(i, Fn.NANOS_PER_SECOND), i = E.intMod(i, Fn.NANOS_PER_SECOND), b.ofSeconds(x, i);
      }, w.dividedBy = function(i) {
        if (i === 0) throw new we("Cannot divide by zero");
        if (i === 1) return this;
        var x = E.intDiv(this._seconds, i), X = E.roundDown((this._seconds / i - x) * Fn.NANOS_PER_SECOND);
        return i = E.intDiv(this._nanos, i), b.ofSeconds(x, X + i);
      }, w.negated = function() {
        return this.multipliedBy(-1);
      }, w.abs = function() {
        return this.isNegative() ? this.negated() : this;
      }, w.addTo = function(i) {
        return s(i, "temporal"), this._seconds !== 0 && (i = i.plus(this._seconds, le.SECONDS)), this._nanos !== 0 && (i = i.plus(this._nanos, le.NANOS)), i;
      }, w.subtractFrom = function(i) {
        return s(i, "temporal"), this._seconds !== 0 && (i = i.minus(this._seconds, le.SECONDS)), this._nanos !== 0 && (i = i.minus(this._nanos, le.NANOS)), i;
      }, w.toDays = function() {
        return E.intDiv(this._seconds, Fn.SECONDS_PER_DAY);
      }, w.toHours = function() {
        return E.intDiv(this._seconds, Fn.SECONDS_PER_HOUR);
      }, w.toMinutes = function() {
        return E.intDiv(this._seconds, Fn.SECONDS_PER_MINUTE);
      }, w.toMillis = function() {
        var i = Math.round(E.safeMultiply(
          this._seconds,
          1e3
        ));
        return i = E.safeAdd(i, E.intDiv(this._nanos, 1e6));
      }, w.toNanos = function() {
        var i = E.safeMultiply(this._seconds, Fn.NANOS_PER_SECOND);
        return i = E.safeAdd(i, this._nanos);
      }, w.compareTo = function(i) {
        s(i, "otherDuration"), d(i, b, "otherDuration");
        var x = E.compareNumbers(this._seconds, i.seconds());
        return x !== 0 ? x : this._nanos - i.nano();
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this.seconds() === i.seconds() && this.nano() === i.nano() : !1;
      }, w.toString = function() {
        if (this === b.ZERO) return "PT0S";
        var i = E.intDiv(
          this._seconds,
          Fn.SECONDS_PER_HOUR
        ), x = E.intDiv(E.intMod(this._seconds, Fn.SECONDS_PER_HOUR), Fn.SECONDS_PER_MINUTE), X = E.intMod(this._seconds, Fn.SECONDS_PER_MINUTE), He = "PT";
        if (i !== 0 && (He += i + "H"), x !== 0 && (He += x + "M"), X === 0 && this._nanos === 0 && 2 < He.length) return He;
        if (He = 0 > X && 0 < this._nanos ? X === -1 ? He + "-0" : He + (X + 1) : He + X, 0 < this._nanos) for (He += ".", i = 0 > X ? "" + (2 * Fn.NANOS_PER_SECOND - this._nanos) : "" + (Fn.NANOS_PER_SECOND + this._nanos), i = i.slice(1, i.length), He += i; He.charAt(He.length - 1) === "0"; ) He = He.slice(0, He.length - 1);
        return He + "S";
      }, w.toJSON = function() {
        return this.toString();
      }, b;
    }(K), Me = function() {
    }, le = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return X._name = i, X._duration = x, X;
      }
      o(b, be);
      var w = b.prototype;
      return w.duration = function() {
        return this._duration;
      }, w.isDurationEstimated = function() {
        return this.isDateBased() || this === b.FOREVER;
      }, w.isDateBased = function() {
        return 0 <= this.compareTo(b.DAYS) && this !== b.FOREVER;
      }, w.isTimeBased = function() {
        return 0 > this.compareTo(b.DAYS);
      }, w.isSupportedBy = function(i) {
        if (this === b.FOREVER) return !1;
        try {
          return i.plus(1, this), !0;
        } catch {
          try {
            return i.plus(
              -1,
              this
            ), !0;
          } catch {
            return !1;
          }
        }
      }, w.addTo = function(i, x) {
        return i.plus(x, this);
      }, w.between = function(i, x) {
        return i.until(x, this);
      }, w.toString = function() {
        return this._name;
      }, w.compareTo = function(i) {
        return this.duration().compareTo(i.duration());
      }, b;
    }(H), Ce = function() {
      function be() {
      }
      var b = be.prototype;
      return b.isDateBased = function() {
        p("isDateBased");
      }, b.isTimeBased = function() {
        p("isTimeBased");
      }, b.baseUnit = function() {
        p("baseUnit");
      }, b.rangeUnit = function() {
        p("rangeUnit");
      }, b.range = function() {
        p("range");
      }, b.rangeRefinedBy = function(w) {
        p("rangeRefinedBy");
      }, b.getFrom = function(w) {
        p("getFrom");
      }, b.adjustInto = function(w, i) {
        p("adjustInto");
      }, b.isSupportedBy = function(w) {
        p("isSupportedBy");
      }, b.displayName = function() {
        p("displayName");
      }, b.equals = function(w) {
        p("equals");
      }, b.name = function() {
        p("name");
      }, be;
    }(), Ye = function() {
      function be(w, i, x, X) {
        h(!(w > i), "Smallest minimum value '" + w + "' must be less than largest minimum value '" + i + "'", ce), h(!(x > X), "Smallest maximum value '" + x + "' must be less than largest maximum value '" + X + "'", ce), h(!(i > X), "Minimum value '" + i + "' must be less than maximum value '" + X + "'", ce), this._minSmallest = w, this._minLargest = i, this._maxLargest = X, this._maxSmallest = x;
      }
      var b = be.prototype;
      return b.isFixed = function() {
        return this._minSmallest === this._minLargest && this._maxSmallest === this._maxLargest;
      }, b.minimum = function() {
        return this._minSmallest;
      }, b.largestMinimum = function() {
        return this._minLargest;
      }, b.maximum = function() {
        return this._maxLargest;
      }, b.smallestMaximum = function() {
        return this._maxSmallest;
      }, b.isValidValue = function(w) {
        return this.minimum() <= w && w <= this.maximum();
      }, b.checkValidValue = function(w, i) {
        return this.isValidValue(w) ? w : (w = i != null ? "Invalid value for " + i + " (valid values " + this.toString() + "): " + w : "Invalid value (valid values " + this.toString() + "): " + w, h(!1, w, L));
      }, b.checkValidIntValue = function(w, i) {
        if (this.isValidIntValue(w) === !1) throw new L("Invalid int value for " + i + ": " + w);
        return w;
      }, b.isValidIntValue = function(w) {
        return this.isIntValue() && this.isValidValue(w);
      }, b.isIntValue = function() {
        return this.minimum() >= E.MIN_SAFE_INTEGER && this.maximum() <= E.MAX_SAFE_INTEGER;
      }, b.equals = function(w) {
        return w === this ? !0 : w instanceof be ? this._minSmallest === w._minSmallest && this._minLargest === w._minLargest && this._maxSmallest === w._maxSmallest && this._maxLargest === w._maxLargest : !1;
      }, b.hashCode = function() {
        return E.hashCode(this._minSmallest, this._minLargest, this._maxSmallest, this._maxLargest);
      }, b.toString = function() {
        var w = this.minimum() + (this.minimum() !== this.largestMinimum() ? "/" + this.largestMinimum() : "");
        return w = w + " - " + (this.smallestMaximum() + (this.smallestMaximum() !== this.maximum() ? "/" + this.maximum() : ""));
      }, be.of = function() {
        return arguments.length === 2 ? new be(arguments[0], arguments[0], arguments[1], arguments[1]) : arguments.length === 3 ? new be(arguments[0], arguments[0], arguments[1], arguments[2]) : arguments.length === 4 ? new be(arguments[0], arguments[1], arguments[2], arguments[3]) : h(!1, "Invalid number of arguments " + arguments.length, ce);
      }, be;
    }(), B = function(be) {
      function b(i, x, X, He) {
        var $n = be.call(this) || this;
        return $n._name = i, $n._baseUnit = x, $n._rangeUnit = X, $n._range = He, $n;
      }
      o(b, be), b.byName = function(i) {
        for (var x in b) if (b[x] && b[x] instanceof b && b[x].name() === i) return b[x];
      };
      var w = b.prototype;
      return w.name = function() {
        return this._name;
      }, w.baseUnit = function() {
        return this._baseUnit;
      }, w.rangeUnit = function() {
        return this._rangeUnit;
      }, w.range = function() {
        return this._range;
      }, w.displayName = function() {
        return this.toString();
      }, w.checkValidValue = function(i) {
        return this.range().checkValidValue(i, this);
      }, w.checkValidIntValue = function(i) {
        return this.range().checkValidIntValue(
          i,
          this
        );
      }, w.isDateBased = function() {
        return this === b.DAY_OF_WEEK || this === b.ALIGNED_DAY_OF_WEEK_IN_MONTH || this === b.ALIGNED_DAY_OF_WEEK_IN_YEAR || this === b.DAY_OF_MONTH || this === b.DAY_OF_YEAR || this === b.EPOCH_DAY || this === b.ALIGNED_WEEK_OF_MONTH || this === b.ALIGNED_WEEK_OF_YEAR || this === b.MONTH_OF_YEAR || this === b.YEAR_OF_ERA || this === b.YEAR || this === b.ERA;
      }, w.isTimeBased = function() {
        return this === b.NANO_OF_SECOND || this === b.NANO_OF_DAY || this === b.MICRO_OF_SECOND || this === b.MICRO_OF_DAY || this === b.MILLI_OF_SECOND || this === b.MILLI_OF_DAY || this === b.SECOND_OF_MINUTE || this === b.SECOND_OF_DAY || this === b.MINUTE_OF_HOUR || this === b.MINUTE_OF_DAY || this === b.HOUR_OF_AMPM || this === b.CLOCK_HOUR_OF_AMPM || this === b.HOUR_OF_DAY || this === b.CLOCK_HOUR_OF_DAY || this === b.AMPM_OF_DAY;
      }, w.rangeRefinedBy = function(i) {
        return i.range(this);
      }, w.getFrom = function(i) {
        return i.getLong(this);
      }, w.toString = function() {
        return this.name();
      }, w.equals = function(i) {
        return this === i;
      }, w.adjustInto = function(i, x) {
        return i.with(this, x);
      }, w.isSupportedBy = function(i) {
        return i.isSupported(this);
      }, b;
    }(Ce), q = function() {
      function be() {
      }
      return be.zoneId = function() {
        return be.ZONE_ID;
      }, be.chronology = function() {
        return be.CHRONO;
      }, be.precision = function() {
        return be.PRECISION;
      }, be.zone = function() {
        return be.ZONE;
      }, be.offset = function() {
        return be.OFFSET;
      }, be.localDate = function() {
        return be.LOCAL_DATE;
      }, be.localTime = function() {
        return be.LOCAL_TIME;
      }, be;
    }(), me = function() {
      function be() {
      }
      var b = be.prototype;
      return b.query = function(w) {
        return w === q.zoneId() || w === q.chronology() || w === q.precision() ? null : w.queryFrom(this);
      }, b.get = function(w) {
        return this.range(w).checkValidIntValue(
          this.getLong(w),
          w
        );
      }, b.range = function(w) {
        if (w instanceof B) {
          if (this.isSupported(w)) return w.range();
          throw new J("Unsupported field: " + w);
        }
        return w.rangeRefinedBy(this);
      }, be;
    }(), Ae = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      return o(b, be), b.prototype.queryFrom = function(w) {
        p("queryFrom");
      }, b;
    }(P), Fe = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return X._ordinal = i, X._name = x, X;
      }
      o(b, be);
      var w = b.prototype;
      return w.ordinal = function() {
        return this._ordinal;
      }, w.name = function() {
        return this._name;
      }, b.values = function() {
        return ln.slice();
      }, b.valueOf = function(i) {
        var x = 0;
        for (x; x < ln.length && ln[x].name() !== i; x++) ;
        return b.of(x + 1);
      }, b.of = function(i) {
        if (1 > i || 7 < i) throw new L("Invalid value for DayOfWeek: " + i);
        return ln[i - 1];
      }, b.from = function(i) {
        if (h(i != null, "temporal", $e), i instanceof b) return i;
        try {
          return b.of(i.get(B.DAY_OF_WEEK));
        } catch (x) {
          throw x instanceof L ? new L("Unable to obtain DayOfWeek from TemporalAccessor: " + i + ", type " + (i.constructor != null ? i.constructor.name : ""), x) : x;
        }
      }, w.value = function() {
        return this._ordinal + 1;
      }, w.displayName = function(i, x) {
        throw new ce("Pattern using (localized) text not implemented yet!");
      }, w.isSupported = function(i) {
        return i instanceof B ? i === B.DAY_OF_WEEK : i != null && i.isSupportedBy(this);
      }, w.range = function(i) {
        if (i === B.DAY_OF_WEEK) return i.range();
        if (i instanceof B) throw new J("Unsupported field: " + i);
        return i.rangeRefinedBy(this);
      }, w.get = function(i) {
        return i === B.DAY_OF_WEEK ? this.value() : this.range(i).checkValidIntValue(this.getLong(i), i);
      }, w.getLong = function(i) {
        if (i === B.DAY_OF_WEEK) return this.value();
        if (i instanceof B) throw new J("Unsupported field: " + i);
        return i.getFrom(this);
      }, w.plus = function(i) {
        return i = E.floorMod(i, 7), ln[E.floorMod(this._ordinal + (i + 7), 7)];
      }, w.minus = function(i) {
        return this.plus(-1 * E.floorMod(i, 7));
      }, w.query = function(i) {
        return i === q.precision() ? le.DAYS : i === q.localDate() || i === q.localTime() || i === q.chronology() || i === q.zone() || i === q.zoneId() || i === q.offset() ? null : (h(i != null, "query", $e), i.queryFrom(this));
      }, w.adjustInto = function(i) {
        return s(i, "temporal"), i.with(
          B.DAY_OF_WEEK,
          this.value()
        );
      }, w.equals = function(i) {
        return this === i;
      }, w.toString = function() {
        return this._name;
      }, w.compareTo = function(i) {
        return s(i, "other"), d(i, b, "other"), this._ordinal - i._ordinal;
      }, w.toJSON = function() {
        return this.toString();
      }, b;
    }(me), ln, Be = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return X._value = E.safeToInt(i), X._name = x, X;
      }
      o(b, be);
      var w = b.prototype;
      return w.value = function() {
        return this._value;
      }, w.ordinal = function() {
        return this._value - 1;
      }, w.name = function() {
        return this._name;
      }, w.displayName = function(i, x) {
        throw new ce("Pattern using (localized) text not implemented yet!");
      }, w.isSupported = function(i) {
        return i === null ? !1 : i instanceof B ? i === B.MONTH_OF_YEAR : i != null && i.isSupportedBy(this);
      }, w.get = function(i) {
        return i === B.MONTH_OF_YEAR ? this.value() : this.range(i).checkValidIntValue(this.getLong(i), i);
      }, w.getLong = function(i) {
        if (i === B.MONTH_OF_YEAR) return this.value();
        if (i instanceof B) throw new J("Unsupported field: " + i);
        return i.getFrom(this);
      }, w.plus = function(i) {
        return i = E.intMod(i, 12) + 12, i = E.intMod(this.value() + i, 12), b.of(i === 0 ? 12 : i);
      }, w.minus = function(i) {
        return this.plus(-1 * E.intMod(i, 12));
      }, w.length = function(i) {
        switch (this) {
          case b.FEBRUARY:
            return i ? 29 : 28;
          case b.APRIL:
          case b.JUNE:
          case b.SEPTEMBER:
          case b.NOVEMBER:
            return 30;
          default:
            return 31;
        }
      }, w.minLength = function() {
        switch (this) {
          case b.FEBRUARY:
            return 28;
          case b.APRIL:
          case b.JUNE:
          case b.SEPTEMBER:
          case b.NOVEMBER:
            return 30;
          default:
            return 31;
        }
      }, w.maxLength = function() {
        switch (this) {
          case b.FEBRUARY:
            return 29;
          case b.APRIL:
          case b.JUNE:
          case b.SEPTEMBER:
          case b.NOVEMBER:
            return 30;
          default:
            return 31;
        }
      }, w.firstDayOfYear = function(i) {
        switch (i = i ? 1 : 0, this) {
          case b.JANUARY:
            return 1;
          case b.FEBRUARY:
            return 32;
          case b.MARCH:
            return 60 + i;
          case b.APRIL:
            return 91 + i;
          case b.MAY:
            return 121 + i;
          case b.JUNE:
            return 152 + i;
          case b.JULY:
            return 182 + i;
          case b.AUGUST:
            return 213 + i;
          case b.SEPTEMBER:
            return 244 + i;
          case b.OCTOBER:
            return 274 + i;
          case b.NOVEMBER:
            return 305 + i;
          default:
            return 335 + i;
        }
      }, w.firstMonthOfQuarter = function() {
        switch (this) {
          case b.JANUARY:
          case b.FEBRUARY:
          case b.MARCH:
            return b.JANUARY;
          case b.APRIL:
          case b.MAY:
          case b.JUNE:
            return b.APRIL;
          case b.JULY:
          case b.AUGUST:
          case b.SEPTEMBER:
            return b.JULY;
          default:
            return b.OCTOBER;
        }
      }, w.query = function(i) {
        return h(i != null, "query() parameter must not be null", L), i === q.chronology() ? ze.INSTANCE : i === q.precision() ? le.MONTHS : be.prototype.query.call(this, i);
      }, w.toString = function() {
        switch (this) {
          case b.JANUARY:
            return "JANUARY";
          case b.FEBRUARY:
            return "FEBRUARY";
          case b.MARCH:
            return "MARCH";
          case b.APRIL:
            return "APRIL";
          case b.MAY:
            return "MAY";
          case b.JUNE:
            return "JUNE";
          case b.JULY:
            return "JULY";
          case b.AUGUST:
            return "AUGUST";
          case b.SEPTEMBER:
            return "SEPTEMBER";
          case b.OCTOBER:
            return "OCTOBER";
          case b.NOVEMBER:
            return "NOVEMBER";
          case b.DECEMBER:
            return "DECEMBER";
          default:
            return "unknown Month, value: " + this.value();
        }
      }, w.toJSON = function() {
        return this.toString();
      }, w.adjustInto = function(i) {
        return i.with(B.MONTH_OF_YEAR, this.value());
      }, w.compareTo = function(i) {
        return s(i, "other"), d(i, b, "other"), this._value - i._value;
      }, w.equals = function(i) {
        return this === i;
      }, b.valueOf = function(i) {
        var x = 0;
        for (x; x < eu.length && eu[x].name() !== i; x++) ;
        return b.of(x + 1);
      }, b.values = function() {
        return eu.slice();
      }, b.of = function(i) {
        return (1 > i || 12 < i) && h(!1, "Invalid value for MonthOfYear: " + i, L), eu[i - 1];
      }, b.from = function(i) {
        if (i instanceof b) return i;
        try {
          return b.of(i.get(B.MONTH_OF_YEAR));
        } catch (x) {
          throw new L("Unable to obtain Month from TemporalAccessor: " + i + " of type " + (i && i.constructor != null ? i.constructor.name : ""), x);
        }
      }, b;
    }(me), Ze = /([-+]?)P(?:([-+]?[0-9]+)Y)?(?:([-+]?[0-9]+)M)?(?:([-+]?[0-9]+)W)?(?:([-+]?[0-9]+)D)?/, pn = function(be) {
      function b(i, x, X) {
        var He = be.call(this) || this;
        return i = E.safeToInt(i), x = E.safeToInt(x), X = E.safeToInt(X), i === 0 && x === 0 && X === 0 ? (b.ZERO || (He._years = i, He._months = x, He._days = X, b.ZERO = a(He)), b.ZERO || a(He)) : (He._years = i, He._months = x, He._days = X, He);
      }
      o(b, be), b.ofYears = function(i) {
        return b.create(i, 0, 0);
      }, b.ofMonths = function(i) {
        return b.create(0, i, 0);
      }, b.ofWeeks = function(i) {
        return b.create(0, 0, E.safeMultiply(i, 7));
      }, b.ofDays = function(i) {
        return b.create(0, 0, i);
      }, b.of = function(i, x, X) {
        return b.create(i, x, X);
      }, b.from = function(i) {
        if (i instanceof b) return i;
        s(i, "amount");
        for (var x = 0, X = 0, He = 0, $n = i.units(), Xt = 0; Xt < $n.length; Xt++) {
          var $l = $n[Xt], Oe = i.get($l);
          if ($l === le.YEARS) x = E.safeToInt(Oe);
          else if ($l === le.MONTHS) X = E.safeToInt(Oe);
          else if ($l === le.DAYS) He = E.safeToInt(Oe);
          else throw new L("Unit must be Years, Months or Days, but was " + $l);
        }
        return b.create(x, X, He);
      }, b.between = function(i, x) {
        return s(i, "startDate"), s(x, "endDate"), d(i, ct, "startDate"), d(x, ct, "endDate"), i.until(x);
      }, b.parse = function(i) {
        s(i, "text");
        try {
          return b._parse(i);
        } catch (x) {
          throw x instanceof we ? new G("Text cannot be parsed to a Period", i, 0, x) : x;
        }
      }, b._parse = function(i) {
        var x = Ze.exec(i);
        if (x != null) {
          var X = x[1] === "-" ? -1 : 1, He = x[2], $n = x[3], Xt = x[4];
          if (x = x[5], He != null || $n != null || Xt != null || x != null) return He = b._parseNumber(i, He, X), $n = b._parseNumber(i, $n, X), Xt = b._parseNumber(i, Xt, X), i = b._parseNumber(i, x, X), i = E.safeAdd(i, E.safeMultiply(Xt, 7)), b.create(He, $n, i);
        }
        throw new G("Text cannot be parsed to a Period", i, 0);
      }, b._parseNumber = function(i, x, X) {
        return x == null ? 0 : (i = E.parseInt(x), E.safeMultiply(
          i,
          X
        ));
      }, b.create = function(i, x, X) {
        return new b(i, x, X);
      };
      var w = b.prototype;
      return w.units = function() {
        return [le.YEARS, le.MONTHS, le.DAYS];
      }, w.chronology = function() {
        return ze.INSTANCE;
      }, w.get = function(i) {
        if (i === le.YEARS) return this._years;
        if (i === le.MONTHS) return this._months;
        if (i === le.DAYS) return this._days;
        throw new J("Unsupported unit: " + i);
      }, w.isZero = function() {
        return this === b.ZERO;
      }, w.isNegative = function() {
        return 0 > this._years || 0 > this._months || 0 > this._days;
      }, w.years = function() {
        return this._years;
      }, w.months = function() {
        return this._months;
      }, w.days = function() {
        return this._days;
      }, w.withYears = function(i) {
        return i === this._years ? this : b.create(i, this._months, this._days);
      }, w.withMonths = function(i) {
        return i === this._months ? this : b.create(this._years, i, this._days);
      }, w.withDays = function(i) {
        return i === this._days ? this : b.create(this._years, this._months, i);
      }, w.plus = function(i) {
        return i = b.from(i), b.create(E.safeAdd(this._years, i._years), E.safeAdd(this._months, i._months), E.safeAdd(this._days, i._days));
      }, w.plusYears = function(i) {
        return i === 0 ? this : b.create(E.safeToInt(E.safeAdd(
          this._years,
          i
        )), this._months, this._days);
      }, w.plusMonths = function(i) {
        return i === 0 ? this : b.create(this._years, E.safeToInt(E.safeAdd(this._months, i)), this._days);
      }, w.plusDays = function(i) {
        return i === 0 ? this : b.create(this._years, this._months, E.safeToInt(E.safeAdd(this._days, i)));
      }, w.minus = function(i) {
        return i = b.from(i), b.create(E.safeSubtract(this._years, i._years), E.safeSubtract(this._months, i._months), E.safeSubtract(this._days, i._days));
      }, w.minusYears = function(i) {
        return this.plusYears(-1 * i);
      }, w.minusMonths = function(i) {
        return this.plusMonths(-1 * i);
      }, w.minusDays = function(i) {
        return this.plusDays(-1 * i);
      }, w.multipliedBy = function(i) {
        return this === b.ZERO || i === 1 ? this : b.create(E.safeMultiply(this._years, i), E.safeMultiply(this._months, i), E.safeMultiply(this._days, i));
      }, w.negated = function() {
        return this.multipliedBy(-1);
      }, w.normalized = function() {
        var i = this.toTotalMonths(), x = E.intDiv(i, 12);
        return i = E.intMod(i, 12), x === this._years && i === this._months ? this : b.create(E.safeToInt(x), i, this._days);
      }, w.toTotalMonths = function() {
        return 12 * this._years + this._months;
      }, w.addTo = function(i) {
        return s(i, "temporal"), this._years !== 0 ? i = this._months !== 0 ? i.plus(this.toTotalMonths(), le.MONTHS) : i.plus(this._years, le.YEARS) : this._months !== 0 && (i = i.plus(this._months, le.MONTHS)), this._days !== 0 && (i = i.plus(this._days, le.DAYS)), i;
      }, w.subtractFrom = function(i) {
        return s(i, "temporal"), this._years !== 0 ? i = this._months !== 0 ? i.minus(this.toTotalMonths(), le.MONTHS) : i.minus(this._years, le.YEARS) : this._months !== 0 && (i = i.minus(this._months, le.MONTHS)), this._days !== 0 && (i = i.minus(this._days, le.DAYS)), i;
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this._years === i._years && this._months === i._months && this._days === i._days : !1;
      }, w.hashCode = function() {
        return E.hashCode(this._years, this._months, this._days);
      }, w.toString = function() {
        if (this === b.ZERO) return "P0D";
        var i = "P";
        return this._years !== 0 && (i += "" + this._years + "Y"), this._months !== 0 && (i += "" + this._months + "M"), this._days !== 0 && (i += "" + this._days + "D"), i;
      }, w.toJSON = function() {
        return this.toString();
      }, b;
    }(K), xn = function() {
      function be(w) {
        this._index = w, this._errorIndex = -1;
      }
      var b = be.prototype;
      return b.getIndex = function() {
        return this._index;
      }, b.setIndex = function(w) {
        this._index = w;
      }, b.getErrorIndex = function() {
        return this._errorIndex;
      }, b.setErrorIndex = function(w) {
        this._errorIndex = w;
      }, be;
    }(), Nn = function() {
      function be() {
        this._map = {};
      }
      var b = be.prototype;
      return b.putAll = function(w) {
        for (var i in w._map) this._map[i] = w._map[i];
        return this;
      }, b.containsKey = function(w) {
        return this._map.hasOwnProperty(w.name()) && this.get(w) !== void 0;
      }, b.get = function(w) {
        return this._map[w.name()];
      }, b.put = function(w, i) {
        return this.set(w, i);
      }, b.set = function(w, i) {
        return this._map[w.name()] = i, this;
      }, b.retainAll = function(w) {
        for (var i = {}, x = 0; x < w.length; x++) {
          var X = w[x].name();
          i[X] = this._map[X];
        }
        return this._map = i, this;
      }, b.remove = function(w) {
        w = w.name();
        var i = this._map[w];
        return this._map[w] = void 0, i;
      }, b.keySet = function() {
        return this._map;
      }, b.clear = function() {
        this._map = {};
      }, be;
    }(), at = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      return o(b, be), b;
    }(P);
    at.STRICT = new at("STRICT"), at.SMART = new at("SMART"), at.LENIENT = new at("LENIENT");
    var Yt = function() {
      function be() {
      }
      return be.prototype.adjustInto = function(b) {
        p("adjustInto");
      }, be;
    }(), jt = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.isSupported = function(i) {
        p("isSupported");
      }, w.minus = function(i, x) {
        return 2 > arguments.length ? this.minusAmount(i) : this.minusAmountUnit(i, x);
      }, w.minusAmount = function(i) {
        p("minusAmount");
      }, w.minusAmountUnit = function(i, x) {
        p("minusAmountUnit");
      }, w.plus = function(i, x) {
        return 2 > arguments.length ? this.plusAmount(i) : this.plusAmountUnit(i, x);
      }, w.plusAmount = function(i) {
        p("plusAmount");
      }, w.plusAmountUnit = function(i, x) {
        p("plusAmountUnit");
      }, w.until = function(i, x) {
        p("until");
      }, w.with = function(i, x) {
        return 2 > arguments.length ? this.withAdjuster(i) : this.withFieldValue(i, x);
      }, w.withAdjuster = function(i) {
        p("withAdjuster");
      }, w.withFieldValue = function(i, x) {
        p("withFieldValue");
      }, b;
    }(me), Cl = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.withAdjuster = function(i) {
        return s(i, "adjuster"), d(i, Yt, "adjuster"), i.adjustInto(this);
      }, w.plusAmount = function(i) {
        return s(i, "amount"), d(i, K, "amount"), i.addTo(this);
      }, w.minusAmount = function(i) {
        return s(i, "amount"), d(i, K, "amount"), i.subtractFrom(this);
      }, w.minusAmountUnit = function(i, x) {
        return s(i, "amountToSubtract"), s(x, "unit"), d(x, H, "unit"), i === -9007199254740991 ? this.plusAmountUnit(9007199254740991, x).plusAmountUnit(1, x) : this.plusAmount(-i, x);
      }, b;
    }(jt), fn = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.isSupported = function(i) {
        return i instanceof B || i instanceof le ? i.isDateBased() : i != null && i.isSupportedBy(this);
      }, w.query = function(i) {
        return i === q.chronology() ? this.chronology() : i === q.precision() ? le.DAYS : i === q.localDate() ? ct.ofEpochDay(this.toEpochDay()) : i === q.localTime() || i === q.zone() || i === q.zoneId() || i === q.offset() ? null : be.prototype.query.call(this, i);
      }, w.adjustInto = function(i) {
        return i.with(B.EPOCH_DAY, this.toEpochDay());
      }, w.format = function(i) {
        return s(i, "formatter"), d(i, De, "formatter"), i.format(this);
      }, b;
    }(Cl), _e = function() {
      function be() {
      }
      return be.startsWith = function(b, w) {
        return b.indexOf(w) === 0;
      }, be.hashCode = function(b) {
        var w = b.length;
        if (w === 0) return 0;
        for (var i = 0, x = 0; x < w; x++) {
          var X = b.charCodeAt(x);
          i = (i << 5) - i + X, i |= 0;
        }
        return E.smi(i);
      }, be;
    }(), Ve = function() {
      function be() {
      }
      be.systemDefault = function() {
        throw new L("not supported operation");
      }, be.getAvailableZoneIds = function() {
        throw new L("not supported operation");
      }, be.of = function(w) {
        throw new L("not supported operation" + w);
      }, be.ofOffset = function(w, i) {
        throw new L("not supported operation" + w + i);
      }, be.from = function(w) {
        throw new L("not supported operation" + w);
      };
      var b = be.prototype;
      return b.id = function() {
        p("ZoneId.id");
      }, b.rules = function() {
        p("ZoneId.rules");
      }, b.normalized = function() {
        var w = this.rules();
        return w.isFixedOffset() ? w.offset(br.EPOCH) : this;
      }, b.equals = function(w) {
        return this === w ? !0 : w instanceof be ? this.id() === w.id() : !1;
      }, b.hashCode = function() {
        return _e.hashCode(this.id());
      }, b.toString = function() {
        return this.id();
      }, b.toJSON = function() {
        return this.toString();
      }, be;
    }(), an = function() {
      function be() {
      }
      be.of = function(w) {
        return s(w, "offset"), new En(w);
      };
      var b = be.prototype;
      return b.isFixedOffset = function() {
        p("ZoneRules.isFixedOffset");
      }, b.offset = function(w) {
        return w instanceof br ? this.offsetOfInstant(w) : this.offsetOfLocalDateTime(w);
      }, b.offsetOfInstant = function(w) {
        p("ZoneRules.offsetInstant");
      }, b.offsetOfEpochMilli = function(w) {
        p("ZoneRules.offsetOfEpochMilli");
      }, b.offsetOfLocalDateTime = function(w) {
        p("ZoneRules.offsetLocalDateTime");
      }, b.validOffsets = function(w) {
        p("ZoneRules.validOffsets");
      }, b.transition = function(w) {
        p("ZoneRules.transition");
      }, b.standardOffset = function(w) {
        p("ZoneRules.standardOffset");
      }, b.daylightSavings = function(w) {
        p("ZoneRules.daylightSavings");
      }, b.isDaylightSavings = function(w) {
        p("ZoneRules.isDaylightSavings");
      }, b.isValidOffset = function(w, i) {
        p("ZoneRules.isValidOffset");
      }, b.nextTransition = function(w) {
        p("ZoneRules.nextTransition");
      }, b.previousTransition = function(w) {
        p("ZoneRules.previousTransition");
      }, b.transitions = function() {
        p("ZoneRules.transitions");
      }, b.transitionRules = function() {
        p("ZoneRules.transitionRules");
      }, b.toString = function() {
        p("ZoneRules.toString");
      }, b.toJSON = function() {
        return this.toString();
      }, be;
    }(), En = function(be) {
      function b(i) {
        var x = be.call(this) || this;
        return x._offset = i, x;
      }
      o(b, be);
      var w = b.prototype;
      return w.isFixedOffset = function() {
        return !0;
      }, w.offsetOfInstant = function() {
        return this._offset;
      }, w.offsetOfEpochMilli = function() {
        return this._offset;
      }, w.offsetOfLocalDateTime = function() {
        return this._offset;
      }, w.validOffsets = function() {
        return [this._offset];
      }, w.transition = function() {
        return null;
      }, w.standardOffset = function() {
        return this._offset;
      }, w.daylightSavings = function() {
        return U.ZERO;
      }, w.isDaylightSavings = function() {
        return !1;
      }, w.isValidOffset = function(i, x) {
        return this._offset.equals(x);
      }, w.nextTransition = function() {
        return null;
      }, w.previousTransition = function() {
        return null;
      }, w.transitions = function() {
        return [];
      }, w.transitionRules = function() {
        return [];
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this._offset.equals(i._offset) : !1;
      }, w.toString = function() {
        return "FixedRules:" + this._offset.toString();
      }, b;
    }(an), Qn = {}, Vn = {}, ot = function(be) {
      function b(i) {
        var x = be.call(this) || this;
        return b._validateTotalSeconds(i), x._totalSeconds = E.safeToInt(i), x._rules = an.of(a(x)), x._id = b._buildId(i), x;
      }
      o(b, be);
      var w = b.prototype;
      return w.totalSeconds = function() {
        return this._totalSeconds;
      }, w.id = function() {
        return this._id;
      }, b._buildId = function(i) {
        if (i === 0) return "Z";
        var x = Math.abs(i), X = E.intDiv(x, Fn.SECONDS_PER_HOUR), He = E.intMod(E.intDiv(x, Fn.SECONDS_PER_MINUTE), Fn.MINUTES_PER_HOUR);
        return i = (0 > i ? "-" : "+") + (10 > X ? "0" : "") + X + (10 > He ? ":0" : ":") + He, x = E.intMod(x, Fn.SECONDS_PER_MINUTE), x !== 0 && (i += (10 > x ? ":0" : ":") + x), i;
      }, b._validateTotalSeconds = function(i) {
        if (Math.abs(i) > b.MAX_SECONDS) throw new L("Zone offset not in valid range: -18:00 to +18:00");
      }, b._validate = function(i, x, X) {
        if (-18 > i || 18 < i) throw new L("Zone offset hours not in valid range: value " + i + " is not in the range -18 to 18");
        if (0 < i) {
          if (0 > x || 0 > X) throw new L("Zone offset minutes and seconds must be positive because hours is positive");
        } else if (0 > i) {
          if (0 < x || 0 < X) throw new L("Zone offset minutes and seconds must be negative because hours is negative");
        } else if (0 < x && 0 > X || 0 > x && 0 < X) throw new L("Zone offset minutes and seconds must have the same sign");
        if (59 < Math.abs(x)) throw new L("Zone offset minutes not in valid range: abs(value) " + Math.abs(x) + " is not in the range 0 to 59");
        if (59 < Math.abs(X)) throw new L("Zone offset seconds not in valid range: abs(value) " + Math.abs(X) + " is not in the range 0 to 59");
        if (Math.abs(i) === 18 && (0 < Math.abs(x) || 0 < Math.abs(X))) throw new L("Zone offset not in valid range: -18:00 to +18:00");
      }, b.of = function(i) {
        s(i, "offsetId");
        var x = Vn[i];
        if (x != null) return x;
        var X;
        switch (i.length) {
          case 2:
            i = i[0] + "0" + i[1];
          case 3:
            x = b._parseNumber(i, 1, !1);
            var He = X = 0;
            break;
          case 5:
            x = b._parseNumber(i, 1, !1), X = b._parseNumber(i, 3, !1), He = 0;
            break;
          case 6:
            x = b._parseNumber(i, 1, !1), X = b._parseNumber(i, 4, !0), He = 0;
            break;
          case 7:
            x = b._parseNumber(i, 1, !1), X = b._parseNumber(i, 3, !1), He = b._parseNumber(i, 5, !1);
            break;
          case 9:
            x = b._parseNumber(i, 1, !1), X = b._parseNumber(
              i,
              4,
              !0
            ), He = b._parseNumber(i, 7, !0);
            break;
          default:
            throw new L("Invalid ID for ZoneOffset, invalid format: " + i);
        }
        var $n = i[0];
        if ($n !== "+" && $n !== "-") throw new L("Invalid ID for ZoneOffset, plus/minus not found when expected: " + i);
        return $n === "-" ? b.ofHoursMinutesSeconds(-x, -X, -He) : b.ofHoursMinutesSeconds(x, X, He);
      }, b._parseNumber = function(i, x, X) {
        if (X && i[x - 1] !== ":") throw new L("Invalid ID for ZoneOffset, colon not found when expected: " + i);
        if (X = i[x], x = i[x + 1], "0" > X || "9" < X || "0" > x || "9" < x) throw new L("Invalid ID for ZoneOffset, non numeric characters found: " + i);
        return 10 * (X.charCodeAt(0) - 48) + (x.charCodeAt(0) - 48);
      }, b.ofHours = function(i) {
        return b.ofHoursMinutesSeconds(i, 0, 0);
      }, b.ofHoursMinutes = function(i, x) {
        return b.ofHoursMinutesSeconds(i, x, 0);
      }, b.ofHoursMinutesSeconds = function(i, x, X) {
        return b._validate(i, x, X), b.ofTotalSeconds(i * Fn.SECONDS_PER_HOUR + x * Fn.SECONDS_PER_MINUTE + X);
      }, b.ofTotalMinutes = function(i) {
        return b.ofTotalSeconds(i * Fn.SECONDS_PER_MINUTE);
      }, b.ofTotalSeconds = function(i) {
        if (i % (15 * Fn.SECONDS_PER_MINUTE) === 0) {
          var x = Qn[i];
          return x == null && (x = new b(i), Qn[i] = x, Vn[x.id()] = x), x;
        }
        return new b(i);
      }, w.rules = function() {
        return this._rules;
      }, w.get = function(i) {
        return this.getLong(i);
      }, w.getLong = function(i) {
        if (i === B.OFFSET_SECONDS) return this._totalSeconds;
        if (i instanceof B) throw new L("Unsupported field: " + i);
        return i.getFrom(this);
      }, w.query = function(i) {
        return s(i, "query"), i === q.offset() || i === q.zone() ? this : i === q.localDate() || i === q.localTime() || i === q.precision() || i === q.chronology() || i === q.zoneId() ? null : i.queryFrom(this);
      }, w.adjustInto = function(i) {
        return i.with(
          B.OFFSET_SECONDS,
          this._totalSeconds
        );
      }, w.compareTo = function(i) {
        return s(i, "other"), i._totalSeconds - this._totalSeconds;
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this._totalSeconds === i._totalSeconds : !1;
      }, w.hashCode = function() {
        return this._totalSeconds;
      }, w.toString = function() {
        return this._id;
      }, b;
    }(Ve), Nt = function(be) {
      function b() {
        var i = be.call(this) || this;
        return i.fieldValues = new Nn(), i.chrono = null, i.zone = null, i.date = null, i.time = null, i.leapSecond = !1, i.excessDays = null, i;
      }
      o(b, be), b.create = function(i, x) {
        var X = new b();
        return X._addFieldValue(i, x), X;
      };
      var w = b.prototype;
      return w.getFieldValue0 = function(i) {
        return this.fieldValues.get(i);
      }, w._addFieldValue = function(i, x) {
        s(i, "field");
        var X = this.getFieldValue0(i);
        if (X != null && X !== x) throw new L("Conflict found: " + i + " " + X + " differs from " + i + " " + x + ": " + this);
        return this._putFieldValue0(i, x);
      }, w._putFieldValue0 = function(i, x) {
        return this.fieldValues.put(i, x), this;
      }, w.resolve = function(i, x) {
        return x != null && this.fieldValues.retainAll(x), this._mergeDate(i), this._mergeTime(i), this._resolveTimeInferZeroes(i), this.excessDays != null && this.excessDays.isZero() === !1 && this.date != null && this.time != null && (this.date = this.date.plus(this.excessDays), this.excessDays = pn.ZERO), this._resolveInstant(), this;
      }, w._mergeDate = function(i) {
        this._checkDate(ze.INSTANCE.resolveDate(this.fieldValues, i));
      }, w._checkDate = function(i) {
        if (i != null) {
          this._addObject(i);
          for (var x in this.fieldValues.keySet()) {
            var X = B.byName(x);
            if (X && this.fieldValues.get(X) !== void 0 && X.isDateBased()) {
              var He = void 0;
              try {
                He = i.getLong(X);
              } catch (Xt) {
                if (Xt instanceof L) continue;
                throw Xt;
              }
              var $n = this.fieldValues.get(X);
              if (He !== $n) throw new L("Conflict found: Field " + X + " " + He + " differs from " + X + " " + $n + " derived from " + i);
            }
          }
        }
      }, w._mergeTime = function(i) {
        if (this.fieldValues.containsKey(B.CLOCK_HOUR_OF_DAY)) {
          var x = this.fieldValues.remove(B.CLOCK_HOUR_OF_DAY);
          i === at.LENIENT || i === at.SMART && x === 0 || B.CLOCK_HOUR_OF_DAY.checkValidValue(x), this._addFieldValue(B.HOUR_OF_DAY, x === 24 ? 0 : x);
        }
        if (this.fieldValues.containsKey(B.CLOCK_HOUR_OF_AMPM) && (x = this.fieldValues.remove(B.CLOCK_HOUR_OF_AMPM), i === at.LENIENT || i === at.SMART && x === 0 || B.CLOCK_HOUR_OF_AMPM.checkValidValue(x), this._addFieldValue(B.HOUR_OF_AMPM, x === 12 ? 0 : x)), i !== at.LENIENT && (this.fieldValues.containsKey(B.AMPM_OF_DAY) && B.AMPM_OF_DAY.checkValidValue(this.fieldValues.get(B.AMPM_OF_DAY)), this.fieldValues.containsKey(B.HOUR_OF_AMPM) && B.HOUR_OF_AMPM.checkValidValue(this.fieldValues.get(B.HOUR_OF_AMPM))), this.fieldValues.containsKey(B.AMPM_OF_DAY) && this.fieldValues.containsKey(B.HOUR_OF_AMPM)) {
          x = this.fieldValues.remove(B.AMPM_OF_DAY);
          var X = this.fieldValues.remove(B.HOUR_OF_AMPM);
          this._addFieldValue(B.HOUR_OF_DAY, 12 * x + X);
        }
        this.fieldValues.containsKey(B.NANO_OF_DAY) && (x = this.fieldValues.remove(B.NANO_OF_DAY), i !== at.LENIENT && B.NANO_OF_DAY.checkValidValue(x), this._addFieldValue(B.SECOND_OF_DAY, E.intDiv(x, 1e9)), this._addFieldValue(B.NANO_OF_SECOND, E.intMod(x, 1e9))), this.fieldValues.containsKey(B.MICRO_OF_DAY) && (x = this.fieldValues.remove(B.MICRO_OF_DAY), i !== at.LENIENT && B.MICRO_OF_DAY.checkValidValue(x), this._addFieldValue(
          B.SECOND_OF_DAY,
          E.intDiv(x, 1e6)
        ), this._addFieldValue(B.MICRO_OF_SECOND, E.intMod(x, 1e6))), this.fieldValues.containsKey(B.MILLI_OF_DAY) && (x = this.fieldValues.remove(B.MILLI_OF_DAY), i !== at.LENIENT && B.MILLI_OF_DAY.checkValidValue(x), this._addFieldValue(B.SECOND_OF_DAY, E.intDiv(x, 1e3)), this._addFieldValue(B.MILLI_OF_SECOND, E.intMod(x, 1e3))), this.fieldValues.containsKey(B.SECOND_OF_DAY) && (x = this.fieldValues.remove(B.SECOND_OF_DAY), i !== at.LENIENT && B.SECOND_OF_DAY.checkValidValue(x), this._addFieldValue(B.HOUR_OF_DAY, E.intDiv(
          x,
          3600
        )), this._addFieldValue(B.MINUTE_OF_HOUR, E.intMod(E.intDiv(x, 60), 60)), this._addFieldValue(B.SECOND_OF_MINUTE, E.intMod(x, 60))), this.fieldValues.containsKey(B.MINUTE_OF_DAY) && (x = this.fieldValues.remove(B.MINUTE_OF_DAY), i !== at.LENIENT && B.MINUTE_OF_DAY.checkValidValue(x), this._addFieldValue(B.HOUR_OF_DAY, E.intDiv(x, 60)), this._addFieldValue(B.MINUTE_OF_HOUR, E.intMod(x, 60))), i !== at.LENIENT && (this.fieldValues.containsKey(B.MILLI_OF_SECOND) && B.MILLI_OF_SECOND.checkValidValue(this.fieldValues.get(B.MILLI_OF_SECOND)), this.fieldValues.containsKey(B.MICRO_OF_SECOND) && B.MICRO_OF_SECOND.checkValidValue(this.fieldValues.get(B.MICRO_OF_SECOND))), this.fieldValues.containsKey(B.MILLI_OF_SECOND) && this.fieldValues.containsKey(B.MICRO_OF_SECOND) && (i = this.fieldValues.remove(B.MILLI_OF_SECOND), x = this.fieldValues.get(B.MICRO_OF_SECOND), this._putFieldValue0(B.MICRO_OF_SECOND, 1e3 * i + E.intMod(x, 1e3))), this.fieldValues.containsKey(B.MICRO_OF_SECOND) && this.fieldValues.containsKey(B.NANO_OF_SECOND) && (i = this.fieldValues.get(B.NANO_OF_SECOND), this._putFieldValue0(B.MICRO_OF_SECOND, E.intDiv(i, 1e3)), this.fieldValues.remove(B.MICRO_OF_SECOND)), this.fieldValues.containsKey(B.MILLI_OF_SECOND) && this.fieldValues.containsKey(B.NANO_OF_SECOND) && (i = this.fieldValues.get(B.NANO_OF_SECOND), this._putFieldValue0(B.MILLI_OF_SECOND, E.intDiv(i, 1e6)), this.fieldValues.remove(B.MILLI_OF_SECOND)), this.fieldValues.containsKey(B.MICRO_OF_SECOND) ? (i = this.fieldValues.remove(B.MICRO_OF_SECOND), this._putFieldValue0(B.NANO_OF_SECOND, 1e3 * i)) : this.fieldValues.containsKey(B.MILLI_OF_SECOND) && (i = this.fieldValues.remove(B.MILLI_OF_SECOND), this._putFieldValue0(B.NANO_OF_SECOND, 1e6 * i));
      }, w._resolveTimeInferZeroes = function(i) {
        var x = this.fieldValues.get(B.HOUR_OF_DAY), X = this.fieldValues.get(B.MINUTE_OF_HOUR), He = this.fieldValues.get(B.SECOND_OF_MINUTE), $n = this.fieldValues.get(B.NANO_OF_SECOND);
        x == null || X == null && (He != null || $n != null) || X != null && He == null && $n != null || (i !== at.LENIENT ? x != null && (i !== at.SMART || x !== 24 || X != null && X !== 0 || He != null && He !== 0 || $n != null && $n !== 0 || (x = 0, this.excessDays = pn.ofDays(1)), i = B.HOUR_OF_DAY.checkValidIntValue(x), X != null ? (X = B.MINUTE_OF_HOUR.checkValidIntValue(X), He != null ? (He = B.SECOND_OF_MINUTE.checkValidIntValue(He), $n != null ? ($n = B.NANO_OF_SECOND.checkValidIntValue($n), this._addObject(Fn.of(i, X, He, $n))) : this._addObject(Fn.of(i, X, He))) : $n == null && this._addObject(Fn.of(i, X))) : He == null && $n == null && this._addObject(Fn.of(i, 0))) : x != null && (i = x, X != null ? He != null ? ($n == null && ($n = 0), i = E.safeMultiply(i, 36e11), i = E.safeAdd(i, E.safeMultiply(X, 6e10)), i = E.safeAdd(i, E.safeMultiply(He, 1e9)), i = E.safeAdd(
          i,
          $n
        ), $n = E.floorDiv(i, 864e11), X = E.floorMod(i, 864e11), this._addObject(Fn.ofNanoOfDay(X)), this.excessDays = pn.ofDays($n)) : ($n = E.safeMultiply(i, 3600), $n = E.safeAdd($n, E.safeMultiply(X, 60)), X = E.floorDiv($n, 86400), $n = E.floorMod($n, 86400), this._addObject(Fn.ofSecondOfDay($n)), this.excessDays = pn.ofDays(X)) : ($n = E.safeToInt(E.floorDiv(i, 24)), i = E.floorMod(i, 24), this._addObject(Fn.of(i, 0)), this.excessDays = pn.ofDays($n))), this.fieldValues.remove(B.HOUR_OF_DAY), this.fieldValues.remove(B.MINUTE_OF_HOUR), this.fieldValues.remove(B.SECOND_OF_MINUTE), this.fieldValues.remove(B.NANO_OF_SECOND));
      }, w._addObject = function(i) {
        i instanceof fn ? this.date = i : i instanceof Fn && (this.time = i);
      }, w._resolveInstant = function() {
        if (this.date != null && this.time != null) {
          var i = this.fieldValues.get(B.OFFSET_SECONDS);
          i != null ? (i = ot.ofTotalSeconds(i), i = this.date.atTime(this.time).atZone(i).getLong(B.INSTANT_SECONDS), this.fieldValues.put(B.INSTANT_SECONDS, i)) : this.zone != null && (i = this.date.atTime(this.time).atZone(this.zone).getLong(B.INSTANT_SECONDS), this.fieldValues.put(
            B.INSTANT_SECONDS,
            i
          ));
        }
      }, w.build = function(i) {
        return i.queryFrom(this);
      }, w.isSupported = function(i) {
        return i == null ? !1 : this.fieldValues.containsKey(i) && this.fieldValues.get(i) !== void 0 || this.date != null && this.date.isSupported(i) || this.time != null && this.time.isSupported(i);
      }, w.getLong = function(i) {
        s(i, "field");
        var x = this.getFieldValue0(i);
        if (x == null) {
          if (this.date != null && this.date.isSupported(i)) return this.date.getLong(i);
          if (this.time != null && this.time.isSupported(i)) return this.time.getLong(i);
          throw new L("Field not found: " + i);
        }
        return x;
      }, w.query = function(i) {
        return i === q.zoneId() ? this.zone : i === q.chronology() ? this.chrono : i === q.localDate() ? this.date != null ? ct.from(this.date) : null : i === q.localTime() ? this.time : i !== q.zone() && i !== q.offset() && i === q.precision() ? null : i.queryFrom(this);
      }, b;
    }(me), zt = function() {
      function be() {
        if (arguments.length === 1) {
          if (arguments[0] instanceof be) {
            this._constructorSelf.apply(this, arguments);
            return;
          }
          this._constructorFormatter.apply(this, arguments);
        } else this._constructorParam.apply(this, arguments);
        this._strict = this._caseSensitive = !0, this._parsed = [new Pt(this)];
      }
      var b = be.prototype;
      return b._constructorParam = function(w, i, x) {
        this._locale = w, this._symbols = i, this._overrideChronology = x;
      }, b._constructorFormatter = function(w) {
        this._locale = w.locale(), this._symbols = w.decimalStyle(), this._overrideChronology = w.chronology();
      }, b._constructorSelf = function(w) {
        this._locale = w._locale, this._symbols = w._symbols, this._overrideChronology = w._overrideChronology, this._overrideZone = w._overrideZone, this._caseSensitive = w._caseSensitive, this._strict = w._strict, this._parsed = [new Pt(this)];
      }, b.copy = function() {
        return new be(this);
      }, b.symbols = function() {
        return this._symbols;
      }, b.isStrict = function() {
        return this._strict;
      }, b.setStrict = function(w) {
        this._strict = w;
      }, b.locale = function() {
        return this._locale;
      }, b.setLocale = function(w) {
        this._locale = w;
      }, b.startOptional = function() {
        this._parsed.push(this.currentParsed().copy());
      }, b.endOptional = function(w) {
        w ? this._parsed.splice(this._parsed.length - 2, 1) : this._parsed.splice(this._parsed.length - 1, 1);
      }, b.isCaseSensitive = function() {
        return this._caseSensitive;
      }, b.setCaseSensitive = function(w) {
        this._caseSensitive = w;
      }, b.subSequenceEquals = function(w, i, x, X, He) {
        if (i + He > w.length || X + He > x.length) return !1;
        this.isCaseSensitive() || (w = w.toLowerCase(), x = x.toLowerCase());
        for (var $n = 0; $n < He; $n++) if (w[i + $n] !== x[X + $n]) return !1;
        return !0;
      }, b.charEquals = function(w, i) {
        return this.isCaseSensitive() ? w === i : this.charEqualsIgnoreCase(w, i);
      }, b.charEqualsIgnoreCase = function(w, i) {
        return w === i || w.toLowerCase() === i.toLowerCase();
      }, b.setParsedField = function(w, i, x, X) {
        var He = this.currentParsed().fieldValues, $n = He.get(w);
        return He.set(w, i), $n != null && $n !== i ? ~x : X;
      }, b.setParsedZone = function(w) {
        s(w, "zone"), this.currentParsed().zone = w;
      }, b.getParsed = function(w) {
        return this.currentParsed().fieldValues.get(w);
      }, b.toParsed = function() {
        return this.currentParsed();
      }, b.currentParsed = function() {
        return this._parsed[this._parsed.length - 1];
      }, b.setParsedLeapSecond = function() {
        this.currentParsed().leapSecond = !0;
      }, b.getEffectiveChronology = function() {
        var w = this.currentParsed().chrono;
        return w == null && (w = this._overrideChronology, w == null && (w = ze.INSTANCE)), w;
      }, be;
    }(), Pt = function(be) {
      function b(i) {
        var x = be.call(this) || this;
        return x.chrono = null, x.zone = null, x.fieldValues = new Nn(), x.leapSecond = !1, x.dateTimeParseContext = i, x;
      }
      o(b, be);
      var w = b.prototype;
      return w.copy = function() {
        var i = new b();
        return i.chrono = this.chrono, i.zone = this.zone, i.fieldValues.putAll(this.fieldValues), i.leapSecond = this.leapSecond, i.dateTimeParseContext = this.dateTimeParseContext, i;
      }, w.toString = function() {
        return this.fieldValues + ", " + this.chrono + ", " + this.zone;
      }, w.isSupported = function(i) {
        return this.fieldValues.containsKey(i);
      }, w.get = function(i) {
        return i = this.fieldValues.get(i), h(i != null), i;
      }, w.query = function(i) {
        return i === q.chronology() ? this.chrono : i === q.zoneId() || i === q.zone() ? this.zone : be.prototype.query.call(this, i);
      }, w.toBuilder = function() {
        var i = new Nt();
        return i.fieldValues.putAll(this.fieldValues), i.chrono = this.dateTimeParseContext.getEffectiveChronology(), i.zone = this.zone != null ? this.zone : this.overrideZone, i.leapSecond = this.leapSecond, i.excessDays = this.excessDays, i;
      }, b;
    }(jt), ol = function() {
      function be(w, i, x) {
        arguments.length === 2 && arguments[1] instanceof De ? (this._temporal = be.adjust(w, i), this._locale = i.locale(), this._symbols = i.decimalStyle()) : (this._temporal = w, this._locale = i, this._symbols = x), this._optional = 0;
      }
      be.adjust = function(w, i) {
        return w;
      };
      var b = be.prototype;
      return b.symbols = function() {
        return this._symbols;
      }, b.startOptional = function() {
        this._optional++;
      }, b.endOptional = function() {
        this._optional--;
      }, b.getValueQuery = function(w) {
        if (w = this._temporal.query(w), w == null && this._optional === 0) throw new L("Unable to extract value: " + this._temporal);
        return w;
      }, b.getValue = function(w) {
        try {
          return this._temporal.getLong(w);
        } catch (i) {
          if (i instanceof L && 0 < this._optional) return null;
          throw i;
        }
      }, b.temporal = function() {
        return this._temporal;
      }, b.locale = function() {
        return this._locale;
      }, b.setDateTime = function(w) {
        this._temporal = w;
      }, b.setLocale = function(w) {
        this._locale = w;
      }, be;
    }(), St = {}, pr = [0, 90, 181, 273, 0, 91, 182, 274], ul = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.isDateBased = function() {
        return !0;
      }, w.isTimeBased = function() {
        return !1;
      }, w._isIso = function() {
        return !0;
      }, b._getWeekRangeByLocalDate = function(i) {
        return i = b._getWeekBasedYear(i), Ye.of(1, b._getWeekRangeByYear(i));
      }, b._getWeekRangeByYear = function(i) {
        return i = ct.of(i, 1, 1), i.dayOfWeek() === Fe.THURSDAY || i.dayOfWeek() === Fe.WEDNESDAY && i.isLeapYear() ? 53 : 52;
      }, b._getWeek = function(i) {
        var x = i.dayOfWeek().ordinal(), X = i.dayOfYear() - 1;
        x = X + (3 - x);
        var He = E.intDiv(x, 7);
        return x = x - 7 * He - 3, -3 > x && (x += 7), X < x ? b._getWeekRangeByLocalDate(i.withDayOfYear(180).minusYears(1)).maximum() : (X = E.intDiv(X - x, 7) + 1, X === 53 && (x === -3 || x === -2 && i.isLeapYear()) === !1 && (X = 1), X);
      }, b._getWeekBasedYear = function(i) {
        var x = i.year(), X = i.dayOfYear();
        if (3 >= X) i = i.dayOfWeek().ordinal(), -2 > X - i && x--;
        else if (363 <= X) {
          var He = i.dayOfWeek().ordinal();
          X = X - 363 - (i.isLeapYear() ? 1 : 0), 0 <= X - He && x++;
        }
        return x;
      }, w.displayName = function() {
        return this.toString();
      }, w.resolve = function() {
        return null;
      }, w.name = function() {
        return this.toString();
      }, b;
    }(Ce), Rr = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.toString = function() {
        return "DayOfQuarter";
      }, w.baseUnit = function() {
        return le.DAYS;
      }, w.rangeUnit = function() {
        return gl;
      }, w.range = function() {
        return Ye.of(1, 90, 92);
      }, w.isSupportedBy = function(i) {
        return i.isSupported(B.DAY_OF_YEAR) && i.isSupported(B.MONTH_OF_YEAR) && i.isSupported(B.YEAR) && this._isIso(i);
      }, w.rangeRefinedBy = function(i) {
        if (i.isSupported(this) === !1) throw new J("Unsupported field: DayOfQuarter");
        var x = i.getLong(Zt);
        return x === 1 ? (i = i.getLong(B.YEAR), ze.isLeapYear(i) ? Ye.of(1, 91) : Ye.of(
          1,
          90
        )) : x === 2 ? Ye.of(1, 91) : x === 3 || x === 4 ? Ye.of(1, 92) : this.range();
      }, w.getFrom = function(i) {
        if (i.isSupported(this) === !1) throw new J("Unsupported field: DayOfQuarter");
        var x = i.get(B.DAY_OF_YEAR), X = i.get(B.MONTH_OF_YEAR);
        return i = i.getLong(B.YEAR), x - pr[E.intDiv(X - 1, 3) + (ze.isLeapYear(i) ? 4 : 0)];
      }, w.adjustInto = function(i, x) {
        var X = this.getFrom(i);
        return this.range().checkValidValue(x, this), i.with(B.DAY_OF_YEAR, i.getLong(B.DAY_OF_YEAR) + (x - X));
      }, w.resolve = function(i, x, X) {
        x = i.get(B.YEAR);
        var He = i.get(Zt);
        if (x == null || He == null) return null;
        var $n = B.YEAR.checkValidIntValue(x);
        return x = i.get(tl), X === at.LENIENT ? (X = ct.of($n, 1, 1), X = X.plusMonths(E.safeMultiply(E.safeSubtract(He, 1), 3)), X = X.plusDays(E.safeSubtract(x, 1))) : (He = Zt.range().checkValidIntValue(He, Zt), X === at.STRICT ? (X = 92, He === 1 ? X = ze.isLeapYear($n) ? 91 : 90 : He === 2 && (X = 91), Ye.of(1, X).checkValidValue(x, this)) : this.range().checkValidValue(x, this), X = ct.of($n, 3 * (He - 1) + 1, 1).plusDays(x - 1)), i.remove(this), i.remove(B.YEAR), i.remove(Zt), X;
      }, b;
    }(ul), ql = function(be) {
      function b() {
        return be.apply(
          this,
          arguments
        ) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.toString = function() {
        return "QuarterOfYear";
      }, w.baseUnit = function() {
        return gl;
      }, w.rangeUnit = function() {
        return le.YEARS;
      }, w.range = function() {
        return Ye.of(1, 4);
      }, w.isSupportedBy = function(i) {
        return i.isSupported(B.MONTH_OF_YEAR) && this._isIso(i);
      }, w.rangeRefinedBy = function(i) {
        return this.range();
      }, w.getFrom = function(i) {
        if (i.isSupported(this) === !1) throw new J("Unsupported field: QuarterOfYear");
        return i = i.getLong(B.MONTH_OF_YEAR), E.intDiv(i + 2, 3);
      }, w.adjustInto = function(i, x) {
        var X = this.getFrom(i);
        return this.range().checkValidValue(x, this), i.with(B.MONTH_OF_YEAR, i.getLong(B.MONTH_OF_YEAR) + 3 * (x - X));
      }, b;
    }(ul), Mr = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.toString = function() {
        return "WeekOfWeekBasedYear";
      }, w.baseUnit = function() {
        return le.WEEKS;
      }, w.rangeUnit = function() {
        return Sl;
      }, w.range = function() {
        return Ye.of(1, 52, 53);
      }, w.isSupportedBy = function(i) {
        return i.isSupported(B.EPOCH_DAY) && this._isIso(i);
      }, w.rangeRefinedBy = function(i) {
        if (i.isSupported(this) === !1) throw new J("Unsupported field: WeekOfWeekBasedYear");
        return ul._getWeekRangeByLocalDate(ct.from(i));
      }, w.getFrom = function(i) {
        if (i.isSupported(this) === !1) throw new J("Unsupported field: WeekOfWeekBasedYear");
        return ul._getWeek(ct.from(i));
      }, w.adjustInto = function(i, x) {
        return this.range().checkValidValue(x, this), i.plus(E.safeSubtract(x, this.getFrom(i)), le.WEEKS);
      }, w.resolve = function(i, x, X) {
        x = i.get(jl);
        var He = i.get(B.DAY_OF_WEEK);
        if (x == null || He == null) return null;
        x = jl.range().checkValidIntValue(
          x,
          jl
        );
        var $n = i.get(Ql);
        return X === at.LENIENT ? (X = He, He = 0, 7 < X ? (He = E.intDiv(X - 1, 7), X = E.intMod(X - 1, 7) + 1) : 1 > X && (He = E.intDiv(X, 7) - 1, X = E.intMod(X, 7) + 7), x = ct.of(x, 1, 4).plusWeeks($n - 1).plusWeeks(He).with(B.DAY_OF_WEEK, X)) : (He = B.DAY_OF_WEEK.checkValidIntValue(He), X === at.STRICT ? (X = ct.of(x, 1, 4), ul._getWeekRangeByLocalDate(X).checkValidValue($n, this)) : this.range().checkValidValue($n, this), x = ct.of(x, 1, 4).plusWeeks($n - 1).with(B.DAY_OF_WEEK, He)), i.remove(this), i.remove(jl), i.remove(B.DAY_OF_WEEK), x;
      }, w.displayName = function() {
        return "Week";
      }, b;
    }(ul), wi = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.toString = function() {
        return "WeekBasedYear";
      }, w.baseUnit = function() {
        return Sl;
      }, w.rangeUnit = function() {
        return le.FOREVER;
      }, w.range = function() {
        return B.YEAR.range();
      }, w.isSupportedBy = function(i) {
        return i.isSupported(B.EPOCH_DAY) && this._isIso(i);
      }, w.rangeRefinedBy = function(i) {
        return B.YEAR.range();
      }, w.getFrom = function(i) {
        if (i.isSupported(this) === !1) throw new J("Unsupported field: WeekBasedYear");
        return ul._getWeekBasedYear(ct.from(i));
      }, w.adjustInto = function(i, x) {
        if (this.isSupportedBy(i) === !1) throw new J("Unsupported field: WeekBasedYear");
        var X = this.range().checkValidIntValue(x, jl), He = ct.from(i);
        return x = He.get(B.DAY_OF_WEEK), He = ul._getWeek(He), He === 53 && ul._getWeekRangeByYear(X) === 52 && (He = 52), X = ct.of(X, 1, 4), x = x - X.get(B.DAY_OF_WEEK) + 7 * (He - 1), X = X.plusDays(x), i.with(X);
      }, b;
    }(ul), bl = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return X._name = i, X._duration = x, X;
      }
      o(b, be);
      var w = b.prototype;
      return w.duration = function() {
        return this._duration;
      }, w.isDurationEstimated = function() {
        return !0;
      }, w.isDateBased = function() {
        return !0;
      }, w.isTimeBased = function() {
        return !1;
      }, w.isSupportedBy = function(i) {
        return i.isSupported(B.EPOCH_DAY);
      }, w.addTo = function(i, x) {
        switch (this) {
          case Sl:
            return x = E.safeAdd(i.get(jl), x), i.with(jl, x);
          case gl:
            return i.plus(E.intDiv(x, 256), le.YEARS).plus(3 * E.intMod(x, 256), le.MONTHS);
          default:
            throw new xe("Unreachable");
        }
      }, w.between = function(i, x) {
        switch (this) {
          case Sl:
            return E.safeSubtract(x.getLong(jl), i.getLong(jl));
          case gl:
            return E.intDiv(i.until(
              x,
              le.MONTHS
            ), 3);
          default:
            throw new xe("Unreachable");
        }
      }, w.toString = function() {
        return name;
      }, b;
    }(H), tl = null, Zt = null, Ql = null, jl = null, Sl = null, gl = null, jr = function() {
      function be(w, i, x, X) {
        this._zeroDigit = w, this._zeroDigitCharCode = w.charCodeAt(0), this._positiveSign = i, this._negativeSign = x, this._decimalSeparator = X;
      }
      var b = be.prototype;
      return b.positiveSign = function() {
        return this._positiveSign;
      }, b.withPositiveSign = function(w) {
        return w === this._positiveSign ? this : new be(this._zeroDigit, w, this._negativeSign, this._decimalSeparator);
      }, b.negativeSign = function() {
        return this._negativeSign;
      }, b.withNegativeSign = function(w) {
        return w === this._negativeSign ? this : new be(this._zeroDigit, this._positiveSign, w, this._decimalSeparator);
      }, b.zeroDigit = function() {
        return this._zeroDigit;
      }, b.withZeroDigit = function(w) {
        return w === this._zeroDigit ? this : new be(w, this._positiveSign, this._negativeSign, this._decimalSeparator);
      }, b.decimalSeparator = function() {
        return this._decimalSeparator;
      }, b.withDecimalSeparator = function(w) {
        return w === this._decimalSeparator ? this : new be(
          this._zeroDigit,
          this._positiveSign,
          this._negativeSign,
          w
        );
      }, b.convertToDigit = function(w) {
        return w = w.charCodeAt(0) - this._zeroDigitCharCode, 0 <= w && 9 >= w ? w : -1;
      }, b.convertNumberToI18N = function(w) {
        if (this._zeroDigit === "0") return w;
        for (var i = this._zeroDigitCharCode - 48, x = "", X = 0; X < w.length; X++) x += String.fromCharCode(w.charCodeAt(X) + i);
        return x;
      }, b.equals = function(w) {
        return this === w ? !0 : w instanceof be ? this._zeroDigit === w._zeroDigit && this._positiveSign === w._positiveSign && this._negativeSign === w._negativeSign && this._decimalSeparator === w._decimalSeparator : !1;
      }, b.hashCode = function() {
        return this._zeroDigit + this._positiveSign + this._negativeSign + this._decimalSeparator;
      }, b.toString = function() {
        return "DecimalStyle[" + this._zeroDigit + this._positiveSign + this._negativeSign + this._decimalSeparator + "]";
      }, be.of = function() {
        throw Error("not yet supported");
      }, be.availableLocales = function() {
        throw Error("not yet supported");
      }, be;
    }();
    jr.STANDARD = new jr("0", "+", "-", ".");
    var Kt = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      return o(b, be), b.prototype.parse = function(w, i, x) {
        switch (this) {
          case b.NORMAL:
            return !w || !i;
          case b.ALWAYS:
          case b.EXCEEDS_PAD:
            return !0;
          default:
            return !i && !x;
        }
      }, b;
    }(P);
    Kt.NORMAL = new Kt("NORMAL"), Kt.NEVER = new Kt("NEVER"), Kt.ALWAYS = new Kt("ALWAYS"), Kt.EXCEEDS_PAD = new Kt("EXCEEDS_PAD"), Kt.NOT_NEGATIVE = new Kt("NOT_NEGATIVE");
    var nl = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.isStandalone = function() {
        switch (this) {
          case b.FULL_STANDALONE:
          case b.SHORT_STANDALONE:
          case b.NARROW_STANDALONE:
            return !0;
          default:
            return !1;
        }
      }, w.asStandalone = function() {
        switch (this) {
          case b.FULL:
            return b.FULL_STANDALONE;
          case b.SHORT:
            return b.SHORT_STANDALONE;
          case b.NARROW:
            return b.NARROW_STANDALONE;
          default:
            return this;
        }
      }, w.asNormal = function() {
        switch (this) {
          case b.FULL_STANDALONE:
            return b.FULL;
          case b.SHORT_STANDALONE:
            return b.SHORT;
          case b.NARROW_STANDALONE:
            return b.NARROW;
          default:
            return this;
        }
      }, b;
    }(P);
    nl.FULL = new nl("FULL"), nl.FULL_STANDALONE = new nl("FULL_STANDALONE"), nl.SHORT = new nl("SHORT"), nl.SHORT_STANDALONE = new nl("SHORT_STANDALONE"), nl.NARROW = new nl("NARROW"), nl.NARROW_STANDALONE = new nl("NARROW_STANDALONE");
    var Pr = function() {
      function be(w) {
        if (1 < w.length) throw new ce('invalid literal, too long: "' + w + '"');
        this._literal = w;
      }
      var b = be.prototype;
      return b.print = function(w, i) {
        return i.append(this._literal), !0;
      }, b.parse = function(w, i, x) {
        return x === i.length ? ~x : (i = i.charAt(x), w.charEquals(this._literal, i) === !1 ? ~x : x + this._literal.length);
      }, b.toString = function() {
        return this._literal === "'" ? "''" : "'" + this._literal + "'";
      }, be;
    }(), ii = function() {
      function be(w, i) {
        this._printerParsers = w, this._optional = i;
      }
      var b = be.prototype;
      return b.withOptional = function(w) {
        return w === this._optional ? this : new be(this._printerParsers, w);
      }, b.print = function(w, i) {
        var x = i.length();
        this._optional && w.startOptional();
        try {
          for (var X = 0; X < this._printerParsers.length; X++) if (this._printerParsers[X].print(w, i) === !1) {
            i.setLength(x);
            break;
          }
        } finally {
          this._optional && w.endOptional();
        }
        return !0;
      }, b.parse = function(w, i, x) {
        if (this._optional) {
          w.startOptional();
          for (var X = x, He = 0; He < this._printerParsers.length; He++) if (X = this._printerParsers[He].parse(w, i, X), 0 > X) return w.endOptional(!1), x;
          return w.endOptional(!0), X;
        }
        for (X = 0; X < this._printerParsers.length && (x = this._printerParsers[X].parse(w, i, x), !(0 > x)); X++) ;
        return x;
      }, b.toString = function() {
        var w = "";
        if (this._printerParsers != null) {
          w += this._optional ? "[" : "(";
          for (var i = 0; i < this._printerParsers.length; i++) w += this._printerParsers[i].toString();
          w += this._optional ? "]" : ")";
        }
        return w;
      }, be;
    }(), Ar = function() {
      function be(w, i, x, X) {
        if (s(w, "field"), w.range().isFixed() === !1) throw new ce("Field must have a fixed set of values: " + w);
        if (0 > i || 9 < i) throw new ce("Minimum width must be from 0 to 9 inclusive but was " + i);
        if (1 > x || 9 < x) throw new ce("Maximum width must be from 1 to 9 inclusive but was " + x);
        if (x < i) throw new ce("Maximum width must exceed or equal the minimum width but " + x + " < " + i);
        this.field = w, this.minWidth = i, this.maxWidth = x, this.decimalPoint = X;
      }
      var b = be.prototype;
      return b.print = function(w, i) {
        var x = w.getValue(this.field);
        if (x === null) return !1;
        if (w = w.symbols(), x === 0) {
          if (0 < this.minWidth) for (this.decimalPoint && i.append(w.decimalSeparator()), x = 0; x < this.minWidth; x++) i.append(w.zeroDigit());
        } else {
          if (x = this.convertToFraction(x, w.zeroDigit()), x = x.substr(0, Math.min(Math.max(x.length, this.minWidth), this.maxWidth)), 0 < 1 * x) for (; x.length > this.minWidth && x[x.length - 1] === "0"; ) x = x.substr(0, x.length - 1);
          x = w.convertNumberToI18N(x), this.decimalPoint && i.append(w.decimalSeparator()), i.append(x);
        }
        return !0;
      }, b.parse = function(w, i, x) {
        var X = w.isStrict() ? this.minWidth : 0, He = w.isStrict() ? this.maxWidth : 9, $n = i.length;
        if (x === $n) return 0 < X ? ~x : x;
        if (this.decimalPoint) {
          if (i[x] !== w.symbols().decimalSeparator()) return 0 < X ? ~x : x;
          x++;
        }
        if (X = x + X, X > $n) return ~x;
        $n = Math.min(x + He, $n);
        var Xt = 0;
        for (He = x; He < $n; ) {
          var $l = i.charAt(He++);
          if ($l = w.symbols().convertToDigit($l), 0 > $l) {
            if (He < X) return ~x;
            He--;
            break;
          }
          Xt = 10 * Xt + $l;
        }
        return i = this.convertFromFraction(Xt, Math.pow(10, He - x)), w.setParsedField(this.field, i, x, He);
      }, b.convertToFraction = function(w, i) {
        var x = this.field.range();
        x.checkValidValue(w, this.field);
        var X = x.minimum();
        for (x = x.maximum() - X + 1, w = "" + E.intDiv(1e9 * (w - X), x); 9 > w.length; ) w = i + w;
        return w;
      }, b.convertFromFraction = function(w, i) {
        var x = this.field.range(), X = x.minimum();
        return x = x.maximum() - X + 1, E.intDiv(w * x, i);
      }, b.toString = function() {
        return "Fraction(" + this.field + "," + this.minWidth + "," + this.maxWidth + (this.decimalPoint ? ",DecimalPoint" : "") + ")";
      }, be;
    }(), Ml = [0, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9], Rl = function() {
      function be(w, i, x, X, He) {
        He === void 0 && (He = 0), this._field = w, this._minWidth = i, this._maxWidth = x, this._signStyle = X, this._subsequentWidth = He;
      }
      var b = be.prototype;
      return b.field = function() {
        return this._field;
      }, b.minWidth = function() {
        return this._minWidth;
      }, b.maxWidth = function() {
        return this._maxWidth;
      }, b.signStyle = function() {
        return this._signStyle;
      }, b.withFixedWidth = function() {
        return this._subsequentWidth === -1 ? this : new be(this._field, this._minWidth, this._maxWidth, this._signStyle, -1);
      }, b.withSubsequentWidth = function(w) {
        return new be(this._field, this._minWidth, this._maxWidth, this._signStyle, this._subsequentWidth + w);
      }, b._isFixedWidth = function() {
        return this._subsequentWidth === -1 || 0 < this._subsequentWidth && this._minWidth === this._maxWidth && this._signStyle === Kt.NOT_NEGATIVE;
      }, b.print = function(w, i) {
        var x = w.getValue(this._field);
        if (x == null) return !1;
        x = this._getValue(w, x), w = w.symbols();
        var X = "" + Math.abs(x);
        if (X.length > this._maxWidth) throw new L("Field " + this._field + " cannot be printed as the value " + x + " exceeds the maximum print width of " + this._maxWidth);
        if (X = w.convertNumberToI18N(X), 0 <= x) switch (this._signStyle) {
          case Kt.EXCEEDS_PAD:
            15 > this._minWidth && x >= Ml[this._minWidth] && i.append(w.positiveSign());
            break;
          case Kt.ALWAYS:
            i.append(w.positiveSign());
        }
        else switch (this._signStyle) {
          case Kt.NORMAL:
          case Kt.EXCEEDS_PAD:
          case Kt.ALWAYS:
            i.append(w.negativeSign());
            break;
          case Kt.NOT_NEGATIVE:
            throw new L("Field " + this._field + " cannot be printed as the value " + x + " cannot be negative according to the SignStyle");
        }
        for (x = 0; x < this._minWidth - X.length; x++) i.append(w.zeroDigit());
        return i.append(X), !0;
      }, b.parse = function(w, i, x) {
        var X = i.length;
        if (x === X) return ~x;
        h(0 <= x && x < X);
        var He = i.charAt(x), $n = !1, Xt = !1;
        if (He === w.symbols().positiveSign()) {
          if (this._signStyle.parse(!0, w.isStrict(), this._minWidth === this._maxWidth) === !1) return ~x;
          Xt = !0, x++;
        } else if (He === w.symbols().negativeSign()) {
          if (this._signStyle.parse(!1, w.isStrict(), this._minWidth === this._maxWidth) === !1) return ~x;
          $n = !0, x++;
        } else if (this._signStyle === Kt.ALWAYS && w.isStrict()) return ~x;
        var $l = w.isStrict() || this._isFixedWidth() ? this._minWidth : 1, Oe = x + $l;
        if (Oe > X) return ~x;
        var Ke = (w.isStrict() || this._isFixedWidth() ? this._maxWidth : 9) + Math.max(this._subsequentWidth, 0);
        He = 0;
        for (var mn = x, wn = 0; 2 > wn; wn++) {
          for (Ke = Math.min(mn + Ke, X); mn < Ke; ) {
            var On = i.charAt(mn++);
            if (On = w.symbols().convertToDigit(On), 0 > On) {
              if (mn--, mn < Oe) return ~x;
              break;
            }
            if (15 < mn - x) throw new we("number text exceeds length");
            He = 10 * He + On;
          }
          if (0 < this._subsequentWidth && wn === 0) Ke = Math.max($l, mn - x - this._subsequentWidth), mn = x, He = 0;
          else break;
        }
        if ($n) {
          if (He === 0 && w.isStrict()) return ~(x - 1);
          He !== 0 && (He = -He);
        } else if (this._signStyle === Kt.EXCEEDS_PAD && w.isStrict()) {
          if (i = mn - x, Xt) {
            if (i <= this._minWidth) return ~(x - 1);
          } else if (i > this._minWidth) return ~x;
        }
        return this._setValue(w, He, x, mn);
      }, b._getValue = function(w, i) {
        return i;
      }, b._setValue = function(w, i, x, X) {
        return w.setParsedField(this._field, i, x, X);
      }, b.toString = function() {
        return this._minWidth === 1 && this._maxWidth === 15 && this._signStyle === Kt.NORMAL ? "Value(" + this._field + ")" : this._minWidth === this._maxWidth && this._signStyle === Kt.NOT_NEGATIVE ? "Value(" + this._field + "," + this._minWidth + ")" : "Value(" + this._field + "," + this._minWidth + "," + this._maxWidth + "," + this._signStyle + ")";
      }, be;
    }(), Se = function(be) {
      function b(i, x, X, He, $n) {
        var Xt = be.call(this, i, x, X, Kt.NOT_NEGATIVE) || this;
        if (1 > x || 10 < x) throw new ce("The width must be from 1 to 10 inclusive but was " + x);
        if (1 > X || 10 < X) throw new ce("The maxWidth must be from 1 to 10 inclusive but was " + X);
        if (X < x) throw new ce("The maxWidth must be greater than the width");
        if ($n === null) {
          if (i.range().isValidValue(He) === !1) throw new ce("The base value must be within the range of the field");
          if (He + Ml[x] > E.MAX_SAFE_INTEGER) throw new L("Unable to add printer-parser as the range exceeds the capacity of an int");
        }
        return Xt._baseValue = He, Xt._baseDate = $n, Xt;
      }
      o(b, be);
      var w = b.prototype;
      return w._getValue = function(i, x) {
        var X = Math.abs(x), He = this._baseValue;
        return this._baseDate !== null && (i.temporal(), He = ze.INSTANCE.date(this._baseDate).get(this._field)), x >= He && x < He + Ml[this._minWidth] ? X % Ml[this._minWidth] : X % Ml[this._maxWidth];
      }, w._setValue = function(i, x, X, He) {
        var $n = this._baseValue;
        if (this._baseDate != null && ($n = i.getEffectiveChronology().date(this._baseDate).get(this._field)), He - X === this._minWidth && 0 <= x) {
          var Xt = Ml[this._minWidth], $l = $n - $n % Xt;
          x = 0 < $n ? $l + x : $l - x, x < $n && (x += Xt);
        }
        return i.setParsedField(this._field, x, X, He);
      }, w.withFixedWidth = function() {
        return this._subsequentWidth === -1 ? this : new b(this._field, this._minWidth, this._maxWidth, this._baseValue, this._baseDate);
      }, w.withSubsequentWidth = function(i) {
        return new b(this._field, this._minWidth, this._maxWidth, this._baseValue, this._baseDate, this._subsequentWidth + i);
      }, w.isFixedWidth = function(i) {
        return i.isStrict() === !1 ? !1 : be.prototype.isFixedWidth.call(this, i);
      }, w.toString = function() {
        return "ReducedValue(" + this._field + "," + this._minWidth + "," + this._maxWidth + "," + (this._baseDate != null ? this._baseDate : this._baseValue) + ")";
      }, b;
    }(Rl), se = "+HH +HHmm +HH:mm +HHMM +HH:MM +HHMMss +HH:MM:ss +HHMMSS +HH:MM:SS".split(" "), Ee = function() {
      function be(w, i) {
        s(w, "noOffsetText"), s(i, "pattern"), this.noOffsetText = w, this.type = this._checkPattern(i);
      }
      var b = be.prototype;
      return b._checkPattern = function(w) {
        for (var i = 0; i < se.length; i++) if (se[i] === w) return i;
        throw new ce("Invalid zone offset pattern: " + w);
      }, b.print = function(w, i) {
        if (w = w.getValue(B.OFFSET_SECONDS), w == null) return !1;
        if (w = E.safeToInt(w), w === 0) i.append(this.noOffsetText);
        else {
          var x = Math.abs(E.intMod(E.intDiv(w, 3600), 100)), X = Math.abs(E.intMod(E.intDiv(w, 60), 60)), He = Math.abs(E.intMod(w, 60)), $n = i.length(), Xt = x;
          i.append(0 > w ? "-" : "+").appendChar(E.intDiv(x, 10) + "0").appendChar(E.intMod(x, 10) + "0"), (3 <= this.type || 1 <= this.type && 0 < X) && (i.append(this.type % 2 === 0 ? ":" : "").appendChar(E.intDiv(X, 10) + "0").appendChar(X % 10 + "0"), Xt += X, (7 <= this.type || 5 <= this.type && 0 < He) && (i.append(this.type % 2 === 0 ? ":" : "").appendChar(E.intDiv(He, 10) + "0").appendChar(He % 10 + "0"), Xt += He)), Xt === 0 && (i.setLength($n), i.append(this.noOffsetText));
        }
        return !0;
      }, b.parse = function(w, i, x) {
        var X = i.length, He = this.noOffsetText.length;
        if (He === 0) {
          if (x === X) return w.setParsedField(
            B.OFFSET_SECONDS,
            0,
            x,
            x
          );
        } else {
          if (x === X) return ~x;
          if (w.subSequenceEquals(i, x, this.noOffsetText, 0, He)) return w.setParsedField(B.OFFSET_SECONDS, 0, x, x + He);
        }
        if (X = i[x], X === "+" || X === "-") {
          var $n = X === "-" ? -1 : 1;
          if (X = [0, 0, 0, 0], X[0] = x + 1, (this._parseNumber(X, 1, i, !0) || this._parseNumber(X, 2, i, 3 <= this.type) || this._parseNumber(X, 3, i, !1)) === !1) return i = E.safeZero($n * (3600 * X[1] + 60 * X[2] + X[3])), w.setParsedField(B.OFFSET_SECONDS, i, x, X[0]);
        }
        return He === 0 ? w.setParsedField(B.OFFSET_SECONDS, 0, x, x + He) : ~x;
      }, b._parseNumber = function(w, i, x, X) {
        if ((this.type + 3) / 2 < i) return !1;
        var He = w[0];
        if (this.type % 2 === 0 && 1 < i) {
          if (He + 1 > x.length || x[He] !== ":") return X;
          He++;
        }
        if (He + 2 > x.length) return X;
        var $n = x[He++];
        return x = x[He++], "0" > $n || "9" < $n || "0" > x || "9" < x || ($n = 10 * ($n.charCodeAt(0) - 48) + (x.charCodeAt(0) - 48), 0 > $n || 59 < $n) ? X : (w[i] = $n, w[0] = He, !1);
      }, b.toString = function() {
        var w = this.noOffsetText.replace("'", "''");
        return "Offset(" + se[this.type] + ",'" + w + "')";
      }, be;
    }();
    Ee.INSTANCE_ID = new Ee("Z", "+HH:MM:ss"), Ee.PATTERNS = se;
    var Ge = function() {
      function be(w, i, x) {
        this._printerParser = w, this._padWidth = i, this._padChar = x;
      }
      var b = be.prototype;
      return b.print = function(w, i) {
        var x = i.length();
        if (this._printerParser.print(w, i) === !1) return !1;
        if (w = i.length() - x, w > this._padWidth) throw new L("Cannot print as output of " + w + " characters exceeds pad width of " + this._padWidth);
        for (var X = 0; X < this._padWidth - w; X++) i.insert(x, this._padChar);
        return !0;
      }, b.parse = function(w, i, x) {
        var X = w.isStrict(), He = w.isCaseSensitive();
        if (h(!(x > i.length)), h(0 <= x), x === i.length) return ~x;
        var $n = x + this._padWidth;
        if ($n > i.length) {
          if (X) return ~x;
          $n = i.length;
        }
        for (var Xt = x; Xt < $n && (He ? i[Xt] === this._padChar : w.charEquals(i[Xt], this._padChar)); ) Xt++;
        return i = i.substring(0, $n), w = this._printerParser.parse(w, i, Xt), w !== $n && X ? ~(x + Xt) : w;
      }, b.toString = function() {
        return "Pad(" + this._printerParser + "," + this._padWidth + (this._padChar === " " ? ")" : ",'" + this._padChar + "')");
      }, be;
    }(), vn = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.print = function() {
        return !0;
      }, w.parse = function(i, x, X) {
        switch (this) {
          case b.SENSITIVE:
            i.setCaseSensitive(!0);
            break;
          case b.INSENSITIVE:
            i.setCaseSensitive(!1);
            break;
          case b.STRICT:
            i.setStrict(!0);
            break;
          case b.LENIENT:
            i.setStrict(!1);
        }
        return X;
      }, w.toString = function() {
        switch (this) {
          case b.SENSITIVE:
            return "ParseCaseSensitive(true)";
          case b.INSENSITIVE:
            return "ParseCaseSensitive(false)";
          case b.STRICT:
            return "ParseStrict(true)";
          case b.LENIENT:
            return "ParseStrict(false)";
        }
      }, b;
    }(P);
    vn.SENSITIVE = new vn("SENSITIVE"), vn.INSENSITIVE = new vn("INSENSITIVE"), vn.STRICT = new vn("STRICT"), vn.LENIENT = new vn("LENIENT");
    var Kn = function() {
      function be(w) {
        this._literal = w;
      }
      var b = be.prototype;
      return b.print = function(w, i) {
        return i.append(this._literal), !0;
      }, b.parse = function(w, i, x) {
        return h(!(x > i.length || 0 > x)), w.subSequenceEquals(i, x, this._literal, 0, this._literal.length) === !1 ? ~x : x + this._literal.length;
      }, b.toString = function() {
        return "'" + this._literal.replace("'", "''") + "'";
      }, be;
    }(), Un = function() {
      function be() {
      }
      return be.getRules = function(b) {
        throw new L("unsupported ZoneId:" + b);
      }, be.getAvailableZoneIds = function() {
        return [];
      }, be;
    }(), Pe = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return X._id = i, X._rules = x, X;
      }
      o(b, be), b.ofId = function(i) {
        var x = Un.getRules(i);
        return new b(i, x);
      };
      var w = b.prototype;
      return w.id = function() {
        return this._id;
      }, w.rules = function() {
        return this._rules;
      }, b;
    }(Ve), C = function() {
      function be(w, i) {
        this.query = w, this.description = i;
      }
      var b = be.prototype;
      return b.print = function(w, i) {
        return w = w.getValueQuery(this.query), w == null ? !1 : (i.append(w.id()), !0);
      }, b.parse = function(w, i, x) {
        var X = i.length;
        if (x > X || x === X) return ~x;
        var He = i.charAt(x);
        if (He === "+" || He === "-")
          return X = w.copy(), i = Ee.INSTANCE_ID.parse(
            X,
            i,
            x
          ), 0 > i || (x = X.getParsed(B.OFFSET_SECONDS), x = ot.ofTotalSeconds(x), w.setParsedZone(x)), i;
        if (X >= x + 2) {
          var $n = i.charAt(x + 1);
          if (w.charEquals(He, "U") && w.charEquals($n, "T")) return X >= x + 3 && w.charEquals(i.charAt(x + 2), "C") ? this._parsePrefixedOffset(w, i, x, x + 3) : this._parsePrefixedOffset(w, i, x, x + 2);
          if (w.charEquals(He, "G") && X >= x + 3 && w.charEquals($n, "M") && w.charEquals(i.charAt(x + 2), "T")) return this._parsePrefixedOffset(w, i, x, x + 3);
        }
        if (i.substr(x, 6) === "SYSTEM") return w.setParsedZone(Ve.systemDefault()), x + 6;
        if (w.charEquals(He, "Z")) return w.setParsedZone(ot.UTC), x + 1;
        He = Un.getAvailableZoneIds(), Z.size !== He.length && (Z = re.createTreeMap(He)), X -= x, He = Z.treeMap, $n = null;
        for (var Xt = 0; He != null; ) {
          var $l = i.substr(x, Math.min(He.length, X));
          He = He.get($l), He != null && He.isLeaf && ($n = $l, Xt = He.length);
        }
        return $n != null ? (w.setParsedZone(Pe.ofId($n)), x + Xt) : ~x;
      }, b._parsePrefixedOffset = function(w, i, x, X) {
        x = i.substring(x, X).toUpperCase();
        var He = w.copy();
        return X < i.length && w.charEquals(i.charAt(X), "Z") || (i = Ee.INSTANCE_ID.parse(He, i, X), 0 > i) ? (w.setParsedZone(Ve.ofOffset(x, ot.UTC)), X) : (X = He.getParsed(B.OFFSET_SECONDS), X = ot.ofTotalSeconds(X), w.setParsedZone(Ve.ofOffset(x, X)), i);
      }, b.toString = function() {
        return this.description;
      }, be;
    }(), re = function() {
      function be(b, w) {
        this.size = b, this.treeMap = w;
      }
      return be.createTreeMap = function(b) {
        b = b.sort(function(x, X) {
          return x.length - X.length;
        });
        for (var w = new ge(b[0].length, !1), i = 0; i < b.length; i++) w.add(b[i]);
        return new be(b.length, w);
      }, be;
    }(), ge = function() {
      function be(w, i) {
        w === void 0 && (w = 0), i === void 0 && (i = !1), this.length = w, this.isLeaf = i, this._treeMap = {};
      }
      var b = be.prototype;
      return b.add = function(w) {
        var i = w.length;
        if (i === this.length) this._treeMap[w] = new be(i, !0);
        else if (i > this.length) {
          var x = w.substr(0, this.length), X = this._treeMap[x];
          X == null && (X = new be(i, !1), this._treeMap[x] = X), X.add(w);
        }
      }, b.get = function(w) {
        return this._treeMap[w];
      }, be;
    }(), Z = new re([]), Y = function() {
      function be() {
        this._active = this, this._parent = null, this._printerParsers = [], this._optional = !1, this._padNextWidth = 0, this._padNextChar = null, this._valueParserIndex = -1;
      }
      be._of = function(w, i) {
        s(w, "parent"), s(i, "optional");
        var x = new be();
        return x._parent = w, x._optional = i, x;
      };
      var b = be.prototype;
      return b.parseCaseSensitive = function() {
        return this._appendInternalPrinterParser(vn.SENSITIVE), this;
      }, b.parseCaseInsensitive = function() {
        return this._appendInternalPrinterParser(vn.INSENSITIVE), this;
      }, b.parseStrict = function() {
        return this._appendInternalPrinterParser(vn.STRICT), this;
      }, b.parseLenient = function() {
        return this._appendInternalPrinterParser(vn.LENIENT), this;
      }, b.appendValue = function() {
        return arguments.length === 1 ? this._appendValue1.apply(this, arguments) : arguments.length === 2 ? this._appendValue2.apply(this, arguments) : this._appendValue4.apply(this, arguments);
      }, b._appendValue1 = function(w) {
        return s(w), this._appendValuePrinterParser(new Rl(w, 1, 15, Kt.NORMAL)), this;
      }, b._appendValue2 = function(w, i) {
        if (s(w), 1 > i || 15 < i) throw new ce("The width must be from 1 to 15 inclusive but was " + i);
        return w = new Rl(w, i, i, Kt.NOT_NEGATIVE), this._appendValuePrinterParser(w), this;
      }, b._appendValue4 = function(w, i, x, X) {
        if (s(w), s(X), i === x && X === Kt.NOT_NEGATIVE) return this._appendValue2(w, x);
        if (1 > i || 15 < i) throw new ce("The minimum width must be from 1 to 15 inclusive but was " + i);
        if (1 > x || 15 < x) throw new ce("The minimum width must be from 1 to 15 inclusive but was " + x);
        if (x < i) throw new ce("The maximum width must exceed or equal the minimum width but " + x + " < " + i);
        return w = new Rl(w, i, x, X), this._appendValuePrinterParser(w), this;
      }, b.appendValueReduced = function() {
        return arguments.length === 4 && arguments[3] instanceof fn ? this._appendValueReducedFieldWidthMaxWidthBaseDate.apply(this, arguments) : this._appendValueReducedFieldWidthMaxWidthBaseValue.apply(this, arguments);
      }, b._appendValueReducedFieldWidthMaxWidthBaseValue = function(w, i, x, X) {
        return s(w, "field"), w = new Se(w, i, x, X, null), this._appendValuePrinterParser(w), this;
      }, b._appendValueReducedFieldWidthMaxWidthBaseDate = function(w, i, x, X) {
        return s(w, "field"), s(X, "baseDate"), d(X, fn, "baseDate"), w = new Se(w, i, x, 0, X), this._appendValuePrinterParser(w), this;
      }, b._appendValuePrinterParser = function(w) {
        if (h(w != null), 0 <= this._active._valueParserIndex && this._active._printerParsers[this._active._valueParserIndex] instanceof Rl) {
          var i = this._active._valueParserIndex, x = this._active._printerParsers[i];
          w.minWidth() === w.maxWidth() && w.signStyle() === Kt.NOT_NEGATIVE ? (x = x.withSubsequentWidth(w.maxWidth()), this._appendInternal(w.withFixedWidth()), this._active._valueParserIndex = i) : (x = x.withFixedWidth(), this._active._valueParserIndex = this._appendInternal(w)), this._active._printerParsers[i] = x;
        } else this._active._valueParserIndex = this._appendInternal(w);
        return this;
      }, b.appendFraction = function(w, i, x, X) {
        return this._appendInternal(new Ar(w, i, x, X)), this;
      }, b.appendInstant = function(w) {
        if (w === void 0 && (w = -2), -2 > w || 9 < w) throw new ce("Invalid fractional digits: " + w);
        return this._appendInternal(new oe(w)), this;
      }, b.appendOffsetId = function() {
        return this._appendInternal(Ee.INSTANCE_ID), this;
      }, b.appendOffset = function(w, i) {
        return this._appendInternalPrinterParser(new Ee(i, w)), this;
      }, b.appendZoneId = function() {
        return this._appendInternal(new C(
          q.zoneId(),
          "ZoneId()"
        )), this;
      }, b.appendPattern = function(w) {
        return s(w, "pattern"), this._parsePattern(w), this;
      }, b.appendZoneText = function() {
        throw new ce("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
      }, b.appendText = function() {
        throw new ce("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
      }, b.appendLocalizedOffset = function() {
        throw new ce("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
      }, b.appendWeekField = function() {
        throw new ce("Pattern using (localized) text not implemented, use js-joda-locale plugin!");
      }, b._parsePattern = function(w) {
        for (var i = { G: B.ERA, y: B.YEAR_OF_ERA, u: B.YEAR, Q: St.QUARTER_OF_YEAR, q: St.QUARTER_OF_YEAR, M: B.MONTH_OF_YEAR, L: B.MONTH_OF_YEAR, D: B.DAY_OF_YEAR, d: B.DAY_OF_MONTH, F: B.ALIGNED_DAY_OF_WEEK_IN_MONTH, E: B.DAY_OF_WEEK, c: B.DAY_OF_WEEK, e: B.DAY_OF_WEEK, a: B.AMPM_OF_DAY, H: B.HOUR_OF_DAY, k: B.CLOCK_HOUR_OF_DAY, K: B.HOUR_OF_AMPM, h: B.CLOCK_HOUR_OF_AMPM, m: B.MINUTE_OF_HOUR, s: B.SECOND_OF_MINUTE, S: B.NANO_OF_SECOND, A: B.MILLI_OF_DAY, n: B.NANO_OF_SECOND, N: B.NANO_OF_DAY }, x = 0; x < w.length; x++) {
          var X = w.charAt(x);
          if ("A" <= X && "Z" >= X || "a" <= X && "z" >= X) {
            for (var He = x++; x < w.length && w.charAt(x) === X; x++) ;
            if (He = x - He, X === "p") {
              var $n = 0;
              if (x < w.length && (X = w.charAt(x), "A" <= X && "Z" >= X || "a" <= X && "z" >= X)) {
                for ($n = He, He = x++; x < w.length && w.charAt(x) === X; x++) ;
                He = x - He;
              }
              if ($n === 0) throw new ce("Pad letter 'p' must be followed by valid pad pattern: " + w);
              this.padNext($n);
            }
            if ($n = i[X], $n != null) this._parseField(X, He, $n);
            else if (X === "z") {
              if (4 < He) throw new ce("Too many pattern letters: " + X);
              He === 4 ? this.appendZoneText(nl.FULL) : this.appendZoneText(nl.SHORT);
            } else if (X === "V") {
              if (He !== 2) throw new ce("Pattern letter count must be 2: " + X);
              this.appendZoneId();
            } else if (X === "Z") if (4 > He) this.appendOffset("+HHMM", "+0000");
            else if (He === 4) this.appendLocalizedOffset(nl.FULL);
            else if (He === 5) this.appendOffset("+HH:MM:ss", "Z");
            else throw new ce("Too many pattern letters: " + X);
            else if (X === "O") if (He === 1) this.appendLocalizedOffset(nl.SHORT);
            else if (He === 4) this.appendLocalizedOffset(nl.FULL);
            else throw new ce("Pattern letter count must be 1 or 4: " + X);
            else if (X === "X") {
              if (5 < He) throw new ce("Too many pattern letters: " + X);
              this.appendOffset(Ee.PATTERNS[He + (He === 1 ? 0 : 1)], "Z");
            } else if (X === "x") {
              if (5 < He) throw new ce("Too many pattern letters: " + X);
              this.appendOffset(Ee.PATTERNS[He + (He === 1 ? 0 : 1)], He === 1 ? "+00" : He % 2 === 0 ? "+0000" : "+00:00");
            } else if (X === "W") {
              if (1 < He) throw new ce("Too many pattern letters: " + X);
              this.appendWeekField("W", He);
            } else if (X === "w") {
              if (2 < He) throw new ce("Too many pattern letters: " + X);
              this.appendWeekField("w", He);
            } else if (X === "Y") this.appendWeekField("Y", He);
            else throw new ce("Unknown pattern letter: " + X);
            x--;
          } else if (X === "'") {
            for (X = x++; x < w.length; x++) if (w.charAt(x) === "'") if (x + 1 < w.length && w.charAt(x + 1) === "'") x++;
            else break;
            if (x >= w.length) throw new ce("Pattern ends with an incomplete string literal: " + w);
            X = w.substring(X + 1, x), X.length === 0 ? this.appendLiteral("'") : this.appendLiteral(X.replace("''", "'"));
          } else if (X === "[") this.optionalStart();
          else if (X === "]") {
            if (this._active._parent === null) throw new ce("Pattern invalid as it contains ] without previous [");
            this.optionalEnd();
          } else {
            if (X === "{" || X === "}" || X === "#") throw new ce("Pattern includes reserved character: '" + X + "'");
            this.appendLiteral(X);
          }
        }
      }, b._parseField = function(w, i, x) {
        switch (w) {
          case "u":
          case "y":
            i === 2 ? this.appendValueReduced(x, 2, 2, Se.BASE_DATE) : 4 > i ? this.appendValue(x, i, 15, Kt.NORMAL) : this.appendValue(x, i, 15, Kt.EXCEEDS_PAD);
            break;
          case "M":
          case "Q":
            switch (i) {
              case 1:
                this.appendValue(x);
                break;
              case 2:
                this.appendValue(x, 2);
                break;
              case 3:
                this.appendText(x, nl.SHORT);
                break;
              case 4:
                this.appendText(x, nl.FULL);
                break;
              case 5:
                this.appendText(x, nl.NARROW);
                break;
              default:
                throw new ce("Too many pattern letters: " + w);
            }
            break;
          case "L":
          case "q":
            switch (i) {
              case 1:
                this.appendValue(x);
                break;
              case 2:
                this.appendValue(x, 2);
                break;
              case 3:
                this.appendText(x, nl.SHORT_STANDALONE);
                break;
              case 4:
                this.appendText(x, nl.FULL_STANDALONE);
                break;
              case 5:
                this.appendText(x, nl.NARROW_STANDALONE);
                break;
              default:
                throw new ce("Too many pattern letters: " + w);
            }
            break;
          case "e":
            switch (i) {
              case 1:
              case 2:
                this.appendWeekField("e", i);
                break;
              case 3:
                this.appendText(x, nl.SHORT);
                break;
              case 4:
                this.appendText(x, nl.FULL);
                break;
              case 5:
                this.appendText(x, nl.NARROW);
                break;
              default:
                throw new ce("Too many pattern letters: " + w);
            }
            break;
          case "c":
            switch (i) {
              case 1:
                this.appendWeekField("c", i);
                break;
              case 2:
                throw new ce("Invalid number of pattern letters: " + w);
              case 3:
                this.appendText(x, nl.SHORT_STANDALONE);
                break;
              case 4:
                this.appendText(x, nl.FULL_STANDALONE);
                break;
              case 5:
                this.appendText(x, nl.NARROW_STANDALONE);
                break;
              default:
                throw new ce("Too many pattern letters: " + w);
            }
            break;
          case "a":
            if (i === 1) this.appendText(x, nl.SHORT);
            else throw new ce("Too many pattern letters: " + w);
            break;
          case "E":
          case "G":
            switch (i) {
              case 1:
              case 2:
              case 3:
                this.appendText(
                  x,
                  nl.SHORT
                );
                break;
              case 4:
                this.appendText(x, nl.FULL);
                break;
              case 5:
                this.appendText(x, nl.NARROW);
                break;
              default:
                throw new ce("Too many pattern letters: " + w);
            }
            break;
          case "S":
            this.appendFraction(B.NANO_OF_SECOND, i, i, !1);
            break;
          case "F":
            if (i === 1) this.appendValue(x);
            else throw new ce("Too many pattern letters: " + w);
            break;
          case "d":
          case "h":
          case "H":
          case "k":
          case "K":
          case "m":
          case "s":
            if (i === 1) this.appendValue(x);
            else if (i === 2) this.appendValue(x, i);
            else throw new ce("Too many pattern letters: " + w);
            break;
          case "D":
            if (i === 1) this.appendValue(x);
            else if (3 >= i) this.appendValue(x, i);
            else throw new ce("Too many pattern letters: " + w);
            break;
          default:
            i === 1 ? this.appendValue(x) : this.appendValue(x, i);
        }
      }, b.padNext = function() {
        return arguments.length === 1 ? this._padNext1.apply(this, arguments) : this._padNext2.apply(this, arguments);
      }, b._padNext1 = function(w) {
        return this._padNext2(w, " ");
      }, b._padNext2 = function(w, i) {
        if (1 > w) throw new ce("The pad width must be at least one but was " + w);
        return this._active._padNextWidth = w, this._active._padNextChar = i, this._active._valueParserIndex = -1, this;
      }, b.optionalStart = function() {
        return this._active._valueParserIndex = -1, this._active = be._of(this._active, !0), this;
      }, b.optionalEnd = function() {
        if (this._active._parent == null) throw new xe("Cannot call optionalEnd() as there was no previous call to optionalStart()");
        if (0 < this._active._printerParsers.length) {
          var w = new ii(this._active._printerParsers, this._active._optional);
          this._active = this._active._parent, this._appendInternal(w);
        } else this._active = this._active._parent;
        return this;
      }, b._appendInternal = function(w) {
        return h(w != null), 0 < this._active._padNextWidth && (w != null && (w = new Ge(w, this._active._padNextWidth, this._active._padNextChar)), this._active._padNextWidth = 0, this._active._padNextChar = 0), this._active._printerParsers.push(w), this._active._valueParserIndex = -1, this._active._printerParsers.length - 1;
      }, b.appendLiteral = function(w) {
        return h(w != null), 0 < w.length && (w.length === 1 ? this._appendInternalPrinterParser(new Pr(w.charAt(0))) : this._appendInternalPrinterParser(new Kn(w))), this;
      }, b._appendInternalPrinterParser = function(w) {
        return h(w != null), 0 < this._active._padNextWidth && (w != null && (w = new Ge(w, this._active._padNextWidth, this._active._padNextChar)), this._active._padNextWidth = 0, this._active._padNextChar = 0), this._active._printerParsers.push(w), this._active._valueParserIndex = -1, this._active._printerParsers.length - 1;
      }, b.append = function(w) {
        return s(w, "formatter"), this._appendInternal(w._toPrinterParser(!1)), this;
      }, b.toFormatter = function(w) {
        for (w === void 0 && (w = at.SMART); this._active._parent != null; ) this.optionalEnd();
        var i = new ii(this._printerParsers, !1);
        return new De(i, null, jr.STANDARD, w, null, null, null);
      }, be;
    }(), oe = function() {
      function be(w) {
        this.fractionalDigits = w;
      }
      var b = be.prototype;
      return b.print = function(w, i) {
        var x = w.getValue(B.INSTANT_SECONDS), X = 0;
        if (w.temporal().isSupported(B.NANO_OF_SECOND) && (X = w.temporal().getLong(B.NANO_OF_SECOND)), x == null) return !1;
        if (w = B.NANO_OF_SECOND.checkValidIntValue(X), -62167219200 <= x) X = x - 31556952e4 + 62167219200, x = E.floorDiv(X, 31556952e4) + 1, X = E.floorMod(
          X,
          31556952e4
        ), X = Pl.ofEpochSecond(X - 62167219200, 0, ot.UTC), 0 < x && i.append("+").append(x), i.append(X), X.second() === 0 && i.append(":00");
        else {
          X = x + 62167219200, x = E.intDiv(X, 31556952e4), X = E.intMod(X, 31556952e4);
          var He = Pl.ofEpochSecond(X - 62167219200, 0, ot.UTC), $n = i.length();
          i.append(He), He.second() === 0 && i.append(":00"), 0 > x && (He.year() === -1e4 ? i.replace($n, $n + 2, "" + (x - 1)) : X === 0 ? i.insert($n, x) : i.insert($n + 1, Math.abs(x)));
        }
        if (this.fractionalDigits === -2) w !== 0 && (i.append("."), E.intMod(w, 1e6) === 0 ? i.append(("" + (E.intDiv(w, 1e6) + 1e3)).substring(1)) : E.intMod(w, 1e3) === 0 ? i.append(("" + (E.intDiv(w, 1e3) + 1e6)).substring(1)) : i.append(("" + (w + 1e9)).substring(1)));
        else if (0 < this.fractionalDigits || this.fractionalDigits === -1 && 0 < w) for (i.append("."), x = 1e8, X = 0; this.fractionalDigits === -1 && 0 < w || X < this.fractionalDigits; X++) He = E.intDiv(w, x), i.append(He), w -= He * x, x = E.intDiv(x, 10);
        return i.append("Z"), !0;
      }, b.parse = function(w, i, x) {
        var X = w.copy(), He = 0 > this.fractionalDigits ? 0 : this.fractionalDigits, $n = 0 > this.fractionalDigits ? 9 : this.fractionalDigits;
        if (i = new Y().append(De.ISO_LOCAL_DATE).appendLiteral("T").appendValue(
          B.HOUR_OF_DAY,
          2
        ).appendLiteral(":").appendValue(B.MINUTE_OF_HOUR, 2).appendLiteral(":").appendValue(B.SECOND_OF_MINUTE, 2).appendFraction(B.NANO_OF_SECOND, He, $n, !0).appendLiteral("Z").toFormatter()._toPrinterParser(!1).parse(X, i, x), 0 > i) return i;
        He = X.getParsed(B.YEAR), $n = X.getParsed(B.MONTH_OF_YEAR);
        var Xt = X.getParsed(B.DAY_OF_MONTH), $l = X.getParsed(B.HOUR_OF_DAY), Oe = X.getParsed(B.MINUTE_OF_HOUR), Ke = X.getParsed(B.SECOND_OF_MINUTE), mn = X.getParsed(B.NANO_OF_SECOND);
        X = Ke ?? 0, Ke = mn ?? 0, mn = E.intMod(He, 1e4);
        var wn = 0;
        $l === 24 && Oe === 0 && X === 0 && Ke === 0 ? ($l = 0, wn = 1) : $l === 23 && Oe === 59 && X === 60 && (w.setParsedLeapSecond(), X = 59);
        try {
          var On = Pl.of(mn, $n, Xt, $l, Oe, X, 0).plusDays(wn).toEpochSecond(ot.UTC);
          On += E.safeMultiply(E.intDiv(He, 1e4), 31556952e4);
        } catch {
          return ~x;
        }
        return On = w.setParsedField(B.INSTANT_SECONDS, On, x, i), w.setParsedField(B.NANO_OF_SECOND, Ke, x, On);
      }, b.toString = function() {
        return "Instant()";
      }, be;
    }(), ke = function() {
      function be() {
        this._str = "";
      }
      var b = be.prototype;
      return b.append = function(w) {
        return this._str += w, this;
      }, b.appendChar = function(w) {
        return this._str += w[0], this;
      }, b.insert = function(w, i) {
        return this._str = this._str.slice(0, w) + i + this._str.slice(w), this;
      }, b.replace = function(w, i, x) {
        return this._str = this._str.slice(0, w) + x + this._str.slice(i), this;
      }, b.length = function() {
        return this._str.length;
      }, b.setLength = function(w) {
        return this._str = this._str.slice(0, w), this;
      }, b.toString = function() {
        return this._str;
      }, be;
    }(), De = function() {
      function be(w, i, x, X, He, $n, Xt) {
        $n === void 0 && ($n = ze.INSTANCE), h(w != null), h(x != null), h(X != null), this._printerParser = w, this._locale = i, this._decimalStyle = x, this._resolverStyle = X, this._resolverFields = He, this._chrono = $n, this._zone = Xt;
      }
      be.parsedExcessDays = function() {
        return be.PARSED_EXCESS_DAYS;
      }, be.parsedLeapSecond = function() {
        return be.PARSED_LEAP_SECOND;
      }, be.ofPattern = function(w) {
        return new Y().appendPattern(w).toFormatter();
      };
      var b = be.prototype;
      return b.locale = function() {
        return this._locale;
      }, b.decimalStyle = function() {
        return this._decimalStyle;
      }, b.chronology = function() {
        return this._chrono;
      }, b.withChronology = function(w) {
        return this._chrono != null && this._chrono.equals(w) ? this : new be(this._printerParser, this._locale, this._decimalStyle, this._resolverStyle, this._resolverFields, w, this._zone);
      }, b.withLocale = function() {
        return this;
      }, b.withResolverStyle = function(w) {
        return s(w, "resolverStyle"), w.equals(this._resolverStyle) ? this : new be(this._printerParser, this._locale, this._decimalStyle, w, this._resolverFields, this._chrono, this._zone);
      }, b.format = function(w) {
        var i = new ke(32);
        return this._formatTo(w, i), i.toString();
      }, b._formatTo = function(w, i) {
        s(w, "temporal"), s(i, "appendable"), w = new ol(w, this), this._printerParser.print(w, i);
      }, b.parse = function(w, i) {
        return arguments.length === 1 ? this.parse1(w) : this.parse2(w, i);
      }, b.parse1 = function(w) {
        s(w, "text");
        try {
          return this._parseToBuilder(w, null).resolve(this._resolverStyle, this._resolverFields);
        } catch (i) {
          throw i instanceof G ? i : this._createError(w, i);
        }
      }, b.parse2 = function(w, i) {
        s(w, "text"), s(i, "type");
        try {
          return this._parseToBuilder(w, null).resolve(this._resolverStyle, this._resolverFields).build(i);
        } catch (x) {
          throw x instanceof G ? x : this._createError(w, x);
        }
      }, b._createError = function(w, i) {
        var x = 64 < w.length ? w.substring(0, 64) + "..." : w;
        return new G("Text '" + x + "' could not be parsed: " + i.message, w, 0, i);
      }, b._parseToBuilder = function(w, i) {
        var x = i ?? new xn(0), X = this._parseUnresolved0(w, x);
        if (X == null || 0 <= x.getErrorIndex() || i == null && x.getIndex() < w.length)
          throw i = 64 < w.length ? w.substr(0, 64).toString() + "..." : w, 0 <= x.getErrorIndex() ? new G("Text '" + i + "' could not be parsed at index " + x.getErrorIndex(), w, x.getErrorIndex()) : new G("Text '" + i + "' could not be parsed, unparsed text found at index " + x.getIndex(), w, x.getIndex());
        return X.toBuilder();
      }, b.parseUnresolved = function(w, i) {
        return this._parseUnresolved0(w, i);
      }, b._parseUnresolved0 = function(w, i) {
        h(w != null, "text", $e), h(i != null, "position", $e);
        var x = new zt(this), X = i.getIndex();
        return X = this._printerParser.parse(x, w, X), 0 > X ? (i.setErrorIndex(~X), null) : (i.setIndex(X), x.toParsed());
      }, b._toPrinterParser = function(w) {
        return this._printerParser.withOptional(w);
      }, b.toString = function() {
        var w = this._printerParser.toString();
        return w.indexOf("[") === 0 ? w : w.substring(1, w.length - 1);
      }, be;
    }(), un = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return X._month = E.safeToInt(i), X._day = E.safeToInt(x), X;
      }
      o(b, be), b.now = function(i) {
        return arguments.length === 0 ? b.now0() : arguments.length === 1 && i instanceof Ve ? b.nowZoneId(i) : b.nowClock(i);
      }, b.now0 = function() {
        return this.nowClock(Wn.systemDefaultZone());
      }, b.nowZoneId = function(i) {
        return s(i, "zone"), this.nowClock(Wn.system(i));
      }, b.nowClock = function(i) {
        return s(i, "clock"), i = ct.now(i), b.of(i.month(), i.dayOfMonth());
      }, b.of = function(i, x) {
        return arguments.length === 2 && i instanceof Be ? b.ofMonthNumber(i, x) : b.ofNumberNumber(i, x);
      }, b.ofMonthNumber = function(i, x) {
        if (s(i, "month"), B.DAY_OF_MONTH.checkValidValue(x), x > i.maxLength()) throw new L("Illegal value for DayOfMonth field, value " + x + " is not valid for month " + i.toString());
        return new b(i.value(), x);
      }, b.ofNumberNumber = function(i, x) {
        return s(i, "month"), s(x, "dayOfMonth"), b.of(Be.of(i), x);
      }, b.from = function(i) {
        if (s(i, "temporal"), d(i, me, "temporal"), i instanceof b) return i;
        try {
          return b.of(i.get(B.MONTH_OF_YEAR), i.get(B.DAY_OF_MONTH));
        } catch {
          throw new L("Unable to obtain MonthDay from TemporalAccessor: " + i + ", type " + (i && i.constructor != null ? i.constructor.name : ""));
        }
      }, b.parse = function(i, x) {
        return arguments.length === 1 ? b.parseString(i) : b.parseStringFormatter(i, x);
      }, b.parseString = function(i) {
        return b.parseStringFormatter(i, gn);
      }, b.parseStringFormatter = function(i, x) {
        return s(i, "text"), s(x, "formatter"), d(
          x,
          De,
          "formatter"
        ), x.parse(i, b.FROM);
      };
      var w = b.prototype;
      return w.monthValue = function() {
        return this._month;
      }, w.month = function() {
        return Be.of(this._month);
      }, w.dayOfMonth = function() {
        return this._day;
      }, w.isSupported = function(i) {
        return i instanceof B ? i === B.MONTH_OF_YEAR || i === B.DAY_OF_MONTH : i != null && i.isSupportedBy(this);
      }, w.range = function(i) {
        return i === B.MONTH_OF_YEAR ? i.range() : i === B.DAY_OF_MONTH ? Ye.of(1, this.month().minLength(), this.month().maxLength()) : be.prototype.range.call(this, i);
      }, w.get = function(i) {
        return this.range(i).checkValidIntValue(
          this.getLong(i),
          i
        );
      }, w.getLong = function(i) {
        if (s(i, "field"), i instanceof B) {
          switch (i) {
            case B.DAY_OF_MONTH:
              return this._day;
            case B.MONTH_OF_YEAR:
              return this._month;
          }
          throw new J("Unsupported field: " + i);
        }
        return i.getFrom(this);
      }, w.isValidYear = function(i) {
        return !(this._day === 29 && this._month === 2 && gt.isLeap(i) === !1);
      }, w.withMonth = function(i) {
        return this.with(Be.of(i));
      }, w.with = function(i) {
        if (s(i, "month"), i.value() === this._month) return this;
        var x = Math.min(this._day, i.maxLength());
        return new b(i.value(), x);
      }, w.withDayOfMonth = function(i) {
        return i === this._day ? this : b.of(this._month, i);
      }, w.query = function(i) {
        return s(i, "query"), d(i, Ae, "query"), i === q.chronology() ? ze.INSTANCE : be.prototype.query.call(this, i);
      }, w.adjustInto = function(i) {
        return s(i, "temporal"), i = i.with(B.MONTH_OF_YEAR, this._month), i.with(B.DAY_OF_MONTH, Math.min(i.range(B.DAY_OF_MONTH).maximum(), this._day));
      }, w.atYear = function(i) {
        return ct.of(i, this._month, this.isValidYear(i) ? this._day : 28);
      }, w.compareTo = function(i) {
        s(i, "other"), d(i, b, "other");
        var x = this._month - i.monthValue();
        return x === 0 && (x = this._day - i.dayOfMonth()), x;
      }, w.isAfter = function(i) {
        return s(i, "other"), d(i, b, "other"), 0 < this.compareTo(i);
      }, w.isBefore = function(i) {
        return s(i, "other"), d(i, b, "other"), 0 > this.compareTo(i);
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this.monthValue() === i.monthValue() && this.dayOfMonth() === i.dayOfMonth() : !1;
      }, w.toString = function() {
        return "--" + (10 > this._month ? "0" : "") + this._month + (10 > this._day ? "-0" : "-") + this._day;
      }, w.toJSON = function() {
        return this.toString();
      }, w.format = function(i) {
        return s(
          i,
          "formatter"
        ), d(i, De, "formatter"), i.format(this);
      }, b;
    }(me), gn, Tn = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return X._year = E.safeToInt(i), X._month = E.safeToInt(x), X;
      }
      o(b, be), b.now = function(i) {
        return arguments.length === 0 ? b.now0() : arguments.length === 1 && i instanceof Ve ? b.nowZoneId(i) : b.nowClock(i);
      }, b.now0 = function() {
        return b.nowClock(Wn.systemDefaultZone());
      }, b.nowZoneId = function(i) {
        return b.nowClock(Wn.system(i));
      }, b.nowClock = function(i) {
        return i = ct.now(i), b.of(i.year(), i.month());
      }, b.of = function(i, x) {
        return arguments.length === 2 && x instanceof Be ? b.ofNumberMonth(i, x) : b.ofNumberNumber(i, x);
      }, b.ofNumberMonth = function(i, x) {
        return s(x, "month"), d(x, Be, "month"), b.ofNumberNumber(i, x.value());
      }, b.ofNumberNumber = function(i, x) {
        return s(i, "year"), s(x, "month"), B.YEAR.checkValidValue(i), B.MONTH_OF_YEAR.checkValidValue(x), new b(i, x);
      }, b.from = function(i) {
        if (s(i, "temporal"), i instanceof b) return i;
        try {
          return b.of(i.get(B.YEAR), i.get(B.MONTH_OF_YEAR));
        } catch {
          throw new L("Unable to obtain YearMonth from TemporalAccessor: " + i + ", type " + (i && i.constructor != null ? i.constructor.name : ""));
        }
      }, b.parse = function(i, x) {
        return arguments.length === 1 ? b.parseString(i) : b.parseStringFormatter(i, x);
      }, b.parseString = function(i) {
        return b.parseStringFormatter(i, ft);
      }, b.parseStringFormatter = function(i, x) {
        return s(x, "formatter"), x.parse(i, b.FROM);
      };
      var w = b.prototype;
      return w.isSupported = function(i) {
        return arguments.length === 1 && i instanceof Ce ? this.isSupportedField(i) : this.isSupportedUnit(i);
      }, w.isSupportedField = function(i) {
        return i instanceof B ? i === B.YEAR || i === B.MONTH_OF_YEAR || i === B.PROLEPTIC_MONTH || i === B.YEAR_OF_ERA || i === B.ERA : i != null && i.isSupportedBy(this);
      }, w.isSupportedUnit = function(i) {
        return i instanceof le ? i === le.MONTHS || i === le.YEARS || i === le.DECADES || i === le.CENTURIES || i === le.MILLENNIA || i === le.ERAS : i != null && i.isSupportedBy(this);
      }, w.range = function(i) {
        return i === B.YEAR_OF_ERA ? 0 >= this.year() ? Ye.of(1, gt.MAX_VALUE + 1) : Ye.of(1, gt.MAX_VALUE) : be.prototype.range.call(this, i);
      }, w.get = function(i) {
        return s(i, "field"), d(i, Ce, "field"), this.range(i).checkValidIntValue(
          this.getLong(i),
          i
        );
      }, w.getLong = function(i) {
        if (s(i, "field"), d(i, Ce, "field"), i instanceof B) {
          switch (i) {
            case B.MONTH_OF_YEAR:
              return this._month;
            case B.PROLEPTIC_MONTH:
              return this._getProlepticMonth();
            case B.YEAR_OF_ERA:
              return 1 > this._year ? 1 - this._year : this._year;
            case B.YEAR:
              return this._year;
            case B.ERA:
              return 1 > this._year ? 0 : 1;
          }
          throw new J("Unsupported field: " + i);
        }
        return i.getFrom(this);
      }, w._getProlepticMonth = function() {
        return E.safeAdd(E.safeMultiply(this._year, 12), this._month - 1);
      }, w.year = function() {
        return this._year;
      }, w.monthValue = function() {
        return this._month;
      }, w.month = function() {
        return Be.of(this._month);
      }, w.isLeapYear = function() {
        return ze.isLeapYear(this._year);
      }, w.isValidDay = function(i) {
        return 1 <= i && i <= this.lengthOfMonth();
      }, w.lengthOfMonth = function() {
        return this.month().length(this.isLeapYear());
      }, w.lengthOfYear = function() {
        return this.isLeapYear() ? 366 : 365;
      }, w.with = function(i, x) {
        return arguments.length === 1 ? this.withAdjuster(i) : this.withFieldValue(i, x);
      }, w.withAdjuster = function(i) {
        return s(i, "adjuster"), i.adjustInto(this);
      }, w.withFieldValue = function(i, x) {
        if (s(i, "field"), d(i, Ce, "field"), i instanceof B) {
          switch (i.checkValidValue(x), i) {
            case B.MONTH_OF_YEAR:
              return this.withMonth(x);
            case B.PROLEPTIC_MONTH:
              return this.plusMonths(x - this.getLong(B.PROLEPTIC_MONTH));
            case B.YEAR_OF_ERA:
              return this.withYear(1 > this._year ? 1 - x : x);
            case B.YEAR:
              return this.withYear(x);
            case B.ERA:
              return this.getLong(B.ERA) === x ? this : this.withYear(1 - this._year);
          }
          throw new J("Unsupported field: " + i);
        }
        return i.adjustInto(this, x);
      }, w.withYear = function(i) {
        return B.YEAR.checkValidValue(i), new b(i, this._month);
      }, w.withMonth = function(i) {
        return B.MONTH_OF_YEAR.checkValidValue(i), new b(this._year, i);
      }, w.plusAmount = function(i) {
        return s(i, "amount"), d(i, K, "amount"), i.addTo(this);
      }, w.plusAmountUnit = function(i, x) {
        if (s(x, "unit"), d(x, H, "unit"), x instanceof le) {
          switch (x) {
            case le.MONTHS:
              return this.plusMonths(i);
            case le.YEARS:
              return this.plusYears(i);
            case le.DECADES:
              return this.plusYears(E.safeMultiply(i, 10));
            case le.CENTURIES:
              return this.plusYears(E.safeMultiply(i, 100));
            case le.MILLENNIA:
              return this.plusYears(E.safeMultiply(
                i,
                1e3
              ));
            case le.ERAS:
              return this.with(B.ERA, E.safeAdd(this.getLong(B.ERA), i));
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.addTo(this, i);
      }, w.plusYears = function(i) {
        return i === 0 ? this : (i = B.YEAR.checkValidIntValue(this._year + i), this.withYear(i));
      }, w.plusMonths = function(i) {
        if (i === 0) return this;
        var x = 12 * this._year + (this._month - 1) + i;
        return i = B.YEAR.checkValidIntValue(E.floorDiv(x, 12)), x = E.floorMod(x, 12) + 1, new b(i, x);
      }, w.minusAmount = function(i) {
        return s(i, "amount"), i.subtractFrom(this);
      }, w.minusAmountUnit = function(i, x) {
        return i === E.MIN_SAFE_INTEGER ? this.plusAmountUnit(E.MAX_SAFE_INTEGER, x).plusAmountUnit(1, x) : this.plusAmountUnit(-i, x);
      }, w.minusYears = function(i) {
        return i === E.MIN_SAFE_INTEGER ? this.plusYears(E.MIN_SAFE_INTEGER).plusYears(1) : this.plusYears(-i);
      }, w.minusMonths = function(i) {
        return i === E.MIN_SAFE_INTEGER ? this.plusMonths(Math.MAX_SAFE_INTEGER).plusMonths(1) : this.plusMonths(-i);
      }, w.query = function(i) {
        return s(i, "query"), d(i, Ae, "query"), i === q.chronology() ? ze.INSTANCE : i === q.precision() ? le.MONTHS : i === q.localDate() || i === q.localTime() || i === q.zone() || i === q.zoneId() || i === q.offset() ? null : be.prototype.query.call(this, i);
      }, w.adjustInto = function(i) {
        return s(i, "temporal"), d(i, jt, "temporal"), i.with(B.PROLEPTIC_MONTH, this._getProlepticMonth());
      }, w.until = function(i, x) {
        if (s(i, "endExclusive"), s(x, "unit"), d(i, jt, "endExclusive"), d(x, H, "unit"), i = b.from(i), x instanceof le) {
          var X = i._getProlepticMonth() - this._getProlepticMonth();
          switch (x) {
            case le.MONTHS:
              return X;
            case le.YEARS:
              return X / 12;
            case le.DECADES:
              return X / 120;
            case le.CENTURIES:
              return X / 1200;
            case le.MILLENNIA:
              return X / 12e3;
            case le.ERAS:
              return i.getLong(B.ERA) - this.getLong(B.ERA);
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.between(this, i);
      }, w.atDay = function(i) {
        return ct.of(this._year, this._month, i);
      }, w.atEndOfMonth = function() {
        return ct.of(this._year, this._month, this.lengthOfMonth());
      }, w.compareTo = function(i) {
        s(i, "other"), d(i, b, "other");
        var x = this._year - i.year();
        return x === 0 && (x = this._month - i.monthValue()), x;
      }, w.isAfter = function(i) {
        return 0 < this.compareTo(i);
      }, w.isBefore = function(i) {
        return 0 > this.compareTo(i);
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this.year() === i.year() && this.monthValue() === i.monthValue() : !1;
      }, w.toString = function() {
        return ft.format(this);
      }, w.toJSON = function() {
        return this.toString();
      }, w.format = function(i) {
        return s(i, "formatter"), i.format(this);
      }, b;
    }(jt), ft, gt = function(be) {
      function b(i) {
        var x = be.call(this) || this;
        return x._year = E.safeToInt(i), x;
      }
      o(b, be);
      var w = b.prototype;
      return w.value = function() {
        return this._year;
      }, b.now = function(i) {
        return i === void 0 && (i = void 0), i === void 0 ? b.now0() : i instanceof Ve ? b.nowZoneId(i) : b.nowClock(i);
      }, b.now0 = function() {
        return b.nowClock(Wn.systemDefaultZone());
      }, b.nowZoneId = function(i) {
        return s(i, "zone"), d(i, Ve, "zone"), b.nowClock(Wn.system(i));
      }, b.nowClock = function(i) {
        return s(i, "clock"), d(i, Wn, "clock"), i = ct.now(i), b.of(i.year());
      }, b.of = function(i) {
        return s(i, "isoYear"), B.YEAR.checkValidValue(i), new b(i);
      }, b.from = function(i) {
        if (s(i, "temporal"), d(i, me, "temporal"), i instanceof b) return i;
        try {
          return b.of(i.get(B.YEAR));
        } catch {
          throw new L("Unable to obtain Year from TemporalAccessor: " + i + ", type " + (i && i.constructor != null ? i.constructor.name : ""));
        }
      }, b.parse = function(i, x) {
        return 1 >= arguments.length ? b.parseText(i) : b.parseTextFormatter(i, x);
      }, b.parseText = function(i) {
        return s(i, "text"), b.parse(i, Gt);
      }, b.parseTextFormatter = function(i, x) {
        return x === void 0 && (x = Gt), s(i, "text"), s(x, "formatter"), d(x, De, "formatter"), x.parse(i, b.FROM);
      }, b.isLeap = function(i) {
        return E.intMod(i, 4) === 0 && (E.intMod(i, 100) !== 0 || E.intMod(i, 400) === 0);
      }, w.isSupported = function(i) {
        return arguments.length === 1 && i instanceof Ce ? this.isSupportedField(i) : this.isSupportedUnit(i);
      }, w.isSupportedField = function(i) {
        return i instanceof B ? i === B.YEAR || i === B.YEAR_OF_ERA || i === B.ERA : i != null && i.isSupportedBy(this);
      }, w.isSupportedUnit = function(i) {
        return i instanceof le ? i === le.YEARS || i === le.DECADES || i === le.CENTURIES || i === le.MILLENNIA || i === le.ERAS : i != null && i.isSupportedBy(this);
      }, w.range = function(i) {
        if (this.isSupported(i)) return i.range();
        if (i instanceof B) throw new J("Unsupported field: " + i);
        return be.prototype.range.call(this, i);
      }, w.get = function(i) {
        return this.range(i).checkValidIntValue(
          this.getLong(i),
          i
        );
      }, w.getLong = function(i) {
        if (s(i, "field"), i instanceof B) {
          switch (i) {
            case B.YEAR_OF_ERA:
              return 1 > this._year ? 1 - this._year : this._year;
            case B.YEAR:
              return this._year;
            case B.ERA:
              return 1 > this._year ? 0 : 1;
          }
          throw new J("Unsupported field: " + i);
        }
        return i.getFrom(this);
      }, w.isLeap = function() {
        return b.isLeap(this._year);
      }, w.withAdjuster = function(i) {
        return s(i, "adjuster"), i.adjustInto(this);
      }, w.withFieldValue = function(i, x) {
        if (s(i, "field"), d(i, Ce, "field"), i instanceof B) {
          switch (i.checkValidValue(x), i) {
            case B.YEAR_OF_ERA:
              return b.of(1 > this._year ? 1 - x : x);
            case B.YEAR:
              return b.of(x);
            case B.ERA:
              return this.getLong(B.ERA) === x ? this : b.of(1 - this._year);
          }
          throw new J("Unsupported field: " + i);
        }
        return i.adjustInto(this, x);
      }, w.plusAmount = function(i) {
        return s(i, "amount"), d(i, K, "amount"), i.addTo(this);
      }, w.plusAmountUnit = function(i, x) {
        if (s(i, "amountToAdd"), s(x, "unit"), d(x, H, "unit"), x instanceof le) {
          switch (x) {
            case le.YEARS:
              return this.plusYears(i);
            case le.DECADES:
              return this.plusYears(E.safeMultiply(i, 10));
            case le.CENTURIES:
              return this.plusYears(E.safeMultiply(
                i,
                100
              ));
            case le.MILLENNIA:
              return this.plusYears(E.safeMultiply(i, 1e3));
            case le.ERAS:
              return this.with(B.ERA, E.safeAdd(this.getLong(B.ERA), i));
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.addTo(this, i);
      }, w.plusYears = function(i) {
        return i === 0 ? this : b.of(B.YEAR.checkValidIntValue(E.safeAdd(this._year, i)));
      }, w.minusAmount = function(i) {
        return s(i, "amount"), d(i, K, "amount"), i.subtractFrom(this);
      }, w.minusAmountUnit = function(i, x) {
        return s(i, "amountToSubtract"), s(x, "unit"), d(x, H, "unit"), i === E.MIN_SAFE_INTEGER ? this.plus(
          E.MAX_SAFE_INTEGER,
          x
        ).plus(1, x) : this.plus(-i, x);
      }, w.minusYears = function(i) {
        return i === E.MIN_SAFE_INTEGER ? this.plusYears(E.MAX_SAFE_INTEGER).plusYears(1) : this.plusYears(-i);
      }, w.adjustInto = function(i) {
        return s(i, "temporal"), i.with(B.YEAR, this._year);
      }, w.isValidMonthDay = function(i) {
        return i != null && i.isValidYear(this._year);
      }, w.length = function() {
        return this.isLeap() ? 366 : 365;
      }, w.atDay = function(i) {
        return ct.ofYearDay(this._year, i);
      }, w.atMonth = function(i) {
        return arguments.length === 1 && i instanceof Be ? this.atMonthMonth(i) : this.atMonthNumber(i);
      }, w.atMonthMonth = function(i) {
        return s(i, "month"), d(i, Be, "month"), Tn.of(this._year, i);
      }, w.atMonthNumber = function(i) {
        return s(i, "month"), Tn.of(this._year, i);
      }, w.atMonthDay = function(i) {
        return s(i, "monthDay"), d(i, un, "monthDay"), i.atYear(this._year);
      }, w.query = function(i) {
        return s(i, "query()"), d(i, Ae, "query()"), i === q.chronology() ? ze.INSTANCE : i === q.precision() ? le.YEARS : i === q.localDate() || i === q.localTime() || i === q.zone() || i === q.zoneId() || i === q.offset() ? null : be.prototype.query.call(this, i);
      }, w.compareTo = function(i) {
        return s(
          i,
          "other"
        ), d(i, b, "other"), this._year - i._year;
      }, w.isAfter = function(i) {
        return s(i, "other"), d(i, b, "other"), this._year > i._year;
      }, w.isBefore = function(i) {
        return s(i, "other"), d(i, b, "other"), this._year < i._year;
      }, w.format = function(i) {
        return s(i, "formatter"), d(i, De, "formatter"), i.format(this);
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this.value() === i.value() : !1;
      }, w.toString = function() {
        return "" + this._year;
      }, w.toJSON = function() {
        return this.toString();
      }, w.until = function(i, x) {
        if (i = b.from(i), x instanceof le) {
          var X = i.value() - this.value();
          switch (x) {
            case le.YEARS:
              return X;
            case le.DECADES:
              return E.intDiv(X, 10);
            case le.CENTURIES:
              return E.intDiv(X, 100);
            case le.MILLENNIA:
              return E.intDiv(X, 1e3);
            case le.ERAS:
              return i.getLong(B.ERA) - this.getLong(B.ERA);
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.between(this, i);
      }, b;
    }(jt), Gt, zl = function() {
      function be() {
      }
      return be.firstDayOfMonth = function() {
        return qe.FIRST_DAY_OF_MONTH;
      }, be.lastDayOfMonth = function() {
        return qe.LAST_DAY_OF_MONTH;
      }, be.firstDayOfNextMonth = function() {
        return qe.FIRST_DAY_OF_NEXT_MONTH;
      }, be.firstDayOfYear = function() {
        return qe.FIRST_DAY_OF_YEAR;
      }, be.lastDayOfYear = function() {
        return qe.LAST_DAY_OF_YEAR;
      }, be.firstDayOfNextYear = function() {
        return qe.FIRST_DAY_OF_NEXT_YEAR;
      }, be.firstInMonth = function(b) {
        return s(b, "dayOfWeek"), new ae(1, b);
      }, be.lastInMonth = function(b) {
        return s(b, "dayOfWeek"), new ae(-1, b);
      }, be.dayOfWeekInMonth = function(b, w) {
        return s(w, "dayOfWeek"), new ae(b, w);
      }, be.next = function(b) {
        return new Ue(2, b);
      }, be.nextOrSame = function(b) {
        return new Ue(0, b);
      }, be.previous = function(b) {
        return new Ue(3, b);
      }, be.previousOrSame = function(b) {
        return new Ue(1, b);
      }, be;
    }(), qe = function(be) {
      function b(w) {
        var i = be.call(this) || this;
        return i._ordinal = w, i;
      }
      return o(b, be), b.prototype.adjustInto = function(w) {
        switch (this._ordinal) {
          case 0:
            return w.with(B.DAY_OF_MONTH, 1);
          case 1:
            return w.with(B.DAY_OF_MONTH, w.range(B.DAY_OF_MONTH).maximum());
          case 2:
            return w.with(B.DAY_OF_MONTH, 1).plus(1, le.MONTHS);
          case 3:
            return w.with(B.DAY_OF_YEAR, 1);
          case 4:
            return w.with(B.DAY_OF_YEAR, w.range(B.DAY_OF_YEAR).maximum());
          case 5:
            return w.with(B.DAY_OF_YEAR, 1).plus(
              1,
              le.YEARS
            );
        }
        throw new xe("Unreachable");
      }, b;
    }(Yt);
    qe.FIRST_DAY_OF_MONTH = new qe(0), qe.LAST_DAY_OF_MONTH = new qe(1), qe.FIRST_DAY_OF_NEXT_MONTH = new qe(2), qe.FIRST_DAY_OF_YEAR = new qe(3), qe.LAST_DAY_OF_YEAR = new qe(4), qe.FIRST_DAY_OF_NEXT_YEAR = new qe(5);
    var ae = function(be) {
      function b(w, i) {
        var x = be.call(this) || this;
        return x._ordinal = w, x._dowValue = i.value(), x;
      }
      return o(b, be), b.prototype.adjustInto = function(w) {
        if (0 <= this._ordinal) {
          w = w.with(B.DAY_OF_MONTH, 1);
          var i = w.get(B.DAY_OF_WEEK);
          return i = E.intMod(this._dowValue - i + 7, 7), i += 7 * (this._ordinal - 1), w.plus(i, le.DAYS);
        }
        return w = w.with(B.DAY_OF_MONTH, w.range(B.DAY_OF_MONTH).maximum()), i = w.get(B.DAY_OF_WEEK), i = this._dowValue - i, i = (i === 0 ? 0 : 0 < i ? i - 7 : i) - 7 * (-this._ordinal - 1), w.plus(i, le.DAYS);
      }, b;
    }(Yt), Ue = function(be) {
      function b(w, i) {
        var x = be.call(this) || this;
        return s(i, "dayOfWeek"), x._relative = w, x._dowValue = i.value(), x;
      }
      return o(b, be), b.prototype.adjustInto = function(w) {
        var i = w.get(B.DAY_OF_WEEK);
        return 2 > this._relative && i === this._dowValue ? w : this._relative & 1 ? (i = this._dowValue - i, w.minus(0 <= i ? 7 - i : -i, le.DAYS)) : (i -= this._dowValue, w.plus(0 <= i ? 7 - i : -i, le.DAYS));
      }, b;
    }(Yt), ze = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be), b.isLeapYear = function(i) {
        return (i & 3) === 0 && (i % 100 !== 0 || i % 400 === 0);
      };
      var w = b.prototype;
      return w._updateResolveMap = function(i, x, X) {
        s(i, "fieldValues"), s(x, "field");
        var He = i.get(x);
        if (He != null && He !== X) throw new L("Invalid state, field: " + x + " " + He + " conflicts with " + x + " " + X);
        i.put(x, X);
      }, w.resolveDate = function(i, x) {
        if (i.containsKey(B.EPOCH_DAY)) return ct.ofEpochDay(i.remove(B.EPOCH_DAY));
        var X = i.remove(B.PROLEPTIC_MONTH);
        if (X != null && (x !== at.LENIENT && B.PROLEPTIC_MONTH.checkValidValue(X), this._updateResolveMap(i, B.MONTH_OF_YEAR, E.floorMod(X, 12) + 1), this._updateResolveMap(i, B.YEAR, E.floorDiv(X, 12))), X = i.remove(B.YEAR_OF_ERA), X != null) {
          x !== at.LENIENT && B.YEAR_OF_ERA.checkValidValue(X);
          var He = i.remove(B.ERA);
          if (He == null) He = i.get(B.YEAR), x === at.STRICT ? He != null ? this._updateResolveMap(i, B.YEAR, 0 < He ? X : E.safeSubtract(1, X)) : i.put(B.YEAR_OF_ERA, X) : this._updateResolveMap(i, B.YEAR, He == null || 0 < He ? X : E.safeSubtract(
            1,
            X
          ));
          else if (He === 1) this._updateResolveMap(i, B.YEAR, X);
          else if (He === 0) this._updateResolveMap(i, B.YEAR, E.safeSubtract(1, X));
          else throw new L("Invalid value for era: " + He);
        } else i.containsKey(B.ERA) && B.ERA.checkValidValue(i.get(B.ERA));
        if (i.containsKey(B.YEAR)) {
          if (i.containsKey(B.MONTH_OF_YEAR) && i.containsKey(B.DAY_OF_MONTH))
            return X = B.YEAR.checkValidIntValue(i.remove(B.YEAR)), He = i.remove(B.MONTH_OF_YEAR), i = i.remove(B.DAY_OF_MONTH), x === at.LENIENT ? (x = He - 1, --i, ct.of(X, 1, 1).plusMonths(x).plusDays(i)) : (x === at.SMART && (B.DAY_OF_MONTH.checkValidValue(i), He === 4 || He === 6 || He === 9 || He === 11 ? i = Math.min(i, 30) : He === 2 && (i = Math.min(i, Be.FEBRUARY.length(gt.isLeap(X))))), ct.of(X, He, i));
          if (i.containsKey(B.DAY_OF_YEAR))
            return X = B.YEAR.checkValidIntValue(i.remove(B.YEAR)), x === at.LENIENT ? (x = E.safeSubtract(i.remove(B.DAY_OF_YEAR), 1), ct.ofYearDay(X, 1).plusDays(x)) : (x = B.DAY_OF_YEAR.checkValidIntValue(i.remove(B.DAY_OF_YEAR)), ct.ofYearDay(X, x));
          if (i.containsKey(B.ALIGNED_WEEK_OF_YEAR)) {
            if (i.containsKey(B.ALIGNED_DAY_OF_WEEK_IN_YEAR)) {
              if (X = B.YEAR.checkValidIntValue(i.remove(B.YEAR)), x === at.LENIENT) return x = E.safeSubtract(i.remove(B.ALIGNED_WEEK_OF_YEAR), 1), i = E.safeSubtract(i.remove(B.ALIGNED_DAY_OF_WEEK_IN_YEAR), 1), ct.of(X, 1, 1).plusWeeks(x).plusDays(i);
              if (He = B.ALIGNED_WEEK_OF_YEAR.checkValidIntValue(i.remove(B.ALIGNED_WEEK_OF_YEAR)), i = B.ALIGNED_DAY_OF_WEEK_IN_YEAR.checkValidIntValue(i.remove(B.ALIGNED_DAY_OF_WEEK_IN_YEAR)), i = ct.of(X, 1, 1).plusDays(7 * (He - 1) + (i - 1)), x === at.STRICT && i.get(B.YEAR) !== X) throw new L("Strict mode rejected date parsed to a different year");
              return i;
            }
            if (i.containsKey(B.DAY_OF_WEEK)) {
              if (X = B.YEAR.checkValidIntValue(i.remove(B.YEAR)), x === at.LENIENT) return x = E.safeSubtract(i.remove(B.ALIGNED_WEEK_OF_YEAR), 1), i = E.safeSubtract(i.remove(B.DAY_OF_WEEK), 1), ct.of(X, 1, 1).plusWeeks(x).plusDays(i);
              if (He = B.ALIGNED_WEEK_OF_YEAR.checkValidIntValue(i.remove(B.ALIGNED_WEEK_OF_YEAR)), i = B.DAY_OF_WEEK.checkValidIntValue(i.remove(B.DAY_OF_WEEK)), i = ct.of(X, 1, 1).plusWeeks(He - 1).with(zl.nextOrSame(Fe.of(i))), x === at.STRICT && i.get(B.YEAR) !== X) throw new L("Strict mode rejected date parsed to a different month");
              return i;
            }
          }
        }
        return null;
      }, w.date = function(i) {
        return ct.from(i);
      }, b;
    }(P), dn = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return s(i, "time"), d(i, Fn, "time"), s(x, "offset"), d(x, ot, "offset"), X._time = i, X._offset = x, X;
      }
      o(b, be), b.from = function(i) {
        if (s(i, "temporal"), i instanceof b) return i;
        if (i instanceof ht) return i.toOffsetTime();
        try {
          var x = Fn.from(i), X = ot.from(i);
          return new b(x, X);
        } catch {
          throw new L("Unable to obtain OffsetTime TemporalAccessor: " + i + ", type " + (i.constructor != null ? i.constructor.name : ""));
        }
      }, b.now = function(i) {
        return arguments.length === 0 ? b._now(Wn.systemDefaultZone()) : i instanceof Wn ? b._now(i) : b._now(Wn.system(i));
      }, b._now = function(i) {
        s(i, "clock");
        var x = i.instant();
        return b.ofInstant(x, i.zone().rules().offset(x));
      }, b.of = function() {
        return 2 >= arguments.length ? b.ofTimeAndOffset.apply(this, arguments) : b.ofNumbers.apply(this, arguments);
      }, b.ofNumbers = function(i, x, X, He, $n) {
        return i = Fn.of(i, x, X, He), new b(i, $n);
      }, b.ofTimeAndOffset = function(i, x) {
        return new b(i, x);
      }, b.ofInstant = function(i, x) {
        s(
          i,
          "instant"
        ), d(i, br, "instant"), s(x, "zone"), d(x, Ve, "zone"), x = x.rules().offset(i);
        var X = i.epochSecond() % Fn.SECONDS_PER_DAY;
        return X = (X + x.totalSeconds()) % Fn.SECONDS_PER_DAY, 0 > X && (X += Fn.SECONDS_PER_DAY), i = Fn.ofSecondOfDay(X, i.nano()), new b(i, x);
      }, b.parse = function(i, x) {
        return x === void 0 && (x = De.ISO_OFFSET_TIME), s(x, "formatter"), x.parse(i, b.FROM);
      };
      var w = b.prototype;
      return w.adjustInto = function(i) {
        return i.with(B.NANO_OF_DAY, this._time.toNanoOfDay()).with(B.OFFSET_SECONDS, this.offset().totalSeconds());
      }, w.atDate = function(i) {
        return ht.of(
          i,
          this._time,
          this._offset
        );
      }, w.format = function(i) {
        return s(i, "formatter"), i.format(this, b.FROM);
      }, w.get = function(i) {
        return be.prototype.get.call(this, i);
      }, w.getLong = function(i) {
        return i instanceof B ? i === B.OFFSET_SECONDS ? this._offset.totalSeconds() : this._time.getLong(i) : i.getFrom(this);
      }, w.hour = function() {
        return this._time.hour();
      }, w.minute = function() {
        return this._time.minute();
      }, w.second = function() {
        return this._time.second();
      }, w.nano = function() {
        return this._time.nano();
      }, w.offset = function() {
        return this._offset;
      }, w.isAfter = function(i) {
        return s(i, "other"), this._toEpochNano() > i._toEpochNano();
      }, w.isBefore = function(i) {
        return s(i, "other"), this._toEpochNano() < i._toEpochNano();
      }, w.isEqual = function(i) {
        return s(i, "other"), this._toEpochNano() === i._toEpochNano();
      }, w.isSupported = function(i) {
        return i instanceof B ? i.isTimeBased() || i === B.OFFSET_SECONDS : i instanceof le ? i.isTimeBased() : i != null && i.isSupportedBy(this);
      }, w.minusHours = function(i) {
        return this._withLocalTimeOffset(this._time.minusHours(i), this._offset);
      }, w.minusMinutes = function(i) {
        return this._withLocalTimeOffset(this._time.minusMinutes(i), this._offset);
      }, w.minusSeconds = function(i) {
        return this._withLocalTimeOffset(this._time.minusSeconds(i), this._offset);
      }, w.minusNanos = function(i) {
        return this._withLocalTimeOffset(this._time.minusNanos(i), this._offset);
      }, w.minusAmount = function(i) {
        return s(i), i.subtractFrom(this);
      }, w.minusAmountUnit = function(i, x) {
        return this.plus(-1 * i, x);
      }, w.plusAmount = function(i) {
        return s(i), i.addTo(this);
      }, w.plusAmountUnit = function(i, x) {
        return x instanceof le ? this._withLocalTimeOffset(this._time.plus(i, x), this._offset) : x.addTo(this, i);
      }, w.plusHours = function(i) {
        return this._withLocalTimeOffset(this._time.plusHours(i), this._offset);
      }, w.plusMinutes = function(i) {
        return this._withLocalTimeOffset(this._time.plusMinutes(i), this._offset);
      }, w.plusSeconds = function(i) {
        return this._withLocalTimeOffset(this._time.plusSeconds(i), this._offset);
      }, w.plusNanos = function(i) {
        return this._withLocalTimeOffset(this._time.plusNanos(i), this._offset);
      }, w.query = function(i) {
        return s(i, "query"), i === q.precision() ? le.NANOS : i === q.offset() || i === q.zone() ? this.offset() : i === q.localTime() ? this._time : i === q.chronology() || i === q.localDate() || i === q.zoneId() ? null : be.prototype.query.call(this, i);
      }, w.range = function(i) {
        return i instanceof B ? i === B.OFFSET_SECONDS ? i.range() : this._time.range(i) : i.rangeRefinedBy(this);
      }, w.toLocalTime = function() {
        return this._time;
      }, w.truncatedTo = function(i) {
        return this._withLocalTimeOffset(this._time.truncatedTo(i), this._offset);
      }, w.until = function(i, x) {
        if (s(i, "endExclusive"), s(
          x,
          "unit"
        ), i = b.from(i), x instanceof le) {
          switch (i = i._toEpochNano() - this._toEpochNano(), x) {
            case le.NANOS:
              return i;
            case le.MICROS:
              return Math.floor(i / 1e3);
            case le.MILLIS:
              return Math.floor(i / 1e6);
            case le.SECONDS:
              return Math.floor(i / Fn.NANOS_PER_SECOND);
            case le.MINUTES:
              return Math.floor(i / Fn.NANOS_PER_MINUTE);
            case le.HOURS:
              return Math.floor(i / Fn.NANOS_PER_HOUR);
            case le.HALF_DAYS:
              return Math.floor(i / (12 * Fn.NANOS_PER_HOUR));
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.between(this, i);
      }, w.withHour = function(i) {
        return this._withLocalTimeOffset(
          this._time.withHour(i),
          this._offset
        );
      }, w.withMinute = function(i) {
        return this._withLocalTimeOffset(this._time.withMinute(i), this._offset);
      }, w.withSecond = function(i) {
        return this._withLocalTimeOffset(this._time.withSecond(i), this._offset);
      }, w.withNano = function(i) {
        return this._withLocalTimeOffset(this._time.withNano(i), this._offset);
      }, w.withOffsetSameInstant = function(i) {
        if (s(i, "offset"), i.equals(this._offset)) return this;
        var x = i.totalSeconds() - this._offset.totalSeconds();
        return x = this._time.plusSeconds(x), new b(x, i);
      }, w.withOffsetSameLocal = function(i) {
        return i != null && i.equals(this._offset) ? this : new b(this._time, i);
      }, w._toEpochNano = function() {
        var i = this._time.toNanoOfDay(), x = this._offset.totalSeconds() * Fn.NANOS_PER_SECOND;
        return i - x;
      }, w.withAdjuster = function(i) {
        return s(i, "adjuster"), i instanceof Fn ? this._withLocalTimeOffset(i, this._offset) : i instanceof ot ? this._withLocalTimeOffset(this._time, i) : i instanceof b ? i : i.adjustInto(this);
      }, w.withFieldValue = function(i, x) {
        return s(i, "field"), i instanceof B ? i === B.OFFSET_SECONDS ? this._withLocalTimeOffset(
          this._time,
          ot.ofTotalSeconds(i.checkValidIntValue(x))
        ) : this._withLocalTimeOffset(this._time.with(i, x), this._offset) : i.adjustInto(this, x);
      }, w._withLocalTimeOffset = function(i, x) {
        return this._time === i && this._offset.equals(x) ? this : new b(i, x);
      }, w.compareTo = function(i) {
        if (s(i, "other"), d(i, b, "other"), this._offset.equals(i._offset)) return this._time.compareTo(i._time);
        var x = E.compareNumbers(this._toEpochNano(), i._toEpochNano());
        return x === 0 ? this._time.compareTo(i._time) : x;
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this._time.equals(i._time) && this._offset.equals(i._offset) : !1;
      }, w.hashCode = function() {
        return this._time.hashCode() ^ this._offset.hashCode();
      }, w.toString = function() {
        return this._time.toString() + this._offset.toString();
      }, w.toJSON = function() {
        return this.toString();
      }, b;
    }(Cl), ut = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.query = function(i) {
        return i === q.zoneId() || i === q.zone() ? this.zone() : i === q.chronology() ? this.toLocalDate().chronology() : i === q.precision() ? le.NANOS : i === q.offset() ? this.offset() : i === q.localDate() ? ct.ofEpochDay(this.toLocalDate().toEpochDay()) : i === q.localTime() ? this.toLocalTime() : be.prototype.query.call(this, i);
      }, w.format = function(i) {
        return s(i, "formatter"), i.format(this);
      }, w.toInstant = function() {
        return br.ofEpochSecond(this.toEpochSecond(), this.toLocalTime().nano());
      }, w.toEpochSecond = function() {
        var i = 86400 * this.toLocalDate().toEpochDay() + this.toLocalTime().toSecondOfDay();
        return i -= this.offset().totalSeconds();
      }, w.compareTo = function(i) {
        s(
          i,
          "other"
        );
        var x = E.compareNumbers(this.toEpochSecond(), i.toEpochSecond());
        return x === 0 && (x = this.toLocalTime().nano() - i.toLocalTime().nano(), x === 0 && (x = this.toLocalDateTime().compareTo(i.toLocalDateTime()), x === 0 && (x = this.zone().id(), i = i.zone().id(), x = x < i ? -1 : x > i ? 1 : 0))), x;
      }, w.isAfter = function(i) {
        s(i, "other");
        var x = this.toEpochSecond(), X = i.toEpochSecond();
        return x > X || x === X && this.toLocalTime().nano() > i.toLocalTime().nano();
      }, w.isBefore = function(i) {
        s(i, "other");
        var x = this.toEpochSecond(), X = i.toEpochSecond();
        return x < X || x === X && this.toLocalTime().nano() < i.toLocalTime().nano();
      }, w.isEqual = function(i) {
        return s(i, "other"), this.toEpochSecond() === i.toEpochSecond() && this.toLocalTime().nano() === i.toLocalTime().nano();
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this.compareTo(i) === 0 : !1;
      }, b;
    }(Cl), Zn = function(be) {
      function b(i, x, X) {
        s(i, "dateTime"), s(x, "offset"), s(X, "zone");
        var He = be.call(this) || this;
        return He._dateTime = i, He._offset = x, He._zone = X, He;
      }
      o(b, be), b.now = function(i) {
        return i = i instanceof Ve ? Wn.system(i) : i ?? Wn.systemDefaultZone(), b.ofInstant(i.instant(), i.zone());
      }, b.of = function() {
        return 2 >= arguments.length ? b.of2.apply(this, arguments) : arguments.length === 3 && arguments[0] instanceof ct ? b.of3.apply(this, arguments) : b.of8.apply(this, arguments);
      }, b.of3 = function(i, x, X) {
        return b.of2(Pl.of(i, x), X);
      }, b.of2 = function(i, x) {
        return b.ofLocal(i, x, null);
      }, b.of8 = function(i, x, X, He, $n, Xt, $l, Oe) {
        return i = Pl.of(i, x, X, He, $n, Xt, $l), b.ofLocal(i, Oe, null);
      }, b.ofLocal = function(i, x, X) {
        if (s(i, "localDateTime"), s(x, "zone"), x instanceof ot) return new b(i, x, x);
        var He = null;
        He = x.rules();
        var $n = He.validOffsets(i);
        return $n.length === 1 ? He = $n[0] : $n.length === 0 ? (He = He.transition(i), i = i.plusSeconds(He.duration().seconds()), He = He.offsetAfter()) : He = X != null && $n.some(function(Xt) {
          return Xt.equals(X);
        }) ? X : s($n[0], "offset"), new b(i, He, x);
      }, b.ofInstant = function() {
        return arguments.length === 2 ? b.ofInstant2.apply(this, arguments) : b.ofInstant3.apply(this, arguments);
      }, b.ofInstant2 = function(i, x) {
        return s(i, "instant"), s(x, "zone"), b._create(i.epochSecond(), i.nano(), x);
      }, b.ofInstant3 = function(i, x, X) {
        return s(i, "localDateTime"), s(x, "offset"), s(X, "zone"), b._create(i.toEpochSecond(x), i.nano(), X);
      }, b._create = function(i, x, X) {
        var He = X.rules(), $n = br.ofEpochSecond(i, x);
        return He = He.offset($n), i = Pl.ofEpochSecond(i, x, He), new b(i, He, X);
      }, b.ofStrict = function(i, x, X) {
        s(i, "localDateTime"), s(x, "offset"), s(X, "zone");
        var He = X.rules();
        if (He.isValidOffset(i, x) === !1)
          throw He = He.transition(i), He != null && He.isGap() ? new L("LocalDateTime " + i + " does not exist in zone " + X + " due to a gap in the local time-line, typically caused by daylight savings") : new L('ZoneOffset "' + x + '" is not valid for LocalDateTime "' + i + '" in zone "' + X + '"');
        return new b(i, x, X);
      }, b.ofLenient = function(i, x, X) {
        if (s(i, "localDateTime"), s(x, "offset"), s(X, "zone"), X instanceof ot && x.equals(X) === !1) throw new ce("ZoneId must match ZoneOffset");
        return new b(i, x, X);
      }, b.from = function(i) {
        if (s(i, "temporal"), i instanceof b) return i;
        var x = Ve.from(i);
        if (i.isSupported(B.INSTANT_SECONDS)) {
          var X = b._from(i, x);
          if (X != null) return X;
        }
        return i = Pl.from(i), b.of2(i, x);
      }, b._from = function(i, x) {
        try {
          return b.__from(
            i,
            x
          );
        } catch (X) {
          if (!(X instanceof L)) throw X;
        }
      }, b.__from = function(i, x) {
        var X = i.getLong(B.INSTANT_SECONDS);
        return i = i.get(B.NANO_OF_SECOND), b._create(X, i, x);
      }, b.parse = function(i, x) {
        return x === void 0 && (x = De.ISO_ZONED_DATE_TIME), s(x, "formatter"), x.parse(i, b.FROM);
      };
      var w = b.prototype;
      return w._resolveLocal = function(i) {
        return s(i, "newDateTime"), b.ofLocal(i, this._zone, this._offset);
      }, w._resolveInstant = function(i) {
        return b.ofInstant3(i, this._offset, this._zone);
      }, w._resolveOffset = function(i) {
        return i.equals(this._offset) === !1 && this._zone.rules().isValidOffset(this._dateTime, i) ? new b(this._dateTime, i, this._zone) : this;
      }, w.isSupported = function(i) {
        return i instanceof B ? !0 : i instanceof le ? i.isDateBased() || i.isTimeBased() : i != null && i.isSupportedBy(this);
      }, w.range = function(i) {
        return i instanceof B ? i === B.INSTANT_SECONDS || i === B.OFFSET_SECONDS ? i.range() : this._dateTime.range(i) : i.rangeRefinedBy(this);
      }, w.get = function(i) {
        return this.getLong(i);
      }, w.getLong = function(i) {
        if (i instanceof B) {
          switch (i) {
            case B.INSTANT_SECONDS:
              return this.toEpochSecond();
            case B.OFFSET_SECONDS:
              return this._offset.totalSeconds();
          }
          return this._dateTime.getLong(i);
        }
        return s(i, "field"), i.getFrom(this);
      }, w.offset = function() {
        return this._offset;
      }, w.withEarlierOffsetAtOverlap = function() {
        var i = this._zone.rules().transition(this._dateTime);
        return i != null && i.isOverlap() && (i = i.offsetBefore(), i.equals(this._offset) === !1) ? new b(this._dateTime, i, this._zone) : this;
      }, w.withLaterOffsetAtOverlap = function() {
        var i = this._zone.rules().transition(this.toLocalDateTime());
        return i != null && (i = i.offsetAfter(), i.equals(this._offset) === !1) ? new b(this._dateTime, i, this._zone) : this;
      }, w.zone = function() {
        return this._zone;
      }, w.withZoneSameLocal = function(i) {
        return s(i, "zone"), this._zone.equals(i) ? this : b.ofLocal(this._dateTime, i, this._offset);
      }, w.withZoneSameInstant = function(i) {
        return s(i, "zone"), this._zone.equals(i) ? this : b._create(this._dateTime.toEpochSecond(this._offset), this._dateTime.nano(), i);
      }, w.withFixedOffsetZone = function() {
        return this._zone.equals(this._offset) ? this : new b(this._dateTime, this._offset, this._offset);
      }, w.year = function() {
        return this._dateTime.year();
      }, w.monthValue = function() {
        return this._dateTime.monthValue();
      }, w.month = function() {
        return this._dateTime.month();
      }, w.dayOfMonth = function() {
        return this._dateTime.dayOfMonth();
      }, w.dayOfYear = function() {
        return this._dateTime.dayOfYear();
      }, w.dayOfWeek = function() {
        return this._dateTime.dayOfWeek();
      }, w.hour = function() {
        return this._dateTime.hour();
      }, w.minute = function() {
        return this._dateTime.minute();
      }, w.second = function() {
        return this._dateTime.second();
      }, w.nano = function() {
        return this._dateTime.nano();
      }, w.withAdjuster = function(i) {
        return i instanceof ct ? this._resolveLocal(Pl.of(i, this._dateTime.toLocalTime())) : i instanceof Fn ? this._resolveLocal(Pl.of(this._dateTime.toLocalDate(), i)) : i instanceof Pl ? this._resolveLocal(i) : i instanceof br ? b._create(i.epochSecond(), i.nano(), this._zone) : i instanceof ot ? this._resolveOffset(i) : (s(i, "adjuster"), i.adjustInto(this));
      }, w.withFieldValue = function(i, x) {
        if (i instanceof B) {
          switch (i) {
            case B.INSTANT_SECONDS:
              return b._create(
                x,
                this.nano(),
                this._zone
              );
            case B.OFFSET_SECONDS:
              return i = ot.ofTotalSeconds(i.checkValidIntValue(x)), this._resolveOffset(i);
          }
          return this._resolveLocal(this._dateTime.with(i, x));
        }
        return i.adjustInto(this, x);
      }, w.withYear = function(i) {
        return this._resolveLocal(this._dateTime.withYear(i));
      }, w.withMonth = function(i) {
        return this._resolveLocal(this._dateTime.withMonth(i));
      }, w.withDayOfMonth = function(i) {
        return this._resolveLocal(this._dateTime.withDayOfMonth(i));
      }, w.withDayOfYear = function(i) {
        return this._resolveLocal(this._dateTime.withDayOfYear(i));
      }, w.withHour = function(i) {
        return this._resolveLocal(this._dateTime.withHour(i));
      }, w.withMinute = function(i) {
        return this._resolveLocal(this._dateTime.withMinute(i));
      }, w.withSecond = function(i) {
        return this._resolveLocal(this._dateTime.withSecond(i));
      }, w.withNano = function(i) {
        return this._resolveLocal(this._dateTime.withNano(i));
      }, w.truncatedTo = function(i) {
        return this._resolveLocal(this._dateTime.truncatedTo(i));
      }, w.plusAmount = function(i) {
        return s(i), i.addTo(this);
      }, w.plusAmountUnit = function(i, x) {
        return x instanceof le ? x.isDateBased() ? this._resolveLocal(this._dateTime.plus(i, x)) : this._resolveInstant(this._dateTime.plus(i, x)) : (s(x, "unit"), x.addTo(this, i));
      }, w.plusYears = function(i) {
        return this._resolveLocal(this._dateTime.plusYears(i));
      }, w.plusMonths = function(i) {
        return this._resolveLocal(this._dateTime.plusMonths(i));
      }, w.plusWeeks = function(i) {
        return this._resolveLocal(this._dateTime.plusWeeks(i));
      }, w.plusDays = function(i) {
        return this._resolveLocal(this._dateTime.plusDays(i));
      }, w.plusHours = function(i) {
        return this._resolveInstant(this._dateTime.plusHours(i));
      }, w.plusMinutes = function(i) {
        return this._resolveInstant(this._dateTime.plusMinutes(i));
      }, w.plusSeconds = function(i) {
        return this._resolveInstant(this._dateTime.plusSeconds(i));
      }, w.plusNanos = function(i) {
        return this._resolveInstant(this._dateTime.plusNanos(i));
      }, w.minusAmount = function(i) {
        return s(i, "amount"), i.subtractFrom(this);
      }, w.minusAmountUnit = function(i, x) {
        return this.plusAmountUnit(-1 * i, x);
      }, w.minusYears = function(i) {
        return this.plusYears(-1 * i);
      }, w.minusMonths = function(i) {
        return this.plusMonths(-1 * i);
      }, w.minusWeeks = function(i) {
        return this.plusWeeks(-1 * i);
      }, w.minusDays = function(i) {
        return this.plusDays(-1 * i);
      }, w.minusHours = function(i) {
        return this.plusHours(-1 * i);
      }, w.minusMinutes = function(i) {
        return this.plusMinutes(-1 * i);
      }, w.minusSeconds = function(i) {
        return this.plusSeconds(-1 * i);
      }, w.minusNanos = function(i) {
        return this.plusNanos(-1 * i);
      }, w.query = function(i) {
        return i === q.localDate() ? this.toLocalDate() : (s(i, "query"), be.prototype.query.call(this, i));
      }, w.until = function(i, x) {
        if (i = b.from(i), x instanceof le) {
          if (i = i.withZoneSameInstant(this._zone), x.isDateBased()) return this._dateTime.until(i._dateTime, x);
          var X = this._offset.totalSeconds() - i._offset.totalSeconds();
          return i = i._dateTime.plusSeconds(X), this._dateTime.until(i, x);
        }
        return x.between(this, i);
      }, w.toLocalDateTime = function() {
        return this._dateTime;
      }, w.toLocalDate = function() {
        return this._dateTime.toLocalDate();
      }, w.toLocalTime = function() {
        return this._dateTime.toLocalTime();
      }, w.toOffsetDateTime = function() {
        return ht.of(this._dateTime, this._offset);
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this._dateTime.equals(i._dateTime) && this._offset.equals(i._offset) && this._zone.equals(i._zone) : !1;
      }, w.hashCode = function() {
        return E.hashCode(this._dateTime.hashCode(), this._offset.hashCode(), this._zone.hashCode());
      }, w.toString = function() {
        var i = this._dateTime.toString() + this._offset.toString();
        return this._offset !== this._zone && (i += "[" + this._zone.toString() + "]"), i;
      }, w.toJSON = function() {
        return this.toString();
      }, w.format = function(i) {
        return be.prototype.format.call(
          this,
          i
        );
      }, b;
    }(ut), ht = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return s(i, "dateTime"), d(i, Pl, "dateTime"), s(x, "offset"), d(x, ot, "offset"), X._dateTime = i, X._offset = x, X;
      }
      o(b, be), b.from = function(i) {
        if (s(i, "temporal"), i instanceof b) return i;
        try {
          var x = ot.from(i);
          try {
            var X = Pl.from(i);
            return b.of(X, x);
          } catch {
            var He = br.from(i);
            return b.ofInstant(He, x);
          }
        } catch {
          throw new L("Unable to obtain OffsetDateTime TemporalAccessor: " + i + ", type " + (i.constructor != null ? i.constructor.name : ""));
        }
      }, b.now = function(i) {
        if (arguments.length === 0) return b.now(Wn.systemDefaultZone());
        if (s(i, "clockOrZone"), i instanceof Ve) return b.now(Wn.system(i));
        if (i instanceof Wn) {
          var x = i.instant();
          return b.ofInstant(x, i.zone().rules().offset(x));
        }
        throw new ce("clockOrZone must be an instance of ZoneId or Clock");
      }, b.of = function() {
        return 2 >= arguments.length ? b.ofDateTime.apply(this, arguments) : arguments.length === 3 ? b.ofDateAndTime.apply(this, arguments) : b.ofNumbers.apply(this, arguments);
      }, b.ofDateTime = function(i, x) {
        return new b(i, x);
      }, b.ofDateAndTime = function(i, x, X) {
        return i = Pl.of(i, x), new b(i, X);
      }, b.ofNumbers = function(i, x, X, He, $n, Xt, $l, Oe) {
        return He === void 0 && (He = 0), $n === void 0 && ($n = 0), Xt === void 0 && (Xt = 0), $l === void 0 && ($l = 0), i = Pl.of(i, x, X, He, $n, Xt, $l), new b(i, Oe);
      }, b.ofInstant = function(i, x) {
        return s(i, "instant"), s(x, "zone"), x = x.rules().offset(i), i = Pl.ofEpochSecond(i.epochSecond(), i.nano(), x), new b(i, x);
      }, b.parse = function(i, x) {
        return x === void 0 && (x = De.ISO_OFFSET_DATE_TIME), s(x, "formatter"), x.parse(i, b.FROM);
      };
      var w = b.prototype;
      return w.adjustInto = function(i) {
        return i.with(
          B.EPOCH_DAY,
          this.toLocalDate().toEpochDay()
        ).with(B.NANO_OF_DAY, this.toLocalTime().toNanoOfDay()).with(B.OFFSET_SECONDS, this.offset().totalSeconds());
      }, w.until = function(i, x) {
        return i = b.from(i), x instanceof le ? (i = i.withOffsetSameInstant(this._offset), this._dateTime.until(i._dateTime, x)) : x.between(this, i);
      }, w.atZoneSameInstant = function(i) {
        return Zn.ofInstant(this._dateTime, this._offset, i);
      }, w.atZoneSimilarLocal = function(i) {
        return Zn.ofLocal(this._dateTime, i, this._offset);
      }, w.query = function(i) {
        return s(i, "query"), i === q.chronology() ? ze.INSTANCE : i === q.precision() ? le.NANOS : i === q.offset() || i === q.zone() ? this.offset() : i === q.localDate() ? this.toLocalDate() : i === q.localTime() ? this.toLocalTime() : i === q.zoneId() ? null : be.prototype.query.call(this, i);
      }, w.get = function(i) {
        if (i instanceof B) {
          switch (i) {
            case B.INSTANT_SECONDS:
              throw new L("Field too large for an int: " + i);
            case B.OFFSET_SECONDS:
              return this.offset().totalSeconds();
          }
          return this._dateTime.get(i);
        }
        return be.prototype.get.call(this, i);
      }, w.getLong = function(i) {
        if (i instanceof B) {
          switch (i) {
            case B.INSTANT_SECONDS:
              return this.toEpochSecond();
            case B.OFFSET_SECONDS:
              return this.offset().totalSeconds();
          }
          return this._dateTime.getLong(i);
        }
        return i.getFrom(this);
      }, w.offset = function() {
        return this._offset;
      }, w.year = function() {
        return this._dateTime.year();
      }, w.monthValue = function() {
        return this._dateTime.monthValue();
      }, w.month = function() {
        return this._dateTime.month();
      }, w.dayOfMonth = function() {
        return this._dateTime.dayOfMonth();
      }, w.dayOfYear = function() {
        return this._dateTime.dayOfYear();
      }, w.dayOfWeek = function() {
        return this._dateTime.dayOfWeek();
      }, w.hour = function() {
        return this._dateTime.hour();
      }, w.minute = function() {
        return this._dateTime.minute();
      }, w.second = function() {
        return this._dateTime.second();
      }, w.nano = function() {
        return this._dateTime.nano();
      }, w.toLocalDateTime = function() {
        return this._dateTime;
      }, w.toLocalDate = function() {
        return this._dateTime.toLocalDate();
      }, w.toLocalTime = function() {
        return this._dateTime.toLocalTime();
      }, w.toOffsetTime = function() {
        return dn.of(this._dateTime.toLocalTime(), this._offset);
      }, w.toZonedDateTime = function() {
        return Zn.of(this._dateTime, this._offset);
      }, w.toInstant = function() {
        return this._dateTime.toInstant(this._offset);
      }, w.toEpochSecond = function() {
        return this._dateTime.toEpochSecond(this._offset);
      }, w.isSupported = function(i) {
        return i instanceof B || i instanceof le ? i.isDateBased() || i.isTimeBased() : i != null && i.isSupportedBy(this);
      }, w.range = function(i) {
        return i instanceof B ? i === B.INSTANT_SECONDS || i === B.OFFSET_SECONDS ? i.range() : this._dateTime.range(i) : i.rangeRefinedBy(this);
      }, w.withAdjuster = function(i) {
        return s(i), i instanceof ct || i instanceof Fn || i instanceof Pl ? this._withDateTimeOffset(this._dateTime.with(i), this._offset) : i instanceof br ? b.ofInstant(i, this._offset) : i instanceof ot ? this._withDateTimeOffset(this._dateTime, i) : i instanceof b ? i : i.adjustInto(this);
      }, w.withFieldValue = function(i, x) {
        if (s(i), i instanceof B) {
          switch (i) {
            case B.INSTANT_SECONDS:
              return b.ofInstant(br.ofEpochSecond(x, this.nano()), this._offset);
            case B.OFFSET_SECONDS:
              return this._withDateTimeOffset(this._dateTime, ot.ofTotalSeconds(i.checkValidIntValue(x)));
          }
          return this._withDateTimeOffset(this._dateTime.with(i, x), this._offset);
        }
        return i.adjustInto(
          this,
          x
        );
      }, w._withDateTimeOffset = function(i, x) {
        return this._dateTime === i && this._offset.equals(x) ? this : new b(i, x);
      }, w.withYear = function(i) {
        return this._withDateTimeOffset(this._dateTime.withYear(i), this._offset);
      }, w.withMonth = function(i) {
        return this._withDateTimeOffset(this._dateTime.withMonth(i), this._offset);
      }, w.withDayOfMonth = function(i) {
        return this._withDateTimeOffset(this._dateTime.withDayOfMonth(i), this._offset);
      }, w.withDayOfYear = function(i) {
        return this._withDateTimeOffset(
          this._dateTime.withDayOfYear(i),
          this._offset
        );
      }, w.withHour = function(i) {
        return this._withDateTimeOffset(this._dateTime.withHour(i), this._offset);
      }, w.withMinute = function(i) {
        return this._withDateTimeOffset(this._dateTime.withMinute(i), this._offset);
      }, w.withSecond = function(i) {
        return this._withDateTimeOffset(this._dateTime.withSecond(i), this._offset);
      }, w.withNano = function(i) {
        return this._withDateTimeOffset(this._dateTime.withNano(i), this._offset);
      }, w.withOffsetSameLocal = function(i) {
        return s(i, "offset"), this._withDateTimeOffset(
          this._dateTime,
          i
        );
      }, w.withOffsetSameInstant = function(i) {
        if (s(i, "offset"), i.equals(this._offset)) return this;
        var x = i.totalSeconds() - this._offset.totalSeconds();
        return x = this._dateTime.plusSeconds(x), new b(x, i);
      }, w.truncatedTo = function(i) {
        return this._withDateTimeOffset(this._dateTime.truncatedTo(i), this._offset);
      }, w.plusAmount = function(i) {
        return s(i, "amount"), i.addTo(this);
      }, w.plusAmountUnit = function(i, x) {
        return x instanceof le ? this._withDateTimeOffset(this._dateTime.plus(i, x), this._offset) : x.addTo(this, i);
      }, w.plusYears = function(i) {
        return this._withDateTimeOffset(this._dateTime.plusYears(i), this._offset);
      }, w.plusMonths = function(i) {
        return this._withDateTimeOffset(this._dateTime.plusMonths(i), this._offset);
      }, w.plusWeeks = function(i) {
        return this._withDateTimeOffset(this._dateTime.plusWeeks(i), this._offset);
      }, w.plusDays = function(i) {
        return this._withDateTimeOffset(this._dateTime.plusDays(i), this._offset);
      }, w.plusHours = function(i) {
        return this._withDateTimeOffset(this._dateTime.plusHours(i), this._offset);
      }, w.plusMinutes = function(i) {
        return this._withDateTimeOffset(
          this._dateTime.plusMinutes(i),
          this._offset
        );
      }, w.plusSeconds = function(i) {
        return this._withDateTimeOffset(this._dateTime.plusSeconds(i), this._offset);
      }, w.plusNanos = function(i) {
        return this._withDateTimeOffset(this._dateTime.plusNanos(i), this._offset);
      }, w.minusAmount = function(i) {
        return s(i), i.subtractFrom(this);
      }, w.minusAmountUnit = function(i, x) {
        return this.plus(-1 * i, x);
      }, w.minusYears = function(i) {
        return this._withDateTimeOffset(this._dateTime.minusYears(i), this._offset);
      }, w.minusMonths = function(i) {
        return this._withDateTimeOffset(
          this._dateTime.minusMonths(i),
          this._offset
        );
      }, w.minusWeeks = function(i) {
        return this._withDateTimeOffset(this._dateTime.minusWeeks(i), this._offset);
      }, w.minusDays = function(i) {
        return this._withDateTimeOffset(this._dateTime.minusDays(i), this._offset);
      }, w.minusHours = function(i) {
        return this._withDateTimeOffset(this._dateTime.minusHours(i), this._offset);
      }, w.minusMinutes = function(i) {
        return this._withDateTimeOffset(this._dateTime.minusMinutes(i), this._offset);
      }, w.minusSeconds = function(i) {
        return this._withDateTimeOffset(
          this._dateTime.minusSeconds(i),
          this._offset
        );
      }, w.minusNanos = function(i) {
        return this._withDateTimeOffset(this._dateTime.minusNanos(i), this._offset);
      }, w.compareTo = function(i) {
        if (s(i, "other"), d(i, b, "other"), this.offset().equals(i.offset())) return this.toLocalDateTime().compareTo(i.toLocalDateTime());
        var x = E.compareNumbers(this.toEpochSecond(), i.toEpochSecond());
        return x === 0 && (x = this.toLocalTime().nano() - i.toLocalTime().nano(), x === 0 && (x = this.toLocalDateTime().compareTo(i.toLocalDateTime()))), x;
      }, w.isAfter = function(i) {
        s(i, "other");
        var x = this.toEpochSecond(), X = i.toEpochSecond();
        return x > X || x === X && this.toLocalTime().nano() > i.toLocalTime().nano();
      }, w.isBefore = function(i) {
        s(i, "other");
        var x = this.toEpochSecond(), X = i.toEpochSecond();
        return x < X || x === X && this.toLocalTime().nano() < i.toLocalTime().nano();
      }, w.isEqual = function(i) {
        return s(i, "other"), this.toEpochSecond() === i.toEpochSecond() && this.toLocalTime().nano() === i.toLocalTime().nano();
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this._dateTime.equals(i._dateTime) && this._offset.equals(i._offset) : !1;
      }, w.hashCode = function() {
        return this._dateTime.hashCode() ^ this._offset.hashCode();
      }, w.toString = function() {
        return this._dateTime.toString() + this._offset.toString();
      }, w.toJSON = function() {
        return this.toString();
      }, w.format = function(i) {
        return s(i, "formatter"), i.format(this);
      }, b;
    }(Cl), ct = function(be) {
      function b(i, x, X) {
        var He = be.call(this) || this;
        return s(i, "year"), s(x, "month"), s(X, "dayOfMonth"), x instanceof Be && (x = x.value()), He._year = E.safeToInt(i), He._month = E.safeToInt(x), He._day = E.safeToInt(X), b._validate(
          He._year,
          He._month,
          He._day
        ), He;
      }
      o(b, be), b.now = function(i) {
        return i = i == null ? Wn.systemDefaultZone() : i instanceof Ve ? Wn.system(i) : i, b.ofInstant(i.instant(), i.zone());
      }, b.ofInstant = function(i, x) {
        return x === void 0 && (x = Ve.systemDefault()), s(i, "instant"), x = x.rules().offset(i), i = i.epochSecond() + x.totalSeconds(), i = E.floorDiv(i, Fn.SECONDS_PER_DAY), b.ofEpochDay(i);
      }, b.of = function(i, x, X) {
        return new b(i, x, X);
      }, b.ofYearDay = function(i, x) {
        B.YEAR.checkValidValue(i);
        var X = ze.isLeapYear(i);
        x === 366 && X === !1 && h(!1, "Invalid date 'DayOfYear 366' as '" + i + "' is not a leap year", L);
        var He = Be.of(Math.floor((x - 1) / 31 + 1)), $n = He.firstDayOfYear(X) + He.length(X) - 1;
        return x > $n && (He = He.plus(1)), x = x - He.firstDayOfYear(X) + 1, new b(i, He.value(), x);
      }, b.ofEpochDay = function(i) {
        i === void 0 && (i = 0);
        var x = i + 719528 - 60, X = 0;
        0 > x && (i = E.intDiv(x + 1, 146097) - 1, X = 400 * i, x += 146097 * -i), i = E.intDiv(400 * x + 591, 146097);
        var He = x - (365 * i + E.intDiv(i, 4) - E.intDiv(i, 100) + E.intDiv(i, 400));
        return 0 > He && (i--, He = x - (365 * i + E.intDiv(i, 4) - E.intDiv(i, 100) + E.intDiv(i, 400))), i += X, X = E.intDiv(5 * He + 2, 153), x = (X + 2) % 12 + 1, He = He - E.intDiv(306 * X + 5, 10) + 1, i += E.intDiv(X, 10), new b(i, x, He);
      }, b.from = function(i) {
        s(i, "temporal");
        var x = i.query(q.localDate());
        if (x == null) throw new L("Unable to obtain LocalDate from TemporalAccessor: " + i + ", type " + (i.constructor != null ? i.constructor.name : ""));
        return x;
      }, b.parse = function(i, x) {
        return x === void 0 && (x = De.ISO_LOCAL_DATE), h(x != null, "formatter", $e), x.parse(i, b.FROM);
      }, b._resolvePreviousValid = function(i, x, X) {
        switch (x) {
          case 2:
            X = Math.min(X, ze.isLeapYear(i) ? 29 : 28);
            break;
          case 4:
          case 6:
          case 9:
          case 11:
            X = Math.min(X, 30);
        }
        return b.of(i, x, X);
      }, b._validate = function(i, x, X) {
        if (B.YEAR.checkValidValue(i), B.MONTH_OF_YEAR.checkValidValue(x), B.DAY_OF_MONTH.checkValidValue(X), 28 < X) {
          var He = 31;
          switch (x) {
            case 2:
              He = ze.isLeapYear(i) ? 29 : 28;
              break;
            case 4:
            case 6:
            case 9:
            case 11:
              He = 30;
          }
          X > He && (X === 29 ? h(!1, "Invalid date 'February 29' as '" + i + "' is not a leap year", L) : h(!1, "Invalid date '" + i + "' '" + x + "' '" + X + "'", L));
        }
      };
      var w = b.prototype;
      return w.isSupported = function(i) {
        return be.prototype.isSupported.call(this, i);
      }, w.range = function(i) {
        if (i instanceof B) {
          if (i.isDateBased()) {
            switch (i) {
              case B.DAY_OF_MONTH:
                return Ye.of(1, this.lengthOfMonth());
              case B.DAY_OF_YEAR:
                return Ye.of(1, this.lengthOfYear());
              case B.ALIGNED_WEEK_OF_MONTH:
                return Ye.of(1, this.month() === Be.FEBRUARY && this.isLeapYear() === !1 ? 4 : 5);
              case B.YEAR_OF_ERA:
                return 0 >= this._year ? Ye.of(1, gt.MAX_VALUE + 1) : Ye.of(1, gt.MAX_VALUE);
            }
            return i.range();
          }
          throw new J("Unsupported field: " + i);
        }
        return i.rangeRefinedBy(this);
      }, w.get = function(i) {
        return this.getLong(i);
      }, w.getLong = function(i) {
        return h(i != null, "", $e), i instanceof B ? this._get0(i) : i.getFrom(this);
      }, w._get0 = function(i) {
        switch (i) {
          case B.DAY_OF_WEEK:
            return this.dayOfWeek().value();
          case B.ALIGNED_DAY_OF_WEEK_IN_MONTH:
            return E.intMod(this._day - 1, 7) + 1;
          case B.ALIGNED_DAY_OF_WEEK_IN_YEAR:
            return E.intMod(this.dayOfYear() - 1, 7) + 1;
          case B.DAY_OF_MONTH:
            return this._day;
          case B.DAY_OF_YEAR:
            return this.dayOfYear();
          case B.EPOCH_DAY:
            return this.toEpochDay();
          case B.ALIGNED_WEEK_OF_MONTH:
            return E.intDiv(this._day - 1, 7) + 1;
          case B.ALIGNED_WEEK_OF_YEAR:
            return E.intDiv(this.dayOfYear() - 1, 7) + 1;
          case B.MONTH_OF_YEAR:
            return this._month;
          case B.PROLEPTIC_MONTH:
            return this._prolepticMonth();
          case B.YEAR_OF_ERA:
            return 1 <= this._year ? this._year : 1 - this._year;
          case B.YEAR:
            return this._year;
          case B.ERA:
            return 1 <= this._year ? 1 : 0;
        }
        throw new J("Unsupported field: " + i);
      }, w._prolepticMonth = function() {
        return 12 * this._year + (this._month - 1);
      }, w.chronology = function() {
        return ze.INSTANCE;
      }, w.year = function() {
        return this._year;
      }, w.monthValue = function() {
        return this._month;
      }, w.month = function() {
        return Be.of(this._month);
      }, w.dayOfMonth = function() {
        return this._day;
      }, w.dayOfYear = function() {
        return this.month().firstDayOfYear(this.isLeapYear()) + this._day - 1;
      }, w.dayOfWeek = function() {
        var i = E.floorMod(this.toEpochDay() + 3, 7);
        return Fe.of(i + 1);
      }, w.isLeapYear = function() {
        return ze.isLeapYear(this._year);
      }, w.lengthOfMonth = function() {
        switch (this._month) {
          case 2:
            return this.isLeapYear() ? 29 : 28;
          case 4:
          case 6:
          case 9:
          case 11:
            return 30;
          default:
            return 31;
        }
      }, w.lengthOfYear = function() {
        return this.isLeapYear() ? 366 : 365;
      }, w.withAdjuster = function(i) {
        return s(
          i,
          "adjuster"
        ), i instanceof b ? i : (h(typeof i.adjustInto == "function", "adjuster", ce), i.adjustInto(this));
      }, w.withFieldValue = function(i, x) {
        if (h(i != null, "field", $e), i instanceof B) {
          switch (i.checkValidValue(x), i) {
            case B.DAY_OF_WEEK:
              return this.plusDays(x - this.dayOfWeek().value());
            case B.ALIGNED_DAY_OF_WEEK_IN_MONTH:
              return this.plusDays(x - this.getLong(B.ALIGNED_DAY_OF_WEEK_IN_MONTH));
            case B.ALIGNED_DAY_OF_WEEK_IN_YEAR:
              return this.plusDays(x - this.getLong(B.ALIGNED_DAY_OF_WEEK_IN_YEAR));
            case B.DAY_OF_MONTH:
              return this.withDayOfMonth(x);
            case B.DAY_OF_YEAR:
              return this.withDayOfYear(x);
            case B.EPOCH_DAY:
              return b.ofEpochDay(x);
            case B.ALIGNED_WEEK_OF_MONTH:
              return this.plusWeeks(x - this.getLong(B.ALIGNED_WEEK_OF_MONTH));
            case B.ALIGNED_WEEK_OF_YEAR:
              return this.plusWeeks(x - this.getLong(B.ALIGNED_WEEK_OF_YEAR));
            case B.MONTH_OF_YEAR:
              return this.withMonth(x);
            case B.PROLEPTIC_MONTH:
              return this.plusMonths(x - this.getLong(B.PROLEPTIC_MONTH));
            case B.YEAR_OF_ERA:
              return this.withYear(1 <= this._year ? x : 1 - x);
            case B.YEAR:
              return this.withYear(x);
            case B.ERA:
              return this.getLong(B.ERA) === x ? this : this.withYear(1 - this._year);
          }
          throw new J("Unsupported field: " + i);
        }
        return i.adjustInto(this, x);
      }, w.withYear = function(i) {
        return this._year === i ? this : (B.YEAR.checkValidValue(i), b._resolvePreviousValid(i, this._month, this._day));
      }, w.withMonth = function(i) {
        return i = i instanceof Be ? i.value() : i, this._month === i ? this : (B.MONTH_OF_YEAR.checkValidValue(i), b._resolvePreviousValid(this._year, i, this._day));
      }, w.withDayOfMonth = function(i) {
        return this._day === i ? this : b.of(this._year, this._month, i);
      }, w.withDayOfYear = function(i) {
        return this.dayOfYear() === i ? this : b.ofYearDay(this._year, i);
      }, w.plusAmount = function(i) {
        return s(i, "amount"), i.addTo(this);
      }, w.plusAmountUnit = function(i, x) {
        if (s(i, "amountToAdd"), s(x, "unit"), x instanceof le) {
          switch (x) {
            case le.DAYS:
              return this.plusDays(i);
            case le.WEEKS:
              return this.plusWeeks(i);
            case le.MONTHS:
              return this.plusMonths(i);
            case le.YEARS:
              return this.plusYears(i);
            case le.DECADES:
              return this.plusYears(E.safeMultiply(i, 10));
            case le.CENTURIES:
              return this.plusYears(E.safeMultiply(
                i,
                100
              ));
            case le.MILLENNIA:
              return this.plusYears(E.safeMultiply(i, 1e3));
            case le.ERAS:
              return this.with(B.ERA, E.safeAdd(this.getLong(B.ERA), i));
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.addTo(this, i);
      }, w.plusYears = function(i) {
        return i === 0 ? this : (i = B.YEAR.checkValidIntValue(this._year + i), b._resolvePreviousValid(i, this._month, this._day));
      }, w.plusMonths = function(i) {
        if (i === 0) return this;
        var x = 12 * this._year + (this._month - 1) + i;
        return i = B.YEAR.checkValidIntValue(E.floorDiv(x, 12)), x = E.floorMod(x, 12) + 1, b._resolvePreviousValid(
          i,
          x,
          this._day
        );
      }, w.plusWeeks = function(i) {
        return this.plusDays(E.safeMultiply(i, 7));
      }, w.plusDays = function(i) {
        return i === 0 ? this : (i = E.safeAdd(this.toEpochDay(), i), b.ofEpochDay(i));
      }, w.minusAmount = function(i) {
        return s(i, "amount"), i.subtractFrom(this);
      }, w.minusAmountUnit = function(i, x) {
        return s(i, "amountToSubtract"), s(x, "unit"), this.plusAmountUnit(-1 * i, x);
      }, w.minusYears = function(i) {
        return this.plusYears(-1 * i);
      }, w.minusMonths = function(i) {
        return this.plusMonths(-1 * i);
      }, w.minusWeeks = function(i) {
        return this.plusWeeks(-1 * i);
      }, w.minusDays = function(i) {
        return this.plusDays(-1 * i);
      }, w.query = function(i) {
        return s(i, "query"), i === q.localDate() ? this : be.prototype.query.call(this, i);
      }, w.adjustInto = function(i) {
        return be.prototype.adjustInto.call(this, i);
      }, w.until = function(i, x) {
        return 2 > arguments.length ? this.until1(i) : this.until2(i, x);
      }, w.until2 = function(i, x) {
        if (i = b.from(i), x instanceof le) {
          switch (x) {
            case le.DAYS:
              return this.daysUntil(i);
            case le.WEEKS:
              return E.intDiv(this.daysUntil(i), 7);
            case le.MONTHS:
              return this._monthsUntil(i);
            case le.YEARS:
              return E.intDiv(
                this._monthsUntil(i),
                12
              );
            case le.DECADES:
              return E.intDiv(this._monthsUntil(i), 120);
            case le.CENTURIES:
              return E.intDiv(this._monthsUntil(i), 1200);
            case le.MILLENNIA:
              return E.intDiv(this._monthsUntil(i), 12e3);
            case le.ERAS:
              return i.getLong(B.ERA) - this.getLong(B.ERA);
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.between(this, i);
      }, w.daysUntil = function(i) {
        return i.toEpochDay() - this.toEpochDay();
      }, w._monthsUntil = function(i) {
        var x = 32 * this._prolepticMonth() + this.dayOfMonth();
        return i = 32 * i._prolepticMonth() + i.dayOfMonth(), E.intDiv(i - x, 32);
      }, w.until1 = function(i) {
        var x = b.from(i);
        i = x._prolepticMonth() - this._prolepticMonth();
        var X = x._day - this._day;
        return 0 < i && 0 > X ? (i--, X = this.plusMonths(i), X = x.toEpochDay() - X.toEpochDay()) : 0 > i && 0 < X && (i++, X -= x.lengthOfMonth()), x = E.intDiv(i, 12), i = E.intMod(i, 12), pn.of(x, i, X);
      }, w.atTime = function() {
        return arguments.length === 1 ? this.atTime1.apply(this, arguments) : this.atTime4.apply(this, arguments);
      }, w.atTime1 = function(i) {
        if (s(i, "time"), i instanceof Fn) return Pl.of(this, i);
        if (i instanceof dn) return this._atTimeOffsetTime(i);
        throw new ce("time must be an instance of LocalTime or OffsetTime" + (i && i.constructor && i.constructor.name ? ", but is " + i.constructor.name : ""));
      }, w.atTime4 = function(i, x, X, He) {
        return X === void 0 && (X = 0), He === void 0 && (He = 0), this.atTime1(Fn.of(i, x, X, He));
      }, w._atTimeOffsetTime = function(i) {
        return ht.of(Pl.of(this, i.toLocalTime()), i.offset());
      }, w.atStartOfDay = function(i) {
        return i != null ? this.atStartOfDayWithZone(i) : Pl.of(this, Fn.MIDNIGHT);
      }, w.atStartOfDayWithZone = function(i) {
        s(i, "zone");
        var x = this.atTime(Fn.MIDNIGHT);
        if (!(i instanceof ot)) {
          var X = i.rules().transition(x);
          X != null && X.isGap() && (x = X.dateTimeAfter());
        }
        return Zn.of(x, i);
      }, w.toEpochDay = function() {
        var i = this._year, x = this._month, X = 365 * i;
        return X = 0 <= i ? X + (E.intDiv(i + 3, 4) - E.intDiv(i + 99, 100) + E.intDiv(i + 399, 400)) : X - (E.intDiv(i, -4) - E.intDiv(i, -100) + E.intDiv(i, -400)), X += E.intDiv(367 * x - 362, 12), X += this.dayOfMonth() - 1, 2 < x && (X--, ze.isLeapYear(i) || X--), X - 719528;
      }, w.compareTo = function(i) {
        return s(i, "other"), d(i, b, "other"), this._compareTo0(i);
      }, w._compareTo0 = function(i) {
        var x = this._year - i._year;
        return x === 0 && (x = this._month - i._month, x === 0 && (x = this._day - i._day)), x;
      }, w.isAfter = function(i) {
        return 0 < this.compareTo(i);
      }, w.isBefore = function(i) {
        return 0 > this.compareTo(i);
      }, w.isEqual = function(i) {
        return this.compareTo(i) === 0;
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this._compareTo0(i) === 0 : !1;
      }, w.hashCode = function() {
        var i = this._year;
        return E.hash(i & 4294965248 ^ (i << 11) + (this._month << 6) + this._day);
      }, w.toString = function() {
        var i = this._year, x = this._month, X = this._day;
        return (1e3 > Math.abs(i) ? 0 > i ? "-" + ("" + (i - 1e4)).slice(-4) : ("" + (i + 1e4)).slice(-4) : 9999 < i ? "+" + i : "" + i) + (10 > x ? "-0" + x : "-" + x) + (10 > X ? "-0" + X : "-" + X);
      }, w.toJSON = function() {
        return this.toString();
      }, w.format = function(i) {
        return s(i, "formatter"), d(i, De, "formatter"), be.prototype.format.call(this, i);
      }, b;
    }(fn), Hl = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.chronology = function() {
        return this.toLocalDate().chronology();
      }, w.query = function(i) {
        return i === q.chronology() ? this.chronology() : i === q.precision() ? le.NANOS : i === q.localDate() ? ct.ofEpochDay(this.toLocalDate().toEpochDay()) : i === q.localTime() ? this.toLocalTime() : i === q.zone() || i === q.zoneId() || i === q.offset() ? null : be.prototype.query.call(this, i);
      }, w.adjustInto = function(i) {
        return i.with(B.EPOCH_DAY, this.toLocalDate().toEpochDay()).with(B.NANO_OF_DAY, this.toLocalTime().toNanoOfDay());
      }, w.toInstant = function(i) {
        return d(i, ot, "zoneId"), br.ofEpochSecond(this.toEpochSecond(i), this.toLocalTime().nano());
      }, w.toEpochSecond = function(i) {
        s(i, "offset");
        var x = 86400 * this.toLocalDate().toEpochDay() + this.toLocalTime().toSecondOfDay();
        return x -= i.totalSeconds(), E.safeToInt(x);
      }, b;
    }(Cl), Pl = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return d(i, ct, "date"), d(x, Fn, "time"), X._date = i, X._time = x, X;
      }
      o(b, be), b.now = function(i) {
        return i == null ? b._now(Wn.systemDefaultZone()) : i instanceof Wn ? b._now(i) : b._now(Wn.system(i));
      }, b._now = function(i) {
        return s(i, "clock"), b.ofInstant(i.instant(), i.zone());
      }, b._ofEpochMillis = function(i, x) {
        var X = E.floorDiv(i, 1e3) + x.totalSeconds();
        return x = E.floorDiv(X, Fn.SECONDS_PER_DAY), X = E.floorMod(X, Fn.SECONDS_PER_DAY), i = 1e6 * E.floorMod(i, 1e3), x = ct.ofEpochDay(x), i = Fn.ofSecondOfDay(X, i), new b(x, i);
      }, b.of = function() {
        return 2 >= arguments.length ? b.ofDateAndTime.apply(this, arguments) : b.ofNumbers.apply(this, arguments);
      }, b.ofNumbers = function(i, x, X, He, $n, Xt, $l) {
        return He === void 0 && (He = 0), $n === void 0 && ($n = 0), Xt === void 0 && (Xt = 0), $l === void 0 && ($l = 0), i = ct.of(i, x, X), He = Fn.of(He, $n, Xt, $l), new b(i, He);
      }, b.ofDateAndTime = function(i, x) {
        return s(i, "date"), s(x, "time"), new b(i, x);
      }, b.ofInstant = function(i, x) {
        return x === void 0 && (x = Ve.systemDefault()), s(i, "instant"), d(i, br, "instant"), s(x, "zone"), x = x.rules().offset(i), b.ofEpochSecond(i.epochSecond(), i.nano(), x);
      }, b.ofEpochSecond = function(i, x, X) {
        i === void 0 && (i = 0), x === void 0 && (x = 0), arguments.length === 2 && x instanceof ot && (X = x, x = 0), s(X, "offset");
        var He = i + X.totalSeconds(), $n = E.floorDiv(He, Fn.SECONDS_PER_DAY);
        return He = E.floorMod(He, Fn.SECONDS_PER_DAY), $n = ct.ofEpochDay($n), He = Fn.ofSecondOfDay(He, x), new b($n, He);
      }, b.from = function(i) {
        if (s(i, "temporal"), i instanceof b) return i;
        if (i instanceof Zn) return i.toLocalDateTime();
        try {
          var x = ct.from(i), X = Fn.from(i);
          return new b(x, X);
        } catch {
          throw new L("Unable to obtain LocalDateTime TemporalAccessor: " + i + ", type " + (i.constructor != null ? i.constructor.name : ""));
        }
      }, b.parse = function(i, x) {
        return x === void 0 && (x = De.ISO_LOCAL_DATE_TIME), s(x, "formatter"), x.parse(i, b.FROM);
      };
      var w = b.prototype;
      return w._withDateTime = function(i, x) {
        return this._date.equals(i) && this._time.equals(x) ? this : new b(
          i,
          x
        );
      }, w.isSupported = function(i) {
        return i instanceof B || i instanceof le ? i.isDateBased() || i.isTimeBased() : i != null && i.isSupportedBy(this);
      }, w.range = function(i) {
        return i instanceof B ? i.isTimeBased() ? this._time.range(i) : this._date.range(i) : i.rangeRefinedBy(this);
      }, w.get = function(i) {
        return i instanceof B ? i.isTimeBased() ? this._time.get(i) : this._date.get(i) : be.prototype.get.call(this, i);
      }, w.getLong = function(i) {
        return s(i, "field"), i instanceof B ? i.isTimeBased() ? this._time.getLong(i) : this._date.getLong(i) : i.getFrom(this);
      }, w.year = function() {
        return this._date.year();
      }, w.monthValue = function() {
        return this._date.monthValue();
      }, w.month = function() {
        return this._date.month();
      }, w.dayOfMonth = function() {
        return this._date.dayOfMonth();
      }, w.dayOfYear = function() {
        return this._date.dayOfYear();
      }, w.dayOfWeek = function() {
        return this._date.dayOfWeek();
      }, w.hour = function() {
        return this._time.hour();
      }, w.minute = function() {
        return this._time.minute();
      }, w.second = function() {
        return this._time.second();
      }, w.nano = function() {
        return this._time.nano();
      }, w.withAdjuster = function(i) {
        return s(i, "adjuster"), i instanceof ct ? this._withDateTime(i, this._time) : i instanceof Fn ? this._withDateTime(this._date, i) : i instanceof b ? i : (h(typeof i.adjustInto == "function", "adjuster", ce), i.adjustInto(this));
      }, w.withFieldValue = function(i, x) {
        return s(i, "field"), i instanceof B ? i.isTimeBased() ? this._withDateTime(this._date, this._time.with(i, x)) : this._withDateTime(this._date.with(i, x), this._time) : i.adjustInto(this, x);
      }, w.withYear = function(i) {
        return this._withDateTime(
          this._date.withYear(i),
          this._time
        );
      }, w.withMonth = function(i) {
        return this._withDateTime(this._date.withMonth(i), this._time);
      }, w.withDayOfMonth = function(i) {
        return this._withDateTime(this._date.withDayOfMonth(i), this._time);
      }, w.withDayOfYear = function(i) {
        return this._withDateTime(this._date.withDayOfYear(i), this._time);
      }, w.withHour = function(i) {
        return i = this._time.withHour(i), this._withDateTime(this._date, i);
      }, w.withMinute = function(i) {
        return i = this._time.withMinute(i), this._withDateTime(this._date, i);
      }, w.withSecond = function(i) {
        return i = this._time.withSecond(i), this._withDateTime(this._date, i);
      }, w.withNano = function(i) {
        return i = this._time.withNano(i), this._withDateTime(this._date, i);
      }, w.truncatedTo = function(i) {
        return this._withDateTime(this._date, this._time.truncatedTo(i));
      }, w.plusAmount = function(i) {
        return s(i, "amount"), i.addTo(this);
      }, w.plusAmountUnit = function(i, x) {
        if (s(x, "unit"), x instanceof le) {
          switch (x) {
            case le.NANOS:
              return this.plusNanos(i);
            case le.MICROS:
              return this.plusDays(E.intDiv(i, Fn.MICROS_PER_DAY)).plusNanos(1e3 * E.intMod(
                i,
                Fn.MICROS_PER_DAY
              ));
            case le.MILLIS:
              return this.plusDays(E.intDiv(i, Fn.MILLIS_PER_DAY)).plusNanos(1e6 * E.intMod(i, Fn.MILLIS_PER_DAY));
            case le.SECONDS:
              return this.plusSeconds(i);
            case le.MINUTES:
              return this.plusMinutes(i);
            case le.HOURS:
              return this.plusHours(i);
            case le.HALF_DAYS:
              return this.plusDays(E.intDiv(i, 256)).plusHours(12 * E.intMod(i, 256));
          }
          return this._withDateTime(this._date.plus(i, x), this._time);
        }
        return x.addTo(this, i);
      }, w.plusYears = function(i) {
        return i = this._date.plusYears(i), this._withDateTime(i, this._time);
      }, w.plusMonths = function(i) {
        return i = this._date.plusMonths(i), this._withDateTime(i, this._time);
      }, w.plusWeeks = function(i) {
        return i = this._date.plusWeeks(i), this._withDateTime(i, this._time);
      }, w.plusDays = function(i) {
        return i = this._date.plusDays(i), this._withDateTime(i, this._time);
      }, w.plusHours = function(i) {
        return this._plusWithOverflow(this._date, i, 0, 0, 0, 1);
      }, w.plusMinutes = function(i) {
        return this._plusWithOverflow(this._date, 0, i, 0, 0, 1);
      }, w.plusSeconds = function(i) {
        return this._plusWithOverflow(
          this._date,
          0,
          0,
          i,
          0,
          1
        );
      }, w.plusNanos = function(i) {
        return this._plusWithOverflow(this._date, 0, 0, 0, i, 1);
      }, w.minusAmount = function(i) {
        return s(i, "amount"), i.subtractFrom(this);
      }, w.minusAmountUnit = function(i, x) {
        return s(x, "unit"), this.plusAmountUnit(-1 * i, x);
      }, w.minusYears = function(i) {
        return this.plusYears(-1 * i);
      }, w.minusMonths = function(i) {
        return this.plusMonths(-1 * i);
      }, w.minusWeeks = function(i) {
        return this.plusWeeks(-1 * i);
      }, w.minusDays = function(i) {
        return this.plusDays(-1 * i);
      }, w.minusHours = function(i) {
        return this._plusWithOverflow(
          this._date,
          i,
          0,
          0,
          0,
          -1
        );
      }, w.minusMinutes = function(i) {
        return this._plusWithOverflow(this._date, 0, i, 0, 0, -1);
      }, w.minusSeconds = function(i) {
        return this._plusWithOverflow(this._date, 0, 0, i, 0, -1);
      }, w.minusNanos = function(i) {
        return this._plusWithOverflow(this._date, 0, 0, 0, i, -1);
      }, w._plusWithOverflow = function(i, x, X, He, $n, Xt) {
        if (x === 0 && X === 0 && He === 0 && $n === 0) return this._withDateTime(i, this._time);
        var $l = E.intDiv($n, Fn.NANOS_PER_DAY) + E.intDiv(He, Fn.SECONDS_PER_DAY) + E.intDiv(X, Fn.MINUTES_PER_DAY) + E.intDiv(x, Fn.HOURS_PER_DAY);
        return $l *= Xt, X = E.intMod($n, Fn.NANOS_PER_DAY) + E.intMod(He, Fn.SECONDS_PER_DAY) * Fn.NANOS_PER_SECOND + E.intMod(X, Fn.MINUTES_PER_DAY) * Fn.NANOS_PER_MINUTE + E.intMod(x, Fn.HOURS_PER_DAY) * Fn.NANOS_PER_HOUR, x = this._time.toNanoOfDay(), X = X * Xt + x, $l += E.floorDiv(X, Fn.NANOS_PER_DAY), Xt = E.floorMod(X, Fn.NANOS_PER_DAY), Xt = Xt === x ? this._time : Fn.ofNanoOfDay(Xt), this._withDateTime(i.plusDays($l), Xt);
      }, w.query = function(i) {
        return s(i, "query"), i === q.localDate() ? this.toLocalDate() : be.prototype.query.call(this, i);
      }, w.adjustInto = function(i) {
        return be.prototype.adjustInto.call(
          this,
          i
        );
      }, w.until = function(i, x) {
        if (s(i, "endExclusive"), s(x, "unit"), i = b.from(i), x instanceof le) {
          if (x.isTimeBased()) {
            var X = this._date.daysUntil(i._date);
            switch (i = i._time.toNanoOfDay() - this._time.toNanoOfDay(), 0 < X && 0 > i ? (X--, i += Fn.NANOS_PER_DAY) : 0 > X && 0 < i && (X++, i -= Fn.NANOS_PER_DAY), x) {
              case le.NANOS:
                return X = E.safeMultiply(X, Fn.NANOS_PER_DAY), E.safeAdd(X, i);
              case le.MICROS:
                return X = E.safeMultiply(X, Fn.MICROS_PER_DAY), E.safeAdd(X, E.intDiv(i, 1e3));
              case le.MILLIS:
                return X = E.safeMultiply(X, Fn.MILLIS_PER_DAY), E.safeAdd(
                  X,
                  E.intDiv(i, 1e6)
                );
              case le.SECONDS:
                return X = E.safeMultiply(X, Fn.SECONDS_PER_DAY), E.safeAdd(X, E.intDiv(i, Fn.NANOS_PER_SECOND));
              case le.MINUTES:
                return X = E.safeMultiply(X, Fn.MINUTES_PER_DAY), E.safeAdd(X, E.intDiv(i, Fn.NANOS_PER_MINUTE));
              case le.HOURS:
                return X = E.safeMultiply(X, Fn.HOURS_PER_DAY), E.safeAdd(X, E.intDiv(i, Fn.NANOS_PER_HOUR));
              case le.HALF_DAYS:
                return X = E.safeMultiply(X, 2), E.safeAdd(X, E.intDiv(i, 12 * Fn.NANOS_PER_HOUR));
            }
            throw new J("Unsupported unit: " + x);
          }
          return X = i._date, i = i._time, X.isAfter(this._date) && i.isBefore(this._time) ? X = X.minusDays(1) : X.isBefore(this._date) && i.isAfter(this._time) && (X = X.plusDays(1)), this._date.until(X, x);
        }
        return x.between(this, i);
      }, w.atOffset = function(i) {
        return ht.of(this, i);
      }, w.atZone = function(i) {
        return Zn.of(this, i);
      }, w.toLocalDate = function() {
        return this._date;
      }, w.toLocalTime = function() {
        return this._time;
      }, w.compareTo = function(i) {
        return s(i, "other"), d(i, b, "other"), this._compareTo0(i);
      }, w._compareTo0 = function(i) {
        var x = this._date.compareTo(i.toLocalDate());
        return x === 0 && (x = this._time.compareTo(i.toLocalTime())), x;
      }, w.isAfter = function(i) {
        return 0 < this.compareTo(i);
      }, w.isBefore = function(i) {
        return 0 > this.compareTo(i);
      }, w.isEqual = function(i) {
        return this.compareTo(i) === 0;
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this._date.equals(i._date) && this._time.equals(i._time) : !1;
      }, w.hashCode = function() {
        return this._date.hashCode() ^ this._time.hashCode();
      }, w.toString = function() {
        return this._date.toString() + "T" + this._time.toString();
      }, w.toJSON = function() {
        return this.toString();
      }, w.format = function(i) {
        return s(i, "formatter"), i.format(this);
      }, b;
    }(Hl), Fn = function(be) {
      function b(i, x, X, He) {
        i === void 0 && (i = 0), x === void 0 && (x = 0), X === void 0 && (X = 0), He === void 0 && (He = 0);
        var $n = be.call(this) || this;
        return i = E.safeToInt(i), x = E.safeToInt(x), X = E.safeToInt(X), He = E.safeToInt(He), b._validate(i, x, X, He), x === 0 && X === 0 && He === 0 ? (b.HOURS[i] || ($n._hour = i, $n._minute = x, $n._second = X, $n._nano = He, b.HOURS[i] = a($n)), b.HOURS[i] || a($n)) : ($n._hour = i, $n._minute = x, $n._second = X, $n._nano = He, $n);
      }
      o(b, be), b.now = function(i) {
        return i == null ? b._now(Wn.systemDefaultZone()) : i instanceof Wn ? b._now(i) : b._now(Wn.system(i));
      }, b._now = function(i) {
        return i === void 0 && (i = Wn.systemDefaultZone()), s(i, "clock"), b.ofInstant(i.instant(), i.zone());
      }, b.ofInstant = function(i, x) {
        x === void 0 && (x = Ve.systemDefault()), x = x.rules().offset(i);
        var X = E.intMod(i.epochSecond(), b.SECONDS_PER_DAY);
        return X = E.intMod(X + x.totalSeconds(), b.SECONDS_PER_DAY), 0 > X && (X += b.SECONDS_PER_DAY), b.ofSecondOfDay(X, i.nano());
      }, b.of = function(i, x, X, He) {
        return new b(i, x, X, He);
      }, b.ofSecondOfDay = function(i, x) {
        i === void 0 && (i = 0), x === void 0 && (x = 0), B.SECOND_OF_DAY.checkValidValue(i), B.NANO_OF_SECOND.checkValidValue(x);
        var X = E.intDiv(i, b.SECONDS_PER_HOUR);
        i -= X * b.SECONDS_PER_HOUR;
        var He = E.intDiv(i, b.SECONDS_PER_MINUTE);
        return i -= He * b.SECONDS_PER_MINUTE, new b(X, He, i, x);
      }, b.ofNanoOfDay = function(i) {
        i === void 0 && (i = 0), B.NANO_OF_DAY.checkValidValue(i);
        var x = E.intDiv(i, b.NANOS_PER_HOUR);
        i -= x * b.NANOS_PER_HOUR;
        var X = E.intDiv(i, b.NANOS_PER_MINUTE);
        i -= X * b.NANOS_PER_MINUTE;
        var He = E.intDiv(i, b.NANOS_PER_SECOND);
        return i -= He * b.NANOS_PER_SECOND, new b(
          x,
          X,
          He,
          i
        );
      }, b.from = function(i) {
        s(i, "temporal");
        var x = i.query(q.localTime());
        if (x == null) throw new L("Unable to obtain LocalTime TemporalAccessor: " + i + ", type " + (i.constructor != null ? i.constructor.name : ""));
        return x;
      }, b.parse = function(i, x) {
        return x === void 0 && (x = De.ISO_LOCAL_TIME), s(x, "formatter"), x.parse(i, b.FROM);
      }, b._validate = function(i, x, X, He) {
        B.HOUR_OF_DAY.checkValidValue(i), B.MINUTE_OF_HOUR.checkValidValue(x), B.SECOND_OF_MINUTE.checkValidValue(X), B.NANO_OF_SECOND.checkValidValue(He);
      };
      var w = b.prototype;
      return w.isSupported = function(i) {
        return i instanceof B || i instanceof le ? i.isTimeBased() : i != null && i.isSupportedBy(this);
      }, w.range = function(i) {
        return s(i), be.prototype.range.call(this, i);
      }, w.get = function(i) {
        return this.getLong(i);
      }, w.getLong = function(i) {
        return s(i, "field"), i instanceof B ? this._get0(i) : i.getFrom(this);
      }, w._get0 = function(i) {
        switch (i) {
          case B.NANO_OF_SECOND:
            return this._nano;
          case B.NANO_OF_DAY:
            return this.toNanoOfDay();
          case B.MICRO_OF_SECOND:
            return E.intDiv(this._nano, 1e3);
          case B.MICRO_OF_DAY:
            return E.intDiv(
              this.toNanoOfDay(),
              1e3
            );
          case B.MILLI_OF_SECOND:
            return E.intDiv(this._nano, 1e6);
          case B.MILLI_OF_DAY:
            return E.intDiv(this.toNanoOfDay(), 1e6);
          case B.SECOND_OF_MINUTE:
            return this._second;
          case B.SECOND_OF_DAY:
            return this.toSecondOfDay();
          case B.MINUTE_OF_HOUR:
            return this._minute;
          case B.MINUTE_OF_DAY:
            return 60 * this._hour + this._minute;
          case B.HOUR_OF_AMPM:
            return E.intMod(this._hour, 12);
          case B.CLOCK_HOUR_OF_AMPM:
            return i = E.intMod(this._hour, 12), i % 12 === 0 ? 12 : i;
          case B.HOUR_OF_DAY:
            return this._hour;
          case B.CLOCK_HOUR_OF_DAY:
            return this._hour === 0 ? 24 : this._hour;
          case B.AMPM_OF_DAY:
            return E.intDiv(this._hour, 12);
        }
        throw new J("Unsupported field: " + i);
      }, w.hour = function() {
        return this._hour;
      }, w.minute = function() {
        return this._minute;
      }, w.second = function() {
        return this._second;
      }, w.nano = function() {
        return this._nano;
      }, w.withAdjuster = function(i) {
        return s(i, "adjuster"), i instanceof b ? i : (h(typeof i.adjustInto == "function", "adjuster", ce), i.adjustInto(this));
      }, w.withFieldValue = function(i, x) {
        if (s(i, "field"), d(i, Ce, "field"), i instanceof B) {
          switch (i.checkValidValue(x), i) {
            case B.NANO_OF_SECOND:
              return this.withNano(x);
            case B.NANO_OF_DAY:
              return b.ofNanoOfDay(x);
            case B.MICRO_OF_SECOND:
              return this.withNano(1e3 * x);
            case B.MICRO_OF_DAY:
              return b.ofNanoOfDay(1e3 * x);
            case B.MILLI_OF_SECOND:
              return this.withNano(1e6 * x);
            case B.MILLI_OF_DAY:
              return b.ofNanoOfDay(1e6 * x);
            case B.SECOND_OF_MINUTE:
              return this.withSecond(x);
            case B.SECOND_OF_DAY:
              return this.plusSeconds(x - this.toSecondOfDay());
            case B.MINUTE_OF_HOUR:
              return this.withMinute(x);
            case B.MINUTE_OF_DAY:
              return this.plusMinutes(x - (60 * this._hour + this._minute));
            case B.HOUR_OF_AMPM:
              return this.plusHours(x - E.intMod(this._hour, 12));
            case B.CLOCK_HOUR_OF_AMPM:
              return this.plusHours((x === 12 ? 0 : x) - E.intMod(this._hour, 12));
            case B.HOUR_OF_DAY:
              return this.withHour(x);
            case B.CLOCK_HOUR_OF_DAY:
              return this.withHour(x === 24 ? 0 : x);
            case B.AMPM_OF_DAY:
              return this.plusHours(12 * (x - E.intDiv(this._hour, 12)));
          }
          throw new J("Unsupported field: " + i);
        }
        return i.adjustInto(this, x);
      }, w.withHour = function(i) {
        return i === void 0 && (i = 0), this._hour === i ? this : new b(
          i,
          this._minute,
          this._second,
          this._nano
        );
      }, w.withMinute = function(i) {
        return i === void 0 && (i = 0), this._minute === i ? this : new b(this._hour, i, this._second, this._nano);
      }, w.withSecond = function(i) {
        return i === void 0 && (i = 0), this._second === i ? this : new b(this._hour, this._minute, i, this._nano);
      }, w.withNano = function(i) {
        return i === void 0 && (i = 0), this._nano === i ? this : new b(this._hour, this._minute, this._second, i);
      }, w.truncatedTo = function(i) {
        if (s(i, "unit"), i === le.NANOS) return this;
        if (i = i.duration(), i.seconds() > b.SECONDS_PER_DAY) throw new L("Unit is too large to be used for truncation");
        if (i = i.toNanos(), E.intMod(b.NANOS_PER_DAY, i) !== 0) throw new L("Unit must divide into a standard day without remainder");
        var x = this.toNanoOfDay();
        return b.ofNanoOfDay(E.intDiv(x, i) * i);
      }, w.plusAmount = function(i) {
        return s(i, "amount"), i.addTo(this);
      }, w.plusAmountUnit = function(i, x) {
        if (s(x, "unit"), x instanceof le) {
          switch (x) {
            case le.NANOS:
              return this.plusNanos(i);
            case le.MICROS:
              return this.plusNanos(1e3 * E.intMod(i, b.MICROS_PER_DAY));
            case le.MILLIS:
              return this.plusNanos(1e6 * E.intMod(i, b.MILLIS_PER_DAY));
            case le.SECONDS:
              return this.plusSeconds(i);
            case le.MINUTES:
              return this.plusMinutes(i);
            case le.HOURS:
              return this.plusHours(i);
            case le.HALF_DAYS:
              return this.plusHours(12 * E.intMod(i, 2));
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.addTo(this, i);
      }, w.plusHours = function(i) {
        return i === 0 ? this : (i = E.intMod(E.intMod(i, b.HOURS_PER_DAY) + this._hour + b.HOURS_PER_DAY, b.HOURS_PER_DAY), new b(i, this._minute, this._second, this._nano));
      }, w.plusMinutes = function(i) {
        if (i === 0) return this;
        var x = this._hour * b.MINUTES_PER_HOUR + this._minute;
        return i = E.intMod(E.intMod(i, b.MINUTES_PER_DAY) + x + b.MINUTES_PER_DAY, b.MINUTES_PER_DAY), x === i ? this : (x = E.intDiv(i, b.MINUTES_PER_HOUR), i = E.intMod(i, b.MINUTES_PER_HOUR), new b(x, i, this._second, this._nano));
      }, w.plusSeconds = function(i) {
        if (i === 0) return this;
        var x = this._hour * b.SECONDS_PER_HOUR + this._minute * b.SECONDS_PER_MINUTE + this._second;
        if (i = E.intMod(E.intMod(i, b.SECONDS_PER_DAY) + x + b.SECONDS_PER_DAY, b.SECONDS_PER_DAY), x === i) return this;
        x = E.intDiv(i, b.SECONDS_PER_HOUR);
        var X = E.intMod(E.intDiv(i, b.SECONDS_PER_MINUTE), b.MINUTES_PER_HOUR);
        return i = E.intMod(i, b.SECONDS_PER_MINUTE), new b(x, X, i, this._nano);
      }, w.plusNanos = function(i) {
        if (i === 0) return this;
        var x = this.toNanoOfDay();
        if (i = E.intMod(E.intMod(i, b.NANOS_PER_DAY) + x + b.NANOS_PER_DAY, b.NANOS_PER_DAY), x === i) return this;
        x = E.intDiv(i, b.NANOS_PER_HOUR);
        var X = E.intMod(E.intDiv(i, b.NANOS_PER_MINUTE), b.MINUTES_PER_HOUR), He = E.intMod(E.intDiv(i, b.NANOS_PER_SECOND), b.SECONDS_PER_MINUTE);
        return i = E.intMod(i, b.NANOS_PER_SECOND), new b(x, X, He, i);
      }, w.minusAmount = function(i) {
        return s(i, "amount"), i.subtractFrom(this);
      }, w.minusAmountUnit = function(i, x) {
        return s(x, "unit"), this.plusAmountUnit(-1 * i, x);
      }, w.minusHours = function(i) {
        return this.plusHours(-1 * E.intMod(i, b.HOURS_PER_DAY));
      }, w.minusMinutes = function(i) {
        return this.plusMinutes(-1 * E.intMod(i, b.MINUTES_PER_DAY));
      }, w.minusSeconds = function(i) {
        return this.plusSeconds(-1 * E.intMod(i, b.SECONDS_PER_DAY));
      }, w.minusNanos = function(i) {
        return this.plusNanos(-1 * E.intMod(i, b.NANOS_PER_DAY));
      }, w.query = function(i) {
        return s(i, "query"), i === q.precision() ? le.NANOS : i === q.localTime() ? this : i === q.chronology() || i === q.zoneId() || i === q.zone() || i === q.offset() || i === q.localDate() ? null : i.queryFrom(this);
      }, w.adjustInto = function(i) {
        return i.with(b.NANO_OF_DAY, this.toNanoOfDay());
      }, w.until = function(i, x) {
        if (s(i, "endExclusive"), s(x, "unit"), i = b.from(i), x instanceof le) {
          switch (i = i.toNanoOfDay() - this.toNanoOfDay(), x) {
            case le.NANOS:
              return i;
            case le.MICROS:
              return E.intDiv(i, 1e3);
            case le.MILLIS:
              return E.intDiv(i, 1e6);
            case le.SECONDS:
              return E.intDiv(i, b.NANOS_PER_SECOND);
            case le.MINUTES:
              return E.intDiv(i, b.NANOS_PER_MINUTE);
            case le.HOURS:
              return E.intDiv(i, b.NANOS_PER_HOUR);
            case le.HALF_DAYS:
              return E.intDiv(i, 12 * b.NANOS_PER_HOUR);
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.between(this, i);
      }, w.atDate = function(i) {
        return Pl.of(i, this);
      }, w.toSecondOfDay = function() {
        var i = this._hour * b.SECONDS_PER_HOUR;
        return i += this._minute * b.SECONDS_PER_MINUTE, i += this._second;
      }, w.toNanoOfDay = function() {
        var i = this._hour * b.NANOS_PER_HOUR;
        return i += this._minute * b.NANOS_PER_MINUTE, i += this._second * b.NANOS_PER_SECOND, i += this._nano;
      }, w.compareTo = function(i) {
        s(
          i,
          "other"
        ), d(i, b, "other");
        var x = E.compareNumbers(this._hour, i._hour);
        return x === 0 && (x = E.compareNumbers(this._minute, i._minute), x === 0 && (x = E.compareNumbers(this._second, i._second), x === 0 && (x = E.compareNumbers(this._nano, i._nano)))), x;
      }, w.isAfter = function(i) {
        return 0 < this.compareTo(i);
      }, w.isBefore = function(i) {
        return 0 > this.compareTo(i);
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this._hour === i._hour && this._minute === i._minute && this._second === i._second && this._nano === i._nano : !1;
      }, w.hashCode = function() {
        var i = this.toNanoOfDay();
        return E.hash(i);
      }, w.toString = function() {
        var i = this._hour, x = this._minute, X = this._second, He = this._nano;
        return i = (10 > i ? "0" : "") + i + (10 > x ? ":0" : ":") + x, (0 < X || 0 < He) && (i += 10 > X ? ":0" : ":", i += X, 0 < He && (i += ".", i = E.intMod(He, 1e6) === 0 ? i + ("" + (E.intDiv(He, 1e6) + 1e3)).substring(1) : E.intMod(He, 1e3) === 0 ? i + ("" + (E.intDiv(He, 1e3) + 1e6)).substring(1) : i + ("" + (He + 1e9)).substring(1))), i;
      }, w.toJSON = function() {
        return this.toString();
      }, w.format = function(i) {
        return s(i, "formatter"), i.format(this);
      }, b;
    }(jt);
    Fn.HOURS_PER_DAY = 24, Fn.MINUTES_PER_HOUR = 60, Fn.MINUTES_PER_DAY = Fn.MINUTES_PER_HOUR * Fn.HOURS_PER_DAY, Fn.SECONDS_PER_MINUTE = 60, Fn.SECONDS_PER_HOUR = Fn.SECONDS_PER_MINUTE * Fn.MINUTES_PER_HOUR, Fn.SECONDS_PER_DAY = Fn.SECONDS_PER_HOUR * Fn.HOURS_PER_DAY, Fn.MILLIS_PER_DAY = 1e3 * Fn.SECONDS_PER_DAY, Fn.MICROS_PER_DAY = 1e6 * Fn.SECONDS_PER_DAY, Fn.NANOS_PER_SECOND = 1e9, Fn.NANOS_PER_MINUTE = Fn.NANOS_PER_SECOND * Fn.SECONDS_PER_MINUTE, Fn.NANOS_PER_HOUR = Fn.NANOS_PER_MINUTE * Fn.MINUTES_PER_HOUR, Fn.NANOS_PER_DAY = Fn.NANOS_PER_HOUR * Fn.HOURS_PER_DAY;
    var br = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return b._validate(i, x), X._seconds = E.safeToInt(i), X._nanos = E.safeToInt(x), X;
      }
      o(b, be), b.now = function(i) {
        return i === void 0 && (i = Wn.systemUTC()), i.instant();
      }, b.ofEpochSecond = function(i, x) {
        return x === void 0 && (x = 0), i += E.floorDiv(x, Fn.NANOS_PER_SECOND), x = E.floorMod(x, Fn.NANOS_PER_SECOND), b._create(i, x);
      }, b.ofEpochMilli = function(i) {
        var x = E.floorDiv(i, 1e3);
        return i = E.floorMod(i, 1e3), b._create(x, 1e6 * i);
      }, b.from = function(i) {
        try {
          var x = i.getLong(B.INSTANT_SECONDS), X = i.get(B.NANO_OF_SECOND);
          return b.ofEpochSecond(x, X);
        } catch (He) {
          throw new L("Unable to obtain Instant from TemporalAccessor: " + i + ", type " + typeof i, He);
        }
      }, b.parse = function(i) {
        return De.ISO_INSTANT.parse(i, b.FROM);
      }, b._create = function(i, x) {
        return i === 0 && x === 0 ? b.EPOCH : new b(i, x);
      }, b._validate = function(i, x) {
        if (i < b.MIN_SECONDS || i > b.MAX_SECONDS) throw new L("Instant exceeds minimum or maximum instant");
        if (0 > x || x > Fn.NANOS_PER_SECOND) throw new L("Instant exceeds minimum or maximum instant");
      };
      var w = b.prototype;
      return w.isSupported = function(i) {
        return i instanceof B ? i === B.INSTANT_SECONDS || i === B.NANO_OF_SECOND || i === B.MICRO_OF_SECOND || i === B.MILLI_OF_SECOND : i instanceof le ? i.isTimeBased() || i === le.DAYS : i != null && i.isSupportedBy(this);
      }, w.range = function(i) {
        return be.prototype.range.call(this, i);
      }, w.get = function(i) {
        return this.getLong(i);
      }, w.getLong = function(i) {
        if (i instanceof B) {
          switch (i) {
            case B.NANO_OF_SECOND:
              return this._nanos;
            case B.MICRO_OF_SECOND:
              return E.intDiv(this._nanos, 1e3);
            case B.MILLI_OF_SECOND:
              return E.intDiv(
                this._nanos,
                1e6
              );
            case B.INSTANT_SECONDS:
              return this._seconds;
          }
          throw new J("Unsupported field: " + i);
        }
        return i.getFrom(this);
      }, w.epochSecond = function() {
        return this._seconds;
      }, w.nano = function() {
        return this._nanos;
      }, w.withAdjuster = function(i) {
        return s(i, "adjuster"), i.adjustInto(this);
      }, w.withFieldValue = function(i, x) {
        if (s(i, "field"), i instanceof B) {
          switch (i.checkValidValue(x), i) {
            case B.MILLI_OF_SECOND:
              return i = 1e6 * x, i !== this._nanos ? b._create(this._seconds, i) : this;
            case B.MICRO_OF_SECOND:
              return i = 1e3 * x, i !== this._nanos ? b._create(this._seconds, i) : this;
            case B.NANO_OF_SECOND:
              return x !== this._nanos ? b._create(this._seconds, x) : this;
            case B.INSTANT_SECONDS:
              return x !== this._seconds ? b._create(x, this._nanos) : this;
          }
          throw new J("Unsupported field: " + i);
        }
        return i.adjustInto(this, x);
      }, w.truncatedTo = function(i) {
        if (s(i, "unit"), i === le.NANOS) return this;
        if (i = i.duration(), i.seconds() > Fn.SECONDS_PER_DAY) throw new L("Unit is too large to be used for truncation");
        var x = i.toNanos();
        if (E.intMod(Fn.NANOS_PER_DAY, x) !== 0) throw new L("Unit must divide into a standard day without remainder");
        return i = E.intMod(this._seconds, Fn.SECONDS_PER_DAY) * Fn.NANOS_PER_SECOND + this._nanos, x *= E.intDiv(i, x), this.plusNanos(x - i);
      }, w.plusAmount = function(i) {
        return s(i, "amount"), i.addTo(this);
      }, w.plusAmountUnit = function(i, x) {
        if (s(i, "amountToAdd"), s(x, "unit"), d(x, H), x instanceof le) {
          switch (x) {
            case le.NANOS:
              return this.plusNanos(i);
            case le.MICROS:
              return this._plus(E.intDiv(i, 1e6), 1e3 * E.intMod(i, 1e6));
            case le.MILLIS:
              return this.plusMillis(i);
            case le.SECONDS:
              return this.plusSeconds(i);
            case le.MINUTES:
              return this.plusSeconds(E.safeMultiply(
                i,
                Fn.SECONDS_PER_MINUTE
              ));
            case le.HOURS:
              return this.plusSeconds(E.safeMultiply(i, Fn.SECONDS_PER_HOUR));
            case le.HALF_DAYS:
              return this.plusSeconds(E.safeMultiply(i, Fn.SECONDS_PER_DAY / 2));
            case le.DAYS:
              return this.plusSeconds(E.safeMultiply(i, Fn.SECONDS_PER_DAY));
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.addTo(this, i);
      }, w.plusSeconds = function(i) {
        return this._plus(i, 0);
      }, w.plusMillis = function(i) {
        return this._plus(E.intDiv(i, 1e3), 1e6 * E.intMod(i, 1e3));
      }, w.plusNanos = function(i) {
        return this._plus(0, i);
      }, w._plus = function(i, x) {
        return i === 0 && x === 0 ? this : (i = this._seconds + i, i += E.intDiv(x, Fn.NANOS_PER_SECOND), b.ofEpochSecond(i, this._nanos + x % Fn.NANOS_PER_SECOND));
      }, w.minusAmount = function(i) {
        return s(i, "amount"), i.subtractFrom(this);
      }, w.minusAmountUnit = function(i, x) {
        return this.plusAmountUnit(-1 * i, x);
      }, w.minusSeconds = function(i) {
        return this.plusSeconds(-1 * i);
      }, w.minusMillis = function(i) {
        return this.plusMillis(-1 * i);
      }, w.minusNanos = function(i) {
        return this.plusNanos(-1 * i);
      }, w.query = function(i) {
        return s(i, "query"), i === q.precision() ? le.NANOS : i === q.localDate() || i === q.localTime() || i === q.chronology() || i === q.zoneId() || i === q.zone() || i === q.offset() ? null : i.queryFrom(this);
      }, w.adjustInto = function(i) {
        return s(i, "temporal"), i.with(B.INSTANT_SECONDS, this._seconds).with(B.NANO_OF_SECOND, this._nanos);
      }, w.until = function(i, x) {
        if (s(i, "endExclusive"), s(x, "unit"), i = b.from(i), x instanceof le) {
          switch (x) {
            case le.NANOS:
              return this._nanosUntil(i);
            case le.MICROS:
              return E.intDiv(this._nanosUntil(i), 1e3);
            case le.MILLIS:
              return E.safeSubtract(
                i.toEpochMilli(),
                this.toEpochMilli()
              );
            case le.SECONDS:
              return this._secondsUntil(i);
            case le.MINUTES:
              return E.intDiv(this._secondsUntil(i), Fn.SECONDS_PER_MINUTE);
            case le.HOURS:
              return E.intDiv(this._secondsUntil(i), Fn.SECONDS_PER_HOUR);
            case le.HALF_DAYS:
              return E.intDiv(this._secondsUntil(i), 12 * Fn.SECONDS_PER_HOUR);
            case le.DAYS:
              return E.intDiv(this._secondsUntil(i), Fn.SECONDS_PER_DAY);
          }
          throw new J("Unsupported unit: " + x);
        }
        return x.between(this, i);
      }, w._nanosUntil = function(i) {
        var x = E.safeSubtract(i.epochSecond(), this.epochSecond());
        return x = E.safeMultiply(x, Fn.NANOS_PER_SECOND), E.safeAdd(x, i.nano() - this.nano());
      }, w._secondsUntil = function(i) {
        var x = E.safeSubtract(i.epochSecond(), this.epochSecond());
        return i = i.nano() - this.nano(), 0 < x && 0 > i ? x-- : 0 > x && 0 < i && x++, x;
      }, w.atOffset = function(i) {
        return ht.ofInstant(this, i);
      }, w.atZone = function(i) {
        return Zn.ofInstant(this, i);
      }, w.toEpochMilli = function() {
        return E.safeMultiply(this._seconds, 1e3) + E.intDiv(this._nanos, 1e6);
      }, w.compareTo = function(i) {
        s(i, "otherInstant"), d(i, b, "otherInstant");
        var x = E.compareNumbers(
          this._seconds,
          i._seconds
        );
        return x !== 0 ? x : this._nanos - i._nanos;
      }, w.isAfter = function(i) {
        return 0 < this.compareTo(i);
      }, w.isBefore = function(i) {
        return 0 > this.compareTo(i);
      }, w.equals = function(i) {
        return this === i ? !0 : i instanceof b ? this.epochSecond() === i.epochSecond() && this.nano() === i.nano() : !1;
      }, w.hashCode = function() {
        return E.hashCode(this._seconds, this._nanos);
      }, w.toString = function() {
        return De.ISO_INSTANT.format(this);
      }, w.toJSON = function() {
        return this.toString();
      }, b;
    }(jt), Wn = function() {
      function be() {
      }
      be.systemUTC = function() {
        return new cs(ot.UTC);
      }, be.systemDefaultZone = function() {
        return new cs(Ve.systemDefault());
      }, be.system = function(w) {
        return new cs(w);
      }, be.fixed = function(w, i) {
        return new Ds(w, i);
      }, be.offset = function(w, i) {
        return new ac(w, i);
      };
      var b = be.prototype;
      return b.millis = function() {
        p("Clock.millis");
      }, b.instant = function() {
        p("Clock.instant");
      }, b.zone = function() {
        p("Clock.zone");
      }, b.withZone = function() {
        p("Clock.withZone");
      }, be;
    }(), cs = function(be) {
      function b(i) {
        s(i, "zone");
        var x = be.call(this) || this;
        return x._zone = i, x;
      }
      o(b, be);
      var w = b.prototype;
      return w.zone = function() {
        return this._zone;
      }, w.millis = function() {
        return (/* @__PURE__ */ new Date()).getTime();
      }, w.instant = function() {
        return br.ofEpochMilli(this.millis());
      }, w.equals = function(i) {
        return i instanceof b ? this._zone.equals(i._zone) : !1;
      }, w.withZone = function(i) {
        return i.equals(this._zone) ? this : new b(i);
      }, w.toString = function() {
        return "SystemClock[" + this._zone.toString() + "]";
      }, b;
    }(Wn), Ds = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return X._instant = i, X._zoneId = x, X;
      }
      o(b, be);
      var w = b.prototype;
      return w.instant = function() {
        return this._instant;
      }, w.millis = function() {
        return this._instant.toEpochMilli();
      }, w.zone = function() {
        return this._zoneId;
      }, w.toString = function() {
        return "FixedClock[]";
      }, w.equals = function(i) {
        return i instanceof b ? this._instant.equals(i._instant) && this._zoneId.equals(i._zoneId) : !1;
      }, w.withZone = function(i) {
        return i.equals(this._zoneId) ? this : new b(this._instant, i);
      }, b;
    }(Wn), ac = function(be) {
      function b(i, x) {
        var X = be.call(this) || this;
        return X._baseClock = i, X._offset = x, X;
      }
      o(b, be);
      var w = b.prototype;
      return w.zone = function() {
        return this._baseClock.zone();
      }, w.withZone = function(i) {
        return i.equals(this._baseClock.zone()) ? this : new b(this._baseClock.withZone(i), this._offset);
      }, w.millis = function() {
        return this._baseClock.millis() + this._offset.toMillis();
      }, w.instant = function() {
        return this._baseClock.instant().plus(this._offset);
      }, w.equals = function(i) {
        return i instanceof b ? this._baseClock.equals(i._baseClock) && this._offset.equals(i._offset) : !1;
      }, w.toString = function() {
        return "OffsetClock[" + this._baseClock + "," + this._offset + "]";
      }, b;
    }(Wn), Hs = function() {
      function be(w, i, x) {
        if (s(w, "transition"), s(i, "offsetBefore"), s(x, "offsetAfter"), i.equals(x)) throw new ce("Offsets must not be equal");
        if (w.nano() !== 0) throw new ce("Nano-of-second must be zero");
        this._transition = w instanceof Pl ? w : Pl.ofEpochSecond(w, 0, i), this._offsetBefore = i, this._offsetAfter = x;
      }
      be.of = function(w, i, x) {
        return new be(w, i, x);
      };
      var b = be.prototype;
      return b.instant = function() {
        return this._transition.toInstant(this._offsetBefore);
      }, b.toEpochSecond = function() {
        return this._transition.toEpochSecond(this._offsetBefore);
      }, b.dateTimeBefore = function() {
        return this._transition;
      }, b.dateTimeAfter = function() {
        return this._transition.plusSeconds(this.durationSeconds());
      }, b.offsetBefore = function() {
        return this._offsetBefore;
      }, b.offsetAfter = function() {
        return this._offsetAfter;
      }, b.duration = function() {
        return U.ofSeconds(this.durationSeconds());
      }, b.durationSeconds = function() {
        return this._offsetAfter.totalSeconds() - this._offsetBefore.totalSeconds();
      }, b.isGap = function() {
        return this._offsetAfter.totalSeconds() > this._offsetBefore.totalSeconds();
      }, b.isOverlap = function() {
        return this._offsetAfter.totalSeconds() < this._offsetBefore.totalSeconds();
      }, b.isValidOffset = function(w) {
        return this.isGap() ? !1 : this._offsetBefore.equals(w) || this._offsetAfter.equals(w);
      }, b.validOffsets = function() {
        return this.isGap() ? [] : [this._offsetBefore, this._offsetAfter];
      }, b.compareTo = function(w) {
        return this.instant().compareTo(w.instant());
      }, b.equals = function(w) {
        return w === this ? !0 : w instanceof be ? this._transition.equals(w._transition) && this._offsetBefore.equals(w.offsetBefore()) && this._offsetAfter.equals(w.offsetAfter()) : !1;
      }, b.hashCode = function() {
        return this._transition.hashCode() ^ this._offsetBefore.hashCode() ^ this._offsetAfter.hashCode() >>> 16;
      }, b.toString = function() {
        return "Transition[" + (this.isGap() ? "Gap" : "Overlap") + " at " + this._transition.toString() + this._offsetBefore.toString() + " to " + this._offsetAfter + "]";
      }, be;
    }(), vu = function(be) {
      function b() {
        return be.apply(this, arguments) || this;
      }
      o(b, be);
      var w = b.prototype;
      return w.isFixedOffset = function() {
        return !1;
      }, w.offsetOfInstant = function(i) {
        return i = new Date(i.toEpochMilli()).getTimezoneOffset(), ot.ofTotalMinutes(-1 * i);
      }, w.offsetOfEpochMilli = function(i) {
        return i = new Date(i).getTimezoneOffset(), ot.ofTotalMinutes(-1 * i);
      }, w.offsetOfLocalDateTime = function(i) {
        i = 1e3 * i.toEpochSecond(ot.UTC);
        var x = new Date(i).getTimezoneOffset();
        return i = new Date(i + 6e4 * x).getTimezoneOffset(), ot.ofTotalMinutes(-1 * i);
      }, w.validOffsets = function(i) {
        return [this.offsetOfLocalDateTime(i)];
      }, w.transition = function() {
        return null;
      }, w.standardOffset = function(i) {
        return this.offsetOfInstant(i);
      }, w.daylightSavings = function() {
        this._throwNotSupported();
      }, w.isDaylightSavings = function() {
        this._throwNotSupported();
      }, w.isValidOffset = function(i, x) {
        return this.offsetOfLocalDateTime(i).equals(x);
      }, w.nextTransition = function() {
        this._throwNotSupported();
      }, w.previousTransition = function() {
        this._throwNotSupported();
      }, w.transitions = function() {
        this._throwNotSupported();
      }, w.transitionRules = function() {
        this._throwNotSupported();
      }, w._throwNotSupported = function() {
        throw new L("not supported operation");
      }, w.equals = function(i) {
        return this === i || i instanceof b;
      }, w.toString = function() {
        return "SYSTEM";
      }, b;
    }(an), Ji = function(be) {
      function b() {
        var i = be.call(this) || this;
        return i._rules = new vu(), i;
      }
      o(b, be);
      var w = b.prototype;
      return w.rules = function() {
        return this._rules;
      }, w.equals = function(i) {
        return this === i;
      }, w.id = function() {
        return "SYSTEM";
      }, b;
    }(Ve), hs = function() {
      function be() {
      }
      return be.systemDefault = function() {
        return li;
      }, be.getAvailableZoneIds = function() {
        return Un.getAvailableZoneIds();
      }, be.of = function(b) {
        if (s(b, "zoneId"), b === "Z") return ot.UTC;
        if (b.length === 1) throw new L("Invalid zone: " + b);
        if (_e.startsWith(b, "+") || _e.startsWith(b, "-")) return ot.of(b);
        if (b === "UTC" || b === "GMT" || b === "GMT0" || b === "UT") return new Pe(b, ot.UTC.rules());
        if (_e.startsWith(b, "UTC+") || _e.startsWith(b, "GMT+") || _e.startsWith(b, "UTC-") || _e.startsWith(b, "GMT-")) {
          var w = ot.of(b.substring(3));
          return w.totalSeconds() === 0 ? new Pe(b.substring(0, 3), w.rules()) : new Pe(b.substring(0, 3) + w.id(), w.rules());
        }
        return _e.startsWith(b, "UT+") || _e.startsWith(b, "UT-") ? (b = ot.of(b.substring(2)), b.totalSeconds() === 0 ? new Pe("UT", b.rules()) : new Pe("UT" + b.id(), b.rules())) : b === "SYSTEM" ? Ve.systemDefault() : Pe.ofId(b);
      }, be.ofOffset = function(b, w) {
        if (s(b, "prefix"), s(w, "offset"), b.length === 0) return w;
        if (b === "GMT" || b === "UTC" || b === "UT") return w.totalSeconds() === 0 ? new Pe(b, w.rules()) : new Pe(b + w.id(), w.rules());
        throw new ce("Invalid prefix, must be GMT, UTC or UT: " + b);
      }, be.from = function(b) {
        s(b, "temporal");
        var w = b.query(q.zone());
        if (w == null) throw new L("Unable to obtain ZoneId from TemporalAccessor: " + b + ", type " + (b.constructor != null ? b.constructor.name : ""));
        return w;
      }, be;
    }(), li = null, cc = !1;
    if (!cc) {
      cc = !0, Me.MIN_VALUE = -999999, Me.MAX_VALUE = 999999, U.ZERO = new U(0, 0), le.NANOS = new le("Nanos", U.ofNanos(1)), le.MICROS = new le("Micros", U.ofNanos(1e3)), le.MILLIS = new le("Millis", U.ofNanos(1e6)), le.SECONDS = new le("Seconds", U.ofSeconds(1)), le.MINUTES = new le("Minutes", U.ofSeconds(60)), le.HOURS = new le("Hours", U.ofSeconds(3600)), le.HALF_DAYS = new le("HalfDays", U.ofSeconds(43200)), le.DAYS = new le("Days", U.ofSeconds(86400)), le.WEEKS = new le("Weeks", U.ofSeconds(604800)), le.MONTHS = new le(
        "Months",
        U.ofSeconds(2629746)
      ), le.YEARS = new le("Years", U.ofSeconds(31556952)), le.DECADES = new le("Decades", U.ofSeconds(315569520)), le.CENTURIES = new le("Centuries", U.ofSeconds(3155695200)), le.MILLENNIA = new le("Millennia", U.ofSeconds(31556952e3)), le.ERAS = new le("Eras", U.ofSeconds(31556952 * (Me.MAX_VALUE + 1))), le.FOREVER = new le("Forever", U.ofSeconds(E.MAX_SAFE_INTEGER, 999999999)), B.NANO_OF_SECOND = new B("NanoOfSecond", le.NANOS, le.SECONDS, Ye.of(0, 999999999)), B.NANO_OF_DAY = new B("NanoOfDay", le.NANOS, le.DAYS, Ye.of(0, 864e11 - 1)), B.MICRO_OF_SECOND = new B("MicroOfSecond", le.MICROS, le.SECONDS, Ye.of(0, 999999)), B.MICRO_OF_DAY = new B("MicroOfDay", le.MICROS, le.DAYS, Ye.of(0, 864e8 - 1)), B.MILLI_OF_SECOND = new B("MilliOfSecond", le.MILLIS, le.SECONDS, Ye.of(0, 999)), B.MILLI_OF_DAY = new B("MilliOfDay", le.MILLIS, le.DAYS, Ye.of(0, 86399999)), B.SECOND_OF_MINUTE = new B("SecondOfMinute", le.SECONDS, le.MINUTES, Ye.of(0, 59)), B.SECOND_OF_DAY = new B("SecondOfDay", le.SECONDS, le.DAYS, Ye.of(0, 86399)), B.MINUTE_OF_HOUR = new B("MinuteOfHour", le.MINUTES, le.HOURS, Ye.of(0, 59)), B.MINUTE_OF_DAY = new B("MinuteOfDay", le.MINUTES, le.DAYS, Ye.of(0, 1439)), B.HOUR_OF_AMPM = new B("HourOfAmPm", le.HOURS, le.HALF_DAYS, Ye.of(0, 11)), B.CLOCK_HOUR_OF_AMPM = new B("ClockHourOfAmPm", le.HOURS, le.HALF_DAYS, Ye.of(1, 12)), B.HOUR_OF_DAY = new B("HourOfDay", le.HOURS, le.DAYS, Ye.of(0, 23)), B.CLOCK_HOUR_OF_DAY = new B("ClockHourOfDay", le.HOURS, le.DAYS, Ye.of(1, 24)), B.AMPM_OF_DAY = new B("AmPmOfDay", le.HALF_DAYS, le.DAYS, Ye.of(0, 1)), B.DAY_OF_WEEK = new B("DayOfWeek", le.DAYS, le.WEEKS, Ye.of(1, 7)), B.ALIGNED_DAY_OF_WEEK_IN_MONTH = new B(
        "AlignedDayOfWeekInMonth",
        le.DAYS,
        le.WEEKS,
        Ye.of(1, 7)
      ), B.ALIGNED_DAY_OF_WEEK_IN_YEAR = new B("AlignedDayOfWeekInYear", le.DAYS, le.WEEKS, Ye.of(1, 7)), B.DAY_OF_MONTH = new B("DayOfMonth", le.DAYS, le.MONTHS, Ye.of(1, 28, 31), "day"), B.DAY_OF_YEAR = new B("DayOfYear", le.DAYS, le.YEARS, Ye.of(1, 365, 366)), B.EPOCH_DAY = new B("EpochDay", le.DAYS, le.FOREVER, Ye.of(Math.floor(365.25 * Me.MIN_VALUE), Math.floor(365.25 * Me.MAX_VALUE))), B.ALIGNED_WEEK_OF_MONTH = new B("AlignedWeekOfMonth", le.WEEKS, le.MONTHS, Ye.of(1, 4, 5)), B.ALIGNED_WEEK_OF_YEAR = new B(
        "AlignedWeekOfYear",
        le.WEEKS,
        le.YEARS,
        Ye.of(1, 53)
      ), B.MONTH_OF_YEAR = new B("MonthOfYear", le.MONTHS, le.YEARS, Ye.of(1, 12), "month"), B.PROLEPTIC_MONTH = new B("ProlepticMonth", le.MONTHS, le.FOREVER, Ye.of(12 * Me.MIN_VALUE, 12 * Me.MAX_VALUE + 11)), B.YEAR_OF_ERA = new B("YearOfEra", le.YEARS, le.FOREVER, Ye.of(1, Me.MAX_VALUE, Me.MAX_VALUE + 1)), B.YEAR = new B("Year", le.YEARS, le.FOREVER, Ye.of(Me.MIN_VALUE, Me.MAX_VALUE), "year"), B.ERA = new B("Era", le.ERAS, le.FOREVER, Ye.of(0, 1)), B.INSTANT_SECONDS = new B("InstantSeconds", le.SECONDS, le.FOREVER, Ye.of(
        -9007199254740991,
        9007199254740991
      )), B.OFFSET_SECONDS = new B("OffsetSeconds", le.SECONDS, le.FOREVER, Ye.of(-64800, 64800)), function() {
        Fn.HOURS = [];
        for (var be = 0; 24 > be; be++) Fn.of(be, 0, 0, 0);
        Fn.MIN = Fn.HOURS[0], Fn.MAX = new Fn(23, 59, 59, 999999999), Fn.MIDNIGHT = Fn.HOURS[0], Fn.NOON = Fn.HOURS[12], Fn.FROM = _("LocalTime.FROM", function(b) {
          return Fn.from(b);
        });
      }(), function() {
        tl = new Rr(), Zt = new ql(), Ql = new Mr(), jl = new wi(), Sl = new bl("WeekBasedYears", U.ofSeconds(31556952)), gl = new bl("QuarterYears", U.ofSeconds(7889238)), St.DAY_OF_QUARTER = tl, St.QUARTER_OF_YEAR = Zt, St.WEEK_OF_WEEK_BASED_YEAR = Ql, St.WEEK_BASED_YEAR = jl, St.WEEK_BASED_YEARS = Sl, St.QUARTER_YEARS = gl, ct.prototype.isoWeekOfWeekyear = function() {
          return this.get(St.WEEK_OF_WEEK_BASED_YEAR);
        }, ct.prototype.isoWeekyear = function() {
          return this.get(St.WEEK_BASED_YEAR);
        };
      }(), function() {
        q.ZONE_ID = _("ZONE_ID", function(be) {
          return be.query(q.ZONE_ID);
        }), q.CHRONO = _("CHRONO", function(be) {
          return be.query(q.CHRONO);
        }), q.PRECISION = _("PRECISION", function(be) {
          return be.query(q.PRECISION);
        }), q.OFFSET = _("OFFSET", function(be) {
          return be.isSupported(B.OFFSET_SECONDS) ? ot.ofTotalSeconds(be.get(B.OFFSET_SECONDS)) : null;
        }), q.ZONE = _("ZONE", function(be) {
          var b = be.query(q.ZONE_ID);
          return b ?? be.query(q.OFFSET);
        }), q.LOCAL_DATE = _("LOCAL_DATE", function(be) {
          return be.isSupported(B.EPOCH_DAY) ? ct.ofEpochDay(be.getLong(B.EPOCH_DAY)) : null;
        }), q.LOCAL_TIME = _("LOCAL_TIME", function(be) {
          return be.isSupported(B.NANO_OF_DAY) ? Fn.ofNanoOfDay(be.getLong(B.NANO_OF_DAY)) : null;
        });
      }(), function() {
        Fe.MONDAY = new Fe(0, "MONDAY"), Fe.TUESDAY = new Fe(1, "TUESDAY"), Fe.WEDNESDAY = new Fe(2, "WEDNESDAY"), Fe.THURSDAY = new Fe(3, "THURSDAY"), Fe.FRIDAY = new Fe(4, "FRIDAY"), Fe.SATURDAY = new Fe(5, "SATURDAY"), Fe.SUNDAY = new Fe(6, "SUNDAY"), Fe.FROM = _("DayOfWeek.FROM", function(be) {
          return Fe.from(be);
        }), ln = [Fe.MONDAY, Fe.TUESDAY, Fe.WEDNESDAY, Fe.THURSDAY, Fe.FRIDAY, Fe.SATURDAY, Fe.SUNDAY];
      }(), function() {
        br.MIN_SECONDS = -31619119219200, br.MAX_SECONDS = 31494816403199, br.EPOCH = new br(0, 0), br.MIN = br.ofEpochSecond(br.MIN_SECONDS, 0), br.MAX = br.ofEpochSecond(br.MAX_SECONDS, 999999999), br.FROM = _("Instant.FROM", function(be) {
          return br.from(be);
        });
      }(), function() {
        ct.MIN = ct.of(Me.MIN_VALUE, 1, 1), ct.MAX = ct.of(Me.MAX_VALUE, 12, 31), ct.EPOCH_0 = ct.ofEpochDay(0), ct.FROM = _("LocalDate.FROM", function(be) {
          return ct.from(be);
        });
      }(), function() {
        Pl.MIN = Pl.of(ct.MIN, Fn.MIN), Pl.MAX = Pl.of(ct.MAX, Fn.MAX), Pl.FROM = _("LocalDateTime.FROM", function(be) {
          return Pl.from(be);
        });
      }(), function() {
        gt.MIN_VALUE = Me.MIN_VALUE, gt.MAX_VALUE = Me.MAX_VALUE, Gt = new Y().appendValue(B.YEAR, 4, 10, Kt.EXCEEDS_PAD).toFormatter(), gt.FROM = _("Year.FROM", function(be) {
          return gt.from(be);
        });
      }(), Be.JANUARY = new Be(1, "JANUARY"), Be.FEBRUARY = new Be(2, "FEBRUARY"), Be.MARCH = new Be(3, "MARCH"), Be.APRIL = new Be(4, "APRIL"), Be.MAY = new Be(5, "MAY"), Be.JUNE = new Be(6, "JUNE"), Be.JULY = new Be(7, "JULY"), Be.AUGUST = new Be(8, "AUGUST"), Be.SEPTEMBER = new Be(9, "SEPTEMBER"), Be.OCTOBER = new Be(10, "OCTOBER"), Be.NOVEMBER = new Be(11, "NOVEMBER"), Be.DECEMBER = new Be(12, "DECEMBER");
      var eu = [Be.JANUARY, Be.FEBRUARY, Be.MARCH, Be.APRIL, Be.MAY, Be.JUNE, Be.JULY, Be.AUGUST, Be.SEPTEMBER, Be.OCTOBER, Be.NOVEMBER, Be.DECEMBER];
      (function() {
        ft = new Y().appendValue(
          B.YEAR,
          4,
          10,
          Kt.EXCEEDS_PAD
        ).appendLiteral("-").appendValue(B.MONTH_OF_YEAR, 2).toFormatter(), Tn.FROM = _("YearMonth.FROM", function(be) {
          return Tn.from(be);
        });
      })(), function() {
        gn = new Y().appendLiteral("--").appendValue(B.MONTH_OF_YEAR, 2).appendLiteral("-").appendValue(B.DAY_OF_MONTH, 2).toFormatter(), un.FROM = _("MonthDay.FROM", function(be) {
          return un.from(be);
        });
      }(), pn.ofDays(0), ot.MAX_SECONDS = 18 * Fn.SECONDS_PER_HOUR, ot.UTC = ot.ofTotalSeconds(0), ot.MIN = ot.ofTotalSeconds(-ot.MAX_SECONDS), ot.MAX = ot.ofTotalSeconds(ot.MAX_SECONDS), function() {
        Zn.FROM = _("ZonedDateTime.FROM", function(be) {
          return Zn.from(be);
        });
      }(), li = new Ji(), Ve.systemDefault = hs.systemDefault, Ve.getAvailableZoneIds = hs.getAvailableZoneIds, Ve.of = hs.of, Ve.ofOffset = hs.ofOffset, Ve.from = hs.from, ot.from = hs.from, Ve.SYSTEM = li, Ve.UTC = ot.ofTotalSeconds(0), ze.INSTANCE = new ze("IsoChronology"), function() {
        De.ISO_LOCAL_DATE = new Y().appendValue(B.YEAR, 4, 10, Kt.EXCEEDS_PAD).appendLiteral("-").appendValue(B.MONTH_OF_YEAR, 2).appendLiteral("-").appendValue(B.DAY_OF_MONTH, 2).toFormatter(at.STRICT).withChronology(ze.INSTANCE), De.ISO_LOCAL_TIME = new Y().appendValue(B.HOUR_OF_DAY, 2).appendLiteral(":").appendValue(B.MINUTE_OF_HOUR, 2).optionalStart().appendLiteral(":").appendValue(B.SECOND_OF_MINUTE, 2).optionalStart().appendFraction(B.NANO_OF_SECOND, 0, 9, !0).toFormatter(at.STRICT), De.ISO_LOCAL_DATE_TIME = new Y().parseCaseInsensitive().append(De.ISO_LOCAL_DATE).appendLiteral("T").append(De.ISO_LOCAL_TIME).toFormatter(at.STRICT).withChronology(ze.INSTANCE), De.ISO_INSTANT = new Y().parseCaseInsensitive().appendInstant().toFormatter(at.STRICT), De.ISO_OFFSET_DATE_TIME = new Y().parseCaseInsensitive().append(De.ISO_LOCAL_DATE_TIME).appendOffsetId().toFormatter(at.STRICT).withChronology(ze.INSTANCE), De.ISO_ZONED_DATE_TIME = new Y().append(De.ISO_OFFSET_DATE_TIME).optionalStart().appendLiteral("[").parseCaseSensitive().appendZoneId().appendLiteral("]").toFormatter(at.STRICT).withChronology(ze.INSTANCE), De.BASIC_ISO_DATE = new Y().appendValue(B.YEAR, 4, 10, Kt.EXCEEDS_PAD).appendValue(B.MONTH_OF_YEAR, 2).appendValue(B.DAY_OF_MONTH, 2).toFormatter(at.STRICT).withChronology(ze.INSTANCE), De.ISO_OFFSET_DATE = new Y().parseCaseInsensitive().append(De.ISO_LOCAL_DATE).appendOffsetId().toFormatter(at.STRICT).withChronology(ze.INSTANCE), De.ISO_OFFSET_TIME = new Y().parseCaseInsensitive().append(De.ISO_LOCAL_TIME).appendOffsetId().toFormatter(at.STRICT).withChronology(ze.INSTANCE), De.ISO_ORDINAL_DATE = new Y().appendValue(B.YEAR, 4, 10, Kt.EXCEEDS_PAD).appendLiteral("-").appendValue(B.DAY_OF_YEAR).toFormatter(at.STRICT), De.ISO_WEEK_DATE = new Y().appendValue(B.YEAR, 4, 10, Kt.EXCEEDS_PAD).appendLiteral("-W").appendValue(B.ALIGNED_WEEK_OF_YEAR).appendLiteral("-").appendValue(B.DAY_OF_WEEK).toFormatter(at.STRICT), De.PARSED_EXCESS_DAYS = _("PARSED_EXCESS_DAYS", function(be) {
          return be instanceof Nt ? be.excessDays : pn.ZERO;
        }), De.PARSED_LEAP_SECOND = _("PARSED_LEAP_SECOND", function(be) {
          return be instanceof Nt ? be.leapSecond : !1;
        });
      }(), Se.BASE_DATE = ct.of(2e3, 1, 1), Y.CompositePrinterParser = ii, Y.PadPrinterParserDecorator = Ge, Y.SettingsParser = vn, Y.CharLiteralPrinterParser = Kn, Y.StringLiteralPrinterParser = Kn, Y.CharLiteralPrinterParser = Pr, Y.NumberPrinterParser = Rl, Y.ReducedPrinterParser = Se, Y.FractionPrinterParser = Ar, Y.OffsetIdPrinterParser = Ee, Y.ZoneIdPrinterParser = C, function() {
        ht.MIN = Pl.MIN.atOffset(ot.MAX), ht.MAX = Pl.MAX.atOffset(ot.MIN), ht.FROM = _("OffsetDateTime.FROM", function(be) {
          return ht.from(be);
        });
      }(), function() {
        dn.MIN = dn.ofNumbers(0, 0, 0, 0, ot.MAX), dn.MAX = dn.ofNumbers(23, 59, 59, 999999999, ot.MIN), dn.FROM = _("OffsetTime.FROM", function(be) {
          return dn.from(be);
        });
      }();
    }
    var $a = function() {
      function be(w, i) {
        if (w instanceof ct) i = i ?? Ve.systemDefault(), w = w.atStartOfDay(i);
        else if (w instanceof Pl) i = i ?? Ve.systemDefault(), w = w.atZone(i);
        else if (w instanceof Zn) w = i == null ? w : w.withZoneSameInstant(i);
        else throw new ce("unsupported instance for convert operation:" + w);
        this.instant = w.toInstant();
      }
      var b = be.prototype;
      return b.toDate = function() {
        return new Date(this.instant.toEpochMilli());
      }, b.toEpochMilli = function() {
        return this.instant.toEpochMilli();
      }, be;
    }(), oa = function(be) {
      function b(i, x) {
        x === void 0 && (x = Ve.systemDefault());
        var X = be.call(this) || this;
        return X._zone = x, i instanceof Date ? (X._epochMilli = i.getTime(), a(X)) : typeof i.toDate == "function" && i.toDate() instanceof Date ? (X._epochMilli = i.toDate().getTime(), a(X)) : (h(!1, "date must be either a javascript date or a moment"), X);
      }
      o(b, be);
      var w = b.prototype;
      return w.query = function(i) {
        return s(i, "query"), i === q.localDate() ? ct.ofInstant(br.ofEpochMilli(this._epochMilli), this._zone) : i === q.localTime() ? Fn.ofInstant(br.ofEpochMilli(this._epochMilli), this._zone) : i === q.zone() ? this._zone : be.prototype.query.call(this, i);
      }, w.get = function(i) {
        return this.getLong(i);
      }, w.getLong = function(i) {
        if (s(i, "field"), i instanceof B) {
          switch (i) {
            case B.NANO_OF_SECOND:
              return 1e6 * E.floorMod(this._epochMilli, 1e3);
            case B.INSTANT_SECONDS:
              return E.floorDiv(this._epochMilli, 1e3);
          }
          throw new J("Unsupported field: " + i);
        }
        return i.getFrom(this);
      }, w.isSupported = function(i) {
        return i === B.INSTANT_SECONDS || i === B.NANO_OF_SECOND;
      }, b;
    }(me), hc = { assert: je, DateTimeBuilder: Nt, DateTimeParseContext: zt, DateTimePrintContext: ol, MathUtil: E, StringUtil: _e, StringBuilder: ke }, aa = {
      _: hc,
      convert: R,
      nativeJs: F,
      ArithmeticException: we,
      DateTimeException: L,
      DateTimeParseException: G,
      IllegalArgumentException: ce,
      IllegalStateException: xe,
      UnsupportedTemporalTypeException: J,
      NullPointerException: $e,
      Clock: Wn,
      DayOfWeek: Fe,
      Duration: U,
      Instant: br,
      LocalDate: ct,
      LocalTime: Fn,
      LocalDateTime: Pl,
      OffsetTime: dn,
      OffsetDateTime: ht,
      Month: Be,
      MonthDay: un,
      Period: pn,
      Year: gt,
      YearConstants: Me,
      YearMonth: Tn,
      ZonedDateTime: Zn,
      ZoneOffset: ot,
      ZoneId: Ve,
      ZoneRegion: Pe,
      ZoneOffsetTransition: Hs,
      ZoneRules: an,
      ZoneRulesProvider: Un,
      ChronoLocalDate: fn,
      ChronoLocalDateTime: Hl,
      ChronoZonedDateTime: ut,
      IsoChronology: ze,
      ChronoField: B,
      ChronoUnit: le,
      IsoFields: St,
      Temporal: jt,
      TemporalAccessor: me,
      TemporalAdjuster: Yt,
      TemporalAdjusters: zl,
      TemporalAmount: K,
      TemporalField: Ce,
      TemporalQueries: q,
      TemporalQuery: Ae,
      TemporalUnit: H,
      ValueRange: Ye,
      DateTimeFormatter: De,
      DateTimeFormatterBuilder: Y,
      DecimalStyle: jr,
      ResolverStyle: at,
      SignStyle: Kt,
      TextStyle: nl
    }, Eo = /* @__PURE__ */ function(be) {
      var b = [];
      return function(w) {
        return ~b.indexOf(w) || (w(be), b.push(w)), be;
      };
    }(aa);
    aa.use = Eo, r.ArithmeticException = we, r.ChronoField = B, r.ChronoLocalDate = fn, r.ChronoLocalDateTime = Hl, r.ChronoUnit = le, r.ChronoZonedDateTime = ut, r.Clock = Wn, r.DateTimeException = L, r.DateTimeFormatter = De, r.DateTimeFormatterBuilder = Y, r.DateTimeParseException = G, r.DayOfWeek = Fe, r.DecimalStyle = jr, r.Duration = U, r.IllegalArgumentException = ce, r.IllegalStateException = xe, r.Instant = br, r.IsoChronology = ze, r.IsoFields = St, r.LocalDate = ct, r.LocalDateTime = Pl, r.LocalTime = Fn, r.Month = Be, r.MonthDay = un, r.NullPointerException = $e, r.OffsetDateTime = ht, r.OffsetTime = dn, r.Period = pn, r.ResolverStyle = at, r.SignStyle = Kt, r.Temporal = jt, r.TemporalAccessor = me, r.TemporalAdjuster = Yt, r.TemporalAdjusters = zl, r.TemporalAmount = K, r.TemporalField = Ce, r.TemporalQueries = q, r.TemporalQuery = Ae, r.TemporalUnit = H, r.TextStyle = nl, r.UnsupportedTemporalTypeException = J, r.ValueRange = Ye, r.Year = gt, r.YearConstants = Me, r.YearMonth = Tn, r.ZoneId = Ve, r.ZoneOffset = ot, r.ZoneOffsetTransition = Hs, r.ZoneRegion = Pe, r.ZoneRules = an, r.ZoneRulesProvider = Un, r.ZonedDateTime = Zn, r._ = hc, r.convert = R, r.nativeJs = F, r.use = Eo, Object.defineProperty(r, "__esModule", { value: !0 });
  });
};
var A, Qz = function(e, n) {
  e = e.split(".");
  var t = cZ;
  e[0] in t || typeof t.execScript > "u" || t.execScript("var " + e[0]);
  for (var l; e.length && (l = e.shift()); ) e.length || n === void 0 ? t = t[l] && t[l] !== Object.prototype[l] ? t[l] : t[l] = {} : t[l] = n;
}, $t = function(e) {
  var n = typeof e;
  return n != "object" ? n : e ? Array.isArray(e) ? "array" : n : "null";
}, pL = function(e) {
  return Object.prototype.hasOwnProperty.call(e, HA) && e[HA] || (e[HA] = ++$me);
}, Jz = function(e, n) {
  function t() {
  }
  t.prototype = n.prototype, e.Zf = n.prototype, e.prototype = new t(), e.prototype.constructor = e, e.base = function(l, r, u) {
    for (var o = Array(arguments.length - 2), a = 2; a < arguments.length; a++) o[a - 2] = arguments[a];
    return n.prototype[r].apply(l, o);
  };
}, g1 = function(e, n) {
  const t = e.length - n.length;
  return 0 <= t && e.indexOf(n, t) == t;
}, _3 = function(e) {
  const n = [];
  let t = 0;
  for (const l in e) n[t++] = l;
  return n;
}, lo = function(e, n) {
  return e !== null && n in e ? e[n] : void 0;
}, BD = function(e) {
  const n = arguments.length;
  if (n == 1 && Array.isArray(arguments[0])) return BD.apply(null, arguments[0]);
  if (n % 2) throw Error("Uneven number of arguments");
  const t = {};
  for (let l = 0; l < n; l += 2) t[arguments[l]] = arguments[l + 1];
  return t;
}, wY = function(e) {
  const n = e.length;
  if (0 < n) {
    const t = Array(n);
    for (let l = 0; l < n; l++) t[l] = e[l];
    return t;
  }
  return [];
}, bfe = function(e, n) {
  e.sort(n || hh);
}, Tfe = function(e, n) {
  const t = Array(e.length);
  for (let r = 0; r < e.length; r++) t[r] = { index: r, value: e[r] };
  const l = n || hh;
  for (bfe(t, function(r, u) {
    return l(r.value, u.value) || r.index - u.index;
  }), n = 0; n < e.length; n++) e[n] = t[n].value;
}, hh = function(e, n) {
  return e > n ? 1 : e < n ? -1 : 0;
}, Lh = function(e, n) {
  if (!Number.isFinite(e)) return String(e);
  e = String(e);
  let t = e.indexOf(".");
  t === -1 && (t = e.length);
  const l = e[0] === "-" ? "-" : "";
  return l && (e = e.substring(1)), l + _x("0", Math.max(0, n - t)) + e;
}, x3 = function(e) {
  return String(e.charAt(0)).toUpperCase() + String(e.slice(1)).toLowerCase();
}, Ts = function(e, n) {
  e != null && this.append.apply(this, arguments);
}, Rf = function() {
  return new $(null, 5, [DX, !0, c5, Lu, Db, Ys, E2e, Bu, g8, Fu], null);
}, eK = function() {
  ku = !1, Js = function() {
    var e = arguments;
    return console.log.apply(console, wY(e));
  }, fZ = function() {
    var e = arguments;
    return console.error.apply(
      console,
      wY(e)
    );
  };
}, j = function(e) {
  return e != null && e !== !1;
}, vY = function(e, n) {
  return e === n;
}, dy = function(e) {
  return e == null;
}, ra = function(e) {
  return e instanceof Array;
}, er = function(e) {
  return e == null ? !0 : e === !1;
}, nK = function(e) {
  return e != null;
}, tK = function(e) {
  return e != null ? e.constructor === Object : !1;
}, lK = function(e) {
  return typeof e == "string" && e.length === 1;
}, pl = function(e, n) {
  return e[$t(n ?? null)] ? !0 : !!e._;
}, zh = function(e) {
  return e == null ? null : e.constructor;
}, Ut = function(e, n) {
  var t = zh(n);
  return Error([
    "No protocol method ",
    e,
    " defined for type ",
    j(j(t) ? t.af : t) ? t.Hd : $t(n),
    ": ",
    n
  ].join(""));
}, rK = function(e) {
  var n = e.Hd;
  return j(n) ? n : ye.h(e);
}, ki = function(e) {
  for (var n = e.length, t = Array(n), l = 0; l < n; ) t[l] = e[l], l += 1;
  return t;
}, yY = function(e) {
  return e.length;
}, FD = function() {
}, _Y = function() {
}, VD = function() {
}, Kh = function(e) {
  if (e != null && e.$ != null) e = e.$(e);
  else {
    var n = Kh[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Kh._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("ICounted.-count", e);
  }
  return e;
}, xY = function() {
}, NO = function(e) {
  if (e != null && e.ha != null) e = e.ha(e);
  else {
    var n = NO[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = NO._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IEmptyableCollection.-empty", e);
  }
  return e;
}, SY = function() {
}, Qo = function(e, n) {
  if (e != null && e.aa != null) e = e.aa(e, n);
  else {
    var t = Qo[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = Qo._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("ICollection.-conj", e);
  }
  return e;
}, CO = function() {
}, EY = function() {
}, Er = function(e) {
  if (e != null && e.Ba != null) e = e.Ba(e);
  else {
    var n = Er[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Er._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("ISeq.-first", e);
  }
  return e;
}, Gu = function(e) {
  if (e != null && e.Fa != null) e = e.Fa(e);
  else {
    var n = Gu[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Gu._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("ISeq.-rest", e);
  }
  return e;
}, Im = function() {
}, YD = function(e) {
  if (e != null && e.Ca != null) e = e.Ca(e);
  else {
    var n = YD[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = YD._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("INext.-next", e);
  }
  return e;
}, iK = function() {
}, UD = function() {
}, MO = function(e, n) {
  if (e != null && e.gb != null) e = e.gb(e, n);
  else {
    var t = MO[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = MO._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IAssociative.-contains-key?", e);
  }
  return e;
}, Cw = function(e, n, t) {
  if (e != null && e.Aa != null) e = e.Aa(e, n, t);
  else {
    var l = Cw[$t(e ?? null)];
    if (l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else if (l = Cw._, l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else throw Ut("IAssociative.-assoc", e);
  }
  return e;
}, OY = function() {
}, PO = function(e, n) {
  if (e != null && e.Ub != null) e = e.Ub(e, n);
  else {
    var t = PO[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = PO._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IFind.-find", e);
  }
  return e;
}, kY = function() {
}, $O = function(e, n) {
  if (e != null && e.sb != null) e = e.sb(e, n);
  else {
    var t = $O[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = $O._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IMap.-dissoc", e);
  }
  return e;
}, Xa = function(e) {
  if (e != null && e.xd != null) e = e.key;
  else {
    var n = Xa[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Xa._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IMapEntry.-key", e);
  }
  return e;
}, Cc = function(e) {
  if (e != null && e.yd != null) e = e.val;
  else {
    var n = Cc[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Cc._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IMapEntry.-val", e);
  }
  return e;
}, bY = function() {
}, qD = function(e, n) {
  if (e != null && e.Ad != null) e = e.Ad(e, n);
  else {
    var t = qD[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = qD._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("ISet.-disjoin", e);
  }
  return e;
}, WD = function(e) {
  if (e != null && e.Xb != null) e = e.Xb(e);
  else {
    var n = WD[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = WD._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut(
      "IStack.-peek",
      e
    );
  }
  return e;
}, HD = function(e) {
  if (e != null && e.Yb != null) e = e.Yb(e);
  else {
    var n = HD[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = HD._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IStack.-pop", e);
  }
  return e;
}, TY = function() {
}, zD = function(e, n, t) {
  if (e != null && e.Cb != null) e = e.Cb(e, n, t);
  else {
    var l = zD[$t(e ?? null)];
    if (l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else if (l = zD._, l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else throw Ut("IVector.-assoc-n", e);
  }
  return e;
}, __ = function() {
}, sn = function(e) {
  if (e != null && e.jb != null) e = e.jb(e);
  else {
    var n = sn[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = sn._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IDeref.-deref", e);
  }
  return e;
}, KD = function() {
}, LO = function(e) {
  if (e != null && e.U != null) e = e.U(e);
  else {
    var n = LO[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = LO._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IMeta.-meta", e);
  }
  return e;
}, jY = function() {
}, su = function(e, n) {
  if (e != null && e.Z != null) e = e.Z(e, n);
  else {
    var t = su[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = su._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IWithMeta.-with-meta", e);
  }
  return e;
}, uK = function() {
}, AY = function() {
}, GD = function(e, n, t) {
  if (e != null && e.nb != null) e = e.nb(e, n, t);
  else {
    var l = GD[$t(e ?? null)];
    if (l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else if (l = GD._, l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else throw Ut("IKVReduce.-kv-reduce", e);
  }
  return e;
}, py = function(e, n) {
  if (e != null && e.N != null) e = e.N(e, n);
  else {
    var t = py[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = py._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IEquiv.-equiv", e);
  }
  return e;
}, BO = function(e) {
  if (e != null && e.O != null) e = e.O(e);
  else {
    var n = BO[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = BO._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IHash.-hash", e);
  }
  return e;
}, ZD = function() {
}, tx = function(e) {
  if (e != null && e.W != null) e = e.W(e);
  else {
    var n = tx[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = tx._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("ISeqable.-seq", e);
  }
  return e;
}, DY = function() {
}, IY = function() {
}, dm = function() {
}, RY = function() {
}, lx = function(e) {
  if (e != null && e.Wb != null) e = e.Wb(e);
  else {
    var n = lx[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = lx._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IReversible.-rseq", e);
  }
  return e;
}, NY = function() {
}, rx = function(e, n) {
  if (e != null && e.Dd != null) e = e.Dd(e, n);
  else {
    var t = rx[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = rx._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("ISorted.-sorted-seq", e);
  }
  return e;
}, Mw = function(e, n, t) {
  if (e != null && e.Ed != null) e = e.Ed(e, n, t);
  else {
    var l = Mw[$t(e ?? null)];
    if (l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else if (l = Mw._, l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else throw Ut("ISorted.-sorted-seq-from", e);
  }
  return e;
}, XD = function(e, n) {
  if (e != null && e.Cd != null) e = e.Cd(e, n);
  else {
    var t = XD[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = XD._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("ISorted.-entry-key", e);
  }
  return e;
}, FO = function(e) {
  if (e != null && e.Bd != null) e = e.Bd(e);
  else {
    var n = FO[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = FO._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("ISorted.-comparator", e);
  }
  return e;
}, Br = function(e, n) {
  if (e != null && e.qe != null) e = e.qe(e, n);
  else {
    var t = Br[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = Br._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IWriter.-write", e);
  }
  return e;
}, CY = function() {
}, VO = function(e, n, t) {
  if (e != null && e.R != null) e = e.R(e, n, t);
  else {
    var l = VO[$t(e ?? null)];
    if (l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else if (l = VO._, l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else throw Ut("IPrintWithWriter.-pr-writer", e);
  }
  return e;
}, QD = function(e) {
  if (e != null && e.Ac != null) e = e.Ac(e);
  else {
    var n = QD[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = QD._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IPending.-realized?", e);
  }
  return e;
}, JD = function(e, n, t) {
  if (e != null && e.oe != null) e.oe(e, n, t);
  else {
    var l = JD[$t(e ?? null)];
    if (l != null) l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else if (l = JD._, l != null) l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else throw Ut("IWatchable.-add-watch", e);
  }
}, eI = function(e, n) {
  if (e != null && e.pe != null) e.pe(e, n);
  else {
    var t = eI[$t(e ?? null)];
    if (t != null) t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = eI._, t != null) t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut(
      "IWatchable.-remove-watch",
      e
    );
  }
}, ou = function(e) {
  if (e != null && e.xc != null) e = e.xc(e);
  else {
    var n = ou[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = ou._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IEditableCollection.-as-transient", e);
  }
  return e;
}, Rm = function(e, n) {
  if (e != null && e.Cc != null) e = e.Cc(e, n);
  else {
    var t = Rm[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = Rm._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("ITransientCollection.-conj!", e);
  }
  return e;
}, gu = function(e) {
  if (e != null && e.Oc != null) e = e.Oc(e);
  else {
    var n = gu[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = gu._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("ITransientCollection.-persistent!", e);
  }
  return e;
}, Pw = function(e, n, t) {
  if (e != null && e.Bc != null) e = e.Bc(e, n, t);
  else {
    var l = Pw[$t(e ?? null)];
    if (l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else if (l = Pw._, l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else throw Ut("ITransientAssociative.-assoc!", e);
  }
  return e;
}, YO = function(e, n) {
  if (e != null && e.Fd != null) e = e.Fd(e, n);
  else {
    var t = YO[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = YO._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("ITransientMap.-dissoc!", e);
  }
  return e;
}, nI = function(e) {
  if (e != null && e.me != null) e = e.me(e);
  else {
    var n = nI[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = nI._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("ITransientVector.-pop!", e);
  }
  return e;
}, UO = function(e, n) {
  if (e != null && e.le != null) e = e.le(e, n);
  else {
    var t = UO[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = UO._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("ITransientSet.-disjoin!", e);
  }
  return e;
}, MY = function() {
}, tI = function(e, n) {
  if (e != null && e.Ua != null) e = e.Ua(e, n);
  else {
    var t = tI[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = tI._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IComparable.-compare", e);
  }
  return e;
}, qO = function(e) {
  if (e != null && e.vd != null) e = e.vd(e);
  else {
    var n = qO[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = qO._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IChunk.-drop-first", e);
  }
  return e;
}, Jr = function(e) {
  if (e != null && e.Mc != null) e = e.Mc(e);
  else {
    var n = Jr[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Jr._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IChunkedSeq.-chunked-first", e);
  }
  return e;
}, Wr = function(e) {
  if (e != null && e.ic != null) e = e.ic(e);
  else {
    var n = Wr[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Wr._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IChunkedSeq.-chunked-rest", e);
  }
  return e;
}, lI = function(e) {
  if (e != null && e.yc != null) e = e.yc(e);
  else {
    var n = lI[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = lI._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("INamed.-name", e);
  }
  return e;
}, rI = function(e) {
  if (e != null && e.zc != null) e = e.zc(e);
  else {
    var n = rI[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = rI._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut(
      "INamed.-namespace",
      e
    );
  }
  return e;
}, x_ = function() {
}, iI = function(e, n) {
  if (e != null && e.Ue != null) e = e.Ue(e, n);
  else {
    var t = iI[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = iI._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IReset.-reset!", e);
  }
  return e;
}, S_ = function() {
}, Yu = function(e, n) {
  if (e != null && e.Nb != null) e = e.Nb(e, n);
  else {
    var t = Yu[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = Yu._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IVolatile.-vreset!", e);
  }
  return e;
}, PY = function() {
}, eo = function(e) {
  if (e != null && e.Xa != null) e = e.Xa(e);
  else {
    var n = eo[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = eo._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IIterable.-iterator", e);
  }
  return e;
}, mL = function(e) {
  this.hf = e, this.C = 1073741824, this.J = 0;
}, Ui = function(e) {
  var n = new Ts();
  return e.R(null, new mL(n), Rf()), ye.h(n);
}, $w = function(e) {
  return e = Ym(e | 0, -862048943), Ym(e << 15 | e >>> -15, 461845907);
}, r2 = function(e, n) {
  return e = (e | 0) ^ (n | 0), Ym(e << 13 | e >>> -13, 5) + -430675100 | 0;
}, i2 = function(e, n) {
  return e = (e | 0) ^ n, e = Ym(e ^ e >>> 16, -2048144789), e = Ym(e ^ e >>> 13, -1028477387), e ^ e >>> 16;
}, sK = function(e) {
  if (255 < GA && (KA = {}, GA = 0), e == null) return 0;
  var n = KA[e];
  if (typeof n == "number") e = n;
  else {
    e: if (e != null) if (n = e.length, 0 < n) for (var t = 0, l = 0; ; ) if (t < n) l = Ym(31, l) + e.charCodeAt(t), t += 1;
    else {
      n = l;
      break e;
    }
    else n = 0;
    else n = 0;
    KA[e] = n, GA += 1, e = n;
  }
  return e;
}, Uu = function(e) {
  if (e != null && (e.C & 4194304 || Rn === e.mb)) return e.O(null) ^ 0;
  if (typeof e == "number") {
    if (isFinite(e)) return Math.floor(e) % 2147483647;
    switch (e) {
      case 1 / 0:
        return 2146435072;
      case -1 / 0:
        return -1048576;
      default:
        return 2146959360;
    }
  } else return e === !0 ? e = 1231 : e === !1 ? e = 1237 : typeof e == "string" ? (e = sK(e), e = e === 0 ? e : i2(r2(0, $w(e)), 4)) : e = e instanceof Date ? e.valueOf() ^ 0 : e == null ? 0 : BO(e) ^ 0, e;
}, oK = function(e, n) {
  return e ^ n + 2654435769 + (e << 6) + (e >> 2);
}, jp = function(e) {
  return e instanceof T;
}, gL = function(e) {
  var n = e.name;
  e:
    for (var t = 1, l = 0; ; ) if (t < n.length) l = r2(l, $w(n.charCodeAt(t - 1) | n.charCodeAt(t) << 16)), t += 2;
    else {
      t = l;
      break e;
    }
  return oK(i2((n.length & 1) === 1 ? t ^ $w(n.charCodeAt(n.length - 1)) : t, Ym(2, n.length)), sK(e.ns));
}, jfe = function(e, n) {
  if (e.Qb === n.Qb) return 0;
  var t = er(e.ns);
  return j(t && n.ns) ? -1 : j(e.ns) ? er(n.ns) ? 1 : (t = hh(e.ns, n.ns), t === 0 ? hh(e.name, n.name) : t) : hh(e.name, n.name);
}, T = function(e, n, t, l, r) {
  this.ns = e, this.name = n, this.Qb = t, this.wc = l, this.zb = r, this.C = 2154168321, this.J = 4096;
}, Jn = function(e, n, t) {
  this.val = e, this.Rb = n, this.zb = t, this.C = 6717441, this.J = 0;
}, wL = function(e) {
  return e != null ? e.J & 131072 || Rn === e.Pf ? !0 : e.J ? !1 : pl(PY, e) : pl(PY, e);
}, z = function(e) {
  if (e == null) return null;
  if (e != null && (e.C & 8388608 || Rn === e.je)) return e.W(null);
  if (ra(e) || typeof e == "string") return e.length === 0 ? null : new hn(e, 0, null);
  if (e != null && e[Li] != null) return e = lo(e, Li).call(e), Dv.h ? Dv.h(e) : Dv.call(null, e);
  if (pl(ZD, e)) return tx(e);
  throw Error([ye.h(e), " is not ISeqable"].join(""));
}, I = function(e) {
  return e == null ? null : e != null && (e.C & 64 || Rn === e.V) ? e.Ba(null) : (e = z(e), e == null ? null : Er(e));
}, tn = function(e) {
  return e != null && (e != null && (e.C & 64 || Rn === e.V) || (e = z(e))) ? e.Fa(null) : fl;
}, W = function(e) {
  return e == null ? null : e != null && (e.C & 128 || Rn === e.Nc) ? e.Ca(null) : z(tn(e));
}, aK = function(e) {
  this.X = e;
}, ti = function(e) {
  return new aK(z(e));
}, u2 = function(e, n) {
  this.value = e, this.iter = n, this.sd = null, this.C = 8388672, this.J = 0;
}, Dv = function(e) {
  var n = e.next();
  return j(n.done) ? null : new u2(n.value, e);
}, qu = function(e) {
  var n = 0, t = 1;
  for (e = z(e); ; ) if (e != null) n += 1, t = Ym(31, t) + Uu(I(e)) | 0, e = W(e);
  else return i2(r2(0, $w(t)), n);
}, Na = function(e) {
  var n = 0, t = 0;
  for (e = z(e); ; ) if (e != null) n += 1, t = t + Uu(I(e)) | 0, e = W(e);
  else return i2(r2(
    0,
    $w(t)
  ), n);
}, $Y = function() {
}, uI = function(e) {
  if (e != null && e.re != null) e = e.re(e);
  else {
    var n = uI[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = uI._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("Inst.inst-ms*", e);
  }
  return e;
}, Lw = function(e) {
  return e + 1;
}, vL = function(e) {
  this.val = e, this.C = 32768, this.J = 0;
}, xh = function(e) {
  return new vL(e);
}, ni = function(e) {
  return e instanceof vL;
}, cK = function(e) {
  return ni(e) ? e : xh(e);
}, S3 = function(e) {
  return ni(e) ? gA.h ? gA.h(e) : gA.call(null, e) : e;
}, gA = function(e) {
  return sn(e);
}, E3 = function(e, n) {
  var t = e.$(null);
  if (t === 0) return n.o ? n.o() : n.call(null);
  for (var l = e.Y(null, 0), r = 1; ; ) if (r < t) {
    var u = e.Y(null, r);
    if (l = n.g ? n.g(l, u) : n.call(null, l, u), ni(l)) return sn(l);
    r += 1;
  } else return l;
}, E4 = function(e, n, t) {
  var l = e.$(null), r = t;
  for (t = 0; ; ) if (t < l) {
    var u = e.Y(null, t);
    if (r = n.g ? n.g(r, u) : n.call(null, r, u), ni(r)) return sn(r);
    t += 1;
  } else return r;
}, LY = function(e, n) {
  var t = e.length;
  if (e.length === 0) return n.o ? n.o() : n.call(null);
  for (var l = e[0], r = 1; ; ) if (r < t) {
    var u = e[r];
    if (l = n.g ? n.g(l, u) : n.call(null, l, u), ni(l)) return sn(l);
    r += 1;
  } else return l;
}, BY = function(e, n, t) {
  var l = e.length, r = t;
  for (t = 0; ; ) if (t < l) {
    var u = e[t];
    if (r = n.g ? n.g(r, u) : n.call(null, r, u), ni(r)) return sn(r);
    t += 1;
  } else return r;
}, O4 = function(e, n, t, l) {
  for (var r = e.length; ; ) if (l < r) {
    var u = e[l];
    if (t = n.g ? n.g(t, u) : n.call(null, t, u), ni(t)) return sn(t);
    l += 1;
  } else return t;
}, ix = function(e) {
  return e != null ? e.C & 2 || Rn === e.Je ? !0 : e.C ? !1 : pl(VD, e) : pl(VD, e);
}, yL = function(e) {
  return e != null ? e.C & 16 || Rn === e.be ? !0 : e.C ? !1 : pl(CO, e) : pl(CO, e);
}, Ht = function(e, n, t) {
  var l = Cn.h ? Cn.h(e) : Cn.call(null, e);
  if (t >= l) return -1;
  for (!(0 < t) && 0 > t && (t += l, t = 0 > t ? 0 : t); ; ) if (t < l) {
    if (on.g(O.g ? O.g(e, t) : O.call(null, e, t), n)) return t;
    t += 1;
  } else return -1;
}, xl = function(e, n, t) {
  var l = Cn.h ? Cn.h(e) : Cn.call(null, e);
  if (l === 0) return -1;
  for (0 < t ? (--l, t = l < t ? l : t) : t = 0 > t ? l + t : t; ; ) if (0 <= t) {
    if (on.g(O.g ? O.g(e, t) : O.call(null, e, t), n)) return t;
    --t;
  } else return -1;
}, _L = function(e, n) {
  this.A = e, this.i = n;
}, hn = function(e, n, t) {
  this.A = e, this.i = n, this.meta = t, this.C = 166592766, this.J = 139264;
}, Te = function(e) {
  return 0 < e.length ? new hn(e, 0, null) : null;
}, Qf = function(e, n, t) {
  this.cd = e, this.i = n, this.meta = t, this.C = 32374990, this.J = 8192;
}, Vr = function(e) {
  return I(W(e));
}, hK = function(e) {
  return I(I(e));
}, va = function(e) {
  return W(W(e));
}, ho = function(e) {
  for (; ; ) {
    var n = W(e);
    if (n != null) e = n;
    else return I(e);
  }
}, O3 = function(e) {
  return e == null ? null : e != null && (e.C & 4 || Rn === e.Me) ? e.ha(null) : (e != null ? e.C & 4 || Rn === e.Me || !e.C && pl(xY, e) : pl(xY, e)) ? NO(e) : null;
}, Cn = function(e) {
  if (e != null) if (e != null && (e.C & 2 || Rn === e.Je)) e = e.$(null);
  else if (ra(e)) e = e.length;
  else if (typeof e == "string") e = e.length;
  else if (e != null && (e.C & 8388608 || Rn === e.je)) e: {
    e = z(e);
    for (var n = 0; ; ) {
      if (ix(e)) {
        e = n + Kh(e);
        break e;
      }
      e = W(e), n += 1;
    }
  }
  else e = Kh(e);
  else e = 0;
  return e;
}, Afe = function(e, n, t) {
  for (; ; ) {
    if (e == null) return t;
    if (n === 0) return z(e) ? I(e) : t;
    if (yL(e)) return Ul(e, n, t);
    if (z(e)) e = W(e), --n;
    else return t;
  }
}, Bw = function(e) {
  var n = typeof e == "function";
  return n || (e != null ? Rn === e.$d ? !0 : e.Pc ? !1 : pl(FD, e) : pl(FD, e));
}, xL = function(e, n) {
  this.afn = e, this.meta = n, this.C = 393217, this.J = 0;
}, Bl = function(e, n) {
  return typeof e == "function" ? new xL(e, n) : e == null ? null : su(
    e,
    n
  );
}, Vt = function(e) {
  var n = e != null;
  return n && (e != null ? e.C & 131072 || Rn === e.zd || !e.C && pl(KD, e) : pl(KD, e)) ? LO(e) : null;
}, WO = function(e) {
  return e == null ? null : WD(e);
}, my = function(e) {
  return e == null ? null : HD(e);
}, Ca = function(e) {
  return e == null || er(z(e));
}, w1 = function(e) {
  return e == null ? !1 : e != null ? e.C & 8 || Rn === e.Mf ? !0 : e.C ? !1 : pl(SY, e) : pl(SY, e);
}, ug = function(e) {
  return e == null ? !1 : e != null ? e.C & 4096 || Rn === e.Vf ? !0 : e.C ? !1 : pl(bY, e) : pl(bY, e);
}, fK = function(e) {
  return e != null ? e.C & 512 || Rn === e.ae ? !0 : e.C ? !1 : pl(UD, e) : pl(UD, e);
}, Fw = function(e) {
  return e != null ? e.C & 16777216 || Rn === e.ke ? !0 : e.C ? !1 : pl(DY, e) : pl(DY, e);
}, ci = function(e) {
  return e == null ? !1 : e != null ? e.C & 1024 || Rn === e.Sf ? !0 : e.C ? !1 : pl(kY, e) : pl(kY, e);
}, Ap = function(e) {
  return e != null ? e.C & 67108864 || Rn === e.Re ? !0 : e.C ? !1 : pl(dm, e) : pl(dm, e);
}, or = function(e) {
  return e != null ? e.C & 16384 || Rn === e.Xf ? !0 : e.C ? !1 : pl(TY, e) : pl(TY, e);
}, oi = function(e) {
  return e != null ? !!(e.J & 512 || Rn === e.Lf) : !1;
}, ec = function(e, n, t, l, r) {
  for (; ; ) {
    if (r === 0) return t;
    t[l] = e[n], l += 1, --r, n += 1;
  }
}, dK = function(e) {
  return e === !0;
}, SL = function(e) {
  return e === !0 || e === !1;
}, ei = function(e) {
  return e == null ? !1 : e != null ? e.C & 64 || Rn === e.V ? !0 : e.C ? !1 : pl(EY, e) : pl(EY, e);
}, pK = function(e) {
  var n = e == null;
  return n || ((n = e != null ? e.C & 8388608 || Rn === e.je ? !0 : e.C ? !1 : pl(ZD, e) : pl(ZD, e)) ? n : ra(e) || typeof e == "string");
}, pu = function(e) {
  return e == null ? !1 : e !== !1;
}, za = function(e) {
  return typeof e == "number" && !isNaN(e) && e !== 1 / 0 && parseFloat(e) === parseInt(e, 10);
}, mK = function(e) {
  return za(e) ? !(0 > e) : !1;
}, Ol = function(e, n) {
  return e != null && (e.C & 512 || Rn === e.ae) ? e.gb(null, n) : pl(UD, e) ? MO(e, n) : en.j(
    e,
    n,
    Da
  ) !== Da;
}, oh = function(e, n) {
  return (e != null ? Rn === e.jc || !e.Pc && pl(OY, e) : pl(OY, e)) ? PO(e, n) : e != null && fK(e) && Ol(e, n) ? new yl(n, en.g(e, n)) : null;
}, Gh = function(e, n) {
  if (e === n) return 0;
  if (e == null) return -1;
  if (n == null) return 1;
  if (typeof e == "number") {
    if (typeof n == "number") return hh(e, n);
    throw Error(["Cannot compare ", ye.h(e), " to ", ye.h(n)].join(""));
  }
  if (e != null ? e.J & 2048 || Rn === e.Za || !e.J && pl(MY, e) : pl(MY, e)) return tI(e, n);
  if (typeof e != "string" && !ra(e) && e !== !0 && e !== !1 || zh(e) !== zh(n)) throw Error([
    "Cannot compare ",
    ye.h(e),
    " to ",
    ye.h(n)
  ].join(""));
  return hh(e, n);
}, k3 = function(e, n) {
  var t = Cn(e), l = Cn(n);
  if (t < l) e = -1;
  else if (t > l) e = 1;
  else if (t === 0) e = 0;
  else e: for (l = 0; ; ) {
    var r = Gh(O.g(e, l), O.g(n, l));
    if (r === 0 && l + 1 < t) l += 1;
    else {
      e = r;
      break e;
    }
  }
  return e;
}, EL = function(e) {
  return on.g(e, Gh) ? Gh : function(n, t) {
    var l = e.g ? e.g(n, t) : e.call(null, n, t);
    return typeof l == "number" ? l : j(l) ? -1 : j(e.g ? e.g(t, n) : e.call(null, t, n)) ? 1 : 0;
  };
}, gK = function(e) {
  switch (arguments.length) {
    case 2:
      return ja(arguments[0], arguments[1]);
    case 3:
      return nc(
        arguments[0],
        arguments[1],
        arguments[2]
      );
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
}, ja = function(e, n) {
  var t = z(n);
  return t ? (n = I(t), t = W(t), wt.j ? wt.j(e, n, t) : wt.call(null, e, n, t)) : e.o ? e.o() : e.call(null);
}, nc = function(e, n, t) {
  for (t = z(t); ; ) if (t) {
    var l = I(t);
    if (n = e.g ? e.g(n, l) : e.call(null, n, l), ni(n)) return sn(n);
    t = W(t);
  } else return n;
}, wK = function(e, n) {
  if (e = eo(e), j(e.ja())) for (var t = e.next(); ; ) if (e.ja()) {
    var l = e.next();
    if (t = n.g ? n.g(t, l) : n.call(null, t, l), ni(t)) return sn(t);
  } else return t;
  else return n.o ? n.o() : n.call(null);
}, vK = function(e, n, t) {
  for (e = eo(e); ; ) if (e.ja()) {
    var l = e.next();
    if (t = n.g ? n.g(t, l) : n.call(null, t, l), ni(t)) return sn(t);
  } else return t;
}, Jf = function(e, n, t) {
  return t != null ? GD(t, e, n) : n;
}, No = function(e) {
  return e;
}, FY = function(e) {
  return e - 1;
}, VY = function(e) {
  return e;
}, gy = function(e) {
  if (typeof e == "number") return String.fromCharCode(e);
  if (typeof e == "string" && e.length === 1) return e;
  throw Error("Argument to char must be a character or number");
}, YY = function(e) {
  return e;
}, UY = function(e) {
  return e;
}, qY = function(e) {
  return e;
}, WY = function(e) {
  return e;
}, HY = function(e) {
  return e;
}, zY = function(e) {
  return e;
}, KY = function(e) {
  return e;
}, GY = function(e) {
  return e;
}, ZY = function(e) {
  return e - 1;
}, XY = function(e) {
  return e - 1;
}, QY = function(e) {
  return e + 1;
}, JY = function(e) {
  return e + 1;
}, eU = function(e) {
  return -e;
}, nU = function(e) {
  return -e;
}, tU = function(e, n) {
  return ya.g ? ya.g(e, n) : ya.call(null, e, n);
}, s2 = function(e) {
  return 0 <= e ? Math.floor(e) : Math.ceil(e);
}, lU = function(e) {
  return e | 0;
}, rU = function(e) {
  return s2(e);
}, iU = function(e) {
  return s2(e);
}, uU = function(e) {
  return s2(e);
}, sU = function(e) {
  return e;
}, oU = function(e) {
  return e;
}, aU = function(e) {
  return e;
}, cU = function(e) {
  return e;
}, hU = function(e) {
  return e;
}, fU = function(e) {
  return e;
}, dU = function(e) {
  return e;
}, pU = function(e) {
  return e;
}, ya = function(e, n) {
  return (e % n + n) % n;
}, wy = function(e, n) {
  return s2((e - e % n) / n);
}, sI = function(e, n) {
  return e - n * wy(e, n);
}, mU = function(e) {
  return ~e;
}, gU = function(e, n) {
  return e << n;
}, wU = function(e, n) {
  return e >> n;
}, vU = function(e, n) {
  return e >>> n;
}, cp = function(e) {
  return e -= e >> 1 & 1431655765, e = (e & 858993459) + (e >> 2 & 858993459), 16843009 * (e + (e >> 4) & 252645135) >> 24;
}, yU = function(e) {
  return 0 < e;
}, _U = function(e) {
  return e === 0;
}, oI = function(e) {
  return 0 > e;
}, iu = function(e, n) {
  if (Fw(n)) if (ix(e) && ix(n) && Cn(e) !== Cn(n)) e = !1;
  else e: for (e = z(e), n = z(n); ; ) {
    if (e == null) {
      e = n == null;
      break e;
    }
    if (n != null && on.g(I(e), I(n))) e = W(e), n = W(n);
    else {
      e = !1;
      break e;
    }
  }
  else e = null;
  return pu(e);
}, g = function(e, n, t, l, r) {
  this.meta = e, this.first = n, this.rest = t, this.count = l, this.H = r, this.C = 65937646, this.J = 8192;
}, o2 = function(e) {
  return e != null ? e.C & 33554432 || Rn === e.Rf ? !0 : e.C ? !1 : pl(IY, e) : pl(IY, e);
}, a2 = function(e) {
  this.meta = e, this.C = 65937614, this.J = 8192;
}, yK = function(e) {
  return e != null ? e.C & 134217728 || Rn === e.Uf ? !0 : e.C ? !1 : pl(RY, e) : pl(RY, e);
}, OL = function(e) {
  return yK(e) ? (e = lx(e)) ? e : fl : wt.j(yt, fl, e);
}, hp = function(e, n, t, l) {
  this.meta = e, this.first = n, this.rest = t, this.H = l, this.C = 65929452, this.J = 8192;
}, kt = function(e, n) {
  return n == null ? new g(null, e, null, 1, null) : n != null && (n.C & 64 || Rn === n.V) ? new hp(null, e, n, null) : new hp(null, e, z(n), null);
}, Dfe = function(e, n) {
  if (e.ca === n.ca) return 0;
  var t = er(e.ns);
  return j(t && n.ns) ? -1 : j(e.ns) ? er(n.ns) ? 1 : (t = hh(e.ns, n.ns), t === 0 ? hh(e.name, n.name) : t) : hh(e.name, n.name);
}, de = function(e, n, t, l) {
  this.ns = e, this.name = n, this.ca = t, this.wc = l, this.C = 2153775105, this.J = 4096;
}, ux = function(e) {
  return e instanceof de;
}, Ln = function(e, n) {
  return e === n ? !0 : e instanceof de && n instanceof de ? e.ca === n.ca : !1;
}, Yi = function(e) {
  if (e != null && (e.J & 4096 || Rn === e.he)) return e.zc(null);
  throw Error(["Doesn't support namespace: ", ye.h(e)].join(""));
}, aI = function(e) {
  return e instanceof de || e instanceof T;
}, b3 = function(e) {
  return e instanceof T && Yi(e) == null;
}, iE = function(e) {
  var n = e instanceof T;
  return n ? (e = Yi(e), e = j(e) ? !0 : e) : e = n, pu(e);
}, rr = function(e, n, t, l) {
  this.meta = e, this.ka = n, this.X = t, this.H = l, this.C = 32374988, this.J = 1;
}, xU = function(e) {
  return e.ka != null && (e.X = e.ka.o ? e.ka.o() : e.ka.call(null), e.ka = null), e.X;
}, k4 = function(e) {
  this.nc = e, this.end = 0, this.C = 2, this.J = 0;
}, Sh = function(e) {
  return new k4(Array(e));
}, Vw = function(e, n, t) {
  this.A = e, this.off = n, this.end = t, this.C = 524306, this.J = 0;
}, sg = function(e, n, t, l) {
  this.chunk = e, this.Ib = n, this.meta = t, this.H = l, this.C = 31850732, this.J = 1536;
}, js = function(e, n) {
  return Kh(e) === 0 ? n : new sg(e, n, null, null);
}, T3 = function(e, n) {
  return e.add(n);
}, mo = function(e) {
  return e.chunk();
}, Sc = function(e) {
  var n = [];
  for (e = z(e); ; ) if (e != null) n.push(I(e)), e = W(e);
  else return n;
}, c2 = function(e, n) {
  if (ix(n)) return Cn(n);
  var t = 0;
  for (n = z(n); ; ) if (n != null && t < e) t += 1, n = W(n);
  else return t;
}, j3 = function(e, n, t) {
  var l = z(t);
  if (n === 0) return e.o ? e.o() : e.call(null);
  t = Er(l);
  var r = Gu(l);
  if (n === 1) return e.h ? e.h(t) : e.call(null, t);
  l = Er(r);
  var u = Gu(r);
  if (n === 2) return e.g ? e.g(t, l) : e.call(null, t, l);
  r = Er(u);
  var o = Gu(u);
  if (n === 3) return e.j ? e.j(t, l, r) : e.call(null, t, l, r);
  u = Er(o);
  var a = Gu(o);
  if (n === 4) return e.B ? e.B(t, l, r, u) : e.call(null, t, l, r, u);
  o = Er(a);
  var h = Gu(a);
  if (n === 5) return e.I ? e.I(t, l, r, u, o) : e.call(null, t, l, r, u, o);
  a = Er(h);
  var s = Gu(h);
  if (n === 6) return e.T ? e.T(t, l, r, u, o, a) : e.call(null, t, l, r, u, o, a);
  h = Er(s);
  var d = Gu(s);
  if (n === 7) return e.ba ? e.ba(t, l, r, u, o, a, h) : e.call(null, t, l, r, u, o, a, h);
  s = Er(d);
  var p = Gu(d);
  if (n === 8) return e.ia ? e.ia(t, l, r, u, o, a, h, s) : e.call(null, t, l, r, u, o, a, h, s);
  d = Er(p);
  var _ = Gu(p);
  if (n === 9) return e.va ? e.va(t, l, r, u, o, a, h, s, d) : e.call(null, t, l, r, u, o, a, h, s, d);
  p = Er(_);
  var R = Gu(_);
  if (n === 10) return e.la ? e.la(t, l, r, u, o, a, h, s, d, p) : e.call(null, t, l, r, u, o, a, h, s, d, p);
  _ = Er(R);
  var F = Gu(R);
  if (n === 11) return e.ma ? e.ma(t, l, r, u, o, a, h, s, d, p, _) : e.call(null, t, l, r, u, o, a, h, s, d, p, _);
  R = Er(F);
  var L = Gu(F);
  if (n === 12) return e.na ? e.na(t, l, r, u, o, a, h, s, d, p, _, R) : e.call(null, t, l, r, u, o, a, h, s, d, p, _, R);
  F = Er(L);
  var G = Gu(L);
  if (n === 13) return e.oa ? e.oa(t, l, r, u, o, a, h, s, d, p, _, R, F) : e.call(null, t, l, r, u, o, a, h, s, d, p, _, R, F);
  L = Er(G);
  var J = Gu(G);
  if (n === 14) return e.pa ? e.pa(t, l, r, u, o, a, h, s, d, p, _, R, F, L) : e.call(null, t, l, r, u, o, a, h, s, d, p, _, R, F, L);
  G = Er(J);
  var we = Gu(J);
  if (n === 15) return e.qa ? e.qa(t, l, r, u, o, a, h, s, d, p, _, R, F, L, G) : e.call(null, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G);
  J = Er(we);
  var ce = Gu(we);
  if (n === 16) return e.ra ? e.ra(t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J) : e.call(null, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J);
  we = Er(ce);
  var xe = Gu(ce);
  if (n === 17) return e.sa ? e.sa(
    t,
    l,
    r,
    u,
    o,
    a,
    h,
    s,
    d,
    p,
    _,
    R,
    F,
    L,
    G,
    J,
    we
  ) : e.call(null, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we);
  ce = Er(xe);
  var $e = Gu(xe);
  if (n === 18) return e.ta ? e.ta(t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce) : e.call(null, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce);
  if (xe = Er($e), $e = Gu($e), n === 19) return e.ua ? e.ua(t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe) : e.call(null, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe);
  var je = Er($e);
  if (Gu($e), n === 20) return e.Va ? e.Va(t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe, je) : e.call(
    null,
    t,
    l,
    r,
    u,
    o,
    a,
    h,
    s,
    d,
    p,
    _,
    R,
    F,
    L,
    G,
    J,
    we,
    ce,
    xe,
    je
  );
  throw Error("Only up to 20 arguments supported on functions");
}, b4 = function(e) {
  return e != null && (e.C & 128 || Rn === e.Nc) ? e.Ca(null) : z(tn(e));
}, _K = function(e, n, t) {
  return t == null ? e.h ? e.h(n) : e.call(e, n) : xK(e, n, Er(t), b4(t));
}, xK = function(e, n, t, l) {
  return l == null ? e.g ? e.g(n, t) : e.call(e, n, t) : SK(e, n, t, Er(l), b4(l));
}, SK = function(e, n, t, l, r) {
  return r == null ? e.j ? e.j(n, t, l) : e.call(e, n, t, l) : EK(e, n, t, l, Er(r), b4(r));
}, EK = function(e, n, t, l, r, u) {
  if (u == null) return e.B ? e.B(n, t, l, r) : e.call(e, n, t, l, r);
  var o = Er(u), a = W(u);
  if (a == null) return e.I ? e.I(n, t, l, r, o) : e.call(e, n, t, l, r, o);
  u = Er(a);
  var h = W(a);
  if (h == null) return e.T ? e.T(n, t, l, r, o, u) : e.call(e, n, t, l, r, o, u);
  a = Er(h);
  var s = W(h);
  if (s == null) return e.ba ? e.ba(n, t, l, r, o, u, a) : e.call(e, n, t, l, r, o, u, a);
  h = Er(s);
  var d = W(s);
  if (d == null) return e.ia ? e.ia(n, t, l, r, o, u, a, h) : e.call(e, n, t, l, r, o, u, a, h);
  s = Er(d);
  var p = W(d);
  if (p == null) return e.va ? e.va(n, t, l, r, o, u, a, h, s) : e.call(e, n, t, l, r, o, u, a, h, s);
  d = Er(p);
  var _ = W(p);
  if (_ == null) return e.la ? e.la(n, t, l, r, o, u, a, h, s, d) : e.call(
    e,
    n,
    t,
    l,
    r,
    o,
    u,
    a,
    h,
    s,
    d
  );
  p = Er(_);
  var R = W(_);
  if (R == null) return e.ma ? e.ma(n, t, l, r, o, u, a, h, s, d, p) : e.call(e, n, t, l, r, o, u, a, h, s, d, p);
  _ = Er(R);
  var F = W(R);
  if (F == null) return e.na ? e.na(n, t, l, r, o, u, a, h, s, d, p, _) : e.call(e, n, t, l, r, o, u, a, h, s, d, p, _);
  R = Er(F);
  var L = W(F);
  if (L == null) return e.oa ? e.oa(n, t, l, r, o, u, a, h, s, d, p, _, R) : e.call(e, n, t, l, r, o, u, a, h, s, d, p, _, R);
  F = Er(L);
  var G = W(L);
  if (G == null) return e.pa ? e.pa(n, t, l, r, o, u, a, h, s, d, p, _, R, F) : e.call(e, n, t, l, r, o, u, a, h, s, d, p, _, R, F);
  L = Er(G);
  var J = W(G);
  if (J == null) return e.qa ? e.qa(
    n,
    t,
    l,
    r,
    o,
    u,
    a,
    h,
    s,
    d,
    p,
    _,
    R,
    F,
    L
  ) : e.call(e, n, t, l, r, o, u, a, h, s, d, p, _, R, F, L);
  G = Er(J);
  var we = W(J);
  if (we == null) return e.ra ? e.ra(n, t, l, r, o, u, a, h, s, d, p, _, R, F, L, G) : e.call(e, n, t, l, r, o, u, a, h, s, d, p, _, R, F, L, G);
  J = Er(we);
  var ce = W(we);
  if (ce == null) return e.sa ? e.sa(n, t, l, r, o, u, a, h, s, d, p, _, R, F, L, G, J) : e.call(e, n, t, l, r, o, u, a, h, s, d, p, _, R, F, L, G, J);
  we = Er(ce);
  var xe = W(ce);
  if (xe == null) return e.ta ? e.ta(n, t, l, r, o, u, a, h, s, d, p, _, R, F, L, G, J, we) : e.call(e, n, t, l, r, o, u, a, h, s, d, p, _, R, F, L, G, J, we);
  ce = Er(xe);
  var $e = W(xe);
  if ($e == null) return e.ua ? e.ua(
    n,
    t,
    l,
    r,
    o,
    u,
    a,
    h,
    s,
    d,
    p,
    _,
    R,
    F,
    L,
    G,
    J,
    we,
    ce
  ) : e.call(e, n, t, l, r, o, u, a, h, s, d, p, _, R, F, L, G, J, we, ce);
  if (xe = Er($e), $e = W($e), $e == null) return e.Va ? e.Va(n, t, l, r, o, u, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe) : e.call(e, n, t, l, r, o, u, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe);
  for (n = [n, t, l, r, o, u, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe], t = $e; t; ) n.push(Er(t)), t = W(t);
  return e.apply(e, n);
}, fr = function(e) {
  return e != null && (e.C & 64 || Rn === e.V) ? W(e) ? Qu(Sc(e)) : z(e) ? I(e) : Tt : e;
}, Fo = function(e) {
  return z(e) ? e : null;
}, kL = function(e) {
  this.df = e, this.C = 393216, this.J = 0;
}, ed = function() {
  return new kL(Tt);
}, T4 = function(e) {
  this.X = e, this.i = 0;
}, j4 = function(e) {
  this.A = e, this.i = 0;
}, A3 = function(e) {
  this.Kc = wZ, this.hb = e;
}, HO = function(e) {
  if (wL(e)) return eo(e);
  if (e == null) return ed();
  if (typeof e == "string") return new T4(e);
  if (ra(e)) return new j4(e);
  if (pK(e)) return new A3(e);
  throw Error(["Cannot create iterator from ", ye.h(e)].join(""));
}, D3 = function(e) {
  this.qd = e;
}, I3 = function(e) {
  this.val = e;
}, R3 = function() {
}, bL = function(e) {
  this.Od = e;
}, og = function(e, n) {
  this.buffer = Vme, this.hb = Qm, this.Nd = !1, this.Mb = null, this.Td = e, this.ef = n;
}, TL = function(e, n, t) {
  var l = new og(n, t);
  return l.Mb = function() {
    var r = function() {
      function u(a, h) {
        return l.buffer = l.buffer.add(h), a;
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 0:
            return null;
          case 1:
            return a;
          case 2:
            return u.call(this, a, h);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.o = function() {
        return null;
      }, o.h = function(a) {
        return a;
      }, o.g = u, o;
    }();
    return e.h ? e.h(r) : e.call(null, r);
  }(), l;
}, hu = function(e, n) {
  for (; ; ) {
    if (z(n) == null) return !0;
    var t = I(n);
    if (t = e.h ? e.h(t) : e.call(null, t), j(t)) n = W(n);
    else return !1;
  }
}, fu = function(e, n) {
  for (; ; ) if (n = z(n)) {
    var t = I(n);
    if (t = e.h ? e.h(t) : e.call(null, t), j(t)) return t;
    n = W(n);
  } else return null;
}, qc = function(e) {
  if (za(e)) return (e & 1) === 0;
  throw Error(["Argument must be an integer: ", ye.h(e)].join(""));
}, Dp = function(e) {
  return function() {
    function n(o, a) {
      return er(e.g ? e.g(o, a) : e.call(null, o, a));
    }
    function t(o) {
      return er(e.h ? e.h(o) : e.call(null, o));
    }
    function l() {
      return er(e.o ? e.o() : e.call(null));
    }
    var r = null, u = function() {
      function o(h, s, d) {
        var p = null;
        if (2 < arguments.length) {
          p = 0;
          for (var _ = Array(arguments.length - 2); p < _.length; ) _[p] = arguments[p + 2], ++p;
          p = new hn(_, 0, null);
        }
        return a.call(this, h, s, p);
      }
      function a(h, s, d) {
        return er(In.B(e, h, s, d));
      }
      return o.m = 2, o.v = function(h) {
        var s = I(h);
        h = W(h);
        var d = I(h);
        return h = tn(h), a(s, d, h);
      }, o.l = a, o;
    }();
    return r = function(o, a, h) {
      switch (arguments.length) {
        case 0:
          return l.call(this);
        case 1:
          return t.call(this, o);
        case 2:
          return n.call(this, o, a);
        default:
          var s = null;
          if (2 < arguments.length) {
            s = 0;
            for (var d = Array(arguments.length - 2); s < d.length; ) d[s] = arguments[s + 2], ++s;
            s = new hn(d, 0, null);
          }
          return u.l(o, a, s);
      }
    }, r.m = 2, r.v = u.v, r.o = l, r.h = t, r.g = n, r.l = u.l, r;
  }();
}, v1 = function(e) {
  return function() {
    function n(t) {
      if (0 < arguments.length) for (var l = 0, r = Array(arguments.length - 0); l < r.length; ) r[l] = arguments[l + 0], ++l;
      return e;
    }
    return n.m = 0, n.v = function(t) {
      return z(t), e;
    }, n.l = function() {
      return e;
    }, n;
  }();
}, Wc = function(e, n, t) {
  this.state = e, this.meta = n, this.pf = t, this.lc = null, this.J = 16386, this.C = 6455296;
}, Qa = function(e, n) {
  if (e instanceof Wc) {
    var t = e.pf;
    if (t != null && !j(t.h ? t.h(n) : t.call(null, n))) throw Error("Validator rejected reference state");
    if (t = e.state, e.state = n, e.lc != null) e: for (var l = z(e.lc), r = null, u = 0, o = 0; ; ) if (o < u) {
      var a = r.Y(null, o), h = O.j(a, 0, null);
      a = O.j(a, 1, null), a.B ? a.B(h, e, t, n) : a.call(null, h, e, t, n), o += 1;
    } else if (l = z(l)) oi(l) ? (r = Jr(l), l = Wr(l), h = r, u = Cn(r), r = h) : (r = I(l), h = O.j(r, 0, null), a = O.j(r, 1, null), a.B ? a.B(h, e, t, n) : a.call(null, h, e, t, n), l = W(l), r = null, u = 0), o = 0;
    else break e;
    return n;
  }
  return iI(
    e,
    n
  );
}, N3 = function(e) {
  this.state = e, this.C = 32768, this.J = 0;
}, Qi = function(e) {
  return new N3(e);
}, OK = function(e, n) {
  return Yu(e, n);
}, h2 = function(e, n, t, l, r) {
  this.meta = e, this.all = n, this.prev = t, this.current = l, this.hb = r, this.C = 26083532, this.J = 1;
}, A4 = function(e) {
  if (!e.current) {
    var n = W(e.prev);
    e.current = n || e.all;
  }
  return e.current;
}, jL = function(e, n) {
  return new v(null, 2, 5, y, [Vu.g(e, n), uu.g(e, n)], null);
}, ag = function(e, n, t, l) {
  this.meta = e, this.count = n, this.val = t, this.next = l, this.H = null, this.C = 32374988, this.J = 1;
}, f2 = function(e, n, t, l, r) {
  this.meta = e, this.f = n, this.Qd = t, this.seed = l, this.next = r, this.C = 26083532, this.J = 1;
}, Yw = function(e, n) {
  return new f2(null, e, null, n, null);
}, kK = function(e, n, t) {
  return function l(r) {
    return new rr(null, function() {
      return kt(r, j(e.h ? e.h(r) : e.call(null, r)) ? na.l(l, Te([n.h ? n.h(r) : n.call(null, r)])) : null);
    }, null, null);
  }(t);
}, bK = function(e) {
  return Ou.g(function(n) {
    return !Fw(n);
  }, tn(kK(Fw, z, e)));
}, Nf = function(e, n) {
  this.ea = e, this.A = n;
}, TK = function(e) {
  return new Nf(e, [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  ]);
}, zO = function(e) {
  return new Nf(e.ea, ki(e.A));
}, cg = function(e) {
  return e = e.G, 32 > e ? 0 : e - 1 >>> 5 << 5;
}, D4 = function(e, n, t) {
  for (; ; ) {
    if (n === 0) return t;
    var l = TK(e);
    l.A[0] = t, t = l, n -= 5;
  }
}, jK = function(e, n) {
  throw Error(["No item ", ye.h(e), " in vector of length ", ye.h(n)].join(""));
}, ph = function(e, n) {
  if (n >= cg(e)) return e.fb;
  var t = e.root;
  for (e = e.shift; ; ) if (0 < e) {
    var l = e - 5;
    t = t.A[n >>> e & 31], e = l;
  } else return t.A;
}, AL = function(e, n) {
  return 0 <= n && n < e.G ? ph(e, n) : jK(n, e.G);
}, DL = function(e, n, t, l, r, u) {
  this.i = e, this.base = n, this.A = t, this.bb = l, this.start = r, this.end = u;
}, AK = function(e, n, t) {
  return new DL(n, n - n % 32, n < Cn(e) ? ph(e, n) : null, e, n, t);
}, IL = function(e, n, t, l) {
  return t < l ? RL(e, n, O.g(e, t), t + 1, l) : n.o ? n.o() : n.call(null);
}, RL = function(e, n, t, l, r) {
  var u = t;
  for (t = l, l = ph(e, l); ; ) if (t < r) {
    var o = t & 31;
    if (l = o === 0 ? ph(e, t) : l, o = l[o], u = n.g ? n.g(u, o) : n.call(null, u, o), ni(u)) return sn(u);
    t += 1;
  } else return u;
}, v = function(e, n, t, l, r, u) {
  this.meta = e, this.G = n, this.shift = t, this.root = l, this.fb = r, this.H = u, this.C = 167666463, this.J = 139268;
}, C3 = function(e, n) {
  var t = e.length;
  if (e = n ? e : ki(e), 32 > t) return new v(null, t, 5, y, e, null);
  n = 32;
  for (var l = new v(null, 32, 5, y, e.slice(0, 32), null).xc(null); ; ) if (n < t) {
    var r = n + 1;
    l = to.g(l, e[n]), n = r;
  } else return gu(l);
}, Et = function(e) {
  return j(Qd.h ? Qd.h(e) : Qd.call(null, e)) ? new v(null, 2, 5, y, [Zu.h ? Zu.h(e) : Zu.call(null, e), Ho.h ? Ho.h(e) : Ho.call(null, e)], null) : or(e) ? Bl(e, null) : ra(e) ? C3(e, !0) : gu(wt.j(Rm, ou(Dt), e));
}, y1 = function(e, n, t, l, r) {
  this.rb = e, this.node = n, this.i = t, this.off = l, this.meta = r, this.H = null, this.C = 32375020, this.J = 1536;
}, d2 = function(e) {
  switch (arguments.length) {
    case 3:
      var n = arguments[0], t = arguments[1], l = arguments[2];
      return new y1(n, AL(n, t), t, l, null);
    case 4:
      return Zh(arguments[0], arguments[1], arguments[2], arguments[3]);
    case 5:
      return cI(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
}, Zh = function(e, n, t, l) {
  return new y1(e, n, t, l, null);
}, cI = function(e, n, t, l, r) {
  return new y1(e, n, t, l, r);
}, Nm = function(e, n, t, l, r) {
  this.meta = e, this.bb = n, this.start = t, this.end = l, this.H = r, this.C = 167666463, this.J = 139264;
}, jc = function(e, n, t, l, r) {
  for (; ; ) if (n instanceof Nm) t = n.start + t, l = n.start + l, n = n.bb;
  else {
    if (!or(n)) throw Error("v must satisfy IVector");
    if (0 > t || l < t || l > Cn(n)) throw Error("Index out of bounds");
    return new Nm(e, n, t, l, r);
  }
}, sx = function(e, n) {
  return e === n.ea ? n : new Nf(e, ki(n.A));
}, wA = function(e) {
  return new Nf({}, ki(e.A));
}, vA = function(e) {
  var n = [
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null
  ];
  return ec(e, 0, n, 0, e.length), n;
}, DK = function(e, n, t, l) {
  this.G = e, this.shift = n, this.root = t, this.fb = l, this.J = 88, this.C = 275;
}, Ife = function(e, n, t) {
  if (e.root.ea) {
    if (0 <= n && n < e.G) {
      if (cg(e) <= n) e.fb[n & 31] = t;
      else {
        var l = function r(u, o) {
          if (o = sx(e.root.ea, o), u === 0) o.A[n & 31] = t;
          else {
            var a = n >>> u & 31;
            u = r(u - 5, o.A[a]), o.A[a] = u;
          }
          return o;
        }(e.shift, e.root);
        e.root = l;
      }
      return e;
    }
    if (n === e.G) return e.Cc(
      null,
      t
    );
    throw Error(["Index ", ye.h(n), " out of bounds for TransientVector of length", ye.h(e.G)].join(""));
  }
  throw Error("assoc! after persistent!");
}, I4 = function(e, n) {
  this.Fc = e, this.$c = n;
}, Cf = function(e, n, t, l) {
  this.meta = e, this.lb = n, this.qb = t, this.H = l, this.C = 31850700, this.J = 0;
}, Xh = function(e, n, t, l, r) {
  this.meta = e, this.count = n, this.lb = t, this.qb = l, this.H = r, this.J = 139264, this.C = 31858766;
}, IK = function() {
  this.C = 2097152, this.J = 0;
}, RK = function(e, n) {
  return pu(ci(n) && !Ap(n) && Cn(e) === Cn(n) ? (e != null ? e.C & 1048576 || Rn === e.Qf || !e.C && pl(AY, e) : pl(AY, e)) ? Jf(function(t, l, r) {
    return on.g(en.j(n, l, Iq), r) ? !0 : xh(!1);
  }, !0, e) : hu(function(t) {
    return on.g(en.j(n, I(t), Iq), Vr(t));
  }, e) : null);
}, hf = function(e, n, t, l) {
  this.i = 0, this.gf = e, this.Zd = n, this.cf = t, this.ue = l;
}, R4 = function(e) {
  this.X = e;
}, NL = function(e) {
  this.X = e;
}, hg = function(e, n) {
  if (n instanceof de) e: {
    var t = e.length;
    n = n.ca;
    for (var l = 0; ; ) {
      if (t <= l) {
        e = -1;
        break e;
      }
      if (e[l] instanceof de && n === e[l].ca) {
        e = l;
        break e;
      }
      l += 2;
    }
  }
  else if (typeof n == "string" || typeof n == "number") e: for (t = e.length, l = 0; ; ) {
    if (t <= l) {
      e = -1;
      break e;
    }
    if (n === e[l]) {
      e = l;
      break e;
    }
    l += 2;
  }
  else if (n instanceof T) e: for (t = e.length, n = n.Qb, l = 0; ; ) {
    if (t <= l) {
      e = -1;
      break e;
    }
    if (e[l] instanceof T && n === e[l].Qb) {
      e = l;
      break e;
    }
    l += 2;
  }
  else if (n == null) e: for (n = e.length, t = 0; ; ) {
    if (n <= t) {
      e = -1;
      break e;
    }
    if (e[t] == null) {
      e = t;
      break e;
    }
    t += 2;
  }
  else e: for (t = e.length, l = 0; ; ) {
    if (t <= l) {
      e = -1;
      break e;
    }
    if (on.g(n, e[l])) {
      e = l;
      break e;
    }
    l += 2;
  }
  return e;
}, yl = function(e, n) {
  this.key = e, this.val = n, this.H = null, this.C = 166619935, this.J = 0;
}, Qd = function(e) {
  return e != null ? !!(e.C & 2048 || Rn === e.Tf) : !1;
}, Ip = function(e, n, t) {
  this.A = e, this.i = n, this.zb = t, this.C = 32374990, this.J = 0;
}, CL = function(e, n) {
  this.A = e, this.i = 0, this.G = n;
}, $ = function(e, n, t, l) {
  this.meta = e, this.G = n, this.A = t, this.H = l, this.C = 16647951, this.J = 139268;
}, Mc = function(e, n) {
  return e === n || Ln(e, n) ? !0 : on.g(e, n);
}, Rfe = function(e) {
  for (var n = 0, t = 0; ; ) if (n < e.length) {
    var l;
    e: for (l = 0; ; ) if (l < n) {
      var r = Mc(e[n], e[l]);
      if (r) {
        l = r;
        break e;
      }
      l = 2 + l;
    } else {
      l = !1;
      break e;
    }
    t = l ? t : t + 2, n = 2 + n;
  } else return t;
}, Nfe = function(e, n) {
  var t = e.length - 1, l = z(n);
  for (n = Array(t + 2 * Cn(l)), e = ec(e, 0, n, 0, t), n = t; ; ) if (l) {
    var r = I(l);
    e[n] = Xa(r), e[n + 1] = Cc(r), n = 2 + t, l = W(l);
  } else return e;
}, Qu = function(e) {
  var n = e.length, t = (n & 1) === 1, l;
  if (!(l = t)) e: for (l = 0; ; ) if (l < e.length) {
    var r;
    n: for (r = 0; ; ) if (r < l) {
      var u = Mc(e[l], e[r]);
      if (u) {
        r = u;
        break n;
      }
      r = 2 + r;
    } else {
      r = !1;
      break n;
    }
    if (r) {
      l = r;
      break e;
    }
    l = 2 + l;
  } else {
    l = !1;
    break e;
  }
  return l ? Cfe(e, t) : new $(null, n / 2, e, null);
}, Cfe = function(e, n) {
  var t = n ? Nfe(e, lr.g(Tt, e[e.length - 1])) : e;
  e = Rfe(t);
  var l = t.length;
  if (e < l) {
    e = Array(e);
    for (var r = 0, u = 0; r < l; ) (function() {
      for (var o = 0; ; ) if (o < u) {
        var a = Mc(
          t[r],
          t[o]
        );
        if (a) return a;
        o = 2 + o;
      } else return !1;
    })() ? (n = u, r = 2 + r, u = n) : (n = function() {
      for (var o = l - 2; ; ) if (o >= r) {
        if (Mc(t[r], t[o])) return o;
        o -= 2;
      } else return o;
    }(), e[u] = t[r], e[u + 1] = t[n + 1], n = 2 + u, r = 2 + r, u = n);
    return new $(null, e.length / 2, e, null);
  }
  return new $(null, t.length / 2, t, null);
}, NK = function(e, n) {
  this.rc = {}, this.len = e, this.A = n, this.C = 259, this.J = 56;
}, yA = function(e, n) {
  for (var t = ou(b2), l = 0; ; ) if (l < e) t = ao.j(t, n[l], n[l + 1]), l += 2;
  else return t;
}, M3 = function() {
  this.val = !1;
}, Cm = function(e, n, t) {
  return e = ki(e), e[n] = t, e;
}, hI = function(e, n) {
  var t = Array(e.length - 2);
  return ec(e, 0, t, 0, 2 * n), ec(e, 2 * (n + 1), t, 2 * n, t.length - 2 * n), t;
}, Mm = function(e, n, t, l) {
  return e = e.ac(n), e.A[t] = l, e;
}, CK = function(e, n, t) {
  for (var l = e.length, r = 0, u = t; ; ) if (r < l) {
    if (t = e[r], t != null) {
      var o = e[r + 1];
      t = n.j ? n.j(u, t, o) : n.call(null, u, t, o);
    } else t = e[r + 1], t = t != null ? t.sc(n, u) : u;
    if (ni(t)) return t;
    r += 2, u = t;
  } else return u;
}, p2 = function(e) {
  this.A = e, this.i = 0, this.Jb = this.Wc = null;
}, kc = function(e, n, t) {
  this.ea = e, this.ga = n, this.A = t, this.J = 131072, this.C = 0;
}, SU = function(e, n, t, l) {
  if (e.ga === t) return null;
  e = e.ac(n), n = e.A;
  var r = n.length;
  return e.ga ^= t, ec(n, 2 * (l + 1), n, 2 * l, r - 2 * (l + 1)), n[r - 2] = null, n[r - 1] = null, e;
}, MK = function(e, n, t) {
  var l = e.A, r = l.length;
  e = Array(2 * (e.G - 1));
  for (var u = 0, o = 1, a = 0; ; ) if (u < r) u !== t && l[u] != null && (e[o] = l[u], o += 2, a |= 1 << u), u += 1;
  else return new kc(n, a, e);
}, N4 = function(e) {
  this.A = e, this.i = 0, this.Jb = null;
}, Pm = function(e, n, t) {
  this.ea = e, this.G = n, this.A = t, this.J = 131072, this.C = 0;
}, m2 = function(e, n, t) {
  n *= 2;
  for (var l = 0; ; ) if (l < n) {
    if (Mc(t, e[l])) return l;
    l += 2;
  } else return -1;
}, $m = function(e, n, t, l) {
  this.ea = e, this.Zb = n, this.G = t, this.A = l, this.J = 131072, this.C = 0;
}, PK = function(e) {
  switch (arguments.length) {
    case 6:
      return fI(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    case 7:
      return dI(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
}, fI = function(e, n, t, l, r, u) {
  var o = Uu(n);
  if (o === l) return new $m(null, o, 2, [n, t, r, u]);
  var a = new M3();
  return Vf.Fb(
    e,
    o,
    n,
    t,
    a
  ).Fb(e, l, r, u, a);
}, dI = function(e, n, t, l, r, u, o) {
  var a = Uu(t);
  if (a === r) return new $m(null, a, 2, [t, l, u, o]);
  var h = new M3();
  return Vf.Gb(e, n, a, t, l, h).Gb(e, n, r, u, o, h);
}, Jd = function(e, n, t, l, r) {
  this.meta = e, this.nodes = n, this.i = t, this.X = l, this.H = r, this.C = 32374988, this.J = 0;
}, vy = function(e) {
  switch (arguments.length) {
    case 1:
      return ox(arguments[0]);
    case 3:
      return bf(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
}, ox = function(e) {
  return bf(e, 0, null);
}, bf = function(e, n, t) {
  if (t == null) for (t = e.length; ; ) if (n < t) {
    if (e[n] != null) return new Jd(null, e, n, null, null);
    var l = e[n + 1];
    if (j(l) && (l = l.Tc(), j(l))) return new Jd(null, e, n + 2, l, null);
    n += 2;
  } else return null;
  else return new Jd(null, e, n, t, null);
}, Uw = function(e, n, t, l, r) {
  this.meta = e, this.nodes = n, this.i = t, this.X = l, this.H = r, this.C = 32374988, this.J = 0;
}, ML = function(e) {
  switch (arguments.length) {
    case 1:
      return pI(arguments[0]);
    case 3:
      return yy(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
}, pI = function(e) {
  return yy(e, 0, null);
}, yy = function(e, n, t) {
  if (t == null) for (t = e.length; ; ) if (n < t) {
    var l = e[n];
    if (j(l) && (l = l.Tc(), j(l))) return new Uw(null, e, n + 1, l, null);
    n += 1;
  } else return null;
  else return new Uw(null, e, n, t, null);
}, C4 = function(e, n) {
  this.eb = e, this.xe = n, this.Sd = !1;
}, Qh = function(e, n, t, l, r, u) {
  this.meta = e, this.G = n, this.root = t, this.cb = l, this.eb = r, this.H = u, this.C = 16123663, this.J = 139268;
}, Gn = function(e, n) {
  for (var t = e.length, l = 0, r = ou(b2); ; ) if (l < t) {
    if (n.length <= l) throw Error([
      "No value supplied for key: ",
      ye.h(e[l])
    ].join(""));
    var u = l + 1;
    r = Pw(r, e[l], n[l]), l = u;
  } else return gu(r);
}, $K = function(e, n, t, l) {
  this.ea = {}, this.root = e, this.count = n, this.cb = t, this.eb = l, this.C = 259, this.J = 56;
}, uE = function(e, n, t) {
  if (e.ea) {
    if (n == null) e.eb !== t && (e.eb = t), e.cb || (e.count += 1, e.cb = !0);
    else {
      var l = new M3();
      n = (e.root == null ? Vf : e.root).Gb(e.ea, 0, Uu(n), n, t, l), n !== e.root && (e.root = n), l.val && (e.count += 1);
    }
    return e;
  }
  throw Error("assoc! after persistent!");
}, PL = function(e, n, t) {
  for (var l = n; ; ) if (e != null) n = t ? e.left : e.right, l = yt.g(l, e), e = n;
  else return l;
}, Mf = function(e, n, t, l, r) {
  this.meta = e, this.stack = n, this.mc = t, this.G = l, this.H = r, this.C = 32374990, this.J = 0;
}, $L = function(e, n, t) {
  return new Mf(null, PL(e, null, n), n, t, null);
}, EU = function(e, n, t, l) {
  return t instanceof Jl ? t.left instanceof Jl ? new Jl(t.key, t.val, t.left.Sb(), new Qr(e, n, t.right, l)) : t.right instanceof Jl ? new Jl(t.right.key, t.right.val, new Qr(t.key, t.val, t.left, t.right.left), new Qr(e, n, t.right.right, l)) : new Qr(e, n, t, l) : new Qr(e, n, t, l);
}, OU = function(e, n, t, l) {
  return l instanceof Jl ? l.right instanceof Jl ? new Jl(l.key, l.val, new Qr(e, n, t, l.left), l.right.Sb()) : l.left instanceof Jl ? new Jl(l.left.key, l.left.val, new Qr(e, n, t, l.left.left), new Qr(l.key, l.val, l.left.right, l.right)) : new Qr(e, n, t, l) : new Qr(e, n, t, l);
}, LK = function(e, n, t, l) {
  if (t instanceof Jl) return new Jl(e, n, t.Sb(), l);
  if (l instanceof Qr) return OU(e, n, t, l.Zc());
  if (l instanceof Jl && l.left instanceof Qr) return new Jl(l.left.key, l.left.val, new Qr(e, n, t, l.left.left), OU(l.key, l.val, l.left.right, l.right.Zc()));
  throw Error("red-black tree invariant violation");
}, Mfe = function(e, n, t, l) {
  if (l instanceof Jl) return new Jl(e, n, t, l.Sb());
  if (t instanceof Qr) return EU(e, n, t.Zc(), l);
  if (t instanceof Jl && t.right instanceof Qr) return new Jl(t.right.key, t.right.val, EU(t.key, t.val, t.left.Zc(), t.right.left), new Qr(e, n, t.right.right, l));
  throw Error("red-black tree invariant violation");
}, Qr = function(e, n, t, l) {
  this.key = e, this.val = n, this.left = t, this.right = l, this.H = null, this.C = 166619935, this.J = 0;
}, Jl = function(e, n, t, l) {
  this.key = e, this.val = n, this.left = t, this.right = l, this.H = null, this.C = 166619935, this.J = 0;
}, mh = function(e, n, t, l, r) {
  this.kb = e, this.tree = n, this.G = t, this.meta = l, this.H = r, this.C = 418776847, this.J = 8192;
}, M4 = function(e, n) {
  for (var t = e.tree; ; ) if (t != null) {
    var l = t.key;
    if (l = e.kb.g ? e.kb.g(n, l) : e.kb.call(null, n, l), l === 0) return t;
    t = 0 > l ? t.left : t.right;
  } else return null;
}, fg = function(e, n) {
  this.fa = e, this.zb = n, this.C = 32374988, this.J = 0;
}, xi = function(e) {
  return (e = z(e)) ? new fg(e, null) : null;
}, Zu = function(e) {
  return Xa(e);
}, dg = function(e, n) {
  this.fa = e, this.zb = n, this.C = 32374988, this.J = 0;
}, Ju = function(e) {
  return (e = z(e)) ? new dg(e, null) : null;
}, Ho = function(e) {
  return Cc(e);
}, pg = function(e, n) {
  var t = Tt;
  for (n = z(n); ; ) if (n) {
    var l = I(n), r = en.j(e, l, eH);
    t = xa.g(r, eH) ? Dn.j(t, l, r) : t, n = W(n);
  } else return su(t, Vt(e));
}, P4 = function(e) {
  this.iter = e;
}, gi = function(e, n, t) {
  this.meta = e, this.bc = n, this.H = t, this.C = 15077647, this.J = 139268;
}, Rp = function(e) {
  for (var n = e.length, t = ou(ss), l = 0; l < n; ) Rm(t, e[l]), l += 1;
  return gu(t);
}, BK = function(e) {
  this.fc = e, this.J = 136, this.C = 259;
}, nd = function(e, n, t) {
  this.meta = e, this.xb = n, this.H = t, this.C = 417730831, this.J = 8192;
}, Us = function(e) {
  if (ug(e)) return Bl(e, null);
  if (e = z(e), e == null) return ss;
  if (e instanceof hn && e.i === 0) return Rp(e.A);
  for (var n = ou(ss); ; ) if (e != null) {
    var t = W(e);
    n = Rm(n, Er(e)), e = t;
  } else return gu(n);
}, td = function(e) {
  for (var n = Dt; ; ) if (W(e)) n = yt.g(n, I(e)), e = W(e);
  else return z(n);
}, ml = function(e) {
  if (e != null && (e.J & 4096 || Rn === e.he)) return e.yc(null);
  if (typeof e == "string") return e;
  throw Error(["Doesn't support name: ", ye.h(e)].join(""));
}, _a = function(e, n) {
  var t = ou(Tt);
  for (e = z(e), n = z(n); ; ) if (e && n) t = ao.j(
    t,
    I(e),
    I(n)
  ), e = W(e), n = W(n);
  else return gu(t);
}, g2 = function() {
  this.A = [];
}, _y = function(e, n, t) {
  return function(l) {
    var r = FO(e);
    return l = XD(e, l), r = r.g ? r.g(l, t) : r.call(null, l, t), n.g ? n.g(r, 0) : n.call(null, r, 0);
  };
}, KO = function(e, n, t) {
  this.start = e, this.step = n, this.count = t, this.C = 82, this.J = 0;
}, $4 = function(e, n, t) {
  this.i = e, this.end = n, this.step = t;
}, Pf = function(e, n, t, l, r, u, o) {
  this.meta = e, this.start = n, this.end = t, this.step = l, this.chunk = r, this.Tb = u, this.H = o, this.C = 32375006, this.J = 140800;
}, $f = function(e, n, t, l, r, u, o) {
  this.meta = e, this.start = n, this.end = t, this.step = l, this.chunk = r, this.Tb = u, this.H = o, this.J = 140800, this.C = 32374988;
}, FK = function(e, n) {
  return new v(null, 2, 5, y, [vo.g(e, n), J3.g(e, n)], null);
}, LL = function(e) {
  return gu(wt.j(function(n, t) {
    return ao.j(n, t, en.j(n, t, 0) + 1);
  }, ou(Tt), e));
}, L4 = function(e, n) {
  if (typeof n == "string") return e = e.exec(n), e != null && on.g(e[0], n) ? e.length === 1 ? e[0] : Et(e) : null;
  throw new TypeError("re-matches must match against a string.");
}, Ss = function(e, n) {
  if (typeof n == "string") return e = e.exec(n), e == null ? null : e.length === 1 ? e[0] : Et(e);
  throw new TypeError("re-find must match against a string.");
}, _1 = function(e) {
  if (e instanceof RegExp) return e;
  var n = Ss(/^\(\?([idmsux]*)\)/, e), t = O.j(n, 0, null);
  return n = O.j(n, 1, null), e = Si.g(e, t == null ? 0 : t.length), new RegExp(e, j(n) ? n : "");
}, vr = function(e, n, t, l, r, u, o) {
  var a = Wi;
  Wi = Wi == null ? null : Wi - 1;
  try {
    if (Wi != null && 0 > Wi) return Br(e, "#");
    if (Br(e, t), g8.h(u) === 0) z(o) && Br(e, function() {
      var R = DW.h(u);
      return j(R) ? R : "...";
    }());
    else {
      if (z(o)) {
        var h = I(o);
        n.j ? n.j(h, e, u) : n.call(null, h, e, u);
      }
      for (var s = W(o), d = g8.h(u) - 1; ; ) if (!s || d != null && d === 0) {
        z(s) && d === 0 && (Br(e, l), Br(e, function() {
          var R = DW.h(u);
          return j(R) ? R : "...";
        }()));
        break;
      } else {
        Br(e, l);
        var p = I(s);
        t = e, o = u, n.j ? n.j(p, t, o) : n.call(null, p, t, o);
        var _ = W(s);
        t = d - 1, s = _, d = t;
      }
    }
    return Br(e, r);
  } finally {
    Wi = a;
  }
}, Mh = function(e, n) {
  n = z(n);
  for (var t = null, l = 0, r = 0; ; ) if (r < l) {
    var u = t.Y(null, r);
    Br(e, u), r += 1;
  } else if (n = z(n)) t = n, oi(t) ? (n = Jr(t), l = Wr(t), t = n, u = Cn(n), n = l, l = u) : (u = I(t), Br(e, u), n = W(t), t = null, l = 0), r = 0;
  else return null;
}, VK = function(e) {
  if (Js == null) throw Error("No *print-fn* fn set for evaluation environment");
  return Js.call(null, e), null;
}, Pfe = function(e) {
  return ['"', ye.h(e.replace(RegExp(`[\\\\"\b\f
\r	]`, "g"), function(n) {
    return Jme[n];
  })), '"'].join("");
}, $fe = function(e, n) {
  return (e = pu(en.g(e, Db))) && (e = n != null ? !!(n.C & 131072 || Rn === n.zd) : !1) ? Vt(n) != null : e;
}, kU = function(e, n, t) {
  if (e == null) return Br(n, "nil");
  if ($fe(t, e)) {
    Br(n, "^");
    var l = Vt(e);
    Wl.j ? Wl.j(l, n, t) : Wl.call(null, l, n, t), Br(n, " ");
  }
  if (e.af) return e.Yf(e, n, t);
  if (e != null ? e.C & 2147483648 || Rn === e.da || !e.C && pl(CY, e) : pl(CY, e)) return VO(e, n, t);
  if (e === !0 || e === !1) return Br(
    n,
    ye.h(e)
  );
  if (typeof e == "number") return Br(n, isNaN(e) ? "##NaN" : e === Number.POSITIVE_INFINITY ? "##Inf" : e === Number.NEGATIVE_INFINITY ? "##-Inf" : ye.h(e));
  if (tK(e)) return Br(n, "#js "), l = bt.g(function(u) {
    return new yl(L4(/[A-Za-z_\*\+\?!\-'][\w\*\+\?!\-']*/, u) != null ? ts.h(u) : u, e[u]);
  }, _3(e)), Iv.B ? Iv.B(l, Wl, n, t) : Iv.call(null, l, Wl, n, t);
  if (ra(e)) return vr(n, Wl, "#js [", " ", "]", t, e);
  if (typeof e == "string") return j(c5.h(t)) ? Br(n, Pfe(e)) : Br(n, e);
  if (typeof e == "function") {
    var r = e.name;
    return t = j(function() {
      var u = r == null;
      return u || /^[\s\xa0]*$/.test(r);
    }()) ? "Function" : r, Mh(n, Te(["#object[", t, j(!1) ? [' "', ye.h(e), '"'].join("") : "", "]"]));
  }
  return e instanceof Date ? (t = function(u, o) {
    for (u = ye.h(u); ; ) if (u.length < o) u = ["0", u].join("");
    else return u;
  }, Mh(n, Te(['#inst "', t(e.getUTCFullYear(), 4), "-", t(e.getUTCMonth() + 1, 2), "-", t(e.getUTCDate(), 2), "T", t(e.getUTCHours(), 2), ":", t(e.getUTCMinutes(), 2), ":", t(e.getUTCSeconds(), 2), ".", t(e.getUTCMilliseconds(), 3), "-", '00:00"']))) : e instanceof RegExp ? Mh(n, Te(['#"', e.source, '"'])) : $t(e) === "symbol" || typeof Symbol < "u" && e instanceof Symbol ? Mh(n, Te(["#object[", e.toString(), "]"])) : j(function() {
    var u = e == null ? null : e.constructor;
    return u == null ? null : u.Hd;
  }()) ? Mh(n, Te(["#object[", e.constructor.Hd.replace(RegExp("/", "g"), "."), "]"])) : (r = function() {
    var u = e == null ? null : e.constructor;
    return u == null ? null : u.name;
  }(), t = j(function() {
    var u = r == null;
    return u || /^[\s\xa0]*$/.test(r);
  }()) ? "Object" : r, e.constructor == null ? Mh(n, Te(["#object[", t, "]"])) : Mh(n, Te(["#object[", t, " ", ye.h(e), "]"])));
}, Wl = function(e, n, t) {
  var l = d2e.h(t);
  return j(l) ? (t = Dn.j(t, mwe, kU), l.j ? l.j(e, n, t) : l.call(null, e, n, t)) : kU(e, n, t);
}, YK = function(e, n) {
  var t = new Ts();
  e: {
    var l = new mL(t);
    Wl(I(e), l, n), e = z(W(e));
    for (var r = null, u = 0, o = 0; ; ) if (o < u) {
      var a = r.Y(null, o);
      Br(l, " "), Wl(a, l, n), o += 1;
    } else if (e = z(e)) r = e, oi(r) ? (e = Jr(r), u = Wr(r), r = e, a = Cn(e), e = u, u = a) : (a = I(r), Br(l, " "), Wl(a, l, n), e = W(r), r = null, u = 0), o = 0;
    else break e;
  }
  return t;
}, BL = function(e, n) {
  return Ca(e) ? "" : ye.h(YK(e, n));
}, B4 = function(e, n) {
  return VK(BL(e, n));
}, FL = function(e) {
  return VK(`
`), en.g(e, DX), null;
}, bU = function(e) {
  return e instanceof T ? _n.g(null, ml(e)) : ts.g(null, ml(e));
}, Lfe = function(e) {
  if (j(ns)) {
    var n = z(e), t = z(n), l = I(t);
    for (W(t), O.j(l, 0, null), O.j(l, 1, null), t = O3(e), e = null; ; ) {
      l = e, n = z(n), e = I(n);
      var r = W(n), u = e;
      if (e = O.j(u, 0, null), n = O.j(u, 1, null), j(u)) if (e instanceof de || e instanceof T) if (j(l)) if (on.g(l, Yi(e))) t = Dn.j(t, bU(e), n), e = l, n = r;
      else return null;
      else if (l = Yi(e), j(l)) t = Dn.j(t, bU(e), n), e = l, n = r;
      else return null;
      else return null;
      else return new v(null, 2, 5, y, [l, t], null);
    }
  } else return null;
}, TU = function(e, n, t, l, r) {
  return vr(l, function(u, o, a) {
    var h = Xa(u);
    return t.j ? t.j(h, o, a) : t.call(null, h, o, a), Br(o, " "), u = Cc(u), t.j ? t.j(u, o, a) : t.call(null, u, o, a);
  }, [ye.h(e), "{"].join(""), ", ", "}", r, z(n));
}, Iv = function(e, n, t, l) {
  var r = ci(e) ? Lfe(e) : null, u = O.j(r, 0, null);
  return r = O.j(r, 1, null), j(u) ? TU(["#:", ye.h(u)].join(""), r, n, t, l) : TU(null, e, n, t, l);
}, P3 = function(e, n) {
  this.f = e, this.value = n, this.C = 2147516416, this.J = 1;
}, jU = function(e) {
  return e instanceof P3;
}, Bfe = function(e) {
  return function(n, t) {
    return n = e.g ? e.g(n, t) : e.call(
      null,
      n,
      t
    ), ni(n) ? xh(n) : n;
  };
}, F4 = function(e) {
  var n = Bfe(e);
  return function() {
    function t(o, a) {
      return wt.j(n, o, a);
    }
    function l(o) {
      return e.h ? e.h(o) : e.call(null, o);
    }
    function r() {
      return e.o ? e.o() : e.call(null);
    }
    var u = null;
    return u = function(o, a) {
      switch (arguments.length) {
        case 0:
          return r.call(this);
        case 1:
          return l.call(this, o);
        case 2:
          return t.call(this, o, a);
      }
      throw Error("Invalid arity: " + arguments.length);
    }, u.o = r, u.h = l, u.g = t, u;
  }();
}, V4 = function(e, n) {
  this.rd = e, this.coll = n, this.C = 2173173760, this.J = 131072;
}, UK = function(e, n) {
  return wt.j(function(t, l) {
    return e.h ? e.h(l) : e.call(null, l);
  }, null, n), null;
}, GO = function() {
}, ZO = function(e) {
  if (e != null && e.Pe != null) e = e.Pe(e);
  else {
    var n = ZO[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = ZO._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IEncodeJS.-clj->js", e);
  }
  return e;
}, AU = function(e, n) {
  return (e != null ? Rn === e.Oe || !e.Pc && pl(GO, e) : pl(GO, e)) ? ZO(e) : typeof e == "string" || typeof e == "number" || e instanceof de || e instanceof T ? n.h ? n.h(e) : n.call(null, e) : wg.l(Te([e]));
}, DU = function() {
}, mI = function(e, n) {
  if (e != null && e.Ne != null) e = e.Ne(e, n);
  else {
    var t = mI[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = mI._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IEncodeClojure.-js->clj", e);
  }
  return e;
}, Eh = function(e) {
  var n = kr.h(Tt);
  return function() {
    function t(r) {
      var u = null;
      if (0 < arguments.length) {
        u = 0;
        for (var o = Array(arguments.length - 0); u < o.length; ) o[u] = arguments[u + 0], ++u;
        u = new hn(o, 0, null);
      }
      return l.call(this, u);
    }
    function l(r) {
      var u = en.j(
        sn(n),
        r,
        Da
      );
      return u === Da && (u = In.g(e, r), wr.B(n, Dn, r, u)), u;
    }
    return t.m = 0, t.v = function(r) {
      return r = z(r), l(r);
    }, t.l = l, t;
  }();
}, OS = function(e) {
  return Math.floor(Math.random() * e);
}, xy = function(e, n) {
  return gu(wt.j(function(t, l) {
    var r = e.h ? e.h(l) : e.call(null, l);
    return ao.j(t, r, yt.g(en.j(t, r, Dt), l));
  }, ou(Tt), n));
}, Y4 = function() {
  return new $(null, 3, [Ea, Tt, Y_, Tt, U0, Tt], null);
}, es = function() {
  return XA == null && (XA = kr.h(Y4())), XA;
}, w2 = function(e, n, t) {
  var l = on.g(n, t);
  if (l) return l;
  if (l = U0.h(e), l = l.h ? l.h(n) : l.call(null, n), !(l = Ol(
    l,
    t
  )) && (l = or(t))) if (l = or(n)) if (l = Cn(t) === Cn(n)) {
    l = !0;
    for (var r = 0; ; ) if (l && r !== Cn(t)) l = w2(e, n.h ? n.h(r) : n.call(null, r), t.h ? t.h(r) : t.call(null, r)), r += 1;
    else return l;
  } else return l;
  else return l;
  else return l;
}, IU = function(e) {
  return VL(sn(es()), e);
}, VL = function(e, n) {
  return Fo(en.g(Ea.h(e), n));
}, qK = function(e, n) {
  return Fo(en.g(U0.h(e), n));
}, WK = function(e, n) {
  return Fo(en.g(Y_.h(e), n));
}, $3 = function(e, n, t, l) {
  return wr.g(e, function() {
    return sn(n);
  }), wr.g(t, function() {
    return sn(l);
  });
}, RU = function(e, n, t, l) {
  return t = _Z(
    e,
    n,
    t
  ), j(t) ? t : w2(l, e, n);
}, gI = function(e) {
  if (e != null && e.ge != null) e = e.ge(e);
  else {
    var n = gI[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = gI._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IMultiFn.-reset", e);
  }
  return e;
}, wI = function(e, n, t) {
  if (e != null && e.$a != null) e = e.$a(e, n, t);
  else {
    var l = wI[$t(e ?? null)];
    if (l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else if (l = wI._, l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else throw Ut("IMultiFn.-add-method", e);
  }
  return e;
}, vI = function(e, n) {
  if (e != null && e.fe != null) e = e.fe(e, n);
  else {
    var t = vI[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = vI._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IMultiFn.-remove-method", e);
  }
  return e;
}, yI = function(e, n, t) {
  if (e != null && e.de != null) e = e.de(e, n, t);
  else {
    var l = yI[$t(e ?? null)];
    if (l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else if (l = yI._, l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else throw Ut("IMultiFn.-prefer-method", e);
  }
  return e;
}, XO = function(e, n) {
  if (e != null && e.Ya != null) e = e.Ya(e, n);
  else {
    var t = XO[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = XO._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IMultiFn.-get-method", e);
  }
  return e;
}, QO = function(e) {
  if (e != null && e.ce != null) e = e.ce(e);
  else {
    var n = QO[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = QO._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IMultiFn.-methods", e);
  }
  return e;
}, _I = function(e) {
  if (e != null && e.ee != null) e = e.ee(e);
  else {
    var n = _I[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = _I._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IMultiFn.-prefers", e);
  }
  return e;
}, os = function(e, n) {
  throw Error(["No method in multimethod '", ye.h(e), "' for dispatch value: ", ye.h(n)].join(""));
}, Np = function(e, n, t, l, r, u, o, a) {
  this.name = e, this.M = n, this.bf = t, this.Gc = l, this.cc = r, this.Xc = u, this.tc = o, this.oc = a, this.C = 4194305, this.J = 4352;
}, HK = function(e, n) {
  return XO(e, n);
}, L3 = function(e) {
  this.vc = e, this.H = null, this.C = 2153775104, this.J = 2048;
}, ld = function(e, n, t) {
  var l = Error(e);
  return this.message = e, this.data = n, this.cause = t, this.name = l.name, this.description = l.description, this.number = l.number, this.fileName = l.fileName, this.lineNumber = l.lineNumber, this.columnNumber = l.columnNumber, this.stack = l.stack, this;
}, ax = function(e) {
  return e instanceof ld ? e.data : null;
}, kS = function(e) {
  return e instanceof Error ? e.message : null;
}, bS = function(e) {
  return e instanceof ld ? e.cause : null;
}, xI = function(e) {
  return Ol(new gi(null, new $(null, 24, [
    et,
    "null",
    bb,
    "null",
    v_e,
    "null",
    T1,
    "null",
    o0e,
    "null",
    A2,
    "null",
    Hx,
    "null",
    mi,
    "null",
    Yge,
    "null",
    si,
    "null",
    lf,
    "null",
    ih,
    "null",
    R2e,
    "null",
    Gy,
    "null",
    D1e,
    "null",
    r1,
    "null",
    b1,
    "null",
    jb,
    "null",
    Kf,
    "null",
    $u,
    "null",
    Fr,
    "null",
    Eee,
    "null",
    rp,
    "null",
    Yc,
    "null"
  ], null), null), e);
}, JO = function(e, n) {
  this.tag = e, this.form = n, this.C = 2153775360, this.J = 0;
}, Ffe = function(e) {
  return QA == null && (QA = wt.j(function(n, t) {
    return n[t] = !0, n;
  }, {}, tge)), QA.hasOwnProperty(e);
}, Vfe = function() {
  return j(zA) || (zA = function() {
    for (var e = Lf.g(function(r, u) {
      return u.length - r.length;
    }, _3(dZ)), n = ""; ; ) if (z(e)) {
      var t = W(e), l = [function() {
        var r = n;
        return n !== "" ? [r, "|"].join("") : r;
      }(), ye.h(I(e))].join("");
      e = t, n = l;
    } else return [n, "|\\$"].join("");
  }()), zA;
}, B3 = function(e) {
  for (var n = ye.h(e), t = new Ts(), l = 0; l < n.length; ) {
    var r = n.charAt(l), u = lo(Bme, r);
    u != null ? t.append(u) : t.append(r), l += 1;
  }
  return n = t.toString(), n = n === ".." ? "_DOT__DOT_" : j(Ffe(n)) ? [n, "$"].join("") : n, e instanceof T ? _n.h(n) : n;
}, zK = function(e) {
  var n = ye.h(e);
  if (n === "_DOT__DOT_") var t = "..";
  else e: {
    t = new RegExp(Vfe(), "g"), n = j(g1(n, "$")) ? n.substring(0, n.length - 1) : n;
    for (var l = "", r = 0; ; ) {
      var u = t.exec(n);
      if (j(u)) u = O.j(u, 0, null), l = [l, ye.h(n.substring(r, t.lastIndex - u.length)), ye.h(u === "$" ? "/" : lo(dZ, u))].join(""), r = t.lastIndex;
      else {
        t = [l, ye.h(n.substring(r, n.length))].join("");
        break e;
      }
    }
  }
  return e = e instanceof T ? _n : ye, e.h ? e.h(t) : e.call(null, t);
}, NU = function(e, n, t) {
  var l = j(n.ignoreCase) ? "gi" : "g";
  return l = j(n.multiline) ? [l, "m"].join("") : l, e.replace(new RegExp(n.source, j(n.unicode) ? [l, "u"].join("") : l), t);
}, Yfe = function(e) {
  return function() {
    function n(l) {
      var r = null;
      if (0 < arguments.length) {
        r = 0;
        for (var u = Array(arguments.length - 0); r < u.length; ) u[r] = arguments[r + 0], ++r;
        r = new hn(u, 0, null);
      }
      return t.call(this, r);
    }
    function t(l) {
      return l = Py.g(2, l), on.g(Cn(l), 1) ? (l = I(l), e.h ? e.h(l) : e.call(null, l)) : (l = Et(l), e.h ? e.h(l) : e.call(null, l));
    }
    return n.m = 0, n.v = function(l) {
      return l = z(l), t(l);
    }, n.l = t, n;
  }();
}, F3 = function(e, n, t) {
  if (typeof n == "string") return e.replace(new RegExp(String(n).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08"), "g"), t);
  if (n instanceof RegExp) return typeof t == "string" ? NU(e, n, t) : NU(e, n, Yfe(t));
  throw ["Invalid match arg: ", ye.h(n)].join("");
}, Ufe = function(e, n) {
  return 0 >= n || n >= 2 + Cn(e) ? yt.g(Et(kt("", bt.g(ye, z(e)))), "") : j(Ec.g ? Ec.g(1, n) : Ec.call(null, 1, n)) ? new v(null, 1, 5, y, [e], null) : j(Ec.g ? Ec.g(2, n) : Ec.call(null, 2, n)) ? new v(null, 2, 5, y, ["", e], null) : (n -= 2, yt.g(Et(kt("", _p.j(Et(bt.g(ye, z(e))), 0, n))), Si.g(e, n)));
}, U4 = function(e) {
  return /^[\s\xa0]*$/.test(e == null ? "" : String(e));
}, KK = function(e, n) {
  return e.lastIndexOf(n, 0) == 0;
}, GK = function(e, n) {
  return e.indexOf(n) != -1;
}, hw = function(e, n, t, l, r) {
  this.Pb = e, this.form = n, this.K = t, this.F = l, this.H = r, this.C = 2230716170, this.J = 139264;
}, qfe = function(e, n) {
  return new hw(n, e, null, null, null);
}, ep = function(e) {
  return e == null ? null : e === "," ? !0 : gxe.test(e);
}, ek = function(e) {
  return e == null ? null : !/[^0-9]/.test(e);
}, q4 = function(e) {
  return e === `
` || e === `
` || e == null;
}, SI = function(e, n) {
  return function t(l) {
    return new rr(null, function() {
      for (; ; ) {
        var r = z(l);
        if (r) {
          if (oi(r)) {
            var u = Jr(r), o = Cn(u), a = Sh(o);
            return function() {
              for (var s = 0; ; ) if (s < o) {
                var d = Ul(u, s), p = a;
                if (d instanceof T || d instanceof de) {
                  var _ = Yf.g(Yi, ml)(d), R = O.j(_, 0, null);
                  _ = O.j(_, 1, null);
                  var F = d instanceof T ? _n : ts;
                  d = R == null ? F.g ? F.g(e, _) : F.call(null, e, _) : on.g("_", R) ? F.h ? F.h(_) : F.call(null, _) : d;
                }
                p.add(d), s += 1;
              } else return !0;
            }() ? js(mo(a), t(Wr(r))) : js(mo(a), null);
          }
          var h = I(r);
          return kt(h instanceof T || h instanceof de ? function() {
            var s = Yf.g(Yi, ml)(h), d = O.j(s, 0, null);
            s = O.j(s, 1, null);
            var p = h instanceof T ? _n : ts;
            return d == null ? p.g ? p.g(e, s) : p.call(null, e, s) : on.g("_", d) ? p.h ? p.h(s) : p.call(
              null,
              s
            ) : h;
          }() : h, t(tn(r)));
        }
        return null;
      }
    }, null, null);
  }(n);
}, EI = function(e, n) {
  return e = parseInt(e, n), j(isNaN(e)) ? -1 : e;
}, Ko = function(e) {
  if (e != null && e.S != null) e = e.S(e);
  else {
    var n = Ko[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Ko._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("Reader.read-char", e);
  }
  return e;
}, cx = function(e) {
  if (e != null && e.ob != null) e = e.ob(e);
  else {
    var n = cx[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = cx._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut(
      "Reader.peek-char",
      e
    );
  }
  return e;
}, Sy = function(e, n) {
  if (e != null && e.Ob != null) e.Ob(e, n);
  else {
    var t = Sy[$t(e ?? null)];
    if (t != null) t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = Sy._, t != null) t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IPushbackReader.unread", e);
  }
}, Lm = function(e) {
  if (e != null && e.qc != null) e = e.qc(e);
  else {
    var n = Lm[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Lm._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IndexingReader.get-line-number", e);
  }
  return e;
}, Bm = function(e) {
  if (e != null && e.pc != null) e = e.pc(e);
  else {
    var n = Bm[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Bm._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IndexingReader.get-column-number", e);
  }
  return e;
}, hx = function(e) {
  if (e != null && e.te != null) e = e.nd;
  else {
    var n = hx[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = hx._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IndexingReader.get-file-name", e);
  }
  return e;
}, W4 = function(e, n) {
  this.X = e, this.ye = n, this.Ic = 0;
}, V3 = function(e) {
  var n = Gl.h(1);
  this.Ab = e, this.nc = n, this.Bb = this.td = 1;
}, ZK = function(e, n) {
  return n === "\r" ? (n = e.ob(null), n !== "\f" && n !== `
` || e.S(null), `
`) : n;
}, XK = function(e) {
  this.Ab = e, this.column = this.line = 1, this.Hb = !0, this.prev = null, this.Yc = 0, this.nd = null;
}, YL = function(e) {
  var n = kr.h(new $(null, 2, [l1, new Ts(), OE, ue(0)], null));
  this.Ab = e, this.column = this.line = 1, this.Hb = !0, this.prev = null, this.Yc = 0, this.nd = null, this.frames = n;
}, Pc = function(e) {
  return e != null ? Rn === e.se : !1;
}, x1 = function(e) {
  return new V3(new W4(e, Cn(e)));
}, H4 = function(e) {
  return new XK(typeof e == "string" ? x1(e) : e);
}, Wfe = function(e, n) {
  var t = l1.h(sn(e.frames));
  try {
    wr.l(e.frames, bu, new v(null, 1, 5, y, [OE], null), yt, Te([t.getLength()]));
    var l = n.o ? n.o() : n.call(null);
    if (l != null && (l.C & 131072 || Rn === l.zd))
      var r = sn(e.frames), u = Si.g(ye.h(l1.h(r)), I(OE.h(r))), o = new $(null, 1, [co, u], null), a = Vt(l), h = Bl(l, gr.l(Te([o, nr.g(a, co)])));
    else h = l;
    return h;
  } finally {
    wr.B(e.frames, bu, new v(null, 1, 5, y, [OE], null), tn);
  }
}, z4 = function(e, n, t, l) {
  var r = Cn(n);
  return e = j(e) ? 0 : 10 < r ? 10 : r, n = bt.g(go.g(As, !0), Vu.g(e, n)), n = In.g(ye, rd.g(
    " ",
    n
  )), r = e < r ? "..." : null, [ye.h(t), ye.h(n), r, ye.h(l)].join("");
}, UL = function(e, n, t) {
  n = new $(null, 2, [zi, vE, Ege, n], null), e = Pc(e) ? Dn.l(n, Bn, hx(e), Te([Yn, Lm(e), tu, Bm(e)])) : n;
  var l = Bn.h(e);
  n = Yn.h(e);
  var r = tu.h(e);
  throw l = j(l) ? [ye.h(l), " "].join("") : null, n = j(n) ? ["[line ", ye.h(n), ", col ", ye.h(r), "]"].join("") : null, t = In.I(ye, l, n, j(j(l) ? l : n) ? " " : null, t), Yr.g(t, e);
}, bs = function(e, n) {
  return UL(e, Cwe, Te([In.g(ye, n)]));
}, nk = function(e, n) {
  return UL(e, wwe, Te([In.g(ye, n)]));
}, qw = function(e, n) {
  return UL(e, qf, Te([In.g(ye, n)]));
}, QK = function(e, n, t, l) {
  bs(e, Te(["The map literal starting with ", As.g(!1, I(l)), j(n) ? [" on line ", ye.h(n), " column ", ye.h(t)].join("") : null, " contains ", Cn(l), " form(s). Map literals must contain an even number of forms."]));
}, OI = function(e, n, t) {
  return bs(e, Te(["Invalid ", ml(n), ": ", t, "."]));
}, CU = function(e, n, t) {
  return bs(e, Te(["Invalid character: ", t, " found while reading ", ml(n), "."]));
}, Hfe = function(e, n) {
  e: {
    var t = H_ instanceof de ? H_.ca : null;
    switch (t) {
      case "regex":
        t = '#"';
        break e;
      case "string":
        t = '"';
        break e;
      default:
        throw Error([
          "No matching clause: ",
          ye.h(t)
        ].join(""));
    }
  }
  return qw(e, Te(["Unexpected EOF reading ", ml(H_), " starting ", In.j(ye, t, n), "."]));
}, MU = function(e, n) {
  return nk(e, Te(["Invalid digit ", n, " in unicode character."]));
}, JK = function(e) {
  return bs(e, Te(["Octal escape sequence must be in range [0, 377]."]));
}, zfe = function(e, n) {
  return n = function(t) {
    return function l(r) {
      return new rr(null, function() {
        for (var u = r; ; ) if (u = z(u)) {
          if (oi(u)) {
            var o = Jr(u), a = Cn(o), h = Sh(a);
            e: for (var s = 0; ; ) if (s < a) {
              var d = Ul(o, s), p = O.j(d, 0, null);
              1 < O.j(d, 1, null) && h.add(p), s += 1;
            } else {
              o = !0;
              break e;
            }
            return o ? js(mo(h), l(Wr(u))) : js(mo(h), null);
          }
          if (h = I(u), o = O.j(h, 0, null), 1 < O.j(h, 1, null)) return kt(o, l(tn(u)));
          u = tn(u);
        } else return null;
      }, null, null);
    }(LL(t));
  }(n), In.I(ye, e, 1 < Cn(n) ? "s" : null, ": ", rd.g(", ", n));
}, qL = function(e, n, t) {
  bs(e, Te([zfe([x3(ml(n)), " literal contains duplicate key"].join(""), t)]));
}, sE = function(e, n) {
  return ek(n) || (n === "+" || n === "-") && ek(e.ob(null));
}, eG = function(e) {
  for (var n = e.S(null); ; ) if (ep.h ? ep.h(n) : ep.call(null, n)) n = e.S(null);
  else return n;
}, _A = function(e, n) {
  return e = Ss(e, n), O.j(e, 0, null) === n;
}, nG = function(e) {
  if (_A(jH, e)) {
    var n = Et(Ss(jH, e));
    if ((n.h ? n.h(2) : n.call(null, 2)) != null) e = 0;
    else {
      e = (n.h ? n.h(1) : n.call(null, 1)) === "-", n = (n.h ? n.h(3) : n.call(null, 3)) != null ? new v(null, 2, 5, y, [n.h ? n.h(3) : n.call(null, 3), 10], null) : (n.h ? n.h(4) : n.call(null, 4)) != null ? new v(null, 2, 5, y, [n.h ? n.h(4) : n.call(null, 4), 16], null) : (n.h ? n.h(5) : n.call(null, 5)) != null ? new v(null, 2, 5, y, [n.h ? n.h(5) : n.call(null, 5), 8], null) : (n.h ? n.h(7) : n.call(null, 7)) != null ? new v(null, 2, 5, y, [n.h ? n.h(7) : n.call(null, 7), parseInt(n.h ? n.h(6) : n.call(null, 6))], null) : new v(null, 2, 5, y, [null, null], null);
      var t = n.h ? n.h(0) : n.call(null, 0);
      t == null ? e = null : (n = parseInt(t, n.h ? n.h(1) : n.call(null, 1)), e = e ? -1 * n : n, e = j(isNaN(e)) ? null : e);
    }
  } else _A(DH, e) ? (n = Et(Ss(DH, e)), e = (n.h ? n.h(4) : n.call(null, 4)) != null ? parseFloat(n.h ? n.h(1) : n.call(null, 1)) : parseFloat(e)) : _A(AH, e) ? (n = Et(Ss(AH, e)), e = n.h ? n.h(1) : n.call(null, 1), n = n.h ? n.h(2) : n.call(null, 2), e = j(Ss(/^\+/, e)) ? Si.g(e, 1) : e, e = parseInt(e) / parseInt(n)) : e = null;
  return e;
}, Rv = function(e) {
  if (e === "" || /:$/.test(e) === !0 || /^::/.test(e) === !0) return null;
  var n = e.indexOf("/"), t = 0 < n ? Si.j(e, 0, n) : null;
  return t != null ? (n += 1, n === Cn(e) ? null : (e = Si.g(e, n), ek(O.g(e, 0)) || e === "" || /:$/.test(t) !== !1 || e !== "/" && e.indexOf("/") !== -1 ? null : new v(null, 2, 5, y, [t, e], null))) : e === "/" || e.indexOf("/") === -1 ? new v(null, 2, 5, y, [null, e], null) : null;
}, Kfe = function() {
  return function() {
    function e(t, l) {
      var r = null;
      if (1 < arguments.length) {
        r = 0;
        for (var u = Array(arguments.length - 1); r < u.length; ) u[r] = arguments[r + 1], ++r;
        r = new hn(u, 0, null);
      }
      return n.call(
        this,
        t,
        r
      );
    }
    function n(t) {
      return bs(t, Te(["Unreadable form"]));
    }
    return e.m = 1, e.v = function(t) {
      var l = I(t);
      return t = tn(t), n(l);
    }, e.l = n, e;
  }();
}, tG = function(e) {
  var n = e !== "#";
  return n && ((n = e !== "'") && (n = e !== ":") ? Ac.h ? Ac.h(e) : Ac.call(null, e) : n);
}, kI = function(e) {
  return e === "@" || e === "`" || e === "~";
}, K4 = function(e, n, t, l) {
  if (er(t)) return qw(e, Te(["Unexpected EOF while reading start of ", ml(n), "."]));
  if (j(j(l) ? kI(t) : l)) return CU(e, n, t);
  for (l = new Ts(), Sy(e, t); ; ) {
    if (ep(t) || tG(t) || t == null) return ye.h(l);
    if (kI(t)) return CU(e, n, t);
    l.append(Ko(e)), t = cx(e);
  }
}, Gfe = function(e, n, t) {
  if (n = Ko(e), j(n)) {
    var l = SA.h ? SA.h(n) : SA.call(null, n);
    return j(l) ? l.j ? l.j(e, n, t) : l.call(null, e, n, t) : (Sy(e, n), EA.j ? EA.j(e, n, t) : EA.call(null, e, n, t));
  }
  return qw(e, Te(["Unexpected EOF while reading dispatch character."]));
}, xA = function(e, n) {
  return bs(e, Te(["Unmatched delimiter ", n, "."]));
}, PU = function(e, n, t) {
  if (n = 1 + n, Cn(e) !== n) throw nk(null, Te(["Invalid unicode literal: \\", e, "."]));
  for (var l = 1, r = 0; ; ) {
    if (l === n) return String.fromCharCode(r);
    var u = EI(O.g(e, l), t);
    if (u === -1) return t = O.g(e, l), nk(null, Te(["Invalid digit ", t, " in unicode character \\", e, "."]));
    r = u + r * t, l += 1;
  }
}, $U = function(e, n, t, l, r) {
  for (var u = 1, o = EI(n, t); ; ) {
    if (o === -1) return MU(e, n);
    if (u !== l) {
      var a = cx(e), h = ep(a);
      if (h || (h = Ac.h ? Ac.h(a) : Ac.call(null, a), h = j(h) ? h : a == null), j(h)) return j(r) ? nk(e, Te(["Invalid unicode literal. Unicode literals should be ", l, "characters long.  ", "value suppled is ", u, "characters long."])) : String.fromCharCode(o);
      if (h = EI(a, t), Ko(e), h === -1) return MU(e, a);
      o = h + o * t, u += 1;
    } else return String.fromCharCode(o);
  }
}, oE = function(e) {
  var n = Ko(e);
  if (n != null) {
    n = tG(n) || kI(n) || ep(n) ? ye.h(n) : K4(e, X_e, n, !1);
    var t = n.length;
    return t === 1 ? O.g(n, 0) : n === "newline" ? `
` : n === "space" ? " " : n === "tab" ? "	" : n === "backspace" ? "\b" : n === "formfeed" ? "\f" : n === "return" ? "\r" : j(n.lastIndexOf("u", 0) == 0) ? (n = PU(n, 4, 16), t = n.charCodeAt(), 55295 < t && 57344 > t ? (n = t.toString(16), e = bs(e, Te(["Invalid character literal \\u", n, "."]))) : e = n, e) : j(n.lastIndexOf("o", 0) == 0) ? (--t, 3 < t ? bs(e, Te([
      "Invalid octal escape sequence in a character literal:",
      n,
      ". Octal escape sequences must be 3 or fewer digits."
    ])) : (n = PU(n, t, 8), 255 < (n | 0) ? JK(e) : n)) : bs(e, Te(["Unsupported character: ", n, "."]));
  }
  return qw(e, Te(["Unexpected EOF while reading character."]));
}, lG = function(e) {
  return Pc(e) ? new v(null, 2, 5, y, [Lm(e), (Bm(e) | 0) - 1 | 0], null) : null;
}, Y3 = function(e, n, t, l) {
  var r = lG(t), u = O.j(r, 0, null);
  r = O.j(r, 1, null), n = n == null ? null : gy(n);
  for (var o = ou(Dt); ; ) {
    var a = eG(t);
    if (!j(a)) {
      var h = e, s = u, d = r, p = Cn(o);
      qw(t, Te(["Unexpected EOF while reading ", j(p) ? ["item ", ye.h(p), " of "].join("") : null, ml(h), j(s) ? [", starting at line ", ye.h(s), " and column ", ye.h(d)].join("") : null, "."]));
    }
    if (on.g(n, a == null ? null : gy(a))) return gu(o);
    h = Ac.h ? Ac.h(a) : Ac.call(null, a), j(h) ? (a = h.j ? h.j(t, a, l) : h.call(null, t, a, l), o = a !== t ? to.g(o, a) : o) : (Sy(t, a), a = Ro ? Ro(t, !0, null, l) : Ww.call(null, t, !0, null, l), o = a !== t ? to.g(o, a) : o);
  }
}, Zfe = function(e, n, t) {
  return e = Y3(UB, ")", e, t), Ca(e) ? fl : In.g(ue, e);
}, Xfe = function(e, n, t) {
  return Y3(ZB, "]", e, t);
}, Qfe = function(e, n, t) {
  var l = lG(e);
  n = O.j(l, 0, null), l = O.j(l, 1, null), t = Y3(Xx, "}", e, t);
  var r = Cn(t), u = Po.g(2, t), o = Us(u);
  if (!qc(r) && QK(e, n, l, t), on.g(Cn(o), Cn(u)) || qL(e, Xx, u), r <= 2 * _B) e = Sc(t), e = new $(null, e.length / 2, e, null);
  else e: for (e = Sc(t), n = e.length, l = 0, r = ou(b2); ; ) if (l < n) t = l + 2, r = Pw(r, e[l], e[l + 1]), l = t;
  else {
    e = gu(r);
    break e;
  }
  return e;
}, Jfe = function(e, n) {
  for (var t = function() {
    var o = new Ts();
    return o.append(n), o;
  }(), l = Ko(e); ; ) {
    if (j(function() {
      var o = ep(l);
      return o || (o = Ac.h ? Ac.h(l) : Ac.call(null, l), j(o) ? o : l == null);
    }())) {
      var r = ye.h(t);
      Sy(e, l);
      var u = nG(r);
      return j(u) ? u : bs(e, Te(["Invalid number: ", r, "."]));
    }
    r = function() {
      var o = t;
      return o.append(l), o;
    }(), u = Ko(e), t = r, l = u;
  }
}, aE = function(e, n) {
  switch (e = Ko(n), e) {
    case "t":
      return "	";
    case "r":
      return "\r";
    case "n":
      return `
`;
    case "\\":
      return "\\";
    case '"':
      return '"';
    case "b":
      return "\b";
    case "f":
      return "\f";
    case "u":
      return e = Ko(n), parseInt(e | 0, 16) === -1 ? bs(n, Te(["Invalid unicode escape: \\u", e, "."])) : $U(n, e, 16, 4, !0);
    default:
      return ek(e) ? (e = $U(n, e, 8, 3, !1), 255 < (e | 0) ? JK(n) : e) : bs(n, Te(["Unsupported escape character: \\", e, "."]));
  }
}, ede = function(e) {
  for (var n = new Ts(), t = Ko(e); ; ) {
    var l = t;
    if (on.g(null, l)) return Hfe(e, Te(['"', n]));
    if (on.g("\\", l)) {
      l = function() {
        var u = n;
        return u.append(aE(n, e)), u;
      }();
      var r = Ko(e);
      n = l, t = r;
    } else {
      if (on.g('"', l)) return ye.h(n);
      l = function() {
        var u = n;
        return u.append(t), u;
      }(), r = Ko(e), n = l, t = r;
    }
  }
}, nde = function(e, n) {
  if (n = K4(e, Qq, n, !0), j(n)) switch (n) {
    case "nil":
      return null;
    case "true":
      return !0;
    case "false":
      return !1;
    case "/":
      return $x;
    default:
      var t = Rv(n);
      return t = j(t) ? _n.g(t.h ? t.h(0) : t.call(null, 0), t.h ? t.h(1) : t.call(null, 1)) : null, j(t) ? t : OI(e, Qq, n);
  }
  else return null;
}, tde = function(e) {
  var n = Ko(e);
  if (ep(n)) return bs(e, Te(["A single colon is not a valid keyword."]));
  n = K4(e, g6, n, !0);
  var t = Rv(n);
  if (j(j(t) ? n.indexOf("::") === -1 : t)) {
    var l = t.h ? t.h(0) : t.call(null, 0);
    return t = t.h ? t.h(1) : t.call(null, 1), O.g(n, 0) === ":" ? OI(e, g6, n) : ts.g(l, t);
  }
  return OI(e, g6, n);
}, rG = function(e, n, t) {
  return n = Ro ? Ro(e, !0, null, t) : Ww.call(null, e, !0, null, t), n = n instanceof de ? Qu([n, !0]) : n instanceof T ? new $(null, 1, [Ft, n], null) : typeof n == "string" ? new $(null, 1, [Ft, n], null) : n, ci(n) || bs(e, Te(["Metadata cannot be ", As.g(!1, n), ". Metadata must be a Symbol, Keyword, String or Map."])), t = Ro ? Ro(e, !0, null, t) : Ww.call(null, e, !0, null, t), t != null && (t.C & 131072 || Rn === t.zd) ? Bl(t, gr.l(Te([Vt(t), n]))) : bs(e, Te(["Metadata can not be applied to ", As.g(!1, t), ". ", "Metadata can only be applied to IMetas."]));
}, lde = function(e, n, t) {
  return n = Y3(Mx, "}", e, t), t = Us(n), on.g(Cn(n), Cn(t)) || qL(e, Mx, n), t;
}, rde = function(e) {
  return Ro ? Ro(e, !0, null, !0) : Ww.call(null, e, !0, null, !0), e;
}, ide = function(e, n, t) {
  n = Ko(e), n = K4(e, wD, n, !0);
  var l = n == null ? null : Rv(n);
  if (l == null) var r = null;
  else r = O.j(l, 0, null), l = O.j(l, 1, null), r = j(r) ? null : l;
  return j(r) ? eG(e) === "{" ? (t = Y3(wD, "}", e, t), !qc(Cn(t)) && QK(e, null, null, t), n = SI(ye.h(r), Po.g(2, t)), t = Po.g(2, tn(t)), on.g(Cn(Us(n)), Cn(n)) || qL(e, wD, n), _a(n, t)) : bs(e, Te(["Namespaced map with namespace ", n, " does not specify a map."])) : bs(e, Te(["Invalid value used as namespace in namespaced map: ", n, "."]));
}, cE = function(e, n, t) {
  return n = Ro ? Ro(e, !0, null, t) : Ww.call(null, e, !0, null, t), on.g(Wge, n) ? Number.NaN : on.g(Q2e, n) ? Number.NEGATIVE_INFINITY : on.g(wge, n) ? Number.POSITIVE_INFINITY : bs(e, Te([[
    "Invalid token: ##",
    ye.h(n)
  ].join("")]));
}, Ac = function(e) {
  switch (e) {
    case '"':
      return ede;
    case ":":
      return tde;
    case ";":
      return h5;
    case "^":
      return rG;
    case "(":
      return Zfe;
    case ")":
      return xA;
    case "[":
      return Xfe;
    case "]":
      return xA;
    case "{":
      return Qfe;
    case "}":
      return xA;
    case "\\":
      return oE;
    case "#":
      return Gfe;
    default:
      return null;
  }
}, SA = function(e) {
  switch (e) {
    case "^":
      return rG;
    case "{":
      return lde;
    case "<":
      return Kfe();
    case "!":
      return h5;
    case "_":
      return rde;
    case ":":
      return ide;
    case "#":
      return cE;
    default:
      return null;
  }
}, EA = function(e, n, t) {
  n = Ro ? Ro(e, !0, null, t) : Ww.call(null, e, !0, null, t);
  var l = Ro ? Ro(e, !0, null, t) : Ww.call(null, e, !0, null, t);
  n instanceof T || bs(e, Te(["Invalid reader tag: ", As.g(!1, "Reader tag must be a symbol"), ". Reader tags must be symbols."]));
  var r = en.g(of.h(t), n);
  return r = j(r) ? r : Tt.h ? Tt.h(n) : Tt.call(null, n), j(r) ? r.h ? r.h(l) : r.call(null, l) : (t = ai.h(t), j(t) ? t.g ? t.g(n, l) : t.call(null, n, l) : bs(e, Te(["No reader function for tag ", As.g(!1, n), "."])));
}, Ww = function(e) {
  switch (arguments.length) {
    case 1:
      return Ey(Tt, arguments[0]);
    case 2:
      return Ey(arguments[0], arguments[1]);
    case 4:
      return Ro(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
}, Ey = function(e, n) {
  e = fr(e);
  var t = en.g(e, qf), l = !Ol(e, qf);
  return Ro(n, l, t, e);
}, Ro = function(e, n, t, l) {
  try {
    for (; ; ) {
      var r = Ko(e);
      if (!ep(r)) {
        if (r == null) {
          if (j(n)) {
            n = e;
            var u = j(null) ? qw(n, Te(["EOF while reading, starting at line ", null, "."])) : qw(n, Te(["EOF while reading."]));
          } else u = t;
          return u;
        }
        if (sE(e, r)) return Jfe(e, r);
        var o = Ac(r);
        if (j(o)) {
          var a = o.j ? o.j(e, r, l) : o.call(null, e, r, l);
          if (a !== e) return a;
        } else return nde(e, r);
      }
    }
  } catch (h) {
    throw h instanceof Error ? (u = h, u instanceof ld ? (n = ax(u), on.g(vE, zi.h(n)) ? u : Yr.j(u.message, gr.l(Te([new $(null, 1, [zi, vE], null), n, Pc(e) ? new $(null, 3, [Yn, Lm(e), zn, Bm(e), Bn, hx(e)], null) : null])), u)) : Yr.j(u.message, gr.l(Te([new $(null, 1, [zi, vE], null), Pc(e) ? new $(null, 3, [Yn, Lm(e), zn, Bm(e), Bn, hx(e)], null) : null])), u)) : h;
  }
}, iG = function(e, n) {
  return j(j(n) ? xa.g(n, "") : n) ? Ey(e, x1(n)) : null;
}, Dd = function(e) {
  return e = parseInt(e, 10), er(isNaN(e)) ? e : null;
}, lv = function(e, n, t, l) {
  if (!(e <= n && n <= t)) throw Error([ye.h(l), " Failed:  ", ye.h(e), "<=", ye.h(n), "<=", ye.h(t)].join(""));
  return n;
}, ude = function(e) {
  var n = L4(Exe, e);
  O.j(n, 0, null);
  var t = O.j(n, 1, null), l = O.j(n, 2, null), r = O.j(n, 3, null), u = O.j(n, 4, null), o = O.j(n, 5, null), a = O.j(n, 6, null), h = O.j(n, 7, null), s = O.j(n, 8, null), d = O.j(n, 9, null), p = O.j(n, 10, null);
  if (er(n)) throw Error(["Unrecognized date/time syntax: ", ye.h(e)].join(""));
  e = Dd(t), n = function() {
    var G = Dd(l);
    return j(G) ? G : 1;
  }(), t = function() {
    var G = Dd(r);
    return j(G) ? G : 1;
  }();
  var _ = function() {
    var G = Dd(u);
    return j(G) ? G : 0;
  }(), R = function() {
    var G = Dd(o);
    return j(G) ? G : 0;
  }(), F = function() {
    var G = Dd(a);
    return j(G) ? G : 0;
  }(), L = function() {
    e: if (on.g(3, Cn(h))) var G = h;
    else if (3 < Cn(h)) G = Si.j(h, 0, 3);
    else for (G = new Ts(h); ; ) if (3 > G.getLength()) G = G.append("0");
    else {
      G = G.toString();
      break e;
    }
    return G = Dd(G), j(G) ? G : 0;
  }();
  return s = (on.g(s, "-") ? -1 : 1) * (60 * function() {
    var G = Dd(d);
    return j(G) ? G : 0;
  }() + function() {
    var G = Dd(p);
    return j(G) ? G : 0;
  }()), new v(
    null,
    8,
    5,
    y,
    [e, lv(1, n, 12, "timestamp month field must be in range 1..12"), lv(1, t, Sxe(n, ya(e, 4) === 0 && (ya(e, 100) !== 0 || ya(e, 400) === 0)), "timestamp day field must be in range 1..last day in month"), lv(0, _, 23, "timestamp hour field must be in range 0..23"), lv(0, R, 59, "timestamp minute field must be in range 0..59"), lv(0, F, on.g(R, 59) ? 60 : 59, "timestamp second field must be in range 0..60"), lv(0, L, 999, "timestamp millisecond field must be in range 0..999"), s],
    null
  );
}, hE = function(e) {
  if (typeof e == "string") {
    var n = ude(e);
    if (j(n)) {
      e = O.j(n, 0, null);
      var t = O.j(n, 1, null), l = O.j(n, 2, null), r = O.j(n, 3, null), u = O.j(n, 4, null), o = O.j(n, 5, null), a = O.j(n, 6, null);
      n = O.j(n, 7, null), n = new Date(Date.UTC(e, t - 1, l, r, u, o, a) - 6e4 * n);
    } else throw Error(["Unrecognized date/time syntax: ", ye.h(e)].join(""));
    return n;
  }
  throw Error("Instance literal expects a string for its timestamp.");
}, Bh = function(e) {
  if (or(e)) {
    var n = [];
    e = z(e);
    for (var t = null, l = 0, r = 0; ; ) if (r < l) {
      var u = t.Y(null, r);
      n.push(u), r += 1;
    } else if (e = z(e)) t = e, oi(t) ? (e = Jr(t), r = Wr(t), t = e, l = Cn(e), e = r) : (e = I(t), n.push(e), e = W(t), t = null, l = 0), r = 0;
    else break;
    return n;
  }
  if (ci(e)) {
    for (n = {}, e = z(e), t = null, r = l = 0; ; ) if (r < l) {
      var o = t.Y(null, r);
      u = O.j(o, 0, null), o = O.j(o, 1, null), u = ml(u), n[u] = o, r += 1;
    } else if (e = z(e)) oi(e) ? (l = Jr(e), e = Wr(e), t = l, l = Cn(l)) : (l = I(e), t = O.j(l, 0, null), l = O.j(l, 1, null), t = ml(t), n[t] = l, e = W(e), t = null, l = 0), r = 0;
    else break;
    return n;
  }
  throw Error("JS literal expects a vector or map containing only string or unqualified keyword keys");
}, G4 = function(e) {
  var n = Xf.g(e, "-");
  e = O.j(n, 0, null);
  var t = O.j(n, 1, null);
  return n = O.j(
    n,
    2,
    null
  ), new Date([ye.h(e), "/", ye.h(t), "/", ye.h(n)].join(""));
}, ia = function(e, n) {
  var t = Oxe[e];
  if (t !== void 0) return t;
  try {
    RH.push(e);
    var l = IH[e], r = Xo[e];
    if (l === void 0) {
      if (r === void 0) throw "Module not provided: " + e;
      l = { exports: {} }, IH[e] = l;
    }
    if (r) {
      delete Xo[e];
      try {
        r.call(l, cZ, ia, l, l.exports);
      } catch (o) {
        throw console.warn("shadow-cljs - failed to load", e), console.error(o), o;
      }
      if (n) {
        var u = n.globals;
        if (u) for (e = 0; e < u.length; e++) window[u[e]] = l.exports;
      }
    }
  } finally {
    RH.pop();
  }
  return l.exports;
}, fx = function(e) {
  return e instanceof de ? ml(e) : e;
}, LU = function(e, n) {
  var t = z(n);
  for (I(t), t = W(t), I(t), W(t); ; ) {
    t = z(n), n = I(t), t = W(t);
    var l = I(t);
    if (t = W(t), e[fx(n)] = l, t) n = t;
    else break;
  }
}, sde = function(e, n) {
  return n = 0 < n ? n : 0, e = e.doc.length, n < e ? n : e;
}, Dc = function(e, n) {
  return j(n.h ? n.h(e) : n.call(null, e)) ? e : null;
}, dx = function(e, n) {
  return e > n ? { from: n, to: e } : { from: e, to: n };
}, WL = function(e, n) {
  return j(n) ? (e.dispatch(n), !0) : !1;
}, fE = function(e, n, t) {
  return new $(null, 2, [Za, new $(null, 3, [fh, t, fo, e, Op, n], null), Bs, e + t.length], null);
}, BU = function(e, n) {
  return on.g(e, n) && (--e, e = 0 > e ? 0 : e), new $(null, 2, [Bs, e, Za, new $(null, 2, [fo, e, Op, n], null)], null);
}, fw = function(e, n) {
  return Oy(e, null, n);
}, Oy = function(e, n, t) {
  return e.update(ip.g(e.changeByRange(function(l) {
    var r = t.h ? t.h(l) : t.call(null, l);
    if (r == null) r = null;
    else {
      r = Dc(r, ci), r = fr(r);
      var u = en.g(r, kee), o = en.g(r, Bs), a = en.g(r, bZ), h = en.g(r, Tx);
      r = en.g(r, Za), r = j(r) ? e.changes(Bc(r)) : null, j(h) ? a = h : (j(u) ? a = Ru.EditorSelection.cursor(r.mapPos(u)) : j(o) ? a = Ru.EditorSelection.cursor(o) : j(a) ? (u = a.h ? a.h(0) : a.call(null, 0), a = a.h ? a.h(1) : a.call(null, 1), a = Ru.EditorSelection.range(u, a)) : a = null, a = j(a) ? a : l), a = { range: a }, j(r) && (a.changes = r), r = a;
    }
    return j(r) ? r : { range: l };
  }), n));
}, ode = function(e) {
  for (var n = [], t = arguments.length, l = 0; l < t; ) n.push(arguments[l]), l += 1;
  return ade(arguments[0], arguments[1], 2 < n.length ? new hn(n.slice(2), 0, null) : null);
}, ade = function(e, n, t) {
  t = O.j(t, 0, null), t = fr(t);
  var l = en.j(t, fo, 0), r = en.g(t, Op);
  t = en.g(t, oge);
  for (var u = e.doc.iter(), o = u.next(), a = [], h = l, s = 1; ; ) {
    var d = o, p = d != null && (d.C & 64 || Rn === d.V) ? In.g(tr, d) : d, _ = function() {
      var J = p;
      if (J != null) return J.done;
    }(), R = function() {
      var J = p;
      if (J != null) return J.lineBreak;
    }(), F = function() {
      var J = p;
      if (J != null) return J.value;
    }();
    if (j(function() {
      var J = _;
      return j(J) ? J : l > r;
    }())) return e.update(ip.g({ changes: e.changes(a) }, t));
    o = u.next(), d = function() {
      var J = (J = er(R)) ? n.j ? n.j(h, F, s) : n.call(null, h, F, s) : J;
      if (j(J)) {
        var we = a;
        return we.push(J), we;
      }
      return a;
    }();
    var L = h + F.length, G = function() {
      var J = s;
      return j(R) ? J + 1 : J;
    }();
    a = d, h = L, s = G;
  }
}, cde = function(e, n) {
  var t = kr.h(-1), l = e.doc;
  return e.changeByRange(function(r) {
    for (var u = r != null && (r.C & 64 || Rn === r.V) ? In.g(tr, r) : r, o = u?.from, a = u?.to, h = u?.anchor, s = u?.head, d = [], p = l.lineAt(o); ; ) {
      var _ = p, R = _ != null && (_.C & 64 || Rn === _.V) ? In.g(tr, _) : _, F = function() {
        var J = R;
        if (J != null) return J.number;
      }(), L = function() {
        var J = R;
        if (J != null) return J.to;
      }();
      p.number > sn(t) && (Qa(t, F), n.j ? n.j(p, d, u) : n.call(null, p, d, u));
      var G = function() {
        var J = a > L;
        return J && Dc(l.lineAt(L + 1), /* @__PURE__ */ function(we, ce, xe, $e, je) {
          return function(E) {
            return E.number > je;
          };
        }(p, J, _, R, F));
      }();
      if (j(G)) p = G;
      else return G = e.changes(d), { changes: d, range: Ru.EditorSelection.range(G.mapPos(h, 1), G.mapPos(s, 1)) };
    }
  });
}, hde = function(e, n) {
  var t = e != null && (e.C & 64 || Rn === e.V) ? In.g(tr, e) : e;
  e = t?.state;
  var l = e != null && (e.C & 64 || Rn === e.V) ? In.g(tr, e) : e, r = l?.doc, u = t?.changes;
  e = t?.effects;
  var o = t?.selection, a = kr.h(-1), h = [];
  u.iterChanges(function(p, _, R, F) {
    for (p = r.lineAt(R), R = p != null && (p.C & 64 || Rn === p.V) ? In.g(tr, p) : p, p = R?.number, _ = R?.to; ; ) {
      if (p > sn(a) && (Qa(a, p), n.g ? n.g(R, h) : n.call(null, R, h)), F <= _) return null;
      var L = r.lineAt(_ + 1), G = L;
      if (j(j(G) ? L.number > R.number : G)) R = L;
      else return null;
    }
  });
  var s = l.changes(h);
  if (z(h)) {
    var d = function() {
      if (t != null) {
        var p = {};
        "annotations" in t && (p.annotations = t.annotations), "scrollIntoView" in t && (p.scrollIntoView = t.scrollIntoView), "reconfigure" in t && (p.reconfigure = t.reconfigure);
      } else p = {};
      return p = p ?? {}, p.changes = u.compose(s), p;
    }();
    return o = j(o) ? function() {
      var p = d ?? {};
      return p.selection = l.selection.map(s), p;
    }() : d, j(e) && (o = o ?? {}, o.effects = Ru.StateEffect.mapEffects(e, s)), o;
  }
  return t;
}, fde = function(e) {
  return e = e != null && (e.C & 64 || Rn === e.V) ? In.g(tr, e) : e, e = e?.selection, e = e != null && (e.C & 64 || Rn === e.V) ? In.g(tr, e) : e, e = e?.ranges, !hu(function(n) {
    return n.empty;
  }, e);
}, tk = function(e) {
  for (var n = 0; ; ) {
    if (e = e.parent, e == null) return n;
    n += 1;
  }
}, Nv = function(e) {
  return e.parent.childBefore(e.from);
}, ym = function(e) {
  return e.parent.childAfter(e.to);
}, dde = function(e) {
  return e.type.prop(dF);
}, pde = function(e) {
  return e.type.prop(bxe);
}, lk = function(e) {
  return e.type.prop(Mb);
}, rk = function(e) {
  return e.type.prop(Pb);
}, HL = function(e) {
  return e.prop(Mb) || e.prop(D2) || e.prop(dF);
}, zL = function(e) {
  return e.prop(Pb) || e.prop(D2);
}, KL = function(e) {
  return e = e.type.prop(Cb.NodeProp.closedBy), e == null ? null : e[0];
}, bI = function(e) {
  return e.type.isTop;
}, FU = function(e) {
  return e.name === "Program";
}, px = function(e) {
  return e.name === "String";
}, mx = function(e) {
  return e.name === "LineComment";
}, np = function(e) {
  return e.type.prop(fF);
}, uG = function(e) {
  return e.isTop || j(e.prop(Dne)) || j(e.prop(fF)) || e.name === "Meta" || e.name === "TaggedLiteral" ? !1 : e.name !== "ConstructorCall";
}, GL = function(e) {
  var n = e != null && (e.C & 64 || Rn === e.V) ? In.g(tr, e) : e;
  e = n?.firstChild, n = n?.lastChild;
  var t = KL(e);
  return j(t) ? on.g(t, n.name) && xa.g(e.to, n.to) : !0;
}, dw = function(e, n) {
  return j(n.h ? n.h(e) : n.call(null, e)) ? e : wt.j(function(t, l) {
    return j(n.h ? n.h(l) : n.call(null, l)) ? xh(l) : null;
  }, null, m5(e));
}, mde = function(e, n) {
  return wt.j(function(t, l) {
    return j(n.h ? n.h(l) : n.call(null, l)) ? l : xh(t);
  }, null, kt(e, m5(e)));
}, ZL = function(e, n, t) {
  e: switch (t) {
    case 1:
      var l = e.childAfter(n);
      break e;
    case -1:
      l = e.childBefore(n);
      break e;
    default:
      throw Error(["No matching clause: ", ye.h(t)].join(""));
  }
  return l == null ? null : kt(l, new rr(null, function() {
    var r = ZL;
    e: switch (t) {
      case 1:
        var u = l.to;
        break e;
      case -1:
        u = l.from;
        break e;
      default:
        throw Error(["No matching clause: ", ye.h(t)].join(""));
    }
    return r(
      e,
      u,
      t
    );
  }, null, null));
}, sG = function(e, n) {
  return e.from === n.from && e.to === n.to && tk(e) === tk(n);
}, ik = function(e) {
  return { from: e.from, to: e.to };
}, xv = function(e, n) {
  return pu(e.from <= n.from && e.to >= n.to && tk(e) < tk(n));
}, gde = function(e, n) {
  if (sG(e, n)) return null;
  var t = Gh(n.from, e.from);
  switch (t) {
    case 0:
      return xv(n, e) ? e.parent : xv(e, n) ? e.firstChild : null;
    case -1:
      return xv(e, n) ? e.lastChild : (n = Nv(e), j(n) ? n : e.parent);
    case 1:
      return xv(e, n) ? e.firstChild : (n = ym(e), j(n) ? n : e.parent);
    default:
      throw Error([
        "No matching clause: ",
        ye.h(t)
      ].join(""));
  }
}, wde = function(e, n) {
  return vo.g(No, Yw(function(t) {
    return gde(t, n);
  }, e));
}, VU = function(e) {
  var n = np(e);
  return j(n) ? n : px(e) || e.name === "RegExp";
}, fp = function(e, n) {
  return Xu.syntaxTree(e).resolveInner(n);
}, Jh = function(e, n, t) {
  return Xu.syntaxTree(e).resolveInner(n, t);
}, vde = function(e) {
  var n = e.from, t = mde(e, function(l) {
    return on.g(n, l.from);
  });
  return j(t) ? t : e;
}, yde = function(e, n, t) {
  for (e = vde(Jh(e, n, 1).node).cursor(), n = Dt; ; ) {
    var l = e.type;
    if (e.from > t) return n;
    if (uG(l) || l.isError) {
      if (n = yt.g(n, {
        type: l,
        from: e.from,
        to: e.to
      }), e.lastChild(), !j(e.next())) return n;
    } else if (!j(e.next())) return n;
  }
}, dE = function(e, n, t) {
  t = Lf.h(new v(null, 2, 5, y, [n, t], null)), n = O.j(t, 0, null), t = O.j(t, 1, null);
  var l = Jh(e, n, 1), r = Jh(e, t, -1);
  return e = j(VU(l)) ? l.from : n, n = j(VU(r)) ? r.to : t, n = wt.j(function(u, o) {
    var a = O.j(u, 0, null);
    return u = O.j(u, 1, null), new v(null, 2, 5, y, [xv(o, l) ? o.from : a, xv(o, r) ? o.to : u], null);
  }, new v(null, 2, 5, y, [e, n], null), bt.g(function(u) {
    var o = u.type;
    return o.prop(Mb) || o.prop(Pb) || o.prop(D2) || o.prop(Dne) ? u.parent : u;
  }, wde(l, r))), e = O.j(n, 0, null), n = O.j(n, 1, null), Ru.EditorSelection.range(e, n);
}, oG = function(e) {
  e = e != null && (e.C & 64 || Rn === e.V) ? In.g(tr, e) : e;
  var n = e?.firstChild, t = e?.lastChild;
  return { from: HL(n.type) ? n.to : e.from, to: zL(t.type) ? t.from : e.to };
}, aG = function(e) {
  if (e = e.parent, e == null) return null;
  var n = Dc(e, pde);
  return j(n) ? n : Dc(e.firstChild, dde);
}, cG = function(e, n) {
  var t = ye, l = t.h, r = aG(n);
  return e = r == null ? null : e.doc.sliceString(r.from, r.to, `
`), [l.call(t, e), n.firstChild.name].join("");
}, vv = function(e) {
  return j(aG(e)) ? e.parent : e;
}, _de = function(e, n) {
  return e = Jh(e, n, -1), e == null ? null : Dc(e, function(t) {
    return on.g(n, t.to);
  });
}, hG = function(e, n) {
  var t = function() {
    var o = Jh(e, n, -1);
    return o == null ? null : Dc(o, function(a) {
      return a = a != null && (a.C & 64 || Rn === a.V) ? In.g(tr, a) : a, a = a?.to, on.g(n, a);
    });
  }(), l = function() {
    var o = Jh(e, n, 1);
    return o == null ? null : Dc(o, function(a) {
      return a = a != null && (a.C & 64 || Rn === a.V) ? In.g(tr, a) : a, a = a?.from, on.g(n, a);
    });
  }(), r = fp(e, n), u = Dc(t, mf.g(nK, function(o) {
    return o.type.prop(D2) || !HL(o.type);
  }));
  return j(u) ? u : j(l) ? l : j(t) ? t : r;
}, XL = function(e) {
  return fG(e, e.selection.main.head);
}, fG = function(e, n) {
  return e = fp(e, n), (n = FU(e)) ? n : fu(FU, m5(e));
}, dG = function(e, n) {
  return e = fp(e, n).name, n = new gi(null, new $(null, 2, ["StringContent", null, "String", null], null), null), n.h ? n.h(e) : n.call(null, e);
}, pG = function(e, n) {
  var t = n - 1;
  return on.g("\\", e.doc.slice(0 > t ? 0 : t, n).toString());
}, xde = function(e) {
  var n = e != null && (e.C & 64 || Rn === e.V) ? In.g(tr, e) : e;
  return j(function() {
    var t = on.g(1, n.selection.ranges.length);
    if (t) {
      t = n?.selection, t = t?.ranges, t = t?.[0];
      var l = t.empty;
      return j(l) ? on.g(0, t.from) : l;
    }
    return t;
  }()) ? null : Oy(n, { annotations: Ru.Transaction.userEvent.of("delete") }, function(t) {
    var l = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t, r = l?.empty;
    t = l?.head, l = l?.anchor, t = dx(t, l), l = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t, t = l?.from, l = l?.to;
    var u = Xu.syntaxTree(n).resolveInner(t, -1), o = u.parent;
    return r = er(r), r || (r = (r = on.g(
      "StringContent",
      Jh(n, t, -1).name
    )) ? r : j(o) ? !GL(o) && HL(u.type) : o), j(r) ? t = BU(t, l) : zL(u.type) && t === o.to ? t = new $(null, 1, [Bs, t - 1], null) : (lk(u) || u.type.prop(D2)) && u.from === o.from ? (l = u.parent, r = l.name, t = (j(np(l)) ? sG(ym(l.firstChild), l.lastChild) : on.g("String", r) && l.firstChild.to === l.lastChild.from) ? new $(null, 2, [Bs, o.from, Za, new v(null, 1, 5, y, [dx(o.from, o.to)], null)], null) : new $(null, 1, [Bs, t], null)) : (r = _de(n, t - 1), r = r == null ? null : Dc(r, mx), j(r) && (r = n.doc, r = r.lineAt.call(r, t), r = r.slice.call(r), r = !U4(r)), t = j(r) ? new $(null, 1, [
      Bs,
      t - 1
    ], null) : BU(t, l)), t;
  });
}, Sde = function(e, n) {
  var t = vD.h ? vD.h(n) : vD.call(null, n);
  return Oy(e, { annotations: Ru.Transaction.userEvent.of("input") }, function(l) {
    var r = l != null && (l.C & 64 || Rn === l.V) ? In.g(tr, l) : l;
    l = r?.from;
    var u = r?.to, o = r?.head, a = r?.anchor;
    return r = r?.empty, j(dG(e, l)) ? on.g(n, '"') ? fE(o, o, '\\"') : fE(l, u, n) : pG(e, l) ? fE(l, u, n) : j(r) ? new $(null, 2, [Za, new $(null, 2, [fh, [n, t].join(""), fo, o], null), Bs, o + n.length], null) : new $(
      null,
      2,
      [Za, new v(null, 2, 5, y, [new $(null, 2, [fh, n, fo, l], null), new $(null, 2, [fh, t, fo, u], null)], null), bZ, new v(null, 2, 5, y, [a + n.length, o + n.length], null)],
      null
    );
  });
}, Ede = function(e, n) {
  return Oy(e, { annotations: Ru.Transaction.userEvent.of("input") }, function(t) {
    var l = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t;
    t = l?.empty;
    var r = l?.head, u = l?.from;
    return l = l?.to, j(function() {
      var o = dG(e, u);
      return j(o) ? o : pG(e, u);
    }()) ? fE(u, l, n) : j(t) ? (t = function() {
      var o = function() {
        var s = Jh(e, r, -1);
        return s = s == null ? null : m5(s), s = s == null ? null : Ou.g(mf.g(np, Dp(GL)), s), s == null ? null : I(s);
      }(), a = function() {
        var s = o == null ? null : o.firstChild;
        return s == null ? null : KL(s);
      }(), h = o == null ? null : o.to;
      return j(j(a) ? on.g(a, n) : a) ? new $(null, 2, [Za, new $(null, 2, [fo, h, fh, a], null), Bs, h + 1], null) : null;
    }(), j(t) ? t : (t = function() {
      var o = function() {
        e:
          for (var a = Xu.syntaxTree(e), h = r; ; ) {
            var s = a.cursorAt(h, 1);
            if (s.type.isTop) {
              a = null;
              break e;
            }
            if (uG(s.type)) {
              a = s;
              break e;
            }
            h = 1 + h;
          }
        if (j(a)) for (; ; ) {
          if (zL(a.type)) return a.to;
          if (!j(a.next())) return null;
        }
        else return null;
      }();
      return j(o) ? new $(null, 1, [Bs, o], null) : null;
    }(), j(t) ? t : new $(null, 1, [Bs, r], null))) : null;
  });
}, TS = function(e) {
  return function(n) {
    n = n != null && (n.C & 64 || Rn === n.V) ? In.g(tr, n) : n;
    var t = n?.state;
    return WL(n, Sde(t, e));
  };
}, OA = function(e) {
  return function(n) {
    n = n != null && (n.C & 64 || Rn === n.V) ? In.g(tr, n) : n;
    var t = n?.state;
    return WL(n, Ede(t, e));
  };
}, em = function(e) {
  return function(n) {
    n = n != null && (n.C & 64 || Rn === n.V) ? In.g(tr, n) : n;
    var t = n?.state, l = Ane.parser.nodeTypes.FencedCode === t.tree.resolve(t.selection.main.head).type.id;
    return t = j(l) ? l : XL(t), j(t) ? e.h ? e.h(n) : e.call(null, n) : !1;
  };
}, mG = function() {
  return Ru.Prec.high(Do.keymap.of([{ key: "Backspace", run: em(function(e) {
    e = e != null && (e.C & 64 || Rn === e.V) ? In.g(tr, e) : e;
    var n = e?.state;
    return WL(e, xde(n));
  }) }, { key: "(", run: em(TS("(")) }, { key: "[", run: em(TS("[")) }, { key: "{", run: em(TS("{")) }, { key: '"', run: em(TS('"')) }, { key: ")", run: em(OA(")")) }, { key: "]", run: em(OA("]")) }, { key: "}", run: em(OA("}")) }]));
}, jS = function(e, n) {
  return n.range(e.from, e.to);
}, TI = function() {
  return [Txe, MH, Do.EditorView.decorations.from(MH)];
}, Ode = function(e, n, t) {
  var l = OL(Ou.g(function(r) {
    return n <= r.from && r.from <= t || n <= r.to && r.to <= t;
  }, yde(e, n, t)));
  return e = function() {
    var r = I(l);
    return r = r == null ? null : r.to, r == null ? null : r < t;
  }(), wt.j(function(r, u) {
    var o = O.j(u, 0, null), a = o != null && (o.C & 64 || Rn === o.V) ? In.g(tr, o) : o;
    o = a?.type, a = a?.from, u = O.j(u, 1, null);
    var h = u != null && (u.C & 64 || Rn === u.V) ? In.g(tr, u) : u;
    switch (u = h?.to, h = h?.type, o = h.prop(Mb) || h.prop(dF) || o.prop(Pb) || o.prop(D2) ? 0 : 1, Gh(a - u, o)) {
      case 0:
        return r;
      case 1:
        return r.push({ from: o === 0 ? u : u + 1, to: a }), r;
      case -1:
        return r.push({ from: u, insert: " " }), r;
      default:
        return r;
    }
  }, j(e) ? [{ from: I(l).to, to: t }] : [], Mo.j(2, 1, l));
}, kde = function(e, n) {
  n = z(n);
  for (var t = null, l = 0, r = 0; ; ) if (r < l) {
    var u = t.Y(null, r);
    e.push(u), r += 1;
  } else if (n = z(n)) t = n, oi(t) ? (n = Jr(t), r = Wr(t), t = n, l = Cn(n), n = r) : (n = I(t), e.push(n), n = W(t), t = null, l = 0), r = 0;
  else break;
  return e;
}, QL = function(e, n, t, l, r) {
  var u = /^\s*/.exec(l)[0].length, o = Dc(Xu.getIndentation(n.state, t), Dp(oI));
  return n = j(o) ? function() {
    var a = Gh(o, u);
    switch (a) {
      case 0:
        return null;
      case 1:
        return { from: t + u, insert: Xu.indentString(e, o - u) };
      case -1:
        return { from: t + o, to: t + u };
      default:
        throw Error(["No matching clause: ", ye.h(a)].join(""));
    }
  }() : null, l = j(function() {
    if (j(!0)) {
      var a = Ane.parser.nodeTypes.FencedCode === e.tree.resolve(t).type.id;
      return a || fG(e, t);
    }
    return !0;
  }()) ? Ode(e, t + u, t + Cn(l)) : null, r = j(l) ? kde(r, l) : r, j(n) && r.push(n), r;
}, gG = function(e) {
  var n = new Xu.IndentContext(e);
  return cde(e, function(t, l) {
    var r = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t;
    return t = r?.from, r = r?.text, QL(e, n, t, r, l);
  });
}, bde = function(e) {
  var n = new Xu.IndentContext(e);
  return ode(e, function(t, l) {
    return QL(e, n, t, l, []);
  });
}, jI = function(e) {
  var n = e.annotation(Ru.Transaction.userEvent), t = j(XL(e.startState)) ? function() {
    switch (n) {
      case "input":
      case "input.type":
      case "delete":
      case "keyboardselection":
      case "pointerselection":
      case "select.pointer":
      case "cut":
      case "noformat":
      case "evalregion":
        return null;
      case "format-selections":
        return gG(e.state);
      default:
        if (j(e.changes.empty)) return null;
        var l = e.state, r = new Xu.IndentContext(l);
        return hde(e, function(u, o) {
          return QL(l, r, u.from, u.text, o);
        });
    }
  }() : null;
  return t == null ? e : e.startState.update(function() {
    var l = t ?? {};
    return l.filter = !1, l;
  }());
}, Tde = function(e) {
  return fu(function(n) {
    return er(n.empty);
  }, e.ranges);
}, jde = function(e, n, t) {
  return e = hG(e, t), I(Ou.g(function(l) {
    var r = l != null && (l.C & 64 || Rn === l.V) ? In.g(tr, l) : l;
    return l = r?.from, r = r?.to, l <= n && r >= t && !(l === n && r === t);
  }, kt(e, na.l(Yf.g(oG, No), Te([m5(e)])))));
}, _c = function(e) {
  return function(n) {
    var t = n != null && (n.C & 64 || Rn === n.V) ? In.g(tr, n) : n;
    return n = t?.state, t = t?.dispatch, n = e.h ? e.h(n) : e.call(null, n), n != null && (t.h ? t.h(n) : t.call(null, n)), !0;
  };
}, YU = function(e) {
  var n = document;
  n = n?.activeElement;
  var t = document.createElement("textarea");
  t.setAttribute("class", "clipboard-input"), (t ?? {}).innerHTML = e, document.body.appendChild(t), t.focus({ preventScroll: !0 }), t.select(), document.execCommand("copy"), n.focus({ preventScroll: !0 }), document.body.removeChild(t);
}, pE = function(e, n, t) {
  var l = function() {
    var r = dw(fp(e, n), function(o) {
      var a = np(o);
      return j(a) ? a : px(o) || bI(o);
    });
    if (r = r == null ? null : ZL(r, n, t), r = r == null ? null : I(r), r == null) return null;
    if (r != null) {
      e: switch (t) {
        case -1:
          var u = fo;
          break e;
        case 1:
          u = Op;
          break e;
        default:
          throw Error(["No matching clause: ", ye.h(t)].join(""));
      }
      return r[fx(u)];
    }
  }();
  return j(l) ? l : sde(e, n + t);
}, UU = function(e) {
  return function(n) {
    return fw(n, function(t) {
      var l = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t;
      t = l?.from;
      var r = l?.to;
      if (l = l?.empty, j(l)) t = new $(null, 1, [Bs, pE(n, t, e)], null);
      else {
        if (t = dx(t, r), t != null) {
          e: switch (e) {
            case -1:
              r = fo;
              break e;
            case 1:
              r = Op;
              break e;
            default:
              throw Error(["No matching clause: ", ye.h(e)].join(""));
          }
          t = t[fx(r)];
        } else t = void 0;
        t = new $(null, 1, [Bs, t], null);
      }
      return t;
    });
  };
}, qU = function(e) {
  return function(n) {
    return fw(n, function(t) {
      var l = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t;
      t = l?.from;
      var r = l?.to;
      if (l = l?.empty, j(l)) t = new $(null, 1, [Tx, dE(n, t, pE(n, t, e))], null);
      else {
        e: switch (t = dx(t, r), r = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t, t = r?.from, r = r?.to, e) {
          case 1:
            t = dE(n, t, pE(n, r, e));
            break e;
          case -1:
            t = dE(n, pE(n, t, e), r);
            break e;
          default:
            throw Error(["No matching clause: ", ye.h(e)].join(""));
        }
        t = new $(null, 1, [Tx, t], null);
      }
      return t;
    });
  };
}, WU = function(e) {
  return function(n) {
    return fw(n, function(t) {
      var l = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t;
      if (t = l?.from, l = l?.empty, j(l)) {
        var r = dw(fp(n, t), mf.g(np, function(o) {
          e: switch (e) {
            case 1:
              o = o == null ? null : vv(o), o = o == null ? null : ym(o), o = o == null ? null : rk(o);
              break e;
            case -1:
              o = o == null ? null : vv(o), o = o == null ? null : Nv(o), o = o == null ? null : lk(o);
              break e;
            default:
              throw Error(["No matching clause: ", ye.h(e)].join(""));
          }
          return er(o);
        }));
        if (j(r)) {
          e: switch (e) {
            case 1:
              var u = I(Ia.g(mx, vo.g(No, Yw(ym, ym(vv(r))))));
              break e;
            case -1:
              u = I(Ia.g(mx, vo.g(No, Yw(Nv, Nv(vv(r))))));
              break e;
            default:
              throw Error([
                "No matching clause: ",
                ye.h(e)
              ].join(""));
          }
          return j(u) ? new $(null, 2, [kee, t, Za, function() {
            switch (e) {
              case 1:
                var o = r.lastChild, a = y, h = new $(null, 2, [fo, u.to, fh, o.name], null);
                return o = ik(o), o = o ?? {}, o.insert = " ", new v(null, 2, 5, a, [h, o], null);
              case -1:
                return o = cG(n, r), a = vv(r).from, new v(null, 2, 5, y, [new $(null, 3, [fo, a, Op, a + o.length, fh, " "], null), new $(null, 2, [fo, u.from, fh, o], null)], null);
              default:
                throw Error(["No matching clause: ", ye.h(e)].join(""));
            }
          }()], null) : null;
        }
      }
      return null;
    });
  };
}, HU = function(e) {
  return function(n) {
    return fw(
      n,
      function(t) {
        t = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t;
        var l = t?.from;
        if (t = t?.empty, j(t)) {
          var r = dw(fp(n, l), np);
          if (j(r)) switch (e) {
            case 1:
              if (t = function() {
                var h = r.lastChild;
                return h = h == null ? null : vo.g(No, Yw(Nv, Nv(h))), h = h == null ? null : Ia.g(mx, h), h = h == null ? null : uu.g(1, h), h == null ? null : I(h);
              }(), j(t)) {
                var u = t;
                return new $(null, 2, [Bs, function() {
                  var h = u.to;
                  return h < l ? h : l;
                }(), Za, new v(null, 2, 5, y, [new $(null, 2, [fo, u.to, fh, r.lastChild.name], null), function() {
                  var h = ik(r.lastChild);
                  return h = h ?? {}, h.insert = " ", h;
                }()], null)], null);
              }
              return null;
            case -1:
              if (t = function() {
                var h = r.firstChild;
                return h = h == null ? null : vo.g(No, Yw(ym, ym(h))), h = h == null ? null : Ia.g(mx, h), h = h == null ? null : uu.g(1, h), h == null ? null : I(h);
              }(), j(t)) {
                var o = t, a = cG(n, r);
                return t = vv(r).from, new $(null, 2, [Bs, function() {
                  var h = o.from + (a.length + 1);
                  return l > h ? l : h;
                }(), Za, new v(null, 2, 5, y, [new $(null, 2, [fo, o.from, fh, [" ", a].join("")], null), new $(null, 3, [fo, t, Op, t + a.length, fh, Xu.indentString(n, a.length)], null)], null)], null);
              }
              return null;
            default:
              throw Error(["No matching clause: ", ye.h(e)].join(""));
          }
          else return null;
        } else return null;
      }
    );
  };
}, Ade = function(e) {
  return Jf(function(n, t, l) {
    var r = en.g(n, t);
    return r == null ? nr.g(n, t) : Dn.j(n, t, l.h ? l.h(r) : l.call(null, r));
  }, e, new $(null, 2, [ZQ, W$, Su, W$], null));
}, JL = function(e) {
  return Bc(Jf(function(n, t, l) {
    return lr.g(n, bt.g(function(r) {
      return Ade(Dn.j(r, ZQ, t));
    }, l));
  }, Dt, e));
}, uk = function(e) {
  return Xu.LRLanguage.define({ parser: e.configure({ props: [jxe, Xu.foldNodeProp.add(Nxe), Uo.styleTags(Cxe)] }) });
}, Dde = function(e) {
  var n = Rme;
  return e = e.state.doc, e = e == null ? null : ye.h(e), e == null ? null : n.h ? n.h(e) : n.call(null, e);
}, Ide = function(e) {
  return typeof e == "string" || e instanceof de && Yi(e) == null;
}, wG = function(e) {
  this.val = e;
}, Rde = function(e, n, t) {
  if (o2(t)) return Bl(function() {
    var r = In.g(ue, bt.g(e, t));
    return n.h ? n.h(r) : n.call(null, r);
  }(), Vt(t));
  if (Qd(t)) {
    var l = new yl(function() {
      var r = Xa(t);
      return e.h ? e.h(r) : e.call(null, r);
    }(), function() {
      var r = Cc(t);
      return e.h ? e.h(r) : e.call(null, r);
    }());
    return n.h ? n.h(l) : n.call(null, l);
  }
  return ei(t) ? Bl(function() {
    var r = k1.h(bt.g(e, t));
    return n.h ? n.h(r) : n.call(null, r);
  }(), Vt(t)) : Ap(t) ? (l = wt.j(function(r, u) {
    return yt.g(r, e.h ? e.h(u) : e.call(null, u));
  }, t, t), n.h ? n.h(l) : n.call(null, l)) : w1(t) ? (l = lr.g(O3(t), bt.g(e, t)), n.h ? n.h(l) : n.call(null, l)) : n.h ? n.h(t) : n.call(null, t);
}, Nde = function(e) {
  var n = Qi(new $(null, 2, [aw, 0, E6, !1], null));
  e = Lxe(function(r) {
    if (r instanceof T) {
      var u = L4(/^%(.*)/, ml(r));
      if (j(u)) {
        if (O.j(u, 0, null), u = O.j(u, 1, null), Ca(u)) return n.Nb(null, Ri.B(n.jb(null), aw, Bf, 1)), $we;
        on.g("&", u) ? n.Nb(null, Dn.j(
          n.jb(null),
          E6,
          !0
        )) : (u = parseInt(u), n.Nb(null, Ri.B(n.jb(null), aw, Bf, u)));
      }
    }
    return r;
  }, e);
  var t = sn(n), l = fr(t);
  return t = en.g(l, aw), l = en.g(l, E6), t = bt.g(function(r) {
    return _n.h(["%", ye.h(r)].join(""));
  }, ic.g(1, t + 1)), t = Et(he.g(t, j(l) ? new v(null, 2, 5, y, [et, Pwe], null) : null)), new g(null, r1, new g(null, t, new g(null, e, null, 1, null), 2, null), 3, null);
}, AS = function(e, n, t, l) {
  e: {
    l = z(l);
    for (var r = ou(Dt); ; ) if (l) {
      var u = I(l);
      r = to.g(r, ei(u) && on.g(I(u), rF) ? new g(null, JN, new g(null, Vr(u), null, 1, null), 2, null) : ei(u) && on.g(I(u), aF) ? Vr(u) : new g(
        null,
        JN,
        new g(null, mE.j ? mE.j(e, n, u) : mE.call(null, e, n, u), null, 1, null),
        2,
        null
      )), l = W(l);
    } else {
      e = z(gu(r));
      break e;
    }
  }
  return e = new g(null, ewe, new g(null, new g(null, Jye, new g(null, kt(K_e, e), null, 1, null), 2, null), null, 1, null), 2, null), j(t) ? new g(null, q2e, new g(null, t, new g(null, e, null, 1, null), 2, null), 3, null) : e;
}, Cde = function(e) {
  e = z(e);
  for (var n = ou(Dt); ; ) if (e) {
    var t = I(e);
    e = W(e), n = to.g(to.g(n, Xa(t)), Cc(t));
  } else return z(gu(n));
}, zU = function(e, n, t) {
  var l = fr(e), r = en.g(l, eQ);
  if (xI(t)) return new g(null, Fr, new g(
    null,
    t,
    null,
    1,
    null
  ), 2, null);
  if (t instanceof T) return new g(null, Fr, new g(null, function() {
    var u = ml(t);
    if (xI(t)) return t;
    if (g1(u, "#")) {
      var o = en.g(sn(r), t);
      return j(o) ? o : (u = Si.j(u, 0, u.length - 1), u = Xr.h([u, "__"].join("")), u = _n.h([ml(u), "__auto__"].join("")), wr.B(r, Dn, t, u), u);
    }
    return u = yX.h(ba.h(l)), u = j(u) ? u : No, u.h ? u.h(t) : u.call(null, t);
  }(), null, 1, null), 2, null);
  if (ei(t) && on.g(I(t), rF)) return Vr(t);
  if (ei(t) && on.g(I(t), aF)) throw Error("unquote-splice not in list");
  if (w1(t)) {
    if (t instanceof dm) return t;
    if (ci(t)) return AS(
      l,
      n,
      16 <= Cn(t) ? f_e : nve,
      Cde(t)
    );
    if (or(t)) return new g(null, ixe, new g(null, AS(l, n, null, t), null, 1, null), 2, null);
    if (ug(t)) return AS(l, n, Dve, t);
    if (ei(t) || o2(t)) return (e = z(t)) ? AS(l, n, null, e) : ue(JN);
    throw Error("Unknown Collection type");
  }
  return t instanceof de || typeof t == "number" || lK(t) || typeof t == "string" || t == null || SL(t) || t instanceof RegExp ? t : new g(null, Fr, new g(null, t, null, 1, null), 2, null);
}, mE = function(e, n, t) {
  var l = zU(e, n, t), r = t != null ? !!(t.C & 262144 || Rn === t.Gd) : !1;
  return r && z(nr.l(Vt(t), ka.h(e), Te([
    Sa.h(e),
    Fc.h(e),
    Uc.h(e)
  ]))) ? new g(null, Z0e, new g(null, l, new g(null, zU(e, n, Vt(t)), null, 1, null), 2, null), 3, null) : l;
}, Mde = function(e) {
  return e instanceof T || or(e) && (Vr(e) == null || Vr(e) instanceof de);
}, KU = function(e, n) {
  return e instanceof T ? kt(e, n) : he.g(e, n);
}, Pde = function(e, n) {
  e = kt(e, n);
  var t = Ou.g(ux, e), l = Nu.g(t, sa.h(!0));
  return e = Ou.g(Dp(ux), e), na.l(function(r) {
    if (Mde(r)) return new v(null, 1, 5, y, [In.j(Jx, null, KU(r, l))], null);
    r = z(r);
    var u = I(r);
    if (r = W(r), u == null) throw Yr.g("prefix cannot be nil", new $(null, 1, [H0e, n], null));
    return na.l(function(o) {
      return new v(
        null,
        1,
        5,
        y,
        [In.j(Jx, u, KU(o, l))],
        null
      );
    }, Te([r]));
  }, Te([e]));
}, $de = function(e) {
  e = z(e), I(e);
  var n = W(e);
  e = I(n);
  var t = W(n);
  return n = typeof I(t) == "string" ? I(t) : null, t = j(n) ? W(t) : t, e = j(n) ? wu.B(e, Dn, ee, n) : e, n = ci(I(t)) ? I(t) : null, t = j(n) ? W(t) : t, t = Ou.g(ei, t), t = xy(I, t), t = na.l(function(l) {
    return Pde(n4, tn(l));
  }, Te([n4.h(t)])), new $(null, 4, [i5, e, Db, n, w1e, t, Vc, wt.j(function(l, r) {
    var u = Uh.h(r);
    return u = j(u) ? u : mJ.h(r), j(u) ? Dn.j(l, u, bne.h(r)) : l;
  }, Tt, t)], null);
}, Zs = function(e, n, t) {
  return S1(e, n, t, null);
}, S1 = function(e, n, t, l) {
  return Cv(
    e,
    n,
    t,
    l,
    null
  );
}, Cv = function(e, n, t, l, r) {
  var u = Pc(n), o = u ? tu.g(r, Bm(n)) : null;
  throw n = u ? Du.g(r, Lm(n)) : null, Yr.g(t, gr.l(Te([Dn.l(new $(null, 1, [zi, bwe], null), ka.h(e), n, Te([Sa.h(e), o])), l])));
}, U3 = function(e) {
  return j(e) ? -1 < ["\r", `
`, "	", " ", ","].indexOf(e) : e;
}, vG = function(e, n) {
  for (var t = new Ts(); ; ) {
    var l = U3(n);
    if (!j(l)) {
      e: switch (n) {
        case '"':
        case ";":
        case "@":
        case "^":
        case "`":
        case "~":
        case "(":
        case ")":
        case "[":
        case "]":
        case "{":
        case "}":
        case "\\":
          l = !0;
          break e;
        default:
          l = !1;
      }
      l = j(l) ? l : n == null;
    }
    if (j(l)) return j(n) && e.Ob(null, n), ye.h(t);
    t = t.append(n), n = e.S(null);
  }
}, Lde = function(e, n, t) {
  for (var l = function() {
    var a = new Ts();
    return a.append(t), a;
  }(), r = n.S(null); ; ) {
    if (j(function() {
      var a = U3(r);
      if (j(a)) return a;
      e: switch (r) {
        case ":":
        case ";":
        case "'":
        case "@":
        case "^":
        case "`":
        case "~":
        case "(":
        case ")":
        case "[":
        case "]":
        case "{":
        case "}":
        case "\\":
        case "%":
        case "#":
        case '"':
          a = !0;
          break e;
        default:
          a = !1;
      }
      return j(a) ? a : r == null;
    }())) {
      var u = ye.h(l);
      n.Ob(null, r);
      var o = nG(u);
      return j(o) ? o : Zs(e, n, ["Invalid number: ", u].join(""));
    }
    u = function() {
      var a = l;
      return a.append(r), a;
    }(), o = n.S(null), l = u, r = o;
  }
}, yG = function(e, n) {
  return e = Wve.h(e), Ey(e, n);
}, Bde = function(e, n) {
  var t = Pc(n), l = t ? n.qc(null) : null;
  t = t ? n.pc(null) : null;
  for (var r = n.S(null), u = new Ts(), o = n.S(null); ; ) {
    var a = o;
    if (on.g(null, a)) return S1(e, n, ["EOF while reading, expected ", ye.h(r), " to match ", ye.h(r), " at [", ye.h(l), ",", ye.h(t), "]"].join(""), new $(null, 3, [V0, ye.h(r), j0, ye.h(r), V_, new $(null, 2, [Du, l, tu, t], null)], null));
    if (on.g("\\", a)) {
      a = function() {
        var s = u;
        return s.append(xD.g ? xD.g(u, n) : xD.call(null, u, n)), s;
      }();
      var h = n.S(null);
      u = a, o = h;
    } else {
      if (on.g('"', a)) return ye.h(u);
      a = function() {
        var s = u;
        return s.append(o), s;
      }(), h = n.S(null), u = a, o = h;
    }
  }
}, pw = function(e, n, t, l, r) {
  this.dc = e, this.col = n, this.K = t, this.F = l, this.H = r, this.C = 2230716170, this.J = 139264;
}, _m = function(e) {
  return new pw(e.qc(null), e.pc(null), null, null, null);
}, _G = function(e) {
  e: for (var n = e.S(null), t = new Ts(); ; ) {
    if (q4(n)) {
      ye.h(t);
      break e;
    }
    var l = e.S(null);
    t = t.append(n), n = l;
  }
  return e;
}, sk = function(e) {
  for (var n = h0e; ; ) {
    var t = e.S(null);
    if (j(t)) if (j(U3(t))) n = Dee;
    else return e.Ob(
      null,
      t
    ), n;
    else return null;
  }
}, ok = function(e, n, t) {
  var l = Dt, r = Pc(n), u = r ? n.qc(null) : null;
  r = r ? n.pc(null) : null;
  var o = n.S(null);
  for (e = Dn.j(Dn.j(e, z0, t), Ud, new $(null, 3, [Yd, o, Du, u, tu, r], null)), l = ou(l); ; ) {
    var a = mr ? mr(e, n) : Au.call(null, e, n), h = a;
    if (h = h == null ? null : Vt(h), h = h == null ? null : LQ.h(h), up === a) return S1(e, n, ["EOF while reading, expected ", ye.h(t), " to match ", ye.h(o), " at [", ye.h(u), ",", ye.h(r), "]"].join(""), new $(null, 3, [V0, ye.h(t), j0, ye.h(o), V_, new $(null, 2, [Du, u, tu, r], null)], null));
    if (bw === a) return gu(l);
    j(h) ? l = wt.j(to, l, a) : a === K_ || (l = to.g(l, a));
  }
}, Fde = function(e, n) {
  n.S(null);
  for (var t = new Ts(), l = n.S(null); ; ) {
    if (l === '"') return ye.h(t);
    if (l == null) return Zs(e, n, "Error while parsing regex");
    t.append(l), l === "\\" && (l = n.S(null), l == null && Zs(e, n, "Error while parsing regex"), t.append(l)), l = n.S(null);
  }
}, Vde = function(e, n) {
  return n = function(t) {
    return function l(r) {
      return new rr(null, function() {
        for (var u = r; ; ) if (u = z(u)) {
          if (oi(u)) {
            var o = Jr(u), a = Cn(o), h = Sh(a);
            e: for (var s = 0; ; ) if (s < a) {
              var d = Ul(o, s), p = O.j(d, 0, null);
              1 < O.j(d, 1, null) && h.add(p), s += 1;
            } else {
              o = !0;
              break e;
            }
            return o ? js(mo(h), l(Wr(u))) : js(mo(h), null);
          }
          if (h = I(u), o = O.j(h, 0, null), 1 < O.j(h, 1, null)) return kt(o, l(tn(u)));
          u = tn(u);
        } else return null;
      }, null, null);
    }(LL(t));
  }(n), In.I(ye, e, 1 < Cn(n) ? "s" : null, ": ", rd.g(", ", n));
}, xG = function(e, n, t, l, r) {
  Cv(e, n, Vde([x3(ml(l)), " literal contains duplicate key"].join(""), r), null, t);
}, Yde = function(e, n) {
  var t = Pc(n) ? _m(n) : null, l = ok(e, n, "}"), r = Us(l);
  return on.g(Cn(l), Cn(r)) || xG(e, n, t, Mx, l), r;
}, Ude = function(e, n) {
  for (var t = u1.h(e); ; ) {
    var l = mr ? mr(e, n) : Au.call(
      null,
      e,
      n
    );
    if (bw === l) return K_;
    if (l instanceof de || Zs(e, n, ["Feature should be a keyword: ", ye.h(l)].join("")), K_ === K_ && (Ol(t, l) || Ln(l, ai))) {
      for (t = mr ? mr(e, n) : Au.call(null, e, n), e = Dn.j(e, DR, !0); ; ) {
        if (l = mr ? mr(e, n) : Au.call(null, e, n), bw !== l) if (up === l) {
          l = z0.h(e);
          var r = Ud.h(e), u = fr(r);
          r = en.g(u, Du);
          var o = en.g(u, tu);
          u = en.g(u, Yd), S1(e, n, ["EOF while reading, expected ", ye.h(l), " to match ", ye.h(u), " at [", ye.h(r), ",", ye.h(o), "]"].join(""), new $(null, 2, [V0, ye.h(l), j0, ye.h(u)], null));
        } else continue;
        break;
      }
      return t;
    }
    l = Dn.j(
      e,
      DR,
      !0
    ), r = n, mr ? mr(l, r) : Au.call(null, l, r);
  }
}, qde = function(e, n) {
  sk(n);
  var t = Ob.h(e), l = on.g("@", n.ob(null));
  if (l && n.S(null), sk(n), Ln(e2e, t)) return qfe(mr ? mr(e, n) : Au.call(null, e, n), l);
  if (Bw(t)) return n = wu.B(mr ? mr(e, n) : Au.call(null, e, n), Dn, g1e, l), t.h ? t.h(n) : t.call(null, n);
  var r = Pc(n);
  t = r ? n.qc(null) : null, r = r ? n.pc(null) : null;
  var u = n.S(null);
  return e = Dn.j(Dn.j(e, z0, ")"), Ud, new $(null, 3, [Yd, u, Du, t, tu, r], null)), e = Ude(e, n), e === K_ ? n : l ? wu.g(e, function(o) {
    return Dn.j(o, LQ, !0);
  }) : e;
}, AI = function(e, n, t, l) {
  var r = function() {
    var u = AB.h(e), o = function() {
      var a = e == null ? null : tf.h(e);
      return a == null ? null : sn(a);
    }();
    return j(o) ? function(a) {
      var h = o.h ? o.h(a) : o.call(null, a);
      return j(h) ? h : u.h ? u.h(a) : u.call(null, a);
    } : u;
  }();
  return j(r) ? r : S1(e, n, j(l) ? l : "Use `:auto-resolve` to resolve aliases.", new $(null, 1, [gX, [":", ye.h(t)].join("")], null));
}, DI = function(e, n, t, l, r, u) {
  return n = n.h ? n.h(t) : n.call(null, t), j(n) ? n : S1(e, l, j(u) ? u : ["Alias `", ye.h(_n.h(t)), "` not found in `:auto-resolve`"].join(""), new $(null, 1, [gX, [":", ye.h(r)].join("")], null));
}, II = function(e, n, t) {
  if (t = vG(n, t), j(t)) switch (t) {
    case "nil":
      return null;
    case "true":
      return !0;
    case "false":
      return !1;
    case "/":
      return $x;
    default:
      var l = K0.h ? K0.h(t) : K0.call(null, t);
      return l = j(l) ? _n.g(l.h ? l.h(0) : l.call(null, 0), l.h ? l.h(1) : l.call(null, 1)) : null, j(l) ? l : S1(e, n, ["Invalid symbol: ", t].join(""), Ri.B(_m(n), tu, Lc, t.length));
  }
  else return null;
}, Wde = function(e, n) {
  var t = n.ob(null), l = U3(t);
  t === ":" ? (n.S(null), t = !0) : t = null;
  var r = Ln(Dee, sk(n)), u = j(t) ? n.ob(null) === "{" : null, o = er(u);
  return j(o && (j(l) ? l : r)) && Zs(e, n, "Namespaced map must specify a namespace"), r = j(t) && j(u) ? null : II(e, n, n.S(null)), l = mr ? mr(e, n) : Au.call(null, e, n), j(t) ? (t = j(u) ? i5 : _n.h(ml(r)), u = AI(e, n, t, null), e = DI(e, u, t, n, r, null), _a(SI(ye.h(e), xi(l)), Ju(l))) : (e = ml(r), _a(SI(e, xi(l)), Ju(l)));
}, Hde = function(e, n) {
  var t = n.ob(null);
  if (on.g(null, t)) return Zs(e, n, "Unexpected EOF.");
  if (on.g("!", t)) return _G(n), n;
  if (on.g('"', t)) {
    if (t = rf.h(e), j(t)) {
      var l = Fde(e, n);
      return t === !0 ? _1(l) : t.h ? t.h(l) : t.call(null, l);
    }
    return Zs(e, n, "Regex not allowed. Use the `:regex` option");
  }
  if (on.g(
    "#",
    t
  )) return n.S(null), ED.j ? ED.j(n, null, null) : ED.call(null, n, null, null);
  if (on.g("'", t)) return t = $o.h(e), j(t) ? (n.S(null), l = mr ? mr(e, n) : Au.call(null, e, n), up === l && Zs(e, n, "EOF while reading"), t === !0 ? new g(null, $u, new g(null, l, null, 1, null), 2, null) : t.h ? t.h(l) : t.call(null, l)) : Zs(e, n, "Var literal not allowed. Use the `:var` option");
  if (on.g("(", t))
    return t = qs.h(e), j(t) ? j(GW.h(e)) ? Zs(e, n, "Nested fn literals not allowed.") : (l = function() {
      var o = Dn.j(e, GW, !0);
      return mr ? mr(o, n) : Au.call(null, o, n);
    }(), t === !0 ? Nde(l) : t.h ? t.h(l) : t.call(null, l)) : Zs(e, n, "Function literal not allowed. Use the `:fn` option");
  if (on.g(":", t)) return n.S(null), Wde(e, n);
  if (on.g("{", t)) return Yde(e, n);
  if (on.g("=", t)) return t = wh.h(e), j(t) ? (n.S(null), l = mr ? mr(e, n) : Au.call(null, e, n), t === !0 ? new g(null, o_e, new g(null, l, null, 1, null), 2, null) : t.h ? t.h(l) : t.call(null, l)) : Zs(e, n, "Read-eval not allowed. Use the `:read-eval` option");
  if (on.g("?", t)) return j(Ob.h(e)) || Zs(e, n, "Conditional read not allowed."), n.S(null), qde(e, n);
  if (on.g(
    "_",
    t
  )) {
    if (n.S(null), t = lW.h(e), l = mr ? mr(e, n) : Au.call(null, e, n), j(t)) {
      var r = mr ? mr(e, n) : Au.call(null, e, n);
      return up === r ? up : (l = new $(null, 2, [lW, l, jwe, r], null), t.h ? t.h(l) : t.call(null, l));
    }
    return n;
  }
  e: switch (t) {
    case "^":
    case "'":
    case "(":
    case "{":
    case '"':
    case "!":
    case "_":
    case "?":
    case ":":
    case "#":
      t = !0;
      break e;
    default:
      t = !1;
  }
  if (j(t)) return n.Ob(null, "#"), yG(e, n);
  if (t = DR.h(e), j(t)) return mr ? mr(e, n) : Au.call(null, e, n), mr ? mr(e, n) : Au.call(null, e, n);
  var u = mr ? mr(e, n) : Au.call(null, e, n);
  if (t = mr ? mr(e, n) : Au.call(
    null,
    e,
    n
  ), l = function() {
    var o = of.h(e);
    return o = j(o) ? o.h ? o.h(u) : o.call(null, u) : null, j(o) ? o : $xe.call(null, u);
  }(), j(l)) return l.h ? l.h(t) : l.call(null, t);
  throw Error(["No reader function for tag ", ye.h(u)].join(""));
}, zde = function(e, n) {
  var t = Pc(n) ? _m(n) : null, l = ok(e, n, "}"), r = Cn(l);
  if (0 < r) {
    qc(r) || Cv(e, n, ["The map literal starting with ", ye.h(As.g(!1, I(l))), " contains ", ye.h(Cn(l)), " form(s). Map literals must contain an even number of forms."].join(""), null, t);
    var u = Po.g(2, l);
    j(In.g(O1, u)) || xG(e, n, t, Xx, u);
  }
  return 16 >= r ? In.g(ah, l) : In.g(tr, l);
}, Kde = function(e, n) {
  n.S(null);
  var t = n.S(null);
  j(U3(t)) && Zs(e, n, "Invalid token: :"), t = vG(n, t);
  var l = t.charAt(0) === ":";
  if (l) {
    var r = l ? Si.g(t, 1) : t;
    if (l = K0.h ? K0.h(r) : K0.call(null, r), t = O.j(l, 0, null), l = O.j(l, 1, null), j(t)) {
      var u = AI(e, n, r, null);
      r = _n.h(t), e = DI(e, u, r, n, t, null);
    } else u = AI(e, n, r, "Use `:auto-resolve` + `:current` to resolve current namespace."), e = DI(e, u, i5, n, r, "Use `:auto-resolve` + `:current` to resolve current namespace.");
    return ts.g(ye.h(e), l);
  }
  return ts.h(t);
}, Gde = function(e) {
  return e instanceof de ? Qu([e, !0]) : e instanceof T ? new $(null, 1, [Ft, e], null) : typeof e == "string" ? new $(null, 1, [Ft, e], null) : e;
}, Zde = function(e, n) {
  return e instanceof de ? Qu([n.h ? n.h(e) : n.call(null, e), n.h ? n.h(!0) : n.call(null, !0)]) : e instanceof T ? Qu([n.h ? n.h(Ft) : n.call(null, Ft), n.h ? n.h(e) : n.call(null, e)]) : typeof e == "string" ? Qu([n.h ? n.h(Ft) : n.call(null, Ft), n.h ? n.h(e) : n.call(null, e)]) : e;
}, GU = function(e, n, t) {
  var l = Pc(n);
  if (on.g("#", t)) return n.S(null), Hde(e, n);
  if (on.g(null, t)) return up;
  if (on.g("@", t)) return t = sf.h(e), j(t) ? (l = t, n.S(null), t = mr ? mr(e, n) : Au.call(null, e, n), l === !0 ? new g(null, f2e, new g(null, t, null, 1, null), 2, null) : l.h ? l.h(t) : l.call(null, t)) : Zs(e, n, "Deref not allowed. Use the `:deref` option");
  if (on.g("`", t)) return t = ba.h(e), j(t) ? (l = t, n.S(null), t = mr ? mr(e, n) : Au.call(null, e, n), l === !0 || ci(l) ? (l = kr.h(Tt), l = Dn.j(e, eQ, l), mE(l, n, t)) : l.h ? l.h(t) : l.call(null, t)) : Zs(e, n, "Syntax quote not allowed. Use the `:syntax-quote` option");
  if (on.g('"', t)) return Bde(e, n);
  if (on.g("'", t)) return t = af.h(e), j(t) ? (l = t, n.S(null), t = mr ? mr(e, n) : Au.call(
    null,
    e,
    n
  ), up === t && Zs(e, n, "EOF while reading"), l === !0 ? new g(null, Fr, new g(null, t, null, 1, null), 2, null) : l.h ? l.h(t) : l.call(null, t)) : yG(e, n);
  if (on.g("(", t)) return In.g(ue, ok(e, n, ")"));
  if (on.g(")", t)) {
    var r = z0.h(e);
    return xa.g(r, t) ? (l = l ? _m(n) : null, n.S(null), Cv(e, n, ["Unmatched delimiter: ", ye.h(t), j(r) ? [", expected: ", ye.h(r), function() {
      var u = Ud.h(e);
      if (j(u)) {
        var o = fr(u);
        u = en.g(o, Du);
        var a = en.g(o, tu);
        return o = en.g(o, Yd), [" to match ", ye.h(o), " at ", ye.h(new v(null, 2, 5, y, [u, a], null))].join("");
      }
      return null;
    }()].join("") : null].join(""), function() {
      var u = Ud.h(e), o = fr(u);
      u = en.g(o, Yd);
      var a = en.g(o, Du);
      return o = en.g(o, tu), new $(null, 3, [j0, ye.h(u), V_, new $(null, 2, [Du, a, tu, o], null), V0, ye.h(r)], null);
    }(), l)) : (n.S(null), bw);
  }
  return on.g(":", t) ? Kde(e, n) : on.g(";", t) ? _G(n) : on.g("[", t) ? ok(e, n, "]") : on.g("{", t) ? zde(e, n) : on.g("\\", t) ? (t = n.S(null), SD.j ? SD.j(n, t, null) : SD.call(null, n, t, null)) : on.g("]", t) ? (r = z0.h(e), xa.g(r, t) ? (l = l ? _m(n) : null, n.S(null), Cv(e, n, [
    "Unmatched delimiter: ",
    ye.h(t),
    j(r) ? [", expected: ", ye.h(r), function() {
      var u = Ud.h(e);
      if (j(u)) {
        var o = fr(u);
        u = en.g(o, Du);
        var a = en.g(o, tu);
        return o = en.g(o, Yd), [" to match ", ye.h(o), " at ", ye.h(new v(null, 2, 5, y, [u, a], null))].join("");
      }
      return null;
    }()].join("") : null
  ].join(""), function() {
    var u = Ud.h(e), o = fr(u);
    u = en.g(o, Yd);
    var a = en.g(o, Du);
    return o = en.g(o, tu), new $(null, 3, [j0, ye.h(u), V_, new $(null, 2, [Du, a, tu, o], null), V0, ye.h(r)], null);
  }(), l)) : (n.S(null), bw)) : on.g("}", t) ? (r = z0.h(e), xa.g(r, t) ? (l = l ? _m(n) : null, n.S(null), Cv(
    e,
    n,
    ["Unmatched delimiter: ", ye.h(t), j(r) ? [", expected: ", ye.h(r), function() {
      var u = Ud.h(e);
      if (j(u)) {
        var o = fr(u);
        u = en.g(o, Du);
        var a = en.g(o, tu);
        return o = en.g(o, Yd), [" to match ", ye.h(o), " at ", ye.h(new v(null, 2, 5, y, [u, a], null))].join("");
      }
      return null;
    }()].join("") : null].join(""),
    function() {
      var u = Ud.h(e), o = fr(u);
      u = en.g(o, Yd);
      var a = en.g(o, Du);
      return o = en.g(o, tu), new $(null, 3, [j0, ye.h(u), V_, new $(null, 2, [Du, a, tu, o], null), V0, ye.h(r)], null);
    }(),
    l
  )) : (n.S(null), bw)) : on.g("^", t) ? (n.S(null), t = ak ? ak(e, n, !0) : Au.call(null, e, n, !0), wu.j(mr ? mr(e, n) : Au.call(null, e, n), gr, t)) : on.g("~", t) ? (t = function() {
    var u = ba.h(e);
    return j(u) ? (u = nf.h(e), j(u) ? u : !0) : u;
  }(), j(t) ? (l = t, n.S(null), n.ob(null) === "@" ? (l = function() {
    var u = ba.h(e);
    return j(u) ? (u = Wf.h(e), j(u) ? u : !0) : u;
  }(), j(l) ? (n.S(null), t = mr ? mr(e, n) : Au.call(null, e, n), l === !0 ? new g(null, aF, new g(null, t, null, 1, null), 2, null) : l.h ? l.h(t) : l.call(null, t)) : Zs(e, n, "Syntax unquote splice not allowed. Use the `:syntax-quote` option")) : (t = mr ? mr(e, n) : Au.call(null, e, n), l === !0 ? new g(null, rF, new g(null, t, null, 1, null), 2, null) : l.h ? l.h(t) : l.call(null, t))) : Zs(e, n, "Syntax unquote not allowed. Use the `:syntax-quote` option")) : (t = n.S(null), j(_D.g ? _D.g(n, t) : _D.call(null, n, t)) ? Lde(e, n, t) : II(e, n, t));
}, Au = function(e) {
  switch (arguments.length) {
    case 2:
      return mr(arguments[0], arguments[1]);
    case 3:
      return ak(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
}, mr = function(e, n) {
  return ak(e, n, null);
}, ak = function(e, n, t) {
  for (; ; ) {
    var l = Pc(n), r = function() {
      var H = sk(n);
      return j(H) ? cx(n) : H;
    }();
    if (j(r)) {
      var u = r, o = l ? _m(n) : null, a = co.h(e), h = j(a) ? l1.h(sn(n.frames)) : null, s = j(a) ? h.getLength() : null, d = j(a) ? Wfe(n, /* @__PURE__ */ function(H, U, Me, le, Ce, Ye, B, q) {
        return function() {
          return GU(H, U, q);
        };
      }(e, n, t, o, a, h, s, u)) : GU(e, n, u);
      if (n !== d) {
        if (bw === d) return d;
        var p = J2e.h(e), _ = j(p) ? function() {
          if (ei(d) && on.g(ih, I(d))) try {
            var H = $de(d);
          } catch (Me) {
            if (Me instanceof Bxe) H = null;
            else throw Me;
          }
          else H = null;
          if (j(H)) {
            var U = tf.h(e);
            return j(U) ? Qa(U, Dn.j(Vc.h(H), i5, te.h(H))) : null;
          }
          return null;
        }() : null, R = kp.h(e), F = Uf.h(e), L = dh.h(e), G = d != null ? d.C & 262144 || Rn === d.Gd ? !0 : d.C ? !1 : pl(jY, d) : pl(jY, d), J = j(a) ? Si.g(ye.h(h), s).trim() : null, we = function() {
          var H = l;
          return H && ((H = G) && (H = (H = er(F)) ? H : F.h ? F.h(d) : F.call(null, d)), j(H) ? H : R);
        }(), ce = j(function() {
          var H = l;
          return H && (H = we, j(H) ? L : H);
        }()) ? _m(n) : null, xe = j(we) ? Du.h(o) : null, $e = j(L) ? Du.h(ce) : null, je = j(we) ? tu.h(o) : null, E = j(L) ? tu.h(ce) : null, P = j(R) ? /* @__PURE__ */ function(H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn) {
          return function(Nn) {
            var at = function() {
              var Yt = new $(
                null,
                1,
                [Go, Nn],
                null
              );
              return Yt = j(Fe) ? Dn.j(Yt, $_e, function() {
                var jt = Qu([ka.h(H), Be, Sa.h(H), pn]);
                return j(q) ? Dn.l(jt, Fc.h(H), Ze, Te([Uc.h(H), xn])) : jt;
              }()) : Yt, j(Ae) ? Dn.j(Yt, function() {
                var jt = vh.h(H);
                return j(jt) ? jt : co;
              }(), Ae) : Yt;
            }();
            return Ye.h ? Ye.h(at) : Ye.call(null, at);
          };
        }(e, n, t, p, _, R, F, L, G, J, we, ce, xe, $e, je, E) : null, K = j(t) ? j(P) ? Zde(d, P) : Gde(d) : d;
        return j(R) ? P.h ? P.h(K) : P.call(null, K) : j(we) ? wu.g(K, /* @__PURE__ */ function(H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn) {
          return function(Nn) {
            return Nn = Dn.j(
              Dn.j(Nn, ka.h(H), Be),
              Sa.h(H),
              pn
            ), Nn = j(q) ? Dn.j(Dn.j(Nn, Fc.h(H), Ze), Uc.h(H), xn) : Nn, j(Ae) ? Dn.j(Nn, vh.h(H), Ae) : Nn;
          };
        }(e, n, t, p, _, R, F, L, G, J, we, ce, xe, $e, je, E)) : K;
      }
    } else return up;
  }
}, Eu = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je) {
  this.dispatch = e, this.deref = n, this.Ra = t, this.Sa = l, this.Ta = r, this.quote = u, this.ka = o, this.za = a, this.Na = h, this.Oa = s, this.Pa = d, this.Ga = p, this.Ja = _, this.Ha = R, this.source = F, this.Qa = L, this.Ma = G, this.Ka = J, this.Ia = we, this.La = ce, this.K = xe, this.F = $e, this.H = je, this.C = 2230716170, this.J = 139264;
}, Xde = function(e) {
  var n = nr.l(e, zf, Te([sf, ba, nf, Wf, af, qs, $o, wh, rf, ka, Sa, Fc, Uc, co, vh, kp, Uf, dh, tf]));
  return n = Ap(e) ? lr.g(Tt, n) : n, new Eu(zf.h(e), sf.h(e), ba.h(e), nf.h(e), Wf.h(e), af.h(e), qs.h(e), $o.h(e), wh.h(e), rf.h(e), ka.h(e), Sa.h(e), Fc.h(e), Uc.h(e), co.h(e), vh.h(e), kp.h(e), Uf.h(e), dh.h(e), tf.h(e), null, Fo(n), null);
}, ky = function(e, n) {
  if (e != null && e.od != null) e = e.od(e, n);
  else {
    var t = ky[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = ky._, t != null) e = t.g ? t.g(e, n) : t.call(
      null,
      e,
      n
    );
    else throw Ut("IBox.setVal", e);
  }
  return e;
}, gx = function(e) {
  if (e != null && e.ec != null) e = e.ec(e);
  else {
    var n = gx[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = gx._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IBox.getVal", e);
  }
  return e;
}, Kd = function(e) {
  if (e != null && e.kf != null) e = e.ve;
  else {
    var n = Kd[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Kd._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IReified.getMethods", e);
  }
  return e;
}, Z4 = function(e, n) {
  this.ve = e, this.ff = n;
}, ck = function(e, n, t) {
  if (e != null && e.ze != null) e = e.ze(e, n, t);
  else {
    var l = ck[$t(e ?? null)];
    if (l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else if (l = ck._, l != null) e = l.j ? l.j(e, n, t) : l.call(null, e, n, t);
    else throw Ut("SciTypeInstance.-mutate", e);
  }
  return e;
}, eB = function(e) {
  this.form = e;
}, hk = function(e) {
  if (e != null && e.lf != null) e = e.stack;
  else {
    var n = hk[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = hk._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("Stack.stack", e);
  }
  return e;
}, Ic = function(e, n, t, l, r) {
  this.f = e, this.stack = n, this.K = t, this.F = l, this.H = r, this.C = 2230716170, this.J = 139264;
}, it = function(e, n) {
  return new Ic(e, n, null, null, null);
}, D = function(e, n, t) {
  if (e instanceof Ic) {
    var l = e.f;
    return l.j ? l.j(e, n, t) : l.call(null, e, n, t);
  }
  return e;
}, Jo = function(e) {
  if (e != null && e.Jc != null) e = e.Jc(e);
  else {
    var n = Jo[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Jo._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("HasName.getName", e);
  }
  return e;
}, nB = function(e, n) {
  this.bd = e, this.prev = n;
}, X4 = function() {
  return sn(g5);
}, tB = function(e) {
  this.val = e;
}, Qde = function() {
  var e = sn(g5);
  return new nB(e.bd, null);
}, am = function(e) {
  return Yu(g5, e);
}, Fm = function(e, n) {
  if (e != null && e.Be != null) e = e.Be(e, n);
  else {
    var t = Fm[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = Fm._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("IVar.bindRoot", e);
  }
  return e;
}, wx = function(e) {
  if (e != null && e.nf != null) e = e.root;
  else {
    var n = wx[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = wx._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IVar.getRawRoot", e);
  }
  return e;
}, fk = function(e) {
  if (e != null && e.De != null) e = e.De(e);
  else {
    var n = fk[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = fk._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IVar.isMacro", e);
  }
  return e;
}, dk = function(e) {
  if (e != null && e.Ce != null) e = e.Ce(e);
  else {
    var n = dk[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = dk._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut(
      "IVar.hasRoot",
      e
    );
  }
  return e;
}, RI = function(e) {
  if (e != null && e.Ee != null) e.Ee(e, !0);
  else {
    var n = RI[$t(e ?? null)];
    if (n != null) n.g ? n.g(e, !0) : n.call(null, e, !0);
    else if (n = RI._, n != null) n.g ? n.g(e, !0) : n.call(null, e, !0);
    else throw Ut("IVar.setThreadBound", e);
  }
}, dp = function(e) {
  if (e != null && e.Rd != null) e.Rd(e);
  else {
    var n = dp[$t(e ?? null)];
    if (n != null) n.h ? n.h(e) : n.call(null, e);
    else if (n = dp._, n != null) n.h ? n.h(e) : n.call(null, e);
    else throw Ut("IVar.unbind", e);
  }
}, pk = function(e) {
  if (e != null && e.Ae != null) e = e.Ae(e);
  else {
    var n = pk[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = pk._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("DynVar.dynamic?", e);
  }
  return e;
}, by = function(e) {
  if (e != null && e.mf != null) e = e.we;
  else {
    var n = by[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = by._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("CtxVar.needs-ctx?", e);
  }
  return e;
}, mg = function(e) {
  var n = X4();
  return e = wt.j(function(t, l) {
    var r = O.j(l, 0, null);
    if (l = O.j(l, 1, null), er(pk(r))) throw Error([
      "Can't dynamically bind non-dynamic var ",
      ye.h(r)
    ].join(""));
    return RI(r), Dn.j(t, r, new tB(l));
  }, n.bd, e), am(new nB(e, n));
}, Vm = function() {
  var e = X4().prev;
  if (j(e)) return H$ === e ? Yu(g5, H$) : am(e);
  throw Error("No frame to pop.");
}, Jde = function() {
  var e = X4(), n = Tt;
  for (e = z(e.bd); ; ) if (e) {
    var t = I(e), l = O.j(t, 0, null);
    t = O.j(t, 1, null).ec(null), n = Dn.j(n, l, t), e = W(e);
  } else return n;
}, Q4 = function(e) {
  var n = sn(g5);
  return j(n) ? n.bd.get(e) : null;
}, as = function(e) {
  throw Error(["Attempting to call unbound fn: ", ye.h(e)].join(""));
}, lB = function(e) {
  this.ab = e, this.C = 1, this.J = 0;
}, Mv = function(e) {
  return iE(e) ? _n.h(ml(e)) : e;
}, v2 = function(e, n, t) {
  this.data = e, this.namespace = n, this.name = t, this.C = 131072, this.J = 4096;
}, epe = function(e, n, t, l) {
  j(n) && 0 < Cn(n) && Jf(function(r, u, o) {
    return o.B ? o.B(u, e, t, l) : o.call(null, u, e, t, l), null;
  }, null, n);
}, Ne = function(e, n, t, l) {
  this.root = e, this.Rb = n, this.meta = t, this.Fe = !1, this.we = l, this.lc = null, this.C = 2147647489, this.J = 0;
}, SG = function(e) {
  var n = function() {
    var t = te.h(e.meta);
    return t == null ? null : ml(t);
  }();
  return j(n) ? _n.g(function() {
    var t = ie.h(e.meta);
    return t = t == null ? null : Jo(t), t == null ? null : ml(t);
  }(), n) : e.Rb;
}, q3 = function(e, n) {
  this.name = e, this.meta = n, this.C = 131072, this.J = 0;
}, oc = function(e, n) {
  return new q3(e, n);
}, rB = function(e) {
  var n = Mo.g(2, e), t = function l(r, u, o) {
    function a(s, d, p) {
      var _ = Xr.h("map__"), R = Kr.h(d), F = (/* @__PURE__ */ function(J) {
        return function(we) {
          return j(Uh.h(d)) ? yt.l(we, Uh.h(d), Te([J])) : we;
        };
      }(_))(yt.g(yt.g(yt.g(yt.g(s, _), p), _), new g(null, si, new g(null, new g(null, ei, new g(null, _, null, 1, null), 2, null), new g(null, ve.h(z(he.g(new g(null, K0e, null, 1, null), new g(
        null,
        _,
        null,
        1,
        null
      )))), new g(null, _, null, 1, null), 2, null), 3, null), 4, null)));
      for (s = function() {
        var J = wt.j(/* @__PURE__ */ function() {
          return function(we, ce) {
            if (ce instanceof de) {
              var xe = Yi(ce), $e = ml(ce);
              return on.g($e, "keys") ? Dn.j(we, ce, function(je) {
                return ts.g(j(xe) ? xe : Yi(je), ml(je));
              }) : on.g($e, "syms") ? Dn.j(we, ce, function(je) {
                return new g(null, Fr, new g(null, _n.g(j(xe) ? xe : Yi(je), ml(je)), null, 1, null), 2, null);
              }) : on.g($e, "strs") ? Dn.j(we, ce, ye) : we;
            }
            return we;
          };
        }(), Tt, xi(d));
        return wt.j(/* @__PURE__ */ function() {
          return function(we, ce) {
            return wt.j(function(xe, $e) {
              var je = Dn.j, E = Cc(ce);
              return E = E.h ? E.h($e) : E.call(null, $e), je.call(Dn, xe, $e, E);
            }, nr.g(we, Xa(ce)), function() {
              var xe = Xa(ce);
              return xe.h ? xe.h(we) : xe.call(null, we);
            }());
          };
        }(), nr.l(d, Uh, Te([Kr])), J);
      }(); ; ) if (z(s)) {
        p = Xa(I(s));
        var L = Cc(I(s)), G = p != null && (p.J & 4096 || Rn === p.he) ? Bl(_n.g(null, ml(p)), Vt(p)) : p;
        L = Ol(R, G) ? new g(null, Ky, new g(null, _, new g(null, L, new g(null, R.h ? R.h(G) : R.call(null, G), null, 1, null), 2, null), 3, null), 4, null) : new g(null, Ky, new g(null, _, new g(null, L, null, 1, null), 2, null), 3, null), p = p instanceof de || p instanceof T ? yt.l(F, G, Te([L])) : l(F, p, L), s = W(s), F = p;
      } else return F;
    }
    function h(s, d, p) {
      var _ = Xr.h("vec__"), R = Xr.h("seq__"), F = Xr.h("first__"), L = fu(new gi(null, new $(null, 1, [et, null], null), null), d);
      s = yt.l(s, _, Te([p])), s = j(L) ? yt.l(s, R, Te([new g(null, z, new g(null, _, null, 1, null), 2, null)])) : s, p = 0;
      for (var G = !1; ; ) if (z(d)) {
        var J = I(d);
        if (on.g(J, et)) s = l(s, Vr(d), R), d = va(d), G = !0;
        else {
          if (on.g(J, Uh)) return l(s, Vr(d), _);
          if (j(G)) throw Error("Unsupported binding form, only :as can follow & parameter");
          s = l(j(L) ? yt.l(s, F, Te([ve.h(z(he.g(new g(null, I, null, 1, null), new g(null, R, null, 1, null)))), R, ve.h(z(he.g(new g(null, W, null, 1, null), new g(null, R, null, 1, null))))])) : s, J, j(L) ? F : new g(null, O, new g(null, _, new g(null, p, new g(null, null, null, 1, null), 2, null), 3, null), 4, null)), p += 1, d = W(d);
        }
      } else return s;
    }
    if (u instanceof T) return yt.g(yt.g(r, j(Yi(u)) ? _n.h(ml(u)) : u), o);
    if (u instanceof de) return yt.g(yt.g(r, _n.h(ml(u))), o);
    if (or(u)) return h(r, u, o);
    if (ci(u)) return a(r, u, o);
    throw Error(["Unsupported binding form: ", ye.h(u)].join(""));
  };
  if (hu(jp, bt.g(I, n))) return e;
  if (e = z(Ou.g(function(l) {
    return I(l) instanceof de;
  }, n))) throw Error(["Unsupported binding key: ", ye.h(hK(e))].join(""));
  return wt.j(function(l, r) {
    return t(l, I(r), Vr(r));
  }, Dt, n);
}, mk = function(e) {
  return e == null || typeof e == "number" || typeof e == "string" || e instanceof de || SL(e) || e instanceof RegExp;
}, mu = function(e, n) {
  return iB(e, n, Tt);
}, iB = function(e, n, t) {
  n = Vt(n);
  var l = fr(n);
  n = en.g(l, Yn);
  var r = en.g(l, zn);
  throw l = en.j(l, Bn, sn(Iu)), Yr.g(e, gr.l(Te([new $(null, 4, [
    zi,
    bm,
    Yn,
    j(n) ? n : Yn.h(c1),
    zn,
    j(r) ? r : zn.h(c1),
    Bn,
    l
  ], null), t])));
}, EG = function(e) {
  if (e = Vt(e), e == null) return null;
  var n = a5.h(e);
  return j(n) ? n : Zf.h(e);
}, ZU = function(e, n, t) {
  return Al(e, Ws.h(e), n, t);
}, Al = function(e, n, t, l) {
  if (j(function() {
    var L = A_;
    return Ln(L, bm) ? !1 : L;
  }())) throw t;
  var r = hk(l), u = Or.h(e), o = Z1e.h(e), a = ax(t), h = function() {
    var L = MS.h(a);
    return L = j(L) ? L : null, j(L) ? L : Qi(fl);
  }();
  j(r) && Yu(h, yt.g(sn(h), r));
  var s = ax(t);
  if (e = function() {
    var L = zi.h(s);
    return (L = w2(sn(es()), L, bm)) ? MS.h(s) : L;
  }(), j(e)) throw t;
  var d = t.message;
  e = function() {
    if (j(r)) return r;
    var L = u == null ? null : sn(u);
    return L = L == null ? null : MS.h(L), L = L == null ? null : en.g(L, o), L = L == null ? null : sn(L), L = L == null ? null : ho(L), L == null ? null : Vt(L);
  }(), e = fr(e);
  var p = en.g(e, Yn), _ = en.g(e, zn), R = en.g(e, Bn);
  if (j(j(p) ? _ : p)) {
    var F = jx.h(s);
    throw function() {
      var L = new $(null, 6, [zi, bm, Yn, p, zn, _, p1e, d, MS, h, Bn, R], null);
      return L = j(F) ? Dn.j(L, jx, F) : L, Yr.j(d, L, t);
    }();
  }
  throw t;
}, OG = function(e) {
  switch (Yi(e)) {
    case "clojure.core":
    case "cljs.core":
      return _n.h(ml(e));
    default:
      return e;
  }
}, J4 = function(e, n, t, l) {
  var r = sn(e);
  r = xr.g(
    r,
    new v(null, 2, 5, y, [Il, n], null)
  );
  var u = Go.h(r);
  return j(u) ? u : j(j(r) ? r : t) ? (t = oc(n, l), wr.B(e, xs, new v(null, 3, 5, y, [Il, n, Go], null), t), t) : null;
}, kG = function(e, n, t) {
  return e = Or.h(e), t = gr.l(Te([Vt(n), t])), n = J4(e, n, !0, t), ky(Mi, n);
}, NI = function(e, n) {
  var t = sn(Pne);
  return t.g ? t.g(e, n) : t.call(null, e, n);
}, bG = function(e, n) {
  if (hu(jp, e)) return new $(null, 2, [yh, e, uc, n], null);
  for (var t = Bl(Dt, Vt(e)), l = Dt; ; ) if (j(e)) if (I(e) instanceof T) {
    var r = W(e);
    t = yt.g(t, I(e)), e = r;
  } else {
    var u = Xr.h("p__");
    r = W(e), t = yt.g(t, u), l = yt.g(
      yt.g(l, I(e)),
      u
    ), e = r;
  }
  else return new $(null, 2, [yh, t, uc, new v(null, 1, 5, y, [ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, l, null, 1, null), Te([n]))))], null)], null);
}, uB = function(e, n) {
  return e = Dn.l(e, ie, sn(Mi), Te([Bn, sn(Iu)])), j(n) ? Dn.j(e, bB, !0) : e;
}, W3 = function(e, n, t) {
  return t = Dn.l(t, Ma, !0, Te([te, Mv.h ? Mv.h(e) : Mv.call(null, e)])), new Ne(n, e, t, !1);
}, Vs = function() {
  return Jo(sn(Mi));
}, Hc = function(e, n, t) {
  return eb(e, n, t, !1);
}, eb = function(e, n, t, l) {
  return new Ne(n, e, Dn.j(t, te, Mv.h ? Mv.h(e) : Mv.call(null, e)), l);
}, Qs = function(e) {
  return e instanceof Ne;
}, XU = function(e) {
  var n = la(e);
  return ["#object[", ye.h(n), " 0x", ye.h(Uu(e).toString(16)), ' "', ye.h(w5.h(e)), '"]'].join("");
}, sB = function(e, n, t, l) {
  this.uc = e, this.type = n, this.za = t, this.ib = l, this.C = 2147483648, this.J = 0;
}, TG = function(e, n, t, l, r) {
  var u = t[l];
  if (u == null) throw Error(["Could not find instance method: ", ye.h(l)].join(""));
  return l = r.map(function(o) {
    return D(o, e, n);
  }), Reflect.apply(u, t, l);
}, gk = function(e, n) {
  for (var t = 0; ; ) if (t < n.length) {
    var l = t + 1;
    e = e[n[t]], t = l;
  } else return e;
}, Sv = function(e, n, t, l) {
  return Reflect.construct(
    t,
    l.map(function(r) {
      return D(r, e, n);
    })
  );
}, QU = function(e, n, t, l, r) {
  return Reflect.apply(l, t, r.map(function(u) {
    return D(u, e, n);
  }));
}, npe = function(e, n) {
  e = sn(Or.h(e));
  var t = Hf.h(e), l = Yi(n);
  return t = j(l) ? l === "js" && Ol(t, _n.h(ml(n))) ? n : null : Ol(t, n) ? n : null, j(t) || (t = en.g(po.h(e), n), j(t)) ? t : (t = Vs(), xr.g(e, new v(null, 4, 5, y, [Il, t, po, n], null)));
}, wk = function(e, n) {
  var t = sn(Or.h(e)), l = Hf.h(t);
  return function() {
    var r = Yi(n);
    return r = j(r) ? r === "js" ? en.g(l, _n.h(ml(n))) : null : en.g(l, n), j(r) ? r : (r = Vs(), r = xr.g(
      t,
      new v(null, 3, 5, y, [Il, r, po], null)
    ), r = oh(r, n), j(r) ? (O.j(r, 0, null), r = O.j(r, 1, null), en.g(l, r)) : (r = xr.g(t, new v(null, 2, 5, y, [po, n], null)), j(r) ? en.g(l, r) : null));
  }();
}, E1 = function(e) {
  return xr.g(sn(Or.h(e)), new v(null, 3, 5, y, [Il, ks, zN], null));
}, y2 = function(e) {
  return e instanceof v2 ? _n.g(Yi(e), ml(e)) : e;
}, tpe = function(e) {
  var n = Te([ai, vg]);
  if (z(In.j(Aa, In.g(id, xi(e)), n))) throw e = In.B(ye, "Only these options are valid: ", I(n), bt.g(function(t) {
    return [", ", ye.h(t)].join("");
  }, tn(n))), Error(e);
}, E_ = function(e, n, t) {
  return wI(e, n, t);
}, lpe = function(e) {
  return lr.g(Tt, bt.g(function(n) {
    var t = z(n);
    n = I(t), t = W(t);
    var l = ho(t);
    return l = typeof l == "string" ? new v(null, 2, 5, y, [td(t), l], null) : new v(null, 2, 5, y, [t, null], null), t = O.j(l, 0, null), l = O.j(l, 1, null), new v(null, 2, 5, y, [ts.h(n), new $(null, 3, [te, n, ne, t, ee, l], null)], null);
  }, e));
}, JU = function(e, n, t) {
  var l = z(n);
  return n = I(l), l = W(l), new g(null, n, new g(null, j(t) ? ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(
    null,
    Et(ve.h(z(he.g(new g(null, qS, null, 1, null), new g(null, I(n), null, 1, null))))),
    null,
    1,
    null
  ), Te([new g(null, ve.h(z(he.l(new g(null, Zd, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, zW, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Yx, null, 1, null), new g(null, qS, null, 1, null)))), null, 1, null))))), null, 1, null), Te([new g(
    null,
    ve.h(z(he.l(new g(null, Zd, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, lm, null, 1, null), new g(
      null,
      ve.h(z(he.l(new g(null, Ky, null, 1, null), new g(null, zW, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, e, null, 1, null)))), null, 1, null)])))),
      null,
      1,
      null
    ))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, kf, null, 1, null), new g(null, lm, null, 1, null), Te([new g(null, n, null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, lm, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yh, null, 1, null), new g(null, e, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Y0, null, 1, null), new g(null, qS, null, 1, null)))), null, 1, null)])))), null, 1, null), Te([new g(null, LS, null, 1, null), new g(null, ve.h(z(he.l(new g(
      null,
      Yh,
      null,
      1,
      null
    ), new g(null, e, null, 1, null), Te([new g(null, ai, null, 1, null)])))), null, 1, null)]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Wx, null, 1, null), new g(null, LS, null, 1, null), Te([new g(null, lm, null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, kf, null, 1, null), new g(null, lm, null, 1, null), Te([new g(null, n, null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.g(new g(null, mi, null, 1, null), l))), null, 1, null)])))), null, 1, null)])))), null, 1, null)])))),
    null,
    1,
    null
  ), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, lm, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yh, null, 1, null), new g(null, e, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Y0, null, 1, null), new g(null, qS, null, 1, null)))), null, 1, null)])))), null, 1, null), Te([new g(null, LS, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yh, null, 1, null), new g(null, e, null, 1, null), Te([new g(null, ai, null, 1, null)])))), null, 1, null)]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(
    null,
    si,
    null,
    1,
    null
  ), new g(null, ve.h(z(he.l(new g(null, Wx, null, 1, null), new g(null, LS, null, 1, null), Te([new g(null, lm, null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, kf, null, 1, null), new g(null, lm, null, 1, null), Te([new g(null, n, null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.g(new g(null, mi, null, 1, null), l))), null, 1, null)])))), null, 1, null)])))), null, 1, null)])))), null, 1, null)])))) : ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(
    null,
    Et(ve.h(z(he.g(new g(null, vH, null, 1, null), new g(null, I(n), null, 1, null))))),
    null,
    1,
    null
  ), Te([new g(null, ve.h(z(he.l(new g(null, Zd, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, SW, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Yx, null, 1, null), new g(null, vH, null, 1, null)))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Zd, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, dW, null, 1, null), new g(
    null,
    ve.h(z(he.l(new g(null, Ky, null, 1, null), new g(null, SW, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, e, null, 1, null)))), null, 1, null)])))),
    null,
    1,
    null
  ))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, kf, null, 1, null), new g(null, dW, null, 1, null), Te([new g(null, n, null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.g(new g(null, mi, null, 1, null), l))), null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.g(new g(null, mi, null, 1, null), l))), null, 1, null)])))), null, 1, null)])))), null, 1, null), 2, null);
}, eq = function(e, n) {
  var t = z(n);
  return n = I(t), t = W(t), new g(null, n, new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(
    new g(null, Bq, null, 1, null),
    new g(null, I(n), null, 1, null)
  )))), null, 1, null), Te([new g(null, ve.h(z(he.l(
    new g(null, Yl, null, 1, null),
    new g(null, Et(ve.h(z(he.l(new g(null, H6, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yh, null, 1, null), new g(null, e, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Y0, null, 1, null), new g(null, Bq, null, 1, null)))), null, 1, null)])))), null, 1, null), Te([new g(null, SH, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yh, null, 1, null), new g(null, e, null, 1, null), Te([new g(null, ai, null, 1, null)])))), null, 1, null)]))))), null, 1, null),
    Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Wx, null, 1, null), new g(null, SH, null, 1, null), Te([new g(null, H6, null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, kf, null, 1, null), new g(null, H6, null, 1, null), Te([new g(null, n, null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.g(new g(null, mi, null, 1, null), t))), null, 1, null)])))), null, 1, null)])
  ))), null, 1, null)])))), null, 1, null), 2, null);
}, jG = function(e, n, t, l) {
  var r = on.g(mF, e);
  return bt.g(function(u) {
    var o = z(u);
    u = I(o), o = W(o);
    var a = _n.g(t, ml(u));
    return u = j(l) ? or(I(o)) ? JU(a, o, r) : bt.g(function(h) {
      return JU(a, h, r);
    }, o) : r ? or(I(o)) ? eq(a, o) : bt.g(function(h) {
      return eq(a, h);
    }, o) : o, r ? ve.h(z(he.l(new g(null, xw, null, 1, null), new g(null, a, null, 1, null), Te([new g(null, ai, null, 1, null), u])))) : ve.h(z(he.l(new g(null, xw, null, 1, null), new g(null, a, null, 1, null), Te([new g(null, e, null, 1, null), u]))));
  }, n);
}, oB = function(e) {
  return ye.h(e);
}, rpe = function(e, n) {
  var t = function() {
    var l = s5.h(e);
    if (j(l)) {
      var r = Ol(l, mF);
      return r || (r = la(n), j(r) ? Ol(l, oB(r)) : null);
    }
    return null;
  }();
  return j(t) ? t : pu(fu(function(l) {
    var r = HK(l, la(n));
    return j(r) ? (l = QO(l), l = en.g(l, ai), r !== l) : null;
  }, i1.h(e)));
}, nq = function(e, n) {
  if (n instanceof Z4) return Ol(n.ff, e);
  var t = o5.h(e), l = function() {
    if (j(t)) {
      if (j(on.g ? on.g(__, t) : on.call(null, __, t))) return n != null ? n.C & 32768 || Rn === n.Ke ? !0 : n.C ? !1 : pl(__, n) : pl(__, n);
      if (j(on.g ? on.g(S_, t) : on.call(null, S_, t))) return n != null ? n.J & 65536 || Rn === n.Ve ? !0 : n.J ? !1 : pl(S_, n) : pl(S_, n);
      if (j(on.g ? on.g(x_, t) : on.call(null, x_, t))) return n != null ? n.J & 32768 || Rn === n.Te ? !0 : n.J ? !1 : pl(x_, n) : pl(x_, n);
      if (j(on.g ? on.g(dm, t) : on.call(null, dm, t))) return n != null ? n.C & 67108864 || Rn === n.Re ? !0 : n.C ? !1 : pl(dm, n) : pl(dm, n);
      throw Error(["No matching clause: ", ye.h(t)].join(""));
    }
    return t;
  }();
  return j(l) ? l : rpe(e, n);
}, tq = function(e) {
  var n = la(e);
  return ["#", ye.h(n), ye.h(lr.g(Tt, e))].join("");
}, _2 = function(e, n, t, l, r) {
  this.uc = e, this.type = n, this.za = t, this.ib = l, this.Pd = r, this.C = 2230716170, this.J = 139264;
}, AG = function(e, n) {
  var t = ye.h(n), l = yg.g(t, ".");
  return n = j(l) ? Si.j(t, l + 1, t.length) : t, t = j(l) ? _n.h(Si.j(
    t,
    0,
    l
  )) : Vs(), n = _n.h(n), t = _n.h(F3(ye.h(t), "_", "-")), e = xr.g(sn(Or.h(e)), new v(null, 2, 5, y, [Il, t], null)), t = en.g(e, n), e = j(t) ? t : en.g(ta.h(e), n), j(e) ? Qs(e) ? sn(e) : e : null;
}, ipe = function(e, n) {
  return e = AG(e, n), j(e) && e instanceof v2 ? e : null;
}, upe = function(e, n, t, l, r) {
  var u = D(l, e, n), o = D(r, e, n), a = Jo(ie.h(o));
  return e = wr.g(Or.h(e), function(h) {
    var s = en.g(en.g(h, Il), a), d = en.g(s, t);
    return d = Qs(d) ? d : new Ne(d, _n.g(ye.h(a), ye.h(t)), Vt(d), !1), Mne !== u && Fm(d, u), j2.l(d, gr, Te([o])), s = Dn.j(s, t, d), xs(h, new v(null, 2, 5, y, [Il, a], null), s);
  }), en.g(en.g(en.g(e, Il), a), t);
}, spe = function(e, n, t, l, r, u) {
  try {
    var o = A_;
    A_ = function() {
      var s = j(u) ? bm : null;
      return j(s) || (s = z(l)) ? s : A_;
    }();
    try {
      return D(t, e, n);
    } finally {
      A_ = o;
    }
  } catch (s) {
    var a = s, h = wt.j(function(d, p) {
      var _ = gh.h(p);
      return j(function() {
        var R = Ln(ai, _);
        return R || (_ instanceof Ic ? (R = D(_, e, n), a instanceof R) : a instanceof _);
      }()) ? (d = y, n[HJ.h(p)] = a, p = D(uc.h(p), e, n), p = xh(new v(null, 2, 5, d, [U1e, p], null))) : p = null, p;
    }, null, l);
    return j(h) ? (O.j(h, 0, null), O.j(h, 1, null)) : Al(e, 0, a, t);
  } finally {
    D(r, e, n);
  }
}, ope = function(e, n, t) {
  return t.length === 0 ? e instanceof _2 ? en.j(e, ts.h(n), D_) : e instanceof sB ? en.j(e.ec(null), _n.h(n), D_) : D_ : D_;
}, ape = function(e, n, t, l, r, u, o) {
  var a = Vt(t);
  a = N2e.h(a);
  var h = D(t, e, n), s = ope(h, l, u);
  if (D_ !== s) return s;
  var d = j(a) ? a : zh(h), p = sn(Or.h(e)), _ = Hf.h(p);
  return a = function() {
    if (j(o)) return o;
    var R = en.g(_, Ew);
    return j(R) ? R : (R = _n.h(d.name), en.g(_, R));
  }(), j(a) || function() {
    var R = Ix.h(p);
    return j(R) ? R.h ? R.h(h) : R.call(null, h) : null;
  }(), j(a) || mu(["Method ", ye.h(l), " on ", ye.h(d), " not allowed!"].join(""), t), j(r) ? h[l] : TG(e, n, h, l, u);
}, vk = function(e, n, t, l) {
  switch (Cn(l)) {
    case 0:
      return t.o ? t.o() : t.call(null);
    case 1:
      var r = D(I(l), e, n), u = tn(l);
      return t.h ? t.h(r) : t.call(null, r);
    case 2:
      var o = D(I(l), e, n);
      u = tn(l);
      var a = D(I(u), e, n), h = tn(u);
      return t.g ? t.g(o, a) : t.call(null, o, a);
    case 3:
      var s = D(I(l), e, n);
      u = tn(l);
      var d = D(I(u), e, n);
      h = tn(u);
      var p = D(I(h), e, n), _ = tn(h);
      return t.j ? t.j(s, d, p) : t.call(null, s, d, p);
    case 4:
      var R = D(I(l), e, n);
      u = tn(l);
      var F = D(I(u), e, n);
      h = tn(u);
      var L = D(I(h), e, n);
      _ = tn(h);
      var G = D(I(_), e, n), J = tn(_);
      return t.B ? t.B(R, F, L, G) : t.call(null, R, F, L, G);
    case 5:
      var we = D(I(l), e, n);
      u = tn(l);
      var ce = D(I(u), e, n);
      h = tn(u);
      var xe = D(I(h), e, n);
      _ = tn(h);
      var $e = D(I(_), e, n);
      J = tn(_);
      var je = D(I(J), e, n), E = tn(J);
      return t.I ? t.I(we, ce, xe, $e, je) : t.call(null, we, ce, xe, $e, je);
    case 6:
      var P = D(I(l), e, n);
      u = tn(l);
      var K = D(I(u), e, n);
      h = tn(u);
      var H = D(I(h), e, n);
      _ = tn(h);
      var U = D(I(_), e, n);
      J = tn(_);
      var Me = D(I(J), e, n);
      E = tn(J);
      var le = D(I(E), e, n), Ce = tn(E);
      return t.T ? t.T(P, K, H, U, Me, le) : t.call(null, P, K, H, U, Me, le);
    case 7:
      var Ye = D(I(l), e, n);
      u = tn(l);
      var B = D(
        I(u),
        e,
        n
      );
      h = tn(u);
      var q = D(I(h), e, n);
      _ = tn(h);
      var me = D(I(_), e, n);
      J = tn(_);
      var Ae = D(I(J), e, n);
      E = tn(J);
      var Fe = D(I(E), e, n);
      Ce = tn(E);
      var ln = D(I(Ce), e, n), Be = tn(Ce);
      return t.ba ? t.ba(Ye, B, q, me, Ae, Fe, ln) : t.call(null, Ye, B, q, me, Ae, Fe, ln);
    case 8:
      var Ze = D(I(l), e, n);
      u = tn(l);
      var pn = D(I(u), e, n);
      h = tn(u);
      var xn = D(I(h), e, n);
      _ = tn(h);
      var Nn = D(I(_), e, n);
      J = tn(_);
      var at = D(I(J), e, n);
      E = tn(J);
      var Yt = D(I(E), e, n);
      Ce = tn(E);
      var jt = D(I(Ce), e, n);
      Be = tn(Ce);
      var Cl = D(I(Be), e, n), fn = tn(Be);
      return t.ia ? t.ia(Ze, pn, xn, Nn, at, Yt, jt, Cl) : t.call(
        null,
        Ze,
        pn,
        xn,
        Nn,
        at,
        Yt,
        jt,
        Cl
      );
    case 9:
      var _e = D(I(l), e, n);
      u = tn(l);
      var Ve = D(I(u), e, n);
      h = tn(u);
      var an = D(I(h), e, n);
      _ = tn(h);
      var En = D(I(_), e, n);
      J = tn(_);
      var Qn = D(I(J), e, n);
      E = tn(J);
      var Vn = D(I(E), e, n);
      Ce = tn(E);
      var ot = D(I(Ce), e, n);
      Be = tn(Ce);
      var Nt = D(I(Be), e, n);
      fn = tn(Be);
      var zt = D(I(fn), e, n), Pt = tn(fn);
      return t.va ? t.va(_e, Ve, an, En, Qn, Vn, ot, Nt, zt) : t.call(null, _e, Ve, an, En, Qn, Vn, ot, Nt, zt);
    case 10:
      var ol = D(I(l), e, n);
      u = tn(l);
      var St = D(I(u), e, n);
      h = tn(u);
      var pr = D(I(h), e, n);
      _ = tn(h);
      var ul = D(I(_), e, n);
      J = tn(_);
      var Rr = D(
        I(J),
        e,
        n
      );
      E = tn(J);
      var ql = D(I(E), e, n);
      Ce = tn(E);
      var Mr = D(I(Ce), e, n);
      Be = tn(Ce);
      var wi = D(I(Be), e, n);
      fn = tn(Be);
      var bl = D(I(fn), e, n);
      Pt = tn(fn);
      var tl = D(I(Pt), e, n), Zt = tn(Pt);
      return t.la ? t.la(ol, St, pr, ul, Rr, ql, Mr, wi, bl, tl) : t.call(null, ol, St, pr, ul, Rr, ql, Mr, wi, bl, tl);
    case 11:
      var Ql = D(I(l), e, n);
      u = tn(l);
      var jl = D(I(u), e, n);
      h = tn(u);
      var Sl = D(I(h), e, n);
      _ = tn(h);
      var gl = D(I(_), e, n);
      J = tn(_);
      var jr = D(I(J), e, n);
      E = tn(J);
      var Kt = D(I(E), e, n);
      Ce = tn(E);
      var nl = D(I(Ce), e, n);
      Be = tn(Ce);
      var Pr = D(I(Be), e, n);
      fn = tn(Be);
      var ii = D(I(fn), e, n);
      Pt = tn(fn);
      var Ar = D(I(Pt), e, n);
      Zt = tn(Pt);
      var Ml = D(I(Zt), e, n), Rl = tn(Zt);
      return t.ma ? t.ma(Ql, jl, Sl, gl, jr, Kt, nl, Pr, ii, Ar, Ml) : t.call(null, Ql, jl, Sl, gl, jr, Kt, nl, Pr, ii, Ar, Ml);
    case 12:
      var Se = D(I(l), e, n);
      u = tn(l);
      var se = D(I(u), e, n);
      h = tn(u);
      var Ee = D(I(h), e, n);
      _ = tn(h);
      var Ge = D(I(_), e, n);
      J = tn(_);
      var vn = D(I(J), e, n);
      E = tn(J);
      var Kn = D(I(E), e, n);
      Ce = tn(E);
      var Un = D(I(Ce), e, n);
      Be = tn(Ce);
      var Pe = D(I(Be), e, n);
      fn = tn(Be);
      var C = D(I(fn), e, n);
      Pt = tn(fn);
      var re = D(I(Pt), e, n);
      Zt = tn(Pt);
      var ge = D(I(Zt), e, n);
      Rl = tn(Zt);
      var Z = D(
        I(Rl),
        e,
        n
      ), Y = tn(Rl);
      return t.na ? t.na(Se, se, Ee, Ge, vn, Kn, Un, Pe, C, re, ge, Z) : t.call(null, Se, se, Ee, Ge, vn, Kn, Un, Pe, C, re, ge, Z);
    case 13:
      var oe = D(I(l), e, n);
      u = tn(l);
      var ke = D(I(u), e, n);
      h = tn(u);
      var De = D(I(h), e, n);
      _ = tn(h);
      var un = D(I(_), e, n);
      J = tn(_);
      var gn = D(I(J), e, n);
      E = tn(J);
      var Tn = D(I(E), e, n);
      Ce = tn(E);
      var ft = D(I(Ce), e, n);
      Be = tn(Ce);
      var gt = D(I(Be), e, n);
      fn = tn(Be);
      var Gt = D(I(fn), e, n);
      Pt = tn(fn);
      var zl = D(I(Pt), e, n);
      Zt = tn(Pt);
      var qe = D(I(Zt), e, n);
      Rl = tn(Zt);
      var ae = D(I(Rl), e, n);
      Y = tn(Rl);
      var Ue = D(I(Y), e, n), ze = tn(Y);
      return t.oa ? t.oa(oe, ke, De, un, gn, Tn, ft, gt, Gt, zl, qe, ae, Ue) : t.call(null, oe, ke, De, un, gn, Tn, ft, gt, Gt, zl, qe, ae, Ue);
    case 14:
      var dn = D(I(l), e, n);
      u = tn(l);
      var ut = D(I(u), e, n);
      h = tn(u);
      var Zn = D(I(h), e, n);
      _ = tn(h);
      var ht = D(I(_), e, n);
      J = tn(_);
      var ct = D(I(J), e, n);
      E = tn(J);
      var Hl = D(I(E), e, n);
      Ce = tn(E);
      var Pl = D(I(Ce), e, n);
      Be = tn(Ce);
      var Fn = D(I(Be), e, n);
      fn = tn(Be);
      var br = D(I(fn), e, n);
      Pt = tn(fn);
      var Wn = D(I(Pt), e, n);
      Zt = tn(Pt);
      var cs = D(I(Zt), e, n);
      Rl = tn(Zt);
      var Ds = D(I(Rl), e, n);
      Y = tn(Rl);
      var ac = D(I(Y), e, n);
      ze = tn(Y);
      var Hs = D(I(ze), e, n), vu = tn(ze);
      return t.pa ? t.pa(dn, ut, Zn, ht, ct, Hl, Pl, Fn, br, Wn, cs, Ds, ac, Hs) : t.call(null, dn, ut, Zn, ht, ct, Hl, Pl, Fn, br, Wn, cs, Ds, ac, Hs);
    case 15:
      var Ji = D(I(l), e, n);
      u = tn(l);
      var hs = D(I(u), e, n);
      h = tn(u);
      var li = D(I(h), e, n);
      _ = tn(h);
      var cc = D(I(_), e, n);
      J = tn(_);
      var eu = D(I(J), e, n);
      E = tn(J);
      var $a = D(I(E), e, n);
      Ce = tn(E);
      var oa = D(I(Ce), e, n);
      Be = tn(Ce);
      var hc = D(I(Be), e, n);
      fn = tn(Be);
      var aa = D(I(fn), e, n);
      Pt = tn(fn);
      var Eo = D(I(Pt), e, n);
      Zt = tn(Pt);
      var be = D(I(Zt), e, n);
      Rl = tn(Zt);
      var b = D(I(Rl), e, n);
      Y = tn(Rl);
      var w = D(I(Y), e, n);
      ze = tn(Y);
      var i = D(I(ze), e, n);
      vu = tn(ze);
      var x = D(I(vu), e, n), X = tn(vu);
      return t.qa ? t.qa(Ji, hs, li, cc, eu, $a, oa, hc, aa, Eo, be, b, w, i, x) : t.call(null, Ji, hs, li, cc, eu, $a, oa, hc, aa, Eo, be, b, w, i, x);
    case 16:
      var He = D(I(l), e, n);
      u = tn(l);
      var $n = D(I(u), e, n);
      h = tn(u);
      var Xt = D(I(h), e, n);
      _ = tn(h);
      var $l = D(I(_), e, n);
      J = tn(_);
      var Oe = D(I(J), e, n);
      E = tn(J);
      var Ke = D(I(E), e, n);
      Ce = tn(E);
      var mn = D(I(Ce), e, n);
      Be = tn(Ce);
      var wn = D(I(Be), e, n);
      fn = tn(Be);
      var On = D(I(fn), e, n);
      Pt = tn(fn);
      var An = D(I(Pt), e, n);
      Zt = tn(Pt);
      var mt = D(I(Zt), e, n);
      Rl = tn(Zt);
      var Ot = D(I(Rl), e, n);
      Y = tn(Rl);
      var ll = D(I(Y), e, n);
      ze = tn(Y);
      var Nr = D(I(ze), e, n);
      vu = tn(ze);
      var hi = D(I(vu), e, n);
      X = tn(vu);
      var Oo = D(I(X), e, n), yu = tn(X);
      return t.ra ? t.ra(He, $n, Xt, $l, Oe, Ke, mn, wn, On, An, mt, Ot, ll, Nr, hi, Oo) : t.call(null, He, $n, Xt, $l, Oe, Ke, mn, wn, On, An, mt, Ot, ll, Nr, hi, Oo);
    case 17:
      var $r = D(I(l), e, n);
      u = tn(l);
      var ri = D(I(u), e, n);
      h = tn(u);
      var bh = D(I(h), e, n);
      _ = tn(h);
      var Tg = D(I(_), e, n);
      J = tn(_);
      var jg = D(I(J), e, n);
      E = tn(J);
      var Ag = D(I(E), e, n);
      Ce = tn(E);
      var sd = D(I(Ce), e, n);
      Be = tn(Ce);
      var Dg = D(I(Be), e, n);
      fn = tn(Be);
      var gf = D(I(fn), e, n);
      Pt = tn(fn);
      var I1 = D(I(Pt), e, n);
      Zt = tn(Pt);
      var au = D(I(Zt), e, n);
      Rl = tn(Zt);
      var _u = D(I(Rl), e, n);
      Y = tn(Rl);
      var La = D(I(Y), e, n);
      ze = tn(Y);
      var Mp = D(I(ze), e, n);
      vu = tn(ze);
      var Th = D(I(vu), e, n);
      X = tn(vu);
      var fs = D(I(X), e, n);
      yu = tn(X);
      var od = D(I(yu), e, n), Kc = tn(yu);
      return t.sa ? t.sa($r, ri, bh, Tg, jg, Ag, sd, Dg, gf, I1, au, _u, La, Mp, Th, fs, od) : t.call(null, $r, ri, bh, Tg, jg, Ag, sd, Dg, gf, I1, au, _u, La, Mp, Th, fs, od);
    case 18:
      var Pp = D(I(l), e, n);
      u = tn(l);
      var jh = D(I(u), e, n);
      h = tn(u);
      var zs = D(I(h), e, n);
      _ = tn(h);
      var Ah = D(I(_), e, n);
      J = tn(_);
      var Wu = D(I(J), e, n);
      E = tn(J);
      var Ig = D(I(E), e, n);
      Ce = tn(E);
      var ko = D(I(Ce), e, n);
      Be = tn(Ce);
      var R1 = D(I(Be), e, n);
      fn = tn(Be);
      var ad = D(I(fn), e, n);
      Pt = tn(fn);
      var Hu = D(I(Pt), e, n);
      Zt = tn(Pt);
      var cd = D(I(Zt), e, n);
      Rl = tn(Zt);
      var bo = D(I(Rl), e, n);
      Y = tn(Rl);
      var Kl = D(I(Y), e, n);
      ze = tn(Y);
      var Ba = D(I(ze), e, n);
      vu = tn(ze);
      var hd = D(I(vu), e, n);
      X = tn(vu);
      var Rg = D(I(X), e, n);
      yu = tn(X);
      var $p = D(I(yu), e, n);
      Kc = tn(yu);
      var N1 = D(I(Kc), e, n), Lp = tn(Kc);
      return t.ta ? t.ta(
        Pp,
        jh,
        zs,
        Ah,
        Wu,
        Ig,
        ko,
        R1,
        ad,
        Hu,
        cd,
        bo,
        Kl,
        Ba,
        hd,
        Rg,
        $p,
        N1
      ) : t.call(null, Pp, jh, zs, Ah, Wu, Ig, ko, R1, ad, Hu, cd, bo, Kl, Ba, hd, Rg, $p, N1);
    case 19:
      var Ng = D(I(l), e, n);
      u = tn(l);
      var Cg = D(I(u), e, n);
      h = tn(u);
      var ro = D(I(h), e, n);
      _ = tn(h);
      var ds = D(I(_), e, n);
      J = tn(_);
      var Mg = D(I(J), e, n);
      E = tn(J);
      var Pg = D(I(E), e, n);
      Ce = tn(E);
      var Bp = D(I(Ce), e, n);
      Be = tn(Ce);
      var fd = D(I(Be), e, n);
      fn = tn(Be);
      var dd = D(I(fn), e, n);
      Pt = tn(fn);
      var pd = D(I(Pt), e, n);
      Zt = tn(Pt);
      var $g = D(I(Zt), e, n);
      Rl = tn(Zt);
      var md = D(I(Rl), e, n);
      Y = tn(Rl);
      var gd = D(I(Y), e, n);
      ze = tn(Y);
      var Lg = D(I(ze), e, n);
      vu = tn(ze);
      var Fp = D(I(vu), e, n);
      X = tn(vu);
      var Gi = D(I(X), e, n);
      yu = tn(X);
      var bi = D(I(yu), e, n);
      Kc = tn(yu);
      var xu = D(I(Kc), e, n);
      Lp = tn(Kc);
      var Vp = D(I(Lp), e, n);
      return tn(Lp), t.ua ? t.ua(Ng, Cg, ro, ds, Mg, Pg, Bp, fd, dd, pd, $g, md, gd, Lg, Fp, Gi, bi, xu, Vp) : t.call(null, Ng, Cg, ro, ds, Mg, Pg, Bp, fd, dd, pd, $g, md, gd, Lg, Fp, Gi, bi, xu, Vp);
    default:
      return u = wo.g(function(io) {
        return D(io, e, n);
      }, l), In.g(t, u);
  }
}, DG = function(e, n, t, l, r, u, o) {
  return j(o) ? function() {
    switch (t) {
      case 0:
        return function() {
          function a(s) {
            var d = null;
            if (0 < arguments.length) {
              d = 0;
              for (var p = Array(arguments.length - 0); d < p.length; ) p[d] = arguments[d + 0], ++d;
              d = new hn(p, 0, null);
            }
            return h.call(this, d);
          }
          function h(s) {
            var d = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, d) : l.call(null, n, d)), d[o] = s; ; ) if (s = D(r, e, d), !Ln(Ll, s)) return s;
          }
          return a.m = 0, a.v = function(s) {
            return s = z(s), h(s);
          }, a.l = h, a;
        }();
      case 1:
        return function() {
          function a(s, d) {
            var p = null;
            if (1 < arguments.length) {
              p = 0;
              for (var _ = Array(arguments.length - 1); p < _.length; ) _[p] = arguments[p + 1], ++p;
              p = new hn(_, 0, null);
            }
            return h.call(this, s, p);
          }
          function h(s, d) {
            var p = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, p) : l.call(null, n, p)), p[0] = s, p[o] = d; ; ) if (s = D(r, e, p), !Ln(Ll, s)) return s;
          }
          return a.m = 1, a.v = function(s) {
            var d = I(s);
            return s = tn(s), h(d, s);
          }, a.l = h, a;
        }();
      case 2:
        return function() {
          function a(s, d, p) {
            var _ = null;
            if (2 < arguments.length) {
              _ = 0;
              for (var R = Array(arguments.length - 2); _ < R.length; ) R[_] = arguments[_ + 2], ++_;
              _ = new hn(R, 0, null);
            }
            return h.call(this, s, d, _);
          }
          function h(s, d, p) {
            var _ = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, _) : l.call(null, n, _)), _[0] = s, _[1] = d, _[o] = p; ; ) if (s = D(r, e, _), !Ln(Ll, s)) return s;
          }
          return a.m = 2, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            return s = tn(s), h(d, p, s);
          }, a.l = h, a;
        }();
      case 3:
        return function() {
          function a(s, d, p, _) {
            var R = null;
            if (3 < arguments.length) {
              R = 0;
              for (var F = Array(arguments.length - 3); R < F.length; ) F[R] = arguments[R + 3], ++R;
              R = new hn(F, 0, null);
            }
            return h.call(this, s, d, p, R);
          }
          function h(s, d, p, _) {
            var R = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, R) : l.call(null, n, R)), R[0] = s, R[1] = d, R[2] = p, R[o] = _; ; ) if (s = D(r, e, R), !Ln(Ll, s)) return s;
          }
          return a.m = 3, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            return s = tn(s), h(d, p, _, s);
          }, a.l = h, a;
        }();
      case 4:
        return function() {
          function a(s, d, p, _, R) {
            var F = null;
            if (4 < arguments.length) {
              F = 0;
              for (var L = Array(arguments.length - 4); F < L.length; ) L[F] = arguments[F + 4], ++F;
              F = new hn(L, 0, null);
            }
            return h.call(this, s, d, p, _, F);
          }
          function h(s, d, p, _, R) {
            var F = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, F) : l.call(null, n, F)), F[0] = s, F[1] = d, F[2] = p, F[3] = _, F[o] = R; ; ) if (s = D(r, e, F), !Ln(Ll, s)) return s;
          }
          return a.m = 4, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            return s = tn(s), h(d, p, _, R, s);
          }, a.l = h, a;
        }();
      case 5:
        return function() {
          function a(s, d, p, _, R, F) {
            var L = null;
            if (5 < arguments.length) {
              L = 0;
              for (var G = Array(arguments.length - 5); L < G.length; ) G[L] = arguments[L + 5], ++L;
              L = new hn(G, 0, null);
            }
            return h.call(this, s, d, p, _, R, L);
          }
          function h(s, d, p, _, R, F) {
            var L = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, L) : l.call(null, n, L)), L[0] = s, L[1] = d, L[2] = p, L[3] = _, L[4] = R, L[o] = F; ; ) if (s = D(r, e, L), !Ln(Ll, s)) return s;
          }
          return a.m = 5, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            return s = tn(s), h(d, p, _, R, F, s);
          }, a.l = h, a;
        }();
      case 6:
        return function() {
          function a(s, d, p, _, R, F, L) {
            var G = null;
            if (6 < arguments.length) {
              G = 0;
              for (var J = Array(arguments.length - 6); G < J.length; ) J[G] = arguments[G + 6], ++G;
              G = new hn(J, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, G);
          }
          function h(s, d, p, _, R, F, L) {
            var G = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, G) : l.call(null, n, G)), G[0] = s, G[1] = d, G[2] = p, G[3] = _, G[4] = R, G[5] = F, G[o] = L; ; ) if (s = D(r, e, G), !Ln(Ll, s)) return s;
          }
          return a.m = 6, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            return s = tn(s), h(d, p, _, R, F, L, s);
          }, a.l = h, a;
        }();
      case 7:
        return function() {
          function a(s, d, p, _, R, F, L, G) {
            var J = null;
            if (7 < arguments.length) {
              J = 0;
              for (var we = Array(arguments.length - 7); J < we.length; ) we[J] = arguments[J + 7], ++J;
              J = new hn(we, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, J);
          }
          function h(s, d, p, _, R, F, L, G) {
            var J = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, J) : l.call(null, n, J)), J[0] = s, J[1] = d, J[2] = p, J[3] = _, J[4] = R, J[5] = F, J[6] = L, J[o] = G; ; ) if (s = D(r, e, J), !Ln(Ll, s)) return s;
          }
          return a.m = 7, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, s);
          }, a.l = h, a;
        }();
      case 8:
        return function() {
          function a(s, d, p, _, R, F, L, G, J) {
            var we = null;
            if (8 < arguments.length) {
              we = 0;
              for (var ce = Array(arguments.length - 8); we < ce.length; ) ce[we] = arguments[we + 8], ++we;
              we = new hn(ce, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, we);
          }
          function h(s, d, p, _, R, F, L, G, J) {
            var we = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, we) : l.call(null, n, we)), we[0] = s, we[1] = d, we[2] = p, we[3] = _, we[4] = R, we[5] = F, we[6] = L, we[7] = G, we[o] = J; ; ) if (s = D(r, e, we), !Ln(Ll, s)) return s;
          }
          return a.m = 8, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, s);
          }, a.l = h, a;
        }();
      case 9:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we) {
            var ce = null;
            if (9 < arguments.length) {
              ce = 0;
              for (var xe = Array(arguments.length - 9); ce < xe.length; ) xe[ce] = arguments[ce + 9], ++ce;
              ce = new hn(xe, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, ce);
          }
          function h(s, d, p, _, R, F, L, G, J, we) {
            var ce = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, ce) : l.call(null, n, ce)), ce[0] = s, ce[1] = d, ce[2] = p, ce[3] = _, ce[4] = R, ce[5] = F, ce[6] = L, ce[7] = G, ce[8] = J, ce[o] = we; ; ) if (s = D(r, e, ce), !Ln(Ll, s)) return s;
          }
          return a.m = 9, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, s);
          }, a.l = h, a;
        }();
      case 10:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce) {
            var xe = null;
            if (10 < arguments.length) {
              xe = 0;
              for (var $e = Array(arguments.length - 10); xe < $e.length; ) $e[xe] = arguments[xe + 10], ++xe;
              xe = new hn($e, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, xe);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce) {
            var xe = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, xe) : l.call(null, n, xe)), xe[0] = s, xe[1] = d, xe[2] = p, xe[3] = _, xe[4] = R, xe[5] = F, xe[6] = L, xe[7] = G, xe[8] = J, xe[9] = we, xe[o] = ce; ; ) if (s = D(r, e, xe), !Ln(Ll, s)) return s;
          }
          return a.m = 10, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, ce, s);
          }, a.l = h, a;
        }();
      case 11:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce, xe) {
            var $e = null;
            if (11 < arguments.length) {
              $e = 0;
              for (var je = Array(arguments.length - 11); $e < je.length; ) je[$e] = arguments[$e + 11], ++$e;
              $e = new hn(je, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, ce, $e);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce, xe) {
            var $e = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, $e) : l.call(null, n, $e)), $e[0] = s, $e[1] = d, $e[2] = p, $e[3] = _, $e[4] = R, $e[5] = F, $e[6] = L, $e[7] = G, $e[8] = J, $e[9] = we, $e[10] = ce, $e[o] = xe; ; ) if (s = D(r, e, $e), !Ln(Ll, s)) return s;
          }
          return a.m = 11, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            s = W(s);
            var xe = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, ce, xe, s);
          }, a.l = h, a;
        }();
      case 12:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce, xe, $e) {
            var je = null;
            if (12 < arguments.length) {
              je = 0;
              for (var E = Array(arguments.length - 12); je < E.length; ) E[je] = arguments[je + 12], ++je;
              je = new hn(E, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, ce, xe, je);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce, xe, $e) {
            var je = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, je) : l.call(null, n, je)), je[0] = s, je[1] = d, je[2] = p, je[3] = _, je[4] = R, je[5] = F, je[6] = L, je[7] = G, je[8] = J, je[9] = we, je[10] = ce, je[11] = xe, je[o] = $e; ; ) if (s = D(r, e, je), !Ln(Ll, s)) return s;
          }
          return a.m = 12, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            s = W(s);
            var xe = I(s);
            s = W(s);
            var $e = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, ce, xe, $e, s);
          }, a.l = h, a;
        }();
      case 13:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je) {
            var E = null;
            if (13 < arguments.length) {
              E = 0;
              for (var P = Array(arguments.length - 13); E < P.length; ) P[E] = arguments[E + 13], ++E;
              E = new hn(P, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, E);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je) {
            var E = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, E) : l.call(null, n, E)), E[0] = s, E[1] = d, E[2] = p, E[3] = _, E[4] = R, E[5] = F, E[6] = L, E[7] = G, E[8] = J, E[9] = we, E[10] = ce, E[11] = xe, E[12] = $e, E[o] = je; ; ) if (s = D(r, e, E), !Ln(Ll, s)) return s;
          }
          return a.m = 13, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            s = W(s);
            var xe = I(s);
            s = W(s);
            var $e = I(s);
            s = W(s);
            var je = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, ce, xe, $e, je, s);
          }, a.l = h, a;
        }();
      case 14:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E) {
            var P = null;
            if (14 < arguments.length) {
              P = 0;
              for (var K = Array(arguments.length - 14); P < K.length; ) K[P] = arguments[P + 14], ++P;
              P = new hn(K, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, P);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E) {
            var P = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, P) : l.call(null, n, P)), P[0] = s, P[1] = d, P[2] = p, P[3] = _, P[4] = R, P[5] = F, P[6] = L, P[7] = G, P[8] = J, P[9] = we, P[10] = ce, P[11] = xe, P[12] = $e, P[13] = je, P[o] = E; ; ) if (s = D(r, e, P), !Ln(Ll, s)) return s;
          }
          return a.m = 14, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            s = W(s);
            var xe = I(s);
            s = W(s);
            var $e = I(s);
            s = W(s);
            var je = I(s);
            s = W(s);
            var E = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, s);
          }, a.l = h, a;
        }();
      case 15:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P) {
            var K = null;
            if (15 < arguments.length) {
              K = 0;
              for (var H = Array(arguments.length - 15); K < H.length; ) H[K] = arguments[K + 15], ++K;
              K = new hn(H, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, K);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P) {
            var K = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, K) : l.call(null, n, K)), K[0] = s, K[1] = d, K[2] = p, K[3] = _, K[4] = R, K[5] = F, K[6] = L, K[7] = G, K[8] = J, K[9] = we, K[10] = ce, K[11] = xe, K[12] = $e, K[13] = je, K[14] = E, K[o] = P; ; ) if (s = D(r, e, K), !Ln(Ll, s)) return s;
          }
          return a.m = 15, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            s = W(s);
            var xe = I(s);
            s = W(s);
            var $e = I(s);
            s = W(s);
            var je = I(s);
            s = W(s);
            var E = I(s);
            s = W(s);
            var P = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, s);
          }, a.l = h, a;
        }();
      case 16:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K) {
            var H = null;
            if (16 < arguments.length) {
              H = 0;
              for (var U = Array(arguments.length - 16); H < U.length; ) U[H] = arguments[H + 16], ++H;
              H = new hn(U, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, H);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K) {
            var H = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, H) : l.call(null, n, H)), H[0] = s, H[1] = d, H[2] = p, H[3] = _, H[4] = R, H[5] = F, H[6] = L, H[7] = G, H[8] = J, H[9] = we, H[10] = ce, H[11] = xe, H[12] = $e, H[13] = je, H[14] = E, H[15] = P, H[o] = K; ; ) if (s = D(r, e, H), !Ln(Ll, s)) return s;
          }
          return a.m = 16, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            s = W(s);
            var xe = I(s);
            s = W(s);
            var $e = I(s);
            s = W(s);
            var je = I(s);
            s = W(s);
            var E = I(s);
            s = W(s);
            var P = I(s);
            s = W(s);
            var K = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, s);
          }, a.l = h, a;
        }();
      case 17:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H) {
            var U = null;
            if (17 < arguments.length) {
              U = 0;
              for (var Me = Array(arguments.length - 17); U < Me.length; ) Me[U] = arguments[U + 17], ++U;
              U = new hn(Me, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, U);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H) {
            var U = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, U) : l.call(null, n, U)), U[0] = s, U[1] = d, U[2] = p, U[3] = _, U[4] = R, U[5] = F, U[6] = L, U[7] = G, U[8] = J, U[9] = we, U[10] = ce, U[11] = xe, U[12] = $e, U[13] = je, U[14] = E, U[15] = P, U[16] = K, U[o] = H; ; ) if (s = D(r, e, U), !Ln(Ll, s)) return s;
          }
          return a.m = 17, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            s = W(s);
            var xe = I(s);
            s = W(s);
            var $e = I(s);
            s = W(s);
            var je = I(s);
            s = W(s);
            var E = I(s);
            s = W(s);
            var P = I(s);
            s = W(s);
            var K = I(s);
            s = W(s);
            var H = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, s);
          }, a.l = h, a;
        }();
      case 18:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, U) {
            var Me = null;
            if (18 < arguments.length) {
              Me = 0;
              for (var le = Array(arguments.length - 18); Me < le.length; ) le[Me] = arguments[Me + 18], ++Me;
              Me = new hn(le, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, Me);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, U) {
            var Me = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, Me) : l.call(null, n, Me)), Me[0] = s, Me[1] = d, Me[2] = p, Me[3] = _, Me[4] = R, Me[5] = F, Me[6] = L, Me[7] = G, Me[8] = J, Me[9] = we, Me[10] = ce, Me[11] = xe, Me[12] = $e, Me[13] = je, Me[14] = E, Me[15] = P, Me[16] = K, Me[17] = H, Me[o] = U; ; ) if (s = D(r, e, Me), !Ln(Ll, s)) return s;
          }
          return a.m = 18, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            s = W(s);
            var xe = I(s);
            s = W(s);
            var $e = I(s);
            s = W(s);
            var je = I(s);
            s = W(s);
            var E = I(s);
            s = W(s);
            var P = I(s);
            s = W(s);
            var K = I(s);
            s = W(s);
            var H = I(s);
            s = W(s);
            var U = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, U, s);
          }, a.l = h, a;
        }();
      case 19:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, U, Me) {
            var le = null;
            if (19 < arguments.length) {
              le = 0;
              for (var Ce = Array(arguments.length - 19); le < Ce.length; ) Ce[le] = arguments[le + 19], ++le;
              le = new hn(Ce, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, U, le);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, U, Me) {
            var le = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, le) : l.call(null, n, le)), le[0] = s, le[1] = d, le[2] = p, le[3] = _, le[4] = R, le[5] = F, le[6] = L, le[7] = G, le[8] = J, le[9] = we, le[10] = ce, le[11] = xe, le[12] = $e, le[13] = je, le[14] = E, le[15] = P, le[16] = K, le[17] = H, le[18] = U, le[o] = Me; ; ) if (s = D(r, e, le), !Ln(Ll, s)) return s;
          }
          return a.m = 19, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            s = W(s);
            var xe = I(s);
            s = W(s);
            var $e = I(s);
            s = W(s);
            var je = I(s);
            s = W(s);
            var E = I(s);
            s = W(s);
            var P = I(s);
            s = W(s);
            var K = I(s);
            s = W(s);
            var H = I(s);
            s = W(s);
            var U = I(s);
            s = W(s);
            var Me = I(s);
            return s = tn(s), h(d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, U, Me, s);
          }, a.l = h, a;
        }();
      case 20:
        return function() {
          function a(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, U, Me, le) {
            var Ce = null;
            if (20 < arguments.length) {
              Ce = 0;
              for (var Ye = Array(arguments.length - 20); Ce < Ye.length; ) Ye[Ce] = arguments[Ce + 20], ++Ce;
              Ce = new hn(Ye, 0, null);
            }
            return h.call(this, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, U, Me, Ce);
          }
          function h(s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H, U, Me, le) {
            var Ce = u === 0 ? null : Gl.h(u);
            for (j(l) && (l.g ? l.g(n, Ce) : l.call(null, n, Ce)), Ce[0] = s, Ce[1] = d, Ce[2] = p, Ce[3] = _, Ce[4] = R, Ce[5] = F, Ce[6] = L, Ce[7] = G, Ce[8] = J, Ce[9] = we, Ce[10] = ce, Ce[11] = xe, Ce[12] = $e, Ce[13] = je, Ce[14] = E, Ce[15] = P, Ce[16] = K, Ce[17] = H, Ce[18] = U, Ce[19] = Me, Ce[o] = le; ; ) if (s = D(r, e, Ce), !Ln(Ll, s)) return s;
          }
          return a.m = 20, a.v = function(s) {
            var d = I(s);
            s = W(s);
            var p = I(s);
            s = W(s);
            var _ = I(s);
            s = W(s);
            var R = I(s);
            s = W(s);
            var F = I(s);
            s = W(s);
            var L = I(s);
            s = W(s);
            var G = I(s);
            s = W(s);
            var J = I(s);
            s = W(s);
            var we = I(s);
            s = W(s);
            var ce = I(s);
            s = W(s);
            var xe = I(s);
            s = W(s);
            var $e = I(s);
            s = W(s);
            var je = I(s);
            s = W(s);
            var E = I(s);
            s = W(s);
            var P = I(s);
            s = W(s);
            var K = I(s);
            s = W(s);
            var H = I(s);
            s = W(s);
            var U = I(s);
            s = W(s);
            var Me = I(s);
            s = W(s);
            var le = I(s);
            return s = tn(s), h(
              d,
              p,
              _,
              R,
              F,
              L,
              G,
              J,
              we,
              ce,
              xe,
              $e,
              je,
              E,
              P,
              K,
              H,
              U,
              Me,
              le,
              s
            );
          }, a.l = h, a;
        }();
      default:
        throw Error(["No matching clause: ", ye.h(t)].join(""));
    }
  }() : function() {
    switch (t) {
      case 0:
        return function() {
          var a = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, a) : l.call(null, n, a)); ; ) {
            var h = D(r, e, a);
            if (!Ln(Ll, h)) return h;
          }
        };
      case 1:
        return function(a) {
          var h = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, h) : l.call(null, n, h)), h[0] = a; ; ) if (a = D(r, e, h), !Ln(Ll, a)) return a;
        };
      case 2:
        return function(a, h) {
          var s = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, s) : l.call(
            null,
            n,
            s
          )), s[0] = a, s[1] = h; ; ) if (a = D(r, e, s), !Ln(Ll, a)) return a;
        };
      case 3:
        return function(a, h, s) {
          var d = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, d) : l.call(null, n, d)), d[0] = a, d[1] = h, d[2] = s; ; ) if (a = D(r, e, d), !Ln(Ll, a)) return a;
        };
      case 4:
        return function(a, h, s, d) {
          var p = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, p) : l.call(null, n, p)), p[0] = a, p[1] = h, p[2] = s, p[3] = d; ; ) if (a = D(r, e, p), !Ln(Ll, a)) return a;
        };
      case 5:
        return function(a, h, s, d, p) {
          var _ = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, _) : l.call(null, n, _)), _[0] = a, _[1] = h, _[2] = s, _[3] = d, _[4] = p; ; ) if (a = D(r, e, _), !Ln(Ll, a)) return a;
        };
      case 6:
        return function(a, h, s, d, p, _) {
          var R = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, R) : l.call(null, n, R)), R[0] = a, R[1] = h, R[2] = s, R[3] = d, R[4] = p, R[5] = _; ; ) if (a = D(r, e, R), !Ln(Ll, a)) return a;
        };
      case 7:
        return function(a, h, s, d, p, _, R) {
          var F = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, F) : l.call(null, n, F)), F[0] = a, F[1] = h, F[2] = s, F[3] = d, F[4] = p, F[5] = _, F[6] = R; ; ) if (a = D(r, e, F), !Ln(Ll, a)) return a;
        };
      case 8:
        return function(a, h, s, d, p, _, R, F) {
          var L = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, L) : l.call(null, n, L)), L[0] = a, L[1] = h, L[2] = s, L[3] = d, L[4] = p, L[5] = _, L[6] = R, L[7] = F; ; ) if (a = D(r, e, L), !Ln(Ll, a)) return a;
        };
      case 9:
        return function(a, h, s, d, p, _, R, F, L) {
          var G = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, G) : l.call(null, n, G)), G[0] = a, G[1] = h, G[2] = s, G[3] = d, G[4] = p, G[5] = _, G[6] = R, G[7] = F, G[8] = L; ; ) if (a = D(r, e, G), !Ln(Ll, a)) return a;
        };
      case 10:
        return function(a, h, s, d, p, _, R, F, L, G) {
          var J = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, J) : l.call(null, n, J)), J[0] = a, J[1] = h, J[2] = s, J[3] = d, J[4] = p, J[5] = _, J[6] = R, J[7] = F, J[8] = L, J[9] = G; ; ) if (a = D(r, e, J), !Ln(Ll, a)) return a;
        };
      case 11:
        return function(a, h, s, d, p, _, R, F, L, G, J) {
          var we = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, we) : l.call(null, n, we)), we[0] = a, we[1] = h, we[2] = s, we[3] = d, we[4] = p, we[5] = _, we[6] = R, we[7] = F, we[8] = L, we[9] = G, we[10] = J; ; ) if (a = D(r, e, we), !Ln(Ll, a)) return a;
        };
      case 12:
        return function(a, h, s, d, p, _, R, F, L, G, J, we) {
          var ce = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, ce) : l.call(null, n, ce)), ce[0] = a, ce[1] = h, ce[2] = s, ce[3] = d, ce[4] = p, ce[5] = _, ce[6] = R, ce[7] = F, ce[8] = L, ce[9] = G, ce[10] = J, ce[11] = we; ; ) if (a = D(r, e, ce), !Ln(Ll, a)) return a;
        };
      case 13:
        return function(a, h, s, d, p, _, R, F, L, G, J, we, ce) {
          var xe = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, xe) : l.call(null, n, xe)), xe[0] = a, xe[1] = h, xe[2] = s, xe[3] = d, xe[4] = p, xe[5] = _, xe[6] = R, xe[7] = F, xe[8] = L, xe[9] = G, xe[10] = J, xe[11] = we, xe[12] = ce; ; ) if (a = D(r, e, xe), !Ln(Ll, a)) return a;
        };
      case 14:
        return function(a, h, s, d, p, _, R, F, L, G, J, we, ce, xe) {
          var $e = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, $e) : l.call(null, n, $e)), $e[0] = a, $e[1] = h, $e[2] = s, $e[3] = d, $e[4] = p, $e[5] = _, $e[6] = R, $e[7] = F, $e[8] = L, $e[9] = G, $e[10] = J, $e[11] = we, $e[12] = ce, $e[13] = xe; ; ) if (a = D(r, e, $e), !Ln(Ll, a)) return a;
        };
      case 15:
        return function(a, h, s, d, p, _, R, F, L, G, J, we, ce, xe, $e) {
          var je = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, je) : l.call(null, n, je)), je[0] = a, je[1] = h, je[2] = s, je[3] = d, je[4] = p, je[5] = _, je[6] = R, je[7] = F, je[8] = L, je[9] = G, je[10] = J, je[11] = we, je[12] = ce, je[13] = xe, je[14] = $e; ; ) if (a = D(r, e, je), !Ln(Ll, a)) return a;
        };
      case 16:
        return function(a, h, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je) {
          var E = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, E) : l.call(null, n, E)), E[0] = a, E[1] = h, E[2] = s, E[3] = d, E[4] = p, E[5] = _, E[6] = R, E[7] = F, E[8] = L, E[9] = G, E[10] = J, E[11] = we, E[12] = ce, E[13] = xe, E[14] = $e, E[15] = je; ; ) if (a = D(r, e, E), !Ln(Ll, a)) return a;
        };
      case 17:
        return function(a, h, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E) {
          var P = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, P) : l.call(null, n, P)), P[0] = a, P[1] = h, P[2] = s, P[3] = d, P[4] = p, P[5] = _, P[6] = R, P[7] = F, P[8] = L, P[9] = G, P[10] = J, P[11] = we, P[12] = ce, P[13] = xe, P[14] = $e, P[15] = je, P[16] = E; ; ) if (a = D(r, e, P), !Ln(Ll, a)) return a;
        };
      case 18:
        return function(a, h, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P) {
          var K = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, K) : l.call(null, n, K)), K[0] = a, K[1] = h, K[2] = s, K[3] = d, K[4] = p, K[5] = _, K[6] = R, K[7] = F, K[8] = L, K[9] = G, K[10] = J, K[11] = we, K[12] = ce, K[13] = xe, K[14] = $e, K[15] = je, K[16] = E, K[17] = P; ; ) if (a = D(r, e, K), !Ln(Ll, a)) return a;
        };
      case 19:
        return function(a, h, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K) {
          var H = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, H) : l.call(null, n, H)), H[0] = a, H[1] = h, H[2] = s, H[3] = d, H[4] = p, H[5] = _, H[6] = R, H[7] = F, H[8] = L, H[9] = G, H[10] = J, H[11] = we, H[12] = ce, H[13] = xe, H[14] = $e, H[15] = je, H[16] = E, H[17] = P, H[18] = K; ; ) if (a = D(r, e, H), !Ln(Ll, a)) return a;
        };
      case 20:
        return function(a, h, s, d, p, _, R, F, L, G, J, we, ce, xe, $e, je, E, P, K, H) {
          var U = u === 0 ? null : Gl.h(u);
          for (j(l) && (l.g ? l.g(n, U) : l.call(null, n, U)), U[0] = a, U[1] = h, U[2] = s, U[3] = d, U[4] = p, U[5] = _, U[6] = R, U[7] = F, U[8] = L, U[9] = G, U[10] = J, U[11] = we, U[12] = ce, U[13] = xe, U[14] = $e, U[15] = je, U[16] = E, U[17] = P, U[18] = K, U[19] = H; ; ) if (a = D(r, e, U), !Ln(Ll, a)) return a;
        };
      default:
        throw Error(["No matching clause: ", ye.h(t)].join(""));
    }
  }();
}, cpe = function(e, n) {
  if (hu(jp, e)) return kt(
    e,
    n
  );
  for (var t = Bl(Dt, Vt(e)), l = Dt; ; ) if (j(e)) if (I(e) instanceof T) {
    var r = W(e);
    t = yt.g(t, I(e)), e = r;
  } else {
    var u = Xr.h("p__");
    r = W(e), t = yt.g(t, u), l = yt.g(yt.g(l, I(e)), u), e = r;
  }
  else return ve.h(z(he.g(new g(null, t, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, l, null, 1, null), Te([n])))), null, 1, null))));
}, hpe = function(e) {
  function n(l) {
    var r = I(l);
    return r = on.g(FJ, I(r)) ? _p.j(r, 2, Cn(r)) : r, l = W(l), ci(I(l)) && W(l) ? Bl(r, yt.g(j(Vt(r)) ? Vt(r) : Tt, I(l))) : r;
  }
  if (ei(I(e))) for (var t = Dt; ; ) if (j(e)) t = yt.g(t, n(I(e))), e = W(e);
  else return z(t);
  else return new g(null, n(e), null, 1, null);
}, lq = function(e, n, t, l, r) {
  var u = ta.h(e), o = j(r) ? Us(r) : null;
  return n = wt.j(function(a, h) {
    var s = O.j(h, 0, null);
    h = O.j(h, 1, null);
    var d;
    return (d = s instanceof T) && (d = t.h ? t.h(s) : t.call(null, s), d = j(d) ? er(o) || Ol(o, s) : d), j(d) ? Dn.j(a, l.h ? l.h(s) : l.call(null, s), h) : a;
  }, u, n), Dn.j(e, ta, n);
}, IG = function(e, n, t, l, r) {
  var u = tF.h(n), o = j(u) ? wt.j(function(d, p) {
    return Reflect.get(d, p);
  }, r, u.split(".")) : r, a = _n.h(B3([ye.h(t), j(u) ? "$" : null, ye.h(u)].join(""))), h = xs(xs(e, new v(
    null,
    3,
    5,
    y,
    [Hf, a, gh],
    null
  ), o), new v(null, 2, 5, y, [H8, a], null), o), s = function() {
    var d = Uh.h(n);
    return j(d) ? xs(h, new v(null, 4, 5, y, [Il, l, po, d], null), a) : h;
  }();
  return function() {
    var d = Gf.h(n);
    if (j(d)) {
      var p = zB.h(n);
      return wt.j(function(_, R) {
        var F = _n.h([ye.h(t), "$$", ye.h(R)].join("")), L = Reflect.get(o, ye.h(R));
        return R = en.j(p, R, R), xs(xs(xs(_, new v(null, 4, 5, y, [Il, l, po, R], null), F), new v(null, 3, 5, y, [Hf, F, gh], null), L), new v(null, 2, 5, y, [H8, F], null), L);
      }, s, d);
    }
    return s;
  }();
}, DS = function(e, n, t, l, r) {
  var u = fr(r);
  r = en.g(u, Uh);
  var o = en.g(u, Gf), a = en.g(u, twe), h = en.g(u, zB), s = en.g(u, By), d = en.g(u, aJ), p = en.g(u, eF), _ = typeof l == "string" ? function() {
    var J = Xf.j(l, _1("\\$"), 2), we = O.j(J, 0, null);
    J = O.j(J, 1, null);
    var ce = en.g(kx.h(e), we);
    return j(ce) ? IG(e, Dn.j(u, tF, J), we, n, ce) : e;
  }() : null;
  if (j(_)) return _;
  _ = xr.g(e, new v(null, 2, 5, y, [Il, n], null));
  var R = j(r) ? xs(_, new v(null, 2, 5, y, [Vc, r], null), l) : _, F = j(h) ? function(J) {
    var we = h.h ? h.h(J) : h.call(null, J);
    return j(we) ? we : J;
  } : No, L = j(s) ? function() {
    var J = Us(s);
    return function(we) {
      return !Ol(J, we);
    };
  }() : v1(!0), G = j(a) && (o == null || w1(o)) ? lr.g(o, a) : o;
  if (j(G)) if (j(function() {
    var J = Ln(kk, G);
    return J || p;
  }())) r = lq(R, t, L, F, null);
  else if (Fw(G)) r = function() {
    var J = ta.h(R);
    return J = wt.j(function(we, ce) {
      if (j(L(ce))) {
        var xe = Dn.j, $e = F.h ? F.h(ce) : F.call(null, ce), je = oh(t, ce);
        if (j(je)) O.j(je, 0, null), ce = O.j(je, 1, null);
        else throw Error([ye.h(ce), " does not exist"].join(""));
        we = xe.call(Dn, we, $e, ce);
      }
      return we;
    }, J, G), Dn.j(R, ta, J);
  }();
  else throw Error(":refer value must be a sequential collection of symbols");
  else r = j(p) ? lq(
    R,
    t,
    L,
    F,
    d
  ) : R;
  return r = xs(e, new v(null, 2, 5, y, [Il, n], null), r), o = function() {
    var J = t == null ? null : Go.h(t);
    return J = J == null ? null : Vt(J), J == null ? null : I_e.h(J);
  }(), j(o) && (o.h ? o.h(Tt) : o.call(null, Tt)), r;
}, aB = function(e, n) {
  wr.g(e, function(t) {
    var l = uN.h(t);
    return Ol(l, n) ? t : (l = xr.g(t, new v(null, 3, 5, y, [Il, ks, Lk], null)), wr.j(sn(l), yt, n), Ri.j(t, uN, function(r) {
      return r == null ? Rp([n]) : yt.g(r, n);
    }));
  });
}, fpe = function(e, n, t) {
  var l = Or.h(e), r = sn(l), u = Vs(), o = en.j(Bx.h(r), n, n), a = (n = typeof o == "string") ? function() {
    var we = Xf.j(
      o,
      _1("\\$"),
      2
    ), ce = O.j(we, 0, null), xe = O.j(we, 1, null), $e = en.g(kx.h(r), ce);
    return j($e) ? (wr.g(l, function(je) {
      return IG(je, Dn.j(t, tF, xe), ce, u, $e);
    }), Tt) : null;
  }() : null;
  if (j(a)) return a;
  if (a = mJ.h(t), j(a)) return Qa(l, DS(r, u, null, o, new $(null, 1, [Uh, a], null)));
  a = fr(t);
  var h = en.g(a, SR), s = en.g(a, bE), d = en.g(r, Il);
  a = j(h) ? h : j(s) ? s : bE.h(e);
  var p = j(a) ? null : en.g(d, o);
  if (j(p)) {
    var _ = gH.h(e);
    j(j(_) ? !Ol(uN.h(r), o) && mK(_.indexOf(o)) : _) ? mu(function() {
      var we = ["[ ", ye.h(o), " ]"].join(""), ce = yt.g(_, o);
      return we = l5.g(Qu([o, we]), ce), [
        "Cyclic load dependency: ",
        Ja.g("->", we)
      ].join("");
    }(), o) : on.g(o, u) || Qa(l, DS(r, u, p, o, t));
  } else {
    var R = Ox.h(r);
    if (j(R)) {
      var F = sn(Mi);
      if (p = function() {
        var we = new $(null, 6, [ZX, o, Ave, o, g0e, e, OR, t, ie, Jo(F), SR, j(h) ? h : s], null);
        return R.h ? R.h(we) : R.call(null, we);
      }(), j(p)) {
        var L = fr(p);
        a = en.g(L, Bn), p = en.g(L, co), L = en.g(L, F2e);
        var G = Ri.j(Dn.j(Dn.j(e, Ws, Tt), bE, s), gH, function(we) {
          return we == null ? new v(null, 1, 5, y, [o], null) : yt.g(we, o);
        });
        if (j(p)) try {
          mg(Qu([Mi, F, Iu, a]));
          try {
            var J = sn(Vne);
            J.g ? J.g(G, p) : J.call(null, G, p);
          } finally {
            Vm();
          }
        } catch (we) {
          throw we instanceof Error ? (n = we, wr.l(l, Ri, Il, nr, Te([o])), n) : we;
        }
        j(L) || wr.g(l, function(we) {
          var ce = en.g(we, Il);
          return ce = en.g(ce, o), DS(we, u, ce, o, t);
        });
      } else if (J = j(a) ? function() {
        var we = en.g(d, o);
        return j(we) ? Qa(l, DS(r, u, we, o, t)) : null;
      }() : null, !j(J)) throw Error(["Could not find namespace: ", ye.h(o), "."].join(""));
    } else throw Error(["Could not find namespace ", ye.h(o), "."].join(""));
  }
  return n || aB(l, o), null;
}, rv = function(e, n) {
  return e instanceof T ? kt(e, n) : he.g(e, n);
}, rq = function(e) {
  return e instanceof T || or(e) && (Vr(e) == null || Vr(e) instanceof de);
}, cB = function(e, n, t) {
  var l = kt(n, t), r = Ou.g(ux, l);
  n = Nu.g(r, sa.h(!0)), l = Ou.g(Dp(ux), l), (r = z(Ia.g(new gi(null, new $(null, 8, [eF, null, Uh, null, n4, null, bye, null, SR, null, bE, null, nQ, null, Gf, null], null), null), r))) && mu(In.j(ye, "Unsupported option(s) supplied: ", rd.g(",", r)), t), z(l) || mu("Nothing specified to load", t), r = z(l), l = null;
  for (var u = 0, o = 0; ; ) if (o < u) {
    var a = l.Y(null, o);
    if (rq(a)) In.B(qd, e, null, rv(a, n));
    else {
      var h = z(a);
      a = I(h), h = W(h), a == null && mu("prefix cannot be nil", t), h = z(h);
      for (var s = null, d = 0, p = 0; ; ) if (p < d) {
        var _ = s.Y(null, p);
        In.B(qd, e, a, rv(_, n)), p += 1;
      } else if (h = z(h)) s = h, oi(s) ? (h = Jr(s), p = Wr(s), s = h, d = Cn(h), h = p) : (h = I(s), In.B(qd, e, a, rv(h, n)), h = W(s), s = null, d = 0), p = 0;
      else break;
    }
    o += 1;
  } else if (r = z(r)) {
    if (oi(r)) u = Jr(r), r = Wr(r), l = u, u = Cn(u);
    else {
      if (a = I(r), rq(a)) In.B(qd, e, null, rv(a, n));
      else for (u = z(a), l = I(u), u = W(u), l == null && mu("prefix cannot be nil", t), u = z(u), o = null, h = a = 0; ; ) if (h < a) s = o.Y(null, h), In.B(qd, e, l, rv(s, n)), h += 1;
      else if (u = z(u)) o = u, oi(o) ? (u = Jr(o), h = Wr(o), o = u, a = Cn(u), u = h) : (u = I(o), In.B(
        qd,
        e,
        l,
        rv(u, n)
      ), u = W(o), o = null, a = 0), h = 0;
      else break;
      r = W(r), l = null, u = 0;
    }
    o = 0;
  } else return null;
}, dpe = function(e, n) {
  for (; j(n); ) {
    var t = n, l = O.j(t, 0, null), r = O.j(t, 1, null), u = l, o = u instanceof de ? u.ca : null;
    switch (o) {
      case "exclude":
        wr.g(Or.h(e), /* @__PURE__ */ function(a, h, s, d, p, _, R) {
          return function(F) {
            var L = Vs();
            return bu.B(F, new v(null, 5, 5, y, [Il, L, Gf, R, By], null), Ff.g(lr, ss), _);
          };
        }(n, u, o, t, l, r, ks));
        break;
      case "only":
        wr.g(Or.h(e), /* @__PURE__ */ function(a, h, s, d, p, _, R) {
          return function(F) {
            var L = Vs(), G = xr.g(F, new v(null, 2, 5, y, [Il, R], null));
            return G = pg(G, _), bu.B(F, new v(null, 2, 5, y, [Il, L], null), gr, G);
          };
        }(n, u, o, t, l, r, ks));
        break;
      case "rename":
        wr.g(Or.h(e), /* @__PURE__ */ function(a, h, s, d, p, _, R) {
          return function(F) {
            var L = Vs(), G = Il.h(F), J = en.g(G, L), we = xr.g(F, new v(null, 2, 5, y, [Il, R], null));
            return G = wt.j(/* @__PURE__ */ function(ce, xe, $e, je, E, P, K, H, U, Me, le) {
              return function(Ce, Ye) {
                var B = O.j(Ye, 0, null);
                return Ye = O.j(Ye, 1, null), bu.B(xs(Ce, new v(null, 2, 5, y, [ta, Ye], null), en.g(E, B)), new v(null, 3, 5, y, [Gf, le, By], null), Ff.g(yt, ss), B);
              };
            }(a, L, G, J, we, h, s, d, p, _, R), J, _), xs(F, new v(null, 2, 5, y, [
              Il,
              L
            ], null), G);
          };
        }(n, u, o, t, l, r, ks));
        break;
      default:
        throw Error(["No matching clause: ", ye.h(o)].join(""));
    }
    n = va(n);
  }
}, ppe = function(e, n, t) {
  var l = Vs(), r = Il.h(e), u = function() {
    var _ = en.g(r, n);
    if (j(_)) return _;
    throw Error(["No namespace: ", ye.h(n)].join(""));
  }(), o = In.g(tr, t), a = Ou.g(jp, xi(u)), h = function() {
    var _ = zB.h(o);
    return j(_) ? _ : Tt;
  }(), s = Us(By.h(o)), d = on.g(kk, Gf.h(o)) ? a : function() {
    var _ = Gf.h(o);
    return j(_) ? _ : (_ = aJ.h(o), j(_) ? _ : a);
  }();
  if (j(j(d) ? !Fw(d) : d)) throw Error(":only/:refer value must be a sequential collection of symbols");
  t = en.g(r, l);
  var p = ta.h(t);
  return d = wt.j(function(_, R) {
    if (er(s.h ? s.h(R) : s.call(null, R))) {
      var F = en.g(u, R);
      if (!j(F)) throw Error([ye.h(R), " does not exist"].join(""));
      var L = Dn.j, G = h.h ? h.h(R) : h.call(null, R);
      return L.call(Dn, _, j(G) ? G : R, F);
    }
    return _;
  }, p, d), t = Dn.j(t, ta, d), l = Dn.j(r, l, t), Dn.j(e, Il, l);
}, CI = function(e, n) {
  return iB(e, n, new $(null, 1, [jx, "analysis"], null));
}, mpe = function(e, n) {
  return wu.g(e, function(t) {
    return Dn.l(t, JM, t_e, Te([Hee, n]));
  });
}, RG = function(e, n, t) {
  var l = O.j(t, 0, null);
  if (t = O.j(t, 1, null), G0 !== n && Xd !== n) {
    l = OG(l);
    var r = Ew.h(e);
    !j(r) || Qs(t) && er(Re.h(Vt(t))) || Ol(r, l) || CI([ye.h(n), " is not allowed!"].join(""), n), e = qk.h(e), j(e) && Ol(e, l) && CI([ye.h(n), " is not allowed!"].join(""), n);
  }
}, gpe = function(e, n, t) {
  var l = function() {
    var p = Yi(n);
    return p == null ? null : _n.h(p);
  }(), r = _n.h(ml(n)), u = e.get(Or), o = sn(u), a = Vs(), h = function() {
    var p = Il.h(o);
    return a.h ? a.h(p) : a.call(null, p);
  }();
  u = j(l) ? function() {
    var p = xr.g(h, new v(null, 2, 5, y, [Vc, l], null));
    return j(p) ? p : l;
  }() : null;
  var s = en.j(Bx.h(o), u, u);
  if (j(s)) {
    if (u = on.g(s, ks) || on.g(
      s,
      r5
    ) ? function() {
      var p = o == null ? null : Il.h(o);
      return p = p == null ? null : en.g(p, ks), p = p == null ? null : oh(p, r), j(p) ? p : (p = j(t) ? en.g(u4, r) : null, j(p) ? new v(null, 2, 5, y, [n, p], null) : null);
    }() : null, j(u) || (u = function() {
      var p = o == null ? null : Il.h(o);
      return p = p == null ? null : en.g(p, s), p == null ? null : oh(p, r);
    }(), j(u))) return u;
    if (j(!1)) return null;
    if (u = gh.h(wk(e, s)), j(u)) {
      var d = u;
      return new v(null, 2, 5, y, [n, j(t) ? Bl(new v(null, 2, 5, y, [d, ye.h(r).split(".")], null), new $(null, 1, [MB, !0], null)) : function() {
        var p = Dn.l(
          Vt(n),
          Bn,
          sn(Iu),
          Te([ie, sn(Mi)])
        ), _ = ye.h(r).split(".");
        return _.length === 1 ? it(function() {
          return d[r];
        }, p) : it(function() {
          return gk(d, _);
        }, p);
      }()], null);
    }
    return null;
  }
  return u = function() {
    var p = ta.h(h);
    return j(p) ? oh(p, r) : null;
  }(), j(u) || (u = oh(h, n), j(u)) || (u = function() {
    var p = function() {
      var _ = o == null ? null : Il.h(o);
      return _ = _ == null ? null : en.g(_, ks), _ == null ? null : oh(_, r);
    }();
    return j(function() {
      var _ = h == null ? null : Gf.h(h);
      return _ = _ == null ? null : en.g(_, ks), _ = _ == null ? null : By.h(_), _ == null ? null : Ol(_, r);
    }()) ? null : p;
  }(), j(u)) || (u = j(j(t) ? en.g(u4, n) : null) ? new v(null, 2, 5, y, [n, n], null) : null, j(u)) ? u : j(!1) ? null : (u = function() {
    var p = gh.h(wk(e, n));
    return j(p) ? new v(null, 2, 5, y, [n, p], null) : null;
  }(), j(u) ? u : j(kZ.h(e)) ? null : (u = AG(e, n), j(u) ? new v(null, 2, 5, y, [n, u], null) : null));
}, wpe = function(e, n, t) {
  var l = Ea.h(e);
  return e = Yu(n, function(r) {
    return I(wt.j(function(u) {
      var o = O.j(u, 0, null), a = O.j(u, 1, null);
      return u = bu.j(o, a, function(h) {
        var s = bc.h(h);
        return s = j(s) ? s : Tt, Ol(s, t) ? h : Dn.j(h, bc, Dn.j(s, t, Cn(s)));
      }), a = new v(null, 2, 5, y, [u, my(my(a))], null), on.g(o, u) ? xh(a) : a;
    }, new v(null, 2, 5, y, [r, l], null), ic.h(Cn(l) / 2)));
  }(sn(n))), xr.g(e, yt.l(l, bc, Te([t])));
}, MI = function(e, n, t, l) {
  return e = h1.B(e, n, t, l), j(e) ? e : (e = ml(n), j(j(t) ? e.lastIndexOf(".", 0) == 0 && 1 < e.length : t) ? new v(null, 2, 5, y, [n, hF], null) : j(j(t) ? g1(e, ".") && 1 < e.length : t) ? new v(null, 2, 5, y, [n, BB], null) : null);
}, vpe = function(e, n, t) {
  var l = Yi(n);
  n = ml(n).split("."), e = Dn.j(e, kZ, !0);
  for (var r = null; ; ) {
    if (Ca(n)) return null;
    var u = I(n);
    n = W(n);
    var o = _n.g(
      l,
      [r, j(r) ? "." : null, ye.h(u)].join("")
    ), a = er(l);
    if (r = j(a && r) ? _n.g(r, u) : null, u = MI(e, o, !1, t), j(u)) return new v(null, 2, 5, y, [Vr(u), n], null);
    if (r = j(r) ? MI(e, r, !1, t) : null, j(r)) return new v(null, 2, 5, y, [Vr(r), n], null);
    r = ye.h(o);
  }
}, ype = function(e, n, t, l) {
  if (l = vpe(e, n, l), j(l)) {
    e = O.j(l, 0, null), l = O.j(l, 1, null);
    var r = Qs(e) ? sn(e) : e, u = Fs.h(l);
    return j(t) ? new v(null, 2, 5, y, [n, Bl(new v(null, 2, 5, y, [r, u], null), new $(null, 1, [MB, !0], null))], null) : r instanceof Ic ? new v(
      null,
      2,
      5,
      y,
      [n, it(function(o, a, h) {
        return gk(D(r, a, h), u);
      }, n)],
      null
    ) : new v(null, 2, 5, y, [n, gk(r, u)], null);
  }
  return null;
}, Hw = function(e, n, t, l) {
  var r = MI(e, n, t, l);
  return j(r) ? n = r : (e = ype(e, n, t, l), n = j(e) ? e : CI(["Could not resolve symbol: ", ye.h(n)].join(""), n)), Vr(n);
}, ff = function(e) {
  return Dn.j(e, bp, !1);
}, Co = function(e, n) {
  return iB(e, n, new $(null, 1, [jx, "analysis"], null));
}, NG = function(e, n) {
  if (e = Dn.j(e, Tb, !0), ei(n)) {
    var t = I(n);
    if (t instanceof T) {
      if (j(en.g(Hne, t))) return n;
      if (Ol(new gi(null, new $(null, 1, [Yk, null], null), null), t)) return nt.g ? nt.g(e, n) : nt.call(null, e, n);
      if (on.g(
        Bee,
        t
      )) return n;
      try {
        var l = Hw(e, t, !0, null);
      } catch {
        l = kW;
      }
      if (Ln(kW, l)) return n;
      var r = Qs(l), u = r && fk(l);
      return r = r && by(l), l = j(u) ? sn(l) : l, j(j(u) ? u : EG(l)) ? j(r) ? In.I(l, n, Ws.h(e), e, tn(n)) : In.B(l, n, Ws.h(e), tn(n)) : KK(ye.h(t), ".") ? us.B(Kf, Vr(n), _n.h(Si.g(ye.h(t), 1)), va(n)) : n;
    }
  }
  return n;
}, hB = function(e, n) {
  var t = bp.h(e), l = ff(e), r = wo.g(function(o) {
    return nt.g ? nt.g(l, o) : nt.call(null, l, o);
  }, td(n)), u = function() {
    var o = Dn.j(e, bp, t), a = ho(n);
    return nt.g ? nt.g(o, a) : nt.call(null, o, a);
  }();
  return yt.g(r, u);
}, _pe = function(e, n, t) {
  j(bp.h(e)) || Co(function() {
    var E = QZ.h(e);
    switch (E instanceof de ? E.ca : null) {
      case "try":
        return "Cannot recur across try";
      default:
        return "Can only recur from tail position";
    }
  }(), n), n = yh.h(e);
  var l = Cn(t);
  switch (l) {
    case 0:
      return it(function() {
        return Ll;
      }, null);
    case 1:
      var r = O.g(t, 0);
      return O.g(n, 0), it(function(E, P, K) {
        return E = D(r, P, K), K[0] = E, Ll;
      }, null);
    case 2:
      r = O.g(t, 0), O.g(n, 0);
      var u = O.g(t, 1);
      return O.g(n, 1), it(function(E, P, K) {
        return E = D(r, P, K), P = D(u, P, K), K[0] = E, K[1] = P, Ll;
      }, null);
    case 3:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(
        n,
        1
      );
      var o = O.g(t, 2);
      return O.g(n, 2), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K);
        return P = D(o, P, K), K[0] = E, K[1] = H, K[2] = P, Ll;
      }, null);
    case 4:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2);
      var a = O.g(t, 3);
      return O.g(n, 3), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K);
        return P = D(a, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = P, Ll;
      }, null);
    case 5:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3);
      var h = O.g(t, 4);
      return O.g(n, 4), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K);
        return P = D(h, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = P, Ll;
      }, null);
    case 6:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4);
      var s = O.g(t, 5);
      return O.g(n, 5), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K);
        return P = D(s, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = P, Ll;
      }, null);
    case 7:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(
        n,
        5
      );
      var d = O.g(t, 6);
      return O.g(n, 6), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K);
        return P = D(d, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = P, Ll;
      }, null);
    case 8:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6);
      var p = O.g(t, 7);
      return O.g(n, 7), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K);
        return P = D(p, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = P, Ll;
      }, null);
    case 9:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7);
      var _ = O.g(t, 8);
      return O.g(n, 8), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K), B = D(p, P, K);
        return P = D(_, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = P, Ll;
      }, null);
    case 10:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7), _ = O.g(t, 8), O.g(n, 8);
      var R = O.g(t, 9);
      return O.g(n, 9), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K), B = D(p, P, K), q = D(_, P, K);
        return P = D(R, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = q, K[9] = P, Ll;
      }, null);
    case 11:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7), _ = O.g(t, 8), O.g(n, 8), R = O.g(t, 9), O.g(n, 9);
      var F = O.g(t, 10);
      return O.g(n, 10), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K), B = D(p, P, K), q = D(_, P, K), me = D(R, P, K);
        return P = D(F, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = q, K[9] = me, K[10] = P, Ll;
      }, null);
    case 12:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7), _ = O.g(t, 8), O.g(n, 8), R = O.g(t, 9), O.g(n, 9), F = O.g(t, 10), O.g(n, 10);
      var L = O.g(t, 11);
      return O.g(n, 11), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K), B = D(p, P, K), q = D(_, P, K), me = D(R, P, K), Ae = D(F, P, K);
        return P = D(L, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = q, K[9] = me, K[10] = Ae, K[11] = P, Ll;
      }, null);
    case 13:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(
        n,
        1
      ), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7), _ = O.g(t, 8), O.g(n, 8), R = O.g(t, 9), O.g(n, 9), F = O.g(t, 10), O.g(n, 10), L = O.g(t, 11), O.g(n, 11);
      var G = O.g(t, 12);
      return O.g(n, 12), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K), B = D(p, P, K), q = D(_, P, K), me = D(R, P, K), Ae = D(F, P, K), Fe = D(L, P, K);
        return P = D(G, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = q, K[9] = me, K[10] = Ae, K[11] = Fe, K[12] = P, Ll;
      }, null);
    case 14:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7), _ = O.g(t, 8), O.g(n, 8), R = O.g(t, 9), O.g(n, 9), F = O.g(t, 10), O.g(n, 10), L = O.g(t, 11), O.g(n, 11), G = O.g(t, 12), O.g(n, 12);
      var J = O.g(t, 13);
      return O.g(n, 13), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K), B = D(p, P, K), q = D(_, P, K), me = D(R, P, K), Ae = D(F, P, K), Fe = D(
          L,
          P,
          K
        ), ln = D(G, P, K);
        return P = D(J, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = q, K[9] = me, K[10] = Ae, K[11] = Fe, K[12] = ln, K[13] = P, Ll;
      }, null);
    case 15:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7), _ = O.g(t, 8), O.g(n, 8), R = O.g(t, 9), O.g(n, 9), F = O.g(t, 10), O.g(n, 10), L = O.g(t, 11), O.g(n, 11), G = O.g(t, 12), O.g(n, 12), J = O.g(t, 13), O.g(n, 13);
      var we = O.g(t, 14);
      return O.g(n, 14), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K), B = D(p, P, K), q = D(_, P, K), me = D(R, P, K), Ae = D(F, P, K), Fe = D(L, P, K), ln = D(G, P, K), Be = D(J, P, K);
        return P = D(we, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = q, K[9] = me, K[10] = Ae, K[11] = Fe, K[12] = ln, K[13] = Be, K[14] = P, Ll;
      }, null);
    case 16:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7), _ = O.g(t, 8), O.g(n, 8), R = O.g(t, 9), O.g(n, 9), F = O.g(t, 10), O.g(n, 10), L = O.g(t, 11), O.g(n, 11), G = O.g(t, 12), O.g(n, 12), J = O.g(t, 13), O.g(n, 13), we = O.g(t, 14), O.g(n, 14);
      var ce = O.g(t, 15);
      return O.g(n, 15), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K), B = D(p, P, K), q = D(_, P, K), me = D(R, P, K), Ae = D(F, P, K), Fe = D(L, P, K), ln = D(G, P, K), Be = D(J, P, K), Ze = D(we, P, K);
        return P = D(ce, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = q, K[9] = me, K[10] = Ae, K[11] = Fe, K[12] = ln, K[13] = Be, K[14] = Ze, K[15] = P, Ll;
      }, null);
    case 17:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7), _ = O.g(t, 8), O.g(n, 8), R = O.g(t, 9), O.g(n, 9), F = O.g(t, 10), O.g(n, 10), L = O.g(t, 11), O.g(n, 11), G = O.g(t, 12), O.g(n, 12), J = O.g(t, 13), O.g(n, 13), we = O.g(t, 14), O.g(n, 14), ce = O.g(t, 15), O.g(n, 15);
      var xe = O.g(t, 16);
      return O.g(n, 16), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(
          d,
          P,
          K
        ), B = D(p, P, K), q = D(_, P, K), me = D(R, P, K), Ae = D(F, P, K), Fe = D(L, P, K), ln = D(G, P, K), Be = D(J, P, K), Ze = D(we, P, K), pn = D(ce, P, K);
        return P = D(xe, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = q, K[9] = me, K[10] = Ae, K[11] = Fe, K[12] = ln, K[13] = Be, K[14] = Ze, K[15] = pn, K[16] = P, Ll;
      }, null);
    case 18:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7), _ = O.g(t, 8), O.g(n, 8), R = O.g(t, 9), O.g(n, 9), F = O.g(t, 10), O.g(n, 10), L = O.g(t, 11), O.g(n, 11), G = O.g(t, 12), O.g(n, 12), J = O.g(t, 13), O.g(n, 13), we = O.g(t, 14), O.g(n, 14), ce = O.g(t, 15), O.g(n, 15), xe = O.g(t, 16), O.g(n, 16);
      var $e = O.g(t, 17);
      return O.g(n, 17), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K), B = D(p, P, K), q = D(_, P, K), me = D(R, P, K), Ae = D(F, P, K), Fe = D(L, P, K), ln = D(G, P, K), Be = D(J, P, K), Ze = D(we, P, K), pn = D(ce, P, K), xn = D(xe, P, K);
        return P = D($e, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = q, K[9] = me, K[10] = Ae, K[11] = Fe, K[12] = ln, K[13] = Be, K[14] = Ze, K[15] = pn, K[16] = xn, K[17] = P, Ll;
      }, null);
    case 19:
      r = O.g(t, 0), O.g(n, 0), u = O.g(t, 1), O.g(n, 1), o = O.g(t, 2), O.g(n, 2), a = O.g(t, 3), O.g(n, 3), h = O.g(t, 4), O.g(n, 4), s = O.g(t, 5), O.g(n, 5), d = O.g(t, 6), O.g(n, 6), p = O.g(t, 7), O.g(n, 7), _ = O.g(t, 8), O.g(n, 8), R = O.g(t, 9), O.g(n, 9), F = O.g(t, 10), O.g(n, 10), L = O.g(t, 11), O.g(n, 11), G = O.g(t, 12), O.g(n, 12), J = O.g(t, 13), O.g(n, 13), we = O.g(t, 14), O.g(n, 14), ce = O.g(t, 15), O.g(n, 15), xe = O.g(t, 16), O.g(n, 16), $e = O.g(t, 17), O.g(n, 17);
      var je = O.g(t, 18);
      return O.g(n, 18), it(function(E, P, K) {
        E = D(r, P, K);
        var H = D(u, P, K), U = D(o, P, K), Me = D(a, P, K), le = D(h, P, K), Ce = D(s, P, K), Ye = D(d, P, K), B = D(p, P, K), q = D(_, P, K), me = D(R, P, K), Ae = D(F, P, K), Fe = D(L, P, K), ln = D(G, P, K), Be = D(J, P, K), Ze = D(we, P, K), pn = D(ce, P, K), xn = D(xe, P, K), Nn = D($e, P, K);
        return P = D(je, P, K), K[0] = E, K[1] = H, K[2] = U, K[3] = Me, K[4] = le, K[5] = Ce, K[6] = Ye, K[7] = B, K[8] = q, K[9] = me, K[10] = Ae, K[11] = Fe, K[12] = ln, K[13] = Be, K[14] = Ze, K[15] = pn, K[16] = xn, K[17] = Nn, K[18] = P, Ll;
      }, null);
    default:
      throw Error(["No matching clause: ", ye.h(l)].join(""));
  }
}, $s = function(e, n) {
  return wo.g(function(t) {
    return nt.g ? nt.g(e, t) : nt.call(null, e, t);
  }, n);
}, Ph = function(e, n, t, l, r, u, o, a, h) {
  this.vb = e, this.body = n, this.tb = t, this.yb = l, this.wb = r, this.ub = u, this.K = o, this.F = a, this.H = h, this.C = 2230716170, this.J = 139264;
}, xpe = function(e, n, t, l) {
  var r = fr(e);
  e = en.g(r, BZ);
  var u = z(n);
  n = I(u);
  var o = W(u);
  j(n) || Co("Parameter declaration missing.", e), or(n) || Co("Parameter declaration should be a vector", e), u = FK(function(R) {
    return xa.g(et, R);
  }, n);
  var a = O.j(u, 0, null);
  u = O.j(u, 1, null), O.j(u, 0, null), u = O.j(u, 1, null);
  var h = Et(a);
  a = Cn(h), h = j(u) ? yt.g(
    h,
    u
  ) : h;
  var s = Dn.j(r, yh, h);
  r = Cn(h), r = n1.g(r, Xr);
  var d = _a(h, r), p = _a(r, ic.o());
  h = In.j(nr, Ws.h(s), h), h = Dn.j(s, Ws, gr.l(Te([h, d]))), h = Dn.j(h, Rc, p);
  var _ = Ri.B(h, Ea, yt, j(u) ? u : a);
  return Yu(jf.h(_), xs(sn(jf.h(_)), yt.g(Ea.h(_), bc), _a(r, ic.o()))), t = j(t) ? function() {
    var R = jf.h(_);
    return M_.j ? M_.j(_, R, l) : M_.call(null, _, R, l);
  }() : null, o = S5(Dn.j(_, bp, !0), e, o), e = xr.g(sn(jf.h(_)), yt.g(Ea.h(_), bc)), n = new Ph(n, o, a, u, t, e, null, null, null), j(u) ? Dn.j(n, VB, en.g(e, ho(r))) : n;
}, Spe = function(e, n, t, l, r, u) {
  var o = Vi.h(n), a = kB.h(n), h = XB.h(n), s = uc.h(n), d = VB.h(n);
  return it(function(p, _, R) {
    p = e.h ? e.h(R) : e.call(null, R);
    var F = DG(_, p, o, a, s, h, d), L = r == null ? F : function() {
      var J = D(r, _, R);
      return wu.j(F, gr, J);
    }(), G = j(u) ? wu.g(L, function(J) {
      return Dn.l(J, a5, u, Te([oJ, L]));
    }) : L;
    return j(l) && (p[t] = G), G;
  }, null);
}, Epe = function(e) {
  var n = Vi.h(e), t = kB.h(e), l = XB.h(e), r = uc.h(e), u = VB.h(e);
  return function(o) {
    return it(function(a, h) {
      return DG(h, o, n, t, r, l, u);
    }, null);
  };
}, Ope = function(e, n) {
  var t = z(n);
  I(t), t = W(t);
  var l = I(t), r = W(t), u = Vt(n);
  t = AP.h(u);
  var o = Zf.h(t);
  t = TZ.h(t), u = nr.g(
    u,
    AP
  );
  var a = Dn.j(e, BZ, n);
  e = l instanceof T ? l : null, l = j(e) ? r : kt(l, r), r = ei(I(l)) ? l : new v(null, 1, 5, y, [l], null);
  var h = Xr.o();
  l = Ff.g(yt, Dt)(Ea.h(a), h), a = Dn.j(a, Ea, l);
  var s = j(e) ? xs(a, new v(null, 2, 5, y, [Ws, e], null), h) : a, d = j(t) ? t : e;
  e = Ws.h(s), a = Us(Ju(e));
  var p = Dn.j(s, EX, a);
  s = jf.h(p), e = wt.j(function($e, je) {
    $e = fr($e);
    var E = en.g($e, aw), P = en.g($e, bH), K = I(je), H = xpe(p, je, d, h), U = tg.h(H), Me = Vi.h(H), le = j(U) ? Me : null;
    return j(j(U) ? P : U) && Co("Can't have more than 1 variadic overload", n), U = er(U), j(U && (j(P) ? Me > P : P)) && Co(
      "Can't have fixed arity function with more params than variadic function",
      n
    ), Ri.B(Ri.B(Dn.l($e, bH, le, Te([aw, Me > E ? Me : E])), d6, yt, Dn.j(H, jve, je)), ne, yt, K);
  }, new $(null, 4, [d6, Dt, ne, Dt, e0e, null, aw, -1], null), r), r = xr.g(sn(s), l), r = In.g(gr, bt.g(bc, Ju(r)));
  var _ = j(d) ? Ol(r, h) : null, R = Ou.g(a, xi(r)), F = xr.g(sn(s), yt.g(my(l), bc));
  l = j(F) ? _a(R, wo.g(F, R)) : null;
  var L = Cn(R);
  r = _a(R, ic.h(L));
  var G = j(d) ? Dn.j(r, h, L) : r;
  l = (j(_) ? _ : z(l)) ? function() {
    var $e = j(d) ? L + 1 : L, je = Fs.h(Tf.g(function(E) {
      var P = en.g(F, E);
      if (j(P)) {
        E = en.g(G, E);
        var K = Gl.h(2);
        return K[0] = P, K[1] = E, K;
      }
      return null;
    }, R));
    return new v(
      null,
      2,
      5,
      y,
      [function(E) {
        for (var P = je.length, K = 0, H = Gl.h($e); ; ) if (K < P) {
          var U = K + 1;
          K = je[K], H[K[1]] = E[K[0]], K = U;
        } else return H;
      }, $e],
      null
    );
  }() : new v(null, 1, 5, y, [v1(null)], null);
  var J = O.j(l, 0, null);
  l = O.j(l, 1, null), r = d6.h(e);
  var we = wo.g(function($e) {
    var je = Rc.h($e), E = s1.h($e), P = Fs.h(Tf.g(function(H) {
      var U = je.h ? je.h(H) : je.call(null, H);
      if (j(U)) {
        var Me = Gl.h(2);
        return Me[0] = G.h ? G.h(H) : G.call(null, H), Me[1] = U, Me;
      }
      return null;
    }, R)), K = Cn(je);
    return Dn.l($e, XB, K, Te([x_e, E, kB, 0 < P.length ? function(H, U) {
      for (var Me = P.length, le = 0, Ce = U; ; ) if (le < Me) U = le + 1, le = P[le], Ce[le[1]] = H[le[0]], le = U;
      else return Ce;
    } : null]));
  }, r);
  u = nr.l(u, Yn, Te([zn]));
  var ce = z(u) ? nt.g ? nt.g(p, u) : nt.call(null, p, u) : null;
  u = on.g(1, Cn(we)) ? I(we) : null, Vs();
  var xe = l == null ? null : l - 1;
  return u = j(u) ? Spe(J, u, xe, _, ce, o) : function() {
    var $e = wt.j(function(je, E) {
      var P = Epe(E), K = tg.h(E);
      return E = Vi.h(E), j(K) ? Dn.j(je, mH, P) : Dn.j(je, E, P);
    }, Tt, we);
    return it(function(je, E, P) {
      var K = J.h ? J.h(P) : J.call(null, P), H = function() {
        function Me(Ce) {
          var Ye = null;
          if (0 < arguments.length) {
            Ye = 0;
            for (var B = Array(arguments.length - 0); Ye < B.length; ) B[Ye] = arguments[Ye + 0], ++Ye;
            Ye = new hn(B, 0, null);
          }
          return le.call(this, Ye);
        }
        function le(Ce) {
          var Ye = Cn(Ce), B = en.g($e, Ye);
          if (B = j(B) ? B : mH.h($e), j(B)) return Ye = B.h ? B.h(K) : B.call(null, K), Ye = D(Ye, E, P), In.g(Ye, Ce);
          throw Ce = Error, Ye = j(o) ? Ye - 2 : Ye, Ye = ["Cannot call ", ye.h(d), " with ", ye.h(Ye), " arguments"].join(""), Ce(Ye);
        }
        return Me.m = 0, Me.v = function(Ce) {
          return Ce = z(Ce), le(Ce);
        }, Me.l = le, Me;
      }(), U = ce == null ? H : function() {
        var Me = D(ce, E, P);
        return wu.j(H, gr, Me);
      }();
      return je = j(o) ? wu.g(U, function(Me) {
        return Dn.l(
          Me,
          a5,
          o,
          Te([oJ, U])
        );
      }) : U, j(_) && (K[xe] = je), je;
    }, null);
  }(), j(t) ? Bl(u, new $(null, 1, [ne, ne.h(e)], null)) : u;
}, M_ = function(e, n, t) {
  var l = Ea.h(e);
  return e = Yu(n, function(r) {
    return bu.j(r, yt.g(l, bc), function(u) {
      return Ol(u, t) ? u : Dn.j(u, t, Cn(u));
    });
  }(sn(n))), xr.g(e, yt.l(l, bc, Te([t])));
}, kpe = function(e, n, t) {
  var l = Vs();
  e = Or.h(e);
  var r = xr.g(sn(e), new v(null, 2, 5, y, [Il, l], null)), u = ta.h(r), o = function() {
    var a = j(u) ? u.get(n) : u;
    if (j(a)) return Co([ye.h(n), " already refers to ", ye.h(a), " in namespace ", ye.h(l)].join(""), t);
    if (a = en.g(r, n), j(a)) {
      var h = sn(Iu);
      return on.g(h, Bn.h(Vt(a))) || j2.l(a, Dn, Te([Bn, h])), r;
    }
    return a = Dn.j, h = new Ne(null, _n.g(ye.h(l), ye.h(n)), new $(null, 3, [te, n, ie, sn(Mi), Bn, sn(Iu)], null), !1), h.Rd(null), a.call(Dn, r, n, h);
  }();
  wr.g(e, function(a) {
    return Ri.I(a, Il, Dn, l, o);
  });
}, bpe = function(e, n) {
  e = ff(e), O.j(n, 0, null);
  var t = O.j(n, 1, null), l = O.j(n, 2, null), r = O.j(n, 3, null), u = sn(Mi), o = b3(t);
  o || on.g(Yi(t), ye.h(Jo(u))) || Co("Var name should be simple symbol.", n);
  var a = o ? t : _n.h(ml(t));
  if (kpe(e, a, n), o = Cn(n), t = on.g(4, o) && typeof l == "string" ? l : null, !(o <= (j(t) ? 4 : 3))) throw Error("Too many arguments to def");
  l = j(t) ? r : l;
  var h = on.g(2, o) ? Mne : nt.g ? nt.g(e, l) : nt.call(null, e, l);
  n = Vt(n), l = Yn.h(n);
  var s = Vt(a);
  n = j(l) ? Dn.j(Dn.j(s, Yn, Yn.h(n)), zn, zn.h(n)) : function() {
    var p = c1;
    return Dn.j(Dn.j(s, Yn, Yn.h(p)), zn, zn.h(p));
  }(), u = Dn.j(n, ie, u), u = j(t) ? Dn.j(u, ee, t) : u;
  var d = j(s) ? nt.g ? nt.g(e, u) : nt.call(null, e, u) : u;
  return it(function(p, _, R) {
    return upe(_, R, a, h, d);
  }, null);
}, Tpe = function(e, n) {
  var t = tn(n);
  e = Dn.j(e, bp, !0);
  var l = S5(e, n, t);
  return it(function(r, u, o) {
    return new rr(
      null,
      function() {
        return D(l, u, o);
      },
      null,
      null
    );
  }, null);
}, jpe = function(e, n) {
  var t = tn(n);
  switch (e = $s(e, t), t = Dn.l(Vt(n), ie, sn(Mi), Te([Bn, sn(Iu), bB, !0])), Cn(e)) {
    case 0:
    case 1:
      return Co("Too few arguments to if", n);
    case 2:
      var l = O.g(e, 0), r = O.g(e, 1);
      return er(l) ? null : mk(l) ? r : it(function(o, a, h) {
        return j(D(l, a, h)) ? D(r, a, h) : null;
      }, t);
    case 3:
      l = O.g(e, 0), r = O.g(e, 1);
      var u = O.g(e, 2);
      return er(l) ? u : mk(l) ? r : it(function(o, a, h) {
        return j(D(l, a, h)) ? D(r, a, h) : D(u, a, h);
      }, t);
    default:
      return Co("Too many arguments to if", n);
  }
}, iq = function(e, n) {
  function t(R, F, L) {
    return Ol(R, F) ? Co(["Duplicate case test constant ", ye.h(F)].join(""), n) : Dn.j(R, F, L);
  }
  var l = ff(e), r = function() {
    var R = Vr(n);
    return nt.g ? nt.g(l, R) : nt.call(null, l, R);
  }(), u = va(n), o = Po.g(2, u), a = $s(e, Po.g(2, tn(u))), h = qc(Cn(u)) ? null : new v(null, 2, 5, y, [!0, function() {
    var R = ho(u);
    return nt.g ? nt.g(e, R) : nt.call(null, e, R);
  }()], null), s = O.j(h, 0, null), d = O.j(h, 1, null), p = Nu.g(o, a), _ = function() {
    for (var R = z(p), F = Tt; ; ) if (R) {
      var L = R, G = z(L), J = I(G), we = W(G), ce = J, xe = I(we), $e = W(we), je = xe, E = $e;
      if (ei(ce)) {
        var P = E;
        F = wt.j(/* @__PURE__ */ function(K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt, jt) {
          return function(Cl, fn) {
            return jt(Cl, fn, me);
          };
        }(R, F, L, G, J, we, ce, xe, $e, je, E, l, r, u, o, a, h, s, d, p, t), F, ce), R = P;
      } else R = E, F = t(F, ce, je);
    } else return F;
  }();
  return j(s) ? it(function(R, F, L) {
    return R = D(r, F, L), R = en.j(_, R, CS), Ln(CS, R) ? D(d, F, L) : D(R, F, L);
  }, null) : it(function(R, F, L) {
    R = D(r, F, L);
    var G = en.j(_, R, CS);
    if (Ln(CS, G)) throw Error(["No matching clause: ", ye.h(R)].join(""));
    return D(G, F, L);
  }, null);
}, Ape = function(e, n) {
  var t = Dn.l(e, bp, !1, Te([QZ, k0e])), l = W(n);
  e = uB(Vt(n), !0), n = function() {
    for (var p = l, _ = Dt, R = Dt, F = null; ; ) if (p) {
      var L = I(p);
      if (p = W(p), ei(L) && on.g(Eee, I(L))) R = yt.g(R, L);
      else {
        if (er(p) && ei(L) && on.g(A2, I(L))) return new v(null, 3, 5, y, [_, R, L], null);
        _ = yt.g(_, L);
      }
    } else return new v(null, 3, 5, y, [_, R, F], null);
  }();
  var r = O.j(n, 0, null), u = O.j(n, 1, null), o = O.j(n, 2, null), a = function() {
    var p = kt(mi, r);
    return nt.g ? nt.g(t, p) : nt.call(null, t, p);
  }(), h = wo.g(function(p) {
    p = z(p), I(p);
    var _ = W(p);
    p = I(_), _ = W(_);
    var R = I(_), F = W(_);
    if (_ = on.g(Cx, p) ? Error : on.g(yJ, p) ? Object : on.g(
      ai,
      p
    ) ? ai : nt.g ? nt.g(t, p) : nt.call(null, t, p), j(_)) {
      var L = Xr.o(), G = jf.h(t);
      G = M_(t, G, L);
      var J = xs(bu.j(t, new v(null, 1, 5, y, [Ws], null), function(ce) {
        return Dn.j(nr.g(ce, R), R, L);
      }), new v(null, 2, 5, y, [Rc, L], null), G), we = function() {
        var ce = kt(mi, F);
        return nt.g ? nt.g(J, ce) : nt.call(null, J, ce);
      }();
      return new $(null, 4, [gh, _, HJ, G, uc, we, rW, p], null);
    }
    return Co(["Unable to resolve classname: ", ye.h(p)].join(""), p);
  }, u), s = function() {
    var p = on.g(1, Cn(h)) ? O.g(h, 0) : null;
    p = rW.h(p);
    var _ = on.g(Cx, p);
    return _ && (p = p == null ? null : Vt(p), p == null ? null : bm.h(p));
  }(), d = j(o) ? function() {
    var p = kt(mi, tn(o));
    return nt.g ? nt.g(t, p) : nt.call(null, t, p);
  }() : null;
  return it(function(p, _, R) {
    return spe(_, R, a, h, d, s);
  }, e);
}, Dpe = function(e, n) {
  O.j(n, 0, null);
  var t = O.j(n, 1, null);
  on.g(2, Cn(n)) || Co("Too many arguments to throw", n), e = ff(e);
  var l = nt.g ? nt.g(e, t) : nt.call(null, e, t);
  return n = Dn.l(Vt(n), ie, sn(Mi), Te([Bn, sn(Iu), bB, !0])), it(function(r, u, o) {
    return Al(u, 0, D(l, u, o), r);
  }, n);
}, uq = function(e, n) {
  var t = z(n);
  I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  l = I(r), r = W(r);
  var u = ff(e);
  e = ei(l) ? l : kt(l, r), e = z(e);
  var o = I(e);
  e = W(e);
  var a = nt.g ? nt.g(u, t) : nt.call(null, u, t), h = ml(o), s = e ? $s(u, e) : null;
  return function() {
    var d = h.lastIndexOf("-", 0) == 0, p = d ? Si.g(h, 1) : h, _ = Dn.l(Vt(n), ie, sn(Mi), Te([Bn, sn(Iu)])), R = function() {
      var L = rs;
      return j(L) || (L = o === Cne) ? L : Ew.h(Hf.h(sn(Or.h(u))));
    }(), F = Fs.h(s);
    return Bl(function() {
      var L = new v(null, 2, 5, y, [pu(R), pu(d)], null);
      return on.g(new v(null, 2, 5, y, [!0, !0], null), L) ? it(function(G, J, we) {
        return D(a, J, we)[p];
      }, _) : on.g(new v(null, 2, 5, y, [!0, !1], null), L) ? it(function(G, J, we) {
        return G = D(a, J, we), TG(J, we, G, p, F);
      }, _) : it(function(G, J, we) {
        return ape(J, we, a, p, d, F, R);
      }, _);
    }(), new $(null, 2, [pX, a, $J, h], null));
  }();
}, sq = function(e, n) {
  var t = z(n);
  I(t), t = W(t);
  var l = I(t);
  t = W(t);
  var r = ff(e);
  if (l instanceof T) {
    if (e = function() {
      var s = wk(r, l);
      if (j(s)) {
        var d = T7.h(s);
        s = j(d) ? d : gh.h(s);
      } else s = null;
      return s = j(s) ? s : null, j(s) ? s : Hw(r, l, !1, null);
    }(), j(e)) {
      var u = e;
      e = $s(r, t);
      var o = Qs(u), a = o ? u : null;
      if (t = o ? sn(a) : u instanceof T ? u : null, t = j(t) ? Ik.h(Vt(t)) : null, j(t)) return o = Dn.l(Vt(n), ie, sn(Mi), Te([Bn, sn(Iu)])), Ka.T ? Ka.T(r, n, t, e, o, null) : Ka.call(null, r, n, t, e, o, null);
      if (o) {
        var h = Fs.h(e);
        return it(function(s, d, p) {
          return Sv(d, p, sn(a), h);
        }, null);
      }
      return u instanceof Ic ? (h = Fs.h(e), it(function(s, d, p) {
        return Sv(d, p, D(u, d, p), h);
      }, null)) : (h = Fs.h(e), it(function(s, d, p) {
        return Sv(d, p, u, h);
      }, null));
    }
    return o = ipe(r, l), j(o) ? (e = $s(r, t), t = Ik.h(Vt(o)), o = Dn.l(Vt(n), ie, sn(Mi), Te([Bn, sn(Iu)])), Ka.T ? Ka.T(r, n, t, e, o, null) : Ka.call(null, r, n, t, e, o, null)) : Co(["Unable to resolve classname: ", ye.h(l)].join(""), l);
  }
  return u = nt.g ? nt.g(r, l) : nt.call(
    null,
    r,
    l
  ), e = $s(r, t), h = Fs.h(e), it(function(s, d, p) {
    return Sv(d, p, D(u, d, p), h);
  }, null);
}, Ipe = function(e, n, t) {
  return n = Dn.l(Vt(n), Bn, sn(Iu), Te([ie, sn(Mi)])), it(function(l, r) {
    try {
      return In.j(e, r, t);
    } catch (u) {
      if (u instanceof Error) return Al(r, 0, u, l);
      throw u;
    }
  }, n);
}, Rpe = function(e, n) {
  var t = z(n), l = I(t), r = W(t), u = I(r), o = W(r);
  if (!(u instanceof T)) throw Error(["Namespace name must be symbol, got: ", wg.l(Te([u]))].join(""));
  var a = function() {
    var U = I(o);
    return typeof U == "string" ? new v(null, 2, 5, y, [U, W(o)], null) : new v(
      null,
      2,
      5,
      y,
      [null, o],
      null
    );
  }(), h = O.j(a, 0, null), s = O.j(a, 1, null), d = function() {
    var U = I(s);
    return ci(U) ? new v(null, 2, 5, y, [U, W(s)], null) : new v(null, 2, 5, y, [null, s], null);
  }(), p = O.j(d, 0, null), _ = O.j(d, 1, null), R = j(h) ? Dn.j(p, ee, h) : p;
  kG(e, u, R);
  for (var F = _, L = Dt; ; ) if (j(F)) {
    var G = I(F), J = z(G), we = I(J), ce = W(J), xe = we, $e = ce, je = G, E = xe, P = E instanceof de ? E.ca : null;
    switch (P) {
      case "require":
      case "require-macros":
      case "use":
      case "import":
      case "refer-clojure":
        var K = W(F), H = yt.g(L, Ipe(function() {
          var U = xe, Me = U instanceof de ? U.ca : null;
          switch (Me) {
            case "require":
              return y5;
            case "require-macros":
              return tT;
            case "use":
              return _5;
            case "import":
              return v5;
            case "refer-clojure":
              return function() {
                return function() {
                  function le(Ye, B) {
                    var q = null;
                    if (1 < arguments.length) {
                      q = 0;
                      for (var me = Array(arguments.length - 1); q < me.length; ) me[q] = arguments[q + 1], ++q;
                      q = new hn(me, 0, null);
                    }
                    return Ce.call(this, Ye, q);
                  }
                  function Ce(Ye, B) {
                    return In.B(x5, Ye, ks, B);
                  }
                  return le.m = 1, le.v = function(Ye) {
                    var B = I(Ye);
                    return Ye = tn(Ye), Ce(B, Ye);
                  }, le.l = Ce, le;
                }();
              }();
            default:
              throw Error(["No matching clause: ", ye.h(Me)].join(""));
          }
        }(), je, $e));
        F = K, L = H;
        continue;
      case "gen-class":
        K = W(F), H = L, F = K, L = H;
        continue;
      default:
        throw Error(["No matching clause: ", ye.h(P)].join(""));
    }
  } else return S5(e, n, yt.g(L, it(/* @__PURE__ */ function(U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at) {
    return function(Yt, jt) {
      return aB(Or.h(jt), at), null;
    };
  }(F, L, a, h, s, d, p, _, R, n, t, l, r, l, u, o, u), null)));
}, Npe = function(e, n) {
  O.j(n, 0, null);
  var t = O.j(n, 1, null), l = O.j(n, 2, null);
  if (t instanceof T) {
    var r = Hw(e, t, !1, null), u = nt.g ? nt.g(e, l) : nt.call(null, e, l);
    if (Qs(r)) return it(function(d, p, _) {
      return d = D(u, p, _), ky(r, d);
    }, null);
    if (j(E7.h(Vt(r)))) {
      var o = Hw(e, U_, !1, null), a = en.g(SQ.h(e), t);
      return it(function(d, p, _) {
        return d = D(u, p, _), p = D(o, p, _), a.g ? a.g(p, d) : a.call(null, p, d);
      }, null);
    }
    return Co("Invalid assignment target", n);
  }
  if (ei(t)) {
    r = nt.g ? nt.g(e, t) : nt.call(null, e, t), u = nt.g ? nt.g(e, l) : nt.call(null, e, l), e = Vt(r);
    var h = Si.g($J.h(e), 1), s = pX.h(e);
    return it(function(d, p, _) {
      d = D(s, p, _), p = D(u, p, _), d[h] = p;
    }, null);
  }
  return Co(
    "Invalid assignment target",
    n
  );
}, Cpe = function(e, n, t) {
  switch (Cn(n)) {
    case 0:
      return it(function(je, E, P) {
        try {
          var K = P[e];
          return K.o ? K.o() : K.call(null);
        } catch (H) {
          if (H instanceof Error) return Al(E, 0, H, je);
          throw H;
        }
      }, t);
    case 1:
      var l = O.g(n, 0);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = P[e];
          return H.h ? H.h(K) : H.call(null, K);
        } catch (U) {
          if (U instanceof Error) return Al(E, 0, U, je);
          throw U;
        }
      }, t);
    case 2:
      l = O.g(n, 0);
      var r = O.g(n, 1);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = P[e];
          return U.g ? U.g(K, H) : U.call(null, K, H);
        } catch (Me) {
          if (Me instanceof Error) return Al(E, 0, Me, je);
          throw Me;
        }
      }, t);
    case 3:
      l = O.g(n, 0), r = O.g(n, 1);
      var u = O.g(n, 2);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = P[e];
          return Me.j ? Me.j(K, H, U) : Me.call(null, K, H, U);
        } catch (le) {
          if (le instanceof Error) return Al(E, 0, le, je);
          throw le;
        }
      }, t);
    case 4:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2);
      var o = O.g(n, 3);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = P[e];
          return le.B ? le.B(K, H, U, Me) : le.call(null, K, H, U, Me);
        } catch (Ce) {
          if (Ce instanceof Error) return Al(
            E,
            0,
            Ce,
            je
          );
          throw Ce;
        }
      }, t);
    case 5:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3);
      var a = O.g(n, 4);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = P[e];
          return Ce.I ? Ce.I(K, H, U, Me, le) : Ce.call(null, K, H, U, Me, le);
        } catch (Ye) {
          if (Ye instanceof Error) return Al(E, 0, Ye, je);
          throw Ye;
        }
      }, t);
    case 6:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4);
      var h = O.g(n, 5);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = P[e];
          return Ye.T ? Ye.T(K, H, U, Me, le, Ce) : Ye.call(null, K, H, U, Me, le, Ce);
        } catch (B) {
          if (B instanceof Error) return Al(E, 0, B, je);
          throw B;
        }
      }, t);
    case 7:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5);
      var s = O.g(n, 6);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = P[e];
          return B.ba ? B.ba(K, H, U, Me, le, Ce, Ye) : B.call(null, K, H, U, Me, le, Ce, Ye);
        } catch (q) {
          if (q instanceof Error) return Al(E, 0, q, je);
          throw q;
        }
      }, t);
    case 8:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6);
      var d = O.g(n, 7);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = P[e];
          return q.ia ? q.ia(K, H, U, Me, le, Ce, Ye, B) : q.call(null, K, H, U, Me, le, Ce, Ye, B);
        } catch (me) {
          if (me instanceof Error) return Al(E, 0, me, je);
          throw me;
        }
      }, t);
    case 9:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7);
      var p = O.g(n, 8);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = P[e];
          return me.va ? me.va(K, H, U, Me, le, Ce, Ye, B, q) : me.call(null, K, H, U, Me, le, Ce, Ye, B, q);
        } catch (Ae) {
          if (Ae instanceof Error) return Al(E, 0, Ae, je);
          throw Ae;
        }
      }, t);
    case 10:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7), p = O.g(n, 8);
      var _ = O.g(n, 9);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = D(_, E, P), Ae = P[e];
          return Ae.la ? Ae.la(K, H, U, Me, le, Ce, Ye, B, q, me) : Ae.call(null, K, H, U, Me, le, Ce, Ye, B, q, me);
        } catch (Fe) {
          if (Fe instanceof Error) return Al(E, 0, Fe, je);
          throw Fe;
        }
      }, t);
    case 11:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7), p = O.g(n, 8), _ = O.g(n, 9);
      var R = O.g(n, 10);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = D(_, E, P), Ae = D(R, E, P), Fe = P[e];
          return Fe.ma ? Fe.ma(K, H, U, Me, le, Ce, Ye, B, q, me, Ae) : Fe.call(null, K, H, U, Me, le, Ce, Ye, B, q, me, Ae);
        } catch (ln) {
          if (ln instanceof Error) return Al(E, 0, ln, je);
          throw ln;
        }
      }, t);
    case 12:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7), p = O.g(n, 8), _ = O.g(n, 9), R = O.g(n, 10);
      var F = O.g(n, 11);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = D(_, E, P), Ae = D(R, E, P), Fe = D(F, E, P), ln = P[e];
          return ln.na ? ln.na(K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe) : ln.call(null, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe);
        } catch (Be) {
          if (Be instanceof Error) return Al(E, 0, Be, je);
          throw Be;
        }
      }, t);
    case 13:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7), p = O.g(n, 8), _ = O.g(n, 9), R = O.g(n, 10), F = O.g(n, 11);
      var L = O.g(n, 12);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = D(_, E, P), Ae = D(R, E, P), Fe = D(F, E, P), ln = D(L, E, P), Be = P[e];
          return Be.oa ? Be.oa(K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln) : Be.call(null, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln);
        } catch (Ze) {
          if (Ze instanceof Error) return Al(E, 0, Ze, je);
          throw Ze;
        }
      }, t);
    case 14:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7), p = O.g(n, 8), _ = O.g(n, 9), R = O.g(n, 10), F = O.g(n, 11), L = O.g(n, 12);
      var G = O.g(n, 13);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = D(
            _,
            E,
            P
          ), Ae = D(R, E, P), Fe = D(F, E, P), ln = D(L, E, P), Be = D(G, E, P), Ze = P[e];
          return Ze.pa ? Ze.pa(K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be) : Ze.call(null, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be);
        } catch (pn) {
          if (pn instanceof Error) return Al(E, 0, pn, je);
          throw pn;
        }
      }, t);
    case 15:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7), p = O.g(n, 8), _ = O.g(n, 9), R = O.g(n, 10), F = O.g(n, 11), L = O.g(n, 12), G = O.g(n, 13);
      var J = O.g(n, 14);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = D(_, E, P), Ae = D(R, E, P), Fe = D(F, E, P), ln = D(L, E, P), Be = D(G, E, P), Ze = D(J, E, P), pn = P[e];
          return pn.qa ? pn.qa(K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze) : pn.call(null, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze);
        } catch (xn) {
          if (xn instanceof Error) return Al(E, 0, xn, je);
          throw xn;
        }
      }, t);
    case 16:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7), p = O.g(n, 8), _ = O.g(n, 9), R = O.g(n, 10), F = O.g(n, 11), L = O.g(n, 12), G = O.g(n, 13), J = O.g(
        n,
        14
      );
      var we = O.g(n, 15);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = D(_, E, P), Ae = D(R, E, P), Fe = D(F, E, P), ln = D(L, E, P), Be = D(G, E, P), Ze = D(J, E, P), pn = D(we, E, P), xn = P[e];
          return xn.ra ? xn.ra(K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn) : xn.call(null, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn);
        } catch (Nn) {
          if (Nn instanceof Error) return Al(E, 0, Nn, je);
          throw Nn;
        }
      }, t);
    case 17:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7), p = O.g(n, 8), _ = O.g(n, 9), R = O.g(n, 10), F = O.g(n, 11), L = O.g(n, 12), G = O.g(n, 13), J = O.g(n, 14), we = O.g(n, 15);
      var ce = O.g(n, 16);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = D(_, E, P), Ae = D(R, E, P), Fe = D(F, E, P), ln = D(L, E, P), Be = D(G, E, P), Ze = D(J, E, P), pn = D(we, E, P), xn = D(ce, E, P), Nn = P[e];
          return Nn.sa ? Nn.sa(K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn) : Nn.call(
            null,
            K,
            H,
            U,
            Me,
            le,
            Ce,
            Ye,
            B,
            q,
            me,
            Ae,
            Fe,
            ln,
            Be,
            Ze,
            pn,
            xn
          );
        } catch (at) {
          if (at instanceof Error) return Al(E, 0, at, je);
          throw at;
        }
      }, t);
    case 18:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7), p = O.g(n, 8), _ = O.g(n, 9), R = O.g(n, 10), F = O.g(n, 11), L = O.g(n, 12), G = O.g(n, 13), J = O.g(n, 14), we = O.g(n, 15), ce = O.g(n, 16);
      var xe = O.g(n, 17);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = D(_, E, P), Ae = D(R, E, P), Fe = D(F, E, P), ln = D(
            L,
            E,
            P
          ), Be = D(G, E, P), Ze = D(J, E, P), pn = D(we, E, P), xn = D(ce, E, P), Nn = D(xe, E, P), at = P[e];
          return at.ta ? at.ta(K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn) : at.call(null, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn);
        } catch (Yt) {
          if (Yt instanceof Error) return Al(E, 0, Yt, je);
          throw Yt;
        }
      }, t);
    case 19:
      l = O.g(n, 0), r = O.g(n, 1), u = O.g(n, 2), o = O.g(n, 3), a = O.g(n, 4), h = O.g(n, 5), s = O.g(n, 6), d = O.g(n, 7), p = O.g(n, 8), _ = O.g(n, 9), R = O.g(n, 10), F = O.g(n, 11), L = O.g(n, 12), G = O.g(n, 13), J = O.g(n, 14), we = O.g(n, 15), ce = O.g(n, 16), xe = O.g(n, 17);
      var $e = O.g(n, 18);
      return it(function(je, E, P) {
        try {
          var K = D(l, E, P), H = D(r, E, P), U = D(u, E, P), Me = D(o, E, P), le = D(a, E, P), Ce = D(h, E, P), Ye = D(s, E, P), B = D(d, E, P), q = D(p, E, P), me = D(_, E, P), Ae = D(R, E, P), Fe = D(F, E, P), ln = D(L, E, P), Be = D(G, E, P), Ze = D(J, E, P), pn = D(we, E, P), xn = D(ce, E, P), Nn = D(xe, E, P), at = D($e, E, P), Yt = P[e];
          return Yt.ua ? Yt.ua(K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at) : Yt.call(null, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at);
        } catch (jt) {
          if (jt instanceof Error) return Al(E, 0, jt, je);
          throw jt;
        }
      }, t);
    default:
      return function(je, E) {
        return vk(je, E, E[e], n);
      };
  }
}, Mpe = function(e, n, t) {
  switch (e = Dn.l(Vt(e), Bn, sn(Iu), Te([ie, sn(Mi)])), Cn(t)) {
    case 0:
      return it(function(je, E) {
        return n.h ? n.h(E) : n.call(null, E);
      }, e);
    case 1:
      var l = O.g(t, 0);
      return it(function(je, E, P) {
        return je = D(l, E, P), n.g ? n.g(E, je) : n.call(null, E, je);
      }, e);
    case 2:
      l = O.g(t, 0);
      var r = O.g(t, 1);
      return it(function(je, E, P) {
        return je = D(l, E, P), P = D(r, E, P), n.j ? n.j(E, je, P) : n.call(null, E, je, P);
      }, e);
    case 3:
      l = O.g(t, 0), r = O.g(t, 1);
      var u = O.g(t, 2);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P);
        return P = D(u, E, P), n.B ? n.B(E, je, K, P) : n.call(null, E, je, K, P);
      }, e);
    case 4:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2);
      var o = O.g(t, 3);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P);
        return P = D(o, E, P), n.I ? n.I(E, je, K, H, P) : n.call(null, E, je, K, H, P);
      }, e);
    case 5:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3);
      var a = O.g(t, 4);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P);
        return P = D(a, E, P), n.T ? n.T(E, je, K, H, U, P) : n.call(null, E, je, K, H, U, P);
      }, e);
    case 6:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4);
      var h = O.g(t, 5);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P);
        return P = D(h, E, P), n.ba ? n.ba(E, je, K, H, U, Me, P) : n.call(null, E, je, K, H, U, Me, P);
      }, e);
    case 7:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5);
      var s = O.g(t, 6);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P);
        return P = D(s, E, P), n.ia ? n.ia(E, je, K, H, U, Me, le, P) : n.call(null, E, je, K, H, U, Me, le, P);
      }, e);
    case 8:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6);
      var d = O.g(t, 7);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P);
        return P = D(d, E, P), n.va ? n.va(E, je, K, H, U, Me, le, Ce, P) : n.call(null, E, je, K, H, U, Me, le, Ce, P);
      }, e);
    case 9:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7);
      var p = O.g(t, 8);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(
          d,
          E,
          P
        );
        return P = D(p, E, P), n.la ? n.la(E, je, K, H, U, Me, le, Ce, Ye, P) : n.call(null, E, je, K, H, U, Me, le, Ce, Ye, P);
      }, e);
    case 10:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7), p = O.g(t, 8);
      var _ = O.g(t, 9);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(d, E, P), B = D(p, E, P);
        return P = D(_, E, P), n.ma ? n.ma(E, je, K, H, U, Me, le, Ce, Ye, B, P) : n.call(null, E, je, K, H, U, Me, le, Ce, Ye, B, P);
      }, e);
    case 11:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7), p = O.g(t, 8), _ = O.g(t, 9);
      var R = O.g(t, 10);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(d, E, P), B = D(p, E, P), q = D(_, E, P);
        return P = D(R, E, P), n.na ? n.na(E, je, K, H, U, Me, le, Ce, Ye, B, q, P) : n.call(null, E, je, K, H, U, Me, le, Ce, Ye, B, q, P);
      }, e);
    case 12:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7), p = O.g(t, 8), _ = O.g(t, 9), R = O.g(t, 10);
      var F = O.g(t, 11);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(d, E, P), B = D(p, E, P), q = D(_, E, P), me = D(R, E, P);
        return P = D(F, E, P), n.oa ? n.oa(E, je, K, H, U, Me, le, Ce, Ye, B, q, me, P) : n.call(null, E, je, K, H, U, Me, le, Ce, Ye, B, q, me, P);
      }, e);
    case 13:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7), p = O.g(t, 8), _ = O.g(t, 9), R = O.g(t, 10), F = O.g(t, 11);
      var L = O.g(t, 12);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(d, E, P), B = D(p, E, P), q = D(_, E, P), me = D(R, E, P), Ae = D(F, E, P);
        return P = D(L, E, P), n.pa ? n.pa(E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, P) : n.call(null, E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, P);
      }, e);
    case 14:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7), p = O.g(t, 8), _ = O.g(t, 9), R = O.g(t, 10), F = O.g(t, 11), L = O.g(t, 12);
      var G = O.g(t, 13);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(d, E, P), B = D(
          p,
          E,
          P
        ), q = D(_, E, P), me = D(R, E, P), Ae = D(F, E, P), Fe = D(L, E, P);
        return P = D(G, E, P), n.qa ? n.qa(E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, P) : n.call(null, E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, P);
      }, e);
    case 15:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7), p = O.g(t, 8), _ = O.g(t, 9), R = O.g(t, 10), F = O.g(t, 11), L = O.g(t, 12), G = O.g(t, 13);
      var J = O.g(t, 14);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(d, E, P), B = D(p, E, P), q = D(
          _,
          E,
          P
        ), me = D(R, E, P), Ae = D(F, E, P), Fe = D(L, E, P), ln = D(G, E, P);
        return P = D(J, E, P), n.ra ? n.ra(E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, P) : n.call(null, E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, P);
      }, e);
    case 16:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7), p = O.g(t, 8), _ = O.g(t, 9), R = O.g(t, 10), F = O.g(t, 11), L = O.g(t, 12), G = O.g(t, 13), J = O.g(t, 14);
      var we = O.g(t, 15);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(
          d,
          E,
          P
        ), B = D(p, E, P), q = D(_, E, P), me = D(R, E, P), Ae = D(F, E, P), Fe = D(L, E, P), ln = D(G, E, P), Be = D(J, E, P);
        return P = D(we, E, P), n.sa ? n.sa(E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, P) : n.call(null, E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, P);
      }, e);
    case 17:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7), p = O.g(t, 8), _ = O.g(t, 9), R = O.g(t, 10), F = O.g(t, 11), L = O.g(t, 12), G = O.g(t, 13), J = O.g(t, 14), we = O.g(t, 15);
      var ce = O.g(t, 16);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(d, E, P), B = D(p, E, P), q = D(_, E, P), me = D(R, E, P), Ae = D(F, E, P), Fe = D(L, E, P), ln = D(G, E, P), Be = D(J, E, P), Ze = D(we, E, P);
        return P = D(ce, E, P), n.ta ? n.ta(E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, P) : n.call(null, E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, P);
      }, e);
    case 18:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7), p = O.g(t, 8), _ = O.g(t, 9), R = O.g(t, 10), F = O.g(t, 11), L = O.g(t, 12), G = O.g(t, 13), J = O.g(t, 14), we = O.g(t, 15), ce = O.g(t, 16);
      var xe = O.g(t, 17);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(d, E, P), B = D(p, E, P), q = D(_, E, P), me = D(R, E, P), Ae = D(F, E, P), Fe = D(L, E, P), ln = D(G, E, P), Be = D(J, E, P), Ze = D(we, E, P), pn = D(ce, E, P);
        return P = D(xe, E, P), n.ua ? n.ua(E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, P) : n.call(null, E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, P);
      }, e);
    case 19:
      l = O.g(t, 0), r = O.g(t, 1), u = O.g(t, 2), o = O.g(t, 3), a = O.g(t, 4), h = O.g(t, 5), s = O.g(t, 6), d = O.g(t, 7), p = O.g(
        t,
        8
      ), _ = O.g(t, 9), R = O.g(t, 10), F = O.g(t, 11), L = O.g(t, 12), G = O.g(t, 13), J = O.g(t, 14), we = O.g(t, 15), ce = O.g(t, 16), xe = O.g(t, 17);
      var $e = O.g(t, 18);
      return it(function(je, E, P) {
        je = D(l, E, P);
        var K = D(r, E, P), H = D(u, E, P), U = D(o, E, P), Me = D(a, E, P), le = D(h, E, P), Ce = D(s, E, P), Ye = D(d, E, P), B = D(p, E, P), q = D(_, E, P), me = D(R, E, P), Ae = D(F, E, P), Fe = D(L, E, P), ln = D(G, E, P), Be = D(J, E, P), Ze = D(we, E, P), pn = D(ce, E, P), xn = D(xe, E, P);
        return P = D($e, E, P), n.Va ? n.Va(E, je, K, H, U, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, P) : n.call(
          null,
          E,
          je,
          K,
          H,
          U,
          Me,
          le,
          Ce,
          Ye,
          B,
          q,
          me,
          Ae,
          Fe,
          ln,
          Be,
          Ze,
          pn,
          xn,
          P
        );
      }, e);
    default:
      return it(function(je, E, P) {
        return vk(E, P, n, kt(E, t));
      }, e);
  }
}, Ka = function(e, n, t, l, r, u) {
  switch (Cn(l)) {
    case 0:
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return Me.o ? Me.o() : Me.call(null);
        } catch (le) {
          if (le instanceof Error) return Al(H, 0, le, K);
          throw le;
        }
      }, r) : it(function(K, H) {
        try {
          return t.o ? t.o() : t.call(null);
        } catch (U) {
          if (U instanceof Error) return Al(H, 0, U, K);
          throw U;
        }
      }, r);
    case 1:
      var o = O.g(l, 0);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(
            o,
            H,
            U
          ), le = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return le.h ? le.h(Me) : le.call(null, Me);
        } catch (Ce) {
          if (Ce instanceof Error) return Al(H, 0, Ce, K);
          throw Ce;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U);
          return t.h ? t.h(Me) : t.call(null, Me);
        } catch (le) {
          if (le instanceof Error) return Al(H, 0, le, K);
          throw le;
        }
      }, r);
    case 2:
      o = O.g(l, 0);
      var a = O.g(l, 1);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return Ce.g ? Ce.g(Me, le) : Ce.call(null, Me, le);
        } catch (Ye) {
          if (Ye instanceof Error) return Al(
            H,
            0,
            Ye,
            K
          );
          throw Ye;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U);
          return t.g ? t.g(Me, le) : t.call(null, Me, le);
        } catch (Ce) {
          if (Ce instanceof Error) return Al(H, 0, Ce, K);
          throw Ce;
        }
      }, r);
    case 3:
      o = O.g(l, 0), a = O.g(l, 1);
      var h = O.g(l, 2);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return Ye.j ? Ye.j(Me, le, Ce) : Ye.call(null, Me, le, Ce);
        } catch (B) {
          if (B instanceof Error) return Al(H, 0, B, K);
          throw B;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(
            a,
            H,
            U
          ), Ce = D(h, H, U);
          return t.j ? t.j(Me, le, Ce) : t.call(null, Me, le, Ce);
        } catch (Ye) {
          if (Ye instanceof Error) return Al(H, 0, Ye, K);
          throw Ye;
        }
      }, r);
    case 4:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2);
      var s = O.g(l, 3);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return B.B ? B.B(Me, le, Ce, Ye) : B.call(null, Me, le, Ce, Ye);
        } catch (q) {
          if (q instanceof Error) return Al(H, 0, q, K);
          throw q;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U);
          return t.B ? t.B(Me, le, Ce, Ye) : t.call(null, Me, le, Ce, Ye);
        } catch (B) {
          if (B instanceof Error) return Al(H, 0, B, K);
          throw B;
        }
      }, r);
    case 5:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3);
      var d = O.g(l, 4);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return q.I ? q.I(Me, le, Ce, Ye, B) : q.call(null, Me, le, Ce, Ye, B);
        } catch (me) {
          if (me instanceof Error) return Al(H, 0, me, K);
          throw me;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U);
          return t.I ? t.I(Me, le, Ce, Ye, B) : t.call(null, Me, le, Ce, Ye, B);
        } catch (q) {
          if (q instanceof Error) return Al(H, 0, q, K);
          throw q;
        }
      }, r);
    case 6:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4);
      var p = O.g(l, 5);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return me.T ? me.T(Me, le, Ce, Ye, B, q) : me.call(null, Me, le, Ce, Ye, B, q);
        } catch (Ae) {
          if (Ae instanceof Error) return Al(
            H,
            0,
            Ae,
            K
          );
          throw Ae;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U);
          return t.T ? t.T(Me, le, Ce, Ye, B, q) : t.call(null, Me, le, Ce, Ye, B, q);
        } catch (me) {
          if (me instanceof Error) return Al(H, 0, me, K);
          throw me;
        }
      }, r);
    case 7:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5);
      var _ = O.g(l, 6);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return Ae.ba ? Ae.ba(Me, le, Ce, Ye, B, q, me) : Ae.call(null, Me, le, Ce, Ye, B, q, me);
        } catch (Fe) {
          if (Fe instanceof Error) return Al(H, 0, Fe, K);
          throw Fe;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U);
          return t.ba ? t.ba(Me, le, Ce, Ye, B, q, me) : t.call(null, Me, le, Ce, Ye, B, q, me);
        } catch (Ae) {
          if (Ae instanceof Error) return Al(H, 0, Ae, K);
          throw Ae;
        }
      }, r);
    case 8:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6);
      var R = O.g(l, 7);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return Fe.ia ? Fe.ia(Me, le, Ce, Ye, B, q, me, Ae) : Fe.call(null, Me, le, Ce, Ye, B, q, me, Ae);
        } catch (ln) {
          if (ln instanceof Error) return Al(H, 0, ln, K);
          throw ln;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U);
          return t.ia ? t.ia(Me, le, Ce, Ye, B, q, me, Ae) : t.call(
            null,
            Me,
            le,
            Ce,
            Ye,
            B,
            q,
            me,
            Ae
          );
        } catch (Fe) {
          if (Fe instanceof Error) return Al(H, 0, Fe, K);
          throw Fe;
        }
      }, r);
    case 9:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7);
      var F = O.g(l, 8);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return ln.va ? ln.va(Me, le, Ce, Ye, B, q, me, Ae, Fe) : ln.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe);
        } catch (Be) {
          if (Be instanceof Error) return Al(
            H,
            0,
            Be,
            K
          );
          throw Be;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U);
          return t.va ? t.va(Me, le, Ce, Ye, B, q, me, Ae, Fe) : t.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe);
        } catch (ln) {
          if (ln instanceof Error) return Al(H, 0, ln, K);
          throw ln;
        }
      }, r);
    case 10:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7), F = O.g(l, 8);
      var L = O.g(l, 9);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(
            h,
            H,
            U
          ), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return Be.la ? Be.la(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln) : Be.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln);
        } catch (Ze) {
          if (Ze instanceof Error) return Al(H, 0, Ze, K);
          throw Ze;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U);
          return t.la ? t.la(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln) : t.call(
            null,
            Me,
            le,
            Ce,
            Ye,
            B,
            q,
            me,
            Ae,
            Fe,
            ln
          );
        } catch (Be) {
          if (Be instanceof Error) return Al(H, 0, Be, K);
          throw Be;
        }
      }, r);
    case 11:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7), F = O.g(l, 8), L = O.g(l, 9);
      var G = O.g(l, 10);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return Ze.ma ? Ze.ma(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be) : Ze.call(
            null,
            Me,
            le,
            Ce,
            Ye,
            B,
            q,
            me,
            Ae,
            Fe,
            ln,
            Be
          );
        } catch (pn) {
          if (pn instanceof Error) return Al(H, 0, pn, K);
          throw pn;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U);
          return t.ma ? t.ma(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be) : t.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be);
        } catch (Ze) {
          if (Ze instanceof Error) return Al(H, 0, Ze, K);
          throw Ze;
        }
      }, r);
    case 12:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7), F = O.g(l, 8), L = O.g(l, 9), G = O.g(l, 10);
      var J = O.g(l, 11);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return pn.na ? pn.na(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze) : pn.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze);
        } catch (xn) {
          if (xn instanceof Error) return Al(H, 0, xn, K);
          throw xn;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U);
          return t.na ? t.na(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze) : t.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze);
        } catch (pn) {
          if (pn instanceof Error) return Al(H, 0, pn, K);
          throw pn;
        }
      }, r);
    case 13:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7), F = O.g(l, 8), L = O.g(l, 9), G = O.g(l, 10), J = O.g(l, 11);
      var we = O.g(l, 12);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return xn.oa ? xn.oa(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn) : xn.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn);
        } catch (Nn) {
          if (Nn instanceof Error) return Al(H, 0, Nn, K);
          throw Nn;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(
            F,
            H,
            U
          ), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U);
          return t.oa ? t.oa(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn) : t.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn);
        } catch (xn) {
          if (xn instanceof Error) return Al(H, 0, xn, K);
          throw xn;
        }
      }, r);
    case 14:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7), F = O.g(l, 8), L = O.g(l, 9), G = O.g(l, 10), J = O.g(l, 11), we = O.g(l, 12);
      var ce = O.g(l, 13);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return Nn.pa ? Nn.pa(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn) : Nn.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn);
        } catch (at) {
          if (at instanceof Error) return Al(H, 0, at, K);
          throw at;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(
            J,
            H,
            U
          ), pn = D(we, H, U), xn = D(ce, H, U);
          return t.pa ? t.pa(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn) : t.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn);
        } catch (Nn) {
          if (Nn instanceof Error) return Al(H, 0, Nn, K);
          throw Nn;
        }
      }, r);
    case 15:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7), F = O.g(l, 8), L = O.g(l, 9), G = O.g(l, 10), J = O.g(l, 11), we = O.g(l, 12), ce = O.g(l, 13);
      var xe = O.g(l, 14);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(
            p,
            H,
            U
          ), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = D(xe, H, U), at = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return at.qa ? at.qa(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn) : at.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn);
        } catch (Yt) {
          if (Yt instanceof Error) return Al(H, 0, Yt, K);
          throw Yt;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(
            G,
            H,
            U
          ), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = D(xe, H, U);
          return t.qa ? t.qa(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn) : t.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn);
        } catch (at) {
          if (at instanceof Error) return Al(H, 0, at, K);
          throw at;
        }
      }, r);
    case 16:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7), F = O.g(l, 8), L = O.g(l, 9), G = O.g(l, 10), J = O.g(l, 11), we = O.g(l, 12), ce = O.g(l, 13), xe = O.g(l, 14);
      var $e = O.g(l, 15);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(
            a,
            H,
            U
          ), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = D(xe, H, U), at = D($e, H, U), Yt = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return Yt.ra ? Yt.ra(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at) : Yt.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at);
        } catch (jt) {
          if (jt instanceof Error) return Al(H, 0, jt, K);
          throw jt;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(
            p,
            H,
            U
          ), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = D(xe, H, U), at = D($e, H, U);
          return t.ra ? t.ra(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at) : t.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at);
        } catch (Yt) {
          if (Yt instanceof Error) return Al(H, 0, Yt, K);
          throw Yt;
        }
      }, r);
    case 17:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7), F = O.g(l, 8), L = O.g(l, 9), G = O.g(l, 10), J = O.g(l, 11), we = O.g(l, 12), ce = O.g(l, 13), xe = O.g(
        l,
        14
      ), $e = O.g(l, 15);
      var je = O.g(l, 16);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = D(xe, H, U), at = D($e, H, U), Yt = D(je, H, U), jt = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return jt.sa ? jt.sa(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt) : jt.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt);
        } catch (Cl) {
          if (Cl instanceof Error) return Al(
            H,
            0,
            Cl,
            K
          );
          throw Cl;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = D(xe, H, U), at = D($e, H, U), Yt = D(je, H, U);
          return t.sa ? t.sa(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt) : t.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt);
        } catch (jt) {
          if (jt instanceof Error) return Al(H, 0, jt, K);
          throw jt;
        }
      }, r);
    case 18:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7), F = O.g(l, 8), L = O.g(l, 9), G = O.g(l, 10), J = O.g(l, 11), we = O.g(l, 12), ce = O.g(l, 13), xe = O.g(l, 14), $e = O.g(l, 15), je = O.g(l, 16);
      var E = O.g(l, 17);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = D(xe, H, U), at = D($e, H, U), Yt = D(je, H, U), jt = D(E, H, U), Cl = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return Cl.ta ? Cl.ta(
            Me,
            le,
            Ce,
            Ye,
            B,
            q,
            me,
            Ae,
            Fe,
            ln,
            Be,
            Ze,
            pn,
            xn,
            Nn,
            at,
            Yt,
            jt
          ) : Cl.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt, jt);
        } catch (fn) {
          if (fn instanceof Error) return Al(H, 0, fn, K);
          throw fn;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = D(xe, H, U), at = D($e, H, U), Yt = D(je, H, U), jt = D(E, H, U);
          return t.ta ? t.ta(
            Me,
            le,
            Ce,
            Ye,
            B,
            q,
            me,
            Ae,
            Fe,
            ln,
            Be,
            Ze,
            pn,
            xn,
            Nn,
            at,
            Yt,
            jt
          ) : t.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt, jt);
        } catch (Cl) {
          if (Cl instanceof Error) return Al(H, 0, Cl, K);
          throw Cl;
        }
      }, r);
    case 19:
      o = O.g(l, 0), a = O.g(l, 1), h = O.g(l, 2), s = O.g(l, 3), d = O.g(l, 4), p = O.g(l, 5), _ = O.g(l, 6), R = O.g(l, 7), F = O.g(l, 8), L = O.g(l, 9), G = O.g(l, 10), J = O.g(l, 11), we = O.g(l, 12), ce = O.g(l, 13), xe = O.g(l, 14), $e = O.g(l, 15), je = O.g(l, 16), E = O.g(l, 17);
      var P = O.g(l, 18);
      return j(u) ? it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(_, H, U), Ae = D(
            R,
            H,
            U
          ), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = D(xe, H, U), at = D($e, H, U), Yt = D(je, H, U), jt = D(E, H, U), Cl = D(P, H, U), fn = u.j ? u.j(H, U, t) : u.call(null, H, U, t);
          return fn.ua ? fn.ua(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt, jt, Cl) : fn.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt, jt, Cl);
        } catch (_e) {
          if (_e instanceof Error) return Al(H, 0, _e, K);
          throw _e;
        }
      }, r) : it(function(K, H, U) {
        try {
          var Me = D(o, H, U), le = D(a, H, U), Ce = D(h, H, U), Ye = D(s, H, U), B = D(d, H, U), q = D(p, H, U), me = D(
            _,
            H,
            U
          ), Ae = D(R, H, U), Fe = D(F, H, U), ln = D(L, H, U), Be = D(G, H, U), Ze = D(J, H, U), pn = D(we, H, U), xn = D(ce, H, U), Nn = D(xe, H, U), at = D($e, H, U), Yt = D(je, H, U), jt = D(E, H, U), Cl = D(P, H, U);
          return t.ua ? t.ua(Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt, jt, Cl) : t.call(null, Me, le, Ce, Ye, B, q, me, Ae, Fe, ln, Be, Ze, pn, xn, Nn, at, Yt, jt, Cl);
        } catch (fn) {
          if (fn instanceof Error) return Al(H, 0, fn, K);
          throw fn;
        }
      }, r);
    default:
      return j(u) ? it(function(K, H, U) {
        return vk(H, U, u.j ? u.j(H, U, t) : u.call(null, H, U, t), l);
      }, r) : it(function(K, H, U) {
        return vk(H, U, t, l);
      }, r);
  }
}, Ppe = function(e) {
  var n = tn(e);
  return e = Dn.l(Vt(e), ie, sn(Mi), Te([Bn, sn(Iu)])), it(function(t, l) {
    try {
      return In.j(v5, l, n);
    } catch (r) {
      if (r instanceof Error) return Al(l, 0, r, t);
      throw r;
    }
  }, e);
}, $pe = function(e, n, t) {
  if (on.g(Kf, t)) {
    if (3 > Cn(n)) throw Error("Malformed member expression, expecting (.member target ...)");
    return uq(e, n);
  }
  if (on.g(P0, t)) return Xxe(e, n, tn(n));
  if (on.g(cF, t)) return Ppe(n);
  if (on.g(L0, t)) return iq(e, n);
  if (on.g(r1, t)) return Ope(e, n);
  if (on.g(si, t)) return jpe(e, n);
  if (on.g(Hx, t)) {
    t = Vr(n);
    var l = Po.g(2, t);
    return n = va(n), n = ve.h(z(he.l(new g(null, Gy, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, us.g(ve.h(z(he.l(new g(null, r1, null, 1, null), new g(null, Et(l), null, 1, null), Te([n])))), l), null, 1, null)])))), nt.g ? nt.g(e, n) : nt.call(null, e, n);
  }
  if (on.g(mi, t)) return S5(e, n, tn(n));
  if (on.g(BB, t)) return t = z(n), n = I(t), t = W(t), l = ml(n), l = Bl(_n.g(Yi(n), Si.j(l, 0, l.length - 1)), Vt(n)), sq(e, Bl(us.j(lf, l, t), Vt(n)));
  if (on.g(Yc, t)) return bpe(e, n);
  if (on.g(Fr, t)) return on.g(2, Cn(n)) || Co("Wrong number of args (0) passed to quote", n), Vr(n);
  if (on.g(Gy, t)) return Qxe(e, n, Vr(n), va(n));
  if (on.g(hF, t)) {
    l = z(n), t = I(l);
    var r = W(l);
    if (l = I(r), r = W(r), 2 > Cn(n)) throw Error("Malformed member expression, expecting (.member target ...)");
    return uq(e, Bl(new g(null, Kf, new g(null, l, new g(null, kt(_n.h(Si.g(ml(t), 1)), r), null, 1, null), 2, null), 3, null), Vt(n)));
  }
  if (on.g(ih, t)) return Rpe(e, n);
  if (on.g(bb, t)) return iq(e, n);
  if (on.g(jb, t)) return Npe(e, n);
  if (on.g(b1, t)) return _pe(e, n, $s(ff(e), tn(n)));
  if (on.g(lf, t)) return sq(e, n);
  if (on.g($u, t)) return O.j(n, 0, null), n = O.j(n, 1, null), Hw(e, n, !1, null);
  if (on.g(C0, t)) return Tpe(e, n);
  if (on.g(rp, t)) return Dpe(e, n);
  if (on.g(T1, t)) return Ape(e, n);
  if (on.g(B0, t)) return Zxe(e, n, tn(n));
  throw Error(["No matching clause: ", ye.h(t)].join(""));
}, Lpe = function(e, n, t, l) {
  var r = j(j(l) ? j(t) ? Yn.h(t) : t : l) ? new $(null, 2, [zn, zn.h(t), Yn, Yn.h(t)], null) : null;
  j(r) && (c1 = r);
  try {
    var u = Kge.h(t);
    j(u) && mg(Qu([Iu, u]));
    try {
      var o = I(n);
      if (o instanceof T) {
        var a = en.g(Hne, o);
        j(j(a) ? nF.h(e) : a) && RG(e, o, new v(null, 2, 5, y, [a, null], null));
        var h = j(a) ? a : Hw(e, o, !0, null), s = Vt(h), d = j(s) ? JM.h(s) : s, p = F0.h(s), _ = j(p) ? p : h;
        if (j(j(s) ? MB.h(s) : s)) {
          var R = O.j(_, 0, null), F = O.j(_, 1, null), L = ho(F), G = on.g(L, ""), J = Cn(F), we = F.slice(0, J - 1), ce = on.g(1, J) ? v1([R, L]) : function() {
            return [gk(R, we), L];
          };
          try {
            var xe = ce();
          } catch {
            xe = null;
          }
          var $e = O.j(xe, 0, null), je = O.j(xe, 1, null), E = $s(e, tn(n)), P = Fs.h(E);
          if (j($e)) {
            if (G) return it(function(Ze, pn, xn) {
              return Sv(pn, xn, $e, P);
            }, null);
            var K = $e[je];
            return it(function(Ze, pn, xn) {
              return QU(pn, xn, $e, K, P);
            }, null);
          }
          return it(G ? function(Ze, pn, xn) {
            return Ze = ce()[0], Sv(
              pn,
              xn,
              Ze,
              P
            );
          } : function(Ze, pn, xn) {
            Ze = ce();
            var Nn = Ze[0];
            return QU(pn, xn, Nn, Nn[Ze[1]], P);
          }, null);
        }
        if (j(function() {
          var Ze = er(d);
          return Ze && ((Ze = _ instanceof T) ? j(a) ? a : Ol(u4, _) : Ze);
        }())) return $pe(e, n, _);
        try {
          if (j(EG(_))) {
            var H = function() {
              var Ze = Qs(_);
              return Ze && by(_);
            }(), U = Qs(_) ? sn(_) : _, Me = function() {
              var Ze = U.afn;
              return j(Ze) ? Ze : U;
            }(), le = j(H) ? In.I(Me, n, Ws.h(e), e, tn(n)) : In.B(Me, n, Ws.h(e), tn(n));
            return j(Tb.h(e)) ? le : j(j(l) ? ei(le) && on.g(mi, I(le)) : l) ? new eB(le != null && (le.C & 262144 || Rn === le.Gd) ? Bl(le, gr.l(Te([
              t,
              Vt(le)
            ]))) : le) : function() {
              var Ze = j(t) && le != null && (le.C & 262144 || Rn === le.Gd) ? Bl(le, gr.l(Te([t, Vt(le)]))) : le;
              return nt.j ? nt.j(e, Ze, l) : nt.call(null, e, Ze, l);
            }();
          }
          var Ce = hl.h(s);
          if (j(Ce)) return U = Ce, Ka(e, n, U, $s(e, tn(n)), Dn.l(t, ie, sn(Mi), Te([Bn, sn(Iu), uv, s])), null);
          var Ye = JM.h(Vt(_));
          if (j(Ye)) switch (Ye instanceof de ? Ye.ca : null) {
            case "resolve-sym":
              return Cpe(Hee.h(Vt(_)), $s(e, tn(n)), Dn.l(t, ie, sn(Mi), Te([Bn, sn(Iu), uv, s])));
            default:
              return E = $s(e, tn(n)), Ka(e, n, _, E, Dn.l(t, ie, sn(Mi), Te([Bn, sn(Iu), uv, s])), null);
          }
          else {
            if (H = function() {
              var Ze = Qs(_);
              return Ze && by(_);
            }(), j(H)) return Mpe(n, _, $s(e, tn(n)));
            var B = Zye.h(e);
            return j(j(B) ? B.h ? B.h(_) : B.call(null, _) : B) ? (E = $s(e, tn(n)), Ka(e, n, _, E, Dn.l(t, ie, sn(Mi), Te([Bn, sn(Iu), uv, s])), function(Ze, pn) {
              return sn(pn.get(o));
            })) : (E = $s(e, tn(n)), Ka(e, n, _, E, Dn.l(t, ie, sn(Mi), Te([Bn, sn(Iu), uv, s])), Qs(_) ? function(Ze, pn, xn) {
              return sn(xn);
            } : null));
          }
        } catch (Ze) {
          if (Ze instanceof Error) {
            var q = Ze;
            return ZU(e, q, function() {
              var pn = Dn.l(t, ie, sn(Mi), Te([Bn, sn(Iu), uv, s]));
              return it(function() {
                return null;
              }, pn);
            }());
          }
          throw Ze;
        }
      } else if (o instanceof de) {
        E = $s(e, tn(n));
        var me = Cn(E);
        switch (me) {
          case 1:
            var Ae = O.g(E, 0);
            return it(function(Ze, pn, xn) {
              return o.h(D(Ae, pn, xn));
            }, null);
          case 2:
            var Fe = O.g(E, 0), ln = O.g(E, 1);
            return it(function(Ze, pn, xn) {
              return o.g(D(Fe, pn, xn), D(ln, pn, xn));
            }, null);
          default:
            return Co(["Wrong number of args (", ye.h(me), ") passed to: ", ye.h(o)].join(""), n);
        }
      } else {
        h = nt.g ? nt.g(e, o) : nt.call(null, e, o), E = $s(e, tn(n));
        var Be = Dn.l(t, ie, sn(Mi), Te([Bn, sn(Iu)]));
        return Ka(e, n, h, E, Be, Qs(h) ? function(Ze, pn, xn) {
          return D(
            sn(xn),
            Ze,
            pn
          );
        } : function(Ze, pn, xn) {
          return D(xn, Ze, pn);
        });
      }
    } catch (Ze) {
      return q = Ze, ZU(e, q, it(function() {
        return null;
      }, uB(t, !1)));
    } finally {
      j(u) && Vm();
    }
  } finally {
    j(r) && (c1 = null);
  }
}, CG = function(e) {
  return 16 >= e ? ah : tr;
}, Bpe = function(e, n, t) {
  var l = CG(Cn(t));
  return Ka(e, n, l, t, null, null), Ka(e, n, l, t, null, null);
}, MG = function(e) {
  return !(e instanceof Ic);
}, Fpe = function(e, n, t) {
  e = ff(e);
  var l = lr.j(Dt, F4, n), r = $s(e, l), u = hu(MG, r);
  l = u ? on.g(l, r) : null, l = u ? j(l) ? n : function() {
    var h = CG(Cn(r));
    return In.g(h, r);
  }() : null;
  var o = u ? l : Bpe(e, n, r), a = j(t) ? nt.g ? nt.g(e, t) : nt.call(null, e, t) : null;
  return j(a) ? it(function(h, s, d) {
    return h = D(o, s, d), s = D(a, s, d), Bl(h, s);
  }, null) : o;
}, oq = function(e, n, t, l, r) {
  e = ff(e);
  var u = j(r) ? nt.g ? nt.g(e, r) : nt.call(null, e, r) : null;
  r = $s(e, l);
  var o = hu(MG, r), a = ug(l), h = o && on.g(a ? function() {
    var d = z(l);
    return d || Dt;
  }() : l, r);
  n = o ? h ? Ca(l) ? a ? ss : Dt : l : n.h ? n.h(r) : n.call(null, r) : null;
  var s = o ? n : Ka(e, l, t, r, null, null);
  return j(u) ? it(function(d, p, _) {
    return d = D(s, p, _), p = D(u, p, _), Bl(d, p);
  }, null) : s;
}, Vpe = function(e, n) {
  if (n = n.val, ci(n)) {
    var t = xi(n), l = bt.g(
      ml,
      t
    ), r = Ju(n), u = $s(e, r);
    return it(function(o, a, h) {
      return In.g(S2, Nu.g(l, bt.g(function(s) {
        return D(s, a, h);
      }, u)));
    }, null);
  }
  return r = $s(e, n), it(function(o, a, h) {
    var s = [];
    return UK(function(d) {
      return s.push(D(d, a, h));
    }, r), s;
  }, null);
}, Nl = function(e, n, t, l, r) {
  return t = new $(null, 3, [ie, j(t) ? t : Le, Zf, !0, Re, !0], null), r = j(r) ? gr.l(Te([t, r])) : t, eb(e, n, r, l);
}, Nd = function(e, n) {
  return PG(e, n, null, !1);
}, O_ = function(e, n, t) {
  return PG(e, n, t, !0);
}, PG = function(e, n, t, l) {
  return l = j(l) ? l : t === !0, t = new $(null, 2, [ie, t === !0 ? Le : j(t) ? t : Le, Re, !0], null), t = j(null) ? gr.l(Te([t, null])) : t, eb(e, n, t, l);
}, $G = function(e, n) {
  var t = In.j(lp, e, n);
  return kt(t, Ia.g(function(l) {
    return t === l;
  }, n));
}, PI = function(e, n) {
  return wt.j(function(t, l) {
    var r = O.j(l, 0, null);
    return l = O.j(l, 1, null), Ol(e, r) ? Dn.j(t, l, en.g(e, r)) : t;
  }, In.j(nr, e, xi(n)), n);
}, fB = function(e, n) {
  return wt.j(function(t, l) {
    var r = pg(l, n);
    return Dn.j(t, r, yt.g(en.j(t, r, ss), l));
  }, Tt, e);
}, LG = function(e) {
  return gu(Jf(function(n, t, l) {
    return ao.j(n, l, t);
  }, ou(Tt), e));
}, dB = function(e, n, t) {
  if (o2(t)) {
    var l = In.g(ue, bt.g(e, t));
    return n.h ? n.h(l) : n.call(null, l);
  }
  return Qd(t) ? (l = new yl(function() {
    var r = Xa(t);
    return e.h ? e.h(r) : e.call(null, r);
  }(), function() {
    var r = Cc(t);
    return e.h ? e.h(r) : e.call(null, r);
  }()), n.h ? n.h(l) : n.call(null, l)) : ei(t) ? (l = k1.h(bt.g(e, t)), n.h ? n.h(l) : n.call(null, l)) : Ap(t) ? (l = wt.j(function(r, u) {
    return yt.g(r, e.h ? e.h(u) : e.call(null, u));
  }, t, t), n.h ? n.h(l) : n.call(null, l)) : w1(t) ? (l = lr.g(O3(t), bt.g(e, t)), n.h ? n.h(l) : n.call(null, l)) : n.h ? n.h(t) : n.call(null, t);
}, BG = function(e, n) {
  return TE(function(t) {
    return Ol(e, t) ? e.h ? e.h(t) : e.call(null, t) : t;
  }, n);
}, Ype = function(e, n) {
  var t = Cn(e) - 1;
  on.g(2, t) || mu(["Wrong number of args (", ye.h(t), ") passed to: clojure.core/for"].join(""), e), or(n) || mu("for requires a vector for its binding", e), qc(Cn(n)) || mu("for requires an even number of forms in binding vector", e);
}, H3 = function(e) {
  return W3(e, null, new $(null, 2, [ie, Le, Re, !0], null));
}, aq = function(e) {
  var n = Vt(e);
  if (j(n)) {
    if (j(Gee.h(n))) return _n.h(ye.h(sn(e)));
    if (e = te.h(n), j(e)) return n = ie.h(n), j(n) ? _n.g(ye.h(Jo(n)), ye.h(e)) : null;
  }
  return null;
}, Upe = function(e, n) {
  var t = sn(Or.h(e)), l = function() {
    var d = Yi(n);
    return j(d) ? _n.h(d) : null;
  }(), r = Vs(), u = ye.h(r), o = en.g(t, Il), a = en.g(o, r), h = Vc.h(a), s = function d(p) {
    var _ = ml(p), R = function() {
      var F = ta.h(a);
      return j(F) ? (F = en.g(F, p), j(F) ? aq(F) : null) : null;
    }();
    return j(R) || (R = function() {
      var F = en.g(a, p);
      return j(F) ? aq(F) : null;
    }(), j(R)) || (R = Ol(en.g(o, ks), p) && er(function() {
      var F = a == null ? null : Gf.h(a);
      return F = F == null ? null : en.g(F, ks), F = F == null ? null : By.h(F), F == null ? null : Ol(F, p);
    }()) || Ol(u4, p) ? _n.g("clojure.core", _) : null, j(R)) ? R : (R = npe(e, p), j(R) ? R : _.indexOf(".") != -1 ? _.lastIndexOf(".", 0) != 0 && g1(_, ".") ? _n.h([ye.h(d(_n.h(Si.j(_, 0, _.length - 1)))), "."].join("")) : p : _n.g(u, _));
  };
  return er(l) ? s(n) : function() {
    var d = en.g(t, Il);
    if (j(en.g(d, l))) return n;
    var p = en.g(h, l);
    return j(p) ? _n.g(ye.h(p), ml(n)) : (d = en.g(po.h(en.g(d, r)), l), j(d) ? _n.g(ye.h(d), ml(n)) : n);
  }();
}, qpe = function() {
  throw Yr.g("EvalReader not allowed when *read-eval* is false.", new $(null, 1, [zi, Vx], null));
}, Wpe = function(e, n) {
  return n = AB.h(n), j(n) ? n : (e = Or.h(e), n = sn(e), e = Vs(), n = xr.g(n, new v(null, 2, 5, y, [Il, e], null)), n = Vc.h(n), Dn.j(n, i5, e));
}, z3 = function(e, n, t) {
  var l = u1.h(e), r = of.h(e), u = Qs(r) ? sn(r) : r, o = Wpe(e, t), a = function() {
    var h = Dn.l(b3e, u1, l, Te([AB, o, ba, new $(null, 1, [yX, function(s) {
      return Upe(e, s);
    }], null), of, function(s) {
      var d = j(u) ? u.h ? u.h(s) : u.call(null, s) : u;
      if (j(d) || (d = function() {
        var _ = sn(Kne);
        return _.h ? _.h(s) : _.call(null, s);
      }(), j(d)) || (d = function() {
        var _ = sn(xg);
        return _ = _.j ? _.j(e, Tt, s) : _.call(null, e, Tt, s), _ = _ == null ? null : Vt(_), _ == null ? null : xX.h(_);
      }(), j(d))) return d;
      var p = sn(Gne);
      return j(p) ? function(_) {
        return p.g ? p.g(s, _) : p.call(null, s, _);
      } : null;
    }, wh, j(sn(zne)) ? function(s) {
      return NI(e, s);
    } : qpe]));
    return j(t) ? gr.l(Te([h, t])) : h;
  }();
  return function() {
    try {
      n instanceof YL && l1.h(sn(n.frames)).clear();
      var h = mr(a, n);
      if (up === h)
        var s = en.g(a, qf), d = j(s) ? s : lH;
      else d = h;
      return Ln(d, lH) ? yb : d instanceof T && Pc(n) ? wu.T(d, Dn, Yn, Lm(n), zn, Bm(n) - ye.h(d).length) : d;
    } catch (p) {
      throw p instanceof ld ? (d = p, Yr.j(d.message, Dn.l(ax(d), zi, Vx, Te([jx, "parse", Bn, sn(Iu)])), d)) : p;
    }
  }();
}, FG = function(e, n) {
  if (Ln(yb, n)) {
    if (n = qf.h(e), j(n)) {
      if (Ln(l_e, n)) throw Yr.g("EOF while reading", new $(null, 2, [zi, Vx, OR, e], null));
      return n;
    }
    throw Yr.g("EOF while reading", new $(null, 2, [zi, Vx, OR, e], null));
  }
  return n;
}, tc = function(e) {
  return e.Jc(null);
}, VG = function(e, n) {
  return J4(Or.h(e), n, !1, null);
}, $c = function(e, n) {
  if (n instanceof q3) return n;
  if (e = VG(e, n), j(e)) return e;
  throw Error(["No namespace: ", ye.h(n), " found"].join(""));
}, YG = function(e, n) {
  return n = $c(e, n), n = tc(n), e = xr.g(sn(Or.h(e)), new v(null, 3, 5, y, [
    Il,
    n,
    Vc
  ], null)), _a(xi(e), bt.g(function(t) {
    return oc(t, null);
  }, Ju(e)));
}, pB = function(e) {
  return nr.l(e, Vc, Te([po, Go, Gf, ta]));
}, $I = function(e, n) {
  return n = $c(e, n), n = tc(n), e = xr.g(sn(Or.h(e)), new v(null, 2, 5, y, [Il, n], null)), pB(e);
}, LI = function(e, n) {
  return n = $c(e, n), n = tc(n), e = xr.g(sn(Or.h(e)), new v(null, 2, 5, y, [Il, n], null)), e = pB(e), lr.g(Tt, Tf.g(function(t) {
    var l = O.j(t, 0, null);
    return t = O.j(t, 1, null), j(kh.h(Vt(t))) ? null : new v(null, 2, 5, y, [l, t], null);
  }, e));
}, cq = function(e, n) {
  n = $c(e, n), n = tc(n);
  var t = sn(Or.h(e));
  e = po.h(t), n = xr.g(t, new v(null, 3, 5, y, [Il, n, po], null));
  var l = Hf.h(t);
  return t = he.g(xi(e), xi(n)), e = he.g(Ju(e), Ju(n)), _a(t, bt.g(ua.g(gh, function(r) {
    return en.g(l, r);
  }), e));
}, UG = function(e, n) {
  n = $c(e, n), n = tc(n);
  var t = sn(Or.h(e));
  return e = xr.g(t, new v(null, 3, 5, y, [Il, n, ta], null)), n = xr.g(t, new v(null, 2, 5, y, [Il, ks], null)), n = pB(n), gr.l(Te([n, e]));
}, gE = function(e) {
  var n = Or.h(e);
  return e = en.g(sn(n), Il), e = Ia.g(function(t) {
    return O.j(t, 0, null), t = O.j(t, 1, null), kh.h(t);
  }, e), bt.g(function(t) {
    return J4(n, t, !0, null);
  }, xi(e));
}, qG = function(e) {
  return new v2(e, null, null);
}, kA = function(e) {
  var n = ne.h(e), t = ee.h(e), l = Zf.h(e);
  Sf.l(Te(["-------------------------"]));
  var r = Sf.l, u = ie.h(e);
  return u = j(u) ? [ye.h(tc(u)), "/"].join("") : null, r.call(Sf, Te([[u, ye.h(te.h(e))].join("")])), j(n) && Sf.l(Te([n])), j(l) && Sf.l(Te(["Macro"])), j(t) ? Sf.l(Te([" ", t])) : null;
}, WG = function(e, n, t) {
  return BG(_a(e, t), n);
}, Hpe = function(e, n, t, l, r, u, o, a, h, s, d) {
  wr.g(e, function(p) {
    var _ = Il.h(p), R = n5.l(gr, Te([j(_) ? _ : nte, j(_) ? null : new $(null, 1, [R0, Dn.j(n, Go, qne)], null), l])), F = gr.l(Te([
      t,
      xr.g(p, new v(null, 3, 5, y, [Il, R0, Vc], null))
    ])), L = Ri.l;
    return R = Ri.I(R, R0, Dn, Vc, F), F = Hc(zN, Y4(), new $(null, 1, [ie, Le], null)), _ = he.g(xi(_), yEe), _ = W3(Lk, kr.h(lr.g(t5(), _)), new $(null, 4, [ee, "A ref to a sorted set of symbols representing loaded libs", ie, Le, kh, !0, Re, !0], null)), L = L.call(Ri, R, ks, Dn, zN, F, Lk, Te([_])), _ = po.h(p), _ = j(_) ? gr.l(Te([_, o])) : o, R = gr.l(Te([Bx.h(p), d])), F = gr.l(Te([kx.h(p), s])), er(p) ? new $(null, 4, [Il, L, po, _, Ox, a, M8, h], null) : Dn.l(p, Il, L, Te([po, _, Ox, a, M8, h, kx, F, Ix, Ix.h(r), Hf, Hf.h(r), H8, u, Bx, R]));
  });
}, hq = function(e) {
  return Fo(lr.j(ss, ua.g(F4, bt.h(OG)), e));
}, zpe = function() {
  return null;
}, HG = function(e) {
  var n = fr(e);
  e = en.g(n, u1);
  var t = en.g(n, Il), l = en.g(n, Bx), r = en.g(n, kx), u = en.g(n, Ws), o = en.g(n, of), a = en.g(n, Pq), h = en.g(n, Or), s = en.g(n, po), d = en.g(n, Ew), p = en.g(n, Ox), _ = en.g(n, M8), R = en.g(n, Vc), F = en.g(n, qk), L = en.g(n, sH);
  n = en.g(n, yve), h = j(h) ? h : kr.h(Tt), s = gr.l(Te([Tt, s])), l = gr.l(Te([xEe, l])), n = gr.l(Te([_Ee, n]));
  var G;
  e: {
    var J = ou(pg(n, new v(null, 1, 5, y, [Ew], null)));
    for (G = n; ; ) {
      var we = I(G);
      if (j(we)) {
        var ce = we;
        if (we = O.j(ce, 0, null), ce = O.j(ce, 1, null), ci(ce)) {
          var xe = u6.h(ce);
          J = j(xe) ? ao.j(ao.j(J, we, ce), u6, Dn.j(u6.h(J), ye.h(we), xe)) : ao.j(J, we, ce);
        } else J = ao.j(J, we, new $(null, 1, [gh, ce], null));
        G = tn(G);
      } else {
        G = new $(null, 2, [Ix, Ix.h(n), Hf, gu(J)], null);
        break e;
      }
    }
  }
  return Hpe(h, u, R, t, G, n, s, p, _, r, l), Dn.l(new $(null, 5, [Ws, Tt, Or, h, u1, e, of, o, nF, j(d) ? d : F], null), Ew, j(d) ? hq(Te([d])) : null, Te([qk, j(F) ? hq(Te([F])) : null, Pq, j(a) ? a : zpe, sH, L]));
}, zG = function(e, n) {
  var t = rs;
  rs = !0;
  try {
    ud.g(e, n);
  } finally {
    rs = t;
  }
}, Kpe = function() {
  var e = sn(xF);
  return Ri.j(e, Or, function(n) {
    return kr.h(sn(n));
  });
}, fq = function(e, n) {
  var t = e >>> 28, l = n >>> 28;
  return t < l || t === l && (e & 268435455) < (n & 268435455);
}, Pv = function(e) {
  return Math.sin(e);
}, $v = function(e) {
  return Math.cos(e);
}, Lv = function(e) {
  return Math.tan(e);
}, Bv = function(e) {
  return Math.asin(e);
}, Fv = function(e) {
  return Math.acos(e);
}, Vv = function(e) {
  return Math.atan(e);
}, Yv = function(e) {
  return 0.017453292519943295 * e;
}, Uv = function(e) {
  return 57.29577951308232 * e;
}, qv = function(e) {
  return Math.exp(e);
}, Wv = function(e) {
  return Math.log(e);
}, Hv = function(e) {
  return Math.log10(e);
}, zv = function(e) {
  return Math.sqrt(e);
}, Kv = function(e) {
  return Math.cbrt(e);
}, dq = function(e, n) {
  if (1048576 > e) {
    var t = e === 0, l = t ? -1043 : -1022;
    for (e = t ? n : e << 11; ; ) if (0 < e) e <<= 1, --l;
    else return l;
  } else return (e >> 20) - 1023;
}, pq = function(e, n, t) {
  return -1022 <= e ? new v(null, 2, 5, y, [1048576 | 1048575 & n, t], null) : (e = -1022 - e, 31 >= e ? new v(null, 2, 5, y, [n << e | t >>> 32 - e, t << e], null) : new v(null, 2, 5, y, [t << e - 32, 0], null));
}, Gpe = function(e, n) {
  if (n === 0 || isNaN(n) || !isFinite(e)) return NaN;
  var t = new ArrayBuffer(16), l = new Float64Array(t);
  t = new Uint32Array(t), l[0] = e, l[1] = n;
  var r = t[bD], u = t[TD], o = t[bEe];
  n = r & 2147483648, r &= 2147483647;
  var a = t[kEe] & 2147483647, h = r <= a;
  if (h && (r < a || u < o)) return e;
  if (h && u === o) return a4[n >>> 31];
  try {
    var s = dq(r, u), d = dq(a, o), p = pq(s, r, u), _ = O.j(p, 0, null), R = O.j(p, 1, null), F = pq(d, a, o), L = O.j(F, 0, null), G = O.j(F, 1, null), J = function() {
      for (var Ye = s - d, B = _, q = R; ; ) {
        if (Ye === 0) return new v(null, 2, 5, y, [B, q], null);
        var me = fq(q, G) ? B - L - 1 : B - L, Ae = q - G;
        if (0 > me) B = new v(null, 2, 5, y, [B + B + (q >>> 31), q + q], null);
        else {
          if (!(me | Ae)) throw Yr.g("Signed zero", new $(
            null,
            1,
            [AW, !0],
            null
          ));
          B = new v(null, 2, 5, y, [me + me + (Ae >>> 31), Ae + Ae], null);
        }
        q = B, B = O.j(q, 0, null), q = O.j(q, 1, null), B &= 4294967295, q &= 4294967295, --Ye;
      }
    }(), we = O.j(J, 0, null), ce = O.j(J, 1, null), xe = fq(ce, G) ? we - L - 1 : we - L, $e = 0 <= xe ? new v(null, 2, 5, y, [xe, ce - G], null) : new v(null, 2, 5, y, [we, ce], null), je = O.j($e, 0, null), E = O.j($e, 1, null);
    if (!(je | E)) throw Yr.g("Signed zero", new $(null, 1, [AW, !0], null));
    var P = function() {
      for (var Ye = je, B = E, q = d; ; ) if (1048576 > Ye) {
        var me = B + B;
        --q, Ye = Ye + Ye + (B >>> 31), B = me;
      } else return new v(
        null,
        3,
        5,
        y,
        [Ye, B, q],
        null
      );
    }(), K = O.j(P, 0, null), H = O.j(P, 1, null), U = O.j(P, 2, null);
    if (-1022 <= U) return t[bD] = K - 1048576 | U + 1023 << 20 | n, t[TD] = H, l[0];
    e = -1022 - U;
    var Me = 20 >= e ? new v(null, 2, 5, y, [K >> e, H >>> e | K << 32 - e], null) : 31 >= e ? new v(null, 2, 5, y, [n, K << 32 - e | H >>> e], null) : new v(null, 2, 5, y, [n, K >> e - 32], null), le = O.j(Me, 0, null), Ce = O.j(Me, 1, null);
    return t[bD] = le | n, t[TD] = Ce, 1 * l[0];
  } catch {
    return a4[n >>> 31];
  }
}, Gv = function(e, n) {
  if (n === 0 || isNaN(n) || isNaN(e)) return NaN;
  if (isFinite(e)) {
    if (isFinite(n)) {
      var t = new ArrayBuffer(16), l = new Float64Array(t);
      t = new Uint32Array(t), l[0] = e, l[1] = n;
      var r = t[wa], u = t[Tc], o = t[Tc + 2], a = r & 2147483648, h = t[wa + 2] & 2147483647;
      if (r &= 2147483647, e = 2145386495 >= h ? Gpe(e, n + n) : e, !(r - h | u - o)) return 0 * e;
      var s = Math.abs(e), d = Math.abs(n);
      return l[0] = 2097152 > h ? s + s > d ? function() {
        var p = s - d;
        return p + p >= d ? p - d : p;
      }() : s : function() {
        var p = 0.5 * d;
        if (s > p) {
          var _ = s - d;
          return _ >= p ? _ - d : _;
        }
        return s;
      }(), t[wa] ^= a, l[0];
    }
    return e;
  }
  return NaN;
}, Zv = function(e) {
  if (e != null) return Math.ceil(e);
  throw Yr.g("Unexpected Null passed to ceil", new $(
    null,
    1,
    [qs, "ceil"],
    null
  ));
}, Df = function(e) {
  if (e != null) return Math.floor(e);
  throw Yr.g("Unexpected Null passed to floor", new $(null, 1, [qs, "floor"], null));
}, xm = function(e, n) {
  var t = new ArrayBuffer(16), l = new Float64Array(t);
  t = new Uint8Array(t);
  var r = uj ? 7 : 0;
  return l[0] = e, l[1] = n, t[r] = 128 & t[8 + r] | 127 & t[r], l[0];
}, Xv = function(e) {
  var n = xm(1, e);
  return e = Math.abs(e), n * (4503599627370496 > e ? 4503599627370496 + e - 4503599627370496 : e);
}, Qv = function(e, n) {
  return Math.atan2(e, n);
}, Jv = function(e, n) {
  return Math.pow(e, n);
}, e0 = function(e) {
  return isNaN(e) ? 0 : isFinite(e) ? Math.round(e) : e === 1 / 0 ? Number.MAX_SAFE_INTEGER : Number.MIN_SAFE_INTEGER;
}, n0 = function() {
  return Math.random();
}, t0 = function(e, n) {
  if (e += n, e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) throw Yr.g("Integer overflow", new $(null, 1, [qs, "add-exact"], null));
  return e;
}, l0 = function(e, n) {
  if (e -= n, e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) throw Yr.g("Integer overflow", new $(null, 1, [qs, "subtract-exact"], null));
  return e;
}, r0 = function(e, n) {
  if (e *= n, e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) throw Yr.g(
    "Integer overflow",
    new $(null, 1, [qs, "multiply-exact"], null)
  );
  return e;
}, i0 = function(e) {
  if (e >= Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) throw Yr.g("Integer overflow", new $(null, 1, [qs, "increment-exact"], null));
  return e + 1;
}, u0 = function(e) {
  if (e <= Number.MIN_SAFE_INTEGER || e > Number.MAX_SAFE_INTEGER) throw Yr.g("Integer overflow", new $(null, 1, [qs, "decrement-exact"], null));
  return e - 1;
}, s0 = function(e) {
  if (e > Number.MAX_SAFE_INTEGER || e < Number.MIN_SAFE_INTEGER) throw Yr.g("Integer overflow", new $(null, 1, [qs, "negate-exact"], null));
  return -e;
}, o0 = function(e, n) {
  if (Number.isSafeInteger(e) && Number.isSafeInteger(n)) {
    var t = s2(e / n), l = 0 > e, r = 0 > n;
    return (l && !r || !l && r) && t * n !== e ? t - 1 : t;
  }
  throw Yr.g("floor-div called with non-safe-integer arguments", new $(null, 2, [VJ, Number.isSafeInteger(e), RZ, Number.isSafeInteger(n)], null));
}, a0 = function(e, n) {
  if (Number.isSafeInteger(e) && Number.isSafeInteger(n)) {
    var t = s2(e / n), l = 0 > e, r = 0 > n;
    return (l && !r || !l && r) && t * n !== e ? e - n * t - -n : e - n * t;
  }
  throw Yr.g("floor-mod called with non-safe-integer arguments", new $(null, 2, [
    VJ,
    Number.isSafeInteger(e),
    RZ,
    Number.isSafeInteger(n)
  ], null));
}, mw = function(e) {
  if (isNaN(e) || !isFinite(e)) return 1024;
  if (e === 0) return -1023;
  var n = new ArrayBuffer(8), t = new Float64Array(n);
  n = new Uint32Array(n);
  var l = uj ? 1 : 0;
  return t[0] = e, ((n[l] & 2146435072) >> 20) - 1023;
}, c0 = function(e, n) {
  var t = new ArrayBuffer(8), l = new Float64Array(t);
  return t = new Uint32Array(t), t[Tc] = n, t[wa] = e, l[0];
}, h0 = function(e) {
  if (isNaN(e)) return e;
  if (isFinite(e)) {
    var n = mw(e);
    switch (n) {
      case 1024:
        return Math.abs(e);
      case -1023:
        return Number.MIN_VALUE;
      default:
        return e = n - 52, -1022 <= e ? c0(e + 1023 << 20 & 2146435072, 0) : (e -= -1074, 32 > e ? c0(0, 1 << e) : c0(1 << e - 32, 0));
    }
  } else return 1 / 0;
}, f0 = function(e) {
  return e === 0 || isNaN(e) ? e : xm(1, e);
}, d0 = function(e) {
  return Math.sinh(e);
}, p0 = function(e) {
  return Math.cosh(e);
}, m0 = function(e) {
  return Math.tanh(e);
}, g0 = function(e, n) {
  return Math.hypot(e, n);
}, w0 = function(e) {
  return Math.expm1(e);
}, v0 = function(e) {
  return Math.log1p(e);
}, pm = function(e, n, t, l) {
  var r = (2147483647 & n) + (2147483647 & l);
  return n = ((n & 2147483648) >>> 31) + ((l & 2147483648) >>> 31) + ((r & 2147483648) >>> 31), new v(null, 2, 5, y, [4294967295 & e + t + (n >> 1), r & 2147483647 | n << 31], null);
}, y0 = function(e, n) {
  var t = new ArrayBuffer(8), l = new Float64Array(t);
  return t = new Uint32Array(t), e > n ? e !== 0 ? (l[0] = e, e = t[wa], n = t[Tc], n = e & 2147483648 ? pm(e, n, 0, 1) : pm(e, n, 4294967295, 4294967295), e = O.j(n, 0, null), n = O.j(n, 1, null), t[wa] = e, t[Tc] = n, l[0]) : -Number.MIN_VALUE : e < n ? (l[0] = e + 0, e = t[wa], n = t[Tc], n = e & 2147483648 ? pm(e, n, 4294967295, 4294967295) : pm(e, n, 0, 1), e = O.j(n, 0, null), n = O.j(n, 1, null), t[wa] = e, t[Tc] = n, l[0]) : e === n ? n : e + n;
}, _0 = function(e) {
  if (e < Number.POSITIVE_INFINITY) {
    var n = new ArrayBuffer(8), t = new Float64Array(n);
    n = new Uint32Array(n), t[0] = e + 0, e = n[wa];
    var l = n[Tc];
    return l = e & 2147483648 ? pm(e, l, 4294967295, 4294967295) : pm(e, l, 0, 1), e = O.j(l, 0, null), l = O.j(l, 1, null), n[wa] = e, n[Tc] = l, t[0];
  }
  return e;
}, x0 = function(e) {
  if (isNaN(e) || e === -1 / 0) return e;
  if (e === 0) return -Number.MIN_VALUE;
  var n = new ArrayBuffer(8), t = new Float64Array(n);
  n = new Uint32Array(n), t[0] = e;
  var l = n[wa], r = n[Tc];
  return l = 0 < e ? pm(l, r, 4294967295, 4294967295) : pm(l, r, 0, 1), e = O.j(l, 0, null), l = O.j(l, 1, null), n[wa] = e, n[Tc] = l, t[0];
}, S0 = function(e, n) {
  var t = 0 > n ? new v(null, 3, 5, y, [Math.max(n, -2099), -512, jEe], null) : new v(null, 3, 5, y, [Math.min(n, 2099), 512, TEe], null), l = O.j(t, 0, null);
  n = O.j(t, 1, null), t = O.j(t, 2, null);
  var r = l >> 8 >>> 23;
  for (r = (l + r & 511) - r, e *= c0(r + 1023 << 20 & 2146435072, 0), l -= r; ; ) {
    if (l === 0) return e;
    l -= n, e *= t;
  }
}, ef = function(e, n) {
  const t = Array.prototype.slice.call(arguments), l = t.shift();
  if (typeof l > "u") throw Error("[goog.string.format] Template required");
  return l.replace(/%([0\- \+]*)(\d+)?(\.(\d+))?([%sfdiu])/g, function(r, u, o, a, h, s, d, p) {
    if (s == "%") return "%";
    const _ = t.shift();
    if (typeof _ > "u") throw Error("[goog.string.format] Not enough arguments");
    return arguments[0] = _, ef.$b[s].apply(null, arguments);
  });
}, KG = function(e, n) {
  switch (n) {
    case 1:
      return e % 4 != 0 || e % 100 == 0 && e % 400 != 0 ? 28 : 29;
    case 5:
    case 8:
    case 10:
    case 3:
      return 30;
  }
  return 31;
}, GG = function(e, n, t) {
  return e = new Date(e, n, t), e = e.valueOf() + 864e5 * (3 - ((e.getDay() + 6) % 7 + 7) % 7), Math.floor(Math.round((e - new Date(new Date(e).getFullYear(), 0, 1).valueOf()) / 864e5) / 7) + 1;
}, lc = function(e, n, t, l, r, u) {
  typeof e == "string" ? (this.years = e == ute ? n : 0, this.months = e == ste ? n : 0, this.days = e == vF ? n : 0, this.xa = e == ote ? n : 0, this.ya = e == yF ? n : 0, this.seconds = e == _F ? n : 0) : (this.years = e || 0, this.months = n || 0, this.days = t || 0, this.xa = l || 0, this.ya = r || 0, this.seconds = u || 0);
}, zc = function(e, n, t) {
  typeof e == "number" ? (this.date = mq(e, n || 0, t || 1), wE(this, t || 1)) : (n = typeof e, n == "object" && e != null || n == "function" ? (this.date = mq(
    e.getFullYear(),
    e.getMonth(),
    e.getDate()
  ), wE(this, e.getDate())) : (this.date = new Date(Date.now()), e = this.date.getDate(), this.date.setHours(0), this.date.setMinutes(0), this.date.setSeconds(0), this.date.setMilliseconds(0), wE(this, e)));
}, mq = function(e, n, t) {
  return n = new Date(e, n, t), 0 <= e && 100 > e && n.setFullYear(n.getFullYear() - 1900), n;
}, gq = function(e) {
  var n = e.getDate(), t = e.getFullYear();
  for (e = e.getMonth() - 1; 0 <= e; e--) n += KG(t, e);
  return n;
}, wE = function(e, n) {
  e.getDate() != n && e.date.setUTCHours(e.date.getUTCHours() + (e.getDate() < n ? 1 : -1));
}, Tu = function(e, n, t, l, r, u, o) {
  this.date = typeof e == "number" ? new Date(e, n || 0, t || 1, l || 0, r || 0, u || 0, o || 0) : new Date(e && e.getTime ? e.getTime() : Date.now());
}, tp = function(e) {
  for (var n = [], t = arguments.length, l = 0; l < t; ) n.push(arguments[l]), l += 1;
  return gw(0 < n.length ? new hn(n.slice(0), 0, null) : null);
}, gw = function(e) {
  return hu(function(n) {
    return n instanceof zc;
  }, e) ? In.g(on, bt.g(function(n) {
    return n.getTime();
  }, e)) : In.g(on, e);
}, ZG = function(e) {
  return ya(e, 400) === 0 ? !0 : ya(e, 100) === 0 ? !1 : ya(e, 4) === 0;
}, XG = function(e) {
  return e = j(gw(Te([
    e,
    1
  ]))) ? 11 : e - 1, jD.h ? jD.h(e) : jD.call(null, e);
}, Zpe = function(e, n) {
  var t = XG(n);
  return n = (e = ZG(e)) ? gw(Te([n, 2])) : e, j(n) ? t + 1 : t;
}, Xpe = function(e) {
  e = fr(e);
  var n = en.g(e, Lo), t = en.g(e, yo), l = en.g(e, Nx), r = en.g(e, ls), u = en.g(e, $i), o = en.g(e, _w), a = en.g(e, Bo), h = en.g(e, a1), s = en.g(e, _o), d = en.g(e, Zo), p = j(r) ? 1 <= r && 12 >= r : null, _ = j(d) ? j(r) ? j(p) ? Zpe(d, r) : p : r : j(r) ? j(p) ? XG(r) : p : r, R = j(u) ? j(_) ? 1 <= u && u <= _ : 1 <= u && 31 >= u : null, F = j(s) ? 0 <= s && 23 >= s : null, L = j(n) ? 0 <= n && 59 >= n : null, G = j(a) ? 0 <= a && 60 >= a : null, J = j(t) ? 0 <= t && 999 >= t : null, we = j(h) ? 1 <= h && 53 >= h : null, ce = j(l) ? 1 <= l && 7 >= l : null;
  if (hu(dK, Ia.g(dy, new v(null, 8, 5, y, [p, R, F, L, G, J, we, ce], null)))) {
    if (er(function() {
      var xe = j(d) ? d : j(r) ? r : u;
      return j(xe) ? j(o) ? o : j(h) ? h : l : xe;
    }())) return e;
    throw Yr.g("Mixing year, month, day and week-year week-number fields", new $(null, 3, [zi, OH, hr, e, sW, Tt], null));
  }
  throw Yr.g("Date is not valid", new $(null, 3, [zi, OH, hr, e, sW, function() {
    var xe = p === !1 ? Dn.j(Tt, ls, r) : Tt;
    return xe = R === !1 ? Dn.j(xe, $i, u) : xe, xe = F === !1 ? Dn.j(xe, _o, s) : xe, xe = L === !1 ? Dn.j(xe, Lo, n) : xe, xe = G === !1 ? Dn.j(xe, Bo, a) : xe, xe = J === !1 ? Dn.j(xe, yo, t) : xe, xe = we === !1 ? Dn.j(xe, a1, h) : xe, ce === !1 ? Dn.j(xe, Nx, l) : xe;
  }()], null));
}, Qpe = function(e, n) {
  return I(O2.g(function(t, l) {
    return j(gw(Te([l, n]))) ? t : null;
  }, e));
}, QG = function(e, n) {
  return n = bt.g(function(t) {
    return t instanceof de || t instanceof T ? ye.h(t) : t;
  }, n), In.j(ef, e, n);
}, Oh = function(e, n, t, l, r, u, o) {
  e = typeof e == "number" ? Date.UTC(e, n || 0, t || 1, l || 0, r || 0, u || 0, o || 0) : e ? e.getTime() : Date.now(), this.date = new Date(e);
}, P_ = function(e) {
  var n = new Oh();
  return n.setTime(e), n;
}, zw = function(e) {
  if (e != null && e.md != null) e = e.md(e);
  else {
    var n = zw[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = zw._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("DateTimeProtocol.year", e);
  }
  return e;
}, yk = function() {
  var e = nb();
  if (e != null && e.kd != null) e = e.kd(e);
  else {
    var n = yk[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = yk._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("DateTimeProtocol.month", e);
  }
  return e;
}, no = function(e) {
  if (e != null && e.fd != null) e = e.fd(e);
  else {
    var n = no[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = no._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("DateTimeProtocol.day-of-week", e);
  }
  return e;
}, Ty = function(e, n) {
  if (e != null && e.gd != null) e = e.gd(e, n);
  else {
    var t = Ty[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = Ty._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("DateTimeProtocol.equal?", e);
  }
  return e;
}, vx = function(e, n) {
  if (e != null && e.dd != null) e = e.dd(e, n);
  else {
    var t = vx[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = vx._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("DateTimeProtocol.after?", e);
  }
  return e;
}, yx = function(e, n) {
  if (e != null && e.ed != null) e = e.ed(e, n);
  else {
    var t = yx[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = yx._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("DateTimeProtocol.before?", e);
  }
  return e;
}, Kw = function(e, n) {
  if (e != null && e.ld != null) e = e.ld(e, n);
  else {
    var t = Kw[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = Kw._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("DateTimeProtocol.plus-", e);
  }
  return e;
}, jy = function(e, n) {
  if (e != null && e.jd != null) e = e.jd(e, n);
  else {
    var t = jy[$t(e ?? null)];
    if (t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else if (t = jy._, t != null) e = t.g ? t.g(e, n) : t.call(null, e, n);
    else throw Ut("DateTimeProtocol.minus-", e);
  }
  return e;
}, Ay = function(e) {
  if (e != null && e.hd != null) e = e.hd(e);
  else {
    var n = Ay[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Ay._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("DateTimeProtocol.last-day-of-the-month-", e);
  }
  return e;
}, _k = function(e) {
  if (e != null && e.Kd != null) e = e.Kd(e);
  else {
    var n = _k[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = _k._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("InTimeUnitProtocol.in-millis", e);
  }
  return e;
}, xk = function(e) {
  if (e != null && e.Md != null) e = e.Md(e);
  else {
    var n = xk[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = xk._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut(
      "InTimeUnitProtocol.in-seconds",
      e
    );
  }
  return e;
}, Sk = function(e) {
  if (e != null && e.Ld != null) e = e.Ld(e);
  else {
    var n = Sk[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Sk._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("InTimeUnitProtocol.in-minutes", e);
  }
  return e;
}, Ek = function(e) {
  if (e != null && e.Jd != null) e = e.Jd(e);
  else {
    var n = Ek[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Ek._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("InTimeUnitProtocol.in-hours", e);
  }
  return e;
}, Dy = function(e) {
  if (e != null && e.Id != null) e = e.Id(e);
  else {
    var n = Dy[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Dy._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("InTimeUnitProtocol.in-days", e);
  }
  return e;
}, qh = function(e, n, t, l, r) {
  this.start = e, this.end = n, this.K = t, this.F = l, this.H = r, this.C = 2230716170, this.J = 139264;
}, Ha = function(e, n, t, l, r, u, o, a, h, s, d) {
  this.years = e, this.months = n, this.pb = t, this.days = l, this.xa = r, this.ya = u, this.seconds = o, this.millis = a, this.K = h, this.F = s, this.H = d, this.C = 2230716170, this.J = 139264;
}, gg = function(e, n) {
  return e = Qu([e, n]), n = nr.l(e, Zo, Te([ls, uf, $i, _o, Lo, Bo, yo])), n = Ap(e) ? lr.g(Tt, n) : n, new Ha(Zo.h(e), ls.h(e), uf.h(e), $i.h(e), _o.h(e), Lo.h(e), Bo.h(e), yo.h(e), null, Fo(n), null);
}, x2 = function(e) {
  return function(n, t) {
    function l(p, _, R) {
      return j(j(_) ? R : _) ? new lc(_, p.g ? p.g(0, R) : p.call(null, 0, R)) : null;
    }
    t = t.clone();
    for (var r = z(e), u = null, o = 0, a = 0; ; ) if (a < o) {
      var h = u.Y(null, a), s = O.j(h, 0, null);
      h = O.j(h, 1, null);
      var d = wv.h ? wv.h(s) : wv.call(null, s);
      j(d) ? (h = l(n, d, h), j(h) && t.add(h)) : (s = gv.h ? gv.h(s) : gv.call(
        null,
        s
      ), j(s) && (s.j ? s.j(t, n, h) : s.call(null, t, n, h))), a += 1;
    } else if (r = z(r)) oi(r) ? (o = Jr(r), r = Wr(r), u = o, o = Cn(o)) : (u = I(r), o = O.j(u, 0, null), u = O.j(u, 1, null), a = wv.h ? wv.h(o) : wv.call(null, o), j(a) ? (u = l(n, a, u), j(u) && t.add(u)) : (o = gv.h ? gv.h(o) : gv.call(null, o), j(o) && (o.j ? o.j(t, n, u) : o.call(null, t, n, u))), r = W(r), u = null, o = 0), a = 0;
    else break;
    return t;
  };
}, JG = function(e, n) {
  var t = e.getYear(), l = n.getYear();
  return e = gq(e), n = gq(n), xa.g(t, l) ? t - l : xa.g(e, n) ? e - n : 0;
}, eZ = function() {
  return new Oh().getTime();
}, nb = function() {
  var e = new Oh();
  return e.setTime(eZ.call(null)), e;
}, nZ = function() {
  var e = new Tu();
  return e.setTime(eZ.call(null)), e;
}, ea = function(e) {
  return gg($i, e);
}, Gw = function(e, n) {
  return jy(e, n);
}, wq = function(e) {
  e = x3(ml(e));
  var n = ml(yo);
  throw Yr.g(QG("%s cannot be converted to %s", Te([e, n])), new $(null, 1, [zi, M_e], null));
}, tZ = function() {
  var e = nb();
  return e.setHours(0), e.setMinutes(0), e.setSeconds(0), e.setMilliseconds(0), e;
}, lZ = function(e, n) {
  return F3(typeof e == "string" ? e : Ja.h(e), n, "");
}, BI = function(e) {
  return new v(null, 2, 5, y, [Eb, e], null);
}, K3 = function(e, n) {
  var t = z(n);
  for (I(t), W(t), t = Dt; ; ) {
    var l = n, r = z(l);
    n = I(r), r = W(r);
    var u = n;
    if (u = j(u) ? e.h ? e.h(n) : e.call(null, n) : u, j(u)) t = yt.g(t, n), n = r;
    else return new v(null, 2, 5, y, [t, l], null);
  }
}, Jpe = function(e, n) {
  var t = K3(Rp([e]), n);
  return n = O.j(t, 0, null), t = O.j(t, 1, null), new v(null, 2, 5, y, [new v(null, 2, 5, y, [SB, In.j(ye, e, n)], null), t], null);
}, eme = function(e, n) {
  var t = z(n);
  return e = I(t), t = W(t), on.g(e, "'") ? new v(null, 2, 5, y, [BI("'"), t], null) : (e = K3(Dp(new gi(null, new $(null, 1, ["'", null], null), null)), n), n = O.j(e, 0, null), e = O.j(e, 1, null), new v(null, 2, 5, y, [BI(n), tn(e)], null));
}, nme = function(e, n) {
  var t = K3(function(l) {
    return er(Ss(/[a-zA-Z']/, l));
  }, n);
  return n = O.j(t, 0, null), t = O.j(t, 1, null), new v(null, 2, 5, y, [BI(In.j(ye, e, n)), t], null);
}, rZ = function(e) {
  var n = e;
  for (e = Dt; ; ) {
    var t = z(n);
    n = I(t), t = W(t);
    var l = on.g(n, "'") ? eme : j(Ss(/[a-zA-Z]/, ye.h(n))) ? Jpe : nme;
    if (n = l.g ? l.g(n, t) : l.call(null, n, t), t = O.j(n, 0, null), n = O.j(n, 1, null), e = yt.g(e, t), !z(n)) return e;
  }
}, IS = function(e, n) {
  var t = I(e);
  e = Ja.h(tn(e));
  var l = Cn(n) - 1, r = [ye.h(t), Si.j(e, 0, l)].join("");
  return t = on.g(
    n,
    r
  ) ? new v(null, 2, 5, y, [r, Si.j(e, l, Cn(e))], null) : new v(null, 2, 5, y, [null, [ye.h(t), ye.h(e)].join("")], null), n = O.j(t, 0, null), t = O.j(t, 1, null), j(n) ? new v(null, 2, 5, y, [new v(null, 2, 5, y, [$Z, n], null), t], null) : null;
}, tme = function(e, n, t) {
  var l = K3(function(r) {
    return Ss(/\d/, r);
  }, e);
  return e = O.j(l, 0, null), l = O.j(l, 1, null), Cn(e) >= n ? new v(null, 2, 5, y, [parseInt(In.g(ye, Vu.g(t, e))), he.g(uu.g(t, e), l)], null) : new v(null, 2, 5, y, [parseInt(In.g(ye, e)), l], null);
}, df = function(e, n, t, l) {
  return t = tme(e, t, l), e = O.j(t, 0, null), t = O.j(t, 1, null), new v(null, 2, 5, y, [new v(null, 2, 5, y, [n, e], null), t], null);
}, iv = function(e, n) {
  return function(t) {
    return df(t, Zo, e, n);
  };
}, bA = function(e, n) {
  return function(t) {
    return df(t, _w, e, n);
  };
}, vq = function(e) {
  return function(n) {
    return df(n, a1, e, 2);
  };
}, yq = function() {
  return function(e) {
    return df(e, ls, 1, 2);
  };
}, c_ = function(e, n) {
  return function(t) {
    return df(t, $i, e, n);
  };
}, lme = function() {
  return function(e) {
    return df(e, Nx, 1, 2);
  };
}, _q = function(e) {
  return function(n) {
    return df(n, _o, e, 2);
  };
}, xq = function(e) {
  return function(n) {
    return df(
      n,
      Ux,
      e,
      2
    );
  };
}, Sq = function(e) {
  return function(n) {
    return df(n, Lo, e, 2);
  };
}, Eq = function(e) {
  return function(n) {
    return df(n, Bo, e, 2);
  };
}, Oq = function(e, n) {
  return function(t) {
    return df(t, yo, e, n);
  };
}, TA = function(e, n, t) {
  return n = 60 * parseInt(n, 10) + parseInt(t, 10), e = on.g(e, "+") ? Lc : rc, new v(null, 2, 5, y, [Oa, new lc(yF, e.h ? e.h(n) : e.call(null, n))], null);
}, nm = function(e) {
  return function(n) {
    function t(s) {
      var d = Ja.h(Vu.g(5, a)), p = Ss(/^(\d{2}):(\d{2})/, d);
      return j(p) ? (O.j(p, 0, null), d = O.j(p, 1, null), p = O.j(p, 2, null), new v(null, 2, 5, y, [TA(
        s,
        d,
        p
      ), uu.g(5, a)], null)) : null;
    }
    function l(s) {
      var d = Ja.h(Vu.g(4, a)), p = Ss(/^(\d{2})(\d{2})/, d);
      return j(p) ? (O.j(p, 0, null), d = O.j(p, 1, null), p = O.j(p, 2, null), new v(null, 2, 5, y, [TA(s, d, p), uu.g(4, a)], null)) : null;
    }
    function r() {
      return Yr.g(["Invalid timezone format: ", ye.h(n)].join(""), new $(null, 1, [zi, Wy], null));
    }
    var u = z(n), o = I(u), a = W(u);
    if (j(function() {
      var s = new gi(null, new $(null, 2, ["+", null, "-", null], null), null);
      return s.h ? s.h(o) : s.call(null, o);
    }())) switch (u = e instanceof de ? e.ca : null, u) {
      case "dddd":
        if (u = l(o), j(u) || (u = t(o), j(u))) return u;
        throw r();
      case "long":
        if (u = l(o), j(u) || (u = t(o), j(u))) return u;
        throw r();
      default:
        throw Error(["No matching clause: ", ye.h(u)].join(""));
    }
    else {
      if (on.g(o, "Z")) return new v(null, 1, 5, y, [new v(null, 2, 5, y, [Oa, TA(rc, "0", "0")], null)], null);
      switch (e instanceof de ? e.ca : null) {
        case "abbr":
          u = Vu.g(3, n), u = K3(function(s) {
            return Ss(/[A-Z]/, s);
          }, u);
          var h = O.j(u, 0, null);
          if (O.j(u, 1, null), on.g(Cn(h), 3)) return new v(null, 2, 5, y, [new v(null, 2, 5, y, [Oa, Ja.h(h)], null), uu.g(3, n)], null);
          throw r();
        case "full":
          throw Yr.g([
            "Cannot parse long form timezone:",
            ye.h(n)
          ].join(""), new $(null, 1, [zi, Wy], null));
        default:
          throw r();
      }
    }
  };
}, kq = function() {
  return function(e) {
    e = jL(2, e);
    var n = O.j(e, 0, null), t = O.j(n, 0, null);
    n = O.j(n, 1, null), e = O.j(e, 1, null);
    var l = [ye.h(t), ye.h(n)].join("");
    if (j(function() {
      var r = new gi(null, new $(null, 4, ["AM", null, "am", null, "pm", null, "PM", null], null), null);
      return r.h ? r.h(l) : r.call(null, l);
    }())) e = new v(null, 2, 5, y, [l, e], null);
    else if (j(function() {
      var r = new gi(null, new $(null, 2, ["a", null, "p", null], null), null);
      return r.h ? r.h(t) : r.call(null, t);
    }())) e = new v(null, 2, 5, y, [function() {
      var r = new $(null, 2, ["a", "am", "p", "pm"], null);
      return r.h ? r.h(t) : r.call(null, t);
    }(), kt(n, e)], null);
    else if (j(function() {
      var r = new gi(null, new $(null, 2, ["A", null, "P", null], null), null);
      return r.h ? r.h(t) : r.call(null, t);
    }())) e = new v(null, 2, 5, y, [function() {
      var r = new $(null, 2, ["A", "am", "P", "pm"], null);
      return r.h ? r.h(t) : r.call(null, t);
    }(), kt(n, e)], null);
    else throw Yr.g(["Invalid meridiem format: ", l].join(""), new $(null, 1, [zi, Wy], null));
    return n = e, e = O.j(n, 0, null), n = O.j(n, 1, null), new v(
      null,
      2,
      5,
      y,
      [new v(null, 2, 5, y, [bx, ts.h(e)], null), Ja.h(n)],
      null
    );
  };
}, iZ = function(e, n, t) {
  t = he.g(t, bt.g(function(u) {
    return Si.j(u, 0, 3);
  }, t));
  var l = I(Ia.g(ua.g(go.g(on, e), Vr), bt.g(function(u) {
    return new v(null, 2, 5, y, [u, lZ(e, _1(["^", ye.h(u)].join("")))], null);
  }, t))), r = O.j(l, 0, null);
  if (l = O.j(l, 1, null), j(r)) return new v(null, 2, 5, y, [new v(null, 2, 5, y, [n, ya(Qpe(t, r), 12)], null), l], null);
  throw Yr.g(["Could not parse ", ml(n), " name"].join(""), new $(null, 4, [zi, Wy, Qee, Vge, x0e, n, J1e, l], null));
}, bq = function() {
  return function(e) {
    return bu.j(iZ(
      e,
      ls,
      ate
    ), new v(null, 2, 5, y, [0, 1], null), Lw);
  };
}, jA = function() {
  return function(e) {
    return iZ(e, $i, cte);
  };
}, rme = function(e) {
  var n = _1(In.j(ye, "^", e));
  return function(t) {
    t = Ja.h(t);
    var l = lZ(t, n);
    if (on.g(t, l)) throw Yr.g("Quoted text not found", new $(null, 2, [zi, Wy, Z2e, k_e], null));
    return new v(null, 2, 5, y, [new v(null, 2, 5, y, [Eb, e], null), l], null);
  };
}, ime = function() {
  return function(e) {
    var n = IS(e, "st");
    return j(n) || (n = IS(e, "nd"), j(n)) ? n : (n = IS(e, "rd"), j(n) ? n : IS(e, "th"));
  };
}, ume = function(e) {
  var n = O.j(e, 0, null);
  if (e = O.j(
    e,
    1,
    null
  ), on.g(n, SB)) switch (e) {
    case "S":
      return Oq(1, 2);
    case "SSS":
      return Oq(3, 3);
    case "s":
      return Eq(1);
    case "ss":
      return Eq(2);
    case "m":
      return Sq(1);
    case "mm":
      return Sq(2);
    case "h":
      return _q(1);
    case "hh":
      return _q(2);
    case "H":
      return xq(1);
    case "HH":
      return xq(2);
    case "d":
      return c_(1, 2);
    case "dd":
      return c_(2, 2);
    case "D":
      return c_(1, 3);
    case "DD":
      return c_(2, 3);
    case "DDD":
      return c_(3, 3);
    case "M":
      return yq();
    case "MM":
      return yq();
    case "MMM":
      return bq();
    case "MMMM":
      return bq();
    case "y":
      return iv(1, 4);
    case "yy":
      return iv(
        2,
        2
      );
    case "yyyy":
      return iv(4, 4);
    case "Y":
      return iv(1, 4);
    case "YY":
      return iv(2, 2);
    case "YYYY":
      return iv(4, 4);
    case "x":
      return bA(1, 4);
    case "xx":
      return bA(2, 2);
    case "xxxx":
      return bA(4, 4);
    case "w":
      return vq(1);
    case "ww":
      return vq(2);
    case "E":
      return jA();
    case "EEE":
      return jA();
    case "EEEE":
      return jA();
    case "e":
      return lme();
    case "a":
      return kq();
    case "A":
      return kq();
    case "Z":
      return nm(Cge);
    case "ZZ":
      return nm(j_e);
    case "ZZZ":
      return nm(d_);
    case "ZZZZ":
      return nm(d_);
    case "z":
      return nm(d_);
    case "zz":
      return nm(d_);
    case "zzz":
      return nm(d_);
    case "zzzz":
      return nm(xye);
    case "o":
      return ime();
    default:
      throw Yr.g(["Illegal pattern component: ", ye.h(e)].join(""), new $(null, 1, [zi, M0e], null));
  }
  else return rme(e);
}, sme = function(e, n) {
  e = bt.g(ume, rZ(e));
  for (var t = z(e), l = I(t), r = W(t), u = n, o = e, a = Dt; ; ) {
    var h = u, s = o, d = z(s), p = I(d), _ = W(d), R = p, F = _, L = a;
    if (u = /* @__PURE__ */ function(G, J, we, ce) {
      return function() {
        return Yr.g(["Invalid format: ", ye.h(n), " is malformed at ", wg.l(Te([ce]))].join(""), new $(null, 2, [zi, Wy, Qee, Nwe], null));
      };
    }(u, o, a, h), z(h)) {
      if (R == null) throw u();
      o = R.h ? R.h(h) : R.call(null, h), u = O.j(o, 0, null), o = O.j(o, 1, null), L = yt.g(L, u), u = o, o = F, a = L;
    } else {
      if (j(R)) throw u();
      return L;
    }
  }
}, ome = function(e, n) {
  var t = new zc().getYear(), l = t - ya(t, 100);
  return e = j(e) ? e : j(n) ? n : 0, e < ya(t - 30 + 50, 100) ? e + l : e;
}, ame = function(e) {
  e = fr(e);
  var n = en.g(e, _w), t = en.g(e, a1), l = en.g(e, Nx);
  return j(j(n) ? t : n) ? (n = new zc(n, 0, 4), n.add(new lc(0, 0, 7 * (t - 1))), n.add(new lc(0, 0, (j(l) ? l : 1) - (ya(n.getDay() - 1, 7) + 1))), Dn.j(
    Dn.j(Dn.j(e, Zo, n.getYear()), ls, n.getMonth() + 1),
    $i,
    n.getDate()
  )) : e;
}, cme = function(e, n, t) {
  t = ame(Xpe(lr.g(Tt, Ia.g(ua.g(new gi(null, new $(null, 1, [Eb, null], null), null), I), t)))), t = fr(t);
  var l = en.g(t, Lo), r = en.g(t, Ux), u = en.g(t, yo), o = en.g(t, Oa), a = en.g(t, bx), h = en.g(t, ls), s = en.g(t, $i), d = en.g(t, Bo), p = en.g(t, _o), _ = en.g(t, Zo), R = ome(_, Ep.h(n)), F = j(h) ? h - 1 : null, L = j(a) ? j(function() {
    var G = new gi(null, new $(null, 2, [W0e, null, $1e, null], null), null);
    return G.h ? G.h(a) : G.call(null, a);
  }()) ? function() {
    var G = p + 12;
    return on.g(G, 24) ? 12 : G;
  }() : on.g(p, 12) ? 0 : p : r;
  return nr.l(Dn.j(t, _o, L), Ux, Te([bx])), n = o instanceof lc ? o : new lc(_F, 0), t = function() {
    var G = e instanceof de ? e.ca : null;
    switch (G) {
      case "goog.date.Date":
        return new zc(R, F, s);
      case "goog.date.DateTime":
        return new Tu(R, F, s, L, l, d, u);
      case "goog.date.UtcDateTime":
        return new Oh(R, F, s, L, l, d, u);
      default:
        throw Error(["No matching clause: ", ye.h(G)].join(""));
    }
  }(), t.add(n), t;
}, pf = function(e, n, t, l, r) {
  return t = 1 > l ? ye.h(t) : [Ja.h(Vu.g(l - ye.h(t).length, sa.h("0"))), ye.h(t)].join(""), r = Si.g(t, t.length - r), new v(null, 2, 5, y, [[ye.h(e), r].join(""), n], null);
}, hme = function(e) {
  return function(n, t) {
    return new v(null, 2, 5, y, [In.j(ye, n, e), t], null);
  };
}, uZ = function(e, n, t, l, r) {
  var u = Et(function() {
    return j(r) ? bt.g(function(o) {
      return Si.j(o, 0, 3);
    }, l) : l;
  }());
  return new v(null, 2, 5, y, [[ye.h(e), ye.h(u.h ? u.h(t) : u.call(null, t))].join(""), n], null);
}, fme = function(e) {
  return function(n, t) {
    return uZ(n, t, t.getMonth(), ate, e);
  };
}, dme = function(e) {
  return function(n, t) {
    return uZ(n, t, t.getDay(), cte, e);
  };
}, pme = function(e) {
  return function(n, t) {
    var l = t.getHours();
    return l = j(e) ? 12 > l ? "AM" : "PM" : 12 > l ? "am" : "pm", new v(null, 2, 5, y, [[
      ye.h(n),
      l
    ].join(""), t], null);
  };
}, mme = function() {
  return function(e, n) {
    if (n instanceof Oh) {
      var t = y;
      e = ye.h(e);
      var l = ye, r = l.h, u = n.getTimezoneOffset();
      if (u == 0) u = "Z";
      else {
        var o = Math.abs(u) / 60, a = Math.floor(o);
        o = 60 * (o - a), u = (0 < u ? "-" : "+") + Lh(a, 2) + ":" + Lh(o, 2);
      }
      n = new v(null, 2, 5, t, [[e, r.call(l, u)].join(""), n], null);
    } else n = new v(null, 2, 5, y, [e, n], null);
    return n;
  };
}, gme = function(e) {
  return function(n, t) {
    var l = e.h ? e.h(t) : e.call(null, t), r = function() {
      switch (l) {
        case 1:
          return "st";
        case 2:
          return "nd";
        case 3:
          return "rd";
        case 21:
          return "st";
        case 22:
          return "nd";
        case 23:
          return "rd";
        case 31:
          return "st";
        default:
          return "th";
      }
    }();
    return new v(null, 2, 5, y, [[ye.h(n), ye.h(r)].join(""), t], null);
  };
}, wme = function(e) {
  var n = O.j(e, 0, null);
  if (e = O.j(e, 1, null), on.g(n, SB)) switch (e) {
    case "S":
      return new v(null, 3, 5, y, [yo, 1, 2], null);
    case "SSS":
      return new v(null, 3, 5, y, [yo, 3, 3], null);
    case "s":
      return new v(null, 3, 5, y, [Bo, 1, 2], null);
    case "ss":
      return new v(null, 3, 5, y, [Bo, 2, 2], null);
    case "m":
      return new v(null, 3, 5, y, [Lo, 1, 2], null);
    case "mm":
      return new v(
        null,
        3,
        5,
        y,
        [Lo, 2, 2],
        null
      );
    case "h":
      return new v(null, 3, 5, y, [_o, 1, 2], null);
    case "hh":
      return new v(null, 3, 5, y, [_o, 2, 2], null);
    case "H":
      return new v(null, 3, 5, y, [Ux, 1, 2], null);
    case "HH":
      return new v(null, 3, 5, y, [Ux, 2, 2], null);
    case "d":
      return new v(null, 3, 5, y, [w_, 1, 2], null);
    case "dd":
      return new v(null, 3, 5, y, [w_, 2, 2], null);
    case "D":
      return new v(null, 3, 5, y, [w_, 1, 3], null);
    case "DD":
      return new v(null, 3, 5, y, [w_, 2, 3], null);
    case "DDD":
      return new v(null, 3, 5, y, [w_, 3, 3], null);
    case "M":
      return new v(null, 3, 5, y, [VW, 1, 2], null);
    case "MM":
      return new v(
        null,
        3,
        5,
        y,
        [VW, 2, 2],
        null
      );
    case "MMM":
      return new v(null, 2, 5, y, [KW, !0], null);
    case "MMMM":
      return new v(null, 2, 5, y, [KW, !1], null);
    case "y":
      return new v(null, 3, 5, y, [lw, 1, 4], null);
    case "yy":
      return new v(null, 3, 5, y, [lw, 2, 2], null);
    case "yyyy":
      return new v(null, 3, 5, y, [lw, 4, 4], null);
    case "Y":
      return new v(null, 3, 5, y, [lw, 1, 4], null);
    case "YY":
      return new v(null, 3, 5, y, [lw, 2, 2], null);
    case "YYYY":
      return new v(null, 3, 5, y, [lw, 4, 4], null);
    case "x":
      return new v(null, 3, 5, y, [_w, 1, 4], null);
    case "xx":
      return new v(null, 3, 5, y, [
        _w,
        2,
        2
      ], null);
    case "xxxx":
      return new v(null, 3, 5, y, [_w, 4, 4], null);
    case "w":
      return new v(null, 3, 5, y, [a1, 1, 2], null);
    case "ww":
      return new v(null, 3, 5, y, [a1, 2, 2], null);
    case "e":
      return new v(null, 3, 5, y, [Nx, 1, 1], null);
    case "E":
      return new v(null, 2, 5, y, [q6, !0], null);
    case "EEE":
      return new v(null, 2, 5, y, [q6, !0], null);
    case "EEEE":
      return new v(null, 2, 5, y, [q6, !1], null);
    case "a":
      return new v(null, 2, 5, y, [bx, !1], null);
    case "A":
      return new v(null, 2, 5, y, [bx, !0], null);
    case "Z":
      return new v(null, 1, 5, y, [Oa], null);
    case "ZZ":
      return new v(
        null,
        1,
        5,
        y,
        [Oa],
        null
      );
    case "o":
      return new v(null, 1, 5, y, [$Z], null);
    default:
      throw Error(["No matching clause: ", ye.h(e)].join(""));
  }
  else return new v(null, 2, 5, y, [Eb, e], null);
}, vme = function(e) {
  switch (e = e instanceof de ? e.ca : null, e) {
    case "millis":
      return function(n) {
        return n.getMilliseconds();
      };
    case "seconds":
      return function(n) {
        return n.getSeconds();
      };
    case "minutes":
      return function(n) {
        return n.getMinutes();
      };
    case "hours":
      return function(n) {
        return n.getHours();
      };
    case "HOURS":
      return function(n) {
        return n.getHours();
      };
    case "day":
      return function(n) {
        return n.getDate();
      };
    case "month":
      return function(n) {
        return n.getMonth();
      };
    case "year":
      return function(n) {
        return n.getYear();
      };
    default:
      throw Error(["No matching clause: ", ye.h(e)].join(""));
  }
}, yme = function(e, n, t) {
  var l = z(t);
  switch (t = I(l), l = W(l), t = t instanceof de ? t.ca : null, t) {
    case "millis":
      return In.g(r3, l);
    case "seconds":
      return In.g(i3, l);
    case "minutes":
      return In.g(u3, l);
    case "hours":
      return In.g(s3, l);
    case "HOURS":
      return In.g(o3, l);
    case "day":
      return In.g(a3, l);
    case "month":
      return In.g(h3, l);
    case "month-name":
      return In.g(
        fme,
        l
      );
    case "year":
      return In.g(f3, l);
    case "weekyear":
      return In.g(d3, l);
    case "weekyear-week":
      return In.g(p3, l);
    case "day-name":
      return In.g(dme, l);
    case "day-of-week":
      return In.g(c3, l);
    case "meridiem":
      return In.g(pme, l);
    case "timezone":
      return In.g(mme, l);
    case "ordinal-suffix":
      return --n, e = e.h ? e.h(n) : e.call(null, n), e = O.j(e, 0, null), gme(vme(e));
    case "quoted":
      return In.g(hme, l);
    default:
      throw Error(["No matching clause: ", ye.h(t)].join(""));
  }
}, Wd = function(e, n, t, l, r, u, o) {
  this.Eb = e, this.Kb = n, this.Db = t, this.Lb = l, this.K = r, this.F = u, this.H = o, this.C = 2230716170, this.J = 139264;
}, Zl = function(e) {
  e = new $(null, 2, [Hh, e, Oa, AEe], null);
  var n = nr.l(e, Hh, Te([eg, Ep, Oa]));
  return n = Ap(e) ? lr.g(Tt, n) : n, new Wd(Hh.h(e), eg.h(e), Ep.h(e), Oa.h(e), null, Fo(n), null);
}, tm = function(e) {
  return function() {
    throw { name: lxe, message: QG("%s not implemented yet", Te([ml(e)])) };
  };
}, Ok = function(e, n) {
  return cme(x2e, e, sme(Hh.h(e), n));
}, Ki = function(e) {
  return I(function() {
    return function n(t) {
      return new rr(null, function() {
        for (var l = t; ; ) if (l = z(l)) {
          if (oi(l)) {
            var r = Jr(l), u = Cn(r), o = Sh(u);
            e: for (var a = 0; ; ) if (a < u) {
              var h = Ul(r, a);
              try {
                var s = Ok(h, e);
              } catch {
                s = null;
              }
              j(s) && o.add(s), a += 1;
            } else {
              s = !0;
              break e;
            }
            return s ? js(mo(o), n(Wr(l))) : js(mo(o), null);
          }
          r = I(l);
          try {
            o = Ok(r, e);
          } catch {
            o = null;
          }
          if (j(o)) return kt(o, n(tn(l)));
          l = tn(l);
        } else return null;
      }, null, null);
    }(Ju(sj));
  }());
}, So = function(e, n) {
  e = fr(e);
  var t = en.g(e, Hh);
  en.g(e, Jge);
  e: for (e = wo.g(wme, rZ(t)), t = Q3.g(go.g(yme, e), e), e = z(t), I(e), W(e), e = n, n = ""; ; ) {
    var l = z(t);
    t = I(l);
    var r = W(l);
    if (l = t, t = r, l == null) break e;
    e = l.g ? l.g(n, e) : l.call(null, n, e), n = O.j(
      e,
      0,
      null
    ), e = O.j(e, 1, null);
  }
  return n;
}, Iy = function(e) {
  if (e != null && e.Qc != null) e = e.Qc(e);
  else {
    var n = Iy[$t(e ?? null)];
    if (n != null) e = n.h ? n.h(e) : n.call(null, e);
    else if (n = Iy._, n != null) e = n.h ? n.h(e) : n.call(null, e);
    else throw Ut("ICoerce.to-date-time", e);
  }
  return e;
}, tb = function(e) {
  return e == null ? null : P_.h ? P_.h(e) : P_.call(null, e);
}, _me = function(e) {
  return j(e) ? I(function() {
    return function n(t) {
      return new rr(null, function() {
        for (var l = t; ; ) if (l = z(l)) {
          if (oi(l)) {
            var r = Jr(l), u = Cn(r), o = Sh(u);
            e: for (var a = 0; ; ) if (a < u) {
              var h = Ul(r, a);
              try {
                var s = Ok(h, e);
              } catch (d) {
                if (d instanceof Error) s = null;
                else throw d;
              }
              j(s) && o.add(s), a += 1;
            } else {
              s = !0;
              break e;
            }
            return s ? js(mo(o), n(Wr(l))) : js(mo(o), null);
          }
          r = I(l);
          try {
            o = Ok(r, e);
          } catch (d) {
            if (d instanceof Error) o = null;
            else throw d;
          }
          if (j(o)) return kt(o, n(tn(l)));
          l = tn(l);
        } else return null;
      }, null, null);
    }(Ju(sj));
  }()) : null;
}, lb = function(e) {
  return e = e == null ? null : Iy(e), e == null ? null : e.getTime();
}, mB = function(e) {
  return on.g(no(e), 6) || on.g(no(e), 7);
}, AA = function(e, n) {
  try {
    var t = U4(n) ? "yyyy-MM-dd" : g1(n, " z") ? F3(
      n,
      / z/,
      " Z"
    ) : n;
    return So(Zl(t), Ki(e));
  } catch (l) {
    if (l instanceof Error) return e;
    throw l;
  }
}, DA = function(e) {
  return lb(Ca(e) ? 0 : e) / 1e3 | 0;
}, $_ = function(e, n) {
  if ((j(e) ? n : e) == null) return !1;
  try {
    return Dy(new qh(n, e, null, null, null));
  } catch (t) {
    if (t instanceof Error) try {
      return -1 * Dy(new qh(e, n, null, null, null));
    } catch (l) {
      if (l instanceof Error) return !1;
      throw l;
    }
    else throw t;
  }
}, L_ = function(e, n, t, l) {
  return n = Ki(n), t = Kw(dr.j(zw(nb()), yk(), l), gg(ls, t)), e.g ? e.g(n, t) : e.call(null, n, t);
}, IA = function(e, n, t) {
  return L_(yx, e, n, t);
}, RA = function(e, n, t) {
  return L_(vx, e, n, t);
}, G3 = function(e) {
  switch (no(e)) {
    case 6:
      return Gw(e, ea(1));
    case 7:
      return Ra.g(e, ea(1));
    default:
      return e;
  }
}, xme = function(e) {
  var n = zw(e);
  return fu(function(t) {
    return Ty(e, t);
  }, bt.g(function(t) {
    return t.h ? t.h(n) : t.call(null, n);
  }, new v(null, 12, 5, y, [G_, AE, DE, IE, ME, RE, NE, $E, CE, PE, LE, ua.g(G_, Lw)], null)));
}, NA = function(e, n) {
  if (j(function() {
    var o = fu(Ca, new v(null, 2, 5, y, [e, n], null));
    return j(o) ? o : fu(function(a) {
      return !on.g(Cn(a), 10);
    }, new v(null, 2, 5, y, [e, n], null));
  }())) return null;
  var t = Ki(e), l = Ki(n), r = n2.g(t, l);
  t = t2.g(t, l);
  var u = r;
  for (l = 0; ; ) {
    if (j(Ty(u, t))) return l;
    r = Ra.g(u, ea(1)), l = j(function() {
      var o = mB(u);
      return o || xme(u);
    }()) ? l : l + 1, u = r;
  }
}, CA = function(e, n) {
  try {
    var t = U4(n) ? "yyyy-MM-dd" : g1(n, " z") ? F3(n, / z/, " Z") : n;
    return So(Zl(t), Ki(e));
  } catch (l) {
    if (l instanceof Error) return e;
    throw l;
  }
}, MA = function(e) {
  return lb(Ca(e) ? 0 : e) / 1e3 | 0;
}, B_ = function(e, n) {
  if ((j(e) ? n : e) == null) return !1;
  try {
    return Dy(new qh(n, e, null, null, null));
  } catch (t) {
    if (t instanceof Error) try {
      return -1 * Dy(new qh(
        e,
        n,
        null,
        null,
        null
      ));
    } catch (l) {
      if (l instanceof Error) return !1;
      throw l;
    }
    else throw t;
  }
}, F_ = function(e, n, t, l) {
  return n = Ki(n), t = Kw(dr.j(zw(nb()), yk(), l), gg(ls, t)), e.g ? e.g(n, t) : e.call(null, n, t);
}, PA = function(e, n, t) {
  return F_(yx, e, n, t);
}, $A = function(e, n, t) {
  return F_(vx, e, n, t);
}, rb = function(e) {
  switch (no(e)) {
    case 6:
      return Gw(e, ea(1));
    case 7:
      return Ra.g(e, ea(1));
    default:
      return e;
  }
}, Sme = function(e) {
  var n = no(dr.j(e, 1, 1));
  return dr.j(e, 1, en.j(new v(null, 7, 5, y, [null, 15, 21, 20, 19, 18, 17], null), n, 16));
}, Eme = function(e) {
  var n = no(dr.j(
    e,
    2,
    1
  ));
  return dr.j(e, 2, en.j(new v(null, 7, 5, y, [null, 15, 21, 20, 19, 18, 17], null), n, 16));
}, Ome = function(e) {
  var n = no(dr.j(e, 5, 31));
  return dr.j(e, 5, en.j(new v(null, 7, 5, y, [null, 31, 30, 29, 28, 27, 26], null), n, 25));
}, kme = function(e) {
  var n = no(dr.j(e, 9, 1));
  return dr.j(e, 9, en.j(new v(null, 7, 5, y, [null, 1, 7, 6, 5, 4, 3], null), n, 2));
}, bme = function(e) {
  var n = no(dr.j(e, 10, 1));
  return dr.j(e, 10, en.j(new v(null, 7, 5, y, [null, 8, 14, 13, 12, 11, 10], null), n, 9));
}, Tme = function(e) {
  var n = no(dr.j(e, 11, 1));
  return dr.j(e, 11, en.j(new v(null, 7, 5, y, [
    null,
    25,
    24,
    23,
    22,
    28,
    27
  ], null), n, 26));
}, Tq = function(e) {
  return rb(dr.j(e, 1, 1));
}, jme = function(e) {
  return rb(dr.j(e, 7, 4));
}, Ame = function(e) {
  return rb(dr.j(e, 12, 25));
}, Dme = function(e) {
  return rb(dr.j(e, 11, 11));
}, sZ = function(e) {
  var n = new v(null, 11, 5, y, [Tq, Sme, Eme, Ome, jme, kme, bme, Dme, Tme, Ame, ua.g(Tq, Lw)], null), t = zw(e);
  return fu(function(l) {
    return Ty(e, l);
  }, bt.g(function(l) {
    return l.h ? l.h(t) : l.call(null, t);
  }, n));
}, LA = function(e, n) {
  if (j(function() {
    var o = fu(dy, new v(null, 2, 5, y, [e, n], null));
    return j(o) ? o : fu(function(a) {
      return !on.g(
        Cn(a),
        10
      );
    }, new v(null, 2, 5, y, [e, n], null));
  }())) return null;
  var t = Ki(e), l = Ki(n), r = n2.g(t, l);
  t = t2.g(t, l);
  var u = r;
  for (l = 0; ; ) {
    if (j(Ty(u, t))) return l;
    r = Ra.g(u, ea(1)), l = j(function() {
      var o = mB(u);
      return o || sZ(u);
    }()) ? l : l + 1, u = r;
  }
}, gB = function(e) {
  return !mB(e) && er(sZ(e));
}, BA = function(e, n) {
  return j(fu(dy, new v(null, 2, 5, y, [e, n], null))) ? null : So(Nc, Ra.g(Ki(e), gg(ls, n)));
}, FA = function(e, n) {
  return j(fu(dy, new v(null, 2, 5, y, [e, n], null))) ? null : So(Nc, Gw(Ki(e), gg(ls, n)));
}, VA = function(e) {
  return x3(en.g(new v(
    null,
    7,
    5,
    y,
    "Monday Tuesday Wednesday Thursday Friday Saturday Sunday".split(" "),
    null
  ), no(Ki(e)) - 1));
}, YA = function(e) {
  return ZG(zw(Ki(e)));
}, UA = function(e) {
  return gB(Ki(e));
}, qA = function(e) {
  for (e = Ki(e), e = Gw(e, ea(1)); ; ) {
    if (gB(e)) return So(Nc, e);
    e = Gw(e, ea(1));
  }
}, WA = function(e) {
  for (e = Ki(e), e = Ra.g(e, ea(1)); ; ) {
    if (gB(e)) return So(Nc, e);
    e = Ra.g(e, ea(1));
  }
}, E0 = function(e) {
  return parseInt(Ss(/\d+/, e));
}, O0 = function(e, n) {
  return e = Math.pow(10, e), Math.round(n * e) / e;
}, k0 = function(e) {
  return parseFloat(Ss(/\d+(?:\.\d+)?/, e));
}, b0 = function(e, n) {
  return In.g(ye, rd.g(", ", Jf(function(t, l, r) {
    return yt.g(
      t,
      n.h ? n.h(r) : n.call(null, r)
    );
  }, Dt, e)));
}, T0 = function(e) {
  return JSON.stringify(Bc(e));
}, jq = function(e, n) {
  var t = O.j(n, 0, null);
  n = O.j(n, 1, null), e = [ye.h(e), "/", ye.h(t)].join("");
  var l = ee.h(Vt(n));
  return new $(null, 5, [KB, e, iF, j(l) ? l : "Description not available.", qs, n, te, t, zi, "function"], null);
}, Ime = function(e) {
  return bt.g(function(n) {
    var t = fr(n);
    return n = en.g(t, te), t = en.g(t, IJ), new v(null, 2, 5, y, [_n.h(n), t], null);
  }, e);
}, Aq = function(e) {
  return wt.j(
    function(n, t) {
      return yt.g(n, Qu([_n.h(en.g(t, "name")), en.g(t, "fn")]));
    },
    Tt,
    e
  );
}, oZ = function(e) {
  return new $(null, 2, [Il, new $(null, 4, [R0, Ime(e), wve, Aq(dte), Md, Aq(pte), Zwe, lr.g(Tt, C3([new v(null, 2, 5, y, [_n.h("next-after"), new Jn(function() {
    return y0;
  }, rQ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    gQ,
    "cljs/math.cljs",
    25,
    1,
    742,
    742,
    Lt,
    ue(new v(null, 2, 5, y, [cm, hee], null)),
    `Returns the adjacent floating point number to start in the direction of
  the second argument. If the arguments are equal, the second is returned.
  If either arg is #NaN => #NaN
  If both arguments are signed zeros => direction
  If start is +-Number/MIN_VALUE and direction would cause a smaller magnitude
    => zero with sign matching start
  If start is ##Inf or ##-Inf and direction would cause a smaller magnitude
    => Number/MAX_VALUE with same sign as start
  If start is equal to +=Number/MAX_VALUE and direction would cause a larger magnitude
    => ##Inf or ##-Inf with sign matching start
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#nextAfter-double-double-`,
    j(y0) ? y0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("to-radians"), new Jn(function() {
    return Yv;
  }, $X, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, RX, "cljs/math.cljs", 25, 1, 126, 126, Lt, ue(new v(null, 1, 5, y, [wee], null)), `Converts an angle in degrees to an approximate equivalent angle in radians.
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#toRadians-double-`, j(Yv) ? Yv.D : null]))], null), new v(null, 2, 5, y, [_n.h("log"), new Jn(function() {
    return Wv;
  }, dee, Gn(
    [Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt],
    ["1.11.10", Jt, one, "cljs/math.cljs", 18, 1, 149, 149, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the natural logarithm (base e) of a.
  If a is ##NaN or negative => ##NaN
  If a is ##Inf => ##Inf
  If a is zero => ##-Inf
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log`, j(Wv) ? Wv.D : null]
  ))], null), new v(null, 2, 5, y, [_n.h("acos"), new Jn(function() {
    return Fv;
  }, vJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    AQ,
    "cljs/math.cljs",
    19,
    1,
    111,
    111,
    Lt,
    ue(new v(null, 1, 5, y, [Vl], null)),
    `Returns the arc cosine of a, in the range 0.0 to pi.
  If a is ##NaN or |a|>1 => ##NaN
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/acos`,
    j(Fv) ? Fv.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("to-degrees"), new Jn(function() {
    return Uv;
  }, vee, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    _ne,
    "cljs/math.cljs",
    25,
    1,
    133,
    133,
    Lt,
    ue(new v(null, 1, 5, y, [CB], null)),
    `Converts an angle in radians to an approximate equivalent angle in degrees.
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#toDegrees-double-`,
    j(Uv) ? Uv.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("floor"), new Jn(function() {
    return Df;
  }, oX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    zQ,
    "cljs/math.cljs",
    20,
    1,
    425,
    425,
    Lt,
    ue(new v(null, 1, 5, y, [Vl], null)),
    `Returns the largest double less than or equal to a, and equal to a
  mathematical integer.
  If a is ##NaN or ##Inf or ##-Inf or already equal to an integer => a
  If a is less than zero but greater than -1.0 => -0.0
  Note that if a is \`nil\` then an exception will be thrown. This matches Clojure, rather than js/Math.floor
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/floor`,
    j(Df) ? Df.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("atan2"), new Jn(function() {
    return Qv;
  }, OJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    rne,
    "cljs/math.cljs",
    20,
    1,
    478,
    478,
    Lt,
    ue(new v(null, 2, 5, y, [al, Sn], null)),
    `Returns the angle theta from the conversion of rectangular coordinates (x, y) to polar coordinates (r, theta).
  Computes the phase theta by computing an arc tangent of y/x in the range of -pi to pi.
  For more details on special cases, see:
  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/atan`,
    j(Qv) ? Qv.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("hypot"), new Jn(function() {
    return g0;
  }, LJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, XX, "cljs/math.cljs", 20, 1, 699, 699, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), `Returns sqrt(x^2 + y^2) without intermediate underflow or overflow.
  If x or y is ##Inf or ##-Inf => ##Inf
  If x or y is ##NaN and neither is ##Inf or ##-Inf => ##NaN
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/hypot`, j(g0) ? g0.D : null]))], null), new v(null, 2, 5, y, [_n.h("tanh"), new Jn(function() {
    return m0;
  }, FX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, Wee, "cljs/math.cljs", 19, 1, 689, 689, Lt, ue(new v(null, 1, 5, y, [Sn], null)), `Returns the hyperbolic tangent of x, sinh(x)/cosh(x).
  If x is ##NaN => ##NaN
  If x is zero => zero, with same sign
  If x is ##Inf => +1.0
  If x is ##-Inf => -1.0
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/tanh`, j(m0) ? m0.D : null]))], null), new v(null, 2, 5, y, [_n.h("floor-mod"), new Jn(function() {
    return a0;
  }, mne, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, Ree, "cljs/math.cljs", 24, 1, 584, 584, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), `Integer modulus x - (floorDiv(x, y) * y). Sign matches y and is in the
  range -|y| < r < |y|.
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#floorMod-long-long-`, j(a0) ? a0.D : null]))], null), new v(null, 2, 5, y, [_n.h("ceil"), new Jn(function() {
    return Zv;
  }, HQ, Gn([
    Qt,
    ie,
    te,
    Bn,
    tt,
    zn,
    Yn,
    rt,
    Ft,
    ne,
    ee,
    lt
  ], ["1.11.10", Jt, sX, "cljs/math.cljs", 19, 1, 413, 413, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the smallest double greater than or equal to a, and equal to a
  mathematical integer.
  If a is ##NaN or ##Inf or ##-Inf or already equal to an integer => a
  Note that if a is \`nil\` then an exception will be thrown. This matches Clojure, rather than js/Math.ceil
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/ceil`, j(Zv) ? Zv.D : null]))], null), new v(null, 2, 5, y, [_n.h("atan"), new Jn(function() {
    return Vv;
  }, FQ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, OZ, "cljs/math.cljs", 19, 1, 118, 118, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the arc tangent of a, in the range of -pi/2 to pi/2.
  If a is ##NaN => ##NaN
  If a is zero => zero with the same sign as a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/atan`, j(Vv) ? Vv.D : null]))], null), new v(null, 2, 5, y, [
    _n.h("multiply-exact"),
    new Jn(function() {
      return r0;
    }, qQ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, _J, "cljs/math.cljs", 29, 1, 534, 534, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), "Returns the product of x and y, throws ArithmeticException on overflow. ", j(r0) ? r0.D : null]))
  ], null), new v(null, 2, 5, y, [_n.h("expm1"), new Jn(function() {
    return w0;
  }, lX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    UQ,
    "cljs/math.cljs",
    20,
    1,
    707,
    707,
    Lt,
    ue(new v(null, 1, 5, y, [Sn], null)),
    `Returns e^x - 1. Near 0, expm1(x)+1 is more accurate to e^x than exp(x).
  If x is ##NaN => ##NaN
  If x is ##Inf => #Inf
  If x is ##-Inf => -1.0
  If x is zero => x
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/expm1`,
    j(w0) ? w0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("get-exponent"), new Jn(function() {
    return mw;
  }, Cee, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, SX, "cljs/math.cljs", 27, 1, 599, 599, Lt, ue(new v(null, 1, 5, y, [Xs], null)), `Returns the exponent of d.
  If d is ##NaN, ##Inf, ##-Inf => max_Float64_exponent + 1
  If d is zero or subnormal => min_Float64_exponent - 1
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#getExponent-double-`, j(mw) ? mw.D : null]))], null), new v(
    null,
    2,
    5,
    y,
    [_n.h("add-exact"), new Jn(function() {
      return t0;
    }, NJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, KQ, "cljs/math.cljs", 24, 1, 516, 516, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), "Returns the sum of x and y, throws an exception on overflow. ", j(t0) ? t0.D : null]))],
    null
  ), new v(null, 2, 5, y, [_n.h("cos"), new Jn(function() {
    return $v;
  }, qJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    UZ,
    "cljs/math.cljs",
    18,
    1,
    88,
    88,
    Lt,
    ue(new v(null, 1, 5, y, [Vl], null)),
    `Returns the cosine of an angle.
  If a is ##NaN, ##-Inf, ##Inf => ##NaN
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/cos`,
    j($v) ? $v.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("log10"), new Jn(function() {
    return Hv;
  }, mX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, _ee, "cljs/math.cljs", 20, 1, 158, 158, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the logarithm (base 10) of a.
  If a is ##NaN or negative => ##NaN
  If a is ##Inf => ##Inf
  If a is zero => ##-Inf
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log10`, j(Hv) ? Hv.D : null]))], null), new v(null, 2, 5, y, [
    _n.h("tan"),
    new Jn(function() {
      return Lv;
    }, sJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, CX, "cljs/math.cljs", 18, 1, 95, 95, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the tangent of an angle.
  If a is ##NaN, ##-Inf, ##Inf => ##NaN
  If a is zero => zero with the same sign as a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/tan`, j(Lv) ? Lv.D : null]))
  ], null), new v(null, 2, 5, y, [_n.h("cbrt"), new Jn(function() {
    return Kv;
  }, Lee, Gn([
    Qt,
    ie,
    te,
    Bn,
    tt,
    zn,
    Yn,
    rt,
    Ft,
    ne,
    ee,
    lt
  ], ["1.11.10", Jt, GJ, "cljs/math.cljs", 19, 1, 176, 176, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the cube root of a.
  If a is ##NaN => ##NaN
  If a is ##Inf or ##-Inf => a
  If a is zero => zero with sign matching a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/cbrt`, j(Kv) ? Kv.D : null]))], null), new v(null, 2, 5, y, [_n.h("sqrt"), new Jn(function() {
    return zv;
  }, JJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    _Q,
    "cljs/math.cljs",
    19,
    1,
    167,
    167,
    Lt,
    ue(new v(null, 1, 5, y, [Vl], null)),
    `Returns the positive square root of a.
  If a is ##NaN or negative => ##NaN
  If a is ##Inf => ##Inf
  If a is zero => a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sqrt`,
    j(zv) ? zv.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("decrement-exact"), new Jn(function() {
    return u0;
  }, JQ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    CZ,
    "cljs/math.cljs",
    30,
    1,
    551,
    551,
    Lt,
    ue(new v(null, 1, 5, y, [Vl], null)),
    "Returns a decremented by 1, throws ArithmeticException on overflow. ",
    j(u0) ? u0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("PI"), new Jn(function() {
    return X0;
  }, oee, Gn([Qt, ie, te, Bn, tt, zn, Ax, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, sQ, "cljs/math.cljs", 20, 1, !0, 12, 17, Lt, fl, `Constant for pi, the ratio of the circumference of a circle to its diameter.
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/PI`, j(X0) ? X0.D : null]))], null), new v(null, 2, 5, y, [_n.h("next-down"), new Jn(
    function() {
      return x0;
    },
    aX,
    Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, xne, "cljs/math.cljs", 24, 1, 816, 816, Lt, ue(new v(null, 1, 5, y, [Xs], null)), `Returns the adjacent double of d in the direction of ##-Inf.
  If d is ##NaN => ##NaN
  If d is ##Inf => Number/MAX_VALUE
  If d is zero => -Number/MIN_VALUE
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#nextDown-double-`, j(x0) ? x0.D : null])
  )], null), new v(null, 2, 5, y, [_n.h("pow"), new Jn(function() {
    return Jv;
  }, ree, Gn([
    Qt,
    ie,
    te,
    Bn,
    tt,
    zn,
    Yn,
    rt,
    Ft,
    ne,
    ee,
    lt
  ], ["1.11.10", Jt, Kee, "cljs/math.cljs", 18, 1, 486, 486, Lt, ue(new v(null, 2, 5, y, [Vl, qo], null)), `Returns the value of a raised to the power of b.
  For more details on special cases, see:
  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/pow`, j(Jv) ? Jv.D : null]))], null), new v(null, 2, 5, y, [_n.h("next-up"), new Jn(function() {
    return _0;
  }, qZ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    JZ,
    "cljs/math.cljs",
    22,
    1,
    790,
    790,
    Lt,
    ue(new v(null, 1, 5, y, [Xs], null)),
    `Returns the adjacent double of d in the direction of ##Inf.
  If d is ##NaN => ##NaN
  If d is ##Inf => ##Inf
  If d is zero => Number/MIN_VALUE
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#nextUp-double-`,
    j(_0) ? _0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("exp"), new Jn(function() {
    return qv;
  }, qX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, BQ, "cljs/math.cljs", 18, 1, 140, 140, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns Euler's number e raised to the power of a.
  If a is ##NaN => ##NaN
  If a is ##Inf => ##Inf
  If a is ##-Inf => +0.0
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/exp`, j(qv) ? qv.D : null]))], null), new v(null, 2, 5, y, [
    _n.h("subtract-exact"),
    new Jn(function() {
      return l0;
    }, ine, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, gee, "cljs/math.cljs", 29, 1, 525, 525, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), "Returns the difference of x and y, throws ArithmeticException on overflow. ", j(l0) ? l0.D : null]))
  ], null), new v(null, 2, 5, y, [_n.h("cosh"), new Jn(function() {
    return p0;
  }, lne, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    iJ,
    "cljs/math.cljs",
    19,
    1,
    680,
    680,
    Lt,
    ue(new v(null, 1, 5, y, [Sn], null)),
    `Returns the hyperbolic cosine of x, (e^x + e^-x)/2.
  If x is ##NaN => ##NaN
  If x is ##Inf or ##-Inf => ##Inf
  If x is zero => 1.0
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/cosh`,
    j(p0) ? p0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("scalb"), new Jn(function() {
    return S0;
  }, HX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    Mee,
    "cljs/math.cljs",
    20,
    1,
    847,
    847,
    Lt,
    ue(new v(null, 2, 5, y, [Xs, IX], null)),
    `Returns d * 2^scaleFactor, scaling by a factor of 2. If the exponent
  is between min_Float64_exponent and max_Float64_exponent.
  scaleFactor is an integer
  If d is ##NaN => ##NaN
  If d is ##Inf or ##-Inf => ##Inf or ##-Inf respectively
  If d is zero => zero of same sign as d
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#nextDown-double-`,
    j(S0) ? S0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("log1p"), new Jn(function() {
    return v0;
  }, OX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    Aee,
    "cljs/math.cljs",
    20,
    1,
    717,
    717,
    Lt,
    ue(new v(null, 1, 5, y, [Sn], null)),
    `Returns ln(1+x). For small values of x, log1p(x) is more accurate than
  log(1.0+x).
  If x is ##NaN or ##-Inf or < -1 => ##NaN
  If x is -1 => ##-Inf
  If x is ##Inf => ##Inf
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log1p`,
    j(v0) ? v0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("asin"), new Jn(function() {
    return Bv;
  }, LX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, bee, "cljs/math.cljs", 19, 1, 103, 103, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the arc sine of an angle, in the range -pi/2 to pi/2.
  If a is ##NaN or |a|>1 => ##NaN
  If a is zero => zero with the same sign as a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/asin`, j(Bv) ? Bv.D : null]))], null), new v(
    null,
    2,
    5,
    y,
    [_n.h("copy-sign"), new Jn(function() {
      return xm;
    }, aQ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, VQ, "cljs/math.cljs", 24, 1, 438, 438, Lt, ue(new v(null, 2, 5, y, [MQ, YJ], null)), `Returns a double with the magnitude of the first argument and the sign of
  the second.
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#copySign-double-double-`, j(xm) ? xm.D : null]))],
    null
  ), new v(null, 2, 5, y, [_n.h("round"), new Jn(function() {
    return e0;
  }, XJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    kb,
    "cljs/math.cljs",
    20,
    1,
    493,
    493,
    Lt,
    ue(new v(null, 1, 5, y, [Vl], null)),
    `Returns the closest long to a. If equally close to two values, return the one
  closer to ##Inf.
  If a is ##NaN => 0
  If a is ##-Inf => js/Number.MIN_SAFE_INTEGER
  If a is ##Inf => js/Number.MAX_SAFE_INTEGER
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round`,
    j(e0) ? e0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("negate-exact"), new Jn(
    function() {
      return s0;
    },
    SZ,
    Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, ZJ, "cljs/math.cljs", 27, 1, 559, 559, Lt, ue(new v(null, 1, 5, y, [Vl], null)), "Returns the negation of a, throws ArithmeticException on overflow. ", j(s0) ? s0.D : null])
  )], null), new v(null, 2, 5, y, [_n.h("E"), new Jn(function() {
    return Z0;
  }, PZ, Gn([Qt, ie, te, Bn, tt, zn, Ax, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    jQ,
    "cljs/math.cljs",
    19,
    1,
    !0,
    5,
    10,
    Lt,
    fl,
    `Constant for Euler's number e, the base for natural logarithms.
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E`,
    j(Z0) ? Z0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("IEEE-remainder"), new Jn(function() {
    return Gv;
  }, MZ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    DJ,
    "cljs/math.cljs",
    29,
    1,
    335,
    335,
    Lt,
    ue(new v(null, 2, 5, y, [KZ, kX], null)),
    `Returns the remainder per IEEE 754 such that
    remainder = dividend - divisor * n
   where n is the integer closest to the exact value of dividend / divisor.
   If two integers are equally close, then n is the even one.
   If the remainder is zero, sign will match dividend.
   If dividend or divisor is ##NaN, or dividend is ##Inf or ##-Inf, or divisor is zero => ##NaN
   If dividend is finite and divisor is infinite => dividend

   Method: based on fmod return x-[x/p]chopped*p exactlp.
   Ported from: https://github.com/openjdk/jdk/blob/master/src/java.base/share/native/libfdlibm/e_remainder.c
   See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#IEEEremainder-double-double-`,
    j(Gv) ? Gv.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("sinh"), new Jn(function() {
    return d0;
  }, Yee, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, QJ, "cljs/math.cljs", 19, 1, 672, 672, Lt, ue(new v(null, 1, 5, y, [Sn], null)), `Returns the hyperbolic sine of x, (e^x - e^-x)/2.
  If x is ##NaN => ##NaN
  If x is ##Inf or ##-Inf or zero => x
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sinh`, j(d0) ? d0.D : null]))], null), new v(null, 2, 5, y, [_n.h("rint"), new Jn(
    function() {
      return Xv;
    },
    tJ,
    Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, RQ, "cljs/math.cljs", 19, 1, 465, 465, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the double closest to a and equal to a mathematical integer.
  If two values are equally close, return the even one.
  If a is ##NaN or ##Inf or ##-Inf or zero => a
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#rint-double-`, j(Xv) ? Xv.D : null])
  )], null), new v(null, 2, 5, y, [_n.h("ulp"), new Jn(function() {
    return h0;
  }, Pee, Gn([
    Qt,
    ie,
    te,
    Bn,
    tt,
    zn,
    Yn,
    rt,
    Ft,
    ne,
    ee,
    lt
  ], ["1.11.10", Jt, $ee, "cljs/math.cljs", 18, 1, 636, 636, Lt, ue(new v(null, 1, 5, y, [Xs], null)), `Returns the size of an ulp (unit in last place) for d.
  If d is ##NaN => ##NaN
  If d is ##Inf or ##-Inf => ##Inf
  If d is zero => Number/MIN_VALUE
  If d is +/- Number/MAX_VALUE => 2^971
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#ulp-double-`, j(h0) ? h0.D : null]))], null), new v(null, 2, 5, y, [_n.h("sin"), new Jn(function() {
    return Pv;
  }, cQ, Gn([
    Qt,
    ie,
    te,
    Bn,
    tt,
    zn,
    Yn,
    rt,
    Ft,
    ne,
    ee,
    lt
  ], ["1.11.10", Jt, wQ, "cljs/math.cljs", 18, 1, 80, 80, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the sine of an angle.
  If a is ##NaN, ##-Inf, ##Inf => ##NaN
  If a is zero => zero with the same sign as a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sin`, j(Pv) ? Pv.D : null]))], null), new v(null, 2, 5, y, [_n.h("increment-exact"), new Jn(function() {
    return i0;
  }, VX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    EJ,
    "cljs/math.cljs",
    30,
    1,
    543,
    543,
    Lt,
    ue(new v(null, 1, 5, y, [Vl], null)),
    "Returns a incremented by 1, throws ArithmeticException on overflow.",
    j(i0) ? i0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("random"), new Jn(function() {
    return n0;
  }, kJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
    "1.11.10",
    Jt,
    une,
    "cljs/math.cljs",
    21,
    1,
    508,
    508,
    Lt,
    ue(Dt),
    `Returns a positive double between 0.0 and 1.0, chosen pseudorandomly with
  approximately random distribution. Not cryptographically secure. The seed is chosen internally
  and cannot be selected.
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random`,
    j(n0) ? n0.D : null
  ]))], null), new v(null, 2, 5, y, [_n.h("floor-div"), new Jn(function() {
    return o0;
  }, CJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, Ene, "cljs/math.cljs", 24, 1, 571, 571, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), `Integer division that rounds to negative infinity (as opposed to zero).
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#floorDiv-long-long-`, j(o0) ? o0.D : null]))], null), new v(null, 2, 5, y, [_n.h("signum"), new Jn(function() {
    return f0;
  }, AX, Gn([
    Qt,
    ie,
    te,
    Bn,
    tt,
    zn,
    Yn,
    rt,
    Ft,
    ne,
    ee,
    lt
  ], ["1.11.10", Jt, pee, "cljs/math.cljs", 21, 1, 661, 661, Lt, ue(new v(null, 1, 5, y, [Xs], null)), `Returns the signum function of d - zero for zero, 1.0 if >0, -1.0 if <0.
  If d is ##NaN => ##NaN
  If d is ##Inf or ##-Inf => sign of d
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#signum-double-`, j(f0) ? f0.D : null]))], null)], !0))], null), qk, NEe], null);
}, Dq = function(e, n) {
  Qa(xF, HG(gr.l(Te([oZ(n), new $(null, 1, [Ws, e], null)]))));
}, Rme = function(e) {
  try {
    var n = Kpe();
    return e2.g(n, e);
  } catch (t) {
    return new $(
      null,
      1,
      [C8, ye.h(t.message)],
      null
    );
  }
}, Nme = function(e, n) {
  var t = Dde(e);
  return e = en.g(t, C8), !Ol(t, C8) && ci(t) ? Dq(gr.l(Te([en.g(Il.h(sn(Or.h(sn(xF)))), R0), lr.g(Tt, function() {
    return function l(r) {
      return new rr(null, function() {
        for (; ; ) {
          var u = z(r);
          if (u) {
            if (oi(u)) {
              var o = Jr(u), a = Cn(o), h = Sh(a);
              e: for (var s = 0; ; ) if (s < a) {
                var d = Ul(o, s), p = O.j(d, 0, null);
                d = O.j(d, 1, null), T3(h, new v(null, 2, 5, y, [_n.h(p), d], null)), s += 1;
              } else {
                o = !0;
                break e;
              }
              return o ? js(mo(h), l(Wr(u))) : js(mo(h), null);
            }
            return o = I(u), h = O.j(o, 0, null), o = O.j(o, 1, null), kt(new v(
              null,
              2,
              5,
              y,
              [_n.h(h), o],
              null
            ), l(tn(u)));
          }
          return null;
        }
      }, null, null);
    }(t);
  }())])), n) : Dq(sn(CEe), n), new $(null, 2, [SJ, e, Ib, e == null ? t : null], null);
}, Cme = function(e) {
  return e == null ? Dt : bt.g(function(n) {
    var t = fr(n);
    n = en.g(t, te);
    var l = en.g(t, o1e);
    return t = en.g(t, IJ), Bh(new $(null, 3, [KB, n, iF, j(l) ? l : j(t) ? t : "Description not available.", zi, "variable"], null));
  }, e);
}, Mme = function(e) {
  return Bh(new v(null, 1, 5, y, [function(n) {
    n = n.matchBefore(/(\w|-|\/)*/);
    var t = he.l(MEe, PEe, Te([Bc(dte), Bc(pte), Cme(e)]));
    return Bh(new $(null, 2, [
      fo,
      n.from,
      gve,
      t
    ], null));
  }], null));
}, Pme = function(e, n, t, l) {
  var r = l.docChanged;
  return r = j(r) ? Bw(e) : r, r = j(r) ? r : er(en.g(sn(t), XW)) && Bw(e), j(r) ? (n = Nme(l, n), r = fr(n), n = en.g(r, SJ), r = en.g(r, Ib), l.error = n, l.output = r, wr.j(t, yt, new $(null, 1, [XW, !0], null)), e.h ? e.h(l) : e.call(null, l)) : null;
}, aZ = function(e, n) {
  var t = kr.h(new $(null, 1, [eye, !1], null));
  e = document.getElementById(e);
  var l = xp.l(n, Te([_b, !0]));
  n = en.g(l, ive);
  var r = en.j(l, pwe, "read-write"), u = en.j(l, W1e, Dt), o = en.g(l, q1e);
  return r = on.g(r, "read-only") ? Bh(new v(null, 12, 5, y, [
    $H,
    qr.history(),
    Xu.syntaxHighlighting(Xu.defaultHighlightStyle),
    Do.drawSelection(),
    Ru.EditorState.allowMultipleSelections.of(!0),
    uk(PH),
    TI(),
    i4,
    Ru.EditorState.transactionFilter.of(jI),
    Do.keymap.of(Nne),
    Do.keymap.of(qr.historyKeymap),
    Ru.EditorState.readOnly.of(!0)
  ], null)) : Bh(new v(null, 15, 5, y, [
    $H,
    qr.history(),
    Xu.syntaxHighlighting(Xu.defaultHighlightStyle),
    Do.drawSelection(),
    Xu.foldGutter(),
    Do.lineNumbers(),
    Ru.EditorState.allowMultipleSelections.of(!0),
    uk(PH),
    mG(),
    TI(),
    i4,
    Ru.EditorState.transactionFilter.of(jI),
    Do.keymap.of(Rxe),
    Do.keymap.of(qr.historyKeymap),
    kxe.autocompletion(Bh(new $(null, 2, [z_e, !0, X2e, Mme(u)], null)))
  ], null)), l = document.createElement("div"), l.id = e.id, e.replaceWith(l), t = go.B(Pme, o, u, t), t = Bh(new v(null, 1, 5, y, [Do.EditorView.updateListener.of(t)], null)), new Do.EditorView(Bh(new $(null, 2, [U_e, l, Sve, Ru.EditorState.create(Bh(new $(null, 2, [ee, n, uxe, r.concat(t)], null)))], null)));
}, cZ = globalThis, HA = "closure_uid_" + (1e9 * Math.random() >>> 0), $me = 0, Lme = String.prototype.trim ? function(e) {
  return e.trim();
} : function(e) {
  return /^[\s\xa0]*([\s\S]*?)[\s\xa0]*$/.exec(e)[1];
}, _x = String.prototype.repeat ? function(e, n) {
  return e.repeat(n);
} : function(e, n) {
  return Array(n + 1).join(e);
};
A = Ts.prototype;
A.hc = "";
A.set = function(e) {
  this.hc = "" + e;
};
A.append = function(e, n, t) {
  if (this.hc += String(e), n != null) for (let l = 1; l < arguments.length; l++) this.hc += arguments[l];
  return this;
};
A.clear = function() {
  this.hc = "";
};
A.getLength = function() {
  return this.hc.length;
};
A.toString = function() {
  return this.hc;
};
var Ev = {}, hZ = {}, Rn = {}, Js = null, fZ = null, ku = !0, Lu = !0, Ys = !1, Bu = !1, ns = !1, Fu = null, Wi = null, Li = typeof Symbol < "u" && $t(Symbol) === "function" ? Symbol.iterator : "@@iterator", Bme = {
  "]": "_RBRACK_",
  "'": "_SINGLEQUOTE_",
  "=": "_EQ_",
  '"': "_DOUBLEQUOTE_",
  "!": "_BANG_",
  "*": "_STAR_",
  "%": "_PERCENT_",
  "|": "_BAR_",
  "~": "_TILDE_",
  "/": "_SLASH_",
  "\\": "_BSLASH_",
  "-": "_",
  "?": "_QMARK_",
  "&": "_AMPERSAND_",
  ":": "_COLON_",
  "<": "_LT_",
  "{": "_LBRACE_",
  "}": "_RBRACE_",
  "[": "_LBRACK_",
  "#": "_SHARP_",
  "^": "_CARET_",
  "+": "_PLUS_",
  "@": "_CIRCA_",
  ">": "_GT_"
}, dZ = { _RBRACE_: "}", _COLON_: ":", _BANG_: "!", _QMARK_: "?", _BSLASH_: "\\\\", _SLASH_: "/", _PERCENT_: "%", _PLUS_: "+", _SHARP_: "#", _LBRACE_: "{", _BAR_: "|", _LBRACK_: "[", _EQ_: "=", _: "-", _TILDE_: "~", _RBRACK_: "]", _GT_: ">", _SINGLEQUOTE_: "'", _CIRCA_: "@", _AMPERSAND_: "&", _DOUBLEQUOTE_: '\\"', _CARET_: "^", _LT_: "<", _STAR_: "*" }, zA = null, Sm = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Sm.h = function(e) {
  return Array(e);
};
Sm.g = function(e, n) {
  return Array(n);
};
Sm.l = function(e, n, t) {
  e = Array(n), n = e.length;
  for (var l = 0; l < n; ) e[l] = In.j ? In.j(Sm, null, t) : In.call(null, Sm, null, t), l += 1;
  return e;
};
Sm.v = function(e) {
  var n = I.h ? I.h(e) : I.call(null, e), t = W.h ? W.h(e) : W.call(null, e);
  return e = I.h ? I.h(t) : I.call(null, t), t = W.h ? W.h(t) : W.call(null, t), this.l(n, e, t);
};
Sm.m = 2;
var Em = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Em.g = function(e, n) {
  return e[n];
};
Em.l = function(e, n, t) {
  return e = e[n], In.j ? In.j(Em, e, t) : In.call(null, Em, e, t);
};
Em.v = function(e) {
  var n = I.h ? I.h(e) : I.call(null, e), t = W.h ? W.h(e) : W.call(null, e);
  return e = I.h ? I.h(t) : I.call(null, t), t = W.h ? W.h(t) : W.call(null, t), this.l(n, e, t);
};
Em.m = 2;
var Om = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
Om.j = function(e, n, t) {
  return e[n] = t;
};
Om.l = function(e, n, t, l) {
  return e = e[n], In.B ? In.B(Om, e, t, l) : In.call(null, Om, e, t, l);
};
Om.v = function(e) {
  var n = I.h ? I.h(e) : I.call(null, e), t = W.h ? W.h(e) : W.call(null, e);
  e = I.h ? I.h(t) : I.call(null, t);
  var l = W.h ? W.h(t) : W.call(null, t);
  return t = I.h ? I.h(l) : I.call(null, l), l = W.h ? W.h(l) : W.call(null, l), this.l(n, e, t, l);
};
Om.m = 3;
var Fs = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Fs.h = function(e) {
  return Fs.g(null, e);
};
Fs.g = function(e, n) {
  function t(l, r) {
    return l.push(r), l;
  }
  return e = [], wt.j ? wt.j(t, e, n) : wt.call(null, t, e, n);
};
Fs.m = 2;
var pZ = function() {
  function e(l, r, u) {
    var o = Ul[$t(l ?? null)];
    if (o != null || (o = Ul._, o != null)) return o.j ? o.j(l, r, u) : o.call(null, l, r, u);
    throw Ut("IIndexed.-nth", l);
  }
  function n(l, r) {
    var u = Ul[$t(l ?? null)];
    if (u != null || (u = Ul._, u != null)) return u.g ? u.g(l, r) : u.call(null, l, r);
    throw Ut("IIndexed.-nth", l);
  }
  var t = null;
  return t = function(l, r, u) {
    switch (arguments.length) {
      case 2:
        return n.call(this, l, r);
      case 3:
        return e.call(this, l, r, u);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, t.g = n, t.j = e, t;
}(), Ul = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Ul.g = function(e, n) {
  return e != null && e.Y != null ? e.Y(e, n) : pZ(e, n);
};
Ul.j = function(e, n, t) {
  return e != null && e.Wa != null ? e.Wa(e, n, t) : pZ(e, n, t);
};
Ul.m = 3;
var mZ = function() {
  function e(l, r, u) {
    var o = zo[$t(l ?? null)];
    if (o != null || (o = zo._, o != null)) return o.j ? o.j(l, r, u) : o.call(null, l, r, u);
    throw Ut("ILookup.-lookup", l);
  }
  function n(l, r) {
    var u = zo[$t(l ?? null)];
    if (u != null || (u = zo._, u != null)) return u.g ? u.g(l, r) : u.call(null, l, r);
    throw Ut("ILookup.-lookup", l);
  }
  var t = null;
  return t = function(l, r, u) {
    switch (arguments.length) {
      case 2:
        return n.call(this, l, r);
      case 3:
        return e.call(
          this,
          l,
          r,
          u
        );
    }
    throw Error("Invalid arity: " + arguments.length);
  }, t.g = n, t.j = e, t;
}(), zo = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
zo.g = function(e, n) {
  return e != null && e.wa != null ? e.wa(e, n) : mZ(e, n);
};
zo.j = function(e, n, t) {
  return e != null && e.P != null ? e.P(e, n, t) : mZ(e, n, t);
};
zo.m = 3;
var gZ = function() {
  function e(l, r, u) {
    var o = Gd[$t(l ?? null)];
    if (o != null || (o = Gd._, o != null)) return o.j ? o.j(l, r, u) : o.call(null, l, r, u);
    throw Ut("IReduce.-reduce", l);
  }
  function n(l, r) {
    var u = Gd[$t(l ?? null)];
    if (u != null || (u = Gd._, u != null)) return u.g ? u.g(l, r) : u.call(null, l, r);
    throw Ut("IReduce.-reduce", l);
  }
  var t = null;
  return t = function(l, r, u) {
    switch (arguments.length) {
      case 2:
        return n.call(this, l, r);
      case 3:
        return e.call(
          this,
          l,
          r,
          u
        );
    }
    throw Error("Invalid arity: " + arguments.length);
  }, t.g = n, t.j = e, t;
}(), Gd = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Gd.g = function(e, n) {
  return e != null && e.Da != null ? e.Da(e, n) : gZ(e, n);
};
Gd.j = function(e, n, t) {
  return e != null && e.Ea != null ? e.Ea(e, n, t) : gZ(e, n, t);
};
Gd.m = 3;
var ib = function() {
  function e(u, o, a, h, s) {
    var d = Io[$t(u ?? null)];
    if (d != null || (d = Io._, d != null)) return d.I ? d.I(u, o, a, h, s) : d.call(null, u, o, a, h, s);
    throw Ut("ISwap.-swap!", u);
  }
  function n(u, o, a, h) {
    var s = Io[$t(u ?? null)];
    if (s != null || (s = Io._, s != null)) return s.B ? s.B(u, o, a, h) : s.call(null, u, o, a, h);
    throw Ut("ISwap.-swap!", u);
  }
  function t(u, o, a) {
    var h = Io[$t(u ?? null)];
    if (h != null || (h = Io._, h != null)) return h.j ? h.j(u, o, a) : h.call(null, u, o, a);
    throw Ut("ISwap.-swap!", u);
  }
  function l(u, o) {
    var a = Io[$t(u ?? null)];
    if (a != null || (a = Io._, a != null)) return a.g ? a.g(u, o) : a.call(null, u, o);
    throw Ut("ISwap.-swap!", u);
  }
  var r = null;
  return r = function(u, o, a, h, s) {
    switch (arguments.length) {
      case 2:
        return l.call(this, u, o);
      case 3:
        return t.call(this, u, o, a);
      case 4:
        return n.call(this, u, o, a, h);
      case 5:
        return e.call(this, u, o, a, h, s);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, r.g = l, r.j = t, r.B = n, r.I = e, r;
}(), Io = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    case 5:
      return e.I(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Io.g = function(e, n) {
  return e != null && e.We != null ? e.We(e, n) : ib(e, n);
};
Io.j = function(e, n, t) {
  return e != null && e.Xe != null ? e.Xe(e, n, t) : ib(e, n, t);
};
Io.B = function(e, n, t, l) {
  return e != null && e.Ye != null ? e.Ye(e, n, t, l) : ib(e, n, t, l);
};
Io.I = function(e, n, t, l, r) {
  return e != null && e.Ze != null ? e.Ze(e, n, t, l, r) : ib(e, n, t, l, r);
};
Io.m = 5;
mL.prototype.qe = function(e, n) {
  return this.hf.append(n);
};
var Ym = typeof Math < "u" && typeof Math.imul < "u" ? function(e, n) {
  return Math.imul(e, n);
} : function(e, n) {
  var t = e & 65535, l = n & 65535;
  return t * l + ((e >>> 16 & 65535) * l + t * (n >>> 16 & 65535) << 16 >>> 0) | 0;
}, KA = {}, GA = 0;
A = T.prototype;
A.toString = function() {
  return this.Qb;
};
A.N = function(e, n) {
  return n instanceof T ? this.Qb === n.Qb : !1;
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return en.g ? en.g(e, this) : en.call(null, e, this);
};
A.g = function(e, n) {
  return en.j ? en.j(e, this, n) : en.call(null, e, this, n);
};
A.U = function() {
  return this.zb;
};
A.Z = function(e, n) {
  return new T(this.ns, this.name, this.Qb, this.wc, n);
};
A.O = function() {
  var e = this.wc;
  return e ?? (this.wc = e = gL(this));
};
A.yc = function() {
  return this.name;
};
A.zc = function() {
  return this.ns;
};
A.R = function(e, n) {
  return Br(n, this.Qb);
};
var _n = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
_n.h = function(e) {
  for (; ; ) {
    if (e instanceof T) return e;
    if (typeof e == "string") {
      var n = e.indexOf("/");
      return 1 > n ? _n.g(null, e) : _n.g(e.substring(0, n), e.substring(n + 1, e.length));
    }
    if (e instanceof Jn) return e.Rb;
    if (e instanceof de) e = e.ca;
    else throw Error("no conversion to symbol");
  }
};
_n.g = function(e, n) {
  var t = e != null ? [ye.h(e), "/", ye.h(n)].join("") : n;
  return new T(e, n, t, null, null);
};
_n.m = 2;
A = Jn.prototype;
A.toString = function() {
  return ["#'", ye.h(this.Rb)].join("");
};
A.jb = function() {
  return this.val.o ? this.val.o() : this.val.call(null);
};
A.U = function() {
  return this.zb;
};
A.Z = function(e, n) {
  return new Jn(this.val, this.Rb, n);
};
A.N = function(e, n) {
  return n instanceof Jn ? (e = this.Rb, n = n.Rb, on.g ? on.g(e, n) : on.call(null, e, n)) : !1;
};
A.O = function() {
  return gL(this.Rb);
};
A.$d = Rn;
A.call = function(e) {
  switch (arguments.length - 1) {
    case 0:
      return this.o();
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    case 3:
      return this.j(arguments[1], arguments[2], arguments[3]);
    case 4:
      return this.B(arguments[1], arguments[2], arguments[3], arguments[4]);
    case 5:
      return this.I(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    case 6:
      return this.T(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
    case 7:
      return this.ba(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7]
      );
    case 8:
      return this.ia(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8]);
    case 9:
      return this.va(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9]);
    case 10:
      return this.la(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10]);
    case 11:
      return this.ma(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11]);
    case 12:
      return this.na(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12]);
    case 13:
      return this.oa(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13]
      );
    case 14:
      return this.pa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14]);
    case 15:
      return this.qa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15]);
    case 16:
      return this.ra(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16]
      );
    case 17:
      return this.sa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15], arguments[16], arguments[17]);
    case 18:
      return this.ta(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18]
      );
    case 19:
      return this.ua(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15], arguments[16], arguments[17], arguments[18], arguments[19]);
    case 20:
      return this.Va(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18],
        arguments[19],
        arguments[20]
      );
    case 21:
      return this.Vb(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18],
        arguments[19],
        arguments[20],
        arguments[21]
      );
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.o = function() {
  var e = this.val.o ? this.val.o() : this.val.call(null);
  return e.o ? e.o() : e.call(null);
};
A.h = function(e) {
  var n = this.val.o ? this.val.o() : this.val.call(null);
  return n.h ? n.h(e) : n.call(null, e);
};
A.g = function(e, n) {
  var t = this.val.o ? this.val.o() : this.val.call(null);
  return t.g ? t.g(e, n) : t.call(null, e, n);
};
A.j = function(e, n, t) {
  var l = this.val.o ? this.val.o() : this.val.call(null);
  return l.j ? l.j(e, n, t) : l.call(null, e, n, t);
};
A.B = function(e, n, t, l) {
  var r = this.val.o ? this.val.o() : this.val.call(null);
  return r.B ? r.B(e, n, t, l) : r.call(null, e, n, t, l);
};
A.I = function(e, n, t, l, r) {
  var u = this.val.o ? this.val.o() : this.val.call(null);
  return u.I ? u.I(e, n, t, l, r) : u.call(null, e, n, t, l, r);
};
A.T = function(e, n, t, l, r, u) {
  var o = this.val.o ? this.val.o() : this.val.call(null);
  return o.T ? o.T(e, n, t, l, r, u) : o.call(null, e, n, t, l, r, u);
};
A.ba = function(e, n, t, l, r, u, o) {
  var a = this.val.o ? this.val.o() : this.val.call(null);
  return a.ba ? a.ba(e, n, t, l, r, u, o) : a.call(null, e, n, t, l, r, u, o);
};
A.ia = function(e, n, t, l, r, u, o, a) {
  var h = this.val.o ? this.val.o() : this.val.call(null);
  return h.ia ? h.ia(e, n, t, l, r, u, o, a) : h.call(null, e, n, t, l, r, u, o, a);
};
A.va = function(e, n, t, l, r, u, o, a, h) {
  var s = this.val.o ? this.val.o() : this.val.call(null);
  return s.va ? s.va(e, n, t, l, r, u, o, a, h) : s.call(null, e, n, t, l, r, u, o, a, h);
};
A.la = function(e, n, t, l, r, u, o, a, h, s) {
  var d = this.val.o ? this.val.o() : this.val.call(null);
  return d.la ? d.la(e, n, t, l, r, u, o, a, h, s) : d.call(null, e, n, t, l, r, u, o, a, h, s);
};
A.ma = function(e, n, t, l, r, u, o, a, h, s, d) {
  var p = this.val.o ? this.val.o() : this.val.call(null);
  return p.ma ? p.ma(e, n, t, l, r, u, o, a, h, s, d) : p.call(null, e, n, t, l, r, u, o, a, h, s, d);
};
A.na = function(e, n, t, l, r, u, o, a, h, s, d, p) {
  var _ = this.val.o ? this.val.o() : this.val.call(null);
  return _.na ? _.na(e, n, t, l, r, u, o, a, h, s, d, p) : _.call(null, e, n, t, l, r, u, o, a, h, s, d, p);
};
A.oa = function(e, n, t, l, r, u, o, a, h, s, d, p, _) {
  var R = this.val.o ? this.val.o() : this.val.call(null);
  return R.oa ? R.oa(e, n, t, l, r, u, o, a, h, s, d, p, _) : R.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _);
};
A.pa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R) {
  var F = this.val.o ? this.val.o() : this.val.call(null);
  return F.pa ? F.pa(e, n, t, l, r, u, o, a, h, s, d, p, _, R) : F.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R);
};
A.qa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F) {
  var L = this.val.o ? this.val.o() : this.val.call(null);
  return L.qa ? L.qa(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F) : L.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F);
};
A.ra = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L) {
  var G = this.val.o ? this.val.o() : this.val.call(null);
  return G.ra ? G.ra(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L) : G.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L);
};
A.sa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G) {
  var J = this.val.o ? this.val.o() : this.val.call(null);
  return J.sa ? J.sa(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G) : J.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G);
};
A.ta = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J) {
  var we = this.val.o ? this.val.o() : this.val.call(null);
  return we.ta ? we.ta(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J) : we.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J);
};
A.ua = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we) {
  var ce = this.val.o ? this.val.o() : this.val.call(null);
  return ce.ua ? ce.ua(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we) : ce.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we);
};
A.Va = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce) {
  var xe = this.val.o ? this.val.o() : this.val.call(null);
  return xe.Va ? xe.Va(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce) : xe.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce);
};
A.Vb = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe) {
  var $e = this.val.o ? this.val.o() : this.val.call(null);
  return In.wd ? In.wd($e, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe) : In.call(null, $e, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe);
};
var on = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
on.h = function() {
  return !0;
};
on.g = function(e, n) {
  return e == null ? n == null : e === n || py(e, n);
};
on.l = function(e, n, t) {
  for (; ; ) if (on.g(e, n)) if (W(t)) e = n, n = I(t), t = W(t);
  else return on.g(n, I(t));
  else return !1;
};
on.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
on.m = 2;
aK.prototype.next = function() {
  if (this.X != null) {
    var e = I(this.X);
    return this.X = W(this.X), { value: e, done: !1 };
  }
  return { value: null, done: !0 };
};
u2.prototype.W = function() {
  return this;
};
u2.prototype.Ba = function() {
  return this.value;
};
u2.prototype.Fa = function() {
  return this.sd == null && (this.sd = Dv.h ? Dv.h(this.iter) : Dv.call(null, this.iter)), this.sd;
};
var wB = i2(r2(0, $w(1)), 0), Z3 = i2(r2(0, $w(0)), 0);
VD.null = !0;
Kh.null = function() {
  return 0;
};
A = Date.prototype;
A.N = function(e, n) {
  return n instanceof Date && this.valueOf() === n.valueOf();
};
A.Za = Rn;
A.Ua = function(e, n) {
  if (n instanceof Date) return hh(this.valueOf(), n.valueOf());
  throw Error(["Cannot compare ", ye.h(this), " to ", ye.h(n)].join(""));
};
A.$e = Rn;
A.re = function() {
  return this.getTime();
};
py.number = function(e, n) {
  return e === n;
};
FD.function = !0;
KD.function = !0;
LO.function = function() {
  return null;
};
BO._ = function(e) {
  return pL(e);
};
vL.prototype.jb = function() {
  return this.val;
};
_L.prototype.ja = function() {
  return this.i < this.A.length;
};
_L.prototype.next = function() {
  var e = this.A[this.i];
  return this.i += 1, e;
};
A = hn.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn.h ? Cn.h(this) : Cn.call(null, this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.Y = function(e, n) {
  if (e = n + this.i, 0 <= e && e < this.A.length) return this.A[e];
  throw Error("Index out of bounds");
};
A.Wa = function(e, n, t) {
  return e = n + this.i, 0 <= e && e < this.A.length ? this.A[e] : t;
};
A.Xa = function() {
  return new _L(this.A, this.i);
};
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return this.i + 1 < this.A.length ? new hn(this.A, this.i + 1, null) : null;
};
A.$ = function() {
  var e = this.A.length - this.i;
  return 0 > e ? 0 : e;
};
A.Wb = function() {
  var e = this.$(null);
  return 0 < e ? new Qf(this, e - 1, null) : null;
};
A.O = function() {
  return qu(this);
};
A.N = function(e, n) {
  return iu.g ? iu.g(this, n) : iu.call(null, this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return O4(this.A, n, this.A[this.i], this.i + 1);
};
A.Ea = function(e, n, t) {
  return O4(this.A, n, t, this.i);
};
A.Ba = function() {
  return this.A[this.i];
};
A.Fa = function() {
  return this.i + 1 < this.A.length ? new hn(this.A, this.i + 1, null) : fl;
};
A.W = function() {
  return this.i < this.A.length ? this : null;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new hn(this.A, this.i, n);
};
A.aa = function(e, n) {
  return kt.g ? kt.g(n, this) : kt.call(null, n, this);
};
hn.prototype[Li] = function() {
  return ti(this);
};
A = Qf.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn.h ? Cn.h(this) : Cn.call(null, this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return 0 < this.i ? new Qf(this.cd, this.i - 1, null) : null;
};
A.$ = function() {
  return this.i + 1;
};
A.O = function() {
  return qu(this);
};
A.N = function(e, n) {
  return iu.g ? iu.g(this, n) : iu.call(null, this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return ja ? ja(n, this) : gK.call(null, n, this);
};
A.Ea = function(e, n, t) {
  return nc ? nc(n, t, this) : gK.call(null, n, t, this);
};
A.Ba = function() {
  return Ul(this.cd, this.i);
};
A.Fa = function() {
  return 0 < this.i ? new Qf(this.cd, this.i - 1, null) : fl;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new Qf(this.cd, this.i, n);
};
A.aa = function(e, n) {
  return kt.g ? kt.g(n, this) : kt.call(null, n, this);
};
Qf.prototype[Li] = function() {
  return ti(this);
};
py._ = function(e, n) {
  return e === n;
};
var yt = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
yt.o = function() {
  return Dt;
};
yt.h = function(e) {
  return e;
};
yt.g = function(e, n) {
  return e != null ? Qo(e, n) : new g(null, n, null, 1, null);
};
yt.l = function(e, n, t) {
  for (; ; ) if (j(t)) e = yt.g(e, n), n = I(t), t = W(t);
  else return yt.g(e, n);
};
yt.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
yt.m = 2;
var O = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
O.g = function(e, n) {
  if (typeof n != "number") throw Error("Index argument to nth must be a number");
  if (e == null) return e;
  if (e != null && (e.C & 16 || Rn === e.be)) return e.Y(null, n);
  if (ra(e)) {
    if (-1 < n && n < e.length) return e[n | 0];
    throw Error("Index out of bounds");
  }
  if (typeof e == "string") {
    if (-1 < n && n < e.length) return e.charAt(n | 0);
    throw Error("Index out of bounds");
  }
  if (e != null && (e.C & 64 || Rn === e.V) || e != null && (e.C & 16777216 || Rn === e.ke)) {
    if (0 > n) throw Error("Index out of bounds");
    e: for (; ; ) {
      if (e == null) throw Error("Index out of bounds");
      if (n === 0) {
        if (z(e)) {
          e = I(e);
          break e;
        }
        throw Error("Index out of bounds");
      }
      if (yL(e)) {
        e = Ul(e, n);
        break e;
      }
      if (z(e)) e = W(e), --n;
      else throw Error("Index out of bounds");
    }
    return e;
  }
  if (pl(CO, e)) return Ul(e, n);
  throw Error(["nth not supported on this type ", ye.h(rK(zh(e)))].join(""));
};
O.j = function(e, n, t) {
  if (typeof n != "number") throw Error("Index argument to nth must be a number.");
  if (e == null) return t;
  if (e != null && (e.C & 16 || Rn === e.be)) return e.Wa(null, n, t);
  if (ra(e)) return -1 < n && n < e.length ? e[n | 0] : t;
  if (typeof e == "string") return -1 < n && n < e.length ? e.charAt(n | 0) : t;
  if (e != null && (e.C & 64 || Rn === e.V) || e != null && (e.C & 16777216 || Rn === e.ke)) return 0 > n ? t : Afe(e, n, t);
  if (pl(CO, e)) return Ul(e, n, t);
  throw Error(["nth not supported on this type ", ye.h(rK(zh(e)))].join(""));
};
O.m = 3;
var en = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
en.g = function(e, n) {
  return e == null ? null : e != null && (e.C & 256 || Rn === e.Qe) ? e.wa(null, n) : ra(e) ? n != null && n < e.length ? e[n | 0] : null : typeof e == "string" ? n != null && -1 < n && n < e.length ? e.charAt(n | 0) : null : pl(iK, e) ? zo(e, n) : null;
};
en.j = function(e, n, t) {
  return e != null ? e != null && (e.C & 256 || Rn === e.Qe) ? e.P(null, n, t) : ra(e) ? n != null && -1 < n && n < e.length ? e[n | 0] : t : typeof e == "string" ? n != null && -1 < n && n < e.length ? e.charAt(n | 0) : t : pl(iK, e) ? zo(e, n, t) : t : t;
};
en.m = 3;
var Dn = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
Dn.j = function(e, n, t) {
  return e != null && (e.C & 512 || Rn === e.ae) ? e.Aa(null, n, t) : e != null ? Cw(e, n, t) : Qu([n, t]);
};
Dn.l = function(e, n, t, l) {
  for (; ; ) if (e = Dn.j(e, n, t), j(l)) n = I(l), t = Vr(l), l = va(l);
  else return e;
};
Dn.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
Dn.m = 3;
var nr = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
nr.h = function(e) {
  return e;
};
nr.g = function(e, n) {
  return e == null ? null : $O(e, n);
};
nr.l = function(e, n, t) {
  for (; ; ) {
    if (e == null) return null;
    if (e = nr.g(e, n), j(t)) n = I(t), t = W(t);
    else return e;
  }
};
nr.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
nr.m = 2;
A = xL.prototype;
A.U = function() {
  return this.meta;
};
A.Z = function(e, n) {
  return new xL(this.afn, n);
};
A.$d = Rn;
A.call = function(e) {
  switch (arguments.length - 1) {
    case 0:
      return this.o();
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    case 3:
      return this.j(arguments[1], arguments[2], arguments[3]);
    case 4:
      return this.B(arguments[1], arguments[2], arguments[3], arguments[4]);
    case 5:
      return this.I(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    case 6:
      return this.T(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
    case 7:
      return this.ba(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7]
      );
    case 8:
      return this.ia(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8]);
    case 9:
      return this.va(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9]);
    case 10:
      return this.la(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10]);
    case 11:
      return this.ma(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11]);
    case 12:
      return this.na(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12]);
    case 13:
      return this.oa(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13]
      );
    case 14:
      return this.pa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14]);
    case 15:
      return this.qa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15]);
    case 16:
      return this.ra(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16]
      );
    case 17:
      return this.sa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15], arguments[16], arguments[17]);
    case 18:
      return this.ta(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18]
      );
    case 19:
      return this.ua(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15], arguments[16], arguments[17], arguments[18], arguments[19]);
    case 20:
      return this.Va(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18],
        arguments[19],
        arguments[20]
      );
    case 21:
      return this.Vb(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18],
        arguments[19],
        arguments[20],
        arguments[21]
      );
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.o = function() {
  return this.afn.o ? this.afn.o() : this.afn.call(null);
};
A.h = function(e) {
  return this.afn.h ? this.afn.h(e) : this.afn.call(null, e);
};
A.g = function(e, n) {
  return this.afn.g ? this.afn.g(e, n) : this.afn.call(null, e, n);
};
A.j = function(e, n, t) {
  return this.afn.j ? this.afn.j(e, n, t) : this.afn.call(null, e, n, t);
};
A.B = function(e, n, t, l) {
  return this.afn.B ? this.afn.B(e, n, t, l) : this.afn.call(null, e, n, t, l);
};
A.I = function(e, n, t, l, r) {
  return this.afn.I ? this.afn.I(e, n, t, l, r) : this.afn.call(null, e, n, t, l, r);
};
A.T = function(e, n, t, l, r, u) {
  return this.afn.T ? this.afn.T(e, n, t, l, r, u) : this.afn.call(null, e, n, t, l, r, u);
};
A.ba = function(e, n, t, l, r, u, o) {
  return this.afn.ba ? this.afn.ba(e, n, t, l, r, u, o) : this.afn.call(null, e, n, t, l, r, u, o);
};
A.ia = function(e, n, t, l, r, u, o, a) {
  return this.afn.ia ? this.afn.ia(e, n, t, l, r, u, o, a) : this.afn.call(null, e, n, t, l, r, u, o, a);
};
A.va = function(e, n, t, l, r, u, o, a, h) {
  return this.afn.va ? this.afn.va(e, n, t, l, r, u, o, a, h) : this.afn.call(null, e, n, t, l, r, u, o, a, h);
};
A.la = function(e, n, t, l, r, u, o, a, h, s) {
  return this.afn.la ? this.afn.la(e, n, t, l, r, u, o, a, h, s) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s);
};
A.ma = function(e, n, t, l, r, u, o, a, h, s, d) {
  return this.afn.ma ? this.afn.ma(e, n, t, l, r, u, o, a, h, s, d) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s, d);
};
A.na = function(e, n, t, l, r, u, o, a, h, s, d, p) {
  return this.afn.na ? this.afn.na(e, n, t, l, r, u, o, a, h, s, d, p) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s, d, p);
};
A.oa = function(e, n, t, l, r, u, o, a, h, s, d, p, _) {
  return this.afn.oa ? this.afn.oa(e, n, t, l, r, u, o, a, h, s, d, p, _) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _);
};
A.pa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R) {
  return this.afn.pa ? this.afn.pa(e, n, t, l, r, u, o, a, h, s, d, p, _, R) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R);
};
A.qa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F) {
  return this.afn.qa ? this.afn.qa(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F);
};
A.ra = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L) {
  return this.afn.ra ? this.afn.ra(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L);
};
A.sa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G) {
  return this.afn.sa ? this.afn.sa(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G);
};
A.ta = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J) {
  return this.afn.ta ? this.afn.ta(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J);
};
A.ua = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we) {
  return this.afn.ua ? this.afn.ua(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we);
};
A.Va = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce) {
  return this.afn.Va ? this.afn.Va(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce) : this.afn.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce);
};
A.Vb = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe) {
  return In.wd ? In.wd(this.afn, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe) : In.call(null, this.afn, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe);
};
var Aa = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Aa.h = function(e) {
  return e;
};
Aa.g = function(e, n) {
  return e == null ? null : qD(e, n);
};
Aa.l = function(e, n, t) {
  for (; ; ) {
    if (e == null) return null;
    if (e = Aa.g(e, n), j(t)) n = I(t), t = W(t);
    else return e;
  }
};
Aa.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Aa.m = 2;
var S2 = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(new hn(t.slice(0), 0, null));
  }
};
S2.o = function() {
  return {};
};
S2.l = function(e) {
  return In.g ? In.g(BD, e) : In.call(null, BD, e);
};
S2.v = function(e) {
  return this.l(z(e));
};
S2.m = 0;
var Da = {}, O1 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
O1.h = function() {
  return !0;
};
O1.g = function(e, n) {
  return !on.g(e, n);
};
O1.l = function(e, n, t) {
  if (on.g(e, n)) return !1;
  for (e = Rp([e, n]), n = t; ; ) {
    var l = I(n);
    if (t = W(n), j(n)) {
      if (Ol(e, l)) return !1;
      e = yt.g(e, l), n = t;
    } else return !0;
  }
};
O1.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
O1.m = 2;
var Lf = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Lf.h = function(e) {
  return Lf.g(Gh, e);
};
Lf.g = function(e, n) {
  if (z(n)) {
    var t = Sc.h ? Sc.h(n) : Sc.call(null, n);
    return Tfe(t, EL(e)), Bl(z(t), Vt(n));
  }
  return fl;
};
Lf.m = 2;
var Ry = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Ry.g = function(e, n) {
  return Ry.j(e, Gh, n);
};
Ry.j = function(e, n, t) {
  return Lf.g(function(l, r) {
    l = e.h ? e.h(l) : e.call(null, l), r = e.h ? e.h(r) : e.call(null, r);
    var u = EL(n);
    return u.g ? u.g(l, r) : u.call(null, l, r);
  }, t);
};
Ry.m = 3;
var wt = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
wt.g = function(e, n) {
  return n != null && (n.C & 524288 || Rn === n.Se) ? n.Da(null, e) : ra(n) || typeof n == "string" ? LY(n, e) : pl(uK, n) ? Gd(n, e) : wL(n) ? wK(n, e) : ja(e, n);
};
wt.j = function(e, n, t) {
  return t != null && (t.C & 524288 || Rn === t.Se) ? t.Ea(null, e, n) : ra(t) || typeof t == "string" ? BY(t, e, n) : pl(uK, t) ? Gd(t, e, n) : wL(t) ? vK(t, e, n) : nc(e, n, t);
};
wt.m = 3;
var Zw = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Zw.h = function(e) {
  return Zw.g(e, No);
};
Zw.g = function(e, n) {
  return function() {
    function t(o, a) {
      return e.g ? e.g(o, a) : e.call(null, o, a);
    }
    function l(o) {
      return n.h ? n.h(o) : n.call(null, o);
    }
    function r() {
      return e.o ? e.o() : e.call(null);
    }
    var u = null;
    return u = function(o, a) {
      switch (arguments.length) {
        case 0:
          return r.call(this);
        case 1:
          return l.call(this, o);
        case 2:
          return t.call(this, o, a);
      }
      throw Error("Invalid arity: " + arguments.length);
    }, u.o = r, u.h = l, u.g = t, u;
  }();
};
Zw.m = 2;
var pp = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
pp.j = function(e, n, t) {
  return pp.B(e, n, n.o ? n.o() : n.call(null), t);
};
pp.B = function(e, n, t, l) {
  return e = e.h ? e.h(n) : e.call(null, n), t = wt.j(e, t, l), e.h ? e.h(t) : e.call(null, t);
};
pp.m = 4;
var rc = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
rc.o = function() {
  return 0;
};
rc.h = function(e) {
  return e;
};
rc.g = function(e, n) {
  return e + n;
};
rc.l = function(e, n, t) {
  return wt.j(rc, e + n, t);
};
rc.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
rc.m = 2;
var Lc = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Lc.h = function(e) {
  return -e;
};
Lc.g = function(e, n) {
  return e - n;
};
Lc.l = function(e, n, t) {
  return wt.j(Lc, e - n, t);
};
Lc.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Lc.m = 2;
var mp = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
mp.o = function() {
  return 1;
};
mp.h = function(e) {
  return e;
};
mp.g = function(e, n) {
  return e * n;
};
mp.l = function(e, n, t) {
  return wt.j(mp, e * n, t);
};
mp.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
mp.m = 2;
var Um = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Um.h = function(e) {
  return 1 / e;
};
Um.g = function(e, n) {
  return e / n;
};
Um.l = function(e, n, t) {
  return wt.j(Um, e / n, t);
};
Um.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Um.m = 2;
var qm = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
qm.h = function() {
  return !0;
};
qm.g = function(e, n) {
  return e < n;
};
qm.l = function(e, n, t) {
  for (; ; ) if (e < n) if (W(t)) e = n, n = I(t), t = W(t);
  else return n < I(t);
  else return !1;
};
qm.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
qm.m = 2;
var Wm = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Wm.h = function() {
  return !0;
};
Wm.g = function(e, n) {
  return e <= n;
};
Wm.l = function(e, n, t) {
  for (; ; ) if (e <= n) if (W(t)) e = n, n = I(t), t = W(t);
  else return n <= I(t);
  else return !1;
};
Wm.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Wm.m = 2;
var Hm = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Hm.h = function() {
  return !0;
};
Hm.g = function(e, n) {
  return e > n;
};
Hm.l = function(e, n, t) {
  for (; ; ) if (e > n) if (W(t)) e = n, n = I(t), t = W(t);
  else return n > I(t);
  else return !1;
};
Hm.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Hm.m = 2;
var zm = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
zm.h = function() {
  return !0;
};
zm.g = function(e, n) {
  return e >= n;
};
zm.l = function(e, n, t) {
  for (; ; ) if (e >= n) if (W(t)) e = n, n = I(t), t = W(t);
  else return n >= I(t);
  else return !1;
};
zm.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
zm.m = 2;
var Bf = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Bf.h = function(e) {
  return e;
};
Bf.g = function(e, n) {
  return e > n ? e : n;
};
Bf.l = function(e, n, t) {
  return wt.j(Bf, e > n ? e : n, t);
};
Bf.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Bf.m = 2;
var Km = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Km.h = function(e) {
  return e;
};
Km.g = function(e, n) {
  return e < n ? e : n;
};
Km.l = function(e, n, t) {
  return wt.j(Km, e < n ? e : n, t);
};
Km.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Km.m = 2;
var gp = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
gp.o = function() {
  return 0;
};
gp.h = function(e) {
  return e;
};
gp.g = function(e, n) {
  return e + n;
};
gp.l = function(e, n, t) {
  return wt.j(gp, e + n, t);
};
gp.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
gp.m = 2;
var wp = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
wp.o = function() {
  return 0;
};
wp.h = function(e) {
  return e;
};
wp.g = function(e, n) {
  return e + n;
};
wp.l = function(e, n, t) {
  return wt.j(wp, e + n, t);
};
wp.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
wp.m = 2;
var Gm = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Gm.h = function(e) {
  return 1 / e;
};
Gm.g = function(e, n) {
  return e / n;
};
Gm.l = function(e, n, t) {
  return wt.j(Gm, e / n, t);
};
Gm.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Gm.m = 2;
var vp = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
vp.o = function() {
  return 1;
};
vp.h = function(e) {
  return e;
};
vp.g = function(e, n) {
  return e * n;
};
vp.l = function(e, n, t) {
  return wt.j(vp, e * n, t);
};
vp.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
vp.m = 2;
var yp = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
yp.o = function() {
  return 1;
};
yp.h = function(e) {
  return e;
};
yp.g = function(e, n) {
  return e * n;
};
yp.l = function(e, n, t) {
  return wt.j(yp, e * n, t);
};
yp.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
yp.m = 2;
var Zm = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Zm.h = function(e) {
  return -e;
};
Zm.g = function(e, n) {
  return e - n;
};
Zm.l = function(e, n, t) {
  return wt.j(Zm, e - n, t);
};
Zm.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Zm.m = 2;
var Xm = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Xm.h = function(e) {
  return -e;
};
Xm.g = function(e, n) {
  return e - n;
};
Xm.l = function(e, n, t) {
  return wt.j(Xm, e - n, t);
};
Xm.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Xm.m = 2;
var Xw = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Xw.g = function(e, n) {
  return e ^ n;
};
Xw.l = function(e, n, t) {
  return wt.j(Xw, e ^ n, t);
};
Xw.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Xw.m = 2;
var Qw = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Qw.g = function(e, n) {
  return e & n;
};
Qw.l = function(e, n, t) {
  return wt.j(Qw, e & n, t);
};
Qw.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Qw.m = 2;
var Jw = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Jw.g = function(e, n) {
  return e | n;
};
Jw.l = function(e, n, t) {
  return wt.j(Jw, e | n, t);
};
Jw.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Jw.m = 2;
var e1 = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
e1.g = function(e, n) {
  return e & ~n;
};
e1.l = function(e, n, t) {
  return wt.j(e1, e & ~n, t);
};
e1.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
e1.m = 2;
var Ec = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Ec.h = function() {
  return !0;
};
Ec.g = function(e, n) {
  return py(e, n);
};
Ec.l = function(e, n, t) {
  for (; ; ) if (e === n) if (W(t)) e = n, n = I(t), t = W(t);
  else return n === I(t);
  else return !1;
};
Ec.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Ec.m = 2;
var ye = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], new hn(t.slice(1), 0, null));
  }
};
ye.o = function() {
  return "";
};
ye.h = function(e) {
  return e == null ? "" : [e].join("");
};
ye.l = function(e, n) {
  for (e = new Ts(ye.h(e)); ; ) if (j(n)) e = e.append(ye.h(I(n))), n = W(n);
  else return e.toString();
};
ye.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
ye.m = 1;
var Si = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Si.g = function(e, n) {
  return e.substring(n);
};
Si.j = function(e, n, t) {
  return e.substring(n, t);
};
Si.m = 3;
A = g.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, this.count);
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return this.count === 1 ? null : this.rest;
};
A.$ = function() {
  return this.count;
};
A.Xb = function() {
  return this.first;
};
A.Yb = function() {
  return this.Fa(null);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return su(fl, this.meta);
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  return nc(n, t, this);
};
A.Ba = function() {
  return this.first;
};
A.Fa = function() {
  return this.count === 1 ? fl : this.rest;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new g(n, this.first, this.rest, this.count, this.H);
};
A.aa = function(e, n) {
  return new g(this.meta, n, this, this.count + 1, null);
};
g.prototype[Li] = function() {
  return ti(this);
};
A = a2.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return null;
};
A.$ = function() {
  return 0;
};
A.Xb = function() {
  return null;
};
A.Yb = function() {
  throw Error("Can't pop empty list");
};
A.O = function() {
  return wB;
};
A.N = function(e, n) {
  return o2(n) || Fw(n) ? z(n) == null : !1;
};
A.ha = function() {
  return this;
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  return nc(n, t, this);
};
A.Ba = function() {
  return null;
};
A.Fa = function() {
  return fl;
};
A.W = function() {
  return null;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new a2(n);
};
A.aa = function(e, n) {
  return new g(this.meta, n, null, 1, null);
};
var fl = new a2(null);
a2.prototype[Li] = function() {
  return ti(this);
};
var ue = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
ue.l = function(e) {
  if (e instanceof hn && e.i === 0) var n = e.A;
  else e: for (n = []; ; ) if (e != null) n.push(Er(e)), e = YD(e);
  else break e;
  e = n.length;
  for (var t = fl; ; ) if (0 < e) {
    var l = e - 1;
    t = Qo(t, n[e - 1]), e = l;
  } else return t;
};
ue.m = 0;
ue.v = function(e) {
  return this.l(z(e));
};
A = hp.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return this.rest == null ? null : z(this.rest);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  return nc(n, t, this);
};
A.Ba = function() {
  return this.first;
};
A.Fa = function() {
  return this.rest == null ? fl : this.rest;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new hp(n, this.first, this.rest, this.H);
};
A.aa = function(e, n) {
  return new hp(null, n, this, null);
};
hp.prototype[Li] = function() {
  return ti(this);
};
A = de.prototype;
A.toString = function() {
  return [":", ye.h(this.ca)].join("");
};
A.N = function(e, n) {
  return n instanceof de ? this.ca === n.ca : !1;
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return en.g(e, this);
};
A.g = function(e, n) {
  return en.j(e, this, n);
};
A.O = function() {
  var e = this.wc;
  return e ?? (this.wc = e = gL(this) + 2654435769 | 0);
};
A.yc = function() {
  return this.name;
};
A.zc = function() {
  return this.ns;
};
A.R = function(e, n) {
  return Br(n, [":", ye.h(this.ca)].join(""));
};
var ts = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
ts.h = function(e) {
  if (e instanceof de) return e;
  if (e instanceof T) return new de(Yi(e), ml.h ? ml.h(e) : ml.call(null, e), e.Qb, null);
  if (on.g("/", e)) return new de(null, e, e, null);
  if (typeof e == "string") {
    var n = e.split("/");
    return n.length === 2 ? new de(n[0], n[1], e, null) : new de(null, n[0], e, null);
  }
  return null;
};
ts.g = function(e, n) {
  return e = e instanceof de || e instanceof T ? ml.h ? ml.h(e) : ml.call(null, e) : e, n = n instanceof de || n instanceof T ? ml.h ? ml.h(n) : ml.call(null, n) : n, new de(e, n, [j(e) ? [ye.h(e), "/"].join("") : null, ye.h(n)].join(""), null);
};
ts.m = 2;
A = rr.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return this.W(null), this.X == null ? null : W(this.X);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return su(fl, this.meta);
};
A.Ac = function() {
  return er(this.ka);
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  return nc(n, t, this);
};
A.Ba = function() {
  return this.W(null), this.X == null ? null : I(this.X);
};
A.Fa = function() {
  return this.W(null), this.X != null ? tn(this.X) : fl;
};
A.W = function() {
  if (xU(this), this.X == null) return null;
  for (var e = this.X; ; ) if (e instanceof rr) e = xU(e);
  else return this.X = e, z(this.X);
};
A.Z = function(e, n) {
  var t = this;
  return n === this.meta ? t : new rr(n, function() {
    return t.W(null);
  }, null, this.H);
};
A.aa = function(e, n) {
  return kt(n, this);
};
rr.prototype[Li] = function() {
  return ti(this);
};
k4.prototype.add = function(e) {
  return this.nc[this.end] = e, this.end += 1;
};
k4.prototype.chunk = function() {
  var e = new Vw(this.nc, 0, this.end);
  return this.nc = null, e;
};
k4.prototype.$ = function() {
  return this.end;
};
A = Vw.prototype;
A.$ = function() {
  return this.end - this.off;
};
A.Y = function(e, n) {
  return this.A[this.off + n];
};
A.Wa = function(e, n, t) {
  return 0 <= n && n < this.end - this.off ? this.A[this.off + n] : t;
};
A.vd = function() {
  if (this.off === this.end) throw Error("-drop-first of empty chunk");
  return new Vw(this.A, this.off + 1, this.end);
};
A.Da = function(e, n) {
  return O4(this.A, n, this.A[this.off], this.off + 1);
};
A.Ea = function(e, n, t) {
  return O4(this.A, n, t, this.off);
};
A = sg.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return 1 < Kh(this.chunk) ? new sg(qO(this.chunk), this.Ib, null, null) : this.Ib == null ? null : tx(this.Ib);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Ba = function() {
  return Ul(this.chunk, 0);
};
A.Fa = function() {
  return 1 < Kh(this.chunk) ? new sg(qO(this.chunk), this.Ib, null, null) : this.Ib == null ? fl : this.Ib;
};
A.W = function() {
  return this;
};
A.Mc = function() {
  return this.chunk;
};
A.ic = function() {
  return this.Ib == null ? fl : this.Ib;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new sg(this.chunk, this.Ib, n, this.H);
};
A.aa = function(e, n) {
  return kt(n, this);
};
A.Lc = function() {
  return this.Ib == null ? null : this.Ib;
};
sg.prototype[Li] = function() {
  return ti(this);
};
var Ny = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Ny.h = function(e) {
  return typeof e == "number" ? Ny.g(e, null) : Fs.h(e);
};
Ny.g = function(e, n) {
  var t = Array(e);
  if (ei(n)) {
    var l = 0;
    for (n = z(n); ; ) if (n && l < e) t[l] = I(n), l += 1, n = W(n);
    else return t;
  } else {
    for (l = 0; l < e; ) t[l] = n, l += 1;
    return t;
  }
};
Ny.m = 2;
var Cy = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Cy.h = function(e) {
  return typeof e == "number" ? Cy.g(e, null) : Fs.h(e);
};
Cy.g = function(e, n) {
  var t = Array(e);
  if (ei(n)) {
    var l = 0;
    for (n = z(n); ; ) if (n && l < e) t[l] = I(n), l += 1, n = W(n);
    else return t;
  } else {
    for (l = 0; l < e; ) t[l] = n, l += 1;
    return t;
  }
};
Cy.m = 2;
var My = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
My.h = function(e) {
  return typeof e == "number" ? My.g(e, null) : Fs.h(e);
};
My.g = function(e, n) {
  var t = Array(e);
  if (ei(n)) {
    var l = 0;
    for (n = z(n); ; ) if (n && l < e) t[l] = I(n), l += 1, n = W(n);
    else return t;
  } else {
    for (l = 0; l < e; ) t[l] = n, l += 1;
    return t;
  }
};
My.m = 2;
var Gl = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Gl.h = function(e) {
  return typeof e == "number" ? Gl.g(e, null) : Fs.h(e);
};
Gl.g = function(e, n) {
  var t = Array(e);
  if (ei(n)) {
    var l = 0;
    for (n = z(n); ; ) if (n && l < e) t[l] = I(n), l += 1, n = W(n);
    else return t;
  } else {
    for (l = 0; l < e; ) t[l] = n, l += 1;
    return t;
  }
};
Gl.m = 2;
var FI = function e(n) {
  if (n == null) return null;
  var t = W(n);
  return t == null ? z(I(n)) : kt(I(n), e.h ? e.h(t) : e.call(null, t));
}, he = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
he.o = function() {
  return new rr(null, function() {
    return null;
  }, null, null);
};
he.h = function(e) {
  return new rr(null, function() {
    return e;
  }, null, null);
};
he.g = function(e, n) {
  return new rr(null, function() {
    var t = z(e);
    return t ? oi(t) ? js(Jr(t), he.g(Wr(t), n)) : kt(I(t), he.g(tn(t), n)) : n;
  }, null, null);
};
he.l = function(e, n, t) {
  return function l(r, u) {
    return new rr(null, function() {
      var o = z(r);
      return o ? oi(o) ? js(Jr(o), l(Wr(o), u)) : kt(I(o), l(tn(o), u)) : j(u) ? l(I(u), W(u)) : null;
    }, null, null);
  }(he.g(e, n), t);
};
he.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
he.m = 2;
var us = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], arguments[3], new hn(t.slice(4), 0, null));
  }
};
us.h = function(e) {
  return z(e);
};
us.g = function(e, n) {
  return kt(e, n);
};
us.j = function(e, n, t) {
  return kt(e, kt(n, t));
};
us.B = function(e, n, t, l) {
  return kt(e, kt(n, kt(t, l)));
};
us.l = function(e, n, t, l, r) {
  return kt(e, kt(n, kt(t, kt(l, FI(r)))));
};
us.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
us.m = 4;
var to = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
to.o = function() {
  return ou(Dt);
};
to.h = function(e) {
  return e;
};
to.g = function(e, n) {
  return Rm(e, n);
};
to.l = function(e, n, t) {
  for (; ; ) if (e = Rm(e, n), j(t)) n = I(t), t = W(t);
  else return e;
};
to.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
to.m = 2;
var ao = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
ao.j = function(e, n, t) {
  return Pw(e, n, t);
};
ao.l = function(e, n, t, l) {
  for (; ; ) if (e = Pw(e, n, t), j(l)) n = I(l), t = Vr(l), l = va(l);
  else return e;
};
ao.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
ao.m = 3;
var E2 = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
E2.g = function(e, n) {
  return YO(e, n);
};
E2.l = function(e, n, t) {
  for (; ; ) if (e = YO(e, n), j(t)) n = I(t), t = W(t);
  else return e;
};
E2.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
E2.m = 2;
var X3 = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
X3.g = function(e, n) {
  return UO(e, n);
};
X3.l = function(e, n, t) {
  for (; ; ) if (e = UO(e, n), j(t)) n = I(t), t = W(t);
  else return e;
};
X3.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
X3.m = 2;
var In = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    case 5:
      return e.I(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], new hn(t.slice(5), 0, null));
  }
};
In.g = function(e, n) {
  if (e.v) {
    var t = e.m, l = c2(t + 1, n);
    return l <= t ? j3(e, l, n) : e.v(n);
  }
  return n = z(n), n == null ? e.o ? e.o() : e.call(e) : _K(e, Er(n), b4(n));
};
In.j = function(e, n, t) {
  if (e.v) {
    n = us.g(n, t);
    var l = e.m;
    return t = c2(l, t) + 1, t <= l ? j3(e, t, n) : e.v(n);
  }
  return _K(e, n, z(t));
};
In.B = function(e, n, t, l) {
  return e.v ? (n = us.j(n, t, l), t = e.m, l = 2 + c2(t - 1, l), l <= t ? j3(e, l, n) : e.v(n)) : xK(e, n, t, z(l));
};
In.I = function(e, n, t, l, r) {
  return e.v ? (n = us.B(n, t, l, r), t = e.m, r = 3 + c2(t - 2, r), r <= t ? j3(e, r, n) : e.v(n)) : SK(e, n, t, l, z(r));
};
In.l = function(e, n, t, l, r, u) {
  return e.v ? (u = FI(u), n = kt(n, kt(t, kt(l, kt(r, u)))), t = e.m, u = 4 + c2(t - 3, u), u <= t ? j3(e, u, n) : e.v(n)) : EK(e, n, t, l, r, FI(u));
};
In.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  l = I(r);
  var u = W(r);
  return r = I(u), u = W(u), this.l(n, e, t, l, r, u);
};
In.m = 5;
var wu = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    case 5:
      return e.I(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    case 6:
      return e.T(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(
        arguments[0],
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        new hn(t.slice(6), 0, null)
      );
  }
};
wu.g = function(e, n) {
  var t = Vt(e);
  return n = n.h ? n.h(t) : n.call(null, t), Bl(e, n);
};
wu.j = function(e, n, t) {
  var l = Vt(e);
  return n = n.g ? n.g(l, t) : n.call(null, l, t), Bl(e, n);
};
wu.B = function(e, n, t, l) {
  var r = Vt(e);
  return n = n.j ? n.j(r, t, l) : n.call(null, r, t, l), Bl(e, n);
};
wu.I = function(e, n, t, l, r) {
  var u = Vt(e);
  return n = n.B ? n.B(u, t, l, r) : n.call(null, u, t, l, r), Bl(e, n);
};
wu.T = function(e, n, t, l, r, u) {
  var o = Vt(e);
  return n = n.I ? n.I(o, t, l, r, u) : n.call(null, o, t, l, r, u), Bl(e, n);
};
wu.l = function(e, n, t, l, r, u, o) {
  return Bl(e, In.l(n, Vt(e), t, l, r, Te([u, o])));
};
wu.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  l = I(r);
  var u = W(r);
  r = I(u);
  var o = W(u);
  return u = I(o), o = W(o), this.l(n, e, t, l, r, u, o);
};
wu.m = 6;
var xa = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
xa.h = function() {
  return !1;
};
xa.g = function(e, n) {
  return !on.g(e, n);
};
xa.l = function(e, n, t) {
  return er(In.B(on, e, n, t));
};
xa.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
xa.m = 2;
A = kL.prototype;
A.Z = function(e, n) {
  return new kL(n);
};
A.U = function() {
  return this.df;
};
A.ja = function() {
  return !1;
};
A.next = function() {
  return Error("No such element");
};
A.remove = function() {
  return Error("Unsupported operation");
};
T4.prototype.ja = function() {
  return this.i < this.X.length;
};
T4.prototype.next = function() {
  var e = this.X.charAt(this.i);
  return this.i += 1, e;
};
T4.prototype.remove = function() {
  return Error("Unsupported operation");
};
j4.prototype.ja = function() {
  return this.i < this.A.length;
};
j4.prototype.next = function() {
  var e = this.A[this.i];
  return this.i += 1, e;
};
j4.prototype.remove = function() {
  return Error("Unsupported operation");
};
var wZ = {}, Fme = {};
A3.prototype.ja = function() {
  return this.Kc === wZ ? (this.Kc = Fme, this.hb = z(this.hb)) : this.Kc === this.hb && (this.hb = W(this.Kc)), this.hb != null;
};
A3.prototype.next = function() {
  if (this.ja()) return this.Kc = this.hb, I(this.hb);
  throw Error("No such element");
};
A3.prototype.remove = function() {
  return Error("Unsupported operation");
};
D3.prototype.add = function(e) {
  return this.qd.push(e), this;
};
D3.prototype.remove = function() {
  return this.qd.shift();
};
D3.prototype.Hc = function() {
  return this.qd.length === 0;
};
D3.prototype.toString = function() {
  return ["Many: ", ye.h(this.qd)].join("");
};
var Qm = {};
I3.prototype.add = function(e) {
  return this.val === Qm ? (this.val = e, this) : new D3([this.val, e]);
};
I3.prototype.remove = function() {
  if (this.val === Qm) throw Error("Removing object from empty buffer");
  var e = this.val;
  return this.val = Qm, e;
};
I3.prototype.Hc = function() {
  return this.val === Qm;
};
I3.prototype.toString = function() {
  return ["Single: ", ye.h(this.val)].join("");
};
R3.prototype.add = function(e) {
  return new I3(e);
};
R3.prototype.remove = function() {
  throw Error("Removing object from empty buffer");
};
R3.prototype.Hc = function() {
  return !0;
};
R3.prototype.toString = function() {
  return "Empty";
};
var Vme = new R3();
bL.prototype.ja = function() {
  for (var e = z(this.Od); ; ) if (e != null) if (I(e).ja()) e = W(e);
  else return !1;
  else return !0;
};
bL.prototype.next = function() {
  for (var e = [], n = this.Od.length, t = 0; t < n; ) e[t] = this.Od[t].next(), t += 1;
  return Te(e);
};
var vZ = function e(n) {
  return new rr(null, function() {
    if (n.ja()) for (var t = [], l = 0; ; ) {
      var r = n.ja();
      if (j(j(r) ? 32 > l : r)) t[l] = n.next(), l += 1;
      else return js(new Vw(t, 0, l), e.h ? e.h(n) : e.call(null, n));
    }
    else return null;
  }, null, null);
};
og.prototype.step = function() {
  if (this.hb !== Qm) return !0;
  for (; ; ) if (this.hb === Qm) if (this.buffer.Hc()) {
    if (this.Nd) return !1;
    if (this.Td.ja()) {
      if (this.ef) var e = In.g(this.Mb, kt(null, this.Td.next()));
      else e = this.Td.next(), e = this.Mb.g ? this.Mb.g(null, e) : this.Mb.call(null, null, e);
      ni(e) && (this.Mb.h ? this.Mb.h(null) : this.Mb.call(null, null), this.Nd = !0);
    } else this.Mb.h ? this.Mb.h(null) : this.Mb.call(null, null), this.Nd = !0;
  } else this.hb = this.buffer.remove();
  else return !0;
};
og.prototype.ja = function() {
  return this.step();
};
og.prototype.next = function() {
  if (this.ja()) {
    var e = this.hb;
    return this.hb = Qm, e;
  }
  throw Error("No such element");
};
og.prototype.remove = function() {
  return Error("Unsupported operation");
};
og.prototype[Li] = function() {
  return ti(this);
};
var ve = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
ve.h = function(e) {
  return ei(e) || (e = z(e)) ? e : fl;
};
ve.g = function(e, n) {
  return n = HO(n), e = TL(e, n, !1), e = vZ(e), j(e) ? e : fl;
};
ve.l = function(e, n, t) {
  return n = kt(n, t), n = bt.g ? bt.g(HO, n) : bt.call(null, HO, n), e = vZ(TL(e, new bL(Sc(n)), !0)), j(e) ? e : fl;
};
ve.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
ve.m = 2;
var ua = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
ua.o = function() {
  return No;
};
ua.h = function(e) {
  return e;
};
ua.g = function(e, n) {
  return function() {
    function t(h, s, d) {
      return h = n.j ? n.j(h, s, d) : n.call(null, h, s, d), e.h ? e.h(h) : e.call(null, h);
    }
    function l(h, s) {
      return h = n.g ? n.g(h, s) : n.call(null, h, s), e.h ? e.h(h) : e.call(null, h);
    }
    function r(h) {
      return h = n.h ? n.h(h) : n.call(null, h), e.h ? e.h(h) : e.call(null, h);
    }
    function u() {
      var h = n.o ? n.o() : n.call(null);
      return e.h ? e.h(h) : e.call(null, h);
    }
    var o = null, a = function() {
      function h(d, p, _, R) {
        var F = null;
        if (3 < arguments.length) {
          F = 0;
          for (var L = Array(arguments.length - 3); F < L.length; ) L[F] = arguments[F + 3], ++F;
          F = new hn(L, 0, null);
        }
        return s.call(this, d, p, _, F);
      }
      function s(d, p, _, R) {
        return d = In.I(n, d, p, _, R), e.h ? e.h(d) : e.call(null, d);
      }
      return h.m = 3, h.v = function(d) {
        var p = I(d);
        d = W(d);
        var _ = I(d);
        d = W(d);
        var R = I(d);
        return d = tn(d), s(p, _, R, d);
      }, h.l = s, h;
    }();
    return o = function(h, s, d, p) {
      switch (arguments.length) {
        case 0:
          return u.call(this);
        case 1:
          return r.call(this, h);
        case 2:
          return l.call(this, h, s);
        case 3:
          return t.call(this, h, s, d);
        default:
          var _ = null;
          if (3 < arguments.length) {
            _ = 0;
            for (var R = Array(arguments.length - 3); _ < R.length; ) R[_] = arguments[_ + 3], ++_;
            _ = new hn(R, 0, null);
          }
          return a.l(h, s, d, _);
      }
    }, o.m = 3, o.v = a.v, o.o = u, o.h = r, o.g = l, o.j = t, o.l = a.l, o;
  }();
};
ua.j = function(e, n, t) {
  return function() {
    function l(s, d, p) {
      return s = t.j ? t.j(s, d, p) : t.call(null, s, d, p), s = n.h ? n.h(s) : n.call(null, s), e.h ? e.h(s) : e.call(null, s);
    }
    function r(s, d) {
      return s = t.g ? t.g(s, d) : t.call(null, s, d), s = n.h ? n.h(s) : n.call(null, s), e.h ? e.h(s) : e.call(null, s);
    }
    function u(s) {
      return s = t.h ? t.h(s) : t.call(null, s), s = n.h ? n.h(s) : n.call(null, s), e.h ? e.h(s) : e.call(null, s);
    }
    function o() {
      var s = t.o ? t.o() : t.call(null);
      return s = n.h ? n.h(s) : n.call(null, s), e.h ? e.h(s) : e.call(null, s);
    }
    var a = null, h = function() {
      function s(p, _, R, F) {
        var L = null;
        if (3 < arguments.length) {
          L = 0;
          for (var G = Array(arguments.length - 3); L < G.length; ) G[L] = arguments[L + 3], ++L;
          L = new hn(G, 0, null);
        }
        return d.call(this, p, _, R, L);
      }
      function d(p, _, R, F) {
        return p = In.I(t, p, _, R, F), p = n.h ? n.h(p) : n.call(null, p), e.h ? e.h(p) : e.call(null, p);
      }
      return s.m = 3, s.v = function(p) {
        var _ = I(p);
        p = W(p);
        var R = I(p);
        p = W(p);
        var F = I(p);
        return p = tn(p), d(_, R, F, p);
      }, s.l = d, s;
    }();
    return a = function(s, d, p, _) {
      switch (arguments.length) {
        case 0:
          return o.call(this);
        case 1:
          return u.call(this, s);
        case 2:
          return r.call(
            this,
            s,
            d
          );
        case 3:
          return l.call(this, s, d, p);
        default:
          var R = null;
          if (3 < arguments.length) {
            R = 0;
            for (var F = Array(arguments.length - 3); R < F.length; ) F[R] = arguments[R + 3], ++R;
            R = new hn(F, 0, null);
          }
          return h.l(s, d, p, R);
      }
    }, a.m = 3, a.v = h.v, a.o = o, a.h = u, a.g = r, a.j = l, a.l = h.l, a;
  }();
};
ua.l = function(e, n, t, l) {
  var r = OL(us.B(e, n, t, l));
  return function() {
    function u(a) {
      var h = null;
      if (0 < arguments.length) {
        h = 0;
        for (var s = Array(arguments.length - 0); h < s.length; ) s[h] = arguments[h + 0], ++h;
        h = new hn(s, 0, null);
      }
      return o.call(this, h);
    }
    function o(a) {
      a = In.g(I(r), a);
      for (var h = W(r); ; ) if (h) {
        var s = I(h);
        a = s.h ? s.h(a) : s.call(null, a), h = W(h);
      } else return a;
    }
    return u.m = 0, u.v = function(a) {
      return a = z(a), o(a);
    }, u.l = o, u;
  }();
};
ua.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
ua.m = 3;
var go = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], arguments[3], new hn(t.slice(4), 0, null));
  }
};
go.h = function(e) {
  return e;
};
go.g = function(e, n) {
  return function() {
    function t(h, s, d) {
      return e.B ? e.B(n, h, s, d) : e.call(null, n, h, s, d);
    }
    function l(h, s) {
      return e.j ? e.j(n, h, s) : e.call(null, n, h, s);
    }
    function r(h) {
      return e.g ? e.g(n, h) : e.call(null, n, h);
    }
    function u() {
      return e.h ? e.h(n) : e.call(null, n);
    }
    var o = null, a = function() {
      function h(d, p, _, R) {
        var F = null;
        if (3 < arguments.length) {
          F = 0;
          for (var L = Array(arguments.length - 3); F < L.length; ) L[F] = arguments[F + 3], ++F;
          F = new hn(L, 0, null);
        }
        return s.call(this, d, p, _, F);
      }
      function s(d, p, _, R) {
        return In.l(e, n, d, p, _, Te([R]));
      }
      return h.m = 3, h.v = function(d) {
        var p = I(d);
        d = W(d);
        var _ = I(d);
        d = W(d);
        var R = I(d);
        return d = tn(d), s(p, _, R, d);
      }, h.l = s, h;
    }();
    return o = function(h, s, d, p) {
      switch (arguments.length) {
        case 0:
          return u.call(this);
        case 1:
          return r.call(this, h);
        case 2:
          return l.call(this, h, s);
        case 3:
          return t.call(this, h, s, d);
        default:
          var _ = null;
          if (3 < arguments.length) {
            _ = 0;
            for (var R = Array(arguments.length - 3); _ < R.length; ) R[_] = arguments[_ + 3], ++_;
            _ = new hn(R, 0, null);
          }
          return a.l(h, s, d, _);
      }
    }, o.m = 3, o.v = a.v, o.o = u, o.h = r, o.g = l, o.j = t, o.l = a.l, o;
  }();
};
go.j = function(e, n, t) {
  return function() {
    function l(s, d, p) {
      return e.I ? e.I(n, t, s, d, p) : e.call(null, n, t, s, d, p);
    }
    function r(s, d) {
      return e.B ? e.B(n, t, s, d) : e.call(null, n, t, s, d);
    }
    function u(s) {
      return e.j ? e.j(n, t, s) : e.call(null, n, t, s);
    }
    function o() {
      return e.g ? e.g(n, t) : e.call(null, n, t);
    }
    var a = null, h = function() {
      function s(p, _, R, F) {
        var L = null;
        if (3 < arguments.length) {
          L = 0;
          for (var G = Array(arguments.length - 3); L < G.length; ) G[L] = arguments[L + 3], ++L;
          L = new hn(G, 0, null);
        }
        return d.call(this, p, _, R, L);
      }
      function d(p, _, R, F) {
        return In.l(
          e,
          n,
          t,
          p,
          _,
          Te([R, F])
        );
      }
      return s.m = 3, s.v = function(p) {
        var _ = I(p);
        p = W(p);
        var R = I(p);
        p = W(p);
        var F = I(p);
        return p = tn(p), d(_, R, F, p);
      }, s.l = d, s;
    }();
    return a = function(s, d, p, _) {
      switch (arguments.length) {
        case 0:
          return o.call(this);
        case 1:
          return u.call(this, s);
        case 2:
          return r.call(this, s, d);
        case 3:
          return l.call(this, s, d, p);
        default:
          var R = null;
          if (3 < arguments.length) {
            R = 0;
            for (var F = Array(arguments.length - 3); R < F.length; ) F[R] = arguments[R + 3], ++R;
            R = new hn(F, 0, null);
          }
          return h.l(s, d, p, R);
      }
    }, a.m = 3, a.v = h.v, a.o = o, a.h = u, a.g = r, a.j = l, a.l = h.l, a;
  }();
};
go.B = function(e, n, t, l) {
  return function() {
    function r(d, p, _) {
      return e.T ? e.T(n, t, l, d, p, _) : e.call(null, n, t, l, d, p, _);
    }
    function u(d, p) {
      return e.I ? e.I(n, t, l, d, p) : e.call(null, n, t, l, d, p);
    }
    function o(d) {
      return e.B ? e.B(n, t, l, d) : e.call(null, n, t, l, d);
    }
    function a() {
      return e.j ? e.j(n, t, l) : e.call(null, n, t, l);
    }
    var h = null, s = function() {
      function d(_, R, F, L) {
        var G = null;
        if (3 < arguments.length) {
          G = 0;
          for (var J = Array(arguments.length - 3); G < J.length; ) J[G] = arguments[G + 3], ++G;
          G = new hn(J, 0, null);
        }
        return p.call(this, _, R, F, G);
      }
      function p(_, R, F, L) {
        return In.l(e, n, t, l, _, Te([R, F, L]));
      }
      return d.m = 3, d.v = function(_) {
        var R = I(_);
        _ = W(_);
        var F = I(_);
        _ = W(_);
        var L = I(_);
        return _ = tn(_), p(R, F, L, _);
      }, d.l = p, d;
    }();
    return h = function(d, p, _, R) {
      switch (arguments.length) {
        case 0:
          return a.call(this);
        case 1:
          return o.call(this, d);
        case 2:
          return u.call(this, d, p);
        case 3:
          return r.call(this, d, p, _);
        default:
          var F = null;
          if (3 < arguments.length) {
            F = 0;
            for (var L = Array(arguments.length - 3); F < L.length; ) L[F] = arguments[F + 3], ++F;
            F = new hn(L, 0, null);
          }
          return s.l(d, p, _, F);
      }
    }, h.m = 3, h.v = s.v, h.o = a, h.h = o, h.g = u, h.j = r, h.l = s.l, h;
  }();
};
go.l = function(e, n, t, l, r) {
  return function() {
    function u(a) {
      var h = null;
      if (0 < arguments.length) {
        h = 0;
        for (var s = Array(arguments.length - 0); h < s.length; ) s[h] = arguments[h + 0], ++h;
        h = new hn(s, 0, null);
      }
      return o.call(this, h);
    }
    function o(a) {
      return In.I(e, n, t, l, he.g(r, a));
    }
    return u.m = 0, u.v = function(a) {
      return a = z(a), o(a);
    }, u.l = o, u;
  }();
};
go.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
go.m = 4;
var Ff = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Ff.g = function(e, n) {
  return function() {
    function t(a, h, s) {
      return a = a ?? n, e.j ? e.j(a, h, s) : e.call(null, a, h, s);
    }
    function l(a, h) {
      return a = a ?? n, e.g ? e.g(a, h) : e.call(null, a, h);
    }
    function r(a) {
      return a = a ?? n, e.h ? e.h(a) : e.call(null, a);
    }
    var u = null, o = function() {
      function a(s, d, p, _) {
        var R = null;
        if (3 < arguments.length) {
          R = 0;
          for (var F = Array(arguments.length - 3); R < F.length; ) F[R] = arguments[R + 3], ++R;
          R = new hn(F, 0, null);
        }
        return h.call(this, s, d, p, R);
      }
      function h(s, d, p, _) {
        return In.I(e, s ?? n, d, p, _);
      }
      return a.m = 3, a.v = function(s) {
        var d = I(s);
        s = W(s);
        var p = I(s);
        s = W(s);
        var _ = I(s);
        return s = tn(s), h(d, p, _, s);
      }, a.l = h, a;
    }();
    return u = function(a, h, s, d) {
      switch (arguments.length) {
        case 1:
          return r.call(this, a);
        case 2:
          return l.call(this, a, h);
        case 3:
          return t.call(this, a, h, s);
        default:
          var p = null;
          if (3 < arguments.length) {
            p = 0;
            for (var _ = Array(arguments.length - 3); p < _.length; ) _[p] = arguments[p + 3], ++p;
            p = new hn(_, 0, null);
          }
          return o.l(a, h, s, p);
      }
    }, u.m = 3, u.v = o.v, u.h = r, u.g = l, u.j = t, u.l = o.l, u;
  }();
};
Ff.j = function(e, n, t) {
  return function() {
    function l(a, h, s) {
      return a = a ?? n, h = h ?? t, e.j ? e.j(a, h, s) : e.call(null, a, h, s);
    }
    function r(a, h) {
      return a = a ?? n, h = h ?? t, e.g ? e.g(a, h) : e.call(null, a, h);
    }
    var u = null, o = function() {
      function a(s, d, p, _) {
        var R = null;
        if (3 < arguments.length) {
          R = 0;
          for (var F = Array(arguments.length - 3); R < F.length; ) F[R] = arguments[R + 3], ++R;
          R = new hn(F, 0, null);
        }
        return h.call(this, s, d, p, R);
      }
      function h(s, d, p, _) {
        return In.I(e, s ?? n, d ?? t, p, _);
      }
      return a.m = 3, a.v = function(s) {
        var d = I(s);
        s = W(s);
        var p = I(s);
        s = W(s);
        var _ = I(s);
        return s = tn(s), h(d, p, _, s);
      }, a.l = h, a;
    }();
    return u = function(a, h, s, d) {
      switch (arguments.length) {
        case 2:
          return r.call(this, a, h);
        case 3:
          return l.call(this, a, h, s);
        default:
          var p = null;
          if (3 < arguments.length) {
            p = 0;
            for (var _ = Array(arguments.length - 3); p < _.length; ) _[p] = arguments[p + 3], ++p;
            p = new hn(_, 0, null);
          }
          return o.l(a, h, s, p);
      }
    }, u.m = 3, u.v = o.v, u.g = r, u.j = l, u.l = o.l, u;
  }();
};
Ff.B = function(e, n, t, l) {
  return function() {
    function r(h, s, d) {
      return h = h ?? n, s = s ?? t, d = d ?? l, e.j ? e.j(h, s, d) : e.call(null, h, s, d);
    }
    function u(h, s) {
      return h = h ?? n, s = s ?? t, e.g ? e.g(h, s) : e.call(null, h, s);
    }
    var o = null, a = function() {
      function h(d, p, _, R) {
        var F = null;
        if (3 < arguments.length) {
          F = 0;
          for (var L = Array(arguments.length - 3); F < L.length; ) L[F] = arguments[F + 3], ++F;
          F = new hn(L, 0, null);
        }
        return s.call(this, d, p, _, F);
      }
      function s(d, p, _, R) {
        return In.I(e, d ?? n, p ?? t, _ ?? l, R);
      }
      return h.m = 3, h.v = function(d) {
        var p = I(d);
        d = W(d);
        var _ = I(d);
        d = W(d);
        var R = I(d);
        return d = tn(d), s(p, _, R, d);
      }, h.l = s, h;
    }();
    return o = function(h, s, d, p) {
      switch (arguments.length) {
        case 2:
          return u.call(this, h, s);
        case 3:
          return r.call(this, h, s, d);
        default:
          var _ = null;
          if (3 < arguments.length) {
            _ = 0;
            for (var R = Array(arguments.length - 3); _ < R.length; ) R[_] = arguments[_ + 3], ++_;
            _ = new hn(R, 0, null);
          }
          return a.l(h, s, d, _);
      }
    }, o.m = 3, o.v = a.v, o.g = u, o.j = r, o.l = a.l, o;
  }();
};
Ff.m = 4;
var Q3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Q3.h = function(e) {
  return function(n) {
    var t = Qi.h ? Qi.h(-1) : Qi.call(null, -1);
    return function() {
      function l(a, h) {
        var s = Yu(t, sn(t) + 1);
        return h = e.g ? e.g(s, h) : e.call(null, s, h), n.g ? n.g(a, h) : n.call(null, a, h);
      }
      function r(a) {
        return n.h ? n.h(a) : n.call(null, a);
      }
      function u() {
        return n.o ? n.o() : n.call(null);
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 0:
            return u.call(this);
          case 1:
            return r.call(this, a);
          case 2:
            return l.call(this, a, h);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.o = u, o.h = r, o.g = l, o;
    }();
  };
};
Q3.g = function(e, n) {
  return function t(l, r) {
    return new rr(null, function() {
      var u = z(r);
      if (u) {
        if (oi(u)) {
          for (var o = Jr(u), a = Cn(o), h = Sh(a), s = 0; s < a; ) T3(h, function() {
            var d = l + s, p = Ul(o, s);
            return e.g ? e.g(d, p) : e.call(null, d, p);
          }()), s += 1;
          return js(mo(h), t(l + a, Wr(u)));
        }
        return kt(function() {
          var d = I(u);
          return e.g ? e.g(l, d) : e.call(null, l, d);
        }(), t(l + 1, tn(u)));
      }
      return null;
    }, null, null);
  }(0, n);
};
Q3.m = 2;
var Tf = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Tf.h = function(e) {
  return function(n) {
    return function() {
      function t(o, a) {
        return a = e.h ? e.h(a) : e.call(null, a), a == null ? o : n.g ? n.g(o, a) : n.call(null, o, a);
      }
      function l(o) {
        return n.h ? n.h(o) : n.call(null, o);
      }
      function r() {
        return n.o ? n.o() : n.call(null);
      }
      var u = null;
      return u = function(o, a) {
        switch (arguments.length) {
          case 0:
            return r.call(this);
          case 1:
            return l.call(this, o);
          case 2:
            return t.call(this, o, a);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, u.o = r, u.h = l, u.g = t, u;
    }();
  };
};
Tf.g = function(e, n) {
  return new rr(null, function() {
    var t = z(n);
    if (t) {
      if (oi(t)) {
        for (var l = Jr(t), r = Cn(l), u = Sh(r), o = 0; o < r; ) {
          var a = function() {
            var h = Ul(l, o);
            return e.h ? e.h(h) : e.call(null, h);
          }();
          a != null && u.add(a), o += 1;
        }
        return js(mo(u), Tf.g(e, Wr(t)));
      }
      return r = function() {
        var h = I(t);
        return e.h ? e.h(h) : e.call(null, h);
      }(), r == null ? Tf.g(e, tn(t)) : kt(r, Tf.g(e, tn(t)));
    }
    return null;
  }, null, null);
};
Tf.m = 2;
A = Wc.prototype;
A.N = function(e, n) {
  return this === n;
};
A.jb = function() {
  return this.state;
};
A.U = function() {
  return this.meta;
};
A.oe = function(e, n, t) {
  return this.lc = Dn.j(this.lc, n, t), this;
};
A.pe = function(e, n) {
  return this.lc = nr.g(this.lc, n);
};
A.O = function() {
  return pL(this);
};
var kr = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], new hn(t.slice(1), 0, null));
  }
};
kr.h = function(e) {
  return new Wc(e, null, null);
};
kr.l = function(e, n) {
  var t = fr(n);
  return n = en.g(t, Db), t = en.g(t, F_e), new Wc(e, n, t);
};
kr.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
kr.m = 1;
var wr = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], arguments[3], new hn(t.slice(4), 0, null));
  }
};
wr.g = function(e, n) {
  if (e instanceof Wc) {
    var t = e.state;
    n = n.h ? n.h(t) : n.call(null, t), e = Qa(e, n);
  } else e = Io(e, n);
  return e;
};
wr.j = function(e, n, t) {
  if (e instanceof Wc) {
    var l = e.state;
    n = n.g ? n.g(l, t) : n.call(null, l, t), e = Qa(e, n);
  } else e = Io(e, n, t);
  return e;
};
wr.B = function(e, n, t, l) {
  if (e instanceof Wc) {
    var r = e.state;
    n = n.j ? n.j(r, t, l) : n.call(null, r, t, l), e = Qa(e, n);
  } else e = Io(e, n, t, l);
  return e;
};
wr.l = function(e, n, t, l, r) {
  return e instanceof Wc ? Qa(e, In.I(n, e.state, t, l, r)) : Io(e, n, t, l, r);
};
wr.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
wr.m = 4;
N3.prototype.Nb = function(e, n) {
  return this.state = n;
};
N3.prototype.jb = function() {
  return this.state;
};
var O2 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
O2.h = function(e) {
  return function(n) {
    var t = Qi(-1);
    return function() {
      function l(a, h) {
        var s = t.Nb(null, t.jb(null) + 1);
        return h = e.g ? e.g(s, h) : e.call(null, s, h), h == null ? a : n.g ? n.g(a, h) : n.call(null, a, h);
      }
      function r(a) {
        return n.h ? n.h(a) : n.call(null, a);
      }
      function u() {
        return n.o ? n.o() : n.call(null);
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 0:
            return u.call(this);
          case 1:
            return r.call(this, a);
          case 2:
            return l.call(this, a, h);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.o = u, o.h = r, o.g = l, o;
    }();
  };
};
O2.g = function(e, n) {
  return function t(l, r) {
    return new rr(null, function() {
      var u = z(r);
      if (u) {
        if (oi(u)) {
          for (var o = Jr(u), a = Cn(o), h = Sh(a), s = 0; s < a; ) {
            var d = function() {
              var p = l + s, _ = Ul(o, s);
              return e.g ? e.g(p, _) : e.call(null, p, _);
            }();
            d != null && h.add(d), s += 1;
          }
          return js(mo(h), t(l + a, Wr(u)));
        }
        return a = function() {
          var p = I(u);
          return e.g ? e.g(l, p) : e.call(null, l, p);
        }(), a == null ? t(l + 1, tn(u)) : kt(a, t(l + 1, tn(u)));
      }
      return null;
    }, null, null);
  }(0, n);
};
O2.m = 2;
var mf = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
mf.h = function(e) {
  return function() {
    function n(o, a, h) {
      return o = e.h ? e.h(o) : e.call(null, o), j(o) ? (a = e.h ? e.h(a) : e.call(null, a), h = j(a) ? e.h ? e.h(h) : e.call(null, h) : a) : h = o, pu(h);
    }
    function t(o, a) {
      return o = e.h ? e.h(o) : e.call(null, o), a = j(o) ? e.h ? e.h(a) : e.call(null, a) : o, pu(a);
    }
    function l(o) {
      return pu(e.h ? e.h(o) : e.call(null, o));
    }
    var r = null, u = function() {
      function o(h, s, d, p) {
        var _ = null;
        if (3 < arguments.length) {
          _ = 0;
          for (var R = Array(arguments.length - 3); _ < R.length; ) R[_] = arguments[_ + 3], ++_;
          _ = new hn(R, 0, null);
        }
        return a.call(
          this,
          h,
          s,
          d,
          _
        );
      }
      function a(h, s, d, p) {
        return h = r.j(h, s, d), p = j(h) ? hu(e, p) : h, pu(p);
      }
      return o.m = 3, o.v = function(h) {
        var s = I(h);
        h = W(h);
        var d = I(h);
        h = W(h);
        var p = I(h);
        return h = tn(h), a(s, d, p, h);
      }, o.l = a, o;
    }();
    return r = function(o, a, h, s) {
      switch (arguments.length) {
        case 0:
          return !0;
        case 1:
          return l.call(this, o);
        case 2:
          return t.call(this, o, a);
        case 3:
          return n.call(this, o, a, h);
        default:
          var d = null;
          if (3 < arguments.length) {
            d = 0;
            for (var p = Array(arguments.length - 3); d < p.length; ) p[d] = arguments[d + 3], ++d;
            d = new hn(p, 0, null);
          }
          return u.l(o, a, h, d);
      }
    }, r.m = 3, r.v = u.v, r.o = function() {
      return !0;
    }, r.h = l, r.g = t, r.j = n, r.l = u.l, r;
  }();
};
mf.g = function(e, n) {
  return function() {
    function t(a, h, s) {
      return pu(function() {
        var d = e.h ? e.h(a) : e.call(null, a);
        return j(d) ? (d = e.h ? e.h(h) : e.call(null, h), j(d) ? (d = e.h ? e.h(s) : e.call(null, s), j(d) ? (d = n.h ? n.h(a) : n.call(null, a), j(d) ? (d = n.h ? n.h(h) : n.call(null, h), j(d) ? n.h ? n.h(s) : n.call(null, s) : d) : d) : d) : d) : d;
      }());
    }
    function l(a, h) {
      return pu(function() {
        var s = e.h ? e.h(a) : e.call(null, a);
        return j(s) ? (s = e.h ? e.h(h) : e.call(null, h), j(s) ? (s = n.h ? n.h(a) : n.call(null, a), j(s) ? n.h ? n.h(h) : n.call(null, h) : s) : s) : s;
      }());
    }
    function r(a) {
      var h = e.h ? e.h(a) : e.call(null, a);
      return a = j(h) ? n.h ? n.h(a) : n.call(null, a) : h, pu(a);
    }
    var u = null, o = function() {
      function a(s, d, p, _) {
        var R = null;
        if (3 < arguments.length) {
          R = 0;
          for (var F = Array(arguments.length - 3); R < F.length; ) F[R] = arguments[R + 3], ++R;
          R = new hn(F, 0, null);
        }
        return h.call(this, s, d, p, R);
      }
      function h(s, d, p, _) {
        return pu(function() {
          var R = u.j(s, d, p);
          return j(R) ? hu(function(F) {
            var L = e.h ? e.h(F) : e.call(null, F);
            return j(L) ? n.h ? n.h(F) : n.call(null, F) : L;
          }, _) : R;
        }());
      }
      return a.m = 3, a.v = function(s) {
        var d = I(s);
        s = W(s);
        var p = I(s);
        s = W(s);
        var _ = I(s);
        return s = tn(s), h(d, p, _, s);
      }, a.l = h, a;
    }();
    return u = function(a, h, s, d) {
      switch (arguments.length) {
        case 0:
          return !0;
        case 1:
          return r.call(this, a);
        case 2:
          return l.call(this, a, h);
        case 3:
          return t.call(this, a, h, s);
        default:
          var p = null;
          if (3 < arguments.length) {
            p = 0;
            for (var _ = Array(arguments.length - 3); p < _.length; ) _[p] = arguments[p + 3], ++p;
            p = new hn(_, 0, null);
          }
          return o.l(a, h, s, p);
      }
    }, u.m = 3, u.v = o.v, u.o = function() {
      return !0;
    }, u.h = r, u.g = l, u.j = t, u.l = o.l, u;
  }();
};
mf.j = function(e, n, t) {
  return function() {
    function l(h, s, d) {
      return pu(function() {
        var p = e.h ? e.h(h) : e.call(null, h);
        return j(p) ? (p = e.h ? e.h(s) : e.call(null, s), j(p) ? (p = e.h ? e.h(d) : e.call(null, d), j(p) ? (p = n.h ? n.h(h) : n.call(null, h), j(p) ? (p = n.h ? n.h(s) : n.call(null, s), j(p) ? (p = n.h ? n.h(d) : n.call(null, d), j(p) ? (p = t.h ? t.h(h) : t.call(null, h), j(p) ? (p = t.h ? t.h(s) : t.call(null, s), j(p) ? t.h ? t.h(d) : t.call(null, d) : p) : p) : p) : p) : p) : p) : p) : p;
      }());
    }
    function r(h, s) {
      return pu(function() {
        var d = e.h ? e.h(h) : e.call(null, h);
        return j(d) ? (d = e.h ? e.h(s) : e.call(null, s), j(d) ? (d = n.h ? n.h(h) : n.call(null, h), j(d) ? (d = n.h ? n.h(s) : n.call(null, s), j(d) ? (d = t.h ? t.h(h) : t.call(null, h), j(d) ? t.h ? t.h(s) : t.call(null, s) : d) : d) : d) : d) : d;
      }());
    }
    function u(h) {
      var s = e.h ? e.h(h) : e.call(null, h);
      return j(s) ? (s = n.h ? n.h(h) : n.call(null, h), h = j(s) ? t.h ? t.h(h) : t.call(null, h) : s) : h = s, pu(h);
    }
    var o = null, a = function() {
      function h(d, p, _, R) {
        var F = null;
        if (3 < arguments.length) {
          F = 0;
          for (var L = Array(arguments.length - 3); F < L.length; ) L[F] = arguments[F + 3], ++F;
          F = new hn(L, 0, null);
        }
        return s.call(
          this,
          d,
          p,
          _,
          F
        );
      }
      function s(d, p, _, R) {
        return pu(function() {
          var F = o.j(d, p, _);
          return j(F) ? hu(function(L) {
            var G = e.h ? e.h(L) : e.call(null, L);
            return j(G) ? (G = n.h ? n.h(L) : n.call(null, L), j(G) ? t.h ? t.h(L) : t.call(null, L) : G) : G;
          }, R) : F;
        }());
      }
      return h.m = 3, h.v = function(d) {
        var p = I(d);
        d = W(d);
        var _ = I(d);
        d = W(d);
        var R = I(d);
        return d = tn(d), s(p, _, R, d);
      }, h.l = s, h;
    }();
    return o = function(h, s, d, p) {
      switch (arguments.length) {
        case 0:
          return !0;
        case 1:
          return u.call(this, h);
        case 2:
          return r.call(this, h, s);
        case 3:
          return l.call(this, h, s, d);
        default:
          var _ = null;
          if (3 < arguments.length) {
            _ = 0;
            for (var R = Array(arguments.length - 3); _ < R.length; ) R[_] = arguments[_ + 3], ++_;
            _ = new hn(R, 0, null);
          }
          return a.l(h, s, d, _);
      }
    }, o.m = 3, o.v = a.v, o.o = function() {
      return !0;
    }, o.h = u, o.g = r, o.j = l, o.l = a.l, o;
  }();
};
mf.l = function(e, n, t, l) {
  var r = us.B(e, n, t, l);
  return function() {
    function u(d, p, _) {
      return hu(function(R) {
        var F = R.h ? R.h(d) : R.call(null, d);
        return j(F) ? (F = R.h ? R.h(p) : R.call(null, p), j(F) ? R.h ? R.h(_) : R.call(null, _) : F) : F;
      }, r);
    }
    function o(d, p) {
      return hu(function(_) {
        var R = _.h ? _.h(d) : _.call(null, d);
        return j(R) ? _.h ? _.h(p) : _.call(null, p) : R;
      }, r);
    }
    function a(d) {
      return hu(function(p) {
        return p.h ? p.h(d) : p.call(null, d);
      }, r);
    }
    var h = null, s = function() {
      function d(_, R, F, L) {
        var G = null;
        if (3 < arguments.length) {
          G = 0;
          for (var J = Array(arguments.length - 3); G < J.length; ) J[G] = arguments[G + 3], ++G;
          G = new hn(J, 0, null);
        }
        return p.call(this, _, R, F, G);
      }
      function p(_, R, F, L) {
        return pu(function() {
          var G = h.j(_, R, F);
          return j(G) ? hu(function(J) {
            return hu(J, L);
          }, r) : G;
        }());
      }
      return d.m = 3, d.v = function(_) {
        var R = I(_);
        _ = W(_);
        var F = I(_);
        _ = W(_);
        var L = I(_);
        return _ = tn(_), p(R, F, L, _);
      }, d.l = p, d;
    }();
    return h = function(d, p, _, R) {
      switch (arguments.length) {
        case 0:
          return !0;
        case 1:
          return a.call(this, d);
        case 2:
          return o.call(this, d, p);
        case 3:
          return u.call(this, d, p, _);
        default:
          var F = null;
          if (3 < arguments.length) {
            F = 0;
            for (var L = Array(arguments.length - 3); F < L.length; ) L[F] = arguments[F + 3], ++F;
            F = new hn(L, 0, null);
          }
          return s.l(d, p, _, F);
      }
    }, h.m = 3, h.v = s.v, h.o = function() {
      return !0;
    }, h.h = a, h.g = o, h.j = u, h.l = s.l, h;
  }();
};
mf.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
mf.m = 3;
var Cp = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
Cp.h = function(e) {
  return function() {
    function n(o, a, h) {
      return o = e.h ? e.h(o) : e.call(null, o), j(o) ? o : (a = e.h ? e.h(a) : e.call(null, a), j(a) ? a : e.h ? e.h(h) : e.call(null, h));
    }
    function t(o, a) {
      return o = e.h ? e.h(o) : e.call(null, o), j(o) ? o : e.h ? e.h(a) : e.call(null, a);
    }
    function l(o) {
      return e.h ? e.h(o) : e.call(null, o);
    }
    var r = null, u = function() {
      function o(h, s, d, p) {
        var _ = null;
        if (3 < arguments.length) {
          _ = 0;
          for (var R = Array(arguments.length - 3); _ < R.length; ) R[_] = arguments[_ + 3], ++_;
          _ = new hn(R, 0, null);
        }
        return a.call(this, h, s, d, _);
      }
      function a(h, s, d, p) {
        return h = r.j(h, s, d), j(h) ? h : fu(e, p);
      }
      return o.m = 3, o.v = function(h) {
        var s = I(h);
        h = W(h);
        var d = I(h);
        h = W(h);
        var p = I(h);
        return h = tn(h), a(s, d, p, h);
      }, o.l = a, o;
    }();
    return r = function(o, a, h, s) {
      switch (arguments.length) {
        case 0:
          return null;
        case 1:
          return l.call(this, o);
        case 2:
          return t.call(this, o, a);
        case 3:
          return n.call(this, o, a, h);
        default:
          var d = null;
          if (3 < arguments.length) {
            d = 0;
            for (var p = Array(arguments.length - 3); d < p.length; ) p[d] = arguments[d + 3], ++d;
            d = new hn(p, 0, null);
          }
          return u.l(o, a, h, d);
      }
    }, r.m = 3, r.v = u.v, r.o = function() {
      return null;
    }, r.h = l, r.g = t, r.j = n, r.l = u.l, r;
  }();
};
Cp.g = function(e, n) {
  return function() {
    function t(a, h, s) {
      var d = e.h ? e.h(a) : e.call(null, a);
      return j(d) || (d = e.h ? e.h(h) : e.call(null, h), j(d)) || (d = e.h ? e.h(s) : e.call(null, s), j(d)) ? d : (a = n.h ? n.h(a) : n.call(null, a), j(a) ? a : (h = n.h ? n.h(h) : n.call(null, h), j(h) ? h : n.h ? n.h(s) : n.call(null, s)));
    }
    function l(a, h) {
      var s = e.h ? e.h(a) : e.call(null, a);
      return j(s) || (s = e.h ? e.h(h) : e.call(null, h), j(s)) ? s : (a = n.h ? n.h(a) : n.call(null, a), j(a) ? a : n.h ? n.h(h) : n.call(null, h));
    }
    function r(a) {
      var h = e.h ? e.h(a) : e.call(null, a);
      return j(h) ? h : n.h ? n.h(a) : n.call(null, a);
    }
    var u = null, o = function() {
      function a(s, d, p, _) {
        var R = null;
        if (3 < arguments.length) {
          R = 0;
          for (var F = Array(arguments.length - 3); R < F.length; ) F[R] = arguments[R + 3], ++R;
          R = new hn(F, 0, null);
        }
        return h.call(this, s, d, p, R);
      }
      function h(s, d, p, _) {
        return s = u.j(s, d, p), j(s) ? s : fu(function(R) {
          var F = e.h ? e.h(R) : e.call(null, R);
          return j(F) ? F : n.h ? n.h(R) : n.call(null, R);
        }, _);
      }
      return a.m = 3, a.v = function(s) {
        var d = I(s);
        s = W(s);
        var p = I(s);
        s = W(s);
        var _ = I(s);
        return s = tn(s), h(d, p, _, s);
      }, a.l = h, a;
    }();
    return u = function(a, h, s, d) {
      switch (arguments.length) {
        case 0:
          return null;
        case 1:
          return r.call(this, a);
        case 2:
          return l.call(this, a, h);
        case 3:
          return t.call(this, a, h, s);
        default:
          var p = null;
          if (3 < arguments.length) {
            p = 0;
            for (var _ = Array(arguments.length - 3); p < _.length; ) _[p] = arguments[p + 3], ++p;
            p = new hn(_, 0, null);
          }
          return o.l(a, h, s, p);
      }
    }, u.m = 3, u.v = o.v, u.o = function() {
      return null;
    }, u.h = r, u.g = l, u.j = t, u.l = o.l, u;
  }();
};
Cp.j = function(e, n, t) {
  return function() {
    function l(h, s, d) {
      var p = e.h ? e.h(h) : e.call(null, h);
      return j(p) || (p = e.h ? e.h(s) : e.call(null, s), j(p)) || (p = e.h ? e.h(d) : e.call(null, d), j(p)) || (p = n.h ? n.h(h) : n.call(null, h), j(p)) || (p = n.h ? n.h(s) : n.call(null, s), j(p)) || (p = n.h ? n.h(d) : n.call(null, d), j(p)) ? p : (h = t.h ? t.h(h) : t.call(null, h), j(h) ? h : (s = t.h ? t.h(s) : t.call(null, s), j(s) ? s : t.h ? t.h(d) : t.call(null, d)));
    }
    function r(h, s) {
      var d = e.h ? e.h(h) : e.call(null, h);
      return j(d) || (d = e.h ? e.h(s) : e.call(null, s), j(d)) || (d = n.h ? n.h(h) : n.call(null, h), j(d)) || (d = n.h ? n.h(s) : n.call(null, s), j(d)) ? d : (h = t.h ? t.h(h) : t.call(null, h), j(h) ? h : t.h ? t.h(s) : t.call(null, s));
    }
    function u(h) {
      var s = e.h ? e.h(h) : e.call(null, h);
      return j(s) ? s : (s = n.h ? n.h(h) : n.call(null, h), j(s) ? s : t.h ? t.h(h) : t.call(null, h));
    }
    var o = null, a = function() {
      function h(d, p, _, R) {
        var F = null;
        if (3 < arguments.length) {
          F = 0;
          for (var L = Array(arguments.length - 3); F < L.length; ) L[F] = arguments[F + 3], ++F;
          F = new hn(
            L,
            0,
            null
          );
        }
        return s.call(this, d, p, _, F);
      }
      function s(d, p, _, R) {
        return d = o.j(d, p, _), j(d) ? d : fu(function(F) {
          var L = e.h ? e.h(F) : e.call(null, F);
          return j(L) ? L : (L = n.h ? n.h(F) : n.call(null, F), j(L) ? L : t.h ? t.h(F) : t.call(null, F));
        }, R);
      }
      return h.m = 3, h.v = function(d) {
        var p = I(d);
        d = W(d);
        var _ = I(d);
        d = W(d);
        var R = I(d);
        return d = tn(d), s(p, _, R, d);
      }, h.l = s, h;
    }();
    return o = function(h, s, d, p) {
      switch (arguments.length) {
        case 0:
          return null;
        case 1:
          return u.call(this, h);
        case 2:
          return r.call(this, h, s);
        case 3:
          return l.call(this, h, s, d);
        default:
          var _ = null;
          if (3 < arguments.length) {
            _ = 0;
            for (var R = Array(arguments.length - 3); _ < R.length; ) R[_] = arguments[_ + 3], ++_;
            _ = new hn(R, 0, null);
          }
          return a.l(h, s, d, _);
      }
    }, o.m = 3, o.v = a.v, o.o = function() {
      return null;
    }, o.h = u, o.g = r, o.j = l, o.l = a.l, o;
  }();
};
Cp.l = function(e, n, t, l) {
  var r = us.B(e, n, t, l);
  return function() {
    function u(d, p, _) {
      return fu(function(R) {
        var F = R.h ? R.h(d) : R.call(null, d);
        return j(F) ? F : (F = R.h ? R.h(p) : R.call(null, p), j(F) ? F : R.h ? R.h(_) : R.call(null, _));
      }, r);
    }
    function o(d, p) {
      return fu(function(_) {
        var R = _.h ? _.h(d) : _.call(null, d);
        return j(R) ? R : _.h ? _.h(p) : _.call(null, p);
      }, r);
    }
    function a(d) {
      return fu(function(p) {
        return p.h ? p.h(d) : p.call(null, d);
      }, r);
    }
    var h = null, s = function() {
      function d(_, R, F, L) {
        var G = null;
        if (3 < arguments.length) {
          G = 0;
          for (var J = Array(arguments.length - 3); G < J.length; ) J[G] = arguments[G + 3], ++G;
          G = new hn(J, 0, null);
        }
        return p.call(this, _, R, F, G);
      }
      function p(_, R, F, L) {
        return _ = h.j(_, R, F), j(_) ? _ : fu(function(G) {
          return fu(G, L);
        }, r);
      }
      return d.m = 3, d.v = function(_) {
        var R = I(_);
        _ = W(_);
        var F = I(_);
        _ = W(_);
        var L = I(_);
        return _ = tn(_), p(R, F, L, _);
      }, d.l = p, d;
    }();
    return h = function(d, p, _, R) {
      switch (arguments.length) {
        case 0:
          return null;
        case 1:
          return a.call(this, d);
        case 2:
          return o.call(this, d, p);
        case 3:
          return u.call(this, d, p, _);
        default:
          var F = null;
          if (3 < arguments.length) {
            F = 0;
            for (var L = Array(arguments.length - 3); F < L.length; ) L[F] = arguments[F + 3], ++F;
            F = new hn(L, 0, null);
          }
          return s.l(d, p, _, F);
      }
    }, h.m = 3, h.v = s.v, h.o = function() {
      return null;
    }, h.h = a, h.g = o, h.j = u, h.l = s.l, h;
  }();
};
Cp.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
Cp.m = 3;
var bt = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], arguments[3], new hn(t.slice(4), 0, null));
  }
};
bt.h = function(e) {
  return function(n) {
    return function() {
      function t(a, h) {
        return h = e.h ? e.h(h) : e.call(null, h), n.g ? n.g(a, h) : n.call(null, a, h);
      }
      function l(a) {
        return n.h ? n.h(a) : n.call(null, a);
      }
      function r() {
        return n.o ? n.o() : n.call(null);
      }
      var u = null, o = function() {
        function a(s, d, p) {
          var _ = null;
          if (2 < arguments.length) {
            _ = 0;
            for (var R = Array(arguments.length - 2); _ < R.length; ) R[_] = arguments[_ + 2], ++_;
            _ = new hn(R, 0, null);
          }
          return h.call(this, s, d, _);
        }
        function h(s, d, p) {
          return d = In.j(e, d, p), n.g ? n.g(s, d) : n.call(null, s, d);
        }
        return a.m = 2, a.v = function(s) {
          var d = I(s);
          s = W(s);
          var p = I(s);
          return s = tn(s), h(d, p, s);
        }, a.l = h, a;
      }();
      return u = function(a, h, s) {
        switch (arguments.length) {
          case 0:
            return r.call(this);
          case 1:
            return l.call(this, a);
          case 2:
            return t.call(this, a, h);
          default:
            var d = null;
            if (2 < arguments.length) {
              d = 0;
              for (var p = Array(arguments.length - 2); d < p.length; ) p[d] = arguments[d + 2], ++d;
              d = new hn(p, 0, null);
            }
            return o.l(a, h, d);
        }
      }, u.m = 2, u.v = o.v, u.o = r, u.h = l, u.g = t, u.l = o.l, u;
    }();
  };
};
bt.g = function(e, n) {
  return new rr(null, function() {
    var t = z(n);
    if (t) {
      if (oi(t)) {
        for (var l = Jr(t), r = Cn(l), u = Sh(r), o = 0; o < r; ) T3(u, function() {
          var a = Ul(l, o);
          return e.h ? e.h(a) : e.call(null, a);
        }()), o += 1;
        return js(mo(u), bt.g(e, Wr(t)));
      }
      return kt(function() {
        var a = I(t);
        return e.h ? e.h(a) : e.call(null, a);
      }(), bt.g(e, tn(t)));
    }
    return null;
  }, null, null);
};
bt.j = function(e, n, t) {
  return new rr(null, function() {
    var l = z(n), r = z(t);
    if (l && r) {
      var u = I(l), o = I(r);
      u = e.g ? e.g(u, o) : e.call(null, u, o), l = kt(u, bt.j(e, tn(l), tn(r)));
    } else l = null;
    return l;
  }, null, null);
};
bt.B = function(e, n, t, l) {
  return new rr(null, function() {
    var r = z(n), u = z(t), o = z(l);
    if (r && u && o) {
      var a = I(r), h = I(u), s = I(o);
      a = e.j ? e.j(a, h, s) : e.call(null, a, h, s), r = kt(a, bt.B(e, tn(r), tn(u), tn(o)));
    } else r = null;
    return r;
  }, null, null);
};
bt.l = function(e, n, t, l, r) {
  return bt.g(function(u) {
    return In.g(e, u);
  }, function u(o) {
    return new rr(null, function() {
      var a = bt.g(z, o);
      return hu(No, a) ? kt(bt.g(I, a), u(bt.g(tn, a))) : null;
    }, null, null);
  }(yt.l(r, l, Te([t, n]))));
};
bt.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
bt.m = 4;
var Vu = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Vu.h = function(e) {
  return function(n) {
    var t = Qi(e);
    return function() {
      function l(a, h) {
        var s = sn(t), d = t.Nb(null, t.jb(null) - 1);
        return a = 0 < s ? n.g ? n.g(a, h) : n.call(null, a, h) : a, 0 < d ? a : cK(a);
      }
      function r(a) {
        return n.h ? n.h(a) : n.call(null, a);
      }
      function u() {
        return n.o ? n.o() : n.call(null);
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 0:
            return u.call(this);
          case 1:
            return r.call(this, a);
          case 2:
            return l.call(this, a, h);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.o = u, o.h = r, o.g = l, o;
    }();
  };
};
Vu.g = function(e, n) {
  return new rr(null, function() {
    if (0 < e) {
      var t = z(n);
      return t ? kt(I(t), Vu.g(e - 1, tn(t))) : null;
    }
    return null;
  }, null, null);
};
Vu.m = 2;
var uu = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
uu.h = function(e) {
  return function(n) {
    var t = Qi(e);
    return function() {
      function l(a, h) {
        var s = sn(t);
        return t.Nb(null, t.jb(null) - 1), 0 < s ? a : n.g ? n.g(a, h) : n.call(null, a, h);
      }
      function r(a) {
        return n.h ? n.h(a) : n.call(null, a);
      }
      function u() {
        return n.o ? n.o() : n.call(null);
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 0:
            return u.call(this);
          case 1:
            return r.call(this, a);
          case 2:
            return l.call(this, a, h);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.o = u, o.h = r, o.g = l, o;
    }();
  };
};
uu.g = function(e, n) {
  return new rr(null, function() {
    e: for (var t = e, l = n; ; ) if (l = z(l), 0 < t && l) --t, l = tn(l);
    else break e;
    return l;
  }, null, null);
};
uu.m = 2;
var Py = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Py.h = function(e) {
  return Py.g(1, e);
};
Py.g = function(e, n) {
  return bt.j(function(t) {
    return t;
  }, n, uu.g(e, n));
};
Py.m = 2;
var J3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
J3.h = function(e) {
  return function(n) {
    var t = Qi(!0);
    return function() {
      function l(a, h) {
        var s = sn(t);
        return j(j(s) ? e.h ? e.h(h) : e.call(null, h) : s) ? a : (Yu(t, null), n.g ? n.g(a, h) : n.call(null, a, h));
      }
      function r(a) {
        return n.h ? n.h(a) : n.call(null, a);
      }
      function u() {
        return n.o ? n.o() : n.call(null);
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 0:
            return u.call(this);
          case 1:
            return r.call(this, a);
          case 2:
            return l.call(this, a, h);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.o = u, o.h = r, o.g = l, o;
    }();
  };
};
J3.g = function(e, n) {
  return new rr(null, function() {
    e: for (var t = e, l = n; ; ) {
      l = z(l);
      var r;
      if ((r = l) && (r = I(l), r = t.h ? t.h(r) : t.call(null, r)), j(r)) l = tn(l);
      else break e;
    }
    return l;
  }, null, null);
};
J3.m = 2;
A = h2.prototype;
A.toString = function() {
  return Ui(this);
};
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return this.Fa(null);
};
A.ha = function() {
  return fl;
};
A.Ac = function() {
  return this.current != null;
};
A.Da = function(e, n) {
  for (var t = this, l = A4(this), r = I(l); ; ) {
    var u = function() {
      var o = W(l);
      return o || t.all;
    }();
    if (e = function() {
      var o = r, a = I(u);
      return n.g ? n.g(o, a) : n.call(null, o, a);
    }(), ni(e)) return sn(e);
    l = u, r = e;
  }
};
A.Ea = function(e, n, t) {
  for (var l = this, r = A4(this), u = t; ; ) {
    if (t = function() {
      var o = u, a = I(r);
      return n.g ? n.g(o, a) : n.call(null, o, a);
    }(), ni(t)) return sn(t);
    r = function() {
      var o = W(r);
      return o || l.all;
    }(), u = t;
  }
};
A.Ba = function() {
  return I(A4(this));
};
A.Fa = function() {
  return this.hb == null && (this.hb = new h2(null, this.all, A4(this), null, null)), this.hb;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new h2(n, this.all, this.prev, this.current, this.hb);
};
A.aa = function(e, n) {
  return kt(n, this);
};
A = ag.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, this.count);
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return this.next == null ? 1 < this.count ? this.next = new ag(null, this.count - 1, this.val, null) : this.count === -1 ? this : null : this.next;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Ac = function() {
  return !1;
};
A.Da = function(e, n) {
  if (this.count === -1) for (var t = n.g ? n.g(this.val, this.val) : n.call(null, this.val, this.val); ; ) {
    if (ni(t)) return sn(t);
    t = n.g ? n.g(t, this.val) : n.call(null, t, this.val);
  }
  else for (e = 1, t = this.val; ; ) if (e < this.count) {
    if (t = n.g ? n.g(t, this.val) : n.call(null, t, this.val), ni(t)) return sn(t);
    e += 1;
  } else return t;
};
A.Ea = function(e, n, t) {
  if (this.count === -1) for (t = n.g ? n.g(t, this.val) : n.call(null, t, this.val); ; ) {
    if (ni(t)) return sn(t);
    t = n.g ? n.g(t, this.val) : n.call(null, t, this.val);
  }
  else for (e = 0; ; ) if (e < this.count) {
    if (t = n.g ? n.g(t, this.val) : n.call(null, t, this.val), ni(t)) return sn(t);
    e += 1;
  } else return t;
};
A.Ba = function() {
  return this.val;
};
A.Fa = function() {
  return this.next == null ? 1 < this.count ? this.next = new ag(null, this.count - 1, this.val, null) : this.count === -1 ? this : fl : this.next;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new ag(n, this.count, this.val, this.next);
};
A.aa = function(e, n) {
  return kt(n, this);
};
var sa = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
sa.h = function(e) {
  return new ag(null, -1, e, null);
};
sa.g = function(e, n) {
  return 0 < e ? new ag(null, e, n, null) : fl;
};
sa.m = 2;
var n1 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
n1.h = function(e) {
  return new rr(null, function() {
    return kt(e.o ? e.o() : e.call(null), n1.h(e));
  }, null, null);
};
n1.g = function(e, n) {
  return Vu.g(e, n1.h(n));
};
n1.m = 2;
var vB = {};
A = f2.prototype;
A.toString = function() {
  return Ui(this);
};
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return this.Fa(null);
};
A.ha = function() {
  return fl;
};
A.Ac = function() {
  return this.seed !== vB;
};
A.Da = function(e, n) {
  e = this.Ba(null);
  var t = this.f.h ? this.f.h(e) : this.f.call(null, e);
  for (e = n.g ? n.g(e, t) : n.call(null, e, t); ; ) {
    if (ni(e)) return sn(e);
    t = this.f.h ? this.f.h(t) : this.f.call(null, t), e = n.g ? n.g(e, t) : n.call(null, e, t);
  }
};
A.Ea = function(e, n, t) {
  for (e = this.Ba(null), t = n.g ? n.g(t, e) : n.call(null, t, e); ; ) {
    if (ni(t)) return sn(t);
    e = this.f.h ? this.f.h(e) : this.f.call(null, e), t = n.g ? n.g(t, e) : n.call(null, t, e);
  }
};
A.Ba = function() {
  return vB === this.seed && (this.seed = this.f.h ? this.f.h(this.Qd) : this.f.call(null, this.Qd)), this.seed;
};
A.Fa = function() {
  return this.next == null && (this.next = new f2(null, this.f, this.Ba(null), vB, null)), this.next;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new f2(n, this.f, this.Qd, this.seed, this.next);
};
A.aa = function(e, n) {
  return kt(n, this);
};
var Nu = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Nu.o = function() {
  return fl;
};
Nu.h = function(e) {
  return new rr(null, function() {
    return e;
  }, null, null);
};
Nu.g = function(e, n) {
  return new rr(null, function() {
    var t = z(e), l = z(n);
    return t && l ? kt(I(t), kt(I(l), Nu.g(tn(t), tn(l)))) : null;
  }, null, null);
};
Nu.l = function(e, n, t) {
  return new rr(null, function() {
    var l = bt.g(z, yt.l(t, n, Te([e])));
    return hu(No, l) ? he.g(bt.g(I, l), In.g(Nu, bt.g(tn, l))) : null;
  }, null, null);
};
Nu.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Nu.m = 2;
var rd = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
rd.h = function(e) {
  return function(n) {
    var t = Qi(!1);
    return function() {
      function l(a, h) {
        return j(sn(t)) ? (a = n.g ? n.g(a, e) : n.call(null, a, e), ni(a) ? a : n.g ? n.g(a, h) : n.call(null, a, h)) : (Yu(t, !0), n.g ? n.g(a, h) : n.call(null, a, h));
      }
      function r(a) {
        return n.h ? n.h(a) : n.call(null, a);
      }
      function u() {
        return n.o ? n.o() : n.call(null);
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 0:
            return u.call(this);
          case 1:
            return r.call(this, a);
          case 2:
            return l.call(this, a, h);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.o = u, o.h = r, o.g = l, o;
    }();
  };
};
rd.g = function(e, n) {
  return uu.g(1, Nu.g(sa.h(e), n));
};
rd.m = 2;
var na = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], new hn(t.slice(1), 0, null));
  }
};
na.h = function(e) {
  return ua.g(bt.h(e), F4);
};
na.l = function(e, n) {
  return In.g(he, In.j(bt, e, n));
};
na.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
na.m = 1;
var Ou = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Ou.h = function(e) {
  return function(n) {
    return function() {
      function t(o, a) {
        return j(e.h ? e.h(a) : e.call(null, a)) ? n.g ? n.g(o, a) : n.call(null, o, a) : o;
      }
      function l(o) {
        return n.h ? n.h(o) : n.call(null, o);
      }
      function r() {
        return n.o ? n.o() : n.call(null);
      }
      var u = null;
      return u = function(o, a) {
        switch (arguments.length) {
          case 0:
            return r.call(this);
          case 1:
            return l.call(this, o);
          case 2:
            return t.call(this, o, a);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, u.o = r, u.h = l, u.g = t, u;
    }();
  };
};
Ou.g = function(e, n) {
  return new rr(null, function() {
    var t = z(n);
    if (t) {
      if (oi(t)) {
        for (var l = Jr(t), r = Cn(l), u = Sh(r), o = 0; o < r; ) {
          var a = Ul(l, o);
          a = e.h ? e.h(a) : e.call(null, a), j(a) && T3(u, Ul(l, o)), o += 1;
        }
        return js(mo(u), Ou.g(e, Wr(t)));
      }
      return l = I(t), t = tn(t), j(e.h ? e.h(l) : e.call(null, l)) ? kt(l, Ou.g(e, t)) : Ou.g(e, t);
    }
    return null;
  }, null, null);
};
Ou.m = 2;
var Ia = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Ia.h = function(e) {
  return Ou.h(Dp(e));
};
Ia.g = function(e, n) {
  return Ou.g(Dp(e), n);
};
Ia.m = 2;
var lr = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
lr.o = function() {
  return Dt;
};
lr.h = function(e) {
  return e;
};
lr.g = function(e, n) {
  return e != null ? e != null && (e.J & 4 || Rn === e.Le) ? su(gu(wt.j(Rm, ou(e), n)), Vt(e)) : wt.j(Qo, e, n) : wt.j(yt, e, n);
};
lr.j = function(e, n, t) {
  if (e != null && (e.J & 4 || Rn === e.Le)) {
    var l = Vt(e);
    return pp.B(n, function() {
      function r(a, h) {
        return to.g(a, h);
      }
      function u(a) {
        return su(gu(a), l);
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 1:
            return u.call(this, a);
          case 2:
            return r.call(this, a, h);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.h = u, o.g = r, o;
    }(), ou(e), t);
  }
  return pp.B(n, yt, e, t);
};
lr.m = 3;
var wo = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], arguments[3], new hn(t.slice(4), 0, null));
  }
};
wo.g = function(e, n) {
  return gu(wt.j(function(t, l) {
    return to.g(t, e.h ? e.h(l) : e.call(null, l));
  }, ou(Dt), n));
};
wo.j = function(e, n, t) {
  return lr.g(Dt, bt.j(e, n, t));
};
wo.B = function(e, n, t, l) {
  return lr.g(Dt, bt.B(e, n, t, l));
};
wo.l = function(e, n, t, l, r) {
  return lr.g(Dt, In.l(bt, e, n, t, l, Te([r])));
};
wo.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
wo.m = 4;
var Mo = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Mo.g = function(e, n) {
  return Mo.j(e, e, n);
};
Mo.j = function(e, n, t) {
  return new rr(null, function() {
    var l = z(t);
    if (l) {
      var r = Vu.g(e, l);
      return e === Cn(r) ? kt(r, Mo.j(e, n, uu.g(n, l))) : null;
    }
    return null;
  }, null, null);
};
Mo.B = function(e, n, t, l) {
  return new rr(null, function() {
    var r = z(l);
    if (r) {
      var u = Vu.g(e, r);
      return e === Cn(u) ? kt(u, Mo.B(e, n, t, uu.g(n, r))) : new g(null, Vu.g(e, he.g(u, t)), null, 1, null);
    }
    return null;
  }, null, null);
};
Mo.m = 4;
var xr = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
xr.g = function(e, n) {
  return wt.j(en, e, n);
};
xr.j = function(e, n, t) {
  var l = Da;
  for (n = z(n); ; ) if (n != null) {
    if (e = en.j(e, I(n), l), l === e) return t;
    n = W(n);
  } else return e;
};
xr.m = 3;
var xs = function e(n, t, l) {
  var r = z(t);
  t = I(r);
  var u = W(r);
  if (u) {
    r = Dn.j;
    var o = en.g(n, t);
    l = e.j ? e.j(o, u, l) : e.call(null, o, u, l), n = r.call(Dn, n, t, l);
  } else n = Dn.j(n, t, l);
  return n;
}, bu = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    case 5:
      return e.I(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    case 6:
      return e.T(
        arguments[0],
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5]
      );
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], new hn(t.slice(6), 0, null));
  }
};
bu.j = function(e, n, t) {
  var l = z(n);
  if (n = I(l), l = W(l)) e = Dn.j(e, n, bu.j(en.g(e, n), l, t));
  else {
    l = Dn.j;
    var r = en.g(e, n);
    t = t.h ? t.h(r) : t.call(null, r), e = l.call(Dn, e, n, t);
  }
  return e;
};
bu.B = function(e, n, t, l) {
  var r = z(n);
  if (n = I(r), r = W(r)) e = Dn.j(e, n, bu.B(en.g(e, n), r, t, l));
  else {
    r = Dn.j;
    var u = en.g(e, n);
    t = t.g ? t.g(u, l) : t.call(null, u, l), e = r.call(Dn, e, n, t);
  }
  return e;
};
bu.I = function(e, n, t, l, r) {
  var u = z(n);
  if (n = I(u), u = W(u)) e = Dn.j(e, n, bu.I(en.g(e, n), u, t, l, r));
  else {
    u = Dn.j;
    var o = en.g(e, n);
    t = t.j ? t.j(o, l, r) : t.call(null, o, l, r), e = u.call(Dn, e, n, t);
  }
  return e;
};
bu.T = function(e, n, t, l, r, u) {
  var o = z(n);
  if (n = I(o), o = W(o)) e = Dn.j(e, n, bu.T(en.g(e, n), o, t, l, r, u));
  else {
    o = Dn.j;
    var a = en.g(e, n);
    t = t.B ? t.B(a, l, r, u) : t.call(null, a, l, r, u), e = o.call(Dn, e, n, t);
  }
  return e;
};
bu.l = function(e, n, t, l, r, u, o) {
  var a = z(n);
  return n = I(a), (a = W(a)) ? Dn.j(e, n, In.l(bu, en.g(e, n), a, t, l, Te([r, u, o]))) : Dn.j(e, n, In.l(t, en.g(e, n), l, r, u, Te([o])));
};
bu.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  l = I(r);
  var u = W(r);
  r = I(u);
  var o = W(u);
  return u = I(o), o = W(o), this.l(n, e, t, l, r, u, o);
};
bu.m = 6;
var Ri = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    case 5:
      return e.I(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    case 6:
      return e.T(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(
        arguments[0],
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        new hn(t.slice(6), 0, null)
      );
  }
};
Ri.j = function(e, n, t) {
  var l = Dn.j, r = en.g(e, n);
  return t = t.h ? t.h(r) : t.call(null, r), l.call(Dn, e, n, t);
};
Ri.B = function(e, n, t, l) {
  var r = Dn.j, u = en.g(e, n);
  return t = t.g ? t.g(u, l) : t.call(null, u, l), r.call(Dn, e, n, t);
};
Ri.I = function(e, n, t, l, r) {
  var u = Dn.j, o = en.g(e, n);
  return t = t.j ? t.j(o, l, r) : t.call(null, o, l, r), u.call(Dn, e, n, t);
};
Ri.T = function(e, n, t, l, r, u) {
  var o = Dn.j, a = en.g(e, n);
  return t = t.B ? t.B(a, l, r, u) : t.call(null, a, l, r, u), o.call(Dn, e, n, t);
};
Ri.l = function(e, n, t, l, r, u, o) {
  return Dn.j(e, n, In.l(t, en.g(e, n), l, r, u, Te([o])));
};
Ri.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  l = I(r);
  var u = W(r);
  r = I(u);
  var o = W(u);
  return u = I(o), o = W(o), this.l(n, e, t, l, r, u, o);
};
Ri.m = 6;
var Yme = function e(n, t, l, r) {
  var u = zO(l), o = n.G - 1 >>> t & 31;
  return t === 5 ? u.A[o] = r : (l = l.A[o], l != null ? (t -= 5, n = e.B ? e.B(n, t, l, r) : e.call(null, n, t, l, r)) : n = D4(null, t - 5, r), u.A[o] = n), u;
}, Ume = function e(n, t, l, r, u) {
  var o = zO(l);
  if (t === 0) o.A[r & 31] = u;
  else {
    var a = r >>> t & 31;
    t -= 5, l = l.A[a], n = e.I ? e.I(n, t, l, r, u) : e.call(null, n, t, l, r, u), o.A[a] = n;
  }
  return o;
}, qme = function e(n, t, l) {
  var r = n.G - 2 >>> t & 31;
  if (5 < t) {
    t -= 5;
    var u = l.A[r];
    return n = e.j ? e.j(n, t, u) : e.call(null, n, t, u), n == null && r === 0 ? null : (l = zO(l), l.A[r] = n, l);
  }
  return r === 0 ? null : (l = zO(l), l.A[r] = null, l);
};
DL.prototype.ja = function() {
  return this.i < this.end;
};
DL.prototype.next = function() {
  this.i - this.base === 32 && (this.A = ph(this.bb, this.i), this.base += 32);
  var e = this.A[this.i & 31];
  return this.i += 1, e;
};
A = v.prototype;
A.jc = Rn;
A.Ub = function(e, n) {
  return 0 <= n && n < this.G ? new yl(n, ph(this, n)[n & 31]) : null;
};
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  return typeof n == "number" ? this.Wa(null, n, t) : t;
};
A.nb = function(e, n, t) {
  e = 0;
  for (var l = t; ; ) if (e < this.G) {
    var r = ph(this, e);
    t = r.length;
    e: for (var u = 0; ; ) if (u < t) {
      var o = u + e, a = r[u];
      if (l = n.j ? n.j(l, o, a) : n.call(null, l, o, a), ni(l)) {
        r = l;
        break e;
      }
      u += 1;
    } else {
      r = l;
      break e;
    }
    if (ni(r)) return sn(r);
    e += t, l = r;
  } else return l;
};
A.ud = Rn;
A.Y = function(e, n) {
  return AL(this, n)[n & 31];
};
A.Wa = function(e, n, t) {
  return 0 <= n && n < this.G ? ph(this, n)[n & 31] : t;
};
A.Cb = function(e, n, t) {
  if (0 <= n && n < this.G) return cg(this) <= n ? (e = ki(this.fb), e[n & 31] = t, new v(this.meta, this.G, this.shift, this.root, e, null)) : new v(this.meta, this.G, this.shift, Ume(this, this.shift, this.root, n, t), this.fb, null);
  if (n === this.G) return this.aa(null, t);
  throw Error(["Index ", ye.h(n), " out of bounds  [0,", ye.h(this.G), "]"].join(""));
};
A.Xa = function() {
  return AK(this, 0, this.G);
};
A.U = function() {
  return this.meta;
};
A.$ = function() {
  return this.G;
};
A.Xb = function() {
  return 0 < this.G ? this.Y(null, this.G - 1) : null;
};
A.Yb = function() {
  if (this.G === 0) throw Error("Can't pop empty vector");
  if (this.G === 1) return su(Dt, this.meta);
  if (1 < this.G - cg(this)) return new v(this.meta, this.G - 1, this.shift, this.root, this.fb.slice(0, -1), null);
  var e = ph(this, this.G - 2), n = qme(this, this.shift, this.root);
  n = n ?? y;
  var t = this.G - 1;
  return 5 < this.shift && n.A[1] == null ? new v(this.meta, t, this.shift - 5, n.A[0], e, null) : new v(this.meta, t, this.shift, n, e, null);
};
A.Wb = function() {
  return 0 < this.G ? new Qf(this, this.G - 1, null) : null;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  if (n instanceof v) if (this.G === Cn(n)) for (e = this.Xa(null), n = n.Xa(null); ; ) if (e.ja()) {
    var t = e.next(), l = n.next();
    if (!on.g(t, l)) return !1;
  } else return !0;
  else return !1;
  else return iu(this, n);
};
A.xc = function() {
  return new DK(this.G, this.shift, wA.h ? wA.h(this.root) : wA.call(null, this.root), vA.h ? vA.h(this.fb) : vA.call(null, this.fb));
};
A.ha = function() {
  return su(Dt, this.meta);
};
A.Da = function(e, n) {
  return IL(this, n, 0, this.G);
};
A.Ea = function(e, n, t) {
  e = 0;
  for (var l = t; ; ) if (e < this.G) {
    var r = ph(this, e);
    t = r.length;
    e: for (var u = 0; ; ) if (u < t) {
      var o = r[u];
      if (l = n.g ? n.g(l, o) : n.call(null, l, o), ni(l)) {
        r = l;
        break e;
      }
      u += 1;
    } else {
      r = l;
      break e;
    }
    if (ni(r)) return sn(r);
    e += t, l = r;
  } else return l;
};
A.Aa = function(e, n, t) {
  if (typeof n == "number") return this.Cb(null, n, t);
  throw Error("Vector's key for assoc must be a number.");
};
A.gb = function(e, n) {
  return za(n) ? 0 <= n && n < this.G : !1;
};
A.W = function() {
  if (this.G === 0) return null;
  if (32 >= this.G) return new hn(this.fb, 0, null);
  e:
    for (var e = this.root, n = this.shift; ; ) if (0 < n) n -= 5, e = e.A[0];
    else {
      e = e.A;
      break e;
    }
  return Zh ? Zh(this, e, 0, 0) : d2.call(null, this, e, 0, 0);
};
A.Z = function(e, n) {
  return n === this.meta ? this : new v(n, this.G, this.shift, this.root, this.fb, this.H);
};
A.aa = function(e, n) {
  if (32 > this.G - cg(this)) {
    e = this.fb.length;
    for (var t = Array(e + 1), l = 0; l < e; ) t[l] = this.fb[l], l += 1;
    return t[e] = n, new v(this.meta, this.G + 1, this.shift, this.root, t, null);
  }
  return e = (t = this.G >>> 5 > 1 << this.shift) ? this.shift + 5 : this.shift, t ? (t = TK(null), t.A[0] = this.root, l = D4(null, this.shift, new Nf(null, this.fb)), t.A[1] = l) : t = Yme(this, this.shift, this.root, new Nf(null, this.fb)), new v(this.meta, this.G + 1, e, t, [n], null);
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  if (typeof e == "number") return this.Y(null, e);
  throw Error("Key must be integer");
};
var y = new Nf(null, [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null]), Dt = new v(null, 0, 5, y, [], wB);
v.prototype[Li] = function() {
  return ti(this);
};
var k2 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
k2.l = function(e) {
  return e instanceof hn && e.i === 0 ? C3(e.A, !ra(e.A)) : Et(e);
};
k2.m = 0;
k2.v = function(e) {
  return this.l(z(e));
};
A = y1.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  if (this.off + 1 < this.node.length) {
    var e = this.rb, n = this.node, t = this.i, l = this.off + 1;
    return e = Zh ? Zh(e, n, t, l) : d2.call(null, e, n, t, l), e ?? null;
  }
  return this.Lc();
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return IL(this.rb, n, this.i + this.off, Cn(this.rb));
};
A.Ea = function(e, n, t) {
  return RL(this.rb, n, t, this.i + this.off, Cn(this.rb));
};
A.Ba = function() {
  return this.node[this.off];
};
A.Fa = function() {
  if (this.off + 1 < this.node.length) {
    var e = this.rb, n = this.node, t = this.i, l = this.off + 1;
    return e = Zh ? Zh(e, n, t, l) : d2.call(null, e, n, t, l), e ?? fl;
  }
  return this.ic(null);
};
A.W = function() {
  return this;
};
A.Mc = function() {
  var e = this.node;
  return new Vw(e, this.off, e.length);
};
A.ic = function() {
  var e = this.i + this.node.length;
  if (e < Kh(this.rb)) {
    var n = this.rb, t = ph(this.rb, e);
    return Zh ? Zh(n, t, e, 0) : d2.call(null, n, t, e, 0);
  }
  return fl;
};
A.Z = function(e, n) {
  return n === this.meta ? this : cI ? cI(this.rb, this.node, this.i, this.off, n) : d2.call(null, this.rb, this.node, this.i, this.off, n);
};
A.aa = function(e, n) {
  return kt(n, this);
};
A.Lc = function() {
  var e = this.i + this.node.length;
  if (e < Kh(this.rb)) {
    var n = this.rb, t = ph(this.rb, e);
    return Zh ? Zh(n, t, e, 0) : d2.call(null, n, t, e, 0);
  }
  return null;
};
y1.prototype[Li] = function() {
  return ti(this);
};
A = Nm.prototype;
A.jc = Rn;
A.Ub = function(e, n) {
  return 0 > n ? null : (e = this.start + n, e < this.end ? new yl(n, zo(this.bb, e)) : null);
};
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  return typeof n == "number" ? this.Wa(null, n, t) : t;
};
A.nb = function(e, n, t) {
  e = this.start;
  for (var l = 0; ; ) if (e < this.end) {
    var r = l, u = Ul(this.bb, e);
    if (t = n.j ? n.j(t, r, u) : n.call(null, t, r, u), ni(t)) return sn(t);
    l += 1, e += 1;
  } else return t;
};
A.Y = function(e, n) {
  return 0 > n || this.end <= this.start + n ? jK(n, this.end - this.start) : Ul(this.bb, this.start + n);
};
A.Wa = function(e, n, t) {
  return 0 > n || this.end <= this.start + n ? t : Ul(this.bb, this.start + n, t);
};
A.Cb = function(e, n, t) {
  if (e = this.start + n, 0 > n || this.end + 1 <= e) throw Error(["Index ", ye.h(n), " out of bounds [0,", ye.h(this.$(null)), "]"].join(""));
  n = this.meta, t = Dn.j(this.bb, e, t);
  var l = this.start, r = this.end;
  return e += 1, e = r > e ? r : e, jc.I ? jc.I(n, t, l, e, null) : jc.call(null, n, t, l, e, null);
};
A.Xa = function() {
  return this.bb != null && Rn === this.bb.ud ? AK(this.bb, this.start, this.end) : new A3(this);
};
A.U = function() {
  return this.meta;
};
A.$ = function() {
  return this.end - this.start;
};
A.Xb = function() {
  return this.start === this.end ? null : Ul(this.bb, this.end - 1);
};
A.Yb = function() {
  if (this.start === this.end) throw Error("Can't pop empty vector");
  var e = this.meta, n = this.bb, t = this.start, l = this.end - 1;
  return jc.I ? jc.I(e, n, t, l, null) : jc.call(null, e, n, t, l, null);
};
A.Wb = function() {
  return this.start !== this.end ? new Qf(this, this.end - this.start - 1, null) : null;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return su(Dt, this.meta);
};
A.Da = function(e, n) {
  return this.bb != null && Rn === this.bb.ud ? IL(this.bb, n, this.start, this.end) : E3(this, n);
};
A.Ea = function(e, n, t) {
  return this.bb != null && Rn === this.bb.ud ? RL(this.bb, n, t, this.start, this.end) : E4(this, n, t);
};
A.Aa = function(e, n, t) {
  if (typeof n == "number") return this.Cb(null, n, t);
  throw Error("Subvec's key for assoc must be a number.");
};
A.gb = function(e, n) {
  return za(n) ? 0 <= n && n < this.end - this.start : !1;
};
A.W = function() {
  var e = this;
  return function n(t) {
    return t === e.end ? null : kt(Ul(e.bb, t), new rr(null, function() {
      return n(t + 1);
    }, null, null));
  }(e.start);
};
A.Z = function(e, n) {
  return n === this.meta ? this : jc.I ? jc.I(n, this.bb, this.start, this.end, this.H) : jc.call(null, n, this.bb, this.start, this.end, this.H);
};
A.aa = function(e, n) {
  e = this.meta, n = zD(this.bb, this.end, n);
  var t = this.start, l = this.end + 1;
  return jc.I ? jc.I(e, n, t, l, null) : jc.call(null, e, n, t, l, null);
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.Y(null, e);
};
A.g = function(e, n) {
  return this.Wa(null, e, n);
};
Nm.prototype[Li] = function() {
  return ti(this);
};
var _p = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
_p.g = function(e, n) {
  return _p.j(e, n, Cn(e));
};
_p.j = function(e, n, t) {
  return jc(null, e, n | 0, t | 0, null);
};
_p.m = 3;
var Wme = function e(n, t, l, r) {
  l = sx(n.root.ea, l);
  var u = n.G - 1 >>> t & 31;
  if (t === 5) n = r;
  else {
    var o = l.A[u];
    o != null ? (t -= 5, n = e.B ? e.B(n, t, o, r) : e.call(null, n, t, o, r)) : n = D4(n.root.ea, t - 5, r);
  }
  return l.A[u] = n, l;
}, Hme = function e(n, t, l) {
  l = sx(n.root.ea, l);
  var r = n.G - 2 >>> t & 31;
  if (5 < t) {
    t -= 5;
    var u = l.A[r];
    return n = e.j ? e.j(n, t, u) : e.call(null, n, t, u), n == null && r === 0 ? null : (l.A[r] = n, l);
  }
  return r === 0 ? null : (l.A[r] = null, l);
};
A = DK.prototype;
A.Cc = function(e, n) {
  if (this.root.ea) {
    if (32 > this.G - cg(this)) this.fb[this.G & 31] = n;
    else {
      e = new Nf(this.root.ea, this.fb);
      var t = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null];
      t[0] = n, this.fb = t, this.G >>> 5 > 1 << this.shift ? (n = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null], t = this.shift + 5, n[0] = this.root, n[1] = D4(this.root.ea, this.shift, e), this.root = new Nf(this.root.ea, n), this.shift = t) : this.root = Wme(this, this.shift, this.root, e);
    }
    return this.G += 1, this;
  }
  throw Error("conj! after persistent!");
};
A.Oc = function() {
  if (this.root.ea) {
    this.root.ea = null;
    var e = this.G - cg(this), n = Array(e);
    return ec(this.fb, 0, n, 0, e), new v(null, this.G, this.shift, this.root, n, null);
  }
  throw Error("persistent! called twice");
};
A.Bc = function(e, n, t) {
  if (typeof n == "number") return Ife(this, n, t);
  throw Error("TransientVector's key for assoc! must be a number.");
};
A.me = function() {
  if (this.root.ea) {
    if (this.G === 0) throw Error("Can't pop empty vector");
    if (this.G === 1) this.G = 0;
    else if (0 < (this.G - 1 & 31)) --this.G;
    else {
      e: {
        var e = this.G - 2;
        if (e >= cg(this)) e = this.fb;
        else for (var n = this.root, t = n, l = this.shift; ; ) if (0 < l) t = sx(n.ea, t.A[e >>> l & 31]), l -= 5;
        else {
          e = t.A;
          break e;
        }
      }
      n = Hme(this, this.shift, this.root), n = n ?? new Nf(this.root.ea, [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null
      ]), 5 < this.shift && n.A[1] == null ? (this.root = sx(this.root.ea, n.A[0]), this.shift -= 5) : this.root = n, --this.G, this.fb = e;
    }
    return this;
  }
  throw Error("pop! after persistent!");
};
A.$ = function() {
  if (this.root.ea) return this.G;
  throw Error("count after persistent!");
};
A.Y = function(e, n) {
  if (this.root.ea) return AL(this, n)[n & 31];
  throw Error("nth after persistent!");
};
A.Wa = function(e, n, t) {
  return 0 <= n && n < this.G ? this.Y(null, n) : t;
};
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  if (this.root.ea) return typeof n == "number" ? this.Wa(null, n, t) : t;
  throw Error("lookup after persistent!");
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.wa(null, e);
};
A.g = function(e, n) {
  return this.P(null, e, n);
};
I4.prototype.ja = function() {
  var e = this.Fc != null && z(this.Fc);
  return e || ((e = this.$c != null) ? this.$c.ja() : e);
};
I4.prototype.next = function() {
  if (this.Fc != null) {
    var e = I(this.Fc);
    return this.Fc = W(this.Fc), e;
  }
  if (this.$c != null && this.$c.ja()) return this.$c.next();
  throw Error("No such element");
};
I4.prototype.remove = function() {
  return Error("Unsupported operation");
};
A = Cf.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  var e = W(this.lb);
  return e ? new Cf(this.meta, e, this.qb, null) : this.qb != null ? new Cf(this.meta, this.qb, null, null) : null;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return su(fl, this.meta);
};
A.Ba = function() {
  return I(this.lb);
};
A.Fa = function() {
  var e = W(this.lb);
  return e ? new Cf(this.meta, e, this.qb, null) : this.qb == null ? this.ha(null) : new Cf(this.meta, this.qb, null, null);
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new Cf(n, this.lb, this.qb, this.H);
};
A.aa = function(e, n) {
  return kt(n, this);
};
Cf.prototype[Li] = function() {
  return ti(this);
};
A = Xh.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, this.count.h ? this.count.h(this) : this.count.call(null, this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.Xa = function() {
  return new I4(this.lb, eo(this.qb));
};
A.U = function() {
  return this.meta;
};
A.$ = function() {
  return this.count;
};
A.Xb = function() {
  return I(this.lb);
};
A.Yb = function() {
  if (j(this.lb)) {
    var e = W(this.lb);
    return e ? new Xh(this.meta, this.count - 1, e, this.qb, null) : new Xh(this.meta, this.count - 1, z(this.qb), Dt, null);
  }
  return this;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return su(yB, this.meta);
};
A.Ba = function() {
  return I(this.lb);
};
A.Fa = function() {
  return tn(z(this));
};
A.W = function() {
  var e = z(this.qb), n = this.lb;
  return j(j(n) ? n : e) ? new Cf(null, this.lb, z(e), null) : null;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new Xh(n, this.count, this.lb, this.qb, this.H);
};
A.aa = function(e, n) {
  return j(this.lb) ? (e = this.qb, n = new Xh(this.meta, this.count + 1, this.lb, yt.g(j(e) ? e : Dt, n), null)) : n = new Xh(this.meta, this.count + 1, yt.g(this.lb, n), Dt, null), n;
};
var yB = new Xh(null, 0, null, Dt, wB);
Xh.prototype[Li] = function() {
  return ti(this);
};
IK.prototype.N = function() {
  return !1;
};
var Iq = new IK();
hf.prototype.ja = function() {
  var e = this.i < this.Zd;
  return e || this.ue.ja();
};
hf.prototype.next = function() {
  if (this.i < this.Zd) {
    var e = O.g(this.cf, this.i);
    return this.i += 1, new yl(e, zo(this.gf, e));
  }
  return this.ue.next();
};
hf.prototype.remove = function() {
  return Error("Unsupported operation");
};
R4.prototype.next = function() {
  if (this.X != null) {
    var e = I(this.X), n = O.j(e, 0, null);
    return e = O.j(e, 1, null), this.X = W(this.X), { value: [n, e], done: !1 };
  }
  return { value: null, done: !0 };
};
NL.prototype.next = function() {
  if (this.X != null) {
    var e = I(this.X);
    return this.X = W(this.X), { value: [e, e], done: !1 };
  }
  return { value: null, done: !0 };
};
A = yl.prototype;
A.jc = Rn;
A.Ub = function(e, n) {
  switch (n) {
    case 0:
      return new yl(0, this.key);
    case 1:
      return new yl(1, this.val);
    default:
      return null;
  }
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.wa = function(e, n) {
  return this.Wa(null, n, null);
};
A.P = function(e, n, t) {
  return this.Wa(null, n, t);
};
A.Y = function(e, n) {
  if (n === 0) return this.key;
  if (n === 1) return this.val;
  throw Error("Index out of bounds");
};
A.Wa = function(e, n, t) {
  return n === 0 ? this.key : n === 1 ? this.val : t;
};
A.Cb = function(e, n, t) {
  return new v(null, 2, 5, y, [this.key, this.val], null).Cb(null, n, t);
};
A.U = function() {
  return null;
};
A.$ = function() {
  return 2;
};
A.xd = function() {
  return this.key;
};
A.yd = function() {
  return this.val;
};
A.Xb = function() {
  return this.val;
};
A.Yb = function() {
  return new v(null, 1, 5, y, [this.key], null);
};
A.Wb = function() {
  return new hn([this.val, this.key], 0, null);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return null;
};
A.Da = function(e, n) {
  return E3(this, n);
};
A.Ea = function(e, n, t) {
  return E4(this, n, t);
};
A.Aa = function(e, n, t) {
  return Dn.j(new v(null, 2, 5, y, [this.key, this.val], null), n, t);
};
A.gb = function(e, n) {
  return n === 0 || n === 1;
};
A.W = function() {
  return new hn([this.key, this.val], 0, null);
};
A.Z = function(e, n) {
  return Bl(new v(null, 2, 5, y, [this.key, this.val], null), n);
};
A.aa = function(e, n) {
  return new v(null, 3, 5, y, [this.key, this.val, n], null);
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.Y(null, e);
};
A.g = function(e, n) {
  return this.Wa(null, e, n);
};
A = Ip.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.zb;
};
A.Ca = function() {
  return this.i < this.A.length - 2 ? new Ip(this.A, this.i + 2, null) : null;
};
A.$ = function() {
  return (this.A.length - this.i) / 2;
};
A.O = function() {
  return qu(this);
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  return nc(n, t, this);
};
A.Ba = function() {
  return new yl(this.A[this.i], this.A[this.i + 1]);
};
A.Fa = function() {
  return this.i < this.A.length - 2 ? new Ip(this.A, this.i + 2, null) : fl;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.zb ? this : new Ip(this.A, this.i, n);
};
A.aa = function(e, n) {
  return kt(n, this);
};
Ip.prototype[Li] = function() {
  return ti(this);
};
CL.prototype.ja = function() {
  return this.i < this.G;
};
CL.prototype.next = function() {
  var e = new yl(this.A[this.i], this.A[this.i + 1]);
  return this.i += 2, e;
};
A = $.prototype;
A.jc = Rn;
A.Ub = function(e, n) {
  return e = hg(this.A, n), e === -1 ? null : new yl(this.A[e], this.A[e + 1]);
};
A.toString = function() {
  return Ui(this);
};
A.keys = function() {
  return ti(xi.h ? xi.h(this) : xi.call(null, this));
};
A.entries = function() {
  return new R4(z(z(this)));
};
A.values = function() {
  return ti(Ju.h ? Ju.h(this) : Ju.call(null, this));
};
A.has = function(e) {
  return Ol(this, e);
};
A.get = function(e, n) {
  return this.P(null, e, n);
};
A.forEach = function(e) {
  for (var n = z(this), t = null, l = 0, r = 0; ; ) if (r < l) {
    var u = t.Y(null, r), o = O.j(u, 0, null);
    u = O.j(u, 1, null), e.g ? e.g(u, o) : e.call(null, u, o), r += 1;
  } else if (n = z(n)) oi(n) ? (t = Jr(n), n = Wr(n), o = t, l = Cn(t), t = o) : (t = I(n), o = O.j(t, 0, null), u = O.j(t, 1, null), e.g ? e.g(u, o) : e.call(null, u, o), n = W(n), t = null, l = 0), r = 0;
  else return null;
};
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  return e = hg(this.A, n), e === -1 ? t : this.A[e + 1];
};
A.nb = function(e, n, t) {
  e = this.A.length;
  for (var l = 0; ; ) if (l < e) {
    var r = this.A[l], u = this.A[l + 1];
    if (t = n.j ? n.j(t, r, u) : n.call(null, t, r, u), ni(t)) return sn(t);
    l += 2;
  } else return t;
};
A.Xa = function() {
  return new CL(this.A, 2 * this.G);
};
A.U = function() {
  return this.meta;
};
A.$ = function() {
  return this.G;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = Na(this));
};
A.N = function(e, n) {
  if (ci(n) && !Ap(n)) if (e = this.A.length, this.G === n.$(null)) for (var t = 0; ; ) if (t < e) {
    var l = n.P(null, this.A[t], Da);
    if (l !== Da) if (on.g(this.A[t + 1], l)) t += 2;
    else return !1;
    else return !1;
  } else return !0;
  else return !1;
  else return !1;
};
A.xc = function() {
  return new NK(this.A.length, ki(this.A));
};
A.ha = function() {
  return su(Tt, this.meta);
};
A.Da = function(e, n) {
  return wK(this, n);
};
A.Ea = function(e, n, t) {
  return vK(this, n, t);
};
A.sb = function(e, n) {
  if (0 <= hg(this.A, n)) {
    e = this.A.length;
    var t = e - 2;
    if (t === 0) return this.ha(null);
    t = Array(t);
    for (var l = 0, r = 0; ; ) {
      if (l >= e) return new $(this.meta, this.G - 1, t, null);
      on.g(n, this.A[l]) || (t[r] = this.A[l], t[r + 1] = this.A[l + 1], r += 2), l += 2;
    }
  } else return this;
};
A.Aa = function(e, n, t) {
  if (e = hg(this.A, n), e === -1) {
    if (this.G < _B) {
      e = this.A;
      for (var l = e.length, r = Array(l + 2), u = 0; u < l; ) r[u] = e[u], u += 1;
      return r[l] = n, r[l + 1] = t, new $(this.meta, this.G + 1, r, null);
    }
    return su(Cw(lr.g(b2, this), n, t), this.meta);
  }
  return t === this.A[e + 1] ? this : (n = ki(this.A), n[e + 1] = t, new $(this.meta, this.G, n, null));
};
A.gb = function(e, n) {
  return hg(this.A, n) !== -1;
};
A.W = function() {
  var e = this.A;
  return 0 <= e.length - 2 ? new Ip(e, 0, null) : null;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new $(n, this.G, this.A, this.H);
};
A.aa = function(e, n) {
  if (or(n)) return this.Aa(null, Ul(n, 0), Ul(n, 1));
  for (e = this, n = z(n); ; ) {
    if (n == null) return e;
    var t = I(n);
    if (or(t)) e = Cw(e, Ul(t, 0), Ul(t, 1)), n = W(n);
    else throw Error("conj on a map takes map entries or seqables of map entries");
  }
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.wa(null, e);
};
A.g = function(e, n) {
  return this.P(null, e, n);
};
var Tt = new $(null, 0, [], Z3), _B = 8;
$.prototype[Li] = function() {
  return ti(this);
};
A = NK.prototype;
A.$ = function() {
  if (this.rc) return wy(this.len, 2);
  throw Error("count after persistent!");
};
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  if (this.rc) return e = hg(this.A, n), e === -1 ? t : this.A[e + 1];
  throw Error("lookup after persistent!");
};
A.Cc = function(e, n) {
  if (this.rc) {
    if (Qd(n)) return this.Bc(null, Zu.h ? Zu.h(n) : Zu.call(null, n), Ho.h ? Ho.h(n) : Ho.call(null, n));
    if (or(n)) return this.Bc(null, n.h ? n.h(0) : n.call(null, 0), n.h ? n.h(1) : n.call(null, 1));
    for (e = z(n), n = this; ; ) {
      var t = I(e);
      if (j(t)) e = W(e), n = Pw(n, Zu.h ? Zu.h(t) : Zu.call(null, t), Ho.h ? Ho.h(t) : Ho.call(null, t));
      else return n;
    }
  } else throw Error("conj! after persistent!");
};
A.Oc = function() {
  if (this.rc) return this.rc = !1, new $(null, wy(this.len, 2), this.A, null);
  throw Error("persistent! called twice");
};
A.Bc = function(e, n, t) {
  if (this.rc)
    return e = hg(this.A, n), e === -1 ? this.len + 2 <= 2 * _B ? (this.len += 2, this.A.push(n), this.A.push(t), this) : ao.j(yA.g ? yA.g(this.len, this.A) : yA.call(null, this.len, this.A), n, t) : (t !== this.A[e + 1] && (this.A[e + 1] = t), this);
  throw Error("assoc! after persistent!");
};
A.Fd = function(e, n) {
  if (this.rc) return e = hg(this.A, n), 0 <= e && (this.A[e] = this.A[this.len - 2], this.A[e + 1] = this.A[this.len - 1], e = this.A, e.pop(), e.pop(), this.len -= 2), this;
  throw Error("dissoc! after persistent!");
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.P(null, e, null);
};
A.g = function(e, n) {
  return this.P(null, e, n);
};
p2.prototype.advance = function() {
  for (var e = this.A.length; ; ) if (this.i < e) {
    var n = this.A[this.i], t = this.A[this.i + 1];
    if (n != null ? n = this.Wc = new yl(n, t) : t != null ? (n = eo(t), n = n.ja() ? this.Jb = n : !1) : n = !1, this.i += 2, n) return !0;
  } else return !1;
};
p2.prototype.ja = function() {
  var e = this.Wc != null;
  return e || ((e = this.Jb != null) ? e : this.advance());
};
p2.prototype.next = function() {
  if (this.Wc != null) {
    var e = this.Wc;
    return this.Wc = null, e;
  }
  if (this.Jb != null) return e = this.Jb.next(), this.Jb.ja() || (this.Jb = null), e;
  if (this.advance()) return this.next();
  throw Error("No such element");
};
p2.prototype.remove = function() {
  return Error("Unsupported operation");
};
A = kc.prototype;
A.ac = function(e) {
  if (e === this.ea) return this;
  var n = cp(this.ga), t = Array(0 > n ? 4 : 2 * (n + 1));
  return ec(this.A, 0, t, 0, 2 * n), new kc(e, this.ga, t);
};
A.Vc = function(e, n, t, l, r) {
  var u = 1 << (t >>> n & 31);
  if (!(this.ga & u)) return this;
  var o = cp(this.ga & u - 1), a = this.A[2 * o], h = this.A[2 * o + 1];
  return a == null ? (n = h.Vc(e, n + 5, t, l, r), n === h ? this : n != null ? Mm(this, e, 2 * o + 1, n) : this.ga === u ? null : SU(this, e, u, o)) : Mc(l, a) ? (r.val = !0, SU(this, e, u, o)) : this;
};
A.Tc = function() {
  return ox ? ox(this.A) : vy.call(null, this.A);
};
A.sc = function(e, n) {
  return CK(this.A, e, n);
};
A.kc = function(e, n, t, l) {
  var r = 1 << (n >>> e & 31);
  if (!(this.ga & r)) return l;
  var u = cp(this.ga & r - 1);
  return r = this.A[2 * u], u = this.A[2 * u + 1], r == null ? u.kc(e + 5, n, t, l) : Mc(t, r) ? u : l;
};
A.Gb = function(e, n, t, l, r, u) {
  var o = 1 << (t >>> n & 31), a = cp(this.ga & o - 1);
  if (!(this.ga & o)) {
    var h = cp(this.ga);
    if (2 * h < this.A.length) {
      for (e = this.ac(e), n = e.A, u.val = !0, t = 2 * (h - a), u = 2 * a + (t - 1), h = 2 * (a + 1) + (t - 1); t !== 0; ) n[h] = n[u], --h, --t, --u;
      return n[2 * a] = l, n[2 * a + 1] = r, e.ga |= o, e;
    }
    if (16 <= h) {
      for (a = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null], a[t >>> n & 31] = Vf.Gb(e, n + 5, t, l, r, u), r = l = 0; 32 > l; ) this.ga >>> l & 1 && (a[l] = this.A[r] != null ? Vf.Gb(e, n + 5, Uu(this.A[r]), this.A[r], this.A[r + 1], u) : this.A[r + 1], r += 2), l += 1;
      return new Pm(e, h + 1, a);
    }
    return n = Array(2 * (h + 4)), ec(this.A, 0, n, 0, 2 * a), n[2 * a] = l, n[2 * a + 1] = r, ec(this.A, 2 * a, n, 2 * (a + 1), 2 * (h - a)), u.val = !0, e = this.ac(e), e.A = n, e.ga |= o, e;
  }
  return h = this.A[2 * a], o = this.A[2 * a + 1], h == null ? (h = o.Gb(e, n + 5, t, l, r, u), h === o ? this : Mm(this, e, 2 * a + 1, h)) : Mc(l, h) ? r === o ? this : Mm(this, e, 2 * a + 1, r) : (u.val = !0, u = n + 5, l = dI ? dI(e, u, h, o, t, l, r) : PK.call(null, e, u, h, o, t, l, r), r = 2 * a, a = 2 * a + 1, e = this.ac(e), e.A[r] = null, e.A[a] = l, e);
};
A.Fb = function(e, n, t, l, r) {
  var u = 1 << (n >>> e & 31), o = cp(this.ga & u - 1);
  if (!(this.ga & u)) {
    var a = cp(this.ga);
    if (16 <= a) {
      for (o = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null], o[n >>> e & 31] = Vf.Fb(e + 5, n, t, l, r), l = t = 0; 32 > t; ) this.ga >>> t & 1 && (o[t] = this.A[l] != null ? Vf.Fb(e + 5, Uu(this.A[l]), this.A[l], this.A[l + 1], r) : this.A[l + 1], l += 2), t += 1;
      return new Pm(null, a + 1, o);
    }
    return e = Array(2 * (a + 1)), ec(
      this.A,
      0,
      e,
      0,
      2 * o
    ), e[2 * o] = t, e[2 * o + 1] = l, ec(this.A, 2 * o, e, 2 * (o + 1), 2 * (a - o)), r.val = !0, new kc(null, this.ga | u, e);
  }
  var h = this.A[2 * o];
  return u = this.A[2 * o + 1], h == null ? (a = u.Fb(e + 5, n, t, l, r), a === u ? this : new kc(null, this.ga, Cm(this.A, 2 * o + 1, a))) : Mc(t, h) ? l === u ? this : new kc(null, this.ga, Cm(this.A, 2 * o + 1, l)) : (r.val = !0, r = this.ga, a = this.A, e += 5, e = fI ? fI(e, h, u, n, t, l) : PK.call(null, e, h, u, n, t, l), t = 2 * o, o = 2 * o + 1, l = ki(a), l[t] = null, l[o] = e, new kc(null, r, l));
};
A.Sc = function(e, n, t, l) {
  var r = 1 << (n >>> e & 31);
  if (!(this.ga & r)) return l;
  var u = cp(this.ga & r - 1);
  return r = this.A[2 * u], u = this.A[2 * u + 1], r == null ? u.Sc(e + 5, n, t, l) : Mc(t, r) ? new yl(r, u) : l;
};
A.Uc = function(e, n, t) {
  var l = 1 << (n >>> e & 31);
  if (!(this.ga & l)) return this;
  var r = cp(this.ga & l - 1), u = this.A[2 * r], o = this.A[2 * r + 1];
  return u == null ? (e = o.Uc(e + 5, n, t), e === o ? this : e != null ? new kc(null, this.ga, Cm(this.A, 2 * r + 1, e)) : this.ga === l ? null : new kc(null, this.ga ^ l, hI(this.A, r))) : Mc(t, u) ? this.ga === l ? null : new kc(null, this.ga ^ l, hI(this.A, r)) : this;
};
A.Xa = function() {
  return new p2(this.A);
};
var Vf = new kc(null, 0, []);
N4.prototype.ja = function() {
  for (var e = this.A.length; ; ) {
    if (this.Jb != null && this.Jb.ja()) return !0;
    if (this.i < e) {
      var n = this.A[this.i];
      this.i += 1, n != null && (this.Jb = eo(n));
    } else return !1;
  }
};
N4.prototype.next = function() {
  if (this.ja()) return this.Jb.next();
  throw Error("No such element");
};
N4.prototype.remove = function() {
  return Error("Unsupported operation");
};
A = Pm.prototype;
A.ac = function(e) {
  return e === this.ea ? this : new Pm(e, this.G, ki(this.A));
};
A.Vc = function(e, n, t, l, r) {
  var u = t >>> n & 31, o = this.A[u];
  return o == null ? this : (n = o.Vc(e, n + 5, t, l, r), n === o ? this : n == null ? 8 >= this.G ? MK(this, e, u) : (e = Mm(this, e, u, n), --e.G, e) : Mm(this, e, u, n));
};
A.Tc = function() {
  return pI ? pI(this.A) : ML.call(null, this.A);
};
A.sc = function(e, n) {
  for (var t = this.A.length, l = 0; ; ) if (l < t) {
    var r = this.A[l];
    if (r != null) {
      if (n = r.sc(e, n), ni(n)) return n;
      l += 1;
    } else l += 1;
  } else return n;
};
A.kc = function(e, n, t, l) {
  var r = this.A[n >>> e & 31];
  return r != null ? r.kc(e + 5, n, t, l) : l;
};
A.Gb = function(e, n, t, l, r, u) {
  var o = t >>> n & 31, a = this.A[o];
  return a == null ? (e = Mm(this, e, o, Vf.Gb(e, n + 5, t, l, r, u)), e.G += 1, e) : (n = a.Gb(e, n + 5, t, l, r, u), n === a ? this : Mm(this, e, o, n));
};
A.Fb = function(e, n, t, l, r) {
  var u = n >>> e & 31, o = this.A[u];
  return o == null ? new Pm(null, this.G + 1, Cm(this.A, u, Vf.Fb(e + 5, n, t, l, r))) : (e = o.Fb(e + 5, n, t, l, r), e === o ? this : new Pm(null, this.G, Cm(this.A, u, e)));
};
A.Sc = function(e, n, t, l) {
  var r = this.A[n >>> e & 31];
  return r != null ? r.Sc(e + 5, n, t, l) : l;
};
A.Uc = function(e, n, t) {
  var l = n >>> e & 31, r = this.A[l];
  return r != null ? (e = r.Uc(e + 5, n, t), e === r ? this : e == null ? 8 >= this.G ? MK(this, null, l) : new Pm(null, this.G - 1, Cm(this.A, l, e)) : new Pm(null, this.G, Cm(this.A, l, e))) : this;
};
A.Xa = function() {
  return new N4(this.A);
};
A = $m.prototype;
A.ac = function(e) {
  if (e === this.ea) return this;
  var n = Array(2 * (this.G + 1));
  return ec(this.A, 0, n, 0, 2 * this.G), new $m(e, this.Zb, this.G, n);
};
A.Vc = function(e, n, t, l, r) {
  return n = m2(this.A, this.G, l), n === -1 ? this : (r.val = !0, this.G === 1 ? null : (e = this.ac(e), r = e.A, r[n] = r[2 * this.G - 2], r[n + 1] = r[2 * this.G - 1], r[2 * this.G - 1] = null, r[2 * this.G - 2] = null, --e.G, e));
};
A.Tc = function() {
  return ox ? ox(this.A) : vy.call(null, this.A);
};
A.sc = function(e, n) {
  return CK(this.A, e, n);
};
A.kc = function(e, n, t, l) {
  return e = m2(this.A, this.G, t), 0 > e ? l : Mc(t, this.A[e]) ? this.A[e + 1] : l;
};
A.Gb = function(e, n, t, l, r, u) {
  return t === this.Zb ? (n = m2(this.A, this.G, l), n === -1 ? this.A.length > 2 * this.G ? (n = 2 * this.G, t = 2 * this.G + 1, e = this.ac(e), e.A[n] = l, e.A[t] = r, u.val = !0, e.G += 1, e) : (t = this.A.length, n = Array(t + 2), ec(this.A, 0, n, 0, t), n[t] = l, n[t + 1] = r, u.val = !0, l = this.G + 1, e === this.ea ? (this.A = n, this.G = l, e = this) : e = new $m(this.ea, this.Zb, l, n), e) : this.A[n + 1] === r ? this : Mm(this, e, n + 1, r)) : new kc(e, 1 << (this.Zb >>> n & 31), [null, this, null, null]).Gb(e, n, t, l, r, u);
};
A.Fb = function(e, n, t, l, r) {
  return n === this.Zb ? (e = m2(this.A, this.G, t), e === -1 ? (e = 2 * this.G, n = Array(e + 2), ec(this.A, 0, n, 0, e), n[e] = t, n[e + 1] = l, r.val = !0, new $m(null, this.Zb, this.G + 1, n)) : on.g(this.A[e + 1], l) ? this : new $m(null, this.Zb, this.G, Cm(this.A, e + 1, l))) : new kc(null, 1 << (this.Zb >>> e & 31), [null, this]).Fb(e, n, t, l, r);
};
A.Sc = function(e, n, t, l) {
  return e = m2(this.A, this.G, t), 0 > e ? l : Mc(t, this.A[e]) ? new yl(this.A[e], this.A[e + 1]) : l;
};
A.Uc = function(e, n, t) {
  return e = m2(this.A, this.G, t), e === -1 ? this : this.G === 1 ? null : new $m(null, this.Zb, this.G - 1, hI(this.A, wy(e, 2)));
};
A.Xa = function() {
  return new p2(this.A);
};
A = Jd.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  if (this.X == null) {
    var e = this.nodes, n = this.i + 2;
    return bf ? bf(e, n, null) : vy.call(null, e, n, null);
  }
  e = this.nodes, n = this.i;
  var t = W(this.X);
  return bf ? bf(e, n, t) : vy.call(null, e, n, t);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  return nc(n, t, this);
};
A.Ba = function() {
  return this.X == null ? new yl(this.nodes[this.i], this.nodes[this.i + 1]) : I(this.X);
};
A.Fa = function() {
  var e = this, n = e.X == null ? function() {
    var t = e.nodes, l = e.i + 2;
    return bf ? bf(t, l, null) : vy.call(null, t, l, null);
  }() : function() {
    var t = e.nodes, l = e.i, r = W(e.X);
    return bf ? bf(t, l, r) : vy.call(null, t, l, r);
  }();
  return n ?? fl;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new Jd(n, this.nodes, this.i, this.X, this.H);
};
A.aa = function(e, n) {
  return kt(n, this);
};
Jd.prototype[Li] = function() {
  return ti(this);
};
A = Uw.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  var e = this.nodes, n = this.i, t = W(this.X);
  return yy ? yy(e, n, t) : ML.call(null, e, n, t);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  return nc(n, t, this);
};
A.Ba = function() {
  return I(this.X);
};
A.Fa = function() {
  var e = this.nodes, n = this.i, t = W(this.X);
  return e = yy ? yy(e, n, t) : ML.call(null, e, n, t), e ?? fl;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new Uw(n, this.nodes, this.i, this.X, this.H);
};
A.aa = function(e, n) {
  return kt(n, this);
};
Uw.prototype[Li] = function() {
  return ti(this);
};
C4.prototype.ja = function() {
  return !this.Sd || this.xe.ja();
};
C4.prototype.next = function() {
  return this.Sd ? this.xe.next() : (this.Sd = !0, new yl(null, this.eb));
};
C4.prototype.remove = function() {
  return Error("Unsupported operation");
};
A = Qh.prototype;
A.jc = Rn;
A.Ub = function(e, n) {
  return n == null ? this.cb ? new yl(null, this.eb) : null : this.root == null ? null : this.root.Sc(0, Uu(n), n, null);
};
A.toString = function() {
  return Ui(this);
};
A.keys = function() {
  return ti(xi.h ? xi.h(this) : xi.call(null, this));
};
A.entries = function() {
  return new R4(z(z(this)));
};
A.values = function() {
  return ti(Ju.h ? Ju.h(this) : Ju.call(null, this));
};
A.has = function(e) {
  return Ol(this, e);
};
A.get = function(e, n) {
  return this.P(null, e, n);
};
A.forEach = function(e) {
  for (var n = z(this), t = null, l = 0, r = 0; ; ) if (r < l) {
    var u = t.Y(null, r), o = O.j(u, 0, null);
    u = O.j(u, 1, null), e.g ? e.g(u, o) : e.call(null, u, o), r += 1;
  } else if (n = z(n)) oi(n) ? (t = Jr(n), n = Wr(n), o = t, l = Cn(t), t = o) : (t = I(n), o = O.j(t, 0, null), u = O.j(t, 1, null), e.g ? e.g(u, o) : e.call(null, u, o), n = W(n), t = null, l = 0), r = 0;
  else return null;
};
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  return n == null ? this.cb ? this.eb : t : this.root == null ? t : this.root.kc(0, Uu(n), n, t);
};
A.nb = function(e, n, t) {
  return e = this.cb ? n.j ? n.j(t, null, this.eb) : n.call(null, t, null, this.eb) : t, ni(e) ? sn(e) : this.root != null ? S3(this.root.sc(n, e)) : e;
};
A.Xa = function() {
  var e = this.root ? eo(this.root) : ed();
  return this.cb ? new C4(this.eb, e) : e;
};
A.U = function() {
  return this.meta;
};
A.$ = function() {
  return this.G;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = Na(this));
};
A.N = function(e, n) {
  return RK(this, n);
};
A.xc = function() {
  return new $K(this.root, this.G, this.cb, this.eb);
};
A.ha = function() {
  return su(b2, this.meta);
};
A.sb = function(e, n) {
  return n == null ? this.cb ? new Qh(this.meta, this.G - 1, this.root, !1, null, null) : this : this.root == null ? this : (e = this.root.Uc(0, Uu(n), n), e === this.root ? this : new Qh(this.meta, this.G - 1, e, this.cb, this.eb, null));
};
A.Aa = function(e, n, t) {
  return n == null ? this.cb && t === this.eb ? this : new Qh(this.meta, this.cb ? this.G : this.G + 1, this.root, !0, t, null) : (e = new M3(), n = (this.root == null ? Vf : this.root).Fb(0, Uu(n), n, t, e), n === this.root ? this : new Qh(this.meta, e.val ? this.G + 1 : this.G, n, this.cb, this.eb, null));
};
A.gb = function(e, n) {
  return n == null ? this.cb : this.root == null ? !1 : this.root.kc(0, Uu(n), n, Da) !== Da;
};
A.W = function() {
  if (0 < this.G) {
    var e = this.root != null ? this.root.Tc() : null;
    return this.cb ? kt(new yl(null, this.eb), e) : e;
  }
  return null;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new Qh(n, this.G, this.root, this.cb, this.eb, this.H);
};
A.aa = function(e, n) {
  if (or(n)) return this.Aa(null, Ul(n, 0), Ul(n, 1));
  for (e = this, n = z(n); ; ) {
    if (n == null) return e;
    var t = I(n);
    if (or(t)) e = Cw(e, Ul(t, 0), Ul(t, 1)), n = W(n);
    else throw Error("conj on a map takes map entries or seqables of map entries");
  }
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.wa(null, e);
};
A.g = function(e, n) {
  return this.P(null, e, n);
};
var b2 = new Qh(null, 0, null, !1, null, Z3);
Qh.prototype[Li] = function() {
  return ti(this);
};
A = $K.prototype;
A.$ = function() {
  if (this.ea) return this.count;
  throw Error("count after persistent!");
};
A.wa = function(e, n) {
  return n == null ? this.cb ? this.eb : null : this.root == null ? null : this.root.kc(0, Uu(n), n);
};
A.P = function(e, n, t) {
  return n == null ? this.cb ? this.eb : t : this.root == null ? t : this.root.kc(0, Uu(n), n, t);
};
A.Cc = function(e, n) {
  e: if (this.ea) if (Qd(n)) e = uE(this, Zu.h ? Zu.h(n) : Zu.call(null, n), Ho.h ? Ho.h(n) : Ho.call(null, n));
  else if (or(n)) e = uE(this, n.h ? n.h(0) : n.call(null, 0), n.h ? n.h(1) : n.call(null, 1));
  else for (e = z(n), n = this; ; ) {
    var t = I(e);
    if (j(t)) e = W(e), n = uE(n, Zu.h ? Zu.h(t) : Zu.call(null, t), Ho.h ? Ho.h(t) : Ho.call(null, t));
    else {
      e = n;
      break e;
    }
  }
  else throw Error("conj! after persistent");
  return e;
};
A.Oc = function() {
  if (this.ea) {
    this.ea = null;
    var e = new Qh(null, this.count, this.root, this.cb, this.eb, null);
  } else throw Error("persistent! called twice");
  return e;
};
A.Bc = function(e, n, t) {
  return uE(this, n, t);
};
A.Fd = function(e, n) {
  if (this.ea) n == null ? this.cb && (this.cb = !1, this.eb = null, --this.count) : this.root != null && (e = new M3(), n = this.root.Vc(this.ea, 0, Uu(n), n, e), n !== this.root && (this.root = n), e.val && --this.count);
  else throw Error("dissoc! after persistent!");
  return this;
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.wa(null, e);
};
A.g = function(e, n) {
  return this.P(null, e, n);
};
A = Mf.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  var e = I(this.stack);
  return e = PL(this.mc ? e.right : e.left, W(this.stack), this.mc), e == null ? null : new Mf(null, e, this.mc, this.G - 1, null);
};
A.$ = function() {
  return 0 > this.G ? Cn(W(this)) + 1 : this.G;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  return nc(n, t, this);
};
A.Ba = function() {
  return WO(this.stack);
};
A.Fa = function() {
  var e = I(this.stack);
  return e = PL(this.mc ? e.right : e.left, W(this.stack), this.mc), e != null ? new Mf(null, e, this.mc, this.G - 1, null) : fl;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new Mf(n, this.stack, this.mc, this.G, this.H);
};
A.aa = function(e, n) {
  return kt(n, this);
};
Mf.prototype[Li] = function() {
  return ti(this);
};
var xB = function e(n, t, l) {
  var r = n.left != null ? function() {
    var a = n.left;
    return e.j ? e.j(a, t, l) : e.call(null, a, t, l);
  }() : l;
  if (ni(r)) return r;
  var u = function() {
    var a = n.key, h = n.val;
    return t.j ? t.j(r, a, h) : t.call(null, r, a, h);
  }();
  if (ni(u)) return u;
  if (n.right != null) {
    var o = n.right;
    return e.j ? e.j(o, t, u) : e.call(null, o, t, u);
  }
  return u;
};
A = Qr.prototype;
A.jc = Rn;
A.Ub = function(e, n) {
  switch (n) {
    case 0:
      return new yl(0, this.key);
    case 1:
      return new yl(1, this.val);
    default:
      return null;
  }
};
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.Vd = function(e) {
  return e.Yd(this);
};
A.Zc = function() {
  return new Jl(this.key, this.val, this.left, this.right);
};
A.Sb = function() {
  return this;
};
A.Ud = function(e) {
  return e.Xd(this);
};
A.replace = function(e, n, t, l) {
  return new Qr(e, n, t, l);
};
A.Xd = function(e) {
  return new Qr(e.key, e.val, this, e.right);
};
A.Yd = function(e) {
  return new Qr(e.key, e.val, e.left, this);
};
A.sc = function(e, n) {
  return xB(this, e, n);
};
A.wa = function(e, n) {
  return this.Wa(null, n, null);
};
A.P = function(e, n, t) {
  return this.Wa(null, n, t);
};
A.Y = function(e, n) {
  if (n === 0) return this.key;
  if (n === 1) return this.val;
  throw Error("Index out of bounds");
};
A.Wa = function(e, n, t) {
  return n === 0 ? this.key : n === 1 ? this.val : t;
};
A.Cb = function(e, n, t) {
  return new v(null, 2, 5, y, [this.key, this.val], null).Cb(null, n, t);
};
A.U = function() {
  return null;
};
A.$ = function() {
  return 2;
};
A.xd = function() {
  return this.key;
};
A.yd = function() {
  return this.val;
};
A.Xb = function() {
  return this.val;
};
A.Yb = function() {
  return new v(null, 1, 5, y, [this.key], null);
};
A.Wb = function() {
  return new hn([this.val, this.key], 0, null);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return null;
};
A.Da = function(e, n) {
  return E3(this, n);
};
A.Ea = function(e, n, t) {
  return E4(this, n, t);
};
A.Aa = function(e, n, t) {
  return Dn.j(new v(null, 2, 5, y, [this.key, this.val], null), n, t);
};
A.gb = function(e, n) {
  return n === 0 || n === 1;
};
A.W = function() {
  return new hn([this.key, this.val], 0, null);
};
A.Z = function(e, n) {
  return su(new v(null, 2, 5, y, [this.key, this.val], null), n);
};
A.aa = function(e, n) {
  return new v(null, 3, 5, y, [this.key, this.val, n], null);
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.Y(null, e);
};
A.g = function(e, n) {
  return this.Wa(null, e, n);
};
Qr.prototype[Li] = function() {
  return ti(this);
};
A = Jl.prototype;
A.jc = Rn;
A.Ub = function(e, n) {
  switch (n) {
    case 0:
      return new yl(0, this.key);
    case 1:
      return new yl(1, this.val);
    default:
      return null;
  }
};
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.Vd = function(e) {
  return new Jl(this.key, this.val, this.left, e);
};
A.Zc = function() {
  throw Error("red-black tree invariant violation");
};
A.Sb = function() {
  return new Qr(this.key, this.val, this.left, this.right);
};
A.Ud = function(e) {
  return new Jl(this.key, this.val, e, this.right);
};
A.replace = function(e, n, t, l) {
  return new Jl(e, n, t, l);
};
A.Xd = function(e) {
  return this.left instanceof Jl ? new Jl(this.key, this.val, this.left.Sb(), new Qr(e.key, e.val, this.right, e.right)) : this.right instanceof Jl ? new Jl(this.right.key, this.right.val, new Qr(this.key, this.val, this.left, this.right.left), new Qr(e.key, e.val, this.right.right, e.right)) : new Qr(e.key, e.val, this, e.right);
};
A.Yd = function(e) {
  return this.right instanceof Jl ? new Jl(this.key, this.val, new Qr(e.key, e.val, e.left, this.left), this.right.Sb()) : this.left instanceof Jl ? new Jl(this.left.key, this.left.val, new Qr(e.key, e.val, e.left, this.left.left), new Qr(this.key, this.val, this.left.right, this.right)) : new Qr(e.key, e.val, e.left, this);
};
A.sc = function(e, n) {
  return xB(this, e, n);
};
A.wa = function(e, n) {
  return this.Wa(null, n, null);
};
A.P = function(e, n, t) {
  return this.Wa(null, n, t);
};
A.Y = function(e, n) {
  if (n === 0) return this.key;
  if (n === 1) return this.val;
  throw Error("Index out of bounds");
};
A.Wa = function(e, n, t) {
  return n === 0 ? this.key : n === 1 ? this.val : t;
};
A.Cb = function(e, n, t) {
  return new v(null, 2, 5, y, [this.key, this.val], null).Cb(null, n, t);
};
A.U = function() {
  return null;
};
A.$ = function() {
  return 2;
};
A.xd = function() {
  return this.key;
};
A.yd = function() {
  return this.val;
};
A.Xb = function() {
  return this.val;
};
A.Yb = function() {
  return new v(null, 1, 5, y, [this.key], null);
};
A.Wb = function() {
  return new hn([this.val, this.key], 0, null);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return null;
};
A.Da = function(e, n) {
  return E3(this, n);
};
A.Ea = function(e, n, t) {
  return E4(this, n, t);
};
A.Aa = function(e, n, t) {
  return Dn.j(new v(null, 2, 5, y, [this.key, this.val], null), n, t);
};
A.gb = function(e, n) {
  return n === 0 || n === 1;
};
A.W = function() {
  return new hn([this.key, this.val], 0, null);
};
A.Z = function(e, n) {
  return su(new v(null, 2, 5, y, [this.key, this.val], null), n);
};
A.aa = function(e, n) {
  return new v(null, 3, 5, y, [this.key, this.val, n], null);
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.Y(null, e);
};
A.g = function(e, n) {
  return this.Wa(null, e, n);
};
Jl.prototype[Li] = function() {
  return ti(this);
};
var zme = function e(n, t, l, r, u) {
  if (t == null) return new Jl(l, r, null, null);
  var o = function() {
    var a = t.key;
    return n.g ? n.g(l, a) : n.call(null, l, a);
  }();
  return o === 0 ? (u[0] = t, null) : 0 > o ? (o = function() {
    var a = t.left;
    return e.I ? e.I(n, a, l, r, u) : e.call(null, n, a, l, r, u);
  }(), o != null ? t.Ud(o) : null) : (o = function() {
    var a = t.right;
    return e.I ? e.I(n, a, l, r, u) : e.call(null, n, a, l, r, u);
  }(), o != null ? t.Vd(o) : null);
}, Kme = function e(n, t) {
  if (n == null) return t;
  if (t == null) return n;
  if (n instanceof Jl) {
    if (t instanceof Jl) {
      var l = function() {
        var r = n.right, u = t.left;
        return e.g ? e.g(r, u) : e.call(null, r, u);
      }();
      return l instanceof Jl ? new Jl(l.key, l.val, new Jl(n.key, n.val, n.left, l.left), new Jl(t.key, t.val, l.right, t.right)) : new Jl(n.key, n.val, n.left, new Jl(t.key, t.val, l, t.right));
    }
    return new Jl(n.key, n.val, n.left, function() {
      var r = n.right;
      return e.g ? e.g(r, t) : e.call(null, r, t);
    }());
  }
  return t instanceof Jl ? new Jl(t.key, t.val, function() {
    var r = t.left;
    return e.g ? e.g(n, r) : e.call(null, n, r);
  }(), t.right) : (l = function() {
    var r = n.right, u = t.left;
    return e.g ? e.g(r, u) : e.call(null, r, u);
  }(), l instanceof Jl ? new Jl(l.key, l.val, new Qr(n.key, n.val, n.left, l.left), new Qr(t.key, t.val, l.right, t.right)) : LK(n.key, n.val, n.left, new Qr(t.key, t.val, l, t.right)));
}, Gme = function e(n, t, l, r) {
  if (t != null) {
    var u = function() {
      var o = t.key;
      return n.g ? n.g(l, o) : n.call(null, l, o);
    }();
    return u === 0 ? (r[0] = t, Kme(t.left, t.right)) : 0 > u ? (u = function() {
      var o = t.left;
      return e.B ? e.B(n, o, l, r) : e.call(null, n, o, l, r);
    }(), u != null || r[0] != null ? t.left instanceof Qr ? LK(t.key, t.val, u, t.right) : new Jl(t.key, t.val, u, t.right) : null) : (u = function() {
      var o = t.right;
      return e.B ? e.B(n, o, l, r) : e.call(null, n, o, l, r);
    }(), u != null || r[0] != null ? t.right instanceof Qr ? Mfe(t.key, t.val, t.left, u) : new Jl(t.key, t.val, t.left, u) : null);
  }
  return null;
}, Zme = function e(n, t, l, r) {
  var u = t.key, o = n.g ? n.g(l, u) : n.call(null, l, u);
  return o === 0 ? t.replace(u, r, t.left, t.right) : 0 > o ? t.replace(u, t.val, function() {
    var a = t.left;
    return e.B ? e.B(n, a, l, r) : e.call(null, n, a, l, r);
  }(), t.right) : t.replace(u, t.val, t.left, function() {
    var a = t.right;
    return e.B ? e.B(n, a, l, r) : e.call(null, n, a, l, r);
  }());
};
A = mh.prototype;
A.jc = Rn;
A.Ub = function(e, n) {
  return M4(this, n);
};
A.forEach = function(e) {
  for (var n = z(this), t = null, l = 0, r = 0; ; ) if (r < l) {
    var u = t.Y(null, r), o = O.j(u, 0, null);
    u = O.j(u, 1, null), e.g ? e.g(u, o) : e.call(null, u, o), r += 1;
  } else if (n = z(n)) oi(n) ? (t = Jr(n), n = Wr(n), o = t, l = Cn(t), t = o) : (t = I(n), o = O.j(t, 0, null), u = O.j(t, 1, null), e.g ? e.g(u, o) : e.call(null, u, o), n = W(n), t = null, l = 0), r = 0;
  else return null;
};
A.get = function(e, n) {
  return this.P(null, e, n);
};
A.entries = function() {
  return new R4(z(z(this)));
};
A.toString = function() {
  return Ui(this);
};
A.keys = function() {
  return ti(xi.h ? xi.h(this) : xi.call(null, this));
};
A.values = function() {
  return ti(Ju.h ? Ju.h(this) : Ju.call(null, this));
};
A.has = function(e) {
  return Ol(this, e);
};
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  return e = M4(this, n), e != null ? e.val : t;
};
A.nb = function(e, n, t) {
  return this.tree != null ? S3(xB(this.tree, n, t)) : t;
};
A.U = function() {
  return this.meta;
};
A.$ = function() {
  return this.G;
};
A.Wb = function() {
  return 0 < this.G ? $L(this.tree, !1, this.G) : null;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = Na(this));
};
A.N = function(e, n) {
  return RK(this, n);
};
A.ha = function() {
  return new mh(this.kb, null, 0, this.meta, 0);
};
A.sb = function(e, n) {
  return e = [null], n = Gme(this.kb, this.tree, n, e), n == null ? O.g(e, 0) == null ? this : new mh(this.kb, null, 0, this.meta, null) : new mh(this.kb, n.Sb(), this.G - 1, this.meta, null);
};
A.Aa = function(e, n, t) {
  e = [null];
  var l = zme(this.kb, this.tree, n, t, e);
  return l == null ? (e = O.g(e, 0), on.g(t, e.val) ? this : new mh(this.kb, Zme(this.kb, this.tree, n, t), this.G, this.meta, null)) : new mh(this.kb, l.Sb(), this.G + 1, this.meta, null);
};
A.gb = function(e, n) {
  return M4(this, n) != null;
};
A.W = function() {
  return 0 < this.G ? $L(this.tree, !0, this.G) : null;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new mh(this.kb, this.tree, this.G, n, this.H);
};
A.aa = function(e, n) {
  if (or(n)) return this.Aa(null, Ul(n, 0), Ul(n, 1));
  for (e = this, n = z(n); ; ) {
    if (n == null) return e;
    var t = I(n);
    if (or(t)) e = Cw(e, Ul(t, 0), Ul(t, 1)), n = W(n);
    else throw Error("conj on a map takes map entries or seqables of map entries");
  }
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.wa(null, e);
};
A.g = function(e, n) {
  return this.P(null, e, n);
};
A.Dd = function(e, n) {
  return 0 < this.G ? $L(this.tree, n, this.G) : null;
};
A.Ed = function(e, n, t) {
  if (0 < this.G) {
    e = null;
    for (var l = this.tree; ; ) if (l != null) {
      var r = l.key;
      if (r = this.kb.g ? this.kb.g(n, r) : this.kb.call(null, n, r), r === 0) return new Mf(null, yt.g(e, l), t, -1, null);
      j(t) ? 0 > r ? (e = yt.g(e, l), l = l.left) : l = l.right : 0 < r ? (e = yt.g(e, l), l = l.right) : l = l.left;
    } else return e == null ? null : new Mf(null, e, t, -1, null);
  } else return null;
};
A.Cd = function(e, n) {
  return Zu.h ? Zu.h(n) : Zu.call(null, n);
};
A.Bd = function() {
  return this.kb;
};
var yZ = new mh(Gh, null, 0, null, Z3);
mh.prototype[Li] = function() {
  return ti(this);
};
var tr = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
tr.l = function(e) {
  e = z(e);
  for (var n = ou(b2); ; ) if (e) {
    var t = W(e);
    if (t == null) throw Error(["No value supplied for key: ", ye.h(I(e))].join(""));
    var l = W(t);
    n = ao.j(n, I(e), I(t)), e = l;
  } else return gu(n);
};
tr.m = 0;
tr.v = function(e) {
  return this.l(z(e));
};
var ah = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
ah.l = function(e) {
  if (e = e instanceof hn && e.i === 0 ? e.A : Fs.h(e), !qc(e.length)) throw Error(["No value supplied for key: ", ye.h(ho(e))].join(""));
  return Qu(e);
};
ah.m = 0;
ah.v = function(e) {
  return this.l(z(e));
};
var ub = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
ub.l = function(e) {
  e = z(e);
  for (var n = yZ; ; ) if (e) {
    var t = va(e);
    n = Dn.j(n, I(e), Vr(e)), e = t;
  } else return n;
};
ub.m = 0;
ub.v = function(e) {
  return this.l(z(e));
};
var e5 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
e5.l = function(e, n) {
  n = z(n);
  for (var t = new mh(EL(e), null, 0, null, 0); ; ) if (n) e = va(n), t = Dn.j(t, I(n), Vr(n)), n = e;
  else return t;
};
e5.m = 1;
e5.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
A = fg.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.zb;
};
A.Ca = function() {
  var e = (this.fa != null ? this.fa.C & 128 || Rn === this.fa.Nc || !this.fa.C && pl(Im, this.fa) : pl(Im, this.fa)) ? this.fa.Ca(null) : W(this.fa);
  return e == null ? null : new fg(e, null);
};
A.O = function() {
  return qu(this);
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  return nc(n, t, this);
};
A.Ba = function() {
  return this.fa.Ba(null).key;
};
A.Fa = function() {
  var e = (this.fa != null ? this.fa.C & 128 || Rn === this.fa.Nc || !this.fa.C && pl(Im, this.fa) : pl(Im, this.fa)) ? this.fa.Ca(null) : W(this.fa);
  return e != null ? new fg(e, null) : fl;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.zb ? this : new fg(this.fa, n);
};
A.aa = function(e, n) {
  return kt(n, this);
};
fg.prototype[Li] = function() {
  return ti(this);
};
A = dg.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.U = function() {
  return this.zb;
};
A.Ca = function() {
  var e = (this.fa != null ? this.fa.C & 128 || Rn === this.fa.Nc || !this.fa.C && pl(Im, this.fa) : pl(Im, this.fa)) ? this.fa.Ca(null) : W(this.fa);
  return e == null ? null : new dg(e, null);
};
A.O = function() {
  return qu(this);
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  return nc(n, t, this);
};
A.Ba = function() {
  return this.fa.Ba(null).val;
};
A.Fa = function() {
  var e = (this.fa != null ? this.fa.C & 128 || Rn === this.fa.Nc || !this.fa.C && pl(Im, this.fa) : pl(Im, this.fa)) ? this.fa.Ca(null) : W(this.fa);
  return e != null ? new dg(e, null) : fl;
};
A.W = function() {
  return this;
};
A.Z = function(e, n) {
  return n === this.zb ? this : new dg(this.fa, n);
};
A.aa = function(e, n) {
  return kt(n, this);
};
dg.prototype[Li] = function() {
  return ti(this);
};
var gr = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
gr.l = function(e) {
  return j(fu(No, e)) ? wt.g(function(n, t) {
    return yt.g(j(n) ? n : Tt, t);
  }, e) : null;
};
gr.m = 0;
gr.v = function(e) {
  return this.l(z(e));
};
var n5 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
n5.l = function(e, n) {
  if (j(fu(No, n))) {
    var t = function(l, r) {
      var u = Xa(r), o = Cc(r);
      if (Ol(l, u)) {
        r = Dn.j;
        var a = en.g(l, u);
        o = e.g ? e.g(a, o) : e.call(null, a, o), l = r.call(Dn, l, u, o);
      } else l = Dn.j(l, u, o);
      return l;
    };
    return wt.g(function(l, r) {
      return wt.j(t, j(l) ? l : Tt, z(r));
    }, n);
  }
  return null;
};
n5.m = 1;
n5.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
P4.prototype.ja = function() {
  return this.iter.ja();
};
P4.prototype.next = function() {
  if (this.iter.ja()) return this.iter.next().key;
  throw Error("No such element");
};
P4.prototype.remove = function() {
  return Error("Unsupported operation");
};
A = gi.prototype;
A.toString = function() {
  return Ui(this);
};
A.keys = function() {
  return ti(z(this));
};
A.entries = function() {
  return new NL(z(z(this)));
};
A.values = function() {
  return ti(z(this));
};
A.has = function(e) {
  return Ol(this, e);
};
A.forEach = function(e) {
  for (var n = z(this), t = null, l = 0, r = 0; ; ) if (r < l) {
    var u = t.Y(null, r), o = O.j(u, 0, null);
    u = O.j(u, 1, null), e.g ? e.g(u, o) : e.call(null, u, o), r += 1;
  } else if (n = z(n)) oi(n) ? (t = Jr(n), n = Wr(n), o = t, l = Cn(t), t = o) : (t = I(n), o = O.j(t, 0, null), u = O.j(t, 1, null), e.g ? e.g(u, o) : e.call(null, u, o), n = W(n), t = null, l = 0), r = 0;
  else return null;
};
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  return e = PO(this.bc, n), j(e) ? Xa(e) : t;
};
A.Xa = function() {
  return new P4(eo(this.bc));
};
A.U = function() {
  return this.meta;
};
A.$ = function() {
  return Kh(this.bc);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = Na(this));
};
A.N = function(e, n) {
  if (e = ug(n)) if (e = Cn(this) === Cn(n)) try {
    return Jf(function(t, l) {
      return (t = Ol(n, l)) ? t : xh(!1);
    }, !0, this.bc);
  } catch (t) {
    if (t instanceof Error) return !1;
    throw t;
  }
  else return e;
  else return e;
};
A.xc = function() {
  return new BK(ou(this.bc));
};
A.ha = function() {
  return su(ss, this.meta);
};
A.Ad = function(e, n) {
  return new gi(this.meta, $O(this.bc, n), null);
};
A.W = function() {
  return xi(this.bc);
};
A.Z = function(e, n) {
  return n === this.meta ? this : new gi(n, this.bc, this.H);
};
A.aa = function(e, n) {
  return new gi(this.meta, Dn.j(this.bc, n, null), null);
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.wa(null, e);
};
A.g = function(e, n) {
  return this.P(null, e, n);
};
var ss = new gi(null, Tt, Z3);
gi.prototype[Li] = function() {
  return ti(this);
};
A = BK.prototype;
A.Cc = function(e, n) {
  return this.fc = ao.j(this.fc, n, null), this;
};
A.Oc = function() {
  return new gi(null, gu(this.fc), null);
};
A.le = function(e, n) {
  return this.fc = E2.g(this.fc, n), this;
};
A.$ = function() {
  return Cn(this.fc);
};
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  return zo(this.fc, n, Da) === Da ? t : n;
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return zo(this.fc, e, Da) === Da ? null : e;
};
A.g = function(e, n) {
  return zo(this.fc, e, Da) === Da ? n : e;
};
A = nd.prototype;
A.toString = function() {
  return Ui(this);
};
A.keys = function() {
  return ti(z(this));
};
A.entries = function() {
  return new NL(z(z(this)));
};
A.values = function() {
  return ti(z(this));
};
A.has = function(e) {
  return Ol(this, e);
};
A.forEach = function(e) {
  for (var n = z(this), t = null, l = 0, r = 0; ; ) if (r < l) {
    var u = t.Y(null, r), o = O.j(u, 0, null);
    u = O.j(u, 1, null), e.g ? e.g(u, o) : e.call(null, u, o), r += 1;
  } else if (n = z(n)) oi(n) ? (t = Jr(n), n = Wr(n), o = t, l = Cn(t), t = o) : (t = I(n), o = O.j(t, 0, null), u = O.j(t, 1, null), e.g ? e.g(u, o) : e.call(null, u, o), n = W(n), t = null, l = 0), r = 0;
  else return null;
};
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  return e = M4(this.xb, n), e != null ? e.key : t;
};
A.U = function() {
  return this.meta;
};
A.$ = function() {
  return Cn(this.xb);
};
A.Wb = function() {
  return 0 < Cn(this.xb) ? bt.g(Zu, lx(this.xb)) : null;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = Na(this));
};
A.N = function(e, n) {
  if (e = ug(n)) if (e = Cn(this) === Cn(n)) try {
    return Jf(function(t, l) {
      return (t = Ol(n, l)) ? t : xh(!1);
    }, !0, this.xb);
  } catch (t) {
    if (t instanceof Error) return !1;
    throw t;
  }
  else return e;
  else return e;
};
A.ha = function() {
  return new nd(this.meta, NO(this.xb), 0);
};
A.Ad = function(e, n) {
  return new nd(this.meta, nr.g(this.xb, n), null);
};
A.W = function() {
  return xi(this.xb);
};
A.Z = function(e, n) {
  return n === this.meta ? this : new nd(n, this.xb, this.H);
};
A.aa = function(e, n) {
  return new nd(this.meta, Dn.j(this.xb, n, null), null);
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.h = function(e) {
  return this.wa(null, e);
};
A.g = function(e, n) {
  return this.P(null, e, n);
};
A.Dd = function(e, n) {
  return bt.g(Zu, rx(this.xb, n));
};
A.Ed = function(e, n, t) {
  return bt.g(Zu, Mw(this.xb, n, t));
};
A.Cd = function(e, n) {
  return n;
};
A.Bd = function() {
  return FO(this.xb);
};
var Xme = new nd(null, yZ, Z3);
nd.prototype[Li] = function() {
  return ti(this);
};
var id = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(new hn(t.slice(0), 0, null));
  }
};
id.o = function() {
  return ss;
};
id.l = function(e) {
  return Us(e);
};
id.v = function(e) {
  return this.l(z(e));
};
id.m = 0;
var t5 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
t5.l = function(e) {
  return wt.j(Qo, Xme, e);
};
t5.m = 0;
t5.v = function(e) {
  return this.l(z(e));
};
var sb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
sb.l = function(e, n) {
  return wt.j(Qo, new nd(null, e5(e), 0), n);
};
sb.m = 1;
sb.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
var l5 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
l5.h = function(e) {
  return bt.h(function(n) {
    var t = oh(e, n);
    return j(t) ? Cc(t) : n;
  });
};
l5.g = function(e, n) {
  if (or(n)) {
    var t = Cn(n);
    return wt.j(function(l, r) {
      var u = oh(e, O.g(l, r));
      return j(u) ? Dn.j(l, r, Vr(u)) : l;
    }, n, Vu.g(t, Yw(Lw, 0)));
  }
  return bt.g(function(l) {
    var r = oh(e, l);
    return j(r) ? Vr(r) : l;
  }, n);
};
l5.m = 2;
var ob = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
ob.o = function() {
  return function(e) {
    var n = Qi(ss);
    return function() {
      function t(o, a) {
        return Ol(sn(n), a) ? o : (n.Nb(null, yt.g(n.jb(null), a)), e.g ? e.g(o, a) : e.call(null, o, a));
      }
      function l(o) {
        return e.h ? e.h(o) : e.call(null, o);
      }
      function r() {
        return e.o ? e.o() : e.call(null);
      }
      var u = null;
      return u = function(o, a) {
        switch (arguments.length) {
          case 0:
            return r.call(this);
          case 1:
            return l.call(this, o);
          case 2:
            return t.call(this, o, a);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, u.o = r, u.h = l, u.g = t, u;
    }();
  };
};
ob.h = function(e) {
  return function n(t, l) {
    return new rr(null, function() {
      var r;
      e: {
        var u = t;
        for (r = l; ; ) {
          var o = u;
          if (u = O.j(o, 0, null), o = z(o)) if (Ol(r, u)) u = tn(o);
          else {
            r = kt(u, n(tn(o), yt.g(r, u)));
            break e;
          }
          else {
            r = null;
            break e;
          }
        }
      }
      return r;
    }, null, null);
  }(e, ss);
};
ob.m = 1;
var lp = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
lp.g = function(e, n) {
  return n;
};
lp.j = function(e, n, t) {
  return (e.h ? e.h(n) : e.call(null, n)) > (e.h ? e.h(t) : e.call(null, t)) ? n : t;
};
lp.l = function(e, n, t, l) {
  return wt.j(function(r, u) {
    return lp.j(e, r, u);
  }, lp.j(e, n, t), l);
};
lp.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
lp.m = 3;
var km = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
km.g = function(e, n) {
  return n;
};
km.j = function(e, n, t) {
  return (e.h ? e.h(n) : e.call(null, n)) < (e.h ? e.h(t) : e.call(null, t)) ? n : t;
};
km.l = function(e, n, t, l) {
  return wt.j(function(r, u) {
    return km.j(e, r, u);
  }, km.j(e, n, t), l);
};
km.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
km.m = 3;
g2.prototype.add = function(e) {
  return this.A.push(e);
};
g2.prototype.size = function() {
  return this.A.length;
};
g2.prototype.clear = function() {
  return this.A = [];
};
g2.prototype.Hc = function() {
  return this.A.length === 0;
};
var t1 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
t1.h = function(e) {
  return function(n) {
    var t = new g2();
    return function() {
      function l(a, h) {
        return t.add(h), e === t.size() ? (h = Et(t.A), t.clear(), n.g ? n.g(a, h) : n.call(null, a, h)) : a;
      }
      function r(a) {
        if (!j(t.Hc())) {
          var h = Et(t.A);
          t.clear(), a = S3(n.g ? n.g(a, h) : n.call(null, a, h));
        }
        return n.h ? n.h(a) : n.call(null, a);
      }
      function u() {
        return n.o ? n.o() : n.call(null);
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 0:
            return u.call(this);
          case 1:
            return r.call(this, a);
          case 2:
            return l.call(this, a, h);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.o = u, o.h = r, o.g = l, o;
    }();
  };
};
t1.g = function(e, n) {
  return t1.j(e, e, n);
};
t1.j = function(e, n, t) {
  return new rr(null, function() {
    var l = z(t);
    return l ? kt(Vu.g(e, l), t1.j(e, n, uu.g(n, l))) : null;
  }, null, null);
};
t1.m = 3;
var vo = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
vo.h = function(e) {
  return function(n) {
    return function() {
      function t(o, a) {
        return j(e.h ? e.h(a) : e.call(null, a)) ? n.g ? n.g(o, a) : n.call(null, o, a) : xh(o);
      }
      function l(o) {
        return n.h ? n.h(o) : n.call(null, o);
      }
      function r() {
        return n.o ? n.o() : n.call(null);
      }
      var u = null;
      return u = function(o, a) {
        switch (arguments.length) {
          case 0:
            return r.call(this);
          case 1:
            return l.call(this, o);
          case 2:
            return t.call(this, o, a);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, u.o = r, u.h = l, u.g = t, u;
    }();
  };
};
vo.g = function(e, n) {
  return new rr(null, function() {
    var t = z(n);
    if (t) {
      var l = I(t);
      l = e.h ? e.h(l) : e.call(null, l), t = j(l) ? kt(I(t), vo.g(e, tn(t))) : null;
    } else t = null;
    return t;
  }, null, null);
};
vo.m = 2;
var ab = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 5:
      return e.I(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
ab.j = function(e, n, t) {
  var l = _y(e, n, t), r = Rp([Hm, zm]);
  return n = r.h ? r.h(n) : r.call(null, n), j(n) ? (e = Mw(e, t, !0), j(e) ? (t = O.j(e, 0, null), j(l(t)) ? e : W(e)) : null) : vo.g(l, rx(e, !0));
};
ab.I = function(e, n, t, l, r) {
  var u = Mw(e, t, !0);
  if (j(u)) {
    var o = O.j(u, 0, null);
    return vo.g(_y(e, l, r), j(_y(e, n, t)(o)) ? u : W(u));
  }
  return null;
};
ab.m = 5;
var cb = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 5:
      return e.I(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
cb.j = function(e, n, t) {
  var l = _y(e, n, t), r = Rp([qm, Wm]);
  return n = r.h ? r.h(n) : r.call(null, n), j(n) ? (e = Mw(e, t, !1), j(e) ? (t = O.j(e, 0, null), j(l(t)) ? e : W(e)) : null) : vo.g(l, rx(e, !1));
};
cb.I = function(e, n, t, l, r) {
  var u = Mw(e, r, !1);
  if (j(u)) {
    var o = O.j(u, 0, null);
    return vo.g(_y(e, n, t), j(_y(e, l, r)(o)) ? u : W(u));
  }
  return null;
};
cb.m = 5;
A = KO.prototype;
A.$ = function() {
  return this.count;
};
A.Ba = function() {
  return this.start;
};
A.Y = function(e, n) {
  return this.start + n * this.step;
};
A.Wa = function(e, n, t) {
  return 0 <= n && n < this.count ? this.start + n * this.step : t;
};
A.vd = function() {
  if (1 >= this.count) throw Error("-drop-first of empty chunk");
  return new KO(this.start + this.step, this.step, this.count - 1);
};
$4.prototype.ja = function() {
  return 0 < this.step ? this.i < this.end : this.i > this.end;
};
$4.prototype.next = function() {
  var e = this.i;
  return this.i += this.step, e;
};
A = Pf.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.Rc = function() {
  if (this.chunk == null) {
    var e = this.$(null);
    32 < e ? (this.Tb = new Pf(null, this.start + 32 * this.step, this.end, this.step, null, null, null), this.chunk = new KO(this.start, this.step, 32)) : this.chunk = new KO(this.start, this.step, e);
  }
};
A.Y = function(e, n) {
  if (0 <= n && n < this.$(null)) return this.start + n * this.step;
  if (0 <= n && this.start > this.end && this.step === 0) return this.start;
  throw Error("Index out of bounds");
};
A.Wa = function(e, n, t) {
  return 0 <= n && n < this.$(null) ? this.start + n * this.step : 0 <= n && this.start > this.end && this.step === 0 ? this.start : t;
};
A.Xa = function() {
  return new $4(this.start, this.end, this.step);
};
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return 0 < this.step ? this.start + this.step < this.end ? new Pf(null, this.start + this.step, this.end, this.step, null, null, null) : null : this.start + this.step > this.end ? new Pf(null, this.start + this.step, this.end, this.step, null, null, null) : null;
};
A.$ = function() {
  return Math.ceil((this.end - this.start) / this.step);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return E3(this, n);
};
A.Ea = function(e, n, t) {
  for (e = this.start; ; ) if (0 < this.step ? e < this.end : e > this.end) {
    if (t = n.g ? n.g(t, e) : n.call(null, t, e), ni(t)) return sn(t);
    e += this.step;
  } else return t;
};
A.Ba = function() {
  return this.start;
};
A.Fa = function() {
  var e = this.Ca(null);
  return e ?? fl;
};
A.W = function() {
  return this;
};
A.Mc = function() {
  return this.Rc(), this.chunk;
};
A.ic = function() {
  return this.Rc(), this.Tb == null ? fl : this.Tb;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new Pf(n, this.start, this.end, this.step, this.chunk, this.Tb, this.H);
};
A.aa = function(e, n) {
  return kt(n, this);
};
A.Lc = function() {
  return z(this.ic(null));
};
Pf.prototype[Li] = function() {
  return ti(this);
};
A = $f.prototype;
A.toString = function() {
  return Ui(this);
};
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.Rc = function() {
  if (this.chunk == null) {
    var e = [null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null];
    e:
      for (var n = 0, t = this.start; ; ) if (32 > n) {
        if (e[n] = t, n += 1, t += this.step, !(0 < this.step ? t < this.end : t > this.end)) {
          n = this.chunk = new Vw(e, 0, n);
          break e;
        }
      } else {
        n = t;
        break e;
      }
    this.chunk == null && (this.chunk = new Vw(e, 0, 32), (0 < this.step ? n < this.end : n > this.end) && (this.Tb = new $f(
      null,
      n,
      this.end,
      this.step,
      null,
      null,
      null
    )));
  }
};
A.Xa = function() {
  return new $4(this.start, this.end, this.step);
};
A.U = function() {
  return this.meta;
};
A.Ca = function() {
  return 0 < this.step ? this.start + this.step < this.end ? new $f(null, this.start + this.step, this.end, this.step, null, null, null) : null : this.start + this.step > this.end ? new $f(null, this.start + this.step, this.end, this.step, null, null, null) : null;
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = qu(this));
};
A.N = function(e, n) {
  return iu(this, n);
};
A.ha = function() {
  return fl;
};
A.Da = function(e, n) {
  return ja(n, this);
};
A.Ea = function(e, n, t) {
  for (e = this.start; ; ) if (0 < this.step ? e < this.end : e > this.end) {
    if (t = n.g ? n.g(t, e) : n.call(null, t, e), ni(t)) return sn(t);
    e += this.step;
  } else return t;
};
A.Ba = function() {
  return this.start;
};
A.Fa = function() {
  var e = this.Ca(null);
  return e ?? fl;
};
A.W = function() {
  return this;
};
A.Mc = function() {
  return this.Rc(), this.chunk;
};
A.ic = function() {
  return this.Rc(), this.Tb == null ? fl : this.Tb;
};
A.Z = function(e, n) {
  return n === this.meta ? this : new $f(n, this.start, this.end, this.step, this.chunk, this.Tb, this.H);
};
A.aa = function(e, n) {
  return kt(n, this);
};
A.Lc = function() {
  return z(this.ic(null));
};
$f.prototype[Li] = function() {
  return ti(this);
};
var ic = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
ic.o = function() {
  return ic.j(0, Number.MAX_VALUE, 1);
};
ic.h = function(e) {
  return ic.j(0, e, 1);
};
ic.g = function(e, n) {
  return ic.j(e, n, 1);
};
ic.j = function(e, n, t) {
  return 0 < t ? n <= e ? fl : za(e) && za(n) && za(t) ? new Pf(null, e, n, t, null, null, null) : new $f(null, e, n, t, null, null, null) : 0 > t ? n >= e ? fl : za(e) && za(n) && za(t) ? new Pf(null, e, n, t, null, null, null) : new $f(null, e, n, t, null, null, null) : n === e ? fl : sa.h(e);
};
ic.m = 3;
var Po = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Po.h = function(e) {
  return function(n) {
    var t = Qi(-1);
    return function() {
      function l(a, h) {
        var s = t.Nb(null, t.jb(null) + 1);
        return sI(s, e) === 0 ? n.g ? n.g(a, h) : n.call(null, a, h) : a;
      }
      function r(a) {
        return n.h ? n.h(a) : n.call(null, a);
      }
      function u() {
        return n.o ? n.o() : n.call(null);
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 0:
            return u.call(this);
          case 1:
            return r.call(this, a);
          case 2:
            return l.call(this, a, h);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.o = u, o.h = r, o.g = l, o;
    }();
  };
};
Po.g = function(e, n) {
  return new rr(null, function() {
    var t = z(n);
    return t ? kt(I(t), Po.g(e, uu.g(e, t))) : null;
  }, null, null);
};
Po.m = 2;
var xx = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
xx.h = function(e) {
  return function(n) {
    var t = new g2(), l = Qi(mR);
    return function() {
      function r(h, s) {
        var d = sn(l), p = e.h ? e.h(s) : e.call(null, s);
        return Yu(l, p), Ln(d, mR) || on.g(p, d) ? (t.add(s), h) : (d = Et(t.A), t.clear(), h = n.g ? n.g(h, d) : n.call(null, h, d), ni(h) || t.add(s), h);
      }
      function u(h) {
        if (!j(t.Hc())) {
          var s = Et(t.A);
          t.clear(), h = S3(n.g ? n.g(h, s) : n.call(null, h, s));
        }
        return n.h ? n.h(h) : n.call(null, h);
      }
      function o() {
        return n.o ? n.o() : n.call(null);
      }
      var a = null;
      return a = function(h, s) {
        switch (arguments.length) {
          case 0:
            return o.call(this);
          case 1:
            return u.call(this, h);
          case 2:
            return r.call(this, h, s);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, a.o = o, a.h = u, a.g = r, a;
    }();
  };
};
xx.g = function(e, n) {
  return new rr(null, function() {
    var t = z(n);
    if (t) {
      var l = I(t), r = e.h ? e.h(l) : e.call(null, l), u = kt(l, vo.g(function(o) {
        return on.g(r, e.h ? e.h(o) : e.call(null, o));
      }, W(t)));
      return kt(u, xx.g(e, new rr(null, function() {
        return uu.g(Cn(u), t);
      }, null, null)));
    }
    return null;
  }, null, null);
};
xx.m = 2;
var ww = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
ww.g = function(e, n) {
  return new rr(null, function() {
    var t = z(n);
    return t ? ww.j(e, I(t), tn(t)) : new g(null, e.o ? e.o() : e.call(null), null, 1, null);
  }, null, null);
};
ww.j = function(e, n, t) {
  return ni(n) ? new g(null, sn(n), null, 1, null) : kt(n, new rr(null, function() {
    var l = z(t);
    if (l) {
      var r = ww.j, u = I(l);
      u = e.g ? e.g(n, u) : e.call(null, n, u), l = r.call(ww, e, u, tn(l));
    } else l = null;
    return l;
  }, null, null));
};
ww.m = 3;
var Yf = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
Yf.h = function(e) {
  return function() {
    function n(a, h, s) {
      return new v(null, 1, 5, y, [e.j ? e.j(a, h, s) : e.call(null, a, h, s)], null);
    }
    function t(a, h) {
      return new v(null, 1, 5, y, [e.g ? e.g(a, h) : e.call(null, a, h)], null);
    }
    function l(a) {
      return new v(null, 1, 5, y, [e.h ? e.h(a) : e.call(null, a)], null);
    }
    function r() {
      return new v(null, 1, 5, y, [e.o ? e.o() : e.call(null)], null);
    }
    var u = null, o = function() {
      function a(s, d, p, _) {
        var R = null;
        if (3 < arguments.length) {
          R = 0;
          for (var F = Array(arguments.length - 3); R < F.length; ) F[R] = arguments[R + 3], ++R;
          R = new hn(
            F,
            0,
            null
          );
        }
        return h.call(this, s, d, p, R);
      }
      function h(s, d, p, _) {
        return new v(null, 1, 5, y, [In.I(e, s, d, p, _)], null);
      }
      return a.m = 3, a.v = function(s) {
        var d = I(s);
        s = W(s);
        var p = I(s);
        s = W(s);
        var _ = I(s);
        return s = tn(s), h(d, p, _, s);
      }, a.l = h, a;
    }();
    return u = function(a, h, s, d) {
      switch (arguments.length) {
        case 0:
          return r.call(this);
        case 1:
          return l.call(this, a);
        case 2:
          return t.call(this, a, h);
        case 3:
          return n.call(this, a, h, s);
        default:
          var p = null;
          if (3 < arguments.length) {
            p = 0;
            for (var _ = Array(arguments.length - 3); p < _.length; ) _[p] = arguments[p + 3], ++p;
            p = new hn(_, 0, null);
          }
          return o.l(a, h, s, p);
      }
    }, u.m = 3, u.v = o.v, u.o = r, u.h = l, u.g = t, u.j = n, u.l = o.l, u;
  }();
};
Yf.g = function(e, n) {
  return function() {
    function t(h, s, d) {
      return new v(null, 2, 5, y, [e.j ? e.j(h, s, d) : e.call(null, h, s, d), n.j ? n.j(h, s, d) : n.call(null, h, s, d)], null);
    }
    function l(h, s) {
      return new v(null, 2, 5, y, [e.g ? e.g(h, s) : e.call(null, h, s), n.g ? n.g(h, s) : n.call(null, h, s)], null);
    }
    function r(h) {
      return new v(null, 2, 5, y, [e.h ? e.h(h) : e.call(null, h), n.h ? n.h(h) : n.call(null, h)], null);
    }
    function u() {
      return new v(null, 2, 5, y, [e.o ? e.o() : e.call(null), n.o ? n.o() : n.call(null)], null);
    }
    var o = null, a = function() {
      function h(d, p, _, R) {
        var F = null;
        if (3 < arguments.length) {
          F = 0;
          for (var L = Array(arguments.length - 3); F < L.length; ) L[F] = arguments[F + 3], ++F;
          F = new hn(L, 0, null);
        }
        return s.call(this, d, p, _, F);
      }
      function s(d, p, _, R) {
        return new v(null, 2, 5, y, [In.I(e, d, p, _, R), In.I(n, d, p, _, R)], null);
      }
      return h.m = 3, h.v = function(d) {
        var p = I(d);
        d = W(d);
        var _ = I(d);
        d = W(d);
        var R = I(d);
        return d = tn(d), s(p, _, R, d);
      }, h.l = s, h;
    }();
    return o = function(h, s, d, p) {
      switch (arguments.length) {
        case 0:
          return u.call(this);
        case 1:
          return r.call(this, h);
        case 2:
          return l.call(this, h, s);
        case 3:
          return t.call(
            this,
            h,
            s,
            d
          );
        default:
          var _ = null;
          if (3 < arguments.length) {
            _ = 0;
            for (var R = Array(arguments.length - 3); _ < R.length; ) R[_] = arguments[_ + 3], ++_;
            _ = new hn(R, 0, null);
          }
          return a.l(h, s, d, _);
      }
    }, o.m = 3, o.v = a.v, o.o = u, o.h = r, o.g = l, o.j = t, o.l = a.l, o;
  }();
};
Yf.j = function(e, n, t) {
  return function() {
    function l(s, d, p) {
      return new v(null, 3, 5, y, [e.j ? e.j(s, d, p) : e.call(null, s, d, p), n.j ? n.j(s, d, p) : n.call(null, s, d, p), t.j ? t.j(s, d, p) : t.call(null, s, d, p)], null);
    }
    function r(s, d) {
      return new v(null, 3, 5, y, [e.g ? e.g(s, d) : e.call(null, s, d), n.g ? n.g(s, d) : n.call(null, s, d), t.g ? t.g(s, d) : t.call(null, s, d)], null);
    }
    function u(s) {
      return new v(null, 3, 5, y, [e.h ? e.h(s) : e.call(null, s), n.h ? n.h(s) : n.call(null, s), t.h ? t.h(s) : t.call(null, s)], null);
    }
    function o() {
      return new v(null, 3, 5, y, [e.o ? e.o() : e.call(null), n.o ? n.o() : n.call(null), t.o ? t.o() : t.call(null)], null);
    }
    var a = null, h = function() {
      function s(p, _, R, F) {
        var L = null;
        if (3 < arguments.length) {
          L = 0;
          for (var G = Array(arguments.length - 3); L < G.length; ) G[L] = arguments[L + 3], ++L;
          L = new hn(G, 0, null);
        }
        return d.call(this, p, _, R, L);
      }
      function d(p, _, R, F) {
        return new v(null, 3, 5, y, [In.I(e, p, _, R, F), In.I(n, p, _, R, F), In.I(t, p, _, R, F)], null);
      }
      return s.m = 3, s.v = function(p) {
        var _ = I(p);
        p = W(p);
        var R = I(p);
        p = W(p);
        var F = I(p);
        return p = tn(p), d(_, R, F, p);
      }, s.l = d, s;
    }();
    return a = function(s, d, p, _) {
      switch (arguments.length) {
        case 0:
          return o.call(this);
        case 1:
          return u.call(this, s);
        case 2:
          return r.call(this, s, d);
        case 3:
          return l.call(this, s, d, p);
        default:
          var R = null;
          if (3 < arguments.length) {
            R = 0;
            for (var F = Array(arguments.length - 3); R < F.length; ) F[R] = arguments[R + 3], ++R;
            R = new hn(F, 0, null);
          }
          return h.l(s, d, p, R);
      }
    }, a.m = 3, a.v = h.v, a.o = o, a.h = u, a.g = r, a.j = l, a.l = h.l, a;
  }();
};
Yf.l = function(e, n, t, l) {
  var r = us.B(e, n, t, l);
  return function() {
    function u(p, _, R) {
      return wt.j(function(F, L) {
        return yt.g(F, L.j ? L.j(p, _, R) : L.call(null, p, _, R));
      }, Dt, r);
    }
    function o(p, _) {
      return wt.j(function(R, F) {
        return yt.g(R, F.g ? F.g(p, _) : F.call(null, p, _));
      }, Dt, r);
    }
    function a(p) {
      return wt.j(function(_, R) {
        return yt.g(_, R.h ? R.h(p) : R.call(null, p));
      }, Dt, r);
    }
    function h() {
      return wt.j(function(p, _) {
        return yt.g(p, _.o ? _.o() : _.call(null));
      }, Dt, r);
    }
    var s = null, d = function() {
      function p(R, F, L, G) {
        var J = null;
        if (3 < arguments.length) {
          J = 0;
          for (var we = Array(arguments.length - 3); J < we.length; ) we[J] = arguments[J + 3], ++J;
          J = new hn(we, 0, null);
        }
        return _.call(this, R, F, L, J);
      }
      function _(R, F, L, G) {
        return wt.j(function(J, we) {
          return yt.g(J, In.I(we, R, F, L, G));
        }, Dt, r);
      }
      return p.m = 3, p.v = function(R) {
        var F = I(R);
        R = W(R);
        var L = I(R);
        R = W(R);
        var G = I(R);
        return R = tn(R), _(F, L, G, R);
      }, p.l = _, p;
    }();
    return s = function(p, _, R, F) {
      switch (arguments.length) {
        case 0:
          return h.call(this);
        case 1:
          return a.call(this, p);
        case 2:
          return o.call(this, p, _);
        case 3:
          return u.call(this, p, _, R);
        default:
          var L = null;
          if (3 < arguments.length) {
            L = 0;
            for (var G = Array(arguments.length - 3); L < G.length; ) G[L] = arguments[L + 3], ++L;
            L = new hn(G, 0, null);
          }
          return d.l(p, _, R, L);
      }
    }, s.m = 3, s.v = d.v, s.o = h, s.h = a, s.g = o, s.j = u, s.l = d.l, s;
  }();
};
Yf.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
Yf.m = 3;
var T2 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
T2.h = function(e) {
  for (; ; ) if (e = z(e)) e = W(e);
  else return null;
};
T2.g = function(e, n) {
  for (; ; ) if (z(n) && 0 < e) --e, n = W(n);
  else return null;
};
T2.m = 2;
var k1 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
k1.h = function(e) {
  return T2.h(e), e;
};
k1.g = function(e, n) {
  return T2.g(e, n), n;
};
k1.m = 2;
var Qme = function e(n, t) {
  var l = n.exec(t);
  if (l == null) return null;
  var r = l[0], u = l.length === 1 ? r : Et(l);
  return kt(u, new rr(null, function() {
    var o = r.length;
    return o = l.index + (1 > o ? 1 : o), o <= t.length ? (o = Si.g(t, o), e.g ? e.g(n, o) : e.call(null, n, o)) : null;
  }, null, null));
}, Jme = { '"': '\\"', "\\": "\\\\", "\b": "\\b", "\f": "\\f", "\n": "\\n", "\r": "\\r", "	": "\\t" }, wg = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
wg.l = function(e) {
  return BL(e, Rf());
};
wg.m = 0;
wg.v = function(e) {
  return this.l(z(e));
};
var hb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
hb.l = function(e) {
  var n = Rf();
  return Ca(e) ? e = `
` : (e = YK(e, n), e.append(`
`), e = ye.h(e)), e;
};
hb.m = 0;
hb.v = function(e) {
  return this.l(z(e));
};
var fb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
fb.l = function(e) {
  return B4(e, Rf());
};
fb.m = 0;
fb.v = function(e) {
  return this.l(z(e));
};
var ege = function() {
  function e(t) {
    var l = null;
    if (0 < arguments.length) {
      l = 0;
      for (var r = Array(arguments.length - 0); l < r.length; ) r[l] = arguments[l + 0], ++l;
      l = new hn(r, 0, null);
    }
    return n.call(this, l);
  }
  function n(t) {
    return B4(t, Dn.j(Rf(), c5, !1));
  }
  return e.m = 0, e.v = function(t) {
    return t = z(t), n(t);
  }, e.l = n, e;
}(), db = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
db.l = function(e) {
  return BL(e, Dn.j(Rf(), c5, !1));
};
db.m = 0;
db.v = function(e) {
  return this.l(z(e));
};
var pb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
pb.l = function(e) {
  return B4(e, Dn.j(Rf(), c5, !1)), j(ku) ? FL(Rf()) : null;
};
pb.m = 0;
pb.v = function(e) {
  return this.l(z(e));
};
var mb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
mb.l = function(e) {
  return B4(e, Rf()), j(ku) ? FL(Rf()) : null;
};
mb.m = 0;
mb.v = function(e) {
  return this.l(z(e));
};
N3.prototype.da = Rn;
N3.prototype.R = function(e, n, t) {
  return Br(n, "#object[cljs.core.Volatile "), Wl(new $(null, 1, [xb, this.state], null), n, t), Br(n, "]");
};
Jn.prototype.da = Rn;
Jn.prototype.R = function(e, n, t) {
  return Br(n, "#'"), Wl(this.Rb, n, t);
};
hn.prototype.da = Rn;
hn.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
rr.prototype.da = Rn;
rr.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
yl.prototype.da = Rn;
yl.prototype.R = function(e, n, t) {
  return vr(n, Wl, "[", " ", "]", t, this);
};
Mf.prototype.da = Rn;
Mf.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
Jd.prototype.da = Rn;
Jd.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
Qr.prototype.da = Rn;
Qr.prototype.R = function(e, n, t) {
  return vr(n, Wl, "[", " ", "]", t, this);
};
Ip.prototype.da = Rn;
Ip.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
u2.prototype.da = Rn;
u2.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
nd.prototype.da = Rn;
nd.prototype.R = function(e, n, t) {
  return vr(n, Wl, "#{", " ", "}", t, this);
};
y1.prototype.da = Rn;
y1.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
hp.prototype.da = Rn;
hp.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
f2.prototype.da = Rn;
f2.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
Qf.prototype.da = Rn;
Qf.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
Pf.prototype.da = Rn;
Pf.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
Qh.prototype.da = Rn;
Qh.prototype.R = function(e, n, t) {
  return Iv(this, Wl, n, t);
};
Uw.prototype.da = Rn;
Uw.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
Nm.prototype.da = Rn;
Nm.prototype.R = function(e, n, t) {
  return vr(n, Wl, "[", " ", "]", t, this);
};
h2.prototype.da = Rn;
h2.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
mh.prototype.da = Rn;
mh.prototype.R = function(e, n, t) {
  return Iv(this, Wl, n, t);
};
gi.prototype.da = Rn;
gi.prototype.R = function(e, n, t) {
  return vr(n, Wl, "#{", " ", "}", t, this);
};
sg.prototype.da = Rn;
sg.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
Wc.prototype.da = Rn;
Wc.prototype.R = function(e, n, t) {
  return Br(n, "#object[cljs.core.Atom "), Wl(new $(null, 1, [xb, this.state], null), n, t), Br(n, "]");
};
dg.prototype.da = Rn;
dg.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
Jl.prototype.da = Rn;
Jl.prototype.R = function(e, n, t) {
  return vr(n, Wl, "[", " ", "]", t, this);
};
ag.prototype.da = Rn;
ag.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
v.prototype.da = Rn;
v.prototype.R = function(e, n, t) {
  return vr(n, Wl, "[", " ", "]", t, this);
};
Cf.prototype.da = Rn;
Cf.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
a2.prototype.da = Rn;
a2.prototype.R = function(e, n) {
  return Br(n, "()");
};
Xh.prototype.da = Rn;
Xh.prototype.R = function(e, n, t) {
  return vr(n, Wl, "#queue [", " ", "]", t, z(this));
};
$.prototype.da = Rn;
$.prototype.R = function(e, n, t) {
  return Iv(this, Wl, n, t);
};
$f.prototype.da = Rn;
$f.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
og.prototype.da = Rn;
og.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
fg.prototype.da = Rn;
fg.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
g.prototype.da = Rn;
g.prototype.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
T.prototype.Za = Rn;
T.prototype.Ua = function(e, n) {
  if (n instanceof T) return jfe(this, n);
  throw Error(["Cannot compare ", ye.h(this), " to ", ye.h(n)].join(""));
};
de.prototype.Za = Rn;
de.prototype.Ua = function(e, n) {
  if (n instanceof de) return Dfe(this, n);
  throw Error(["Cannot compare ", ye.h(this), " to ", ye.h(n)].join(""));
};
Nm.prototype.Za = Rn;
Nm.prototype.Ua = function(e, n) {
  if (or(n)) return k3(this, n);
  throw Error(["Cannot compare ", ye.h(this), " to ", ye.h(n)].join(""));
};
v.prototype.Za = Rn;
v.prototype.Ua = function(e, n) {
  if (or(n)) return k3(this, n);
  throw Error(["Cannot compare ", ye.h(this), " to ", ye.h(n)].join(""));
};
yl.prototype.Za = Rn;
yl.prototype.Ua = function(e, n) {
  if (or(n)) return k3(this, n);
  throw Error(["Cannot compare ", ye.h(this), " to ", ye.h(n)].join(""));
};
Qr.prototype.Za = Rn;
Qr.prototype.Ua = function(e, n) {
  if (or(n)) return k3(this, n);
  throw Error(["Cannot compare ", ye.h(this), " to ", ye.h(n)].join(""));
};
Jl.prototype.Za = Rn;
Jl.prototype.Ua = function(e, n) {
  if (or(n)) return k3(this, n);
  throw Error(["Cannot compare ", ye.h(this), " to ", ye.h(n)].join(""));
};
var j2 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
j2.l = function(e, n, t) {
  return e.meta = In.j(n, e.meta, t);
};
j2.m = 2;
j2.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var ZA = null, Xr = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Xr.o = function() {
  return Xr.h("G__");
};
Xr.h = function(e) {
  return ZA == null && (ZA = kr.h(0)), _n.h([ye.h(e), ye.h(wr.g(ZA, Lw))].join(""));
};
Xr.m = 1;
P3.prototype.jb = function() {
  return j(this.f) && (this.value = this.f.o ? this.f.o() : this.f.call(null), this.f = null), this.value;
};
P3.prototype.Ac = function() {
  return er(this.f);
};
P3.prototype.R = function(e, n, t) {
  return Br(n, "#object[cljs.core.Delay "), Wl(new $(null, 2, [O2e, this.f == null ? Gge : I0e, xb, this.value], null), n, t), Br(n, "]");
};
var Sx = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Sx.h = function(e) {
  return Sx.g(e, null);
};
Sx.g = function(e, n) {
  return function(t) {
    return function() {
      function l(a, h) {
        if (j(e.h ? e.h(h) : e.call(null, h))) {
          var s = j6;
          j(n) && (a = t.h ? t.h(a) : t.call(null, a), h = n.g ? n.g(a, h) : n.call(null, a, h)), s = xh(new $(null, 1, [s, h], null));
        } else s = t.g ? t.g(a, h) : t.call(null, a, h);
        return s;
      }
      function r(a) {
        return ci(a) && Ol(a, j6) ? j6.h(a) : t.h ? t.h(a) : t.call(null, a);
      }
      function u() {
        return t.o ? t.o() : t.call(null);
      }
      var o = null;
      return o = function(a, h) {
        switch (arguments.length) {
          case 0:
            return u.call(this);
          case 1:
            return r.call(this, a);
          case 2:
            return l.call(
              this,
              a,
              h
            );
        }
        throw Error("Invalid arity: " + arguments.length);
      }, o.o = u, o.h = r, o.g = l, o;
    }();
  };
};
Sx.m = 2;
var Ex = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Ex.o = function() {
  return function(e) {
    var n = Qi(mR);
    return function() {
      function t(o, a) {
        var h = sn(n);
        return Yu(n, a), on.g(h, a) ? o : e.g ? e.g(o, a) : e.call(null, o, a);
      }
      function l(o) {
        return e.h ? e.h(o) : e.call(null, o);
      }
      function r() {
        return e.o ? e.o() : e.call(null);
      }
      var u = null;
      return u = function(o, a) {
        switch (arguments.length) {
          case 0:
            return r.call(this);
          case 1:
            return l.call(this, o);
          case 2:
            return t.call(this, o, a);
        }
        throw Error("Invalid arity: " + arguments.length);
      }, u.o = r, u.h = l, u.g = t, u;
    }();
  };
};
Ex.h = function(e) {
  return ve.g(Ex.o(), e);
};
Ex.m = 1;
var gb = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
gb.h = function(e) {
  return Ou.h(function() {
    return (Wh.o ? Wh.o() : Wh.call(null)) < e;
  });
};
gb.g = function(e, n) {
  return Ou.g(function() {
    return (Wh.o ? Wh.o() : Wh.call(null)) < e;
  }, n);
};
gb.m = 2;
A = V4.prototype;
A.indexOf = function() {
  var e = null;
  return e = function(n, t) {
    switch (arguments.length) {
      case 1:
        return Ht(this, n, 0);
      case 2:
        return Ht(this, n, t);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Ht(this, n, 0);
  }, e.g = function(n, t) {
    return Ht(this, n, t);
  }, e;
}();
A.lastIndexOf = function() {
  function e(t) {
    return xl(this, t, Cn(this));
  }
  var n = null;
  return n = function(t, l) {
    switch (arguments.length) {
      case 1:
        return e.call(this, t);
      case 2:
        return xl(this, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, n.h = e, n.g = function(t, l) {
    return xl(this, t, l);
  }, n;
}();
A.Xa = function() {
  var e = HO(this.coll);
  return TL(this.rd, e, !1);
};
A.W = function() {
  return z(ve.g(this.rd, this.coll));
};
A.Da = function(e, n) {
  return pp.j(this.rd, Zw.h(n), this.coll);
};
A.Ea = function(e, n, t) {
  return pp.B(this.rd, Zw.h(n), t, this.coll);
};
A.R = function(e, n, t) {
  return vr(n, Wl, "(", " ", ")", t, this);
};
V4.prototype[Li] = function() {
  return ti(this);
};
var wb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
wb.l = function(e) {
  return new V4(In.g(ua, td(e)), ho(e));
};
wb.m = 0;
wb.v = function(e) {
  return this.l(z(e));
};
var Bc = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
Bc.l = function(e, n) {
  n = fr(n);
  var t = en.j(n, D_e, ml), l = function r(u) {
    if (u == null) return null;
    if (u != null ? Rn === u.Oe || !u.Pc && pl(GO, u) : pl(GO, u)) return ZO(u);
    if (u instanceof de) return t.h ? t.h(u) : t.call(null, u);
    if (u instanceof T) return ye.h(u);
    if (ci(u)) {
      var o = {};
      u = z(u);
      for (var a = null, h = 0, s = 0; ; ) if (s < h) {
        var d = a.Y(null, s), p = O.j(d, 0, null);
        d = O.j(d, 1, null), p = AU(p, l), d = r(d), o[p] = d, s += 1;
      } else if (u = z(u)) oi(u) ? (h = Jr(u), u = Wr(u), a = h, h = Cn(h)) : (h = I(u), a = O.j(h, 0, null), h = O.j(h, 1, null), a = AU(a, l), h = r(h), o[a] = h, u = W(u), a = null, h = 0), s = 0;
      else break;
      return o;
    }
    if (w1(u)) {
      for (o = [], u = z(bt.g(r, u)), a = null, s = h = 0; ; ) if (s < h) p = a.Y(null, s), o.push(p), s += 1;
      else if (u = z(u)) a = u, oi(a) ? (u = Jr(a), s = Wr(a), a = u, h = Cn(u), u = s) : (u = I(a), o.push(u), u = W(a), a = null, h = 0), s = 0;
      else break;
      return o;
    }
    return u;
  };
  return l(e);
};
Bc.m = 1;
Bc.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
var xp = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], new hn(t.slice(1), 0, null));
  }
};
xp.h = function(e) {
  return xp.l(e, Te([_b, !1]));
};
xp.l = function(e, n) {
  var t = fr(n);
  t = en.g(t, _b);
  var l = j(t) ? ts : ye;
  return function r(u) {
    return (u != null ? Rn === u.Nf || !u.Pc && pl(DU, u) : pl(DU, u)) ? mI(u, In.g(ah, n)) : ei(u) ? k1.h(bt.g(r, u)) : Qd(u) ? new yl(r(Xa(u)), r(Cc(u))) : w1(u) ? lr.j(O3(u), bt.h(r), u) : ra(u) ? gu(wt.j(function(o, a) {
      return to.g(o, r(a));
    }, ou(Dt), u)) : zh(u) === Object ? gu(wt.j(function(o, a) {
      return ao.j(o, l.h ? l.h(a) : l.call(null, a), r(lo(u, a)));
    }, ou(Tt), _3(u))) : u;
  }(e);
};
xp.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
xp.m = 1;
var $y = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], new hn(t.slice(1), 0, null));
  }
};
$y.h = function(e) {
  for (; ; ) if (e = e.o ? e.o() : e.call(null), !Bw(e)) return e;
};
$y.l = function(e, n) {
  return $y.h(function() {
    return In.g(e, n);
  });
};
$y.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
$y.m = 1;
var Wh = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Wh.o = function() {
  return Wh.h(1);
};
Wh.h = function(e) {
  return Math.random() * e;
};
Wh.m = 1;
var XA = null, Sp = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Sp.g = function(e, n) {
  return e = Te([e, n]), In.B(wr, es(), Sp, e), null;
};
Sp.j = function(e, n, t) {
  function l(a, h, s, d, p) {
    return wt.j(function(_, R) {
      return Dn.j(_, R, wt.j(yt, en.j(p, R, ss), kt(d, p.h ? p.h(d) : p.call(null, d))));
    }, a, kt(h, s.h ? s.h(h) : s.call(null, h)));
  }
  var r = Ea.h(e), u = Y_.h(e), o = U0.h(e);
  if (Ol(r.h ? r.h(n) : r.call(null, n), t)) n = null;
  else {
    if (Ol(o.h ? o.h(n) : o.call(null, n), t)) throw Error([ye.h(n), "already has", ye.h(t), "as ancestor"].join(""));
    if (Ol(o.h ? o.h(t) : o.call(null, t), n)) throw Error(["Cyclic derivation:", ye.h(t), "has", ye.h(n), "as ancestor"].join(""));
    n = new $(null, 3, [Ea, Dn.j(
      Ea.h(e),
      n,
      yt.g(en.j(r, n, ss), t)
    ), U0, l(U0.h(e), n, u, t, o), Y_, l(Y_.h(e), t, o, n, u)], null);
  }
  return j(n) ? n : e;
};
Sp.m = 3;
var Ly = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Ly.g = function(e, n) {
  return e = Te([e, n]), In.B(wr, es(), Ly, e), null;
};
Ly.j = function(e, n, t) {
  var l = Ea.h(e), r = j(l.h ? l.h(n) : l.call(null, n)) ? Aa.g(l.h ? l.h(n) : l.call(null, n), t) : ss;
  return r = j(Fo(r)) ? Dn.j(l, n, r) : nr.g(l, n), r = bK(bt.g(function(u) {
    return kt(I(u), rd.g(I(u), Vr(u)));
  }, z(r))), Ol(l.h ? l.h(n) : l.call(null, n), t) ? wt.j(function(u, o) {
    return In.j(Sp, u, o);
  }, Y4(), Mo.g(2, r)) : e;
};
Ly.m = 3;
var _Z = function e(n, t, l) {
  var r = function() {
    var u = sn(l);
    return u.h ? u.h(n) : u.call(null, n);
  }();
  return r = j(j(r) ? r.h ? r.h(t) : r.call(null, t) : r) ? !0 : null, j(r) || (r = function() {
    for (var u = IU(t); ; ) if (0 < Cn(u)) {
      var o = I(u);
      e.j ? e.j(n, o, l) : e.call(null, n, o, l), u = tn(u);
    } else return null;
  }(), j(r)) ? r : (r = function() {
    for (var u = IU(n); ; ) if (0 < Cn(u)) {
      var o = I(u);
      e.j ? e.j(o, t, l) : e.call(null, o, t, l), u = tn(u);
    } else return null;
  }(), j(r) ? r : !1);
}, nge = function e(n, t, l, r, u, o, a, h) {
  var s = wt.j(function(p, _) {
    var R = O.j(_, 0, null);
    if (O.j(_, 1, null), w2(sn(l), t, R)) {
      if (p = p == null || RU(R, I(p), u, sn(l)) ? _ : p, !RU(I(p), R, u, sn(l))) throw Error(["Multiple methods in multimethod '", ye.h(n), "' match dispatch value: ", ye.h(t), " -> ", ye.h(R), " and ", ye.h(I(p)), ", and neither is preferred"].join(""));
      return p;
    }
    return p;
  }, null, sn(r)), d = function() {
    var p;
    return (p = s == null) && (p = sn(r), p = p.h ? p.h(h) : p.call(null, h)), j(p) ? new v(null, 2, 5, y, [h, p], null) : s;
  }();
  return j(d) ? on.g(sn(a), sn(l)) ? (wr.B(o, Dn, t, Vr(d)), Vr(d)) : ($3(o, r, a, l), e.ia ? e.ia(
    n,
    t,
    l,
    r,
    u,
    o,
    a,
    h
  ) : e.call(null, n, t, l, r, u, o, a, h)) : null;
};
A = Np.prototype;
A.call = function(e) {
  switch (arguments.length - 1) {
    case 0:
      return this.o();
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    case 3:
      return this.j(arguments[1], arguments[2], arguments[3]);
    case 4:
      return this.B(arguments[1], arguments[2], arguments[3], arguments[4]);
    case 5:
      return this.I(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    case 6:
      return this.T(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
    case 7:
      return this.ba(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7]
      );
    case 8:
      return this.ia(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8]);
    case 9:
      return this.va(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9]);
    case 10:
      return this.la(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10]);
    case 11:
      return this.ma(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11]);
    case 12:
      return this.na(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12]);
    case 13:
      return this.oa(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13]
      );
    case 14:
      return this.pa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14]);
    case 15:
      return this.qa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15]);
    case 16:
      return this.ra(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16]
      );
    case 17:
      return this.sa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15], arguments[16], arguments[17]);
    case 18:
      return this.ta(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18]
      );
    case 19:
      return this.ua(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15], arguments[16], arguments[17], arguments[18], arguments[19]);
    case 20:
      return this.Va(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18],
        arguments[19],
        arguments[20]
      );
    case 21:
      return this.Vb(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18],
        arguments[19],
        arguments[20],
        arguments[21]
      );
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.o = function() {
  var e = this.M.o ? this.M.o() : this.M.call(null), n = this.Ya(null, e);
  return j(n) || os(this.name, e), n.o ? n.o() : n.call(null);
};
A.h = function(e) {
  var n = this.M.h ? this.M.h(e) : this.M.call(null, e), t = this.Ya(null, n);
  return j(t) || os(this.name, n), t.h ? t.h(e) : t.call(null, e);
};
A.g = function(e, n) {
  var t = this.M.g ? this.M.g(e, n) : this.M.call(null, e, n), l = this.Ya(null, t);
  return j(l) || os(this.name, t), l.g ? l.g(e, n) : l.call(null, e, n);
};
A.j = function(e, n, t) {
  var l = this.M.j ? this.M.j(e, n, t) : this.M.call(null, e, n, t), r = this.Ya(null, l);
  return j(r) || os(this.name, l), r.j ? r.j(e, n, t) : r.call(null, e, n, t);
};
A.B = function(e, n, t, l) {
  var r = this.M.B ? this.M.B(e, n, t, l) : this.M.call(null, e, n, t, l), u = this.Ya(null, r);
  return j(u) || os(this.name, r), u.B ? u.B(e, n, t, l) : u.call(null, e, n, t, l);
};
A.I = function(e, n, t, l, r) {
  var u = this.M.I ? this.M.I(e, n, t, l, r) : this.M.call(null, e, n, t, l, r), o = this.Ya(null, u);
  return j(o) || os(this.name, u), o.I ? o.I(e, n, t, l, r) : o.call(null, e, n, t, l, r);
};
A.T = function(e, n, t, l, r, u) {
  var o = this.M.T ? this.M.T(e, n, t, l, r, u) : this.M.call(null, e, n, t, l, r, u), a = this.Ya(null, o);
  return j(a) || os(this.name, o), a.T ? a.T(e, n, t, l, r, u) : a.call(null, e, n, t, l, r, u);
};
A.ba = function(e, n, t, l, r, u, o) {
  var a = this.M.ba ? this.M.ba(e, n, t, l, r, u, o) : this.M.call(null, e, n, t, l, r, u, o), h = this.Ya(null, a);
  return j(h) || os(this.name, a), h.ba ? h.ba(e, n, t, l, r, u, o) : h.call(null, e, n, t, l, r, u, o);
};
A.ia = function(e, n, t, l, r, u, o, a) {
  var h = this.M.ia ? this.M.ia(e, n, t, l, r, u, o, a) : this.M.call(null, e, n, t, l, r, u, o, a), s = this.Ya(null, h);
  return j(s) || os(this.name, h), s.ia ? s.ia(e, n, t, l, r, u, o, a) : s.call(null, e, n, t, l, r, u, o, a);
};
A.va = function(e, n, t, l, r, u, o, a, h) {
  var s = this.M.va ? this.M.va(e, n, t, l, r, u, o, a, h) : this.M.call(null, e, n, t, l, r, u, o, a, h), d = this.Ya(null, s);
  return j(d) || os(this.name, s), d.va ? d.va(e, n, t, l, r, u, o, a, h) : d.call(null, e, n, t, l, r, u, o, a, h);
};
A.la = function(e, n, t, l, r, u, o, a, h, s) {
  var d = this.M.la ? this.M.la(e, n, t, l, r, u, o, a, h, s) : this.M.call(null, e, n, t, l, r, u, o, a, h, s), p = this.Ya(null, d);
  return j(p) || os(this.name, d), p.la ? p.la(e, n, t, l, r, u, o, a, h, s) : p.call(null, e, n, t, l, r, u, o, a, h, s);
};
A.ma = function(e, n, t, l, r, u, o, a, h, s, d) {
  var p = this.M.ma ? this.M.ma(e, n, t, l, r, u, o, a, h, s, d) : this.M.call(null, e, n, t, l, r, u, o, a, h, s, d), _ = this.Ya(null, p);
  return j(_) || os(this.name, p), _.ma ? _.ma(e, n, t, l, r, u, o, a, h, s, d) : _.call(null, e, n, t, l, r, u, o, a, h, s, d);
};
A.na = function(e, n, t, l, r, u, o, a, h, s, d, p) {
  var _ = this.M.na ? this.M.na(e, n, t, l, r, u, o, a, h, s, d, p) : this.M.call(null, e, n, t, l, r, u, o, a, h, s, d, p), R = this.Ya(null, _);
  return j(R) || os(this.name, _), R.na ? R.na(e, n, t, l, r, u, o, a, h, s, d, p) : R.call(null, e, n, t, l, r, u, o, a, h, s, d, p);
};
A.oa = function(e, n, t, l, r, u, o, a, h, s, d, p, _) {
  var R = this.M.oa ? this.M.oa(e, n, t, l, r, u, o, a, h, s, d, p, _) : this.M.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _), F = this.Ya(null, R);
  return j(F) || os(this.name, R), F.oa ? F.oa(e, n, t, l, r, u, o, a, h, s, d, p, _) : F.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _);
};
A.pa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R) {
  var F = this.M.pa ? this.M.pa(e, n, t, l, r, u, o, a, h, s, d, p, _, R) : this.M.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R), L = this.Ya(null, F);
  return j(L) || os(this.name, F), L.pa ? L.pa(e, n, t, l, r, u, o, a, h, s, d, p, _, R) : L.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R);
};
A.qa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F) {
  var L = this.M.qa ? this.M.qa(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F) : this.M.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F), G = this.Ya(null, L);
  return j(G) || os(this.name, L), G.qa ? G.qa(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F) : G.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F);
};
A.ra = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L) {
  var G = this.M.ra ? this.M.ra(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L) : this.M.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L), J = this.Ya(null, G);
  return j(J) || os(this.name, G), J.ra ? J.ra(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L) : J.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L);
};
A.sa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G) {
  var J = this.M.sa ? this.M.sa(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G) : this.M.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G), we = this.Ya(null, J);
  return j(we) || os(this.name, J), we.sa ? we.sa(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G) : we.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G);
};
A.ta = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J) {
  var we = this.M.ta ? this.M.ta(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J) : this.M.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J), ce = this.Ya(null, we);
  return j(ce) || os(this.name, we), ce.ta ? ce.ta(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J) : ce.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J);
};
A.ua = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we) {
  var ce = this.M.ua ? this.M.ua(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we) : this.M.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we), xe = this.Ya(null, ce);
  return j(xe) || os(this.name, ce), xe.ua ? xe.ua(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we) : xe.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we);
};
A.Va = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce) {
  var xe = this.M.Va ? this.M.Va(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce) : this.M.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce), $e = this.Ya(null, xe);
  return j($e) || os(this.name, xe), $e.Va ? $e.Va(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce) : $e.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce);
};
A.Vb = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe) {
  var $e = In.l(this.M, e, n, t, l, Te([r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe])), je = this.Ya(null, $e);
  return j(je) || os(this.name, $e), In.l(je, e, n, t, l, Te([r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe]));
};
A.de = function(e, n, t) {
  if (j(_Z(t, n, this.Xc))) throw Error(["Preference conflict in multimethod '", ye.h(this.name), "': ", ye.h(t), " is already preferred to ", ye.h(n)].join(""));
  return wr.g(this.Xc, function(l) {
    return Dn.j(l, n, yt.g(en.j(l, n, ss), t));
  }), $3(this.tc, this.cc, this.oc, this.Gc);
};
A.fe = function(e, n) {
  return wr.j(this.cc, nr, n), $3(this.tc, this.cc, this.oc, this.Gc), this;
};
A.ce = function() {
  return sn(this.cc);
};
A.ee = function() {
  return sn(this.Xc);
};
A.$a = function(e, n, t) {
  return wr.B(this.cc, Dn, n, t), $3(this.tc, this.cc, this.oc, this.Gc), this;
};
A.ge = function() {
  return wr.g(this.cc, function() {
    return Tt;
  }), wr.g(this.tc, function() {
    return Tt;
  }), wr.g(this.Xc, function() {
    return Tt;
  }), wr.g(this.oc, function() {
    return null;
  }), this;
};
A.Ya = function(e, n) {
  return on.g(sn(this.oc), sn(this.Gc)) || $3(this.tc, this.cc, this.oc, this.Gc), e = sn(this.tc), e = e.h ? e.h(n) : e.call(null, n), j(e) ? e : nge(this.name, n, this.Gc, this.cc, this.Xc, this.tc, this.oc, this.bf);
};
A.yc = function() {
  return lI(this.name);
};
A.zc = function() {
  return rI(this.name);
};
A.O = function() {
  return pL(this);
};
A = L3.prototype;
A.ne = Rn;
A.toString = function() {
  return this.vc;
};
A.N = function(e, n) {
  return (e = n != null ? Rn === n.ne : !1) ? this.vc === n.vc : e;
};
A.R = function(e, n) {
  return Br(n, ['#uuid "', ye.h(this.vc), '"'].join(""));
};
A.O = function() {
  return this.H == null && (this.H = Uu(this.vc)), this.H;
};
A.Ua = function(e, n) {
  if (n instanceof L3) return hh(this.vc, n.vc);
  throw Error(["Cannot compare ", ye.h(this), " to ", ye.h(n)].join(""));
};
ld.prototype.__proto__ = Error.prototype;
ld.prototype.da = Rn;
ld.prototype.R = function(e, n, t) {
  return Br(n, "#error {:message "), Wl(this.message, n, t), j(this.data) && (Br(n, ", :data "), Wl(this.data, n, t)), j(this.cause) && (Br(n, ", :cause "), Wl(this.cause, n, t)), Br(n, "}");
};
ld.prototype.toString = function() {
  return Ui(this);
};
var Yr = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Yr.g = function(e, n) {
  return Yr.j(e, n, null);
};
Yr.j = function(e, n, t) {
  return new ld(e, n, t);
};
Yr.m = 3;
A = JO.prototype;
A.toString = function() {
  return Ui(this);
};
A.N = function(e, n) {
  return n instanceof JO && on.g(this.tag, n.tag) && on.g(this.form, n.form);
};
A.O = function() {
  return 31 * Uu(this.tag) + Uu(this.form);
};
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  switch (n instanceof de ? n.ca : null) {
    case "tag":
      return this.tag;
    case "form":
      return this.form;
    default:
      return t;
  }
};
A.R = function(e, n, t) {
  return Br(n, ["#", ye.h(this.tag), " "].join("")), Wl(this.form, n, t);
};
var tge = "arguments abstract await boolean break byte case catch char class const continue debugger default delete do double else enum export extends final finally float for function goto if implements import in instanceof int interface let long native new package private protected public return short static super switch synchronized this throw throws transient try typeof var void volatile while with yield methods null constructor".split(" "), QA = null;
typeof console < "u" && eK();
eK();
var xZ = new de(null, "nil", "nil", 99600501), SB = new de(null, "token", "token", -1211463215), lge = new T(null, "message", "message", 1234475525, null), rge = new T(null, "banking-day?", "banking-day?", 1838719672, null), VI = new T(null, "extend-protocol", "extend-protocol", 306378578, null), YI = new T(null, "assoc-in", "assoc-in", -113585743, null), SZ = new T("cljs.math", "negate-exact", "cljs.math/negate-exact", 559751781, null), UI = new T(null, "ns-aliases", "ns-aliases", -1364180948, null), ige = new T(
  "ruler.utils.java-time",
  "after-nth-of-month",
  "ruler.utils.java-time/after-nth-of-month",
  1959372612,
  null
), qI = new T(null, "ident?", "ident?", -2061359468, null), vE = new de(null, "reader-exception", "reader-exception", -1938323098), WI = new T(null, "*1", "*1", 2110258092, null), HI = new T(null, "*2", "*2", 1728229926, null), zI = new T(null, "*3", "*3", 105062009, null), Rq = new T(null, "kvs", "kvs", -1695980277, null), KI = new T(null, "filterv", "filterv", 1977739179, null), lw = new de(null, "year", "year", 335913393), Nq = new T(null, "from", "from", -839142725, null), uge = new T(
  null,
  "import-vars",
  "import-vars",
  975773089,
  null
), EZ = new T(null, "*reader-resolver*", "*reader-resolver*", 309718590, null), sge = new T("ruler.utils.clj-time", "labor-day-m", "ruler.utils.clj-time/labor-day-m", 1618119413, null), OZ = new T(null, "atan", "atan", -1026550135, null), Du = new de(null, "row", "row", -570139521), Cq = new T(null, "m__24506__auto__", "m__24506__auto__", -1537201191, null), GI = new T(null, "*e", "*e", 329170866, null), oge = new de(null, "spec", "spec", 347520401), Ox = new de(null, "load-fn", "load-fn", -2121144334), ZI = new T(
  null,
  "hash-map",
  "hash-map",
  -439030950,
  null
), XI = new T(null, "vary-meta", "vary-meta", -1580067831, null), Dl = new T(null, "format", "format", 333606761, null), age = new T(null, "pad", "pad", 1603796986, null), kZ = new de(null, "dotted-access", "dotted-access", 114961112), Mq = new T(null, "apropos", "apropos", -1511857537, null), fo = new de(null, "from", "from", 1815293044), cge = new T(null, "Error", "Error", -1692662047, null), QI = new T(null, "ns-refers", "ns-refers", -2030918515, null), Pq = new de(null, "reify-fn", "reify-fn", -1360983316), hge = new T(
  "cljs.core",
  "ex-cause",
  "cljs.core/ex-cause",
  1843478517,
  null
), $q = new T(null, "start-key", "start-key", 790225477, null), bZ = new de(null, "from-to", "from-to", -640428401), fge = new de(null, "basic-t-time-no-ms", "basic-t-time-no-ms", -424650106), JI = new T(null, "not-any?", "not-any?", -2114707554, null), dge = new T("ruler.utils.clj-time", "date-format-with-time", "ruler.utils.clj-time/date-format-with-time", -2073838637, null), eR = new T(null, "apply", "apply", -1334050276, null), nR = new T(null, "when-let", "when-let", -1383043480, null), r5 = new T(
  null,
  "cljs.core",
  "cljs.core",
  770546058,
  null
), cm = new T(null, "start", "start", 1285322546, null), tR = new T(null, "->>", "->>", -1874332161, null), lR = new T(null, "ifn?", "ifn?", -2106461064, null), rR = new T(null, "->Eduction", "->Eduction", -188511967, null), pge = new de(null, "hour-minute-second-fraction", "hour-minute-second-fraction", -1253038551), mge = new T("ruler.utils.clj-time", "presidents-day-m", "ruler.utils.clj-time/presidents-day-m", -1339298432, null), TZ = new de(null, "fn-name", "fn-name", -766594004), iR = new T(
  null,
  "merge",
  "merge",
  -163787882,
  null
), i5 = new de(null, "current", "current", -1088038603), uR = new T(null, "qualified-symbol?", "qualified-symbol?", 98763807, null), jZ = new T(null, "ns-obj", "ns-obj", -635821906, null), gge = new T(null, "xform*", "xform*", 264470622, null), sR = new T(null, "letfn", "letfn", -480490827, null), kx = new de(null, "js-libs", "js-libs", -502933721), AZ = new T(null, "psym", "psym", 752521989, null), oR = new T(null, "->", "->", -2139605430, null), wge = new T(null, "Inf", "Inf", 647172781, null), kk = new de(null, "all", "all", 892129742), gh = new de(null, "class", "class", -2030961996), aR = new T(null, "nil?", "nil?", 1612038930, null), cR = new T(null, "uri?", "uri?", 2029475116, null), hR = new T(null, "cat", "cat", 182721320, null), vge = new de(null, "selectLineStart", "selectLineStart", 1211557745), bk = new T(null, "..", "..", -300507420, null), yge = new T(null, "children", "children", 699969545, null), _ge = new de(null, "outline", "outline", 793464534), xge = new T(null, "read-char*", "read-char*", 1494526523, null), ai = new de(null, "default", "default", -1987822328), fR = new T(
  null,
  "object-array",
  "object-array",
  206434647,
  null
), Sge = new de(null, "basic-ordinal-date-time-no-ms", "basic-ordinal-date-time-no-ms", -395135436), dR = new T(null, "nnext", "nnext", -2065435598, null), DZ = new T("cljs.core", "chunk-first", "cljs.core/chunk-first", -1157877305, null), Ege = new de(null, "ex-kind", "ex-kind", 1581199296), pR = new T(null, "sorted-map-by", "sorted-map-by", 218894812, null), j0 = new de("edamame", "opened-delimiter", "edamame/opened-delimiter", -1906008305), mR = new de("cljs.core", "none", "cljs.core/none", 926646439), Oge = new T(
  "cljs.reader",
  "read-date",
  "cljs.reader/read-date",
  1663417238,
  null
), bx = new de(null, "meridiem", "meridiem", 1668960617), Tk = new T(null, "params*", "params*", 336153603, null), IZ = new T(null, "sci.impl.records", "sci.impl.records", -393424368, null), gR = new T(null, "unreduced", "unreduced", 780976083, null), wR = new T(null, "add-watch", "add-watch", 1389887634, null), RZ = new de(null, "y-int?", "y-int?", 2045680479), NZ = new T(null, "-new-dynamic-var", "-new-dynamic-var", -1029088918, null), vR = new T(
  null,
  "pop-thread-bindings",
  "pop-thread-bindings",
  -1312224790,
  null
), Lq = new T(null, "end-key", "end-key", -1592097336, null), kge = new T("cljs.analyzer.api", "resolve", "cljs.analyzer.api/resolve", 498213843, null), CZ = new T(null, "decrement-exact", "decrement-exact", -2059293233, null), yR = new T(null, "unchecked-byte", "unchecked-byte", 1091664664, null), vw = new T(null, "opts", "opts", 1795607228, null), _R = new T(null, "remove-all-methods", "remove-all-methods", -728267092, null), bge = new de(null, "date-hour-minute-second-fraction", "date-hour-minute-second-fraction", 1937143076), Tge = new T(null, "initch", "initch", 946908919, null), fh = new de(null, "insert", "insert", 1286475395), jge = new T("clojure.repl", "source-fn", "clojure.repl/source-fn", 1877923323, null), Bq = new T(null, "farg__24403__auto__", "farg__24403__auto__", 888644878, null), xR = new T(null, "uuid?", "uuid?", 400077689, null), SR = new de(null, "reload", "reload", 863702807), RS = new T("cljs.core", "atom", "cljs.core/atom", 1943839529, null), Age = new T("ruler.utils.java-time", "nth-of-month", "ruler.utils.java-time/nth-of-month", -768003915, null), NS = new T(
  null,
  "quoted-ns",
  "quoted-ns",
  -2054280928,
  null
), Dge = new de(null, "hour-minute-second", "hour-minute-second", -1906654770), ER = new T(null, "first", "first", 996428481, null), MZ = new T("cljs.math", "IEEE-remainder", "cljs.math/IEEE-remainder", 1683252566, null), Ige = new T("cljs.tools.reader.impl.commons", "parse-symbol", "cljs.tools.reader.impl.commons/parse-symbol", -903976395, null), PZ = new T("cljs.math", "E", "cljs.math/E", -1211754635, null), OR = new de(null, "opts", "opts", 155075701), kR = new T(null, "fnil", "fnil", -187395162, null), bR = new T(null, "reduced", "reduced", -1189224808, null), Uf = new de(null, "location?", "location?", 425878086), Rge = new de("sci.impl", "eval-string+", "sci.impl/eval-string+", -178784582), $Z = new de(null, "ordinal-suffix", "ordinal-suffix", -1311843199), TR = new T(null, "pop!", "pop!", -1253383511, null), jR = new T(null, "unchecked-negate-int", "unchecked-negate-int", -825297602, null), th = new T(null, "bindings", "bindings", -1383038577, null), AR = new T(null, "unchecked-add-int", "unchecked-add-int", -1821763285, null), Fq = new de(
  null,
  "background",
  "background",
  -863952629
), DR = new de("edamame.impl.parser", "suppress", "edamame.impl.parser/suppress", 1718484755), LZ = new T(null, "format-date", "format-date", -17964141, null), Vq = new T(null, "ret__27417__auto__", "ret__27417__auto__", -2012218806, null), BZ = new de(null, "fn-expr", "fn-expr", -933027985), FZ = new de(null, "transposeChars", "transposeChars", 1566260285), Nge = new T("clojure.core", "multi-fn-add-method-impl", "clojure.core/multi-fn-add-method-impl", -1293834231, null), Cge = new de(null, "dddd", "dddd", 217016228), vb = new T(
  "cljs.core",
  "nil?",
  "cljs.core/nil?",
  945071861,
  null
), Mge = new T("clojure.core", "-new-dynamic-var", "clojure.core/-new-dynamic-var", -1873937019, null), qf = new de(null, "eof", "eof", -489063237), IR = new de(null, "custom-color-10", "custom-color-10", -68996464), RR = new T(null, "defrecord", "defrecord", 273038109, null), VZ = new de(null, "cursorGroupForward", "cursorGroupForward", 1231480632), NR = new de(null, "custom-color-14", "custom-color-14", 1273073470), CR = new T(null, "even?", "even?", -1827825394, null), Pge = new de(
  null,
  "basic-time",
  "basic-time",
  -923134899
), MR = new de(null, "custom-color-13", "custom-color-13", -1282803213), PR = new de(null, "custom-color-12", "custom-color-12", -838318268), $R = new de(null, "custom-color-11", "custom-color-11", -1893879929), yo = new de(null, "millis", "millis", -1338288387), LR = new T(null, "neg?", "neg?", -1902175577, null), BR = new T(null, "float", "float", -91857841, null), yE = new T(null, "chunk", "chunk", 449371907, null), $ge = new T("ruler.utils.java-time", "subtract-months", "ruler.utils.java-time/subtract-months", -2096239194, null), YZ = new T(
  "cljs.core",
  "fnil",
  "cljs.core/fnil",
  479587341,
  null
), FR = new T(null, "if-let", "if-let", 1803593690, null), VR = new T(null, "object?", "object?", 327472310, null), UZ = new T(null, "cos", "cos", -1452677493, null), qZ = new T("cljs.math", "next-up", "cljs.math/next-up", -73329772, null), Jm = new de(null, "end", "end", -268185958), WZ = new de(null, "deleteGroupBackward", "deleteGroupBackward", 616768113), Ov = new T(null, "parent", "parent", 761652748, null), HZ = new T(null, "date-compare-difference-as-days", "date-compare-difference-as-days", 960819945, null), Lge = new T("clojure.core", "-new-var", "clojure.core/-new-var", 363339052, null), zZ = new T(null, "not-native", "not-native", -236392494, null), KZ = new T(null, "dividend", "dividend", 1540160115, null), Or = new de(null, "env", "env", -1815813235), GZ = new T(null, "*print-fn*", "*print-fn*", 138509853, null), Bge = new T("js", "Number", "js/Number", -508133572, null), YR = new T(null, "system-time", "system-time", 1690633727, null), ZZ = new de(null, "deftype-fields", "deftype-fields", -222569172), XZ = new de(null, "cursorPageUp", "cursorPageUp", -716828715), Fge = new de(null, "post", "post", 269697687), UR = new T(null, "pos?", "pos?", -244377722, null), Vge = new de(null, "period-match-erroro", "period-match-erroro", 1058444722), $h = new T(null, "tcoll", "tcoll", -1341294481, null), Sa = new de(null, "col-key", "col-key", -2009675766), EB = new de("sci.impl", "type-name", "sci.impl/type-name", -1528979388), $d = new T(null, "array", "array", -440182315, null), QZ = new de(null, "no-recur-reason", "no-recur-reason", -1993064353), qR = new T(null, "ns-interns", "ns-interns", 535532824, null), Yge = new T(
  null,
  "letfn*",
  "letfn*",
  -110097810,
  null
), Ea = new de(null, "parents", "parents", -2027538891), mm = new T(null, "date-b", "date-b", 606315825, null), WR = new T(null, "unchecked-dec-int", "unchecked-dec-int", 1339067442, null), HR = new T(null, "bit-shift-left", "bit-shift-left", -1814765981, null), gm = new T(null, "date-a", "date-a", 616042413, null), zR = new T(null, "take-last", "take-last", -41013151, null), Uge = new T(null, "->type-impl", "->type-impl", 483401048, null), JZ = new T(null, "next-up", "next-up", -1813766256, null), KR = new T(
  null,
  "short",
  "short",
  -725675253,
  null
), GR = new T(null, "atom", "atom", 1243487874, null), qge = new de(null, "date-hour-minute", "date-hour-minute", 1629918346), _E = new T(null, "symbol?", "symbol?", 1820680511, null), jk = new T(null, "defmacro", "defmacro", 2054157304, null), ZR = new T(null, "tagged-literal", "tagged-literal", -896422703, null), Wge = new T(null, "NaN", "NaN", 666918153, null), Tx = new de(null, "range", "range", 1639692286), Hge = new de(null, "end-col", "end-col", -724155879), eX = new de(null, "local-time", "local-time", -1873195290), nX = new T(
  null,
  "last-day-of-the-month",
  "last-day-of-the-month",
  -432331230,
  null
), A0 = new T(null, "ruler.utils.math", "ruler.utils.math", 34338725, null), Yq = new T(null, "default__24287__auto__", "default__24287__auto__", 925432403, null), tX = new T(null, "first-of-month?", "first-of-month?", -1495143641, null), zge = new T(null, "pprint", "pprint", -1434237374, null), lX = new T("cljs.math", "expm1", "cljs.math/expm1", -299913042, null), XR = new T(null, "extends?", "extends?", -2012201234, null), QR = new T(null, "bit-set", "bit-set", -910710655, null), Kge = new de(
  "clojure.core",
  "eval-file",
  "clojure.core/eval-file",
  801420726
), rX = new T(null, "protocol-type-impl", "protocol-type-impl", 561934718, null), jx = new de(null, "phase", "phase", 575722892), Gge = new de(null, "ready", "ready", 1086465795), Uq = new T(null, "kmap", "kmap", -2108296910, null), uv = new de("sci.impl", "f-meta", "sci.impl/f-meta", -1735495322), iX = new T(null, "date-compare-difference-as-date", "date-compare-difference-as-date", -1907677612, null), Ak = new T(null, "doc-string?", "doc-string?", 393166599, null), qq = new T(
  null,
  "end-test",
  "end-test",
  2122505254,
  null
), uX = new T(null, "IRecord", "IRecord", -903221169, null), sX = new T(null, "ceil", "ceil", -184398425, null), ne = new de(null, "arglists", "arglists", 1661989754), oX = new T("cljs.math", "floor", "cljs.math/floor", -130732800, null), aX = new T("cljs.math", "next-down", "cljs.math/next-down", 2112444436, null), Hh = new de(null, "format-str", "format-str", 695206156), JR = new T(null, "when-first", "when-first", 821699168, null), cX = new de(null, "cursorLineEnd", "cursorLineEnd", -234219178), eN = new T(
  "cljs.core",
  "declare",
  "cljs.core/declare",
  1312638100,
  null
), Zge = new T(null, "writer", "writer", 1362963291, null), tt = new de(null, "end-column", "end-column", 1425389514), Xge = new T(null, "xset", "xset", -371743149, null), hX = new T(null, "date--", "date--", 1792582127, null), fX = new T(null, "date-+", "date-+", 1788148215, null), nN = new T(null, "odd?", "odd?", -1458588199, null), dX = new de(null, "cursorDocEnd", "cursorDocEnd", -1298653903), OB = new T("cljs.core", "alter-var-root", "cljs.core/alter-var-root", -1342668238, null), tN = new T(null, "split-with", "split-with", 1853047034, null), yw = new T("cljs.core", "when", "cljs.core/when", 120293186, null), lN = new T(null, "prefer-method", "prefer-method", -876100205, null), Wf = new de(null, "unquote-splicing", "unquote-splicing", 1295267556), pX = new de("sci.impl.analyzer", "instance-expr", "sci.impl.analyzer/instance-expr", 629338719), Qge = new T(null, "var-args", "var-args", 1341745925, null), Jge = new de(null, "formatters", "formatters", -1875637118), kB = new de(null, "copy-enclosed->invocation", "copy-enclosed->invocation", -1322388729), mX = new T(
  "cljs.math",
  "log10",
  "cljs.math/log10",
  -581074993,
  null
), ewe = new T("clojure.core", "sequence", "clojure.core/sequence", 1998774218, null), gX = new de(null, "expr", "expr", 745722291), rN = new T(null, "bit-or", "bit-or", -1144943723, null), nwe = new T(null, "labor-day-m", "labor-day-m", -1972687257, null), wX = new T(null, "sci.impl.protocols", "sci.impl.protocols", -697012432, null), vX = new T("ruler.utils.string", "serialize", "ruler.utils.string/serialize", 1620967279, null), twe = new de(null, "refer-macros", "refer-macros", -1906841953), lwe = new T(
  "js",
  "Boolean",
  "js/Boolean",
  1661145260,
  null
), iN = new T(null, "find", "find", 2136810983, null), rwe = new T("ruler.utils.clj-time", "new-years-day-m", "ruler.utils.clj-time/new-years-day-m", 494435984, null), Wa = new T(null, "key", "key", 124488940, null), uN = new de(null, "loaded-libs", "loaded-libs", -1156389652), u5 = new de("sci.impl.protocols", "reified", "sci.impl.protocols/reified", -2019939396), sN = new T(null, "count", "count", -514511684, null), Dk = new T(null, "binding", "binding", -2114503176, null), iwe = new T(
  "sci.impl.deftype",
  "-create-type",
  "sci.impl.deftype/-create-type",
  -1020101113,
  null
), uwe = new T(null, "IDeref", "IDeref", 1738423197, null), oN = new T(null, "when-some", "when-some", 1700415903, null), aN = new T(null, "remove-ns", "remove-ns", -1915058781, null), kv = new T(null, "-swap!", "-swap!", -535359318, null), yX = new de(null, "resolve-symbol", "resolve-symbol", -319166964), _X = new T("cljs.core", "push-thread-bindings", "cljs.core/push-thread-bindings", -703482450, null), swe = new de(null, "basic-date-time-no-ms", "basic-date-time-no-ms", -899402179), owe = new de(
  null,
  "color-gray-lighter",
  "color-gray-lighter",
  1149309935
), Fd = new T(null, "number?", "number?", -1747282210, null), JA = new T(null, "s__26439__auto__", "s__26439__auto__", -99959026, null), yb = new de("sci.impl.parser.edamame", "eof", "sci.impl.parser.edamame/eof", -917261517), By = new de(null, "exclude", "exclude", -1230250334), awe = new T("ruler.utils.java-time", "next-banking-day", "ruler.utils.java-time/next-banking-day", -1582296644, null), cN = new T(null, "unchecked-subtract", "unchecked-subtract", -2137458667, null), cwe = new T(
  "cljs.core",
  "when-first",
  "cljs.core/when-first",
  -667185267,
  null
), hN = new T(null, "sort", "sort", -1700969851, null), xX = new de("sci.impl.record", "map-constructor", "sci.impl.record/map-constructor", 1072184780), hwe = new T("cljs.core", "in-ns", "cljs.core/in-ns", 1807208747, null), fwe = new de(null, "color-gray-darker", "color-gray-darker", 114276725), fN = new T(null, "juxt", "juxt", 671085604, null), e6 = new T(null, "args__24279__auto__", "args__24279__auto__", -2038628646, null), dwe = new T(
  "cljs.core",
  "when-let",
  "cljs.core/when-let",
  -2049838349,
  null
), SX = new T(null, "get-exponent", "get-exponent", 100142410, null), uc = new de(null, "body", "body", -2049205669), bB = new de(null, "special", "special", -1125941630), dN = new T(null, "alength", "alength", -1268305401, null), EX = new de(null, "outer-idens", "outer-idens", 1197381241), pN = new T(null, "with-redefs", "with-redefs", -1143728263, null), pwe = new de(null, "mode", "mode", 654403691), mN = new T(null, "nfirst", "nfirst", -554736533, null), n6 = new T(null, "fs__25790__auto__", "fs__25790__auto__", -195817503, null), gN = new T(
  null,
  "volatile!",
  "volatile!",
  919368405,
  null
), jf = new de(null, "closure-bindings", "closure-bindings", 112932037), Wq = new de(null, "border", "border", 1444987323), mwe = new de(null, "fallback-impl", "fallback-impl", -1501286995), te = new de(null, "name", "name", 1843675177), bc = new de(null, "syms", "syms", -1575891762), wN = new T(null, "reset-meta!", "reset-meta!", 1699493291, null), t6 = new T(null, "do-template", "do-template", -1578627476, null), vN = new T(null, "map?", "map?", -1780568534, null), yN = new T(null, "into", "into", 1489695498, null), gwe = new T(
  "ruler.utils.clj-time",
  "first-of-month?",
  "ruler.utils.clj-time/first-of-month?",
  202985429,
  null
), _N = new T(null, "sorted-set", "sorted-set", 992325424, null), xN = new T(null, "ints", "ints", -1761239845, null), SN = new T(null, "contains?", "contains?", -1676812576, null), TB = new T(null, "-deref", "-deref", -283116853, null), wwe = new de(null, "illegal-argument", "illegal-argument", -1845493170), Hf = new de(null, "class->opts", "class->opts", 2061906477), l6 = new T(null, "index-of", "index-of", 1275975485, null), V_ = new de(
  "edamame",
  "opened-delimiter-loc",
  "edamame/opened-delimiter-loc",
  443885208
), EN = new T(null, "all-ns", "all-ns", 1571857784, null), ON = new T(null, "with-bindings", "with-bindings", -1197589787, null), kN = new T(null, "js-keys", "js-keys", -1388365203, null), _b = new de(null, "keywordize-keys", "keywordize-keys", 1310784252), jB = new T(null, "inst", "inst", -2008473268, null), vwe = new de(null, "LineComment", "LineComment", 1087879618), ywe = new T(null, "presidents-day-m", "presidents-day-m", 1310738674, null), AB = new de(null, "auto-resolve", "auto-resolve", 1851201983), bN = new T(
  null,
  "int?",
  "int?",
  1799729645,
  null
), Hq = new T(null, "v__27274__auto__", "v__27274__auto__", 146810568, null), _we = new T("cljs.core", "next", "cljs.core/next", -1291438473, null), _o = new de(null, "hours", "hours", 58380855), xwe = new T(null, "cmap", "cmap", 1947829886, null), l1 = new de(null, "buffer", "buffer", 617295198), OX = new T("cljs.math", "log1p", "cljs.math/log1p", 1802109642, null), kX = new T(null, "divisor", "divisor", 1615502407, null), Cd = new de(null, "preventDefault", "preventDefault", -1714933772), TN = new T(null, "empty?", "empty?", 76408555, null), jN = new T(
  null,
  "lazy-cat",
  "lazy-cat",
  -89906116,
  null
), bX = new de(null, "deleteCharBackward", "deleteCharBackward", -618312025), zq = new T(null, "replacement", "replacement", -195707312, null), AN = new T(null, "*print-readably*", "*print-readably*", -761361221, null), DN = new T(null, "dissoc", "dissoc", 1039760994, null), Swe = new T("cljs.core", "refer", "cljs.core/refer", 269577817, null), r6 = new T(null, "replace-first", "replace-first", -943534331, null), Ax = new de(null, "const", "const", 1709929842), Kq = new T(
  null,
  "n__27121__auto__",
  "n__27121__auto__",
  1991854660,
  null
), Dx = new T(null, "meta", "meta", -1154898805, null), DB = new de(null, "indent", "indent", -148200125), xE = new T(null, "reader", "reader", 1810192380, null), Y_ = new de(null, "descendants", "descendants", 1824886031), Gq = new de("sci.impl.deftype", "object", "sci.impl.deftype/object", -248099673), IN = new T(null, "str", "str", -1564826950, null), Ewe = new T(null, "type-sym", "type-sym", -1942856509, null), TX = new T(null, "IPrintWithWriter", "IPrintWithWriter", -1205316154, null), dh = new de(null, "end-location", "end-location", -1199449467), bm = new de("sci", "error", "sci/error", -979082803), Ik = new de("sci.impl", "constructor", "sci.impl/constructor", 1320345666), Owe = new T("ruler.utils.java-time", "last-of-month?", "ruler.utils.java-time/last-of-month?", -1248242595, null), jX = new T(null, "*print-err-fn*", "*print-err-fn*", 1241679298, null), Rk = new T(null, "print-str", "print-str", -699700354, null), kwe = new T(null, "fn-tail", "fn-tail", -178337841, null), AX = new T("cljs.math", "signum", "cljs.math/signum", -309735886, null), bwe = new de(
  "edamame",
  "error",
  "edamame/error",
  882529634
), xb = new de(null, "val", "val", 128701612), Twe = new T("ruler.utils.java-time", "date-compare", "ruler.utils.java-time/date-compare", 1643368919, null), $o = new de(null, "var", "var", -769682797), jwe = new de(null, "next", "next", -117701485), Nk = new T(null, "get", "get", -971253014, null), Ck = new T(null, "step", "step", -1365547645, null), i6 = new T(null, "method__24290__auto__", "method__24290__auto__", 1009680203, null), Awe = new T(null, "dispatch-fn", "dispatch-fn", -1401088155, null), Mk = new T(
  null,
  "ex-cause",
  "ex-cause",
  95392590,
  null
), RN = new de(null, "selectCharRight", "selectCharRight", 1049825195), Yl = new T("cljs.core", "let", "cljs.core/let", -308701135, null), NN = new T(null, "remove", "remove", 1509103113, null), Rs = new de(null, "variadic?", "variadic?", 584179762), u6 = new de(null, "static-methods", "static-methods", -599124455), CN = new T(null, "isa?", "isa?", 1358492324, null), DX = new de(null, "flush-on-newline", "flush-on-newline", -151457939), MN = new de(null, "selectCharLeft", "selectCharLeft", 1894248154), IX = new T(
  null,
  "scaleFactor",
  "scaleFactor",
  -1915682314,
  null
), Dwe = new de(null, "color-bg", "color-bg", -391960697), wm = new T(null, "timestamp", "timestamp", -2074956798, null), RX = new T(null, "to-radians", "to-radians", -1564562270, null), PN = new T(null, "iterate", "iterate", 694501410, null), Iwe = new T(null, "backslash", "backslash", -863649243, null), $N = new T(null, "-add-loaded-lib", "-add-loaded-lib", 368206419, null), NX = new T(null, "maps", "maps", -71029607, null), LN = new T(null, "mapv", "mapv", -241595241, null), Pk = new T(null, "deref", "deref", 1494944732, null), BN = new T(
  null,
  "loop",
  "loop",
  1244978678,
  null
), D0 = new T(null, "date-as-string-a", "date-as-string-a", -575976346, null), I0 = new T(null, "date-as-string-b", "date-as-string-b", -678770840, null), Sb = new T("cljs.core", "assoc", "cljs.core/assoc", 322326297, null), Ix = new de(null, "public-class", "public-class", 1127293019), s6 = new T(null, "map-invert", "map-invert", 1258886340, null), nf = new de(null, "unquote", "unquote", 1649741032), Rwe = new T(null, "docstring?", "docstring?", -180217883, null), Rx = new T(null, "boolean", "boolean", -278886877, null), FN = new T(
  null,
  "bytes",
  "bytes",
  -1478569089,
  null
), VN = new T(null, "vector", "vector", -751469611, null), YN = new T(null, "long", "long", 1469079434, null), CX = new T(null, "tan", "tan", -1380825876, null), SE = new T(null, "size-or-seq", "size-or-seq", -2062823589, null), s5 = new de(null, "satisfies", "satisfies", -311664218), UN = new T(null, "butlast", "butlast", 1573039585, null), qN = new T(null, "delay?", "delay?", -1528239209, null), Zq = new T("clojure.repl", "print-doc", "clojure.repl/print-doc", -375546711, null), lh = new T(null, "tag", "tag", 350170304, null), Nwe = new de(
  null,
  "invalid-format",
  "invalid-format",
  -72676108
), MX = new T(null, "unquote", "unquote", -1004694737, null), CS = new de("sci.impl.evaluator", "not-found", "sci.impl.evaluator/not-found", 1684798426), Cwe = new de(null, "reader-error", "reader-error", 1610253121), Mwe = new T("ruler.utils.clj-time", "last-day-of-the-month", "ruler.utils.clj-time/last-day-of-the-month", 1547491760, null), Pwe = new T(null, "%&", "%&", -728707069, null), WN = new T(null, "bit-not", "bit-not", 1508529851, null), $we = new T(null, "%1", "%1", 1309450150, null), Xq = new T(
  null,
  "sym",
  "sym",
  195671222,
  null
), Lwe = new T(null, "names", "names", -302543131, null), Ep = new de(null, "default-year", "default-year", 1658037695), PX = new de(null, "cursorLineBoundaryForward", "cursorLineBoundaryForward", -1283359997), $X = new T("cljs.math", "to-radians", "cljs.math/to-radians", 1249751214, null), HN = new T(null, "int-array", "int-array", 459176616, null), Bwe = new T("ruler.utils.java-time", "banking-days-between", "ruler.utils.java-time/banking-days-between", -1299303324, null), LX = new T(
  "cljs.math",
  "asin",
  "cljs.math/asin",
  576259058,
  null
), BX = new T(null, "reset-thread-binding-frame-impl", "reset-thread-binding-frame-impl", -826674194, null), zN = new T(null, "global-hierarchy", "global-hierarchy", -2014004345, null), Nx = new de(null, "day-of-week", "day-of-week", 1639326729), KN = new T(null, "aget", "aget", 1491056546, null), Fwe = new T("sci.impl.protocols", "default", "sci.impl.protocols/default", -1134880191, null), Qq = new de(null, "symbol", "symbol", -1038572696), GN = new T(null, "not-every?", "not-every?", -729672558, null), Vwe = new T(
  "ruler.utils.clj-time",
  "timestamp",
  "ruler.utils.clj-time/timestamp",
  710560140,
  null
), ZN = new T(null, "comment", "comment", -2122229700, null), FX = new T("cljs.math", "tanh", "cljs.math/tanh", 610311737, null), VX = new T("cljs.math", "increment-exact", "cljs.math/increment-exact", -1629018159, null), Ywe = new T("js", "String", "js/String", -2070054036, null), XN = new T("cljs.core", "lazy-seq", "cljs.core/lazy-seq", 627681297, null), Uwe = new T(null, "branch?", "branch?", 641208520, null), qwe = new de(null, "parser", "parser", -1543495310), IB = new de(
  null,
  "kill",
  "kill",
  -12335575
), Wwe = new T(null, "juneteenth-day-m", "juneteenth-day-m", -407366240, null), QN = new T(null, "doseq", "doseq", 221164135, null), Hwe = new T("cljs.core", "prn", "cljs.core/prn", 1725204552, null), zwe = new de(null, "time-no-ms", "time-no-ms", 870271683), JN = new T("clojure.core", "list", "clojure.core/list", -1119203325, null), e9 = new T(null, "some->", "some->", -1011172200, null), Kwe = new de(null, "color-gray-mid", "color-gray-mid", -1232684289), Cx = new T("js", "Error", "js/Error", -1692659266, null), Gwe = new T(
  "cljs.core",
  "with-bindings*",
  "cljs.core/with-bindings*",
  -768558084,
  null
), rp = new T(null, "throw", "throw", 595905694, null), YX = new de(null, "selectAll", "selectAll", 869127842), n9 = new T(null, "seqable?", "seqable?", 72462495, null), Eb = new de(null, "quoted", "quoted", 2117344952), UX = new de(null, "selection-return", "selection-return", 267226206), Zwe = new T(null, "math", "math", -386381276, null), t9 = new T(null, "indexed?", "indexed?", 1234610384, null), qX = new T("cljs.math", "exp", "cljs.math/exp", -1175705547, null), l9 = new de(null, "when", "when", -576417306), WX = new de(
  null,
  "nav-select-left",
  "nav-select-left",
  -1033285138
), Xwe = new de("sci.impl.protocols", "IPrintWithWriter", "sci.impl.protocols/IPrintWithWriter", 1832791161), r9 = new T(null, "compare-and-set!", "compare-and-set!", -1997299382, null), Qwe = new T(null, "formatter", "formatter", 1157522704, null), Fy = new de(null, "extend-via-metadata", "extend-via-metadata", -427346794), o6 = new T(null, "union", "union", -511498270, null), i9 = new T(null, "zero?", "zero?", 325758897, null), Jwe = new T(
  null,
  "dateOptionalTimeParser",
  "dateOptionalTimeParser",
  1783230854,
  null
), HX = new T("cljs.math", "scalb", "cljs.math/scalb", -1710173743, null), u9 = new T(null, "partition-all", "partition-all", -1985005385, null), Jq = new T(null, "default__24291__auto__", "default__24291__auto__", 199885026, null), s9 = new T(null, "run!", "run!", -2055483725, null), e1e = new T("cljs.core", "-add-loaded-lib", "cljs.core/-add-loaded-lib", -38500354, null), a6 = new T(null, "not-found", "not-found", 1011451547, null), n1e = new T(null, "independence-day-m", "independence-day-m", -290686018, null), zX = new de(
  null,
  "cursorLineBoundaryBackward",
  "cursorLineBoundaryBackward",
  1373049802
), t1e = new T(null, "specs", "specs", -1227865028, null), l1e = new T(null, "retf", "retf", 73249638, null), eW = new T(null, "method-table__24245__auto__", "method-table__24245__auto__", -1108367441, null), o9 = new T(null, "rand-int", "rand-int", -495012157, null), r1e = new T(null, "localTimeParser", "localTimeParser", -1738135328, null), KX = new de(null, "selectGroupBackward", "selectGroupBackward", 1569543117), i1e = new de(null, "basic-time-no-ms", "basic-time-no-ms", -1720654076), $k = new T(
  null,
  "rest",
  "rest",
  398835108,
  null
), R0 = new T(null, "user", "user", -1122004413, null), a9 = new T(null, "set", "set", 1945134081, null), GX = new T(null, "date1-as-string", "date1-as-string", -22693366, null), u1e = new de(null, "Discard!", "Discard!", -1586397699), ZX = new de(null, "namespace", "namespace", -377510372), c9 = new T(null, "take-nth", "take-nth", 1378204353, null), s1e = new T("ruler.utils.java-time", "pred-nth-of-month", "ruler.utils.java-time/pred-nth-of-month", -1087490117, null), XX = new T(null, "hypot", "hypot", 205644933, null), h9 = new T(
  null,
  "drop-while",
  "drop-while",
  719206685,
  null
), QX = new de(null, "time-element-parser", "time-element-parser", -2042883205), nW = new T(null, "sep", "sep", -684005239, null), r1 = new T(null, "fn*", "fn*", -752876845, null), f9 = new T(null, "seq", "seq", -177272256, null), o1e = new de(null, "description", "description", -1428560544), JX = new T(null, "banking-days-between", "banking-days-between", 12647943, null), a1e = new de(null, "rfc822", "rfc822", -404628697), tW = new de(null, "visibility", "visibility", 1338380893), d9 = new T(
  null,
  "fn?",
  "fn?",
  1820990818,
  null
), Za = new de(null, "changes", "changes", 1492088), c1e = new de("fmt", "formatter", "fmt/formatter", -483947944), zf = new de(null, "dispatch", "dispatch", 1319337009), h1e = new T("ruler.utils.java-time", "date-compare-difference-as-date", "ruler.utils.java-time/date-compare-difference-as-date", -1014338381, null), f1e = new T("clojure.core", "cond", "clojure.core/cond", 1906951420, null), p9 = new T(null, "remove-method", "remove-method", 72923733, null), _w = new de(null, "weekyear", "weekyear", -74064500), eQ = new de(
  null,
  "gensyms",
  "gensyms",
  248713782
), nQ = new de(null, "require-macros", "require-macros", 707947416), lW = new de(null, "uneval", "uneval", 1932037707), d1e = new T(null, "fmt", "fmt", 1972832299, null), m9 = new T(null, "get-method", "get-method", 185754457, null), g9 = new T(null, "update-in", "update-in", -1445516941, null), p1e = new de(null, "message", "message", -406056002), eg = new de(null, "overrides", "overrides", 1738628867), m1e = new T("cljs.core", "LazySeq", "cljs.core/LazySeq", 1986389673, null), g1e = new de(
  "edamame",
  "read-cond-splicing",
  "edamame/read-cond-splicing",
  -1992728777
), tQ = new T("cljs.core", "count", "cljs.core/count", -921270233, null), rW = new de(null, "ex", "ex", -1413771341), w9 = new T(null, "keep", "keep", -492807003, null), sc = new T("cljs.core", "fn", "cljs.core/fn", -1065745098, null), w1e = new de(null, "requires", "requires", -1201390927), qs = new de(null, "fn", "fn", -1175266204), v9 = new de(null, "radius-md", "radius-md", -702734975), Lk = new T(null, "*loaded-libs*", "*loaded-libs*", 1951428860, null), lQ = new de(null, "time-parser", "time-parser", -1636511536), v1e = new T(
  "ruler.utils.clj-time",
  "date-+",
  "ruler.utils.clj-time/date-+",
  -865314235,
  null
), y1e = new T("ruler.utils.clj-time", "date--", "ruler.utils.clj-time/date--", -2132785823, null), y9 = new T(null, "create-ns", "create-ns", -782886354, null), _1e = new T("cljs.tools.reader.edn", "escape-char", "cljs.tools.reader.edn/escape-char", 17562632, null), _9 = new T(null, "sort-by", "sort-by", 1317932224, null), RB = new de(null, "date-time", "date-time", 177938180), Fc = new de(null, "end-row-key", "end-row-key", -1126662680), ju = new T(
  null,
  "transpose",
  "transpose",
  1165804847,
  null
), x9 = new T(null, "defprotocol", "defprotocol", 1388695348, null), S9 = new T(null, "frequencies", "frequencies", 1757430425, null), c6 = new T(null, "c__25766__auto__", "c__25766__auto__", -140640654, null), rQ = new T("cljs.math", "next-after", "cljs.math/next-after", -1088675035, null), x1e = new T("cljs.core", "defonce", "cljs.core/defonce", -1291833100, null), E9 = new T(null, "into-array", "into-array", -1875808354, null), NB = new de(null, "unwrap", "unwrap", -1399175462), sv = new T(
  null,
  "x__24283__auto__",
  "x__24283__auto__",
  -702486193,
  null
), S1e = new T("ruler.utils.java-time", "date-format", "ruler.utils.java-time/date-format", -1890276491, null), iW = new T(null, "start__27416__auto__", "start__27416__auto__", 404445830, null), O9 = new T(null, "thread-bound?", "thread-bound?", 2075334115, null), k9 = new T(null, "transduce", "transduce", -2083619734, null), uW = new T(null, "meta__24285__auto__", "meta__24285__auto__", 586424427, null), E1e = new de(null, "radius-sm", "radius-sm", -761383926), b9 = new T(null, "ancestors", "ancestors", 864486103, null), Bk = new T(
  null,
  "ruler.utils.string",
  "ruler.utils.string",
  585040441,
  null
), iQ = new de(null, "nav-right", "nav-right", 591041267), O1e = new T(null, "columbus-day-m", "columbus-day-m", -226196488, null), sW = new de(null, "errors", "errors", -908790718), k1e = new de(null, "date-time-no-ms", "date-time-no-ms", 1655953671), oW = new T("cljs.core", "chunk-cons", "cljs.core/chunk-cons", -250075688, null), b1e = new de(null, "volatile-mutable", "volatile-mutable", 1731728411), T9 = new T(null, "ensure-reduced", "ensure-reduced", -1606421005, null), j9 = new T(
  null,
  "re-find",
  "re-find",
  1143444147,
  null
), aw = new de(null, "max-fixed", "max-fixed", 166770124), T1e = new T(null, "next-banking-day", "next-banking-day", 477223769, null), uQ = new T("js", "Error.", "js/Error.", 750655924, null), j1e = new T(null, "oldval", "oldval", -221475803, null), A1e = new T("ruler.utils.clj-time", "independence-day-m", "ruler.utils.clj-time/independence-day-m", 1420041260, null), A9 = new T(null, "rand", "rand", -1745930995, null), D1e = new T(null, "js*", "js*", -1134233646, null), sQ = new T(null, "PI", "PI", -9477137, null), aW = new T(
  "cljs.core",
  "println",
  "cljs.core/println",
  -331834442,
  null
), Fk = new T(null, "smap", "smap", -2041991975, null), I1e = new de("sci.impl", "record", "sci.impl/record", -1939193950), D9 = new T(null, "gensym", "gensym", -1693147401, null), Uh = new de(null, "as", "as", 1148689641), I9 = new T(null, "*print-length*", "*print-length*", -687693654, null), R9 = new T(null, "js->clj", "js->clj", 1544462432, null), R1e = new T("cljs.core", "and", "cljs.core/and", -6692549, null), cW = new T(null, "iterys__25789__auto__", "iterys__25789__auto__", -1008833788, null), N1e = new T(
  "cljs.core",
  "reify*",
  "cljs.core/reify*",
  1256833160,
  null
), Ob = new de(null, "read-cond", "read-cond", 1056899244), C1e = new T("js", "Function", "js/Function", -749892063, null), oQ = new de(null, "cursorGroupBackward", "cursorGroupBackward", -1004717331), N9 = new T(null, "unchecked-char", "unchecked-char", 1662742943, null), C9 = new T(null, "unchecked-int", "unchecked-int", 1672898125, null), Vk = new T("cljs.core", "int", "cljs.core/int", 20935062, null), M9 = new T(null, "unchecked-multiply-int", "unchecked-multiply-int", -788546068, null), zn = new de(null, "column", "column", 2078222095), M1e = new de(null, "ok", "ok", 967785236), Kr = new de(null, "or", "or", 235744169), P9 = new T(null, "unchecked-inc", "unchecked-inc", -1170131490, null), aQ = new T("cljs.math", "copy-sign", "cljs.math/copy-sign", -1502169613, null), P1e = new T(null, "number-literal?", "number-literal?", 843787662, null), $9 = new T(null, "prn-str", "prn-str", -145225943, null), h6 = new T(null, "rename-keys", "rename-keys", 355340888, null), cQ = new T("cljs.math", "sin", "cljs.math/sin", 1046878353, null), ov = new T(null, "xform", "xform", -85179481, null), f6 = new T(
  null,
  "var__27420__auto__",
  "var__27420__auto__",
  -1103408323,
  null
), EE = new T(null, "init-val-or-seq", "init-val-or-seq", -1168783320, null), hQ = new de(null, "date-parser", "date-parser", -981534587), L9 = new T(null, "max-key", "max-key", -2132814732, null), fQ = new T(null, "get-thread-binding-frame-impl", "get-thread-binding-frame-impl", -701667726, null), Go = new de(null, "obj", "obj", 981763962), $1e = new de(null, "pm", "pm", 1813737428), Hd = new T(null, "form", "form", 16469056, null), L1e = new T(null, "object", "object", -1179821820, null), B9 = new T(
  null,
  "conj!",
  "conj!",
  -841007895,
  null
), d6 = new de(null, "bodies", "bodies", -1295887172), F9 = new T(null, "alias", "alias", -399220103, null), V9 = new T(null, "parents", "parents", -387007364, null), k_ = new T(null, "value", "value", 1946509744, null), Y9 = new T(null, "keyword?", "keyword?", 1917797069, null), Vy = new de(null, "form", "form", -1624062471), dQ = new T("cljs.core", "or", "cljs.core/or", 1201033885, null), B1e = new de(null, "StringContent", "StringContent", -877262859), U9 = new T(null, "disj!", "disj!", -1383872088, null), pQ = new de(
  null,
  "with-time",
  "with-time",
  -1649014808
), F1e = new de("sci.error", "realized-beyond-max", "sci.error/realized-beyond-max", -1094268187), q9 = new T(null, "*print-meta*", "*print-meta*", -919406644, null), W9 = new T(null, "counted?", "counted?", 1703071664, null), p6 = new T("cljs.core", "protocol-type-impl", "cljs.core/protocol-type-impl", 155177701, null), V1e = new T("ruler.utils.java-time", "formatters", "ruler.utils.java-time/formatters", -2084714326, null), mQ = new T(
  null,
  "cljs.core.PersistentQueue.EMPTY",
  "cljs.core.PersistentQueue.EMPTY",
  399917828,
  null
), Y1e = new T(null, "outer", "outer", 1265345571, null), U1e = new de("sci.impl.evaluator", "try-result", "sci.impl.evaluator/try-result", -1394897780), gQ = new T(null, "next-after", "next-after", 1465112353, null), H9 = new T(null, "descendants", "descendants", -829549738, null), xw = new T("cljs.core", "defmethod", "cljs.core/defmethod", -180785162, null), z9 = new T(null, "long-array", "long-array", 217579190, null), q1e = new de(null, "onChange", "onChange", -312891301), ie = new de(null, "ns", "ns", 441598760), K9 = new T(
  null,
  "associative?",
  "associative?",
  -141666771,
  null
), G9 = new T(null, "amap", "amap", 635923055, null), Z9 = new T(null, "concat", "concat", -467652465, null), MS = new de("sci.impl", "callstack", "sci.impl/callstack", -1621010557), W1e = new de(null, "contextVariables", "contextVariables", 510141453), X9 = new T(null, "as->", "as->", 1430690540, null), co = new de(null, "source", "source", -433931539), hW = new de("sci.impl.records", "object", "sci.impl.records/object", -590699738), tf = new de(null, "ns-state", "ns-state", -532270771), Yk = new T(null, "for", "for", 316745208, null), wQ = new T(null, "sin", "sin", 1721439389, null), H1e = new de(null, "radius-lg", "radius-lg", -169732923), z1e = new de(null, "Number", "Number", 2146289584), fW = new T(null, "oldform", "oldform", 1995222417, null), K1e = new T(null, "import-all-public-vars", "import-all-public-vars", -897171966, null), Q9 = new T(null, "condp", "condp", 1054325175, null), m6 = new T(null, "else", "else", 132154381, null), g6 = new de(null, "keyword", "keyword", 811389747), J9 = new T(null, "reduced?", "reduced?", 1361797384, null), e8 = new T(null, "var-get", "var-get", -767472097, null), ji = new T(null, "ruler.utils.clj-time", "ruler.utils.clj-time", 96292375, null), vQ = new T(null, "concat-key", "concat-key", -601234001, null), w6 = new T(null, "trimr", "trimr", -1739157155, null), v6 = new T(null, "triml", "triml", -286546306, null), av = new T(null, "join", "join", 881669637, null), sm = new T(null, "obj", "obj", -1672671807, null), G1e = new T("ruler.utils.java-time", "banking-day?", "ruler.utils.java-time/banking-day?", -547809253, null), yQ = new T(null, "*file*", "*file*", 624866474, null), dW = new T(
  null,
  "meth__24398__auto__",
  "meth__24398__auto__",
  -1456893161,
  null
), n8 = new T(null, "binding-conveyor-fn", "binding-conveyor-fn", 2076077877, null), _Q = new T(null, "sqrt", "sqrt", 370479598, null), t8 = new T(null, "re-seq", "re-seq", -2105554076, null), xQ = new T(null, "parse-float", "parse-float", -620694673, null), l8 = new T(null, "bit-xor", "bit-xor", -1334295033, null), Z1e = new de(null, "id", "id", -1388402092), X1e = new T(null, "localDateParser", "localDateParser", 477820077, null), Uk = new T(null, "defn", "defn", -126010802, null), SQ = new de(
  null,
  "local->mutator",
  "local->mutator",
  1004070878
), Q1e = new T("cljs.core", "aset", "cljs.core/aset", -898215545, null), J1e = new de(null, "in", "in", -1531184865), Mx = new de(null, "set", "set", 304602554), r8 = new T(null, "unchecked-add", "unchecked-add", -2030665965, null), i8 = new T(null, "memfn", "memfn", -881453486, null), eve = new de(null, "weekyear-week-day", "weekyear-week-day", -740233533), EQ = new T(null, "date-format-with-time", "date-format-with-time", 578496353, null), Bs = new de(null, "cursor", "cursor", 1011937484), u8 = new T(
  null,
  "ffirst",
  "ffirst",
  -694902e3,
  null
), s8 = new T(null, "bounded-count", "bounded-count", 1030640883, null), o8 = new T(null, "swap!", "swap!", -655677516, null), o5 = new de(null, "protocol", "protocol", 652470118), y6 = new T(null, "capitalize", "capitalize", -2143275164, null), a8 = new T(null, "bound-fn*", "bound-fn*", 102308621, null), c8 = new T(null, "prefers", "prefers", -374265406, null), nve = new T("clojure.core", "array-map", "clojure.core/array-map", -1351833961, null), pW = new T("cljs.core", "chunk", "cljs.core/chunk", 847936424, null), tve = new T(
  "ruler.utils.java-time",
  "leap-year?",
  "ruler.utils.java-time/leap-year?",
  -520865046,
  null
), h8 = new T(null, "empty", "empty", -1886564811, null), f8 = new T(null, "shorts", "shorts", 107738238, null), mW = new T(null, "options", "options", 1740170016, null), gW = new T(null, "methods__24280__auto__", "methods__24280__auto__", 1987691785, null), d8 = new T(null, "defmethod", "defmethod", -579171823, null), lve = new T(null, "-inner-impl", "-inner-impl", -1295431849, null), et = new T(null, "&", "&", -2144855648, null), qk = new de(null, "deny", "deny", 1589338523), p8 = new T(
  null,
  "repeat",
  "repeat",
  -1821743682,
  null
), wW = new T(null, "%", "%", -950237169, null), m8 = new T(null, "*", "*", 345799209, null), g8 = new de(null, "print-length", "print-length", 1931866356), vW = new T(null, "child", "child", -2030468224, null), Px = new T(null, "+", "+", -740910886, null), Kf = new T(null, ".", ".", 1975675962, null), w8 = new T(null, "-", "-", -471816912, null), $x = new T(null, "/", "/", -1371932971, null), Gr = new de(null, "keys", "keys", 1068423698), N0 = new T(null, "day-of-month", "day-of-month", 543881239, null), rve = new T(
  "ruler.utils.clj-time",
  "last-of-month?",
  "ruler.utils.clj-time/last-of-month?",
  -1989989072,
  null
), v8 = new T(null, "boolean?", "boolean?", 1790940868, null), OQ = new T("cljs.core", "chunked-seq?", "cljs.core/chunked-seq?", -712922369, null), PS = new T(null, "x__24288__auto__", "x__24288__auto__", 1746312911, null), y8 = new T(null, "remove-watch", "remove-watch", -1105301448, null), _8 = new T(null, "multi-fn-add-method-impl", "multi-fn-add-method-impl", -523930142, null), ive = new de(null, "code", "code", 1586293142), uve = new T(
  null,
  "IReset",
  "IReset",
  -1893729426,
  null
), sve = new T(null, "arr", "arr", 2115492975, null), x8 = new de(null, "selectLineDown", "selectLineDown", 1741100604), ove = new T(null, ".toFixed", ".toFixed", -895046938, null), ave = new T(null, "_", "_", -1201019570, null), S8 = new T(null, "cond->", "cond->", 561741875, null), _6 = new T(null, "source", "source", 1206599988, null), qo = new T(null, "b", "b", -1172211299, null), Vl = new T(null, "a", "a", -482876059, null), kQ = new T(null, "date-compare", "date-compare", -1825498574, null), Xs = new T(null, "d", "d", -682293345, null), cve = new T(
  "sci.impl.deftype",
  "-inner-impl",
  "sci.impl.deftype/-inner-impl",
  528349233,
  null
), ys = new T(null, "body", "body", -408674142, null), E8 = new T(null, "booleans", "booleans", 756846088, null), Ld = new T(null, "c", "c", -122660552, null), hve = new de(null, "basic-week-date-time-no-ms", "basic-week-date-time-no-ms", -2043113679), il = new T(null, "f", "f", 43394975, null), fve = new de(null, "sigs", "sigs", -1653119622), dve = new T(null, "e", "e", -1273166571, null), Bd = new T(null, "h", "h", -1544777029, null), h_ = new T(null, "g", "g", -916345864, null), x6 = new T(
  null,
  "escape",
  "escape",
  648929575,
  null
), cu = new T(null, "k", "k", -505765866, null), Tr = new T(null, "n", "n", -2092305744, null), Ao = new T(null, "m", "m", -1021758608, null), Sw = new T(null, "attr-map?", "attr-map?", 116307443, null), O8 = new T(null, "p", "p", 1791580836, null), bv = new T(null, "o", "o", 290524299, null), pve = new de(null, "basic-week-date", "basic-week-date", 1775847845), C0 = new T(null, "lazy-seq", "lazy-seq", 489632906, null), M0 = new T(null, "read", "read", -1514377108, null), CB = new T(null, "r", "r", 1169147337, null), k8 = new T(
  null,
  "doubles",
  "doubles",
  -1517872169,
  null
), mve = new T(null, "t", "t", 242699008, null), gve = new de(null, "options", "options", 99638489), Sr = new T(null, "s", "s", -948495851, null), U_ = new T(null, "__sci_this", "__sci_this", -193704996, null), b8 = new T(null, "re-pattern", "re-pattern", 1047705161, null), Md = new T(null, "v", "v", 1661996586, null), bQ = new T(null, "number-of-days-in-the-month", "number-of-days-in-the-month", -1408914063, null), wve = new T(null, "u", "u", 483896742, null), T8 = new T(null, "<=", "<=", 1244895369, null), Sn = new T(
  null,
  "x",
  "x",
  -555367584,
  null
), j8 = new T(null, "get-in", "get-in", -1965644065, null), vve = new de(null, "Boolean", "Boolean", 20610060), A8 = new T(null, "<", "<", 993667236, null), yW = new T(null, "yrel", "yrel", -1573821256, null), TQ = new T(null, "parse-int", "parse-int", -742710469, null), D8 = new T(null, ">", ">", 1085014381, null), I8 = new T(null, "=", "=", -1501502141, null), R8 = new T(null, "macroexpand", "macroexpand", 1509933344, null), N8 = new T(null, "every?", "every?", 2083724064, null), jQ = new T(null, "E", "E", 1871381369, null), C8 = new de(
  "ruler.context",
  "error",
  "ruler.context/error",
  1790437743
), AQ = new T(null, "acos", "acos", 353741763, null), vg = new de(null, "hierarchy", "hierarchy", -1053470341), S6 = new T(null, "keywordize-keys", "keywordize-keys", -1343651517, null), M8 = new de(null, "async-load-fn", "async-load-fn", -472170029), DQ = new T("cljs.core", "alength", "cljs.core/alength", -1012804190, null), P8 = new T(null, "==", "==", -234118149, null), yve = new de(null, "classes", "classes", 2037804510), $8 = new T(null, "chunk-append", "chunk-append", -1447349559, null), L8 = new T(
  null,
  "double?",
  "double?",
  -2146564276,
  null
), IQ = new de(null, "selectLineBoundaryForward", "selectLineBoundaryForward", 904508598), B8 = new T(null, "*print-level*", "*print-level*", -634488505, null), _W = new T(null, "args__24289__auto__", "args__24289__auto__", 552336249, null), _ve = new T("ruler.utils.clj-time", "thanks-giving-day-m", "ruler.utils.clj-time/thanks-giving-day-m", -264948068, null), F8 = new T(null, "areduce", "areduce", -1873477878, null), xve = new de(null, "gen-class", "gen-class", -426712454), xW = new T(
  null,
  "xs__27205__auto__",
  "xs__27205__auto__",
  353713920,
  null
), P0 = new T(null, "and", "and", 668631710, null), V8 = new T(null, ">=", ">=", 1016916022, null), kb = new T(null, "round", "round", -645002441, null), $S = new T(null, "z", "z", 851004344, null), al = new T(null, "y", "y", -117328249, null), RQ = new T(null, "rint", "rint", -1689197702, null), Sve = new de(null, "state", "state", -1988618099), Ew = new de(null, "allow", "allow", -1857325745), Eve = new T(
  "ruler.utils.java-time",
  "last-day-of-the-month",
  "ruler.utils.java-time/last-day-of-the-month",
  1350197319,
  null
), NQ = new T(null, "*data-readers*", "*data-readers*", 1269051058, null), Op = new de(null, "to", "to", 192099007), Lo = new de(null, "minutes", "minutes", 1319166394), CQ = new de(null, "deleteCharForward", "deleteCharForward", 823474956), Ove = new T(null, "separator", "separator", 11782402, null), Lx = new T("cljs.core", "unchecked-inc", "cljs.core/unchecked-inc", -501313167, null), Ow = new T(null, "read-string", "read-string", -558384455, null), E6 = new de(null, "var-args?", "var-args?", -1630678710), Y8 = new T(
  null,
  "interleave",
  "interleave",
  165488106,
  null
), U8 = new T(null, "subs", "subs", 1453849536, null), kve = new T("cljs.core", "binding", "cljs.core/binding", 2050379843, null), MB = new de("sci.impl.analyzer", "static-access", "sci.impl.analyzer/static-access", -79014e3), SW = new T(null, "m__24397__auto__", "m__24397__auto__", 514279127, null), O6 = new T(null, "substr", "substr", -2116301839, null), q8 = new T(null, "js-delete", "js-delete", 170306730, null), W8 = new T(null, "sorted?", "sorted?", 892797714, null), bve = new de(null, "line-height", "line-height", 1870784992), MQ = new T(
  null,
  "magnitude",
  "magnitude",
  -730161547,
  null
), H8 = new de(null, "raw-classes", "raw-classes", 1669916511), z8 = new T(null, "partial", "partial", 1881673272, null), PQ = new de(null, "local-date", "local-date", 1829761428), K8 = new T(null, "memoize", "memoize", 2019341169, null), Tve = new T("cljs.core", "*print-fn*", "cljs.core/*print-fn*", 1342365176, null), Wk = new T(null, "impls", "impls", 326516674, null), jve = new de(null, "orig", "orig", -1678309870), $Q = new T(null, "*out*", "*out*", 1277591796, null), LQ = new de(
  "edamame.impl.parser",
  "cond-splice",
  "edamame.impl.parser/cond-splice",
  1534599765
), BQ = new T(null, "exp", "exp", 1378825265, null), FQ = new T("cljs.math", "atan", "cljs.math/atan", 723323533, null), Ave = new de(null, "libname", "libname", 135992497), G8 = new T(null, "array?", "array?", -1249008197, null), Z8 = new T(null, "reset!", "reset!", 527275632, null), ng = new de(null, "start", "start", -355208981), EW = new de("sci.impl.deftype", "IPrintWithWriter", "sci.impl.deftype/IPrintWithWriter", -1280030107), X8 = new T(null, "sorted-set-by", "sorted-set-by", 899099765, null), Vd = new T(
  null,
  "expr",
  "expr",
  -1908713478,
  null
), Dve = new T("clojure.core", "hash-set", "clojure.core/hash-set", 1229125967, null), Hk = new T(null, "ns-resolve", "ns-resolve", 1788675756, null), Q8 = new T(null, "*flush-on-newline*", "*flush-on-newline*", -737526501, null), Bx = new de(null, "ns-aliases", "ns-aliases", 1290254821), Ive = new T("cljs.core", "doseq", "cljs.core/doseq", -169320766, null), J8 = new T(null, "keyword-identical?", "keyword-identical?", 931555714, null), VQ = new T(null, "copy-sign", "copy-sign", -1907652105, null), YQ = new de(
  null,
  "nav-select-right",
  "nav-select-right",
  -455278613
), Re = new de("sci", "built-in", "sci/built-in", 1244659599), Rve = new T("ruler.utils.java-time", "date-compare-difference-as-days", "ruler.utils.java-time/date-compare-difference-as-days", 1686485260, null), UQ = new T(null, "expm1", "expm1", -960312150, null), Nve = new T(null, "prefix-string", "prefix-string", -922371041, null), e7 = new T(null, "unchecked-subtract-int", "unchecked-subtract-int", -1899147615, null), k6 = new T(null, "prewalk-replace", "prewalk-replace", 2117002030, null), Cve = new T(
  null,
  "-create-type",
  "-create-type",
  805234013,
  null
), n7 = new T(null, "zipmap", "zipmap", -690049687, null), LS = new T(null, "default__24395__auto__", "default__24395__auto__", 34657441, null), b6 = new T(null, "upper-case", "upper-case", 1427515769, null), Mve = new T("cljs.core", "into", "cljs.core/into", 1879938733, null), t7 = new T(null, "nth", "nth", 1529209554, null), qQ = new T("cljs.math", "multiply-exact", "cljs.math/multiply-exact", 1389141070, null), T6 = new T(null, "args__24284__auto__", "args__24284__auto__", 773112931, null), Pve = new de(
  null,
  "hour-minute-second-ms",
  "hour-minute-second-ms",
  1209749775
), b1 = new T(null, "recur", "recur", 1202958259, null), $ve = new de(null, "v-namespace", "v-namespace", -1719986791), Lve = new T("ruler.utils.clj-time", "martin-luther-king-day-m", "ruler.utils.clj-time/martin-luther-king-day-m", 1476444533, null), iw = new T(null, "multifn", "multifn", -1904313150, null), WQ = new T(null, "clojure.walk", "clojure.walk", 1625897340, null), Bve = new T(null, "capacity", "capacity", 1713221261, null), $0 = new T(null, "month", "month", -319717006, null), PB = new T(
  null,
  "-reset!",
  "-reset!",
  1965723739,
  null
), Fve = new de(null, "font-size", "font-size", -1847940346), Vve = new T("cljs.core", "long", "cljs.core/long", 241154833, null), Yve = new T(null, "dispatch-val-y", "dispatch-val-y", 1016388320, null), l7 = new T(null, "inst?", "inst?", 1614698981, null), Uve = new T(null, "dispatch-val-x", "dispatch-val-x", -1545100153, null), qve = new T("ruler.utils.java-time", "timestamp", "ruler.utils.java-time/timestamp", 907272935, null), HQ = new T("cljs.math", "ceil", "cljs.math/ceil", 222779819, null), zQ = new T(
  null,
  "floor",
  "floor",
  -772394748,
  null
), Wve = new de("tools.reader", "opts", "tools.reader/opts", -2121810901), oo = new T(null, "name", "name", -810760592, null), r7 = new T(null, "ex-data", "ex-data", 1331491268, null), Hve = new de(null, "font-family", "font-family", -667419874), zk = new T(null, "print", "print", -1354873355, null), zve = new T(null, "cause", "cause", 1872432779, null), Ns = new de(null, "top-fn", "top-fn", -2056129173), OW = new T(null, "prepost-map?", "prepost-map?", 869562481, null), Kve = new T(null, "cljs.reader", "cljs.reader", 1327473948, null), kW = new de(
  "sci.impl.analyzer",
  "unresolved",
  "sci.impl.analyzer/unresolved",
  308754858
), $B = new T("cljs.core", "loop", "cljs.core/loop", -1829423021, null), i7 = new T(null, "to-array", "to-array", -585705189, null), LB = new de(null, "enter-and-indent", "enter-and-indent", -1825406873), Gve = new T("ruler.utils.clj-time", "before-nth-of-month", "ruler.utils.clj-time/before-nth-of-month", -339720602, null), u7 = new T(null, "defn-", "defn-", 1097765044, null), bW = new de(null, "padding", "padding", 1660304693), Zve = new T(
  null,
  "veterans-day-m",
  "veterans-day-m",
  2078833296,
  null
), wh = new de(null, "read-eval", "read-eval", 1788733932), Xve = new T("ruler.utils.java-time", "number-of-days-in-the-month", "ruler.utils.java-time/number-of-days-in-the-month", 2118443230, null), TW = new T(null, "args__24505__auto__", "args__24505__auto__", -888511963, null), j6 = new de("cljs.core", "halt", "cljs.core/halt", -1049036715), s7 = new T(null, "unchecked-inc-int", "unchecked-inc-int", 1402783397, null), Qve = new T("cljs.core", "deref", "cljs.core/deref", 1901963335, null), jW = new T(
  null,
  "args__24186__auto__",
  "args__24186__auto__",
  -2096897609,
  null
), o7 = new T(null, "refer-clojure", "refer-clojure", -1840651329, null), AW = new de(null, "zero", "zero", -858964576), Ai = new T(null, "more", "more", -418290273, null), a7 = new T(null, "not", "not", 1044554643, null), KQ = new T(null, "add-exact", "add-exact", -1310251414, null), c7 = new T(null, "reduce-kv", "reduce-kv", 1856296400, null), h7 = new T(null, "re-matches", "re-matches", -1865705768, null), Jve = new T(null, "println-str", "println-str", -2049216703, null), Fx = new T(null, "when", "when", 1064114221, null), GQ = new de(
  null,
  "deleteGroupForward",
  "deleteGroupForward",
  596007091
), e0e = new de(null, "min-var-args", "min-var-args", -1883389660), n0e = new de(null, "basic-ordinal-date", "basic-ordinal-date", 243220162), t0e = new T(null, "validator", "validator", -325659154, null), L0 = new T(null, "case", "case", -1510733573, null), Vx = new de("sci.error", "parse", "sci.error/parse", -264338844), l0e = new T("ruler.utils.clj-time", "formatters", "ruler.utils.clj-time/formatters", -1745666465, null), DW = new de(null, "more-marker", "more-marker", -14717935), ZQ = new de(null, "run", "run", -1821166653), r0e = new T("cljs.core", "vreset!", "cljs.core/vreset!", -1308835928, null), f7 = new T(null, "completing", "completing", 565832990, null), d7 = new T(null, "rand-nth", "rand-nth", -1227719931, null), i0e = new T("cljs.core", "defmulti", "cljs.core/defmulti", 723984225, null), Kk = new T(null, "alter-var-root", "alter-var-root", -1749458519, null), u0e = new de(null, "t-time", "t-time", -42016318), p7 = new T(null, "unchecked-double", "unchecked-double", -1593778036, null), m7 = new T(null, "distinct", "distinct", -148347594, null), s0e = new T(
  null,
  "add-months",
  "add-months",
  -1607259237,
  null
), o0e = new T(null, "ns*", "ns*", 1840949383, null), Yx = new T("cljs.core", "meta", "cljs.core/meta", -748218346, null), XQ = new T("cljs.core", "find-ns", "cljs.core/find-ns", -486459417, null), zi = new de(null, "type", "type", 1174270348), a0e = new T("cljs.core", "aclone", "cljs.core/aclone", -758078968, null), QQ = new T(null, "pred-nth-of-month", "pred-nth-of-month", -303051432, null), c0e = new T("ruler.utils.clj-time", "pred-nth-of-month", "ruler.utils.clj-time/pred-nth-of-month", 1272996014, null), g7 = new T(
  null,
  "list?",
  "list?",
  -1494629,
  null
), JQ = new T("cljs.math", "decrement-exact", "cljs.math/decrement-exact", -318594613, null), eJ = new T("sci.impl.protocols", "type->str", "sci.impl.protocols/type->str", 1214133319, null), h0e = new de(null, "none", "none", 1333468478), w7 = new T(null, "vector?", "vector?", -61367869, null), v7 = new T(null, "bound?", "bound?", 767722602, null), y7 = new T(null, "list*", "list*", 765415731, null), Xi = new T(null, "ruler.utils.java-time", "ruler.utils.java-time", 1477024937, null), hl = new de(
  "sci.impl",
  "inlined",
  "sci.impl/inlined",
  -478453593
), q_ = new T(null, "next", "next", 1522830042, null), f0e = new de("sci.impl", "type", "sci.impl/type", 1797552241), nJ = new de(null, "selectGroupForward", "selectGroupForward", 1344873433), tJ = new T("cljs.math", "rint", "cljs.math/rint", 1939865446, null), _7 = new de(null, "let", "let", -1282412701), d0e = new de(null, "flex", "flex", -1425124628), x7 = new T(null, "Delay", "Delay", -956795572, null), p0e = new T("ruler.utils.java-time", "date--", "ruler.utils.java-time/date--", -1264981492, null), S7 = new T(
  null,
  "not=",
  "not=",
  1466536204,
  null
), m0e = new T("ruler.utils.java-time", "date-+", "ruler.utils.java-time/date-+", -657325232, null), Yn = new de(null, "line", "line", 212345235), E7 = new de(null, "mutable", "mutable", 875778266), g0e = new de(null, "ctx", "ctx", -493610118), i1 = new de(null, "methods", "methods", 453930866), O7 = new de(null, "selectLineBoundaryBackward", "selectLineBoundaryBackward", -1443564123), w0e = new de(null, "Nil", "Nil", -1671759041), k7 = new T(null, "seq?", "seq?", -1951934719, null), lJ = new de(
  null,
  "selectLineEnd",
  "selectLineEnd",
  -1578526086
), BB = new T(null, "expand-constructor", "expand-constructor", -343741576, null), rJ = new T(null, "js", "js", -886355190, null), iJ = new T(null, "cosh", "cosh", -1962788142, null), a5 = new de("sci", "macro", "sci/macro", -868536151), b7 = new T(null, "unchecked-float", "unchecked-float", 1485658216, null), bb = new T(null, "case*", "case*", -1938255072, null), IW = new T(null, "data", "data", 1407862150, null), T7 = new de(null, "constructor", "constructor", -1953928811), RW = new T(null, "find-doc", "find-doc", -1096800949, null), NW = new T(
  null,
  "x__26440__auto__",
  "x__26440__auto__",
  1609106749,
  null
), uJ = new T(null, "date", "date", 177097065, null), v0e = new T(null, "ISwap", "ISwap", 484378193, null), A6 = new T(null, "last-index-of", "last-index-of", 215608200, null), j7 = new T(null, "constantly", "constantly", -271143939, null), y0e = new T(null, "km", "km", -1276648257, null), FB = new T(null, "rdr", "rdr", 190007785, null), A7 = new de(null, "custom-color-7", "custom-color-7", 146100161), D7 = new de(null, "custom-color-6", "custom-color-6", -674069480), I7 = new de(
  null,
  "custom-color-5",
  "custom-color-5",
  -1185354032
), R7 = new de(null, "custom-color-4", "custom-color-4", -214126699), N7 = new de(null, "custom-color-3", "custom-color-3", 1757724151), C7 = new de(null, "custom-color-2", "custom-color-2", 1682237928), Oc = new T(null, "ks", "ks", -754231827, null), M7 = new de(null, "custom-color-1", "custom-color-1", -634670553), _0e = new de(null, "year-month-day", "year-month-day", -415594169), Tb = new de("sci.impl", "macroexpanding", "sci.impl/macroexpanding", 2113471825), sJ = new T("cljs.math", "tan", "cljs.math/tan", 1971286288, null), oJ = new de(
  "sci.impl",
  "inner-fn",
  "sci.impl/inner-fn",
  1663302998
), D6 = new T(null, "a__27235__auto__", "a__27235__auto__", -142144394, null), P7 = new T(null, "flush", "flush", 501820328, null), $7 = new T(null, "nthrest", "nthrest", 1219890118, null), c5 = new de(null, "readably", "readably", 1129599760), L7 = new T(null, "true?", "true?", -1600332395, null), B7 = new T(null, "var-set", "var-set", -1361408121, null), x0e = new de(null, "period", "period", -352129191), CW = new T(null, "iter__25801__auto__", "iter__25801__auto__", -1733706818, null), MW = new T(
  null,
  "m__24281__auto__",
  "m__24281__auto__",
  -168265589,
  null
), aJ = new de(null, "only", "only", 1907811652), F7 = new T(null, "rem", "rem", 664046770, null), V7 = new T(null, "ns-map", "ns-map", -434605548, null), S0e = new de(null, "date-hour-minute-second", "date-hour-minute-second", -1565419364), cJ = new T("cljs.core", "pop-thread-bindings", "cljs.core/pop-thread-bindings", -1994943347, null), hJ = new T("cljs.core", "chunk-rest", "cljs.core/chunk-rest", -398161143, null), Qt = new de(null, "added", "added", 2057651688), hr = new de(null, "date", "date", -1463434462), E0e = new T("ruler.utils.java-time", "previous-banking-day", "ruler.utils.java-time/previous-banking-day", -1759215355, null), O0e = new T(null, "rev", "rev", 1653234197, null), k0e = new de(null, "try", "try", 1380742522), fJ = new T(null, "ret", "ret", 1172308713, null), b0e = new T(null, "limit", "limit", 284709164, null), T0e = new T(null, "clojure.lang.IChunk", "clojure.lang.IChunk", 195957271, null), Y7 = new T(null, "make-array", "make-array", -1135103906, null), U7 = new de(null, "custom-color-9", "custom-color-9", 607859848), q7 = new de(
  null,
  "custom-color-8",
  "custom-color-8",
  -2132473116
), j0e = new T("cljs.core", "*print-newline*", "cljs.core/*print-newline*", 6231625, null), W7 = new T(null, "select-keys", "select-keys", -708556589, null), H7 = new T(null, "instance?", "instance?", 1075939923, null), A0e = new de(null, "hour-minute", "hour-minute", -1164421312), z7 = new T(null, "double", "double", -1769548886, null), dJ = new T(null, "date-format", "date-format", 1083334806, null), D0e = new T("sci.impl.namespaces", "with-open", "sci.impl.namespaces/with-open", -1695932508, null), K7 = new T(
  null,
  "update",
  "update",
  -1608859373,
  null
), Ux = new de(null, "HOURS", "HOURS", -1611068963), I6 = new T(null, "sets", "sets", 2041487109, null), pJ = new T("ruler.utils.math", "parse-float", "ruler.utils.math/parse-float", 1019561218, null), mJ = new de(null, "as-alias", "as-alias", 82482467), PW = new T(null, "cached-hierarchy__24248__auto__", "cached-hierarchy__24248__auto__", 1980472359, null), G7 = new T(null, "when-not", "when-not", -1223136340, null), BS = new T(null, "p3", "p3", -923395030, null), R6 = new T(null, "lower-case", "lower-case", 1428172944, null), ih = new T(null, "ns", "ns", 2082130287, null), Yy = new de(null, "stack", "stack", -793405930), I0e = new de(null, "pending", "pending", -220036727), cv = new T(null, "p1", "p1", 703771573, null), hv = new T(null, "p2", "p2", -1748935128, null), Z7 = new T(null, "inc", "inc", 324505433, null), gJ = new T(null, "fields", "fields", -291534703, null), X7 = new T(null, "random-uuid", "random-uuid", -1574409597, null), wJ = new T("ruler.utils.math", "parse-int", "ruler.utils.math/parse-int", 1316902174, null), Q7 = new T(
  null,
  "macroexpand-all",
  "macroexpand-all",
  966103926,
  null
), J7 = new T(null, "sequential?", "sequential?", 1102351463, null), yv = new de(null, "strable", "strable", 1877668047), eC = new T(null, "force", "force", -1872478483, null), R0e = new T("ruler.utils.java-time", "before-nth-of-month", "ruler.utils.java-time/before-nth-of-month", -418779277, null), tu = new de(null, "col", "col", -1959363084), nC = new T(null, "int", "int", -100885395, null), $i = new de(null, "days", "days", -1394072564), tC = new T(null, "nthnext", "nthnext", 1677356670, null), N0e = new T(
  null,
  "timeParser",
  "timeParser",
  1585048034,
  null
), B0 = new T(null, "or", "or", 1876275696, null), VB = new de(null, "vararg-idx", "vararg-idx", -590991228), C0e = new T(null, "dateParser", "dateParser", -1248418930, null), lC = new T(null, "assoc!", "assoc!", -847603280, null), N6 = new T(null, "blank?", "blank?", 1891979743, null), rC = new T(null, "*print-dup*", "*print-dup*", 103854877, null), M0e = new de(null, "illegal-pattern", "illegal-pattern", -1810990520), OE = new de(null, "offset", "offset", 296498311), vJ = new T("cljs.math", "acos", "cljs.math/acos", -840384561, null), P0e = new de(
  null,
  "Keyword",
  "Keyword",
  1804369776
), iC = new T(null, "extend-type", "extend-type", 1123355921, null), $0e = new de(null, "week-date-time", "week-date-time", 540228836), uC = new T(null, "set?", "set?", 1636014792, null), $W = new T(null, "set1", "set1", -1952562536, null), LW = new T(null, "set2", "set2", 1231516531, null), sC = new T(null, "hash-unordered-coll", "hash-unordered-coll", -240471618, null), yJ = new T("js", "Object", "js/Object", 61215323, null), L0e = new de(null, "border-color", "border-color", -2059162761), BW = new T(null, "ps", "ps", 1932889573, null), Jt = new T(null, "cljs.math", "cljs.math", -1774648847, null), Gk = new T(null, "pr", "pr", 1056937027, null), jb = new T(null, "set!", "set!", 250714521, null), oC = new T(null, "reductions", "reductions", 549963952, null), rw = new T(null, "size", "size", -1555742762, null), _J = new T(null, "multiply-exact", "multiply-exact", 2055835722, null), aC = new T(null, "rsubseq", "rsubseq", -710070471, null), cC = new T(null, "chunk-next", "chunk-next", -547810434, null), xJ = new T(null, "*read-eval*", "*read-eval*", 1122065414, null), hC = new T(
  null,
  "subseq",
  "subseq",
  -1558995241,
  null
), Id = new T(null, "s1", "s1", 338671490, null), fC = new T(null, "double-array", "double-array", 257035726, null), fv = new T(null, "s2", "s2", 614604262, null), C6 = new T(null, "select", "select", -1506602266, null), B0e = new T(null, "root", "root", 1191874074, null), dC = new T(null, "vswap!", "vswap!", -574070781, null), Gs = new T(null, "args", "args", -1338879193, null), W_ = new T(null, "re", "re", 1869207729, null), F0e = new T(null, "rf", "rf", -651557526, null), pC = new T(null, "every-pred", "every-pred", -1346958247, null), mC = new T(
  null,
  "pr-str",
  "pr-str",
  -2066912145,
  null
), gC = new T(null, "requiring-resolve", "requiring-resolve", -1888505231, null), V0e = new de(null, "border-radius", "border-radius", 419594011), wC = new T(null, "ns-imports", "ns-imports", 1111168888, null), SJ = new de(null, "error", "error", -978969032), Y0e = new T(null, "-create-record-type", "-create-record-type", -1472918739, null), U0e = new de(null, "white-space", "white-space", -707351930), q0e = new T(null, "sb", "sb", -1249746442, null), FS = new T(null, "sc", "sc", -1506412737, null), FW = new T(
  null,
  "method-cache__24247__auto__",
  "method-cache__24247__auto__",
  -447644431,
  null
), W0e = new de(null, "PM", "PM", 1356677707), YB = new de(null, "slurp-backward", "slurp-backward", -1615745159), vC = new T(null, "with-local-vars", "with-local-vars", 837642072, null), EJ = new T(null, "increment-exact", "increment-exact", -450618403, null), OJ = new T("cljs.math", "atan2", "cljs.math/atan2", -1641453312, null), VW = new de(null, "month", "month", -1960248533), kJ = new T("cljs.math", "random", "cljs.math/random", 952906898, null), yC = new T(
  null,
  "unchecked-dec",
  "unchecked-dec",
  2095823150,
  null
), _C = new T(null, "partition", "partition", -1479695018, null), H0e = new de(null, "args", "args", 1315556576), z0e = new T(null, "cljs.core.ISwap", "cljs.core.ISwap", 2045511362, null), xC = new T(null, "list", "list", -1889078086, null), SC = new T(null, "hash-combine", "hash-combine", 1136881997, null), M6 = new T(null, "ends-with?", "ends-with?", -346570208, null), VS = new T(null, "arg1", "arg1", -1702536411, null), b_ = new de(null, "selection", "selection", 975998651), kp = new de(null, "postprocess", "postprocess", -1863762881), P6 = new T(
  null,
  "arg2",
  "arg2",
  -924884852,
  null
), YW = new T(null, "arg3", "arg3", 153709031, null), Zk = new T(null, "eval", "eval", 536963622, null), EC = new T(null, "nat-int?", "nat-int?", -1879663400, null), K0e = new T("cljs.core", "seq-to-map-for-destructuring", "cljs.core/seq-to-map-for-destructuring", 240595294, null), $6 = new T(null, "to", "to", 1832630534, null), L6 = new T(null, "temp__27182__auto__", "temp__27182__auto__", -617693957, null), B6 = new T(null, "superset?", "superset?", 2074872204, null), dv = new T(
  null,
  "method__24286__auto__",
  "method__24286__auto__",
  -178068828,
  null
), G0e = new T("cljs.tools.reader.edn", "read-symbolic-value", "cljs.tools.reader.edn/read-symbolic-value", 111468855, null), lf = new T(null, "new", "new", -444906321, null), ks = new T(null, "clojure.core", "clojure.core", -189332625, null), Z0e = new T("cljs.core", "with-meta", "cljs.core/with-meta", 749126446, null), OC = new T(null, "second", "second", 1195829517, null), kC = new de(null, "selectDocEnd", "selectDocEnd", 496449813), UW = new T(null, "keyword-fn", "keyword-fn", 1575964852, null), bC = new T(
  null,
  "partition-by",
  "partition-by",
  -1329938249,
  null
), UB = new de(null, "list", "list", 765357683), X0e = new de(null, "NS", "NS", -764805694), qx = new T("cljs.core", "seq", "cljs.core/seq", -1649497689, null), bJ = new de(null, "selection-grow", "selection-grow", 1627169352), Q0e = new de(null, "end-row", "end-row", -545103581), TC = new T(null, "sorted-map", "sorted-map", -521216771, null), J0e = new T(null, "idxv", "idxv", -1163260636, null), jC = new T(null, "peek", "peek", 1349135202, null), AC = new T(null, "refer", "refer", 676235974, null), eye = new de(
  "rule-editor-component",
  "is_component_loaded",
  "rule-editor-component/is_component_loaded",
  1068268137
), qB = new T("cljs.core", "update", "cljs.core/update", -908565906, null), F6 = new de(null, "event", "event", 301435442), TJ = new T(null, "vol", "vol", 1137570949, null), jJ = new T(null, "before-nth-of-month", "before-nth-of-month", -1245141740, null), Wx = new T("cljs.core", "not=", "cljs.core/not=", 1017572457, null), DC = new T(null, "unchecked-multiply", "unchecked-multiply", -1019161490, null), nye = new T(null, "idxs", "idxs", -2145941206, null), tye = new de(
  null,
  "ordinal-date-time",
  "ordinal-date-time",
  -1386753458
), AJ = new T(null, "goog.string.StringBuffer", "goog.string.StringBuffer", -1220229842, null), IC = new T(null, "destructure", "destructure", 1731452410, null), DJ = new T(null, "IEEE-remainder", "IEEE-remainder", 1016551770, null), WB = new de(null, "slurp-forward", "slurp-forward", -866284566), RC = new T(null, "simple-keyword?", "simple-keyword?", -367134735, null), IJ = new de(null, "value", "value", 305978217), RJ = new T(null, "clojure.string", "clojure.string", -1415552165, null), NJ = new T(
  "cljs.math",
  "add-exact",
  "cljs.math/add-exact",
  1772761702,
  null
), f_ = new T(null, "end", "end", 1372345569, null), NC = new T(null, "extend", "extend", -817951763, null), CJ = new T("cljs.math", "floor-div", "cljs.math/floor-div", 1925275106, null), MJ = new T("cljs.core", "constantly", "cljs.core/constantly", 119002258, null), CC = new de(null, "selectDocStart", "selectDocStart", -217268371), qW = new T(null, "quoted-sym", "quoted-sym", 474507191, null), lye = new de(null, "date-hour", "date-hour", -344234471), PJ = new T(
  "cljs.core",
  "concat",
  "cljs.core/concat",
  -1133584918,
  null
), MC = new T(null, "delay", "delay", 1066306308, null), PC = new T(null, "halt-when", "halt-when", -140999689, null), $J = new de("sci.impl.analyzer", "method-name", "sci.impl.analyzer/method-name", -842600667), rye = new T("cljs.core", "bound-fn*", "cljs.core/bound-fn*", -556238942, null), $C = new T(null, "macroexpand-1", "macroexpand-1", 659241329, null), LC = new T(null, "merge-with", "merge-with", 1025434534, null), LJ = new T("cljs.math", "hypot", "cljs.math/hypot", -199432063, null), uh = new T(null, "with-time", "with-time", -8483281, null), WW = new T(null, "eof", "eof", 1151468290, null), iye = new T(null, "new-value", "new-value", -1567397401, null), BC = new T(null, "simple-ident?", "simple-ident?", 194189851, null), FC = new T(null, "chunk-rest", "chunk-rest", -1853526420, null), HW = new T(null, "xs", "xs", -2004992428, null), VC = new T(null, "byte", "byte", -1970660549, null), YC = new T(null, "complement", "complement", -913606051, null), V6 = new T(null, "and__27391__auto__", "and__27391__auto__", 642555568, null), Xk = new T(null, "hash", "hash", 1626749931, null), uye = new T(
  null,
  "rsym",
  "rsym",
  204230332,
  null
), sye = new T("ruler.utils.clj-time", "veterans-day-m", "ruler.utils.clj-time/veterans-day-m", -1578639842, null), oye = new T(null, "idx2", "idx2", 195459820, null), UC = new T(null, "keyword", "keyword", -1843046022, null), aye = new T(null, "ys", "ys", 1606115702, null), qC = new T(null, "identical?", "identical?", -745864205, null), WC = new T(null, "array-map", "array-map", 1555038968, null), zW = new T(null, "m__24393__auto__", "m__24393__auto__", -37969653, null), HC = new T(null, "with-meta", "with-meta", 73674707, null), KW = new de(null, "month-name", "month-name", -605509534), zC = new T(null, "trampoline", "trampoline", -71368916, null), cye = new T(null, "thanks-giving-day-m", "thanks-giving-day-m", 369922826, null), KC = new T(null, "bound-fn", "bound-fn", 125411266, null), hye = new T(null, "function", "function", -486723946, null), GW = new de("edamame.impl.parser", "fn-literal", "edamame.impl.parser/fn-literal", -1835933155), GC = new T(null, "min", "min", 2085523049, null), ZC = new T(
  null,
  "unsigned-bit-shift-right",
  "unsigned-bit-shift-right",
  -1953076601,
  null
), XC = new T(null, "min-key", "min-key", 246826648, null), Y6 = new T(null, "postwalk-replace", "postwalk-replace", 77744733, null), Ab = new de("sci.impl", "print-method", "sci.impl/print-method", 281191566), QC = new T(null, "find-ns", "find-ns", -884829568, null), u1 = new de(null, "features", "features", -1146962336), BJ = new T("ruler.utils.math", "round", "ruler.utils.math/round", 2009837834, null), fye = new T("cljs.core", "with-redefs-fn", "cljs.core/with-redefs-fn", -1271194088, null), dye = new T(null, "sigs", "sigs", -12588095, null), FJ = new T(null, "&form", "&form", 1482799337, null), JC = new T(null, "not-empty", "not-empty", 2029453590, null), eM = new de(null, "matching-bracket", "matching-bracket", 1956822778), VJ = new de(null, "x-int?", "x-int?", 792269440), Uy = new de(null, "transpose", "transpose", -474726680), pye = new T(null, "decls", "decls", -1311111277, null), YJ = new T(null, "sign", "sign", -1392714102, null), ZW = new T("cljs.core", "assert", "cljs.core/assert", 1075777968, null), mye = new T(null, "sci.lang.Type", "sci.lang.Type", -534180168, null), nM = new T(
  null,
  "find-var",
  "find-var",
  -497901917,
  null
), tM = new T(null, "with-out-str", "with-out-str", -140201577, null), lM = new T(null, "with-open", "with-open", 172119667, null), Bo = new de(null, "seconds", "seconds", -445266194), gye = new T("cljs.tools.reader.impl.commons", "number-literal?", "cljs.tools.reader.impl.commons/number-literal?", -1450304800, null), rM = new T(null, "disj", "disj", -1076545178, null), XW = new de("rule-editor-component-test", "is_component_loaded", "rule-editor-component-test/is_component_loaded", 647608844), Rc = new de(
  null,
  "iden->invoke-idx",
  "iden->invoke-idx",
  -1797627026
), wye = new T("ruler.utils.java-time", "today", "ruler.utils.java-time/today", 1214347191, null), UJ = new T(null, "after-nth-of-month", "after-nth-of-month", 637955361, null), iM = new T(null, "distinct?", "distinct?", -1684357959, null), qJ = new T("cljs.math", "cos", "cljs.math/cos", 1361875639, null), F0 = new de("sci.impl", "fast-path", "sci.impl/fast-path", 1273254676), QW = new T(null, "l__27236__auto__", "l__27236__auto__", 1170315564, null), uM = new T(
  null,
  "unchecked-long",
  "unchecked-long",
  1306610949,
  null
), HB = new T("cljs.core", "first", "cljs.core/first", -752535972, null), vye = new de(null, "color-gray-dark", "color-gray-dark", -710916410), WJ = new T("cljs.core", "nth", "cljs.core/nth", 1961052085, null), qy = new T(null, "vals", "vals", -1886377036, null), zB = new de(null, "rename", "rename", 1508157613), sM = new T(null, "intern", "intern", 1664352151, null), yye = new T(null, "-mutate", "-mutate", -795549165, null), _ye = new T("cljs.core", "unchecked-inc-int", "cljs.core/unchecked-inc-int", -2007014592, null), xye = new de(
  null,
  "full",
  "full",
  436801220
), oM = new T(null, "qualified-ident?", "qualified-ident?", -928894763, null), HJ = new de(null, "ex-idx", "ex-idx", 795118805), U6 = new T(null, "project", "project", -1530041190, null), Ft = new de(null, "tag", "tag", -1290361223), KB = new de(null, "label", "label", 1718410804), lm = new T(null, "meth__24394__auto__", "meth__24394__auto__", -1428156985, null), zJ = new de(null, "local-date-opt-time", "local-date-opt-time", 1178432599), Sye = new T(
  "ruler.utils.java-time",
  "day-of-week",
  "ruler.utils.java-time/day-of-week",
  1958732021,
  null
), Eye = new T("cljs.core", "chunk-buffer", "cljs.core/chunk-buffer", 14093626, null), Oye = new T("ruler.utils.clj-time", "date-format", "ruler.utils.clj-time/date-format", -91569144, null), aM = new T(null, "loaded-libs", "loaded-libs", 484141875, null), Zo = new de(null, "years", "years", -1298579689), cM = new T(null, "with-redefs-fn", "with-redefs-fn", -595725379, null), hM = new T(null, "dedupe", "dedupe", -461856254, null), q6 = new de(null, "day-name", "day-name", 1806125744), rf = new de(null, "regex", "regex", 939488856), fM = new T(
  null,
  "record?",
  "record?",
  -1305224237,
  null
), tg = new de(null, "var-arg-name", "var-arg-name", -1100024887), kye = new T("sci.impl.records", "-create-record-type", "sci.impl.records/-create-record-type", 558578550, null), Hx = new T(null, "loop*", "loop*", 615029416, null), dM = new T(null, "defmulti", "defmulti", 1936112154, null), bye = new de(null, "verbose", "verbose", 1694226060), Tye = new T(null, "day-of-week", "day-of-week", -1015109040, null), jye = new de(null, "week-date-time-no-ms", "week-date-time-no-ms", -1226853060), pv = new T(
  null,
  "then",
  "then",
  2101129597,
  null
), Wy = new de(null, "parse-error", "parse-error", 255902478), Aye = new T("ruler.utils.clj-time", "memorial-day-m", "ruler.utils.clj-time/memorial-day-m", -1829929489, null), Dye = new de(null, "date-hour-minute-second-ms", "date-hour-minute-second-ms", -425334775), Iye = new T("ruler.utils.java-time", "format-date", "ruler.utils.java-time/format-date", -1398134660, null), pM = new T(null, "cycle", "cycle", -1944070485, null), Rye = new T(null, "inner", "inner", 257360312, null), Nye = new T(
  "ruler.utils.clj-time",
  "date-compare-difference-as-date",
  "ruler.utils.clj-time/date-compare-difference-as-date",
  -733952602,
  null
), Cye = new de("sci", "type", "sci/type", 1175422389), Mye = new de(null, "insertNewlineAndIndent", "insertNewlineAndIndent", -542382007), Pye = new T(null, "dateTimeParser", "dateTimeParser", -1493718282, null), KJ = new T(null, "*assert*", "*assert*", 1479636474, null), mM = new T(null, "some->>", "some->>", -1499987794, null), Ll = new de("sci.impl.analyzer", "recur", "sci.impl.analyzer/recur", 2033369355), kf = new T(
  "cljs.core",
  "apply",
  "cljs.core/apply",
  1757277831,
  null
), JW = new T(null, "quoted", "quoted", -537090817, null), ma = new de(null, "color", "color", 1011675173), gM = new T(null, "var?", "var?", 230455531, null), $ye = new T("ruler.utils.java-time", "first-of-month?", "ruler.utils.java-time/first-of-month?", -123300614, null), wM = new T(null, "if-not", "if-not", -265415609, null), Lye = new T(null, "printf", "printf", -364440054, null), Vc = new de(null, "aliases", "aliases", 1346874714), kw = new T(null, "keys", "keys", -1586012071, null), eH = new de(
  "cljs.core",
  "not-found",
  "cljs.core/not-found",
  -1572889185
), vM = new T(null, "pos-int?", "pos-int?", -1205815015, null), Bye = new T("cljs.core", "resolve", "cljs.core/resolve", 1796776582, null), Rd = new T(null, "c1", "c1", -1521904966, null), yM = new T(null, "simple-symbol?", "simple-symbol?", 1408454822, null), GJ = new T(null, "cbrt", "cbrt", -235140820, null), Vi = new de(null, "fixed-arity", "fixed-arity", 1586445869), rm = new T(null, "c2", "c2", 78651156, null), YS = new T(null, "c3", "c3", 468715789, null), ZJ = new T(null, "negate-exact", "negate-exact", 1226323577, null), GB = new T(
  "cljs.core",
  "when-not",
  "cljs.core/when-not",
  -556141047,
  null
), Fye = new de(null, "declared", "declared", 92336021), _M = new T(null, "-write", "-write", 1999625154, null), Cs = new de(null, "method-params", "method-params", -980792179), Vye = new T(null, "christmas-day-m", "christmas-day-m", 1128906488, null), ZB = new de(null, "vector", "vector", 1902966158), W6 = new T(null, "size__25800__auto__", "size__25800__auto__", 1537530619, null), xM = new T(null, "tagged-literal?", "tagged-literal?", 1117865390, null), Yye = new de(null, "mysql", "mysql", -1431590210), Ws = new de(null, "bindings", "bindings", 1271397192), H6 = new T(null, "meth__24404__auto__", "meth__24404__auto__", 750192448, null), uf = new de(null, "weeks", "weeks", 1844596125), SM = new T(null, "vreset!", "vreset!", 1237177091, null), nH = new T(null, "v__27419__auto__", "v__27419__auto__", 562242581, null), Uye = new T("ruler.utils.clj-time", "nth-of-month", "ruler.utils.clj-time/nth-of-month", -964523624, null), XJ = new T("cljs.math", "round", "cljs.math/round", -1312590029, null), EM = new T(null, "realized?", "realized?", 207229341, null), OM = new T(null, "symbol", "symbol", 601958831, null), qye = new T(null, "cf", "cf", -1173699459, null), kM = new T(null, "clj->js", "clj->js", -1880244676, null), z6 = new T(null, "trim-newline", "trim-newline", 656815794, null), bM = new T(null, "fnext", "fnext", 1424835295, null), TM = new T(null, "rseq", "rseq", -1719353554, null), Wye = new de(null, "time", "time", 1385887882), K6 = new T(null, "temp__27191__auto__", "temp__27191__auto__", -125819714, null), A2 = new T(null, "finally", "finally", -1065347064, null), Hye = new T(
  null,
  "parse-symbol",
  "parse-symbol",
  1608073451,
  null
), tH = new T(null, "msg", "msg", 254428083, null), QJ = new T(null, "sinh", "sinh", -990423302, null), jM = new T(null, "vec", "vec", 982683596, null), G6 = new T(null, "prewalk", "prewalk", 1337993264, null), lH = new de("edamame.core", "eof", "edamame.core/eof", 1855384188), Ma = new de(null, "dynamic", "dynamic", 704819571), AM = new T(null, "hash-set", "hash-set", -1145168432, null), rH = new T(null, "p__27262__auto__", "p__27262__auto__", 1831887207, null), mi = new T(null, "do", "do", 1686842252, null), zye = new T(
  null,
  "f1",
  "f1",
  -939903380,
  null
), Kye = new T(null, "f2", "f2", 2036700123, null), Gye = new T(null, "f3", "f3", -699606726, null), DM = new T(null, "if-some", "if-some", 1960677609, null), IM = new T(null, "take-while", "take-while", 2007268328, null), JJ = new T("cljs.math", "sqrt", "cljs.math/sqrt", 1876434402, null), Zye = new de(null, "self-ref?", "self-ref?", 412808630), RM = new T(null, "push-thread-bindings", "push-thread-bindings", 1054019843, null), eee = new T(null, "today", "today", -1709164206, null), NM = new T(null, "persistent!", "persistent!", 1286555698, null), XB = new de(
  null,
  "invoc-size",
  "invoc-size",
  2053298058
), Xye = new T(null, "seed", "seed", 1709144854, null), Qye = new T(null, "memorial-day-m", "memorial-day-m", 2094456413, null), Jye = new T("clojure.core", "seq", "clojure.core/seq", -1551838743, null), nee = new T(null, "clojure.edn", "clojure.edn", -302325352, null), CM = new T(null, "the-ns", "the-ns", 1016317907, null), Fr = new T(null, "quote", "quote", 1377916282, null), e2e = new de(null, "preserve", "preserve", 1276846509), MM = new T(null, "qualified-keyword?", "qualified-keyword?", 375456001, null), PM = new T(
  null,
  "char?",
  "char?",
  -1072221244,
  null
), tee = new T(null, "*in*", "*in*", 1130010229, null), _v = new T(null, "idx", "idx", -1600747296, null), Z6 = new T(null, "intersection", "intersection", -650544759, null), zx = new T(null, "ex", "ex", 226760186, null), n2e = new T("cljs.core", "*ns*", "cljs.core/*ns*", 1155497085, null), t2e = new T("ruler.utils.clj-time", "date-compare-difference-as-days", "ruler.utils.clj-time/date-compare-difference-as-days", 1397511799, null), $M = new T(null, "derive", "derive", 1727397303, null), l2e = new de(
  null,
  "cljs",
  "cljs",
  1492417629
), lee = new T(null, "clojure.template", "clojure.template", -1162325089, null), LM = new T(null, "cond->>", "cond->>", 348844960, null), ree = new T("cljs.math", "pow", "cljs.math/pow", -210509964, null), BM = new T(null, "bit-flip", "bit-flip", 809639606, null), r2e = new de(null, "undoSelection", "undoSelection", 628691449), i2e = new T("ruler.utils.clj-time", "date-compare", "ruler.utils.clj-time/date-compare", 2097774272, null), sf = new de(null, "deref", "deref", -145586795), iH = new T(null, "fs", "fs", -482394717, null), Kx = new T(null, "fn", "fn", 465265323, null), cw = new T(null, "type", "type", -1480165421, null), FM = new T(null, "dotimes", "dotimes", -818708397, null), X6 = new T(null, "subset?", "subset?", 1551079215, null), VM = new T(null, "map-indexed", "map-indexed", -1391025435, null), u2e = new T("clojure.core", "deftype", "clojure.core/deftype", -1728257017, null), YM = new T(null, "conj", "conj", -1127293942, null), Yd = new de(null, "char", "char", -641587586), s2e = new T("cljs.core", "chunk-append", "cljs.core/chunk-append", -243671470, null), UM = new T(
  null,
  "newline",
  "newline",
  -864364446,
  null
), qM = new T(null, "cons", "cons", 755448454, null), WM = new T(null, "neg-int?", "neg-int?", -1610409390, null), HM = new T(null, "underive", "underive", -242982950, null), iee = new de(null, "cursorLineDown", "cursorLineDown", 180576864), o2e = new T("clojure.repl", "dir-fn", "clojure.repl/dir-fn", 901908317, null), a2e = new T("ruler.utils.clj-time", "juneteenth-day-m", "ruler.utils.clj-time/juneteenth-day-m", -1119766994, null), c2e = new T("cljs.core", "ns-name", "cljs.core/ns-name", 171430027, null), zM = new T(
  null,
  "cond",
  "cond",
  1606708055,
  null
), h2e = new T(null, "leap-year?", "leap-year?", -1296579449, null), KM = new T(null, "mod", "mod", 1510044207, null), uH = new T(null, "keyfn", "keyfn", -1874375437, null), sH = new de(null, "proxy-fn", "proxy-fn", 1116677438), Di = new de(null, "key", "key", -1516042587), GM = new T(null, "chars", "chars", 545901210, null), Gx = new T(null, "comp", "comp", -1462482139, null), oH = new T("cljs.core", "system-time", "cljs.core/system-time", 1562011930, null), f2e = new T("clojure.core", "deref", "clojure.core/deref", 188719157, null), d2e = new de(null, "alt-impl", "alt-impl", 670969595), ZM = new T(null, "inst-ms", "inst-ms", -653961375, null), rh = new T(null, "val", "val", 1769233139, null), p2e = new T("cljs.core", "not", "cljs.core/not", 100665144, null), $u = new T(null, "var", "var", 870848730, null), XM = new T(null, "dispatch-val", "dispatch-val", 69061e3, null), uee = new T(null, "seq-exprs", "seq-exprs", -637209651, null), m2e = new T(null, "escape-char", "escape-char", -2072670949, null), si = new T(null, "if", "if", 1181717262, null), Bt = new T(null, "coll", "coll", -1006698606, null), g2e = new T(null, "&env", "&env", -919163083, null), w2e = new T(null, "timeElementParser", "timeElementParser", 302132553, null), QM = new T(null, "drop", "drop", 2005013138, null), Q6 = new T(null, "stringify-keys", "stringify-keys", 1735215919, null), v2e = new de(null, "basic-ordinal-date-time", "basic-ordinal-date-time", 1054564521), y2e = new de(null, "basic-week-date-time", "basic-week-date-time", -502077622), see = new T(null, "serialize", "serialize", 1571314953, null), aH = new T(
  null,
  "default__24282__auto__",
  "default__24282__auto__",
  860590142,
  null
), _2e = new T(null, "read-symbolic-value", "read-symbolic-value", -100790078, null), oee = new T("cljs.math", "PI", "cljs.math/PI", 128741355, null), JM = new de("sci.impl", "op", "sci.impl/op", 950953978), x2e = new de(null, "goog.date.UtcDateTime", "goog.date.UtcDateTime", 731790075), S2e = new T("ruler.utils.java-time", "date", "ruler.utils.java-time/date", -1186425140, null), eP = new T(null, "keep-indexed", "keep-indexed", -2020916352, null), cH = new T(null, "source-fn", "source-fn", -1114937984, null), aee = new T(
  null,
  "nth-of-month",
  "nth-of-month",
  -1594201366,
  null
), nP = new T(null, "any?", "any?", -318999933, null), H_ = new de(null, "string", "string", -1989541586), tP = new T(null, "assert", "assert", 677428501, null), J6 = new T(null, "or__27384__auto__", "or__27384__auto__", 1402227327, null), Zx = new T("cljs.core", "defn", "cljs.core/defn", -1606493717, null), cee = new T(null, "uuid", "uuid", -504564192, null), po = new de(null, "imports", "imports", -1249933394), QB = new T(null, "cljs.tools.reader.edn", "cljs.tools.reader.edn", -1275821532, null), hee = new T(
  null,
  "direction",
  "direction",
  1007172132,
  null
), E2e = new de(null, "dup", "dup", 556298533), JB = new de("cljs.analyzer", "no-resolve", "cljs.analyzer/no-resolve", -1872351017), lP = new T(null, "js-obj", "js-obj", 342383250, null), rP = new T(null, "unchecked-negate", "unchecked-negate", -1669067451, null), Qk = new T(null, "ex-message", "ex-message", -1128293394, null), mv = new T(null, "colls", "colls", -397642425, null), O2e = new de(null, "status", "status", -1997798413), k2e = new T("cljs.core", "ex-info", "cljs.core/ex-info", -409744395, null), b2e = new T(
  "js",
  "Array",
  "js/Array",
  -423508366,
  null
), iP = new T(null, "map-entry?", "map-entry?", 1140615277, null), US = new T(null, "iref", "iref", -647796531, null), uP = new T(null, "demunge", "demunge", -1865491845, null), eD = new T(null, "dir", "dir", -919681108, null), T2e = new T(null, "dateElementParser", "dateElementParser", 984800945, null), sP = new T(null, "LazySeq", "LazySeq", 1579450882, null), s1 = new de(null, "self-ref-idx", "self-ref-idx", -1384537812), nD = new T(null, "rename", "rename", -1146278156, null), j2e = new de(null, "basic-date", "basic-date", 1566551506), oP = new T(null, "filter", "filter", 691993593, null), A2e = new T(null, "new-years-day-m", "new-years-day-m", -83830242, null), tD = new T(null, "starts-with?", "starts-with?", 1014173927, null), aP = new T(null, "ex-info", "ex-info", -539875240, null), Ms = new de(null, "max-fixed-arity", "max-fixed-arity", -690205543), D2e = new de(null, "ordinal-date-time-no-ms", "ordinal-date-time-no-ms", -1539005490), I2e = new T(null, "->record-impl", "->record-impl", 1274709757, null), R2e = new T(null, "deftype*", "deftype*", 962659890, null), fee = new de(
  null,
  "splitLine",
  "splitLine",
  -1338533189
), cP = new T(null, "unchecked-remainder-int", "unchecked-remainder-int", 1427188224, null), hP = new T(null, "interpose", "interpose", -2078295140, null), Oa = new de(null, "timezone", "timezone", 1831928099), fP = new T(null, "bit-and", "bit-and", -479352589, null), hH = new T(null, "aseq", "aseq", -1865515628, null), dP = new T(null, "aset", "aset", 900773178, null), dee = new T("cljs.math", "log", "cljs.math/log", 1835212287, null), pee = new T(null, "signum", "signum", -2050172354, null), pP = new T(
  null,
  "false?",
  "false?",
  -1522377573,
  null
), N2e = new de(null, "tag-class", "tag-class", 714967874), C2e = new T("cljs.core", "ex-message", "cljs.core/ex-message", -747602175, null), mP = new T(null, "shuffle", "shuffle", -1393023609, null), mee = new T(null, "last-of-month?", "last-of-month?", -413494850, null), gP = new T(null, "string?", "string?", -1129175764, null), M2e = new de(null, "week-date", "week-date", -1176745129), gee = new T(null, "subtract-exact", "subtract-exact", -811180398, null), wP = new T(null, "methods", "methods", 2094462393, null), vh = new de(
  null,
  "source-key",
  "source-key",
  -1325875542
), vP = new T(null, "doto", "doto", 1252536074, null), Jk = new T(null, "println", "println", -733595439, null), eF = new de(null, "use", "use", -1846382424), ls = new de(null, "months", "months", -45571637), P2e = new T(null, "fnspecs", "fnspecs", -958581686, null), nu = new de(null, "mac", "mac", -1879391650), lD = new T(null, "trim", "trim", -1880116002, null), Ud = new de("edamame.impl.parser", "opened-delimiter", "edamame.impl.parser/opened-delimiter", 1199661648), wee = new T(null, "deg", "deg", 958975446, null), Yc = new T(
  null,
  "def",
  "def",
  597100991,
  null
), Xx = new de(null, "map", "map", 1371690461), $2e = new de(null, "prev-event", "prev-event", -88694225), yh = new de(null, "params", "params", 710516235), vee = new T("cljs.math", "to-degrees", "cljs.math/to-degrees", 372097128, null), yP = new T(null, "dec", "dec", -766002333, null), yee = new T("ruler.utils.string", "concat-key", "ruler.utils.string/concat-key", -151288891, null), L2e = new de(null, "basic-t-time", "basic-t-time", 191791391), nF = new de(null, "check-permissions", "check-permissions", 669054317), _P = new T(
  null,
  "chunk-cons",
  "chunk-cons",
  433801405,
  null
), xP = new T(null, "chunked-seq?", "chunked-seq?", 1044846168, null), _ee = new T(null, "log10", "log10", 891257803, null), xee = new T(null, "-new-var", "-new-var", 1200468147, null), B2e = new T(null, "doc+methods", "doc+methods", 2036080922, null), F2e = new de(null, "handled", "handled", 1889700151), SP = new T(null, "ns-unalias", "ns-unalias", 445102632, null), V2e = new T("cljs.core", "multi-fn-impl", "cljs.core/multi-fn-impl", 1399453884, null), See = new de(null, "bindingx", "bindingx", 679516896), Y2e = new T(
  null,
  "default",
  "default",
  -347290801,
  null
), ee = new de(null, "doc", "doc", 1913296891), fH = new T(null, "l__27234__auto__", "l__27234__auto__", 175972312, null), d_ = new de(null, "abbr", "abbr", 2088591884), of = new de(null, "readers", "readers", -2118263030), af = new de(null, "quote", "quote", -262615245), Eee = new T(null, "catch", "catch", -1616370245, null), rD = new T(null, "apply-template", "apply-template", 1809601838, null), EP = new T(null, "coll?", "coll?", -1874821441, null), tF = new de(null, "path", "path", -188191168), U2e = new T(
  "cljs.core",
  "cond->",
  "cljs.core/cond->",
  -113941356,
  null
), Oee = new T(null, "newval", "newval", 717803975, null), OP = new T(null, "reify", "reify", 1885539699, null), kP = new T(null, "to-array-2d", "to-array-2d", -1563270737, null), kee = new de("cursor", "mapped", "cursor/mapped", 1625530272), q2e = new T("clojure.core", "apply", "clojure.core/apply", 1654646389, null), lF = new T("cljs.core", "alter-meta!", "cljs.core/alter-meta!", 574694262, null), iD = new T(null, "includes?", "includes?", -2049283381, null), bee = new T(null, "asin", "asin", -904130570, null), Tee = new T(
  "cljs.core",
  "->",
  "cljs.core/->",
  1488366311,
  null
), W2e = new T("ruler.utils.java-time", "add-months", "ruler.utils.java-time/add-months", 317746680, null), jee = new de(null, "cursorPageDown", "cursorPageDown", -1143253131), Ps = new de(null, "arglists-meta", "arglists-meta", 1944829838), Aee = new T(null, "log1p", "log1p", -1825632554, null), dH = new T("sci.impl.records", "->record-impl", "sci.impl.records/->record-impl", -1005013370, null), pH = new T(null, "start-test", "start-test", 687547962, null), Dee = new de(null, "some", "some", -1951079573), H2e = new T("ruler.utils.clj-time", "format-date", "ruler.utils.clj-time/format-date", -1864081663, null), o1 = new T(null, "map", "map", -1282745308, null), z2e = new T("ruler.utils.clj-time", "number-of-days-in-the-month", "ruler.utils.clj-time/number-of-days-in-the-month", 171772387, null), K2e = new T(null, "load-file", "load-file", 1215944857, null), bP = new T(null, "max", "max", 1701898075, null), Iee = new T(null, "*default-data-reader-fn*", "*default-data-reader-fn*", 758795499, null), TP = new T(null, "compare", "compare", 1109853757, null), jP = new T(null, "multi-fn?-impl", "multi-fn?-impl", 1372639302, null), G2e = new T(null, ".close", ".close", -1017758745, null), AP = new de("sci.impl", "fn", "sci.impl/fn", 1695180073), rF = new T("clojure.core", "unquote", "clojure.core/unquote", 843087510, null), Ree = new T(null, "floor-mod", "floor-mod", 378160646, null), Nee = new de(null, "nav-left", "nav-left", 845947876), DP = new T(null, "load-string", "load-string", -403739145, null), qS = new T(null, "farg__24392__auto__", "farg__24392__auto__", 298228942, null), IP = new T(
  null,
  "range",
  "range",
  -1014743483,
  null
), e4 = new T(null, "use", "use", -205850897, null), Z2e = new de(null, "where", "where", -2044795965), Zd = new T("cljs.core", "if-let", "cljs.core/if-let", 1346583165, null), X2e = new de(null, "override", "override", 1422085626), uD = new T(null, "index", "index", 108845612, null), xf = new T(null, "test", "test", -2076896892, null), Q2e = new T(null, "-Inf", "-Inf", -2123243689, null), Cee = new T("cljs.math", "get-exponent", "cljs.math/get-exponent", -574752394, null), RP = new T(null, "take", "take", 871646627, null), V0 = new de(
  "edamame",
  "expected-delimiter",
  "edamame/expected-delimiter",
  93379254
), Mee = new T(null, "scalb", "scalb", 1918748117, null), NP = new T(null, "dorun", "dorun", 560426022, null), iF = new de(null, "info", "info", -317069002), Hy = new de(null, "splicing?", "splicing?", -428596366), mH = new de(null, "variadic", "variadic", 882626057), Pee = new T("cljs.math", "ulp", "cljs.math/ulp", -470666632, null), lt = new de(null, "test", "test", 577538877), sD = new T(null, "ns__27421__auto__", "ns__27421__auto__", -1260967634, null), uF = new de(null, "barf-forward", "barf-forward", 1278612337), $ee = new T(
  null,
  "ulp",
  "ulp",
  -879804804,
  null
), J2e = new de(null, "auto-resolve-ns", "auto-resolve-ns", -417488467), CP = new T(null, "*print-newline*", "*print-newline*", 1478078956, null), Bn = new de(null, "file", "file", -1269645878), Lee = new T("cljs.math", "cbrt", "cljs.math/cbrt", 431619368, null), WS = new T("cljs.core", "rest", "cljs.core/rest", -285075455, null), Lt = new T(null, "number", "number", -1084057331, null), e_e = new T("sci.impl.deftype", "->type-impl", "sci.impl.deftype/->type-impl", -2121297742, null), MP = new T(
  null,
  "chunk-buffer",
  "chunk-buffer",
  789680287,
  null
), PP = new T(null, "reversible?", "reversible?", 314107817, null), $P = new T(null, "ns-publics", "ns-publics", 903350436, null), gH = new de(null, "loading", "loading", -737050189), n_e = new T(null, "body-expr", "body-expr", -2125506601, null), p_ = new T(null, "x__24278__auto__", "x__24278__auto__", 791484416, null), Bee = new T("clojure.core", "defrecord", "clojure.core/defrecord", 581689476, null), m_ = new T(null, "xrel", "xrel", -735800081, null), LP = new T(null, "bit-and-not", "bit-and-not", -254338837, null), Fee = new T(
  "cljs.core",
  "->>",
  "cljs.core/->>",
  -1207871206,
  null
), t_e = new de(null, "resolve-sym", "resolve-sym", -1193683260), BP = new T(null, "longs", "longs", -1017696020, null), Vee = new T(null, "cljs.tools.reader.impl.commons", "cljs.tools.reader.impl.commons", 1569241026, null), T_ = new T(null, "init", "init", -234949907, null), Yee = new T("cljs.math", "sinh", "cljs.math/sinh", 489835238, null), oD = new T(null, "split-lines", "split-lines", 777513935, null), Uee = new de(null, "cursorDocStart", "cursorDocStart", 2008312830), qee = new T(
  null,
  "queue",
  "queue",
  -1198599890,
  null
), l_e = new de(null, "eofthrow", "eofthrow", -334166531), r_e = new T(null, "keyseq", "keyseq", -1822150828, null), i_e = new de(null, "padding-left", "padding-left", -1180879053), FP = new T(null, "some", "some", -310548046, null), aD = new T(null, "doc", "doc", -741138878, null), Wee = new T(null, "tanh", "tanh", 480481797, null), u_e = new T(null, "print-doc", "print-doc", 528043232, null), VP = new T(null, "declare", "declare", 654042991, null), Y0 = new T("cljs.core", "type", "cljs.core/type", -821761154, null), Hee = new de(
  "sci.impl",
  "idx",
  "sci.impl/idx",
  700902278
), s_e = new T("cljs.core", "cons", "cljs.core/cons", 96507417, null), zee = new T(null, "clojure.set", "clojure.set", -630955632, null), Db = new de(null, "meta", "meta", 1499536964), sF = new T("cljs.core", "conj", "cljs.core/conj", -460750931, null), o_e = new T("edamame.core", "read-eval", "edamame.core/read-eval", 1461005554, null), YP = new T(null, "floats", "floats", 513591110, null), a_e = new de(null, "t-time-no-ms", "t-time-no-ms", 990689905), c_e = new de(null, "color-dark", "color-dark", 601410583), UP = new T(
  null,
  "with-bindings*",
  "with-bindings*",
  -93186207,
  null
), h_e = new T(null, "zs", "zs", -257004521, null), qP = new T(null, "satisfies?", "satisfies?", -433227199, null), cD = new T(null, "walk", "walk", 1673453164, null), Kee = new T(null, "pow", "pow", 196526960, null), f_e = new T("clojure.core", "hash-map", "clojure.core/hash-map", 338908405, null), WP = new T(null, "pop", "pop", -94247249, null), HP = new de(null, "selectPageUp", "selectPageUp", 152840428), d_e = new T(null, "token", "token", 429068312, null), Gee = new de("sci", "record", "sci/record", -778731026), p_e = new de(null, "hour", "hour", -555989214), m_e = new T("ruler.utils.clj-time", "columbus-day-m", "ruler.utils.clj-time/columbus-day-m", 1421664330, null), wH = new T(null, "dir-fn", "dir-fn", 187684626, null), U0 = new de(null, "ancestors", "ancestors", -776045424), Zee = new de(null, "cursorLineUp", "cursorLineUp", -1375841219), kE = new T(null, "has-root-impl", "has-root-impl", -288948659, null), Xee = new T(null, "sci.impl.deftype", "sci.impl.deftype", 959784924, null), g_e = new T("cljs.core", "Delay", "cljs.core/Delay", -21574999, null), vH = new T(
  null,
  "farg__24396__auto__",
  "farg__24396__auto__",
  1359164803,
  null
), zP = new de(null, "color-gray-light", "color-gray-light", -1678095603), w_e = new T(null, "more-sizes", "more-sizes", -763736162, null), Qee = new de(null, "sub-type", "sub-type", -997954412), KP = new T(null, "seq-to-map-for-destructuring", "seq-to-map-for-destructuring", 647384515, null), Jee = new T(null, "date2-as-string", "date2-as-string", 899584684, null), oF = new de(null, "barf-backward", "barf-backward", 434854195), g_ = new T(null, "keyvals", "keyvals", -2067234787, null), v_e = new T(
  null,
  "defrecord*",
  "defrecord*",
  -1936366207,
  null
), GP = new T(null, "reduce", "reduce", 1358839360, null), y_e = new de(null, "RegExp", "RegExp", 137681940), ZP = new T(null, "dissoc!", "dissoc!", 333592624, null), hD = new T(null, "postwalk", "postwalk", 967039904, null), ene = new T(null, "reify*", "reify*", 1646945123, null), __e = new T("cljs.tools.reader.edn", "read-char*", "cljs.tools.reader.edn/read-char*", -606185164, null), zy = new de(null, "f", "f", -1597136552), x_e = new de(null, "invocation-self-idx", "invocation-self-idx", -1258983407), S_e = new de(null, "margin-left", "margin-left", 2015598377), Ls = new de(null, "b", "b", 1482224470), E_e = new T("cljs.core", "var-get", "cljs.core/var-get", -91823622, null), XP = new T(null, "alter-meta!", "alter-meta!", 1510444945, null), QP = new T(null, "float?", "float?", 673884616, null), nne = new de(null, "a", "a", -2123407586), fD = new T(null, "difference", "difference", -738334373, null), O_e = new T(null, "read-date", "read-date", 1874308181, null), q0 = new T(null, "replace", "replace", 853943757, null), JP = new T(null, "mapcat", "mapcat", -601348859, null), k_e = new de(null, "parse-quoted", "parse-quoted", 1180570118), e$ = new T(null, "chunk-first", "chunk-first", 1379046752, null), Ky = new T("cljs.core", "get", "cljs.core/get", -296075407, null), dD = new T(null, "temp__27213__auto__", "temp__27213__auto__", -740552003, null), n$ = new T(null, "prn", "prn", 1561684909, null), yH = new T(null, "match", "match", -1434376219, null), Gy = new T(null, "let*", "let*", 1920721458, null), bE = new de(null, "reload-all", "reload-all", 761570200), t$ = new T(null, "deftype", "deftype", 1980826088, null), tne = new T("cljs.core", "hash-map", "cljs.core/hash-map", 303385767, null), l$ = new T(null, "doall", "doall", 988520834, null), lne = new T("cljs.math", "cosh", "cljs.math/cosh", 1657222870, null), Xl = new T(null, "date-as-string", "date-as-string", -1639604813, null), W0 = new T(null, "objs", "objs", -170194107, null), rne = new T(null, "atan2", "atan2", -134972156, null), b_e = new T("ruler.utils.clj-time", "after-nth-of-month", "ruler.utils.clj-time/after-nth-of-month", -2146562381, null), xo = new de(null, "format", "format", -1306924766), T_e = new T(
  "ruler.utils.clj-time",
  "date",
  "ruler.utils.clj-time/date",
  -1400492549,
  null
), ka = new de(null, "row-key", "row-key", -1189010712), T1 = new T(null, "try", "try", -1273693247, null), w_ = new de(null, "day", "day", -274800446), r$ = new de(null, "selectPageDown", "selectPageDown", 226562613), j_e = new de(null, "long", "long", -171452093), aF = new T("clojure.core", "unquote-splicing", "clojure.core/unquote-splicing", -552003150, null), i$ = new T(null, "special-symbol?", "special-symbol?", -731144617, null), ine = new T("cljs.math", "subtract-exact", "cljs.math/subtract-exact", 669336214, null), A_e = new T(
  null,
  "cljs.core.IDeref",
  "cljs.core.IDeref",
  -783543206,
  null
), D_e = new de(null, "keyword-fn", "keyword-fn", -64566675), bp = new de(null, "recur-target", "recur-target", -1909494536), une = new T(null, "random", "random", 1082720414, null), _H = new T(null, "prefer-table__24246__auto__", "prefer-table__24246__auto__", 982416495, null), u$ = new T(null, "eduction", "eduction", 1445227968, null), s$ = new T(null, "make-hierarchy", "make-hierarchy", -241558556, null), kh = new de(null, "private", "private", -558947994), ta = new de(null, "refers", "refers", 158076809), j_ = new T(
  null,
  "comparator",
  "comparator",
  -509539107,
  null
), sne = new T(null, "clojure.repl", "clojure.repl", 570897595, null), I_e = new de("sci.impl", "required-fn", "sci.impl/required-fn", 2082701278), H0 = new T(null, "reverse", "reverse", 752076261, null), n4 = new de(null, "require", "require", -468001333), o$ = new T(null, "some?", "some?", 234752293, null), a$ = new T(null, "random-sample", "random-sample", -914181101, null), ws = new T(null, "pred", "pred", -727012372, null), R_e = new T(
  null,
  "martin-luther-king-day-m",
  "martin-luther-king-day-m",
  -1308006681,
  null
), c$ = new T(null, "namespace", "namespace", 1263021155, null), N_e = new T(null, "type->str", "type->str", 360030041, null), pD = new T(null, "c__25799__auto__", "c__25799__auto__", 878004384, null), C_e = new T(null, "cljs.core.IReset", "cljs.core.IReset", 348905844, null), M_e = new de(null, "unsupported-operation", "unsupported-operation", 1890540953), h$ = new T(null, "let", "let", 358118826, null), sh = new T(null, "output", "output", 534662484, null), P_e = new T(null, "string", "string", -349010059, null), Su = new de(
  null,
  "shift",
  "shift",
  997140064
), $_e = new de(null, "loc", "loc", -584284901), cF = new T(null, "import", "import", 241030818, null), f$ = new T(null, "undefined?", "undefined?", 1356377224, null), Gf = new de(null, "refer", "refer", -964295553), t4 = new T(null, "require", "require", 1172530194, null), d$ = new T(null, "assoc", "assoc", 2071440380, null), L_e = new de(null, "DefLike", "DefLike", 851541087), B_e = new T("ruler.utils.clj-time", "christmas-day-m", "ruler.utils.clj-time/christmas-day-m", -45016754, null), one = new T(null, "log", "log", 45015523, null), p$ = new T(
  null,
  "ns-unmap",
  "ns-unmap",
  1255260993,
  null
), m$ = new T(null, "drop-last", "drop-last", -1123611530, null), ane = new T(null, "formatters", "formatters", -235105591, null), z_ = new T(null, "clauses", "clauses", -1199594528, null), g$ = new T(null, "split-at", "split-at", -60953742, null), xH = new T(null, "map-entry", "map-entry", 329617471, null), F_e = new de(null, "validator", "validator", -1966190681), V_e = new T(null, "eof-error?", "eof-error?", 863128689, null), Y_e = new T(
  "ruler.utils.java-time",
  "date-format-with-time",
  "ruler.utils.java-time/date-format-with-time",
  1882874062,
  null
), w$ = new T(null, "time", "time", -1268547887, null), cne = new T(null, "-reified-methods", "-reified-methods", 1702712518, null), U_e = new de(null, "parent", "parent", -878878779), mD = new T(null, "temp__27200__auto__", "temp__27200__auto__", -565407875, null), v$ = new T(null, "subvec", "subvec", 364611032, null), y$ = new T(null, "multi-fn-impl", "multi-fn-impl", 187651105, null), ba = new de(null, "syntax-quote", "syntax-quote", -1233164847), _$ = new T(null, "aclone", "aclone", 722978531, null), z0 = new de(
  "edamame.impl.parser",
  "expected-delimiter",
  "edamame.impl.parser/expected-delimiter",
  2057965803
), Il = new de(null, "namespaces", "namespaces", -1444157469), hne = new T(null, "toString", "toString", -95766347, null), gD = new T(null, "split", "split", 1041096409, null), x$ = new T(null, "defonce", "defonce", -1681484013, null), q_e = new T("ruler.utils.clj-time", "banking-days-between", "ruler.utils.clj-time/banking-days-between", -1496818311, null), S$ = new T(null, "bit-shift-right", "bit-shift-right", 884046498, null), fne = new T(
  "cljs.core",
  "pr-str",
  "cljs.core/pr-str",
  -552799478,
  null
), SH = new T(null, "default__24405__auto__", "default__24405__auto__", 150152454, null), lg = new T("cljs.core", "str", "cljs.core/str", -1971828991, null), E$ = new T(null, "integer?", "integer?", 1303791671, null), O$ = new T(null, "transient", "transient", 899115069, null), W_e = new de(null, "basic-date-time", "basic-date-time", 1525413604), H_e = new de(null, "cursorLineStart", "cursorLineStart", -1505072960), dne = new de(null, "cursorCharRight", "cursorCharRight", -739900583), Uc = new de(null, "end-col-key", "end-col-key", 81813304), pne = new T(
  null,
  "number-of-decimals",
  "number-of-decimals",
  -263292468,
  null
), z_e = new de(null, "activateOnTyping", "activateOnTyping", -1229519599), k$ = new T(null, "identity", "identity", -1007039734, null), EH = new T(null, "from-index", "from-index", 1882766240, null), OH = new de(null, "invalid-date", "invalid-date", 2030506573), K_e = new T("clojure.core", "concat", "clojure.core/concat", -1236478952, null), mne = new T("cljs.math", "floor-mod", "cljs.math/floor-mod", -816885246, null), b$ = new T(null, "last", "last", -1548700637, null), G_e = new de(
  null,
  "no-test",
  "no-test",
  -1679482642
), gne = new T(null, "*ns*", "*ns*", 740153818, null), Z_e = new T("cljs.core", "-", "cljs.core/-", 187040141, null), X_e = new de(null, "character", "character", 380652989), Q_e = new de(null, "u-namespace", "u-namespace", 1583581038), Tv = new T(null, "forms", "forms", -608443419, null), T$ = new T(null, "PersistentQueue", "PersistentQueue", -160870792, null), Qx = new T("cljs.core", "<", "cljs.core/<", 1677496129, null), J_e = new de(null, ">>", ">>", -277509267), wne = new de(null, "date-opt-time", "date-opt-time", -1507102105), j$ = new T(null, "while", "while", -1691317983, null), exe = new T("cljs.core", "=", "cljs.core/=", -1891498332, null), nxe = new T(null, "-pr-writer", "-pr-writer", -445354136, null), txe = new T(null, "previous-banking-day", "previous-banking-day", 1525406458, null), vne = new de(null, "cursorCharLeft", "cursorCharLeft", -1572589780), yne = new de(null, "date-time-parser", "date-time-parser", -656147568), lxe = new de(null, "not-implemented", "not-implemented", 1918806714), A$ = new T(null, "bit-test", "bit-test", 543456753, null), _ne = new T(
  null,
  "to-degrees",
  "to-degrees",
  1314929764,
  null
), wD = new de(null, "namespaced-map", "namespaced-map", 1235665380), hm = new de(null, "pre", "pre", 2118456869), rxe = new T(null, "proc", "proc", -643106804, null), kH = new T(null, "prob", "prob", 1133230269, null), bH = new de(null, "min-varargs", "min-varargs", 1999010596), xne = new T(null, "next-down", "next-down", -2059951088, null), hF = new T(null, "expand-dot*", "expand-dot*", -1946890561, null), Sne = new T(null, "*err*", "*err*", 2070937226, null), D$ = new T(null, "char", "char", 998943941, null), ixe = new T(
  "clojure.core",
  "vec",
  "clojure.core/vec",
  146271141,
  null
), uxe = new de(null, "extensions", "extensions", -1103629196), Ene = new T(null, "floor-div", "floor-div", 704924158, null), a1 = new de(null, "weekyear-week", "weekyear-week", 795291571), One = new de("sci.impl", "var", "sci.impl/var", -2041185552), kne = new T(null, "Object", "Object", 61210754, null), sxe = new de(null, "ordinal-date", "ordinal-date", -77899447), TH = new T(null, "a__27233__auto__", "a__27233__auto__", -694279876, null), oxe = new de("sci.impl.namespaces", "TODO", "sci.impl.namespaces/TODO", -1842365958), bne = new de(null, "lib", "lib", 191808726), I$ = new T(null, "group-by", "group-by", 1261391725, null), R$ = new T(null, "unchecked-divide-int", "unchecked-divide-int", 1613116468, null), N$ = new T(null, "flatten", "flatten", -1441633353, null), axe = new T(null, "subtract-months", "subtract-months", 1322035203, null), cxe = new T("ruler.utils.clj-time", "today", "ruler.utils.clj-time/today", 1010556636, null), hxe = new T("cljs.core", "var?", "cljs.core/var?", 1711182854, null), C$ = new T(null, "unchecked-short", "unchecked-short", 27848057, null), fxe = new de(null, "year-month", "year-month", 735283381), M$ = new T(null, "sequence", "sequence", -1727628355, null), P$ = new T(null, "quot", "quot", -1125214196, null), Tne = new T("cljs.core", "zipmap", "cljs.core/zipmap", -1902130674, null), jne = new de(null, "date-element-parser", "date-element-parser", 2072167040), $$ = new T(null, "tree-seq", "tree-seq", -1800921632, null), L$ = new T(null, "*print-namespace-maps*", "*print-namespace-maps*", -1759108415, null), rt = new de(null, "end-line", "end-line", 1837326455), dxe = new T(
  "cljs.core",
  "-reified-methods",
  "cljs.core/-reified-methods",
  -1833109469,
  null
), B$ = new T(null, "some-fn", "some-fn", -490044165, null), F$ = new de(null, "selectLineUp", "selectLineUp", -255594686), pxe = new T(null, "localDateOptionalTimeParser", "localDateOptionalTimeParser", 435955537, null), V$ = new T(null, "ns-name", "ns-name", -436814796, null), Yh = new T("cljs.core", "get-method", "cljs.core/get-method", -487793502, null), Y$ = new T(null, "munge", "munge", -174396700, null), U$ = new de(null, "while", "while", 963117786), Ib = new de(null, "output", "output", -1105869043), l4 = new T(null, "resolve", "resolve", 56086045, null), q$ = new T(null, "repeatedly", "repeatedly", 1199964457, null), r4 = new T(null, "in-ns", "in-ns", -2089468466, null), Zf = new de(null, "macro", "macro", -867863404), mxe = RegExp("([\\uD800-\\uDBFF])([\\uDC00-\\uDFFF])", "g"), Ja = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Ja.h = function(e) {
  var n = new Ts();
  for (e = z(e); ; ) if (e != null) n = n.append(ye.h(I(e))), e = W(e);
  else return n.toString();
};
Ja.g = function(e, n) {
  var t = new Ts();
  for (n = z(n); ; ) if (n != null) t.append(ye.h(I(n))), n = W(n), n != null && t.append(e);
  else return t.toString();
};
Ja.m = 2;
var Xf = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Xf.g = function(e, n) {
  return Xf.j(e, n, 0);
};
Xf.j = function(e, n, t) {
  if (ye.h(n) === "/(?:)/") n = Ufe(e, t);
  else if (1 > t) n = Et(ye.h(e).split(n));
  else e: for (var l = t, r = Dt; ; ) {
    if (l === 1) {
      n = yt.g(r, e);
      break e;
    }
    var u = Ss(n, e);
    if (u != null) {
      var o = e.indexOf(u);
      u = e.substring(o + Cn(u)), --l, r = yt.g(r, e.substring(0, o)), e = u;
    } else {
      n = yt.g(r, e);
      break e;
    }
  }
  if (t === 0 && 1 < Cn(n)) e: for (t = n; ; ) if (WO(t) === "") t = my(t);
  else break e;
  else t = n;
  return t;
};
Xf.m = 3;
var Rb = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Rb.g = function(e, n) {
  return e = e.indexOf(n), 0 > e ? null : e;
};
Rb.j = function(e, n, t) {
  return e = e.indexOf(n, t), 0 > e ? null : e;
};
Rb.m = 3;
var yg = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
yg.g = function(e, n) {
  return e = e.lastIndexOf(n), 0 > e ? null : e;
};
yg.j = function(e, n, t) {
  return e = e.lastIndexOf(n, t), 0 > e ? null : e;
};
yg.m = 3;
A = hw.prototype;
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  switch (n instanceof de ? n.ca : null) {
    case "splicing?":
      return this.Pb;
    case "form":
      return this.form;
    default:
      return en.j(this.F, n, t);
  }
};
A.nb = function(e, n, t) {
  return wt.j(function(l, r) {
    var u = O.j(r, 0, null);
    return r = O.j(r, 1, null), n.j ? n.j(l, u, r) : n.call(null, l, u, r);
  }, t, this);
};
A.R = function(e, n, t) {
  return vr(n, function(l) {
    return vr(n, Wl, "", " ", "", t, l);
  }, "#cljs.tools.reader.impl.utils.ReaderConditional{", ", ", "}", t, he.g(new v(null, 2, 5, y, [new v(null, 2, 5, y, [Hy, this.Pb], null), new v(null, 2, 5, y, [Vy, this.form], null)], null), this.F));
};
A.Xa = function() {
  return new hf(this, 2, new v(null, 2, 5, y, [Hy, Vy], null), j(this.F) ? eo(this.F) : ed());
};
A.U = function() {
  return this.K;
};
A.$ = function() {
  return 2 + Cn(this.F);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = -209062840 ^ Na(this));
};
A.N = function(e, n) {
  return n != null && this.constructor === n.constructor && on.g(this.Pb, n.Pb) && on.g(this.form, n.form) && on.g(this.F, n.F);
};
A.sb = function(e, n) {
  return Ol(new gi(null, new $(null, 2, [Hy, null, Vy, null], null), null), n) ? nr.g(su(lr.g(Tt, this), this.K), n) : new hw(this.Pb, this.form, this.K, Fo(nr.g(this.F, n)), null);
};
A.gb = function(e, n) {
  switch (n instanceof de ? n.ca : null) {
    case "splicing?":
    case "form":
      return !0;
    default:
      return Ol(this.F, n);
  }
};
A.Aa = function(e, n, t) {
  return j(Ln.g ? Ln.g(Hy, n) : Ln.call(null, Hy, n)) ? new hw(t, this.form, this.K, this.F, null) : j(Ln.g ? Ln.g(Vy, n) : Ln.call(null, Vy, n)) ? new hw(this.Pb, t, this.K, this.F, null) : new hw(this.Pb, this.form, this.K, Dn.j(this.F, n, t), null);
};
A.W = function() {
  return z(he.g(new v(null, 2, 5, y, [new yl(Hy, this.Pb), new yl(Vy, this.form)], null), this.F));
};
A.Z = function(e, n) {
  return new hw(this.Pb, this.form, n, this.F, this.H);
};
A.aa = function(e, n) {
  return or(n) ? this.Aa(null, Ul(n, 0), Ul(n, 1)) : wt.j(Qo, this, n);
};
A.da = Rn;
A.R = function(e, n, t) {
  return Br(n, ["#?", j(this.Pb) ? "@" : null].join("")), Wl(this.form, n, t);
};
var gxe = /[\s]/;
kr.h(0);
W4.prototype.S = function() {
  if (this.ye > this.Ic) {
    var e = this.X.charAt(this.Ic);
    return this.Ic += 1, e;
  }
  return null;
};
W4.prototype.ob = function() {
  return this.ye > this.Ic ? this.X.charAt(this.Ic) : null;
};
V3.prototype.S = function() {
  var e = this.Bb < this.td ? this.nc[this.Bb] : this.Ab.S(null);
  return this.Bb < this.td && (this.Bb += 1), e == null ? null : gy(e);
};
V3.prototype.ob = function() {
  var e = this.Bb < this.td ? this.nc[this.Bb] : this.Ab.ob(null);
  return e == null ? null : gy(e);
};
V3.prototype.Ob = function(e, n) {
  if (j(n)) {
    if (this.Bb === 0) throw Error("Pushback buffer is full");
    return --this.Bb, this.nc[this.Bb] = n;
  }
  return null;
};
A = XK.prototype;
A.S = function() {
  var e = this.Ab.S(null);
  return j(e) ? (e = ZK(this.Ab, e), this.prev = this.Hb, this.Hb = q4(e), j(this.Hb) && (this.Yc = this.column, this.column = 0, this.line += 1), this.column += 1, e) : null;
};
A.ob = function() {
  return this.Ab.ob(null);
};
A.Ob = function(e, n) {
  return j(this.Hb) ? (--this.line, this.column = this.Yc) : --this.column, this.Hb = this.prev, this.Ab.Ob(null, n);
};
A.se = Rn;
A.qc = function() {
  return this.line | 0;
};
A.pc = function() {
  return this.column | 0;
};
A.te = function() {
  return this.nd;
};
A = YL.prototype;
A.S = function() {
  var e = this.Ab.S(null);
  if (j(e)) {
    e = ZK(this.Ab, e), this.prev = this.Hb, this.Hb = q4(e), j(this.Hb) && (this.Yc = this.column, this.column = 0, this.line += 1), this.column += 1;
    var n = sn(this.frames);
    return n = l1.h(n), j(n) && n.append(e), e;
  }
  return null;
};
A.ob = function() {
  return this.Ab.ob(null);
};
A.Ob = function(e, n) {
  return j(this.Hb) ? (--this.line, this.column = this.Yc) : --this.column, this.Hb = this.prev, j(n) && (e = sn(this.frames), e = l1.h(e), j(e) && e.set(Si.j(ye.h(e), 0, e.getLength() - 1))), this.Ab.Ob(null, n);
};
A.se = Rn;
A.qc = function() {
  return this.line | 0;
};
A.pc = function() {
  return this.column | 0;
};
A.te = function() {
  return this.nd;
};
var As, wxe = kr.h(Tt), vxe = kr.h(Tt), yxe = kr.h(Tt), _xe = kr.h(Tt), xxe = en.j(Tt, vg, es.o ? es.o() : es.call(null));
As = new Np(_n.g("cljs.tools.reader.impl.inspect", "inspect*"), function(e, n) {
  return n == null ? xZ : typeof n == "string" ? H_ : n instanceof de || typeof n == "number" || n instanceof T ? yv : or(n) ? ZB : o2(n) ? UB : ci(n) ? Xx : ug(n) ? Mx : on.g(n, !0) || on.g(n, !1) ? yv : zh(n);
}, ai, xxe, wxe, vxe, yxe, _xe);
As.$a(null, H_, function(e, n) {
  e = j(e) ? 5 : 20;
  var t = n.length > e ? '..."' : '"', l = n.length;
  return ['"', ye.h(n.substring(0, e < l ? e : l)), t].join("");
});
As.$a(null, yv, function(e, n) {
  return ye.h(n);
});
As.$a(null, hn, function() {
  return "<indexed seq>";
});
As.$a(null, Ip, function() {
  return "<map seq>";
});
As.$a(null, Jd, function() {
  return "<map seq>";
});
As.$a(null, hp, function() {
  return "<cons>";
});
As.$a(null, rr, function() {
  return "<lazy seq>";
});
As.$a(null, xZ, function() {
  return "nil";
});
As.$a(null, UB, function(e, n) {
  return z4(e, n, "(", ")");
});
As.$a(null, Xx, function(e, n) {
  var t = Cn(n), l = j(e) ? 0 : t;
  return n = In.g(he, Vu.g(l, n)), z4(e, n, "{", t > l ? "...}" : "}");
});
As.$a(null, Mx, function(e, n) {
  return z4(e, n, "#{", "}");
});
As.$a(null, ZB, function(e, n) {
  return z4(e, n, "[", "]");
});
As.$a(null, ai, function(e, n) {
  return wg.l(Te([zh(n)]));
});
var jH = /^([-+]?)(?:(0)|([1-9][0-9]*)|0[xX]([0-9A-Fa-f]+)|0([0-7]+)|([1-9][0-9]?)[rR]([0-9A-Za-z]+)|0[0-9]+)(N)?$/, AH = /([-+]?[0-9]+)\/([0-9]+)/, DH = /([-+]?[0-9]+(\.[0-9]*)?([eE][-+]?[0-9]+)?)(M)?/, h5 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
h5.l = function(e) {
  for (; !q4(e.S(null)); ) ;
  return e;
};
h5.m = 1;
h5.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
new Ts();
var Sxe = function() {
  var e = new v(null, 13, 5, y, [null, 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], null), n = new v(null, 13, 5, y, [null, 31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], null);
  return function(t, l) {
    return en.g(j(l) ? n : e, t);
  };
}(), Exe = /(\d\d\d\d)(?:-(\d\d)(?:-(\d\d)(?:[T](\d\d)(?::(\d\d)(?::(\d\d)(?:[.](\d+))?)?)?)?)?)?(?:[Z]|([-+])(\d\d):(\d\d))?/, f5 = kr.h(null), d5 = kr.h(gr.l(Te([new $(null, 4, [jB, hE, cee, function(e) {
  if (typeof e == "string") return new L3(e.toLowerCase());
  throw Error("UUID literal expects a string as its representation.");
}, qee, function(e) {
  if (or(e)) return lr.g(yB, e);
  throw Error("Queue literal expects a vector for its elements.");
}, rJ, Bh], null), Tt]))), p5 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
p5.h = function(e) {
  return Ey(new $(null, 3, [of, sn(d5), ai, sn(f5), qf, null], null), e);
};
p5.g = function(e, n) {
  return e = fr(e), en.g(e, qf), Ey(Ri.j(gr.l(Te([e, new $(null, 1, [ai, sn(f5)], null)])), of, function(t) {
    return gr.l(Te([sn(d5), t]));
  }), n);
};
p5.B = function(e, n, t, l) {
  return Ro(e, n, t, Ri.j(gr.l(Te([l, new $(null, 1, [ai, sn(f5)], null)])), of, function(r) {
    return gr.l(Te([sn(d5), r]));
  }));
};
p5.m = 4;
var Nb = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Nb.h = function(e) {
  return iG(new $(null, 3, [of, sn(d5), ai, sn(f5), qf, null], null), e);
};
Nb.g = function(e, n) {
  return iG(Ri.j(gr.l(Te([new $(null, 1, [ai, sn(f5)], null), e])), of, function(t) {
    return gr.l(Te([sn(d5), t]));
  }), n);
};
Nb.m = 2;
var IH = {}, Oxe = {}, RH = [];
ia.cache = {};
ia.resolve = function(e) {
  return e;
};
ia.exportCopy = function(e, n) {
  let t = {};
  e = e.exports;
  for (let l in n) l == "default" || l in e || l in t || (t[l] = { enumerable: !0, get: function() {
    return n[l];
  } });
  Object.defineProperties(e, t);
};
ia.esmDefault = function(e) {
  return e && e.__esModule ? e : { default: e };
};
var Ru = ia(0, {});
ia(2, {});
var Do = ia(3, {}), Cb = ia(4, {}), Uo = ia(5, {}), Xu = ia(6, {}), qr = ia(7, {}), kxe = ia(8, {}), _g = ia(11, {}), ip = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
ip.h = function(e) {
  return e;
};
ip.g = function(e, n) {
  if (e = e ?? {}, n != null) for (var t = z(_3(n)), l = null, r = 0, u = 0; ; ) if (u < r) {
    var o = l.Y(null, u);
    LU(e, Te([o, n[fx(o)]])), u += 1;
  } else if (t = z(t)) l = t, oi(l) ? (t = Jr(l), u = Wr(l), l = t, r = Cn(t), t = u) : (t = I(l), LU(e, Te([t, n[fx(t)]])), t = W(l), l = null, r = 0), u = 0;
  else break;
  return e;
};
ip.l = function(e, n, t) {
  return wt.j(ip, ip.g(e, n), t);
};
ip.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
ip.m = 2;
var Ane = ia(12, {}), fF = _g.props.coll, Dne = _g.props.prefixColl, dF = _g.props.prefixEdge, bxe = _g.props.prefixContainer, Mb = Cb.NodeProp.closedBy, Pb = Cb.NodeProp.openedBy, D2 = _g.props.sameEdge, m5 = function e(n) {
  var t = n.parent;
  return t == null ? null : kt(t, new rr(null, function() {
    return e.h ? e.h(t) : e.call(null, t);
  }, null, null));
}, vD = new $(null, 4, '()[]{}""'.split(""), null), Txe = Do.EditorView.baseTheme({ $matchingBracket: { color: "#0b0" }, $nonmatchingBracket: { color: "#a22" } }), NH = Do.Decoration.mark({ class: "cm-matchingBracket" }), CH = Do.Decoration.mark({ class: "cm-nonmatchingBracket" }), MH = Ru.StateField.define({ create: v1(Do.Decoration.none), update: function(e, n) {
  var t = n != null && (n.C & 64 || Rn === n.V) ? In.g(tr, n) : n, l = t?.state;
  n = t?.docChanged;
  var r = t?.selection;
  return j(j(n) ? n : r) ? (e = wt.j(function(u, o) {
    o = o != null && (o.C & 64 || Rn === o.V) ? In.g(
      tr,
      o
    ) : o;
    var a = o?.head, h = o?.empty;
    return o = function() {
      var s = j(h) ? I(Ou.g(Cp.g(lk, rk), new v(null, 2, 5, y, [Jh(l, a, -1), Jh(l, a, 1)], null))) : h;
      if (j(s)) {
        var d = lk(s) && on.g(s.from, s.parent.from) ? Dc(s.parent.lastChild, function(p) {
          return on.g(p.name, KL(s));
        }) : rk(s) && on.g(s.to, s.parent.to) ? Dc(s.parent.firstChild, function(p) {
          var _ = on, R = _.g;
          p = p.name;
          var F = s.type.prop(Cb.NodeProp.openedBy);
          return R.call(_, p, F == null ? null : F[0]);
        }) : null;
        return j(d) ? yt.l(u, jS(s, NH), Te([jS(d, NH)])) : yt.g(u, jS(s, CH));
      }
      return null;
    }(), j(o) ? o : (o = function() {
      var s;
      if (s = er(dw(fp(l, a), px))) {
        s = t.state.doc.slice(a, a + 1).toString();
        var d = new gi(null, new $(null, 3, [")", null, "]", null, "}", null], null), null);
        s = d.h ? d.h(s) : d.call(null, s);
      }
      return j(s) ? yt.g(u, jS({ from: a, to: a + 1 }, CH)) : null;
    }(), j(o) ? o : u);
  }, Dt, t.state.selection.ranges), Do.Decoration.set(Fs.h(e), !0)) : e;
} }), jxe = Xu.indentNodeProp.add(function(e) {
  var n = e != null && (e.C & 64 || Rn === e.V) ? In.g(tr, e) : e, t = n?.name;
  return function(l) {
    l = l != null && (l.C & 64 || Rn === l.V) ? In.g(tr, l) : l;
    var r = l?.node;
    if (on.g("Program", t)) return 0;
    if (j(n.prop(fF))) {
      l = l.column(r.firstChild.to);
      var u = on.g("List", t);
      return u ? (r = r == null ? null : r.firstChild, r = r == null ? null : ym(r), r = r == null ? null : r.name, u = new gi(null, new $(null, 3, ["DefLike", null, "NS", null, "Operator", null], null), null), r = u.h ? u.h(r) : u.call(null, r)) : r = u, j(r) ? l + 1 : l;
    }
    return -1;
  };
}), yD = Ru.Transaction.userEvent.of("selectionhistory"), i4 = Ru.StateField.define({ create: function(e) {
  return new g(null, new $(null, 1, [b_, e.selection], null), null, 1, null);
}, update: function(e, n) {
  n = n != null && (n.C & 64 || Rn === n.V) ? In.g(tr, n) : n;
  var t = n?.state;
  t = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t;
  var l = t?.selection;
  t = n?.docChanged;
  var r = I(O2.g(function(u, o) {
    return o = b_.h(o).eq(l), j(o) ? u : null;
  }, e));
  return j(t) || er(Tde(l)) ? new g(null, new $(
    null,
    2,
    [b_, l, F6, n.annotation(Ru.Transaction.userEvent)],
    null
  ), null, 1, null) : j(r) ? (n = uu.g(r, e), t = z(n), n = I(t), t = W(t), kt(Dn.j(n, $2e, F6.h(I(e))), t)) : kt(new $(null, 2, [b_, l, F6, n.annotation(Ru.Transaction.userEvent)], null), e);
} }), Axe = Gn([H_e, iee, YX, F$, PX, O7, bX, Mye, zX, RN, HP, CQ, vne, oQ, CC, KX, dX, WZ, vge, GQ, kC, r$, jee, XZ, IQ, cX, VZ, dne, nJ, lJ, MN, fee, x8, FZ, Zee, Uee], [
  qr.cursorLineStart,
  qr.cursorLineDown,
  qr.selectAll,
  qr.selectLineUp,
  qr.cursorLineBoundaryForward,
  qr.selectLineBoundaryBackward,
  qr.deleteCharBackward,
  qr.insertNewlineAndIndent,
  qr.cursorLineBoundaryBackward,
  qr.selectCharRight,
  qr.selectPageUp,
  qr.deleteCharForward,
  qr.cursorCharLeft,
  qr.cursorGroupBackward,
  qr.selectDocStart,
  qr.selectGroupBackward,
  qr.cursorDocEnd,
  qr.deleteGroupBackward,
  qr.selectLineStart,
  qr.deleteGroupForward,
  qr.selectDocEnd,
  qr.selectPageDown,
  qr.cursorPageDown,
  qr.cursorPageUp,
  qr.selectLineBoundaryForward,
  qr.cursorLineEnd,
  qr.cursorGroupForward,
  qr.cursorCharRight,
  qr.selectGroupForward,
  qr.selectLineEnd,
  qr.selectCharLeft,
  qr.splitLine,
  qr.selectLineDown,
  qr.transposeChars,
  qr.cursorLineUp,
  qr.cursorDocStart
]), Dxe = Gn([DB, Nee, LB, bJ, IB, WB, YQ, WX, uF, oF, iQ, YB, NB, UX], [_c(function(e) {
  return fde(e) ? e.update(gG(e)) : bde(e);
}), _c(UU(-1)), _c(function(e) {
  var n = new Xu.IndentContext(e);
  return fw(
    e,
    function(t) {
      var l = t != null && (t.C & 64 || Rn === t.V) ? In.g(tr, t) : t;
      t = l?.from, l = l?.to;
      var r = dw(fp(e, t), Cp.g(np, bI));
      return r = r == null ? null : oG(r), r = r == null ? null : r.from, r = j(r) ? Xu.getIndentation(n.state, r) : null, r = [`
`, ye.h(j(r) ? Xu.indentString(e, r) : null)].join(""), new $(null, 2, [Bs, t + r.length, Za, new v(null, 1, 5, y, [new $(null, 3, [fo, t, Op, l, fh, r], null)], null)], null);
    }
  );
}), _c(function(e) {
  return Oy(e, { annotations: yD }, function(n) {
    var t = n != null && (n.C & 64 || Rn === n.V) ? In.g(tr, n) : n, l = t?.from, r = t?.to;
    return n = t?.empty, j(n) ? new $(null, 1, [Tx, function() {
      var u = hG(e, l);
      return u = u == null ? null : dE(e, u.from, u.to), j(u) ? u : t;
    }()], null) : new $(null, 1, [Tx, function() {
      var u = jde(e, l, r);
      return u = u == null ? null : Ru.EditorSelection.range(u.from, u.to), j(u) ? u : t;
    }()], null);
  });
}), /* @__PURE__ */ function(e) {
  return function(n) {
    var t = n != null && (n.C & 64 || Rn === n.V) ? In.g(tr, n) : n;
    return n = t?.state, t = t?.dispatch, j(XL(n)) ? (n = e.h ? e.h(n) : e.call(null, n), n != null && (t.h ? t.h(n) : t.call(
      null,
      n
    )), !0) : !1;
  };
}(function(e) {
  return fw(e, function(n) {
    var t = n != null && (n.C & 64 || Rn === n.V) ? In.g(tr, n) : n, l = t?.from;
    if (n = t?.to, t = t?.empty, j(t)) {
      n = fp(e, l);
      var r = dw(n, function(a) {
        var h = np(a);
        return j(h) ? h : px(a) || bI(a);
      }), u = e.doc.lineAt(l).to, o = j(r) ? ZL(r, l, 1) : null;
      return n = j(r) ? function() {
        var a = o == null ? null : vo.g(mf.h(function(h) {
          return h.from <= u;
        }), o);
        return a == null ? null : ho(a);
      }() : null, n = px(r) ? function() {
        var a = ye.h(e.doc.sliceString(r.from, r.to, `
`));
        return a = Si.g(a, l - r.from).indexOf(`
`), 0 > a ? r.to - 1 : l + a + 1;
      }() : j(n) ? rk(n) ? n.from : n.to : j(function() {
        var a = I(o);
        return a = a == null ? null : a.from, a == null ? null : a > u;
      }()) ? I(o).from : null, YU(e.doc.sliceString(l, n, `
`)), j(n) ? new $(null, 2, [Bs, l, Za, new $(null, 2, [fo, l, Op, n], null)], null) : null;
    }
    return YU(e.doc.sliceString(l, n, `
`)), new $(null, 2, [Bs, l, Za, dx(l, n)], null);
  });
}), _c(WU(1)), _c(qU(1)), _c(qU(-1)), _c(HU(1)), _c(HU(-1)), _c(UU(1)), _c(WU(-1)), _c(function(e) {
  return fw(e, function(n) {
    var t = n != null && (n.C & 64 || Rn === n.V) ? In.g(tr, n) : n;
    return n = t?.from, t = t?.empty, j(t) ? (t = Jh(e, n, -1), t = t == null ? null : dw(t, np), t = t == null ? null : Dc(t, GL), j(t) ? new $(null, 2, [Bs, n - 1, Za, new v(null, 2, 5, y, [ik(t.firstChild), ik(t.lastChild)], null)], null) : null) : null;
  });
}), _c(function(e) {
  var n = b_.h(Vr(e.field(i4)));
  return j(n) ? e.update({ selection: n, annotations: yD }) : Oy(e, { annotations: yD }, function(t) {
    return new $(null, 1, [Bs, t.from], null);
  });
})]), W$ = gr.l(Te([Axe, Dxe]));
Jf(function(e, n, t) {
  return Dn.j(e, t, n);
}, Tt, W$);
var Ixe = Gn([iee, YX, PX, bX, zX, CQ, vne, oQ, dX, WZ, GQ, jee, XZ, cX, VZ, r2e, dne, fee, FZ, Zee, Uee], [new v(null, 2, 5, y, [new $(null, 2, [Di, "ArrowDown", Su, x8], null), new $(null, 2, [nu, "Ctrl-n", Su, x8], null)], null), new v(null, 1, 5, y, [new $(null, 1, [Di, "Mod-a"], null)], null), new v(null, 1, 5, y, [new $(null, 2, [Di, "End", Su, IQ], null)], null), new v(null, 2, 5, y, [new $(null, 1, [Di, "Backspace"], null), new $(null, 1, [nu, "Ctrl-h"], null)], null), new v(null, 2, 5, y, [new $(null, 3, [Di, "Home", Su, O7, nu, "Ctrl-a"], null), new $(
  null,
  2,
  [nu, "Cmd-ArrowLeft", Su, O7],
  null
)], null), new v(null, 2, 5, y, [new $(null, 1, [Di, "Delete"], null), new $(null, 1, [nu, "Ctrl-d"], null)], null), new v(null, 2, 5, y, [new $(null, 2, [Di, "ArrowLeft", Su, MN], null), new $(null, 2, [nu, "Ctrl-b", Su, MN], null)], null), new v(null, 1, 5, y, [new $(null, 2, [nu, "Alt-b", Su, KX], null)], null), new v(null, 3, 5, y, [new $(null, 2, [nu, "Cmd-ArrowDown", Su, kC], null), new $(null, 2, [Di, "Mod-End", Su, kC], null), new $(null, 1, [nu, "Alt->"], null)], null), new v(null, 2, 5, y, [new $(null, 2, [Di, "Mod-Backspace", nu, "Alt-Backspace"], null), new $(
  null,
  1,
  [nu, "Ctrl-Alt-h"],
  null
)], null), new v(null, 3, 5, y, [new $(null, 2, [Di, "Mod-Delete", nu, "Ctrl-Alt-Backspace"], null), new $(null, 1, [nu, "Alt-Delete"], null), new $(null, 1, [nu, "Alt-d"], null)], null), new v(null, 3, 5, y, [new $(null, 2, [nu, "Ctrl-ArrowDown", Su, r$], null), new $(null, 2, [Di, "PageDown", Su, r$], null), new $(null, 1, [nu, "Ctrl-v"], null)], null), new v(null, 3, 5, y, [new $(null, 2, [nu, "Ctrl-ArrowUp", Su, HP], null), new $(null, 2, [Di, "PageUp", Su, HP], null), new $(null, 1, [nu, "Alt-v"], null)], null), new v(null, 2, 5, y, [new $(
  null,
  1,
  [nu, "Cmd-ArrowRight"],
  null
), new $(null, 2, [nu, "Ctrl-e", Su, lJ], null)], null), new v(null, 1, 5, y, [new $(null, 2, [nu, "Alt-f", Su, nJ], null)], null), new v(null, 1, 5, y, [new $(null, 2, [Di, "Mod-u", Cd, !0], null)], null), new v(null, 2, 5, y, [new $(null, 2, [Di, "ArrowRight", Su, RN], null), new $(null, 2, [nu, "Ctrl-f", Su, RN], null)], null), new v(null, 1, 5, y, [new $(null, 1, [nu, "Ctrl-o"], null)], null), new v(null, 1, 5, y, [new $(null, 1, [nu, "Ctrl-t"], null)], null), new v(null, 2, 5, y, [new $(null, 2, [Di, "ArrowUp", Su, F$], null), new $(null, 2, [
  nu,
  "Ctrl-p",
  Su,
  F$
], null)], null), new v(null, 3, 5, y, [new $(null, 2, [nu, "Cmd-ArrowUp", Su, CC], null), new $(null, 2, [Di, "Mod-Home", Su, CC], null), new $(null, 1, [nu, "Alt-<"], null)], null)]), Ine = Gn([DB, Nee, LB, bJ, IB, WB, uF, oF, iQ, YB, NB, UX], [new v(null, 1, 5, y, [new $(null, 2, [Di, "Tab", ee, "Indent document (or selection)"], null)], null), new v(null, 1, 5, y, [new $(null, 4, [Di, "Alt-ArrowLeft", Su, WX, ee, "Move cursor one unit to the left (shift: selects this region)", Cd, !0], null)], null), new v(null, 1, 5, y, [new $(
  null,
  2,
  [Di, "Enter", ee, "Insert newline and indent"],
  null
)], null), new v(null, 2, 5, y, [new $(null, 2, [ee, "Grow selections", Di, "Alt-ArrowUp"], null), new $(null, 1, [Di, "Mod-1"], null)], null), new v(null, 1, 5, y, [new $(null, 2, [Di, "Ctrl-k", ee, "Remove all forms from cursor to end of line"], null)], null), new v(null, 2, 5, y, [new $(null, 3, [Di, "Ctrl-ArrowRight", ee, "Expand collection to include form to the right", Cd, !0], null), new $(null, 2, [Di, "Mod-Shift-k", Cd, !0], null)], null), new v(null, 2, 5, y, [new $(
  null,
  3,
  [Di, "Ctrl-ArrowLeft", ee, "Shrink collection forwards by one form", Cd, !0],
  null
), new $(null, 2, [Di, "Mod-Shift-j", Cd, !0], null)], null), new v(null, 1, 5, y, [new $(null, 2, [ee, "Shrink collection backwards by one form", Di, "Ctrl-Alt-ArrowRight"], null)], null), new v(null, 1, 5, y, [new $(null, 4, [Di, "Alt-ArrowRight", Su, YQ, ee, "Move cursor one unit to the right (shift: selects this region)", Cd, !0], null)], null), new v(null, 1, 5, y, [new $(null, 3, [ee, "Grow collection backwards by one form", Di, "Ctrl-Alt-ArrowLeft", Cd, !0], null)], null), new v(null, 1, 5, y, [new $(null, 3, [
  Di,
  "Alt-s",
  ee,
  "Lift contents of collection into parent",
  Cd,
  !0
], null)], null), new v(null, 2, 5, y, [new $(null, 2, [ee, "Shrink selections", Di, "Alt-ArrowDown"], null), new $(null, 1, [Di, "Mod-2"], null)], null)]), Rne = JL(Ixe), Rxe = JL(Ine).concat(Rne), Nxe = /* @__PURE__ */ function() {
  function e(n) {
    return { from: n.from + 1, to: n.to - 1 };
  }
  return { Vector: e, Map: e, List: e };
}(), Cxe = Bc(Gn([vwe, X0e, '"\\""', "VarName/Symbol", "DocString/...", vve, P0e, z1e, y_e, B1e, "Operator/Symbol", u1e, L_e, w0e], [Uo.tags.lineComment, Uo.tags.keyword, Uo.tags.string, Uo.tags.definition(Uo.tags.variableName), Uo.tags.emphasis, Uo.tags.atom, Uo.tags.atom, Uo.tags.number, Uo.tags.regexp, Uo.tags.string, Uo.tags.keyword, Uo.tags.comment, Uo.tags.keyword, Uo.tags.null])), Mxe = _g.parser, Pxe = [uk(_g.parser), mG(), TI(), i4, Ru.EditorState.transactionFilter.of(jI)];
new Xu.LanguageSupport(uk(Mxe), Pxe.slice(1));
var Nne;
Nne = JL(nr.l(Ine, DB, Te([LB, NB, IB, WB, YB, uF, oF]))).concat(Rne);
var PH = _g.parser, ur = Gn([v9, A7, q7, PR, H1e, vye, M7, Dwe, $R, U7, C7, E1e, zP, owe, IR, I7, MR, fwe, R7, c_e, N7, D7, eM, NR, Kwe], "4px #00f #30a #00c 6px #6F7A9A #404740 #EDEFF #256 #085 #708 2px #deeaf1 #F6F6F #167 #a11 #940 #50545f #164 #1B1D24 #219 #e40 #dee8ff #f00 #A4ADC".split(" ")), $H = Do.EditorView.theme(Bc(Gn(
  "& .ͼe;& .ͼc;&.cm-focused .cm-cursor;.cm-scroller;&.cm-focused;.cm-gutterElement;.cm-cursor;& .ͼd;.cm-gutters;& .ͼm;.cm-line;& .ͼg;.cm-content;& .ͼb;& .ͼk;& .ͼj;.cm-matchingBracket;& .ͼf;& .ͼl;& .ͼn;& .ͼi;& .ͼh;& .ͼ5;.cm-output-panel.error".split(";"),
  [new $(null, 1, [ma, ur.h ? ur.h(I7) : ur.call(null, I7)], null), new $(null, 1, [ma, ur.h ? ur.h(N7) : ur.call(null, N7)], null), new $(null, 1, [tW, "visible"], null), new $(null, 4, [Wq, "1px solid", L0e, ur.h ? ur.h(zP) : ur.call(null, zP), V0e, ur.h ? ur.h(v9) : ur.call(null, v9), i_e, "2px"], null), new $(null, 1, [_ge, "0 !important"], null), new $(null, 1, [S_e, "5px"], null), new $(null, 1, [tW, "hidden"], null), new $(null, 1, [ma, ur.h ? ur.h(R7) : ur.call(null, R7)], null), new $(null, 2, [Fq, "transparent", Wq, "none"], null), new $(null, 1, [ma, ur.h ? ur.h(MR) : ur.call(
    null,
    MR
  )], null), new $(null, 4, [bW, "0 9px", bve, "1.5", Fve, "14px", Hve, "Menlo, Consolas, Monaco, Liberation Mono, Lucida Console, monospace;"], null), new $(null, 1, [ma, ur.h ? ur.h(A7) : ur.call(null, A7)], null), new $(null, 3, [U0e, "pre-wrap", bW, "10px 0", d0e, "1 1 0"], null), new $(null, 1, [ma, ur.h ? ur.h(C7) : ur.call(null, C7)], null), new $(null, 1, [ma, ur.h ? ur.h($R) : ur.call(null, $R)], null), new $(null, 1, [ma, ur.h ? ur.h(IR) : ur.call(null, IR)], null), new $(null, 1, [Fq, ur.h ? ur.h(eM) : ur.call(null, eM)], null), new $(null, 1, [ma, ur.h ? ur.h(D7) : ur.call(null, D7)], null), new $(null, 1, [ma, ur.h ? ur.h(PR) : ur.call(null, PR)], null), new $(null, 1, [ma, ur.h ? ur.h(NR) : ur.call(null, NR)], null), new $(null, 1, [ma, ur.h ? ur.h(U7) : ur.call(null, U7)], null), new $(null, 1, [ma, ur.h ? ur.h(q7) : ur.call(null, q7)], null), new $(null, 1, [ma, ur.h ? ur.h(M7) : ur.call(null, M7)], null), new $(null, 1, [ma, "red"], null)]
))), $xe = gr.l(Te([new $(null, 4, [qee, function(e) {
  if (!or(e)) throw Error("Queue literal expects a vector for its elements.");
  return new g(null, Mve, new g(null, mQ, new g(null, e, null, 1, null), 2, null), 3, null);
}, cee, function(e) {
  if (typeof e != "string") throw Error("UUID literal expects a string as its representation.");
  try {
    return new L3(e.toLowerCase());
  } catch (n) {
    throw Error(n.message);
  }
}, jB, function(e) {
  if (typeof e != "string") throw Error("Instance literal expects a string for its timestamp.");
  try {
    var n = new Jn(
      function() {
        return hE;
      },
      Oge,
      Gn([kh, ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [!0, Kve, O_e, "cljs/reader.cljs", 26, 1, 92, 92, ue(new v(null, 1, 5, y, [Sr], null)), null, j(hE) ? hE.D : null])
    );
    return n.h ? n.h(e) : n.call(null, e);
  } catch (t) {
    throw Error(t.message);
  }
}, rJ, function(e) {
  if (!or(e) && !ci(e)) throw Error("JavaScript literal must use map or vector notation");
  if (ci(e) && !hu(Ide, xi(e))) throw Error("JavaScript literal keys must be strings or unqualified keywords");
  return new wG(e);
}], null)])), Lxe = function e(n, t) {
  return Rde(go.g(e, n), n, t);
}, Jx = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
Jx.l = function(e, n, t) {
  return e = j(e) ? _n.h([ye.h(e), ".", ye.h(n)].join("")) : n, t = In.g(tr, t), Dn.j(t, bne, e);
};
Jx.m = 2;
Jx.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var up = {}, bw = {}, K0 = sn(new Jn(function() {
  return Rv;
}, Ige, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Vee, Hye, "cljs/tools/reader/impl/commons.cljs", 19, 1, 97, 97, ue(new v(null, 1, 5, y, [d_e], null)), "Parses a string into a vector of the namespace and symbol", j(Rv) ? Rv.D : null]))), _D = sn(new Jn(function() {
  return sE;
}, gye, Gn([ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  Vee,
  P1e,
  "cljs/tools/reader/impl/commons.cljs",
  31,
  1,
  20,
  20,
  Rx,
  ue(new v(null, 2, 5, y, [Bl(xE, new $(null, 1, [Ft, zZ], null)), Tge], null)),
  "Checks whether the reader is at the start of a number literal",
  sE ? sE.D : null
]))), xD = sn(new Jn(function() {
  return aE;
}, _1e, Gn([kh, ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [!0, QB, m2e, "cljs/tools/reader/edn.cljs", 19, 1, 217, 217, ue(new v(null, 2, 5, y, [q0e, FB], null)), null, j(aE) ? aE.D : null]))), SD = sn(new Jn(function() {
  return oE;
}, __e, Gn([kh, ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [!0, QB, xge, "cljs/tools/reader/edn.cljs", 18, 1, 118, 118, ue(new v(null, 3, 5, y, [FB, Iwe, vw], null)), null, j(oE) ? oE.D : null]))), ED = sn(new Jn(function() {
  return cE;
}, G0e, Gn([kh, ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [
  !0,
  QB,
  _2e,
  "cljs/tools/reader/edn.cljs",
  27,
  1,
  324,
  324,
  ue(new v(null, 3, 5, y, [FB, ave, vw], null)),
  null,
  j(cE) ? cE.D : null
])));
A = pw.prototype;
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  switch (n instanceof de ? n.ca : null) {
    case "row":
      return this.dc;
    case "col":
      return this.col;
    default:
      return en.j(this.F, n, t);
  }
};
A.nb = function(e, n, t) {
  return wt.j(function(l, r) {
    var u = O.j(r, 0, null);
    return r = O.j(r, 1, null), n.j ? n.j(l, u, r) : n.call(null, l, u, r);
  }, t, this);
};
A.R = function(e, n, t) {
  return vr(n, function(l) {
    return vr(n, Wl, "", " ", "", t, l);
  }, "#edamame.impl.parser.Loc{", ", ", "}", t, he.g(new v(null, 2, 5, y, [new v(null, 2, 5, y, [Du, this.dc], null), new v(null, 2, 5, y, [tu, this.col], null)], null), this.F));
};
A.Xa = function() {
  return new hf(this, 2, new v(null, 2, 5, y, [Du, tu], null), j(this.F) ? eo(this.F) : ed());
};
A.U = function() {
  return this.K;
};
A.$ = function() {
  return 2 + Cn(this.F);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = 1435872067 ^ Na(this));
};
A.N = function(e, n) {
  return n != null && this.constructor === n.constructor && on.g(this.dc, n.dc) && on.g(this.col, n.col) && on.g(this.F, n.F);
};
A.sb = function(e, n) {
  return Ol(new gi(null, new $(null, 2, [tu, null, Du, null], null), null), n) ? nr.g(su(lr.g(Tt, this), this.K), n) : new pw(this.dc, this.col, this.K, Fo(nr.g(this.F, n)), null);
};
A.gb = function(e, n) {
  switch (n instanceof de ? n.ca : null) {
    case "row":
    case "col":
      return !0;
    default:
      return Ol(this.F, n);
  }
};
A.Aa = function(e, n, t) {
  return j(Ln.g ? Ln.g(Du, n) : Ln.call(null, Du, n)) ? new pw(t, this.col, this.K, this.F, null) : j(Ln.g ? Ln.g(tu, n) : Ln.call(null, tu, n)) ? new pw(this.dc, t, this.K, this.F, null) : new pw(this.dc, this.col, this.K, Dn.j(this.F, n, t), null);
};
A.W = function() {
  return z(he.g(new v(null, 2, 5, y, [new yl(Du, this.dc), new yl(tu, this.col)], null), this.F));
};
A.Z = function(e, n) {
  return new pw(this.dc, this.col, n, this.F, this.H);
};
A.aa = function(e, n) {
  return or(n) ? this.Aa(null, Ul(n, 0), Ul(n, 1)) : wt.j(Qo, this, n);
};
var K_ = _n.h("non-match"), Bxe = Error;
A = Eu.prototype;
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  switch (n instanceof de ? n.ca : null) {
    case "dispatch":
      return this.dispatch;
    case "deref":
      return this.deref;
    case "syntax-quote":
      return this.Ra;
    case "unquote":
      return this.Sa;
    case "unquote-splicing":
      return this.Ta;
    case "quote":
      return this.quote;
    case "fn":
      return this.ka;
    case "var":
      return this.za;
    case "read-eval":
      return this.Na;
    case "regex":
      return this.Oa;
    case "row-key":
      return this.Pa;
    case "col-key":
      return this.Ga;
    case "end-row-key":
      return this.Ja;
    case "end-col-key":
      return this.Ha;
    case "source":
      return this.source;
    case "source-key":
      return this.Qa;
    case "postprocess":
      return this.Ma;
    case "location?":
      return this.Ka;
    case "end-location":
      return this.Ia;
    case "ns-state":
      return this.La;
    default:
      return en.j(this.F, n, t);
  }
};
A.nb = function(e, n, t) {
  return wt.j(function(l, r) {
    var u = O.j(r, 0, null);
    return r = O.j(r, 1, null), n.j ? n.j(l, u, r) : n.call(null, l, u, r);
  }, t, this);
};
A.R = function(e, n, t) {
  return vr(n, function(l) {
    return vr(n, Wl, "", " ", "", t, l);
  }, "#edamame.impl.parser.Options{", ", ", "}", t, he.g(new v(null, 20, 5, y, [new v(null, 2, 5, y, [zf, this.dispatch], null), new v(null, 2, 5, y, [sf, this.deref], null), new v(null, 2, 5, y, [ba, this.Ra], null), new v(null, 2, 5, y, [nf, this.Sa], null), new v(null, 2, 5, y, [Wf, this.Ta], null), new v(null, 2, 5, y, [af, this.quote], null), new v(null, 2, 5, y, [qs, this.ka], null), new v(null, 2, 5, y, [$o, this.za], null), new v(null, 2, 5, y, [wh, this.Na], null), new v(
    null,
    2,
    5,
    y,
    [rf, this.Oa],
    null
  ), new v(null, 2, 5, y, [ka, this.Pa], null), new v(null, 2, 5, y, [Sa, this.Ga], null), new v(null, 2, 5, y, [Fc, this.Ja], null), new v(null, 2, 5, y, [Uc, this.Ha], null), new v(null, 2, 5, y, [co, this.source], null), new v(null, 2, 5, y, [vh, this.Qa], null), new v(null, 2, 5, y, [kp, this.Ma], null), new v(null, 2, 5, y, [Uf, this.Ka], null), new v(null, 2, 5, y, [dh, this.Ia], null), new v(null, 2, 5, y, [tf, this.La], null)], null), this.F));
};
A.Xa = function() {
  return new hf(this, 20, new v(null, 20, 5, y, [zf, sf, ba, nf, Wf, af, qs, $o, wh, rf, ka, Sa, Fc, Uc, co, vh, kp, Uf, dh, tf], null), j(this.F) ? eo(this.F) : ed());
};
A.U = function() {
  return this.K;
};
A.$ = function() {
  return 20 + Cn(this.F);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = -1037796634 ^ Na(this));
};
A.N = function(e, n) {
  return n != null && this.constructor === n.constructor && on.g(this.dispatch, n.dispatch) && on.g(this.deref, n.deref) && on.g(this.Ra, n.Ra) && on.g(this.Sa, n.Sa) && on.g(this.Ta, n.Ta) && on.g(this.quote, n.quote) && on.g(this.ka, n.ka) && on.g(this.qf, n.qf) && on.g(this.Na, n.Na) && on.g(this.Oa, n.Oa) && on.g(this.Pa, n.Pa) && on.g(this.Ga, n.Ga) && on.g(this.Ja, n.Ja) && on.g(this.Ha, n.Ha) && on.g(this.source, n.source) && on.g(this.Qa, n.Qa) && on.g(this.Ma, n.Ma) && on.g(this.Ka, n.Ka) && on.g(this.Ia, n.Ia) && on.g(this.La, n.La) && on.g(
    this.F,
    n.F
  );
};
A.sb = function(e, n) {
  return Ol(new gi(null, new $(null, 20, [qs, null, Wf, null, dh, null, Uf, null, nf, null, Fc, null, ka, null, Sa, null, vh, null, wh, null, tf, null, co, null, zf, null, ba, null, $o, null, af, null, sf, null, rf, null, Uc, null, kp, null], null), null), n) ? nr.g(su(lr.g(Tt, this), this.K), n) : new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, Fo(nr.g(this.F, n)), null);
};
A.gb = function(e, n) {
  switch (n instanceof de ? n.ca : null) {
    case "dispatch":
    case "deref":
    case "syntax-quote":
    case "unquote":
    case "unquote-splicing":
    case "quote":
    case "fn":
    case "var":
    case "read-eval":
    case "regex":
    case "row-key":
    case "col-key":
    case "end-row-key":
    case "end-col-key":
    case "source":
    case "source-key":
    case "postprocess":
    case "location?":
    case "end-location":
    case "ns-state":
      return !0;
    default:
      return Ol(this.F, n);
  }
};
A.Aa = function(e, n, t) {
  return j(Ln.g ? Ln.g(zf, n) : Ln.call(null, zf, n)) ? new Eu(t, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(sf, n) : Ln.call(null, sf, n)) ? new Eu(this.dispatch, t, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(
    ba,
    n
  ) : Ln.call(null, ba, n)) ? new Eu(this.dispatch, this.deref, t, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(nf, n) : Ln.call(null, nf, n)) ? new Eu(this.dispatch, this.deref, this.Ra, t, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(Wf, n) : Ln.call(null, Wf, n)) ? new Eu(
    this.dispatch,
    this.deref,
    this.Ra,
    this.Sa,
    t,
    this.quote,
    this.ka,
    this.za,
    this.Na,
    this.Oa,
    this.Pa,
    this.Ga,
    this.Ja,
    this.Ha,
    this.source,
    this.Qa,
    this.Ma,
    this.Ka,
    this.Ia,
    this.La,
    this.K,
    this.F,
    null
  ) : j(Ln.g ? Ln.g(af, n) : Ln.call(null, af, n)) ? new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, t, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(qs, n) : Ln.call(null, qs, n)) ? new Eu(
    this.dispatch,
    this.deref,
    this.Ra,
    this.Sa,
    this.Ta,
    this.quote,
    t,
    this.za,
    this.Na,
    this.Oa,
    this.Pa,
    this.Ga,
    this.Ja,
    this.Ha,
    this.source,
    this.Qa,
    this.Ma,
    this.Ka,
    this.Ia,
    this.La,
    this.K,
    this.F,
    null
  ) : j(Ln.g ? Ln.g($o, n) : Ln.call(null, $o, n)) ? new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, t, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(wh, n) : Ln.call(null, wh, n)) ? new Eu(
    this.dispatch,
    this.deref,
    this.Ra,
    this.Sa,
    this.Ta,
    this.quote,
    this.ka,
    this.za,
    t,
    this.Oa,
    this.Pa,
    this.Ga,
    this.Ja,
    this.Ha,
    this.source,
    this.Qa,
    this.Ma,
    this.Ka,
    this.Ia,
    this.La,
    this.K,
    this.F,
    null
  ) : j(Ln.g ? Ln.g(rf, n) : Ln.call(null, rf, n)) ? new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, t, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(ka, n) : Ln.call(null, ka, n)) ? new Eu(
    this.dispatch,
    this.deref,
    this.Ra,
    this.Sa,
    this.Ta,
    this.quote,
    this.ka,
    this.za,
    this.Na,
    this.Oa,
    t,
    this.Ga,
    this.Ja,
    this.Ha,
    this.source,
    this.Qa,
    this.Ma,
    this.Ka,
    this.Ia,
    this.La,
    this.K,
    this.F,
    null
  ) : j(Ln.g ? Ln.g(Sa, n) : Ln.call(null, Sa, n)) ? new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, t, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(Fc, n) : Ln.call(null, Fc, n)) ? new Eu(
    this.dispatch,
    this.deref,
    this.Ra,
    this.Sa,
    this.Ta,
    this.quote,
    this.ka,
    this.za,
    this.Na,
    this.Oa,
    this.Pa,
    this.Ga,
    t,
    this.Ha,
    this.source,
    this.Qa,
    this.Ma,
    this.Ka,
    this.Ia,
    this.La,
    this.K,
    this.F,
    null
  ) : j(Ln.g ? Ln.g(Uc, n) : Ln.call(null, Uc, n)) ? new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, t, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(co, n) : Ln.call(null, co, n)) ? new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, t, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(vh, n) : Ln.call(null, vh, n)) ? new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, t, this.Ma, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(kp, n) : Ln.call(null, kp, n)) ? new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, t, this.Ka, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(Uf, n) : Ln.call(
    null,
    Uf,
    n
  )) ? new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, t, this.Ia, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(dh, n) : Ln.call(null, dh, n)) ? new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, t, this.La, this.K, this.F, null) : j(Ln.g ? Ln.g(tf, n) : Ln.call(null, tf, n)) ? new Eu(
    this.dispatch,
    this.deref,
    this.Ra,
    this.Sa,
    this.Ta,
    this.quote,
    this.ka,
    this.za,
    this.Na,
    this.Oa,
    this.Pa,
    this.Ga,
    this.Ja,
    this.Ha,
    this.source,
    this.Qa,
    this.Ma,
    this.Ka,
    this.Ia,
    t,
    this.K,
    this.F,
    null
  ) : new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, this.K, Dn.j(this.F, n, t), null);
};
A.W = function() {
  return z(he.g(new v(null, 20, 5, y, [new yl(zf, this.dispatch), new yl(sf, this.deref), new yl(ba, this.Ra), new yl(nf, this.Sa), new yl(Wf, this.Ta), new yl(af, this.quote), new yl(qs, this.ka), new yl($o, this.za), new yl(wh, this.Na), new yl(rf, this.Oa), new yl(ka, this.Pa), new yl(Sa, this.Ga), new yl(Fc, this.Ja), new yl(Uc, this.Ha), new yl(co, this.source), new yl(vh, this.Qa), new yl(kp, this.Ma), new yl(Uf, this.Ka), new yl(dh, this.Ia), new yl(tf, this.La)], null), this.F));
};
A.Z = function(e, n) {
  return new Eu(this.dispatch, this.deref, this.Ra, this.Sa, this.Ta, this.quote, this.ka, this.za, this.Na, this.Oa, this.Pa, this.Ga, this.Ja, this.Ha, this.source, this.Qa, this.Ma, this.Ka, this.Ia, this.La, n, this.F, this.H);
};
A.aa = function(e, n) {
  return or(n) ? this.Aa(null, Ul(n, 0), Ul(n, 1)) : wt.j(Qo, this, n);
};
Z4.prototype.jf = Rn;
Z4.prototype.kf = function() {
  return this.ve;
};
var la = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
la.l = function(e) {
  var n = e != null && Rn === e.jf ? u5 : null;
  return j(n) || (n = e != null && Rn === e.pd ? e.type : null, j(n)) ? n : (n = e == null ? null : Vt(e), n = n == null ? null : zi.h(n), j(n) ? n : zh(e));
};
la.m = 1;
la.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
eB.prototype.ec = function() {
  return this.form;
};
hk._ = function() {
  return null;
};
A = Ic.prototype;
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  switch (n instanceof de ? n.ca : null) {
    case "f":
      return this.f;
    case "stack":
      return this.stack;
    default:
      return en.j(this.F, n, t);
  }
};
A.nb = function(e, n, t) {
  return wt.j(function(l, r) {
    var u = O.j(r, 0, null);
    return r = O.j(r, 1, null), n.j ? n.j(l, u, r) : n.call(null, l, u, r);
  }, t, this);
};
A.R = function(e, n, t) {
  return vr(n, function(l) {
    return vr(n, Wl, "", " ", "", t, l);
  }, "#sci.impl.types.NodeR{", ", ", "}", t, he.g(new v(null, 2, 5, y, [new v(null, 2, 5, y, [zy, this.f], null), new v(null, 2, 5, y, [Yy, this.stack], null)], null), this.F));
};
A.Xa = function() {
  return new hf(this, 2, new v(null, 2, 5, y, [zy, Yy], null), j(this.F) ? eo(this.F) : ed());
};
A.U = function() {
  return this.K;
};
A.$ = function() {
  return 2 + Cn(this.F);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = 256596302 ^ Na(this));
};
A.N = function(e, n) {
  return n != null && this.constructor === n.constructor && on.g(this.f, n.f) && on.g(this.stack, n.stack) && on.g(this.F, n.F);
};
A.lf = function() {
  return this.stack;
};
A.sb = function(e, n) {
  return Ol(new gi(null, new $(null, 2, [Yy, null, zy, null], null), null), n) ? nr.g(su(lr.g(Tt, this), this.K), n) : new Ic(this.f, this.stack, this.K, Fo(nr.g(this.F, n)), null);
};
A.gb = function(e, n) {
  switch (n instanceof de ? n.ca : null) {
    case "f":
    case "stack":
      return !0;
    default:
      return Ol(this.F, n);
  }
};
A.Aa = function(e, n, t) {
  return j(Ln.g ? Ln.g(zy, n) : Ln.call(null, zy, n)) ? new Ic(t, this.stack, this.K, this.F, null) : j(Ln.g ? Ln.g(Yy, n) : Ln.call(null, Yy, n)) ? new Ic(this.f, t, this.K, this.F, null) : new Ic(this.f, this.stack, this.K, Dn.j(this.F, n, t), null);
};
A.W = function() {
  return z(he.g(new v(null, 2, 5, y, [new yl(zy, this.f), new yl(Yy, this.stack)], null), this.F));
};
A.Z = function(e, n) {
  return new Ic(this.f, this.stack, n, this.F, this.H);
};
A.aa = function(e, n) {
  return or(n) ? this.Aa(null, Ul(n, 0), Ul(n, 1)) : wt.j(Qo, this, n);
};
var rs = !1, H$ = new nB(Tt, null), g5 = Qi(H$);
tB.prototype.od = function(e, n) {
  return this.val = n;
};
tB.prototype.ec = function() {
  return this.val;
};
pk._ = function() {
  return !1;
};
A = lB.prototype;
A.toString = function() {
  return ["Unbound: ", ye.h(this.ab)].join("");
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 0:
      return this.o();
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    case 3:
      return this.j(arguments[1], arguments[2], arguments[3]);
    case 4:
      return this.B(arguments[1], arguments[2], arguments[3], arguments[4]);
    case 5:
      return this.I(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    case 6:
      return this.T(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
    case 7:
      return this.ba(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7]
      );
    case 8:
      return this.ia(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8]);
    case 9:
      return this.va(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9]);
    case 10:
      return this.la(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10]);
    case 11:
      return this.ma(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11]);
    case 12:
      return this.na(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12]);
    case 13:
      return this.oa(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13]
      );
    case 14:
      return this.pa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14]);
    case 15:
      return this.qa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15]);
    case 16:
      return this.ra(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16]
      );
    case 17:
      return this.sa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15], arguments[16], arguments[17]);
    case 18:
      return this.ta(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18]
      );
    case 19:
      return this.ua(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15], arguments[16], arguments[17], arguments[18], arguments[19]);
    case 20:
      return this.Va(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18],
        arguments[19],
        arguments[20]
      );
    case 21:
      return this.Vb(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18],
        arguments[19],
        arguments[20],
        arguments[21]
      );
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.o = function() {
  return as(this.ab);
};
A.h = function() {
  return as(this.ab);
};
A.g = function() {
  return as(this.ab);
};
A.j = function() {
  return as(this.ab);
};
A.B = function() {
  return as(this.ab);
};
A.I = function() {
  return as(this.ab);
};
A.T = function() {
  return as(this.ab);
};
A.ba = function() {
  return as(this.ab);
};
A.ia = function() {
  return as(this.ab);
};
A.va = function() {
  return as(this.ab);
};
A.la = function() {
  return as(this.ab);
};
A.ma = function() {
  return as(this.ab);
};
A.na = function() {
  return as(this.ab);
};
A.oa = function() {
  return as(this.ab);
};
A.pa = function() {
  return as(this.ab);
};
A.qa = function() {
  return as(this.ab);
};
A.ra = function() {
  return as(this.ab);
};
A.sa = function() {
  return as(this.ab);
};
A.ta = function() {
  return as(this.ab);
};
A.ua = function() {
  return as(this.ab);
};
A.Va = function() {
  return as(this.ab);
};
A.Vb = function() {
  return as(this.ab);
};
var ud = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
ud.g = function(e, n) {
  var t = wx(e);
  return n = n.h ? n.h(t) : n.call(null, t), Fm(e, n);
};
ud.l = function(e, n, t) {
  return Fm(e, In.j(n, wx(e), t));
};
ud.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
ud.m = 2;
A = v2.prototype;
A.ec = function() {
  return this.data;
};
A.od = function(e, n) {
  return this.data = n;
};
A.toString = function() {
  return ye.h(EB.h(this.data));
};
A.U = function() {
  return this.data;
};
A.zc = function() {
  if (this.namespace == null) {
    var e = ye.h(this), n = yg.g(e, ".");
    return this.namespace = e = j(n) ? Si.j(e, 0, n) : e;
  }
  return this.namespace;
};
A.yc = function() {
  if (this.name == null) {
    var e = ye.h(this), n = yg.g(e, ".");
    return this.name = e = j(n) ? Si.g(e, n + 1) : e;
  }
  return this.name;
};
A = Ne.prototype;
A.toString = function() {
  return ["#'", ye.h(SG(this))].join("");
};
A.Ae = function() {
  return Ma.h(this.meta);
};
A.R = function(e, n, t) {
  return Br(n, "#'"), VO(SG(this), n, t);
};
A.U = function() {
  return this.meta;
};
A.Be = function(e, n) {
  e = this.root;
  var t = this.meta, l = rs;
  if (l = j(l) ? l : er(Re.h(t)), j(l)) this.root = n;
  else throw n = ie.h(t), n = Jo(n), e = this.Jc(null), Yr.g(["Built-in var #'", ye.h(n), "/", ye.h(e), " is read-only."].join(""), new $(null, 1, [$o, this], null));
  return epe(this, this.lc, e, n), n;
};
A.nf = function() {
  return this.root;
};
A.De = function() {
  var e = Zf.h(this.meta);
  return j(e) ? e : (e = Vt(this.root), e == null ? null : a5.h(e));
};
A.Ee = function(e, n) {
  return this.Fe = n;
};
A.Rd = function() {
  var e = this.meta, n = rs;
  if (n = j(n) ? n : er(Re.h(e)), j(n)) return this.root = new lB(this);
  throw e = ie.h(e), e = Jo(e), n = this.Jc(null), Yr.g(["Built-in var #'", ye.h(e), "/", ye.h(n), " is read-only."].join(""), new $(null, 1, [$o, this], null));
};
A.Ce = function() {
  return !(this.root instanceof lB);
};
A.od = function(e, n) {
  if (e = Q4(this), j(e)) n = ky(e, n);
  else if (j(rs)) n = this.root = n;
  else throw Error(["Can't change/establish root binding of ", ye.h(this), " with set"].join(""));
  return n;
};
A.ec = function() {
  return this.root;
};
A.Jc = function() {
  var e = te.h(this.meta);
  return j(e) ? e : this.Rb;
};
A.mf = function() {
  return this.we;
};
A.call = function(e) {
  switch (arguments.length - 1) {
    case 0:
      return this.o();
    case 1:
      return this.h(arguments[1]);
    case 2:
      return this.g(arguments[1], arguments[2]);
    case 3:
      return this.j(arguments[1], arguments[2], arguments[3]);
    case 4:
      return this.B(arguments[1], arguments[2], arguments[3], arguments[4]);
    case 5:
      return this.I(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5]);
    case 6:
      return this.T(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
    case 7:
      return this.ba(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7]
      );
    case 8:
      return this.ia(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8]);
    case 9:
      return this.va(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9]);
    case 10:
      return this.la(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10]);
    case 11:
      return this.ma(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11]);
    case 12:
      return this.na(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12]);
    case 13:
      return this.oa(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13]
      );
    case 14:
      return this.pa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14]);
    case 15:
      return this.qa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15]);
    case 16:
      return this.ra(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16]
      );
    case 17:
      return this.sa(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15], arguments[16], arguments[17]);
    case 18:
      return this.ta(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18]
      );
    case 19:
      return this.ua(arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6], arguments[7], arguments[8], arguments[9], arguments[10], arguments[11], arguments[12], arguments[13], arguments[14], arguments[15], arguments[16], arguments[17], arguments[18], arguments[19]);
    case 20:
      return this.Va(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18],
        arguments[19],
        arguments[20]
      );
    case 21:
      return this.Vb(
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5],
        arguments[6],
        arguments[7],
        arguments[8],
        arguments[9],
        arguments[10],
        arguments[11],
        arguments[12],
        arguments[13],
        arguments[14],
        arguments[15],
        arguments[16],
        arguments[17],
        arguments[18],
        arguments[19],
        arguments[20],
        arguments[21]
      );
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length - 1)].join(""));
  }
};
A.apply = function(e, n) {
  return this.call.apply(this, [this].concat(ki(n)));
};
A.o = function() {
  var e = sn(this);
  return e.o ? e.o() : e.call(null);
};
A.h = function(e) {
  var n = sn(this);
  return n.h ? n.h(e) : n.call(null, e);
};
A.g = function(e, n) {
  var t = sn(this);
  return t.g ? t.g(e, n) : t.call(null, e, n);
};
A.j = function(e, n, t) {
  var l = sn(this);
  return l.j ? l.j(e, n, t) : l.call(null, e, n, t);
};
A.B = function(e, n, t, l) {
  var r = sn(this);
  return r.B ? r.B(e, n, t, l) : r.call(null, e, n, t, l);
};
A.I = function(e, n, t, l, r) {
  var u = sn(this);
  return u.I ? u.I(e, n, t, l, r) : u.call(null, e, n, t, l, r);
};
A.T = function(e, n, t, l, r, u) {
  var o = sn(this);
  return o.T ? o.T(e, n, t, l, r, u) : o.call(null, e, n, t, l, r, u);
};
A.ba = function(e, n, t, l, r, u, o) {
  var a = sn(this);
  return a.ba ? a.ba(e, n, t, l, r, u, o) : a.call(null, e, n, t, l, r, u, o);
};
A.ia = function(e, n, t, l, r, u, o, a) {
  var h = sn(this);
  return h.ia ? h.ia(e, n, t, l, r, u, o, a) : h.call(null, e, n, t, l, r, u, o, a);
};
A.va = function(e, n, t, l, r, u, o, a, h) {
  var s = sn(this);
  return s.va ? s.va(e, n, t, l, r, u, o, a, h) : s.call(null, e, n, t, l, r, u, o, a, h);
};
A.la = function(e, n, t, l, r, u, o, a, h, s) {
  var d = sn(this);
  return d.la ? d.la(e, n, t, l, r, u, o, a, h, s) : d.call(null, e, n, t, l, r, u, o, a, h, s);
};
A.ma = function(e, n, t, l, r, u, o, a, h, s, d) {
  var p = sn(this);
  return p.ma ? p.ma(e, n, t, l, r, u, o, a, h, s, d) : p.call(null, e, n, t, l, r, u, o, a, h, s, d);
};
A.na = function(e, n, t, l, r, u, o, a, h, s, d, p) {
  var _ = sn(this);
  return _.na ? _.na(e, n, t, l, r, u, o, a, h, s, d, p) : _.call(null, e, n, t, l, r, u, o, a, h, s, d, p);
};
A.oa = function(e, n, t, l, r, u, o, a, h, s, d, p, _) {
  var R = sn(this);
  return R.oa ? R.oa(e, n, t, l, r, u, o, a, h, s, d, p, _) : R.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _);
};
A.pa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R) {
  var F = sn(this);
  return F.pa ? F.pa(e, n, t, l, r, u, o, a, h, s, d, p, _, R) : F.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R);
};
A.qa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F) {
  var L = sn(this);
  return L.qa ? L.qa(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F) : L.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F);
};
A.ra = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L) {
  var G = sn(this);
  return G.ra ? G.ra(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L) : G.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L);
};
A.sa = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G) {
  var J = sn(this);
  return J.sa ? J.sa(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G) : J.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G);
};
A.ta = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J) {
  var we = sn(this);
  return we.ta ? we.ta(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J) : we.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J);
};
A.ua = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we) {
  var ce = sn(this);
  return ce.ua ? ce.ua(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we) : ce.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we);
};
A.Va = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce) {
  var xe = sn(this);
  return xe.Va ? xe.Va(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce) : xe.call(null, e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce);
};
A.Vb = function(e, n, t, l, r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe) {
  return In.l(sn(this), e, n, t, l, Te([r, u, o, a, h, s, d, p, _, R, F, L, G, J, we, ce, xe]));
};
A.jb = function() {
  if (j(this.Fe)) {
    var e = Q4(this);
    return j(e) ? gx(e) : this.root;
  }
  return this.root;
};
q3.prototype.toString = function() {
  return ye.h(this.name);
};
q3.prototype.Jc = function() {
  return this.name;
};
q3.prototype.U = function() {
  return this.meta;
};
Sp.g(F1e, bm);
Sp.g(Vx, bm);
var c1 = null, A_ = !1, Cne = _n.h("append"), G0 = _n.h("loop"), Xd = _n.h("recur"), Mne = {}, Pne = Qi(null), $ne = Qi(null), Lne = Qi(null), xg = Qi(null), Bne = Qi(null), pF = Qi(null), Fne = Qi(null), Vne = Qi(null), Yne = Qi(null), Une = Qi(null), $b = function e(n, t) {
  var l = Dp(n);
  return new rr(null, function() {
    var r = z(t);
    if (r) {
      var u = I(r), o = kt(u, vo.g(l, W(r)));
      return kt(o, function() {
        var a = new rr(null, function() {
          return uu.g(Cn(o), r);
        }, null, null);
        return e.g ? e.g(n, a) : e.call(null, n, a);
      }());
    }
    return null;
  }, null, null);
}, u4 = new gi(null, new $(null, 22, [
  T1,
  "null",
  cF,
  "null",
  C0,
  "null",
  Kx,
  "null",
  mi,
  "null",
  r4,
  "null",
  Uk,
  "null",
  si,
  "null",
  lf,
  "null",
  ih,
  "null",
  B0,
  "null",
  r1,
  "null",
  BB,
  "null",
  jk,
  "null",
  jb,
  "null",
  Kf,
  "null",
  $u,
  "null",
  L0,
  "null",
  l4,
  "null",
  P0,
  "null",
  Yc,
  "null",
  hF,
  "null"
], null), null), qne = oc(R0, null), Le = oc(ks, null), Iu = W3(yQ, null, new $(null, 2, [ee, `The path of the file being evaluated, as a String.

  When there is no file, e.g. in the REPL, the value is not defined.`, ie, Le], null)), Mi = W3(gne, qne, new $(
  null,
  2,
  [ie, Le, ee, "A sci.lang.Namespace object representing the current namespace."],
  null
)), w5, Fxe = kr.h(Tt), Vxe = kr.h(Tt), Yxe = kr.h(Tt), Uxe = kr.h(Tt), qxe = en.j(Tt, vg, es.o ? es.o() : es.call(null));
w5 = new Np(_n.g("sci.impl.deftype", "to-string"), la, ai, qxe, Fxe, Vxe, Yxe, Uxe);
w5.$a(null, ai, function(e) {
  var n = la(e);
  return [Yi(n), ".", ml(n), "@", ye.h(Uu(e).toString(16))].join("");
});
A = sB.prototype;
A.toString = function() {
  return w5.h(this);
};
A.pd = Rn;
A.ze = function(e, n, t) {
  return this.ib = Dn.j(this.ib, n, t), t;
};
A.R = function(e, n, t) {
  return e = this.za, j(e) ? (e = Vt(e), e = Ab.h(e), j(e) ? e.j ? e.j(this, n, t) : e.call(null, this, n, t) : Mh(n, Te([XU(this)]))) : Mh(n, Te([XU(this)]));
};
A.ec = function() {
  return this.ib;
};
var Lb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], 5 < t.length ? new hn(t.slice(5), 0, null) : null);
};
Lb.l = function(e, n, t, l, r, u) {
  if (n = z(e), I(n), W(n), j(Tb.h(t))) return kt(u2e, tn(e));
  e = ["->", ye.h(l)].join(""), e = _n.h(e);
  var o = _n.h([ye.h(B3(Vs())), ".", ye.h(l)].join(""));
  n = $b(jp, u);
  var a = Us(r);
  return u = na.l(function(h, s) {
    function d(G) {
      return b3(G) ? _n.g(L, ye.h(G)) : G;
    }
    h = z(h);
    var p = I(h);
    h = W(h), h = xy(I, h);
    var _ = function() {
      var G = Ws.h(t), J = sn(xg);
      return J.j ? J.j(t, G, p) : J.call(null, t, G, p);
    }(), R = function() {
      if (j(_)) return _;
      var G = on.g(kne, p) ? Gq : null;
      return j(G) ? G : on.g(TX, p) ? EW : null;
    }();
    j(R) || mu(
      ["Protocol not found: ", ye.h(p)].join(""),
      s
    );
    var F = Qs(R) ? sn(R) : R;
    s = $o.h(F), j(s) && ud.l(s, Ri, Te([s5, Ff.g(yt, ss), _n.h(ye.h(o))])), s = ie.h(F);
    var L = j(s) ? ye.h(Jo(s)) : on.g(Gq, F) ? "sci.impl.deftype" : null;
    return bt.g(function(G) {
      var J = O.j(G, 0, null);
      if (G = O.j(G, 1, null), Ln(EW, F) && on.g(nxe, J)) return ve.h(z(he.l(new g(null, lF, null, 1, null), new g(null, ve.h(z(he.g(new g(null, $u, null, 1, null), new g(null, l, null, 1, null)))), null, 1, null), Te([new g(null, Sb, null, 1, null), new g(null, Ab, null, 1, null), new g(
        null,
        ve.h(z(he.g(new g(null, sc, null, 1, null), new g(null, tn(I(G)), null, 1, null)))),
        null,
        1,
        null
      )]))));
      G = bt.g(tn, G);
      var we = wo.g(function(ce) {
        var xe = I(ce);
        ce = tn(ce), xe = bG(xe, ce);
        var $e = yh.h(xe);
        xe = uc.h(xe), ce = I($e), $e = tn($e), $e = Et(kt(U_, $e));
        var je = Xr.o(), E = he.g(new v(null, 2, 5, y, [je, new g(null, cve, new g(null, U_, null, 1, null), 2, null)], null), na.l(function(P) {
          return new v(null, 2, 5, y, [P, new g(null, Nk, new g(null, je, new g(null, new g(null, Fr, new g(null, P, null, 1, null), 2, null), null, 1, null), 2, null), 3, null)], null);
        }, Te([wt.j(Aa, a, $e)])));
        return ce = he.g(E, new v(null, 2, 5, y, [ce, U_], null)), ce = Et(ce), ve.h(z(he.g(new g(
          null,
          $e,
          null,
          1,
          null
        ), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, ce, null, 1, null), Te([xe])))), null, 1, null))));
      }, G);
      return G = Dn.l(t, ZZ, a, Te([SQ, _a(a, bt.g(function(ce) {
        return function(xe, $e) {
          return ck(xe, ce, $e);
        };
      }, a))])), J = ve.h(z(he.l(new g(null, xw, null, 1, null), new g(null, d(J), null, 1, null), Te([new g(null, o, null, 1, null), we])))), we = sn(Une), we.g ? we.g(G, J) : we.call(null, G, J);
    }, h);
  }, Te([n, u])), ve.h(z(he.l(new g(null, mi, null, 1, null), new g(null, ve.h(z(he.l(
    new g(null, eN, null, 1, null),
    new g(null, l, null, 1, null),
    Te([new g(null, e, null, 1, null)])
  ))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Yc, null, 1, null), new g(null, Bl(l, new $(null, 1, [Cye, !0], null)), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, iwe, null, 1, null), new g(null, new $(null, 4, [EB, new g(null, Fr, new g(null, o, null, 1, null), 2, null), f0e, o, Ik, new g(null, $u, new g(null, e, null, 1, null), 2, null), One, new g(null, $u, new g(null, l, null, 1, null), 2, null)], null), null, 1, null)))), null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Zx, null, 1, null), new g(
    null,
    e,
    null,
    1,
    null
  ), Te([new g(null, Et(ve.h(z(he.g(new g(null, et, null, 1, null), new g(null, jW, null, 1, null))))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, e_e, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, o, null, 1, null)))), null, 1, null), Te([new g(null, o, null, 1, null), new g(null, ve.h(z(he.g(new g(null, $u, null, 1, null), new g(null, l, null, 1, null)))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Tne, null, 1, null), new g(null, new g(null, Fr, new g(null, r, null, 1, null), 2, null), null, 1, null), Te([new g(
    null,
    jW,
    null,
    1,
    null
  )])))), null, 1, null)])))), null, 1, null)])))), null, 1, null), u, new g(null, l, null, 1, null)]))));
};
Lb.m = 5;
Lb.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  l = I(r);
  var u = W(r);
  return r = I(u), u = W(u), this.l(n, e, t, l, r, u);
};
var Bb = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Bb.j = function(e, n, t) {
  var l = y2(n);
  return ud.g(E1(e), function(r) {
    return Sp.j(r, l, t);
  }), null;
};
Bb.B = function(e, n, t, l) {
  return e = y2(t), Sp.j(n, e, l);
};
Bb.m = 4;
var Fb = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Fb.j = function(e, n, t) {
  var l = y2(n);
  return ud.g(E1(e), function(r) {
    return Ly.j(r, l, t);
  }), null;
};
Fb.B = function(e, n, t, l) {
  return e = y2(t), Ly.j(n, e, l);
};
Fb.m = 4;
var Vb = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Vb.j = function(e, n, t) {
  return e = sn(E1(e)), w2(e, y2(n), t);
};
Vb.B = function(e, n, t, l) {
  return w2(n, y2(t), l);
};
Vb.m = 4;
var Yb = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Yb.g = function(e, n) {
  return e = sn(E1(e)), qK(e, n);
};
Yb.j = function(e, n, t) {
  return qK(n, t);
};
Yb.m = 3;
var Ub = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Ub.g = function(e, n) {
  return e = sn(E1(e)), WK(e, n);
};
Ub.j = function(e, n, t) {
  return WK(n, t);
};
Ub.m = 3;
var qb = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
qb.g = function(e, n) {
  return e = sn(E1(e)), VL(e, n);
};
qb.j = function(e, n, t) {
  return VL(n, t);
};
qb.m = 3;
var Wb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], 4 < t.length ? new hn(t.slice(4), 0, null) : null);
};
Wb.l = function(e, n, t, l, r) {
  e = typeof I(r) == "string" ? I(r) : null, r = typeof I(r) == "string" ? W(r) : r;
  var u = ci(I(r)) ? I(r) : Tt;
  if (n = ci(I(r)) ? W(r) : r, r = I(n), n = W(n), e = j(e) ? Dn.j(u, ee, e) : u, e = j(Vt(l)) ? yt.g(Vt(l), e) : e, l = Bl(l, e), on.g(Cn(n), 1)) throw Error("The syntax for defmulti has changed. Example: (defmulti name dispatch-fn :default dispatch-value)");
  return n = In.g(tr, n), u = en.j(n, ai, ai), t = en.j(n, vg, E1(t)), tpe(n), ve.h(z(he.l(new g(null, x1e, null, 1, null), new g(null, Bl(l, e), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(
    null,
    Yl,
    null,
    1,
    null
  ), new g(null, Et(ve.h(z(he.l(new g(null, eW, null, 1, null), new g(null, ve.h(z(he.g(new g(null, RS, null, 1, null), new g(null, In.g(ah, ve.h(z(he.o()))), null, 1, null)))), null, 1, null), Te([new g(null, _H, null, 1, null), new g(null, ve.h(z(he.g(new g(null, RS, null, 1, null), new g(null, In.g(ah, ve.h(z(he.o()))), null, 1, null)))), null, 1, null), new g(null, FW, null, 1, null), new g(null, ve.h(z(he.g(new g(null, RS, null, 1, null), new g(null, In.g(ah, ve.h(z(he.o()))), null, 1, null)))), null, 1, null), new g(null, PW, null, 1, null), new g(null, ve.h(z(he.g(new g(
    null,
    RS,
    null,
    1,
    null
  ), new g(null, In.g(ah, ve.h(z(he.o()))), null, 1, null)))), null, 1, null)]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, V2e, null, 1, null), new g(null, _n.h(ml(l)), null, 1, null), Te([new g(null, r, null, 1, null), new g(null, u, null, 1, null), new g(null, t, null, 1, null), new g(null, eW, null, 1, null), new g(null, _H, null, 1, null), new g(null, FW, null, 1, null), new g(null, PW, null, 1, null)])))), null, 1, null)])))), null, 1, null)]))));
};
Wb.m = 4;
Wb.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
var Hb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], 4 < t.length ? new hn(t.slice(4), 0, null) : null);
};
Hb.l = function(e, n, t, l, r) {
  return new g(null, Nge, new g(null, t, new g(null, l, new g(null, us.g(Kx, r), null, 1, null), 2, null), 3, null), 4, null);
};
Hb.m = 4;
Hb.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
var mF = ye.h(Fwe), zb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], 4 < t.length ? new hn(t.slice(4), 0, null) : null);
};
zb.l = function(e, n, t, l, r) {
  n = function() {
    var d = I(r);
    return typeof d == "string" ? new v(null, 2, 5, y, [d, tn(r)], null) : new v(null, 2, 5, y, [null, r], null);
  }(), e = O.j(n, 0, null);
  var u = O.j(n, 1, null);
  t = function() {
    var d = I(u);
    return d instanceof de ? new v(null, 2, 5, y, [Qu([d, Vr(u)]), va(u)], null) : new v(null, 2, 5, y, [null, u], null);
  }(), n = O.j(t, 0, null), t = O.j(t, 1, null);
  var o = lpe(t), a = ye.h(Vs()), h = _n.g(a, ye.h(l)), s = Fy.h(n);
  return ve.h(z(he.l(new g(null, mi, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yc, null, 1, null), new g(null, Bl(l, new $(
    null,
    1,
    [ee, e],
    null
  )), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, U2e, null, 1, null), new g(null, In.g(ah, ve.h(z(he.l(new g(null, i1, null, 1, null), new g(null, In.g(id, ve.h(z(he.o()))), null, 1, null), Te([new g(null, te, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, h, null, 1, null)))), null, 1, null), new g(null, ie, null, 1, null), new g(null, n2e, null, 1, null), new g(null, fve, null, 1, null), new g(null, new g(null, Fr, new g(null, o, null, 1, null), 2, null), null, 1, null), new g(null, $o, null, 1, null), new g(null, ve.h(z(he.g(new g(
    null,
    $u,
    null,
    1,
    null
  ), new g(null, h, null, 1, null)))), null, 1, null)]))))), null, 1, null), Te([new g(null, s, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Sb, null, 1, null), new g(null, Fy, null, 1, null), Te([new g(null, !0, null, 1, null)])))), null, 1, null)])))), null, 1, null)])))), null, 1, null), Te([bt.g(function(d) {
    var p = z(d);
    d = I(p), W(p), p = _n.g(a, ye.h(d));
    var _ = pg(en.g(o, ts.h(d)), new v(null, 2, 5, y, [ee, ne], null));
    return _ = Ri.j(_, ne, function(R) {
      return new g(null, Fr, new g(null, R, null, 1, null), 2, null);
    }), _ = new v(null, 2, 5, y, [ve.h(z(he.l(new g(
      null,
      i0e,
      null,
      1,
      null
    ), new g(null, d, null, 1, null), Te([new g(null, _, null, 1, null), new g(null, p6, null, 1, null)])))), ve.h(z(he.l(new g(null, xw, null, 1, null), new g(null, d, null, 1, null), Te([new g(null, u5, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, p_, null, 1, null), new g(null, et, null, 1, null), Te([new g(null, e6, null, 1, null)]))))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, gW, null, 1, null), new g(
      null,
      ve.h(z(he.g(new g(null, dxe, null, 1, null), new g(null, p_, null, 1, null)))),
      null,
      1,
      null
    ))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Zd, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, MW, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Ky, null, 1, null), new g(null, gW, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, d, null, 1, null)))), null, 1, null)])))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, kf, null, 1, null), new g(null, MW, null, 1, null), Te([new g(null, p_, null, 1, null), new g(null, e6, null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.l(new g(
      null,
      Zd,
      null,
      1,
      null
    ), new g(null, Et(ve.h(z(he.g(new g(null, aH, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yh, null, 1, null), new g(null, d, null, 1, null), Te([new g(null, ai, null, 1, null)])))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, kf, null, 1, null), new g(null, aH, null, 1, null), Te([new g(null, p_, null, 1, null), new g(null, e6, null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.g(new g(null, rp, null, 1, null), new g(null, ve.h(z(he.l(new g(null, k2e, null, 1, null), new g(null, "No method ", null, 1, null), Te([new g(
      null,
      ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, d, null, 1, null)))),
      null,
      1,
      null
    ), new g(null, " found for: ", null, 1, null), new g(null, ve.h(z(he.g(new g(null, Y0, null, 1, null), new g(null, p_, null, 1, null)))), null, 1, null)])))), null, 1, null)))), null, 1, null)])))), null, 1, null)])))), null, 1, null)])))), null, 1, null)]))))], null), p = j(s) ? yt.g(_, ve.h(z(he.l(new g(null, xw, null, 1, null), new g(null, d, null, 1, null), Te([new g(null, ai, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, sv, null, 1, null), new g(null, et, null, 1, null), Te([new g(
      null,
      T6,
      null,
      1,
      null
    )]))))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, uW, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Yx, null, 1, null), new g(null, sv, null, 1, null)))), null, 1, null), Te([new g(null, dv, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Ky, null, 1, null), new g(null, uW, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, p, null, 1, null)))), null, 1, null)])))), null, 1, null)]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(
      null,
      si,
      null,
      1,
      null
    ), new g(null, dv, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, kf, null, 1, null), new g(null, dv, null, 1, null), Te([new g(null, sv, null, 1, null), new g(null, T6, null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, dv, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yh, null, 1, null), new g(null, d, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Y0, null, 1, null), new g(null, sv, null, 1, null)))), null, 1, null)])))), null, 1, null), Te([
      new g(null, Yq, null, 1, null),
      new g(null, ve.h(z(he.l(new g(null, Yh, null, 1, null), new g(null, d, null, 1, null), Te([new g(null, ai, null, 1, null)])))), null, 1, null)
    ]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Wx, null, 1, null), new g(null, dv, null, 1, null), Te([new g(null, Yq, null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, kf, null, 1, null), new g(null, dv, null, 1, null), Te([new g(null, sv, null, 1, null), new g(null, T6, null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.g(new g(
      null,
      rp,
      null,
      1,
      null
    ), new g(null, ve.h(z(he.l(new g(null, lf, null, 1, null), new g(null, Cx, null, 1, null), Te([new g(
      null,
      ve.h(z(he.l(new g(null, lg, null, 1, null), new g(null, "No implementation of method: ", null, 1, null), Te([new g(null, ts.h(d), null, 1, null), new g(null, " of protocol: ", null, 1, null), new g(null, ve.h(z(he.g(new g(null, $u, null, 1, null), new g(null, l, null, 1, null)))), null, 1, null), new g(null, " found for: ", null, 1, null), new g(null, ve.h(z(he.g(new g(null, p6, null, 1, null), new g(null, sv, null, 1, null)))), null, 1, null)])))),
      null,
      1,
      null
    )])))), null, 1, null)))), null, 1, null)])))), null, 1, null)])))), null, 1, null)])))), null, 1, null)])))), null, 1, null)]))))) : yt.g(_, ve.h(z(he.l(new g(null, xw, null, 1, null), new g(null, d, null, 1, null), Te([new g(null, ai, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, PS, null, 1, null), new g(null, et, null, 1, null), Te([new g(null, _W, null, 1, null)]))))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, i6, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yh, null, 1, null), new g(
      null,
      d,
      null,
      1,
      null
    ), Te([new g(null, ve.h(z(he.g(new g(null, Y0, null, 1, null), new g(null, PS, null, 1, null)))), null, 1, null)])))), null, 1, null), Te([new g(null, Jq, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yh, null, 1, null), new g(null, d, null, 1, null), Te([new g(null, ai, null, 1, null)])))), null, 1, null)]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Wx, null, 1, null), new g(null, i6, null, 1, null), Te([new g(null, Jq, null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(
      null,
      kf,
      null,
      1,
      null
    ), new g(null, i6, null, 1, null), Te([new g(null, PS, null, 1, null), new g(null, _W, null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.g(new g(null, rp, null, 1, null), new g(null, ve.h(z(he.l(new g(null, lf, null, 1, null), new g(null, Cx, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, lg, null, 1, null), new g(null, "No implementation of method: ", null, 1, null), Te([new g(null, ts.h(d), null, 1, null), new g(null, " of protocol: ", null, 1, null), new g(
      null,
      ve.h(z(he.g(new g(null, $u, null, 1, null), new g(null, l, null, 1, null)))),
      null,
      1,
      null
    ), new g(null, " found for: ", null, 1, null), new g(null, ve.h(z(he.g(new g(null, p6, null, 1, null), new g(null, PS, null, 1, null)))), null, 1, null)])))), null, 1, null)])))), null, 1, null)))), null, 1, null)])))), null, 1, null)])))), null, 1, null)]))))), ve.h(z(he.l(new g(null, mi, null, 1, null), p, Te([new g(null, ve.h(z(he.l(new g(null, Yc, null, 1, null), new g(null, l, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, qB, null, 1, null), new g(null, l, null, 1, null), Te([new g(null, i1, null, 1, null), new g(null, sF, null, 1, null), new g(
      null,
      d,
      null,
      1,
      null
    )])))), null, 1, null)])))), null, 1, null)]))));
  }, t), new g(null, new g(null, Fr, new g(null, l, null, 1, null), 2, null), null, 1, null)]))));
};
zb.m = 4;
zb.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
var Kb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
Kb.l = function(e, n, t) {
  for (var l = z(Mo.g(2, t)), r = null, u = 0, o = 0; ; ) if (o < u) {
    for (var a = r.Y(null, o), h = O.j(a, 0, null), s = O.j(a, 1, null), d = Fy.h(h), p = ie.h(h), _ = Jo(p), R = j(d) ? ye.h(_) : null, F = z(s), L = null, G = 0, J = 0; ; ) if (J < G) {
      var we = L.Y(null, J), ce = O.j(we, 0, null), xe = O.j(we, 1, null), $e = ml(ce), je = _n.h($e), E = sn(Or.h(e)), P = xr.g(E, new v(null, 3, 5, y, [Il, _, je], null)), K = sn(P);
      E_(K, n, j(d) ? function() {
        var tl = _n.g(R, $e);
        return function(Zt, Ql, jl, Sl, gl, jr, Kt, nl, Pr, ii, Ar, Ml, Rl, Se, se, Ee, Ge) {
          return function() {
            function vn(Un, Pe) {
              var C = null;
              if (1 < arguments.length) {
                C = 0;
                for (var re = Array(arguments.length - 1); C < re.length; ) re[C] = arguments[C + 1], ++C;
                C = new hn(re, 0, null);
              }
              return Kn.call(this, Un, C);
            }
            function Kn(Un, Pe) {
              var C = Vt(Un);
              return j(C) ? (C = en.g(C, Pr), j(C) ? In.j(C, Un, Pe) : In.j(Ge, Un, Pe)) : In.j(Ge, Un, Pe);
            }
            return vn.m = 1, vn.v = function(Un) {
              var Pe = I(Un);
              return Un = tn(Un), Kn(Pe, Un);
            }, vn.l = Kn, vn;
          }();
        }(F, L, G, J, l, r, u, o, tl, $e, je, E, P, K, we, ce, xe);
      }() : xe), J += 1;
    } else {
      var H = z(F);
      if (H) {
        var U = H;
        if (oi(U)) {
          var Me = Jr(U);
          t = Wr(U);
          var le = Me;
          Me = Cn(Me), F = t, L = le, G = Me;
        } else {
          var Ce = I(U), Ye = O.j(Ce, 0, null), B = O.j(Ce, 1, null), q = ml(Ye), me = _n.h(q), Ae = sn(Or.h(e)), Fe = xr.g(Ae, new v(null, 3, 5, y, [Il, _, me], null)), ln = sn(Fe);
          E_(ln, n, j(d) ? function() {
            var tl = _n.g(R, q);
            return function(Zt, Ql, jl, Sl, gl, jr, Kt, nl, Pr, ii, Ar, Ml, Rl, Se, se, Ee, Ge) {
              return function() {
                function vn(Un, Pe) {
                  var C = null;
                  if (1 < arguments.length) {
                    C = 0;
                    for (var re = Array(arguments.length - 1); C < re.length; ) re[C] = arguments[C + 1], ++C;
                    C = new hn(re, 0, null);
                  }
                  return Kn.call(this, Un, C);
                }
                function Kn(Un, Pe) {
                  var C = Vt(Un);
                  return j(C) ? (C = en.g(C, Pr), j(C) ? In.j(C, Un, Pe) : In.j(Ge, Un, Pe)) : In.j(Ge, Un, Pe);
                }
                return vn.m = 1, vn.v = function(Un) {
                  var Pe = I(Un);
                  return Un = tn(Un), Kn(Pe, Un);
                }, vn.l = Kn, vn;
              }();
            }(F, L, G, J, l, r, u, o, tl, q, me, Ae, Fe, ln, Ce, Ye, B);
          }() : B), F = W(U), L = null, G = 0;
        }
        J = 0;
      } else break;
    }
    o += 1;
  } else {
    var Be = z(l);
    if (Be) {
      var Ze = Be;
      if (oi(Ze)) Me = Jr(Ze), t = Wr(Ze), le = Me, Me = Cn(Me), l = t, r = le, u = Me;
      else {
        var pn = I(Ze);
        h = O.j(pn, 0, null), s = O.j(pn, 1, null);
        for (var xn = Fy.h(h), Nn = ie.h(h), at = Jo(Nn), Yt = j(xn) ? ye.h(at) : null, jt = z(s), Cl = null, fn = 0, _e = 0; ; ) if (_e < fn) {
          var Ve = Cl.Y(null, _e), an = O.j(Ve, 0, null), En = O.j(Ve, 1, null), Qn = ml(an), Vn = _n.h(Qn), ot = sn(Or.h(e)), Nt = xr.g(ot, new v(null, 3, 5, y, [Il, at, Vn], null)), zt = sn(Nt);
          E_(zt, n, j(xn) ? function() {
            var tl = _n.g(Yt, Qn);
            return function(Zt, Ql, jl, Sl, gl, jr, Kt, nl, Pr, ii, Ar, Ml, Rl, Se, se, Ee, Ge) {
              return function() {
                function vn(Un, Pe) {
                  var C = null;
                  if (1 < arguments.length) {
                    C = 0;
                    for (var re = Array(arguments.length - 1); C < re.length; ) re[C] = arguments[C + 1], ++C;
                    C = new hn(re, 0, null);
                  }
                  return Kn.call(this, Un, C);
                }
                function Kn(Un, Pe) {
                  var C = Vt(Un);
                  return j(C) ? (C = en.g(C, Pr), j(C) ? In.j(C, Un, Pe) : In.j(Ge, Un, Pe)) : In.j(Ge, Un, Pe);
                }
                return vn.m = 1, vn.v = function(Un) {
                  var Pe = I(Un);
                  return Un = tn(Un), Kn(Pe, Un);
                }, vn.l = Kn, vn;
              }();
            }(jt, Cl, fn, _e, l, r, u, o, tl, Qn, Vn, ot, Nt, zt, Ve, an, En);
          }() : En), _e += 1;
        } else {
          var Pt = z(jt);
          if (Pt) {
            var ol = Pt;
            if (oi(ol)) Me = Jr(ol), t = Wr(ol), le = Me, Me = Cn(Me), jt = t, Cl = le, fn = Me;
            else {
              var St = I(ol), pr = O.j(St, 0, null), ul = O.j(St, 1, null), Rr = ml(pr), ql = _n.h(Rr), Mr = sn(Or.h(e)), wi = xr.g(Mr, new v(null, 3, 5, y, [Il, at, ql], null)), bl = sn(wi);
              E_(bl, n, j(xn) ? function() {
                var tl = _n.g(Yt, Rr);
                return function(Zt, Ql, jl, Sl, gl, jr, Kt, nl, Pr, ii, Ar, Ml, Rl, Se, se, Ee, Ge) {
                  return function() {
                    function vn(Un, Pe) {
                      var C = null;
                      if (1 < arguments.length) {
                        C = 0;
                        for (var re = Array(arguments.length - 1); C < re.length; ) re[C] = arguments[C + 1], ++C;
                        C = new hn(re, 0, null);
                      }
                      return Kn.call(this, Un, C);
                    }
                    function Kn(Un, Pe) {
                      var C = Vt(Un);
                      return j(C) ? (C = en.g(C, Pr), j(C) ? In.j(C, Un, Pe) : In.j(Ge, Un, Pe)) : In.j(Ge, Un, Pe);
                    }
                    return vn.m = 1, vn.v = function(Un) {
                      var Pe = I(Un);
                      return Un = tn(Un), Kn(Pe, Un);
                    }, vn.l = Kn, vn;
                  }();
                }(jt, Cl, fn, _e, l, r, u, o, tl, Rr, ql, Mr, wi, bl, St, pr, ul);
              }() : ul), jt = W(ol), Cl = null, fn = 0;
            }
            _e = 0;
          } else break;
        }
        l = W(Ze), r = null, u = 0;
      }
      o = 0;
    } else return null;
  }
};
Kb.m = 2;
Kb.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var Wne = new $(null, 7, [Y2e, mF, L1e, yJ, P_e, Ywe, Lt, Bge, $d, b2e, hye, C1e, Rx, lwe], null), Gb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], 4 < t.length ? new hn(t.slice(4), 0, null) : null);
};
Gb.l = function(e, n, t, l, r) {
  var u = on.g(TX, l);
  n = $b(function(s) {
    return !ei(s);
  }, r), r = function() {
    var s = See.h(t), d = sn(xg);
    return s = d.j ? d.j(t, s, l) : d.call(null, t, s, l), j(s) ? s : (s = u ? Xwe : null, j(s) ? s : mu(["Protocol not found: ", ye.h(l)].join(""), e));
  }();
  var o = Qs(r) ? sn(r) : null, a = Fy.h(o);
  o = ie.h(o);
  var h = r instanceof de ? "sci.impl.protocols" : ye.h(Jo(o));
  return ve.h(z(he.g(new g(null, mi, null, 1, null), bt.g(function(s) {
    var d = z(s);
    return s = I(d), d = W(d), s = en.j(Wne, s, s), u ? ve.h(z(he.l(new g(null, lF, null, 1, null), new g(null, ve.h(z(he.g(new g(
      null,
      $u,
      null,
      1,
      null
    ), new g(null, s, null, 1, null)))), null, 1, null), Te([new g(null, Sb, null, 1, null), new g(null, Ab, null, 1, null), new g(null, ve.h(z(he.g(new g(null, sc, null, 1, null), tn(I(d))))), null, 1, null)])))) : ve.h(z(he.l(new g(null, mi, null, 1, null), new g(null, ve.h(z(he.l(new g(null, OB, null, 1, null), new g(null, ve.h(z(he.g(new g(null, $u, null, 1, null), new g(null, l, null, 1, null)))), null, 1, null), Te([new g(null, qB, null, 1, null), new g(null, s5, null, 1, null), new g(null, ve.h(z(he.l(new g(null, YZ, null, 1, null), new g(null, sF, null, 1, null), Te([new g(
      null,
      In.g(id, ve.h(z(he.o()))),
      null,
      1,
      null
    )])))), null, 1, null), new g(null, ve.h(z(he.g(new g(null, eJ, null, 1, null), new g(null, s, null, 1, null)))), null, 1, null)])))), null, 1, null), Te([jG(s, d, h, a)]))));
  }, n))));
};
Gb.m = 4;
Gb.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
var Zb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], 4 < t.length ? new hn(t.slice(4), 0, null) : null);
};
Zb.l = function(e, n, t, l, r) {
  var u = en.j(Wne, l, l);
  return ve.h(z(he.g(new g(null, mi, null, 1, null), bt.g(function(o) {
    var a = z(o);
    o = I(a), a = W(a);
    var h = See.h(t), s = sn(xg);
    return h = s.j ? s.j(t, h, o) : s.call(null, t, h, o), h = j(h) ? h : mu(["Protocol not found: ", ye.h(o)].join(""), e), h = sn(h), s = ie.h(h), s = ye.h(Jo(s)), h = Fy.h(h), ve.h(z(he.l(new g(null, mi, null, 1, null), new g(null, ve.h(z(he.l(new g(null, OB, null, 1, null), new g(null, ve.h(z(he.g(new g(null, $u, null, 1, null), new g(null, o, null, 1, null)))), null, 1, null), Te([
      new g(null, qB, null, 1, null),
      new g(null, s5, null, 1, null),
      new g(null, ve.h(z(he.l(new g(null, YZ, null, 1, null), new g(null, sF, null, 1, null), Te([new g(null, In.g(id, ve.h(z(he.o()))), null, 1, null)])))), null, 1, null),
      new g(null, ve.h(z(he.g(new g(null, eJ, null, 1, null), new g(null, u, null, 1, null)))), null, 1, null)
    ])))), null, 1, null), Te([jG(u, a, s, h)]))));
  }, $b(function(o) {
    return !ei(o);
  }, r)))));
};
Zb.m = 4;
Zb.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
var Xb, Wxe = kr.h(Tt), Hxe = kr.h(Tt), zxe = kr.h(Tt), Kxe = kr.h(Tt), Gxe = en.j(Tt, vg, es.o ? es.o() : es.call(null));
Xb = new Np(_n.g("sci.impl.records", "to-string"), la, ai, Gxe, Wxe, Hxe, zxe, Kxe);
Xb.$a(null, ai, function(e) {
  var n = la(e);
  return [Yi(n), ".", ml(n), "@", ye.h(Uu(e).toString(16))].join("");
});
A = _2.prototype;
A.toString = function() {
  return Xb.h(this);
};
A.wa = function(e, n) {
  return zo(this.ib, n);
};
A.P = function(e, n, t) {
  return zo(this.ib, n, t);
};
A.nb = function(e, n, t) {
  return wt.j(function(l, r) {
    var u = O.j(r, 0, null);
    return r = O.j(r, 1, null), n.j ? n.j(l, u, r) : n.call(null, l, u, r);
  }, t, this);
};
A.R = function(e, n, t) {
  return e = this.za, j(e) ? (e = Vt(e), e = Ab.h(e), j(e) ? e.j ? e.j(this, n, t) : e.call(null, this, n, t) : Mh(n, Te([tq(this)]))) : Mh(n, Te([tq(this)]));
};
A.Xa = function() {
  return eo(this.ib);
};
A.U = function() {
  return Vt(this.ib);
};
A.$ = function() {
  return Cn(this.ib);
};
A.O = function() {
  var e = this.Pd;
  return e != null ? this.Pd = e = Uu(ye.h(B3(this.uc))) ^ Na(this.ib) : e;
};
A.N = function(e, n) {
  return n != null && this.constructor === n.constructor && on.g(this.uc, n.uc) && on.g(this.ib, n.ib);
};
A.pd = Rn;
A.sb = function(e, n) {
  return new _2(this.uc, this.type, this.za, nr.g(this.ib, n), null);
};
A.gb = function(e, n) {
  return MO(this.ib, n);
};
A.Aa = function(e, n, t) {
  return new _2(this.uc, this.type, this.za, Dn.j(this.ib, n, t), null);
};
A.W = function() {
  return tx(this.ib);
};
A.Z = function(e, n) {
  return new _2(this.uc, this.type, this.za, Bl(this.ib, n), this.Pd);
};
A.aa = function(e, n) {
  return or(n) ? this.Aa(null, Ul(n, 0), Ul(n, 1)) : wt.j(Qo, this, n);
};
var Qb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], 5 < t.length ? new hn(t.slice(5), 0, null) : null);
};
Qb.l = function(e, n, t, l, r, u) {
  if (n = z(e), I(n), W(n), j(Tb.h(t))) return kt(Bee, tn(e));
  n = ["->", ye.h(l)].join(""), e = _n.h(n), n = _n.h(["map", n].join(""));
  var o = wo.g(ts, r), a = _n.h([ye.h(B3(Vs())), ".", ye.h(l)].join("")), h = $b(jp, u), s = Us(r);
  return r = na.l(function(d, p) {
    function _(G) {
      return b3(G) ? _n.g(L, ye.h(G)) : G;
    }
    d = z(d);
    var R = I(d);
    d = W(d), d = xy(I, d);
    var F = function() {
      var G = Ws.h(t), J = sn(xg);
      return J.j ? J.j(t, G, R) : J.call(null, t, G, R);
    }();
    F = j(F) ? F : on.g(kne, R) ? hW : null, j(F) || mu(["Protocol not found: ", ye.h(R)].join(""), p), p = Qs(F) ? sn(F) : F, F = $o.h(p), j(F) && ud.l(F, Ri, Te([s5, Ff.g(yt, ss), oB(a)])), F = ie.h(p);
    var L = j(F) ? ye.h(Jo(F)) : on.g(hW, p) ? "sci.impl.records" : null;
    return bt.g(function(G) {
      var J = O.j(G, 0, null);
      return G = O.j(G, 1, null), G = bt.g(tn, G), G = wo.g(function(we) {
        var ce = I(we);
        we = tn(we), ce = bG(ce, we);
        var xe = yh.h(ce);
        ce = uc.h(ce);
        var $e = I(xe), je = tn(xe);
        we = fu(function(P) {
          return on.g($e, P);
        }, je);
        var E = j(we) ? Xr.h("this_") : $e;
        return xe = j(we) ? Et(kt(E, je)) : xe, je = na.l(
          function(P) {
            return new v(null, 2, 5, y, [P, new g(null, ts.h(P), new g(null, E, null, 1, null), 2, null)], null);
          },
          Te([wt.j(Aa, s, xe)])
        ), we = j(we) ? he.g(je, new v(null, 2, 5, y, [$e, E], null)) : je, we = Et(we), ve.h(z(he.g(new g(null, xe, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, we, null, 1, null), Te([ce])))), null, 1, null))));
      }, G), ve.h(z(he.l(new g(null, xw, null, 1, null), new g(null, _(J), null, 1, null), Te([new g(null, a, null, 1, null), G]))));
    }, d);
  }, Te([h, u])), ve.h(z(he.l(new g(null, mi, null, 1, null), new g(
    null,
    ve.h(z(he.l(new g(null, eN, null, 1, null), new g(null, l, null, 1, null), Te([new g(null, e, null, 1, null)])))),
    null,
    1,
    null
  ), Te([new g(null, ve.h(z(he.g(new g(null, eN, null, 1, null), new g(null, n, null, 1, null)))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yc, null, 1, null), new g(null, Bl(l, new $(null, 1, [Gee, !0], null)), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, kye, null, 1, null), new g(
    null,
    new $(null, 5, [EB, new g(null, Fr, new g(null, a, null, 1, null), 2, null), I1e, !0, Ik, new g(null, $u, new g(null, e, null, 1, null), 2, null), One, new g(null, $u, new g(null, l, null, 1, null), 2, null), xX, new g(null, $u, new g(null, n, null, 1, null), 2, null)], null),
    null,
    1,
    null
  )))), null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Zx, null, 1, null), new g(null, e, null, 1, null), Te([new g(null, Et(ve.h(z(he.g(new g(null, et, null, 1, null), new g(null, TW, null, 1, null))))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, dH, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, a, null, 1, null)))), null, 1, null), Te([new g(null, a, null, 1, null), new g(null, ve.h(z(he.g(new g(null, $u, null, 1, null), new g(null, l, null, 1, null)))), null, 1, null), new g(null, ve.h(z(he.l(new g(
    null,
    Tne,
    null,
    1,
    null
  ), new g(null, o, null, 1, null), Te([new g(null, TW, null, 1, null)])))), null, 1, null)])))), null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Zx, null, 1, null), new g(null, n, null, 1, null), Te([new g(null, Et(ve.h(z(he.h(new g(null, Cq, null, 1, null))))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, dH, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, a, null, 1, null)))), null, 1, null), Te([new g(null, a, null, 1, null), new g(null, ve.h(z(he.g(new g(null, $u, null, 1, null), new g(
    null,
    l,
    null,
    1,
    null
  )))), null, 1, null), new g(null, Cq, null, 1, null)])))), null, 1, null)])))), null, 1, null), r, new g(null, l, null, 1, null)]))));
};
Qb.m = 5;
Qb.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  l = I(r);
  var u = W(r);
  return r = I(u), u = W(u), this.l(n, e, t, l, r, u);
};
var D_ = {}, e3 = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
e3.j = function(e, n, t) {
  return e3.B(e, n, null, t);
};
e3.B = function(e, n, t, l) {
  return er(t) || !Ol(t, l) ? (n = D(l, e, n), t = sn(Yne), e = t.j ? t.j(e, n, !1) : t.call(null, e, n, !1), e = Vr(e), e instanceof Ic ? null : e) : null;
};
e3.m = 4;
Yu(xg, e3);
var v5 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
v5.l = function(e, n) {
  n = bt.g(function(l) {
    return ei(l) && on.g(Fr, I(l)) ? Vr(l) : l;
  }, n);
  var t = Or.h(e);
  return wt.j(function(l, r) {
    l = r instanceof T ? function() {
      var o = ye.h(r), a = yg.g(o, ".");
      return j(a) ? new v(null, 2, 5, y, [_n.h(Si.j(o, 0, a)), new v(null, 1, 5, y, [_n.h(Si.j(o, a + 1, o.length))], null)], null) : new v(null, 2, 5, y, [null, new v(null, 1, 5, y, [r], null)], null);
    }() : function() {
      var o = I(r), a = tn(r);
      return new v(null, 2, 5, y, [o, a], null);
    }();
    var u = O.j(l, 0, null);
    return l = O.j(l, 1, null), wt.j(function(o, a) {
      o = _n.h(j(u) ? [ye.h(u), ".", ye.h(a)].join("") : a);
      var h = gh.h(wk(e, o));
      if (j(h)) {
        var s = Vs();
        return wr.B(t, xs, new v(null, 4, 5, y, [Il, s, po, a], null), o), h;
      }
      if (s = _n.h(zK(ye.h(u))), h = xr.g(sn(t), new v(null, 3, 5, y, [Il, s, a], null)), j(h)) return s = Vs(), wr.B(t, xs, new v(null, 4, 5, y, [Il, s, ta, a], null), h), sn(h);
      throw Error(["Unable to resolve classname: ", ye.h(o)].join(""));
    }, null, l);
  }, null, n);
};
v5.m = 1;
v5.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
var Jb = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
Jb.l = function(e, n, t) {
  n = I(t) instanceof T ? I(t) : null, t = j(n) ? W(t) : t;
  var l = or(I(t)) ? new g(null, t, null, 1, null) : ei(I(t)) ? t : mu(z(t) ? ["Parameter declaration ", ye.h(I(t)), " should be a vector"].join("") : "Parameter declaration missing", e);
  return t = bt.g(function(r) {
    if (!ei(r)) throw mu(["Invalid signature ", ye.h(r), " should be a list"].join(""), e);
    var u = z(r), o = I(u);
    u = W(u), or(o) || mu(ei(I(l)) ? ["Parameter declaration ", ye.h(o), " should be a vector"].join("") : ["Invalid signature ", ye.h(r), " should be a list"].join(""), e);
    var a = W(u) && ci(I(u)) ? I(u) : null;
    return r = j(a) ? W(u) : u, a = j(a) ? a : Vt(o), u = hm.h(a), a = Fge.h(a), r = j(a) ? ve.h(z(he.h(new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, wW, null, 1, null), new g(null, 1 < Cn(r) ? ve.h(z(he.g(new g(null, mi, null, 1, null), r))) : I(r), null, 1, null))))), null, 1, null), Te([bt.g(function(h) {
      return ve.h(z(he.g(new g(null, ZW, null, 1, null), new g(null, h, null, 1, null))));
    }, a), new g(null, wW, null, 1, null)])))), null, 1, null)))) : r, r = j(u) ? he.g(bt.g(function(h) {
      return ve.h(z(he.g(
        new g(null, ZW, null, 1, null),
        new g(null, h, null, 1, null)
      )));
    }, u), r) : r, cpe(o, r);
  }, l), Bl(j(n) ? us.j(r1, n, t) : kt(r1, t), Vt(e));
};
Jb.m = 2;
Jb.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var eT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
eT.l = function(e, n, t, l) {
  return t instanceof T || mu("First argument to defn must be a symbol", e), e = typeof I(l) == "string" ? new $(null, 1, [ee, I(l)], null) : Tt, n = typeof I(l) == "string" ? W(l) : l, l = ci(I(n)) ? yt.g(e, I(n)) : e, e = ci(I(n)) ? W(n) : n, e = or(I(e)) ? new g(null, e, null, 1, null) : e, n = ci(ho(e)) ? yt.g(l, ho(e)) : l, l = ci(ho(e)) ? td(e) : e, e = yt.g(new $(null, 1, [ne, new g(null, Fr, new g(null, hpe(l), null, 1, null), 2, null)], null), n), n = Vt(t), e = yt.g(j(n) ? n : Tt, e), n = Zf.h(n), l = kt(sc, l), new g(null, Yc, new g(null, Bl(t, e), new g(null, j(j(n) ? n : t) ? Bl(l, new $(null, 1, [AP, new $(null, 2, [Zf, n, TZ, t], null)], null)) : l, null, 1, null), 2, null), 3, null);
};
eT.m = 3;
eT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var nT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
nT.l = function(e, n, t, l) {
  var r = wu.B(t, Dn, Zf, !0), u = function() {
    for (var a = new g(null, r, null, 1, null), h = l; ; ) {
      var s = I(h);
      if (typeof s == "string") a = kt(s, a), h = W(h);
      else if (ci(s)) a = kt(s, a), h = W(h);
      else return a;
    }
  }();
  e = function() {
    for (var a = l; ; ) if (typeof I(a) == "string") a = W(a);
    else if (ci(I(a))) a = W(a);
    else return a;
  }(), e = or(I(e)) ? new g(null, e, null, 1, null) : e;
  var o = z(function(a, h) {
    for (; ; ) {
      if (h == null) return a;
      var s = I(h);
      if (ci(s)) return yt.g(a, s);
      var d = yt, p = d.g, _ = I(s);
      s = kt(Et(kt(FJ, kt(g2e, _))), W(s)), d = p.call(d, a, s), h = W(h), a = d;
    }
  }(Dt, e));
  return e = function() {
    for (var a = u, h = o; ; ) if (j(a)) {
      var s = W(a);
      h = kt(I(a), h), a = s;
    } else return h;
  }(), new g(null, mi, new g(null, kt(Zx, e), new g(null, new g(null, $u, new g(null, r, null, 1, null), 2, null), null, 1, null), 2, null), 3, null);
};
nT.m = 3;
nT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var qd = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
qd.l = function(e, n, t, l) {
  return j(j(n) ? 0 < ml(t).indexOf(".") : n) && mu(["Found lib name '", ml(t), "' containing period with prefix '", ye.h(n), "'.  lib names inside prefix lists must not contain periods"].join(""), t), n = j(n) ? _n.h([ye.h(n), ".", ye.h(t)].join("")) : t, l = In.g(tr, l), fpe(e, n, l);
};
qd.m = 3;
qd.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var y5 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
y5.l = function(e, n) {
  return cB(e, n4, n);
};
y5.m = 1;
y5.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
var tT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
tT.l = function(e, n) {
  return cB(e, nQ, n);
};
tT.m = 1;
tT.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
Yu($ne, y5);
var _5 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
_5.l = function(e, n) {
  return cB(e, eF, n);
};
_5.m = 1;
_5.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
Yu(Lne, _5);
var x5 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
x5.l = function(e, n, t) {
  return on.g(ks, n) ? dpe(e, t) : wr.B(Or.h(e), ppe, n, t), null;
};
x5.m = 2;
x5.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Yu(Bne, x5);
var h1 = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
h1.j = function(e, n, t) {
  return h1.B(e, n, t, null);
};
h1.B = function(e, n, t) {
  var l = e.get(Ws), r = e.get(ZZ), u = function() {
    var o = oh(l, n);
    if (j(o)) {
      var a = O.j(o, 0, null), h = O.j(o, 1, null), s = function() {
        var p = en.g(Rc.h(e), h);
        return j(p) ? p : (p = EX.h(e), p = p.h ? p.h(h) : p.call(null, h), wpe(e, jf.h(e), p));
      }(), d = j(r) ? function() {
        var p = a == null ? null : Vt(a);
        if (j(p)) {
          var _ = E7.h(p);
          return j(_) ? _ : b1e.h(p);
        }
        return null;
      }() : null;
      return o = j(t) ? mpe(a, s) : function() {
        return function() {
          var p = j(d) ? function() {
            var _ = Vr(h1.j(e, U_, !1));
            return it(function(R, F, L) {
              return R = D(_, F, L), R = gx(R), en.g(R, n);
            }, null);
          }() : it(function(_, R, F) {
            return F[s];
          }, null);
          return j(d) ? wu.B(p, Dn, E7, !0) : p;
        }();
      }(), new v(null, 2, 5, y, [a, o], null);
    }
    return null;
  }();
  return j(u) ? u : (u = gpe(e, n, t), j(u) ? (j(nF.h(e)) && RG(e, n, u), u) : null);
};
h1.m = 4;
Yu(Yne, h1);
var Hne = new gi(null, new $(null, 15, [bb, "null", T1, "null", A2, "null", Hx, "null", mi, "null", si, "null", lf, "null", Gy, "null", b1, "null", jb, "null", Kf, "null", $u, "null", Fr, "null", rp, "null", Yc, "null"], null), null);
OK(pF, function e(n, t) {
  var l = NG(n, t);
  return l === t ? t : e.g ? e.g(n, l) : e.call(null, n, l);
});
Yu(Fne, NG);
var S5 = function e(n, t, l) {
  var r = Cn(l);
  if (5 < r) {
    var u = function() {
      var p = ff(n), _ = Vu.g(5, l);
      return e.j ? e.j(p, t, _) : e.call(null, p, t, _);
    }(), o = function() {
      var p = uu.g(5, l);
      return e.j ? e.j(n, t, p) : e.call(null, n, t, p);
    }();
    return it(function(p, _, R) {
      return D(u, _, R), D(o, _, R);
    }, null);
  }
  var a = hB(n, l);
  switch (r) {
    case 0:
      return null;
    case 1:
      return O.g(a, 0);
    case 2:
      var h = O.g(a, 0);
      return u = O.g(a, 1), it(function(p, _, R) {
        return D(h, _, R), D(u, _, R);
      }, null);
    case 3:
      return h = O.g(a, 0), u = O.g(a, 1), o = O.g(a, 2), it(function(p, _, R) {
        return D(h, _, R), D(
          u,
          _,
          R
        ), D(o, _, R);
      }, null);
    case 4:
      h = O.g(a, 0), u = O.g(a, 1), o = O.g(a, 2);
      var s = O.g(a, 3);
      return it(function(p, _, R) {
        return D(h, _, R), D(u, _, R), D(o, _, R), D(s, _, R);
      }, null);
    case 5:
      h = O.g(a, 0), u = O.g(a, 1), o = O.g(a, 2), s = O.g(a, 3);
      var d = O.g(a, 4);
      return it(function(p, _, R) {
        return D(h, _, R), D(u, _, R), D(o, _, R), D(s, _, R), D(d, _, R);
      }, null);
    default:
      throw Error(["No matching clause: ", ye.h(r)].join(""));
  }
}, Zxe = function e(n, t, l) {
  var r = Cn(l);
  if (5 < r) {
    var u = function() {
      var p = Vu.g(5, l);
      return e.j ? e.j(n, t, p) : e.call(null, n, t, p);
    }(), o = function() {
      var p = uu.g(5, l);
      return e.j ? e.j(n, t, p) : e.call(null, n, t, p);
    }();
    return it(function(p, _, R) {
      return p = D(u, _, R), j(p) ? p : D(o, _, R);
    }, null);
  }
  var a = hB(n, l);
  switch (r) {
    case 0:
      return null;
    case 1:
      return r = O.g(a, 0), nt.g ? nt.g(n, r) : nt.call(null, n, r);
    case 2:
      return u = function() {
        var p = O.g(a, 0);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), o = function() {
        var p = O.g(a, 1);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), it(function(p, _, R) {
        return p = D(u, _, R), j(p) ? p : D(o, _, R);
      }, null);
    case 3:
      u = function() {
        var p = O.g(a, 0);
        return nt.g ? nt.g(n, p) : nt.call(
          null,
          n,
          p
        );
      }(), o = function() {
        var p = O.g(a, 1);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      var h = function() {
        var p = O.g(a, 2);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      return it(function(p, _, R) {
        return p = D(u, _, R), j(p) ? p : (p = D(o, _, R), j(p) ? p : D(h, _, R));
      }, null);
    case 4:
      u = function() {
        var p = O.g(a, 0);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), o = function() {
        var p = O.g(a, 1);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), h = function() {
        var p = O.g(a, 2);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      var s = function() {
        var p = O.g(a, 3);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      return it(function(p, _, R) {
        return p = D(u, _, R), j(p) || (p = D(o, _, R), j(p)) ? p : (p = D(h, _, R), j(p) ? p : D(s, _, R));
      }, null);
    case 5:
      u = function() {
        var p = O.g(a, 0);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), o = function() {
        var p = O.g(a, 1);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), h = function() {
        var p = O.g(a, 2);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), s = function() {
        var p = O.g(a, 3);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      var d = function() {
        var p = O.g(a, 4);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      return it(function(p, _, R) {
        return p = D(u, _, R), j(p) || (p = D(o, _, R), j(p)) || (p = D(h, _, R), j(p)) ? p : (p = D(s, _, R), j(p) ? p : D(d, _, R));
      }, null);
    default:
      throw Error(["No matching clause: ", ye.h(r)].join(""));
  }
}, Xxe = function e(n, t, l) {
  var r = Cn(l);
  if (5 < r) {
    var u = function() {
      var p = Vu.g(5, l);
      return e.j ? e.j(n, t, p) : e.call(null, n, t, p);
    }(), o = function() {
      var p = uu.g(5, l);
      return e.j ? e.j(n, t, p) : e.call(null, n, t, p);
    }();
    return it(function(p, _, R) {
      return p = D(u, _, R), j(p) ? D(o, _, R) : p;
    }, null);
  }
  var a = hB(n, l);
  switch (r) {
    case 0:
      return !0;
    case 1:
      return r = O.g(a, 0), nt.g ? nt.g(n, r) : nt.call(null, n, r);
    case 2:
      return u = function() {
        var p = O.g(a, 0);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), o = function() {
        var p = O.g(a, 1);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), it(function(p, _, R) {
        return p = D(u, _, R), j(p) ? D(o, _, R) : p;
      }, null);
    case 3:
      u = function() {
        var p = O.g(a, 0);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), o = function() {
        var p = O.g(a, 1);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      var h = function() {
        var p = O.g(
          a,
          2
        );
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      return it(function(p, _, R) {
        return p = D(u, _, R), j(p) ? (p = D(o, _, R), j(p) ? D(h, _, R) : p) : p;
      }, null);
    case 4:
      u = function() {
        var p = O.g(a, 0);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), o = function() {
        var p = O.g(a, 1);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), h = function() {
        var p = O.g(a, 2);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      var s = function() {
        var p = O.g(a, 3);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      return it(function(p, _, R) {
        return p = D(u, _, R), j(p) ? (p = D(o, _, R), j(p) ? (p = D(
          h,
          _,
          R
        ), j(p) ? D(s, _, R) : p) : p) : p;
      }, null);
    case 5:
      u = function() {
        var p = O.g(a, 0);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), o = function() {
        var p = O.g(a, 1);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), h = function() {
        var p = O.g(a, 2);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }(), s = function() {
        var p = O.g(a, 3);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      var d = function() {
        var p = O.g(a, 4);
        return nt.g ? nt.g(n, p) : nt.call(null, n, p);
      }();
      return it(function(p, _, R) {
        return p = D(u, _, R), j(p) ? (p = D(o, _, R), j(p) ? (p = D(h, _, R), j(p) ? (p = D(s, _, R), j(p) ? D(
          d,
          _,
          R
        ) : p) : p) : p) : p;
      }, null);
    default:
      throw Error(["No matching clause: ", ye.h(r)].join(""));
  }
};
A = Ph.prototype;
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  switch (n instanceof de ? n.ca : null) {
    case "params":
      return this.vb;
    case "body":
      return this.body;
    case "fixed-arity":
      return this.tb;
    case "var-arg-name":
      return this.yb;
    case "self-ref-idx":
      return this.wb;
    case "iden->invoke-idx":
      return this.ub;
    default:
      return en.j(this.F, n, t);
  }
};
A.nb = function(e, n, t) {
  return wt.j(function(l, r) {
    var u = O.j(r, 0, null);
    return r = O.j(r, 1, null), n.j ? n.j(l, u, r) : n.call(null, l, u, r);
  }, t, this);
};
A.R = function(e, n, t) {
  return vr(n, function(l) {
    return vr(n, Wl, "", " ", "", t, l);
  }, "#sci.impl.analyzer.FnBody{", ", ", "}", t, he.g(new v(null, 6, 5, y, [new v(null, 2, 5, y, [yh, this.vb], null), new v(null, 2, 5, y, [uc, this.body], null), new v(null, 2, 5, y, [Vi, this.tb], null), new v(null, 2, 5, y, [tg, this.yb], null), new v(null, 2, 5, y, [s1, this.wb], null), new v(null, 2, 5, y, [Rc, this.ub], null)], null), this.F));
};
A.Xa = function() {
  return new hf(this, 6, new v(null, 6, 5, y, [yh, uc, Vi, tg, s1, Rc], null), j(this.F) ? eo(this.F) : ed());
};
A.U = function() {
  return this.K;
};
A.$ = function() {
  return 6 + Cn(this.F);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = 1733662014 ^ Na(this));
};
A.N = function(e, n) {
  return n != null && this.constructor === n.constructor && on.g(this.vb, n.vb) && on.g(this.body, n.body) && on.g(this.tb, n.tb) && on.g(this.yb, n.yb) && on.g(this.wb, n.wb) && on.g(this.ub, n.ub) && on.g(this.F, n.F);
};
A.sb = function(e, n) {
  return Ol(new gi(null, new $(null, 6, [tg, null, yh, null, s1, null, Vi, null, Rc, null, uc, null], null), null), n) ? nr.g(su(lr.g(Tt, this), this.K), n) : new Ph(this.vb, this.body, this.tb, this.yb, this.wb, this.ub, this.K, Fo(nr.g(this.F, n)), null);
};
A.gb = function(e, n) {
  switch (n instanceof de ? n.ca : null) {
    case "params":
    case "body":
    case "fixed-arity":
    case "var-arg-name":
    case "self-ref-idx":
    case "iden->invoke-idx":
      return !0;
    default:
      return Ol(this.F, n);
  }
};
A.Aa = function(e, n, t) {
  return j(Ln.g ? Ln.g(yh, n) : Ln.call(null, yh, n)) ? new Ph(t, this.body, this.tb, this.yb, this.wb, this.ub, this.K, this.F, null) : j(Ln.g ? Ln.g(uc, n) : Ln.call(null, uc, n)) ? new Ph(this.vb, t, this.tb, this.yb, this.wb, this.ub, this.K, this.F, null) : j(Ln.g ? Ln.g(Vi, n) : Ln.call(null, Vi, n)) ? new Ph(this.vb, this.body, t, this.yb, this.wb, this.ub, this.K, this.F, null) : j(Ln.g ? Ln.g(tg, n) : Ln.call(null, tg, n)) ? new Ph(this.vb, this.body, this.tb, t, this.wb, this.ub, this.K, this.F, null) : j(Ln.g ? Ln.g(s1, n) : Ln.call(null, s1, n)) ? new Ph(
    this.vb,
    this.body,
    this.tb,
    this.yb,
    t,
    this.ub,
    this.K,
    this.F,
    null
  ) : j(Ln.g ? Ln.g(Rc, n) : Ln.call(null, Rc, n)) ? new Ph(this.vb, this.body, this.tb, this.yb, this.wb, t, this.K, this.F, null) : new Ph(this.vb, this.body, this.tb, this.yb, this.wb, this.ub, this.K, Dn.j(this.F, n, t), null);
};
A.W = function() {
  return z(he.g(new v(null, 6, 5, y, [new yl(yh, this.vb), new yl(uc, this.body), new yl(Vi, this.tb), new yl(tg, this.yb), new yl(s1, this.wb), new yl(Rc, this.ub)], null), this.F));
};
A.Z = function(e, n) {
  return new Ph(this.vb, this.body, this.tb, this.yb, this.wb, this.ub, n, this.F, this.H);
};
A.aa = function(e, n) {
  return or(n) ? this.Aa(null, Ul(n, 0), Ul(n, 1)) : wt.j(Qo, this, n);
};
var Qxe = function e(n, t, l, r) {
  if (10 < Cn(l)) {
    var u = Vu.g(10, l);
    return r = new v(null, 1, 5, y, [Bl(us.j(Gy, Et(uu.g(10, l)), r), Vt(t))], null), e.B ? e.B(n, t, u, r) : e.call(null, n, t, u, r);
  }
  u = bp.h(n);
  var o = ff(n);
  n = uB(Vt(t), !0);
  var a = wt.j(function(ce, xe) {
    var $e = O.j(ce, 0, null), je = O.j(ce, 1, null);
    ce = O.j(ce, 2, null);
    var E = O.j(xe, 0, null);
    xe = O.j(xe, 1, null);
    var P = Vt(xe);
    P = j(P) ? Ft.h(P) : null;
    var K = j(P) ? wu.B(E, Dn, Ft, P) : E;
    E = nt.g ? nt.g($e, xe) : nt.call(null, $e, xe);
    var H = Xr.o();
    return xe = jf.h($e), xe = M_($e, xe, H), P = Rc.h($e), xe = Dn.j(P, H, xe), $e = Dn.j($e, Rc, xe), new v(null, 3, 5, y, [Ri.j($e, Ws, function(U) {
      return Dn.j(nr.g(U, K), K, H);
    }), yt.g(je, E), yt.g(ce, H)], null);
  }, new v(null, 3, 5, y, [o, Dt, Dt], null), Mo.g(2, l));
  o = O.j(a, 0, null), l = O.j(a, 1, null), a = O.j(a, 2, null);
  var h = S5(Dn.j(o, bp, u), t, r);
  switch (t = Rc.h(o), t = wo.g(t, a), r = Cn(t), r) {
    case 0:
      return it(function(ce, xe, $e) {
        return D(h, xe, $e);
      }, n);
    case 1:
      var s = O.g(l, 0), d = O.g(t, 0);
      return it(function(ce, xe, $e) {
        return ce = D(s, xe, $e), $e[d] = ce, D(h, xe, $e);
      }, n);
    case 2:
      s = O.g(l, 0);
      var p = O.g(l, 1);
      d = O.g(t, 0);
      var _ = O.g(
        t,
        1
      );
      return it(function(ce, xe, $e) {
        return ce = D(s, xe, $e), $e[d] = ce, ce = D(p, xe, $e), $e[_] = ce, D(h, xe, $e);
      }, n);
    case 3:
      s = O.g(l, 0), p = O.g(l, 1);
      var R = O.g(l, 2);
      d = O.g(t, 0), _ = O.g(t, 1);
      var F = O.g(t, 2);
      return it(function(ce, xe, $e) {
        return ce = D(s, xe, $e), $e[d] = ce, ce = D(p, xe, $e), $e[_] = ce, ce = D(R, xe, $e), $e[F] = ce, D(h, xe, $e);
      }, n);
    case 4:
      s = O.g(l, 0), p = O.g(l, 1), R = O.g(l, 2);
      var L = O.g(l, 3);
      d = O.g(t, 0), _ = O.g(t, 1), F = O.g(t, 2);
      var G = O.g(t, 3);
      return it(function(ce, xe, $e) {
        return ce = D(s, xe, $e), $e[d] = ce, ce = D(p, xe, $e), $e[_] = ce, ce = D(R, xe, $e), $e[F] = ce, ce = D(L, xe, $e), $e[G] = ce, D(h, xe, $e);
      }, n);
    case 5:
      s = O.g(l, 0), p = O.g(l, 1), R = O.g(l, 2), L = O.g(l, 3);
      var J = O.g(l, 4);
      d = O.g(t, 0), _ = O.g(t, 1), F = O.g(t, 2), G = O.g(t, 3);
      var we = O.g(t, 4);
      return it(function(ce, xe, $e) {
        return ce = D(s, xe, $e), $e[d] = ce, ce = D(p, xe, $e), $e[_] = ce, ce = D(R, xe, $e), $e[F] = ce, ce = D(L, xe, $e), $e[G] = ce, ce = D(J, xe, $e), $e[we] = ce, D(h, xe, $e);
      }, n);
    default:
      throw Error(["No matching clause: ", ye.h(r)].join(""));
  }
}, nt = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(
        arguments[0],
        arguments[1],
        arguments[2]
      );
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
nt.g = function(e, n) {
  return nt.j(e, n, !1);
};
nt.j = function(e, n, t) {
  var l = Vt(n);
  if (mk(n)) return n;
  if (n instanceof T) {
    var r = Hw(e, n, !1, Ft.h(l)), u = Vt(r);
    if (mk(r)) return r;
    if (Qs(r)) {
      if (j(function() {
        var o = by(r);
        return j(o) ? Re.h(u) : o;
      }())) return go.g(r, e);
      if (j(Ax.h(u))) return sn(r);
      if (j(fk(r))) throw Error(["Can't take value of a macro: ", ye.h(r), ""].join(""));
      return it(function() {
        return sn(r);
      }, null);
    }
    return r;
  }
  return Ap(n) ? n : ci(n) ? Fpe(e, n, l) : n instanceof wG ? Vpe(e, n) : or(n) ? oq(e, No, k2, n, l) : ug(n) ? oq(e, Us, id, n, l) : ei(n) && z(n) ? Lpe(e, n, l, t) : n;
};
nt.m = 3;
Yu(Une, nt);
typeof Ev < "u" && typeof Ev.Wd < "u" && typeof Ev.Wd.Ie < "u" && typeof Ev.Wd.Ie.resolve < "u" && Bl(kge, new $(null, 1, [JB, !0], null));
var j1 = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
j1.o = function() {
  return ss;
};
j1.h = function(e) {
  return e;
};
j1.g = function(e, n) {
  return Cn(e) < Cn(n) ? wt.j(yt, n, e) : wt.j(yt, e, n);
};
j1.l = function(e, n, t) {
  return e = $G(Cn, yt.l(t, n, Te([e]))), wt.j(lr, I(e), tn(e));
};
j1.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
j1.m = 2;
var rg = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
rg.h = function(e) {
  return e;
};
rg.g = function(e, n) {
  for (; ; ) if (Cn(n) < Cn(e)) {
    var t = e;
    e = n, n = t;
  } else return wt.j(/* @__PURE__ */ function(l, r) {
    return function(u, o) {
      return Ol(r, o) ? u : Aa.g(u, o);
    };
  }(e, n), e, e);
};
rg.l = function(e, n, t) {
  return e = $G(function(l) {
    return -Cn(l);
  }, yt.l(t, n, Te([e]))), wt.j(rg, I(e), tn(e));
};
rg.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
rg.m = 2;
var ig = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
ig.h = function(e) {
  return e;
};
ig.g = function(e, n) {
  return Cn(e) < Cn(n) ? wt.j(function(t, l) {
    return Ol(n, l) ? Aa.g(t, l) : t;
  }, e, e) : wt.j(Aa, e, n);
};
ig.l = function(e, n, t) {
  return wt.j(ig, e, yt.g(t, n));
};
ig.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
ig.m = 2;
var lT = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
lT.g = function(e, n) {
  if (z(e) && z(n)) {
    var t = rg.g(Us(xi(I(e))), Us(xi(I(n))));
    n = Cn(e) <= Cn(n) ? new v(null, 2, 5, y, [e, n], null) : new v(null, 2, 5, y, [n, e], null), e = O.j(n, 0, null), n = O.j(n, 1, null);
    var l = fB(e, t);
    return wt.j(function(r, u) {
      var o = function() {
        var a = pg(u, t);
        return l.h ? l.h(a) : l.call(null, a);
      }();
      return j(o) ? wt.j(function(a, h) {
        return yt.g(a, gr.l(Te([h, u])));
      }, r, o) : r;
    }, ss, n);
  }
  return ss;
};
lT.j = function(e, n, t) {
  e = Cn(e) <= Cn(n) ? new v(null, 3, 5, y, [e, n, LG(t)], null) : new v(null, 3, 5, y, [n, e, t], null), n = O.j(e, 0, null), t = O.j(e, 1, null);
  var l = O.j(e, 2, null), r = fB(n, Ju(l));
  return wt.j(function(u, o) {
    var a = function() {
      var h = PI(pg(o, xi(l)), l);
      return r.h ? r.h(h) : r.call(null, h);
    }();
    return j(a) ? wt.j(function(h, s) {
      return yt.g(h, gr.l(Te([s, o])));
    }, u, a) : u;
  }, ss, t);
};
lT.m = 3;
var TE = function e(n, t) {
  return dB(go.g(e, n), n, t);
}, z$ = function e(n, t) {
  return dB(go.g(e, n), No, n.h ? n.h(t) : n.call(null, t));
}, Zy, Jxe = kr.h(Tt), e3e = kr.h(Tt), n3e = kr.h(Tt), t3e = kr.h(Tt), l3e = en.j(Tt, vg, es.o ? es.o() : es.call(null));
Zy = new Np(_n.g("sci.impl.core-protocols", "-deref"), la, ai, l3e, Jxe, e3e, n3e, t3e);
Zy.$a(null, u5, function(e) {
  var n = Kd(e);
  return n = en.g(n, TB), n.h ? n.h(e) : n.call(null, e);
});
var r3e = Zy.$a(null, ai, function(e) {
  return sn(e);
}), Xy = oc(r5, null), i3e = Hc(A_e, new $(null, 3, [o5, __, i1, Rp([Zy]), ie, Xy], null), new $(null, 1, [ie, Xy], null)), f1, u3e = kr.h(Tt), s3e = kr.h(Tt), o3e = kr.h(Tt), a3e = kr.h(Tt), c3e = en.j(Tt, vg, es.o ? es.o() : es.call(null));
f1 = new Np(_n.g("sci.impl.core-protocols", "-swap!"), la, ai, c3e, u3e, s3e, o3e, a3e);
var I2, h3e = kr.h(Tt), f3e = kr.h(Tt), d3e = kr.h(Tt), p3e = kr.h(Tt), m3e = en.j(Tt, vg, es.o ? es.o() : es.call(null));
I2 = new Np(_n.g("sci.impl.core-protocols", "-reset!"), la, ai, m3e, h3e, f3e, d3e, p3e);
f1.$a(null, u5, function() {
  function e(u, o, a, h) {
    var s = Kd(u);
    return s = en.g(s, kv), s.B ? s.B(u, o, a, h) : s.call(null, u, o, a, h);
  }
  function n(u, o, a) {
    var h = Kd(u);
    return h = en.g(h, kv), h.j ? h.j(u, o, a) : h.call(null, u, o, a);
  }
  function t(u, o) {
    var a = Kd(u);
    return a = en.g(a, kv), a.g ? a.g(u, o) : a.call(null, u, o);
  }
  var l = null, r = function() {
    function u(a, h, s, d, p) {
      var _ = null;
      if (4 < arguments.length) {
        _ = 0;
        for (var R = Array(arguments.length - 4); _ < R.length; ) R[_] = arguments[_ + 4], ++_;
        _ = new hn(R, 0, null);
      }
      return o.call(this, a, h, s, d, _);
    }
    function o(a, h, s, d, p) {
      var _ = Kd(a);
      return In.l(en.g(_, kv), a, h, s, d, Te([p]));
    }
    return u.m = 4, u.v = function(a) {
      var h = I(a);
      a = W(a);
      var s = I(a);
      a = W(a);
      var d = I(a);
      a = W(a);
      var p = I(a);
      return a = tn(a), o(h, s, d, p, a);
    }, u.l = o, u;
  }();
  return l = function(u, o, a, h, s) {
    switch (arguments.length) {
      case 2:
        return t.call(this, u, o);
      case 3:
        return n.call(this, u, o, a);
      case 4:
        return e.call(this, u, o, a, h);
      default:
        var d = null;
        if (4 < arguments.length) {
          d = 0;
          for (var p = Array(arguments.length - 4); d < p.length; ) p[d] = arguments[d + 4], ++d;
          d = new hn(p, 0, null);
        }
        return r.l(u, o, a, h, d);
    }
  }, l.m = 4, l.v = r.v, l.g = t, l.j = n, l.B = e, l.l = r.l, l;
}());
I2.$a(null, u5, function(e, n) {
  var t = Kd(e);
  return t = en.g(t, PB), t.g ? t.g(e, n) : t.call(null, e, n);
});
var g3e = new v(null, 2, 5, y, [f1.$a(null, ai, function() {
  function e(t, l, r) {
    var u = null;
    if (2 < arguments.length) {
      u = 0;
      for (var o = Array(arguments.length - 2); u < o.length; ) o[u] = arguments[u + 2], ++u;
      u = new hn(o, 0, null);
    }
    return n.call(this, t, l, u);
  }
  function n(t, l, r) {
    return In.B(wr, t, l, r);
  }
  return e.m = 2, e.v = function(t) {
    var l = I(t);
    t = W(t);
    var r = I(t);
    return t = tn(t), n(l, r, t);
  }, e.l = n, e;
}()), I2.$a(null, ai, function(e, n) {
  return Qa(e, n);
})], null), rT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
rT.l = function(e, n, t) {
  return e instanceof Wc || e != null && (e.J & 65536 || Rn === e.Ve) ? j(t) ? In.B(wr, e, n, t) : wr.g(e, n) : j(t) ? In.B(f1, e, n, t) : f1.g(e, n);
};
rT.m = 2;
rT.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var w3e = Hc(z0e, new $(null, 3, [o5, S_, i1, Rp([f1]), ie, Xy], null), new $(null, 1, [ie, Xy], null)), v3e = Hc(C_e, new $(null, 3, [o5, x_, i1, Rp([I2]), ie, Xy], null), new $(null, 1, [ie, Xy], null));
Us(yt.g(g3e, r3e));
var iT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
iT.l = function(e, n, t, l) {
  if (!or(t)) throw Error("doseq requires a vector for its binding");
  if (!qc(Cn(t))) throw Error("doseq requires an even number of forms in binding vector");
  return O.g(function r(u, o) {
    if (er(o)) return new v(null, 2, 5, y, [!0, ve.h(z(he.g(new g(null, mi, null, 1, null), l)))], null);
    var a = I(o), h = Vr(o);
    if (a instanceof de) {
      var s = r(u, va(o)), d = s.h ? s.h(0) : s.call(null, 0);
      return s = s.h ? s.h(1) : s.call(null, 1), on.g(a, _7) ? new v(null, 2, 5, y, [d, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, h, null, 1, null), Te([new g(
        null,
        s,
        null,
        1,
        null
      )]))))], null) : on.g(a, U$) ? new v(null, 2, 5, y, [!1, ve.h(z(he.l(new g(null, Fx, null, 1, null), new g(null, h, null, 1, null), Te([new g(null, s, null, 1, null), j(d) ? new v(null, 1, 5, y, [u], null) : null]))))], null) : on.g(a, l9) ? new v(null, 2, 5, y, [!1, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, h, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, mi, null, 1, null), new g(null, s, null, 1, null), Te([j(d) ? new v(null, 1, 5, y, [u], null) : null])))), null, 1, null), new g(null, u, null, 1, null)]))))], null) : null;
    }
    u = Xr.h("seq_");
    var p = Bl(
      Xr.h("chunk_"),
      new $(null, 1, [Ft, T0e], null)
    ), _ = Xr.h("count_"), R = Xr.h("i_"), F = ve.h(z(he.l(new g(null, Xd, null, 1, null), new g(null, ve.h(z(he.g(new g(null, _we, null, 1, null), new g(null, u, null, 1, null)))), null, 1, null), Te([new g(null, null, null, 1, null), new g(null, 0, null, 1, null), new g(null, 0, null, 1, null)]))));
    s = r(F, va(o)), d = s.h ? s.h(0) : s.call(null, 0), s = s.h ? s.h(1) : s.call(null, 1);
    var L = ve.h(z(he.l(new g(null, Xd, null, 1, null), new g(null, u, null, 1, null), Te([new g(null, p, null, 1, null), new g(null, _, null, 1, null), new g(null, ve.h(z(he.g(new g(
      null,
      Lx,
      null,
      1,
      null
    ), new g(null, R, null, 1, null)))), null, 1, null)]))));
    return o = r(L, va(o)), o = o.h ? o.h(1) : o.call(null, 1), new v(null, 2, 5, y, [!0, ve.h(z(he.l(new g(null, G0, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, u, null, 1, null), new g(null, ve.h(z(he.g(new g(null, qx, null, 1, null), new g(null, h, null, 1, null)))), null, 1, null), Te([new g(null, p, null, 1, null), new g(null, null, null, 1, null), new g(null, _, null, 1, null), new g(null, 0, null, 1, null), new g(null, R, null, 1, null), new g(null, 0, null, 1, null)]))))), null, 1, null), Te([new g(
      null,
      ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Qx, null, 1, null), new g(null, R, null, 1, null), Te([new g(null, _, null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, a, null, 1, null), new g(null, ve.h(z(he.l(new g(null, WJ, null, 1, null), new g(null, p, null, 1, null), Te([new g(null, R, null, 1, null)])))), null, 1, null))))), null, 1, null), Te([new g(null, o, null, 1, null), j(d) ? new v(null, 1, 5, y, [L], null) : null])))), null, 1, null), new g(null, ve.h(z(he.l(new g(
        null,
        Yl,
        null,
        1,
        null
      ), new g(null, Et(ve.h(z(he.g(new g(null, u, null, 1, null), new g(null, ve.h(z(he.g(new g(null, qx, null, 1, null), new g(null, u, null, 1, null)))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Fx, null, 1, null), new g(null, u, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.g(new g(null, OQ, null, 1, null), new g(null, u, null, 1, null)))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, c6, null, 1, null), new g(
        null,
        ve.h(z(he.g(new g(null, DZ, null, 1, null), new g(null, u, null, 1, null)))),
        null,
        1,
        null
      ))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Xd, null, 1, null), new g(null, ve.h(z(he.g(new g(null, hJ, null, 1, null), new g(null, u, null, 1, null)))), null, 1, null), Te([new g(null, c6, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Vk, null, 1, null), new g(null, ve.h(z(he.g(new g(null, tQ, null, 1, null), new g(null, c6, null, 1, null)))), null, 1, null)))), null, 1, null), new g(
        null,
        ve.h(z(he.g(new g(null, Vk, null, 1, null), new g(null, 0, null, 1, null)))),
        null,
        1,
        null
      )])))), null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, a, null, 1, null), new g(null, ve.h(z(he.g(new g(null, HB, null, 1, null), new g(null, u, null, 1, null)))), null, 1, null))))), null, 1, null), Te([new g(null, s, null, 1, null), j(d) ? new v(null, 1, 5, y, [F], null) : null])))), null, 1, null)])))), null, 1, null)])))), null, 1, null)])))), null, 1, null)])))),
      null,
      1,
      null
    )]))))], null);
  }(null, z(t)), 1);
};
iT.m = 3;
iT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var s4;
e: {
  var y3e = rs;
  rs = !0;
  try {
    var LH = H3(tee);
    dp(LH), s4 = LH;
    break e;
  } finally {
    rs = y3e;
  }
  s4 = void 0;
}
var K$;
e: {
  var _3e = rs;
  rs = !0;
  try {
    var BH = H3($Q);
    dp(BH), K$ = BH;
    break e;
  } finally {
    rs = _3e;
  }
  K$ = void 0;
}
var G$;
e: {
  var x3e = rs;
  rs = !0;
  try {
    var FH = H3(Sne);
    dp(FH), G$ = FH;
    break e;
  } finally {
    rs = x3e;
  }
  G$ = void 0;
}
var Tp;
e: {
  var S3e = rs;
  rs = !0;
  try {
    var VH = H3(GZ);
    dp(VH), Tp = VH;
    break e;
  } finally {
    rs = S3e;
  }
  Tp = void 0;
}
var o4;
e: {
  var E3e = rs;
  rs = !0;
  try {
    var YH = H3(jX);
    dp(YH), o4 = YH;
    break e;
  } finally {
    rs = E3e;
  }
  o4 = void 0;
}
var A1 = new Ne(Ys, q9, new $(null, 6, [te, q9, ne, null, ee, `If set to logical true, when printing an object, its metadata will also
  be printed in a form that can be read back by the reader.

  Defaults to false.`, Ma, !0, Re, !0, ie, Le], null), null), Sg = new Ne(Fu, I9, new $(null, 6, [
  te,
  I9,
  ne,
  null,
  ee,
  `*print-length* controls how many items of each collection the
  printer will print. If it is bound to logical false, there is no
  limit. Otherwise, it must be bound to an integer indicating the maximum
  number of items of each collection to print. If a collection contains
  more items, the printer will print items up to the limit followed by
  '...' to represent the remaining items. The root binding is nil
  indicating no limit.`,
  Ma,
  !0,
  Re,
  !0,
  ie,
  Le
], null), null), Eg = new Ne(Wi, B8, new $(null, 6, [
  te,
  B8,
  ne,
  null,
  ee,
  `*print-level* controls how many levels deep the printer will
  print nested objects. If it is bound to logical false, there is no
  limit. Otherwise, it must be bound to an integer indicating the maximum
  level to print. Each argument to print is at level 0; if an argument is a
  collection, its items are at level 1; and so on. If an object is a
  collection and is at a level greater than or equal to the value bound to
  *print-level*, the printer prints '#' to represent it. The root binding
  is nil indicating no limit.`,
  Ma,
  !0,
  Re,
  !0,
  ie,
  Le
], null), null), Og = new Ne(!0, L$, new $(null, 6, [te, L$, ne, null, ee, `*print-namespace-maps* controls whether the printer will print
  namespace map literal syntax.

  Defaults to false, but the REPL binds it to true.`, Ma, !0, Re, !0, ie, Le], null), null), O3e = new Ne(!0, Q8, new $(null, 6, [te, Q8, ne, null, ee, `When set to true, output will be flushed whenever a newline is printed.

  Defaults to true.`, Ma, !0, Re, !0, ie, Le], null), null), D1 = new Ne(Lu, AN, new $(null, 6, [
  te,
  AN,
  ne,
  null,
  ee,
  `When set to logical false, strings and characters will be printed with
  non-alphanumeric characters converted to the appropriate escape sequences.

  Defaults to true`,
  Ma,
  !0,
  Re,
  !0,
  ie,
  Le
], null), null), kg = new Ne(Bu, rC, new $(null, 6, [te, rC, ne, null, ee, `When set to logical true, objects will be printed in a way that preserves
  their type when read in later.

  Defaults to false.`, Ma, !0, Re, !0, ie, Le], null), null), bg = new Ne(ku, CP, new $(null, 6, [te, CP, ne, null, ee, `When set to logical false will drop newlines from printing calls.
  This is to work around the implicit newlines emitted by standard JavaScript
  console objects.`, Ma, !0, Re, !0, ie, Le], null), null), uT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
uT.l = function(e) {
  var n = Js, t = Fu, l = Wi, r = Ys, u = ns, o = Lu, a = ku, h = Bu, s = sn(Tp), d = sn(Sg), p = sn(Eg), _ = sn(A1), R = sn(Og), F = sn(D1), L = sn(bg), G = sn(kg);
  Js = s, Fu = d, Wi = p, Ys = _, ns = R, Lu = F, ku = L, Bu = G;
  try {
    return In.g(fb, e);
  } finally {
    Bu = h, ku = a, Lu = o, ns = u, Ys = r, Wi = l, Fu = t, Js = n;
  }
};
uT.m = 0;
uT.v = function(e) {
  return this.l(z(e));
};
var sT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
sT.l = function(e) {
  var n = Fu, t = Wi, l = Ys, r = ns, u = Lu, o = ku, a = Bu, h = sn(Sg), s = sn(Eg), d = sn(A1), p = sn(Og), _ = sn(D1), R = sn(bg), F = sn(kg);
  Fu = h, Wi = s, Ys = d, ns = p, Lu = _, ku = R, Bu = F;
  try {
    return In.g(wg, e);
  } finally {
    Bu = a, ku = o, Lu = u, ns = r, Ys = l, Wi = t, Fu = n;
  }
};
sT.m = 0;
sT.v = function(e) {
  return this.l(z(e));
};
var oT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
oT.l = function(e) {
  var n = Js, t = Fu, l = Wi, r = Ys, u = ns, o = Lu, a = ku, h = Bu, s = sn(Tp), d = sn(Sg), p = sn(Eg), _ = sn(A1), R = sn(Og), F = sn(D1), L = sn(bg), G = sn(kg);
  Js = s, Fu = d, Wi = p, Ys = _, ns = R, Lu = F, ku = L, Bu = G;
  try {
    return In.g(mb, e);
  } finally {
    Bu = h, ku = a, Lu = o, ns = u, Ys = r, Wi = l, Fu = t, Js = n;
  }
};
oT.m = 0;
oT.v = function(e) {
  return this.l(z(e));
};
var aT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
aT.l = function(e) {
  var n = Fu, t = Wi, l = Ys, r = ns, u = Lu, o = ku, a = Bu, h = sn(Sg), s = sn(Eg), d = sn(A1), p = sn(Og), _ = sn(D1), R = sn(bg), F = sn(kg);
  Fu = h, Wi = s, Ys = d, ns = p, Lu = _, ku = R, Bu = F;
  try {
    return In.g(hb, e);
  } finally {
    Bu = a, ku = o, Lu = u, ns = r, Ys = l, Wi = t, Fu = n;
  }
};
aT.m = 0;
aT.v = function(e) {
  return this.l(z(e));
};
var cT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
cT.l = function(e) {
  var n = Js, t = Fu, l = Wi, r = ns, u = Lu, o = ku, a = Bu, h = sn(Tp), s = sn(Sg), d = sn(Eg), p = sn(Og), _ = sn(bg), R = sn(kg);
  Js = h, Fu = s, Wi = d, ns = p, Lu = null, ku = _, Bu = R;
  try {
    return In.g(ege, e);
  } finally {
    Bu = a, ku = o, Lu = u, ns = r, Wi = l, Fu = t, Js = n;
  }
};
cT.m = 0;
cT.v = function(e) {
  return this.l(z(e));
};
var hT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
hT.l = function(e) {
  var n = Fu, t = Wi, l = Ys, r = ns, u = Lu, o = ku, a = Bu, h = sn(Sg), s = sn(Eg), d = sn(A1), p = sn(Og), _ = sn(D1), R = sn(bg), F = sn(kg);
  Fu = h, Wi = s, Ys = d, ns = p, Lu = _, ku = R, Bu = F;
  try {
    return In.g(db, e);
  } finally {
    Bu = a, ku = o, Lu = u, ns = r, Ys = l, Wi = t, Fu = n;
  }
};
hT.m = 0;
hT.v = function(e) {
  return this.l(z(e));
};
var Sf = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
Sf.l = function(e) {
  var n = Js, t = Fu, l = Wi, r = Ys, u = ns, o = Lu, a = ku, h = Bu, s = sn(Tp), d = sn(Sg), p = sn(Eg), _ = sn(A1), R = sn(Og), F = sn(D1), L = sn(bg), G = sn(kg);
  Js = s, Fu = d, Wi = p, Ys = _, ns = R, Lu = F, ku = L, Bu = G;
  try {
    return In.g(pb, e);
  } finally {
    Bu = h, ku = a, Lu = o, ns = u, Ys = r, Wi = l, Fu = t, Js = n;
  }
};
Sf.m = 0;
Sf.v = function(e) {
  return this.l(z(e));
};
var fT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
fT.l = function(e, n, t) {
  return ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, JA, null, 1, null), new g(null, ve.h(z(he.g(new g(null, lf, null, 1, null), new g(null, AJ, null, 1, null)))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, kve, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, j0e, null, 1, null), new g(null, !0, null, 1, null), Te([new g(null, Tve, null, 1, null), new g(null, ve.h(z(he.l(
    new g(null, sc, null, 1, null),
    new g(null, Et(ve.h(z(he.h(new g(null, NW, null, 1, null))))), null, 1, null),
    Te([new g(null, ve.h(z(he.l(new g(null, Kf, null, 1, null), new g(null, JA, null, 1, null), Te([new g(null, Cne, null, 1, null), new g(null, NW, null, 1, null)])))), null, 1, null)])
  ))), null, 1, null)]))))), null, 1, null), Te([t, new g(null, ve.h(z(he.g(new g(null, lg, null, 1, null), new g(null, JA, null, 1, null)))), null, 1, null)])))), null, 1, null)]))));
};
fT.m = 2;
fT.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var zne = Hc(xJ, !1, new $(
  null,
  3,
  [ie, Le, Ma, !0, ee, `Defaults to true (or value specified by system property, see below)
  ***This setting implies that the full power of the reader is in play,
  including syntax that can cause code to execute. It should never be
  used with untrusted sources. See also: clojure.edn/read.***

  When set to logical false in the thread-local binding,
  the eval reader (#=) and record/type literal syntax are disabled in read/load.
  Example (will fail): (binding [*read-eval* false] (read-string "#=(* 2 21)"))

  The default binding can be controlled by the system property
  'clojure.read.eval' System properties can be set on the command line
  like this:

  java -Dclojure.read.eval=false ...

  The system property can also be set to 'unknown' via
  -Dclojure.read.eval=unknown, in which case the default binding
  is :unknown and all reads will fail in contexts where *read-eval*
  has not been explicitly bound to either true or false. This setting
  can be a useful diagnostic tool to ensure that all of your reads
  occur in considered contexts. You can also accomplish this in a
  particular scope by binding *read-eval* to :unknown
  `],
  null
)), Kne = Hc(NQ, Tt, new $(
  null,
  3,
  [ie, Le, Ma, !0, ee, `Map from reader tag symbols to data reader Vars.

  When Clojure starts, it searches for files named 'data_readers.clj'
  and 'data_readers.cljc' at the root of the classpath. Each such file
  must contain a literal map of symbols, like this:

      {foo/bar my.project.foo/bar
       foo/baz my.project/baz}

  The first symbol in each pair is a tag that will be recognized by
  the Clojure reader. The second symbol in the pair is the
  fully-qualified name of a Var which will be invoked by the reader to
  parse the form following the tag. For example, given the
  data_readers.clj file above, the Clojure reader would parse this
  form:

      #foo/bar [1 2 3]

  by invoking the Var #'my.project.foo/bar on the vector [1 2 3]. The
  data reader function is invoked on the form AFTER it has been read
  as a normal Clojure data structure by the reader.

  Reader tags without namespace qualifiers are reserved for
  Clojure. Default reader tags are defined in
  clojure.core/default-data-readers but may be overridden in
  data_readers.clj, data_readers.cljc, or by rebinding this Var.`],
  null
)), Gne = Hc(Iee, null, new $(null, 3, [ie, Le, Ma, !0, ee, `When no data reader is found for a tag and *default-data-reader-fn*
  is non-nil, it will be called with two arguments,
  the tag and the value.  If *default-data-reader-fn* is nil (the
  default), an exception will be thrown for the unknown tag.`], null)), k3e = Hc(EZ, null, new $(null, 2, [ie, Le, Ma, !0], null)), b3e = function(e) {
  var n = function() {
    var l = zf.h(e);
    return j(l) ? lr.g(nr.g(e, zf), new v(null, 9, 5, y, [function() {
      var r = xr.g(l, new v(null, 1, 5, y, ["@"], null));
      return j(r) ? new v(null, 2, 5, y, [sf, r], null) : null;
    }(), function() {
      var r = xr.g(l, new v(null, 1, 5, y, ["`"], null));
      return j(r) ? new v(null, 2, 5, y, [ba, r], null) : null;
    }(), function() {
      var r = xr.g(l, new v(null, 1, 5, y, ["~"], null));
      return j(r) ? Bw(r) ? new v(null, 2, 5, y, [nf, r], null) : (r = ai.h(r), j(r) ? new v(null, 2, 5, y, [nf, r], null) : null) : null;
    }(), function() {
      var r = xr.g(l, new v(null, 2, 5, y, ["~", "@"], null));
      return j(r) ? new v(null, 2, 5, y, [Wf, r], null) : null;
    }(), function() {
      var r = xr.g(l, new v(null, 1, 5, y, ["'"], null));
      return j(r) ? new v(null, 2, 5, y, [af, r], null) : null;
    }(), function() {
      var r = xr.g(l, new v(null, 2, 5, y, ["#", "("], null));
      return j(r) ? new v(null, 2, 5, y, [qs, r], null) : null;
    }(), function() {
      var r = xr.g(l, new v(null, 2, 5, y, ["#", "'"], null));
      return j(r) ? new v(null, 2, 5, y, [$o, r], null) : null;
    }(), function() {
      var r = xr.g(l, new v(null, 2, 5, y, ["#", "="], null));
      return j(r) ? new v(null, 2, 5, y, [wh, r], null) : null;
    }(), function() {
      var r = xr.g(l, new v(null, 2, 5, y, ["#", '"'], null));
      return j(r) ? new v(null, 2, 5, y, [rf, r], null) : null;
    }()], null)) : e;
  }(), t = j(kk.h(n)) ? gr.l(Te([new $(
    null,
    7,
    [sf, !0, qs, !0, af, !0, wh, !0, rf, !0, ba, !0, $o, !0],
    null
  ), n])) : n;
  return n = function() {
    var l = er(ka.h(t)) ? Dn.j(t, ka, Du) : t;
    return l = er(Sa.h(t)) ? Dn.j(l, Sa, tu) : l, l = er(Fc.h(t)) ? Dn.j(l, Fc, Q0e) : l, l = er(Uc.h(t)) ? Dn.j(l, Uc, Hge) : l, l = er(vh.h(t)) ? Dn.j(l, vh, co) : l, Ol(t, dh) ? l : Dn.j(l, dh, !0);
  }(), n = Dn.j(n, tf, kr.h(null)), Xde(n);
}(new $(null, 6, [kk, !0, ka, Yn, Sa, zn, Ob, Ew, Uf, ei, dh, !1], null)), _h = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    case 5:
      return e.I(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
_h.h = function(e) {
  return _h.g(e, sn(s4));
};
_h.g = function(e, n) {
  return _h.B(e, n, !0, null);
};
_h.B = function(e, n, t, l) {
  return _h.I(e, n, t, l, !1);
};
_h.I = function(e, n, t, l) {
  return e = z3(e, n, new $(null, 1, [qf, l], null)), FG(new $(null, 1, [qf, l], null), e);
};
_h.j = function(e, n, t) {
  return n = j(Ob.h(n)) ? Dn.j(n, u1, lr.g(new gi(null, new $(null, 1, [l2e, null], null), null), u1.h(n))) : n, e = z3(e, t, n), FG(n, e);
};
_h.m = 5;
var dT = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
dT.g = function(e, n) {
  return n = H4(x1(n)), _h.g(e, n);
};
dT.j = function(e, n, t) {
  return t = H4(x1(t)), _h.j(e, n, t);
};
dT.m = 3;
var pT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
pT.l = function(e, n, t, l) {
  return n = xy(jp, l), t = fr(n), n = en.g(t, !0), t = en.g(t, !1), t = lr.g(Tt, bt.g(function(r) {
    var u = O.j(r, 0, null);
    return r = O.j(r, 1, null), u = b3(u) ? u : _n.h(ml(u)), Et(ve.h(z(he.g(new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, u, null, 1, null)))), null, 1, null), new g(null, ve.h(z(he.g(new g(null, sc, null, 1, null), bt.g(tn, r)))), null, 1, null)))));
  }, xy(I, t))), ve.h(z(he.l(new g(null, N1e, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, e, null, 1, null)))), null, 1, null), Te([new g(
    null,
    Et(n),
    null,
    1,
    null
  ), new g(null, t, null, 1, null)]))));
};
pT.m = 3;
pT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var mT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
mT.l = function(e, n, t, l) {
  for (e = t; ; ) if (j(l)) n = I(l), e = ei(n) ? Bl(ve.h(z(he.l(new g(null, I(n), null, 1, null), new g(null, e, null, 1, null), Te([W(n)])))), Vt(n)) : new g(null, n, new g(null, e, null, 1, null), 2, null), l = W(l);
  else return e;
};
mT.m = 3;
mT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var gT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
gT.l = function(e, n, t, l) {
  for (e = t; ; ) if (j(l)) n = I(l), e = ei(n) ? Bl(ve.h(z(he.l(new g(null, I(n), null, 1, null), W(n), Te([new g(null, e, null, 1, null)])))), Vt(n)) : new g(null, n, new g(null, e, null, 1, null), 2, null), l = W(l);
  else return e;
};
gT.m = 3;
gT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var wT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], 4 < t.length ? new hn(t.slice(4), 0, null) : null);
};
wT.l = function(e, n, t, l, r) {
  return ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, l, null, 1, null), new g(null, t, null, 1, null), Te([Nu.g(sa.h(l), td(r))]))))), null, 1, null), Te([new g(null, Ca(r) ? l : ho(r), null, 1, null)]))));
};
wT.m = 4;
wT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
var vT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
vT.l = function() {
  return null;
};
vT.m = 2;
vT.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var yT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
yT.l = function(e, n, t, l) {
  return e = I(t), t = Vr(t), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, Kq, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Vve, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, G0, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, e, null, 1, null), new g(null, 0, null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, yw, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Qx, null, 1, null), new g(
    null,
    e,
    null,
    1,
    null
  ), Te([new g(null, Kq, null, 1, null)])))), null, 1, null), Te([l, new g(null, ve.h(z(he.g(new g(null, Xd, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Lx, null, 1, null), new g(null, e, null, 1, null)))), null, 1, null)))), null, 1, null)])))), null, 1, null)])))), null, 1, null)]))));
};
yT.m = 3;
yT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var n3 = function e(n) {
  switch (arguments.length) {
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    case 5:
      return e.I(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
n3.B = function(e, n, t, l) {
  return n3.I(e, n, t, l, null);
};
n3.I = function(e, n, t, l, r) {
  return ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.g(new g(null, p2e, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null), Te([new g(null, l, null, 1, null), new g(null, r, null, 1, null)]))));
};
n3.m = 5;
var _T = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
_T.l = function(e, n, t, l) {
  return new g(null, si, new g(null, t, new g(null, kt(mi, l), null, 1, null), 2, null), 3, null);
};
_T.m = 3;
_T.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var xT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
xT.l = function(e, n, t, l) {
  return new g(null, si, new g(null, t, new g(null, null, new g(null, kt(mi, l), null, 1, null), 2, null), 3, null), 4, null);
};
xT.m = 3;
xT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var ST = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
ST.l = function(e, n, t, l) {
  var r = Xr.o();
  return ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, r, null, 1, null), new g(null, t, null, 1, null))))), null, 1, null), Te([bt.g(function(u) {
    return Bl(ei(u) ? ve.h(z(he.l(new g(null, I(u), null, 1, null), new g(null, r, null, 1, null), Te([W(u)])))) : ve.h(z(he.g(new g(null, u, null, 1, null), new g(null, r, null, 1, null)))), Vt(u));
  }, l), new g(null, r, null, 1, null)]))));
};
ST.m = 3;
ST.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var ET = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
ET.l = function(e, n, t) {
  if (j(t)) {
    if (e = si, n = I(t), W(t)) var l = Vr(t);
    else throw Error("cond requires an even number of forms");
    t = new g(null, e, new g(null, n, new g(null, l, new g(null, kt(f1e, W(W(t))), null, 1, null), 2, null), 3, null), 4, null);
  } else t = null;
  return t;
};
ET.m = 2;
ET.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var OT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
OT.l = function(e, n, t, l) {
  var r = Xr.o();
  return e = bt.g(function(u) {
    var o = O.j(u, 0, null);
    return u = O.j(u, 1, null), ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, o, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Tee, null, 1, null), new g(null, r, null, 1, null), Te([new g(null, u, null, 1, null)])))), null, 1, null), new g(null, r, null, 1, null)]))));
  }, Mo.g(2, l)), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, r, null, 1, null), new g(null, t, null, 1, null), Te([Nu.g(sa.h(r), td(e))]))))), null, 1, null), Te([new g(
    null,
    Ca(e) ? r : ho(e),
    null,
    1,
    null
  )]))));
};
OT.m = 3;
OT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var kT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
kT.l = function(e, n, t, l) {
  var r = Xr.o();
  return e = bt.g(function(u) {
    var o = O.j(u, 0, null);
    return u = O.j(u, 1, null), ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, o, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Fee, null, 1, null), new g(null, r, null, 1, null), Te([new g(null, u, null, 1, null)])))), null, 1, null), new g(null, r, null, 1, null)]))));
  }, Mo.g(2, l)), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, r, null, 1, null), new g(null, t, null, 1, null), Te([Nu.g(sa.h(r), td(e))]))))), null, 1, null), Te([new g(
    null,
    Ca(e) ? r : ho(e),
    null,
    1,
    null
  )]))));
};
kT.m = 3;
kT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var Qy = function e(n) {
  switch (arguments.length) {
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], new hn(t.slice(5), 0, null));
  }
};
Qy.B = function(e, n, t, l) {
  return Qy(e, n, t, l, null);
};
Qy.l = function(e, n, t, l, r) {
  return e = t.h ? t.h(0) : t.call(null, 0), t = t.h ? t.h(1) : t.call(null, 1), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, L6, null, 1, null), new g(null, t, null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, L6, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, e, null, 1, null), new g(null, L6, null, 1, null))))), null, 1, null), Te([new g(null, l, null, 1, null)])))), null, 1, null), new g(
    null,
    r,
    null,
    1,
    null
  )])))), null, 1, null)]))));
};
Qy.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  l = I(r);
  var u = W(r);
  return r = I(u), u = W(u), this.l(n, e, t, l, r, u);
};
Qy.m = 5;
var Jy = function e(n) {
  switch (arguments.length) {
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], new hn(t.slice(5), 0, null));
  }
};
Jy.B = function(e, n, t, l) {
  return Jy(e, n, t, l, null);
};
Jy.l = function(e, n, t, l, r) {
  return e = t.h ? t.h(0) : t.call(null, 0), t = t.h ? t.h(1) : t.call(null, 1), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, K6, null, 1, null), new g(null, t, null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.g(new g(null, vb, null, 1, null), new g(null, K6, null, 1, null)))), null, 1, null), Te([new g(null, r, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, e, null, 1, null), new g(
    null,
    K6,
    null,
    1,
    null
  ))))), null, 1, null), Te([new g(null, l, null, 1, null)])))), null, 1, null)])))), null, 1, null)]))));
};
Jy.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  l = I(r);
  var u = W(r);
  return r = I(u), u = W(u), this.l(n, e, t, l, r, u);
};
Jy.m = 5;
var bT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
bT.l = function(e, n, t, l) {
  return e = t.h ? t.h(0) : t.call(null, 0), t = t.h ? t.h(1) : t.call(null, 1), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, mD, null, 1, null), new g(null, t, null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, yw, null, 1, null), new g(null, mD, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, e, null, 1, null), new g(null, mD, null, 1, null))))), null, 1, null), Te([l])))), null, 1, null)])))), null, 1, null)]))));
};
bT.m = 3;
bT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var TT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
TT.l = function(e, n, t, l) {
  return e = O.j(t, 0, null), t = O.j(t, 1, null), ve.h(z(he.l(new g(null, dwe, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, xW, null, 1, null), new g(null, ve.h(z(he.g(new g(null, qx, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, e, null, 1, null), new g(null, ve.h(z(he.g(new g(null, HB, null, 1, null), new g(null, xW, null, 1, null)))), null, 1, null))))), null, 1, null), Te([l])))), null, 1, null)]))));
};
TT.m = 3;
TT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var jT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
jT.l = function(e, n, t, l) {
  return e = t.h ? t.h(0) : t.call(null, 0), t = t.h ? t.h(1) : t.call(null, 1), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, dD, null, 1, null), new g(null, t, null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.g(new g(null, vb, null, 1, null), new g(null, dD, null, 1, null)))), null, 1, null), Te([new g(null, null, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, e, null, 1, null), new g(
    null,
    dD,
    null,
    1,
    null
  ))))), null, 1, null), Te([l])))), null, 1, null)])))), null, 1, null)]))));
};
jT.m = 3;
jT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var AT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
AT.l = function(e, n, t, l) {
  var r = Xr.o();
  return e = bt.g(function(u) {
    return ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.g(new g(null, vb, null, 1, null), new g(null, r, null, 1, null)))), null, 1, null), Te([new g(null, null, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Tee, null, 1, null), new g(null, r, null, 1, null), Te([new g(null, u, null, 1, null)])))), null, 1, null)]))));
  }, l), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(
    null,
    Et(ve.h(z(he.l(new g(null, r, null, 1, null), new g(null, t, null, 1, null), Te([Nu.g(sa.h(r), td(e))]))))),
    null,
    1,
    null
  ), Te([new g(null, Ca(e) ? r : ho(e), null, 1, null)]))));
};
AT.m = 3;
AT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var DT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
DT.l = function(e, n, t, l) {
  var r = Xr.o();
  return e = bt.g(function(u) {
    return ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.g(new g(null, vb, null, 1, null), new g(null, r, null, 1, null)))), null, 1, null), Te([new g(null, null, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Fee, null, 1, null), new g(null, r, null, 1, null), Te([new g(null, u, null, 1, null)])))), null, 1, null)]))));
  }, l), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(
    null,
    Et(ve.h(z(he.l(new g(null, r, null, 1, null), new g(null, t, null, 1, null), Te([Nu.g(sa.h(r), td(e))]))))),
    null,
    1,
    null
  ), Te([new g(null, Ca(e) ? r : ho(e), null, 1, null)]))));
};
DT.m = 3;
DT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var IT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
IT.l = function(e, n, t) {
  return ve.h(z(he.g(new g(null, mi, null, 1, null), bt.g(function(l) {
    return new g(null, Yc, new g(null, wu.B(l, Dn, Fye, !0), null, 1, null), 2, null);
  }, t))));
};
IT.m = 2;
IT.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var T3e = function() {
  var e = typeof Ev < "u" && typeof hZ < "u" && typeof kS < "u" ? new Jn(function() {
    return kS;
  }, Bl(C2e, new $(null, 1, [JB, !0], null)), Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [r5, Qk, "cljs/core.cljs", 17, 1, 11664, 11664, ue(new v(null, 1, 5, y, [zx], null)), `Returns the message attached to the given Error / ExceptionInfo object.
  For non-Errors returns nil.`, j(kS) ? kS.D : null])) : null;
  return j(e) ? sn(e) : function(n) {
    return n instanceof Error ? n.message : null;
  };
}(), j3e = function() {
  var e = typeof Ev < "u" && typeof hZ < "u" && typeof bS < "u" ? new Jn(function() {
    return bS;
  }, Bl(hge, new $(null, 1, [JB, !0], null)), Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [r5, Mk, "cljs/core.cljs", 15, 1, 11671, 11671, ue(new v(null, 1, 5, y, [zx], null)), `Returns exception cause (an Error / ExceptionInfo) if ex is an
  ExceptionInfo.
  Otherwise returns nil.`, j(bS) ? bS.D : null])) : null;
  return j(e) ? sn(e) : function(n) {
    return n instanceof ld ? n.cause : null;
  };
}(), gF = W3(KJ, !0, new $(null, 1, [ie, Le], null)), RT = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(
        arguments[0],
        arguments[1],
        arguments[2]
      );
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
RT.j = function(e, n, t) {
  return j(sn(gF)) ? ve.h(z(he.l(new g(null, GB, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, rp, null, 1, null), new g(null, ve.h(z(he.g(new g(null, uQ, null, 1, null), new g(null, ve.h(z(he.l(new g(null, lg, null, 1, null), new g(null, "Assert failed: ", null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, fne, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null)))), null, 1, null)])))), null, 1, null)))), null, 1, null)))), null, 1, null)])))) : null;
};
RT.B = function(e, n, t, l) {
  return j(sn(gF)) ? ve.h(z(he.l(new g(null, GB, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, rp, null, 1, null), new g(null, ve.h(z(he.g(new g(null, uQ, null, 1, null), new g(
    null,
    ve.h(z(he.l(new g(null, lg, null, 1, null), new g(null, "Assert failed: ", null, 1, null), Te([new g(null, l, null, 1, null), new g(null, `
`, null, 1, null), new g(null, ve.h(z(he.g(new g(null, fne, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null)))), null, 1, null)])))),
    null,
    1,
    null
  )))), null, 1, null)))), null, 1, null)])))) : null;
};
RT.m = 4;
var NT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
NT.l = function(e, n, t, l) {
  return on.g(Cn(t), 0) ? ve.h(z(he.g(new g(null, mi, null, 1, null), l))) : (t.h ? t.h(0) : t.call(null, 0)) instanceof T ? ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, _p.j(t, 0, 2), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, T1, null, 1, null), new g(null, ve.h(z(he.l(new g(null, D0e, null, 1, null), new g(null, _p.g(t, 2), null, 1, null), Te([l])))), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, A2, null, 1, null), new g(
    null,
    ve.h(z(he.g(new g(null, G2e, null, 1, null), new g(null, t.h ? t.h(0) : t.call(null, 0), null, 1, null)))),
    null,
    1,
    null
  )))), null, 1, null)])))), null, 1, null)])))) : oxe;
};
NT.m = 3;
NT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var CT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
CT.l = function(e, n, t, l) {
  return e = bt.g(I, t), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(Nu.g(e, sa.h(ue(Lge)))), null, 1, null), Te([bt.j(function(r, u) {
    return ve.h(z(he.l(new g(null, OB, null, 1, null), new g(null, r, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, MJ, null, 1, null), new g(null, ve.h(z(he.l(new g(null, sc, null, 1, null), new g(null, r, null, 1, null), Te([tn(u)])))), null, 1, null)))), null, 1, null)]))));
  }, e, t), new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(Nu.g(e, bt.g(function(r) {
    return ve.h(z(he.g(new g(
      null,
      E_e,
      null,
      1,
      null
    ), new g(null, r, null, 1, null))));
  }, e))), null, 1, null), Te([l])))), null, 1, null)]))));
};
CT.m = 3;
CT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var MT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
MT.l = function(e, n, t, l) {
  return or(t) || mu("with-local-vars requires a vector for its bindings", e), qc(Cn(t)) || mu("with-local-vars requires an even number of forms in binding vector", e), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.h(Nu.g(Po.g(2, t), sa.h(ue(Mge))))))), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, _X, null, 1, null), new g(null, ve.h(z(he.g(new g(null, tne, null, 1, null), t))), null, 1, null)))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, T1, null, 1, null), l, Te([new g(null, ve.h(z(he.g(new g(
    null,
    A2,
    null,
    1,
    null
  ), new g(null, ve.h(z(he.h(new g(null, cJ, null, 1, null)))), null, 1, null)))), null, 1, null)])))), null, 1, null)]))));
};
MT.m = 3;
MT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var PT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], 4 < t.length ? new hn(t.slice(4), 0, null) : null);
};
PT.l = function(e, n, t, l, r) {
  return ve.h(z(he.l(new g(null, r0e, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, l, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Qve, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null), Te([r])))), null, 1, null)]))));
};
PT.m = 4;
PT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
var A3e = Bl(function() {
  function e(t, l, r, u) {
    var o = null;
    if (3 < arguments.length) {
      o = 0;
      for (var a = Array(arguments.length - 3); o < a.length; ) a[o] = arguments[o + 3], ++o;
      o = new hn(a, 0, null);
    }
    return n.call(this, t, l, r, o);
  }
  function n(t, l, r, u) {
    return t = Bl(Xr.h("target"), Vt(r)), ve.h(z(he.l(new g(null, sc, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, t, null, 1, null), u)))), null, 1, null), Te([new g(
      null,
      ve.h(z(he.l(new g(null, Kf, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, r, null, 1, null), u))), null, 1, null)])))),
      null,
      1,
      null
    )]))));
  }
  return e.m = 3, e.v = function(t) {
    var l = I(t);
    t = W(t);
    var r = I(t);
    t = W(t);
    var u = I(t);
    return t = tn(t), n(l, r, u, t);
  }, e.l = n, e;
}(), new $(null, 1, [a5, !0], null)), $T = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
$T.l = function(e, n, t) {
  return ve.h(z(he.l(new g(null, lf, null, 1, null), new g(null, g_e, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, sc, null, 1, null), new g(null, Et(ve.h(z(he.o()))), null, 1, null), Te([t])))), null, 1, null)]))));
};
$T.m = 2;
$T.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var LT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
LT.l = function(e, n, t, l) {
  return us.j(Zx, Bl(t, Dn.j(Vt(t), kh, !0)), l);
};
LT.m = 3;
LT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var BT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], 4 < t.length ? new hn(t.slice(4), 0, null) : null);
};
BT.l = function(e, n, t, l, r) {
  return e = Xr.h("pred__"), n = Xr.h("expr__"), ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, e, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, n, null, 1, null), new g(null, l, null, 1, null)]))))), null, 1, null), Te([new g(null, function u(o, a, h) {
    var s = jL(on.g(J_e, Vr(h)) ? 3 : 2, h), d = O.j(s, 0, null);
    h = O.j(d, 0, null);
    var p = O.j(d, 1, null), _ = O.j(d, 2, null);
    return s = O.j(s, 1, null), d = Cn(d), on.g(0, d) ? ve.h(z(he.g(new g(null, rp, null, 1, null), new g(null, ve.h(z(he.l(new g(
      null,
      lf,
      null,
      1,
      null
    ), new g(null, Cx, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, lg, null, 1, null), new g(null, "No matching clause: ", null, 1, null), Te([new g(null, a, null, 1, null)])))), null, 1, null)])))), null, 1, null)))) : on.g(1, d) ? h : on.g(2, d) ? ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.l(new g(null, o, null, 1, null), new g(null, h, null, 1, null), Te([new g(null, a, null, 1, null)])))), null, 1, null), Te([new g(null, p, null, 1, null), new g(null, u(o, a, s), null, 1, null)])))) : ve.h(z(he.l(new g(null, Zd, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(
      null,
      rH,
      null,
      1,
      null
    ), new g(null, ve.h(z(he.l(new g(null, o, null, 1, null), new g(null, h, null, 1, null), Te([new g(null, a, null, 1, null)])))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, _, null, 1, null), new g(null, rH, null, 1, null)))), null, 1, null), new g(null, u(o, a, s), null, 1, null)]))));
  }(e, n, r), null, 1, null)]))));
};
BT.m = 4;
BT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
var FT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
FT.l = function(e, n, t, l) {
  return ve.h(z(he.l(new g(null, $B, null, 1, null), new g(null, Et(ve.h(z(he.o()))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, yw, null, 1, null), new g(null, t, null, 1, null), Te([l, new g(null, ve.h(z(he.h(new g(null, b1, null, 1, null)))), null, 1, null)])))), null, 1, null)]))));
};
FT.m = 3;
FT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var E5 = function e(n) {
  switch (arguments.length) {
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], arguments[3], new hn(t.slice(4), 0, null));
  }
};
E5.B = function(e, n, t, l) {
  return ve.h(z(he.l(new g(null, Kf, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, l, null, 1, null)]))));
};
E5.l = function(e, n, t, l, r) {
  return ve.h(z(he.l(new g(null, bk, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Kf, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, l, null, 1, null)])))), null, 1, null), Te([r]))));
};
E5.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
E5.m = 4;
var VT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
VT.l = function(e, n, t) {
  return ve.h(z(he.g(new g(null, PJ, null, 1, null), bt.g(function(l) {
    return new g(null, XN, new g(null, l, null, 1, null), 2, null);
  }, t))));
};
VT.m = 2;
VT.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var YT = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
YT.j = function(e, n, t) {
  var l = $c(e, n);
  n = tc(l), e = Or.h(e);
  var r = xr.g(sn(e), new v(null, 3, 5, y, [Il, n, t], null));
  return j(r) ? r : (r = _n.g(ye.h(n), ye.h(t)), l = Hc(r, null, Dn.j(Vt(t), ie, l)), dp(l), wr.B(e, xs, new v(null, 3, 5, y, [Il, n, t], null), l), l);
};
YT.B = function(e, n, t, l) {
  var r = $c(e, n);
  n = tc(r), e = Or.h(e);
  var u = xr.g(sn(e), new v(null, 3, 5, y, [Il, n, t], null));
  return j(u) ? Fm(u, l) : u = null, j(u) ? u : (u = _n.g(ye.h(n), ye.h(t)), l = Hc(u, l, Dn.j(Vt(t), ie, r)), wr.B(e, xs, new v(null, 3, 5, y, [Il, n, t], null), l), l);
};
YT.m = 4;
var t3 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
t3.l = function(e, n) {
  return In.j(sn($ne), e, n);
};
t3.m = 1;
t3.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
var UT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
UT.l = function(e, n) {
  return In.j(sn(Lne), e, n);
};
UT.m = 1;
UT.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
var sp = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
sp.g = function(e, n) {
  var t = Ws.h(e), l = sn(xg);
  return l.j ? l.j(e, t, n) : l.call(null, e, t, n);
};
sp.j = function(e, n, t) {
  var l = Ws.h(e), r = sn(xg);
  return r.B ? r.B(e, l, n, t) : r.call(null, e, l, n, t);
};
sp.m = 3;
var qT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
qT.l = function(e, n) {
  return In.j(sn(Bne), e, n);
};
qT.m = 1;
qT.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
var WT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
WT.l = function(e, n, t) {
  return ve.h(z(he.l(new g(null, Swe, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, ks, null, 1, null)))), null, 1, null), Te([t]))));
};
WT.m = 2;
WT.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var HT = function e(n) {
  switch (arguments.length) {
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
HT.j = function(e, n, t) {
  mg(Qu([Mi, $c(e, n)]));
  try {
    return sp.g(e, t);
  } finally {
    Vm();
  }
};
HT.B = function(e, n, t, l) {
  mg(Qu([Mi, $c(e, n)]));
  try {
    return sp.j(e, t, l);
  } finally {
    Vm();
  }
};
HT.m = 4;
var l3 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
l3.l = function(e, n, t) {
  mg(e);
  try {
    return In.g(n, t);
  } finally {
    Vm();
  }
};
l3.m = 2;
l3.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var zT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
zT.l = function(e, n, t, l) {
  return ve.h(z(he.l(new g(null, Gwe, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, sc, null, 1, null), new g(null, Et(ve.h(z(he.o()))), null, 1, null), Te([l])))), null, 1, null)]))));
};
zT.m = 3;
zT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var KT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
KT.l = function(e, n, t, l) {
  or(t) || mu("binding requires a vector for its bindings", e), qc(Cn(t)) || mu("binding requires an even number of forms in binding vector", e), e = ve.h, n = he.l;
  var r = new g(null, Yl, null, 1, null), u = new g(null, Et(ve.h(z(he.o()))), null, 1, null), o = ve.h, a = he.g, h = new g(null, _X, null, 1, null), s = ve.h, d = he.g, p = new g(null, tne, null, 1, null);
  e: {
    var _ = Dt;
    for (t = z(t); ; ) if (t) _ = yt.g(yt.g(_, ve.h(z(he.g(new g(null, $u, null, 1, null), new g(null, I(t), null, 1, null))))), Vr(t)), t = W(W(t));
    else {
      t = z(_);
      break e;
    }
  }
  return e.call(ve, z(n.call(
    he,
    r,
    u,
    Te([new g(null, o.call(ve, z(a.call(he, h, new g(null, s.call(ve, z(d.call(he, p, t))), null, 1, null)))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, T1, null, 1, null), l, Te([new g(null, ve.h(z(he.g(new g(null, A2, null, 1, null), new g(null, ve.h(z(he.h(new g(null, cJ, null, 1, null)))), null, 1, null)))), null, 1, null)])))), null, 1, null)])
  )));
};
KT.m = 3;
KT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var GT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
GT.l = function(e, n, t) {
  return ve.h(z(he.g(new g(null, rye, null, 1, null), new g(null, ve.h(z(he.g(new g(null, sc, null, 1, null), t))), null, 1, null))));
};
GT.m = 2;
GT.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var ZT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
ZT.l = function(e) {
  return hu(function(n) {
    return Q4(n);
  }, e);
};
ZT.m = 0;
ZT.v = function(e) {
  return this.l(z(e));
};
var XT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
XT.l = function(e, n, t, l) {
  return ve.h(z(he.l(new g(null, fye, null, 1, null), new g(null, _a(bt.g(function(r) {
    return new g(null, $u, new g(null, r, null, 1, null), 2, null);
  }, Po.g(2, t)), Po.g(2, W(t))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, sc, null, 1, null), new g(null, Et(ve.h(z(he.o()))), null, 1, null), Te([l])))), null, 1, null)]))));
};
XT.m = 3;
XT.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var QT = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
QT.h = function(e) {
  if (Qs(e)) {
    var n = Vt(e);
    return e = ie.h(n), n = te.h(n), j(j(e) ? n : e) ? _n.g(ye.h(tc(e)), ml(n)) : null;
  }
  return _n.h(e);
};
QT.g = function(e, n) {
  return _n.g(e, n);
};
QT.m = 2;
var D3e = new $(null, 5, [Go, oc(IZ, null), kh, !0, hne, Xb, Y0e, qG, I2e, function(e, n, t, l) {
  return new _2(e, n, t, l, null);
}], null), I3e = new $(null, 8, [Go, oc(Xee, null), kh, !0, hne, w5, Cve, qG, Uge, function(e, n, t, l) {
  return new sB(e, n, t, l);
}, lve, gx, yye, ck, cw, la], null), R3e = new $(null, 3, [Go, oc(wX, null), kh, !0, N_e, oB], null), Zne = new Ne(Zne, WI, new $(null, 5, [te, WI, ne, null, ee, "bound in a repl thread to the most recent value printed", Re, !0, ie, Le], null), null), Xne = new Ne(Xne, HI, new $(null, 5, [
  te,
  HI,
  ne,
  null,
  ee,
  "bound in a repl thread to the second most recent value printed",
  Re,
  !0,
  ie,
  Le
], null), null), Qne = new Ne(Qne, zI, new $(null, 5, [te, zI, ne, null, ee, "bound in a repl thread to the third most recent value printed", Re, !0, ie, Le], null), null), Jne = new Ne(Jne, GI, new $(null, 5, [te, GI, ne, null, ee, "bound in a repl thread to the most recent exception caught by the repl", Re, !0, ie, Le], null), null), JT = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
JT.l = function(e, n, t) {
  var l = Vt(e);
  if (er(Re.h(l))) return In.B(j2, e, n, t);
  throw Yr.g(["Built-in var ", ye.h(e), " is read-only."].join(""), new $(null, 1, [$o, e], null));
};
JT.m = 2;
JT.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var ej = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
ej.l = function(e, n, t, l) {
  return or(t) || mu("let requires a vector for its binding", e), qc(Cn(t)) || mu("let requires an even number of forms in binding vector", e), ve.h(z(he.l(new g(null, Gy, null, 1, null), new g(null, rB(t), null, 1, null), Te([l]))));
};
ej.m = 3;
ej.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var nj = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
nj.l = function(e, n, t, l) {
  return or(t) || mu("let requires a vector for its binding", e), qc(Cn(t)) || mu("let requires an even number of forms in binding vector", e), (hu(jp, t) ? t : rB(t)) === t ? ve.h(z(he.l(new g(null, Hx, null, 1, null), new g(null, t, null, 1, null), Te([l])))) : (e = Po.g(2, uu.g(1, t)), t = Po.g(2, t), n = bt.g(function(r) {
    return r instanceof T ? r : Xr.o();
  }, t), e = wt.j(function(r, u) {
    var o = O.j(u, 0, null), a = O.j(u, 1, null);
    return u = O.j(u, 2, null), o instanceof T ? yt.l(r, u, Te([a])) : yt.l(r, u, Te([a, o, u]));
  }, Dt, bt.B(k2, t, e, n)), ve.h(z(he.l(new g(
    null,
    Yl,
    null,
    1,
    null
  ), new g(null, e, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Hx, null, 1, null), new g(null, Et(Nu.g(n, n)), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(Nu.g(t, n)), null, 1, null), Te([l])))), null, 1, null)])))), null, 1, null)])))));
};
nj.m = 3;
nj.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var R2 = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
R2.g = function() {
  return null;
};
R2.j = function(e, n, t) {
  return t;
};
R2.l = function(e, n, t, l) {
  return ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, J6, null, 1, null), new g(null, t, null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, J6, null, 1, null), Te([new g(null, J6, null, 1, null), new g(null, ve.h(z(he.g(new g(null, dQ, null, 1, null), l))), null, 1, null)])))), null, 1, null)]))));
};
R2.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
R2.m = 3;
var N2 = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], arguments[2], new hn(t.slice(3), 0, null));
  }
};
N2.g = function() {
  return !0;
};
N2.j = function(e, n, t) {
  return t;
};
N2.l = function(e, n, t, l) {
  return ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, V6, null, 1, null), new g(null, t, null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, V6, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, R1e, null, 1, null), l))), null, 1, null), new g(null, V6, null, 1, null)])))), null, 1, null)]))));
};
N2.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
N2.m = 3;
var tj = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
tj.l = function(e, n, t) {
  return ve.h(z(he.g(new g(null, bb, null, 1, null), t)));
};
tj.m = 2;
tj.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var lj = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], 3 < t.length ? new hn(t.slice(3), 0, null) : null);
};
lj.l = function(e, n, t, l) {
  return e = typeof I(l) == "string" ? I(l) : null, l = j(e) ? W(l) : l, t = j(e) ? wu.B(t, Dn, ee, e) : t, e = ci(I(l)) ? I(l) : null, l = j(e) ? W(l) : l, t = j(e) ? wu.j(t, gr, e) : t, l = Ia.g(function(r) {
    return on.g(xve, I(r));
  }, l), e = Vt(t), ve.h(z(he.l(new g(null, mi, null, 1, null), new g(null, ve.h(z(he.g(new g(null, hwe, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null)))), null, 1, null), Te([j(e) ? ve.h(z(he.l(new g(null, lF, null, 1, null), new g(null, ve.h(z(he.g(new g(null, XQ, null, 1, null), new g(
    null,
    ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, t, null, 1, null)))),
    null,
    1,
    null
  )))), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, MJ, null, 1, null), new g(null, e, null, 1, null)))), null, 1, null)])))) : null, bt.g(function(r) {
    var u = z(r), o = I(u);
    return u = W(u), Bl(ve.h(z(he.g(new g(null, _n.g("clojure.core", ml(o)), null, 1, null), bt.g(function(a) {
      return new g(null, Fr, new g(null, a, null, 1, null), 2, null);
    }, u)))), Vt(r));
  }, l), new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.l(new g(null, exe, null, 1, null), new g(
    null,
    ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, t, null, 1, null)))),
    null,
    1,
    null
  ), Te([new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, ks, null, 1, null)))), null, 1, null)])))), null, 1, null), Te([new g(null, null, null, 1, null), new g(null, ve.h(z(he.l(new g(null, mi, null, 1, null), new g(null, ve.h(z(he.g(new g(null, e1e, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null)))), null, 1, null), Te([new g(null, null, null, 1, null)])))), null, 1, null)])))), null, 1, null)]))));
};
lj.m = 3;
lj.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  return t = I(l), l = W(l), this.l(n, e, t, l);
};
var rj = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
rj.l = function(e, n, t) {
  return ve.h(z(he.l(new g(null, lf, null, 1, null), new g(null, m1e, null, 1, null), Te([new g(null, null, null, 1, null), new g(null, ve.h(z(he.l(new g(null, sc, null, 1, null), new g(null, Et(ve.h(z(he.o()))), null, 1, null), Te([t])))), null, 1, null), new g(null, null, null, 1, null), new g(null, null, null, 1, null)]))));
};
rj.m = 2;
rj.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var N3e = [
  N9,
  GZ,
  _N,
  L7,
  TR,
  t$,
  yR,
  HI,
  vP,
  c7,
  d8,
  g9,
  lN,
  $M,
  mN,
  _9,
  NQ,
  kw,
  b9,
  ER,
  UN,
  P0,
  tM,
  bC,
  cR,
  iP,
  RC,
  E9,
  QI,
  $k,
  L0,
  f9,
  s7,
  SC,
  SP,
  nN,
  _C,
  V8,
  bM,
  JR,
  rN,
  rM,
  cM,
  xee,
  C$,
  u8,
  Q9,
  Y$,
  yQ,
  jR,
  Rk,
  SM,
  xR,
  Z8,
  uX,
  i8,
  GR,
  W7,
  H0,
  Qk,
  i$,
  iR,
  ZM,
  UM,
  DC,
  AN,
  bk,
  xP,
  l7,
  a$,
  D8,
  xJ,
  sN,
  BC,
  V$,
  WI,
  b$,
  HR,
  nC,
  jk,
  rP,
  y$,
  cP,
  VC,
  B9,
  w$,
  Jk,
  x9,
  bN,
  Uk,
  aM,
  z9,
  iN,
  qy,
  aR,
  P7,
  Xk,
  Gk,
  IC,
  cN,
  ZN,
  pN,
  q8,
  QP,
  OC,
  VI,
  Sne,
  G8,
  e$,
  F9,
  _M,
  AR,
  lR,
  BN,
  aP,
  Z7,
  $x,
  G9,
  gN,
  HC,
  vN,
  w7,
  tR,
  P$,
  nP,
  CP,
  r8,
  x7,
  YP,
  h9,
  s8,
  IM,
  XR,
  hN,
  pP,
  hR,
  iC,
  B8,
  q0,
  QN,
  QM,
  RM,
  a7,
  w9,
  qM,
  GI,
  S$,
  K9,
  M0,
  MX,
  R8,
  y9,
  jX,
  I9,
  wM,
  cC,
  B7,
  BM,
  dP,
  TB,
  gne,
  B$,
  gM,
  q9,
  G7,
  M9,
  k$,
  PB,
  i7,
  fC,
  TC,
  cne,
  Z9,
  D$,
  qI,
  Y7,
  MP,
  jC,
  sC,
  Fx,
  kM,
  M$,
  I$,
  t8,
  kv,
  oN,
  e7,
  T8,
  c8,
  XI,
  I8,
  sM,
  eP,
  lP,
  N8,
  Gx,
  QR,
  DN,
  GC,
  PM,
  lM,
  Y8,
  VP,
  vC,
  v7,
  EN,
  g$,
  WM,
  LN,
  x$,
  $N,
  n$,
  m$,
  UP,
  kR,
  LM,
  vR,
  qP,
  q_,
  Px,
  DP,
  oo,
  p7,
  nR,
  _E,
  _P,
  U9,
  rR,
  wC,
  wP,
  wN,
  F8,
  ih,
  R9,
  FM,
  o9,
  YC,
  g7,
  KN,
  n7,
  nM,
  Yk,
  s9,
  P8,
  GM,
  PN,
  Rx,
  ZI,
  P9,
  L9,
  oM,
  ZP,
  EP,
  PP,
  p$,
  eR,
  tee,
  v$,
  CN,
  GN,
  Mk,
  Y9,
  r7,
  L$,
  TP,
  HM,
  k9,
  Q8,
  IP,
  uwe,
  W8,
  S9,
  pM,
  bP,
  yM,
  OP,
  TN,
  yN,
  E$,
  m8,
  mM,
  ZC,
  mC,
  e9,
  KC,
  yE,
  zM,
  m7,
  T9,
  fR,
  fN,
  FP,
  h$,
  hP,
  CM,
  H7,
  H9,
  j8,
  Kx,
  Dx,
  ene,
  RR,
  rh,
  Ow,
  _$,
  YI,
  i9,
  O$,
  sR,
  EM,
  y7,
  qR,
  K8,
  hC,
  qN,
  f7,
  R$,
  mP,
  V7,
  $9,
  r4,
  u7,
  r9,
  e4,
  BP,
  aN,
  C9,
  $7,
  O9,
  EZ,
  k8,
  eC,
  p9,
  YR,
  NC,
  dR,
  yP,
  MM,
  j_,
  zR,
  QC,
  gP,
  zk,
  KJ,
  l8,
  o1,
  BR,
  $8,
  Pk,
  b8,
  p8,
  GP,
  uR,
  Zk,
  VN,
  l$,
  lC,
  S7,
  XP,
  j7,
  k7,
  kN,
  Nk,
  t4,
  Wa,
  LP,
  JP,
  S8,
  EC,
  uP,
  m9,
  $Q,
  IN,
  h8,
  W9,
  uC,
  dN,
  KI,
  oC,
  E8,
  A8,
  bR,
  PC,
  c$,
  UC,
  a8,
  fM,
  xM,
  w8,
  fP,
  gR,
  d$,
  dM,
  u9,
  WN,
  o$,
  UR,
  zC,
  A9,
  h7,
  v8,
  pC,
  d9,
  J7,
  xC,
  X8,
  tC,
  u$,
  d7,
  MC,
  z8,
  ON,
  aC,
  SN,
  oR,
  f8,
  X7,
  v0e,
  X9,
  AM,
  RP,
  FR,
  $C,
  tN,
  AC,
  n8,
  s$,
  ZR,
  kE,
  V9,
  xf,
  jM,
  t7,
  Go,
  jN,
  DM,
  U8,
  Iee,
  kP,
  OM,
  KM,
  C0,
  Fd,
  J9,
  NZ,
  VR,
  YM,
  FN,
  b7,
  sP,
  A$,
  pR,
  L8,
  TM,
  uM,
  Dk,
  z7,
  yC,
  $$,
  _8,
  n9,
  o8,
  dC,
  WC,
  BX,
  hM,
  KR,
  K7,
  oP,
  WR,
  zI,
  gC,
  F7,
  WP,
  LC,
  YN,
  tP,
  $d,
  o7,
  N$,
  iM,
  VM,
  $P,
  rX,
  CR,
  e8,
  jP,
  Kk,
  cw,
  LR,
  D9,
  l4,
  wR,
  JI,
  c9,
  NP,
  _R,
  JC,
  UI,
  rC,
  Hk,
  fQ,
  FC,
  y8,
  B0,
  HN,
  vM,
  f$,
  xN,
  qC,
  NM,
  uve,
  t9,
  XC,
  q$,
  a9,
  NN,
  J8,
  j$,
  j9,
  T$,
  KP
], C3e = new Ne(HY, N9, new $(null, 6, [te, N9, hl, HY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null), M3e = new Ne(t5, _N, new $(null, 5, [te, _N, ne, ue(new v(null, 2, 5, y, [et, kw], null)), ee, "Returns a new sorted set with supplied keys.", Re, !0, ie, Le], null), null), P3e = new Ne(dK, L7, new $(null, 5, [te, L7, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x is the value true, false otherwise.", Re, !0, ie, Le], null), null), $3e = new Ne(
  function(e) {
    return nI(e);
  },
  TR,
  new $(null, 5, [te, TR, ne, ue(new v(null, 1, 5, y, [$h], null)), ee, `Removes the last item from a transient vector. If
  the collection is empty, throws an exception. Returns tcoll`, Re, !0, ie, Le], null),
  null
), L3e = Nl(t$, Lb, Le, !0, new $(
  null,
  3,
  [te, t$, ne, ue(new v(null, 4, 5, y, [mve, gJ, et, Wk], null)), ee, `(deftype name [fields*]  options* specs*)

  Currently there are no options.

  Each spec consists of a protocol or interface name followed by zero
  or more method bodies:

  protocol-or-Object
  (methodName [args*] body)*

  The type will have the (by default, immutable) fields named by
  fields, which can have type hints. Protocols and methods
  are optional. The only methods that can be supplied are those
  declared in the protocols/interfaces.  Note that method bodies are
  not closures, the local environment includes only the named fields,
  and those fields can be accessed directly. Fields can be qualified
  with the metadata :mutable true at which point (set! afield aval) will be
  supported in method bodies. Note well that mutable fields are extremely
  difficult to use correctly, and are present only to facilitate the building
  of higherlevel constructs, such as ClojureScript's reference types, in
  ClojureScript itself. They are for experts only - if the semantics and
  implications of :mutable are not immediately apparent to you, you should not
  be using them.

  Method definitions take the form:

  (methodname [args*] body)

  The argument and return types can be hinted on the arg and
  methodname symbols. If not supplied, they will be inferred, so type
  hints should be reserved for disambiguation.

  Methods should be supplied for all methods of the desired
  protocol(s). You can also define overrides for methods of Object. Note that
  a parameter must be supplied to correspond to the target object
  ('this' in JavaScript parlance). Note also that recur calls to the method
  head should *not* pass the target object, it will be supplied
  automatically and can not be substituted.

  In the method bodies, the (unqualified) name can be used to name the
  class (for calls to new, instance? etc).

  One constructor will be defined, taking the designated fields.  Note
  that the field names __meta and __extmap are currently reserved and
  should not be used when defining your own types.

  Given (deftype TypeName ...), a factory function called ->TypeName
  will be defined, taking positional parameters for the fields`],
  null
)), B3e = new Ne(WY, yR, new $(null, 6, [te, yR, hl, WY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null), F3e = Xne, V3e = Nl(vP, ST, null, null, new $(null, 3, [te, vP, ne, ue(new v(null, 3, 5, y, [Sn, et, Tv], null)), ee, `Evaluates x then calls all of the methods and functions with the
  value of x supplied at the front of the given arguments.  The forms
  are evaluated in order.  Returns x.

  (doto (new js/Map) (.set "a" 1) (.set "b" 2))`], null)), Y3e = new Ne(Jf, c7, new $(null, 5, [te, c7, ne, ue(new v(
  null,
  3,
  5,
  y,
  [il, T_, Bt],
  null
)), ee, `Reduces an associative collection. f should be a function of 3
  arguments. Returns the result of applying f to init, the first key
  and the first value in coll, then applying f to that result and the
  2nd key and value, etc. If coll contains no entries, returns init
  and f is not called. Note that reduce-kv is supported on vectors,
  where the keys will be the ordinals.`, Re, !0, ie, Le], null), null), U3e = Nl(d8, Hb, null, null, new $(null, 3, [
  te,
  d8,
  ne,
  ue(new v(null, 4, 5, y, [iw, XM, et, kwe], null)),
  ee,
  "Creates and installs a new method of multimethod associated with dispatch-value. "
], null)), q3e = new Ne(bu, g9, new $(null, 5, [
  te,
  g9,
  ne,
  ue(new v(null, 3, 5, y, [Ao, new v(null, 3, 5, y, [cu, et, Oc], null), il], null), new v(null, 4, 5, y, [Ao, new v(null, 3, 5, y, [cu, et, Oc], null), il, Vl], null), new v(null, 5, 5, y, [Ao, new v(null, 3, 5, y, [cu, et, Oc], null), il, Vl, qo], null), new v(null, 6, 5, y, [Ao, new v(null, 3, 5, y, [cu, et, Oc], null), il, Vl, qo, Ld], null), new v(null, 8, 5, y, [Ao, new v(null, 3, 5, y, [cu, et, Oc], null), il, Vl, qo, Ld, et, Gs], null)),
  ee,
  `'Updates' a value in a nested associative structure, where ks is a
  sequence of keys and f is a function that will take the old value
  and any supplied args and return the new value, and returns a new
  nested structure.  If any levels do not exist, hash-maps will be
  created.`,
  Re,
  !0,
  ie,
  Le
], null), null), W3e = new Ne(function(e, n, t) {
  return yI(e, n, t);
}, lN, new $(null, 5, [te, lN, ne, ue(new v(null, 3, 5, y, [iw, Uve, Yve], null)), ee, `Causes the multimethod to prefer matches of dispatch-val-x over dispatch-val-y
   when there is a conflict`, Re, !0, ie, Le], null), null), H3e = new Ne(Bb, $M, new $(null, 5, [
  te,
  $M,
  ne,
  ue(new v(null, 2, 5, y, [lh, Ov], null), new v(null, 3, 5, y, [Bd, lh, Ov], null)),
  ee,
  `Establishes a parent/child relationship between parent and
  tag. Parent must be a namespace-qualified symbol or keyword and
  child can be either a namespace-qualified symbol or keyword or a
  class. h must be a hierarchy obtained from make-hierarchy, if not
  supplied defaults to, and modifies, the global hierarchy.`,
  Re,
  !0,
  ie,
  Le
], null), !0), z3e = new Ne(function(e) {
  return W(I(e));
}, mN, new $(null, 5, [te, mN, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Same as (next (first x))", Re, !0, ie, Le], null), null), K3e = new Ne(Ry, _9, new $(null, 5, [
  te,
  _9,
  ne,
  ue(new v(null, 2, 5, y, [uH, Bt], null), new v(null, 3, 5, y, [uH, Gx, Bt], null)),
  ee,
  `Returns a sorted sequence of the items in coll, where the sort
   order is determined by comparing (keyfn item).  Comp can be
   boolean-valued comparison function, or a -/0/+ valued comparator.
   Comp defaults to compare.`,
  Re,
  !0,
  ie,
  Le
], null), null), G3e = new Ne(xi, kw, new $(null, 5, [te, kw, ne, ue(new v(null, 1, 5, y, [o1], null)), ee, "Returns a sequence of the map's keys, in the same order as (seq map).", Re, !0, ie, Le], null), null), Z3e = new Ne(Yb, b9, new $(null, 5, [
  te,
  b9,
  ne,
  ue(new v(null, 1, 5, y, [lh], null), new v(null, 2, 5, y, [Bd, lh], null)),
  ee,
  `Returns the immediate and indirect parents of tag, either via a JavaScript type
  inheritance relationship or a relationship established via derive. h
  must be a hierarchy obtained from make-hierarchy, if not supplied
  defaults to the global hierarchy`,
  Re,
  !0,
  ie,
  Le
], null), !0), X3e = new Ne(I, ER, new $(null, 5, [te, ER, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `Returns the first item in the collection. Calls seq on its
  argument. If coll is nil, returns nil.`, Re, !0, ie, Le], null), null), Q3e = new Ne(td, UN, new $(null, 5, [te, UN, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, "Return a seq of all but the last item in coll, in linear time", Re, !0, ie, Le], null), null), J3e = Nl(P0, N2, null, null, new $(null, 4, [
  te,
  P0,
  ne,
  ue(Dt, new v(null, 1, 5, y, [Sn], null), new v(null, 3, 5, y, [Sn, et, q_], null)),
  ee,
  `Evaluates exprs one at a time, from left to right. If a form
  returns logical false (nil or false), and returns that value and
  doesn't evaluate any of the other expressions, otherwise it returns
  the value of the last expr. (and) returns true.`,
  F0,
  P0
], null)), e5e = Nl(tM, fT, null, null, new $(null, 3, [te, tM, ne, ue(new v(null, 2, 5, y, [et, ys], null)), ee, `Evaluates exprs in a context in which *print-fn* is bound to .append
  on a fresh StringBuffer.  Returns the string created by any nested
  printing calls.`], null)), n5e = new Ne(xx, bC, new $(null, 5, [
  te,
  bC,
  ne,
  ue(new v(null, 1, 5, y, [il], null), new v(null, 2, 5, y, [il, Bt], null)),
  ee,
  `Applies f to each value in coll, splitting it each time f returns a
   new value.  Returns a lazy seq of partitions.  Returns a stateful
   transducer when no collection is provided.`,
  Re,
  !0,
  ie,
  Le
], null), null), t5e = new Ne(function() {
  return !1;
}, cR, new $(null, 5, [te, cR, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true x is a goog.Uri instance.", Re, !0, ie, Le], null), null), l5e = new Ne(Qd, iP, new $(null, 5, [te, iP, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x satisfies IMapEntry", Re, !0, ie, Le], null), null), r5e = new Ne(function(e) {
  return e instanceof de && Yi(e) == null;
}, RC, new $(null, 5, [te, RC, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x is a keyword without a namespace", Re, !0, ie, Le], null), null), i5e = new Ne(Fs, E9, new $(null, 5, [te, E9, ne, ue(new v(null, 1, 5, y, [hH], null), new v(null, 2, 5, y, [cw, hH], null)), ee, `Returns an array with components set to the values in aseq. Optional type
  argument accepted for compatibility with Clojure.`, Re, !0, ie, Le], null), null), u5e = new Ne(UG, QI, new $(null, 5, [te, QI, ne, null, ee, null, Re, !0, ie, Le], null), !0), s5e = new Ne(tn, $k, new $(null, 5, [te, $k, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `Returns a possibly empty seq of the items after the first. Calls seq on its
  argument.`, Re, !0, ie, Le], null), null), o5e = Nl(L0, tj, null, null, new $(null, 4, [
  te,
  L0,
  ne,
  ue(new v(null, 3, 5, y, [dve, et, z_], null)),
  ee,
  `Takes an expression, and a set of clauses.

  Each clause can take the form of either:

  test-constant result-expr

  (test-constant1 ... test-constantN)  result-expr

  The test-constants are not evaluated. They must be compile-time
  literals, and need not be quoted.  If the expression is equal to a
  test-constant, the corresponding result-expr is returned. A single
  default expression can follow the clauses, and its value will be
  returned if no clause matches. If no default expression is provided
  and no clause matches, an Error is thrown.

  Unlike cond and condp, case does a constant-time dispatch, the
  clauses are not considered sequentially.  All manner of constant
  expressions are acceptable in case, including numbers, strings,
  symbols, keywords, and (ClojureScript) composites thereof. Note that since
  lists are used to group multiple constants that map to the same
  expression, a vector can be used to match a list if needed. The
  test-constants need not be all of the same type.`,
  F0,
  L0
], null)), a5e = new Ne(z, f9, new $(null, 5, [te, f9, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `Returns a seq on the collection. If the collection is
  empty, returns nil.  (seq nil) returns nil. seq also works on
  Strings.`, Re, !0, ie, Le], null), null), c5e = new Ne(JY, s7, new $(null, 6, [te, s7, hl, JY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null), h5e = new Ne(oK, SC, new $(null, 5, [te, SC, ne, ue(new v(null, 2, 5, y, [Xye, Xk], null)), ee, null, Re, !0, ie, Le], null), null), f5e = new Ne(function(e, n, t) {
  return wr.g(Or.h(e), function(l) {
    return bu.B(
      l,
      new v(null, 3, 5, y, [Il, tc($c(e, n)), Vc], null),
      nr,
      t
    );
  }), null;
}, SP, new $(null, 5, [te, SP, ne, null, ee, null, Re, !0, ie, Le], null), !0), d5e = new Ne(function(e) {
  return !qc(e);
}, nN, new $(null, 5, [te, nN, ne, ue(new v(null, 1, 5, y, [Tr], null)), ee, "Returns true if n is odd, throws an exception if n is not an integer", Re, !0, ie, Le], null), null), p5e = new Ne(Mo, _C, new $(null, 5, [
  te,
  _C,
  ne,
  ue(new v(null, 2, 5, y, [Tr, Bt], null), new v(null, 3, 5, y, [Tr, Ck, Bt], null), new v(null, 4, 5, y, [Tr, Ck, age, Bt], null)),
  ee,
  `Returns a lazy sequence of lists of n items each, at offsets step
  apart. If step is not supplied, defaults to n, i.e. the partitions
  do not overlap. If a pad collection is supplied, use its elements as
  necessary to complete last partition up to n items. In case there are
  not enough padding elements, return a partition with less than n items.`,
  Re,
  !0,
  ie,
  Le
], null), null), m5e = new Ne(zm, V8, new $(null, 6, [te, V8, hl, zm, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, `Returns non-nil if nums are in monotonically non-increasing order,
  otherwise false.`, Re, !0, ie, Le], null), null), g5e = new Ne(function(e) {
  return I(W(e));
}, bM, new $(null, 5, [te, bM, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Same as (first (next x))", Re, !0, ie, Le], null), null), w5e = Nl(JR, TT, null, null, new $(null, 3, [
  te,
  JR,
  ne,
  ue(new v(null, 3, 5, y, [th, et, ys], null)),
  ee,
  `bindings => x xs

  Roughly the same as (when (seq xs) (let [x (first xs)] body)) but xs is evaluated only once`
], null)), v5e = new Ne(Jw, rN, new $(null, 6, [te, rN, hl, Jw, ne, ue(new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, "Bitwise or", Re, !0, ie, Le], null), null), y5e = new Ne(Aa, rM, new $(null, 5, [
  te,
  rM,
  ne,
  ue(new v(null, 1, 5, y, [Bt], null), new v(null, 2, 5, y, [Bt, cu], null), new v(null, 4, 5, y, [Bt, cu, et, Oc], null)),
  ee,
  `disj[oin]. Returns a new set of the same (hashed/sorted) type, that
  does not contain key(s).`,
  Re,
  !0,
  ie,
  Le
], null), null), _5e = new Ne(function(e, n) {
  function t(r) {
    r = z(r);
    for (var u = null, o = 0, a = 0; ; ) if (a < o) {
      var h = u.Y(null, a), s = O.j(h, 0, null);
      h = O.j(h, 1, null), Fm(s, h), a += 1;
    } else if (r = z(r)) oi(r) ? (u = Jr(r), r = Wr(r), s = u, o = Cn(u), u = s) : (u = I(r), s = O.j(u, 0, null), h = O.j(u, 1, null), Fm(s, h), r = W(r), u = null, o = 0), a = 0;
    else return null;
  }
  var l = _a(xi(e), bt.g(function(r) {
    return wx(r);
  }, xi(e)));
  try {
    return t(e), n.o ? n.o() : n.call(null);
  } finally {
    t(l);
  }
}, cM, new $(null, 5, [te, cM, ne, null, ee, null, Re, !0, ie, Le], null), null), x5e = Nd(xee, function() {
  var e = Xr.o();
  return eb(e, null, Vt(e), !1);
}), S5e = new Ne(zY, C$, new $(null, 6, [te, C$, hl, zY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null), E5e = new Ne(hK, u8, new $(null, 5, [te, u8, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Same as (first (first x))", Re, !0, ie, Le], null), null), O5e = Nl(Q9, BT, null, null, new $(
  null,
  3,
  [te, Q9, ne, ue(new v(null, 4, 5, y, [ws, Vd, et, z_], null)), ee, `Takes a binary predicate, an expression, and a set of clauses.
  Each clause can take the form of either:

  test-expr result-expr

  test-expr :>> result-fn

  Note :>> is an ordinary keyword.

  For each clause, (pred test-expr expr) is evaluated. If it returns
  logical true, the clause is a match. If a binary clause matches, the
  result-expr is returned, if a ternary clause matches, its result-fn,
  which must be a unary function, is called with the result of the
  predicate as its argument, the result of that call being the return
  value of condp. A single default expression can follow the clauses,
  and its value will be returned if no clause matches. If no default
  expression is provided and no clause matches, an Error is thrown.`],
  null
)), k5e = new Ne(B3, Y$, new $(null, 5, [te, Y$, ne, ue(new v(null, 1, 5, y, [oo], null)), ee, null, Re, !0, ie, Le], null), null), b5e = Iu, T5e = new Ne(nU, jR, new $(null, 6, [te, jR, hl, nU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null), j5e = new Ne(hT, Rk, new $(null, 5, [te, Rk, ne, ue(new v(null, 2, 5, y, [et, W0], null)), ee, "print to a string, returning it", Re, !0, ie, Le], null), null), A5e = new Ne(OK, SM, new $(null, 5, [
  te,
  SM,
  ne,
  ue(new v(null, 2, 5, y, [TJ, Oee], null)),
  ee,
  `Sets the value of volatile to newval without regard for the
   current value. Returns newval.`,
  Re,
  !0,
  ie,
  Le
], null), null), D5e = new Ne(function(e) {
  return e != null ? Rn === e.ne : !1;
}, xR, new $(null, 5, [te, xR, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x is a UUID.", Re, !0, ie, Le], null), null), I5e = new Ne(function(e, n) {
  return e instanceof Wc || e != null && (e.J & 32768 || Rn === e.Te) ? Qa(e, n) : I2.g(e, n);
}, Z8, new $(null, 5, [te, Z8, ne, ue(new v(null, 2, 5, y, [Vl, iye], null)), ee, `Sets the value of atom to newval without regard for the
  current value. Returns new-value.`, Re, !0, ie, Le], null), null), R5e = Hc(uX, new $(
  null,
  2,
  [o5, dm, ie, Le],
  null
), new $(null, 1, [ie, Le], null)), N5e = new Ne(A3e, i8, new $(null, 6, [te, i8, Zf, !0, ne, ue(new v(null, 3, 5, y, [oo, et, Gs], null)), ee, `Expands into code that creates a fn that expects to be passed an
  object and any args and calls the named instance method on the
  object passing the args. Use when you want to treat a JavaScript
  method as a first-class fn.`, Re, !0, ie, Le], null), null), C5e = new Ne(kr, GR, new $(null, 5, [
  te,
  GR,
  ne,
  ue(new v(null, 1, 5, y, [Sn], null), new v(null, 3, 5, y, [Sn, et, new $(null, 1, [Gr, new v(
    null,
    2,
    5,
    y,
    [Dx, t0e],
    null
  )], null)], null)),
  ee,
  `Creates and returns an Atom with an initial value of x and zero or
  more options (in any order):

  :meta metadata-map

  :validator validate-fn

  If metadata-map is supplied, it will become the metadata on the
  atom. validate-fn must be nil or a side-effect-free fn of one
  argument, which will be passed the intended new state on any state
  change. If the new state is unacceptable, the validate-fn should
  return false or throw an Error.  If either of these error conditions
  occur, then the value of the atom will not change.`,
  Re,
  !0,
  ie,
  Le
], null), null), M5e = new Ne(pg, W7, new $(null, 5, [te, W7, ne, ue(new v(null, 2, 5, y, [o1, r_e], null)), ee, "Returns a map containing only those entries in map whose key is in keys", Re, !0, ie, Le], null), null), P5e = new Ne(OL, H0, new $(null, 5, [te, H0, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Returns a seq of the items in coll in reverse order. Not lazy.", Re, !0, ie, Le], null), null), $5e = new Ne(T3e, Qk, new $(null, 5, [
  te,
  Qk,
  ne,
  ue(new v(null, 1, 5, y, [zx], null)),
  ee,
  `Returns the message attached to the given Error / ExceptionInfo object.
  For non-Errors returns nil.`,
  Re,
  !0,
  ie,
  Le
], null), null), L5e = new Ne(xI, i$, new $(null, 5, [te, i$, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x names a special form", Re, !0, ie, Le], null), null), B5e = new Ne(gr, iR, new $(null, 5, [te, iR, ne, ue(new v(null, 2, 5, y, [et, NX], null)), ee, `Returns a map that consists of the rest of the maps conj-ed onto
  the first.  If a key occurs in more than one map, the mapping from
  the latter (left-to-right) will be the mapping in the result.`, Re, !0, ie, Le], null), null), F5e = new Ne(function(e) {
  return uI(e);
}, ZM, new $(
  null,
  5,
  [te, ZM, ne, ue(new v(null, 1, 5, y, [jB], null)), ee, "Return the number of milliseconds since January 1, 1970, 00:00:00 GMT", Re, !0, ie, Le],
  null
), null), V5e = new Ne(function() {
  var e = Js;
  Js = sn(Tp);
  try {
    return FL(null);
  } finally {
    Js = e;
  }
}, UM, new $(null, 5, [te, UM, ne, ue(Dt, new v(null, 1, 5, y, [vw], null)), ee, "Prints a newline using *print-fn*", Re, !0, ie, Le], null), null), Y5e = new Ne(vp, DC, new $(null, 6, [
  te,
  DC,
  hl,
  vp,
  ne,
  ue(Dt, new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)),
  ee,
  "Returns the product of nums. (*) returns 1.",
  Re,
  !0,
  ie,
  Le
], null), null), U5e = Nl(bk, E5, null, null, new $(
  null,
  3,
  [te, bk, ne, ue(new v(null, 2, 5, y, [Sn, Hd], null), new v(null, 4, 5, y, [Sn, Hd, et, Ai], null)), ee, `form => fieldName-symbol or (instanceMethodName-symbol args*)

  Expands into a member access (.) of the first member on the first
  argument, followed by the next member on the result, etc. For
  instance:

  (.. System (getProperties) (get "os.name"))

  expands to:

  (. (. System (getProperties)) (get "os.name"))

  but is easier to write, read, and understand.`],
  null
)), q5e = new Ne(oi, xP, new $(null, 5, [te, xP, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x satisfies IChunkedSeq.", Re, !0, ie, Le], null), null), W5e = new Ne(function(e) {
  return e != null ? Rn === e.$e ? !0 : e.Pc ? !1 : pl($Y, e) : pl($Y, e);
}, l7, new $(null, 5, [te, l7, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x satisfies Inst", Re, !0, ie, Le], null), null), H5e = new Ne(gb, a$, new $(null, 5, [
  te,
  a$,
  ne,
  ue(new v(null, 1, 5, y, [kH], null), new v(null, 2, 5, y, [kH, Bt], null)),
  ee,
  `Returns items from coll with random probability of prob (0.0 -
  1.0).  Returns a transducer when no collection is provided.`,
  Re,
  !0,
  ie,
  Le
], null), null), z5e = new Ne(Hm, D8, new $(null, 6, [te, D8, hl, Hm, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, `Returns non-nil if nums are in monotonically decreasing order,
  otherwise false.`, Re, !0, ie, Le], null), null), K5e = new Ne(Cn, sN, new $(null, 6, [te, sN, hl, Cn, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `Returns the number of items in the collection. (count nil) returns
  0.  Also works on strings, arrays, and Maps`, Re, !0, ie, Le], null), null), G5e = new Ne(function(e) {
  return aI(e) && Yi(e) == null;
}, BC, new $(null, 5, [te, BC, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x is a symbol or keyword without a namespace", Re, !0, ie, Le], null), null), Z5e = new Ne(tc, V$, new $(null, 5, [te, V$, ne, ue(new v(null, 1, 5, y, [jZ], null)), ee, `Returns the name of the namespace, a Namespace object.
  Bootstrap only.`, Re, !0, ie, Le], null), null), X5e = Zne, Q5e = new Ne(ho, b$, new $(null, 5, [te, b$, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, "Return the last item in coll, in linear time", Re, !0, ie, Le], null), null), J5e = new Ne(gU, HR, new $(null, 6, [
  te,
  HR,
  hl,
  gU,
  ne,
  ue(new v(null, 2, 5, y, [Sn, Tr], null)),
  ee,
  "Bitwise shift left",
  Re,
  !0,
  ie,
  Le
], null), null), eSe = new Ne(lU, nC, new $(null, 6, [te, nC, hl, lU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Coerce to int by stripping decimal places.", Re, !0, ie, Le], null), null), nSe = Nl(jk, nT, null, null, new $(
  null,
  3,
  [te, jk, ne, ue(new v(null, 5, 5, y, [oo, Ak, Sw, new v(null, 1, 5, y, [Tk], null), ys], null), new v(null, 6, 5, y, [oo, Ak, Sw, ue(new v(null, 1, 5, y, [Tk], null), ys), Px, Sw], null)), ee, `Like defn, but the resulting function name is declared as a
  macro and will be used as a macro by the compiler when it is
  called.`],
  null
)), tSe = new Ne(eU, rP, new $(null, 6, [te, rP, hl, eU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null), lSe = new Ne(function(e, n, t, l, r, u, o, a) {
  return new Np(e, n, t, l, r, u, o, a);
}, y$, new $(null, 5, [te, y$, ne, null, ee, null, Re, !0, ie, Le], null), null), rSe = new Ne(tU, cP, new $(null, 6, [te, cP, hl, tU, ne, ue(new v(null, 2, 5, y, [Sn, Tr], null)), ee, null, Re, !0, ie, Le], null), null), iSe = new Ne(VY, VC, new $(null, 6, [te, VC, hl, VY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null), uSe = new Ne(to, B9, new $(null, 5, [te, B9, ne, ue(Dt, new v(
  null,
  1,
  5,
  y,
  [$h],
  null
), new v(null, 2, 5, y, [$h, rh], null), new v(null, 4, 5, y, [$h, rh, et, qy], null)), ee, `Adds val to the transient collection, and return tcoll. The 'addition'
  may happen at different 'places' depending on the concrete type.`, Re, !0, ie, Le], null), null), sSe = new Ne(
  function(e, n, t) {
    return ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(
      null,
      Et(ve.h(z(he.l(new g(null, iW, null, 1, null), new g(null, ve.h(z(he.h(new g(null, oH, null, 1, null)))), null, 1, null), Te([new g(null, Vq, null, 1, null), new g(null, t, null, 1, null)]))))),
      null,
      1,
      null
    ), Te([new g(null, ve.h(z(he.g(new g(null, Hwe, null, 1, null), new g(null, ve.h(z(he.l(new g(null, lg, null, 1, null), new g(null, "Elapsed time: ", null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, ove, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Z_e, null, 1, null), new g(null, ve.h(z(he.h(new g(null, oH, null, 1, null)))), null, 1, null), Te([new g(null, iW, null, 1, null)])))), null, 1, null), Te([new g(null, 6, null, 1, null)])))), null, 1, null), new g(null, " msecs", null, 1, null)])))), null, 1, null)))), null, 1, null), new g(null, Vq, null, 1, null)]))));
  },
  w$,
  new $(null, 6, [te, w$, Zf, !0, ne, ue(new v(null, 1, 5, y, [Vd], null)), ee, "Evaluates expr and prints the time it took. Returns the value of expr.", Re, !0, ie, Le], null),
  null
), oSe = new Ne(Sf, Jk, new $(null, 5, [te, Jk, ne, ue(new v(null, 2, 5, y, [et, W0], null)), ee, "Same as print followed by (newline)", Re, !0, ie, Le], null), null), aSe = Nl(x9, zb, Le, !0, new $(
  null,
  3,
  [te, x9, ne, ue(new v(null, 3, 5, y, [AZ, et, B2e], null)), ee, `A protocol is a named set of named methods and their signatures:

  (defprotocol AProtocolName
    ;optional doc string
    "A doc string for AProtocol abstraction"

  ;method signatures
    (bar [this a b] "bar docs")
    (baz [this a] [this a b] [this a b c] "baz docs"))

  No implementations are provided. Docs can be specified for the
  protocol overall and for each method. The above yields a set of
  polymorphic functions and a protocol object. All are
  namespace-qualified by the ns enclosing the definition The resulting
  functions dispatch on the type of their first argument, which is
  required and corresponds to the implicit target object ('this' in
  JavaScript parlance). defprotocol is dynamic, has no special compile-time
  effect, and defines no new types.

  (defprotocol P
    (foo [this])
    (bar-me [this] [this y]))

  (deftype Foo [a b c]
    P
    (foo [this] a)
    (bar-me [this] b)
    (bar-me [this y] (+ c y)))

  (bar-me (Foo. 1 2 3) 42)
  => 45

  (foo
    (let [x 42]
      (reify P
        (foo [this] 17)
        (bar-me [this] x)
        (bar-me [this y] x))))
  => 17`],
  null
)), cSe = new Ne(function(e) {
  return za(e) || !1;
}, bN, new $(null, 5, [te, bN, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, `Return true if x satisfies integer? or is an instance of goog.math.Integer
   or goog.math.Long.`, Re, !0, ie, Le], null), null), hSe = Nl(Uk, eT, null, null, new $(
  null,
  3,
  [te, Uk, ne, ue(new v(null, 6, 5, y, [oo, Ak, Sw, new v(null, 1, 5, y, [Tk], null), OW, ys], null), new v(null, 6, 5, y, [oo, Ak, Sw, ue(new v(null, 1, 5, y, [Tk], null), OW, ys), Px, Sw], null)), ee, `Same as (def name (core/fn [params* ] exprs*)) or (def
    name (core/fn ([params* ] exprs*)+)) with any doc-string or attrs added
    to the var metadata. prepost-map defines a map with optional keys
    :pre and :post that contain collections of pre or post conditions.`],
  null
)), fSe = new Ne(function(e) {
  return sn(sn(en.g(en.g(Il.h(sn(Or.h(e))), ks), Lk)));
}, aM, new $(null, 5, [te, aM, ne, null, ee, null, Re, !0, ie, Le], null), !0), dSe = new Ne(Cy, z9, new $(null, 6, [te, z9, hl, Cy, ne, ue(new v(null, 1, 5, y, [SE], null), new v(null, 2, 5, y, [rw, EE], null)), ee, `Creates an array of longs. Does not coerce array, provided for compatibility
  with Clojure.`, Re, !0, ie, Le], null), null), pSe = new Ne(oh, iN, new $(null, 5, [
  te,
  iN,
  ne,
  ue(new v(null, 2, 5, y, [Bt, cu], null)),
  ee,
  "Returns the map entry for key, or nil if key not present.",
  Re,
  !0,
  ie,
  Le
], null), null), mSe = new Ne(Ju, qy, new $(null, 5, [te, qy, ne, ue(new v(null, 1, 5, y, [o1], null)), ee, "Returns a sequence of the map's values, in the same order as (seq map).", Re, !0, ie, Le], null), null), gSe = new Ne(dy, aR, new $(null, 6, [te, aR, hl, dy, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x is nil, false otherwise.", Re, !0, ie, Le], null), null), wSe = new Ne(function() {
  return null;
}, P7, new $(null, 5, [te, P7, ne, ue(Dt), ee, null, Re, !0, ie, Le], null), null), vSe = new Ne(Uu, Xk, new $(null, 5, [
  te,
  Xk,
  ne,
  ue(new v(null, 1, 5, y, [bv], null)),
  ee,
  `Returns the hash code of its argument. Note this is the hash code
   consistent with =.`,
  Re,
  !0,
  ie,
  Le
], null), null), ySe = new Ne(uT, Gk, new $(null, 5, [te, Gk, ne, ue(new v(null, 2, 5, y, [et, W0], null)), ee, `Prints the object(s) using string-print.  Prints the
  object(s), separated by spaces if there is more than one.
  By default, pr and prn print in a way that objects can be
  read by the reader`, Re, !0, ie, Le], null), null), _Se = new Ne(function(e) {
  return rB(e);
}, IC, new $(null, 5, [te, IC, ne, ue(new v(null, 1, 5, y, [qo], null)), ee, null, Re, !0, ie, Le], null), null), xSe = new Ne(Zm, cN, new $(null, 6, [te, cN, hl, Zm, ne, ue(new v(
  null,
  1,
  5,
  y,
  [Sn],
  null
), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, `If no ys are supplied, returns the negation of x, else subtracts
  the ys from x and returns the result.`, Re, !0, ie, Le], null), null), SSe = Nl(ZN, vT, null, null, new $(null, 3, [te, ZN, ne, ue(new v(null, 2, 5, y, [et, ys], null)), ee, "Ignores body, yields nil"], null)), ESe = Nl(pN, XT, null, null, new $(
  null,
  3,
  [te, pN, ne, ue(new v(null, 3, 5, y, [th, et, ys], null)), ee, `binding => var-symbol temp-value-expr

  Temporarily redefines vars while executing the body.  The
  temp-value-exprs will be evaluated and each resulting value will
  replace in parallel the root value of its var.  After the body is
  executed, the root values of all the vars will be set back to their
  old values. Useful for mocking out functions during testing.`],
  null
)), OSe = new Ne(function(e, n) {
  return delete e[n];
}, q8, new $(null, 5, [te, q8, ne, ue(new v(null, 2, 5, y, [sm, Wa], null)), ee, `Delete a property from a JavaScript object.
  Returns true upon success, false otherwise.`, Re, !0, ie, Le], null), null), kSe = new Ne(function(e) {
  return typeof e == "number";
}, QP, new $(null, 5, [te, QP, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true for JavaScript numbers, false otherwise.", Re, !0, ie, Le], null), null), bSe = new Ne(Vr, OC, new $(null, 5, [
  te,
  OC,
  ne,
  ue(new v(null, 1, 5, y, [Bt], null)),
  ee,
  "Same as (first (next x))",
  Re,
  !0,
  ie,
  Le
], null), null), TSe = Nl(VI, Gb, Le, !0, new $(
  null,
  3,
  [te, VI, ne, ue(new v(null, 3, 5, y, [O8, et, t1e], null)), ee, `Useful when you want to provide several implementations of the same
  protocol all at once. Takes a single protocol and the implementation
  of that protocol for one or more types. Expands into calls to
  extend-type:

  (extend-protocol Protocol
    AType
      (foo [x] ...)
      (bar [x y] ...)
    BType
      (foo [x] ...)
      (bar [x y] ...)
    AClass
      (foo [x] ...)
      (bar [x y] ...)
    nil
      (foo [x] ...)
      (bar [x y] ...))

  expands into:

  (do
   (clojure.core/extend-type AType Protocol 
     (foo [x] ...) 
     (bar [x y] ...))
   (clojure.core/extend-type BType Protocol 
     (foo [x] ...) 
     (bar [x y] ...))
   (clojure.core/extend-type AClass Protocol 
     (foo [x] ...) 
     (bar [x y] ...))
   (clojure.core/extend-type nil Protocol 
     (foo [x] ...) 
     (bar [x y] ...)))`],
  null
)), jSe = new Ne(ra, G8, new $(null, 5, [te, G8, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x is a JavaScript array.", Re, !0, ie, Le], null), null), ASe = new Ne(function(e) {
  return Jr(e);
}, e$, new $(null, 5, [te, e$, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, null, Re, !0, ie, Le], null), null), DSe = new Ne(function(e, n, t) {
  return wr.g(Or.h(e), function(l) {
    var r = Vs();
    return xs(l, new v(null, 4, 5, y, [Il, r, Vc, n], null), t);
  }), null;
}, F9, new $(null, 5, [te, F9, ne, null, ee, null, Re, !0, ie, Le], null), !0), ISe = new Ne(Br, _M, new $(null, 5, [te, _M, ne, ue(new v(
  null,
  2,
  5,
  y,
  [Zge, Sr],
  null
)), ee, "Writes s with writer and returns the result.", Re, !0, ie, Le], null), null), RSe = new Ne(wp, AR, new $(null, 6, [te, AR, hl, wp, ne, ue(Dt, new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, "Returns the sum of nums. (+) returns 0.", Re, !0, ie, Le], null), null), NSe = new Ne(function(e) {
  var n = Bw(e);
  return n || (e != null ? e.C & 1 || Rn === e.Of ? !0 : e.C ? !1 : pl(_Y, e) : pl(_Y, e));
}, lR, new $(null, 5, [
  te,
  lR,
  ne,
  ue(new v(null, 1, 5, y, [il], null)),
  ee,
  "Returns true if f returns true for fn? or satisfies IFn.",
  Re,
  !0,
  ie,
  Le
], null), null), CSe = Nl(BN, nj, null, null, new $(null, 3, [te, BN, ne, ue(new v(null, 3, 5, y, [th, et, ys], null)), ee, `Evaluates the exprs in a lexical context in which the symbols in
  the binding-forms are bound to their respective init-exprs or parts
  therein. Acts as a recur target.`], null)), MSe = new Ne(Yr, aP, new $(
  null,
  5,
  [te, aP, ne, ue(new v(null, 2, 5, y, [tH, IW], null), new v(null, 3, 5, y, [tH, IW, zve], null)), ee, `Create an instance of ExceptionInfo, an Error type that carries a
  map of additional data.`, Re, !0, ie, Le],
  null
), null), PSe = new Ne(Lw, Z7, new $(null, 6, [te, Z7, hl, Lw, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns a number one greater than num.", Re, !0, ie, Le], null), null), $Se = new Ne(Um, $x, new $(null, 6, [te, $x, hl, Um, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, `If no denominators are supplied, returns 1/numerator,
  else returns numerator divided by all of the denominators.`, Re, !0, ie, Le], null), null), LSe = Nl(G9, function(e, n, t, l, r, u) {
  return ve.h(z(he.l(new g(
    null,
    Yl,
    null,
    1,
    null
  ), new g(null, Et(ve.h(z(he.l(new g(null, D6, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, QW, null, 1, null), new g(null, ve.h(z(he.g(new g(null, DQ, null, 1, null), new g(null, D6, null, 1, null)))), null, 1, null), new g(null, r, null, 1, null), new g(null, ve.h(z(he.g(new g(null, a0e, null, 1, null), new g(null, D6, null, 1, null)))), null, 1, null)]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, $B, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, l, null, 1, null), new g(null, 0, null, 1, null))))), null, 1, null), Te([new g(
    null,
    ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Qx, null, 1, null), new g(null, l, null, 1, null), Te([new g(null, QW, null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, mi, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Q1e, null, 1, null), new g(null, r, null, 1, null), Te([new g(null, l, null, 1, null), new g(null, u, null, 1, null)])))), null, 1, null), Te([new g(
      null,
      ve.h(z(he.g(new g(null, b1, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Lx, null, 1, null), new g(null, l, null, 1, null)))), null, 1, null)))),
      null,
      1,
      null
    )])))), null, 1, null), new g(null, r, null, 1, null)])))),
    null,
    1,
    null
  )])))), null, 1, null)]))));
}, null, null, new $(null, 3, [te, G9, ne, ue(new v(null, 4, 5, y, [Vl, _v, fJ, Vd], null)), ee, `Maps an expression across an array a, using an index named idx, and
  return value named ret, initialized to a clone of a, then setting
  each element of ret to the evaluation of expr, returning the new
  array ret.`], null)), BSe = new Ne(Qi, gN, new $(null, 5, [
  te,
  gN,
  ne,
  ue(new v(null, 1, 5, y, [rh], null)),
  ee,
  "Creates and returns a Volatile with an initial value of val.",
  Re,
  !0,
  ie,
  Le
], null), null), FSe = new Ne(Bl, HC, new $(null, 5, [te, HC, ne, ue(new v(null, 2, 5, y, [bv, Dx], null)), ee, `Returns an object of the same type and value as obj, with
  map m as its metadata.`, Re, !0, ie, Le], null), null), VSe = new Ne(ci, vN, new $(null, 5, [te, vN, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x satisfies IMap", Re, !0, ie, Le], null), null), YSe = new Ne(or, w7, new $(null, 5, [te, w7, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x satisfies IVector", Re, !0, ie, Le], null), null), USe = Nl(tR, gT, null, null, new $(null, 3, [
  te,
  tR,
  ne,
  ue(new v(null, 3, 5, y, [Sn, et, Tv], null)),
  ee,
  `Threads the expr through the forms. Inserts x as the
  last item in the first form, making a list of it if it is not a
  list already. If there are more forms, inserts the first form as the
  last item in second form, etc.`
], null)), qSe = new Ne(wy, P$, new $(null, 6, [te, P$, hl, wy, ne, ue(new v(null, 2, 5, y, [Tr, Xs], null)), ee, "quot[ient] of dividing numerator by denominator.", Re, !0, ie, Le], null), null), WSe = new Ne(function() {
  return !0;
}, nP, new $(null, 5, [te, nP, ne, ue(new v(
  null,
  1,
  5,
  y,
  [Sn],
  null
)), ee, "Returns true if given any argument.", Re, !0, ie, Le], null), null), HSe = new Ne(gp, r8, new $(null, 6, [te, r8, hl, gp, ne, ue(Dt, new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, "Returns the sum of nums. (+) returns 0.", Re, !0, ie, Le], null), null), zSe = new Ne(P3, x7, new $(null, 5, [te, x7, ne, null, ee, null, Re, !0, ie, Le], null), null), KSe = new Ne(fU, YP, new $(null, 6, [te, YP, hl, fU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null), GSe = new Ne(J3, h9, new $(null, 5, [
  te,
  h9,
  ne,
  ue(new v(null, 1, 5, y, [ws], null), new v(null, 2, 5, y, [ws, Bt], null)),
  ee,
  `Returns a lazy sequence of the items in coll starting from the
  first item for which (pred item) returns logical false.  Returns a
  stateful transducer when no collection is provided.`,
  Re,
  !0,
  ie,
  Le
], null), null), ZSe = new Ne(c2, s8, new $(null, 5, [te, s8, ne, ue(new v(null, 2, 5, y, [Tr, Bt], null)), ee, `If coll is counted? returns its count, else will count at most the first n
   elements of coll using its seq`, Re, !0, ie, Le], null), null), XSe = new Ne(
  vo,
  IM,
  new $(null, 5, [te, IM, ne, ue(new v(null, 1, 5, y, [ws], null), new v(null, 2, 5, y, [ws, Bt], null)), ee, `Returns a lazy sequence of successive items from coll while
  (pred item) returns logical true. pred must be free of side-effects.
  Returns a transducer when no collection is provided.`, Re, !0, ie, Le], null),
  null
), QSe = new Ne(function(e, n) {
  return pu(fu(function(t) {
    return XO(t, n);
  }, i1.h(e)));
}, XR, new $(null, 5, [te, XR, ne, null, ee, null, Re, !0, ie, Le], null), null), JSe = new Ne(Lf, hN, new $(null, 5, [te, hN, ne, ue(
  new v(null, 1, 5, y, [Bt], null),
  new v(null, 2, 5, y, [Gx, Bt], null)
), ee, `Returns a sorted sequence of the items in coll. Comp can be
   boolean-valued comparison function, or a -/0/+ valued comparator.
   Comp defaults to compare.`, Re, !0, ie, Le], null), null), eEe = new Ne(function(e) {
  return e === !1;
}, pP, new $(null, 5, [te, pP, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x is the value false, false otherwise.", Re, !0, ie, Le], null), null), nEe = new Ne(F4, hR, new $(null, 5, [
  te,
  hR,
  ne,
  ue(new v(null, 1, 5, y, [F0e], null)),
  ee,
  `A transducer which concatenates the contents of each input, which must be a
  collection, into the reduction.`,
  Re,
  !0,
  ie,
  Le
], null), null), tEe = Nl(iC, Zb, Le, !0, new $(
  null,
  3,
  [te, iC, ne, ue(new v(null, 3, 5, y, [Ewe, et, Wk], null)), ee, `Extend a type to a series of protocols. Useful when you are
  supplying the definitions explicitly inline. Propagates the
  type as a type hint on the first argument of all fns.

  type-sym may be

   * default, meaning the definitions will apply for any value,
     unless an extend-type exists for one of the more specific
     cases below.
   * nil, meaning the definitions will apply for the nil value.
   * any of object, boolean, number, string, array, or function,
     indicating the definitions will apply for values of the
     associated base JavaScript types. Note that, for example,
     string should be used instead of js/String.
   * a JavaScript type not covered by the previous list, such
     as js/RegExp.
   * a type defined by deftype or defrecord.

  (extend-type MyType
    ICounted
    (-count [c] ...)
    Foo
    (bar [x y] ...)
    (baz ([x] ...) ([x y] ...) ...)`],
  null
)), lEe = new Ne(l5, q0, new $(null, 5, [te, q0, ne, ue(new v(null, 1, 5, y, [Fk], null), new v(null, 2, 5, y, [Fk, Bt], null)), ee, `Given a map of replacement pairs and a vector/collection, returns a
  vector/seq with any elements = a key in smap replaced with the
  corresponding val in smap.  Returns a transducer when no collection
  is provided.`, Re, !0, ie, Le], null), null), rEe = Nl(QN, iT, null, null, new $(
  null,
  3,
  [te, QN, ne, ue(new v(null, 3, 5, y, [uee, et, ys], null)), ee, `Repeatedly executes body (presumably for side-effects) with
  bindings and filtering as provided by "for".  Does not retain
  the head of the sequence. Returns nil.`],
  null
)), iEe = new Ne(uu, QM, new $(null, 5, [te, QM, ne, ue(Bl(new v(null, 1, 5, y, [Tr], null), new $(null, 1, [hm, new v(null, 1, 5, y, [ue(Fd, Tr)], null)], null)), Bl(new v(null, 2, 5, y, [Tr, Bt], null), new $(null, 1, [hm, new v(null, 1, 5, y, [ue(Fd, Tr)], null)], null))), ee, `Returns a lazy sequence of all but the first n items in coll.
  Returns a stateful transducer when no collection is provided.`, Re, !0, ie, Le], null), null), uEe = new Ne(mg, RM, new $(null, 5, [te, RM, ne, null, ee, null, Re, !0, ie, Le], null), null), sEe = new Ne(er, a7, new $(null, 5, [te, a7, ne, ue(new v(
  null,
  1,
  5,
  y,
  [Sn],
  null
)), ee, "Returns true if x is logical false, false otherwise.", Re, !0, ie, Le], null), null), oEe = new Ne(Tf, w9, new $(null, 5, [te, w9, ne, ue(new v(null, 1, 5, y, [il], null), new v(null, 2, 5, y, [il, Bt], null)), ee, `Returns a lazy sequence of the non-nil results of (f item). Note,
  this means false return values will be included.  f must be free of
  side-effects.  Returns a transducer when no collection is provided.`, Re, !0, ie, Le], null), null), aEe = new Ne(kt, qM, new $(null, 5, [
  te,
  qM,
  ne,
  ue(new v(null, 2, 5, y, [Sn, Bt], null)),
  ee,
  "Returns a new seq where x is the first element and coll is the rest.",
  Re,
  !0,
  ie,
  Le
], null), null), cEe = Jne, hEe = new Ne(wU, S$, new $(null, 6, [te, S$, hl, wU, ne, ue(new v(null, 2, 5, y, [Sn, Tr], null)), ee, "Bitwise shift right", Re, !0, ie, Le], null), null), fEe = new Ne(fK, K9, new $(null, 5, [te, K9, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if coll implements IAssociative", Re, !0, ie, Le], null), null), dEe = new Ne(_h, M0, new $(null, 5, [te, M0, ne, null, ee, null, Re, !0, ie, Le], null), !0), ete = Hc(MX, null, new $(null, 1, [ie, Le], null));
dp(ete);
var pEe = Gn(N3e, [
  C3e,
  Tp,
  M3e,
  P3e,
  $3e,
  L3e,
  B3e,
  F3e,
  V3e,
  Y3e,
  U3e,
  q3e,
  W3e,
  H3e,
  z3e,
  K3e,
  Kne,
  G3e,
  Z3e,
  X3e,
  Q3e,
  J3e,
  e5e,
  n5e,
  t5e,
  l5e,
  r5e,
  i5e,
  u5e,
  s5e,
  o5e,
  a5e,
  c5e,
  h5e,
  f5e,
  d5e,
  p5e,
  m5e,
  g5e,
  w5e,
  v5e,
  y5e,
  _5e,
  x5e,
  S5e,
  E5e,
  O5e,
  k5e,
  b5e,
  T5e,
  j5e,
  A5e,
  D5e,
  I5e,
  R5e,
  N5e,
  C5e,
  M5e,
  P5e,
  $5e,
  L5e,
  B5e,
  F5e,
  V5e,
  Y5e,
  D1,
  U5e,
  q5e,
  W5e,
  H5e,
  z5e,
  zne,
  K5e,
  G5e,
  Z5e,
  X5e,
  Q5e,
  J5e,
  eSe,
  nSe,
  tSe,
  lSe,
  rSe,
  iSe,
  uSe,
  sSe,
  oSe,
  aSe,
  cSe,
  hSe,
  fSe,
  dSe,
  pSe,
  mSe,
  gSe,
  wSe,
  vSe,
  ySe,
  _Se,
  xSe,
  SSe,
  ESe,
  OSe,
  kSe,
  bSe,
  TSe,
  G$,
  jSe,
  ASe,
  DSe,
  ISe,
  RSe,
  NSe,
  CSe,
  MSe,
  PSe,
  $Se,
  LSe,
  BSe,
  FSe,
  VSe,
  YSe,
  USe,
  qSe,
  WSe,
  bg,
  HSe,
  zSe,
  KSe,
  GSe,
  ZSe,
  XSe,
  QSe,
  JSe,
  eEe,
  nEe,
  tEe,
  Eg,
  lEe,
  rEe,
  iEe,
  uEe,
  sEe,
  oEe,
  aEe,
  cEe,
  hEe,
  fEe,
  dEe,
  ete,
  new Ne(function(e, n) {
    var t = sn(pF);
    return t.g ? t.g(e, n) : t.call(null, e, n);
  }, R8, new $(null, 5, [te, R8, ne, ue(new v(null, 1, 5, y, [JW], null)), ee, `Repeatedly calls macroexpand-1 on form until it no longer
  represents a macro form, then returns it.  Note neither
  macroexpand-1 nor macroexpand expand macros in subforms.`, Re, !0, ie, Le], null), !0),
  new Ne(function(e, n) {
    return J4(Or.h(e), n, !0, null);
  }, y9, new $(null, 5, [
    te,
    y9,
    ne,
    ue(new v(null, 1, 5, y, [Xq], null), new v(null, 2, 5, y, [Xq, jZ], null)),
    ee,
    "Create a new namespace named by the symbol. Bootstrap only.",
    Re,
    !0,
    ie,
    Le
  ], null), !0),
  o4,
  Sg,
  Nl(wM, n3, null, null, new $(null, 3, [te, wM, ne, ue(new v(null, 2, 5, y, [xf, pv], null), new v(null, 3, 5, y, [xf, pv, m6], null)), ee, `Evaluates test. If logical false, evaluates and returns then expr, 
  otherwise else expr, if supplied, else nil.`], null)),
  new Ne(function(e) {
    return e != null && (e.J & 1024 || Rn === e.Kf) ? e.Lc() : z(Wr(e));
  }, cC, new $(null, 5, [te, cC, ne, ue(new v(
    null,
    1,
    5,
    y,
    [Sr],
    null
  )), ee, null, Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    return ky(e, n);
  }, B7, new $(null, 5, [te, B7, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    return e ^ 1 << n;
  }, BM, new $(null, 5, [te, BM, ne, ue(new v(null, 2, 5, y, [Sn, Tr], null)), ee, "Flip bit at index n", Re, !0, ie, Le], null), null),
  new Ne(
    Om,
    dP,
    new $(null, 6, [te, dP, hl, Om, ne, ue(new v(null, 3, 5, y, [$d, _v, rh], null), new v(null, 5, 5, y, [$d, _v, oye, et, J0e], null)), ee, `Sets the value at the index/indices. Works on JavaScript arrays.
  Returns val.`, Re, !0, ie, Le], null),
    null
  ),
  Nd(TB, Zy),
  Mi,
  new Ne(Cp, B$, new $(null, 5, [
    te,
    B$,
    ne,
    ue(new v(null, 1, 5, y, [O8], null), new v(null, 2, 5, y, [cv, hv], null), new v(null, 3, 5, y, [cv, hv, BS], null), new v(null, 5, 5, y, [cv, hv, BS, et, BW], null)),
    ee,
    `Takes a set of predicates and returns a function f that returns the first logical true value
  returned by one of its composing predicates against any of its arguments, else it returns
  logical false. Note that f is short-circuiting in that it will stop execution on the first
  argument that triggers a logical true result against the original predicates.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Qs, gM, new $(null, 5, [te, gM, ne, ue(new v(null, 1, 5, y, [Md], null)), ee, "Returns true if v is of type cljs.core.Var", Re, !0, ie, Le], null), null),
  A1,
  Nl(G7, xT, null, null, new $(null, 3, [te, G7, ne, ue(new v(null, 3, 5, y, [xf, et, ys], null)), ee, "Evaluates test. If logical false, evaluates body in an implicit do."], null)),
  new Ne(yp, M9, new $(null, 6, [
    te,
    M9,
    hl,
    yp,
    ne,
    ue(Dt, new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)),
    ee,
    "Returns the product of nums. (*) returns 1.",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(No, k$, new $(null, 5, [te, k$, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns its argument.", Re, !0, ie, Le], null), null),
  Nd(PB, I2),
  new Ne(Sc, i7, new $(null, 5, [te, i7, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Returns an array containing the contents of coll.", Re, !0, ie, Le], null), null),
  new Ne(
    My,
    fC,
    new $(null, 6, [te, fC, hl, My, ne, ue(new v(null, 1, 5, y, [SE], null), new v(null, 2, 5, y, [rw, EE], null)), ee, `Creates an array of doubles. Does not coerce array, provided for compatibility
  with Clojure.`, Re, !0, ie, Le], null),
    null
  ),
  new Ne(ub, TC, new $(null, 5, [te, TC, ne, ue(new v(null, 2, 5, y, [et, g_], null)), ee, `keyval => key val
  Returns a new sorted map with supplied mappings.`, Re, !0, ie, Le], null), null),
  Nd(cne, function(e) {
    return Kd(e);
  }),
  new Ne(he, Z9, new $(null, 5, [te, Z9, ne, ue(Dt, new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, h_e], null)), ee, "Returns a lazy seq representing the concatenation of the elements in the supplied colls.", Re, !0, ie, Le], null), null),
  new Ne(gy, D$, new $(null, 6, [te, D$, hl, gy, ne, ue(new v(
    null,
    1,
    5,
    y,
    [Sn],
    null
  )), ee, "Coerce to char", Re, !0, ie, Le], null), null),
  new Ne(aI, qI, new $(null, 5, [te, qI, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x is a symbol or keyword", Re, !0, ie, Le], null), null),
  new Ne(Sm, Y7, new $(null, 5, [
    te,
    Y7,
    ne,
    ue(new v(null, 1, 5, y, [rw], null), new v(null, 2, 5, y, [cw, rw], null), new v(null, 4, 5, y, [cw, rw, et, w_e], null)),
    ee,
    `Construct a JavaScript array of the specified dimensions. Accepts ignored
  type argument for compatibility with Clojure. Note that there is no efficient
  way to allocate multi-dimensional arrays in JavaScript; as such, this function
  will run in polynomial time when called with 3 or more arguments.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Sh, MP, new $(null, 5, [te, MP, ne, ue(new v(null, 1, 5, y, [Bve], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(WO, jC, new $(null, 5, [te, jC, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `For a list or queue, same as first, for a vector, same as, but much
  more efficient than, last. If the collection is empty, returns nil.`, Re, !0, ie, Le], null), null),
  new Ne(Na, sC, new $(null, 5, [
    te,
    sC,
    ne,
    ue(new v(null, 1, 5, y, [Bt], null)),
    ee,
    `Returns the hash code, consistent with =, for an external unordered
   collection implementing Iterable. For maps, the iterator should
   return map entries whose hash is computed as
     (hash-ordered-coll [k v]).
   See http://clojure.org/data_structures#hash for full algorithms.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nl(Fx, _T, null, null, new $(null, 3, [te, Fx, ne, ue(new v(null, 3, 5, y, [xf, et, ys], null)), ee, "Evaluates test. If logical true, evaluates body in an implicit do."], null)),
  new Ne(Bc, kM, new $(null, 5, [
    te,
    kM,
    ne,
    ue(new v(null, 3, 5, y, [Sn, et, new $(null, 3, [Gr, new v(null, 1, 5, y, [UW], null), Kr, new $(null, 1, [UW, oo], null), Uh, mW], null)], null)),
    ee,
    `Recursively transforms ClojureScript values to JavaScript.
  sets/vectors/lists become Arrays, Keywords and Symbol become Strings,
  Maps become Objects. Arbitrary keys are encoded to by \`key->js\`.
  Options is a key-value pair, where the only valid key is
  :keyword-fn, which should point to a single-argument function to be
  called on keyword keys. Default to \`name\`.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(ve, M$, new $(null, 5, [
    te,
    M$,
    ne,
    ue(new v(null, 1, 5, y, [Bt], null), new v(null, 2, 5, y, [ov, Bt], null), new v(null, 4, 5, y, [ov, Bt, et, mv], null)),
    ee,
    `Coerces coll to a (possibly empty) sequence, if it is not already
  one. Will not force a lazy seq. (sequence nil) yields (), When a
  transducer is supplied, returns a lazy sequence of applications of
  the transform to the items in coll(s), i.e. to the set of first
  items of each coll, followed by the set of second
  items in each coll, until any one of the colls is exhausted.  Any
  remaining items in other colls are ignored. The transform should accept
  number-of-colls arguments`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(xy, I$, new $(null, 5, [te, I$, ne, ue(new v(null, 2, 5, y, [il, Bt], null)), ee, `Returns a map of the elements of coll keyed by the result of
  f on each element. The value at each key will be a vector of the
  corresponding elements, in the order they appeared in coll.`, Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    if (typeof n == "string") return Qme(e, n);
    throw new TypeError("re-seq must match against a string.");
  }, t8, new $(null, 5, [
    te,
    t8,
    ne,
    ue(new v(null, 2, 5, y, [W_, Sr], null)),
    ee,
    "Returns a lazy sequence of successive matches of re in s.",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nd(kv, f1),
  Nl(oN, jT, null, null, new $(null, 3, [te, oN, ne, ue(new v(null, 3, 5, y, [th, et, ys], null)), ee, `bindings => binding-form test

   When test is not nil, evaluates body with binding-form bound to the
   value of test`], null)),
  new Ne(Xm, e7, new $(null, 6, [
    te,
    e7,
    hl,
    Xm,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)),
    ee,
    `If no ys are supplied, returns the negation of x, else subtracts
  the ys from x and returns the result.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Wm, T8, new $(null, 6, [te, T8, hl, Wm, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, `Returns non-nil if nums are in monotonically non-decreasing order,
  otherwise false.`, Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return _I(e);
  }, c8, new $(null, 5, [te, c8, ne, ue(new v(null, 1, 5, y, [iw], null)), ee, "Given a multimethod, returns a map of preferred value -> set of other values", Re, !0, ie, Le], null), null),
  new Ne(wu, XI, new $(null, 5, [te, XI, ne, ue(new v(
    null,
    2,
    5,
    y,
    [sm, il],
    null
  ), new v(null, 3, 5, y, [sm, il, Vl], null), new v(null, 4, 5, y, [sm, il, Vl, qo], null), new v(null, 5, 5, y, [sm, il, Vl, qo, Ld], null), new v(null, 6, 5, y, [sm, il, Vl, qo, Ld, Xs], null), new v(null, 8, 5, y, [sm, il, Vl, qo, Ld, Xs, et, Gs], null)), ee, `Returns an object of the same type and value as obj, with
  (apply f (meta obj) args) as its metadata.`, Re, !0, ie, Le], null), null),
  new Ne(on, I8, new $(null, 6, [
    te,
    I8,
    hl,
    on,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)),
    ee,
    `Equality. Returns true if x equals y, false if not. Compares
  numbers and collections in a type-independent manner.  Clojure's immutable data
  structures define -equiv (and thus =) as a value, not an identity,
  comparison.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(YT, sM, new $(null, 5, [te, sM, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(O2, eP, new $(null, 5, [te, eP, ne, ue(new v(null, 1, 5, y, [il], null), new v(null, 2, 5, y, [il, Bt], null)), ee, `Returns a lazy sequence of the non-nil results of (f index item). Note,
  this means false return values will be included.  f must be free of
  side-effects.  Returns a stateful transducer when no collection is
  provided.`, Re, !0, ie, Le], null), null),
  new Ne(S2, lP, new $(null, 5, [
    te,
    lP,
    ne,
    ue(Dt, new v(null, 2, 5, y, [et, g_], null)),
    ee,
    `Create JavaSript object from an even number arguments representing
  interleaved keys and values.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(hu, N8, new $(null, 5, [te, N8, ne, ue(new v(null, 2, 5, y, [ws, Bt], null)), ee, `Returns true if (pred x) is logical true for every x in coll, else
  false.`, Re, !0, ie, Le], null), null),
  new Ne(ua, Gx, new $(null, 5, [
    te,
    Gx,
    ne,
    ue(Dt, new v(null, 1, 5, y, [il], null), new v(null, 2, 5, y, [il, h_], null), new v(null, 3, 5, y, [il, h_, Bd], null), new v(null, 5, 5, y, [zye, Kye, Gye, et, iH], null)),
    ee,
    `Takes a set of functions and returns a fn that is the composition
  of those fns.  The returned fn takes a variable number of args,
  applies the rightmost of fns to the args, the next
  fn (right-to-left) to the result, etc.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(function(e, n) {
    return e | 1 << n;
  }, QR, new $(null, 5, [te, QR, ne, ue(new v(null, 2, 5, y, [Sn, Tr], null)), ee, "Set bit at index n", Re, !0, ie, Le], null), null),
  new Ne(nr, DN, new $(null, 5, [te, DN, ne, ue(new v(null, 1, 5, y, [Bt], null), new v(null, 2, 5, y, [Bt, cu], null), new v(null, 4, 5, y, [Bt, cu, et, Oc], null)), ee, `dissoc[iate]. Returns a new map of the same (hashed/sorted) type,
  that does not contain a mapping for key(s).`, Re, !0, ie, Le], null), null),
  new Ne(Km, GC, new $(null, 6, [te, GC, hl, Km, ne, ue(
    new v(null, 1, 5, y, [Sn], null),
    new v(null, 2, 5, y, [Sn, al], null),
    new v(null, 4, 5, y, [Sn, al, et, Ai], null)
  ), ee, "Returns the least of the nums.", Re, !0, ie, Le], null), null),
  new Ne(lK, PM, new $(null, 5, [te, PM, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x is a JavaScript string of length one.", Re, !0, ie, Le], null), null),
  Nl(lM, NT, null, null, new $(null, 3, [te, lM, ne, null, ee, null], null)),
  new Ne(Nu, Y8, new $(null, 5, [
    te,
    Y8,
    ne,
    ue(Dt, new v(null, 1, 5, y, [Rd], null), new v(null, 2, 5, y, [Rd, rm], null), new v(null, 4, 5, y, [Rd, rm, et, mv], null)),
    ee,
    "Returns a lazy seq of the first item in each coll, then the second etc.",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nl(VP, IT, null, null, new $(null, 3, [te, VP, ne, ue(new v(null, 2, 5, y, [et, Lwe], null)), ee, "defs the supplied var names with no bindings, useful for making forward declarations."], null)),
  Nl(vC, MT, null, null, new $(null, 3, [te, vC, ne, null, ee, null], null)),
  new Ne(function(e) {
    var n = dk(e);
    return j(n) ? n : Q4(e) != null || !1;
  }, v7, new $(null, 5, [te, v7, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(gE, EN, new $(null, 5, [te, EN, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(jL, g$, new $(null, 5, [te, g$, ne, ue(new v(
    null,
    2,
    5,
    y,
    [Tr, Bt],
    null
  )), ee, "Returns a vector of [(take n coll) (drop n coll)]", Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return za(e) ? 0 > e : !1;
  }, WM, new $(null, 5, [te, WM, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x satisfies int? and is negative.", Re, !0, ie, Le], null), null),
  new Ne(wo, LN, new $(null, 5, [
    te,
    LN,
    ne,
    ue(new v(null, 2, 5, y, [il, Bt], null), new v(null, 3, 5, y, [il, Rd, rm], null), new v(null, 4, 5, y, [il, Rd, rm, YS], null), new v(null, 6, 5, y, [il, Rd, rm, YS, et, mv], null)),
    ee,
    `Returns a vector consisting of the result of applying f to the
  set of first items of each coll, followed by applying f to the set
  of second items in each coll, until any one of the colls is
  exhausted.  Any remaining items in other colls are ignored. Function
  f should accept number-of-colls arguments.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nl(x$, function(e, n, t, l) {
    return ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, Hq, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Yc, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, GB, null, 1, null), new g(null, ve.h(z(he.g(new g(null, kE, null, 1, null), new g(null, Hq, null, 1, null)))), null, 1, null), Te([new g(
      null,
      ve.h(z(he.l(new g(null, Yc, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, l, null, 1, null)])))),
      null,
      1,
      null
    )])))), null, 1, null)]))));
  }, null, null, new $(null, 3, [te, x$, ne, ue(new v(null, 2, 5, y, [Sn, T_], null)), ee, `defs name to have the root value of init iff the named var has no root value,
  else init is unevaluated`], null)),
  new Ne(function(e, n) {
    return aB(Or.h(e), n), null;
  }, $N, new $(null, 5, [te, $N, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(oT, n$, new $(null, 5, [te, n$, ne, ue(new v(null, 2, 5, y, [et, W0], null)), ee, "Same as pr followed by (newline).", Re, !0, ie, Le], null), null),
  new Ne(Py, m$, new $(null, 5, [te, m$, ne, ue(new v(
    null,
    1,
    5,
    y,
    [Sr],
    null
  ), new v(null, 2, 5, y, [Tr, Sr], null)), ee, "Return a lazy sequence of all but the last n (default 1) items in coll", Re, !0, ie, Le], null), null),
  new Ne(l3, UP, new $(null, 5, [te, UP, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(Ff, kR, new $(null, 5, [
    te,
    kR,
    ne,
    ue(new v(null, 2, 5, y, [il, Sn], null), new v(null, 3, 5, y, [il, Sn, al], null), new v(null, 4, 5, y, [il, Sn, al, $S], null)),
    ee,
    `Takes a function f, and returns a function that calls f, replacing
  a nil first argument to f with the supplied value x. Higher arity
  versions can replace arguments in the second and third
  positions (y, z). Note that the function f can take any number of
  arguments, not just the one(s) being nil-patched.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nl(LM, kT, null, null, new $(null, 3, [te, LM, ne, ue(new v(null, 3, 5, y, [Vd, et, z_], null)), ee, `Takes an expression and a set of test/form pairs. Threads expr (via ->>)
  through each form for which the corresponding test expression
  is true.  Note that, unlike cond branching, cond->> threading does not short circuit
  after the first true test expression.`], null)),
  new Ne(Vm, vR, new $(null, 5, [te, vR, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(nq, qP, new $(null, 5, [te, qP, ne, ue(new v(
    null,
    2,
    5,
    y,
    [AZ, Sn],
    null
  )), ee, "Returns true if x satisfies the protocol", Re, !0, ie, Le], null), null),
  new Ne(W, q_, new $(null, 5, [te, q_, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `Returns a seq of the items after the first. Calls seq on its
  argument.  If there are no more items, returns nil`, Re, !0, ie, Le], null), null),
  new Ne(rc, Px, new $(null, 6, [te, Px, hl, rc, ne, ue(Dt, new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, "Returns the sum of nums. (+) returns 0.", Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    mg(Qu([Mi, sn(Mi)]));
    try {
      var t = H4(x1(n));
      for (n = null; ; ) {
        var l = z3(e, t, null);
        if (Ln(yb, l)) return n;
        n = NI(e, l);
      }
    } finally {
      Vm();
    }
  }, DP, new $(null, 5, [te, DP, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(ml, oo, new $(null, 5, [te, oo, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns the name String of a string, symbol or keyword.", Re, !0, ie, Le], null), null),
  new Ne(GY, p7, new $(null, 6, [te, p7, hl, GY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  Nl(nR, bT, null, null, new $(null, 3, [te, nR, ne, ue(new v(
    null,
    3,
    5,
    y,
    [th, et, ys],
    null
  )), ee, `bindings => binding-form test

  When test is true, evaluates body with binding-form bound to the value of test`], null)),
  new Ne(jp, _E, new $(null, 5, [te, _E, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x is a Symbol", Re, !0, ie, Le], null), null),
  new Ne(js, _P, new $(null, 5, [te, _P, ne, ue(new v(null, 2, 5, y, [yE, $k], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(X3, U9, new $(null, 5, [
    te,
    U9,
    ne,
    ue(new v(null, 2, 5, y, [$h, rh], null), new v(null, 4, 5, y, [$h, rh, et, qy], null)),
    ee,
    `disj[oin]. Returns a transient set of the same (hashed/sorted) type, that
  does not contain key(s).`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(function(e, n) {
    return new V4(e, n);
  }, rR, new $(null, 5, [te, rR, ne, ue(new v(null, 2, 5, y, [ov, Bt], null)), ee, "Positional factory function for cljs.core/Eduction.", Re, !0, ie, Le], null), null),
  new Ne(cq, wC, new $(null, 5, [te, wC, ne, ue(new v(null, 1, 5, y, [NS], null)), ee, "Returns a map of the import mappings for the namespace.", Re, !0, ie, Le], null), !0),
  new Ne(function(e) {
    return QO(e);
  }, wP, new $(null, 5, [
    te,
    wP,
    ne,
    ue(new v(null, 1, 5, y, [iw], null)),
    ee,
    "Given a multimethod, returns a map of dispatch values -> dispatch fns",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(function(e, n) {
    return e.meta = n;
  }, wN, new $(null, 5, [te, wN, ne, ue(new v(null, 2, 5, y, [US, Ao], null)), ee, "Atomically resets the metadata for an atom", Re, !0, ie, Le], null), null),
  Nl(F8, function(e, n, t, l, r, u, o) {
    return ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, TH, null, 1, null), new g(null, t, null, 1, null), Te([new g(null, fH, null, 1, null), new g(null, ve.h(z(he.g(new g(null, DQ, null, 1, null), new g(null, TH, null, 1, null)))), null, 1, null)]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(
      null,
      $B,
      null,
      1,
      null
    ), new g(null, Et(ve.h(z(he.l(new g(null, l, null, 1, null), new g(null, 0, null, 1, null), Te([new g(null, r, null, 1, null), new g(null, u, null, 1, null)]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Qx, null, 1, null), new g(null, l, null, 1, null), Te([new g(null, fH, null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, b1, null, 1, null), new g(null, ve.h(z(he.g(new g(null, _ye, null, 1, null), new g(null, l, null, 1, null)))), null, 1, null), Te([new g(
      null,
      o,
      null,
      1,
      null
    )])))), null, 1, null), new g(null, r, null, 1, null)])))), null, 1, null)])))), null, 1, null)]))));
  }, null, null, new $(null, 3, [te, F8, ne, ue(new v(null, 5, 5, y, [Vl, _v, fJ, T_, Vd], null)), ee, `Reduces an expression across an array a, using an index named idx,
  and return value named ret, initialized to init, setting ret to the
  evaluation of expr at each step, returning ret.`], null)),
  Nl(ih, lj, null, null, new $(null, 4, [te, ih, ne, null, ee, null, F0, ih], null)),
  new Ne(xp, R9, new $(null, 5, [te, R9, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(
    null,
    3,
    5,
    y,
    [Sn, et, vw],
    null
  )), ee, `Recursively transforms JavaScript arrays into ClojureScript
  vectors, and JavaScript objects into ClojureScript maps.  With
  option ':keywordize-keys true' will convert object fields from
  strings to keywords.`, Re, !0, ie, Le], null), null),
  Nl(FM, yT, null, null, new $(null, 3, [te, FM, ne, ue(new v(null, 3, 5, y, [th, et, ys], null)), ee, `bindings => name n

  Repeatedly executes body (presumably for side-effects) with name
  bound to integers from 0 through n-1.`], null)),
  new Ne(
    OS,
    o9,
    new $(null, 5, [te, o9, ne, ue(new v(null, 1, 5, y, [Tr], null)), ee, "Returns a random integer between 0 (inclusive) and n (exclusive).", Re, !0, ie, Le], null),
    null
  ),
  new Ne(Dp, YC, new $(null, 5, [te, YC, ne, ue(new v(null, 1, 5, y, [il], null)), ee, `Takes a fn f and returns a fn that takes the same arguments as f,
  has the same effects, if any, and returns the opposite truth value.`, Re, !0, ie, Le], null), null),
  new Ne(o2, g7, new $(null, 5, [te, g7, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x implements IList", Re, !0, ie, Le], null), null),
  new Ne(Em, KN, new $(null, 6, [te, KN, hl, Em, ne, ue(new v(null, 2, 5, y, [$d, _v], null), new v(null, 4, 5, y, [$d, _v, et, nye], null)), ee, "Returns the value at the index/indices. Works on JavaScript arrays.", Re, !0, ie, Le], null), null),
  new Ne(_a, n7, new $(null, 5, [te, n7, ne, ue(new v(null, 2, 5, y, [kw, qy], null)), ee, "Returns a map with the keys mapped to the corresponding vals.", Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    if (iE(n)) {
      var t = _n.h(Yi(n));
      if (n = _n.h(ml(n)), e = en.g(Il.h(sn(Or.h(e))), t), j(e)) return en.g(e, n);
      throw Error([
        "No such namespace: ",
        ye.h(t)
      ].join(""));
    }
    throw Error(["Not a qualified symbol: ", ye.h(n)].join(""));
  }, nM, new $(null, 5, [te, nM, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  Nl(Yk, function(e, n, t, l) {
    Ype(e, t);
    var r = function() {
      function u(a) {
        var h = null;
        if (0 < arguments.length) {
          h = 0;
          for (var s = Array(arguments.length - 0); h < s.length; ) s[h] = arguments[h + 0], ++h;
          h = new hn(s, 0, null);
        }
        return o.call(this, h);
      }
      function o(a) {
        throw Error(In.g(ye, a));
      }
      return u.m = 0, u.v = function(a) {
        return a = z(a), o(a);
      }, u.l = o, u;
    }();
    return ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(
      null,
      Et(ve.h(z(he.g(new g(null, CW, null, 1, null), new g(
        null,
        function u(o) {
          o = z(o);
          var a = I(o), h = W(o);
          a = z(a), o = I(a), a = W(a), I(a), a = W(a);
          var s = O.j(h, 0, null);
          O.j(s, 0, null);
          var d = O.j(s, 1, null), p = Xr.h("iter__"), _ = Xr.h("s__");
          if (s = function L(G) {
            var J = z(G);
            G = I(J), J = W(J);
            var we = O.j(G, 0, null);
            return G = O.j(G, 1, null), on.g(we, _7) ? ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, G, null, 1, null), Te([new g(null, L(J), null, 1, null)])))) : on.g(we, U$) ? ve.h(z(he.l(new g(null, yw, null, 1, null), new g(null, G, null, 1, null), Te([new g(
              null,
              L(J),
              null,
              1,
              null
            )])))) : on.g(we, l9) ? ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, G, null, 1, null), Te([new g(null, L(J), null, 1, null), new g(null, ve.h(z(he.g(new g(null, Xd, null, 1, null), new g(null, ve.h(z(he.g(new g(null, WS, null, 1, null), new g(null, _, null, 1, null)))), null, 1, null)))), null, 1, null)])))) : we instanceof de ? r("Invalid 'for' keyword ", we) : h ? ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, cW, null, 1, null), new g(null, u(h), null, 1, null), Te([new g(null, n6, null, 1, null), new g(null, ve.h(z(he.g(new g(
              null,
              qx,
              null,
              1,
              null
            ), new g(null, ve.h(z(he.g(new g(null, cW, null, 1, null), new g(null, d, null, 1, null)))), null, 1, null)))), null, 1, null)]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, n6, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, PJ, null, 1, null), new g(null, n6, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, p, null, 1, null), new g(null, ve.h(z(he.g(new g(null, WS, null, 1, null), new g(null, _, null, 1, null)))), null, 1, null)))), null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.g(new g(
              null,
              Xd,
              null,
              1,
              null
            ), new g(null, ve.h(z(he.g(new g(null, WS, null, 1, null), new g(null, _, null, 1, null)))), null, 1, null)))), null, 1, null)])))), null, 1, null)])))) : ve.h(z(he.l(new g(null, s_e, null, 1, null), new g(null, l, null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, p, null, 1, null), new g(null, ve.h(z(he.g(new g(null, WS, null, 1, null), new g(null, _, null, 1, null)))), null, 1, null)))), null, 1, null)]))));
          }, h) return ve.h(z(he.l(new g(null, sc, null, 1, null), new g(null, p, null, 1, null), Te([new g(
            null,
            Et(ve.h(z(he.h(new g(null, _, null, 1, null))))),
            null,
            1,
            null
          ), new g(null, ve.h(z(he.g(new g(null, XN, null, 1, null), new g(null, ve.h(z(he.l(new g(null, G0, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, _, null, 1, null), new g(null, _, null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, cwe, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, o, null, 1, null), new g(null, _, null, 1, null))))), null, 1, null), Te([new g(null, s(a), null, 1, null)])))), null, 1, null)])))), null, 1, null)))), null, 1, null)]))));
          var R = Xr.h("i__"), F = Xr.h("b__");
          return ve.h(z(he.l(new g(
            null,
            sc,
            null,
            1,
            null
          ), new g(null, p, null, 1, null), Te([new g(null, Et(ve.h(z(he.h(new g(null, _, null, 1, null))))), null, 1, null), new g(null, ve.h(z(he.g(new g(null, XN, null, 1, null), new g(null, ve.h(z(he.l(new g(null, G0, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, _, null, 1, null), new g(null, _, null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(
            new g(null, Yl, null, 1, null),
            new g(null, Et(ve.h(z(he.g(new g(null, _, null, 1, null), new g(null, ve.h(z(he.g(new g(null, qx, null, 1, null), new g(null, _, null, 1, null)))), null, 1, null))))), null, 1, null),
            Te([new g(null, ve.h(z(he.l(new g(null, yw, null, 1, null), new g(null, _, null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.g(new g(null, OQ, null, 1, null), new g(null, _, null, 1, null)))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.l(new g(null, pD, null, 1, null), new g(null, ve.h(z(he.g(new g(null, DZ, null, 1, null), new g(null, _, null, 1, null)))), null, 1, null), Te([new g(null, W6, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Vk, null, 1, null), new g(null, ve.h(z(he.g(new g(
              null,
              tQ,
              null,
              1,
              null
            ), new g(null, pD, null, 1, null)))), null, 1, null)))), null, 1, null), new g(null, F, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Eye, null, 1, null), new g(null, W6, null, 1, null)))), null, 1, null)]))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, ve.h(z(he.l(new g(null, G0, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, R, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Vk, null, 1, null), new g(null, 0, null, 1, null)))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(
              null,
              si,
              null,
              1,
              null
            ), new g(null, ve.h(z(he.l(new g(null, Qx, null, 1, null), new g(null, R, null, 1, null), Te([new g(null, W6, null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, Yl, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, o, null, 1, null), new g(null, ve.h(z(he.l(new g(null, WJ, null, 1, null), new g(null, pD, null, 1, null), Te([new g(null, R, null, 1, null)])))), null, 1, null))))), null, 1, null), Te([new g(null, function L(G) {
              var J = z(G);
              G = I(J), J = W(J);
              var we = O.j(G, 0, null);
              return G = O.j(G, 1, null), on.g(we, _7) ? ve.h(z(he.l(new g(
                null,
                Yl,
                null,
                1,
                null
              ), new g(null, G, null, 1, null), Te([new g(null, L(J), null, 1, null)])))) : on.g(we, U$) ? ve.h(z(he.l(new g(null, yw, null, 1, null), new g(null, G, null, 1, null), Te([new g(null, L(J), null, 1, null)])))) : on.g(we, l9) ? ve.h(z(he.l(new g(null, si, null, 1, null), new g(null, G, null, 1, null), Te([new g(null, L(J), null, 1, null), new g(null, ve.h(z(he.g(new g(null, Xd, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Lx, null, 1, null), new g(null, R, null, 1, null)))), null, 1, null)))), null, 1, null)])))) : we instanceof de ? r(
                "Invalid 'for' keyword ",
                we
              ) : ve.h(z(he.l(new g(null, mi, null, 1, null), new g(null, ve.h(z(he.l(new g(null, s2e, null, 1, null), new g(null, F, null, 1, null), Te([new g(null, l, null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Xd, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Lx, null, 1, null), new g(null, R, null, 1, null)))), null, 1, null)))), null, 1, null)]))));
            }(a), null, 1, null)])))), null, 1, null), new g(null, !0, null, 1, null)])))), null, 1, null)])))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, oW, null, 1, null), new g(null, ve.h(z(he.g(new g(
              null,
              pW,
              null,
              1,
              null
            ), new g(null, F, null, 1, null)))), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, p, null, 1, null), new g(null, ve.h(z(he.g(new g(null, hJ, null, 1, null), new g(null, _, null, 1, null)))), null, 1, null)))), null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, oW, null, 1, null), new g(null, ve.h(z(he.g(new g(null, pW, null, 1, null), new g(null, F, null, 1, null)))), null, 1, null), Te([new g(null, null, null, 1, null)])))), null, 1, null)])))), null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.l(
              new g(null, Yl, null, 1, null),
              new g(null, Et(ve.h(z(he.g(new g(null, o, null, 1, null), new g(null, ve.h(z(he.g(new g(null, HB, null, 1, null), new g(null, _, null, 1, null)))), null, 1, null))))), null, 1, null),
              Te([new g(null, s(a), null, 1, null)])
            ))), null, 1, null)])))), null, 1, null)])))), null, 1, null)])
          ))), null, 1, null)])))), null, 1, null)))), null, 1, null)]))));
        }(function(u) {
          return wt.j(function(o, a) {
            var h = O.j(a, 0, null);
            return a = O.j(a, 1, null), h instanceof de ? yt.g(my(o), yt.g(WO(o), new v(null, 2, 5, y, [h, a], null))) : yt.g(o, new v(null, 2, 5, y, [h, a], null));
          }, Dt, Mo.g(2, u));
        }(t)),
        null,
        1,
        null
      ))))),
      null,
      1,
      null
    ), Te([new g(null, ve.h(z(he.g(new g(null, CW, null, 1, null), new g(null, Vr(t), null, 1, null)))), null, 1, null)]))));
  }, null, null, new $(
    null,
    3,
    [te, Yk, ne, ue(new v(null, 2, 5, y, [uee, n_e], null)), ee, `List comprehension. Takes a vector of one or more
   binding-form/collection-expr pairs, each followed by zero or more
   modifiers, and yields a lazy sequence of evaluations of expr.
   Collections are iterated in a nested fashion, rightmost fastest,
   and nested coll-exprs can refer to bindings created in prior
   binding-forms.  Supported modifiers are: :let [binding-form expr ...],
   :while test, :when test.

  (take 100 (for [x (range 100000000) y (range 1000000) :while (< y x)]  [x y]))`],
    null
  )),
  new Ne(UK, s9, new $(null, 5, [te, s9, ne, ue(new v(null, 2, 5, y, [rxe, Bt], null)), ee, `Runs the supplied procedure (via reduce), for purposes of side
  effects, on successive items in the collection. Returns nil`, Re, !0, ie, Le], null), null),
  new Ne(Ec, P8, new $(null, 6, [te, P8, hl, Ec, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, `Returns non-nil if nums all have the equivalent
  value, otherwise false. Behavior on non nums is
  undefined.`, Re, !0, ie, Le], null), null),
  new Ne(aU, GM, new $(null, 6, [te, GM, hl, aU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(Yw, PN, new $(null, 5, [te, PN, ne, ue(new v(null, 2, 5, y, [il, Sn], null)), ee, "Returns a lazy sequence of x, (f x), (f (f x)) etc. f must be free of side-effects", Re, !0, ie, Le], null), null),
  new Ne(pu, Rx, new $(null, 6, [te, Rx, hl, pu, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Coerce to boolean", Re, !0, ie, Le], null), null),
  new Ne(tr, ZI, new $(null, 5, [
    te,
    ZI,
    ne,
    ue(new v(null, 2, 5, y, [et, g_], null)),
    ee,
    `keyval => key val
  Returns a new hash map with supplied mappings.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(QY, P9, new $(null, 6, [te, P9, hl, QY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(lp, L9, new $(null, 5, [te, L9, ne, ue(new v(null, 2, 5, y, [cu, Sn], null), new v(null, 3, 5, y, [cu, Sn, al], null), new v(null, 5, 5, y, [cu, Sn, al, et, Ai], null)), ee, `Returns the x for which (k x), a number, is greatest.

  If there are multiple such xs, the last one is returned.`, Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    var n = aI(e);
    return n ? (e = Yi(e), e = j(e) ? !0 : e) : e = n, pu(e);
  }, oM, new $(null, 5, [
    te,
    oM,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null)),
    ee,
    "Return true if x is a symbol or keyword with a namespace",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(E2, ZP, new $(null, 5, [te, ZP, ne, ue(new v(null, 2, 5, y, [$h, Wa], null), new v(null, 4, 5, y, [$h, Wa, et, Oc], null)), ee, "Returns a transient map that doesn't contain a mapping for key(s).", Re, !0, ie, Le], null), null),
  new Ne(w1, EP, new $(null, 5, [te, EP, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x satisfies ICollection", Re, !0, ie, Le], null), null),
  new Ne(yK, PP, new $(null, 5, [te, PP, ne, ue(new v(
    null,
    1,
    5,
    y,
    [Bt],
    null
  )), ee, "Returns true if coll satisfies? IReversible.", Re, !0, ie, Le], null), null),
  new Ne(function(e, n, t) {
    return wr.g(Or.h(e), function(l) {
      var r = $c(e, n);
      return r = tc(r), bu.j(l, new v(null, 2, 5, y, [Il, r], null), function(u) {
        return Ol(ta.h(u), t) ? nr.l(Ri.B(u, ta, nr, t), u, Te([t])) : Ol(u, t) ? nr.g(u, t) : Ol(po.h(l), t) || Ol(po.h(u), t) ? Ri.I(u, po, Dn, t, null) : u;
      });
    }), null;
  }, p$, new $(null, 5, [te, p$, ne, ue(new v(null, 2, 5, y, [NS, qW], null)), ee, "Removes the mappings for the symbol from the namespace.", Re, !0, ie, Le], null), !0),
  new Ne(In, eR, new $(
    null,
    5,
    [te, eR, ne, ue(new v(null, 2, 5, y, [il, Gs], null), new v(null, 3, 5, y, [il, Sn, Gs], null), new v(null, 4, 5, y, [il, Sn, al, Gs], null), new v(null, 5, 5, y, [il, Sn, al, $S, Gs], null), new v(null, 7, 5, y, [il, Vl, qo, Ld, Xs, et, Gs], null)), ee, "Applies fn f to the argument list formed by prepending intervening arguments to args.", Re, !0, ie, Le],
    null
  ), null),
  s4,
  new Ne(_p, v$, new $(null, 5, [
    te,
    v$,
    ne,
    ue(new v(null, 2, 5, y, [Md, cm], null), new v(null, 3, 5, y, [Md, cm, f_], null)),
    ee,
    `Returns a persistent vector of the items in vector from
  start (inclusive) to end (exclusive).  If end is not supplied,
  defaults to (count vector). This operation is O(1) and very fast, as
  the resulting vector shares structure with the original and no
  trimming is done.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Vb, CN, new $(null, 5, [te, CN, ne, ue(new v(null, 2, 5, y, [vW, Ov], null), new v(null, 3, 5, y, [Bd, vW, Ov], null)), ee, `Returns true if (= child parent), or child is directly or indirectly derived from
  parent, either via a JavaScript type inheritance relationship or a
  relationship established via derive. h must be a hierarchy obtained
  from make-hierarchy, if not supplied defaults to the global
  hierarchy`, Re, !0, ie, Le], null), !0),
  new Ne(function(e, n) {
    return !hu(e, n);
  }, GN, new $(
    null,
    5,
    [te, GN, ne, ue(new v(null, 2, 5, y, [ws, Bt], null)), ee, `Returns false if (pred x) is logical true for every x in
  coll, else true.`, Re, !0, ie, Le],
    null
  ), null),
  new Ne(j3e, Mk, new $(null, 5, [te, Mk, ne, ue(new v(null, 1, 5, y, [zx], null)), ee, `Returns exception cause (an Error / ExceptionInfo) if ex is an
  ExceptionInfo.
  Otherwise returns nil.`, Re, !0, ie, Le], null), null),
  new Ne(ux, Y9, new $(null, 5, [te, Y9, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x is a Keyword", Re, !0, ie, Le], null), null),
  new Ne(ax, r7, new $(null, 5, [
    te,
    r7,
    ne,
    ue(new v(null, 1, 5, y, [zx], null)),
    ee,
    `Returns exception data (a map) if ex is an ExceptionInfo.
  Otherwise returns nil.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Og,
  new Ne(Gh, TP, new $(null, 6, [
    te,
    TP,
    hl,
    Gh,
    ne,
    ue(new v(null, 2, 5, y, [Sn, al], null)),
    ee,
    `Comparator. Returns a negative number, zero, or a positive number
  when x is logically 'less than', 'equal to', or 'greater than'
  y. Uses IComparable if available and google.array.defaultCompare for objects
 of the same type and special-cases nil to be less than any other object.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Fb, HM, new $(null, 5, [te, HM, ne, ue(new v(null, 2, 5, y, [lh, Ov], null), new v(null, 3, 5, y, [Bd, lh, Ov], null)), ee, `Removes a parent/child relationship between parent and
  tag. h must be a hierarchy obtained from make-hierarchy, if not
  supplied defaults to, and modifies, the global hierarchy.`, Re, !0, ie, Le], null), !0),
  new Ne(pp, k9, new $(null, 5, [
    te,
    k9,
    ne,
    ue(new v(null, 3, 5, y, [ov, il, Bt], null), new v(null, 4, 5, y, [ov, il, T_, Bt], null)),
    ee,
    `reduce with a transformation of f (xf). If init is not
  supplied, (f) will be called to produce it. f should be a reducing
  step function that accepts both 1 and 2 arguments, if it accepts
  only 2 you can add the arity-1 with 'completing'. Returns the result
  of applying (the transformed) xf to init and the first item in coll,
  then applying xf to that result and the 2nd item, etc. If coll
  contains no items, returns init and f is not called. Note that
  certain transforms may inject or skip items.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  O3e,
  new Ne(ic, IP, new $(null, 5, [te, IP, ne, ue(Dt, new v(null, 1, 5, y, [f_], null), new v(null, 2, 5, y, [cm, f_], null), new v(null, 3, 5, y, [cm, f_, Ck], null)), ee, `Returns a lazy seq of nums from start (inclusive) to end
   (exclusive), by step, where start defaults to 0, step to 1,
   and end to infinity.`, Re, !0, ie, Le], null), null),
  i3e,
  new Ne(function(e) {
    return e != null ? e.C & 268435456 || Rn === e.Wf ? !0 : e.C ? !1 : pl(NY, e) : pl(NY, e);
  }, W8, new $(null, 5, [
    te,
    W8,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null)),
    ee,
    "Returns true if coll satisfies ISorted",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(LL, S9, new $(null, 5, [te, S9, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `Returns a map from distinct items in coll to the number of times
  they appear.`, Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return (e = z(e)) ? new h2(null, e, null, e, null) : fl;
  }, pM, new $(null, 5, [te, pM, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Returns a lazy (infinite!) sequence of repetitions of the items in coll.", Re, !0, ie, Le], null), null),
  new Ne(Bf, bP, new $(null, 6, [te, bP, hl, Bf, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [
    Sn,
    al
  ], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, "Returns the greatest of the nums.", Re, !0, ie, Le], null), null),
  new Ne(b3, yM, new $(null, 5, [te, yM, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x is a symbol without a namespace", Re, !0, ie, Le], null), null),
  Nl(OP, pT, Le, !0, new $(
    null,
    3,
    [te, OP, ne, ue(new v(null, 2, 5, y, [et, Wk], null)), ee, `reify creates an object implementing a protocol.
  reify is a macro with the following structure:

 (reify options* specs*)

  Currently there are no options.

  Each spec consists of the protocol name followed by zero
  or more method bodies:

  protocol
  (methodName [args+] body)*

  Methods should be supplied for all methods of the desired
  protocol(s). You can also define overrides for Object methods. Note that
  the first parameter must be supplied to correspond to the target object
  ('this' in JavaScript parlance). Note also that recur calls
  to the method head should *not* pass the target object, it will be supplied
  automatically and can not be substituted.

  recur works to method heads The method bodies of reify are lexical
  closures, and can refer to the surrounding local scope:

  (str (let [f "foo"]
       (reify Object
         (toString [this] f))))
  == "foo"

  (seq (let [f "foo"]
       (reify ISeqable
         (-seq [this] (seq f)))))
  == ("f" "o" "o"))

  reify always implements IMeta and IWithMeta and transfers meta
  data of the form to the created object.

  (meta ^{:k :v} (reify Object (toString [this] "foo")))
  == {:k :v}`],
    null
  )),
  new Ne(Ca, TN, new $(null, 5, [te, TN, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `Returns true if coll has no items - same as (not (seq coll)).
  Please use the idiom (seq x) rather than (not (empty? x))`, Re, !0, ie, Le], null), null),
  new Ne(lr, yN, new $(null, 5, [te, yN, ne, ue(Dt, new v(null, 1, 5, y, [$6], null), new v(null, 2, 5, y, [$6, Nq], null), new v(null, 3, 5, y, [$6, ov, Nq], null)), ee, `Returns a new coll consisting of to-coll with all of the items of
  from-coll conjoined. A transducer may be supplied.`, Re, !0, ie, Le], null), null),
  new Ne(
    za,
    E$,
    new $(null, 5, [te, E$, ne, ue(new v(null, 1, 5, y, [Tr], null)), ee, "Returns true if n is a JavaScript number with no decimal part.", Re, !0, ie, Le], null),
    null
  ),
  new Ne(mp, m8, new $(null, 6, [te, m8, hl, mp, ne, ue(Dt, new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, "Returns the product of nums. (*) returns 1.", Re, !0, ie, Le], null), null),
  Nl(mM, DT, null, null, new $(
    null,
    3,
    [te, mM, ne, ue(new v(null, 3, 5, y, [Vd, et, Tv], null)), ee, `When expr is not nil, threads it into the first form (via ->>),
  and when that result is not nil, through the next etc`],
    null
  )),
  new Ne(vU, ZC, new $(null, 6, [te, ZC, hl, vU, ne, ue(new v(null, 2, 5, y, [Sn, Tr], null)), ee, "Bitwise shift right with zero fill", Re, !0, ie, Le], null), null),
  new Ne(sT, mC, new $(null, 5, [te, mC, ne, ue(new v(null, 2, 5, y, [et, W0], null)), ee, "pr to a string, returning it. Fundamental entrypoint to IPrintWithWriter.", Re, !0, ie, Le], null), null),
  Nl(e9, AT, null, null, new $(
    null,
    3,
    [te, e9, ne, ue(new v(null, 3, 5, y, [Vd, et, Tv], null)), ee, `When expr is not nil, threads it into the first form (via ->),
  and when that result is not nil, through the next etc`],
    null
  )),
  Nl(KC, GT, null, null, new $(null, 3, [te, KC, ne, null, ee, null], null)),
  new Ne(mo, yE, new $(null, 5, [te, yE, ne, ue(new v(null, 1, 5, y, [qo], null)), ee, null, Re, !0, ie, Le], null), null),
  Nl(zM, ET, null, null, new $(null, 3, [te, zM, ne, ue(new v(null, 2, 5, y, [et, z_], null)), ee, `Takes a set of test/expr pairs. It evaluates each test one at a
  time.  If a test returns logical true, cond evaluates and returns
  the value of the corresponding expr and doesn't evaluate any of the
  other tests or exprs. (cond) returns nil.`], null)),
  new Ne(
    ob,
    m7,
    new $(null, 5, [te, m7, ne, ue(Dt, new v(null, 1, 5, y, [Bt], null)), ee, `Returns a lazy sequence of the elements of coll with duplicates removed.
  Returns a stateful transducer when no collection is provided.`, Re, !0, ie, Le], null),
    null
  ),
  new Ne(cK, T9, new $(null, 5, [te, T9, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "If x is already reduced?, returns it, else returns (reduced x)", Re, !0, ie, Le], null), null),
  new Ne(Gl, fR, new $(null, 6, [
    te,
    fR,
    hl,
    Gl,
    ne,
    ue(new v(null, 1, 5, y, [SE], null), new v(null, 2, 5, y, [rw, EE], null)),
    ee,
    `Creates an array of objects. Does not coerce array, provided for compatibility
  with Clojure.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Yf, fN, new $(null, 5, [te, fN, ne, ue(new v(null, 1, 5, y, [il], null), new v(null, 2, 5, y, [il, h_], null), new v(null, 3, 5, y, [il, h_, Bd], null), new v(null, 5, 5, y, [il, h_, Bd, et, iH], null)), ee, `Takes a set of functions and returns a fn that is the juxtaposition
  of those fns.  The returned fn takes a variable number of args, and
  returns a vector containing the result of applying each fn to the
  args (left-to-right).
  ((juxt a b c) x) => [(a x) (b x) (c x)]`, Re, !0, ie, Le], null), null),
  new Ne(fu, FP, new $(null, 5, [te, FP, ne, ue(new v(null, 2, 5, y, [ws, Bt], null)), ee, `Returns the first logical true value of (pred x) for any x in coll,
  else nil.  One common idiom is to use a set as pred, for example
  this will return :fred if :fred is in the sequence, otherwise nil:
  (some #{:fred} coll)`, Re, !0, ie, Le], null), null),
  Nl(h$, ej, null, null, new $(
    null,
    3,
    [te, h$, ne, ue(new v(null, 3, 5, y, [th, et, ys], null)), ee, `binding => binding-form init-expr
  binding-form => name, or destructuring-form
  destructuring-form => map-destructure-form, or seq-destructure-form

  Evaluates the exprs in a lexical context in which the symbols in
  the binding-forms are bound to their respective init-exprs or parts
  therein.

  See https://clojure.org/reference/special_forms#binding-forms for
  more information about destructuring.`],
    null
  )),
  new Ne(rd, hP, new $(null, 5, [te, hP, ne, ue(new v(null, 1, 5, y, [nW], null), new v(null, 2, 5, y, [nW, Bt], null)), ee, `Returns a lazy seq of the elements of coll separated by sep.
  Returns a stateful transducer when no collection is provided.`, Re, !0, ie, Le], null), null),
  new Ne($c, CM, new $(null, 5, [te, CM, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(function(e, n) {
    return e instanceof v2 ? n != null && Rn === n.pd ? on.g(e, n.type) : on.g(e, zi.h(Vt(n))) : ci(e) ? nq(e, n) : n instanceof e;
  }, H7, new $(null, 5, [
    te,
    H7,
    ne,
    ue(new v(null, 2, 5, y, [Ld, Sn], null)),
    ee,
    `Evaluates x and tests if it is an instance of the type
  c. Returns true or false`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(
    Ub,
    H9,
    new $(null, 5, [te, H9, ne, ue(new v(null, 1, 5, y, [lh], null), new v(null, 2, 5, y, [Bd, lh], null)), ee, `Returns the immediate and indirect children of tag, through a
  relationship established via derive. h must be a hierarchy obtained
  from make-hierarchy, if not supplied defaults to the global
  hierarchy. Note: does not work on JavaScript type inheritance
  relationships.`, Re, !0, ie, Le], null),
    !0
  ),
  new Ne(xr, j8, new $(null, 5, [te, j8, ne, ue(new v(null, 2, 5, y, [Ao, Oc], null), new v(null, 3, 5, y, [Ao, Oc, a6], null)), ee, `Returns the value in a nested associative structure,
  where ks is a sequence of keys. Returns nil if the key is not present,
  or the not-found value if supplied.`, Re, !0, ie, Le], null), null),
  Nl(Kx, Jb, null, null, new $(
    null,
    3,
    [te, Kx, ne, ue(new v(null, 2, 5, y, [et, dye], null)), ee, `params => positional-params* , or positional-params* & next-param
  positional-param => binding-form
  next-param => binding-form
  name => symbol

  Defines a function`],
    null
  )),
  new Ne(Vt, Dx, new $(null, 5, [te, Dx, ne, ue(new v(null, 1, 5, y, [bv], null)), ee, "Returns the metadata of obj, returns nil if there is no metadata.", Re, !0, ie, Le], null), null),
  O_(ene, function(e, n, t, l) {
    return e = Us(t), new Z4(l, e);
  }, Le),
  Nl(RR, Qb, Le, !0, new $(
    null,
    3,
    [te, RR, ne, ue(new v(null, 4, 5, y, [uye, gJ, et, Wk], null)), ee, `(defrecord name [fields*]  options* specs*)

  Currently there are no options.

  Each spec consists of a protocol or interface name followed by zero
  or more method bodies:

  protocol-or-Object
  (methodName [args*] body)*

  The record will have the (immutable) fields named by
  fields, which can have type hints. Protocols and methods
  are optional. The only methods that can be supplied are those
  declared in the protocols.  Note that method bodies are
  not closures, the local environment includes only the named fields,
  and those fields can be accessed directly.

  Method definitions take the form:

  (methodname [args*] body)

  The argument and return types can be hinted on the arg and
  methodname symbols. If not supplied, they will be inferred, so type
  hints should be reserved for disambiguation.

  Methods should be supplied for all methods of the desired
  protocol(s). You can also define overrides for
  methods of Object. Note that a parameter must be supplied to
  correspond to the target object ('this' in JavaScript parlance). Note also
  that recur calls to the method head should *not* pass the target object, it
  will be supplied automatically and can not be substituted.

  In the method bodies, the (unqualified) name can be used to name the
  class (for calls to new, instance? etc).

  The type will have implementations of several ClojureScript
  protocol generated automatically: IMeta/IWithMeta (metadata support) and
  IMap, etc.

  In addition, defrecord will define type-and-value-based =,
  and will define ClojureScript IHash and IEquiv.

  Two constructors will be defined, one taking the designated fields
  followed by a metadata map (nil for none) and an extension field
  map (nil for none), and one taking only the fields (using nil for
  meta and extension fields). Note that the field names __meta
  and __extmap are currently reserved and should not be used when
  defining your own records.

  Given (defrecord TypeName ...), two factory functions will be
  defined: ->TypeName, taking positional parameters for the fields,
  and map->TypeName, taking a map of keywords to field values.`],
    null
  )),
  new Ne(Ho, rh, new $(null, 5, [te, rh, ne, ue(new v(null, 1, 5, y, [xH], null)), ee, "Returns the value in the map entry.", Re, !0, ie, Le], null), null),
  new Ne(dT, Ow, new $(null, 5, [te, Ow, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(ki, _$, new $(null, 6, [te, _$, hl, ki, ne, ue(new v(null, 1, 5, y, [sve], null)), ee, "Returns a javascript array, cloned from the passed in array", Re, !0, ie, Le], null), null),
  new Ne(xs, YI, new $(null, 5, [
    te,
    YI,
    ne,
    ue(new v(null, 3, 5, y, [Ao, new v(null, 3, 5, y, [cu, et, Oc], null), Md], null)),
    ee,
    `Associates a value in a nested associative structure, where ks is a
  sequence of keys and v is the new value and returns a new nested structure.
  If any levels do not exist, hash-maps will be created.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(_U, i9, new $(null, 6, [te, i9, hl, _U, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if num is zero, else false", Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return ou(e);
  }, O$, new $(null, 5, [te, O$, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Returns a new, transient version of the collection, in constant time.", Re, !0, ie, Le], null), null),
  Nl(sR, CT, null, null, new $(
    null,
    3,
    [te, sR, ne, ue(new v(null, 3, 5, y, [P2e, et, ys], null)), ee, `fnspec ==> (fname [params*] exprs) or (fname ([params*] exprs)+)

  Takes a vector of function specs and a body, and generates a set of
  bindings of functions to their names. All of the names are available
  in all of the definitions of the functions, as well as the body.`],
    null
  )),
  new Ne(function(e) {
    return QD(e);
  }, EM, new $(null, 5, [te, EM, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if a value has been produced for a delay or lazy sequence.", Re, !0, ie, Le], null), null),
  new Ne(us, y7, new $(null, 5, [
    te,
    y7,
    ne,
    ue(new v(null, 1, 5, y, [Gs], null), new v(null, 2, 5, y, [Vl, Gs], null), new v(null, 3, 5, y, [Vl, qo, Gs], null), new v(null, 4, 5, y, [Vl, qo, Ld, Gs], null), new v(null, 6, 5, y, [Vl, qo, Ld, Xs, et, Ai], null)),
    ee,
    `Creates a new list containing the items prepended to the rest, the
  last of which will be treated as a sequence.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne($I, qR, new $(null, 5, [te, qR, ne, ue(new v(null, 1, 5, y, [NS], null)), ee, "Returns a map of the intern mappings for the namespace.", Re, !0, ie, Le], null), !0),
  new Ne(Eh, K8, new $(null, 5, [
    te,
    K8,
    ne,
    ue(new v(null, 1, 5, y, [il], null)),
    ee,
    `Returns a memoized version of a referentially transparent function. The
  memoized version of the function keeps a cache of the mapping from arguments
  to results and, when calls with the same arguments are repeated often, has
  higher performance at the expense of higher memory use.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(ab, hC, new $(null, 5, [te, hC, ne, ue(new v(null, 3, 5, y, [FS, xf, Wa], null), new v(null, 5, 5, y, [FS, pH, $q, qq, Lq], null)), ee, `sc must be a sorted collection, test(s) one of <, <=, > or
  >=. Returns a seq of those entries with keys ek for
  which (test (.. sc comparator (compare ek key)) 0) is true`, Re, !0, ie, Le], null), null),
  new Ne(jU, qN, new $(null, 5, [te, qN, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "returns true if x is a Delay created with delay", Re, !0, ie, Le], null), null),
  new Ne(
    Zw,
    f7,
    new $(null, 5, [te, f7, ne, ue(new v(null, 1, 5, y, [il], null), new v(null, 2, 5, y, [il, qye], null)), ee, `Takes a reducing function f of 2 args and returns a fn suitable for
  transduce by adding an arity-1 signature that calls cf (default -
  identity) on the result argument.`, Re, !0, ie, Le], null),
    null
  ),
  new Ne(Gm, R$, new $(null, 6, [
    te,
    R$,
    hl,
    Gm,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)),
    ee,
    `If no denominators are supplied, returns 1/numerator,
  else returns numerator divided by all of the denominators.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(function(e) {
    e = Sc.h ? Sc.h(e) : Sc.call(null, e);
    const n = Math.random;
    for (let t = e.length - 1; 0 < t; t--) {
      const l = Math.floor(n() * (t + 1)), r = e[t];
      e[t] = e[l], e[l] = r;
    }
    return Et.h ? Et.h(e) : Et.call(null, e);
  }, mP, new $(null, 5, [te, mP, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Return a random permutation of coll", Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    return gr.l(Te([$I(e, n), UG(e, n), cq(e, n)]));
  }, V7, new $(null, 5, [te, V7, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(aT, $9, new $(null, 5, [te, $9, ne, ue(new v(
    null,
    2,
    5,
    y,
    [et, W0],
    null
  )), ee, "Same as pr-str followed by (newline)", Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    return kG(e, n, Tt);
  }, r4, new $(null, 5, [te, r4, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  Nl(u7, LT, null, null, new $(null, 3, [te, u7, ne, ue(new v(null, 3, 5, y, [oo, et, pye], null)), ee, "same as defn, yielding non-public def"], null)),
  new Ne(function(e, n, t) {
    return on.g(e.jb(null), n) ? (Qa(e, t), !0) : !1;
  }, r9, new $(null, 5, [
    te,
    r9,
    ne,
    ue(new v(null, 3, 5, y, [Bl(Vl, new $(null, 1, [Ft, zZ], null)), j1e, Oee], null)),
    ee,
    `Atomically sets the value of atom to newval if and only if the
  current value of the atom is equal to oldval. Returns true if
  set happened, else false.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(UT, e4, new $(null, 5, [te, e4, ne, ue(new v(null, 2, 5, y, [et, Gs], null)), ee, `Like require, but referring vars specified by the mandatory
  :only option.

  Example:

  The following would load the library clojure.set while referring
  the intersection var.

  (use '[clojure.set :only [intersection]])`, Re, !0, ie, Le], null), !0),
  new Ne(pU, BP, new $(null, 6, [te, BP, hl, pU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    return e = Or.h(e), wr.l(e, Ri, Il, nr, Te([n])), null;
  }, aN, new $(null, 5, [te, aN, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(rU, C9, new $(null, 6, [te, C9, hl, rU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Coerce to int by stripping decimal places.", Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    for (var t = e; ; ) if (e = 0 < n && z(t)) --n, t = e = tn(e);
    else return t;
  }, $7, new $(null, 5, [te, $7, ne, ue(new v(null, 2, 5, y, [Bt, Tr], null)), ee, "Returns the nth rest of coll, coll when n is 0.", Re, !0, ie, Le], null), null),
  new Ne(ZT, O9, new $(null, 5, [te, O9, ne, null, ee, null, Re, !0, ie, Le], null), null),
  k3e,
  new Ne(
    dU,
    k8,
    new $(null, 6, [te, k8, hl, dU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null),
    null
  ),
  new Ne(function(e) {
    return jU(e) ? sn(e) : e;
  }, eC, new $(null, 5, [te, eC, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "If x is a Delay, returns the (possibly cached) value of its expression, else returns x", Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    return vI(e, n);
  }, p9, new $(null, 5, [te, p9, ne, ue(new v(null, 2, 5, y, [iw, XM], null)), ee, "Removes the method of multimethod associated with dispatch-value.", Re, !0, ie, Le], null), null),
  new Ne(function() {
    if (typeof performance < "u" && performance.now != null) return performance.now();
    if (typeof process < "u" && process.hrtime != null) {
      var e = process.hrtime();
      return (1e9 * e[0] + e[1]) / 1e6;
    }
    return (/* @__PURE__ */ new Date()).getTime();
  }, YR, new $(null, 5, [te, YR, ne, ue(Dt), ee, "Returns highest resolution time offered by host in milliseconds.", Re, !0, ie, Le], null), null),
  new Ne(Kb, NC, new $(null, 5, [te, NC, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(va, dR, new $(null, 5, [te, dR, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Same as (next (next x))", Re, !0, ie, Le], null), null),
  new Ne(FY, yP, new $(null, 6, [te, yP, hl, FY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns a number one less than num.", Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    var n = e instanceof de;
    return n ? (e = Yi(e), e = j(e) ? !0 : e) : e = n, pu(e);
  }, MM, new $(null, 5, [te, MM, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x is a keyword with a namespace", Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return function(n, t) {
      return j(e.g ? e.g(n, t) : e.call(null, n, t)) ? -1 : j(e.g ? e.g(t, n) : e.call(null, t, n)) ? 1 : 0;
    };
  }, j_, new $(null, 5, [te, j_, ne, ue(new v(
    null,
    1,
    5,
    y,
    [ws],
    null
  )), ee, "Returns an JavaScript compatible comparator based upon pred.", Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    var t = z(n);
    for (e = z(uu.g(e, n)); ; ) if (e) t = W(t), e = W(e);
    else return t;
  }, zR, new $(null, 5, [te, zR, ne, ue(new v(null, 2, 5, y, [Tr, Bt], null)), ee, `Returns a seq of the last n items in coll.  Depending on the type
  of coll may be no better than linear time.  For vectors, see also subvec.`, Re, !0, ie, Le], null), null),
  new Ne(VG, QC, new $(null, 5, [
    te,
    QC,
    ne,
    ue(new v(null, 1, 5, y, [ih], null)),
    ee,
    `Returns the namespace named by the symbol or nil if it doesn't exist.
  Bootstrap only.`,
    Re,
    !0,
    ie,
    Le
  ], null), !0),
  new Ne(function(e) {
    return $t(e) === "string";
  }, gP, new $(null, 5, [te, gP, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x is a JavaScript string.", Re, !0, ie, Le], null), null),
  new Ne(cT, zk, new $(null, 5, [te, zk, ne, null, ee, `Prints the object(s) using string-print.
  print and println produce output for human consumption.`, Re, !0, ie, Le], null), null),
  gF,
  new Ne(Xw, l8, new $(
    null,
    6,
    [te, l8, hl, Xw, ne, ue(new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, "Bitwise exclusive or", Re, !0, ie, Le],
    null
  ), null),
  new Ne(bt, o1, new $(null, 5, [
    te,
    o1,
    ne,
    ue(new v(null, 1, 5, y, [il], null), new v(null, 2, 5, y, [il, Bt], null), new v(null, 3, 5, y, [il, Rd, rm], null), new v(null, 4, 5, y, [il, Rd, rm, YS], null), new v(null, 6, 5, y, [il, Rd, rm, YS, et, mv], null)),
    ee,
    `Returns a lazy sequence consisting of the result of applying f to
  the set of first items of each coll, followed by applying f to the
  set of second items in each coll, until any one of the colls is
  exhausted.  Any remaining items in other colls are ignored. Function
  f should accept number-of-colls arguments. Returns a transducer when
  no collection is provided.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(UY, BR, new $(null, 6, [te, BR, hl, UY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(T3, $8, new $(null, 5, [te, $8, ne, ue(new v(null, 2, 5, y, [qo, Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return e instanceof Wc || e != null && (e.C & 32768 || Rn === e.Ke) ? sn(e) : Zy.h(e);
  }, Pk, new $(null, 5, [
    te,
    Pk,
    ne,
    ue(new v(null, 1, 5, y, [bv], null)),
    ee,
    `Also reader macro: @var/@atom/@delay. Returns the
   most-recently-committed value of ref. When applied to a var
   or atom, returns its current state. When applied to a delay, forces
   it if not already forced. See also - realized?.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(_1, b8, new $(null, 5, [te, b8, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, "Returns an instance of RegExp which has compiled the provided string.", Re, !0, ie, Le], null), null),
  new Ne(sa, p8, new $(null, 5, [te, p8, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Tr, Sn], null)), ee, "Returns a lazy (infinite!, or length n if supplied) sequence of xs.", Re, !0, ie, Le], null), null),
  new Ne(wt, GP, new $(null, 5, [
    te,
    GP,
    ne,
    ue(new v(null, 2, 5, y, [il, Bt], null), new v(null, 3, 5, y, [il, rh, Bt], null)),
    ee,
    `f should be a function of 2 arguments. If val is not supplied,
  returns the result of applying f to the first 2 items in coll, then
  applying f to that result and the 3rd item, etc. If coll contains no
  items, f must accept no arguments as well, and reduce returns the
  result of calling f with no arguments.  If coll has only 1 item, it
  is returned and f is not called.  If val is supplied, returns the
  result of applying f to val and the first item in coll, then
  applying f to that result and the 2nd item, etc. If coll contains no
  items, returns val and f is not called.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(iE, uR, new $(null, 5, [te, uR, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x is a symbol with a namespace", Re, !0, ie, Le], null), null),
  new Ne(NI, Zk, new $(null, 5, [te, Zk, ne, ue(new v(null, 1, 5, y, [Hd], null)), ee, `Evaluates the form data structure (not text!) and returns the result.
  Delegates to cljs.core/*eval*. Intended for use in self-hosted ClojureScript,
  which sets up an implementation of cljs.core/*eval* for that environment.`, Re, !0, ie, Le], null), !0),
  new Ne(k2, VN, new $(
    null,
    5,
    [te, VN, ne, ue(new v(null, 2, 5, y, [et, Gs], null)), ee, "Creates a new vector containing the args.", Re, !0, ie, Le],
    null
  ), null),
  new Ne(k1, l$, new $(null, 5, [
    te,
    l$,
    ne,
    ue(new v(null, 1, 5, y, [Bt], null), new v(null, 2, 5, y, [Tr, Bt], null)),
    ee,
    `When lazy sequences are produced via functions that have side
  effects, any effects other than those needed to produce the first
  element in the seq do not occur until the seq is consumed. doall can
  be used to force any effects. Walks through the successive nexts of
  the seq, retains the head and returns it, thus causing the entire
  seq to reside in memory at one time.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(ao, lC, new $(null, 5, [te, lC, ne, ue(new v(null, 3, 5, y, [$h, Wa, rh], null), new v(null, 5, 5, y, [$h, Wa, rh, et, Rq], null)), ee, `When applied to a transient map, adds mapping of key(s) to
  val(s). When applied to a transient vector, sets the val at index.
  Note - index must be <= (count vector). Returns coll.`, Re, !0, ie, Le], null), null),
  new Ne(xa, S7, new $(null, 5, [
    te,
    S7,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)),
    ee,
    "Same as (not (= obj1 obj2))",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(JT, XP, new $(null, 5, [te, XP, ne, ue(new v(null, 4, 5, y, [US, il, et, Gs], null)), ee, `Atomically sets the metadata for a namespace/var/ref/agent/atom to be:

  (apply f its-current-meta args)

  f must be free of side-effects`, Re, !0, ie, Le], null), null),
  new Ne(v1, j7, new $(null, 5, [te, j7, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns a function that takes any number of arguments and returns x.", Re, !0, ie, Le], null), null),
  new Ne(ei, k7, new $(null, 5, [
    te,
    k7,
    ne,
    ue(new v(null, 1, 5, y, [Sr], null)),
    ee,
    "Return true if s satisfies ISeq",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(function(e) {
    return _3(e);
  }, kN, new $(null, 5, [te, kN, ne, ue(new v(null, 1, 5, y, [sm], null)), ee, "Return the JavaScript keys for an object.", Re, !0, ie, Le], null), null),
  new Ne(en, Nk, new $(null, 6, [te, Nk, hl, en, ne, ue(new v(null, 2, 5, y, [bv, cu], null), new v(null, 3, 5, y, [bv, cu, a6], null)), ee, `Returns the value mapped to key, not-found or nil if key not present
  in associative collection, set, string, array, or ILookup instance.`, Re, !0, ie, Le], null), null),
  new Ne(t3, t4, new $(null, 5, [
    te,
    t4,
    ne,
    ue(new v(
      null,
      2,
      5,
      y,
      [et, Gs],
      null
    )),
    ee,
    `Loads libs, skipping any that are already loaded. Each argument is
  either a libspec that identifies a lib or a flag that modifies how all the identified
  libs are loaded. Use :require in the ns macro in preference to calling this
  directly.

  Libs

  A 'lib' is a named set of resources in classpath whose contents define a
  library of ClojureScript code. Lib names are symbols and each lib is associated
  with a ClojureScript namespace. A lib's name also locates its root directory
  within classpath using Java's package name to classpath-relative path mapping.
  All resources in a lib should be contained in the directory structure under its
  root directory. All definitions a lib makes should be in its associated namespace.

  'require loads a lib by loading its root resource. The root resource path
  is derived from the lib name in the following manner:
  Consider a lib named by the symbol 'x.y.z; it has the root directory
  <classpath>/x/y/, and its root resource is <classpath>/x/y/z.clj. The root
  resource should contain code to create the lib's namespace (usually by using
  the ns macro) and load any additional lib resources.

  Libspecs

  A libspec is a lib name or a vector containing a lib name followed by
  options expressed as sequential keywords and arguments.

  Recognized options:
  :as takes a symbol as its argument and makes that symbol an alias to the
    lib's namespace in the current namespace.
  :refer takes a list of symbols to refer from the namespace.
  :refer-macros takes a list of macro symbols to refer from the namespace.
  :include-macros true causes macros from the namespace to be required.
  :rename specifies a map from referred var names to different
    symbols (and can be used to prevent clashes)


  Flags

  A flag is a keyword.
  Recognized flags: :reload, :reload-all, :verbose
  :reload forces loading of all the identified libs even if they are
    already loaded
  :reload-all implies :reload and also forces loading of all libs that the
    identified libs directly or indirectly load via require or use
  :verbose triggers printing information about each load, alias, and refer

  Example:

  The following would load the library clojure.string :as string.

  (require '[clojure.string :as string])`,
    Re,
    !0,
    ie,
    Le
  ], null), !0),
  new Ne(Zu, Wa, new $(null, 5, [te, Wa, ne, ue(new v(null, 1, 5, y, [xH], null)), ee, "Returns the key of the map entry.", Re, !0, ie, Le], null), null),
  new Ne(e1, LP, new $(null, 6, [te, LP, hl, e1, ne, ue(new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, "Bitwise and with complement", Re, !0, ie, Le], null), null),
  new Ne(na, JP, new $(null, 5, [
    te,
    JP,
    ne,
    ue(new v(null, 1, 5, y, [il], null), new v(null, 3, 5, y, [il, et, mv], null)),
    ee,
    `Returns the result of applying concat to the result of applying map
  to f and colls.  Thus function f should return a collection. Returns
  a transducer when no collections are provided`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nl(S8, OT, null, null, new $(null, 3, [te, S8, ne, ue(new v(null, 3, 5, y, [Vd, et, z_], null)), ee, `Takes an expression and a set of test/form pairs. Threads expr (via ->)
  through each form for which the corresponding test
  expression is true. Note that, unlike cond branching, cond-> threading does
  not short circuit after the first true test expression.`], null)),
  new Ne(mK, EC, new $(null, 5, [
    te,
    EC,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null)),
    ee,
    "Return true if x satisfies int? and is a natural integer value.",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(zK, uP, new $(null, 5, [te, uP, ne, ue(new v(null, 1, 5, y, [oo], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(HK, m9, new $(null, 5, [te, m9, ne, ue(new v(null, 2, 5, y, [iw, XM], null)), ee, `Given a multimethod and a dispatch value, returns the dispatch fn
  that would apply to that value, or nil if none apply and no default`, Re, !0, ie, Le], null), null),
  K$,
  new Ne(ye, IN, new $(null, 5, [
    te,
    IN,
    ne,
    ue(Dt, new v(null, 1, 5, y, [Sn], null), new v(null, 3, 5, y, [Sn, et, aye], null)),
    ee,
    `With no args, returns the empty string. With one arg x, returns
  x.toString().  (str nil) returns the empty string. With more than
  one arg, returns the concatenation of the str values of the args.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(O3, h8, new $(null, 5, [te, h8, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Returns an empty collection of the same category as coll, or nil", Re, !0, ie, Le], null), null),
  new Ne(ix, W9, new $(null, 5, [te, W9, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if coll implements count in constant time", Re, !0, ie, Le], null), null),
  new Ne(ug, uC, new $(null, 5, [te, uC, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x satisfies ISet", Re, !0, ie, Le], null), null),
  new Ne(yY, dN, new $(null, 6, [te, dN, hl, yY, ne, ue(new v(
    null,
    1,
    5,
    y,
    [$d],
    null
  )), ee, "Returns the length of the array. Works on arrays of all types.", Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    return gu(wt.j(function(t, l) {
      return j(e.h ? e.h(l) : e.call(null, l)) ? to.g(t, l) : t;
    }, ou(Dt), n));
  }, KI, new $(null, 5, [te, KI, ne, ue(new v(null, 2, 5, y, [ws, Bt], null)), ee, `Returns a vector of the items in coll for which
  (pred item) returns logical true. pred must be free of side-effects.`, Re, !0, ie, Le], null), null),
  new Ne(ww, oC, new $(null, 5, [te, oC, ne, ue(new v(null, 2, 5, y, [il, Bt], null), new v(
    null,
    3,
    5,
    y,
    [il, T_, Bt],
    null
  )), ee, `Returns a lazy seq of the intermediate values of the reduction (as
  per reduce) of coll by f, starting with init.`, Re, !0, ie, Le], null), null),
  new Ne(sU, E8, new $(null, 6, [te, E8, hl, sU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(qm, A8, new $(
    null,
    6,
    [te, A8, hl, qm, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, `Returns non-nil if nums are in monotonically increasing order,
  otherwise false.`, Re, !0, ie, Le],
    null
  ), null),
  new Ne(xh, bR, new $(null, 5, [te, bR, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Wraps x in a way such that a reduce will terminate with the value x", Re, !0, ie, Le], null), null),
  new Ne(Sx, PC, new $(null, 5, [
    te,
    PC,
    ne,
    ue(new v(null, 1, 5, y, [ws], null), new v(null, 2, 5, y, [ws, l1e], null)),
    ee,
    `Returns a transducer that ends transduction when pred returns true
  for an input. When retf is supplied it must be a fn of 2 arguments -
  it will be passed the (completed) result so far and the input that
  triggered the predicate, and its return value (if it does not throw
  an exception) will be the return value of the transducer. If retf
  is not supplied, the input that triggered the predicate will be
  returned. If the predicate never returns true the transduction is
  unaffected.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Yi, c$, new $(null, 5, [te, c$, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns the namespace String of a symbol or keyword, or nil if not present.", Re, !0, ie, Le], null), null),
  new Ne(ts, UC, new $(null, 5, [te, UC, ne, ue(new v(null, 1, 5, y, [oo], null), new v(null, 2, 5, y, [ih, oo], null)), ee, `Returns a Keyword with the given namespace and name.  Do not use :
  in the keyword strings, it will be added automatically.`, Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    var n = Jde();
    return function() {
      function t(r) {
        var u = null;
        if (0 < arguments.length) {
          u = 0;
          for (var o = Array(arguments.length - 0); u < o.length; ) o[u] = arguments[u + 0], ++u;
          u = new hn(o, 0, null);
        }
        return l.call(this, u);
      }
      function l(r) {
        return In.B(l3, n, e, r);
      }
      return t.m = 0, t.v = function(r) {
        return r = z(r), l(r);
      }, t.l = l, t;
    }();
  }, a8, new $(null, 5, [te, a8, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(Ap, fM, new $(null, 5, [te, fM, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x satisfies IRecord", Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return e instanceof JO;
  }, xM, new $(null, 5, [te, xM, ne, ue(new v(
    null,
    1,
    5,
    y,
    [k_],
    null
  )), ee, "Return true if the value is the data representation of a tagged literal", Re, !0, ie, Le], null), null),
  new Ne(Lc, w8, new $(null, 6, [te, w8, hl, Lc, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, `If no ys are supplied, returns the negation of x, else subtracts
  the ys from x and returns the result.`, Re, !0, ie, Le], null), null),
  new Ne(Qw, fP, new $(null, 6, [
    te,
    fP,
    hl,
    Qw,
    ne,
    ue(new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)),
    ee,
    "Bitwise and",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(S3, gR, new $(null, 5, [te, gR, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "If x is reduced?, returns (deref x), else returns x", Re, !0, ie, Le], null), null),
  new Ne(Dn, d$, new $(null, 5, [
    te,
    d$,
    ne,
    ue(new v(null, 3, 5, y, [Bt, cu, Md], null), new v(null, 5, 5, y, [Bt, cu, Md, et, Rq], null)),
    ee,
    `assoc[iate]. When applied to a map, returns a new map of the
   same (hashed/sorted) type, that contains the mapping of key(s) to
   val(s). When applied to a vector, returns a new vector that
   contains val at index. Note - index must be <= (count vector).`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nl(dM, Wb, Le, !0, new $(null, 3, [te, dM, ne, ue(new v(null, 6, 5, y, [oo, Rwe, Sw, Awe, et, mW], null)), ee, `Creates a new multimethod with the associated dispatch function.
  The docstring and attribute-map are optional.

  Options are key-value pairs and may be one of:
    :default    the default dispatch value, defaults to :default
    :hierarchy  the isa? hierarchy to use for dispatching
                defaults to the global hierarchy`], null)),
  new Ne(t1, u9, new $(null, 5, [te, u9, ne, ue(new v(
    null,
    1,
    5,
    y,
    [Tr],
    null
  ), new v(null, 2, 5, y, [Tr, Bt], null), new v(null, 3, 5, y, [Tr, Ck, Bt], null)), ee, `Returns a lazy sequence of lists like partition, but may include
  partitions with fewer than n items at the end.  Returns a stateful
  transducer when no collection is provided.`, Re, !0, ie, Le], null), null),
  new Ne(mU, WN, new $(null, 6, [te, WN, hl, mU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Bitwise complement", Re, !0, ie, Le], null), null),
  new Ne(nK, o$, new $(null, 5, [
    te,
    o$,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null)),
    ee,
    "Returns true if x is not nil, false otherwise.",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(yU, UR, new $(null, 6, [te, UR, hl, yU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if num is greater than zero, else false", Re, !0, ie, Le], null), null),
  new Ne($y, zC, new $(null, 5, [
    te,
    zC,
    ne,
    ue(new v(null, 1, 5, y, [il], null), new v(null, 3, 5, y, [il, et, Gs], null)),
    ee,
    `trampoline can be used to convert algorithms requiring mutual
  recursion without stack consumption. Calls f with supplied args, if
  any. If f returns a fn, calls that fn with no arguments, and
  continues to repeat, until the return value is not a fn, then
  returns that non-fn value. Note that if you want to return a fn as a
  final value, you must wrap it in some data structure and unpack it
  after trampoline returns.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Wh, A9, new $(null, 5, [te, A9, ne, ue(Dt, new v(null, 1, 5, y, [Tr], null)), ee, `Returns a random floating point number between 0 (inclusive) and
  n (default 1) (exclusive).`, Re, !0, ie, Le], null), null),
  new Ne(L4, h7, new $(null, 5, [te, h7, ne, ue(new v(null, 2, 5, y, [W_, Sr], null)), ee, "Returns the result of (re-find re s) if re fully matches s.", Re, !0, ie, Le], null), null),
  new Ne(SL, v8, new $(null, 5, [te, v8, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x is a Boolean", Re, !0, ie, Le], null), null),
  new Ne(mf, pC, new $(
    null,
    5,
    [
      te,
      pC,
      ne,
      ue(new v(null, 1, 5, y, [O8], null), new v(null, 2, 5, y, [cv, hv], null), new v(null, 3, 5, y, [cv, hv, BS], null), new v(null, 5, 5, y, [cv, hv, BS, et, BW], null)),
      ee,
      `Takes a set of predicates and returns a function f that returns true if all of its
  composing predicates return a logical true value against all of its arguments, else it returns
  false. Note that f is short-circuiting in that it will stop execution on the first
  argument that triggers a logical false result against the original predicates.`,
      Re,
      !0,
      ie,
      Le
    ],
    null
  ), null),
  new Ne(Bw, d9, new $(null, 5, [te, d9, ne, ue(new v(null, 1, 5, y, [il], null)), ee, "Return true if f is a JavaScript function or satisfies the Fn protocol.", Re, !0, ie, Le], null), null),
  new Ne(Fw, J7, new $(null, 5, [te, J7, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if coll satisfies ISequential", Re, !0, ie, Le], null), null),
  new Ne(ue, xC, new $(null, 5, [te, xC, ne, ue(new v(null, 2, 5, y, [et, HW], null)), ee, "Creates a new list containing the items.", Re, !0, ie, Le], null), null),
  new Ne(sb, X8, new $(null, 5, [te, X8, ne, ue(new v(
    null,
    3,
    5,
    y,
    [j_, et, kw],
    null
  )), ee, "Returns a new sorted set with supplied keys, using the supplied comparator.", Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    for (e = z(e); ; ) if (e && 0 < n) --n, e = W(e);
    else return e;
  }, tC, new $(null, 5, [te, tC, ne, ue(new v(null, 2, 5, y, [Bt, Tr], null)), ee, "Returns the nth next of coll, (seq coll) when n is 0.", Re, !0, ie, Le], null), null),
  new Ne(wb, u$, new $(null, 5, [
    te,
    u$,
    ne,
    ue(new v(null, 2, 5, y, [gge, Bt], null)),
    ee,
    `Returns a reducible/iterable application of the transducers
  to the items in coll. Transducers are applied in order as if
  combined with comp. Note that these applications will be
  performed every time reduce/iterator is called.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(function(e) {
    return O.g(e, OS(Cn(e)));
  }, d7, new $(null, 5, [te, d7, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `Return a random element of the (sequential) collection. Will have
  the same performance characteristics as nth for the given
  collection.`, Re, !0, ie, Le], null), null),
  Nl(MC, $T, null, null, new $(
    null,
    3,
    [te, MC, ne, ue(new v(null, 2, 5, y, [et, ys], null)), ee, `Takes a body of expressions and yields a Delay object that will
  invoke the body only the first time it is forced (with force or deref/@), and
  will cache the result and return it on all subsequent force
  calls.`],
    null
  )),
  new Ne(go, z8, new $(null, 5, [te, z8, ne, ue(new v(null, 1, 5, y, [il], null), new v(null, 2, 5, y, [il, VS], null), new v(null, 3, 5, y, [il, VS, P6], null), new v(null, 4, 5, y, [il, VS, P6, YW], null), new v(null, 6, 5, y, [il, VS, P6, YW, et, Ai], null)), ee, `Takes a function f and fewer than the normal arguments to f, and
  returns a fn that takes a variable number of additional args. When
  called, the returned function calls f with args + additional args.`, Re, !0, ie, Le], null), null),
  Nl(ON, zT, null, null, new $(
    null,
    3,
    [te, ON, ne, null, ee, null],
    null
  )),
  new Ne(cb, aC, new $(null, 5, [te, aC, ne, ue(new v(null, 3, 5, y, [FS, xf, Wa], null), new v(null, 5, 5, y, [FS, pH, $q, qq, Lq], null)), ee, `sc must be a sorted collection, test(s) one of <, <=, > or
  >=. Returns a reverse seq of those entries with keys ek for
  which (test (.. sc comparator (compare ek key)) 0) is true`, Re, !0, ie, Le], null), null),
  new Ne(Ol, SN, new $(null, 5, [
    te,
    SN,
    ne,
    ue(new v(null, 2, 5, y, [Bt, Md], null)),
    ee,
    `Returns true if key is present in the given collection, otherwise
  returns false.  Note that for numerically indexed collections like
  vectors and arrays, this tests if the numeric key is within the
  range of indexes. 'contains?' operates constant or logarithmic time;
  it will not perform a linear search for a value.  See also 'some'.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nl(oR, mT, null, null, new $(null, 3, [te, oR, ne, ue(new v(null, 3, 5, y, [Sn, et, Tv], null)), ee, `Threads the expr through the forms. Inserts x as the
  second item in the first form, making a list of it if it is not a
  list already. If there are more forms, inserts the first form as the
  second item in second form, etc.`], null)),
  new Ne(cU, f8, new $(null, 6, [te, f8, hl, cU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(function() {
    function e() {
      return OS(16).toString(16);
    }
    var n = (8 | 3 & OS(16)).toString(16);
    return new L3([ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), "-", ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), "-4", ye.h(e()), ye.h(e()), ye.h(e()), "-", ye.h(n), ye.h(e()), ye.h(e()), ye.h(e()), "-", ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e()), ye.h(e())].join("").toLowerCase());
  }, X7, new $(null, 5, [te, X7, ne, ue(Dt), ee, "Returns a pseudo-randomly generated UUID instance (i.e. type 4).", Re, !0, ie, Le], null), null),
  w3e,
  Nl(
    X9,
    wT,
    null,
    null,
    new $(null, 3, [te, X9, ne, ue(new v(null, 4, 5, y, [Vd, oo, et, Tv], null)), ee, `Binds name to expr, evaluates the first form in the lexical context
  of that binding, then binds name to that result, repeating for each
  successive form, returning the result of the last form.`], null)
  ),
  new Ne(id, AM, new $(null, 5, [te, AM, ne, ue(Dt, new v(null, 2, 5, y, [et, kw], null)), ee, `Returns a new hash set with supplied keys.  Any equal keys are
  handled as if by repeated uses of conj.`, Re, !0, ie, Le], null), null),
  new Ne(Vu, RP, new $(
    null,
    5,
    [te, RP, ne, ue(Bl(new v(null, 1, 5, y, [Tr], null), new $(null, 1, [hm, new v(null, 1, 5, y, [ue(Fd, Tr)], null)], null)), Bl(new v(null, 2, 5, y, [Tr, Bt], null), new $(null, 1, [hm, new v(null, 1, 5, y, [ue(Fd, Tr)], null)], null))), ee, `Returns a lazy sequence of the first n items in coll, or all items if
  there are fewer than n.  Returns a stateful transducer when
  no collection is provided.`, Re, !0, ie, Le],
    null
  ), null),
  Nl(FR, Qy, null, null, new $(null, 3, [
    te,
    FR,
    ne,
    ue(new v(null, 2, 5, y, [th, pv], null), new v(null, 5, 5, y, [th, pv, m6, et, fW], null)),
    ee,
    `bindings => binding-form test

  If test is true, evaluates then with binding-form bound to the value of 
  test, if not, yields else`
  ], null)),
  new Ne(function(e, n) {
    var t = sn(Fne);
    return t.g ? t.g(e, n) : t.call(null, e, n);
  }, $C, new $(null, 5, [te, $C, ne, ue(new v(null, 1, 5, y, [JW], null)), ee, `If form represents a macro form, returns its expansion,
  else returns form.`, Re, !0, ie, Le], null), !0),
  new Ne(FK, tN, new $(null, 5, [
    te,
    tN,
    ne,
    ue(new v(null, 2, 5, y, [ws, Bt], null)),
    ee,
    "Returns a vector of [(take-while pred coll) (drop-while pred coll)]",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(qT, AC, new $(null, 5, [te, AC, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(function(e) {
    var n = Qde();
    return function() {
      function t(h, s, d) {
        return am(n), e.j ? e.j(h, s, d) : e.call(null, h, s, d);
      }
      function l(h, s) {
        return am(n), e.g ? e.g(h, s) : e.call(null, h, s);
      }
      function r(h) {
        return am(n), e.h ? e.h(h) : e.call(null, h);
      }
      function u() {
        return am(n), e.o ? e.o() : e.call(null);
      }
      var o = null, a = function() {
        function h(d, p, _, R) {
          var F = null;
          if (3 < arguments.length) {
            F = 0;
            for (var L = Array(arguments.length - 3); F < L.length; ) L[F] = arguments[F + 3], ++F;
            F = new hn(L, 0, null);
          }
          return s.call(this, d, p, _, F);
        }
        function s(d, p, _, R) {
          return am(n), In.I(e, d, p, _, R);
        }
        return h.m = 3, h.v = function(d) {
          var p = I(d);
          d = W(d);
          var _ = I(d);
          d = W(d);
          var R = I(d);
          return d = tn(d), s(p, _, R, d);
        }, h.l = s, h;
      }();
      return o = function(h, s, d, p) {
        switch (arguments.length) {
          case 0:
            return u.call(this);
          case 1:
            return r.call(this, h);
          case 2:
            return l.call(this, h, s);
          case 3:
            return t.call(this, h, s, d);
          default:
            var _ = null;
            if (3 < arguments.length) {
              _ = 0;
              for (var R = Array(arguments.length - 3); _ < R.length; ) R[_] = arguments[_ + 3], ++_;
              _ = new hn(R, 0, null);
            }
            return a.l(h, s, d, _);
        }
      }, o.m = 3, o.v = a.v, o.o = u, o.h = r, o.g = l, o.j = t, o.l = a.l, o;
    }();
  }, n8, new $(null, 5, [te, n8, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(Y4, s$, new $(null, 5, [te, s$, ne, ue(Dt), ee, "Creates a hierarchy object for use with derive, isa? etc.", Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    return new JO(e, n);
  }, ZR, new $(null, 5, [
    te,
    ZR,
    ne,
    ue(Bl(new v(null, 2, 5, y, [lh, Hd], null), new $(null, 1, [hm, new v(null, 1, 5, y, [ue(_E, lh)], null)], null))),
    ee,
    `Construct a data representation of a tagged literal from a
  tag symbol and a form.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(function(e) {
    return dk(e);
  }, kE, new $(null, 5, [te, kE, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(qb, V9, new $(null, 5, [te, V9, ne, ue(new v(null, 1, 5, y, [lh], null), new v(null, 2, 5, y, [Bd, lh], null)), ee, `Returns the immediate parents of tag, either via a JavaScript type
  inheritance relationship or a relationship established via derive. h
  must be a hierarchy obtained from make-hierarchy, if not supplied
  defaults to the global hierarchy`, Re, !0, ie, Le], null), !0),
  new Ne(function(e) {
    return e = e.D, j(e) ? (e.o ? e.o() : e.call(null), M1e) : G_e;
  }, xf, new $(null, 5, [te, xf, ne, ue(new v(null, 1, 5, y, [Md], null)), ee, `test [v] finds fn at key :test in var metadata and calls it,
  presuming failure will throw exception`, Re, !0, ie, Le], null), null),
  new Ne(Et, jM, new $(null, 5, [te, jM, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `Creates a new vector containing the contents of coll. JavaScript arrays
  will be aliased and should not be modified.`, Re, !0, ie, Le], null), null),
  new Ne(O, t7, new $(null, 6, [te, t7, hl, O, ne, ue(new v(
    null,
    2,
    5,
    y,
    [Bt, Tr],
    null
  ), new v(null, 3, 5, y, [Bt, Tr, a6], null)), ee, `Returns the value at the index. get returns nil if index out of
  bounds, nth throws an exception unless not-found is supplied.  nth
  also works for strings, arrays, regex Matchers and Lists, and,
  in O(n) time, for sequences.`, Re, !0, ie, Le], null), null),
  Le,
  Nl(jN, VT, null, null, new $(
    null,
    3,
    [te, jN, ne, ue(new v(null, 2, 5, y, [et, mv], null)), ee, `Expands to code which yields a lazy sequence of the concatenation
  of the supplied colls.  Each coll expr is not evaluated until it is
  needed.

  (lazy-cat xs ys zs) === (concat (lazy-seq xs) (lazy-seq ys) (lazy-seq zs))`],
    null
  )),
  Nl(DM, Jy, null, null, new $(null, 3, [te, DM, ne, ue(new v(null, 2, 5, y, [th, pv], null), new v(null, 5, 5, y, [th, pv, m6, et, fW], null)), ee, `bindings => binding-form test

   If test is not nil, evaluates then with binding-form bound to the
   value of test, if not, yields else`], null)),
  new Ne(Si, U8, new $(null, 5, [
    te,
    U8,
    ne,
    ue(new v(null, 2, 5, y, [Sr, cm], null), new v(null, 3, 5, y, [Sr, cm, f_], null)),
    ee,
    `Returns the substring of s beginning at start inclusive, and ending
  at end (defaults to length of string), exclusive.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Gne,
  new Ne(function(e) {
    var n = Array(Cn(e)), t = 0;
    for (e = z(e); e != null; ) n[t] = Sc(I(e)), t += 1, e = W(e);
    return n;
  }, kP, new $(null, 5, [te, kP, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, `Returns a (potentially-ragged) 2-dimensional array
  containing the contents of coll.`, Re, !0, ie, Le], null), null),
  new Ne(QT, OM, new $(null, 5, [
    te,
    OM,
    ne,
    ue(new v(null, 1, 5, y, [oo], null), new v(null, 2, 5, y, [ih, oo], null)),
    ee,
    `Returns a Symbol with the given namespace and name. Arity-1 works
  on strings, keywords, and vars.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(ya, KM, new $(null, 5, [te, KM, ne, ue(new v(null, 2, 5, y, [Tr, Xs], null)), ee, "Modulus of num and div. Truncates toward negative infinity.", Re, !0, ie, Le], null), null),
  Nl(C0, rj, null, null, new $(null, 4, [te, C0, ne, ue(new v(null, 2, 5, y, [et, ys], null)), ee, `Takes a body of expressions that returns an ISeq or nil, and yields
  a ISeqable object that will invoke the body only the first time seq
  is called, and will cache the result and return it on all subsequent
  seq calls.`, F0, C0], null)),
  new Ne(function(e) {
    return typeof e == "number";
  }, Fd, new $(null, 5, [te, Fd, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x is a JavaScript number.", Re, !0, ie, Le], null), null),
  new Ne(ni, J9, new $(null, 6, [te, J9, hl, ni, ne, ue(new v(null, 1, 5, y, [CB], null)), ee, "Returns true if x is the result of a call to reduced", Re, !0, ie, Le], null), null),
  Nd(NZ, function() {
    return Hc(Xr.o(), null, new $(null, 1, [Ma, !0], null));
  }),
  new Ne(tK, VR, new $(null, 5, [te, VR, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if x's constructor is Object", Re, !0, ie, Le], null), null),
  new Ne(yt, YM, new $(
    null,
    5,
    [te, YM, ne, ue(Dt, new v(null, 1, 5, y, [Bt], null), new v(null, 2, 5, y, [Bt, Sn], null), new v(null, 4, 5, y, [Bt, Sn, et, HW], null)), ee, `conj[oin]. Returns a new collection with the xs
  'added'. (conj nil item) returns (item).
  (conj coll) returns coll. (conj) returns [].
  The 'addition' may happen at different 'places' depending
  on the concrete type.`, Re, !0, ie, Le],
    null
  ), null),
  new Ne(oU, FN, new $(null, 6, [te, FN, hl, oU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(KY, b7, new $(null, 6, [
    te,
    b7,
    hl,
    KY,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null)),
    ee,
    null,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(rr, sP, new $(null, 5, [te, sP, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(function(e, n) {
    return (e & 1 << n) != 0;
  }, A$, new $(null, 5, [te, A$, ne, ue(new v(null, 2, 5, y, [Sn, Tr], null)), ee, "Test bit at index n", Re, !0, ie, Le], null), null),
  new Ne(e5, pR, new $(null, 5, [te, pR, ne, ue(new v(null, 3, 5, y, [j_, et, g_], null)), ee, `keyval => key val
  Returns a new sorted map with supplied mappings, using the supplied comparator.`, Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return typeof e == "number";
  }, L8, new $(null, 5, [te, L8, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true for JavaScript numbers, false otherwise.", Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return lx(e);
  }, TM, new $(null, 5, [te, TM, ne, ue(new v(null, 1, 5, y, [O0e], null)), ee, `Returns, in constant time, a seq of the items in rev (which
  can be a vector or sorted-map), in reverse order. If rev is empty returns nil`, Re, !0, ie, Le], null), null),
  new Ne(uU, uM, new $(null, 6, [
    te,
    uM,
    hl,
    uU,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null)),
    ee,
    "Coerce to long by stripping decimal places. Identical to `int'.",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nl(Dk, KT, null, null, new $(null, 3, [te, Dk, ne, ue(new v(null, 3, 5, y, [th, et, ys], null)), ee, `binding => var-symbol init-expr

  Creates new bindings for the (already-existing) vars, with the
  supplied initial values, executes the exprs in an implicit do, then
  re-establishes the bindings that existed before.  The new bindings
  are made in parallel (unlike let); all init-exprs are evaluated
  before the vars are bound to their new values.`], null)),
  new Ne(qY, z7, new $(
    null,
    6,
    [te, z7, hl, qY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le],
    null
  ), null),
  new Ne(ZY, yC, new $(null, 6, [te, yC, hl, ZY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns a number one less than x, an int.", Re, !0, ie, Le], null), null),
  new Ne(kK, $$, new $(null, 5, [
    te,
    $$,
    ne,
    ue(new v(null, 3, 5, y, [Uwe, yge, B0e], null)),
    ee,
    `Returns a lazy sequence of the nodes in a tree, via a depth-first walk.
  branch? must be a fn of one arg that returns true if passed a node
  that can have children (but may not).  children must be a fn of one
  arg that returns a sequence of the children. Will only be called on
  nodes for which branch? returns true. Root is the root node of the
  tree.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(E_, _8, new $(null, 5, [te, _8, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(pK, n9, new $(null, 5, [te, n9, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, "Return true if the seq function is supported for s", Re, !0, ie, Le], null), null),
  new Ne(rT, o8, new $(null, 5, [
    te,
    o8,
    ne,
    ue(new v(null, 2, 5, y, [Vl, il], null), new v(null, 3, 5, y, [Vl, il, Sn], null), new v(null, 4, 5, y, [Vl, il, Sn, al], null), new v(null, 6, 5, y, [Vl, il, Sn, al, et, Ai], null)),
    ee,
    `Atomically swaps the value of atom to be:
  (apply f current-value-of-atom args). Note that f may be called
  multiple times, and thus should be free of side effects.  Returns
  the value that was swapped in.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nl(dC, PT, null, null, new $(null, 3, [te, dC, ne, ue(new v(null, 4, 5, y, [TJ, il, et, Gs], null)), ee, `Non-atomically swaps the value of the volatile as if:
   (apply f current-value-of-vol args). Returns the value that
   was swapped in.`], null)),
  new Ne(ah, WC, new $(null, 5, [te, WC, ne, ue(new v(null, 2, 5, y, [et, g_], null)), ee, `keyval => key val
  Returns a new array map with supplied mappings.`, Re, !0, ie, Le], null), null),
  Nd(BX, am),
  new Ne(Ex, hM, new $(null, 5, [
    te,
    hM,
    ne,
    ue(Dt, new v(null, 1, 5, y, [Bt], null)),
    ee,
    `Returns a lazy sequence removing consecutive duplicates in coll.
  Returns a transducer when no collection is provided.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(YY, KR, new $(null, 6, [te, KR, hl, YY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(Ri, K7, new $(null, 5, [
    te,
    K7,
    ne,
    ue(new v(null, 3, 5, y, [Ao, cu, il], null), new v(null, 4, 5, y, [Ao, cu, il, Sn], null), new v(null, 5, 5, y, [Ao, cu, il, Sn, al], null), new v(null, 6, 5, y, [Ao, cu, il, Sn, al, $S], null), new v(null, 8, 5, y, [Ao, cu, il, Sn, al, $S, et, Ai], null)),
    ee,
    `'Updates' a value in an associative structure, where k is a
  key and f is a function that will take the old value
  and any supplied args and return the new value, and returns a new
  structure.  If the key does not exist, nil is passed as the old value.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Ou, oP, new $(null, 5, [te, oP, ne, ue(new v(null, 1, 5, y, [ws], null), new v(null, 2, 5, y, [ws, Bt], null)), ee, `Returns a lazy sequence of the items in coll for which
  (pred item) returns logical true. pred must be free of side-effects.
  Returns a transducer when no collection is provided.`, Re, !0, ie, Le], null), null),
  new Ne(XY, WR, new $(null, 6, [te, WR, hl, XY, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns a number one less than x, an int.", Re, !0, ie, Le], null), null),
  Qne,
  new Ne(function(e, n) {
    if (iE(n)) {
      var t = sp.g(e, n);
      return j(t) ? t : (t = _n.h(Yi(n)), t3.l(e, Te([t])), sp.g(e, n));
    }
    throw Error(["Not a qualified symbol: ", ye.h(n)].join(""));
  }, gC, new $(null, 5, [te, gC, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  new Ne(sI, F7, new $(null, 6, [te, F7, hl, sI, ne, ue(new v(null, 2, 5, y, [Tr, Xs], null)), ee, "remainder of dividing numerator by denominator.", Re, !0, ie, Le], null), null),
  new Ne(my, WP, new $(null, 5, [
    te,
    WP,
    ne,
    ue(new v(null, 1, 5, y, [Bt], null)),
    ee,
    `For a list or queue, returns a new list/queue without the first
  item, for a vector, returns a new vector without the last item.
  Note - not the same as next/butlast.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(n5, LC, new $(null, 5, [te, LC, ne, ue(new v(null, 3, 5, y, [il, et, NX], null)), ee, `Returns a map that consists of the rest of the maps conj-ed onto
  the first.  If a key occurs in more than one map, the mapping(s)
  from the latter (left-to-right) will be combined with the mapping in
  the result by calling (f val-in-result val-in-latter).`, Re, !0, ie, Le], null), null),
  new Ne(iU, YN, new $(null, 6, [
    te,
    YN,
    hl,
    iU,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null)),
    ee,
    "Coerce to long by stripping decimal places. Identical to `int'.",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  Nl(tP, RT, null, null, new $(null, 3, [te, tP, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, lge], null)), ee, `Evaluates expr and throws an exception if it does not evaluate to
  logical true.`], null)),
  new Ne(function(e) {
    for (var n = Array(arguments.length), t = 0; ; ) if (t < n.length) n[t] = arguments[t], t += 1;
    else return n;
  }, $d, new $(null, 5, [te, $d, ne, ue(new v(null, 1, 5, y, [Qge], null)), ee, `Creates a new javascript array.
@param {...*} var_args`, Re, !0, ie, Le], null), null),
  Nl(o7, WT, null, null, new $(null, 3, [
    te,
    o7,
    ne,
    ue(new v(null, 2, 5, y, [et, Gs], null)),
    ee,
    `Refers to all the public vars of \`cljs.core\`, subject to
  filters.
  Filters can include at most one each of:

  :exclude list-of-symbols
  :rename map-of-fromsymbol-tosymbol

  Filters can be used to select a subset, via exclusion, or to provide a mapping
  to a symbol different from the var's name, in order to prevent clashes.`
  ], null)),
  new Ne(bK, N$, new $(null, 5, [
    te,
    N$,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null)),
    ee,
    `Takes any nested combination of sequential things (lists, vectors,
  etc.) and returns their contents as a single, flat sequence.
  (flatten nil) returns nil.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(O1, iM, new $(null, 5, [te, iM, ne, ue(new v(null, 1, 5, y, [Sn], null), new v(null, 2, 5, y, [Sn, al], null), new v(null, 4, 5, y, [Sn, al, et, Ai], null)), ee, "Returns true if no two of the arguments are =", Re, !0, ie, Le], null), null),
  new Ne(Q3, VM, new $(null, 5, [
    te,
    VM,
    ne,
    ue(new v(null, 1, 5, y, [il], null), new v(null, 2, 5, y, [il, Bt], null)),
    ee,
    `Returns a lazy sequence consisting of the result of applying f to 0
  and the first item of coll, followed by applying f to 1 and the second
  item in coll, etc, until coll is exhausted. Thus function f should
  accept 2 arguments, index and item. Returns a stateful transducer when
  no collection is provided.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(LI, $P, new $(null, 5, [te, $P, ne, ue(new v(null, 1, 5, y, [NS], null)), ee, "Returns a map of the public intern mappings for the namespace.", Re, !0, ie, Le], null), !0),
  Nd(rX, la),
  new Ne(qc, CR, new $(null, 5, [te, CR, ne, ue(new v(null, 1, 5, y, [Tr], null)), ee, "Returns true if n is even, throws an exception if n is not an integer", Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return sn(e);
  }, e8, new $(null, 5, [te, e8, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return e instanceof Np;
  }, jP, new $(null, 5, [
    te,
    jP,
    ne,
    null,
    ee,
    null,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(ud, Kk, new $(null, 5, [te, Kk, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    var n = e != null && Rn === e.pd ? e.type : null;
    return j(n) ? n : (n = e == null ? null : Vt(e), n = n == null ? null : zi.h(n), j(n) ? n : zh(e));
  }, cw, new $(null, 5, [te, cw, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return x's constructor.", Re, !0, ie, Le], null), null),
  new Ne(oI, LR, new $(null, 6, [te, LR, hl, oI, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if num is less than zero, else false", Re, !0, ie, Le], null), null),
  new Ne(
    Xr,
    D9,
    new $(null, 5, [te, D9, ne, ue(Dt, new v(null, 1, 5, y, [Nve], null)), ee, `Returns a new symbol with a unique name. If a prefix string is
  supplied, the name is prefix# where # is some unique number. If
  prefix is not supplied, the prefix is 'G__'.`, Re, !0, ie, Le], null),
    null
  ),
  new Ne(sp, l4, new $(null, 5, [te, l4, ne, ue(new v(null, 1, 5, y, [qW], null)), ee, "Returns the var to which a symbol will be resolved in the namespace else nil.", Re, !0, ie, Le], null), !0),
  new Ne(function(e, n, t) {
    return JD(e, n, t), e;
  }, wR, new $(null, 5, [
    te,
    wR,
    ne,
    ue(new v(
      null,
      3,
      5,
      y,
      [US, Wa, il],
      null
    )),
    ee,
    `Adds a watch function to an atom reference. The watch fn must be a
  fn of 4 args: a key, the reference, its old-state, its
  new-state. Whenever the reference's state might have been changed,
  any registered watches will have their functions called. The watch
  fn will be called synchronously. Note that an atom's state
  may have changed again prior to the fn call, so use old/new-state
  rather than derefing the reference. Keys must be unique per
  reference, and can be used to remove the watch with remove-watch,
  but are otherwise considered opaque by the watch mechanism.  Bear in
  mind that regardless of the result or action of the watch fns the
  atom's value will change.  Example:

      (def a (atom 0))
      (add-watch a :inc (fn [k r o n] (assert (== 0 n))))
      (swap! a inc)
      ;; Assertion Error
      (deref a)
      ;=> 1`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(function(e, n) {
    return er(fu(e, n));
  }, JI, new $(null, 5, [te, JI, ne, ue(new v(null, 2, 5, y, [ws, Bt], null)), ee, `Returns false if (pred x) is logical true for any x in coll,
  else true.`, Re, !0, ie, Le], null), null),
  new Ne(Po, c9, new $(null, 5, [
    te,
    c9,
    ne,
    ue(Bl(new v(null, 1, 5, y, [Tr], null), new $(null, 1, [hm, new v(null, 1, 5, y, [ue(Fd, Tr)], null)], null)), Bl(new v(null, 2, 5, y, [Tr, Bt], null), new $(null, 1, [hm, new v(null, 1, 5, y, [ue(Fd, Tr)], null)], null))),
    ee,
    `Returns a lazy seq of every nth item in coll.  Returns a stateful
  transducer when no collection is provided.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(T2, NP, new $(null, 5, [te, NP, ne, ue(new v(null, 1, 5, y, [Bt], null), new v(null, 2, 5, y, [Tr, Bt], null)), ee, `When lazy sequences are produced via functions that have side
  effects, any effects other than those needed to produce the first
  element in the seq do not occur until the seq is consumed. dorun can
  be used to force any effects. Walks through the successive nexts of
  the seq, does not retain the head and returns nil.`, Re, !0, ie, Le], null), null),
  new Ne(
    function(e) {
      return gI(e);
    },
    _R,
    new $(null, 5, [te, _R, ne, ue(new v(null, 1, 5, y, [iw], null)), ee, "Removes all of the methods of multimethod.", Re, !0, ie, Le], null),
    null
  ),
  new Ne(Fo, JC, new $(null, 5, [te, JC, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "If coll is empty, returns nil, else coll", Re, !0, ie, Le], null), null),
  new Ne(YG, UI, new $(null, 5, [te, UI, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  kg,
  new Ne(HT, Hk, new $(null, 5, [te, Hk, ne, null, ee, null, Re, !0, ie, Le], null), !0),
  Nd(fQ, X4),
  new Ne(function(e) {
    return Wr(e);
  }, FC, new $(null, 5, [
    te,
    FC,
    ne,
    ue(new v(null, 1, 5, y, [Sr], null)),
    ee,
    null,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(function(e, n) {
    return eI(e, n), e;
  }, y8, new $(null, 5, [te, y8, ne, ue(new v(null, 2, 5, y, [US, Wa], null)), ee, "Removes a watch (set by add-watch) from a reference", Re, !0, ie, Le], null), null),
  Nl(B0, R2, null, null, new $(null, 4, [
    te,
    B0,
    ne,
    ue(Dt, new v(null, 1, 5, y, [Sn], null), new v(null, 3, 5, y, [Sn, et, q_], null)),
    ee,
    `Evaluates exprs one at a time, from left to right. If a form
  returns a logical true value, or returns that value and doesn't
  evaluate any of the other expressions, otherwise it returns the
  value of the last expression. (or) returns nil.`,
    F0,
    B0
  ], null)),
  new Ne(Ny, HN, new $(null, 6, [te, HN, hl, Ny, ne, ue(new v(null, 1, 5, y, [SE], null), new v(null, 2, 5, y, [rw, EE], null)), ee, `Creates an array of ints. Does not coerce array, provided for compatibility
  with Clojure.`, Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return za(e) ? 0 < e : !1;
  }, vM, new $(null, 5, [te, vM, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Return true if x satisfies int? and is positive.", Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return e === void 0;
  }, f$, new $(null, 5, [
    te,
    f$,
    ne,
    ue(new v(null, 1, 5, y, [Sn], null)),
    ee,
    "Returns true if x identical to the JavaScript undefined value.",
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(hU, xN, new $(null, 6, [te, xN, hl, hU, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, null, Re, !0, ie, Le], null), null),
  new Ne(vY, qC, new $(null, 6, [te, qC, hl, vY, ne, ue(new v(null, 2, 5, y, [Sn, al], null)), ee, "Tests if 2 arguments are the same object", Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return gu(e);
  }, NM, new $(null, 5, [
    te,
    NM,
    ne,
    ue(new v(null, 1, 5, y, [$h], null)),
    ee,
    `Returns a new, persistent version of the transient collection, in
  constant time. The transient collection cannot be used after this
  call, any such use will throw an exception.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  v3e,
  new Ne(yL, t9, new $(null, 5, [te, t9, ne, ue(new v(null, 1, 5, y, [Sn], null)), ee, "Returns true if coll implements nth in constant time", Re, !0, ie, Le], null), null),
  new Ne(km, XC, new $(null, 5, [te, XC, ne, ue(new v(null, 2, 5, y, [cu, Sn], null), new v(null, 3, 5, y, [cu, Sn, al], null), new v(null, 5, 5, y, [cu, Sn, al, et, Ai], null)), ee, `Returns the x for which (k x), a number, is least.

  If there are multiple such xs, the last one is returned.`, Re, !0, ie, Le], null), null),
  new Ne(n1, q$, new $(null, 5, [te, q$, ne, ue(new v(
    null,
    1,
    5,
    y,
    [il],
    null
  ), new v(null, 2, 5, y, [Tr, il], null)), ee, `Takes a function of no args, presumably with side effects, and
  returns an infinite (or length n if supplied) lazy sequence of calls
  to it`, Re, !0, ie, Le], null), null),
  new Ne(Us, a9, new $(null, 5, [te, a9, ne, ue(new v(null, 1, 5, y, [Bt], null)), ee, "Returns a set of the distinct elements of coll.", Re, !0, ie, Le], null), null),
  new Ne(Ia, NN, new $(null, 5, [
    te,
    NN,
    ne,
    ue(new v(null, 1, 5, y, [ws], null), new v(null, 2, 5, y, [ws, Bt], null)),
    ee,
    `Returns a lazy sequence of the items in coll for which
  (pred item) returns logical false. pred must be free of side-effects.
  Returns a transducer when no collection is provided.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Ln, J8, new $(null, 5, [te, J8, ne, ue(new v(null, 2, 5, y, [Sn, al], null)), ee, "Efficient test to determine that two keywords are identical.", Re, !0, ie, Le], null), null),
  Nl(j$, FT, null, null, new $(null, 3, [te, j$, ne, ue(new v(null, 3, 5, y, [xf, et, ys], null)), ee, `Repeatedly executes body while test expression is true. Presumes
  some side-effect will cause test to become false/nil. Returns nil`], null)),
  new Ne(Ss, j9, new $(null, 5, [
    te,
    j9,
    ne,
    ue(new v(null, 2, 5, y, [W_, Sr], null)),
    ee,
    `Returns the first regex match, if any, of s to re, using
  re.exec(s). Returns a vector, containing first the matching
  substring, then any capturing groups if the regular expression contains
  capturing groups.`,
    Re,
    !0,
    ie,
    Le
  ], null), null),
  new Ne(Xh, T$, new $(null, 5, [te, T$, ne, null, ee, null, Re, !0, ie, Le], null), null),
  new Ne(function(e) {
    return W(e) ? Qu(Sc(e)) : z(e) ? I(e) : Tt;
  }, KP, new $(null, 5, [te, KP, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, `Builds a map from a seq as described in
  https://clojure.org/reference/special_forms#keyword-arguments`, Re, !0, ie, Le], null), null)
]), im = oc(sne, null), mEe = Gn([RW, eD, wH, cH, _6, aD, u_e, Mq, Go], [O_(RW, function(e, n) {
  var t = _1(n);
  n = he.g(na.l(function(a) {
    return Ry.g(te, bt.g(Vt, Ju($I(e, a))));
  }, Te([gE(e)])), bt.g(function(a) {
    return Dn.j(
      Vt(a),
      te,
      tc(a)
    );
  }, gE(e))), n = z(n);
  for (var l = null, r = 0, u = 0; ; ) if (u < r) {
    var o = l.Y(null, u);
    j(function() {
      var a = ee.h(o);
      return j(a) ? (a = Ss(t, ee.h(o)), j(a) ? a : Ss(t, ye.h(te.h(o)))) : a;
    }()) && kA(o), u += 1;
  } else if (n = z(n)) l = n, oi(l) ? (n = Jr(l), u = Wr(l), l = n, r = Cn(n), n = u) : (o = I(l), j(function() {
    var a = ee.h(o);
    return j(a) ? (a = Ss(t, ee.h(o)), j(a) ? a : Ss(t, ye.h(te.h(o)))) : a;
  }()) && kA(o), n = W(l), l = null, r = 0), u = 0;
  else return null;
}, im), Nl(eD, function(e, n, t) {
  return ve.h(z(he.l(new g(null, Ive, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, nH, null, 1, null), new g(
    null,
    ve.h(z(he.g(new g(null, o2e, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null)))),
    null,
    1,
    null
  ))))), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, aW, null, 1, null), new g(null, nH, null, 1, null)))), null, 1, null)]))));
}, im, null, new $(null, 3, [te, eD, ne, null, ee, null], null)), O_(wH, function(e, n) {
  var t = Vs();
  return n = $c(e, en.j(YG(e, t), n, n)), Lf.h(bt.g(I, LI(e, n)));
}, im), O_(cH, function(e, n) {
  if (n = sp.g(e, n), j(n)) {
    n = Vt(n);
    var t = fr(n);
    n = en.g(t, Yn);
    var l = en.g(t, ie);
    if (j(j(n) ? l : n)) {
      var r = Ox.h(sn(Or.h(e)));
      if (j(r) ? (t = co.h, l = new $(null, 1, [ZX, tc(l)], null), r = r.h ? r.h(l) : r.call(null, l), t = t.call(co, r)) : t = null, j(t)) return t = Xf.g(t, /\n/), n = Ja.g(`
`, uu.g(n - 1, t)), n = new W4(n, Cn(n)), n = new V3(n), n = new YL(typeof n == "string" ? x1(n) : n), e = z3(e, n, new $(null, 1, [co, !0], null)), co.h(Vt(e));
    }
  }
  return null;
}, im), Nl(_6, function(e, n, t) {
  return ve.h(z(he.g(new g(null, aW, null, 1, null), new g(null, ve.h(z(he.l(new g(null, dQ, null, 1, null), new g(null, ve.h(z(he.g(new g(null, jge, null, 1, null), new g(null, ve.h(z(he.g(new g(
    null,
    Fr,
    null,
    1,
    null
  ), new g(null, t, null, 1, null)))), null, 1, null)))), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, lg, null, 1, null), new g(null, "Source not found", null, 1, null)))), null, 1, null)])))), null, 1, null))));
}, im, null, new $(null, 3, [te, _6, ne, null, ee, null], null)), Nl(
  aD,
  function(e, n, t) {
    return ve.h(z(he.l(new g(null, Zd, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, f6, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Bye, null, 1, null), new g(
      null,
      ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, t, null, 1, null)))),
      null,
      1,
      null
    )))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.l(new g(null, yw, null, 1, null), new g(null, ve.h(z(he.g(new g(null, hxe, null, 1, null), new g(null, f6, null, 1, null)))), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Zq, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Yx, null, 1, null), new g(null, f6, null, 1, null)))), null, 1, null)))), null, 1, null)])))), null, 1, null), new g(null, ve.h(z(he.l(new g(null, Zd, null, 1, null), new g(null, Et(ve.h(z(he.g(new g(null, sD, null, 1, null), new g(null, ve.h(z(he.g(new g(
      null,
      XQ,
      null,
      1,
      null
    ), new g(null, ve.h(z(he.g(new g(null, Fr, null, 1, null), new g(null, t, null, 1, null)))), null, 1, null)))), null, 1, null))))), null, 1, null), Te([new g(null, ve.h(z(he.g(new g(null, Zq, null, 1, null), new g(null, ve.h(z(he.l(new g(null, Sb, null, 1, null), new g(null, ve.h(z(he.g(new g(null, Yx, null, 1, null), new g(null, sD, null, 1, null)))), null, 1, null), Te([new g(null, te, null, 1, null), new g(null, ve.h(z(he.g(new g(null, c2e, null, 1, null), new g(null, sD, null, 1, null)))), null, 1, null)])))), null, 1, null)))), null, 1, null)])))), null, 1, null)]))));
  },
  im,
  null,
  new $(null, 3, [te, aD, ne, null, ee, null], null)
), Bl(kA, new $(null, 1, [kh, !0], null)), O_(Mq, function(e, n) {
  var t = n instanceof RegExp ? function(l) {
    return Ss(n, ye.h(l));
  } : function(l) {
    return GK(ye.h(l), ye.h(n));
  };
  return Lf.h(na.l(function(l) {
    var r = ye.h(l);
    return bt.g(function(u) {
      return _n.g(r, ye.h(u));
    }, Ou.g(t, xi(LI(e, l))));
  }, Te([gE(e)])));
}, im), im]), ij = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], arguments[2], arguments[3], 4 < t.length ? new hn(t.slice(4), 0, null) : null);
};
ij.l = function(e, n, t, l, r) {
  return e = Cn(t), ve.h(z(he.g(new g(null, mi, null, 1, null), bt.g(function(u) {
    return WG(t, l, u);
  }, Mo.g(e, r)))));
};
ij.m = 4;
ij.v = function(e) {
  var n = I(e), t = W(e);
  e = I(t);
  var l = W(t);
  t = I(l);
  var r = W(l);
  return l = I(r), r = W(r), this.l(n, e, t, l, r);
};
var OD = oc(lee, null), gEe = new $(null, 3, [Go, OD, rD, new Ne(WG, rD, new $(null, 5, [te, rD, ne, null, ee, null, Re, !0, ie, OD], null), null), t6, Nl(t6, ij, OD, null, new $(null, 3, [te, t6, ne, null, ee, null], null))], null), gs = oc(RJ, null), xc = oc(zee, null), Pd = oc(WQ, null), kD = oc(nee, null), wEe = new Ne(function(e, n) {
  return z$(function(t) {
    if (ei(t)) {
      var l = sn(pF);
      return l.g ? l.g(e, t) : l.call(null, e, t);
    }
    return t;
  }, n);
}, Q7, new $(null, 3, [ie, Pd, te, Q7, ee, "Recursively performs all possible macroexpansions in form."], null), !0), vEe = Gn([S6, hD, Y6, cD, G6, k6, Go, Q6, Q7], [new Ne(function(e) {
  function n(t) {
    var l = O.j(t, 0, null);
    return t = O.j(t, 1, null), typeof l == "string" ? new v(null, 2, 5, y, [ts.h(l), t], null) : new v(null, 2, 5, y, [l, t], null);
  }
  return TE(function(t) {
    return ci(t) ? lr.g(Tt, bt.g(n, t)) : t;
  }, e);
}, S6, new $(null, 5, [te, S6, ne, ue(new v(null, 1, 5, y, [Ao], null)), ee, "Recursively transforms all map keys from strings to keywords.", Re, !0, ie, Pd], null), null), new Ne(TE, hD, new $(null, 5, [
  te,
  hD,
  ne,
  ue(new v(null, 2, 5, y, [il, Hd], null)),
  ee,
  `Performs a depth-first, post-order traversal of form.  Calls f on
  each sub-form, uses f's return value in place of the original.
  Recognizes all Clojure data structures. Consumes seqs as with doall.`,
  Re,
  !0,
  ie,
  Pd
], null), null), new Ne(BG, Y6, new $(null, 5, [te, Y6, ne, ue(new v(null, 2, 5, y, [Fk, Hd], null)), ee, `Recursively transforms form by replacing keys in smap with their
  values.  Like clojure/replace but works on any data structure.  Does
  replacement at the leaves of the tree first.`, Re, !0, ie, Pd], null), null), new Ne(dB, cD, new $(null, 5, [
  te,
  cD,
  ne,
  ue(new v(null, 3, 5, y, [Rye, Y1e, Hd], null)),
  ee,
  `Traverses form, an arbitrary data structure.  inner and outer are
  functions.  Applies inner to each element of form, building up a
  data structure of the same type, then applies outer to the result.
  Recognizes all Clojure data structures. Consumes seqs as with doall.`,
  Re,
  !0,
  ie,
  Pd
], null), null), new Ne(z$, G6, new $(null, 5, [te, G6, ne, ue(new v(null, 2, 5, y, [il, Hd], null)), ee, "Like postwalk, but does pre-order traversal.", Re, !0, ie, Pd], null), null), new Ne(function(e, n) {
  return z$(function(t) {
    return Ol(e, t) ? e.h ? e.h(t) : e.call(null, t) : t;
  }, n);
}, k6, new $(null, 5, [
  te,
  k6,
  ne,
  ue(new v(null, 2, 5, y, [Fk, Hd], null)),
  ee,
  `Recursively transforms form by replacing keys in smap with their
  values.  Like clojure/replace but works on any data structure.  Does
  replacement at the root of the tree first.`,
  Re,
  !0,
  ie,
  Pd
], null), null), Pd, new Ne(function(e) {
  function n(t) {
    var l = O.j(t, 0, null);
    return t = O.j(t, 1, null), l instanceof de ? new v(null, 2, 5, y, [ml(l), t], null) : new v(null, 2, 5, y, [l, t], null);
  }
  return TE(function(t) {
    return ci(t) ? lr.g(Tt, bt.g(n, t)) : t;
  }, e);
}, Q6, new $(null, 5, [te, Q6, ne, ue(new v(null, 1, 5, y, [Ao], null)), ee, "Recursively transforms all map keys from keywords to strings.", Re, !0, ie, Pd], null), null), wEe]), nte = Gn([RJ, lee, wX, ks, zee, Xee, WQ, IZ, nee, sne], [Gn([gD, l6, w6, b6, R6, H0, M6, oD, A6, z6, N6, q0, av, lD, tD, v6, x6, Go, iD, y6, r6], [new Ne(
  Xf,
  gD,
  new $(null, 5, [te, gD, ne, ue(new v(null, 2, 5, y, [Sr, W_], null), new v(null, 3, 5, y, [Sr, W_, b0e], null)), ee, `Splits string on a regular expression. Optional argument limit is
  the maximum number of parts. Not lazy. Returns vector of the parts.
  Trailing empty strings are not returned - pass limit of -1 to return all.`, Re, !0, ie, gs], null),
  null
), new Ne(Rb, l6, new $(null, 5, [
  te,
  l6,
  ne,
  ue(new v(null, 2, 5, y, [Sr, k_], null), new v(null, 3, 5, y, [Sr, k_, EH], null)),
  ee,
  `Return index of value (string or char) in s, optionally searching
  forward from from-index or nil if not found.`,
  Re,
  !0,
  ie,
  gs
], null), null), new Ne(function(e) {
  return e.replace(/[\s\xa0]+$/, "");
}, w6, new $(null, 5, [te, w6, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, "Removes whitespace from the right side of string.", Re, !0, ie, gs], null), null), new Ne(function(e) {
  return e.toUpperCase();
}, b6, new $(null, 5, [te, b6, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, "Converts string to all upper-case.", Re, !0, ie, gs], null), null), new Ne(function(e) {
  return e.toLowerCase();
}, R6, new $(null, 5, [
  te,
  R6,
  ne,
  ue(new v(null, 1, 5, y, [Sr], null)),
  ee,
  "Converts string to all lower-case.",
  Re,
  !0,
  ie,
  gs
], null), null), new Ne(function(e) {
  return e.replace(mxe, "$2$1").split("").reverse().join("");
}, H0, new $(null, 5, [te, H0, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, "Returns s with its characters reversed.", Re, !0, ie, gs], null), null), new Ne(function(e, n) {
  return g1(e, n);
}, M6, new $(null, 5, [te, M6, ne, ue(new v(null, 2, 5, y, [Sr, O6], null)), ee, "True if s ends with substr.", Re, !0, ie, gs], null), null), new Ne(function(e) {
  return Xf.g(e, /\n|\r\n/);
}, oD, new $(null, 5, [
  te,
  oD,
  ne,
  ue(new v(null, 1, 5, y, [Sr], null)),
  ee,
  "Splits s on \\n or \\r\\n. Trailing empty lines are not returned.",
  Re,
  !0,
  ie,
  gs
], null), null), new Ne(yg, A6, new $(null, 5, [te, A6, ne, ue(new v(null, 2, 5, y, [Sr, k_], null), new v(null, 3, 5, y, [Sr, k_, EH], null)), ee, `Return last index of value (string or char) in s, optionally
  searching backward from from-index or nil if not found.`, Re, !0, ie, gs], null), null), new Ne(function(e) {
  for (var n = e.length; ; ) {
    if (n === 0) return "";
    var t = en.g(e, n - 1);
    if (t === `
` || t === "\r") --n;
    else return e.substring(0, n);
  }
}, z6, new $(null, 5, [
  te,
  z6,
  ne,
  ue(new v(null, 1, 5, y, [Sr], null)),
  ee,
  `Removes all trailing newline \\n or return \\r characters from
  string.  Similar to Perl's chomp.`,
  Re,
  !0,
  ie,
  gs
], null), null), new Ne(U4, N6, new $(null, 5, [te, N6, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, "True is s is nil, empty, or contains only whitespace.", Re, !0, ie, gs], null), null), new Ne(F3, q0, new $(null, 5, [
  te,
  q0,
  ne,
  ue(new v(null, 3, 5, y, [Sr, yH, zq], null)),
  ee,
  `Replaces all instance of match with replacement in s.

   match/replacement can be:

   string / string
   pattern / (string or function of match).

   See also replace-first.

   The replacement is literal (i.e. none of its characters are treated
   specially) for all cases above except pattern / string.

   For pattern / string, $1, $2, etc. in the replacement string are
   substituted with the string that matched the corresponding
   parenthesized group in the pattern.

   Example:
   (clojure.string/replace "Almost Pig Latin" #"\\b(\\w)(\\w+)\\b" "$2$1ay")
   -> "lmostAay igPay atinLay"`,
  Re,
  !0,
  ie,
  gs
], null), null), new Ne(Ja, av, new $(null, 5, [te, av, ne, ue(new v(null, 1, 5, y, [Bt], null), new v(null, 2, 5, y, [Ove, Bt], null)), ee, `Returns a string of all elements in coll, as returned by (seq coll),
  separated by an optional separator.`, Re, !0, ie, gs], null), null), new Ne(function(e) {
  return Lme(e);
}, lD, new $(null, 5, [te, lD, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, "Removes whitespace from both ends of string.", Re, !0, ie, gs], null), null), new Ne(KK, tD, new $(null, 5, [
  te,
  tD,
  ne,
  ue(new v(null, 2, 5, y, [Sr, O6], null)),
  ee,
  "True if s starts with substr.",
  Re,
  !0,
  ie,
  gs
], null), null), new Ne(function(e) {
  return e.replace(/^[\s\xa0]+/, "");
}, v6, new $(null, 5, [te, v6, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, "Removes whitespace from the left side of string.", Re, !0, ie, gs], null), null), new Ne(function(e, n) {
  for (var t = new Ts(), l = e.length, r = 0; ; ) {
    if (l === r) return t.toString();
    var u = e.charAt(r), o = en.g(n, u);
    o != null ? t.append(ye.h(o)) : t.append(u), r += 1;
  }
}, x6, new $(null, 5, [
  te,
  x6,
  ne,
  ue(new v(null, 2, 5, y, [Sr, xwe], null)),
  ee,
  `Return a new string, using cmap to escape each character ch
   from s as follows:

   If (cmap ch) is nil, append ch to the new string.
   If (cmap ch) is non-nil, append (str (cmap ch)) instead.`,
  Re,
  !0,
  ie,
  gs
], null), null), gs, new Ne(GK, iD, new $(null, 5, [te, iD, ne, ue(new v(null, 2, 5, y, [Sr, O6], null)), ee, "True if s includes substr.", Re, !0, ie, gs], null), null), new Ne(function(e) {
  return x3(e);
}, y6, new $(null, 5, [te, y6, ne, ue(new v(null, 1, 5, y, [Sr], null)), ee, `Converts first character of the string to upper-case, all other
  characters to lower-case.`, Re, !0, ie, gs], null), null), new Ne(function(e, n, t) {
  return e.replace(n, t);
}, r6, new $(null, 5, [
  te,
  r6,
  ne,
  ue(new v(null, 3, 5, y, [Sr, yH, zq], null)),
  ee,
  `Replaces the first instance of match with replacement in s.

   match/replacement can be:

   string / string
   pattern / (string or function of match).

   See also replace.

   The replacement is literal (i.e. none of its characters are treated
   specially) for all cases above except pattern / string.

   For pattern / string, $1, $2, etc. in the replacement string are
   substituted with the string that matched the corresponding
   parenthesized group in the pattern.

   Example:
   (clojure.string/replace-first "swap first two words"
                                 #"(\\w+)(\\s+)(\\w+)" "$3$2$1")
   -> "first swap two words"`,
  Re,
  !0,
  ie,
  gs
], null), null)]), gEe, R3e, pEe, Gn([U6, s6, C6, B6, av, o6, nD, X6, fD, Go, Z6, uD, h6], [new Ne(function(e, n) {
  return Us(bt.g(function(t) {
    return pg(t, n);
  }, e));
}, U6, new $(null, 5, [te, U6, ne, ue(new v(null, 2, 5, y, [m_, Oc], null)), ee, "Returns a rel of the elements of xrel with only the keys in ks", Re, !0, ie, xc], null), null), new Ne(LG, s6, new $(null, 5, [te, s6, ne, ue(new v(null, 1, 5, y, [Ao], null)), ee, "Returns the map with the vals mapped to the keys.", Re, !0, ie, xc], null), null), new Ne(function(e, n) {
  return wt.j(function(t, l) {
    return j(e.h ? e.h(l) : e.call(null, l)) ? t : Aa.g(t, l);
  }, n, n);
}, C6, new $(null, 5, [te, C6, ne, ue(new v(null, 2, 5, y, [ws, Xge], null)), ee, "Returns a set of the elements for which pred is true", Re, !0, ie, xc], null), null), new Ne(function(e, n) {
  return Cn(e) >= Cn(n) && hu(function(t) {
    return Ol(e, t);
  }, n);
}, B6, new $(null, 5, [te, B6, ne, ue(new v(null, 2, 5, y, [$W, LW], null)), ee, "Is set1 a superset of set2?", Re, !0, ie, xc], null), null), new Ne(lT, av, new $(null, 5, [
  te,
  av,
  ne,
  ue(new v(null, 2, 5, y, [m_, yW], null), new v(null, 3, 5, y, [m_, yW, y0e], null)),
  ee,
  `When passed 2 rels, returns the rel corresponding to the natural
  join. When passed an additional keymap, joins on the corresponding
  keys.`,
  Re,
  !0,
  ie,
  xc
], null), null), new Ne(j1, o6, new $(null, 5, [te, o6, ne, ue(Dt, new v(null, 1, 5, y, [Id], null), new v(null, 2, 5, y, [Id, fv], null), new v(null, 4, 5, y, [Id, fv, et, I6], null)), ee, "Return a set that is the union of the input sets", Re, !0, ie, xc], null), null), new Ne(function(e, n) {
  return Us(bt.g(function(t) {
    return PI(t, n);
  }, e));
}, nD, new $(null, 5, [te, nD, ne, ue(new v(null, 2, 5, y, [m_, Uq], null)), ee, "Returns a rel of the maps in xrel with the keys in kmap renamed to the vals in kmap", Re, !0, ie, xc], null), null), new Ne(function(e, n) {
  return Cn(e) <= Cn(n) && hu(function(t) {
    return Ol(n, t);
  }, e);
}, X6, new $(null, 5, [te, X6, ne, ue(new v(null, 2, 5, y, [$W, LW], null)), ee, "Is set1 a subset of set2?", Re, !0, ie, xc], null), null), new Ne(ig, fD, new $(null, 5, [te, fD, ne, ue(new v(null, 1, 5, y, [Id], null), new v(null, 2, 5, y, [Id, fv], null), new v(null, 4, 5, y, [Id, fv, et, I6], null)), ee, "Return a set that is the first set without elements of the remaining sets", Re, !0, ie, xc], null), null), xc, new Ne(rg, Z6, new $(null, 5, [te, Z6, ne, ue(new v(null, 1, 5, y, [Id], null), new v(null, 2, 5, y, [Id, fv], null), new v(null, 4, 5, y, [
  Id,
  fv,
  et,
  I6
], null)), ee, "Return a set that is the intersection of the input sets", Re, !0, ie, xc], null), null), new Ne(fB, uD, new $(null, 5, [te, uD, ne, ue(new v(null, 2, 5, y, [m_, Oc], null)), ee, `Returns a map of the distinct values of ks in the xrel mapped to a
  set of the maps in xrel with the corresponding values of ks.`, Re, !0, ie, xc], null), null), new Ne(PI, h6, new $(null, 5, [te, h6, ne, ue(new v(null, 2, 5, y, [o1, Uq], null)), ee, "Returns the map with the keys in kmap renamed to the vals in kmap", Re, !0, ie, xc], null), null)]), I3e, vEe, D3e, new $(
  null,
  3,
  [Go, kD, M0, new Ne(p5, M0, new $(null, 5, [
    te,
    M0,
    ne,
    ue(new v(null, 1, 5, y, [xE], null), new v(null, 2, 5, y, [new $(null, 2, [Gr, new v(null, 1, 5, y, [WW], null), Uh, vw], null), xE], null), new v(null, 4, 5, y, [xE, V_e, WW, vw], null)),
    ee,
    `Reads the first object from an cljs.tools.reader.reader-types/IPushbackReader.
   Returns the object read. If EOF, throws if eof-error? is true otherwise returns eof.
   If no reader is provided, *in* will be used.

   Reads data in the edn format (subset of Clojure data):
   http://edn-format.org

   cljs.tools.reader.edn/read doesn't depend on dynamic Vars, all configuration
   is done by passing an opt map.

   opts is a map that can include the following keys:
   :eof - value to return on end-of-file. When not supplied, eof throws an exception.
   :readers  - a map of tag symbols to data-reader functions to be considered before default-data-readers.
              When not supplied, only the default-data-readers will be used.
   :default - A function of two args, that will, if present and no reader is found for a tag,
              be called with the tag and the value.`,
    Re,
    !0,
    ie,
    kD
  ], null), null), Ow, new Ne(Nb, Ow, new $(null, 5, [te, Ow, ne, ue(new v(null, 1, 5, y, [Sr], null), new v(null, 2, 5, y, [vw, Sr], null)), ee, `Reads one object from the string s.
   Returns nil when s is nil or empty.

   Reads data in the edn format (subset of Clojure data):
   http://edn-format.org

   opts is a map as per cljs.tools.reader.edn/read`, Re, !0, ie, kD], null), null)],
  null
), mEe]), yEe = xi(nte), _Ee = new $(null, 4, [cge, new $(null, 2, [gh, Error, T7, function() {
  var e = null;
  return e = function(n, t, l) {
    switch (arguments.length) {
      case 1:
        return Error(n);
      case 2:
        return Error(n, t);
      case 3:
        return Error(n, t, l);
    }
    throw Error("Invalid arity: " + arguments.length);
  }, e.h = function(n) {
    return Error(n);
  }, e.g = function(n, t) {
    return Error(n, t);
  }, e.j = function(n, t, l) {
    return Error(n, t, l);
  }, e;
}()], null), mQ, yB, AJ, new $(null, 2, [gh, Ts, T7, function(e) {
  return new Ts(e);
}], null), mye, v2], null), xEe = new $(null, 1, [r5, ks], null), tte = function e(n, t) {
  if (ei(t)) if (on.g(mi, I(t))) {
    var l = Vt(t);
    l = j(j(l) ? Yn.h(l) : l) ? new $(null, 2, [zn, zn.h(l), Yn, Yn.h(l)], null) : null, j(l) && (c1 = l);
    try {
      var r = tn(t);
      for (t = null; ; ) if (z(r)) {
        var u = tn(r), o = I(r), a = e.g ? e.g(n, o) : e.call(null, n, o);
        r = u, t = a;
      } else return t;
    } finally {
      j(l) && (c1 = null);
    }
  } else {
    if (r = Xr.o(), u = Qi(Qu([r, new $(null, 1, [0, new $(null, 1, [bc, Tt], null)], null)])), n = Dn.l(n, Ea, new v(null, 2, 5, y, [r, 0], null), Te([jf, u])), t = nt.j(n, t, !0), r = Cn(xr.g(sn(u), new v(null, 3, 5, y, [r, 0, bc], null))), r = Gl.h(r), t instanceof eB) return t = t.ec(null), e.g ? e.g(n, t) : e.call(null, n, t);
    try {
      return D(t, n, r);
    } catch (h) {
      if (h instanceof Error) return r = h, Al(n, 0, r, t);
      throw h;
    }
  }
  else {
    r = Xr.o(), u = Qi(Qu([r, new $(null, 1, [0, new $(null, 1, [bc, Tt], null)], null)])), n = Dn.l(n, Ea, new v(null, 2, 5, y, [r, 0], null), Te([jf, u])), t = nt.g(n, t), r = Cn(xr.g(sn(u), new v(null, 3, 5, y, [r, 0, bc], null))), r = Gl.h(r);
    try {
      return D(t, n, r);
    } catch (h) {
      if (h instanceof Error) return r = h, Al(n, 0, r, t);
      throw h;
    }
  }
};
Yu(Pne, tte);
var e2 = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
e2.g = function(e, n) {
  return e2.j(e, n, null);
};
e2.j = function(e, n, t) {
  var l = Mi, r = j(t) ? ie.h(t) : null;
  r = j(r) ? r : sn(Mi), mg(Qu([l, r]));
  try {
    var u = H4(x1(n));
    for (n = null; ; ) {
      var o = z3(e, u, null);
      if (Ln(yb, o)) return j(j(t) ? Rge.h(t) : null) ? new $(null, 2, [xb, n, ie, sn(Mi)], null) : n;
      n = tte(e, o);
    }
  } finally {
    Vm();
  }
};
e2.m = 3;
Yu(Vne, e2);
var Z0 = Math.E, X0 = Math.PI, uj, lte = new ArrayBuffer(4), SEe = new Uint32Array(lte), EEe = new Uint8Array(lte);
SEe[0] = 857870592;
var wa = (uj = EEe[0] === 0) ? 1 : 0, Tc = 1 - wa, rte = new ArrayBuffer(16), a4 = new Float64Array(rte), OEe = new Uint8Array(rte);
a4[0] = 0;
a4[1] = 0;
OEe[uj ? 15 : 8] = -128;
var bD = 0 + wa, TD = 0 + Tc, kEe = 2 + wa, bEe = 2 + Tc, TEe = c0(1609564160, 0), jEe = c0(535822336, 0);
ef.$b = {};
ef.$b.s = function(e, n, t) {
  return isNaN(t) || t == "" || e.length >= Number(t) ? e : e = -1 < n.indexOf("-", 0) ? e + _x(" ", Number(t) - e.length) : _x(" ", Number(t) - e.length) + e;
};
ef.$b.f = function(e, n, t, l, r) {
  l = e.toString(), isNaN(r) || r == "" || (l = parseFloat(e).toFixed(r));
  let u;
  return u = 0 > Number(e) ? "-" : 0 <= n.indexOf("+") ? "+" : 0 <= n.indexOf(" ") ? " " : "", 0 <= Number(e) && (l = u + l), isNaN(t) || l.length >= Number(t) || (l = isNaN(r) ? Math.abs(Number(e)).toString() : Math.abs(Number(e)).toFixed(r), e = Number(t) - l.length - u.length, 0 <= n.indexOf("-", 0) ? l = u + l + _x(" ", e) : (n = 0 <= n.indexOf("0", 0) ? "0" : " ", l = u + _x(n, e) + l)), l;
};
ef.$b.d = function(e, n, t, l, r, u, o, a) {
  return ef.$b.f(parseInt(e, 10), n, t, l, 0, u, o, a);
};
ef.$b.i = ef.$b.d;
ef.$b.u = ef.$b.d;
var ite = {
  ERAS: ["BC", "AD"],
  uf: ["Before Christ", "Anno Domini"],
  vf: "JFMAMJJASOND".split(""),
  Cf: "JFMAMJJASOND".split(""),
  MONTHS: "January February March April May June July August September October November December".split(" "),
  Bf: "January February March April May June July August September October November December".split(" "),
  yf: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
  Ef: "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),
  If: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
  Gf: "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),
  Af: "Sun Mon Tue Wed Thu Fri Sat".split(" "),
  Ff: "Sun Mon Tue Wed Thu Fri Sat".split(" "),
  wf: "SMTWTFS".split(""),
  Df: "SMTWTFS".split(""),
  zf: ["Q1", "Q2", "Q3", "Q4"],
  xf: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"],
  rf: ["AM", "PM"],
  sf: ["EEEE, MMMM d, y", "MMMM d, y", "MMM d, y", "M/d/yy"],
  Hf: ["h:mm:ss a zzzz", "h:mm:ss a z", "h:mm:ss a", "h:mm a"],
  tf: ["{1} 'at' {0}", "{1} 'at' {0}", "{1}, {0}", "{1}, {0}"],
  Ge: 6,
  Jf: [5, 6],
  He: 5
}, wF = ite;
wF = ite;
lc.prototype.ad = function(e) {
  var n = Math.min(this.years, this.months, this.days, this.xa, this.ya, this.seconds), t = Math.max(this.years, this.months, this.days, this.xa, this.ya, this.seconds);
  return 0 > n && 0 < t ? null : !e && n == 0 && t == 0 ? "PT0S" : (t = [], 0 > n && t.push("-"), t.push("P"), (this.years || e) && t.push(Math.abs(this.years) + "Y"), (this.months || e) && t.push(Math.abs(this.months) + "M"), (this.days || e) && t.push(Math.abs(this.days) + "D"), (this.xa || this.ya || this.seconds || e) && (t.push("T"), (this.xa || e) && t.push(Math.abs(this.xa) + "H"), (this.ya || e) && t.push(Math.abs(this.ya) + "M"), (this.seconds || e) && t.push(Math.abs(this.seconds) + "S")), t.join(""));
};
lc.prototype.equals = function(e) {
  return e.years == this.years && e.months == this.months && e.days == this.days && e.xa == this.xa && e.ya == this.ya && e.seconds == this.seconds;
};
lc.prototype.clone = function() {
  return new lc(this.years, this.months, this.days, this.xa, this.ya, this.seconds);
};
var ute = "y", ste = "m", vF = "d", ote = "h", yF = "n", _F = "s";
lc.prototype.isZero = function() {
  return this.years == 0 && this.months == 0 && this.days == 0 && this.xa == 0 && this.ya == 0 && this.seconds == 0;
};
lc.prototype.add = function(e) {
  this.years += e.years, this.months += e.months, this.days += e.days, this.xa += e.xa, this.ya += e.ya, this.seconds += e.seconds;
};
A = zc.prototype;
A.Dc = wF.Ge;
A.Ec = wF.He;
A.clone = function() {
  var e = new zc(this.date);
  return e.Dc = this.Dc, e.Ec = this.Ec, e;
};
A.getFullYear = function() {
  return this.date.getFullYear();
};
A.getYear = function() {
  return this.getFullYear();
};
A.getMonth = function() {
  return this.date.getMonth();
};
A.getDate = function() {
  return this.date.getDate();
};
A.getTime = function() {
  return this.date.getTime();
};
A.getDay = function() {
  return this.date.getDay();
};
A.getUTCFullYear = function() {
  return this.date.getUTCFullYear();
};
A.getUTCMonth = function() {
  return this.date.getUTCMonth();
};
A.getUTCDate = function() {
  return this.date.getUTCDate();
};
A.getUTCDay = function() {
  return this.date.getDay();
};
A.getUTCHours = function() {
  return this.date.getUTCHours();
};
A.getUTCMinutes = function() {
  return this.date.getUTCMinutes();
};
A.getTimezoneOffset = function() {
  return this.date.getTimezoneOffset();
};
A.set = function(e) {
  this.date = new Date(e.getFullYear(), e.getMonth(), e.getDate());
};
A.setFullYear = function(e) {
  this.date.setFullYear(e);
};
A.setYear = function(e) {
  this.setFullYear(e);
};
A.setMonth = function(e) {
  this.date.setMonth(e);
};
A.setDate = function(e) {
  this.date.setDate(e);
};
A.setTime = function(e) {
  this.date.setTime(e);
};
A.setUTCFullYear = function(e) {
  this.date.setUTCFullYear(e);
};
A.setUTCMonth = function(e) {
  this.date.setUTCMonth(e);
};
A.setUTCDate = function(e) {
  this.date.setUTCDate(e);
};
A.add = function(e) {
  if (e.years || e.months) {
    var n = this.getMonth() + e.months + 12 * e.years, t = this.getYear() + Math.floor(n / 12);
    n %= 12, 0 > n && (n += 12);
    var l = Math.min(KG(t, n), this.getDate());
    this.setDate(1), this.setFullYear(t), this.setMonth(n), this.setDate(l);
  }
  e.days && (t = this.getYear(), n = 0 <= t && 99 >= t ? -1900 : 0, e = new Date(new Date(t, this.getMonth(), this.getDate(), 12).getTime() + 864e5 * e.days), this.setDate(1), this.setFullYear(e.getFullYear() + n), this.setMonth(e.getMonth()), this.setDate(e.getDate()), wE(this, e.getDate()));
};
A.ad = function(e) {
  var n = this.getFullYear();
  const t = 0 > n ? "-" : 1e4 <= n ? "+" : "";
  return [t + Lh(Math.abs(n), t ? 6 : 4), Lh(this.getMonth() + 1, 2), Lh(this.getDate(), 2)].join(e ? "-" : "") + "";
};
A.equals = function(e) {
  return !(!e || this.getYear() != e.getYear() || this.getMonth() != e.getMonth() || this.getDate() != e.getDate());
};
A.toString = function() {
  return this.ad();
};
A.valueOf = function() {
  return this.date.valueOf();
};
Jz(Tu, zc);
A = Tu.prototype;
A.getHours = function() {
  return this.date.getHours();
};
A.getMinutes = function() {
  return this.date.getMinutes();
};
A.getSeconds = function() {
  return this.date.getSeconds();
};
A.getMilliseconds = function() {
  return this.date.getMilliseconds();
};
A.getUTCDay = function() {
  return this.date.getUTCDay();
};
A.getUTCHours = function() {
  return this.date.getUTCHours();
};
A.getUTCMinutes = function() {
  return this.date.getUTCMinutes();
};
A.getUTCSeconds = function() {
  return this.date.getUTCSeconds();
};
A.getUTCMilliseconds = function() {
  return this.date.getUTCMilliseconds();
};
A.setHours = function(e) {
  this.date.setHours(e);
};
A.setMinutes = function(e) {
  this.date.setMinutes(e);
};
A.setSeconds = function(e) {
  this.date.setSeconds(e);
};
A.setMilliseconds = function(e) {
  this.date.setMilliseconds(e);
};
A.setUTCHours = function(e) {
  this.date.setUTCHours(e);
};
A.setUTCMinutes = function(e) {
  this.date.setUTCMinutes(e);
};
A.setUTCSeconds = function(e) {
  this.date.setUTCSeconds(e);
};
A.setUTCMilliseconds = function(e) {
  this.date.setUTCMilliseconds(e);
};
A.add = function(e) {
  zc.prototype.add.call(this, e), e.xa && this.setUTCHours(this.date.getUTCHours() + e.xa), e.ya && this.setUTCMinutes(this.date.getUTCMinutes() + e.ya), e.seconds && this.setUTCSeconds(this.date.getUTCSeconds() + e.seconds);
};
A.ad = function(e) {
  var n = zc.prototype.ad.call(this, e);
  return e ? n + "T" + Lh(this.getHours(), 2) + ":" + Lh(this.getMinutes(), 2) + ":" + Lh(this.getSeconds(), 2) : n + "T" + Lh(this.getHours(), 2) + Lh(this.getMinutes(), 2) + Lh(this.getSeconds(), 2);
};
A.equals = function(e) {
  return this.getTime() == e.getTime();
};
A.toString = function() {
  return this.ad();
};
A.clone = function() {
  var e = new Tu(this.date);
  return e.Dc = this.Dc, e.Ec = this.Ec, e;
};
var ate = new v(null, 12, 5, y, "January February March April May June July August September October November December".split(" "), null), cte = new v(null, 7, 5, y, "Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "), null), jD = new v(null, 12, 5, y, [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], null);
Jz(Oh, Tu);
A = Oh.prototype;
A.clone = function() {
  var e = new Oh(this.date);
  return e.Dc = this.Dc, e.Ec = this.Ec, e;
};
A.add = function(e) {
  (e.years || e.months) && zc.prototype.add.call(this, new lc(e.years, e.months)), this.date = new Date(this.date.getTime() + 1e3 * (e.seconds + 60 * (e.ya + 60 * (e.xa + 24 * e.days))));
};
A.getTimezoneOffset = function() {
  return 0;
};
A.getFullYear = Tu.prototype.getUTCFullYear;
A.getMonth = Tu.prototype.getUTCMonth;
A.getDate = Tu.prototype.getUTCDate;
A.getHours = Tu.prototype.getUTCHours;
A.getMinutes = Tu.prototype.getUTCMinutes;
A.getSeconds = Tu.prototype.getUTCSeconds;
A.getMilliseconds = Tu.prototype.getUTCMilliseconds;
A.getDay = Tu.prototype.getUTCDay;
A.setFullYear = Tu.prototype.setUTCFullYear;
A.setMonth = Tu.prototype.setUTCMonth;
A.setDate = Tu.prototype.setUTCDate;
A.setHours = Tu.prototype.setUTCHours;
A.setMinutes = Tu.prototype.setUTCMinutes;
A.setSeconds = Tu.prototype.setUTCSeconds;
A.setMilliseconds = Tu.prototype.setUTCMilliseconds;
A = qh.prototype;
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  switch (n instanceof de ? n.ca : null) {
    case "start":
      return this.start;
    case "end":
      return this.end;
    default:
      return en.j(this.F, n, t);
  }
};
A.nb = function(e, n, t) {
  return wt.j(function(l, r) {
    var u = O.j(r, 0, null);
    return r = O.j(r, 1, null), n.j ? n.j(l, u, r) : n.call(null, l, u, r);
  }, t, this);
};
A.R = function(e, n, t) {
  return vr(n, function(l) {
    return vr(n, Wl, "", " ", "", t, l);
  }, "#cljs-time.core.Interval{", ", ", "}", t, he.g(new v(null, 2, 5, y, [new v(null, 2, 5, y, [ng, this.start], null), new v(null, 2, 5, y, [Jm, this.end], null)], null), this.F));
};
A.Xa = function() {
  return new hf(this, 2, new v(null, 2, 5, y, [ng, Jm], null), j(this.F) ? eo(this.F) : ed());
};
A.U = function() {
  return this.K;
};
A.$ = function() {
  return 2 + Cn(this.F);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = 534314193 ^ Na(this));
};
A.N = function(e, n) {
  return n != null && this.constructor === n.constructor && on.g(this.start, n.start) && on.g(this.end, n.end) && on.g(this.F, n.F);
};
A.sb = function(e, n) {
  return Ol(new gi(null, new $(null, 2, [ng, null, Jm, null], null), null), n) ? nr.g(su(lr.g(Tt, this), this.K), n) : new qh(this.start, this.end, this.K, Fo(nr.g(this.F, n)), null);
};
A.gb = function(e, n) {
  switch (n instanceof de ? n.ca : null) {
    case "start":
    case "end":
      return !0;
    default:
      return Ol(this.F, n);
  }
};
A.Aa = function(e, n, t) {
  return j(Ln.g ? Ln.g(ng, n) : Ln.call(null, ng, n)) ? new qh(t, this.end, this.K, this.F, null) : j(Ln.g ? Ln.g(Jm, n) : Ln.call(null, Jm, n)) ? new qh(this.start, t, this.K, this.F, null) : new qh(this.start, this.end, this.K, Dn.j(this.F, n, t), null);
};
A.W = function() {
  return z(he.g(new v(null, 2, 5, y, [new yl(ng, this.start), new yl(Jm, this.end)], null), this.F));
};
A.Z = function(e, n) {
  return new qh(this.start, this.end, n, this.F, this.H);
};
A.aa = function(e, n) {
  return or(n) ? this.Aa(null, Ul(n, 0), Ul(n, 1)) : wt.j(Qo, this, n);
};
A = Ha.prototype;
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  switch (n instanceof de ? n.ca : null) {
    case "years":
      return this.years;
    case "months":
      return this.months;
    case "weeks":
      return this.pb;
    case "days":
      return this.days;
    case "hours":
      return this.xa;
    case "minutes":
      return this.ya;
    case "seconds":
      return this.seconds;
    case "millis":
      return this.millis;
    default:
      return en.j(this.F, n, t);
  }
};
A.nb = function(e, n, t) {
  return wt.j(function(l, r) {
    var u = O.j(r, 0, null);
    return r = O.j(r, 1, null), n.j ? n.j(l, u, r) : n.call(null, l, u, r);
  }, t, this);
};
A.R = function(e, n, t) {
  return vr(n, function(l) {
    return vr(n, Wl, "", " ", "", t, l);
  }, "#cljs-time.core.Period{", ", ", "}", t, he.g(new v(null, 8, 5, y, [new v(null, 2, 5, y, [Zo, this.years], null), new v(null, 2, 5, y, [ls, this.months], null), new v(null, 2, 5, y, [uf, this.pb], null), new v(null, 2, 5, y, [$i, this.days], null), new v(null, 2, 5, y, [_o, this.xa], null), new v(null, 2, 5, y, [Lo, this.ya], null), new v(null, 2, 5, y, [Bo, this.seconds], null), new v(null, 2, 5, y, [yo, this.millis], null)], null), this.F));
};
A.Xa = function() {
  return new hf(this, 8, new v(null, 8, 5, y, [Zo, ls, uf, $i, _o, Lo, Bo, yo], null), j(this.F) ? eo(this.F) : ed());
};
A.U = function() {
  return this.K;
};
A.$ = function() {
  return 8 + Cn(this.F);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = 1393857022 ^ Na(this));
};
A.N = function(e, n) {
  return n != null && this.constructor === n.constructor && on.g(this.years, n.years) && on.g(this.months, n.months) && on.g(this.pb, n.pb) && on.g(this.days, n.days) && on.g(this.xa, n.xa) && on.g(this.ya, n.ya) && on.g(this.seconds, n.seconds) && on.g(this.millis, n.millis) && on.g(this.F, n.F);
};
A.sb = function(e, n) {
  return Ol(new gi(null, new $(null, 8, [ls, null, $i, null, Bo, null, _o, null, Zo, null, Lo, null, uf, null, yo, null], null), null), n) ? nr.g(su(lr.g(Tt, this), this.K), n) : new Ha(this.years, this.months, this.pb, this.days, this.xa, this.ya, this.seconds, this.millis, this.K, Fo(nr.g(this.F, n)), null);
};
A.gb = function(e, n) {
  switch (n instanceof de ? n.ca : null) {
    case "years":
    case "months":
    case "weeks":
    case "days":
    case "hours":
    case "minutes":
    case "seconds":
    case "millis":
      return !0;
    default:
      return Ol(this.F, n);
  }
};
A.Aa = function(e, n, t) {
  return j(Ln.g ? Ln.g(Zo, n) : Ln.call(null, Zo, n)) ? new Ha(t, this.months, this.pb, this.days, this.xa, this.ya, this.seconds, this.millis, this.K, this.F, null) : j(Ln.g ? Ln.g(ls, n) : Ln.call(null, ls, n)) ? new Ha(this.years, t, this.pb, this.days, this.xa, this.ya, this.seconds, this.millis, this.K, this.F, null) : j(Ln.g ? Ln.g(uf, n) : Ln.call(null, uf, n)) ? new Ha(this.years, this.months, t, this.days, this.xa, this.ya, this.seconds, this.millis, this.K, this.F, null) : j(Ln.g ? Ln.g($i, n) : Ln.call(null, $i, n)) ? new Ha(
    this.years,
    this.months,
    this.pb,
    t,
    this.xa,
    this.ya,
    this.seconds,
    this.millis,
    this.K,
    this.F,
    null
  ) : j(Ln.g ? Ln.g(_o, n) : Ln.call(null, _o, n)) ? new Ha(this.years, this.months, this.pb, this.days, t, this.ya, this.seconds, this.millis, this.K, this.F, null) : j(Ln.g ? Ln.g(Lo, n) : Ln.call(null, Lo, n)) ? new Ha(this.years, this.months, this.pb, this.days, this.xa, t, this.seconds, this.millis, this.K, this.F, null) : j(Ln.g ? Ln.g(Bo, n) : Ln.call(null, Bo, n)) ? new Ha(this.years, this.months, this.pb, this.days, this.xa, this.ya, t, this.millis, this.K, this.F, null) : j(Ln.g ? Ln.g(
    yo,
    n
  ) : Ln.call(null, yo, n)) ? new Ha(this.years, this.months, this.pb, this.days, this.xa, this.ya, this.seconds, t, this.K, this.F, null) : new Ha(this.years, this.months, this.pb, this.days, this.xa, this.ya, this.seconds, this.millis, this.K, Dn.j(this.F, n, t), null);
};
A.W = function() {
  return z(he.g(new v(null, 8, 5, y, [new yl(Zo, this.years), new yl(ls, this.months), new yl(uf, this.pb), new yl($i, this.days), new yl(_o, this.xa), new yl(Lo, this.ya), new yl(Bo, this.seconds), new yl(yo, this.millis)], null), this.F));
};
A.Z = function(e, n) {
  return new Ha(this.years, this.months, this.pb, this.days, this.xa, this.ya, this.seconds, this.millis, n, this.F, this.H);
};
A.aa = function(e, n) {
  return or(n) ? this.Aa(null, Ul(n, 0), Ul(n, 1)) : wt.j(Qo, this, n);
};
var gv = new $(null, 2, [yo, function(e, n, t) {
  var l = e.getTime();
  return n = n.g ? n.g(l, t) : n.call(null, l, t), e.setTime(n), e;
}, uf, function(e, n, t) {
  return t *= 7, n = n.g ? n.g(0, t) : n.call(null, 0, t), e.add(new lc(vF, n)), e;
}], null), wv = new $(null, 6, [Bo, _F, Lo, yF, _o, ote, $i, vF, ls, ste, Zo, ute], null);
A = Oh.prototype;
A.md = function() {
  return this.getYear();
};
A.kd = function() {
  return this.getMonth() + 1;
};
A.fd = function() {
  var e = this.getDay();
  return j(tp.g ? tp.g(e, 0) : tp.call(null, e, 0)) ? 7 : e;
};
A.gd = function(e, n) {
  return this.getTime() === n.getTime();
};
A.dd = function(e, n) {
  return this.getTime() > n.getTime();
};
A.ed = function(e, n) {
  return this.getTime() < n.getTime();
};
A.ld = function(e, n) {
  return x2(n)(rc, this);
};
A.jd = function(e, n) {
  return x2(n)(Lc, this);
};
A.hd = function() {
  return jy(new Oh(this.getYear(), this.getMonth() + 1, 1, 0, 0, 0, 0), gg($i, 1));
};
A = Tu.prototype;
A.md = function() {
  return this.getYear();
};
A.kd = function() {
  return this.getMonth() + 1;
};
A.fd = function() {
  var e = this.getDay();
  return j(tp.g ? tp.g(e, 0) : tp.call(null, e, 0)) ? 7 : e;
};
A.gd = function(e, n) {
  return this.getTime() === n.getTime();
};
A.dd = function(e, n) {
  return this.getTime() > n.getTime();
};
A.ed = function(e, n) {
  return this.getTime() < n.getTime();
};
A.ld = function(e, n) {
  return x2(n)(rc, this);
};
A.jd = function(e, n) {
  return x2(n)(Lc, this);
};
A.hd = function() {
  return jy(new Tu(this.getYear(), this.getMonth() + 1, 1, 0, 0, 0, 0), gg($i, 1));
};
A = zc.prototype;
A.md = function() {
  return this.getYear();
};
A.kd = function() {
  return this.getMonth() + 1;
};
A.fd = function() {
  var e = this.getDay();
  return j(tp.g ? tp.g(e, 0) : tp.call(null, e, 0)) ? 7 : e;
};
A.gd = function(e, n) {
  return this.equals(n);
};
A.dd = function(e, n) {
  return 0 < JG(this, n);
};
A.ed = function(e, n) {
  return 0 > JG(this, n);
};
A.ld = function(e, n) {
  return x2(n)(rc, this);
};
A.jd = function(e, n) {
  return x2(n)(Lc, this);
};
A.hd = function() {
  return jy(new zc(this.getYear(), this.getMonth() + 1, 1), gg($i, 1));
};
var AEe = { id: "UTC", std_offset: 0, names: new v(null, 1, 5, y, ["UTC"], null), transitions: Dt }, dr = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 3:
      return e.j(arguments[0], arguments[1], arguments[2]);
    case 4:
      return e.B(arguments[0], arguments[1], arguments[2], arguments[3]);
    case 5:
      return e.I(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4]);
    case 6:
      return e.T(
        arguments[0],
        arguments[1],
        arguments[2],
        arguments[3],
        arguments[4],
        arguments[5]
      );
    case 7:
      return e.ba(arguments[0], arguments[1], arguments[2], arguments[3], arguments[4], arguments[5], arguments[6]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
dr.h = function(e) {
  return dr.ba(e, 1, 1, 0, 0, 0, 0);
};
dr.g = function(e, n) {
  return dr.ba(e, n, 1, 0, 0, 0, 0);
};
dr.j = function(e, n, t) {
  return dr.ba(e, n, t, 0, 0, 0, 0);
};
dr.B = function(e, n, t, l) {
  return dr.ba(e, n, t, l, 0, 0, 0);
};
dr.I = function(e, n, t, l, r) {
  return dr.ba(e, n, t, l, r, 0, 0);
};
dr.T = function(e, n, t, l, r, u) {
  return dr.ba(e, n, t, l, r, u, 0);
};
dr.ba = function(e, n, t, l, r, u, o) {
  return new Oh(e, n - 1, t, l, r, u, o);
};
dr.m = 7;
var Ra = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
      return e.l(arguments[0], arguments[1], new hn(t.slice(2), 0, null));
  }
};
Ra.g = function(e, n) {
  return Kw(e, n);
};
Ra.l = function(e, n, t) {
  return wt.j(Kw, Kw(e, n), t);
};
Ra.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
Ra.m = 2;
var n2 = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
n2.g = function(e, n) {
  return j(yx(e, n)) ? e : n;
};
n2.h = function(e) {
  return wt.g(n2, e);
};
n2.m = 2;
var t2 = function e(n) {
  switch (arguments.length) {
    case 2:
      return e.g(arguments[0], arguments[1]);
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
t2.g = function(e, n) {
  return j(vx(e, n)) ? e : n;
};
t2.h = function(e) {
  return wt.g(t2, e);
};
t2.m = 2;
A = Ha.prototype;
A.Kd = function(e) {
  e = fr(e), en.g(e, yo), en.g(e, Bo), en.g(e, Lo), en.g(e, _o), en.g(e, $i), en.g(e, uf), en.g(e, ls), en.g(e, Zo);
  var n = fr(this);
  e = en.g(n, yo);
  var t = en.g(n, Bo), l = en.g(n, Lo), r = en.g(n, _o), u = en.g(n, $i), o = en.g(n, uf), a = en.g(n, ls);
  return n = en.g(n, Zo), j(a) ? wq(ls) : j(n) ? wq(Zo) : e + 1e3 * t + 6e4 * l + 36e5 * r + 864e5 * u + 6048e5 * o;
};
A.Md = function() {
  return _k(this) / 1e3 | 0;
};
A.Ld = function() {
  return xk(this) / 60 | 0;
};
A.Jd = function() {
  return Sk(this) / 60 | 0;
};
A.Id = function() {
  return Ek(this) / 24 | 0;
};
A = qh.prototype;
A.Kd = function(e) {
  e = fr(e), en.g(e, ng), en.g(e, Jm), e = fr(this);
  var n = en.g(e, ng);
  return en.g(e, Jm).getTime() - n.getTime();
};
A.Md = function() {
  return _k(this) / 1e3 | 0;
};
A.Ld = function() {
  return xk(this) / 60 | 0;
};
A.Jd = function() {
  return Sk(this) / 60 | 0;
};
A.Id = function() {
  return Ek(this) / 24 | 0;
};
var r3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
r3.h = function(e) {
  return r3.g(e, e);
};
r3.g = function(e, n) {
  return function(t, l) {
    return pf(t, l, l.getMilliseconds(), e, n);
  };
};
r3.m = 2;
var i3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
i3.h = function(e) {
  return i3.g(e, e);
};
i3.g = function(e, n) {
  return function(t, l) {
    return pf(t, l, l.getSeconds(), e, n);
  };
};
i3.m = 2;
var u3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
u3.h = function(e) {
  return u3.g(e, e);
};
u3.g = function(e, n) {
  return function(t, l) {
    return pf(t, l, l.getMinutes(), e, n);
  };
};
u3.m = 2;
var s3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
s3.h = function(e) {
  return s3.g(e, e);
};
s3.g = function(e, n) {
  return function(t, l) {
    var r = ya(l.getHours(), 12);
    return pf(t, l, r === 0 ? 12 : r, e, n);
  };
};
s3.m = 2;
var o3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
o3.h = function(e) {
  return o3.g(e, e);
};
o3.g = function(e, n) {
  return function(t, l) {
    return pf(t, l, l.getHours(), e, n);
  };
};
o3.m = 2;
var a3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
a3.h = function(e) {
  return a3.g(e, e);
};
a3.g = function(e, n) {
  return function(t, l) {
    return pf(t, l, l.getDate(), e, n);
  };
};
a3.m = 2;
var c3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
c3.h = function(e) {
  return c3.g(e, e);
};
c3.g = function(e, n) {
  return function(t, l) {
    var r = l.getDay();
    return r = on.g(r, 0) ? 7 : r, pf(t, l, r, e, n);
  };
};
c3.m = 2;
var h3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
h3.h = function(e) {
  return h3.g(e, e);
};
h3.g = function(e, n) {
  return function(t, l) {
    return pf(t, l, l.getMonth() + 1, e, n);
  };
};
h3.m = 2;
var f3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
f3.h = function(e) {
  return f3.g(e, e);
};
f3.g = function(e, n) {
  return function(t, l) {
    return pf(t, l, l.getYear(), e, n);
  };
};
f3.m = 2;
var d3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
d3.h = function(e) {
  return d3.g(e, e);
};
d3.g = function(e, n) {
  return function(t, l) {
    var r = l.getYear(), u = l.getMonth(), o = l.getDate(), a = gw(Te([u, 0])), h = gw(Te([u, 11]));
    return u = GG(r, u, o), r = j(j(a) ? 52 <= u : a) ? r - 1 : j(j(h) ? gw(Te([u, 1])) : h) ? r + 1 : r, pf(t, l, r, e, n);
  };
};
d3.m = 2;
var p3 = function e(n) {
  switch (arguments.length) {
    case 1:
      return e.h(arguments[0]);
    case 2:
      return e.g(arguments[0], arguments[1]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
p3.h = function(e) {
  return p3.g(e, e);
};
p3.g = function(e, n) {
  return function(t, l) {
    return pf(t, l, GG(l.getYear(), l.getMonth(), l.getDate()), e, n);
  };
};
p3.m = 2;
A = Wd.prototype;
A.wa = function(e, n) {
  return this.P(null, n, null);
};
A.P = function(e, n, t) {
  switch (n instanceof de ? n.ca : null) {
    case "format-str":
      return this.Eb;
    case "overrides":
      return this.Kb;
    case "default-year":
      return this.Db;
    case "timezone":
      return this.Lb;
    default:
      return en.j(this.F, n, t);
  }
};
A.nb = function(e, n, t) {
  return wt.j(function(l, r) {
    var u = O.j(r, 0, null);
    return r = O.j(r, 1, null), n.j ? n.j(l, u, r) : n.call(null, l, u, r);
  }, t, this);
};
A.R = function(e, n, t) {
  return vr(n, function(l) {
    return vr(n, Wl, "", " ", "", t, l);
  }, "#cljs-time.format.Formatter{", ", ", "}", t, he.g(new v(null, 4, 5, y, [new v(null, 2, 5, y, [Hh, this.Eb], null), new v(null, 2, 5, y, [eg, this.Kb], null), new v(null, 2, 5, y, [Ep, this.Db], null), new v(null, 2, 5, y, [Oa, this.Lb], null)], null), this.F));
};
A.Xa = function() {
  return new hf(this, 4, new v(null, 4, 5, y, [Hh, eg, Ep, Oa], null), j(this.F) ? eo(this.F) : ed());
};
A.U = function() {
  return this.K;
};
A.$ = function() {
  return 4 + Cn(this.F);
};
A.O = function() {
  var e = this.H;
  return e ?? (this.H = e = -987738732 ^ Na(this));
};
A.N = function(e, n) {
  return n != null && this.constructor === n.constructor && on.g(this.Eb, n.Eb) && on.g(this.Kb, n.Kb) && on.g(this.Db, n.Db) && on.g(this.Lb, n.Lb) && on.g(this.F, n.F);
};
A.sb = function(e, n) {
  return Ol(new gi(null, new $(null, 4, [Oa, null, eg, null, Hh, null, Ep, null], null), null), n) ? nr.g(su(lr.g(Tt, this), this.K), n) : new Wd(this.Eb, this.Kb, this.Db, this.Lb, this.K, Fo(nr.g(this.F, n)), null);
};
A.gb = function(e, n) {
  switch (n instanceof de ? n.ca : null) {
    case "format-str":
    case "overrides":
    case "default-year":
    case "timezone":
      return !0;
    default:
      return Ol(this.F, n);
  }
};
A.Aa = function(e, n, t) {
  return j(Ln.g ? Ln.g(Hh, n) : Ln.call(null, Hh, n)) ? new Wd(t, this.Kb, this.Db, this.Lb, this.K, this.F, null) : j(Ln.g ? Ln.g(eg, n) : Ln.call(null, eg, n)) ? new Wd(this.Eb, t, this.Db, this.Lb, this.K, this.F, null) : j(Ln.g ? Ln.g(Ep, n) : Ln.call(null, Ep, n)) ? new Wd(this.Eb, this.Kb, t, this.Lb, this.K, this.F, null) : j(Ln.g ? Ln.g(Oa, n) : Ln.call(null, Oa, n)) ? new Wd(this.Eb, this.Kb, this.Db, t, this.K, this.F, null) : new Wd(this.Eb, this.Kb, this.Db, this.Lb, this.K, Dn.j(this.F, n, t), null);
};
A.W = function() {
  return z(he.g(new v(null, 4, 5, y, [new yl(Hh, this.Eb), new yl(eg, this.Kb), new yl(Ep, this.Db), new yl(Oa, this.Lb)], null), this.F));
};
A.Z = function(e, n) {
  return new Wd(this.Eb, this.Kb, this.Db, this.Lb, n, this.F, this.H);
};
A.aa = function(e, n) {
  return or(n) ? this.Aa(null, Ul(n, 0), Ul(n, 1)) : wt.j(Qo, this, n);
};
var sj = Gn([jne, A0e, u0e, n0e, hr, p_e, zwe, eve, $0e, bge, W_e, RB, i1e, hQ, pve, fge, eX, k1e, _0e, wne, a1e, Dye, v2e, sxe, pge, qge, Wye, y2e, _w, Pge, Dge, tye, D2e, Pve, lQ, yne, lw, a_e, hve, j2e, a1, PQ, Sge, fxe, zJ, M2e, lye, QX, S0e, jye, swe, Yye, L2e], [
  tm(T2e),
  Zl("HH:mm"),
  Zl("'T'HH:mm:ss.SSSZZ"),
  Zl("yyyyDDD"),
  Zl("yyyy-MM-dd"),
  Zl("HH"),
  Zl("HH:mm:ssZZ"),
  Zl("xxxx-'W'ww-e"),
  Zl("xxxx-'W'ww-e'T'HH:mm:ss.SSSZZ"),
  Zl("yyyy-MM-dd'T'HH:mm:ss.SSS"),
  Zl("yyyyMMdd'T'HHmmss.SSSZ"),
  Zl("yyyy-MM-dd'T'HH:mm:ss.SSSZZ"),
  Zl("HHmmssZ"),
  tm(C0e),
  Zl("xxxx'W'wwe"),
  Zl("'T'HHmmssZ"),
  tm(r1e),
  Zl("yyyy-MM-dd'T'HH:mm:ssZZ"),
  Zl("yyyy-MM-dd"),
  tm(Jwe),
  Zl("EEE, dd MMM yyyy HH:mm:ss Z"),
  Zl("yyyy-MM-dd'T'HH:mm:ss.SSS"),
  Zl("yyyyDDD'T'HHmmss.SSSZ"),
  Zl("yyyy-DDD"),
  Zl("HH:mm:ss.SSS"),
  Zl("yyyy-MM-dd'T'HH:mm"),
  Zl("HH:mm:ss.SSSZZ"),
  Zl("xxxx'W'wwe'T'HHmmss.SSSZ"),
  Zl("xxxx"),
  Zl("HHmmss.SSSZ"),
  Zl("HH:mm:ss"),
  Zl("yyyy-DDD'T'HH:mm:ss.SSSZZ"),
  Zl("yyyy-DDD'T'HH:mm:ssZZ"),
  Zl("HH:mm:ss.SSS"),
  Zl(N0e),
  tm(Pye),
  Zl("yyyy"),
  Zl("'T'HH:mm:ssZZ"),
  Zl("xxxx'W'wwe'T'HHmmssZ"),
  Zl("yyyyMMdd"),
  Zl("xxxx-'W'ww"),
  tm(X1e),
  Zl("yyyyDDD'T'HHmmssZ"),
  Zl("yyyy-MM"),
  tm(pxe),
  Zl("xxxx-'W'ww-e"),
  Zl("yyyy-MM-dd'T'HH"),
  tm(w2e),
  Zl("yyyy-MM-dd'T'HH:mm:ss"),
  Zl("xxxx-'W'ww-e'T'HH:mm:ssZZ"),
  Zl("yyyyMMdd'T'HHmmssZ"),
  Zl("yyyy-MM-dd HH:mm:ss"),
  Zl("'T'HHmmss.SSSZ")
]), DEe = new gi(null, new $(null, 9, [jne, null, hQ, null, eX, null, wne, null, lQ, null, yne, null, PQ, null, zJ, null, QX, null], null), null);
ig.g(Us(xi(sj)), DEe);
Iy.null = function() {
  return null;
};
Date.prototype.Qc = function() {
  var e = this == null ? null : this.getTime();
  return e == null ? null : tb(e);
};
zc.prototype.Qc = function() {
  return j(this) ? P_(this.getTime()) : null;
};
Tu.prototype.Qc = function() {
  return j(this) ? P_(this.getTime()) : null;
};
Oh.prototype.Qc = function() {
  return this;
};
Iy.number = function(e) {
  return tb(e);
};
Iy.string = function(e) {
  return _me(e);
};
lr.g(Tt, bt.g(function(e) {
  var n = O.j(e, 0, null);
  return e = O.j(e, 1, null), new v(null, 2, 5, y, [n, on.g(zi.h(Vt(e)), c1e) ? bu.j(e, new v(null, 1, 5, y, [qwe], null), function(t) {
    return new Tu(t);
  }) : e], null);
}, sj));
var op = Zl("yyyy-MM-dd"), jE = Zl("yyyy-MM-dd H:m:s"), Tm = new $(null, 2, [hr, op, RB, jE], null), jm = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
jm.l = function(e) {
  var n = fr(e);
  return e = en.g(n, xo), n = en.j(n, pQ, !1), n = j(n) ? nZ() : tZ(), e == null ? lb(n) / 1e3 | 0 : So(en.j(Tm, e, op), n);
};
jm.m = 0;
jm.v = function(e) {
  return this.l(z(e));
};
var Q0 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
Q0.l = function(e, n) {
  return n = fr(n), n = en.j(n, xo, hr), So(en.j(Tm, n, op), tb(1e3 * e));
};
Q0.m = 1;
Q0.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
var Tw = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
Tw.l = function(e, n, t) {
  var l = fr(t);
  t = en.j(l, Uy, Ls), l = en.j(l, xo, hr);
  var r = $_(e, n);
  return e = new $(null, 2, [nne, e, Ls, n], null), So(en.j(Tm, l, op), Ra.g(en.j(e, t, Ls.h(e)), ea(r)));
};
Tw.m = 2;
Tw.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var J0 = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
J0.l = function(e, n, t) {
  var l = fr(t);
  t = en.j(l, xo, $i);
  var r = en.j(l, Uy, Ls);
  return l = en.j(l, Ib, hr), e = Ki(e), n = Ki(n), on.g(t, $i) ? $_(e, n) : Tw.l(e, n, Te([Uy, r, xo, l]));
};
J0.m = 2;
J0.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var ey = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
ey.l = function(e, n, t) {
  return t = fr(t), t = en.j(t, xo, hr), e = Ki(e), n = n ?? 0, So(en.j(Tm, t, op), Ra.g(e, ea(Df(n))));
};
ey.m = 2;
ey.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var ny = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
ny.l = function(e, n, t) {
  return t = fr(t), t = en.j(t, xo, hr), e = Ki(e), n = n ?? 0, So(en.j(Tm, t, op), Gw(e, ea(Df(n))));
};
ny.m = 2;
ny.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var ty = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
ty.o = function() {
  return on.g(1, (/* @__PURE__ */ new Date()).getDate());
};
ty.h = function(e) {
  return on.g(1, G4(e).getDate());
};
ty.m = 1;
var Fh = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Fh.o = function() {
  return Ay(Ki(jm.l(Te([xo, hr])))).getDate();
};
Fh.h = function(e) {
  return Ay(Ki(e)).getDate();
};
Fh.m = 1;
var ly = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
ly.o = function() {
  return on.g(Fh.o(), (/* @__PURE__ */ new Date()).getDate());
};
ly.h = function(e) {
  return on.g(Fh.h(e), G4(e).getDate());
};
ly.m = 1;
var jw = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
jw.o = function() {
  return jw.h(jm.l(Te([xo, hr])));
};
jw.h = function(e) {
  return So(Zl("dd"), Ki(e));
};
jw.m = 1;
var AE = Eh(function(e) {
  var n = no(dr.j(e, 1, 1));
  return dr.j(e, 1, en.j(new v(null, 7, 5, y, [null, 15, 21, 20, 19, 18, 17], null), n, 16));
}), DE = Eh(function(e) {
  var n = no(dr.j(e, 2, 1));
  return dr.j(e, 2, en.j(new v(null, 7, 5, y, [null, 15, 21, 20, 19, 18, 17], null), n, 16));
}), IE = Eh(function(e) {
  var n = no(dr.j(e, 5, 31));
  return dr.j(e, 5, en.j(new v(null, 7, 5, y, [null, 31, 30, 29, 28, 27, 26], null), n, 25));
}), RE = Eh(function(e) {
  var n = no(dr.j(e, 9, 1));
  return dr.j(e, 9, en.j(new v(null, 7, 5, y, [null, 1, 7, 6, 5, 4, 3], null), n, 2));
}), NE = Eh(function(e) {
  var n = no(dr.j(
    e,
    10,
    1
  ));
  return dr.j(e, 10, en.j(new v(null, 7, 5, y, [null, 8, 14, 13, 12, 11, 10], null), n, 9));
}), CE = Eh(function(e) {
  var n = no(dr.j(e, 11, 1));
  return dr.j(e, 11, en.j(new v(null, 7, 5, y, [null, 25, 24, 23, 22, 28, 27], null), n, 26));
}), G_ = Eh(function(e) {
  return G3(dr.j(e, 1, 1));
}), ME = Eh(function(e) {
  return G3(dr.j(e, 7, 4));
}), PE = Eh(function(e) {
  return G3(dr.j(e, 12, 25));
}), $E = Eh(function(e) {
  return G3(dr.j(e, 11, 11));
}), LE = Eh(function(e) {
  return G3(dr.j(e, 6, 19));
}), Pa = ia(13, {}), O5 = lo(Pa, "Period"), k5 = lo(Pa, "Instant"), b5 = lo(Pa, "Duration"), T5 = lo(Pa, "LocalDate"), j5 = lo(Pa, "LocalTime"), A5 = lo(Pa, "ZonedDateTime"), D5 = lo(Pa, "LocalDateTime"), I5 = lo(Pa, "MonthDay"), R5 = lo(Pa, "Year"), N5 = lo(Pa, "YearMonth"), C5 = lo(Pa, "ZoneId"), M5 = lo(Pa, "DayOfWeek"), P5 = lo(Pa, "Month"), $5 = lo(Pa, "OffsetDateTime"), L5 = lo(Pa, "OffsetTime");
I5.prototype.Za = Rn;
I5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
N5.prototype.Za = Rn;
N5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
R5.prototype.Za = Rn;
R5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
A5.prototype.Za = Rn;
A5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
L5.prototype.Za = Rn;
L5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
k5.prototype.Za = Rn;
k5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
C5.prototype.Za = Rn;
C5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
T5.prototype.Za = Rn;
T5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
j5.prototype.Za = Rn;
j5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
$5.prototype.Za = Rn;
$5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
D5.prototype.Za = Rn;
D5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
P5.prototype.Za = Rn;
P5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
O5.prototype.Za = Rn;
O5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
M5.prototype.Za = Rn;
M5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
b5.prototype.Za = Rn;
b5.prototype.Ua = function(e, n) {
  return this.compareTo(n);
};
I5.prototype.N = function(e, n) {
  return this.equals(n);
};
N5.prototype.N = function(e, n) {
  return this.equals(n);
};
R5.prototype.N = function(e, n) {
  return this.equals(n);
};
A5.prototype.N = function(e, n) {
  return this.equals(n);
};
L5.prototype.N = function(e, n) {
  return this.equals(n);
};
k5.prototype.N = function(e, n) {
  return this.equals(n);
};
C5.prototype.N = function(e, n) {
  return this.equals(n);
};
T5.prototype.N = function(e, n) {
  return this.equals(n);
};
j5.prototype.N = function(e, n) {
  return this.equals(n);
};
$5.prototype.N = function(e, n) {
  return this.equals(n);
};
D5.prototype.N = function(e, n) {
  return this.equals(n);
};
P5.prototype.N = function(e, n) {
  return this.equals(n);
};
O5.prototype.N = function(e, n) {
  return this.equals(n);
};
M5.prototype.N = function(e, n) {
  return this.equals(n);
};
b5.prototype.N = function(e, n) {
  return this.equals(n);
};
I5.prototype.mb = Rn;
I5.prototype.O = function() {
  return this.dayOfMonth() + (this.month().value() << 6);
};
N5.prototype.mb = Rn;
N5.prototype.O = function() {
  return this.year() ^ this.monthValue() << 27;
};
R5.prototype.mb = Rn;
R5.prototype.O = function() {
  return this.value();
};
A5.prototype.mb = Rn;
A5.prototype.O = function() {
  return this.hashCode();
};
L5.prototype.mb = Rn;
L5.prototype.O = function() {
  return this.hashCode();
};
k5.prototype.mb = Rn;
k5.prototype.O = function() {
  return this.hashCode();
};
C5.prototype.mb = Rn;
C5.prototype.O = function() {
  return this.hashCode();
};
T5.prototype.mb = Rn;
T5.prototype.O = function() {
  return this.hashCode();
};
j5.prototype.mb = Rn;
j5.prototype.O = function() {
  return this.hashCode();
};
$5.prototype.mb = Rn;
$5.prototype.O = function() {
  return this.hashCode();
};
D5.prototype.mb = Rn;
D5.prototype.O = function() {
  return this.hashCode();
};
P5.prototype.mb = Rn;
P5.prototype.O = function() {
  return this.value();
};
O5.prototype.mb = Rn;
O5.prototype.O = function() {
  return this.hashCode();
};
M5.prototype.mb = Rn;
M5.prototype.O = function() {
  return this.value();
};
b5.prototype.mb = Rn;
b5.prototype.O = function() {
  return 51 * this.nano() + (this.seconds() ^ this.seconds() >>> 32 | 0);
};
var Nc = Zl("yyyy-MM-dd"), BE = Zl("yyyy-MM-dd H:m:s"), Am = new $(null, 2, [hr, Nc, RB, BE], null), Dm = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(0 < t.length ? new hn(t.slice(0), 0, null) : null);
};
Dm.l = function(e) {
  var n = fr(e);
  return e = en.g(n, xo), n = en.j(n, pQ, !1), n = j(n) ? nZ() : tZ(), e == null ? lb(n) / 1e3 | 0 : So(en.j(Am, e, Nc), n);
};
Dm.m = 0;
Dm.v = function(e) {
  return this.l(z(e));
};
var ry = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], 1 < t.length ? new hn(t.slice(1), 0, null) : null);
};
ry.l = function(e, n) {
  return n = fr(n), n = en.j(n, xo, hr), So(en.j(Am, n, Nc), tb(1e3 * e));
};
ry.m = 1;
ry.v = function(e) {
  var n = I(e);
  return e = W(e), this.l(n, e);
};
var Aw = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
Aw.l = function(e, n, t) {
  var l = fr(t);
  t = en.j(l, Uy, Ls), l = en.j(l, xo, hr);
  var r = B_(e, n);
  return e = new $(null, 2, [nne, e, Ls, n], null), So(en.j(Am, l, Nc), Ra.g(en.j(e, t, Ls.h(e)), ea(r)));
};
Aw.m = 2;
Aw.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var iy = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
iy.l = function(e, n, t) {
  var l = fr(t);
  t = en.j(l, xo, $i);
  var r = en.j(l, Uy, Ls);
  return l = en.j(l, Ib, hr), e = Ki(e), n = Ki(n), on.g(t, $i) ? B_(e, n) : Aw.l(e, n, Te([Uy, r, xo, l]));
};
iy.m = 2;
iy.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var uy = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
uy.l = function(e, n, t) {
  return t = fr(t), t = en.j(t, xo, hr), e = Ki(e), n = n ?? 0, So(en.j(Am, t, Nc), Ra.g(e, ea(Df(n))));
};
uy.m = 2;
uy.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var sy = function e(n) {
  for (var t = [], l = arguments.length, r = 0; r < l; ) t.push(arguments[r]), r += 1;
  return e.l(arguments[0], arguments[1], 2 < t.length ? new hn(t.slice(2), 0, null) : null);
};
sy.l = function(e, n, t) {
  return t = fr(t), t = en.j(t, xo, hr), e = Ki(e), n = n ?? 0, So(en.j(Am, t, Nc), Gw(e, ea(Df(n))));
};
sy.m = 2;
sy.v = function(e) {
  var n = I(e), t = W(e);
  return e = I(t), t = W(t), this.l(n, e, t);
};
var oy = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
oy.o = function() {
  return on.g(1, (/* @__PURE__ */ new Date()).getDate());
};
oy.h = function(e) {
  return on.g(1, G4(e).getDate());
};
oy.m = 1;
var Vh = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Vh.o = function() {
  return Ay(Ki(Dm.l(Te([xo, hr])))).getDate();
};
Vh.h = function(e) {
  return Ay(Ki(e)).getDate();
};
Vh.m = 1;
var ay = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
ay.o = function() {
  return on.g(Vh.o(), (/* @__PURE__ */ new Date()).getDate());
};
ay.h = function(e) {
  return on.g(Vh.h(e), G4(e).getDate());
};
ay.m = 1;
var Dw = function e(n) {
  switch (arguments.length) {
    case 0:
      return e.o();
    case 1:
      return e.h(arguments[0]);
    default:
      throw Error(["Invalid arity: ", ye.h(arguments.length)].join(""));
  }
};
Dw.o = function() {
  return Dw.h(Dm.l(Te([xo, hr])));
};
Dw.h = function(e) {
  return So(Zl("dd"), Ki(e));
};
Dw.m = 1;
var IEe = yt.l(lr.g(Tt, new v(null, 2, 5, y, [new v(null, 2, 5, y, [_n.h("concat-key"), new Jn(function() {
  return b0;
}, yee, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Bk, vQ, "ruler/utils/string.cljc", 17, 1, 4, 4, ue(new v(null, 2, 5, y, [Bt, Wa], null)), "Return a string concatenation of all the values represented by key", j(b0) ? b0.D : null]))], null), new v(
  null,
  2,
  5,
  y,
  [_n.h("serialize"), new Jn(function() {
    return T0;
  }, vX, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Bk, see, "ruler/utils/string.cljc", 16, 1, 9, 9, ue(new v(null, 1, 5, y, [Bt], null)), null, j(T0) ? T0.D : null]))],
  null
)], null)), lr.g(Tt, C3([new v(null, 2, 5, y, [_n.h("juneteenth-day-m"), new Jn(function() {
  return LE;
}, a2e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, Wwe, "ruler/utils/clj_time.cljc", 22, 1, 249, 249, fl, null, j(LE) ? LE.D : null]))], null), new v(null, 2, 5, y, [_n.h("after-nth-of-month"), new Jn(function() {
  return RA;
}, b_e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [
  ji,
  UJ,
  "ruler/utils/clj_time.cljc",
  25,
  1,
  156,
  156,
  ue(new v(null, 3, 5, y, [Xl, $0, N0], null)),
  '"is this date strictly after the 3rd within 2 months from today" is the same as (u/after-nt-of-month "this date" 2 3)',
  j(RA) ? RA.D : null
]))], null), new v(null, 2, 5, y, [_n.h("date-format-with-time"), new Jn(function() {
  return jE;
}, dge, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, EQ, "ruler/utils/clj_time.cljc", 27, 1, 20, 20, fl, null, j(jE) ? jE.D : null]))], null), new v(null, 2, 5, y, [_n.h("timestamp"), new Jn(function() {
  return DA;
}, Vwe, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, wm, "ruler/utils/clj_time.cljc", 16, 1, 45, 45, ue(new v(null, 1, 5, y, [Xl], null)), "Get a timestamp from a date as string", j(DA) ? DA.D : null]))], null), new v(null, 2, 5, y, [
  _n.h("last-day-of-the-month"),
  new Jn(function() {
    return Fh;
  }, Mwe, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [ji, nX, "ruler/utils/clj_time.cljc", 28, new $(null, 6, [Rs, !1, Vi, 1, Ms, 1, Cs, new v(null, 2, 5, y, [Dt, new v(null, 1, 5, y, [Xl], null)], null), ne, ue(Dt, new v(null, 1, 5, y, [Xl], null)), Ps, ue(null, null)], null), 1, 126, 126, ue(Dt, new v(null, 1, 5, y, [Xl], null)), null, j(Fh) ? Fh.D : null]))
], null), new v(null, 2, 5, y, [_n.h("banking-days-between"), new Jn(function() {
  return NA;
}, q_e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, JX, "ruler/utils/clj_time.cljc", 27, 1, 270, 270, ue(new v(
  null,
  2,
  5,
  y,
  [GX, Jee],
  null
)), null, j(NA) ? NA.D : null]))], null), new v(null, 2, 5, y, [_n.h("labor-day-m"), new Jn(function() {
  return RE;
}, sge, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, nwe, "ruler/utils/clj_time.cljc", 17, 1, 242, 242, fl, null, j(RE) ? RE.D : null]))], null), new v(null, 2, 5, y, [_n.h("martin-luther-king-day-m"), new Jn(function() {
  return AE;
}, Lve, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, R_e, "ruler/utils/clj_time.cljc", 30, 1, 239, 239, fl, null, j(AE) ? AE.D : null]))], null), new v(null, 2, 5, y, [_n.h("first-of-month?"), new Jn(
  function() {
    return ty;
  },
  gwe,
  Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [ji, tX, "ruler/utils/clj_time.cljc", 22, new $(null, 6, [Rs, !1, Vi, 1, Ms, 1, Cs, new v(null, 2, 5, y, [Dt, new v(null, 1, 5, y, [Xl], null)], null), ne, ue(Dt, new v(null, 1, 5, y, [Xl], null)), Ps, ue(null, null)], null), 1, 117, 117, ue(Dt, new v(null, 1, 5, y, [Xl], null)), null, j(ty) ? ty.D : null])
)], null), new v(null, 2, 5, y, [_n.h("date"), new Jn(function() {
  return Q0;
}, T_e, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [ji, uJ, "ruler/utils/clj_time.cljc", 11, new $(null, 6, [Rs, !0, Vi, 1, Ms, 1, Cs, new v(null, 1, 5, y, [ue(wm, new $(
  null,
  2,
  [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)],
  null
))], null), ne, ue(new v(null, 3, 5, y, [wm, et, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)], null)), Ps, ue(null)], null), 1, 61, 61, ue(new v(null, 3, 5, y, [wm, et, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)], null)), null, j(Q0) ? Q0.D : null]))], null), new v(null, 2, 5, y, [_n.h("formatters"), new Jn(function() {
  return Tm;
}, l0e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [
  ji,
  ane,
  "ruler/utils/clj_time.cljc",
  16,
  1,
  22,
  22,
  fl,
  null,
  j(Tm) ? Tm.D : null
]))], null), new v(null, 2, 5, y, [_n.h("date-compare-difference-as-days"), new Jn(function() {
  return $_;
}, t2e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, HZ, "ruler/utils/clj_time.cljc", 38, 1, 66, 66, ue(new v(null, 2, 5, y, [gm, mm], null)), "Calculate the difference in days between two dates", j($_) ? $_.D : null]))], null), new v(null, 2, 5, y, [_n.h("nth-of-month"), new Jn(function() {
  return jw;
}, Uye, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [ji, aee, "ruler/utils/clj_time.cljc", 19, new $(null, 6, [
  Rs,
  !1,
  Vi,
  1,
  Ms,
  1,
  Cs,
  new v(null, 2, 5, y, [Dt, new v(null, 1, 5, y, [Xl], null)], null),
  ne,
  ue(Dt, new v(null, 1, 5, y, [Xl], null)),
  Ps,
  ue(null, null)
], null), 1, 161, 161, ue(Dt, new v(null, 1, 5, y, [Xl], null)), "Get the numeric representation of a day within a month.", j(jw) ? jw.D : null]))], null), new v(null, 2, 5, y, [_n.h("thanks-giving-day-m"), new Jn(function() {
  return CE;
}, _ve, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, cye, "ruler/utils/clj_time.cljc", 25, 1, 244, 244, fl, null, j(CE) ? CE.D : null]))], null), new v(null, 2, 5, y, [_n.h("date--"), new Jn(
  function() {
    return ny;
  },
  y1e,
  Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [
    ji,
    hX,
    "ruler/utils/clj_time.cljc",
    13,
    new $(null, 6, [Rs, !0, Vi, 2, Ms, 2, Cs, new v(null, 1, 5, y, [ue(Xl, Lt, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null))], null), ne, ue(new v(null, 4, 5, y, [Xl, Lt, et, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)], null)), Ps, ue(null)], null),
    1,
    108,
    108,
    ue(new v(null, 4, 5, y, [Xl, Lt, et, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)], null)),
    "Subtract n days to date",
    j(ny) ? ny.D : null
  ])
)], null), new v(null, 2, 5, y, [_n.h("veterans-day-m"), new Jn(function() {
  return $E;
}, sye, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, Zve, "ruler/utils/clj_time.cljc", 20, 1, 248, 248, fl, null, j($E) ? $E.D : null]))], null), new v(null, 2, 5, y, [_n.h("number-of-days-in-the-month"), new Jn(function() {
  return Fh;
}, z2e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, bQ, "ruler/utils/clj_time.cljc", 33, 1, 168, 168, fl, null, j(Fh) ? Fh.D : null]))], null), new v(null, 2, 5, y, [_n.h("presidents-day-m"), new Jn(function() {
  return DE;
}, mge, Gn([
  ie,
  te,
  Bn,
  tt,
  zn,
  Yn,
  rt,
  ne,
  ee,
  lt
], [ji, ywe, "ruler/utils/clj_time.cljc", 22, 1, 240, 240, fl, null, j(DE) ? DE.D : null]))], null), new v(null, 2, 5, y, [_n.h("today"), new Jn(function() {
  return jm;
}, cxe, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [ji, eee, "ruler/utils/clj_time.cljc", 12, new $(null, 6, [
  Rs,
  !0,
  Vi,
  0,
  Ms,
  0,
  Cs,
  new v(null, 1, 5, y, [ue(new $(null, 2, [Gr, new v(null, 2, 5, y, [Dl, uh], null), Kr, new $(null, 1, [uh, !1], null)], null))], null),
  ne,
  ue(new v(null, 2, 5, y, [et, new $(null, 2, [Gr, new v(null, 2, 5, y, [Dl, uh], null), Kr, new $(null, 1, [uh, !1], null)], null)], null)),
  Ps,
  ue(null)
], null), 1, 50, 50, ue(new v(null, 2, 5, y, [et, new $(null, 2, [Gr, new v(null, 2, 5, y, [Dl, uh], null), Kr, new $(null, 1, [uh, !1], null)], null)], null)), "Get today's date in different formats", j(jm) ? jm.D : null]))], null), new v(null, 2, 5, y, [_n.h("date-compare"), new Jn(function() {
  return J0;
}, i2e, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [ji, kQ, "ruler/utils/clj_time.cljc", 19, new $(null, 6, [Rs, !0, Vi, 2, Ms, 2, Cs, new v(null, 1, 5, y, [ue(D0, I0, new $(
  null,
  2,
  [Gr, new v(null, 3, 5, y, [Dl, ju, sh], null), Kr, new $(null, 3, [Dl, $i, ju, Ls, sh, hr], null)],
  null
))], null), ne, ue(new v(null, 4, 5, y, [D0, I0, et, new $(null, 2, [Gr, new v(null, 3, 5, y, [Dl, ju, sh], null), Kr, new $(null, 3, [Dl, $i, ju, Ls, sh, hr], null)], null)], null)), Ps, ue(null)], null), 1, 91, 91, ue(new v(null, 4, 5, y, [D0, I0, et, new $(null, 2, [Gr, new v(null, 3, 5, y, [Dl, ju, sh], null), Kr, new $(null, 3, [Dl, $i, ju, Ls, sh, hr], null)], null)], null)), null, j(J0) ? J0.D : null]))], null), new v(null, 2, 5, y, [_n.h("format-date"), new Jn(function() {
  return AA;
}, H2e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, LZ, "ruler/utils/clj_time.cljc", 18, 1, 30, 30, ue(new v(
  null,
  2,
  5,
  y,
  [Xl, Qwe],
  null
)), null, j(AA) ? AA.D : null]))], null), new v(null, 2, 5, y, [_n.h("before-nth-of-month"), new Jn(function() {
  return IA;
}, Gve, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, jJ, "ruler/utils/clj_time.cljc", 26, 1, 151, 151, ue(new v(null, 3, 5, y, [Xl, $0, N0], null)), '"is this date strictly before the 3rd within 2 months from today" is the same as (u/before-nt-of-month "this date" 2 3)', j(IA) ? IA.D : null]))], null), new v(null, 2, 5, y, [_n.h("date-compare-difference-as-date"), new Jn(function() {
  return Tw;
}, Nye, Gn([
  ie,
  te,
  Bn,
  tt,
  Ns,
  zn,
  Yn,
  rt,
  ne,
  ee,
  lt
], [
  ji,
  iX,
  "ruler/utils/clj_time.cljc",
  38,
  new $(null, 6, [Rs, !0, Vi, 2, Ms, 2, Cs, new v(null, 1, 5, y, [ue(gm, mm, new $(null, 2, [Gr, new v(null, 2, 5, y, [ju, Dl], null), Kr, new $(null, 2, [ju, Ls, Dl, hr], null)], null))], null), ne, ue(new v(null, 4, 5, y, [gm, mm, et, new $(null, 2, [Gr, new v(null, 2, 5, y, [ju, Dl], null), Kr, new $(null, 2, [ju, Ls, Dl, hr], null)], null)], null)), Ps, ue(null)], null),
  1,
  82,
  82,
  ue(new v(null, 4, 5, y, [gm, mm, et, new $(null, 2, [Gr, new v(null, 2, 5, y, [ju, Dl], null), Kr, new $(null, 2, [ju, Ls, Dl, hr], null)], null)], null)),
  "Calculate the difference in days between two dates and transpose one",
  j(Tw) ? Tw.D : null
]))], null), new v(null, 2, 5, y, [_n.h("date-format"), new Jn(function() {
  return op;
}, Oye, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, dJ, "ruler/utils/clj_time.cljc", 17, 1, 19, 19, fl, null, j(op) ? op.D : null]))], null), new v(null, 2, 5, y, [_n.h("date-+"), new Jn(function() {
  return ey;
}, v1e, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [ji, fX, "ruler/utils/clj_time.cljc", 13, new $(null, 6, [Rs, !0, Vi, 2, Ms, 2, Cs, new v(null, 1, 5, y, [ue(Xl, Lt, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null))], null), ne, ue(new v(
  null,
  4,
  5,
  y,
  [Xl, Lt, et, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)],
  null
)), Ps, ue(null)], null), 1, 100, 100, ue(new v(null, 4, 5, y, [Xl, Lt, et, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)], null)), "Add n days to date", j(ey) ? ey.D : null]))], null), new v(null, 2, 5, y, [_n.h("pred-nth-of-month"), new Jn(function() {
  return L_;
}, c0e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [
  ji,
  QQ,
  "ruler/utils/clj_time.cljc",
  24,
  1,
  142,
  142,
  ue(new v(null, 4, 5, y, [ws, Xl, $0, N0], null)),
  null,
  j(L_) ? L_.D : null
]))], null), new v(null, 2, 5, y, [_n.h("christmas-day-m"), new Jn(function() {
  return PE;
}, B_e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, Vye, "ruler/utils/clj_time.cljc", 21, 1, 247, 247, fl, null, j(PE) ? PE.D : null]))], null), new v(null, 2, 5, y, [_n.h("columbus-day-m"), new Jn(function() {
  return NE;
}, m_e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, O1e, "ruler/utils/clj_time.cljc", 20, 1, 243, 243, fl, null, j(NE) ? NE.D : null]))], null), new v(null, 2, 5, y, [_n.h("memorial-day-m"), new Jn(function() {
  return IE;
}, Aye, Gn([
  ie,
  te,
  Bn,
  tt,
  zn,
  Yn,
  rt,
  ne,
  ee,
  lt
], [ji, Qye, "ruler/utils/clj_time.cljc", 20, 1, 241, 241, fl, null, j(IE) ? IE.D : null]))], null), new v(null, 2, 5, y, [_n.h("last-of-month?"), new Jn(function() {
  return ly;
}, rve, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [ji, mee, "ruler/utils/clj_time.cljc", 21, new $(null, 6, [Rs, !1, Vi, 1, Ms, 1, Cs, new v(null, 2, 5, y, [Dt, new v(null, 1, 5, y, [Xl], null)], null), ne, ue(Dt, new v(null, 1, 5, y, [Xl], null)), Ps, ue(null, null)], null), 1, 134, 134, ue(Dt, new v(null, 1, 5, y, [Xl], null)), null, j(ly) ? ly.D : null]))], null), new v(null, 2, 5, y, [_n.h("new-years-day-m"), new Jn(
  function() {
    return G_;
  },
  rwe,
  Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, A2e, "ruler/utils/clj_time.cljc", 21, 1, 245, 245, fl, null, j(G_) ? G_.D : null])
)], null), new v(null, 2, 5, y, [_n.h("independence-day-m"), new Jn(function() {
  return ME;
}, A1e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [ji, n1e, "ruler/utils/clj_time.cljc", 24, 1, 246, 246, fl, null, j(ME) ? ME.D : null]))], null)], !0)), Te([lr.g(Tt, new v(null, 3, 5, y, [new v(null, 2, 5, y, [_n.h("parse-int"), new Jn(function() {
  return E0;
}, wJ, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [A0, TQ, "ruler/utils/math.cljc", 16, 1, 4, 4, ue(new v(
  null,
  1,
  5,
  y,
  [Sr],
  null
)), null, j(E0) ? E0.D : null]))], null), new v(null, 2, 5, y, [_n.h("round"), new Jn(function() {
  return O0;
}, BJ, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [A0, kb, "ruler/utils/math.cljc", 12, 1, 9, 9, ue(new v(null, 2, 5, y, [pne, Lt], null)), null, j(O0) ? O0.D : null]))], null), new v(null, 2, 5, y, [_n.h("parse-float"), new Jn(function() {
  return k0;
}, pJ, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [A0, xQ, "ruler/utils/math.cljc", 18, 1, 15, 15, ue(new v(null, 1, 5, y, [Sr], null)), null, j(k0) ? k0.D : null]))], null)], null))])), REe = yt.l(lr.g(Tt, new v(null, 2, 5, y, [new v(
  null,
  2,
  5,
  y,
  [_n.h("concat-key"), new Jn(function() {
    return b0;
  }, yee, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Bk, vQ, "ruler/utils/string.cljc", 17, 1, 4, 4, ue(new v(null, 2, 5, y, [Bt, Wa], null)), "Return a string concatenation of all the values represented by key", j(b0) ? b0.D : null]))],
  null
), new v(null, 2, 5, y, [_n.h("serialize"), new Jn(function() {
  return T0;
}, vX, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Bk, see, "ruler/utils/string.cljc", 16, 1, 9, 9, ue(new v(null, 1, 5, y, [Bt], null)), null, j(T0) ? T0.D : null]))], null)], null)), lr.g(Tt, new v(null, 28, 5, y, [new v(
  null,
  2,
  5,
  y,
  [_n.h("after-nth-of-month"), new Jn(function() {
    return $A;
  }, ige, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, UJ, "ruler/utils/java_time.cljc", 25, 1, 227, 227, ue(new v(null, 3, 5, y, [Xl, $0, N0], null)), '"is this date strictly after the 3rd within 2 months from today" is the same as (u/before-nt-of-month "this date" 2 3)', j($A) ? $A.D : null]))],
  null
), new v(null, 2, 5, y, [_n.h("date-format-with-time"), new Jn(function() {
  return BE;
}, Y_e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, EQ, "ruler/utils/java_time.cljc", 27, 1, 21, 21, fl, null, j(BE) ? BE.D : null]))], null), new v(null, 2, 5, y, [_n.h("timestamp"), new Jn(function() {
  return MA;
}, qve, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, wm, "ruler/utils/java_time.cljc", 16, 1, 89, 89, ue(new v(null, 1, 5, y, [Xl], null)), null, j(MA) ? MA.D : null]))], null), new v(null, 2, 5, y, [_n.h("last-day-of-the-month"), new Jn(function() {
  return Vh;
}, Eve, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [Xi, nX, "ruler/utils/java_time.cljc", 28, new $(null, 6, [Rs, !1, Vi, 1, Ms, 1, Cs, new v(null, 2, 5, y, [Dt, new v(null, 1, 5, y, [Xl], null)], null), ne, ue(Dt, new v(
  null,
  1,
  5,
  y,
  [Xl],
  null
)), Ps, ue(null, null)], null), 1, 191, 191, ue(Dt, new v(null, 1, 5, y, [Xl], null)), null, j(Vh) ? Vh.D : null]))], null), new v(null, 2, 5, y, [_n.h("subtract-months"), new Jn(function() {
  return FA;
}, $ge, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, axe, "ruler/utils/java_time.cljc", 22, 1, 393, 393, ue(new v(null, 2, 5, y, [Xl, Lt], null)), "Subtract n months from date.", j(FA) ? FA.D : null]))], null), new v(null, 2, 5, y, [_n.h("leap-year?"), new Jn(function() {
  return YA;
}, tve, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [
  Xi,
  h2e,
  "ruler/utils/java_time.cljc",
  17,
  1,
  417,
  417,
  ue(new v(null, 1, 5, y, [Xl], null)),
  "Year of date is or is not a leap year.",
  j(YA) ? YA.D : null
]))], null), new v(null, 2, 5, y, [_n.h("banking-days-between"), new Jn(function() {
  return LA;
}, Bwe, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, JX, "ruler/utils/java_time.cljc", 27, 1, 337, 337, ue(new v(null, 2, 5, y, [GX, Jee], null)), null, j(LA) ? LA.D : null]))], null), new v(null, 2, 5, y, [_n.h("first-of-month?"), new Jn(function() {
  return oy;
}, $ye, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [Xi, tX, "ruler/utils/java_time.cljc", 22, new $(null, 6, [
  Rs,
  !1,
  Vi,
  1,
  Ms,
  1,
  Cs,
  new v(null, 2, 5, y, [Dt, new v(null, 1, 5, y, [Xl], null)], null),
  ne,
  ue(Dt, new v(null, 1, 5, y, [Xl], null)),
  Ps,
  ue(null, null)
], null), 1, 183, 183, ue(Dt, new v(null, 1, 5, y, [Xl], null)), null, j(oy) ? oy.D : null]))], null), new v(null, 2, 5, y, [_n.h("date"), new Jn(function() {
  return ry;
}, S2e, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [Xi, uJ, "ruler/utils/java_time.cljc", 11, new $(null, 6, [Rs, !0, Vi, 1, Ms, 1, Cs, new v(null, 1, 5, y, [ue(wm, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null))], null), ne, ue(new v(null, 3, 5, y, [
  wm,
  et,
  new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)
], null)), Ps, ue(null)], null), 1, 120, 120, ue(new v(null, 3, 5, y, [wm, et, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)], null)), null, j(ry) ? ry.D : null]))], null), new v(null, 2, 5, y, [_n.h("formatters"), new Jn(function() {
  return Am;
}, V1e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, ane, "ruler/utils/java_time.cljc", 16, 1, 23, 23, fl, null, j(Am) ? Am.D : null]))], null), new v(null, 2, 5, y, [
  _n.h("date-compare-difference-as-days"),
  new Jn(function() {
    return B_;
  }, Rve, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, HZ, "ruler/utils/java_time.cljc", 38, 1, 127, 127, ue(new v(null, 2, 5, y, [gm, mm], null)), "Calculate the difference in days between two dates", j(B_) ? B_.D : null]))
], null), new v(null, 2, 5, y, [_n.h("nth-of-month"), new Jn(function() {
  return Dw;
}, Age, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [Xi, aee, "ruler/utils/java_time.cljc", 19, new $(null, 6, [Rs, !1, Vi, 1, Ms, 1, Cs, new v(null, 2, 5, y, [Dt, new v(null, 1, 5, y, [Xl], null)], null), ne, ue(Dt, new v(null, 1, 5, y, [Xl], null)), Ps, ue(
  null,
  null
)], null), 1, 233, 233, ue(Dt, new v(null, 1, 5, y, [Xl], null)), "Get the numeric representation of a day within a month.", j(Dw) ? Dw.D : null]))], null), new v(null, 2, 5, y, [_n.h("date--"), new Jn(function() {
  return sy;
}, p0e, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [Xi, hX, "ruler/utils/java_time.cljc", 13, new $(null, 6, [Rs, !0, Vi, 2, Ms, 2, Cs, new v(null, 1, 5, y, [ue(Xl, Lt, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null))], null), ne, ue(new v(null, 4, 5, y, [Xl, Lt, et, new $(null, 2, [
  Gr,
  new v(null, 1, 5, y, [Dl], null),
  Kr,
  new $(null, 1, [Dl, hr], null)
], null)], null)), Ps, ue(null)], null), 1, 173, 173, ue(new v(null, 4, 5, y, [Xl, Lt, et, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)], null)), "Subtract n days to date", j(sy) ? sy.D : null]))], null), new v(null, 2, 5, y, [_n.h("day-of-week"), new Jn(function() {
  return VA;
}, Sye, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, Tye, "ruler/utils/java_time.cljc", 18, 1, 411, 411, ue(new v(null, 1, 5, y, [Xl], null)), "Return day of the week of date.", j(VA) ? VA.D : null]))], null), new v(
  null,
  2,
  5,
  y,
  [_n.h("number-of-days-in-the-month"), new Jn(function() {
    return Vh;
  }, Xve, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, bQ, "ruler/utils/java_time.cljc", 33, 1, 242, 242, fl, null, j(Vh) ? Vh.D : null]))],
  null
), new v(null, 2, 5, y, [_n.h("today"), new Jn(function() {
  return Dm;
}, wye, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [Xi, eee, "ruler/utils/java_time.cljc", 12, new $(null, 6, [Rs, !0, Vi, 0, Ms, 0, Cs, new v(null, 1, 5, y, [ue(new $(null, 2, [Gr, new v(null, 2, 5, y, [Dl, uh], null), Kr, new $(null, 1, [uh, !1], null)], null))], null), ne, ue(new v(null, 2, 5, y, [et, new $(
  null,
  2,
  [Gr, new v(null, 2, 5, y, [Dl, uh], null), Kr, new $(null, 1, [uh, !1], null)],
  null
)], null)), Ps, ue(null)], null), 1, 102, 102, ue(new v(null, 2, 5, y, [et, new $(null, 2, [Gr, new v(null, 2, 5, y, [Dl, uh], null), Kr, new $(null, 1, [uh, !1], null)], null)], null)), "Get today's date in different formats", j(Dm) ? Dm.D : null]))], null), new v(null, 2, 5, y, [_n.h("date-compare"), new Jn(function() {
  return iy;
}, Twe, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [Xi, kQ, "ruler/utils/java_time.cljc", 19, new $(null, 6, [Rs, !0, Vi, 2, Ms, 2, Cs, new v(null, 1, 5, y, [ue(D0, I0, new $(
  null,
  2,
  [Gr, new v(null, 3, 5, y, [Dl, ju, sh], null), Kr, new $(null, 3, [Dl, $i, ju, Ls, sh, hr], null)],
  null
))], null), ne, ue(new v(null, 4, 5, y, [D0, I0, et, new $(null, 2, [Gr, new v(null, 3, 5, y, [Dl, ju, sh], null), Kr, new $(null, 3, [Dl, $i, ju, Ls, sh, hr], null)], null)], null)), Ps, ue(null)], null), 1, 154, 154, ue(new v(null, 4, 5, y, [D0, I0, et, new $(null, 2, [Gr, new v(null, 3, 5, y, [Dl, ju, sh], null), Kr, new $(null, 3, [Dl, $i, ju, Ls, sh, hr], null)], null)], null)), null, j(iy) ? iy.D : null]))], null), new v(null, 2, 5, y, [_n.h("format-date"), new Jn(
  function() {
    return CA;
  },
  Iye,
  Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, LZ, "ruler/utils/java_time.cljc", 18, 1, 70, 70, ue(new v(null, 2, 5, y, [Xl, d1e], null)), null, j(CA) ? CA.D : null])
)], null), new v(null, 2, 5, y, [_n.h("before-nth-of-month"), new Jn(function() {
  return PA;
}, R0e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, jJ, "ruler/utils/java_time.cljc", 26, 1, 221, 221, ue(new v(null, 3, 5, y, [Xl, $0, N0], null)), '"is this date strictly before the 3rd within 2 months from today" is the same as (u/before-nt-of-month "this date" 2 3)', j(PA) ? PA.D : null]))], null), new v(
  null,
  2,
  5,
  y,
  [_n.h("date-compare-difference-as-date"), new Jn(function() {
    return Aw;
  }, h1e, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [Xi, iX, "ruler/utils/java_time.cljc", 38, new $(null, 6, [Rs, !0, Vi, 2, Ms, 2, Cs, new v(null, 1, 5, y, [ue(gm, mm, new $(null, 2, [Gr, new v(null, 2, 5, y, [ju, Dl], null), Kr, new $(null, 2, [ju, Ls, Dl, hr], null)], null))], null), ne, ue(new v(null, 4, 5, y, [gm, mm, et, new $(null, 2, [Gr, new v(null, 2, 5, y, [ju, Dl], null), Kr, new $(null, 2, [ju, Ls, Dl, hr], null)], null)], null)), Ps, ue(null)], null), 1, 143, 143, ue(new v(null, 4, 5, y, [gm, mm, et, new $(
    null,
    2,
    [Gr, new v(null, 2, 5, y, [ju, Dl], null), Kr, new $(null, 2, [ju, Ls, Dl, hr], null)],
    null
  )], null)), "Calculate the difference in days between two dates and transpose one", j(Aw) ? Aw.D : null]))],
  null
), new v(null, 2, 5, y, [_n.h("date-format"), new Jn(function() {
  return Nc;
}, S1e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, dJ, "ruler/utils/java_time.cljc", 17, 1, 20, 20, fl, null, j(Nc) ? Nc.D : null]))], null), new v(null, 2, 5, y, [_n.h("date-+"), new Jn(function() {
  return uy;
}, m0e, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [
  Xi,
  fX,
  "ruler/utils/java_time.cljc",
  13,
  new $(null, 6, [Rs, !0, Vi, 2, Ms, 2, Cs, new v(null, 1, 5, y, [ue(Xl, Lt, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null))], null), ne, ue(new v(null, 4, 5, y, [Xl, Lt, et, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)], null)), Ps, ue(null)], null),
  1,
  163,
  163,
  ue(new v(null, 4, 5, y, [Xl, Lt, et, new $(null, 2, [Gr, new v(null, 1, 5, y, [Dl], null), Kr, new $(null, 1, [Dl, hr], null)], null)], null)),
  "Add n days to date",
  j(uy) ? uy.D : null
]))], null), new v(null, 2, 5, y, [
  _n.h("pred-nth-of-month"),
  new Jn(function() {
    return F_;
  }, s1e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, QQ, "ruler/utils/java_time.cljc", 24, 1, 209, 209, ue(new v(null, 4, 5, y, [ws, Xl, $0, N0], null)), null, j(F_) ? F_.D : null]))
], null), new v(null, 2, 5, y, [_n.h("banking-day?"), new Jn(function() {
  return UA;
}, G1e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, rge, "ruler/utils/java_time.cljc", 19, 1, 423, 423, ue(new v(null, 1, 5, y, [Xl], null)), "Date is or is not a banking day.", j(UA) ? UA.D : null]))], null), new v(null, 2, 5, y, [_n.h("next-banking-day"), new Jn(
  function() {
    return WA;
  },
  awe,
  Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, T1e, "ruler/utils/java_time.cljc", 23, 1, 439, 439, ue(new v(null, 1, 5, y, [Xl], null)), "Next banking day after date.", j(WA) ? WA.D : null])
)], null), new v(null, 2, 5, y, [_n.h("previous-banking-day"), new Jn(function() {
  return qA;
}, E0e, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [Xi, txe, "ruler/utils/java_time.cljc", 27, 1, 428, 428, ue(new v(null, 1, 5, y, [Xl], null)), "Prior banking day before date.", j(qA) ? qA.D : null]))], null), new v(null, 2, 5, y, [_n.h("add-months"), new Jn(function() {
  return BA;
}, W2e, Gn([
  ie,
  te,
  Bn,
  tt,
  zn,
  Yn,
  rt,
  ne,
  ee,
  lt
], [Xi, s0e, "ruler/utils/java_time.cljc", 17, 1, 384, 384, ue(new v(null, 2, 5, y, [Xl, Lt], null)), "Add n months to date.", j(BA) ? BA.D : null]))], null), new v(null, 2, 5, y, [_n.h("last-of-month?"), new Jn(function() {
  return ay;
}, Owe, Gn([ie, te, Bn, tt, Ns, zn, Yn, rt, ne, ee, lt], [Xi, mee, "ruler/utils/java_time.cljc", 21, new $(null, 6, [Rs, !1, Vi, 1, Ms, 1, Cs, new v(null, 2, 5, y, [Dt, new v(null, 1, 5, y, [Xl], null)], null), ne, ue(Dt, new v(null, 1, 5, y, [Xl], null)), Ps, ue(null, null)], null), 1, 199, 199, ue(Dt, new v(null, 1, 5, y, [Xl], null)), null, j(ay) ? ay.D : null]))], null)], null)), Te([lr.g(Tt, new v(null, 3, 5, y, [new v(null, 2, 5, y, [_n.h("parse-int"), new Jn(function() {
  return E0;
}, wJ, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [A0, TQ, "ruler/utils/math.cljc", 16, 1, 4, 4, ue(new v(null, 1, 5, y, [Sr], null)), null, j(E0) ? E0.D : null]))], null), new v(null, 2, 5, y, [_n.h("round"), new Jn(function() {
  return O0;
}, BJ, Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [A0, kb, "ruler/utils/math.cljc", 12, 1, 9, 9, ue(new v(null, 2, 5, y, [pne, Lt], null)), null, j(O0) ? O0.D : null]))], null), new v(null, 2, 5, y, [_n.h("parse-float"), new Jn(
  function() {
    return k0;
  },
  pJ,
  Gn([ie, te, Bn, tt, zn, Yn, rt, ne, ee, lt], [A0, xQ, "ruler/utils/math.cljc", 18, 1, 15, 15, ue(new v(null, 1, 5, y, [Sr], null)), null, j(k0) ? k0.D : null])
)], null)], null))])), hte = Bc(new $(null, 2, [Q_e, bt.g(go.g(jq, "u"), IEe), $ve, bt.g(go.g(jq, "v"), REe)], null));
Qz("ruler.rules.namespaces", hte);
var NEe = new v(null, 22, 5, y, [Kk, Dk, Yc, Pk, Zk, cF, K1e, uge, K2e, ih, Hk, zge, Gk, zk, Rk, Lye, Jk, Jve, Ow, b1, t4, e4], null);
zG(Tp, v1(Js));
zG(o4, v1(fZ));
var fte = xp.h(hte), dte = en.g(fte, "u-namespace"), pte = en.g(fte, "v-namespace"), xF = kr.h(HG(oZ(Dt))), CEe = kr.h(null), MEe = bt.g(function(e) {
  return Bh(e);
}, xp.l(
  JSON.parse(`[
  {
    "label": "primitives-classnames",
    "type": "function",
    "info": null
  },
  {
    "label": "+'",
    "type": "function",
    "info": "Returns the sum of nums. (+') returns 0. Supports arbitrary precision.\\n  See also: +"
  },
  {
    "label": "decimal?",
    "type": "function",
    "info": "Returns true if n is a BigDecimal"
  },
  {
    "label": "restart-agent",
    "type": "function",
    "info": "When an agent is failed, changes the agent state to new-state and\\n  then un-fails the agent so that sends are allowed again.  If\\n  a :clear-actions true option is given, any actions queued on the\\n  agent that were being held while it was failed will be discarded,\\n  otherwise those held actions will proceed.  The new-state must pass\\n  the validator if any, or restart will throw an exception and the\\n  agent will remain failed with its old state and error.  Watchers, if\\n  any, will NOT be notified of the new state.  Throws an exception if\\n  the agent is not failed."
  },
  {
    "label": "sort-by",
    "type": "function",
    "info": "Returns a sorted sequence of the items in coll, where the sort\\n  order is determined by comparing (keyfn item).  If no comparator is\\n  supplied, uses compare.  comparator must implement\\n  java.util.Comparator.  Guaranteed to be stable: equal elements will\\n  not be reordered.  If coll is a Java array, it will be modified.  To\\n  avoid this, sort a copy of the array."
  },
  {
    "label": "macroexpand",
    "type": "function",
    "info": "Repeatedly calls macroexpand-1 on form until it no longer\\n  represents a macro form, then returns it.  Note neither\\n  macroexpand-1 nor macroexpand expand macros in subforms."
  },
  {
    "label": "ensure",
    "type": "function",
    "info": "Must be called in a transaction. Protects the ref from modification\\n  by other transactions.  Returns the in-transaction-value of\\n  ref. Allows for more concurrency than (ref-set ref @ref)"
  },
  {
    "label": "chunk-first",
    "type": "function",
    "info": null
  },
  {
    "label": "eduction",
    "type": "function",
    "info": "Returns a reducible\\/iterable application of the transducers\\n  to the items in coll. Transducers are applied in order as if\\n  combined with comp. Note that these applications will be\\n  performed every time reduce\\/iterator is called."
  },
  {
    "label": "tree-seq",
    "type": "function",
    "info": "Returns a lazy sequence of the nodes in a tree, via a depth-first walk.\\n   branch? must be a fn of one arg that returns true if passed a node\\n   that can have children (but may not).  children must be a fn of one\\n   arg that returns a sequence of the children. Will only be called on\\n   nodes for which branch? returns true. Root is the root node of the\\n  tree."
  },
  {
    "label": "unchecked-remainder-int",
    "type": "function",
    "info": "Returns the remainder of division of x by y, both int.\\n  Note - uses a primitive operator subject to truncation."
  },
  {
    "label": "seq",
    "type": "function",
    "info": "Returns a seq on the collection. If the collection is\\n    empty, returns nil.  (seq nil) returns nil. seq also works on\\n    Strings, native Java arrays (of reference types) and any objects\\n    that implement Iterable. Note that seqs cache values, thus seq\\n    should not be used on any Iterable whose iterator repeatedly\\n    returns the same mutable object."
  },
  {
    "label": "reduce",
    "type": "function",
    "info": "f should be a function of 2 arguments. If val is not supplied,\\n  returns the result of applying f to the first 2 items in coll, then\\n  applying f to that result and the 3rd item, etc. If coll contains no\\n  items, f must accept no arguments as well, and reduce returns the\\n  result of calling f with no arguments.  If coll has only 1 item, it\\n  is returned and f is not called.  If val is supplied, returns the\\n  result of applying f to val and the first item in coll, then\\n  applying f to that result and the 2nd item, etc. If coll contains no\\n  items, returns val and f is not called."
  },
  {
    "label": "when-first",
    "type": "function",
    "info": "bindings => x xs\\n\\n  Roughly the same as (when (seq xs) (let [x (first xs)] body)) but xs is evaluated only once"
  },
  {
    "label": "find-ns",
    "type": "function",
    "info": "Returns the namespace named by the symbol or nil if it doesn't exist."
  },
  {
    "label": "get-thread-bindings",
    "type": "function",
    "info": "Get a map with the Var\\/value pairs which is currently in effect for the\\n  current thread."
  },
  {
    "label": "contains?",
    "type": "function",
    "info": "Returns true if key is present in the given collection, otherwise\\n  returns false.  Note that for numerically indexed collections like\\n  vectors and Java arrays, this tests if the numeric key is within the\\n  range of indexes. 'contains?' operates constant or logarithmic time;\\n  it will not perform a linear search for a value.  See also 'some'."
  },
  {
    "label": "every?",
    "type": "function",
    "info": "Returns true if (pred x) is logical true for every x in coll, else\\n  false."
  },
  {
    "label": "proxy-mappings",
    "type": "function",
    "info": "Takes a proxy instance and returns the proxy's fn map."
  },
  {
    "label": "keep-indexed",
    "type": "function",
    "info": "Returns a lazy sequence of the non-nil results of (f index item). Note,\\n  this means false return values will be included.  f must be free of\\n  side-effects.  Returns a stateful transducer when no collection is\\n  provided."
  },
  {
    "label": "cond->>",
    "type": "function",
    "info": "Takes an expression and a set of test\\/form pairs. Threads expr (via ->>)\\n  through each form for which the corresponding test expression\\n  is true.  Note that, unlike cond branching, cond->> threading does not short circuit\\n  after the first true test expression."
  },
  {
    "label": "subs",
    "type": "function",
    "info": "Returns the substring of s beginning at start inclusive, and ending\\n  at end (defaults to length of string), exclusive."
  },
  {
    "label": "ref-min-history",
    "type": "function",
    "info": "Gets the min-history of a ref, or sets it and returns the ref"
  },
  {
    "label": "set",
    "type": "function",
    "info": "Returns a set of the distinct elements of coll."
  },
  {
    "label": "take-last",
    "type": "function",
    "info": "Returns a seq of the last n items in coll.  Depending on the type\\n  of coll may be no better than linear time.  For vectors, see also subvec."
  },
  {
    "label": "bit-set",
    "type": "function",
    "info": "Set bit at index n"
  },
  {
    "label": "reader-conditional",
    "type": "function",
    "info": "Construct a data representation of a reader conditional.\\n  If true, splicing? indicates read-cond-splicing."
  },
  {
    "label": "gen-class",
    "type": "function",
    "info": "When compiling, generates compiled bytecode for a class with the\\n  given package-qualified :name (which, as all names in these\\n  parameters, can be a string or symbol), and writes the .class file\\n  to the *compile-path* directory.  When not compiling, does\\n  nothing. The gen-class construct contains no implementation, as the\\n  implementation will be dynamically sought by the generated class in\\n  functions in an implementing Clojure namespace. Given a generated\\n  class org.mydomain.MyClass with a method named mymethod, gen-class\\n  will generate an implementation that looks for a function named by \\n  (str prefix mymethod) (default prefix: \\"-\\") in a\\n  Clojure namespace specified by :impl-ns\\n  (defaults to the current namespace). All inherited methods,\\n  generated methods, and init and main functions (see :methods, :init,\\n  and :main below) will be found similarly prefixed. By default, the\\n  static initializer for the generated class will attempt to load the\\n  Clojure support code for the class as a resource from the classpath,\\n  e.g. in the example case, \`\`org\\/mydomain\\/MyClass__init.class\`\`. This\\n  behavior can be controlled by :load-impl-ns\\n\\n  Note that methods with a maximum of 18 parameters are supported.\\n\\n  In all subsequent sections taking types, the primitive types can be\\n  referred to by their Java names (int, float etc), and classes in the\\n  java.lang package can be used without a package qualifier. All other\\n  classes must be fully qualified.\\n\\n  Options should be a set of key\\/value pairs, all except for :name are optional:\\n\\n  :name aname\\n\\n  The package-qualified name of the class to be generated\\n\\n  :extends aclass\\n\\n  Specifies the superclass, the non-private methods of which will be\\n  overridden by the class. If not provided, defaults to Object.\\n\\n  :implements [interface ...]\\n\\n  One or more interfaces, the methods of which will be implemented by the class.\\n\\n  :init name\\n\\n  If supplied, names a function that will be called with the arguments\\n  to the constructor. Must return [ [superclass-constructor-args] state] \\n  If not supplied, the constructor args are passed directly to\\n  the superclass constructor and the state will be nil\\n\\n  :constructors {[param-types] [super-param-types], ...}\\n\\n  By default, constructors are created for the generated class which\\n  match the signature(s) of the constructors for the superclass. This\\n  parameter may be used to explicitly specify constructors, each entry\\n  providing a mapping from a constructor signature to a superclass\\n  constructor signature. When you supply this, you must supply an :init\\n  specifier. \\n\\n  :post-init name\\n\\n  If supplied, names a function that will be called with the object as\\n  the first argument, followed by the arguments to the constructor.\\n  It will be called every time an object of this class is created,\\n  immediately after all the inherited constructors have completed.\\n  Its return value is ignored.\\n\\n  :methods [ [name [param-types] return-type], ...]\\n\\n  The generated class automatically defines all of the non-private\\n  methods of its superclasses\\/interfaces. This parameter can be used\\n  to specify the signatures of additional methods of the generated\\n  class. Static methods can be specified with ^{:static true} in the\\n  signature's metadata. Do not repeat superclass\\/interface signatures\\n  here.\\n\\n  :main boolean\\n\\n  If supplied and true, a static public main function will be generated. It will\\n  pass each string of the String[] argument as a separate argument to\\n  a function called (str prefix main).\\n\\n  :factory name\\n\\n  If supplied, a (set of) public static factory function(s) will be\\n  created with the given name, and the same signature(s) as the\\n  constructor(s).\\n  \\n  :state name\\n\\n  If supplied, a public final instance field with the given name will be\\n  created. You must supply an :init function in order to provide a\\n  value for the state. Note that, though final, the state can be a ref\\n  or agent, supporting the creation of Java objects with transactional\\n  or asynchronous mutation semantics.\\n\\n  :exposes {protected-field-name {:get name :set name}, ...}\\n\\n  Since the implementations of the methods of the generated class\\n  occur in Clojure functions, they have no access to the inherited\\n  protected fields of the superclass. This parameter can be used to\\n  generate public getter\\/setter methods exposing the protected field(s)\\n  for use in the implementation.\\n\\n  :exposes-methods {super-method-name exposed-name, ...}\\n\\n  It is sometimes necessary to call the superclass' implementation of an\\n  overridden method.  Those methods may be exposed and referred in \\n  the new method implementation by a local name.\\n\\n  :prefix string\\n\\n  Default: \\"-\\" Methods called e.g. Foo will be looked up in vars called\\n  prefixFoo in the implementing ns.\\n\\n  :impl-ns name\\n\\n  Default: the name of the current ns. Implementations of methods will be \\n  looked up in this namespace.\\n\\n  :load-impl-ns boolean\\n\\n  Default: true. Causes the static initializer for the generated class\\n  to reference the load code for the implementing namespace. Should be\\n  true when implementing-ns is the default, false if you intend to\\n  load the code via some other method."
  },
  {
    "label": "qualified-keyword?",
    "type": "function",
    "info": "Return true if x is a keyword with a namespace"
  },
  {
    "label": "while",
    "type": "function",
    "info": "Repeatedly executes body while test expression is true. Presumes\\n  some side-effect will cause test to become false\\/nil. Returns nil"
  },
  {
    "label": "->Eduction",
    "type": "function",
    "info": "Positional factory function for class clojure.core.Eduction."
  },
  {
    "label": "butlast",
    "type": "function",
    "info": "Return a seq of all but the last item in coll, in linear time"
  },
  {
    "label": "satisfies?",
    "type": "function",
    "info": "Returns true if x satisfies the protocol"
  },
  {
    "label": "line-seq",
    "type": "function",
    "info": "Returns the lines of text from rdr as a lazy sequence of strings.\\n  rdr must implement java.io.BufferedReader."
  },
  {
    "label": "unchecked-subtract-int",
    "type": "function",
    "info": "Returns the difference of x and y, both int.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "*print-namespace-maps*",
    "type": "function",
    "info": "*print-namespace-maps* controls whether the printer will print\\n  namespace map literal syntax. It defaults to false, but the REPL binds\\n  to true."
  },
  {
    "label": "take-nth",
    "type": "function",
    "info": "Returns a lazy seq of every nth item in coll.  Returns a stateful\\n  transducer when no collection is provided."
  },
  {
    "label": "first",
    "type": "function",
    "info": "Returns the first item in the collection. Calls seq on its\\n    argument. If coll is nil, returns nil."
  },
  {
    "label": "re-groups",
    "type": "function",
    "info": "Returns the groups from the most recent match\\/find. If there are no\\n  nested groups, returns a string of the entire match. If there are\\n  nested groups, returns a vector of the groups, the first element\\n  being the entire match."
  },
  {
    "label": "seq?",
    "type": "function",
    "info": "Return true if x implements ISeq"
  },
  {
    "label": "dec'",
    "type": "function",
    "info": "Returns a number one less than num. Supports arbitrary precision.\\n  See also: dec"
  },
  {
    "label": "ns-unmap",
    "type": "function",
    "info": "Removes the mappings for the symbol from the namespace."
  },
  {
    "label": "with-bindings*",
    "type": "function",
    "info": "Takes a map of Var\\/value pairs. Installs for the given Vars the associated\\n  values as thread-local bindings. Then calls f with the supplied arguments.\\n  Pops the installed bindings after f returned. Returns whatever f returns."
  },
  {
    "label": "inst-ms",
    "type": "function",
    "info": "Return the number of milliseconds since January 1, 1970, 00:00:00 GMT"
  },
  {
    "label": "iterator-seq",
    "type": "function",
    "info": "Returns a seq on a java.util.Iterator. Note that most collections\\n  providing iterators implement Iterable and thus support seq directly.\\n  Seqs cache values, thus iterator-seq should not be used on any\\n  iterator that repeatedly returns the same mutable object."
  },
  {
    "label": "iterate",
    "type": "function",
    "info": "Returns a lazy sequence of x, (f x), (f (f x)) etc. f must be free of side-effects"
  },
  {
    "label": "slurp",
    "type": "function",
    "info": "Opens a reader on f and reads all its contents, returning a string.\\n  See clojure.java.io\\/reader for a complete list of supported arguments."
  },
  {
    "label": "newline",
    "type": "function",
    "info": "Writes a platform-specific newline to *out*"
  },
  {
    "label": "short-array",
    "type": "function",
    "info": "Creates an array of shorts"
  },
  {
    "label": "fn?",
    "type": "function",
    "info": "Returns true if x implements Fn, i.e. is an object created via fn."
  },
  {
    "label": "doall",
    "type": "function",
    "info": "When lazy sequences are produced via functions that have side\\n  effects, any effects other than those needed to produce the first\\n  element in the seq do not occur until the seq is consumed. doall can\\n  be used to force any effects. Walks through the successive nexts of\\n  the seq, retains the head and returns it, thus causing the entire\\n  seq to reside in memory at one time."
  },
  {
    "label": "prefers",
    "type": "function",
    "info": "Given a multimethod, returns a map of preferred value -> set of other values"
  },
  {
    "label": "enumeration-seq",
    "type": "function",
    "info": "Returns a seq on a java.util.Enumeration"
  },
  {
    "label": "dedupe",
    "type": "function",
    "info": "Returns a lazy sequence removing consecutive duplicates in coll.\\n  Returns a transducer when no collection is provided."
  },
  {
    "label": "dissoc",
    "type": "function",
    "info": "dissoc[iate]. Returns a new map of the same (hashed\\/sorted) type,\\n  that does not contain a mapping for key(s)."
  },
  {
    "label": "atom",
    "type": "function",
    "info": "Creates and returns an Atom with an initial value of x and zero or\\n  more options (in any order):\\n\\n  :meta metadata-map\\n\\n  :validator validate-fn\\n\\n  If metadata-map is supplied, it will become the metadata on the\\n  atom. validate-fn must be nil or a side-effect-free fn of one\\n  argument, which will be passed the intended new state on any state\\n  change. If the new state is unacceptable, the validate-fn should\\n  return false or throw an exception."
  },
  {
    "label": "bit-shift-right",
    "type": "function",
    "info": "Bitwise shift right"
  },
  {
    "label": "print-method",
    "type": "function",
    "info": null
  },
  {
    "label": "peek",
    "type": "function",
    "info": "For a list or queue, same as first, for a vector, same as, but much\\n  more efficient than, last. If the collection is empty, returns nil."
  },
  {
    "label": "aget",
    "type": "function",
    "info": "Returns the value at the index\\/indices. Works on Java arrays of all\\n  types."
  },
  {
    "label": "pvalues",
    "type": "function",
    "info": "Returns a lazy sequence of the values of the exprs, which are\\n  evaluated in parallel"
  },
  {
    "label": "bound-fn",
    "type": "function",
    "info": "Returns a function defined by the given fntail, which will install the\\n  same bindings in effect as in the thread at the time bound-fn was called.\\n  This may be used to define a helper function which runs on a different\\n  thread, but needs the same bindings in place."
  },
  {
    "label": "vswap!",
    "type": "function",
    "info": "Non-atomically swaps the value of the volatile as if:\\n   (apply f current-value-of-vol args). Returns the value that\\n   was swapped in."
  },
  {
    "label": "last",
    "type": "function",
    "info": "Return the last item in coll, in linear time"
  },
  {
    "label": "namespace",
    "type": "function",
    "info": "Returns the namespace String of a symbol or keyword, or nil if not present."
  },
  {
    "label": "push-thread-bindings",
    "type": "function",
    "info": "WARNING: This is a low-level function. Prefer high-level macros like\\n  binding where ever possible.\\n\\n  Takes a map of Var\\/value pairs. Binds each Var to the associated value for\\n  the current thread. Each call *MUST* be accompanied by a matching call to\\n  pop-thread-bindings wrapped in a try-finally!\\n  \\n      (push-thread-bindings bindings)\\n      (try\\n        ...\\n        (finally\\n          (pop-thread-bindings)))"
  },
  {
    "label": "bases",
    "type": "function",
    "info": "Returns the immediate superclass and direct interfaces of c, if any"
  },
  {
    "label": "=",
    "type": "function",
    "info": "Equality. Returns true if x equals y, false if not. Same as\\n  Java x.equals(y) except it also works for nil, and compares\\n  numbers and collections in a type-independent manner.  Clojure's immutable data\\n  structures define equals() (and thus =) as a value, not an identity,\\n  comparison."
  },
  {
    "label": "read+string",
    "type": "function",
    "info": "Like read, and taking the same args. stream must be a LineNumberingPushbackReader.\\n  Returns a vector containing the object read and the (whitespace-trimmed) string read."
  },
  {
    "label": "dosync",
    "type": "function",
    "info": "Runs the exprs (in an implicit do) in a transaction that encompasses\\n  exprs and any nested calls.  Starts a transaction if none is already\\n  running on this thread. Any uncaught exception will abort the\\n  transaction and flow out of dosync. The exprs may be run more than\\n  once, but any effects on Refs will be atomic."
  },
  {
    "label": "remove-ns",
    "type": "function",
    "info": "Removes the namespace named by the symbol. Use with caution.\\n  Cannot be used to remove the clojure namespace."
  },
  {
    "label": "take",
    "type": "function",
    "info": "Returns a lazy sequence of the first n items in coll, or all items if\\n  there are fewer than n.  Returns a stateful transducer when\\n  no collection is provided."
  },
  {
    "label": "vector?",
    "type": "function",
    "info": "Return true if x implements IPersistentVector"
  },
  {
    "label": "thread-bound?",
    "type": "function",
    "info": "Returns true if all of the vars provided as arguments have thread-local bindings.\\n   Implies that set!'ing the provided vars will succeed.  Returns true if no vars are provided."
  },
  {
    "label": "send-via",
    "type": "function",
    "info": "Dispatch an action to an agent. Returns the agent immediately.\\n  Subsequently, in a thread supplied by executor, the state of the agent\\n  will be set to the value of:\\n\\n  (apply action-fn state-of-agent args)"
  },
  {
    "label": "boolean",
    "type": "function",
    "info": "Coerce to boolean"
  },
  {
    "label": "bit-shift-left",
    "type": "function",
    "info": "Bitwise shift left"
  },
  {
    "label": "any?",
    "type": "function",
    "info": "Returns true given any argument."
  },
  {
    "label": "find-var",
    "type": "function",
    "info": "Returns the global var named by the namespace-qualified symbol, or\\n  nil if no var with that name."
  },
  {
    "label": "rand-int",
    "type": "function",
    "info": "Returns a random integer between 0 (inclusive) and n (exclusive)."
  },
  {
    "label": "aclone",
    "type": "function",
    "info": "Returns a clone of the Java array. Works on arrays of known\\n  types."
  },
  {
    "label": "PrintWriter-on",
    "type": "function",
    "info": "implements java.io.PrintWriter given flush-fn, which will be called\\n  when .flush() is called, with a string built up since the last call to .flush().\\n  if not nil, close-fn will be called with no arguments when .close is called"
  },
  {
    "label": "vreset!",
    "type": "function",
    "info": "Sets the value of volatile to newval without regard for the\\n   current value. Returns newval."
  },
  {
    "label": "chunk",
    "type": "function",
    "info": null
  },
  {
    "label": "dec",
    "type": "function",
    "info": "Returns a number one less than num. Does not auto-promote\\n  longs, will throw on overflow. See also: dec'"
  },
  {
    "label": "future-call",
    "type": "function",
    "info": "Takes a function of no args and yields a future object that will\\n  invoke the function in another thread, and will cache the result and\\n  return it on all subsequent calls to deref\\/@. If the computation has\\n  not yet finished, calls to deref\\/@ will block, unless the variant\\n  of deref with timeout is used. See also - realized?."
  },
  {
    "label": "resultset-seq",
    "type": "function",
    "info": "Creates and returns a lazy sequence of structmaps corresponding to\\n  the rows in the java.sql.ResultSet rs"
  },
  {
    "label": "struct",
    "type": "function",
    "info": "Returns a new structmap instance with the keys of the\\n  structure-basis. vals must be supplied for basis keys in order -\\n  where values are not supplied they will default to nil."
  },
  {
    "label": "map",
    "type": "function",
    "info": "Returns a lazy sequence consisting of the result of applying f to\\n  the set of first items of each coll, followed by applying f to the\\n  set of second items in each coll, until any one of the colls is\\n  exhausted.  Any remaining items in other colls are ignored. Function\\n  f should accept number-of-colls arguments. Returns a transducer when\\n  no collection is provided."
  },
  {
    "label": "juxt",
    "type": "function",
    "info": "Takes a set of functions and returns a fn that is the juxtaposition\\n  of those fns.  The returned fn takes a variable number of args, and\\n  returns a vector containing the result of applying each fn to the\\n  args (left-to-right).\\n  ((juxt a b c) x) => [(a x) (b x) (c x)]"
  },
  {
    "label": "ns-publics",
    "type": "function",
    "info": "Returns a map of the public intern mappings for the namespace."
  },
  {
    "label": "<",
    "type": "function",
    "info": "Returns non-nil if nums are in monotonically increasing order,\\n  otherwise false."
  },
  {
    "label": "*source-path*",
    "type": "function",
    "info": null
  },
  {
    "label": "with-loading-context",
    "type": "function",
    "info": null
  },
  {
    "label": "test",
    "type": "function",
    "info": "test [v] finds fn at key :test in var metadata and calls it,\\n  presuming failure will throw exception"
  },
  {
    "label": "rest",
    "type": "function",
    "info": "Returns a possibly empty seq of the items after the first. Calls seq on its\\n  argument."
  },
  {
    "label": "ex-data",
    "type": "function",
    "info": "Returns exception data (a map) if ex is an IExceptionInfo.\\n   Otherwise returns nil."
  },
  {
    "label": "compile",
    "type": "function",
    "info": "Compiles the namespace named by the symbol lib into a set of\\n  classfiles. The source for the lib must be in a proper\\n  classpath-relative directory. The output files will go into the\\n  directory specified by *compile-path*, and that directory too must\\n  be in the classpath."
  },
  {
    "label": "isa?",
    "type": "function",
    "info": "Returns true if (= child parent), or child is directly or indirectly derived from\\n  parent, either via a Java type inheritance relationship or a\\n  relationship established via derive. h must be a hierarchy obtained\\n  from make-hierarchy, if not supplied defaults to the global\\n  hierarchy"
  },
  {
    "label": "boolean?",
    "type": "function",
    "info": "Return true if x is a Boolean"
  },
  {
    "label": "..",
    "type": "function",
    "info": "form => fieldName-symbol or (instanceMethodName-symbol args*)\\n\\n  Expands into a member access (.) of the first member on the first\\n  argument, followed by the next member on the result, etc. For\\n  instance:\\n\\n  (.. System (getProperties) (get \\"os.name\\"))\\n\\n  expands to:\\n\\n  (. (. System (getProperties)) (get \\"os.name\\"))\\n\\n  but is easier to write, read, and understand."
  },
  {
    "label": "munge",
    "type": "function",
    "info": null
  },
  {
    "label": "delay",
    "type": "function",
    "info": "Takes a body of expressions and yields a Delay object that will\\n  invoke the body only the first time it is forced (with force or deref\\/@), and\\n  will cache the result and return it on all subsequent force\\n  calls. See also - realized?"
  },
  {
    "label": "set-error-mode!",
    "type": "function",
    "info": "Sets the error-mode of agent a to mode-keyword, which must be\\n  either :fail or :continue.  If an action being run by the agent\\n  throws an exception or doesn't pass the validator fn, an\\n  error-handler may be called (see set-error-handler!), after which,\\n  if the mode is :continue, the agent will continue as if neither the\\n  action that caused the error nor the error itself ever happened.\\n  \\n  If the mode is :fail, the agent will become failed and will stop\\n  accepting new 'send' and 'send-off' actions, and any previously\\n  queued actions will be held until a 'restart-agent'.  Deref will\\n  still work, returning the state of the agent before the error."
  },
  {
    "label": "re-seq",
    "type": "function",
    "info": "Returns a lazy sequence of successive matches of pattern in string,\\n  using java.util.regex.Matcher.find(), each such match processed with\\n  re-groups."
  },
  {
    "label": "char?",
    "type": "function",
    "info": "Return true if x is a Character"
  },
  {
    "label": "make-hierarchy",
    "type": "function",
    "info": "Creates a hierarchy object for use with derive, isa? etc."
  },
  {
    "label": "set-agent-send-executor!",
    "type": "function",
    "info": "Sets the ExecutorService to be used by send"
  },
  {
    "label": "swap-vals!",
    "type": "function",
    "info": "Atomically swaps the value of atom to be:\\n  (apply f current-value-of-atom args). Note that f may be called\\n  multiple times, and thus should be free of side effects.\\n  Returns [old new], the value of the atom before and after the swap."
  },
  {
    "label": "keep",
    "type": "function",
    "info": "Returns a lazy sequence of the non-nil results of (f item). Note,\\n  this means false return values will be included.  f must be free of\\n  side-effects.  Returns a transducer when no collection is provided."
  },
  {
    "label": "char",
    "type": "function",
    "info": "Coerce to char"
  },
  {
    "label": "mapcat",
    "type": "function",
    "info": "Returns the result of applying concat to the result of applying map\\n  to f and colls.  Thus function f should return a collection. Returns\\n  a transducer when no collections are provided"
  },
  {
    "label": "unchecked-long",
    "type": "function",
    "info": "Coerce to long. Subject to rounding or truncation."
  },
  {
    "label": "aset-long",
    "type": "function",
    "info": "Sets the value at the index\\/indices. Works on arrays of long. Returns val."
  },
  {
    "label": "some?",
    "type": "function",
    "info": "Returns true if x is not nil, false otherwise."
  },
  {
    "label": "unchecked-negate",
    "type": "function",
    "info": "Returns the negation of x, a long.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "remove-tap",
    "type": "function",
    "info": "Remove f from the tap set."
  },
  {
    "label": "gen-interface",
    "type": "function",
    "info": "When compiling, generates compiled bytecode for an interface with\\n  the given package-qualified :name (which, as all names in these\\n  parameters, can be a string or symbol), and writes the .class file\\n  to the *compile-path* directory.  When not compiling, does nothing.\\n \\n  In all subsequent sections taking types, the primitive types can be\\n  referred to by their Java names (int, float etc), and classes in the\\n  java.lang package can be used without a package qualifier. All other\\n  classes must be fully qualified.\\n \\n  Options should be a set of key\\/value pairs, all except for :name are\\n  optional:\\n\\n  :name aname\\n\\n  The package-qualified name of the class to be generated\\n\\n  :extends [interface ...]\\n\\n  One or more interfaces, which will be extended by this interface.\\n\\n  :methods [ [name [param-types] return-type], ...]\\n\\n  This parameter is used to specify the signatures of the methods of\\n  the generated interface.  Do not repeat superinterface signatures\\n  here."
  },
  {
    "label": "*command-line-args*",
    "type": "function",
    "info": "A sequence of the supplied command line arguments, or nil if\\n  none were supplied"
  },
  {
    "label": "reverse",
    "type": "function",
    "info": "Returns a seq of the items in coll in reverse order. Not lazy."
  },
  {
    "label": "inst?",
    "type": "function",
    "info": "Return true if x satisfies Inst"
  },
  {
    "label": "range",
    "type": "function",
    "info": "Returns a lazy seq of nums from start (inclusive) to end\\n  (exclusive), by step, where start defaults to 0, step to 1, and end to\\n  infinity. When step is equal to 0, returns an infinite sequence of\\n  start. When start is equal to end, returns empty list."
  },
  {
    "label": "sort",
    "type": "function",
    "info": "Returns a sorted sequence of the items in coll. If no comparator is\\n  supplied, uses compare.  comparator must implement\\n  java.util.Comparator.  Guaranteed to be stable: equal elements will\\n  not be reordered.  If coll is a Java array, it will be modified.  To\\n  avoid this, sort a copy of the array."
  },
  {
    "label": "-cache-protocol-fn",
    "type": "function",
    "info": null
  },
  {
    "label": "unchecked-inc-int",
    "type": "function",
    "info": "Returns a number one greater than x, an int.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "map-indexed",
    "type": "function",
    "info": "Returns a lazy sequence consisting of the result of applying f to 0\\n  and the first item of coll, followed by applying f to 1 and the second\\n  item in coll, etc, until coll is exhausted. Thus function f should\\n  accept 2 arguments, index and item. Returns a stateful transducer when\\n  no collection is provided."
  },
  {
    "label": "with-bindings",
    "type": "function",
    "info": "Takes a map of Var\\/value pairs. Installs for the given Vars the associated\\n  values as thread-local bindings. Then executes body. Pops the installed\\n  bindings after body was evaluated. Returns the value of body."
  },
  {
    "label": "rand-nth",
    "type": "function",
    "info": "Return a random element of the (sequential) collection. Will have\\n  the same performance characteristics as nth for the given\\n  collection."
  },
  {
    "label": "comp",
    "type": "function",
    "info": "Takes a set of functions and returns a fn that is the composition\\n  of those fns.  The returned fn takes a variable number of args,\\n  applies the rightmost of fns to the args, the next\\n  fn (right-to-left) to the result, etc."
  },
  {
    "label": "await",
    "type": "function",
    "info": "Blocks the current thread (indefinitely!) until all actions\\n  dispatched thus far, from this thread or agent, to the agent(s) have\\n  occurred.  Will block on failed agents.  Will never return if\\n  a failed agent is restarted with :clear-actions true or shutdown-agents was called."
  },
  {
    "label": "spit",
    "type": "function",
    "info": "Opposite of slurp.  Opens f with writer, writes content, then\\n  closes f. Options passed to clojure.java.io\\/writer."
  },
  {
    "label": "future-done?",
    "type": "function",
    "info": "Returns true if future f is done"
  },
  {
    "label": "*read-eval*",
    "type": "function",
    "info": "Defaults to true (or value specified by system property, see below)\\n  ***This setting implies that the full power of the reader is in play,\\n  including syntax that can cause code to execute. It should never be\\n  used with untrusted sources. See also: clojure.edn\\/read.***\\n\\n  When set to logical false in the thread-local binding,\\n  the eval reader (#=) and record\\/type literal syntax are disabled in read\\/load.\\n  Example (will fail): (binding [*read-eval* false] (read-string \\"#=(* 2 21)\\"))\\n\\n  The default binding can be controlled by the system property\\n  'clojure.read.eval' System properties can be set on the command line\\n  like this:\\n\\n  java -Dclojure.read.eval=false ...\\n\\n  The system property can also be set to 'unknown' via\\n  -Dclojure.read.eval=unknown, in which case the default binding\\n  is :unknown and all reads will fail in contexts where *read-eval*\\n  has not been explicitly bound to either true or false. This setting\\n  can be a useful diagnostic tool to ensure that all of your reads\\n  occur in considered contexts. You can also accomplish this in a\\n  particular scope by binding *read-eval* to :unknown\\n  "
  },
  {
    "label": "dorun",
    "type": "function",
    "info": "When lazy sequences are produced via functions that have side\\n  effects, any effects other than those needed to produce the first\\n  element in the seq do not occur until the seq is consumed. dorun can\\n  be used to force any effects. Walks through the successive nexts of\\n  the seq, does not retain the head and returns nil."
  },
  {
    "label": "simple-symbol?",
    "type": "function",
    "info": "Return true if x is a symbol without a namespace"
  },
  {
    "label": "disj",
    "type": "function",
    "info": "disj[oin]. Returns a new set of the same (hashed\\/sorted) type, that\\n  does not contain key(s)."
  },
  {
    "label": "*2",
    "type": "function",
    "info": "bound in a repl thread to the second most recent value printed"
  },
  {
    "label": "cons",
    "type": "function",
    "info": "Returns a new seq where x is the first element and seq is\\n    the rest."
  },
  {
    "label": "refer",
    "type": "function",
    "info": "refers to all public vars of ns, subject to filters.\\n  filters can include at most one each of:\\n\\n  :exclude list-of-symbols\\n  :only list-of-symbols\\n  :rename map-of-fromsymbol-tosymbol\\n\\n  For each public interned var in the namespace named by the symbol,\\n  adds a mapping from the name of the var to the var to the current\\n  namespace.  Throws an exception if name is already mapped to\\n  something else in the current namespace. Filters can be used to\\n  select a subset, via inclusion or exclusion, or to provide a mapping\\n  to a symbol different from the var's name, in order to prevent\\n  clashes. Use :use in the ns macro in preference to calling this directly."
  },
  {
    "label": "print-dup",
    "type": "function",
    "info": null
  },
  {
    "label": "-reset-methods",
    "type": "function",
    "info": null
  },
  {
    "label": "floats",
    "type": "function",
    "info": "Casts to float[]"
  },
  {
    "label": "pos?",
    "type": "function",
    "info": "Returns true if num is greater than zero, else false"
  },
  {
    "label": "fnil",
    "type": "function",
    "info": "Takes a function f, and returns a function that calls f, replacing\\n  a nil first argument to f with the supplied value x. Higher arity\\n  versions can replace arguments in the second and third\\n  positions (y, z). Note that the function f can take any number of\\n  arguments, not just the one(s) being nil-patched."
  },
  {
    "label": "merge-with",
    "type": "function",
    "info": "Returns a map that consists of the rest of the maps conj-ed onto\\n  the first.  If a key occurs in more than one map, the mapping(s)\\n  from the latter (left-to-right) will be combined with the mapping in\\n  the result by calling (f val-in-result val-in-latter)."
  },
  {
    "label": "nthrest",
    "type": "function",
    "info": "Returns the nth rest of coll, coll when n is 0."
  },
  {
    "label": "load",
    "type": "function",
    "info": "Loads Clojure code from resources in classpath. A path is interpreted as\\n  classpath-relative if it begins with a slash or relative to the root\\n  directory for the current namespace otherwise."
  },
  {
    "label": "if-not",
    "type": "function",
    "info": "Evaluates test. If logical false, evaluates and returns then expr, \\n  otherwise else expr, if supplied, else nil."
  },
  {
    "label": "*verbose-defrecords*",
    "type": "function",
    "info": null
  },
  {
    "label": "sequential?",
    "type": "function",
    "info": "Returns true if coll implements Sequential"
  },
  {
    "label": "*print-level*",
    "type": "function",
    "info": "*print-level* controls how many levels deep the printer will\\n  print nested objects. If it is bound to logical false, there is no\\n  limit. Otherwise, it must be bound to an integer indicating the maximum\\n  level to print. Each argument to print is at level 0; if an argument is a\\n  collection, its items are at level 1; and so on. If an object is a\\n  collection and is at a level greater than or equal to the value bound to\\n  *print-level*, the printer prints '#' to represent it. The root binding\\n  is nil indicating no limit."
  },
  {
    "label": "shuffle",
    "type": "function",
    "info": "Return a random permutation of coll"
  },
  {
    "label": "boolean-array",
    "type": "function",
    "info": "Creates an array of booleans"
  },
  {
    "label": "find",
    "type": "function",
    "info": "Returns the map entry for key, or nil if key not present."
  },
  {
    "label": "alength",
    "type": "function",
    "info": "Returns the length of the Java array. Works on arrays of all\\n  types."
  },
  {
    "label": "bit-xor",
    "type": "function",
    "info": "Bitwise exclusive or"
  },
  {
    "label": "deliver",
    "type": "function",
    "info": "Delivers the supplied value to the promise, releasing any pending\\n  derefs. A subsequent call to deliver on a promise will have no effect."
  },
  {
    "label": "doseq",
    "type": "function",
    "info": "Repeatedly executes body (presumably for side-effects) with\\n  bindings and filtering as provided by \\"for\\".  Does not retain\\n  the head of the sequence. Returns nil."
  },
  {
    "label": "unsigned-bit-shift-right",
    "type": "function",
    "info": "Bitwise shift right, without sign-extension."
  },
  {
    "label": "neg?",
    "type": "function",
    "info": "Returns true if num is less than zero, else false"
  },
  {
    "label": "var-set",
    "type": "function",
    "info": "Sets the value in the var object to val. The var must be\\n thread-locally bound."
  },
  {
    "label": "unchecked-float",
    "type": "function",
    "info": "Coerce to float. Subject to rounding."
  },
  {
    "label": "pmap",
    "type": "function",
    "info": "Like map, except f is applied in parallel. Semi-lazy in that the\\n  parallel computation stays ahead of the consumption, but doesn't\\n  realize the entire result unless required. Only useful for\\n  computationally intensive functions where the time of f dominates\\n  the coordination overhead."
  },
  {
    "label": "error-mode",
    "type": "function",
    "info": "Returns the error-mode of agent a.  See set-error-mode!"
  },
  {
    "label": "num",
    "type": "function",
    "info": "Coerce to Number"
  },
  {
    "label": "reduced?",
    "type": "function",
    "info": "Returns true if x is the result of a call to reduced"
  },
  {
    "label": "disj!",
    "type": "function",
    "info": "disj[oin]. Returns a transient set of the same (hashed\\/sorted) type, that\\n  does not contain key(s)."
  },
  {
    "label": "float?",
    "type": "function",
    "info": "Returns true if n is a floating point number"
  },
  {
    "label": "aset-float",
    "type": "function",
    "info": "Sets the value at the index\\/indices. Works on arrays of float. Returns val."
  },
  {
    "label": "deftype",
    "type": "function",
    "info": "(deftype name [fields*]  options* specs*)\\n\\n  Options are expressed as sequential keywords and arguments (in any order).\\n\\n  Supported options:\\n  :load-ns - if true, importing the type class will cause the\\n             namespace in which the type was defined to be loaded.\\n             Defaults to false.\\n\\n  Each spec consists of a protocol or interface name followed by zero\\n  or more method bodies:\\n\\n  protocol-or-interface-or-Object\\n  (methodName [args*] body)*\\n\\n  Dynamically generates compiled bytecode for class with the given\\n  name, in a package with the same name as the current namespace, the\\n  given fields, and, optionally, methods for protocols and\\/or\\n  interfaces. \\n\\n  The class will have the (by default, immutable) fields named by\\n  fields, which can have type hints. Protocols\\/interfaces and methods\\n  are optional. The only methods that can be supplied are those\\n  declared in the protocols\\/interfaces.  Note that method bodies are\\n  not closures, the local environment includes only the named fields,\\n  and those fields can be accessed directly. Fields can be qualified\\n  with the metadata :volatile-mutable true or :unsynchronized-mutable\\n  true, at which point (set! afield aval) will be supported in method\\n  bodies. Note well that mutable fields are extremely difficult to use\\n  correctly, and are present only to facilitate the building of higher\\n  level constructs, such as Clojure's reference types, in Clojure\\n  itself. They are for experts only - if the semantics and\\n  implications of :volatile-mutable or :unsynchronized-mutable are not\\n  immediately apparent to you, you should not be using them.\\n\\n  Method definitions take the form:\\n\\n  (methodname [args*] body)\\n\\n  The argument and return types can be hinted on the arg and\\n  methodname symbols. If not supplied, they will be inferred, so type\\n  hints should be reserved for disambiguation.\\n\\n  Methods should be supplied for all methods of the desired\\n  protocol(s) and interface(s). You can also define overrides for\\n  methods of Object. Note that a parameter must be supplied to\\n  correspond to the target object ('this' in Java parlance). Thus\\n  methods for interfaces will take one more argument than do the\\n  interface declarations. Note also that recur calls to the method\\n  head should *not* pass the target object, it will be supplied\\n  automatically and can not be substituted.\\n\\n  In the method bodies, the (unqualified) name can be used to name the\\n  class (for calls to new, instance? etc).\\n\\n  When AOT compiling, generates compiled bytecode for a class with the\\n  given name (a symbol), prepends the current ns as the package, and\\n  writes the .class file to the *compile-path* directory.\\n\\n  One constructor will be defined, taking the designated fields.  Note\\n  that the field names __meta, __extmap, __hash and __hasheq are currently\\n  reserved and should not be used when defining your own types.\\n\\n  Given (deftype TypeName ...), a factory function called ->TypeName\\n  will be defined, taking positional parameters for the fields"
  },
  {
    "label": "bean",
    "type": "function",
    "info": "Takes a Java object and returns a read-only implementation of the\\n  map abstraction based upon its JavaBean properties."
  },
  {
    "label": "booleans",
    "type": "function",
    "info": "Casts to boolean[]"
  },
  {
    "label": "ns-unalias",
    "type": "function",
    "info": "Removes the alias for the symbol from the namespace."
  },
  {
    "label": "when-let",
    "type": "function",
    "info": "bindings => binding-form test\\n\\n  When test is true, evaluates body with binding-form bound to the value of test"
  },
  {
    "label": "int-array",
    "type": "function",
    "info": "Creates an array of ints"
  },
  {
    "label": "set?",
    "type": "function",
    "info": "Returns true if x implements IPersistentSet"
  },
  {
    "label": "inc'",
    "type": "function",
    "info": "Returns a number one greater than num. Supports arbitrary precision.\\n  See also: inc"
  },
  {
    "label": "cat",
    "type": "function",
    "info": "A transducer which concatenates the contents of each input, which must be a\\n  collection, into the reduction."
  },
  {
    "label": "StackTraceElement->vec",
    "type": "function",
    "info": "Constructs a data representation for a StackTraceElement: [class method file line]"
  },
  {
    "label": "*suppress-read*",
    "type": "function",
    "info": null
  },
  {
    "label": "flush",
    "type": "function",
    "info": "Flushes the output stream that is the current value of\\n  *out*"
  },
  {
    "label": "take-while",
    "type": "function",
    "info": "Returns a lazy sequence of successive items from coll while\\n  (pred item) returns logical true. pred must be free of side-effects.\\n  Returns a transducer when no collection is provided."
  },
  {
    "label": "vary-meta",
    "type": "function",
    "info": "Returns an object of the same type and value as obj, with\\n  (apply f (meta obj) args) as its metadata."
  },
  {
    "label": "<=",
    "type": "function",
    "info": "Returns non-nil if nums are in monotonically non-decreasing order,\\n  otherwise false."
  },
  {
    "label": "alter",
    "type": "function",
    "info": "Must be called in a transaction. Sets the in-transaction-value of\\n  ref to:\\n\\n  (apply fun in-transaction-value-of-ref args)\\n\\n  and returns the in-transaction-value of ref."
  },
  {
    "label": "-'",
    "type": "function",
    "info": "If no ys are supplied, returns the negation of x, else subtracts\\n  the ys from x and returns the result. Supports arbitrary precision.\\n  See also: -"
  },
  {
    "label": "if-some",
    "type": "function",
    "info": "bindings => binding-form test\\n\\n   If test is not nil, evaluates then with binding-form bound to the\\n   value of test, if not, yields else"
  },
  {
    "label": "conj!",
    "type": "function",
    "info": "Adds x to the transient collection, and return coll. The 'addition'\\n  may happen at different 'places' depending on the concrete type."
  },
  {
    "label": "repeatedly",
    "type": "function",
    "info": "Takes a function of no args, presumably with side effects, and\\n  returns an infinite (or length n if supplied) lazy sequence of calls\\n  to it"
  },
  {
    "label": "zipmap",
    "type": "function",
    "info": "Returns a map with the keys mapped to the corresponding vals."
  },
  {
    "label": "reset-vals!",
    "type": "function",
    "info": "Sets the value of atom to newval. Returns [old new], the value of the\\n   atom before and after the reset."
  },
  {
    "label": "biginteger",
    "type": "function",
    "info": "Coerce to BigInteger"
  },
  {
    "label": "remove",
    "type": "function",
    "info": "Returns a lazy sequence of the items in coll for which\\n  (pred item) returns logical false. pred must be free of side-effects.\\n  Returns a transducer when no collection is provided."
  },
  {
    "label": "*",
    "type": "function",
    "info": "Returns the product of nums. (*) returns 1. Does not auto-promote\\n  longs, will throw on overflow. See also: *'"
  },
  {
    "label": "re-pattern",
    "type": "function",
    "info": "Returns an instance of java.util.regex.Pattern, for use, e.g. in\\n  re-matcher."
  },
  {
    "label": "min",
    "type": "function",
    "info": "Returns the least of the nums."
  },
  {
    "label": "pop!",
    "type": "function",
    "info": "Removes the last item from a transient vector. If\\n  the collection is empty, throws an exception. Returns coll"
  },
  {
    "label": "chunk-append",
    "type": "function",
    "info": null
  },
  {
    "label": "prn-str",
    "type": "function",
    "info": "prn to a string, returning it"
  },
  {
    "label": "with-precision",
    "type": "function",
    "info": "Sets the precision and rounding mode to be used for BigDecimal operations.\\n\\n  Usage: (with-precision 10 (\\/ 1M 3))\\n  or:    (with-precision 10 :rounding HALF_DOWN (\\/ 1M 3))\\n\\n  The rounding mode is one of CEILING, FLOOR, HALF_UP, HALF_DOWN,\\n  HALF_EVEN, UP, DOWN and UNNECESSARY; it defaults to HALF_UP."
  },
  {
    "label": "format",
    "type": "function",
    "info": "Formats a string using java.lang.String.format, see java.util.Formatter for format\\n  string syntax"
  },
  {
    "label": "reversible?",
    "type": "function",
    "info": "Returns true if coll implements Reversible"
  },
  {
    "label": "shutdown-agents",
    "type": "function",
    "info": "Initiates a shutdown of the thread pools that back the agent\\n  system. Running actions will complete, but no new actions will be\\n  accepted"
  },
  {
    "label": "conj",
    "type": "function",
    "info": "conj[oin]. Returns a new collection with the xs\\n    'added'. (conj nil item) returns (item).\\n    (conj coll) returns coll. (conj) returns [].\\n    The 'addition' may happen at different 'places' depending\\n    on the concrete type."
  },
  {
    "label": "bound?",
    "type": "function",
    "info": "Returns true if all of the vars provided as arguments have any bound value, root or thread-local.\\n   Implies that deref'ing the provided vars will succeed. Returns true if no vars are provided."
  },
  {
    "label": "transduce",
    "type": "function",
    "info": "reduce with a transformation of f (xf). If init is not\\n  supplied, (f) will be called to produce it. f should be a reducing\\n  step function that accepts both 1 and 2 arguments, if it accepts\\n  only 2 you can add the arity-1 with 'completing'. Returns the result\\n  of applying (the transformed) xf to init and the first item in coll,\\n  then applying xf to that result and the 2nd item, etc. If coll\\n  contains no items, returns init and f is not called. Note that\\n  certain transforms may inject or skip items."
  },
  {
    "label": "lazy-seq",
    "type": "function",
    "info": "Takes a body of expressions that returns an ISeq or nil, and yields\\n  a Seqable object that will invoke the body only the first time seq\\n  is called, and will cache the result and return it on all subsequent\\n  seq calls. See also - realized?"
  },
  {
    "label": "*print-length*",
    "type": "function",
    "info": "*print-length* controls how many items of each collection the\\n  printer will print. If it is bound to logical false, there is no\\n  limit. Otherwise, it must be bound to an integer indicating the maximum\\n  number of items of each collection to print. If a collection contains\\n  more items, the printer will print items up to the limit followed by\\n  '...' to represent the remaining items. The root binding is nil\\n  indicating no limit."
  },
  {
    "label": "*file*",
    "type": "function",
    "info": "The path of the file being evaluated, as a String.\\n\\n  When there is no file, e.g. in the REPL, the value is not defined."
  },
  {
    "label": "compare-and-set!",
    "type": "function",
    "info": "Atomically sets the value of atom to newval if and only if the\\n  current value of the atom is identical to oldval. Returns true if\\n  set happened, else false"
  },
  {
    "label": "*use-context-classloader*",
    "type": "function",
    "info": null
  },
  {
    "label": "await1",
    "type": "function",
    "info": null
  },
  {
    "label": "let",
    "type": "function",
    "info": "binding => binding-form init-expr\\n\\n  Evaluates the exprs in a lexical context in which the symbols in\\n  the binding-forms are bound to their respective init-exprs or parts\\n  therein."
  },
  {
    "label": "ref-set",
    "type": "function",
    "info": "Must be called in a transaction. Sets the value of ref.\\n  Returns val."
  },
  {
    "label": "pop-thread-bindings",
    "type": "function",
    "info": "Pop one set of bindings pushed with push-binding before. It is an error to\\n  pop bindings without pushing before."
  },
  {
    "label": "interleave",
    "type": "function",
    "info": "Returns a lazy seq of the first item in each coll, then the second etc."
  },
  {
    "label": "map?",
    "type": "function",
    "info": "Return true if x implements IPersistentMap"
  },
  {
    "label": "->",
    "type": "function",
    "info": "Threads the expr through the forms. Inserts x as the\\n  second item in the first form, making a list of it if it is not a\\n  list already. If there are more forms, inserts the first form as the\\n  second item in second form, etc."
  },
  {
    "label": "defstruct",
    "type": "function",
    "info": "Same as (def name (create-struct keys...))"
  },
  {
    "label": "*err*",
    "type": "function",
    "info": "A java.io.Writer object representing standard error for print operations.\\n\\n  Defaults to System\\/err, wrapped in a PrintWriter"
  },
  {
    "label": "get",
    "type": "function",
    "info": "Returns the value mapped to key, not-found or nil if key not present."
  },
  {
    "label": "doto",
    "type": "function",
    "info": "Evaluates x then calls all of the methods and functions with the\\n  value of x supplied at the front of the given arguments.  The forms\\n  are evaluated in order.  Returns x.\\n\\n  (doto (new java.util.HashMap) (.put \\"a\\" 1) (.put \\"b\\" 2))"
  },
  {
    "label": "identity",
    "type": "function",
    "info": "Returns its argument."
  },
  {
    "label": "into",
    "type": "function",
    "info": "Returns a new coll consisting of to-coll with all of the items of\\n  from-coll conjoined. A transducer may be supplied."
  },
  {
    "label": "areduce",
    "type": "function",
    "info": "Reduces an expression across an array a, using an index named idx,\\n  and return value named ret, initialized to init, setting ret to the \\n  evaluation of expr at each step, returning ret."
  },
  {
    "label": "long",
    "type": "function",
    "info": "Coerce to long"
  },
  {
    "label": "double",
    "type": "function",
    "info": "Coerce to double"
  },
  {
    "label": "volatile?",
    "type": "function",
    "info": "Returns true if x is a volatile."
  },
  {
    "label": "definline",
    "type": "function",
    "info": "Experimental - like defmacro, except defines a named function whose\\n  body is the expansion, calls to which may be expanded inline as if\\n  it were a macro. Cannot be used with variadic (&) args."
  },
  {
    "label": "nfirst",
    "type": "function",
    "info": "Same as (next (first x))"
  },
  {
    "label": "meta",
    "type": "function",
    "info": "Returns the metadata of obj, returns nil if there is no metadata."
  },
  {
    "label": "find-protocol-impl",
    "type": "function",
    "info": null
  },
  {
    "label": "bit-and-not",
    "type": "function",
    "info": "Bitwise and with complement"
  },
  {
    "label": "*default-data-reader-fn*",
    "type": "function",
    "info": "When no data reader is found for a tag and *default-data-reader-fn*\\n  is non-nil, it will be called with two arguments,\\n  the tag and the value.  If *default-data-reader-fn* is nil (the\\n  default), an exception will be thrown for the unknown tag."
  },
  {
    "label": "var?",
    "type": "function",
    "info": "Returns true if v is of type clojure.lang.Var"
  },
  {
    "label": "method-sig",
    "type": "function",
    "info": null
  },
  {
    "label": "unchecked-add-int",
    "type": "function",
    "info": "Returns the sum of x and y, both int.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "unquote-splicing",
    "type": "function",
    "info": null
  },
  {
    "label": "hash-ordered-coll",
    "type": "function",
    "info": "Returns the hash code, consistent with =, for an external ordered\\n   collection implementing Iterable.\\n   See http:\\/\\/clojure.org\\/data_structures#hash for full algorithms."
  },
  {
    "label": "future",
    "type": "function",
    "info": "Takes a body of expressions and yields a future object that will\\n  invoke the body in another thread, and will cache the result and\\n  return it on all subsequent calls to deref\\/@. If the computation has\\n  not yet finished, calls to deref\\/@ will block, unless the variant of\\n  deref with timeout is used. See also - realized?."
  },
  {
    "label": "reset-meta!",
    "type": "function",
    "info": "Atomically resets the metadata for a namespace\\/var\\/ref\\/agent\\/atom"
  },
  {
    "label": "cycle",
    "type": "function",
    "info": "Returns a lazy (infinite!) sequence of repetitions of the items in coll."
  },
  {
    "label": "fn",
    "type": "function",
    "info": "params => positional-params* , or positional-params* & next-param\\n  positional-param => binding-form\\n  next-param => binding-form\\n  name => symbol\\n\\n  Defines a function"
  },
  {
    "label": "seque",
    "type": "function",
    "info": "Creates a queued seq on another (presumably lazy) seq s. The queued\\n  seq will produce a concrete seq in the background, and can get up to\\n  n items ahead of the consumer. n-or-q can be an integer n buffer\\n  size, or an instance of java.util.concurrent BlockingQueue. Note\\n  that reading from a seque can block if the reader gets ahead of the\\n  producer."
  },
  {
    "label": "empty?",
    "type": "function",
    "info": "Returns true if coll has no items - same as (not (seq coll)).\\n  Please use the idiom (seq x) rather than (not (empty? x))"
  },
  {
    "label": "short",
    "type": "function",
    "info": "Coerce to short"
  },
  {
    "label": "definterface",
    "type": "function",
    "info": "Creates a new Java interface with the given name and method sigs.\\n  The method return types and parameter types may be specified with type hints,\\n  defaulting to Object if omitted.\\n\\n  (definterface MyInterface\\n    (^int method1 [x])\\n    (^Bar method2 [^Baz b ^Quux q]))"
  },
  {
    "label": "add-tap",
    "type": "function",
    "info": "adds f, a fn of one argument, to the tap set. This function will be called with anything sent via tap>.\\n  This function may (briefly) block (e.g. for streams), and will never impede calls to tap>,\\n  but blocking indefinitely may cause tap values to be dropped.\\n  Remember f in order to remove-tap"
  },
  {
    "label": "filterv",
    "type": "function",
    "info": "Returns a vector of the items in coll for which\\n  (pred item) returns logical true. pred must be free of side-effects."
  },
  {
    "label": "hash",
    "type": "function",
    "info": "Returns the hash code of its argument. Note this is the hash code\\n  consistent with =, and thus is different than .hashCode for Integer,\\n  Short, Byte and Clojure collections."
  },
  {
    "label": "quot",
    "type": "function",
    "info": "quot[ient] of dividing numerator by denominator."
  },
  {
    "label": "ns-aliases",
    "type": "function",
    "info": "Returns a map of the aliases for the namespace."
  },
  {
    "label": "read",
    "type": "function",
    "info": "Reads the next object from stream, which must be an instance of\\n  java.io.PushbackReader or some derivee.  stream defaults to the\\n  current value of *in*.\\n\\n  Opts is a persistent map with valid keys:\\n    :read-cond - :allow to process reader conditionals, or\\n                 :preserve to keep all branches\\n    :features - persistent set of feature keywords for reader conditionals\\n    :eof - on eof, return value unless :eofthrow, then throw.\\n           if not specified, will throw\\n\\n  Note that read can execute code (controlled by *read-eval*),\\n  and as such should be used only with trusted sources.\\n\\n  For data structure interop use clojure.edn\\/read"
  },
  {
    "label": "unchecked-double",
    "type": "function",
    "info": "Coerce to double. Subject to rounding."
  },
  {
    "label": "key",
    "type": "function",
    "info": "Returns the key of the map entry."
  },
  {
    "label": "longs",
    "type": "function",
    "info": "Casts to long[]"
  },
  {
    "label": "not=",
    "type": "function",
    "info": "Same as (not (= obj1 obj2))"
  },
  {
    "label": "string?",
    "type": "function",
    "info": "Return true if x is a String"
  },
  {
    "label": "uri?",
    "type": "function",
    "info": "Return true if x is a java.net.URI"
  },
  {
    "label": "aset-double",
    "type": "function",
    "info": "Sets the value at the index\\/indices. Works on arrays of double. Returns val."
  },
  {
    "label": "unchecked-multiply-int",
    "type": "function",
    "info": "Returns the product of x and y, both int.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "chunk-rest",
    "type": "function",
    "info": null
  },
  {
    "label": "pcalls",
    "type": "function",
    "info": "Executes the no-arg fns in parallel, returning a lazy sequence of\\n  their values"
  },
  {
    "label": "*allow-unresolved-vars*",
    "type": "function",
    "info": null
  },
  {
    "label": "remove-all-methods",
    "type": "function",
    "info": "Removes all of the methods of multimethod."
  },
  {
    "label": "as->",
    "type": "function",
    "info": "Binds name to expr, evaluates the first form in the lexical context\\n  of that binding, then binds name to that result, repeating for each\\n  successive form, returning the result of the last form."
  },
  {
    "label": "aset-boolean",
    "type": "function",
    "info": "Sets the value at the index\\/indices. Works on arrays of boolean. Returns val."
  },
  {
    "label": "trampoline",
    "type": "function",
    "info": "trampoline can be used to convert algorithms requiring mutual\\n  recursion without stack consumption. Calls f with supplied args, if\\n  any. If f returns a fn, calls that fn with no arguments, and\\n  continues to repeat, until the return value is not a fn, then\\n  returns that non-fn value. Note that if you want to return a fn as a\\n  final value, you must wrap it in some data structure and unpack it\\n  after trampoline returns."
  },
  {
    "label": "double?",
    "type": "function",
    "info": "Return true if x is a Double"
  },
  {
    "label": "when-not",
    "type": "function",
    "info": "Evaluates test. If logical false, evaluates body in an implicit do."
  },
  {
    "label": "*1",
    "type": "function",
    "info": "bound in a repl thread to the most recent value printed"
  },
  {
    "label": "vec",
    "type": "function",
    "info": "Creates a new vector containing the contents of coll. Java arrays\\n  will be aliased and should not be modified."
  },
  {
    "label": "*print-meta*",
    "type": "function",
    "info": "If set to logical true, when printing an object, its metadata will also\\n  be printed in a form that can be read back by the reader.\\n\\n  Defaults to false."
  },
  {
    "label": "when",
    "type": "function",
    "info": "Evaluates test. If logical true, evaluates body in an implicit do."
  },
  {
    "label": "int",
    "type": "function",
    "info": "Coerce to int"
  },
  {
    "label": "map-entry?",
    "type": "function",
    "info": "Return true if x is a map entry"
  },
  {
    "label": "ns-refers",
    "type": "function",
    "info": "Returns a map of the refer mappings for the namespace."
  },
  {
    "label": "rand",
    "type": "function",
    "info": "Returns a random floating point number between 0 (inclusive) and\\n  n (default 1) (exclusive)."
  },
  {
    "label": "second",
    "type": "function",
    "info": "Same as (first (next x))"
  },
  {
    "label": "vector-of",
    "type": "function",
    "info": "Creates a new vector of a single primitive type t, where t is one\\n  of :int :long :float :double :byte :short :char or :boolean. The\\n  resulting vector complies with the interface of vectors in general,\\n  but stores the values unboxed internally.\\n\\n  Optionally takes one or more elements to populate the vector."
  },
  {
    "label": "hash-combine",
    "type": "function",
    "info": null
  },
  {
    "label": ">",
    "type": "function",
    "info": "Returns non-nil if nums are in monotonically decreasing order,\\n  otherwise false."
  },
  {
    "label": "replace",
    "type": "function",
    "info": "Given a map of replacement pairs and a vector\\/collection, returns a\\n  vector\\/seq with any elements = a key in smap replaced with the\\n  corresponding val in smap.  Returns a transducer when no collection\\n  is provided."
  },
  {
    "label": "int?",
    "type": "function",
    "info": "Return true if x is a fixed precision integer"
  },
  {
    "label": "associative?",
    "type": "function",
    "info": "Returns true if coll implements Associative"
  },
  {
    "label": "unchecked-int",
    "type": "function",
    "info": "Coerce to int. Subject to rounding or truncation."
  },
  {
    "label": "set-error-handler!",
    "type": "function",
    "info": "Sets the error-handler of agent a to handler-fn.  If an action\\n  being run by the agent throws an exception or doesn't pass the\\n  validator fn, handler-fn will be called with two arguments: the\\n  agent and the exception."
  },
  {
    "label": "inst-ms*",
    "type": "function",
    "info": null
  },
  {
    "label": "keyword?",
    "type": "function",
    "info": "Return true if x is a Keyword"
  },
  {
    "label": "force",
    "type": "function",
    "info": "If x is a Delay, returns the (possibly cached) value of its expression, else returns x"
  },
  {
    "label": "bound-fn*",
    "type": "function",
    "info": "Returns a function, which will install the same bindings in effect as in\\n  the thread at the time bound-fn* was called and then call f with any given\\n  arguments. This may be used to define a helper function which runs on a\\n  different thread, but needs the same bindings in place."
  },
  {
    "label": "namespace-munge",
    "type": "function",
    "info": "Convert a Clojure namespace name to a legal Java package name."
  },
  {
    "label": "group-by",
    "type": "function",
    "info": "Returns a map of the elements of coll keyed by the result of\\n  f on each element. The value at each key will be a vector of the\\n  corresponding elements, in the order they appeared in coll."
  },
  {
    "label": "prn",
    "type": "function",
    "info": "Same as pr followed by (newline). Observes *flush-on-newline*"
  },
  {
    "label": "extend",
    "type": "function",
    "info": "Implementations of protocol methods can be provided using the extend construct:\\n\\n  (extend AType\\n    AProtocol\\n     {:foo an-existing-fn\\n      :bar (fn [a b] ...)\\n      :baz (fn ([a]...) ([a b] ...)...)}\\n    BProtocol \\n      {...} \\n    ...)\\n \\n  extend takes a type\\/class (or interface, see below), and one or more\\n  protocol + method map pairs. It will extend the polymorphism of the\\n  protocol's methods to call the supplied methods when an AType is\\n  provided as the first argument. \\n\\n  Method maps are maps of the keyword-ized method names to ordinary\\n  fns. This facilitates easy reuse of existing fns and fn maps, for\\n  code reuse\\/mixins without derivation or composition. You can extend\\n  an interface to a protocol. This is primarily to facilitate interop\\n  with the host (e.g. Java) but opens the door to incidental multiple\\n  inheritance of implementation since a class can inherit from more\\n  than one interface, both of which extend the protocol. It is TBD how\\n  to specify which impl to use. You can extend a protocol on nil.\\n\\n  If you are supplying the definitions explicitly (i.e. not reusing\\n  exsting functions or mixin maps), you may find it more convenient to\\n  use the extend-type or extend-protocol macros.\\n\\n  Note that multiple independent extend clauses can exist for the same\\n  type, not all protocols need be defined in a single extend call.\\n\\n  See also:\\n  extends?, satisfies?, extenders"
  },
  {
    "label": "unchecked-multiply",
    "type": "function",
    "info": "Returns the product of x and y, both long.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "some->>",
    "type": "function",
    "info": "When expr is not nil, threads it into the first form (via ->>),\\n  and when that result is not nil, through the next etc"
  },
  {
    "label": "default-data-readers",
    "type": "function",
    "info": "Default map of data reader functions provided by Clojure. May be\\n  overridden by binding *data-readers*."
  },
  {
    "label": "->VecSeq",
    "type": "function",
    "info": "Positional factory function for class clojure.core.VecSeq."
  },
  {
    "label": "even?",
    "type": "function",
    "info": "Returns true if n is even, throws an exception if n is not an integer"
  },
  {
    "label": "unchecked-dec",
    "type": "function",
    "info": "Returns a number one less than x, a long.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "Inst",
    "type": "function",
    "info": null
  },
  {
    "label": "tagged-literal?",
    "type": "function",
    "info": "Return true if the value is the data representation of a tagged literal"
  },
  {
    "label": "double-array",
    "type": "function",
    "info": "Creates an array of doubles"
  },
  {
    "label": "in-ns",
    "type": "function",
    "info": "Sets *ns* to the namespace named by the symbol, creating it if needed."
  },
  {
    "label": "create-ns",
    "type": "function",
    "info": "Create a new namespace named by the symbol if one doesn't already\\n  exist, returns it or the already-existing namespace of the same\\n  name."
  },
  {
    "label": "re-matcher",
    "type": "function",
    "info": "Returns an instance of java.util.regex.Matcher, for use, e.g. in\\n  re-find."
  },
  {
    "label": "defn",
    "type": "function",
    "info": "Same as (def name (fn [params* ] exprs*)) or (def\\n    name (fn ([params* ] exprs*)+)) with any doc-string or attrs added\\n    to the var metadata. prepost-map defines a map with optional keys\\n    :pre and :post that contain collections of pre or post conditions."
  },
  {
    "label": "ref",
    "type": "function",
    "info": "Creates and returns a Ref with an initial value of x and zero or\\n  more options (in any order):\\n\\n  :meta metadata-map\\n\\n  :validator validate-fn\\n\\n  :min-history (default 0)\\n  :max-history (default 10)\\n\\n  If metadata-map is supplied, it will become the metadata on the\\n  ref. validate-fn must be nil or a side-effect-free fn of one\\n  argument, which will be passed the intended new state on any state\\n  change. If the new state is unacceptable, the validate-fn should\\n  return false or throw an exception. validate-fn will be called on\\n  transaction commit, when all refs have their final values.\\n\\n  Normally refs accumulate history dynamically as needed to deal with\\n  read demands. If you know in advance you will need history you can\\n  set :min-history to ensure it will be available when first needed (instead\\n  of after a read fault). History is limited, and the limit can be set\\n  with :max-history."
  },
  {
    "label": "bigint",
    "type": "function",
    "info": "Coerce to BigInt"
  },
  {
    "label": "extends?",
    "type": "function",
    "info": "Returns true if atype extends protocol"
  },
  {
    "label": "promise",
    "type": "function",
    "info": "Returns a promise object that can be read with deref\\/@, and set,\\n  once only, with deliver. Calls to deref\\/@ prior to delivery will\\n  block, unless the variant of deref with timeout is used. All\\n  subsequent derefs will return the same delivered value without\\n  blocking. See also - realized?."
  },
  {
    "label": "aset-char",
    "type": "function",
    "info": "Sets the value at the index\\/indices. Works on arrays of char. Returns val."
  },
  {
    "label": "rseq",
    "type": "function",
    "info": "Returns, in constant time, a seq of the items in rev (which\\n  can be a vector or sorted-map), in reverse order. If rev is empty returns nil"
  },
  {
    "label": "ex-cause",
    "type": "function",
    "info": "Returns the cause of ex if ex is a Throwable.\\n  Otherwise returns nil."
  },
  {
    "label": "construct-proxy",
    "type": "function",
    "info": "Takes a proxy class and any arguments for its superclass ctor and\\n  creates and returns an instance of the proxy."
  },
  {
    "label": "agent-errors",
    "type": "function",
    "info": "DEPRECATED: Use 'agent-error' instead.\\n  Returns a sequence of the exceptions thrown during asynchronous\\n  actions of the agent."
  },
  {
    "label": "*compile-files*",
    "type": "function",
    "info": "Set to true when compiling files, false otherwise."
  },
  {
    "label": "ex-message",
    "type": "function",
    "info": "Returns the message attached to ex if ex is a Throwable.\\n  Otherwise returns nil."
  },
  {
    "label": "*math-context*",
    "type": "function",
    "info": null
  },
  {
    "label": "float",
    "type": "function",
    "info": "Coerce to float"
  },
  {
    "label": "pr-str",
    "type": "function",
    "info": "pr to a string, returning it"
  },
  {
    "label": "concat",
    "type": "function",
    "info": "Returns a lazy seq representing the concatenation of the elements in the supplied colls."
  },
  {
    "label": "aset-short",
    "type": "function",
    "info": "Sets the value at the index\\/indices. Works on arrays of short. Returns val."
  },
  {
    "label": "set-agent-send-off-executor!",
    "type": "function",
    "info": "Sets the ExecutorService to be used by send-off"
  },
  {
    "label": "symbol",
    "type": "function",
    "info": "Returns a Symbol with the given namespace and name. Arity-1 works\\n  on strings, keywords, and vars."
  },
  {
    "label": "to-array-2d",
    "type": "function",
    "info": "Returns a (potentially-ragged) 2-dimensional array of Objects\\n  containing the contents of coll, which can be any Collection of any\\n  Collection."
  },
  {
    "label": "mod",
    "type": "function",
    "info": "Modulus of num and div. Truncates toward negative infinity."
  },
  {
    "label": "amap",
    "type": "function",
    "info": "Maps an expression across an array a, using an index named idx, and\\n  return value named ret, initialized to a clone of a, then setting \\n  each element of ret to the evaluation of expr, returning the new \\n  array ret."
  },
  {
    "label": "pop",
    "type": "function",
    "info": "For a list or queue, returns a new list\\/queue without the first\\n  item, for a vector, returns a new vector without the last item. If\\n  the collection is empty, throws an exception.  Note - not the same\\n  as next\\/butlast."
  },
  {
    "label": "unquote",
    "type": "function",
    "info": null
  },
  {
    "label": "declare",
    "type": "function",
    "info": "defs the supplied var names with no bindings, useful for making forward declarations."
  },
  {
    "label": "dissoc!",
    "type": "function",
    "info": "Returns a transient map that doesn't contain a mapping for key(s)."
  },
  {
    "label": "reductions",
    "type": "function",
    "info": "Returns a lazy seq of the intermediate values of the reduction (as\\n  per reduce) of coll by f, starting with init."
  },
  {
    "label": "aset-byte",
    "type": "function",
    "info": "Sets the value at the index\\/indices. Works on arrays of byte. Returns val."
  },
  {
    "label": "indexed?",
    "type": "function",
    "info": "Return true if coll implements Indexed, indicating efficient lookup by index"
  },
  {
    "label": "ref-history-count",
    "type": "function",
    "info": "Returns the history count of a ref"
  },
  {
    "label": "-",
    "type": "function",
    "info": "If no ys are supplied, returns the negation of x, else subtracts\\n  the ys from x and returns the result. Does not auto-promote\\n  longs, will throw on overflow. See also: -'"
  },
  {
    "label": "assoc!",
    "type": "function",
    "info": "When applied to a transient map, adds mapping of key(s) to\\n  val(s). When applied to a transient vector, sets the val at index.\\n  Note - index must be <= (count vector). Returns coll."
  },
  {
    "label": "hash-set",
    "type": "function",
    "info": "Returns a new hash set with supplied keys.  Any equal keys are\\n  handled as if by repeated uses of conj."
  },
  {
    "label": "reduce-kv",
    "type": "function",
    "info": "Reduces an associative collection. f should be a function of 3\\n  arguments. Returns the result of applying f to init, the first key\\n  and the first value in coll, then applying f to that result and the\\n  2nd key and value, etc. If coll contains no entries, returns init\\n  and f is not called. Note that reduce-kv is supported on vectors,\\n  where the keys will be the ordinals."
  },
  {
    "label": "or",
    "type": "function",
    "info": "Evaluates exprs one at a time, from left to right. If a form\\n  returns a logical true value, or returns that value and doesn't\\n  evaluate any of the other expressions, otherwise it returns the\\n  value of the last expression. (or) returns nil."
  },
  {
    "label": "cast",
    "type": "function",
    "info": "Throws a ClassCastException if x is not a c, else returns x."
  },
  {
    "label": "reset!",
    "type": "function",
    "info": "Sets the value of atom to newval without regard for the\\n  current value. Returns newval."
  },
  {
    "label": "name",
    "type": "function",
    "info": "Returns the name String of a string, symbol or keyword."
  },
  {
    "label": "ffirst",
    "type": "function",
    "info": "Same as (first (first x))"
  },
  {
    "label": "sorted-set",
    "type": "function",
    "info": "Returns a new sorted set with supplied keys.  Any equal keys are\\n  handled as if by repeated uses of conj."
  },
  {
    "label": "counted?",
    "type": "function",
    "info": "Returns true if coll implements count in constant time"
  },
  {
    "label": "byte-array",
    "type": "function",
    "info": "Creates an array of bytes"
  },
  {
    "label": "tagged-literal",
    "type": "function",
    "info": "Construct a data representation of a tagged literal from a\\n  tag symbol and a form."
  },
  {
    "label": "extend-type",
    "type": "function",
    "info": "A macro that expands into an extend call. Useful when you are\\n  supplying the definitions explicitly inline, extend-type\\n  automatically creates the maps required by extend.  Propagates the\\n  class as a type hint on the first argument of all fns.\\n\\n  (extend-type MyType \\n    Countable\\n      (cnt [c] ...)\\n    Foo\\n      (bar [x y] ...)\\n      (baz ([x] ...) ([x y & zs] ...)))\\n\\n  expands into:\\n\\n  (extend MyType\\n   Countable\\n     {:cnt (fn [c] ...)}\\n   Foo\\n     {:baz (fn ([x] ...) ([x y & zs] ...))\\n      :bar (fn [x y] ...)})"
  },
  {
    "label": "macroexpand-1",
    "type": "function",
    "info": "If form represents a macro form, returns its expansion,\\n  else returns form."
  },
  {
    "label": "assoc-in",
    "type": "function",
    "info": "Associates a value in a nested associative structure, where ks is a\\n  sequence of keys and v is the new value and returns a new nested structure.\\n  If any levels do not exist, hash-maps will be created."
  },
  {
    "label": "char-name-string",
    "type": "function",
    "info": "Returns name string for char or nil if none"
  },
  {
    "label": "bit-test",
    "type": "function",
    "info": "Test bit at index n"
  },
  {
    "label": "defmethod",
    "type": "function",
    "info": "Creates and installs a new method of multimethod associated with dispatch-value. "
  },
  {
    "label": "requiring-resolve",
    "type": "function",
    "info": "Resolves namespace-qualified sym per 'resolve'. If initial resolve\\nfails, attempts to require sym's namespace and retries."
  },
  {
    "label": "EMPTY-NODE",
    "type": "function",
    "info": null
  },
  {
    "label": "time",
    "type": "function",
    "info": "Evaluates expr and prints the time it took.  Returns the value of\\n expr."
  },
  {
    "label": "memoize",
    "type": "function",
    "info": "Returns a memoized version of a referentially transparent function. The\\n  memoized version of the function keeps a cache of the mapping from arguments\\n  to results and, when calls with the same arguments are repeated often, has\\n  higher performance at the expense of higher memory use."
  },
  {
    "label": "alter-meta!",
    "type": "function",
    "info": "Atomically sets the metadata for a namespace\\/var\\/ref\\/agent\\/atom to be:\\n\\n  (apply f its-current-meta args)\\n\\n  f must be free of side-effects"
  },
  {
    "label": "future?",
    "type": "function",
    "info": "Returns true if x is a future"
  },
  {
    "label": "zero?",
    "type": "function",
    "info": "Returns true if num is zero, else false"
  },
  {
    "label": "simple-keyword?",
    "type": "function",
    "info": "Return true if x is a keyword without a namespace"
  },
  {
    "label": "unchecked-dec-int",
    "type": "function",
    "info": "Returns a number one less than x, an int.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "persistent!",
    "type": "function",
    "info": "Returns a new, persistent version of the transient collection, in\\n  constant time. The transient collection cannot be used after this\\n  call, any such use will throw an exception."
  },
  {
    "label": "nnext",
    "type": "function",
    "info": "Same as (next (next x))"
  },
  {
    "label": "add-watch",
    "type": "function",
    "info": "Adds a watch function to an agent\\/atom\\/var\\/ref reference. The watch\\n  fn must be a fn of 4 args: a key, the reference, its old-state, its\\n  new-state. Whenever the reference's state might have been changed,\\n  any registered watches will have their functions called. The watch fn\\n  will be called synchronously, on the agent's thread if an agent,\\n  before any pending sends if agent or ref. Note that an atom's or\\n  ref's state may have changed again prior to the fn call, so use\\n  old\\/new-state rather than derefing the reference. Note also that watch\\n  fns may be called from multiple threads simultaneously. Var watchers\\n  are triggered only by root binding changes, not thread-local\\n  set!s. Keys must be unique per reference, and can be used to remove\\n  the watch with remove-watch, but are otherwise considered opaque by\\n  the watch mechanism."
  },
  {
    "label": "not-every?",
    "type": "function",
    "info": "Returns false if (pred x) is logical true for every x in\\n  coll, else true."
  },
  {
    "label": "class?",
    "type": "function",
    "info": "Returns true if x is an instance of Class"
  },
  {
    "label": "rem",
    "type": "function",
    "info": "remainder of dividing numerator by denominator."
  },
  {
    "label": "agent-error",
    "type": "function",
    "info": "Returns the exception thrown during an asynchronous action of the\\n  agent if the agent is failed.  Returns nil if the agent is not\\n  failed."
  },
  {
    "label": "some",
    "type": "function",
    "info": "Returns the first logical true value of (pred x) for any x in coll,\\n  else nil.  One common idiom is to use a set as pred, for example\\n  this will return :fred if :fred is in the sequence, otherwise nil:\\n  (some #{:fred} coll)"
  },
  {
    "label": "future-cancelled?",
    "type": "function",
    "info": "Returns true if future f is cancelled"
  },
  {
    "label": "memfn",
    "type": "function",
    "info": "Expands into code that creates a fn that expects to be passed an\\n  object and any args and calls the named instance method on the\\n  object passing the args. Use when you want to treat a Java method as\\n  a first-class fn. name may be type-hinted with the method receiver's\\n  type in order to avoid reflective calls."
  },
  {
    "label": "neg-int?",
    "type": "function",
    "info": "Return true if x is a negative fixed precision integer"
  },
  {
    "label": "struct-map",
    "type": "function",
    "info": "Returns a new structmap instance with the keys of the\\n  structure-basis. keyvals may contain all, some or none of the basis\\n  keys - where values are not supplied they will default to nil.\\n  keyvals can also contain keys not in the basis."
  },
  {
    "label": "drop",
    "type": "function",
    "info": "Returns a lazy sequence of all but the first n items in coll.\\n  Returns a stateful transducer when no collection is provided."
  },
  {
    "label": "*data-readers*",
    "type": "function",
    "info": "Map from reader tag symbols to data reader Vars.\\n\\n  When Clojure starts, it searches for files named 'data_readers.clj'\\n  and 'data_readers.cljc' at the root of the classpath. Each such file\\n  must contain a literal map of symbols, like this:\\n\\n      {foo\\/bar my.project.foo\\/bar\\n       foo\\/baz my.project\\/baz}\\n\\n  The first symbol in each pair is a tag that will be recognized by\\n  the Clojure reader. The second symbol in the pair is the\\n  fully-qualified name of a Var which will be invoked by the reader to\\n  parse the form following the tag. For example, given the\\n  data_readers.clj file above, the Clojure reader would parse this\\n  form:\\n\\n      #foo\\/bar [1 2 3]\\n\\n  by invoking the Var #'my.project.foo\\/bar on the vector [1 2 3]. The\\n  data reader function is invoked on the form AFTER it has been read\\n  as a normal Clojure data structure by the reader.\\n\\n  Reader tags without namespace qualifiers are reserved for\\n  Clojure. Default reader tags are defined in\\n  clojure.core\\/default-data-readers but may be overridden in\\n  data_readers.clj, data_readers.cljc, or by rebinding this Var."
  },
  {
    "label": "nth",
    "type": "function",
    "info": "Returns the value at the index. get returns nil if index out of\\n  bounds, nth throws an exception unless not-found is supplied.  nth\\n  also works for strings, Java arrays, regex Matchers and Lists, and,\\n  in O(n) time, for sequences."
  },
  {
    "label": "sorted?",
    "type": "function",
    "info": "Returns true if coll implements Sorted"
  },
  {
    "label": "nil?",
    "type": "function",
    "info": "Returns true if x is nil, false otherwise."
  },
  {
    "label": "extend-protocol",
    "type": "function",
    "info": "Useful when you want to provide several implementations of the same\\n  protocol all at once. Takes a single protocol and the implementation\\n  of that protocol for one or more types. Expands into calls to\\n  extend-type:\\n\\n  (extend-protocol Protocol\\n    AType\\n      (foo [x] ...)\\n      (bar [x y] ...)\\n    BType\\n      (foo [x] ...)\\n      (bar [x y] ...)\\n    AClass\\n      (foo [x] ...)\\n      (bar [x y] ...)\\n    nil\\n      (foo [x] ...)\\n      (bar [x y] ...))\\n\\n  expands into:\\n\\n  (do\\n   (clojure.core\\/extend-type AType Protocol \\n     (foo [x] ...) \\n     (bar [x y] ...))\\n   (clojure.core\\/extend-type BType Protocol \\n     (foo [x] ...) \\n     (bar [x y] ...))\\n   (clojure.core\\/extend-type AClass Protocol \\n     (foo [x] ...) \\n     (bar [x y] ...))\\n   (clojure.core\\/extend-type nil Protocol \\n     (foo [x] ...) \\n     (bar [x y] ...)))"
  },
  {
    "label": "split-at",
    "type": "function",
    "info": "Returns a vector of [(take n coll) (drop n coll)]"
  },
  {
    "label": "*e",
    "type": "function",
    "info": "bound in a repl thread to the most recent exception caught by the repl"
  },
  {
    "label": "load-reader",
    "type": "function",
    "info": "Sequentially read and evaluate the set of forms contained in the\\n  stream\\/file"
  },
  {
    "label": "random-sample",
    "type": "function",
    "info": "Returns items from coll with random probability of prob (0.0 -\\n  1.0).  Returns a transducer when no collection is provided."
  },
  {
    "label": "cond->",
    "type": "function",
    "info": "Takes an expression and a set of test\\/form pairs. Threads expr (via ->)\\n  through each form for which the corresponding test\\n  expression is true. Note that, unlike cond branching, cond-> threading does\\n  not short circuit after the first true test expression."
  },
  {
    "label": "dotimes",
    "type": "function",
    "info": "bindings => name n\\n\\n  Repeatedly executes body (presumably for side-effects) with name\\n  bound to integers from 0 through n-1."
  },
  {
    "label": "select-keys",
    "type": "function",
    "info": "Returns a map containing only those entries in map whose key is in keys"
  },
  {
    "label": "bit-and",
    "type": "function",
    "info": "Bitwise and"
  },
  {
    "label": "bounded-count",
    "type": "function",
    "info": "If coll is counted? returns its count, else will count at most the first n\\n  elements of coll using its seq"
  },
  {
    "label": "update",
    "type": "function",
    "info": "'Updates' a value in an associative structure, where k is a\\n  key and f is a function that will take the old value\\n  and any supplied args and return the new value, and returns a new\\n  structure.  If the key does not exist, nil is passed as the old value."
  },
  {
    "label": "list*",
    "type": "function",
    "info": "Creates a new seq containing the items prepended to the rest, the\\n  last of which will be treated as a sequence."
  },
  {
    "label": "reify",
    "type": "function",
    "info": "reify is a macro with the following structure:\\n\\n (reify options* specs*)\\n  \\n  Currently there are no options.\\n\\n  Each spec consists of the protocol or interface name followed by zero\\n  or more method bodies:\\n\\n  protocol-or-interface-or-Object\\n  (methodName [args+] body)*\\n\\n  Methods should be supplied for all methods of the desired\\n  protocol(s) and interface(s). You can also define overrides for\\n  methods of Object. Note that the first parameter must be supplied to\\n  correspond to the target object ('this' in Java parlance). Thus\\n  methods for interfaces will take one more argument than do the\\n  interface declarations.  Note also that recur calls to the method\\n  head should *not* pass the target object, it will be supplied\\n  automatically and can not be substituted.\\n\\n  The return type can be indicated by a type hint on the method name,\\n  and arg types can be indicated by a type hint on arg names. If you\\n  leave out all hints, reify will try to match on same name\\/arity\\n  method in the protocol(s)\\/interface(s) - this is preferred. If you\\n  supply any hints at all, no inference is done, so all hints (or\\n  default of Object) must be correct, for both arguments and return\\n  type. If a method is overloaded in a protocol\\/interface, multiple\\n  independent method definitions must be supplied.  If overloaded with\\n  same arity in an interface you must specify complete hints to\\n  disambiguate - a missing hint implies Object.\\n\\n  recur works to method heads The method bodies of reify are lexical\\n  closures, and can refer to the surrounding local scope:\\n  \\n  (str (let [f \\"foo\\"] \\n       (reify Object \\n         (toString [this] f))))\\n  == \\"foo\\"\\n\\n  (seq (let [f \\"foo\\"] \\n       (reify clojure.lang.Seqable \\n         (seq [this] (seq f)))))\\n  == (\\\\f \\\\o \\\\o))\\n  \\n  reify always implements clojure.lang.IObj and transfers meta\\n  data of the form to the created object.\\n  \\n  (meta ^{:k :v} (reify Object (toString [this] \\"foo\\")))\\n  == {:k :v}"
  },
  {
    "label": "update-in",
    "type": "function",
    "info": "'Updates' a value in a nested associative structure, where ks is a\\n  sequence of keys and f is a function that will take the old value\\n  and any supplied args and return the new value, and returns a new\\n  nested structure.  If any levels do not exist, hash-maps will be\\n  created."
  },
  {
    "label": "prefer-method",
    "type": "function",
    "info": "Causes the multimethod to prefer matches of dispatch-val-x over dispatch-val-y \\n   when there is a conflict"
  },
  {
    "label": "aset-int",
    "type": "function",
    "info": "Sets the value at the index\\/indices. Works on arrays of int. Returns val."
  },
  {
    "label": "*clojure-version*",
    "type": "function",
    "info": "The version info for Clojure core, as a map containing :major :minor \\n  :incremental and :qualifier keys. Feature releases may increment \\n  :minor and\\/or :major, bugfix releases will increment :incremental. \\n  Possible values of :qualifier include \\"GA\\", \\"SNAPSHOT\\", \\"RC-x\\" \\"BETA-x\\""
  },
  {
    "label": "ensure-reduced",
    "type": "function",
    "info": "If x is already reduced?, returns it, else returns (reduced x)"
  },
  {
    "label": "*'",
    "type": "function",
    "info": "Returns the product of nums. (*') returns 1. Supports arbitrary precision.\\n  See also: *"
  },
  {
    "label": "instance?",
    "type": "function",
    "info": "Evaluates x and tests if it is an instance of the class\\n    c. Returns true or false"
  },
  {
    "label": "with-open",
    "type": "function",
    "info": "bindings => [name init ...]\\n\\n  Evaluates body in a try expression with names bound to the values\\n  of the inits, and a finally clause that calls (.close name) on each\\n  name in reverse order."
  },
  {
    "label": "mix-collection-hash",
    "type": "function",
    "info": "Mix final collection hash for ordered or unordered collections.\\n   hash-basis is the combined collection hash, count is the number\\n   of elements included in the basis. Note this is the hash code\\n   consistent with =, different from .hashCode.\\n   See http:\\/\\/clojure.org\\/data_structures#hash for full algorithms."
  },
  {
    "label": "re-find",
    "type": "function",
    "info": "Returns the next regex match, if any, of string to pattern, using\\n  java.util.regex.Matcher.find().  Uses re-groups to return the\\n  groups."
  },
  {
    "label": "run!",
    "type": "function",
    "info": "Runs the supplied procedure (via reduce), for purposes of side\\n  effects, on successive items in the collection. Returns nil"
  },
  {
    "label": "val",
    "type": "function",
    "info": "Returns the value in the map entry."
  },
  {
    "label": "defonce",
    "type": "function",
    "info": "defs name to have the root value of the expr iff the named var has no root value,\\n  else expr is unevaluated"
  },
  {
    "label": "unchecked-add",
    "type": "function",
    "info": "Returns the sum of x and y, both long.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "loaded-libs",
    "type": "function",
    "info": "Returns a sorted set of symbols naming the currently loaded libs"
  },
  {
    "label": "->Vec",
    "type": "function",
    "info": "Positional factory function for class clojure.core.Vec."
  },
  {
    "label": "bytes?",
    "type": "function",
    "info": "Return true if x is a byte array"
  },
  {
    "label": "not",
    "type": "function",
    "info": "Returns true if x is logical false, false otherwise."
  },
  {
    "label": "with-meta",
    "type": "function",
    "info": "Returns an object of the same type and value as obj, with\\n    map m as its metadata."
  },
  {
    "label": "unreduced",
    "type": "function",
    "info": "If x is reduced?, returns (deref x), else returns x"
  },
  {
    "label": "the-ns",
    "type": "function",
    "info": "If passed a namespace, returns it. Else, when passed a symbol,\\n  returns the namespace named by it, throwing an exception if not\\n  found."
  },
  {
    "label": "record?",
    "type": "function",
    "info": "Returns true if x is a record"
  },
  {
    "label": "type",
    "type": "function",
    "info": "Returns the :type metadata of x, or its Class if none"
  },
  {
    "label": "identical?",
    "type": "function",
    "info": "Tests if 2 arguments are the same object"
  },
  {
    "label": "unchecked-divide-int",
    "type": "function",
    "info": "Returns the division of x by y, both int.\\n  Note - uses a primitive operator subject to truncation."
  },
  {
    "label": "ns-name",
    "type": "function",
    "info": "Returns the name of the namespace, a symbol."
  },
  {
    "label": "max-key",
    "type": "function",
    "info": "Returns the x for which (k x), a number, is greatest.\\n\\n  If there are multiple such xs, the last one is returned."
  },
  {
    "label": "*unchecked-math*",
    "type": "function",
    "info": "While bound to true, compilations of +, -, *, inc, dec and the\\n  coercions will be done without overflow checks. While bound\\n  to :warn-on-boxed, same behavior as true, and a warning is emitted\\n  when compilation uses boxed math. Default: false."
  },
  {
    "label": "defn-",
    "type": "function",
    "info": "same as defn, yielding non-public def"
  },
  {
    "label": "*out*",
    "type": "function",
    "info": "A java.io.Writer object representing standard output for print operations.\\n\\n  Defaults to System\\/out, wrapped in an OutputStreamWriter"
  },
  {
    "label": "file-seq",
    "type": "function",
    "info": "A tree seq on java.io.Files"
  },
  {
    "label": "agent",
    "type": "function",
    "info": "Creates and returns an agent with an initial value of state and\\n  zero or more options (in any order):\\n\\n  :meta metadata-map\\n\\n  :validator validate-fn\\n\\n  :error-handler handler-fn\\n\\n  :error-mode mode-keyword\\n\\n  If metadata-map is supplied, it will become the metadata on the\\n  agent. validate-fn must be nil or a side-effect-free fn of one\\n  argument, which will be passed the intended new state on any state\\n  change. If the new state is unacceptable, the validate-fn should\\n  return false or throw an exception.  handler-fn is called if an\\n  action throws an exception or if validate-fn rejects a new state --\\n  see set-error-handler! for details.  The mode-keyword may be either\\n  :continue (the default if an error-handler is given) or :fail (the\\n  default if no error-handler is given) -- see set-error-mode! for\\n  details."
  },
  {
    "label": "ns-map",
    "type": "function",
    "info": "Returns a map of all the mappings for the namespace."
  },
  {
    "label": "set-validator!",
    "type": "function",
    "info": "Sets the validator-fn for a var\\/ref\\/agent\\/atom. validator-fn must be nil or a\\n  side-effect-free fn of one argument, which will be passed the intended\\n  new state on any state change. If the new state is unacceptable, the\\n  validator-fn should return false or throw an exception. If the current state (root\\n  value if var) is not acceptable to the new validator, an exception\\n  will be thrown and the validator will not be changed."
  },
  {
    "label": "ident?",
    "type": "function",
    "info": "Return true if x is a symbol or keyword"
  },
  {
    "label": "defprotocol",
    "type": "function",
    "info": "A protocol is a named set of named methods and their signatures:\\n  (defprotocol AProtocolName\\n\\n    ;optional doc string\\n    \\"A doc string for AProtocol abstraction\\"\\n\\n   ;options\\n   :extend-via-metadata true\\n\\n  ;method signatures\\n    (bar [this a b] \\"bar docs\\")\\n    (baz [this a] [this a b] [this a b c] \\"baz docs\\"))\\n\\n  No implementations are provided. Docs can be specified for the\\n  protocol overall and for each method. The above yields a set of\\n  polymorphic functions and a protocol object. All are\\n  namespace-qualified by the ns enclosing the definition The resulting\\n  functions dispatch on the type of their first argument, which is\\n  required and corresponds to the implicit target object ('this' in \\n  Java parlance). defprotocol is dynamic, has no special compile-time \\n  effect, and defines no new types or classes. Implementations of \\n  the protocol methods can be provided using extend.\\n\\n  When :extend-via-metadata is true, values can extend protocols by\\n  adding metadata where keys are fully-qualified protocol function\\n  symbols and values are function implementations. Protocol\\n  implementations are checked first for direct definitions (defrecord,\\n  deftype, reify), then metadata definitions, then external\\n  extensions (extend, extend-type, extend-protocol)\\n\\n  defprotocol will automatically generate a corresponding interface,\\n  with the same name as the protocol, i.e. given a protocol:\\n  my.ns\\/Protocol, an interface: my.ns.Protocol. The interface will\\n  have methods corresponding to the protocol functions, and the\\n  protocol will automatically work with instances of the interface.\\n\\n  Note that you should not use this interface with deftype or\\n  reify, as they support the protocol directly:\\n\\n  (defprotocol P \\n    (foo [this]) \\n    (bar-me [this] [this y]))\\n\\n  (deftype Foo [a b c] \\n   P\\n    (foo [this] a)\\n    (bar-me [this] b)\\n    (bar-me [this y] (+ c y)))\\n  \\n  (bar-me (Foo. 1 2 3) 42)\\n  => 45\\n\\n  (foo \\n    (let [x 42]\\n      (reify P \\n        (foo [this] 17)\\n        (bar-me [this] x)\\n        (bar-me [this y] x))))\\n  => 17"
  },
  {
    "label": "swap!",
    "type": "function",
    "info": "Atomically swaps the value of atom to be:\\n  (apply f current-value-of-atom args). Note that f may be called\\n  multiple times, and thus should be free of side effects.  Returns\\n  the value that was swapped in."
  },
  {
    "label": "vals",
    "type": "function",
    "info": "Returns a sequence of the map's values, in the same order as (seq map)."
  },
  {
    "label": "unchecked-subtract",
    "type": "function",
    "info": "Returns the difference of x and y, both long.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "tap>",
    "type": "function",
    "info": "sends x to any taps. Will not block. Returns true if there was room in the queue,\\n  false if not (dropped)."
  },
  {
    "label": "*warn-on-reflection*",
    "type": "function",
    "info": "When set to true, the compiler will emit warnings when reflection is\\n  needed to resolve Java method calls or field accesses.\\n\\n  Defaults to false."
  },
  {
    "label": "sorted-set-by",
    "type": "function",
    "info": "Returns a new sorted set with supplied keys, using the supplied\\n  comparator.  Any equal keys are handled as if by repeated uses of\\n  conj."
  },
  {
    "label": "sync",
    "type": "function",
    "info": "transaction-flags => TBD, pass nil for now\\n\\n  Runs the exprs (in an implicit do) in a transaction that encompasses\\n  exprs and any nested calls.  Starts a transaction if none is already\\n  running on this thread. Any uncaught exception will abort the\\n  transaction and flow out of sync. The exprs may be run more than\\n  once, but any effects on Refs will be atomic."
  },
  {
    "label": "qualified-ident?",
    "type": "function",
    "info": "Return true if x is a symbol or keyword with a namespace"
  },
  {
    "label": "assert",
    "type": "function",
    "info": "Evaluates expr and throws an exception if it does not evaluate to\\n  logical true."
  },
  {
    "label": "*compile-path*",
    "type": "function",
    "info": "Specifies the directory where 'compile' will write out .class\\n  files. This directory must be in the classpath for 'compile' to\\n  work.\\n\\n  Defaults to \\"classes\\""
  },
  {
    "label": "true?",
    "type": "function",
    "info": "Returns true if x is the value true, false otherwise."
  },
  {
    "label": "release-pending-sends",
    "type": "function",
    "info": "Normally, actions sent directly or indirectly during another action\\n  are held until the action completes (changes the agent's\\n  state). This function can be used to dispatch any pending sent\\n  actions immediately. This has no impact on actions sent during a\\n  transaction, which are still held until commit. If no action is\\n  occurring, does nothing. Returns the number of actions dispatched."
  },
  {
    "label": "empty",
    "type": "function",
    "info": "Returns an empty collection of the same category as coll, or nil"
  },
  {
    "label": "remove-method",
    "type": "function",
    "info": "Removes the method of multimethod associated with dispatch-value."
  },
  {
    "label": "*in*",
    "type": "function",
    "info": "A java.io.Reader object representing standard input for read operations.\\n\\n  Defaults to System\\/in, wrapped in a LineNumberingPushbackReader"
  },
  {
    "label": "print-ctor",
    "type": "function",
    "info": null
  },
  {
    "label": "letfn",
    "type": "function",
    "info": "fnspec ==> (fname [params*] exprs) or (fname ([params*] exprs)+)\\n\\n  Takes a vector of function specs and a body, and generates a set of\\n  bindings of functions to their names. All of the names are available\\n  in all of the definitions of the functions, as well as the body."
  },
  {
    "label": "volatile!",
    "type": "function",
    "info": "Creates and returns a Volatile with an initial value of val."
  },
  {
    "label": "\\/",
    "type": "function",
    "info": "If no denominators are supplied, returns 1\\/numerator,\\n  else returns numerator divided by all of the denominators."
  },
  {
    "label": "read-line",
    "type": "function",
    "info": "Reads the next line from stream that is the current value of *in* ."
  },
  {
    "label": "reader-conditional?",
    "type": "function",
    "info": "Return true if the value is the data representation of a reader conditional"
  },
  {
    "label": "bit-or",
    "type": "function",
    "info": "Bitwise or"
  },
  {
    "label": "clear-agent-errors",
    "type": "function",
    "info": "DEPRECATED: Use 'restart-agent' instead.\\n  Clears any exceptions thrown during asynchronous actions of the\\n  agent, allowing subsequent actions to occur."
  },
  {
    "label": "vector",
    "type": "function",
    "info": "Creates a new vector containing the args."
  },
  {
    "label": "proxy-super",
    "type": "function",
    "info": "Use to call a superclass method in the body of a proxy method. \\n  Note, expansion captures 'this"
  },
  {
    "label": ">=",
    "type": "function",
    "info": "Returns non-nil if nums are in monotonically non-increasing order,\\n  otherwise false."
  },
  {
    "label": "drop-last",
    "type": "function",
    "info": "Return a lazy sequence of all but the last n (default 1) items in coll"
  },
  {
    "label": "not-empty",
    "type": "function",
    "info": "If coll is empty, returns nil, else coll"
  },
  {
    "label": "distinct",
    "type": "function",
    "info": "Returns a lazy sequence of the elements of coll with duplicates removed.\\n  Returns a stateful transducer when no collection is provided."
  },
  {
    "label": "partition",
    "type": "function",
    "info": "Returns a lazy sequence of lists of n items each, at offsets step\\n  apart. If step is not supplied, defaults to n, i.e. the partitions\\n  do not overlap. If a pad collection is supplied, use its elements as\\n  necessary to complete last partition upto n items. In case there are\\n  not enough padding elements, return a partition with less than n items."
  },
  {
    "label": "loop",
    "type": "function",
    "info": "Evaluates the exprs in a lexical context in which the symbols in\\n  the binding-forms are bound to their respective init-exprs or parts\\n  therein. Acts as a recur target."
  },
  {
    "label": "add-classpath",
    "type": "function",
    "info": "DEPRECATED \\n\\n  Adds the url (String or URL object) to the classpath per\\n  URLClassLoader.addURL"
  },
  {
    "label": "bit-flip",
    "type": "function",
    "info": "Flip bit at index n"
  },
  {
    "label": "long-array",
    "type": "function",
    "info": "Creates an array of longs"
  },
  {
    "label": "descendants",
    "type": "function",
    "info": "Returns the immediate and indirect children of tag, through a\\n  relationship established via derive. h must be a hierarchy obtained\\n  from make-hierarchy, if not supplied defaults to the global\\n  hierarchy. Note: does not work on Java type inheritance\\n  relationships."
  },
  {
    "label": "merge",
    "type": "function",
    "info": "Returns a map that consists of the rest of the maps conj-ed onto\\n  the first.  If a key occurs in more than one map, the mapping from\\n  the latter (left-to-right) will be the mapping in the result."
  },
  {
    "label": "accessor",
    "type": "function",
    "info": "Returns a fn that, given an instance of a structmap with the basis,\\n  returns the value at the key.  The key must be in the basis. The\\n  returned function should be (slightly) more efficient than using\\n  get, but such use of accessors should be limited to known\\n  performance-critical areas."
  },
  {
    "label": "integer?",
    "type": "function",
    "info": "Returns true if n is an integer"
  },
  {
    "label": "mapv",
    "type": "function",
    "info": "Returns a vector consisting of the result of applying f to the\\n  set of first items of each coll, followed by applying f to the set\\n  of second items in each coll, until any one of the colls is\\n  exhausted.  Any remaining items in other colls are ignored. Function\\n  f should accept number-of-colls arguments."
  },
  {
    "label": "partition-all",
    "type": "function",
    "info": "Returns a lazy sequence of lists like partition, but may include\\n  partitions with fewer than n items at the end.  Returns a stateful\\n  transducer when no collection is provided."
  },
  {
    "label": "partition-by",
    "type": "function",
    "info": "Applies f to each value in coll, splitting it each time f returns a\\n   new value.  Returns a lazy seq of partitions.  Returns a stateful\\n   transducer when no collection is provided."
  },
  {
    "label": "numerator",
    "type": "function",
    "info": "Returns the numerator part of a Ratio."
  },
  {
    "label": "object-array",
    "type": "function",
    "info": "Creates an array of objects"
  },
  {
    "label": "with-out-str",
    "type": "function",
    "info": "Evaluates exprs in a context in which *out* is bound to a fresh\\n  StringWriter.  Returns the string created by any nested printing\\n  calls."
  },
  {
    "label": "condp",
    "type": "function",
    "info": "Takes a binary predicate, an expression, and a set of clauses.\\n  Each clause can take the form of either:\\n\\n  test-expr result-expr\\n\\n  test-expr :>> result-fn\\n\\n  Note :>> is an ordinary keyword.\\n\\n  For each clause, (pred test-expr expr) is evaluated. If it returns\\n  logical true, the clause is a match. If a binary clause matches, the\\n  result-expr is returned, if a ternary clause matches, its result-fn,\\n  which must be a unary function, is called with the result of the\\n  predicate as its argument, the result of that call being the return\\n  value of condp. A single default expression can follow the clauses,\\n  and its value will be returned if no clause matches. If no default\\n  expression is provided and no clause matches, an\\n  IllegalArgumentException is thrown."
  },
  {
    "label": "derive",
    "type": "function",
    "info": "Establishes a parent\\/child relationship between parent and\\n  tag. Parent must be a namespace-qualified symbol or keyword and\\n  child can be either a namespace-qualified symbol or keyword or a\\n  class. h must be a hierarchy obtained from make-hierarchy, if not\\n  supplied defaults to, and modifies, the global hierarchy."
  },
  {
    "label": "load-string",
    "type": "function",
    "info": "Sequentially read and evaluate the set of forms contained in the\\n  string"
  },
  {
    "label": "special-symbol?",
    "type": "function",
    "info": "Returns true if s names a special form"
  },
  {
    "label": "ancestors",
    "type": "function",
    "info": "Returns the immediate and indirect parents of tag, either via a Java type\\n  inheritance relationship or a relationship established via derive. h\\n  must be a hierarchy obtained from make-hierarchy, if not supplied\\n  defaults to the global hierarchy"
  },
  {
    "label": "subseq",
    "type": "function",
    "info": "sc must be a sorted collection, test(s) one of <, <=, > or\\n  >=. Returns a seq of those entries with keys ek for\\n  which (test (.. sc comparator (compare ek key)) 0) is true"
  },
  {
    "label": "error-handler",
    "type": "function",
    "info": "Returns the error-handler of agent a, or nil if there is none.\\n  See set-error-handler!"
  },
  {
    "label": "gensym",
    "type": "function",
    "info": "Returns a new symbol with a unique name. If a prefix string is\\n  supplied, the name is prefix# where # is some unique number. If\\n  prefix is not supplied, the prefix is 'G__'."
  },
  {
    "label": "cond",
    "type": "function",
    "info": "Takes a set of test\\/expr pairs. It evaluates each test one at a\\n  time.  If a test returns logical true, cond evaluates and returns\\n  the value of the corresponding expr and doesn't evaluate any of the\\n  other tests or exprs. (cond) returns nil."
  },
  {
    "label": "ratio?",
    "type": "function",
    "info": "Returns true if n is a Ratio"
  },
  {
    "label": "delay?",
    "type": "function",
    "info": "returns true if x is a Delay created with delay"
  },
  {
    "label": "intern",
    "type": "function",
    "info": "Finds or creates a var named by the symbol name in the namespace\\n  ns (which can be a symbol or a namespace), setting its root binding\\n  to val if supplied. The namespace must exist. The var will adopt any\\n  metadata from the name symbol.  Returns the var."
  },
  {
    "label": "print-simple",
    "type": "function",
    "info": null
  },
  {
    "label": "flatten",
    "type": "function",
    "info": "Takes any nested combination of sequential things (lists, vectors,\\n  etc.) and returns their contents as a single, flat lazy sequence.\\n  (flatten nil) returns an empty sequence."
  },
  {
    "label": "doubles",
    "type": "function",
    "info": "Casts to double[]"
  },
  {
    "label": "halt-when",
    "type": "function",
    "info": "Returns a transducer that ends transduction when pred returns true\\n  for an input. When retf is supplied it must be a fn of 2 arguments -\\n  it will be passed the (completed) result so far and the input that\\n  triggered the predicate, and its return value (if it does not throw\\n  an exception) will be the return value of the transducer. If retf\\n  is not supplied, the input that triggered the predicate will be\\n  returned. If the predicate never returns true the transduction is\\n  unaffected."
  },
  {
    "label": "with-in-str",
    "type": "function",
    "info": "Evaluates body in a context in which *in* is bound to a fresh\\n  StringReader initialized with the string s."
  },
  {
    "label": "remove-watch",
    "type": "function",
    "info": "Removes a watch (set by add-watch) from a reference"
  },
  {
    "label": "ex-info",
    "type": "function",
    "info": "Create an instance of ExceptionInfo, a RuntimeException subclass\\n   that carries a map of additional data."
  },
  {
    "label": "ifn?",
    "type": "function",
    "info": "Returns true if x implements IFn. Note that many data structures\\n  (e.g. sets and maps) implement IFn"
  },
  {
    "label": "some->",
    "type": "function",
    "info": "When expr is not nil, threads it into the first form (via ->),\\n  and when that result is not nil, through the next etc"
  },
  {
    "label": "nat-int?",
    "type": "function",
    "info": "Return true if x is a non-negative fixed precision integer"
  },
  {
    "label": "proxy-name",
    "type": "function",
    "info": null
  },
  {
    "label": "ns-interns",
    "type": "function",
    "info": "Returns a map of the intern mappings for the namespace."
  },
  {
    "label": "all-ns",
    "type": "function",
    "info": "Returns a sequence of all namespaces."
  },
  {
    "label": "find-protocol-method",
    "type": "function",
    "info": null
  },
  {
    "label": "subvec",
    "type": "function",
    "info": "Returns a persistent vector of the items in vector from\\n  start (inclusive) to end (exclusive).  If end is not supplied,\\n  defaults to (count vector). This operation is O(1) and very fast, as\\n  the resulting vector shares structure with the original and no\\n  trimming is done."
  },
  {
    "label": "for",
    "type": "function",
    "info": "List comprehension. Takes a vector of one or more\\n   binding-form\\/collection-expr pairs, each followed by zero or more\\n   modifiers, and yields a lazy sequence of evaluations of expr.\\n   Collections are iterated in a nested fashion, rightmost fastest,\\n   and nested coll-exprs can refer to bindings created in prior\\n   binding-forms.  Supported modifiers are: :let [binding-form expr ...],\\n   :while test, :when test.\\n\\n  (take 100 (for [x (range 100000000) y (range 1000000) :while (< y x)] [x y]))"
  },
  {
    "label": "partial",
    "type": "function",
    "info": "Takes a function f and fewer than the normal arguments to f, and\\n  returns a fn that takes a variable number of additional args. When\\n  called, the returned function calls f with args + additional args."
  },
  {
    "label": "chunked-seq?",
    "type": "function",
    "info": null
  },
  {
    "label": "find-keyword",
    "type": "function",
    "info": "Returns a Keyword with the given namespace and name if one already\\n  exists.  This function will not intern a new keyword. If the keyword\\n  has not already been interned, it will return nil.  Do not use :\\n  in the keyword strings, it will be added automatically."
  },
  {
    "label": "replicate",
    "type": "function",
    "info": "DEPRECATED: Use 'repeat' instead.\\n   Returns a lazy seq of n xs."
  },
  {
    "label": "min-key",
    "type": "function",
    "info": "Returns the x for which (k x), a number, is least.\\n\\n  If there are multiple such xs, the last one is returned."
  },
  {
    "label": "reduced",
    "type": "function",
    "info": "Wraps x in a way such that a reduce will terminate with the value x"
  },
  {
    "label": "char-escape-string",
    "type": "function",
    "info": "Returns escape string for char or nil if none"
  },
  {
    "label": "re-matches",
    "type": "function",
    "info": "Returns the match, if any, of string to pattern, using\\n  java.util.regex.Matcher.matches().  Uses re-groups to return the\\n  groups."
  },
  {
    "label": "array-map",
    "type": "function",
    "info": "Constructs an array-map. If any keys are equal, they are handled as\\n  if by repeated uses of assoc."
  },
  {
    "label": "unchecked-byte",
    "type": "function",
    "info": "Coerce to byte. Subject to rounding or truncation."
  },
  {
    "label": "with-local-vars",
    "type": "function",
    "info": "varbinding=> symbol init-expr\\n\\n  Executes the exprs in a context in which the symbols are bound to\\n  vars with per-thread bindings to the init-exprs.  The symbols refer\\n  to the var objects themselves, and must be accessed with var-get and\\n  var-set"
  },
  {
    "label": "ns-imports",
    "type": "function",
    "info": "Returns a map of the import mappings for the namespace."
  },
  {
    "label": "send-off",
    "type": "function",
    "info": "Dispatch a potentially blocking action to an agent. Returns the\\n  agent immediately. Subsequently, in a separate thread, the state of\\n  the agent will be set to the value of:\\n\\n  (apply action-fn state-of-agent args)"
  },
  {
    "label": "defmacro",
    "type": "function",
    "info": "Like defn, but the resulting function name is declared as a\\n  macro and will be used as a macro by the compiler when it is\\n  called."
  },
  {
    "label": "every-pred",
    "type": "function",
    "info": "Takes a set of predicates and returns a function f that returns true if all of its\\n  composing predicates return a logical true value against all of its arguments, else it returns\\n  false. Note that f is short-circuiting in that it will stop execution on the first\\n  argument that triggers a logical false result against the original predicates."
  },
  {
    "label": "keys",
    "type": "function",
    "info": "Returns a sequence of the map's keys, in the same order as (seq map)."
  },
  {
    "label": "rationalize",
    "type": "function",
    "info": "returns the rational value of num"
  },
  {
    "label": "distinct?",
    "type": "function",
    "info": "Returns true if no two of the arguments are ="
  },
  {
    "label": "pos-int?",
    "type": "function",
    "info": "Return true if x is a positive fixed precision integer"
  },
  {
    "label": "extenders",
    "type": "function",
    "info": "Returns a collection of the types explicitly extending protocol"
  },
  {
    "label": "unchecked-short",
    "type": "function",
    "info": "Coerce to short. Subject to rounding or truncation."
  },
  {
    "label": "methods",
    "type": "function",
    "info": "Given a multimethod, returns a map of dispatch values -> dispatch fns"
  },
  {
    "label": "odd?",
    "type": "function",
    "info": "Returns true if n is odd, throws an exception if n is not an integer"
  },
  {
    "label": "->ArrayChunk",
    "type": "function",
    "info": "Positional factory function for class clojure.core.ArrayChunk."
  },
  {
    "label": "float-array",
    "type": "function",
    "info": "Creates an array of floats"
  },
  {
    "label": "*3",
    "type": "function",
    "info": "bound in a repl thread to the third most recent value printed"
  },
  {
    "label": "alias",
    "type": "function",
    "info": "Add an alias in the current namespace to another\\n  namespace. Arguments are two symbols: the alias to be used, and\\n  the symbolic name of the target namespace. Use :as in the ns macro in preference\\n  to calling this directly."
  },
  {
    "label": "frequencies",
    "type": "function",
    "info": "Returns a map from distinct items in coll to the number of times\\n  they appear."
  },
  {
    "label": "proxy",
    "type": "function",
    "info": "class-and-interfaces - a vector of class names\\n\\n  args - a (possibly empty) vector of arguments to the superclass\\n  constructor.\\n\\n  f => (name [params*] body) or\\n  (name ([params*] body) ([params+] body) ...)\\n\\n  Expands to code which creates a instance of a proxy class that\\n  implements the named class\\/interface(s) by calling the supplied\\n  fns. A single class, if provided, must be first. If not provided it\\n  defaults to Object.\\n\\n  The interfaces names must be valid interface types. If a method fn\\n  is not provided for a class method, the superclass method will be\\n  called. If a method fn is not provided for an interface method, an\\n  UnsupportedOperationException will be thrown should it be\\n  called. Method fns are closures and can capture the environment in\\n  which proxy is called. Each method fn takes an additional implicit\\n  first arg, which is bound to 'this. Note that while method fns can\\n  be provided to override protected methods, they have no other access\\n  to protected members, nor to super, as these capabilities cannot be\\n  proxied."
  },
  {
    "label": "rsubseq",
    "type": "function",
    "info": "sc must be a sorted collection, test(s) one of <, <=, > or\\n  >=. Returns a reverse seq of those entries with keys ek for\\n  which (test (.. sc comparator (compare ek key)) 0) is true"
  },
  {
    "label": "inc",
    "type": "function",
    "info": "Returns a number one greater than num. Does not auto-promote\\n  longs, will throw on overflow. See also: inc'"
  },
  {
    "label": "get-method",
    "type": "function",
    "info": "Given a multimethod and a dispatch value, returns the dispatch fn\\n  that would apply to that value, or nil if none apply and no default"
  },
  {
    "label": "with-redefs",
    "type": "function",
    "info": "binding => var-symbol temp-value-expr\\n\\n  Temporarily redefines Vars while executing the body.  The\\n  temp-value-exprs will be evaluated and each resulting value will\\n  replace in parallel the root value of its Var.  After the body is\\n  executed, the root values of all the Vars will be set back to their\\n  old values.  These temporary changes will be visible in all threads.\\n  Useful for mocking out functions during testing."
  },
  {
    "label": "uuid?",
    "type": "function",
    "info": "Return true if x is a java.util.UUID"
  },
  {
    "label": "bit-clear",
    "type": "function",
    "info": "Clear bit at index n"
  },
  {
    "label": "filter",
    "type": "function",
    "info": "Returns a lazy sequence of the items in coll for which\\n  (pred item) returns logical true. pred must be free of side-effects.\\n  Returns a transducer when no collection is provided."
  },
  {
    "label": "locking",
    "type": "function",
    "info": "Executes exprs in an implicit do, while holding the monitor of x.\\n  Will release the monitor of x in all circumstances."
  },
  {
    "label": "list",
    "type": "function",
    "info": "Creates a new list containing the items."
  },
  {
    "label": "+",
    "type": "function",
    "info": "Returns the sum of nums. (+) returns 0. Does not auto-promote\\n  longs, will throw on overflow. See also: +'"
  },
  {
    "label": "split-with",
    "type": "function",
    "info": "Returns a vector of [(take-while pred coll) (drop-while pred coll)]"
  },
  {
    "label": "aset",
    "type": "function",
    "info": "Sets the value at the index\\/indices. Works on Java arrays of\\n  reference types. Returns val."
  },
  {
    "label": "->VecNode",
    "type": "function",
    "info": "Positional factory function for class clojure.core.VecNode."
  },
  {
    "label": "keyword",
    "type": "function",
    "info": "Returns a Keyword with the given namespace and name.  Do not use :\\n  in the keyword strings, it will be added automatically."
  },
  {
    "label": "*ns*",
    "type": "function",
    "info": "A clojure.lang.Namespace object representing the current namespace."
  },
  {
    "label": "destructure",
    "type": "function",
    "info": null
  },
  {
    "label": "*assert*",
    "type": "function",
    "info": null
  },
  {
    "label": "defmulti",
    "type": "function",
    "info": "Creates a new multimethod with the associated dispatch function.\\n  The docstring and attr-map are optional.\\n\\n  Options are key-value pairs and may be one of:\\n\\n  :default\\n\\n  The default dispatch value, defaults to :default\\n\\n  :hierarchy\\n\\n  The value used for hierarchical dispatch (e.g. ::square is-a ::shape)\\n\\n  Hierarchies are type-like relationships that do not depend upon type\\n  inheritance. By default Clojure's multimethods dispatch off of a\\n  global hierarchy map.  However, a hierarchy relationship can be\\n  created with the derive function used to augment the root ancestor\\n  created with make-hierarchy.\\n\\n  Multimethods expect the value of the hierarchy option to be supplied as\\n  a reference type e.g. a var (i.e. via the Var-quote dispatch macro #'\\n  or the var special form)."
  },
  {
    "label": "chars",
    "type": "function",
    "info": "Casts to chars[]"
  },
  {
    "label": "str",
    "type": "function",
    "info": "With no args, returns the empty string. With one arg x, returns\\n  x.toString().  (str nil) returns the empty string. With more than\\n  one arg, returns the concatenation of the str values of the args."
  },
  {
    "label": "next",
    "type": "function",
    "info": "Returns a seq of the items after the first. Calls seq on its\\n  argument.  If there are no more items, returns nil."
  },
  {
    "label": "hash-map",
    "type": "function",
    "info": "keyval => key val\\n  Returns a new hash map with supplied mappings.  If any keys are\\n  equal, they are handled as if by repeated uses of assoc."
  },
  {
    "label": "if-let",
    "type": "function",
    "info": "bindings => binding-form test\\n\\n  If test is true, evaluates then with binding-form bound to the value of \\n  test, if not, yields else"
  },
  {
    "label": "underive",
    "type": "function",
    "info": "Removes a parent\\/child relationship between parent and\\n  tag. h must be a hierarchy obtained from make-hierarchy, if not\\n  supplied defaults to, and modifies, the global hierarchy."
  },
  {
    "label": "ref-max-history",
    "type": "function",
    "info": "Gets the max-history of a ref, or sets it and returns the ref"
  },
  {
    "label": "Throwable->map",
    "type": "function",
    "info": "Constructs a data representation for a Throwable with keys:\\n    :cause - root cause message\\n    :phase - error phase\\n    :via - cause chain, with cause keys:\\n             :type - exception class symbol\\n             :message - exception message\\n             :data - ex-data\\n             :at - top stack element\\n    :trace - root cause stack elements"
  },
  {
    "label": "false?",
    "type": "function",
    "info": "Returns true if x is the value false, false otherwise."
  },
  {
    "label": "*print-readably*",
    "type": "function",
    "info": "When set to logical false, strings and characters will be printed with\\n  non-alphanumeric characters converted to the appropriate escape sequences.\\n\\n  Defaults to true"
  },
  {
    "label": "ints",
    "type": "function",
    "info": "Casts to int[]"
  },
  {
    "label": "class",
    "type": "function",
    "info": "Returns the Class of x"
  },
  {
    "label": "some-fn",
    "type": "function",
    "info": "Takes a set of predicates and returns a function f that returns the first logical true value\\n  returned by one of its composing predicates against any of its arguments, else it returns\\n  logical false. Note that f is short-circuiting in that it will stop execution on the first\\n  argument that triggers a logical true result against the original predicates."
  },
  {
    "label": "case",
    "type": "function",
    "info": "Takes an expression, and a set of clauses.\\n\\n  Each clause can take the form of either:\\n\\n  test-constant result-expr\\n\\n  (test-constant1 ... test-constantN)  result-expr\\n\\n  The test-constants are not evaluated. They must be compile-time\\n  literals, and need not be quoted.  If the expression is equal to a\\n  test-constant, the corresponding result-expr is returned. A single\\n  default expression can follow the clauses, and its value will be\\n  returned if no clause matches. If no default expression is provided\\n  and no clause matches, an IllegalArgumentException is thrown.\\n\\n  Unlike cond and condp, case does a constant-time dispatch, the\\n  clauses are not considered sequentially.  All manner of constant\\n  expressions are acceptable in case, including numbers, strings,\\n  symbols, keywords, and (Clojure) composites thereof. Note that since\\n  lists are used to group multiple constants that map to the same\\n  expression, a vector can be used to match a list if needed. The\\n  test-constants need not be all of the same type."
  },
  {
    "label": "*flush-on-newline*",
    "type": "function",
    "info": "When set to true, output will be flushed whenever a newline is printed.\\n\\n  Defaults to true."
  },
  {
    "label": "to-array",
    "type": "function",
    "info": "Returns an array of Objects containing the contents of coll, which\\n  can be any Collection.  Maps to java.util.Collection.toArray()."
  },
  {
    "label": "bigdec",
    "type": "function",
    "info": "Coerce to BigDecimal"
  },
  {
    "label": "list?",
    "type": "function",
    "info": "Returns true if x implements IPersistentList"
  },
  {
    "label": "simple-ident?",
    "type": "function",
    "info": "Return true if x is a symbol or keyword without a namespace"
  },
  {
    "label": "bit-not",
    "type": "function",
    "info": "Bitwise complement"
  },
  {
    "label": "io!",
    "type": "function",
    "info": "If an io! block occurs in a transaction, throws an\\n  IllegalStateException, else runs body in an implicit do. If the\\n  first expression in body is a literal string, will use that as the\\n  exception message."
  },
  {
    "label": "xml-seq",
    "type": "function",
    "info": "A tree seq on the xml elements as per xml\\/parse"
  },
  {
    "label": "byte",
    "type": "function",
    "info": "Coerce to byte"
  },
  {
    "label": "max",
    "type": "function",
    "info": "Returns the greatest of the nums."
  },
  {
    "label": "==",
    "type": "function",
    "info": "Returns non-nil if nums all have the equivalent\\n  value (type-independent), otherwise false"
  },
  {
    "label": "*agent*",
    "type": "function",
    "info": "The agent currently running an action on this thread, else nil"
  },
  {
    "label": "lazy-cat",
    "type": "function",
    "info": "Expands to code which yields a lazy sequence of the concatenation\\n  of the supplied colls.  Each coll expr is not evaluated until it is\\n  needed. \\n\\n  (lazy-cat xs ys zs) === (concat (lazy-seq xs) (lazy-seq ys) (lazy-seq zs))"
  },
  {
    "label": "comment",
    "type": "function",
    "info": "Ignores body, yields nil"
  },
  {
    "label": "parents",
    "type": "function",
    "info": "Returns the immediate parents of tag, either via a Java type\\n  inheritance relationship or a relationship established via derive. h\\n  must be a hierarchy obtained from make-hierarchy, if not supplied\\n  defaults to the global hierarchy"
  },
  {
    "label": "count",
    "type": "function",
    "info": "Returns the number of items in the collection. (count nil) returns\\n  0.  Also works on strings, arrays, and Java Collections and Maps"
  },
  {
    "label": "supers",
    "type": "function",
    "info": "Returns the immediate and indirect superclasses and interfaces of c, if any"
  },
  {
    "label": "*fn-loader*",
    "type": "function",
    "info": null
  },
  {
    "label": "sorted-map-by",
    "type": "function",
    "info": "keyval => key val\\n  Returns a new sorted map with supplied mappings, using the supplied\\n  comparator.  If any keys are equal, they are handled as if by\\n  repeated uses of assoc."
  },
  {
    "label": "apply",
    "type": "function",
    "info": "Applies fn f to the argument list formed by prepending intervening arguments to args."
  },
  {
    "label": "interpose",
    "type": "function",
    "info": "Returns a lazy seq of the elements of coll separated by sep.\\n  Returns a stateful transducer when no collection is provided."
  },
  {
    "label": "assoc",
    "type": "function",
    "info": "assoc[iate]. When applied to a map, returns a new map of the\\n    same (hashed\\/sorted) type, that contains the mapping of key(s) to\\n    val(s). When applied to a vector, returns a new vector that\\n    contains val at index. Note - index must be <= (count vector)."
  },
  {
    "label": "rational?",
    "type": "function",
    "info": "Returns true if n is a rational number"
  },
  {
    "label": "transient",
    "type": "function",
    "info": "Returns a new, transient version of the collection, in constant time."
  },
  {
    "label": "clojure-version",
    "type": "function",
    "info": "Returns clojure version as a printable string."
  },
  {
    "label": "chunk-cons",
    "type": "function",
    "info": null
  },
  {
    "label": "comparator",
    "type": "function",
    "info": "Returns an implementation of java.util.Comparator based upon pred."
  },
  {
    "label": "sorted-map",
    "type": "function",
    "info": "keyval => key val\\n  Returns a new sorted map with supplied mappings.  If any keys are\\n  equal, they are handled as if by repeated uses of assoc."
  },
  {
    "label": "send",
    "type": "function",
    "info": "Dispatch an action to an agent. Returns the agent immediately.\\n  Subsequently, in a thread from a thread pool, the state of the agent\\n  will be set to the value of:\\n\\n  (apply action-fn state-of-agent args)"
  },
  {
    "label": "drop-while",
    "type": "function",
    "info": "Returns a lazy sequence of the items in coll starting from the\\n  first item for which (pred item) returns logical false.  Returns a\\n  stateful transducer when no collection is provided."
  },
  {
    "label": "proxy-call-with-super",
    "type": "function",
    "info": null
  },
  {
    "label": "realized?",
    "type": "function",
    "info": "Returns true if a value has been produced for a promise, delay, future or lazy sequence."
  },
  {
    "label": "char-array",
    "type": "function",
    "info": "Creates an array of chars"
  },
  {
    "label": "resolve",
    "type": "function",
    "info": "same as (ns-resolve *ns* symbol) or (ns-resolve *ns* &env symbol)"
  },
  {
    "label": "compare",
    "type": "function",
    "info": "Comparator. Returns a negative number, zero, or a positive number\\n  when x is logically 'less than', 'equal to', or 'greater than'\\n  y. Same as Java x.compareTo(y) except it also works for nil, and\\n  compares numbers and collections in a type-independent manner. x\\n  must implement Comparable"
  },
  {
    "label": "complement",
    "type": "function",
    "info": "Takes a fn f and returns a fn that takes the same arguments as f,\\n  has the same effects, if any, and returns the opposite truth value."
  },
  {
    "label": "*compiler-options*",
    "type": "function",
    "info": "A map of keys to options.\\n  Note, when binding dynamically make sure to merge with previous value.\\n  Supported options:\\n  :elide-meta - a collection of metadata keys to elide during compilation.\\n  :disable-locals-clearing - set to true to disable clearing, useful for using a debugger\\n  Alpha, subject to change."
  },
  {
    "label": "*print-dup*",
    "type": "function",
    "info": "When set to logical true, objects will be printed in a way that preserves\\n  their type when read in later.\\n\\n  Defaults to false."
  },
  {
    "label": "defrecord",
    "type": "function",
    "info": "(defrecord name [fields*]  options* specs*)\\n\\n  Options are expressed as sequential keywords and arguments (in any order).\\n\\n  Supported options:\\n  :load-ns - if true, importing the record class will cause the\\n             namespace in which the record was defined to be loaded.\\n             Defaults to false.\\n\\n  Each spec consists of a protocol or interface name followed by zero\\n  or more method bodies:\\n\\n  protocol-or-interface-or-Object\\n  (methodName [args*] body)*\\n\\n  Dynamically generates compiled bytecode for class with the given\\n  name, in a package with the same name as the current namespace, the\\n  given fields, and, optionally, methods for protocols and\\/or\\n  interfaces.\\n\\n  The class will have the (immutable) fields named by\\n  fields, which can have type hints. Protocols\\/interfaces and methods\\n  are optional. The only methods that can be supplied are those\\n  declared in the protocols\\/interfaces.  Note that method bodies are\\n  not closures, the local environment includes only the named fields,\\n  and those fields can be accessed directly.\\n\\n  Method definitions take the form:\\n\\n  (methodname [args*] body)\\n\\n  The argument and return types can be hinted on the arg and\\n  methodname symbols. If not supplied, they will be inferred, so type\\n  hints should be reserved for disambiguation.\\n\\n  Methods should be supplied for all methods of the desired\\n  protocol(s) and interface(s). You can also define overrides for\\n  methods of Object. Note that a parameter must be supplied to\\n  correspond to the target object ('this' in Java parlance). Thus\\n  methods for interfaces will take one more argument than do the\\n  interface declarations. Note also that recur calls to the method\\n  head should *not* pass the target object, it will be supplied\\n  automatically and can not be substituted.\\n\\n  In the method bodies, the (unqualified) name can be used to name the\\n  class (for calls to new, instance? etc).\\n\\n  The class will have implementations of several (clojure.lang)\\n  interfaces generated automatically: IObj (metadata support) and\\n  IPersistentMap, and all of their superinterfaces.\\n\\n  In addition, defrecord will define type-and-value-based =,\\n  and will defined Java .hashCode and .equals consistent with the\\n  contract for java.util.Map.\\n\\n  When AOT compiling, generates compiled bytecode for a class with the\\n  given name (a symbol), prepends the current ns as the package, and\\n  writes the .class file to the *compile-path* directory.\\n\\n  Two constructors will be defined, one taking the designated fields\\n  followed by a metadata map (nil for none) and an extension field\\n  map (nil for none), and one taking only the fields (using nil for\\n  meta and extension fields). Note that the field names __meta,\\n  __extmap, __hash and __hasheq are currently reserved and should not\\n  be used when defining your own records.\\n\\n  Given (defrecord TypeName ...), two factory functions will be\\n  defined: ->TypeName, taking positional parameters for the fields,\\n  and map->TypeName, taking a map of keywords to field values."
  },
  {
    "label": "with-redefs-fn",
    "type": "function",
    "info": "Temporarily redefines Vars during a call to func.  Each val of\\n  binding-map will replace the root value of its key which must be\\n  a Var.  After func is called with no args, the root values of all\\n  the Vars will be set back to their old values.  These temporary\\n  changes will be visible in all threads.  Useful for mocking out\\n  functions during testing."
  },
  {
    "label": "sequence",
    "type": "function",
    "info": "Coerces coll to a (possibly empty) sequence, if it is not already\\n  one. Will not force a lazy seq. (sequence nil) yields (), When a\\n  transducer is supplied, returns a lazy sequence of applications of\\n  the transform to the items in coll(s), i.e. to the set of first\\n  items of each coll, followed by the set of second\\n  items in each coll, until any one of the colls is exhausted.  Any\\n  remaining items in other colls are ignored. The transform should accept\\n  number-of-colls arguments"
  },
  {
    "label": "constantly",
    "type": "function",
    "info": "Returns a function that takes any number of arguments and returns x."
  },
  {
    "label": "get-proxy-class",
    "type": "function",
    "info": "Takes an optional single class followed by zero or more\\n  interfaces. If not supplied class defaults to Object.  Creates an\\n  returns an instance of a proxy class derived from the supplied\\n  classes. The resulting value is cached and used for any subsequent\\n  requests for the same class set. Returns a Class object."
  },
  {
    "label": "make-array",
    "type": "function",
    "info": "Creates and returns an array of instances of the specified class of\\n  the specified dimension(s).  Note that a class object is required.\\n  Class objects can be obtained by using their imported or\\n  fully-qualified name.  Class objects for the primitive types can be\\n  obtained using, e.g., Integer\\/TYPE."
  },
  {
    "label": "shorts",
    "type": "function",
    "info": "Casts to shorts[]"
  },
  {
    "label": "completing",
    "type": "function",
    "info": "Takes a reducing function f of 2 args and returns a fn suitable for\\n  transduce by adding an arity-1 signature that calls cf (default -\\n  identity) on the result argument."
  },
  {
    "label": "update-proxy",
    "type": "function",
    "info": "Takes a proxy instance and a map of strings (which must\\n  correspond to methods of the proxy superclass\\/superinterfaces) to\\n  fns (which must take arguments matching the corresponding method,\\n  plus an additional (explicit) first arg corresponding to this, and\\n  updates (via assoc) the proxy's fn map. nil can be passed instead of\\n  a fn, in which case the corresponding method will revert to the\\n  default behavior. Note that this function can be used to update the\\n  behavior of an existing instance without changing its identity.\\n  Returns the proxy."
  },
  {
    "label": "unchecked-negate-int",
    "type": "function",
    "info": "Returns the negation of x, an int.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "hash-unordered-coll",
    "type": "function",
    "info": "Returns the hash code, consistent with =, for an external unordered\\n   collection implementing Iterable. For maps, the iterator should\\n   return map entries whose hash is computed as\\n     (hash-ordered-coll [k v]).\\n   See http:\\/\\/clojure.org\\/data_structures#hash for full algorithms."
  },
  {
    "label": "repeat",
    "type": "function",
    "info": "Returns a lazy (infinite!, or length n if supplied) sequence of xs."
  },
  {
    "label": "unchecked-inc",
    "type": "function",
    "info": "Returns a number one greater than x, a long.\\n  Note - uses a primitive operator subject to overflow."
  },
  {
    "label": "*reader-resolver*",
    "type": "function",
    "info": null
  },
  {
    "label": "nthnext",
    "type": "function",
    "info": "Returns the nth next of coll, (seq coll) when n is 0."
  },
  {
    "label": "and",
    "type": "function",
    "info": "Evaluates exprs one at a time, from left to right. If a form\\n  returns logical false (nil or false), and returns that value and\\n  doesn't evaluate any of the other expressions, otherwise it returns\\n  the value of the last expr. (and) returns true."
  },
  {
    "label": "create-struct",
    "type": "function",
    "info": "Returns a structure basis object."
  },
  {
    "label": "get-validator",
    "type": "function",
    "info": "Gets the validator-fn for a var\\/ref\\/agent\\/atom."
  },
  {
    "label": "number?",
    "type": "function",
    "info": "Returns true if x is a Number"
  },
  {
    "label": "await-for",
    "type": "function",
    "info": "Blocks the current thread until all actions dispatched thus\\n  far (from this thread or agent) to the agents have occurred, or the\\n  timeout (in milliseconds) has elapsed. Returns logical false if\\n  returning due to timeout, logical true otherwise."
  },
  {
    "label": "chunk-next",
    "type": "function",
    "info": null
  },
  {
    "label": "not-any?",
    "type": "function",
    "info": "Returns false if (pred x) is logical true for any x in coll,\\n  else true."
  },
  {
    "label": "into-array",
    "type": "function",
    "info": "Returns an array with components set to the values in aseq. The array's\\n  component type is type if provided, or the type of the first value in\\n  aseq if present, or Object. All values in aseq must be compatible with\\n  the component type. Class objects for the primitive types can be obtained\\n  using, e.g., Integer\\/TYPE."
  },
  {
    "label": "qualified-symbol?",
    "type": "function",
    "info": "Return true if x is a symbol with a namespace"
  },
  {
    "label": "init-proxy",
    "type": "function",
    "info": "Takes a proxy instance and a map of strings (which must\\n  correspond to methods of the proxy superclass\\/superinterfaces) to\\n  fns (which must take arguments matching the corresponding method,\\n  plus an additional (explicit) first arg corresponding to this, and\\n  sets the proxy's fn map.  Returns the proxy."
  },
  {
    "label": "chunk-buffer",
    "type": "function",
    "info": null
  },
  {
    "label": "seqable?",
    "type": "function",
    "info": "Return true if the seq function is supported for x"
  },
  {
    "label": "symbol?",
    "type": "function",
    "info": "Return true if x is a Symbol"
  },
  {
    "label": "when-some",
    "type": "function",
    "info": "bindings => binding-form test\\n\\n   When test is not nil, evaluates body with binding-form bound to the\\n   value of test"
  },
  {
    "label": "unchecked-char",
    "type": "function",
    "info": "Coerce to char. Subject to rounding or truncation."
  },
  {
    "label": "->>",
    "type": "function",
    "info": "Threads the expr through the forms. Inserts x as the\\n  last item in the first form, making a list of it if it is not a\\n  list already. If there are more forms, inserts the first form as the\\n  last item in second form, etc."
  },
  {
    "label": "future-cancel",
    "type": "function",
    "info": "Cancels the future, if possible."
  },
  {
    "label": "var-get",
    "type": "function",
    "info": "Gets the value in the var object"
  },
  {
    "label": "commute",
    "type": "function",
    "info": "Must be called in a transaction. Sets the in-transaction-value of\\n  ref to:\\n\\n  (apply fun in-transaction-value-of-ref args)\\n\\n  and returns the in-transaction-value of ref.\\n\\n  At the commit point of the transaction, sets the value of ref to be:\\n\\n  (apply fun most-recently-committed-value-of-ref args)\\n\\n  Thus fun should be commutative, or, failing that, you must accept\\n  last-one-in-wins behavior.  commute allows for more concurrency than\\n  ref-set."
  },
  {
    "label": "coll?",
    "type": "function",
    "info": "Returns true if x implements IPersistentCollection"
  },
  {
    "label": "get-in",
    "type": "function",
    "info": "Returns the value in a nested associative structure,\\n  where ks is a sequence of keys. Returns nil if the key\\n  is not present, or the not-found value if supplied."
  },
  {
    "label": "fnext",
    "type": "function",
    "info": "Same as (first (next x))"
  },
  {
    "label": "denominator",
    "type": "function",
    "info": "Returns the denominator part of a Ratio."
  },
  {
    "label": "bytes",
    "type": "function",
    "info": "Casts to bytes[]"
  },
  {
    "label": "refer-clojure",
    "type": "function",
    "info": "Same as (refer 'clojure.core <filters>)"
  }
]`),
  Te([_b, !0])
)), PEe = bt.g(function(e) {
  var n = O.j(e, 0, null);
  return e = O.j(e, 1, null), Bc(new $(null, 3, [KB, ["math/", ye.h(n)].join(""), zi, "function", iF, ee.h(Vt(e))], null));
}, lr.g(Tt, C3([new v(null, 2, 5, y, [_n.h("next-after"), new Jn(function() {
  return y0;
}, rQ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  gQ,
  "cljs/math.cljs",
  25,
  1,
  742,
  742,
  Lt,
  ue(new v(null, 2, 5, y, [cm, hee], null)),
  `Returns the adjacent floating point number to start in the direction of
  the second argument. If the arguments are equal, the second is returned.
  If either arg is #NaN => #NaN
  If both arguments are signed zeros => direction
  If start is +-Number/MIN_VALUE and direction would cause a smaller magnitude
    => zero with sign matching start
  If start is ##Inf or ##-Inf and direction would cause a smaller magnitude
    => Number/MAX_VALUE with same sign as start
  If start is equal to +=Number/MAX_VALUE and direction would cause a larger magnitude
    => ##Inf or ##-Inf with sign matching start
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#nextAfter-double-double-`,
  j(y0) ? y0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("to-radians"), new Jn(function() {
  return Yv;
}, $X, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, RX, "cljs/math.cljs", 25, 1, 126, 126, Lt, ue(new v(null, 1, 5, y, [wee], null)), `Converts an angle in degrees to an approximate equivalent angle in radians.
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#toRadians-double-`, j(Yv) ? Yv.D : null]))], null), new v(null, 2, 5, y, [_n.h("log"), new Jn(function() {
  return Wv;
}, dee, Gn(
  [Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt],
  ["1.11.10", Jt, one, "cljs/math.cljs", 18, 1, 149, 149, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the natural logarithm (base e) of a.
  If a is ##NaN or negative => ##NaN
  If a is ##Inf => ##Inf
  If a is zero => ##-Inf
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log`, j(Wv) ? Wv.D : null]
))], null), new v(null, 2, 5, y, [_n.h("acos"), new Jn(function() {
  return Fv;
}, vJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  AQ,
  "cljs/math.cljs",
  19,
  1,
  111,
  111,
  Lt,
  ue(new v(null, 1, 5, y, [Vl], null)),
  `Returns the arc cosine of a, in the range 0.0 to pi.
  If a is ##NaN or |a|>1 => ##NaN
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/acos`,
  j(Fv) ? Fv.D : null
]))], null), new v(null, 2, 5, y, [_n.h("to-degrees"), new Jn(function() {
  return Uv;
}, vee, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  _ne,
  "cljs/math.cljs",
  25,
  1,
  133,
  133,
  Lt,
  ue(new v(null, 1, 5, y, [CB], null)),
  `Converts an angle in radians to an approximate equivalent angle in degrees.
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#toDegrees-double-`,
  j(Uv) ? Uv.D : null
]))], null), new v(null, 2, 5, y, [_n.h("floor"), new Jn(function() {
  return Df;
}, oX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  zQ,
  "cljs/math.cljs",
  20,
  1,
  425,
  425,
  Lt,
  ue(new v(null, 1, 5, y, [Vl], null)),
  `Returns the largest double less than or equal to a, and equal to a
  mathematical integer.
  If a is ##NaN or ##Inf or ##-Inf or already equal to an integer => a
  If a is less than zero but greater than -1.0 => -0.0
  Note that if a is \`nil\` then an exception will be thrown. This matches Clojure, rather than js/Math.floor
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/floor`,
  j(Df) ? Df.D : null
]))], null), new v(null, 2, 5, y, [_n.h("atan2"), new Jn(function() {
  return Qv;
}, OJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  rne,
  "cljs/math.cljs",
  20,
  1,
  478,
  478,
  Lt,
  ue(new v(null, 2, 5, y, [al, Sn], null)),
  `Returns the angle theta from the conversion of rectangular coordinates (x, y) to polar coordinates (r, theta).
  Computes the phase theta by computing an arc tangent of y/x in the range of -pi to pi.
  For more details on special cases, see:
  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/atan`,
  j(Qv) ? Qv.D : null
]))], null), new v(null, 2, 5, y, [_n.h("hypot"), new Jn(function() {
  return g0;
}, LJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, XX, "cljs/math.cljs", 20, 1, 699, 699, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), `Returns sqrt(x^2 + y^2) without intermediate underflow or overflow.
  If x or y is ##Inf or ##-Inf => ##Inf
  If x or y is ##NaN and neither is ##Inf or ##-Inf => ##NaN
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/hypot`, j(g0) ? g0.D : null]))], null), new v(null, 2, 5, y, [_n.h("tanh"), new Jn(function() {
  return m0;
}, FX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, Wee, "cljs/math.cljs", 19, 1, 689, 689, Lt, ue(new v(null, 1, 5, y, [Sn], null)), `Returns the hyperbolic tangent of x, sinh(x)/cosh(x).
  If x is ##NaN => ##NaN
  If x is zero => zero, with same sign
  If x is ##Inf => +1.0
  If x is ##-Inf => -1.0
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/tanh`, j(m0) ? m0.D : null]))], null), new v(null, 2, 5, y, [_n.h("floor-mod"), new Jn(function() {
  return a0;
}, mne, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, Ree, "cljs/math.cljs", 24, 1, 584, 584, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), `Integer modulus x - (floorDiv(x, y) * y). Sign matches y and is in the
  range -|y| < r < |y|.
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#floorMod-long-long-`, j(a0) ? a0.D : null]))], null), new v(null, 2, 5, y, [_n.h("ceil"), new Jn(function() {
  return Zv;
}, HQ, Gn([
  Qt,
  ie,
  te,
  Bn,
  tt,
  zn,
  Yn,
  rt,
  Ft,
  ne,
  ee,
  lt
], ["1.11.10", Jt, sX, "cljs/math.cljs", 19, 1, 413, 413, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the smallest double greater than or equal to a, and equal to a
  mathematical integer.
  If a is ##NaN or ##Inf or ##-Inf or already equal to an integer => a
  Note that if a is \`nil\` then an exception will be thrown. This matches Clojure, rather than js/Math.ceil
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/ceil`, j(Zv) ? Zv.D : null]))], null), new v(null, 2, 5, y, [_n.h("atan"), new Jn(function() {
  return Vv;
}, FQ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, OZ, "cljs/math.cljs", 19, 1, 118, 118, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the arc tangent of a, in the range of -pi/2 to pi/2.
  If a is ##NaN => ##NaN
  If a is zero => zero with the same sign as a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/atan`, j(Vv) ? Vv.D : null]))], null), new v(null, 2, 5, y, [
  _n.h("multiply-exact"),
  new Jn(function() {
    return r0;
  }, qQ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, _J, "cljs/math.cljs", 29, 1, 534, 534, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), "Returns the product of x and y, throws ArithmeticException on overflow. ", j(r0) ? r0.D : null]))
], null), new v(null, 2, 5, y, [_n.h("expm1"), new Jn(function() {
  return w0;
}, lX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  UQ,
  "cljs/math.cljs",
  20,
  1,
  707,
  707,
  Lt,
  ue(new v(null, 1, 5, y, [Sn], null)),
  `Returns e^x - 1. Near 0, expm1(x)+1 is more accurate to e^x than exp(x).
  If x is ##NaN => ##NaN
  If x is ##Inf => #Inf
  If x is ##-Inf => -1.0
  If x is zero => x
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/expm1`,
  j(w0) ? w0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("get-exponent"), new Jn(function() {
  return mw;
}, Cee, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, SX, "cljs/math.cljs", 27, 1, 599, 599, Lt, ue(new v(null, 1, 5, y, [Xs], null)), `Returns the exponent of d.
  If d is ##NaN, ##Inf, ##-Inf => max_Float64_exponent + 1
  If d is zero or subnormal => min_Float64_exponent - 1
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#getExponent-double-`, j(mw) ? mw.D : null]))], null), new v(
  null,
  2,
  5,
  y,
  [_n.h("add-exact"), new Jn(function() {
    return t0;
  }, NJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, KQ, "cljs/math.cljs", 24, 1, 516, 516, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), "Returns the sum of x and y, throws an exception on overflow. ", j(t0) ? t0.D : null]))],
  null
), new v(null, 2, 5, y, [_n.h("cos"), new Jn(function() {
  return $v;
}, qJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  UZ,
  "cljs/math.cljs",
  18,
  1,
  88,
  88,
  Lt,
  ue(new v(null, 1, 5, y, [Vl], null)),
  `Returns the cosine of an angle.
  If a is ##NaN, ##-Inf, ##Inf => ##NaN
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/cos`,
  j($v) ? $v.D : null
]))], null), new v(null, 2, 5, y, [_n.h("log10"), new Jn(function() {
  return Hv;
}, mX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, _ee, "cljs/math.cljs", 20, 1, 158, 158, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the logarithm (base 10) of a.
  If a is ##NaN or negative => ##NaN
  If a is ##Inf => ##Inf
  If a is zero => ##-Inf
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log10`, j(Hv) ? Hv.D : null]))], null), new v(null, 2, 5, y, [
  _n.h("tan"),
  new Jn(function() {
    return Lv;
  }, sJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, CX, "cljs/math.cljs", 18, 1, 95, 95, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the tangent of an angle.
  If a is ##NaN, ##-Inf, ##Inf => ##NaN
  If a is zero => zero with the same sign as a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/tan`, j(Lv) ? Lv.D : null]))
], null), new v(null, 2, 5, y, [_n.h("cbrt"), new Jn(function() {
  return Kv;
}, Lee, Gn([
  Qt,
  ie,
  te,
  Bn,
  tt,
  zn,
  Yn,
  rt,
  Ft,
  ne,
  ee,
  lt
], ["1.11.10", Jt, GJ, "cljs/math.cljs", 19, 1, 176, 176, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the cube root of a.
  If a is ##NaN => ##NaN
  If a is ##Inf or ##-Inf => a
  If a is zero => zero with sign matching a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/cbrt`, j(Kv) ? Kv.D : null]))], null), new v(null, 2, 5, y, [_n.h("sqrt"), new Jn(function() {
  return zv;
}, JJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  _Q,
  "cljs/math.cljs",
  19,
  1,
  167,
  167,
  Lt,
  ue(new v(null, 1, 5, y, [Vl], null)),
  `Returns the positive square root of a.
  If a is ##NaN or negative => ##NaN
  If a is ##Inf => ##Inf
  If a is zero => a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sqrt`,
  j(zv) ? zv.D : null
]))], null), new v(null, 2, 5, y, [_n.h("decrement-exact"), new Jn(function() {
  return u0;
}, JQ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  CZ,
  "cljs/math.cljs",
  30,
  1,
  551,
  551,
  Lt,
  ue(new v(null, 1, 5, y, [Vl], null)),
  "Returns a decremented by 1, throws ArithmeticException on overflow. ",
  j(u0) ? u0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("PI"), new Jn(function() {
  return X0;
}, oee, Gn([Qt, ie, te, Bn, tt, zn, Ax, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, sQ, "cljs/math.cljs", 20, 1, !0, 12, 17, Lt, fl, `Constant for pi, the ratio of the circumference of a circle to its diameter.
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/PI`, j(X0) ? X0.D : null]))], null), new v(null, 2, 5, y, [_n.h("next-down"), new Jn(
  function() {
    return x0;
  },
  aX,
  Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, xne, "cljs/math.cljs", 24, 1, 816, 816, Lt, ue(new v(null, 1, 5, y, [Xs], null)), `Returns the adjacent double of d in the direction of ##-Inf.
  If d is ##NaN => ##NaN
  If d is ##Inf => Number/MAX_VALUE
  If d is zero => -Number/MIN_VALUE
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#nextDown-double-`, j(x0) ? x0.D : null])
)], null), new v(null, 2, 5, y, [_n.h("pow"), new Jn(function() {
  return Jv;
}, ree, Gn([
  Qt,
  ie,
  te,
  Bn,
  tt,
  zn,
  Yn,
  rt,
  Ft,
  ne,
  ee,
  lt
], ["1.11.10", Jt, Kee, "cljs/math.cljs", 18, 1, 486, 486, Lt, ue(new v(null, 2, 5, y, [Vl, qo], null)), `Returns the value of a raised to the power of b.
  For more details on special cases, see:
  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/pow`, j(Jv) ? Jv.D : null]))], null), new v(null, 2, 5, y, [_n.h("next-up"), new Jn(function() {
  return _0;
}, qZ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  JZ,
  "cljs/math.cljs",
  22,
  1,
  790,
  790,
  Lt,
  ue(new v(null, 1, 5, y, [Xs], null)),
  `Returns the adjacent double of d in the direction of ##Inf.
  If d is ##NaN => ##NaN
  If d is ##Inf => ##Inf
  If d is zero => Number/MIN_VALUE
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#nextUp-double-`,
  j(_0) ? _0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("exp"), new Jn(function() {
  return qv;
}, qX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, BQ, "cljs/math.cljs", 18, 1, 140, 140, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns Euler's number e raised to the power of a.
  If a is ##NaN => ##NaN
  If a is ##Inf => ##Inf
  If a is ##-Inf => +0.0
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/exp`, j(qv) ? qv.D : null]))], null), new v(null, 2, 5, y, [
  _n.h("subtract-exact"),
  new Jn(function() {
    return l0;
  }, ine, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, gee, "cljs/math.cljs", 29, 1, 525, 525, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), "Returns the difference of x and y, throws ArithmeticException on overflow. ", j(l0) ? l0.D : null]))
], null), new v(null, 2, 5, y, [_n.h("cosh"), new Jn(function() {
  return p0;
}, lne, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  iJ,
  "cljs/math.cljs",
  19,
  1,
  680,
  680,
  Lt,
  ue(new v(null, 1, 5, y, [Sn], null)),
  `Returns the hyperbolic cosine of x, (e^x + e^-x)/2.
  If x is ##NaN => ##NaN
  If x is ##Inf or ##-Inf => ##Inf
  If x is zero => 1.0
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/cosh`,
  j(p0) ? p0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("scalb"), new Jn(function() {
  return S0;
}, HX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  Mee,
  "cljs/math.cljs",
  20,
  1,
  847,
  847,
  Lt,
  ue(new v(null, 2, 5, y, [Xs, IX], null)),
  `Returns d * 2^scaleFactor, scaling by a factor of 2. If the exponent
  is between min_Float64_exponent and max_Float64_exponent.
  scaleFactor is an integer
  If d is ##NaN => ##NaN
  If d is ##Inf or ##-Inf => ##Inf or ##-Inf respectively
  If d is zero => zero of same sign as d
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#nextDown-double-`,
  j(S0) ? S0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("log1p"), new Jn(function() {
  return v0;
}, OX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  Aee,
  "cljs/math.cljs",
  20,
  1,
  717,
  717,
  Lt,
  ue(new v(null, 1, 5, y, [Sn], null)),
  `Returns ln(1+x). For small values of x, log1p(x) is more accurate than
  log(1.0+x).
  If x is ##NaN or ##-Inf or < -1 => ##NaN
  If x is -1 => ##-Inf
  If x is ##Inf => ##Inf
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log1p`,
  j(v0) ? v0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("asin"), new Jn(function() {
  return Bv;
}, LX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, bee, "cljs/math.cljs", 19, 1, 103, 103, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the arc sine of an angle, in the range -pi/2 to pi/2.
  If a is ##NaN or |a|>1 => ##NaN
  If a is zero => zero with the same sign as a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/asin`, j(Bv) ? Bv.D : null]))], null), new v(
  null,
  2,
  5,
  y,
  [_n.h("copy-sign"), new Jn(function() {
    return xm;
  }, aQ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, VQ, "cljs/math.cljs", 24, 1, 438, 438, Lt, ue(new v(null, 2, 5, y, [MQ, YJ], null)), `Returns a double with the magnitude of the first argument and the sign of
  the second.
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#copySign-double-double-`, j(xm) ? xm.D : null]))],
  null
), new v(null, 2, 5, y, [_n.h("round"), new Jn(function() {
  return e0;
}, XJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  kb,
  "cljs/math.cljs",
  20,
  1,
  493,
  493,
  Lt,
  ue(new v(null, 1, 5, y, [Vl], null)),
  `Returns the closest long to a. If equally close to two values, return the one
  closer to ##Inf.
  If a is ##NaN => 0
  If a is ##-Inf => js/Number.MIN_SAFE_INTEGER
  If a is ##Inf => js/Number.MAX_SAFE_INTEGER
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/round`,
  j(e0) ? e0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("negate-exact"), new Jn(
  function() {
    return s0;
  },
  SZ,
  Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, ZJ, "cljs/math.cljs", 27, 1, 559, 559, Lt, ue(new v(null, 1, 5, y, [Vl], null)), "Returns the negation of a, throws ArithmeticException on overflow. ", j(s0) ? s0.D : null])
)], null), new v(null, 2, 5, y, [_n.h("E"), new Jn(function() {
  return Z0;
}, PZ, Gn([Qt, ie, te, Bn, tt, zn, Ax, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  jQ,
  "cljs/math.cljs",
  19,
  1,
  !0,
  5,
  10,
  Lt,
  fl,
  `Constant for Euler's number e, the base for natural logarithms.
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/E`,
  j(Z0) ? Z0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("IEEE-remainder"), new Jn(function() {
  return Gv;
}, MZ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  DJ,
  "cljs/math.cljs",
  29,
  1,
  335,
  335,
  Lt,
  ue(new v(null, 2, 5, y, [KZ, kX], null)),
  `Returns the remainder per IEEE 754 such that
    remainder = dividend - divisor * n
   where n is the integer closest to the exact value of dividend / divisor.
   If two integers are equally close, then n is the even one.
   If the remainder is zero, sign will match dividend.
   If dividend or divisor is ##NaN, or dividend is ##Inf or ##-Inf, or divisor is zero => ##NaN
   If dividend is finite and divisor is infinite => dividend

   Method: based on fmod return x-[x/p]chopped*p exactlp.
   Ported from: https://github.com/openjdk/jdk/blob/master/src/java.base/share/native/libfdlibm/e_remainder.c
   See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#IEEEremainder-double-double-`,
  j(Gv) ? Gv.D : null
]))], null), new v(null, 2, 5, y, [_n.h("sinh"), new Jn(function() {
  return d0;
}, Yee, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, QJ, "cljs/math.cljs", 19, 1, 672, 672, Lt, ue(new v(null, 1, 5, y, [Sn], null)), `Returns the hyperbolic sine of x, (e^x - e^-x)/2.
  If x is ##NaN => ##NaN
  If x is ##Inf or ##-Inf or zero => x
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sinh`, j(d0) ? d0.D : null]))], null), new v(null, 2, 5, y, [_n.h("rint"), new Jn(
  function() {
    return Xv;
  },
  tJ,
  Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, RQ, "cljs/math.cljs", 19, 1, 465, 465, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the double closest to a and equal to a mathematical integer.
  If two values are equally close, return the even one.
  If a is ##NaN or ##Inf or ##-Inf or zero => a
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#rint-double-`, j(Xv) ? Xv.D : null])
)], null), new v(null, 2, 5, y, [_n.h("ulp"), new Jn(function() {
  return h0;
}, Pee, Gn([
  Qt,
  ie,
  te,
  Bn,
  tt,
  zn,
  Yn,
  rt,
  Ft,
  ne,
  ee,
  lt
], ["1.11.10", Jt, $ee, "cljs/math.cljs", 18, 1, 636, 636, Lt, ue(new v(null, 1, 5, y, [Xs], null)), `Returns the size of an ulp (unit in last place) for d.
  If d is ##NaN => ##NaN
  If d is ##Inf or ##-Inf => ##Inf
  If d is zero => Number/MIN_VALUE
  If d is +/- Number/MAX_VALUE => 2^971
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#ulp-double-`, j(h0) ? h0.D : null]))], null), new v(null, 2, 5, y, [_n.h("sin"), new Jn(function() {
  return Pv;
}, cQ, Gn([
  Qt,
  ie,
  te,
  Bn,
  tt,
  zn,
  Yn,
  rt,
  Ft,
  ne,
  ee,
  lt
], ["1.11.10", Jt, wQ, "cljs/math.cljs", 18, 1, 80, 80, Lt, ue(new v(null, 1, 5, y, [Vl], null)), `Returns the sine of an angle.
  If a is ##NaN, ##-Inf, ##Inf => ##NaN
  If a is zero => zero with the same sign as a
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/sin`, j(Pv) ? Pv.D : null]))], null), new v(null, 2, 5, y, [_n.h("increment-exact"), new Jn(function() {
  return i0;
}, VX, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  EJ,
  "cljs/math.cljs",
  30,
  1,
  543,
  543,
  Lt,
  ue(new v(null, 1, 5, y, [Vl], null)),
  "Returns a incremented by 1, throws ArithmeticException on overflow.",
  j(i0) ? i0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("random"), new Jn(function() {
  return n0;
}, kJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], [
  "1.11.10",
  Jt,
  une,
  "cljs/math.cljs",
  21,
  1,
  508,
  508,
  Lt,
  ue(Dt),
  `Returns a positive double between 0.0 and 1.0, chosen pseudorandomly with
  approximately random distribution. Not cryptographically secure. The seed is chosen internally
  and cannot be selected.
  See: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/random`,
  j(n0) ? n0.D : null
]))], null), new v(null, 2, 5, y, [_n.h("floor-div"), new Jn(function() {
  return o0;
}, CJ, Gn([Qt, ie, te, Bn, tt, zn, Yn, rt, Ft, ne, ee, lt], ["1.11.10", Jt, Ene, "cljs/math.cljs", 24, 1, 571, 571, Lt, ue(new v(null, 2, 5, y, [Sn, al], null)), `Integer division that rounds to negative infinity (as opposed to zero).
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#floorDiv-long-long-`, j(o0) ? o0.D : null]))], null), new v(null, 2, 5, y, [_n.h("signum"), new Jn(function() {
  return f0;
}, AX, Gn([
  Qt,
  ie,
  te,
  Bn,
  tt,
  zn,
  Yn,
  rt,
  Ft,
  ne,
  ee,
  lt
], ["1.11.10", Jt, pee, "cljs/math.cljs", 21, 1, 661, 661, Lt, ue(new v(null, 1, 5, y, [Xs], null)), `Returns the signum function of d - zero for zero, 1.0 if >0, -1.0 if <0.
  If d is ##NaN => ##NaN
  If d is ##Inf or ##-Inf => sign of d
  See: https://docs.oracle.com/javase/8/docs/api/java/lang/Math.html#signum-double-`, j(f0) ? f0.D : null]))], null)], !0)));
Qz("rule_editor_component.render", aZ);
const UH = aZ, $Ee = ["id"], FE = /* @__PURE__ */ cl({
  name: "lp-rule-editor",
  __name: "LpRuleEditor",
  props: {
    modelValue: { default: "" },
    mode: {
      default: "read-write"
      /* ReadWrite */
    },
    contextVariables: { default: null }
  },
  emits: { "update:modelValue": null },
  setup(e, { emit: n }) {
    const t = e, l = n, r = (s) => {
      l("update:modelValue", s.state.doc.text.join(`
`));
    }, u = () => Math.floor(Math.random() * 1e7 + 1), o = dt(`rule-editor-${u()}-${u()}`), a = dt(null), h = dt(!1);
    return cf(() => {
      UH(o.value, {
        code: t.modelValue,
        mode: t.mode,
        onChange: r,
        contextVariables: t.contextVariables
      }), h.value = !0;
    }), ga(() => {
      a.value && t.mode === "read-only" && (a.value.innerHTML = "", UH(o.value, {
        code: t.modelValue,
        mode: t.mode,
        onChange: r,
        contextVariables: t.contextVariables
      }));
    }), (s, d) => (Qe(), yn("div", {
      id: o.value,
      ref_key: "wrapper",
      ref: a,
      class: "w-100"
    }, null, 8, $Ee));
  }
});
FE.install = (e) => {
  e.component(FE.name, FE);
};
const LEe = cl({
  name: "lp-collapse"
}), BEe = { class: "lp-collapse" };
function FEe(e, n, t, l, r, u) {
  return Qe(), yn("div", BEe, [
    el(e.$slots, "default")
  ]);
}
const VE = /* @__PURE__ */ Cr(LEe, [["render", FEe]]);
VE.install = (e) => {
  e.component(VE.name, VE);
};
const VEe = cl({
  name: "lp-collapse-item",
  props: {
    title: { type: String },
    opened: { type: Boolean },
    simple: { type: Boolean },
    precise: { type: Boolean },
    switchIcon: { type: Boolean, default: !1 }
  },
  setup(e) {
    return { active: dt(e.opened) };
  }
}), YEe = ["aria-expanded"], UEe = { class: "ly-row ly-center-center" }, qEe = ["innerHTML"];
function WEe(e, n, t, l, r, u) {
  const o = El("lp-icon");
  return Qe(), yn("div", {
    class: xt(["lp-collapse-item", [e.active && "lp-collapse-item-expanded", e.simple && "simple"]])
  }, [
    qn("div", {
      class: xt(["lp-collapse-item-title", e.simple && "simple"]),
      "aria-expanded": e.active,
      onClick: n[2] || (n[2] = (a) => !e.precise && (e.active = !e.active))
    }, [
      qn("div", UEe, [
        e.switchIcon ? (Qe(), _l(o, {
          key: 0,
          class: "lp-collapse-item-title-icon",
          name: e.active ? "chevron-down" : "chevron-right",
          onClick: n[0] || (n[0] = (a) => e.precise && (e.active = !e.active))
        }, null, 8, ["name"])) : st("", !0),
        qn("span", null, [
          qn("span", {
            class: "ly-col",
            innerHTML: e.title
          }, null, 8, qEe),
          el(e.$slots, "helper")
        ]),
        el(e.$slots, "secondaryActions")
      ]),
      qn("div", null, [
        el(e.$slots, "primaryActions"),
        e.switchIcon ? st("", !0) : (Qe(), _l(o, {
          key: 0,
          class: "lp-collapse-item-title-icon",
          name: e.active ? "chevron-down" : "chevron-right",
          onClick: n[1] || (n[1] = (a) => e.precise && (e.active = !e.active))
        }, null, 8, ["name"]))
      ])
    ], 10, YEe),
    dl(du, { name: "drop-bottom" }, {
      default: kl(() => [
        pi(qn("div", {
          class: xt(["lp-collapse-item-body", e.simple && "simple"])
        }, [
          el(e.$slots, "default")
        ], 2), [
          [Pi, e.active]
        ])
      ]),
      _: 3
    })
  ], 2);
}
const YE = /* @__PURE__ */ Cr(VEe, [["render", WEe]]);
YE.install = (e) => {
  e.component(YE.name, YE);
};
function HEe(e, n) {
  const t = _t(
    () => e.value ? e.value.sortBy : null
  ), l = _t(
    () => e.value ? e.value.sortDirection : null
  );
  function r(o) {
    if (!o) {
      n("onSort", null);
      return;
    }
    let a = l.value === null ? "asc" : l.value === "asc" ? "desc" : null;
    if (o !== t.value && (a = "asc"), a === null) {
      n("onSort", null);
      return;
    }
    n("onSort", {
      sortBy: o,
      sortDirection: a
    });
  }
  function u(o) {
    return o !== t.value ? "sort" : l.value === "asc" ? "caret-up" : l.value === "desc" ? "caret-down" : "sort";
  }
  return {
    changeSort: r,
    getColumnIcon: u
  };
}
const zEe = 10, nw = 5;
function KEe(e, n, t, l) {
  const r = _t(
    () => Math.ceil(n.value / t.value || zEe)
  ), u = _t(() => e.value === r.value || n.value === 0 ? null : e.value + 1), o = _t(
    () => e.value === 0 || n.value === 0 ? null : e.value - 1
  ), a = _t(() => {
    if (n.value === 0)
      return [];
    const h = Math.ceil(e.value / nw), s = Math.ceil(r.value / nw), d = h * nw - nw, p = h === s, _ = r.value % nw, R = p && _ || nw;
    return Array.from(new Array(R)).map((F, L) => d + L + 1);
  });
  return ga(() => {
    e.value > r.value && r.value > 0 && l(r.value);
  }), {
    totalPages: r,
    nextPage: u,
    prevPage: o,
    visiblePages: a
  };
}
const GEe = { key: 0 }, ZEe = { key: 1 }, XEe = /* @__PURE__ */ cl({
  __name: "Checkbox",
  props: {
    modelValue: { type: Boolean },
    isDisabled: { type: Boolean, default: !1 },
    tooltipMessage: { default: "Disabled" },
    tooltipPlacement: { default: sl.TR },
    label: { default: "" }
  },
  emits: ["update:model-value"],
  setup(e, { emit: n }) {
    const t = n;
    function l(r) {
      t("update:model-value", r);
    }
    return (r, u) => {
      const o = El("lp-checkbox"), a = El("lp-tooltip");
      return r.isDisabled ? (Qe(), yn("span", GEe, [
        dl(a, {
          content: r.tooltipMessage,
          placement: r.tooltipPlacement
        }, {
          default: kl(() => [
            dl(o, {
              "model-value": r.modelValue,
              disabled: "",
              label: r.label
            }, null, 8, ["model-value", "label"])
          ]),
          _: 1
        }, 8, ["content", "placement"])
      ])) : (Qe(), yn("span", ZEe, [
        dl(o, {
          "model-value": r.modelValue,
          label: r.label,
          "onUpdate:modelValue": l
        }, null, 8, ["model-value", "label"])
      ]));
    };
  }
});
var zd = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function mte(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var QEe = typeof zd == "object" && zd && zd.Object === Object && zd, JEe = QEe, eOe = JEe, nOe = typeof self == "object" && self && self.Object === Object && self, tOe = eOe || nOe || Function("return this")(), SF = tOe, lOe = SF, rOe = lOe.Symbol, EF = rOe, qH = EF, gte = Object.prototype, iOe = gte.hasOwnProperty, uOe = gte.toString, v_ = qH ? qH.toStringTag : void 0;
function sOe(e) {
  var n = iOe.call(e, v_), t = e[v_];
  try {
    e[v_] = void 0;
    var l = !0;
  } catch {
  }
  var r = uOe.call(e);
  return l && (n ? e[v_] = t : delete e[v_]), r;
}
var oOe = sOe, aOe = Object.prototype, cOe = aOe.toString;
function hOe(e) {
  return cOe.call(e);
}
var fOe = hOe, WH = EF, dOe = oOe, pOe = fOe, mOe = "[object Null]", gOe = "[object Undefined]", HH = WH ? WH.toStringTag : void 0;
function wOe(e) {
  return e == null ? e === void 0 ? gOe : mOe : HH && HH in Object(e) ? dOe(e) : pOe(e);
}
var wte = wOe;
function vOe(e) {
  var n = typeof e;
  return e != null && (n == "object" || n == "function");
}
var vte = vOe, yOe = wte, _Oe = vte, xOe = "[object AsyncFunction]", SOe = "[object Function]", EOe = "[object GeneratorFunction]", OOe = "[object Proxy]";
function kOe(e) {
  if (!_Oe(e))
    return !1;
  var n = yOe(e);
  return n == SOe || n == EOe || n == xOe || n == OOe;
}
var yte = kOe, bOe = SF, TOe = bOe["__core-js_shared__"], jOe = TOe, AD = jOe, zH = function() {
  var e = /[^.]+$/.exec(AD && AD.keys && AD.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function AOe(e) {
  return !!zH && zH in e;
}
var DOe = AOe, IOe = Function.prototype, ROe = IOe.toString;
function NOe(e) {
  if (e != null) {
    try {
      return ROe.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var COe = NOe, MOe = yte, POe = DOe, $Oe = vte, LOe = COe, BOe = /[\\^$.*+?()[\]{}|]/g, FOe = /^\[object .+?Constructor\]$/, VOe = Function.prototype, YOe = Object.prototype, UOe = VOe.toString, qOe = YOe.hasOwnProperty, WOe = RegExp(
  "^" + UOe.call(qOe).replace(BOe, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function HOe(e) {
  if (!$Oe(e) || POe(e))
    return !1;
  var n = MOe(e) ? WOe : FOe;
  return n.test(LOe(e));
}
var zOe = HOe;
function KOe(e, n) {
  return e?.[n];
}
var GOe = KOe, ZOe = zOe, XOe = GOe;
function QOe(e, n) {
  var t = XOe(e, n);
  return ZOe(t) ? t : void 0;
}
var OF = QOe, JOe = OF, eke = JOe(Object, "create"), oj = eke, KH = oj;
function nke() {
  this.__data__ = KH ? KH(null) : {}, this.size = 0;
}
var tke = nke;
function lke(e) {
  var n = this.has(e) && delete this.__data__[e];
  return this.size -= n ? 1 : 0, n;
}
var rke = lke, ike = oj, uke = "__lodash_hash_undefined__", ske = Object.prototype, oke = ske.hasOwnProperty;
function ake(e) {
  var n = this.__data__;
  if (ike) {
    var t = n[e];
    return t === uke ? void 0 : t;
  }
  return oke.call(n, e) ? n[e] : void 0;
}
var cke = ake, hke = oj, fke = Object.prototype, dke = fke.hasOwnProperty;
function pke(e) {
  var n = this.__data__;
  return hke ? n[e] !== void 0 : dke.call(n, e);
}
var mke = pke, gke = oj, wke = "__lodash_hash_undefined__";
function vke(e, n) {
  var t = this.__data__;
  return this.size += this.has(e) ? 0 : 1, t[e] = gke && n === void 0 ? wke : n, this;
}
var yke = vke, _ke = tke, xke = rke, Ske = cke, Eke = mke, Oke = yke;
function C2(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++n < t; ) {
    var l = e[n];
    this.set(l[0], l[1]);
  }
}
C2.prototype.clear = _ke;
C2.prototype.delete = xke;
C2.prototype.get = Ske;
C2.prototype.has = Eke;
C2.prototype.set = Oke;
var kke = C2;
function bke() {
  this.__data__ = [], this.size = 0;
}
var Tke = bke;
function jke(e, n) {
  return e === n || e !== e && n !== n;
}
var Ake = jke, Dke = Ake;
function Ike(e, n) {
  for (var t = e.length; t--; )
    if (Dke(e[t][0], n))
      return t;
  return -1;
}
var aj = Ike, Rke = aj, Nke = Array.prototype, Cke = Nke.splice;
function Mke(e) {
  var n = this.__data__, t = Rke(n, e);
  if (t < 0)
    return !1;
  var l = n.length - 1;
  return t == l ? n.pop() : Cke.call(n, t, 1), --this.size, !0;
}
var Pke = Mke, $ke = aj;
function Lke(e) {
  var n = this.__data__, t = $ke(n, e);
  return t < 0 ? void 0 : n[t][1];
}
var Bke = Lke, Fke = aj;
function Vke(e) {
  return Fke(this.__data__, e) > -1;
}
var Yke = Vke, Uke = aj;
function qke(e, n) {
  var t = this.__data__, l = Uke(t, e);
  return l < 0 ? (++this.size, t.push([e, n])) : t[l][1] = n, this;
}
var Wke = qke, Hke = Tke, zke = Pke, Kke = Bke, Gke = Yke, Zke = Wke;
function M2(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++n < t; ) {
    var l = e[n];
    this.set(l[0], l[1]);
  }
}
M2.prototype.clear = Hke;
M2.prototype.delete = zke;
M2.prototype.get = Kke;
M2.prototype.has = Gke;
M2.prototype.set = Zke;
var Xke = M2, Qke = OF, Jke = SF, e4e = Qke(Jke, "Map"), n4e = e4e, GH = kke, t4e = Xke, l4e = n4e;
function r4e() {
  this.size = 0, this.__data__ = {
    hash: new GH(),
    map: new (l4e || t4e)(),
    string: new GH()
  };
}
var i4e = r4e;
function u4e(e) {
  var n = typeof e;
  return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? e !== "__proto__" : e === null;
}
var s4e = u4e, o4e = s4e;
function a4e(e, n) {
  var t = e.__data__;
  return o4e(n) ? t[typeof n == "string" ? "string" : "hash"] : t.map;
}
var cj = a4e, c4e = cj;
function h4e(e) {
  var n = c4e(this, e).delete(e);
  return this.size -= n ? 1 : 0, n;
}
var f4e = h4e, d4e = cj;
function p4e(e) {
  return d4e(this, e).get(e);
}
var m4e = p4e, g4e = cj;
function w4e(e) {
  return g4e(this, e).has(e);
}
var v4e = w4e, y4e = cj;
function _4e(e, n) {
  var t = y4e(this, e), l = t.size;
  return t.set(e, n), this.size += t.size == l ? 0 : 1, this;
}
var x4e = _4e, S4e = i4e, E4e = f4e, O4e = m4e, k4e = v4e, b4e = x4e;
function P2(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.clear(); ++n < t; ) {
    var l = e[n];
    this.set(l[0], l[1]);
  }
}
P2.prototype.clear = S4e;
P2.prototype.delete = E4e;
P2.prototype.get = O4e;
P2.prototype.has = k4e;
P2.prototype.set = b4e;
var T4e = P2, j4e = "__lodash_hash_undefined__";
function A4e(e) {
  return this.__data__.set(e, j4e), this;
}
var D4e = A4e;
function I4e(e) {
  return this.__data__.has(e);
}
var R4e = I4e, N4e = T4e, C4e = D4e, M4e = R4e;
function c4(e) {
  var n = -1, t = e == null ? 0 : e.length;
  for (this.__data__ = new N4e(); ++n < t; )
    this.add(e[n]);
}
c4.prototype.add = c4.prototype.push = C4e;
c4.prototype.has = M4e;
var P4e = c4;
function $4e(e, n, t, l) {
  for (var r = e.length, u = t + (l ? 1 : -1); l ? u-- : ++u < r; )
    if (n(e[u], u, e))
      return u;
  return -1;
}
var L4e = $4e;
function B4e(e) {
  return e !== e;
}
var F4e = B4e;
function V4e(e, n, t) {
  for (var l = t - 1, r = e.length; ++l < r; )
    if (e[l] === n)
      return l;
  return -1;
}
var Y4e = V4e, U4e = L4e, q4e = F4e, W4e = Y4e;
function H4e(e, n, t) {
  return n === n ? W4e(e, n, t) : U4e(e, q4e, t);
}
var z4e = H4e, K4e = z4e;
function G4e(e, n) {
  var t = e == null ? 0 : e.length;
  return !!t && K4e(e, n, 0) > -1;
}
var Z4e = G4e;
function X4e(e, n, t) {
  for (var l = -1, r = e == null ? 0 : e.length; ++l < r; )
    if (t(n, e[l]))
      return !0;
  return !1;
}
var Q4e = X4e;
function J4e(e, n) {
  for (var t = -1, l = e == null ? 0 : e.length, r = Array(l); ++t < l; )
    r[t] = n(e[t], t, e);
  return r;
}
var ebe = J4e;
function nbe(e) {
  return function(n) {
    return e(n);
  };
}
var tbe = nbe;
function lbe(e, n) {
  return e.has(n);
}
var rbe = lbe, ibe = P4e, ube = Z4e, sbe = Q4e, obe = ebe, abe = tbe, cbe = rbe, hbe = 200;
function fbe(e, n, t, l) {
  var r = -1, u = ube, o = !0, a = e.length, h = [], s = n.length;
  if (!a)
    return h;
  t && (n = obe(n, abe(t))), l ? (u = sbe, o = !1) : n.length >= hbe && (u = cbe, o = !1, n = new ibe(n));
  e:
    for (; ++r < a; ) {
      var d = e[r], p = t == null ? d : t(d);
      if (d = l || d !== 0 ? d : 0, o && p === p) {
        for (var _ = s; _--; )
          if (n[_] === p)
            continue e;
        h.push(d);
      } else u(n, p, l) || h.push(d);
    }
  return h;
}
var dbe = fbe;
function pbe(e, n) {
  for (var t = -1, l = n.length, r = e.length; ++t < l; )
    e[r + t] = n[t];
  return e;
}
var mbe = pbe;
function gbe(e) {
  return e != null && typeof e == "object";
}
var kF = gbe, wbe = wte, vbe = kF, ybe = "[object Arguments]";
function _be(e) {
  return vbe(e) && wbe(e) == ybe;
}
var xbe = _be, ZH = xbe, Sbe = kF, _te = Object.prototype, Ebe = _te.hasOwnProperty, Obe = _te.propertyIsEnumerable, kbe = ZH(/* @__PURE__ */ function() {
  return arguments;
}()) ? ZH : function(e) {
  return Sbe(e) && Ebe.call(e, "callee") && !Obe.call(e, "callee");
}, bbe = kbe, Tbe = Array.isArray, jbe = Tbe, XH = EF, Abe = bbe, Dbe = jbe, QH = XH ? XH.isConcatSpreadable : void 0;
function Ibe(e) {
  return Dbe(e) || Abe(e) || !!(QH && e && e[QH]);
}
var Rbe = Ibe, Nbe = mbe, Cbe = Rbe;
function xte(e, n, t, l, r) {
  var u = -1, o = e.length;
  for (t || (t = Cbe), r || (r = []); ++u < o; ) {
    var a = e[u];
    n > 0 && t(a) ? n > 1 ? xte(a, n - 1, t, l, r) : Nbe(r, a) : l || (r[r.length] = a);
  }
  return r;
}
var Mbe = xte;
function Pbe(e) {
  return e;
}
var Ste = Pbe;
function $be(e, n, t) {
  switch (t.length) {
    case 0:
      return e.call(n);
    case 1:
      return e.call(n, t[0]);
    case 2:
      return e.call(n, t[0], t[1]);
    case 3:
      return e.call(n, t[0], t[1], t[2]);
  }
  return e.apply(n, t);
}
var Lbe = $be, Bbe = Lbe, JH = Math.max;
function Fbe(e, n, t) {
  return n = JH(n === void 0 ? e.length - 1 : n, 0), function() {
    for (var l = arguments, r = -1, u = JH(l.length - n, 0), o = Array(u); ++r < u; )
      o[r] = l[n + r];
    r = -1;
    for (var a = Array(n + 1); ++r < n; )
      a[r] = l[r];
    return a[n] = t(o), Bbe(e, this, a);
  };
}
var Vbe = Fbe;
function Ybe(e) {
  return function() {
    return e;
  };
}
var Ube = Ybe, qbe = OF, Wbe = function() {
  try {
    var e = qbe(Object, "defineProperty");
    return e({}, "", {}), e;
  } catch {
  }
}(), Hbe = Wbe, zbe = Ube, ez = Hbe, Kbe = Ste, Gbe = ez ? function(e, n) {
  return ez(e, "toString", {
    configurable: !0,
    enumerable: !1,
    value: zbe(n),
    writable: !0
  });
} : Kbe, Zbe = Gbe, Xbe = 800, Qbe = 16, Jbe = Date.now;
function eTe(e) {
  var n = 0, t = 0;
  return function() {
    var l = Jbe(), r = Qbe - (l - t);
    if (t = l, r > 0) {
      if (++n >= Xbe)
        return arguments[0];
    } else
      n = 0;
    return e.apply(void 0, arguments);
  };
}
var nTe = eTe, tTe = Zbe, lTe = nTe, rTe = lTe(tTe), iTe = rTe, uTe = Ste, sTe = Vbe, oTe = iTe;
function aTe(e, n) {
  return oTe(sTe(e, n, uTe), e + "");
}
var cTe = aTe, hTe = 9007199254740991;
function fTe(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= hTe;
}
var dTe = fTe, pTe = yte, mTe = dTe;
function gTe(e) {
  return e != null && mTe(e.length) && !pTe(e);
}
var wTe = gTe, vTe = wTe, yTe = kF;
function _Te(e) {
  return yTe(e) && vTe(e);
}
var xTe = _Te, STe = dbe, ETe = Mbe, OTe = cTe, nz = xTe, kTe = OTe(function(e, n) {
  return nz(e) ? STe(e, ETe(n, 1, nz, !0)) : [];
}), bTe = kTe;
const TTe = /* @__PURE__ */ mte(bTe);
var Ete = /* @__PURE__ */ ((e) => (e[e.All = 0] = "All", e[e.Some = 1] = "Some", e[e.None = 2] = "None", e))(Ete || {});
const jTe = cl({
  name: "lp-data-table",
  components: { Checkbox: XEe },
  props: {
    columns: {
      type: Object,
      required: !0
    },
    data: {
      type: Object,
      required: !0
    },
    page: {
      type: Number,
      required: !0
    },
    pageSize: {
      type: Number,
      required: !0
    },
    sortOptions: {
      type: Object,
      default: null
    },
    totalResults: {
      type: Number,
      required: !0
    },
    isLoading: {
      type: Boolean,
      default: !1
    },
    showFixedHeader: {
      type: Boolean,
      default: !1
    },
    rowSelection: {
      type: Array,
      default: () => []
    },
    rowDisableSelection: {
      type: Array,
      default: () => []
    },
    enableRowSelection: {
      type: Boolean,
      default: !0
    },
    showPagination: {
      type: Boolean,
      default: !0
    },
    showResults: {
      type: Boolean,
      default: !0
    },
    showPageSizeSelector: {
      type: Boolean,
      default: !0
    },
    expandedItemId: {
      type: Object,
      default: null
    },
    enableExpandAction: {
      type: Boolean,
      default: !1
    },
    condensed: {
      type: Boolean,
      default: !1
    },
    tooltipDisableCheckbox: {
      type: String,
      default: "Disabled"
    },
    rowClass: {
      type: String,
      default: ""
    },
    enableSingleSelection: {
      type: Boolean,
      default: !1
    },
    expandableColumnWidth: {
      type: Number,
      default: null
    }
  },
  emits: [
    "onSelect",
    "onSort",
    "onPageChange",
    "onPageSizeChange",
    "onRowSelectionChange",
    "onExpand"
    // NOTE: Alias for onSelect
  ],
  setup(e, { emit: n }) {
    const {
      sortOptions: t,
      page: l,
      totalResults: r,
      pageSize: u,
      data: o,
      rowSelection: a,
      rowDisableSelection: h,
      enableSingleSelection: s
    } = w3(e), { changeSort: d, getColumnIcon: p } = HEe(t, n), _ = dt(/* @__PURE__ */ new Set()), R = dt(/* @__PURE__ */ new Set()), F = dt({}), L = dt(null), G = _t(() => o.value.map((Me) => Me.id)), J = _t(() => TTe(
      G.value,
      e.rowDisableSelection
    )), we = _t(() => {
      const Me = J.value.filter((le) => _.value.has(le));
      return Me.length === 0 ? 2 : Me.length === J.value.length ? 0 : 1;
    });
    $e(), di(
      a,
      (Me) => {
        s.value && (L.value = Me[0] ?? null), _.value = new Set(Me);
      },
      { immediate: !0 }
    ), di(
      h,
      (Me) => {
        R.value = new Set(Me);
      },
      { immediate: !0 }
    );
    function ce(Me) {
      n("onPageChange", Me);
    }
    function xe(Me) {
      n("onPageSizeChange", Me);
    }
    function $e() {
      F.value = KEe(
        l,
        r,
        u,
        ce
      );
    }
    const je = [
      { name: "10", value: 10 },
      { name: "25", value: 25 },
      { name: "50", value: 50 }
    ];
    function E(Me) {
      _.value.has(Me) ? _.value.delete(Me) : _.value.add(Me), n("onRowSelectionChange", [..._.value]);
    }
    function P(Me) {
      L.value = Me, n("onRowSelectionChange", [Me]);
    }
    function K() {
      const Me = J.value;
      we.value !== 0 ? Me.forEach((le) => {
        _.value.add(le);
      }) : Me.forEach((le) => {
        _.value.delete(le);
      }), n("onRowSelectionChange", [..._.value]);
    }
    function H(Me) {
      return Me === e.expandedItemId ? "bg-gray-light" : "";
    }
    function U(Me) {
      return Me ? `${Me}%` : "auto";
    }
    return {
      pagination: F,
      changeSort: d,
      getColumnIcon: p,
      onPageChange: ce,
      onPageSizeChange: xe,
      RECORDS_PER_PAGE: je,
      formatInteger: dL,
      onMultipleSelection: E,
      selectAllPageItems: K,
      cherryPickSelection: _,
      pageRowsSelectionState: we,
      SelectAllState: Ete,
      isRowSelected: H,
      getColumnWidth: U,
      disableCherryPickSelection: R,
      singleSelection: L,
      onSingleSelection: P
    };
  }
}), $2 = (e) => (tL("data-v-9636d1e0"), e = e(), lL(), e), ATe = { class: "ly-row ly-start-center mb-1 w-80" }, DTe = { class: "m-0 text-uppercase font-weight-bold" }, ITe = { class: "scroller-h pb-1" }, RTe = { class: "p-relative" }, NTe = {
  class: "ua-datatable-result-row",
  "data-ua-multiple-id": "ua-datatable-result-row"
}, CTe = {
  key: 0,
  class: "table-checkbox-column"
}, MTe = ["data-ua-data-table-header-id", "onClick"], PTe = { key: 0 }, $Te = { colspan: "100%" }, LTe = {
  class: "ly-center-center",
  style: { display: "flex" }
}, BTe = { key: 1 }, FTe = ["data-ua-row-id", "onClick"], VTe = { key: 0 }, YTe = ["onClick"], UTe = {
  key: 1,
  style: { textAlign: "right" }
}, qTe = /* @__PURE__ */ $2(() => /* @__PURE__ */ qn("i", { class: "lpi-chevron-right" }, null, -1)), WTe = { key: 2 }, HTe = /* @__PURE__ */ $2(() => /* @__PURE__ */ qn("tr", null, [
  /* @__PURE__ */ qn("td", {
    colspan: "100%",
    class: "bg-gray-light"
  }, [
    /* @__PURE__ */ qn("p", { class: "text-center text-uppercase font-weight-bold text-dark-muted" }, " No Results ")
  ])
], -1)), zTe = [
  HTe
], KTe = {
  key: 0,
  id: "ua-data-table-pagination",
  class: "ly-row ly-spacebetween-center mt-1 mb-4"
}, GTe = { class: "ly-row" }, ZTe = {
  key: 0,
  class: "ly-row"
}, XTe = /* @__PURE__ */ $2(() => /* @__PURE__ */ qn("span", { class: "mt-half" }, "Show", -1)), QTe = /* @__PURE__ */ $2(() => /* @__PURE__ */ qn("span", { class: "mt-half" }, "Items Selected", -1)), JTe = { class: "ly-row ly-end-center" }, eje = ["disabled"], nje = /* @__PURE__ */ $2(() => /* @__PURE__ */ qn("i", { class: "lpi-caret-left" }, null, -1)), tje = [
  nje
], lje = ["data-ua-value", "onClick"], rje = {
  key: 0,
  class: "btn btn-noborder text-dark",
  disabled: ""
}, ije = ["disabled"], uje = /* @__PURE__ */ $2(() => /* @__PURE__ */ qn("i", { class: "lpi-caret-right" }, null, -1)), sje = [
  uje
];
function oje(e, n, t, l, r, u) {
  const o = El("lp-checkbox"), a = El("lp-icon"), h = El("lp-spinner"), s = El("lp-radio"), d = El("Checkbox"), p = El("lp-select");
  return Qe(), yn("div", null, [
    qn("div", ATe, [
      e.showResults ? el(e.$slots, "results", {
        key: 0,
        totalResults: e.totalResults
      }, () => [
        qn("p", DTe, It(e.formatInteger(e.totalResults)) + " Results ", 1)
      ], !0) : st("", !0),
      e.showFixedHeader ? el(e.$slots, "fixedHeader", { key: 1 }, void 0, !0) : st("", !0)
    ]),
    qn("div", ITe, [
      qn("table", {
        class: xt(["datatable shadow-sm", { "table-condensed": e.condensed, expanded: e.expandedItemId }])
      }, [
        qn("thead", RTe, [
          qn("tr", NTe, [
            e.enableRowSelection ? (Qe(), yn("th", CTe, [
              e.enableSingleSelection ? st("", !0) : (Qe(), _l(o, {
                key: 0,
                "model-value": e.pageRowsSelectionState !== e.SelectAllState.None,
                indeterminate: e.pageRowsSelectionState === e.SelectAllState.Some,
                onClick: e.selectAllPageItems
              }, null, 8, ["model-value", "indeterminate", "onClick"]))
            ])) : st("", !0),
            (Qe(!0), yn(Ii, null, ru(e.columns, (_) => (Qe(), yn("th", {
              key: _.name,
              "data-ua-data-table-header-id": _.name,
              style: Hi({
                textAlign: _.alignLabel || "left",
                width: e.getColumnWidth(_.width)
              }),
              onClick: (R) => _.sortable ? e.changeSort(_.sortBy || _.name) : null
            }, [
              pi(dl(a, {
                name: e.getColumnIcon(_.sortBy || _.name)
              }, null, 8, ["name"]), [
                [Pi, _.sortable]
              ]),
              Ir(" " + It(_.translation ?? _.label), 1)
            ], 12, MTe))), 128)),
            e.enableExpandAction ? (Qe(), yn("th", {
              key: 1,
              style: Hi({
                width: e.getColumnWidth(e.expandableColumnWidth)
              })
            }, null, 4)) : st("", !0)
          ])
        ]),
        e.isLoading ? (Qe(), yn("tbody", PTe, [
          qn("tr", null, [
            qn("td", $Te, [
              qn("div", LTe, [
                dl(h, { type: "inline" })
              ])
            ])
          ])
        ])) : e.totalResults ? (Qe(), yn("tbody", BTe, [
          (Qe(!0), yn(Ii, null, ru(e.data, (_) => (Qe(), yn(Ii, {
            key: _.id
          }, [
            qn("tr", {
              class: xt(e.isRowSelected(_.id) + e.rowClass),
              "data-ua-row-id": _.id,
              onClick: (R) => e.$emit("onExpand", _.id, _)
            }, [
              e.enableRowSelection ? (Qe(), yn("td", VTe, [
                e.enableRowSelection && e.enableSingleSelection ? (Qe(), _l(s, {
                  key: 0,
                  "model-value": e.singleSelection,
                  value: _.id,
                  disabled: e.disableCherryPickSelection.has(_.id),
                  "onUpdate:modelValue": e.onSingleSelection
                }, null, 8, ["model-value", "value", "disabled", "onUpdate:modelValue"])) : (Qe(), _l(d, {
                  key: 1,
                  "model-value": e.cherryPickSelection.has(_.id),
                  "is-disabled": e.disableCherryPickSelection.has(_.id),
                  "tooltip-message": e.tooltipDisableCheckbox,
                  onChange: (R) => e.onMultipleSelection(_.id)
                }, null, 8, ["model-value", "is-disabled", "tooltip-message", "onChange"]))
              ])) : st("", !0),
              (Qe(!0), yn(Ii, null, ru(e.columns, (R) => (Qe(), yn("td", {
                key: R.name,
                style: Hi({
                  textAlign: R.alignContent || "left",
                  width: e.getColumnWidth(R.width)
                }),
                onClick: () => e.$emit("onSelect", _)
              }, [
                el(e.$slots, R.name, {
                  field: _[R.name],
                  row: _
                }, () => [
                  Ir(It(_[R.name]), 1)
                ], !0)
              ], 12, YTe))), 128)),
              e.enableExpandAction ? (Qe(), yn("td", UTe, [
                el(e.$slots, "expand-action", { row: _ }, () => [
                  qTe
                ], !0)
              ])) : st("", !0)
            ], 10, FTe),
            el(e.$slots, "after-row", { row: _ }, void 0, !0)
          ], 64))), 128))
        ])) : (Qe(), yn("tbody", WTe, zTe))
      ], 2)
    ]),
    e.pagination && e.showPagination ? (Qe(), yn("div", KTe, [
      qn("div", GTe, [
        e.showPageSizeSelector ? (Qe(), yn("div", ZTe, [
          XTe,
          dl(p, {
            id: "ua-pagination-select-page-size",
            "model-value": e.pageSize,
            options: e.RECORDS_PER_PAGE,
            placement: "top",
            "onUpdate:modelValue": n[0] || (n[0] = (_, R) => e.onPageSizeChange(R.value))
          }, null, 8, ["model-value", "options"]),
          QTe
        ])) : st("", !0)
      ]),
      qn("div", JTe, [
        qn("button", {
          id: "ua-pagination-previous-page",
          class: "btn btn-icon text-hover-blue",
          disabled: !e.pagination.prevPage,
          onClick: n[1] || (n[1] = (_) => e.onPageChange(e.pagination.prevPage))
        }, tje, 8, eje),
        (Qe(!0), yn(Ii, null, ru(e.pagination.visiblePages, (_) => (Qe(), yn("a", {
          key: _,
          class: xt(["btn btn-icon text-hover-blue ua-data-table-pagination-page-number-button", {
            "btn-primary text-white text-hover-white": _ === e.page
          }]),
          "data-ua-value": _,
          onClick: Oi((R) => e.onPageChange(_), ["prevent"])
        }, It(_), 11, lje))), 128)),
        e.pagination.visiblePages.length > 4 ? (Qe(), yn("a", rje, " ... ")) : st("", !0),
        qn("button", {
          id: "ua-data-table-pagination-next-page-button",
          class: "btn btn-icon text-hover-blue",
          disabled: !e.pagination.nextPage,
          onClick: n[2] || (n[2] = (_) => e.onPageChange(e.pagination.nextPage))
        }, sje, 8, ije)
      ])
    ])) : st("", !0)
  ]);
}
const Ote = /* @__PURE__ */ Cr(jTe, [["render", oje], ["__scopeId", "data-v-9636d1e0"]]), aje = { class: "expanded-panel bg-white shadow mt-1 p-2 rounded" }, cje = { class: "ly-row ly-end-center mt-half" }, hje = {
  name: "lp-expandable-panel"
}, fje = /* @__PURE__ */ cl({
  ...hje,
  props: {
    className: { default: "w-40" }
  },
  emits: ["onClose"],
  setup(e, { emit: n }) {
    const t = n;
    return (l, r) => {
      const u = El("lp-icon");
      return Qe(), yn("div", {
        class: xt(l.className)
      }, [
        qn("div", aje, [
          qn("div", cje, [
            dl(u, {
              name: "close",
              class: "cursor-pointer",
              onClick: r[0] || (r[0] = (o) => t("onClose"))
            })
          ]),
          el(l.$slots, "sections", {}, void 0, !0),
          el(l.$slots, "actions", {}, void 0, !0)
        ])
      ], 2);
    };
  }
}), kte = /* @__PURE__ */ Cr(fje, [["__scopeId", "data-v-6caadb68"]]);
/**
* @vue/shared v3.4.37
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
process.env.NODE_ENV !== "production" && Object.freeze({});
process.env.NODE_ENV !== "production" && Object.freeze([]);
const dje = () => {
}, bte = Object.assign, pje = (e) => typeof e == "function", mje = (e) => typeof e == "symbol", gje = (e, n) => !Object.is(e, n);
/**
* @vue/reactivity v3.4.37
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function Tte(e, ...n) {
  console.warn(`[Vue warn] ${e}`, ...n);
}
let wje;
function vje(e, n = wje) {
  n && n.active && n.effects.push(e);
}
let Z_;
class yje {
  constructor(n, t, l, r) {
    this.fn = n, this.trigger = t, this.scheduler = l, this.active = !0, this.deps = [], this._dirtyLevel = 4, this._trackId = 0, this._runnings = 0, this._shouldSchedule = !1, this._depsLength = 0, vje(this, r);
  }
  get dirty() {
    if (this._dirtyLevel === 2 || this._dirtyLevel === 3) {
      this._dirtyLevel = 1, xje();
      for (let n = 0; n < this._depsLength; n++) {
        const t = this.deps[n];
        if (t.computed && (_je(t.computed), this._dirtyLevel >= 4))
          break;
      }
      this._dirtyLevel === 1 && (this._dirtyLevel = 0), Sje();
    }
    return this._dirtyLevel >= 4;
  }
  set dirty(n) {
    this._dirtyLevel = n ? 4 : 0;
  }
  run() {
    if (this._dirtyLevel = 0, !this.active)
      return this.fn();
    let n = Iw, t = Z_;
    try {
      return Iw = !0, Z_ = this, this._runnings++, tz(this), this.fn();
    } finally {
      lz(this), this._runnings--, Z_ = t, Iw = n;
    }
  }
  stop() {
    this.active && (tz(this), lz(this), this.onStop && this.onStop(), this.active = !1);
  }
}
function _je(e) {
  return e.value;
}
function tz(e) {
  e._trackId++, e._depsLength = 0;
}
function lz(e) {
  if (e.deps.length > e._depsLength) {
    for (let n = e._depsLength; n < e.deps.length; n++)
      jte(e.deps[n], e);
    e.deps.length = e._depsLength;
  }
}
function jte(e, n) {
  const t = e.get(n);
  t !== void 0 && n._trackId !== t && (e.delete(n), e.size === 0 && e.cleanup());
}
let Iw = !0, Z$ = 0;
const Ate = [];
function xje() {
  Ate.push(Iw), Iw = !1;
}
function Sje() {
  const e = Ate.pop();
  Iw = e === void 0 ? !0 : e;
}
function Eje() {
  Z$++;
}
function Oje() {
  for (Z$--; !Z$ && X$.length; )
    X$.shift()();
}
function kje(e, n, t) {
  var l;
  if (n.get(e) !== e._trackId) {
    n.set(e, e._trackId);
    const r = e.deps[e._depsLength];
    r !== n ? (r && jte(r, e), e.deps[e._depsLength++] = n) : e._depsLength++, process.env.NODE_ENV !== "production" && ((l = e.onTrack) == null || l.call(e, bte({ effect: e }, t)));
  }
}
const X$ = [];
function bje(e, n, t) {
  var l;
  Eje();
  for (const r of e.keys()) {
    let u;
    r._dirtyLevel < n && (u ?? (u = e.get(r) === r._trackId)) && (r._shouldSchedule || (r._shouldSchedule = r._dirtyLevel === 0), r._dirtyLevel = n), r._shouldSchedule && (u ?? (u = e.get(r) === r._trackId)) && (process.env.NODE_ENV !== "production" && ((l = r.onTrigger) == null || l.call(r, bte({ effect: r }, t))), r.trigger(), (!r._runnings || r.allowRecurse) && r._dirtyLevel !== 2 && (r._shouldSchedule = !1, r.scheduler && X$.push(r.scheduler)));
  }
  Oje();
}
const Tje = (e, n) => {
  const t = /* @__PURE__ */ new Map();
  return t.cleanup = e, t.computed = n, t;
};
Symbol(process.env.NODE_ENV !== "production" ? "iterate" : "");
Symbol(process.env.NODE_ENV !== "production" ? "Map key iterate" : "");
new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((e) => e !== "arguments" && e !== "caller").map((e) => Symbol[e]).filter(mje)
);
function hj(e) {
  const n = e && e.__v_raw;
  return n ? hj(n) : e;
}
const jje = "Computed is still dirty after getter evaluation, likely because a computed is mutating its own dependency in its getter. State mutations in computed getters should be avoided.  Check the docs for more details: https://vuejs.org/guide/essentials/computed.html#getters-should-be-side-effect-free";
class Dte {
  constructor(n, t, l, r) {
    this.getter = n, this._setter = t, this.dep = void 0, this.__v_isRef = !0, this.__v_isReadonly = !1, this.effect = new yje(
      () => n(this._value),
      () => DD(
        this,
        this.effect._dirtyLevel === 2 ? 2 : 3
      )
    ), this.effect.computed = this, this.effect.active = this._cacheable = !r, this.__v_isReadonly = l;
  }
  get value() {
    const n = hj(this);
    return (!n._cacheable || n.effect.dirty) && gje(n._value, n._value = n.effect.run()) && DD(n, 4), Dje(n), n.effect._dirtyLevel >= 2 && (process.env.NODE_ENV !== "production" && this._warnRecursive && Tte(jje, `

getter: `, this.getter), DD(n, 2)), n._value;
  }
  set value(n) {
    this._setter(n);
  }
  // #region polyfill _dirty for backward compatibility third party code for Vue <= 3.3.x
  get _dirty() {
    return this.effect.dirty;
  }
  set _dirty(n) {
    this.effect.dirty = n;
  }
  // #endregion
}
function Aje(e, n, t = !1) {
  let l, r;
  const u = pje(e);
  u ? (l = e, r = process.env.NODE_ENV !== "production" ? () => {
    Tte("Write operation failed: computed value is readonly");
  } : dje) : (l = e.get, r = e.set);
  const o = new Dte(l, r, u || !r, t);
  return process.env.NODE_ENV !== "production" && n && !t && (o.effect.onTrack = n.onTrack, o.effect.onTrigger = n.onTrigger), o;
}
function Dje(e) {
  var n;
  Iw && Z_ && (e = hj(e), kje(
    Z_,
    (n = e.dep) != null ? n : e.dep = Tje(
      () => e.dep = void 0,
      e instanceof Dte ? e : void 0
    ),
    process.env.NODE_ENV !== "production" ? {
      target: e,
      type: "get",
      key: "value"
    } : void 0
  ));
}
function DD(e, n = 4, t, l) {
  e = hj(e);
  const r = e.dep;
  r && bje(
    r,
    n,
    process.env.NODE_ENV !== "production" ? {
      target: e,
      type: "set",
      key: "value",
      newValue: t,
      oldValue: l
    } : void 0
  );
}
const Ije = { class: "ly-row" }, Rje = { class: "w-100" }, Nje = {
  name: "lp-expandable-data-table"
}, Cje = /* @__PURE__ */ cl({
  ...Nje,
  props: {
    columns: {},
    data: {},
    page: {},
    pageSize: {},
    sortOptions: {},
    totalResults: {},
    isLoading: { type: Boolean },
    showFixedHeader: { type: Boolean },
    rowSelection: {},
    enableRowSelection: { type: Boolean },
    showPagination: { type: Boolean },
    showResults: { type: Boolean },
    showPageSizeSelector: { type: Boolean },
    expandedItemId: {},
    rowClass: {}
  },
  emits: ["onExpandedItemClose", "onSort", "onPageChange", "onPageSizeChange", "onExpand"],
  setup(e, { emit: n }) {
    const t = e, l = n, r = Aje(() => t.columns.filter((u) => t.expandedItemId ? u.secondary !== !0 : !0));
    return (u, o) => (Qe(), yn("div", Ije, [
      qn("div", Rje, [
        dl(Ote, {
          "page-size": u.pageSize,
          page: u.page,
          data: u.data,
          columns: Zr(r),
          "total-results": u.totalResults,
          "sort-options": u.sortOptions,
          "is-loading": u.isLoading,
          "enable-row-selection": u.enableRowSelection,
          "show-pagination": u.showPagination,
          "expanded-item-id": u.expandedItemId,
          "enable-expand-action": !0,
          "row-class": u.rowClass,
          onOnExpand: o[0] || (o[0] = (a, h) => l("onExpand", a, h)),
          onOnSort: o[1] || (o[1] = (a) => u.$emit("onSort", a)),
          onOnPageChange: o[2] || (o[2] = (a) => u.$emit("onPageChange", a)),
          onOnPageSizeChange: o[3] || (o[3] = (a) => u.$emit("onPageSizeChange", a))
        }, Sz({ _: 2 }, [
          ru(Zr(r), (a) => ({
            name: a.name,
            fn: kl(({ row: h }) => [
              el(u.$slots, a.name, {
                field: h[a.name],
                row: h
              })
            ])
          }))
        ]), 1032, ["page-size", "page", "data", "columns", "total-results", "sort-options", "is-loading", "enable-row-selection", "show-pagination", "expanded-item-id", "row-class"])
      ]),
      u.expandedItemId ? (Qe(), _l(kte, {
        key: 0,
        onOnClose: o[4] || (o[4] = (a) => l("onExpandedItemClose"))
      }, {
        sections: kl(() => [
          el(u.$slots, "data-table-panel")
        ]),
        actions: kl(() => [
          el(u.$slots, "data-table-panel-actions")
        ]),
        _: 3
      })) : st("", !0)
    ]));
  }
}), Mje = (e) => (tL("data-v-fdc9ba0a"), e = e(), lL(), e), Pje = { class: "text-dark-muted heading" }, $je = /* @__PURE__ */ Mje(() => /* @__PURE__ */ qn("div", { class: "divider-v w-100 mx-0 my-2" }, null, -1)), Lje = {
  name: "lp-expandable-section"
}, Bje = /* @__PURE__ */ cl({
  ...Lje,
  props: {
    title: {}
  },
  setup(e) {
    return (n, t) => (Qe(), yn("div", null, [
      qn("h3", Pje, It(n.title), 1),
      el(n.$slots, "default", {}, void 0, !0),
      $je
    ]));
  }
}), Fje = /* @__PURE__ */ Cr(Bje, [["__scopeId", "data-v-fdc9ba0a"]]), Vje = { key: 1 }, Yje = {
  name: "lp-expandable-section-element"
}, Uje = /* @__PURE__ */ cl({
  ...Yje,
  props: {
    fieldName: {},
    value: {}
  },
  setup(e) {
    const n = (l, r) => l ?? r, t = (l, r = "-") => n(l, r);
    return (l, r) => (Qe(), yn("p", null, [
      l.fieldName ? (Qe(), yn("span", Vje, [
        qn("strong", null, It(l.fieldName) + ":", 1),
        Ir(" " + It(t(l.value)), 1)
      ])) : el(l.$slots, "default", { key: 0 })
    ]));
  }
}), UE = {
  DataTable: Ote,
  ExpandableDataTable: Cje,
  ExpandedPanel: kte,
  ExpandedSection: Fje,
  ExpandedSectionElement: Uje
};
for (const e in UE)
  if (UE.hasOwnProperty(e)) {
    const n = UE[e];
    n.install = (t) => {
      t.component(n.name, n);
    };
  }
const qje = cl({
  props: {
    headingClickable: {
      type: Boolean,
      default: !1
    },
    leftDisabled: {
      type: Boolean,
      default: !1
    },
    rightDisabled: {
      type: Boolean,
      default: !1
    },
    columnCount: {
      type: Number,
      default: 7
    },
    items: {
      type: Array,
      default: () => []
    },
    highlights: {
      type: Array,
      default: () => []
    },
    placement: {
      type: String,
      default: sl.T,
      validator: (e) => Object.values(sl).includes(e)
    },
    permanent: Boolean,
    autoposition: { type: Boolean, default: !0 }
  },
  emits: {
    elementClick: (e) => Mu(e),
    left: () => !0,
    right: () => !0,
    heading: () => !0
  },
  setup(e) {
    const n = dt(null), t = dt(null), {
      show: l,
      placement: r,
      disabled: u,
      clickable: o,
      transition: a,
      visionTimer: h,
      position: s,
      handleMouseEnter: d,
      handleMouseLeave: p,
      hidePopover: _,
      showPopover: R,
      setPopoverPosition: F
    } = l2({
      ...e,
      popover: n,
      trigger: t,
      arrowCalculation: !1
    });
    return {
      show: l,
      placement: r,
      disabled: u,
      clickable: o,
      transition: a,
      visionTimer: h,
      popover: n,
      trigger: t,
      position: s,
      handleMouseEnter: d,
      handleMouseLeave: p,
      hidePopover: _,
      showPopover: R,
      setPopoverPosition: F,
      isSameDay: ch,
      hasHighlight: (G) => e.highlights.find(
        (J) => ch(J.date, G)
      )
    };
  }
}), Wje = { class: "lp-datepicker-heading" }, Hje = ["disabled"], zje = { key: 0 }, Kje = ["disabled"], Gje = { class: "lp-datepicker-body" }, Zje = { class: "lp-datepicker-subheading" }, Xje = /* @__PURE__ */ qn("hr", { class: "lp-datepicker-divider" }, null, -1), Qje = { class: "lp-datepicker-elements" }, Jje = ["disabled", "data-ua-value", "onClick"], eAe = {
  key: 0,
  class: "notification-dot-container datepicker-notifications"
}, nAe = {
  key: 0,
  class: "lp-highlight-datepicker-tags p-1"
};
function tAe(e, n, t, l, r, u) {
  const o = El("lp-icon");
  return Qe(), _l(du, { name: "drop-bottom" }, {
    default: kl(() => [
      pi(qn("div", {
        ref: "popover",
        class: "lp-datepicker-popout",
        style: Hi({ "--popout-column-definition": `repeat(${e.columnCount}, 1fr)` }),
        onMousedown: n[3] || (n[3] = Oi(() => {
        }, ["prevent"]))
      }, [
        qn("div", Wje, [
          qn("button", {
            class: "lp-datepicker-heading-button",
            disabled: e.leftDisabled,
            onClick: n[0] || (n[0] = Oi((a) => e.$emit("left"), ["stop", "prevent"]))
          }, [
            dl(o, { name: "caret-left" })
          ], 8, Hje),
          (Qe(), _l(ap("button"), {
            class: "lp-datepicker-heading-center",
            onClick: n[1] || (n[1] = Oi((a) => e.$emit("heading"), ["stop", "prevent"]))
          }, {
            default: kl(() => [
              el(e.$slots, "heading"),
              e.headingClickable ? (Qe(), yn("span", zje, [
                dl(o, { name: "caret-down" })
              ])) : st("", !0)
            ]),
            _: 3
          })),
          qn("button", {
            class: "lp-datepicker-heading-button",
            disabled: e.rightDisabled,
            onClick: n[2] || (n[2] = Oi((a) => e.$emit("right"), ["stop", "prevent"]))
          }, [
            dl(o, { name: "caret-right" })
          ], 8, Kje)
        ]),
        qn("div", Gje, [
          "subheading" in e.$slots ? (Qe(), yn(Ii, { key: 0 }, [
            qn("div", Zje, [
              el(e.$slots, "subheading")
            ]),
            Xje
          ], 64)) : st("", !0),
          qn("div", Qje, [
            el(e.$slots, "body", {}, () => [
              (Qe(!0), yn(Ii, null, ru(e.items, (a) => (Qe(), yn("button", {
                key: a.key,
                disabled: a.disabled,
                class: xt({ selected: a.selected }),
                "data-ua-multiple-id": "ua-datepicker-option",
                "data-ua-value": a.display,
                onClick: Oi((h) => e.$emit("elementClick", a.value), ["stop", "prevent"])
              }, [
                Ir(It(a.display) + " ", 1),
                e.hasHighlight(a.value) ? (Qe(), yn("div", eAe, [
                  (Qe(!0), yn(Ii, null, ru(e.highlights, (h) => (Qe(), yn("div", {
                    key: h.date,
                    style: Hi(`${e.isSameDay(h.date, a.value) ? "" : "display: none;"}`),
                    class: xt(["notification-dot-sm", `bg-${h.color}`])
                  }, null, 6))), 128))
                ])) : st("", !0)
              ], 10, Jje))), 128))
            ])
          ])
        ]),
        e.highlights ? (Qe(), yn("div", nAe, [
          (Qe(!0), yn(Ii, null, ru(e.highlights, (a) => (Qe(), yn("span", {
            key: a.date,
            class: xt(["tag", `tag-${a.color}`])
          }, It(a.label), 3))), 128))
        ])) : st("", !0),
        dl(o, { name: "" })
      ], 36), [
        [Pi, e.show]
      ])
    ]),
    _: 3
  });
}
const bF = /* @__PURE__ */ Cr(qje, [["render", tAe]]), lAe = cl({
  components: {
    PickerPopup: bF
  },
  props: {
    selected: {
      type: [Date, Array],
      required: !1,
      default: () => null
    },
    pageDate: {
      type: Date,
      required: !0
    },
    lowerLimit: {
      type: Date,
      required: !1,
      default: null
    },
    upperLimit: {
      type: Date,
      required: !1,
      default: null
    }
  },
  emits: {
    "update:pageDate": (e) => Mu(e),
    select: (e) => Mu(e)
  },
  setup(e, { emit: n }) {
    const t = _t(() => ahe(e.pageDate)), l = _t(() => rae(e.pageDate)), r = (p, _, R) => !_ && !R ? !0 : !(_ && Ch(p) < Ch(_) || R && Ch(p) > Ch(R)), u = _t(
      () => lae({
        start: t.value,
        end: l.value
      }).map((p) => ({
        value: p,
        key: String(Ch(p)),
        display: Ch(p),
        selected: e.selected && Ch(p) === Ch(e.selected),
        disabled: !r(p, e.lowerLimit, e.upperLimit)
      }))
    ), o = _t(() => {
      const p = Ch(t.value), _ = Ch(l.value);
      return `${p} - ${_}`;
    }), a = _t(
      () => e.lowerLimit && (xS(e.lowerLimit) === xS(e.pageDate) || Nw(e.pageDate, e.lowerLimit))
    ), h = _t(
      () => e.upperLimit && (xS(e.upperLimit) === xS(e.pageDate) || Rw(e.pageDate, e.upperLimit))
    );
    return {
      years: u,
      heading: o,
      leftDisabled: a,
      rightDisabled: h,
      previousPage: () => n("update:pageDate", Hz(e.pageDate, 10)),
      nextPage: () => n("update:pageDate", uL(e.pageDate, 10))
    };
  }
});
function rAe(e, n, t, l, r, u) {
  const o = El("picker-popup");
  return Qe(), _l(o, {
    "column-count": 3,
    "left-disabled": e.leftDisabled,
    "right-disabled": e.rightDisabled,
    items: e.years,
    onLeft: e.previousPage,
    onRight: e.nextPage,
    onElementClick: n[0] || (n[0] = (a) => e.$emit("select", a))
  }, {
    heading: kl(() => [
      Ir(It(e.heading), 1)
    ]),
    _: 1
  }, 8, ["left-disabled", "right-disabled", "items", "onLeft", "onRight"]);
}
const iAe = /* @__PURE__ */ Cr(lAe, [["render", rAe]]), uAe = cl({
  components: {
    PickerPopup: bF
  },
  props: {
    /**
     * Currently selected date, needed for highlighting
     */
    selected: {
      type: [Date, Array],
      required: !1,
      default: () => null
    },
    pageDate: {
      type: Date,
      required: !0
    },
    format: {
      type: String,
      required: !1,
      default: "LLL"
    },
    locale: {
      type: Object,
      required: !1
    },
    lowerLimit: {
      type: Date,
      required: !1
    },
    upperLimit: {
      type: Date,
      required: !1
    }
  },
  emits: {
    "update:pageDate": (e) => Mu(e),
    select: (e) => Mu(e),
    back: () => !0
  },
  setup(e, { emit: n }) {
    const t = _t(() => Iz(e.pageDate)), l = _t(() => tae(e.pageDate)), r = _t(
      () => cL({
        locale: e.locale
      })(e.format)
    ), u = (_, R, F) => !R && !F ? !0 : !(R && Nw(_, x4(R)) || F && Rw(_, sL(F))), o = _t(
      () => nae({
        start: t.value,
        end: l.value
      }).map((_) => ({
        value: _,
        display: r.value(_),
        key: r.value(_),
        selected: e.selected && nx(e.selected, _),
        disabled: !u(_, e.lowerLimit, e.upperLimit)
      }))
    ), a = _t(() => Ch(t.value)), h = _t(
      () => e.lowerLimit && (mY(e.lowerLimit, e.pageDate) || Nw(e.pageDate, e.lowerLimit))
    ), s = _t(
      () => e.upperLimit && (mY(e.upperLimit, e.pageDate) || Rw(e.pageDate, e.upperLimit))
    );
    return {
      months: o,
      heading: a,
      leftDisabled: h,
      rightDisabled: s,
      previousPage: () => n("update:pageDate", Hz(e.pageDate, 1)),
      nextPage: () => n("update:pageDate", uL(e.pageDate, 1))
    };
  }
});
function sAe(e, n, t, l, r, u) {
  const o = El("picker-popup");
  return Qe(), _l(o, {
    "heading-clickable": "",
    "column-count": 3,
    items: e.months,
    "left-disabled": e.leftDisabled,
    "right-disabled": e.rightDisabled,
    onLeft: e.previousPage,
    onRight: e.nextPage,
    onHeading: n[0] || (n[0] = (a) => e.$emit("back")),
    onElementClick: n[1] || (n[1] = (a) => e.$emit("select", a))
  }, {
    heading: kl(() => [
      Ir(It(e.heading), 1)
    ]),
    _: 1
  }, 8, ["items", "left-disabled", "right-disabled", "onLeft", "onRight"]);
}
const oAe = /* @__PURE__ */ Cr(uAe, [["render", sAe]]), aAe = cl({
  components: {
    PickerPopup: bF
  },
  props: {
    highlights: {
      type: Array,
      default: () => []
    },
    selected: {
      type: [Date, Array],
      required: !1,
      default: () => null
    },
    pageDate: {
      type: Date,
      required: !0
    },
    format: {
      type: String,
      required: !1,
      default: "dd"
    },
    headingFormat: {
      type: String,
      required: !1,
      default: "LLLL yyyy"
    },
    weekdayFormat: {
      type: String,
      required: !1,
      default: "EE"
    },
    locale: {
      type: Object,
      required: !1
    },
    weekStartsOn: {
      type: Number,
      required: !1,
      default: 1,
      validator: (e) => typeof e == "number" && Number.isInteger(e) && e >= 0 && e <= 6
    },
    lowerLimit: {
      type: Date,
      required: !1
    },
    upperLimit: {
      type: Date,
      required: !1
    },
    disabledDates: {
      type: Object,
      required: !1
    }
  },
  emits: {
    "update:pageDate": (e) => Mu(e),
    select: (e) => Mu(e),
    back: () => !0
  },
  setup(e, { emit: n }) {
    const t = _t(
      () => cL({
        locale: e.locale,
        weekStartsOn: e.weekStartsOn
      })
    ), l = _t(() => x4(e.pageDate)), r = _t(() => sL(e.pageDate)), u = _t(() => ({
      start: l.value,
      end: r.value
    })), o = _t(() => ({
      start: If(l.value, {
        weekStartsOn: e.weekStartsOn
      }),
      end: Rz(r.value, {
        weekStartsOn: e.weekStartsOn
      })
    })), a = _t(() => {
      const L = e.weekStartsOn, G = t.value(e.weekdayFormat);
      return Array.from(Array(7)).map((J, we) => (L + we) % 7).map(
        (J) => y3(/* @__PURE__ */ new Date(), J, {
          weekStartsOn: e.weekStartsOn
        })
      ).map(G);
    }), h = (L, G, J, we) => we?.dates?.some((ce) => ch(L, ce)) || we?.predicate?.(L) ? !1 : !G && !J ? !0 : !(G && Nw(L, fy(G)) || J && Rw(L, Az(J))), s = _t(() => {
      const L = t.value(e.format);
      return Dz(o.value).map((G) => ({
        value: G,
        display: L(G),
        selected: e.selected && ch(e.selected, G),
        disabled: !Uz(G, u.value) || !h(
          G,
          e.lowerLimit,
          e.upperLimit,
          e.disabledDates
        ),
        key: t.value("yyyy-MM-dd", G)
      }));
    }), d = _t(
      () => t.value(e.headingFormat)(e.pageDate)
    ), p = _t(
      () => e.lowerLimit && (nx(e.lowerLimit, e.pageDate) || Nw(e.pageDate, e.lowerLimit))
    ), _ = _t(
      () => e.upperLimit && (nx(e.upperLimit, e.pageDate) || Rw(e.pageDate, e.upperLimit))
    );
    return {
      weekDays: a,
      days: s,
      heading: d,
      leftDisabled: p,
      rightDisabled: _,
      previousPage: () => n("update:pageDate", Wz(e.pageDate, 1)),
      nextPage: () => n("update:pageDate", y4(e.pageDate, 1))
    };
  }
});
function cAe(e, n, t, l, r, u) {
  const o = El("picker-popup");
  return Qe(), _l(o, {
    "heading-clickable": "",
    "left-disabled": e.leftDisabled,
    "right-disabled": e.rightDisabled,
    items: e.days,
    highlights: e.highlights,
    onLeft: e.previousPage,
    onRight: e.nextPage,
    onHeading: n[0] || (n[0] = (a) => e.$emit("back")),
    onElementClick: n[1] || (n[1] = (a) => e.$emit("select", a))
  }, {
    heading: kl(() => [
      Ir(It(e.heading), 1)
    ]),
    subheading: kl(() => [
      (Qe(!0), yn(Ii, null, ru(e.weekDays, (a) => (Qe(), yn("span", { key: a }, It(a), 1))), 128))
    ]),
    _: 1
  }, 8, ["left-disabled", "right-disabled", "items", "highlights", "onLeft", "onRight"]);
}
const hAe = /* @__PURE__ */ Cr(aAe, [["render", cAe]]), HS = ["day", "month", "year"], fAe = cl({
  name: "lp-datepicker",
  components: {
    YearPicker: iAe,
    MonthPicker: oAe,
    DayPicker: hAe
  },
  inheritAttrs: !1,
  props: {
    status: { type: String, default: "neutral" },
    message: { type: String, default: null },
    /**
     * `v-model` for selected date
     */
    modelValue: {
      type: [Date, Array],
      required: !0,
      default: () => null
    },
    /**
     * Dates not available for picking
     */
    disabledDates: {
      type: Object,
      required: !1
    },
    /**
     * Upper limit for available dates for picking
     */
    upperLimit: {
      type: Date,
      required: !1
    },
    /**
     * Lower limit for available dates for picking
     */
    lowerLimit: {
      type: Date,
      required: !1
    },
    /**
     * View on which the date picker should open. Can be either `year`, `month`, or `day`
     */
    startingView: {
      type: String,
      required: !1,
      default: "day",
      validate: (e) => typeof e == "string" && HS.includes(e)
    },
    /**
     * `date-fns`-type formatting for a month view heading
     */
    monthHeadingFormat: {
      type: String,
      required: !1,
      default: "LLLL yyyy"
    },
    /**
     * `date-fns`-type formatting for the month picker view
     */
    monthListFormat: {
      type: String,
      required: !1,
      default: "LLL"
    },
    /**
     * `date-fns`-type formatting for a line of weekdays on day view
     */
    weekdayFormat: {
      type: String,
      required: !1,
      default: "EE"
    },
    /**
     * `date-fns`-type format in which the string in the input should be both
     * parsed and displayed
     */
    inputFormat: {
      type: String,
      required: !1,
      default: "MM/dd/yy"
    },
    placeholder: {
      type: String,
      required: !1,
      default: null
    },
    /**
     * [`date-fns` locale object](https://date-fns.org/v2.16.1/docs/I18n#usage).
     * Used in string formatting (see default `monthHeadingFormat`)
     */
    locale: {
      type: Object,
      required: !1
    },
    /**
     * Day on which the week should start.
     *
     * Number from 0 to 6, where 0 is Sunday and 6 is Saturday.
     * Week starts with a Monday (1) by default
     */
    weekStartsOn: {
      type: Number,
      required: !1,
      default: 0,
      validator: (e) => [0, 1, 2, 3, 4, 5, 6].includes(e)
    },
    /**
     * Disables datepicker and prevents it's opening
     */
    disabled: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * Clears selected date
     */
    clearable: {
      type: Boolean,
      required: !1,
      default: !0
    },
    /*
     * Allows user to input date manually
     */
    typeable: {
      type: Boolean,
      required: !1,
      default: !1
    },
    /**
     * If set, lower-level views won't show
     */
    minimumView: {
      type: String,
      required: !1,
      default: "day",
      validate: (e) => typeof e == "string" && HS.includes(e)
    },
    highlights: {
      type: Array,
      default: () => []
    },
    preview: {
      type: Boolean,
      required: !1,
      default: !1
    },
    dataUaUniqueId: {
      type: String,
      required: !1,
      default: "ua-datepicker-wrapper"
    },
    labelTop: {
      type: String,
      required: !1,
      default: null
    },
    required: {
      type: Boolean
    }
  },
  emits: {
    "update:modelValue": (e) => e == null || Mu(e)
  },
  setup(e, { emit: n }) {
    const t = dt("none"), l = dt(/* @__PURE__ */ new Date()), r = dt(null), u = dt(""), o = dt(e.message), a = dt(e.message);
    ga(() => {
      const L = N_(u.value, e.inputFormat, /* @__PURE__ */ new Date());
      Mu(L) ? (l.value = L, a.value = o.value) : u.value.length > e.inputFormat.length && (u.value = "", n("update:modelValue", null), a.value = "Date is not valid. Please try again.");
    }), ga(
      () => u.value = e.modelValue && Mu(e.modelValue) ? Wo(e.modelValue, e.inputFormat, {
        locale: e.locale
      }) : ""
    ), ga(() => {
      o.value = e.message, a.value = o.value;
    });
    const h = (L = "none") => {
      e.disabled || (t.value = L, e.modelValue || (l.value = /* @__PURE__ */ new Date()));
    };
    ga(() => {
      e.disabled && (t.value = "none");
    });
    const s = (L) => {
      l.value = L, e.minimumView === "year" ? (t.value = "none", n("update:modelValue", L)) : t.value = "month";
    }, d = (L) => {
      l.value = L, e.minimumView === "month" ? (t.value = "none", n("update:modelValue", L)) : t.value = "day";
    }, p = (L) => {
      n("update:modelValue", L), t.value = "none";
    }, _ = () => {
      e.clearable && n("update:modelValue", null);
    }, R = (L) => {
      const G = L.code ? L.code : L.button;
      if ([
        27,
        // escape
        13
        // enter
      ].includes(G) && r.value?.blur(), e.typeable && u.value.length === e.inputFormat.length) {
        const we = N_(u.value, e.inputFormat, /* @__PURE__ */ new Date());
        Mu(we) ? n("update:modelValue", we) : (n("update:modelValue", null), u.value = "");
      }
      h();
    }, F = _t(() => {
      const L = HS.indexOf(e.startingView), G = HS.indexOf(e.minimumView);
      return L < G ? e.minimumView : e.startingView;
    });
    return {
      input: u,
      inputRef: r,
      pageDate: l,
      renderView: h,
      selectYear: s,
      selectMonth: d,
      selectDay: p,
      keyUp: R,
      viewShown: t,
      clearModelValue: _,
      initialView: F,
      messageValue: a
    };
  }
}), dAe = ["data-ua-unique-id"], pAe = {
  key: 0,
  class: "text-blue"
}, mAe = { class: "input-wrapper" }, gAe = { class: "clearable" };
function wAe(e, n, t, l, r, u) {
  const o = El("lp-icon"), a = El("lp-input"), h = El("year-picker"), s = El("month-picker"), d = El("day-picker");
  return Qe(), yn("div", {
    class: xt(["lp-datepicker", [e.preview && "lp-datepicker-preview"]]),
    "data-ua-unique-id": e.dataUaUniqueId
  }, [
    e.labelTop ? (Qe(), yn("span", {
      key: 0,
      class: xt(["lp-input-label font-weight-medium", !e.preview && e.message ? "text-error" : ""])
    }, [
      Ir(It(e.labelTop) + " ", 1),
      !e.preview && e.required ? (Qe(), yn("span", pAe, "*")) : st("", !0)
    ], 2)) : st("", !0),
    qn("div", mAe, [
      dl(a, Ni({
        ref: "inputRef",
        modelValue: e.input,
        "onUpdate:modelValue": n[1] || (n[1] = (p) => e.input = p),
        type: "text",
        readonly: !e.typeable
      }, e.$attrs, {
        tabindex: e.disabled ? -1 : 0,
        status: e.status,
        "suffix-icon": "calendar-alt",
        message: e.messageValue,
        disabled: e.disabled,
        placeholder: e.placeholder ?? e.inputFormat,
        preview: e.preview,
        onBlur: e.keyUp,
        onKeyup: e.keyUp,
        onFocus: n[2] || (n[2] = (p) => e.renderView(e.initialView)),
        onClick: n[3] || (n[3] = (p) => e.renderView(e.initialView))
      }), {
        clear: kl(() => [
          pi(qn("div", gAe, [
            el(e.$slots, "clear", { onClear: e.clearModelValue }, () => [
              dl(o, {
                class: "lp-input-icon-wrapper",
                name: "close",
                compact: "",
                onClick: n[0] || (n[0] = (p) => e.clearModelValue())
              })
            ])
          ], 512), [
            [Pi, e.clearable && e.modelValue && !e.preview]
          ])
        ]),
        _: 3
      }, 16, ["modelValue", "readonly", "tabindex", "status", "message", "disabled", "placeholder", "preview", "onBlur", "onKeyup"])
    ]),
    pi(dl(h, {
      pageDate: e.pageDate,
      "onUpdate:pageDate": n[4] || (n[4] = (p) => e.pageDate = p),
      selected: e.modelValue,
      "lower-limit": e.lowerLimit,
      "upper-limit": e.upperLimit,
      "data-ua-unique-id": "ua-datepicker-yearpicker",
      onSelect: e.selectYear
    }, null, 8, ["pageDate", "selected", "lower-limit", "upper-limit", "onSelect"]), [
      [Pi, e.viewShown === "year"]
    ]),
    pi(dl(s, {
      pageDate: e.pageDate,
      "onUpdate:pageDate": n[5] || (n[5] = (p) => e.pageDate = p),
      selected: e.modelValue,
      "lower-limit": e.lowerLimit,
      "upper-limit": e.upperLimit,
      format: e.monthListFormat,
      "heading-format": e.monthHeadingFormat,
      locale: e.locale,
      "data-ua-unique-id": "ua-datepicker-monthpicker",
      onSelect: e.selectMonth,
      onBack: n[6] || (n[6] = (p) => e.viewShown = "year")
    }, null, 8, ["pageDate", "selected", "lower-limit", "upper-limit", "format", "heading-format", "locale", "onSelect"]), [
      [Pi, e.viewShown === "month"]
    ]),
    pi(dl(d, {
      pageDate: e.pageDate,
      "onUpdate:pageDate": n[7] || (n[7] = (p) => e.pageDate = p),
      selected: e.modelValue,
      "week-starts-on": e.weekStartsOn,
      "lower-limit": e.lowerLimit,
      "upper-limit": e.upperLimit,
      "disabled-dates": e.disabledDates,
      locale: e.locale,
      "weekday-format": e.weekdayFormat,
      highlights: e.highlights,
      "data-ua-unique-id": "ua-datepicker-daypicker",
      onSelect: e.selectDay,
      onBack: n[8] || (n[8] = (p) => e.viewShown = "month")
    }, null, 8, ["pageDate", "selected", "week-starts-on", "lower-limit", "upper-limit", "disabled-dates", "locale", "weekday-format", "highlights", "onSelect"]), [
      [Pi, e.viewShown === "day"]
    ])
  ], 10, dAe);
}
const qE = /* @__PURE__ */ Cr(fAe, [["render", wAe]]);
qE.install = (e) => {
  e.component(qE.name, qE);
};
const Ite = (e, n) => {
  const t = "RANGE", l = e.start || e.end ? dt(t) : e.modelValue ? dt(e.modelValue) : dt(null), r = dt(!0), u = e.start ? dt(e.start) : dt(null), o = e.end ? dt(e.end) : dt(null), a = dt(null), h = dt(null), s = dt(e.labelTop), d = dt(!1), p = dt("");
  function _() {
    (u.value === null || o.value === null) && (l.value = null, F(l.value)), u.value = a.value, o.value = h.value, d.value = !1;
  }
  function R() {
    l.value === t ? (a.value = u.value, h.value = o.value, d.value = !0) : (u.value = null, o.value = null), F(l.value);
  }
  function F(G) {
    n(
      "update-selection",
      G,
      e.options.find((J) => J.value === G)
    );
  }
  function L() {
    const G = u.value, J = o.value;
    if (p.value = "", G === null && J === null) {
      p.value = "At least one of the values must be entered";
      return;
    }
    if (G !== null && J !== null && G > J) {
      p.value = "Start range should be less than end value";
      return;
    }
    n("update-range", u.value, o.value), d.value = !1;
  }
  return {
    CUSTOM_RANGE: t,
    selected: l,
    modal: d,
    updateSelection: R,
    updateRange: L,
    startValue: u,
    endValue: o,
    labelValue: s,
    validRange: r,
    validationMessage: p,
    onCancel: _
  };
}, vAe = cl({
  name: "lp-daterangepicker",
  props: {
    modelValue: {
      type: [String, Date, null],
      default: null,
      required: !0
    },
    start: { type: Date, default: null },
    end: { type: Date, default: null },
    labelTop: { type: String },
    labelBy: { type: String, default: "name" },
    trackBy: { type: String, default: "value" },
    placeholder: { type: String, default: "Select option..." },
    status: { type: String, default: "neutral" },
    message: { type: String, default: null },
    customRangeLabel: { type: String, default: "Custom Range" },
    options: { type: Array, default: () => [] },
    format: { type: String, default: "MM/dd/yyyy" },
    singleValue: { type: Boolean, default: !1 },
    searchable: { type: Boolean, default: !1 },
    typeable: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    disabled: { type: Boolean, default: !1 },
    modalContainer: { type: String, default: "body" },
    preview: { type: Boolean, default: !1 },
    previewSeparator: { type: String, default: "" }
  },
  emits: ["update-range", "update-selection"],
  setup(e, { emit: n }) {
    const t = _t(() => {
      let L = e.customRangeLabel;
      return s.value && d.value ? Wo(s.value, e.format) === Wo(d.value, e.format) ? L += ` (${Wo(s.value, e.format)})` : s.value && d.value && (L += ` (${Wo(s.value, e.format)} - ${Wo(
        d.value,
        e.format
      )})`) : !s.value && d.value ? L += ` (before ${Wo(d.value, e.format)})` : s.value && !d.value && (e.singleValue ? L = `Custom Date (${Wo(s.value, e.format)})` : L += ` (after ${Wo(s.value, e.format)})`), { [e.labelBy]: L, [e.trackBy]: r };
    }), l = _t(() => [...e.options, t.value]), {
      CUSTOM_RANGE: r,
      selected: u,
      modal: o,
      updateSelection: a,
      updateRange: h,
      startValue: s,
      endValue: d,
      labelValue: p,
      validRange: _,
      validationMessage: R,
      onCancel: F
    } = Ite(e, n);
    return ga(() => {
      e.modelValue && (u.value = e.modelValue), (e.start || e.end) && (s.value = e.start, d.value = e.end);
    }), {
      optionsUpdated: l,
      CUSTOM_RANGE: r,
      selected: u,
      modal: o,
      updateSelection: a,
      updateRange: h,
      startValue: s,
      endValue: d,
      labelValue: p,
      validRange: _,
      validationMessage: R,
      onCancel: F
    };
  }
}), yAe = { class: "lp-daterangepicker" }, _Ae = {
  key: 0,
  class: "lp-daterangepicker-preview"
}, xAe = { class: "lp-daterangepicker-preview-label" }, SAe = /* @__PURE__ */ qn("h3", { style: { margin: "0" } }, "Date Range", -1), EAe = {
  key: 1,
  class: "mt-1 text-red"
};
function OAe(e, n, t, l, r, u) {
  const o = El("lp-datepicker"), a = El("lp-select"), h = El("lp-button"), s = El("lp-modal");
  return Qe(), yn("div", yAe, [
    e.preview ? (Qe(), yn("div", _Ae, [
      qn("div", xAe, It(e.labelTop), 1),
      dl(o, {
        modelValue: e.startValue,
        "onUpdate:modelValue": n[0] || (n[0] = (d) => e.startValue = d),
        "label-top": e.singleValue ? "Select date" : "Select start date",
        "input-format": e.format,
        typeable: e.typeable,
        preview: !0,
        "data-ua-unique-id": "ua-daterangepicker-start"
      }, null, 8, ["modelValue", "label-top", "input-format", "typeable"]),
      Ir(" " + It(e.previewSeparator) + " ", 1),
      e.singleValue ? st("", !0) : (Qe(), _l(o, {
        key: 0,
        modelValue: e.endValue,
        "onUpdate:modelValue": n[1] || (n[1] = (d) => e.endValue = d),
        "label-top": "Select end date",
        "input-format": e.format,
        typeable: e.typeable,
        preview: !0,
        "data-ua-unique-id": "ua-daterangepicker-end"
      }, null, 8, ["modelValue", "input-format", "typeable"]))
    ])) : (Qe(), _l(a, {
      key: 1,
      modelValue: e.selected,
      "onUpdate:modelValue": [
        n[2] || (n[2] = (d) => e.selected = d),
        e.updateSelection
      ],
      options: e.optionsUpdated,
      "label-by": e.labelBy,
      "track-by": e.trackBy,
      placement: "bottom",
      class: "w-100",
      "label-top": e.labelTop,
      placeholder: e.placeholder,
      status: e.status,
      message: e.message,
      search: e.searchable,
      required: e.required,
      disabled: e.disabled,
      "data-ua-unique-id": "ua-daterangepicker-select"
    }, null, 8, ["modelValue", "options", "label-by", "track-by", "label-top", "placeholder", "status", "message", "search", "required", "disabled", "onUpdate:modelValue"])),
    dl(s, {
      modelValue: e.modal,
      "onUpdate:modelValue": n[5] || (n[5] = (d) => e.modal = d),
      container: e.modalContainer,
      size: "sm",
      "data-ua-unique-id": "ua-daterangepicker-modal",
      onModalClose: e.onCancel
    }, {
      header: kl(() => [
        SAe
      ]),
      body: kl(() => [
        dl(o, {
          modelValue: e.startValue,
          "onUpdate:modelValue": n[3] || (n[3] = (d) => e.startValue = d),
          "label-top": e.singleValue ? "Select date" : "Select start date",
          "input-format": e.format,
          typeable: e.typeable,
          "data-ua-unique-id": "ua-daterangepicker-start"
        }, null, 8, ["modelValue", "label-top", "input-format", "typeable"]),
        e.singleValue ? st("", !0) : (Qe(), _l(o, {
          key: 0,
          modelValue: e.endValue,
          "onUpdate:modelValue": n[4] || (n[4] = (d) => e.endValue = d),
          "label-top": "Select end date",
          "input-format": e.format,
          typeable: e.typeable,
          "data-ua-unique-id": "ua-daterangepicker-end"
        }, null, 8, ["modelValue", "input-format", "typeable"])),
        e.validationMessage ? (Qe(), yn("div", EAe, It(e.validationMessage), 1)) : st("", !0)
      ]),
      actions: kl(() => [
        dl(h, {
          "data-ua-unique-id": "ua-daterangepicker-cancel",
          onClick: e.onCancel
        }, {
          default: kl(() => [
            Ir(" Cancel ")
          ]),
          _: 1
        }, 8, ["onClick"]),
        dl(h, {
          type: "primary",
          "data-ua-unique-id": "ua-daterangepicker-confirm",
          onClick: e.updateRange
        }, {
          default: kl(() => [
            Ir(" Confirm ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["modelValue", "container", "onModalClose"])
  ]);
}
const WE = /* @__PURE__ */ Cr(vAe, [["render", OAe]]);
WE.install = (e) => {
  e.component(WE.name, WE);
};
const kAe = {
  key: 0,
  class: "lp-input-label font-weight-medium"
}, bAe = {
  key: 0,
  class: "text-blue"
}, TAe = {
  name: "lp-datetimepicker",
  inheritAttrs: !1
}, HE = /* @__PURE__ */ cl({
  ...TAe,
  props: {
    modelValue: { default: null },
    labelTop: { default: null },
    status: { default: "neutral" },
    defaultValue: { default: null },
    message: { default: null },
    disabled: { type: Boolean, default: !1 },
    typeable: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    preview: { type: Boolean, default: !1 },
    required: { type: [Boolean, null], default: !1 },
    dateFormat: { default: "MM/dd/yyyy" },
    timeFormat: { default: "hh:mm a" },
    timeInterval: { default: 5 }
  },
  emits: ["update:model-value"],
  setup(e, { emit: n }) {
    const t = n, l = e, r = l.modelValue ? dt(l.modelValue) : dt(null), u = l.modelValue ? dt(l.modelValue) : dt(null), o = () => {
      t(
        "update:model-value",
        r.value && u.value ? /* @__PURE__ */ new Date(`
          ${r.value ? Wo(r.value, l.dateFormat) + "," : ""} ${u.value ? r.value ? Wo(u.value, l.timeFormat) : Wo(u.value, l.dateFormat + ", " + l.timeFormat) : ""}
        `) : null
      );
    };
    return di(
      () => l.modelValue,
      (a) => {
        r.value = a, u.value = a;
      }
    ), (a, h) => {
      const s = El("lp-datepicker"), d = El("lp-time-picker");
      return Qe(), yn("div", {
        class: xt(["lp-datetimepicker-wrapper", [a.preview && "lp-datetimepicker-preview"]])
      }, [
        a.labelTop ? (Qe(), yn("span", kAe, [
          Ir(It(a.labelTop) + " ", 1),
          !a.preview && a.required ? (Qe(), yn("span", bAe, "*")) : st("", !0)
        ])) : st("", !0),
        qn("div", Ni({
          class: ["lp-datetimepicker", [!a.preview && "ly-even-2 ly-end-end"]]
        }, a.$attrs), [
          dl(s, Ni({
            modelValue: Zr(r),
            "onUpdate:modelValue": h[0] || (h[0] = (p) => om(r) ? r.value = p : null),
            "input-format": a.dateFormat,
            message: a.message,
            required: a.required,
            disabled: a.disabled,
            typeable: a.typeable,
            clearable: a.clearable,
            preview: a.preview,
            compact: a.preview
          }, a.$attrs, {
            "data-ua-unique-id": "ua-datetimepicker-datepicker",
            "onUpdate:modelValue": o
          }), null, 16, ["modelValue", "input-format", "message", "required", "disabled", "typeable", "clearable", "preview", "compact"]),
          dl(d, Ni({
            modelValue: Zr(u),
            "onUpdate:modelValue": h[1] || (h[1] = (p) => om(u) ? u.value = p : null),
            "label-top": "",
            default: a.defaultValue,
            format: a.timeFormat,
            message: a.message,
            interval: a.timeInterval,
            disabled: a.disabled,
            preview: a.preview
          }, a.$attrs, {
            "data-ua-unique-id": "ua-datetimepicker-timepicker",
            "onUpdate:modelValue": o
          }), null, 16, ["modelValue", "default", "format", "message", "interval", "disabled", "preview"])
        ], 16)
      ], 2);
    };
  }
});
HE.install = (e) => {
  e.component(HE.name, HE);
};
const zE = /* @__PURE__ */ cl({
  name: "lp-divider",
  __name: "LpDivider",
  props: {
    vertical: { type: Boolean, default: !1 }
  },
  setup(e) {
    return (n, t) => (Qe(), yn("div", {
      class: xt(["lp-divider", {
        "lp-divider-h": !n.vertical,
        "lp-divider-v": n.vertical
      }]),
      role: "separator"
    }, null, 2));
  }
});
zE.install = (e) => {
  e.component(zE.name, zE);
};
function jAe(e) {
  if (Array.isArray(e)) {
    for (var n = 0, t = Array(e.length); n < e.length; n++)
      t[n] = e[n];
    return t;
  } else
    return Array.from(e);
}
var TF = !1;
if (typeof window < "u") {
  var rz = {
    get passive() {
      TF = !0;
    }
  };
  window.addEventListener("testPassive", null, rz), window.removeEventListener("testPassive", null, rz);
}
var Rte = typeof window < "u" && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1), vm = [], h4 = !1, Nte = -1, X_ = void 0, Q_ = void 0, Cte = function(n) {
  return vm.some(function(t) {
    return !!(t.options.allowTouchMove && t.options.allowTouchMove(n));
  });
}, f4 = function(n) {
  var t = n || window.event;
  return Cte(t.target) || t.touches.length > 1 ? !0 : (t.preventDefault && t.preventDefault(), !1);
}, AAe = function(n) {
  if (Q_ === void 0) {
    var t = !!n && n.reserveScrollBarGap === !0, l = window.innerWidth - document.documentElement.clientWidth;
    t && l > 0 && (Q_ = document.body.style.paddingRight, document.body.style.paddingRight = l + "px");
  }
  X_ === void 0 && (X_ = document.body.style.overflow, document.body.style.overflow = "hidden");
}, DAe = function() {
  Q_ !== void 0 && (document.body.style.paddingRight = Q_, Q_ = void 0), X_ !== void 0 && (document.body.style.overflow = X_, X_ = void 0);
}, IAe = function(n) {
  return n ? n.scrollHeight - n.scrollTop <= n.clientHeight : !1;
}, RAe = function(n, t) {
  var l = n.targetTouches[0].clientY - Nte;
  return Cte(n.target) ? !1 : t && t.scrollTop === 0 && l > 0 || IAe(t) && l < 0 ? f4(n) : (n.stopPropagation(), !0);
}, Mte = function(n, t) {
  if (!n) {
    console.error("disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.");
    return;
  }
  if (!vm.some(function(r) {
    return r.targetElement === n;
  })) {
    var l = {
      targetElement: n,
      options: t || {}
    };
    vm = [].concat(jAe(vm), [l]), Rte ? (n.ontouchstart = function(r) {
      r.targetTouches.length === 1 && (Nte = r.targetTouches[0].clientY);
    }, n.ontouchmove = function(r) {
      r.targetTouches.length === 1 && RAe(r, n);
    }, h4 || (document.addEventListener("touchmove", f4, TF ? { passive: !1 } : void 0), h4 = !0)) : AAe(t);
  }
}, Pte = function(n) {
  if (!n) {
    console.error("enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.");
    return;
  }
  vm = vm.filter(function(t) {
    return t.targetElement !== n;
  }), Rte ? (n.ontouchstart = null, n.ontouchmove = null, h4 && vm.length === 0 && (document.removeEventListener("touchmove", f4, TF ? { passive: !1 } : void 0), h4 = !1)) : vm.length || DAe();
};
function NAe(e) {
  v4() && g4(e);
}
/*!
* tabbable 5.3.3
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/
var $te = ["input", "select", "textarea", "a[href]", "button", "[tabindex]:not(slot)", "audio[controls]", "video[controls]", '[contenteditable]:not([contenteditable="false"])', "details>summary:first-of-type", "details"], d4 = /* @__PURE__ */ $te.join(","), Lte = typeof Element > "u", d1 = Lte ? function() {
} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector, Q$ = !Lte && Element.prototype.getRootNode ? function(e) {
  return e.getRootNode();
} : function(e) {
  return e.ownerDocument;
}, Bte = function(n, t, l) {
  var r = Array.prototype.slice.apply(n.querySelectorAll(d4));
  return t && d1.call(n, d4) && r.unshift(n), r = r.filter(l), r;
}, Fte = function e(n, t, l) {
  for (var r = [], u = Array.from(n); u.length; ) {
    var o = u.shift();
    if (o.tagName === "SLOT") {
      var a = o.assignedElements(), h = a.length ? a : o.children, s = e(h, !0, l);
      l.flatten ? r.push.apply(r, s) : r.push({
        scope: o,
        candidates: s
      });
    } else {
      var d = d1.call(o, d4);
      d && l.filter(o) && (t || !n.includes(o)) && r.push(o);
      var p = o.shadowRoot || // check for an undisclosed shadow
      typeof l.getShadowRoot == "function" && l.getShadowRoot(o), _ = !l.shadowRootFilter || l.shadowRootFilter(o);
      if (p && _) {
        var R = e(p === !0 ? o.children : p.children, !0, l);
        l.flatten ? r.push.apply(r, R) : r.push({
          scope: o,
          candidates: R
        });
      } else
        u.unshift.apply(u, o.children);
    }
  }
  return r;
}, Vte = function(n, t) {
  return n.tabIndex < 0 && (t || /^(AUDIO|VIDEO|DETAILS)$/.test(n.tagName) || n.isContentEditable) && isNaN(parseInt(n.getAttribute("tabindex"), 10)) ? 0 : n.tabIndex;
}, CAe = function(n, t) {
  return n.tabIndex === t.tabIndex ? n.documentOrder - t.documentOrder : n.tabIndex - t.tabIndex;
}, Yte = function(n) {
  return n.tagName === "INPUT";
}, MAe = function(n) {
  return Yte(n) && n.type === "hidden";
}, PAe = function(n) {
  var t = n.tagName === "DETAILS" && Array.prototype.slice.apply(n.children).some(function(l) {
    return l.tagName === "SUMMARY";
  });
  return t;
}, $Ae = function(n, t) {
  for (var l = 0; l < n.length; l++)
    if (n[l].checked && n[l].form === t)
      return n[l];
}, LAe = function(n) {
  if (!n.name)
    return !0;
  var t = n.form || Q$(n), l = function(a) {
    return t.querySelectorAll('input[type="radio"][name="' + a + '"]');
  }, r;
  if (typeof window < "u" && typeof window.CSS < "u" && typeof window.CSS.escape == "function")
    r = l(window.CSS.escape(n.name));
  else
    try {
      r = l(n.name);
    } catch (o) {
      return console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", o.message), !1;
    }
  var u = $Ae(r, n.form);
  return !u || u === n;
}, BAe = function(n) {
  return Yte(n) && n.type === "radio";
}, FAe = function(n) {
  return BAe(n) && !LAe(n);
}, iz = function(n) {
  var t = n.getBoundingClientRect(), l = t.width, r = t.height;
  return l === 0 && r === 0;
}, VAe = function(n, t) {
  var l = t.displayCheck, r = t.getShadowRoot;
  if (getComputedStyle(n).visibility === "hidden")
    return !0;
  var u = d1.call(n, "details>summary:first-of-type"), o = u ? n.parentElement : n;
  if (d1.call(o, "details:not([open]) *"))
    return !0;
  var a = Q$(n).host, h = a?.ownerDocument.contains(a) || n.ownerDocument.contains(n);
  if (!l || l === "full") {
    if (typeof r == "function") {
      for (var s = n; n; ) {
        var d = n.parentElement, p = Q$(n);
        if (d && !d.shadowRoot && r(d) === !0)
          return iz(n);
        n.assignedSlot ? n = n.assignedSlot : !d && p !== n.ownerDocument ? n = p.host : n = d;
      }
      n = s;
    }
    if (h)
      return !n.getClientRects().length;
  } else if (l === "non-zero-area")
    return iz(n);
  return !1;
}, YAe = function(n) {
  if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(n.tagName))
    for (var t = n.parentElement; t; ) {
      if (t.tagName === "FIELDSET" && t.disabled) {
        for (var l = 0; l < t.children.length; l++) {
          var r = t.children.item(l);
          if (r.tagName === "LEGEND")
            return d1.call(t, "fieldset[disabled] *") ? !0 : !r.contains(n);
        }
        return !0;
      }
      t = t.parentElement;
    }
  return !1;
}, p4 = function(n, t) {
  return !(t.disabled || MAe(t) || VAe(t, n) || // For a details element with a summary, the summary element gets the focus
  PAe(t) || YAe(t));
}, J$ = function(n, t) {
  return !(FAe(t) || Vte(t) < 0 || !p4(n, t));
}, UAe = function(n) {
  var t = parseInt(n.getAttribute("tabindex"), 10);
  return !!(isNaN(t) || t >= 0);
}, qAe = function e(n) {
  var t = [], l = [];
  return n.forEach(function(r, u) {
    var o = !!r.scope, a = o ? r.scope : r, h = Vte(a, o), s = o ? e(r.candidates) : a;
    h === 0 ? o ? t.push.apply(t, s) : t.push(a) : l.push({
      documentOrder: u,
      tabIndex: h,
      item: r,
      isScope: o,
      content: s
    });
  }), l.sort(CAe).reduce(function(r, u) {
    return u.isScope ? r.push.apply(r, u.content) : r.push(u.content), r;
  }, []).concat(t);
}, WAe = function(n, t) {
  t = t || {};
  var l;
  return t.getShadowRoot ? l = Fte([n], t.includeContainer, {
    filter: J$.bind(null, t),
    flatten: !1,
    getShadowRoot: t.getShadowRoot,
    shadowRootFilter: UAe
  }) : l = Bte(n, t.includeContainer, J$.bind(null, t)), qAe(l);
}, HAe = function(n, t) {
  t = t || {};
  var l;
  return t.getShadowRoot ? l = Fte([n], t.includeContainer, {
    filter: p4.bind(null, t),
    flatten: !0,
    getShadowRoot: t.getShadowRoot
  }) : l = Bte(n, t.includeContainer, p4.bind(null, t)), l;
}, zS = function(n, t) {
  if (t = t || {}, !n)
    throw new Error("No node provided");
  return d1.call(n, d4) === !1 ? !1 : J$(t, n);
}, zAe = /* @__PURE__ */ $te.concat("iframe").join(","), ID = function(n, t) {
  if (t = t || {}, !n)
    throw new Error("No node provided");
  return d1.call(n, zAe) === !1 ? !1 : p4(t, n);
};
/*!
* focus-trap 6.9.4
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/
function uz(e, n) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    n && (l = l.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, l);
  }
  return t;
}
function sz(e) {
  for (var n = 1; n < arguments.length; n++) {
    var t = arguments[n] != null ? arguments[n] : {};
    n % 2 ? uz(Object(t), !0).forEach(function(l) {
      KAe(e, l, t[l]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : uz(Object(t)).forEach(function(l) {
      Object.defineProperty(e, l, Object.getOwnPropertyDescriptor(t, l));
    });
  }
  return e;
}
function KAe(e, n, t) {
  return n in e ? Object.defineProperty(e, n, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[n] = t, e;
}
var oz = /* @__PURE__ */ function() {
  var e = [];
  return {
    activateTrap: function(t) {
      if (e.length > 0) {
        var l = e[e.length - 1];
        l !== t && l.pause();
      }
      var r = e.indexOf(t);
      r === -1 || e.splice(r, 1), e.push(t);
    },
    deactivateTrap: function(t) {
      var l = e.indexOf(t);
      l !== -1 && e.splice(l, 1), e.length > 0 && e[e.length - 1].unpause();
    }
  };
}(), GAe = function(n) {
  return n.tagName && n.tagName.toLowerCase() === "input" && typeof n.select == "function";
}, ZAe = function(n) {
  return n.key === "Escape" || n.key === "Esc" || n.keyCode === 27;
}, XAe = function(n) {
  return n.key === "Tab" || n.keyCode === 9;
}, az = function(n) {
  return setTimeout(n, 0);
}, cz = function(n, t) {
  var l = -1;
  return n.every(function(r, u) {
    return t(r) ? (l = u, !1) : !0;
  }), l;
}, y_ = function(n) {
  for (var t = arguments.length, l = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    l[r - 1] = arguments[r];
  return typeof n == "function" ? n.apply(void 0, l) : n;
}, KS = function(n) {
  return n.target.shadowRoot && typeof n.composedPath == "function" ? n.composedPath()[0] : n.target;
}, QAe = function(n, t) {
  var l = t?.document || document, r = sz({
    returnFocusOnDeactivate: !0,
    escapeDeactivates: !0,
    delayInitialFocus: !0
  }, t), u = {
    // containers given to createFocusTrap()
    // @type {Array<HTMLElement>}
    containers: [],
    // list of objects identifying tabbable nodes in `containers` in the trap
    // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
    //  is active, but the trap should never get to a state where there isn't at least one group
    //  with at least one tabbable node in it (that would lead to an error condition that would
    //  result in an error being thrown)
    // @type {Array<{
    //   container: HTMLElement,
    //   tabbableNodes: Array<HTMLElement>, // empty if none
    //   focusableNodes: Array<HTMLElement>, // empty if none
    //   firstTabbableNode: HTMLElement|null,
    //   lastTabbableNode: HTMLElement|null,
    //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
    // }>}
    containerGroups: [],
    // same order/length as `containers` list
    // references to objects in `containerGroups`, but only those that actually have
    //  tabbable nodes in them
    // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
    //  the same length
    tabbableGroups: [],
    nodeFocusedBeforeActivation: null,
    mostRecentlyFocusedNode: null,
    active: !1,
    paused: !1,
    // timer ID for when delayInitialFocus is true and initial focus in this trap
    //  has been delayed during activation
    delayInitialFocusTimer: void 0
  }, o, a = function(je, E, P) {
    return je && je[E] !== void 0 ? je[E] : r[P || E];
  }, h = function(je) {
    return u.containerGroups.findIndex(function(E) {
      var P = E.container, K = E.tabbableNodes;
      return P.contains(je) || // fall back to explicit tabbable search which will take into consideration any
      //  web components if the `tabbableOptions.getShadowRoot` option was used for
      //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
      //  look inside web components even if open)
      K.find(function(H) {
        return H === je;
      });
    });
  }, s = function(je) {
    var E = r[je];
    if (typeof E == "function") {
      for (var P = arguments.length, K = new Array(P > 1 ? P - 1 : 0), H = 1; H < P; H++)
        K[H - 1] = arguments[H];
      E = E.apply(void 0, K);
    }
    if (E === !0 && (E = void 0), !E) {
      if (E === void 0 || E === !1)
        return E;
      throw new Error("`".concat(je, "` was specified but was not a node, or did not return a node"));
    }
    var U = E;
    if (typeof E == "string" && (U = l.querySelector(E), !U))
      throw new Error("`".concat(je, "` as selector refers to no known node"));
    return U;
  }, d = function() {
    var je = s("initialFocus");
    if (je === !1)
      return !1;
    if (je === void 0)
      if (h(l.activeElement) >= 0)
        je = l.activeElement;
      else {
        var E = u.tabbableGroups[0], P = E && E.firstTabbableNode;
        je = P || s("fallbackFocus");
      }
    if (!je)
      throw new Error("Your focus-trap needs to have at least one focusable element");
    return je;
  }, p = function() {
    if (u.containerGroups = u.containers.map(function(je) {
      var E = WAe(je, r.tabbableOptions), P = HAe(je, r.tabbableOptions);
      return {
        container: je,
        tabbableNodes: E,
        focusableNodes: P,
        firstTabbableNode: E.length > 0 ? E[0] : null,
        lastTabbableNode: E.length > 0 ? E[E.length - 1] : null,
        /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */
        nextTabbableNode: function(H) {
          var U = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0, Me = P.findIndex(function(le) {
            return le === H;
          });
          if (!(Me < 0))
            return U ? P.slice(Me + 1).find(function(le) {
              return zS(le, r.tabbableOptions);
            }) : P.slice(0, Me).reverse().find(function(le) {
              return zS(le, r.tabbableOptions);
            });
        }
      };
    }), u.tabbableGroups = u.containerGroups.filter(function(je) {
      return je.tabbableNodes.length > 0;
    }), u.tabbableGroups.length <= 0 && !s("fallbackFocus"))
      throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
  }, _ = function $e(je) {
    if (je !== !1 && je !== l.activeElement) {
      if (!je || !je.focus) {
        $e(d());
        return;
      }
      je.focus({
        preventScroll: !!r.preventScroll
      }), u.mostRecentlyFocusedNode = je, GAe(je) && je.select();
    }
  }, R = function(je) {
    var E = s("setReturnFocus", je);
    return E || (E === !1 ? !1 : je);
  }, F = function(je) {
    var E = KS(je);
    if (!(h(E) >= 0)) {
      if (y_(r.clickOutsideDeactivates, je)) {
        o.deactivate({
          // if, on deactivation, we should return focus to the node originally-focused
          //  when the trap was activated (or the configured `setReturnFocus` node),
          //  then assume it's also OK to return focus to the outside node that was
          //  just clicked, causing deactivation, as long as that node is focusable;
          //  if it isn't focusable, then return focus to the original node focused
          //  on activation (or the configured `setReturnFocus` node)
          // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
          //  which will result in the outside click setting focus to the node
          //  that was clicked, whether it's focusable or not; by setting
          //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
          //  on activation (or the configured `setReturnFocus` node)
          returnFocus: r.returnFocusOnDeactivate && !ID(E, r.tabbableOptions)
        });
        return;
      }
      y_(r.allowOutsideClick, je) || je.preventDefault();
    }
  }, L = function(je) {
    var E = KS(je), P = h(E) >= 0;
    P || E instanceof Document ? P && (u.mostRecentlyFocusedNode = E) : (je.stopImmediatePropagation(), _(u.mostRecentlyFocusedNode || d()));
  }, G = function(je) {
    var E = KS(je);
    p();
    var P = null;
    if (u.tabbableGroups.length > 0) {
      var K = h(E), H = K >= 0 ? u.containerGroups[K] : void 0;
      if (K < 0)
        je.shiftKey ? P = u.tabbableGroups[u.tabbableGroups.length - 1].lastTabbableNode : P = u.tabbableGroups[0].firstTabbableNode;
      else if (je.shiftKey) {
        var U = cz(u.tabbableGroups, function(q) {
          var me = q.firstTabbableNode;
          return E === me;
        });
        if (U < 0 && (H.container === E || ID(E, r.tabbableOptions) && !zS(E, r.tabbableOptions) && !H.nextTabbableNode(E, !1)) && (U = K), U >= 0) {
          var Me = U === 0 ? u.tabbableGroups.length - 1 : U - 1, le = u.tabbableGroups[Me];
          P = le.lastTabbableNode;
        }
      } else {
        var Ce = cz(u.tabbableGroups, function(q) {
          var me = q.lastTabbableNode;
          return E === me;
        });
        if (Ce < 0 && (H.container === E || ID(E, r.tabbableOptions) && !zS(E, r.tabbableOptions) && !H.nextTabbableNode(E)) && (Ce = K), Ce >= 0) {
          var Ye = Ce === u.tabbableGroups.length - 1 ? 0 : Ce + 1, B = u.tabbableGroups[Ye];
          P = B.firstTabbableNode;
        }
      }
    } else
      P = s("fallbackFocus");
    P && (je.preventDefault(), _(P));
  }, J = function(je) {
    if (ZAe(je) && y_(r.escapeDeactivates, je) !== !1) {
      je.preventDefault(), o.deactivate();
      return;
    }
    if (XAe(je)) {
      G(je);
      return;
    }
  }, we = function(je) {
    var E = KS(je);
    h(E) >= 0 || y_(r.clickOutsideDeactivates, je) || y_(r.allowOutsideClick, je) || (je.preventDefault(), je.stopImmediatePropagation());
  }, ce = function() {
    if (u.active)
      return oz.activateTrap(o), u.delayInitialFocusTimer = r.delayInitialFocus ? az(function() {
        _(d());
      }) : _(d()), l.addEventListener("focusin", L, !0), l.addEventListener("mousedown", F, {
        capture: !0,
        passive: !1
      }), l.addEventListener("touchstart", F, {
        capture: !0,
        passive: !1
      }), l.addEventListener("click", we, {
        capture: !0,
        passive: !1
      }), l.addEventListener("keydown", J, {
        capture: !0,
        passive: !1
      }), o;
  }, xe = function() {
    if (u.active)
      return l.removeEventListener("focusin", L, !0), l.removeEventListener("mousedown", F, !0), l.removeEventListener("touchstart", F, !0), l.removeEventListener("click", we, !0), l.removeEventListener("keydown", J, !0), o;
  };
  return o = {
    get active() {
      return u.active;
    },
    get paused() {
      return u.paused;
    },
    activate: function(je) {
      if (u.active)
        return this;
      var E = a(je, "onActivate"), P = a(je, "onPostActivate"), K = a(je, "checkCanFocusTrap");
      K || p(), u.active = !0, u.paused = !1, u.nodeFocusedBeforeActivation = l.activeElement, E && E();
      var H = function() {
        K && p(), ce(), P && P();
      };
      return K ? (K(u.containers.concat()).then(H, H), this) : (H(), this);
    },
    deactivate: function(je) {
      if (!u.active)
        return this;
      var E = sz({
        onDeactivate: r.onDeactivate,
        onPostDeactivate: r.onPostDeactivate,
        checkCanReturnFocus: r.checkCanReturnFocus
      }, je);
      clearTimeout(u.delayInitialFocusTimer), u.delayInitialFocusTimer = void 0, xe(), u.active = !1, u.paused = !1, oz.deactivateTrap(o);
      var P = a(E, "onDeactivate"), K = a(E, "onPostDeactivate"), H = a(E, "checkCanReturnFocus"), U = a(E, "returnFocus", "returnFocusOnDeactivate");
      P && P();
      var Me = function() {
        az(function() {
          U && _(R(u.nodeFocusedBeforeActivation)), K && K();
        });
      };
      return U && H ? (H(R(u.nodeFocusedBeforeActivation)).then(Me, Me), this) : (Me(), this);
    },
    pause: function() {
      return u.paused || !u.active ? this : (u.paused = !0, xe(), this);
    },
    unpause: function() {
      return !u.paused || !u.active ? this : (u.paused = !1, p(), ce(), this);
    },
    updateContainerElements: function(je) {
      var E = [].concat(je).filter(Boolean);
      return u.containers = E.map(function(P) {
        return typeof P == "string" ? l.querySelector(P) : P;
      }), u.active && p(), this;
    }
  }, o.updateContainerElements(n), o;
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function JAe(e, n) {
  var t = {};
  for (var l in e) Object.prototype.hasOwnProperty.call(e, l) && n.indexOf(l) < 0 && (t[l] = e[l]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, l = Object.getOwnPropertySymbols(e); r < l.length; r++)
      n.indexOf(l[r]) < 0 && Object.prototype.propertyIsEnumerable.call(e, l[r]) && (t[l[r]] = e[l[r]]);
  return t;
}
function e6e(e) {
  var n, t;
  const l = Zr(e);
  return (t = (n = l) === null || n === void 0 ? void 0 : n.$el) !== null && t !== void 0 ? t : l;
}
var hz;
(function(e) {
  e.UP = "UP", e.RIGHT = "RIGHT", e.DOWN = "DOWN", e.LEFT = "LEFT", e.NONE = "NONE";
})(hz || (hz = {}));
function Ute(e, n = {}) {
  let t;
  const { immediate: l } = n, r = JAe(n, ["immediate"]), u = dt(!1), o = dt(!1), a = (p) => t && t.activate(p), h = (p) => t && t.deactivate(p), s = () => {
    t && (t.pause(), o.value = !0);
  }, d = () => {
    t && (t.unpause(), o.value = !1);
  };
  return di(() => e6e(e), (p) => {
    t = QAe(p, Object.assign(Object.assign({}, r), {
      onActivate() {
        u.value = !0, n.onActivate && n.onActivate();
      },
      onDeactivate() {
        u.value = !1, n.onDeactivate && n.onDeactivate();
      }
    })), l && a();
  }, { flush: "post" }), NAe(() => h()), {
    hasFocus: u,
    isPaused: o,
    activate: a,
    deactivate: h,
    pause: s,
    unpause: d
  };
}
const n6e = cl({
  name: "lp-drawer",
  props: {
    modelValue: { type: Boolean, default: !1 },
    width: { type: String, default: "500px" },
    closableMask: { type: Boolean, default: !0 },
    hideMask: Boolean,
    placement: {
      type: String,
      default: sl.R,
      validator: (e) => [sl.L, sl.R].includes(e)
    }
  },
  setup(e, { emit: n }) {
    let { modelValue: t } = w3(e);
    const l = v4(), r = dt(), u = dt(), { activate: o, deactivate: a } = Ute(u);
    di(
      () => t.value,
      async (p) => {
        const _ = l.appContext.config.globalProperties.$LpComponents.drawers;
        p ? (_.push(r.value), _.slice(0, _.indexOf(r.value)).forEach((R) => {
          if (R.style.transform !== "") {
            const F = R.style.transform.match(/[-+]?[0-9]*\.?[0-9]+/g)?.map((L) => parseFloat(L));
            R.style.transform = `scale(${F[0] - 0.05}) translateX(${F[1] - (e.placement === sl.R ? 10 : -10)}%)`;
          } else
            R.style.transform = `scale(0.9) translateX(${e.placement === sl.R ? -15 : 15}%)`;
        }), await Ta(), e.hideMask || (Mte(u.value, { reserveScrollBarGap: !0 }), o())) : (_.splice(_.indexOf(r.value), 1), _.forEach((R, F) => {
          if (F === _.length - 1) {
            R.style.transform = "";
            return;
          }
          const L = R.style.transform.match(/[-+]?[0-9]*\.?[0-9]+/g)?.map((G) => parseFloat(G));
          R.style.transform = `scale(${L[0] + 0.05}) translateX(${L[1] + (e.placement === sl.R ? 10 : -10)}%)`;
        }), r.value.style.transform = "", e.hideMask || (Pte(u.value), a()));
      }
    );
    function h() {
      e.closableMask && s();
    }
    function s() {
      n("update:modelValue", !1);
    }
    const d = _t(() => e.placement === sl.R ? sl.L : sl.R);
    return {
      maskClick: h,
      transitionSide: d,
      drawerRef: r,
      focusRef: u
    };
  }
}), t6e = {
  class: "lp-drawer",
  ref: "focusRef"
};
function l6e(e, n, t, l, r, u) {
  return Qe(), _l(v3, { to: "body" }, [
    qn("div", t6e, [
      dl(du, { name: "fade" }, {
        default: kl(() => [
          pi(qn("div", {
            class: "lp-drawer-mask",
            tabindex: "0",
            style: Hi({ cursor: e.closableMask ? "pointer" : "default" }),
            onClick: n[0] || (n[0] = Oi((...o) => e.maskClick && e.maskClick(...o), ["self"]))
          }, null, 4), [
            [Pi, e.modelValue && !e.hideMask]
          ])
        ]),
        _: 1
      }),
      dl(du, {
        name: `drop-${e.transitionSide}`
      }, {
        default: kl(() => [
          pi(qn("div", {
            ref: "drawerRef",
            style: Hi({ width: e.width }),
            class: xt(["lp-drawer-body", `lp-drawer-body-${e.placement}`])
          }, [
            el(e.$slots, "default")
          ], 6), [
            [Pi, e.modelValue]
          ])
        ]),
        _: 3
      }, 8, ["name"])
    ], 512)
  ]);
}
const KE = /* @__PURE__ */ Cr(n6e, [["render", l6e]]);
KE.install = (e) => {
  e.component(KE.name, KE);
};
const r6e = cl({
  name: "lp-dropdown",
  directives: {
    clickoutside: S4
  },
  props: {
    placement: {
      default: sl.BL,
      type: String,
      validator: (e) => [
        sl.B,
        sl.BL,
        sl.BR,
        sl.L,
        sl.LT,
        sl.LB,
        sl.R,
        sl.RT,
        sl.RB,
        sl.T,
        sl.TL,
        sl.TR
      ].includes(e)
    },
    clickable: Boolean,
    permanent: Boolean,
    disabled: Boolean
    // autoposition: { type: Boolean, default: true },
  },
  setup(e) {
    const n = dt(null), t = dt(null), {
      show: l,
      placement: r,
      permanent: u,
      disabled: o,
      handleMouseEnter: a,
      handleMouseLeave: h,
      hidePopover: s,
      showPopover: d
    } = l2({
      ...e,
      popover: n,
      trigger: t,
      arrowCalculation: !1,
      disableSetPosition: !1,
      isDropdown: !0,
      allowedMouseOverTransitionElements: [
        ".lp-dropdown",
        ".lp-tooltip-popper"
      ]
    });
    vs("show", l);
    function p(G, J = !1) {
      o.value || (l.value ? s(G, J) : d());
    }
    vs("toggleDropdown", p);
    const _ = _t(() => `drop-${r.value}`), R = _t(() => r.value?.split("-")[0]), F = _t(() => e.clickable ? e.permanent ? {} : { click: p } : {
      mouseenter: a,
      mouseleave: h
    }), L = _t(() => e.permanent ? {
      click: p
    } : {});
    return vs("listenersGlobal", F), {
      toggleDropdown: p,
      transition: _,
      placementSide: R,
      listenersGlobal: F,
      listenersTrigger: L,
      show: l,
      hidePopover: s,
      placement: r,
      popover: n,
      trigger: t,
      showPopover: d,
      handleMouseEnter: a,
      handleMouseLeave: h
    };
  }
});
function i6e(e, n, t, l, r, u) {
  const o = w4("clickoutside");
  return pi((Qe(), yn("div", Ni({
    class: "lp-dropdown",
    "data-ua-unique-id": "unique-dropdown"
  }, AO(e.listenersGlobal, !0)), [
    qn("div", Ni({
      ref: "trigger",
      class: "lp-dropdown-trigger"
    }, AO(e.listenersTrigger, !0)), [
      el(e.$slots, "default")
    ], 16),
    (Qe(), _l(v3, { to: "body" }, [
      dl(du, { name: e.transition }, {
        default: kl(() => [
          pi(qn("div", {
            ref: "popover",
            class: xt(["lp-dropdown-slot", [e.placement && `lp-dropdown-slot-${e.placementSide}`]]),
            onToggleDropdown: n[0] || (n[0] = Oi((...a) => e.toggleDropdown && e.toggleDropdown(...a), ["stop"]))
          }, [
            el(e.$slots, "menu")
          ], 34), [
            [Pi, e.show]
          ])
        ]),
        _: 3
      }, 8, ["name"])
    ]))
  ], 16)), [
    [o, e.hidePopover]
  ]);
}
const u6e = /* @__PURE__ */ Cr(r6e, [["render", i6e]]), s6e = cl({
  name: "lp-dropdown-menu"
}), o6e = /* @__PURE__ */ cl({
  ...s6e,
  setup(e) {
    const n = _s("show", !1), t = _s("listenersGlobal", {}), l = dt(null), r = p1({
      value: 0
    }), u = () => {
      l.value.scrollTop;
    };
    vs("scrollOffset", r.value);
    const o = _t(() => ({
      display: n ? "block" : "none"
    }));
    return (a, h) => (Qe(), yn("ul", Ni({
      ref_key: "menu",
      ref: l,
      class: "menu-pop-up links-dark links-hover-blue",
      style: o.value,
      onScroll: u
    }, AO(Zr(t), !0)), [
      el(a.$slots, "default")
    ], 16));
  }
}), a6e = cl({
  name: "lp-dropdown-item",
  props: {
    disabled: Boolean,
    divided: Boolean,
    icon: { type: String, default: null }
  },
  emits: ["toggle-dropdown"],
  setup(e, { emit: n }) {
    const t = _t(() => e.disabled ? {} : {
      click: r
    }), l = _s(
      "toggleDropdown",
      () => {
      }
    ), r = (u) => {
      u.stopPropagation(), n("toggle-dropdown"), l && typeof l == "function" && l(u, !0);
    };
    return {
      toggleDropdown: r,
      listeners: t
    };
  }
}), c6e = { class: "lp-dropdown-text" };
function h6e(e, n, t, l, r, u) {
  const o = El("lp-icon");
  return Qe(), yn("li", Ni({
    class: ["lp-dropdown-item ly-spacebetween-center", [
      e.disabled && "lp-dropdown-item-disabled",
      e.divided && "lp-dropdown-item-divided"
    ]]
  }, AO(e.listeners, !0)), [
    qn("a", null, [
      e.icon ? (Qe(), _l(o, {
        key: 0,
        name: e.icon
      }, null, 8, ["name"])) : st("", !0),
      qn("span", c6e, [
        el(e.$slots, "default")
      ])
    ]),
    el(e.$slots, "submenu")
  ], 16);
}
const f6e = /* @__PURE__ */ Cr(a6e, [["render", h6e]]), GE = {
  Dropdown: u6e,
  DropdownMenu: o6e,
  DropdownItem: f6e
};
for (const e in GE)
  if (GE.hasOwnProperty(e)) {
    const n = GE[e];
    n.install = (t) => {
      t.component(n.name, n);
    };
  }
const d6e = () => typeof window < "u" ? window : global, um = () => {
  const e = d6e();
  return e && e.tinymce ? e.tinymce : null;
}, p6e = [
  "onActivate",
  "onAddUndo",
  "onBeforeAddUndo",
  "onBeforeExecCommand",
  "onBeforeGetContent",
  "onBeforeRenderUI",
  "onBeforeSetContent",
  "onBeforePaste",
  "onBlur",
  "onChange",
  "onClearUndos",
  "onClick",
  "onContextMenu",
  "onCopy",
  "onCut",
  "onDblclick",
  "onDeactivate",
  "onDirty",
  "onDrag",
  "onDragDrop",
  "onDragEnd",
  "onDragGesture",
  "onDragOver",
  "onDrop",
  "onExecCommand",
  "onFocus",
  "onFocusIn",
  "onFocusOut",
  "onGetContent",
  "onHide",
  "onInit",
  "onKeyDown",
  "onKeyPress",
  "onKeyUp",
  "onLoadContent",
  "onMouseDown",
  "onMouseEnter",
  "onMouseLeave",
  "onMouseMove",
  "onMouseOut",
  "onMouseOver",
  "onMouseUp",
  "onNodeChange",
  "onObjectResizeStart",
  "onObjectResized",
  "onObjectSelected",
  "onPaste",
  "onPostProcess",
  "onPostRender",
  "onPreProcess",
  "onProgressState",
  "onRedo",
  "onRemove",
  "onReset",
  "onSaveContent",
  "onSelectionChange",
  "onSetAttrib",
  "onSetContent",
  "onShow",
  "onSubmit",
  "onUndo",
  "onVisualAid"
], m6e = (e) => p6e.map((n) => n.toLowerCase()).indexOf(e.toLowerCase()) !== -1, g6e = (e, n, t) => {
  Object.keys(n).filter(m6e).forEach((l) => {
    const r = n[l];
    typeof r == "function" && (l === "onInit" ? r(e, t) : t.on(
      l.substring(2),
      (u) => r(u, t)
    ));
  });
}, w6e = (e, n, t, l) => {
  const r = e.modelEvents ? e.modelEvents : null, u = Array.isArray(r) ? r.join(" ") : r;
  di(l, (o, a) => {
    t && typeof o == "string" && o !== a && o !== t.getContent({ format: e.outputFormat }) && t.setContent(o);
  }), t.on(
    u || "change input undo redo",
    () => {
      n.emit(
        "update:modelValue",
        t.getContent({ format: e.outputFormat })
      );
    }
  );
}, v6e = (e, n, t, l, r, u) => {
  l.setContent(u()), t.attrs["onUpdate:modelValue"] && w6e(n, t, l, r), g6e(e, t.attrs, l);
}, y6e = (e) => e !== null && e.tagName.toLowerCase() === "textarea", fz = (e) => typeof e > "u" || e === "" ? [] : Array.isArray(e) ? e : e.split(" "), _6e = (e, n) => fz(e).concat(fz(n)), x6e = {
  apiKey: String,
  cloudChannel: String,
  id: String,
  init: Object,
  initialValue: String,
  inline: Boolean,
  modelEvents: [String, Array],
  plugins: [String, Array],
  tagName: String,
  toolbar: [String, Array],
  modelValue: String,
  disabled: Boolean,
  tinymceScriptSrc: String,
  outputFormat: {
    type: String,
    validator: (e) => e === "html" || e === "text"
  },
  message: String,
  status: String,
  label: String,
  required: Boolean,
  preview: Boolean,
  previewAsHTML: Boolean,
  dataUaUniqueId: {
    type: String,
    default: "unique-editor"
  }
}, S6e = (e, n, t, l) => e(l || "div", {
  id: n,
  ref: t
}), E6e = (e, n, t, l) => l.preview ? e(l.previewAsHTML ? "div" : "textarea", {
  id: n,
  ref: t,
  style: l.previewAsHTML ? {
    display: "block"
  } : {},
  "data-ua-unique-id": l.dataUaUniqueId || "unique-editor"
}) : e("textarea", {
  id: n,
  visibility: "hidden",
  ref: t,
  "data-ua-unique-id": "unique-editor"
}), O6e = {
  font_formats: "Andale Mono=andale mono,times;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;Comic Sans MS=comic sans ms,sans-serif;Courier New=courier new,courier;Georgia=georgia,palatino;Helvetica=helvetica;Impact=impact,chicago;Tahoma=tahoma,arial,helvetica,sans-serif;Terminal=terminal,monaco;Times New Roman=times new roman,times;Trebuchet MS=trebuchet ms,geneva;Verdana=verdana,geneva;",
  menubar: "tools table format view insert edit",
  height: 400,
  plugins: [
    "advlist",
    "autolink",
    "lists",
    "link",
    "image",
    "charmap",
    "preview",
    // 'hr',
    "anchor",
    "pagebreak",
    "searchreplace",
    "wordcount",
    "visualblocks",
    "visualchars",
    "code",
    "fullscreen",
    "insertdatetime",
    "media",
    "nonbreaking",
    "save",
    "table",
    // 'contextmenu',
    "directionality",
    "emoticons"
    // 'template',
    // 'paste',
    // 'textcolor',
  ],
  external_image_plugin: !0,
  toolbar1: "styles fontfamily fontsize | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent",
  toolbar2: "undo redo | preview image | forecolor backcolor | code fullscreen",
  image_advtab: !0,
  invalid_elements: "iframe, script, object, style",
  entity_encoding: "raw"
}, ZE = cl({
  name: "lp-editor",
  props: x6e,
  setup: (e, n) => {
    let t = e.init ? { ...e.init } : { ...O6e };
    const { disabled: l, modelValue: r, tagName: u, preview: o } = w3(e), a = dt(null);
    let h = null;
    const s = e.id || fm("tiny-vue"), d = e.init && e.init.inline || e.inline, p = !!n.attrs["onUpdate:modelValue"];
    let _ = !0;
    const R = e.initialValue ? e.initialValue : "";
    let F = "";
    const L = (ce) => p ? () => r?.value ? r.value : "" : () => ce ? R : F, G = async () => {
      if (e.preview) {
        e.previewAsHTML ? a.value.innerHTML = e.modelValue : a.value.value = e.modelValue;
        return;
      }
      const ce = L(_), xe = await Promise.resolve({                }), $e = await Promise.resolve({                       }), je = {
        ...t,
        readonly: e.disabled,
        selector: `#${s}`,
        plugins: _6e(t.plugins, e.plugins),
        toolbar: e.toolbar || t.toolbar,
        inline: d,
        // base_url: '/node_modules/tinymce/',
        content_style: `${xe.default} ${$e.default}`,
        content_css: !1,
        // skin_url: skinStyles.default.replace('/content.inline.min.css', ''),
        promotion: !1,
        branding: !1,
        setup: (E) => {
          h = E, E.on(
            "init",
            (P) => v6e(P, e, n, E, r, ce)
          ), typeof t.setup == "function" && t.setup(E);
        }
      };
      y6e(a.value) && (a.value.style.visibility = ""), um().init(je), _ = !1;
    };
    di(l, (ce) => {
      h !== null && (typeof h.mode?.set == "function" ? h.mode.set(ce ? "readonly" : "design") : "setMode" in h && typeof h.setMode == "function" && h.setMode(ce ? "readonly" : "design"));
    }), di(u, () => {
      !p && h && (F = h.getContent()), um()?.remove(h), Ta(() => G());
    });
    async function J() {
      await import("./tinymce-CyuBFJzD.js").then((ce) => ce.t), await import("./icons.min-BKMvl2be.js"), await import("./theme.min-D6KqqcDj.js"), await import("./skin-Dq--oJJ6.js"), await import("./model.min-DPl5_zao.js"), await import("./index-DkRiR6Kf.js").then((ce) => ce.i), await import("./index-ytE5OiF6.js").then((ce) => ce.i), await import("./index-C0StYLSW.js").then((ce) => ce.i), await import("./index-CXcJVGfZ.js").then((ce) => ce.i), await import("./index-egxWaIta.js").then((ce) => ce.i), await import("./index-RfDE37FR.js").then((ce) => ce.i), await import("./index-CMr3Rl9k.js").then((ce) => ce.i), await import("./index-C98_vmu8.js").then((ce) => ce.i), await import("./index-CCymiCL2.js").then((ce) => ce.i), await import("./index-l4MJFNdP.js").then((ce) => ce.i), await import("./index-Cc_VqPGM.js").then((ce) => ce.i), await import("./index-HNiaKpsF.js").then((ce) => ce.i), await import("./index-VS5cCOUd.js").then((ce) => ce.i), await import("./index-DZhxohPx.js").then((ce) => ce.i), await import("./index-CZI3Y56_.js").then((ce) => ce.i), await import("./index-BB4w8DWe.js").then((ce) => ce.i), await import("./index-GYFSc1HY.js").then((ce) => ce.i), await import("./index-CItzuMJg.js").then((ce) => ce.i), await import("./index-CXg3dUmv.js").then((ce) => ce.i), await import("./index-CAs2o5da.js").then((ce) => ce.i), await import("./index-B8xCntGv.js").then((ce) => ce.i), await import("./emojis.min-DaiTyaVh.js"), await import("./index-CMi2rclf.js").then((ce) => ce.i), await import("./index-3UGTHs14.js").then((ce) => ce.i), await G();
    }
    cf(J), di(o, async () => {
      um() !== null && um().remove(h), J();
    }), moe(() => {
      um() !== null && um().remove(h);
    }), d || (goe(() => {
      _ || G();
    }), woe(() => {
      !p && h && (F = h.getContent()), um()?.remove(h);
    }));
    const we = (ce) => {
      h && (F = h.getContent(), um()?.remove(h), t = { ...t, ...ce }, Ta(() => G()));
    };
    return n.expose({
      rerender: we
    }), () => d ? S6e(sw, s, a, e.tagName) : [
      e.label ? sw(
        "p",
        {
          class: "lp-input-label lead",
          innerHTML: `${e.label}${e.required ? '<span class="text-blue">*</span>' : ""}`
        },
        []
      ) : null,
      E6e(sw, s, a, e),
      e.message ? sw("p", {
        class: [
          "lp-input-message mt-half d-flex",
          e.status ? `lp-input-message-${e.status}` : "lp-input-message-danger",
          e.disabled && "lp-input-message-disabled"
        ],
        innerText: e.message
      }) : null
    ];
  }
});
ZE.install = (e) => {
  e.component(ZE.name, ZE);
};
const k6e = {
  name: "lp-email-input",
  inheritAttrs: !1
}, XE = /* @__PURE__ */ cl({
  ...k6e,
  props: {
    modelValue: { default: null },
    message: { default: null },
    preview: { type: [Boolean, null], default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, l = e, r = dt(l.modelValue), u = _t(() => {
      const a = new RegExp(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      return r.value === "" || r.value === null ? !0 : !!a.test(r.value);
    }), o = () => {
      t("update:modelValue", r.value);
    };
    return di(
      () => l.modelValue,
      (a) => {
        r.value = a;
      },
      { immediate: !0 }
    ), (a, h) => {
      const s = El("lp-input");
      return Qe(), _l(s, Ni(a.$attrs, {
        modelValue: r.value,
        "onUpdate:modelValue": h[0] || (h[0] = (d) => r.value = d),
        status: u.value ? "neutral" : "danger",
        message: a.message || (u.value ? "" : "Email address is invalid"),
        preview: a.preview,
        onKeyup: o
      }), null, 16, ["modelValue", "status", "message", "preview"]);
    };
  }
});
XE.install = (e) => {
  e.component(XE.name, XE);
};
const b6e = ["data-ua-unique-id"], T6e = { class: "lp-card-wrapper" }, j6e = { class: "lp-card-wrapper" }, QE = /* @__PURE__ */ cl({
  name: "lp-flip-card",
  __name: "LpFlipCard",
  props: {
    width: { default: "100" },
    sameHeight: { type: Boolean, default: !0 },
    dataUaUniqueId: { default: "unique-flip-card" }
  },
  emits: ["on-flip"],
  setup(e, { emit: n }) {
    const t = n, l = dt(
      "front"
      /* FRONT */
    ), r = dt(null);
    function u() {
      return l.value === "front" ? "back" : "front";
    }
    function o() {
      l.value = u(), t("on-flip", l.value);
    }
    vs("onFlip", o);
    const a = _t(() => {
      if (r.value) {
        const h = r.value.querySelector(
          l.value === "front" ? ".lp-front-card" : ".lp-back-card"
        );
        if (h) {
          const { height: s } = h.getBoundingClientRect();
          return {
            height: `${s}px`
          };
        }
      }
      return {
        height: 0
      };
    });
    return (h, s) => (Qe(), yn("div", Ni({
      ref_key: "container",
      ref: r,
      class: ["lp-flip-card", [
        l.value === "back" && "flipped",
        `w-${h.width}`,
        h.sameHeight && "same-height"
      ]],
      style: a.value,
      "data-ua-unique-id": h.dataUaUniqueId
    }, h.$attrs), [
      qn("div", T6e, [
        el(h.$slots, "front-card")
      ]),
      qn("div", j6e, [
        el(h.$slots, "back-card")
      ])
    ], 16, b6e));
  }
});
QE.install = (e) => {
  e.component(QE.name, QE);
};
const JE = /* @__PURE__ */ cl({
  name: "lp-grid",
  __name: "LpGrid",
  props: /* @__PURE__ */ xz({
    alignH: {},
    alignV: {},
    alignment: {},
    bg: {},
    border: { type: Boolean },
    borderBottom: { type: Boolean },
    borderColor: {},
    borderLeft: { type: Boolean },
    borderRight: { type: Boolean },
    borderTop: { type: Boolean },
    col: {},
    color: {},
    container: { type: Boolean },
    direction: {},
    even: { type: Boolean },
    evenItems: {},
    flex: { type: Boolean },
    gap: {},
    grid: { type: Boolean },
    grow: { type: Boolean },
    lg: {},
    margin: {},
    marginBottom: { type: Boolean },
    marginLeft: { type: Boolean },
    marginRight: { type: Boolean },
    marginTop: { type: Boolean },
    md: {},
    noGap: { type: Boolean },
    padding: {},
    paddingBottom: { type: Boolean },
    paddingLeft: { type: Boolean },
    paddingRight: { type: Boolean },
    paddingTop: { type: Boolean },
    rounded: { type: Boolean },
    roundedFull: { type: Boolean },
    roundedLg: { type: Boolean },
    roundedSm: { type: Boolean },
    shadow: { type: Boolean },
    shadowColor: {},
    shadowLg: { type: Boolean },
    shrink: { type: Boolean },
    sm: {},
    width: {},
    wrap: { type: Boolean },
    xl: {}
  }, Zz),
  emits: ["update:modelValue"],
  setup(e) {
    Ez((r) => ({
      "647a7993": l.value
    }));
    const n = e, { propClasses: t } = Xz(n), l = _t(() => `${n.gap}rem`);
    return (r, u) => (Qe(), yn("div", Ni(r.$attrs, {
      class: [Zr(t), "gap-size"]
    }), [
      el(r.$slots, "default")
    ], 16));
  }
});
JE.install = (e) => {
  e.component(JE.name, JE);
};
var m4 = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
m4.exports;
(function(e, n) {
  (function() {
    var t, l = "4.17.21", r = 200, u = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", o = "Expected a function", a = "Invalid `variable` option passed into `_.template`", h = "__lodash_hash_undefined__", s = 500, d = "__lodash_placeholder__", p = 1, _ = 2, R = 4, F = 1, L = 2, G = 1, J = 2, we = 4, ce = 8, xe = 16, $e = 32, je = 64, E = 128, P = 256, K = 512, H = 30, U = "...", Me = 800, le = 16, Ce = 1, Ye = 2, B = 3, q = 1 / 0, me = 9007199254740991, Ae = 17976931348623157e292, Fe = NaN, ln = 4294967295, Be = ln - 1, Ze = ln >>> 1, pn = [
      ["ary", E],
      ["bind", G],
      ["bindKey", J],
      ["curry", ce],
      ["curryRight", xe],
      ["flip", K],
      ["partial", $e],
      ["partialRight", je],
      ["rearg", P]
    ], xn = "[object Arguments]", Nn = "[object Array]", at = "[object AsyncFunction]", Yt = "[object Boolean]", jt = "[object Date]", Cl = "[object DOMException]", fn = "[object Error]", _e = "[object Function]", Ve = "[object GeneratorFunction]", an = "[object Map]", En = "[object Number]", Qn = "[object Null]", Vn = "[object Object]", ot = "[object Promise]", Nt = "[object Proxy]", zt = "[object RegExp]", Pt = "[object Set]", ol = "[object String]", St = "[object Symbol]", pr = "[object Undefined]", ul = "[object WeakMap]", Rr = "[object WeakSet]", ql = "[object ArrayBuffer]", Mr = "[object DataView]", wi = "[object Float32Array]", bl = "[object Float64Array]", tl = "[object Int8Array]", Zt = "[object Int16Array]", Ql = "[object Int32Array]", jl = "[object Uint8Array]", Sl = "[object Uint8ClampedArray]", gl = "[object Uint16Array]", jr = "[object Uint32Array]", Kt = /\b__p \+= '';/g, nl = /\b(__p \+=) '' \+/g, Pr = /(__e\(.*?\)|\b__t\)) \+\n'';/g, ii = /&(?:amp|lt|gt|quot|#39);/g, Ar = /[&<>"']/g, Ml = RegExp(ii.source), Rl = RegExp(Ar.source), Se = /<%-([\s\S]+?)%>/g, se = /<%([\s\S]+?)%>/g, Ee = /<%=([\s\S]+?)%>/g, Ge = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, vn = /^\w*$/, Kn = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, Un = /[\\^$.*+?()[\]{}|]/g, Pe = RegExp(Un.source), C = /^\s+/, re = /\s/, ge = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, Z = /\{\n\/\* \[wrapped with (.+)\] \*/, Y = /,? & /, oe = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, ke = /[()=,{}\[\]\/\s]/, De = /\\(\\)?/g, un = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, gn = /\w*$/, Tn = /^[-+]0x[0-9a-f]+$/i, ft = /^0b[01]+$/i, gt = /^\[object .+?Constructor\]$/, Gt = /^0o[0-7]+$/i, zl = /^(?:0|[1-9]\d*)$/, qe = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, ae = /($^)/, Ue = /['\n\r\u2028\u2029\\]/g, ze = "\\ud800-\\udfff", dn = "\\u0300-\\u036f", ut = "\\ufe20-\\ufe2f", Zn = "\\u20d0-\\u20ff", ht = dn + ut + Zn, ct = "\\u2700-\\u27bf", Hl = "a-z\\xdf-\\xf6\\xf8-\\xff", Pl = "\\xac\\xb1\\xd7\\xf7", Fn = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", br = "\\u2000-\\u206f", Wn = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", cs = "A-Z\\xc0-\\xd6\\xd8-\\xde", Ds = "\\ufe0e\\ufe0f", ac = Pl + Fn + br + Wn, Hs = "['’]", vu = "[" + ze + "]", Ji = "[" + ac + "]", hs = "[" + ht + "]", li = "\\d+", cc = "[" + ct + "]", eu = "[" + Hl + "]", $a = "[^" + ze + ac + li + ct + Hl + cs + "]", oa = "\\ud83c[\\udffb-\\udfff]", hc = "(?:" + hs + "|" + oa + ")", aa = "[^" + ze + "]", Eo = "(?:\\ud83c[\\udde6-\\uddff]){2}", be = "[\\ud800-\\udbff][\\udc00-\\udfff]", b = "[" + cs + "]", w = "\\u200d", i = "(?:" + eu + "|" + $a + ")", x = "(?:" + b + "|" + $a + ")", X = "(?:" + Hs + "(?:d|ll|m|re|s|t|ve))?", He = "(?:" + Hs + "(?:D|LL|M|RE|S|T|VE))?", $n = hc + "?", Xt = "[" + Ds + "]?", $l = "(?:" + w + "(?:" + [aa, Eo, be].join("|") + ")" + Xt + $n + ")*", Oe = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", Ke = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", mn = Xt + $n + $l, wn = "(?:" + [cc, Eo, be].join("|") + ")" + mn, On = "(?:" + [aa + hs + "?", hs, Eo, be, vu].join("|") + ")", An = RegExp(Hs, "g"), mt = RegExp(hs, "g"), Ot = RegExp(oa + "(?=" + oa + ")|" + On + mn, "g"), ll = RegExp([
      b + "?" + eu + "+" + X + "(?=" + [Ji, b, "$"].join("|") + ")",
      x + "+" + He + "(?=" + [Ji, b + i, "$"].join("|") + ")",
      b + "?" + i + "+" + X,
      b + "+" + He,
      Ke,
      Oe,
      li,
      wn
    ].join("|"), "g"), Nr = RegExp("[" + w + ze + ht + Ds + "]"), hi = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, Oo = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], yu = -1, $r = {};
    $r[wi] = $r[bl] = $r[tl] = $r[Zt] = $r[Ql] = $r[jl] = $r[Sl] = $r[gl] = $r[jr] = !0, $r[xn] = $r[Nn] = $r[ql] = $r[Yt] = $r[Mr] = $r[jt] = $r[fn] = $r[_e] = $r[an] = $r[En] = $r[Vn] = $r[zt] = $r[Pt] = $r[ol] = $r[ul] = !1;
    var ri = {};
    ri[xn] = ri[Nn] = ri[ql] = ri[Mr] = ri[Yt] = ri[jt] = ri[wi] = ri[bl] = ri[tl] = ri[Zt] = ri[Ql] = ri[an] = ri[En] = ri[Vn] = ri[zt] = ri[Pt] = ri[ol] = ri[St] = ri[jl] = ri[Sl] = ri[gl] = ri[jr] = !0, ri[fn] = ri[_e] = ri[ul] = !1;
    var bh = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, Tg = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, jg = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, Ag = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, sd = parseFloat, Dg = parseInt, gf = typeof zd == "object" && zd && zd.Object === Object && zd, I1 = typeof self == "object" && self && self.Object === Object && self, au = gf || I1 || Function("return this")(), _u = n && !n.nodeType && n, La = _u && !0 && e && !e.nodeType && e, Mp = La && La.exports === _u, Th = Mp && gf.process, fs = function() {
      try {
        var Hn = La && La.require && La.require("util").types;
        return Hn || Th && Th.binding && Th.binding("util");
      } catch {
      }
    }(), od = fs && fs.isArrayBuffer, Kc = fs && fs.isDate, Pp = fs && fs.isMap, jh = fs && fs.isRegExp, zs = fs && fs.isSet, Ah = fs && fs.isTypedArray;
    function Wu(Hn, vt, pt) {
      switch (pt.length) {
        case 0:
          return Hn.call(vt);
        case 1:
          return Hn.call(vt, pt[0]);
        case 2:
          return Hn.call(vt, pt[0], pt[1]);
        case 3:
          return Hn.call(vt, pt[0], pt[1], pt[2]);
      }
      return Hn.apply(vt, pt);
    }
    function Ig(Hn, vt, pt, Tl) {
      for (var yr = -1, vi = Hn == null ? 0 : Hn.length; ++yr < vi; ) {
        var Zi = Hn[yr];
        vt(Tl, Zi, pt(Zi), Hn);
      }
      return Tl;
    }
    function ko(Hn, vt) {
      for (var pt = -1, Tl = Hn == null ? 0 : Hn.length; ++pt < Tl && vt(Hn[pt], pt, Hn) !== !1; )
        ;
      return Hn;
    }
    function R1(Hn, vt) {
      for (var pt = Hn == null ? 0 : Hn.length; pt-- && vt(Hn[pt], pt, Hn) !== !1; )
        ;
      return Hn;
    }
    function ad(Hn, vt) {
      for (var pt = -1, Tl = Hn == null ? 0 : Hn.length; ++pt < Tl; )
        if (!vt(Hn[pt], pt, Hn))
          return !1;
      return !0;
    }
    function Hu(Hn, vt) {
      for (var pt = -1, Tl = Hn == null ? 0 : Hn.length, yr = 0, vi = []; ++pt < Tl; ) {
        var Zi = Hn[pt];
        vt(Zi, pt, Hn) && (vi[yr++] = Zi);
      }
      return vi;
    }
    function cd(Hn, vt) {
      var pt = Hn == null ? 0 : Hn.length;
      return !!pt && ds(Hn, vt, 0) > -1;
    }
    function bo(Hn, vt, pt) {
      for (var Tl = -1, yr = Hn == null ? 0 : Hn.length; ++Tl < yr; )
        if (pt(vt, Hn[Tl]))
          return !0;
      return !1;
    }
    function Kl(Hn, vt) {
      for (var pt = -1, Tl = Hn == null ? 0 : Hn.length, yr = Array(Tl); ++pt < Tl; )
        yr[pt] = vt(Hn[pt], pt, Hn);
      return yr;
    }
    function Ba(Hn, vt) {
      for (var pt = -1, Tl = vt.length, yr = Hn.length; ++pt < Tl; )
        Hn[yr + pt] = vt[pt];
      return Hn;
    }
    function hd(Hn, vt, pt, Tl) {
      var yr = -1, vi = Hn == null ? 0 : Hn.length;
      for (Tl && vi && (pt = Hn[++yr]); ++yr < vi; )
        pt = vt(pt, Hn[yr], yr, Hn);
      return pt;
    }
    function Rg(Hn, vt, pt, Tl) {
      var yr = Hn == null ? 0 : Hn.length;
      for (Tl && yr && (pt = Hn[--yr]); yr--; )
        pt = vt(pt, Hn[yr], yr, Hn);
      return pt;
    }
    function $p(Hn, vt) {
      for (var pt = -1, Tl = Hn == null ? 0 : Hn.length; ++pt < Tl; )
        if (vt(Hn[pt], pt, Hn))
          return !0;
      return !1;
    }
    var N1 = fd("length");
    function Lp(Hn) {
      return Hn.split("");
    }
    function Ng(Hn) {
      return Hn.match(oe) || [];
    }
    function Cg(Hn, vt, pt) {
      var Tl;
      return pt(Hn, function(yr, vi, Zi) {
        if (vt(yr, vi, Zi))
          return Tl = vi, !1;
      }), Tl;
    }
    function ro(Hn, vt, pt, Tl) {
      for (var yr = Hn.length, vi = pt + (Tl ? 1 : -1); Tl ? vi-- : ++vi < yr; )
        if (vt(Hn[vi], vi, Hn))
          return vi;
      return -1;
    }
    function ds(Hn, vt, pt) {
      return vt === vt ? V5(Hn, vt, pt) : ro(Hn, Pg, pt);
    }
    function Mg(Hn, vt, pt, Tl) {
      for (var yr = pt - 1, vi = Hn.length; ++yr < vi; )
        if (Tl(Hn[yr], vt))
          return yr;
      return -1;
    }
    function Pg(Hn) {
      return Hn !== Hn;
    }
    function Bp(Hn, vt) {
      var pt = Hn == null ? 0 : Hn.length;
      return pt ? md(Hn, vt) / pt : Fe;
    }
    function fd(Hn) {
      return function(vt) {
        return vt == null ? t : vt[Hn];
      };
    }
    function dd(Hn) {
      return function(vt) {
        return Hn == null ? t : Hn[vt];
      };
    }
    function pd(Hn, vt, pt, Tl, yr) {
      return yr(Hn, function(vi, Zi, yi) {
        pt = Tl ? (Tl = !1, vi) : vt(pt, vi, Zi, yi);
      }), pt;
    }
    function $g(Hn, vt) {
      var pt = Hn.length;
      for (Hn.sort(vt); pt--; )
        Hn[pt] = Hn[pt].value;
      return Hn;
    }
    function md(Hn, vt) {
      for (var pt, Tl = -1, yr = Hn.length; ++Tl < yr; ) {
        var vi = vt(Hn[Tl]);
        vi !== t && (pt = pt === t ? vi : pt + vi);
      }
      return pt;
    }
    function gd(Hn, vt) {
      for (var pt = -1, Tl = Array(Hn); ++pt < Hn; )
        Tl[pt] = vt(pt);
      return Tl;
    }
    function Lg(Hn, vt) {
      return Kl(vt, function(pt) {
        return [pt, Hn[pt]];
      });
    }
    function Fp(Hn) {
      return Hn && Hn.slice(0, U5(Hn) + 1).replace(C, "");
    }
    function Gi(Hn) {
      return function(vt) {
        return Hn(vt);
      };
    }
    function bi(Hn, vt) {
      return Kl(vt, function(pt) {
        return Hn[pt];
      });
    }
    function xu(Hn, vt) {
      return Hn.has(vt);
    }
    function Vp(Hn, vt) {
      for (var pt = -1, Tl = Hn.length; ++pt < Tl && ds(vt, Hn[pt], 0) > -1; )
        ;
      return pt;
    }
    function io(Hn, vt) {
      for (var pt = Hn.length; pt-- && ds(vt, Hn[pt], 0) > -1; )
        ;
      return pt;
    }
    function Ks(Hn, vt) {
      for (var pt = Hn.length, Tl = 0; pt--; )
        Hn[pt] === vt && ++Tl;
      return Tl;
    }
    var fj = dd(bh), L2 = dd(Tg);
    function dj(Hn) {
      return "\\" + Ag[Hn];
    }
    function B2(Hn, vt) {
      return Hn == null ? t : Hn[vt];
    }
    function Yp(Hn) {
      return Nr.test(Hn);
    }
    function B5(Hn) {
      return hi.test(Hn);
    }
    function C1(Hn) {
      for (var vt, pt = []; !(vt = Hn.next()).done; )
        pt.push(vt.value);
      return pt;
    }
    function M1(Hn) {
      var vt = -1, pt = Array(Hn.size);
      return Hn.forEach(function(Tl, yr) {
        pt[++vt] = [yr, Tl];
      }), pt;
    }
    function F5(Hn, vt) {
      return function(pt) {
        return Hn(vt(pt));
      };
    }
    function fc(Hn, vt) {
      for (var pt = -1, Tl = Hn.length, yr = 0, vi = []; ++pt < Tl; ) {
        var Zi = Hn[pt];
        (Zi === vt || Zi === d) && (Hn[pt] = d, vi[yr++] = pt);
      }
      return vi;
    }
    function Up(Hn) {
      var vt = -1, pt = Array(Hn.size);
      return Hn.forEach(function(Tl) {
        pt[++vt] = Tl;
      }), pt;
    }
    function F2(Hn) {
      var vt = -1, pt = Array(Hn.size);
      return Hn.forEach(function(Tl) {
        pt[++vt] = [Tl, Tl];
      }), pt;
    }
    function V5(Hn, vt, pt) {
      for (var Tl = pt - 1, yr = Hn.length; ++Tl < yr; )
        if (Hn[Tl] === vt)
          return Tl;
      return -1;
    }
    function Y5(Hn, vt, pt) {
      for (var Tl = pt + 1; Tl--; )
        if (Hn[Tl] === vt)
          return Tl;
      return Tl;
    }
    function wd(Hn) {
      return Yp(Hn) ? pj(Hn) : N1(Hn);
    }
    function dc(Hn) {
      return Yp(Hn) ? mj(Hn) : Lp(Hn);
    }
    function U5(Hn) {
      for (var vt = Hn.length; vt-- && re.test(Hn.charAt(vt)); )
        ;
      return vt;
    }
    var q5 = dd(jg);
    function pj(Hn) {
      for (var vt = Ot.lastIndex = 0; Ot.test(Hn); )
        ++vt;
      return vt;
    }
    function mj(Hn) {
      return Hn.match(Ot) || [];
    }
    function V2(Hn) {
      return Hn.match(ll) || [];
    }
    var gj = function Hn(vt) {
      vt = vt == null ? au : Hr.defaults(au.Object(), vt, Hr.pick(au, Oo));
      var pt = vt.Array, Tl = vt.Date, yr = vt.Error, vi = vt.Function, Zi = vt.Math, yi = vt.Object, Y2 = vt.RegExp, P1 = vt.String, ca = vt.TypeError, Gc = pt.prototype, wj = vi.prototype, qp = yi.prototype, Bg = vt["__core-js_shared__"], $1 = wj.toString, Ti = qp.hasOwnProperty, Fg = 0, W5 = function() {
        var f = /[^.]+$/.exec(Bg && Bg.keys && Bg.keys.IE_PROTO || "");
        return f ? "Symbol(src)_1." + f : "";
      }(), vd = qp.toString, U2 = $1.call(yi), vj = au._, yj = Y2(
        "^" + $1.call(Ti).replace(Un, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), Wp = Mp ? vt.Buffer : t, pc = vt.Symbol, Vg = vt.Uint8Array, H5 = Wp ? Wp.allocUnsafe : t, L1 = F5(yi.getPrototypeOf, yi), q2 = yi.create, z5 = qp.propertyIsEnumerable, B1 = Gc.splice, K5 = pc ? pc.isConcatSpreadable : t, Yg = pc ? pc.iterator : t, yd = pc ? pc.toStringTag : t, Ug = function() {
        try {
          var f = Qg(yi, "defineProperty");
          return f({}, "", {}), f;
        } catch {
        }
      }(), F1 = vt.clearTimeout !== au.clearTimeout && vt.clearTimeout, G5 = Tl && Tl.now !== au.Date.now && Tl.now, W2 = vt.setTimeout !== au.setTimeout && vt.setTimeout, V1 = Zi.ceil, Y1 = Zi.floor, qg = yi.getOwnPropertySymbols, Wg = Wp ? Wp.isBuffer : t, U1 = vt.isFinite, _j = Gc.join, xj = F5(yi.keys, yi), zu = Zi.max, uo = Zi.min, H2 = Tl.now, Z5 = vt.parseInt, Hg = Zi.random, z2 = Gc.reverse, mc = Qg(vt, "DataView"), Dh = Qg(vt, "Map"), K2 = Qg(vt, "Promise"), Zc = Qg(vt, "Set"), _d = Qg(vt, "WeakMap"), zg = Qg(yi, "create"), q1 = _d && new _d(), xd = {}, X5 = Jg(mc), Q5 = Jg(Dh), Hp = Jg(K2), G2 = Jg(Zc), Sj = Jg(_d), W1 = pc ? pc.prototype : t, Kg = W1 ? W1.valueOf : t, Z2 = W1 ? W1.toString : t;
      function Je(f) {
        if (Ku(f) && !Dr(f) && !(f instanceof c)) {
          if (f instanceof N)
            return f;
          if (Ti.call(f, "__wrapped__"))
            return TV(f);
        }
        return new N(f);
      }
      var zp = /* @__PURE__ */ function() {
        function f() {
        }
        return function(S) {
          if (!Cu(S))
            return {};
          if (q2)
            return q2(S);
          f.prototype = S;
          var V = new f();
          return f.prototype = t, V;
        };
      }();
      function H1() {
      }
      function N(f, S) {
        this.__wrapped__ = f, this.__actions__ = [], this.__chain__ = !!S, this.__index__ = 0, this.__values__ = t;
      }
      Je.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: Se,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: se,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Ee,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: Je
        }
      }, Je.prototype = H1.prototype, Je.prototype.constructor = Je, N.prototype = zp(H1.prototype), N.prototype.constructor = N;
      function c(f) {
        this.__wrapped__ = f, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = ln, this.__views__ = [];
      }
      function m() {
        var f = new c(this.__wrapped__);
        return f.__actions__ = Va(this.__actions__), f.__dir__ = this.__dir__, f.__filtered__ = this.__filtered__, f.__iteratees__ = Va(this.__iteratees__), f.__takeCount__ = this.__takeCount__, f.__views__ = Va(this.__views__), f;
      }
      function k() {
        if (this.__filtered__) {
          var f = new c(this);
          f.__dir__ = -1, f.__filtered__ = !0;
        } else
          f = this.clone(), f.__dir__ *= -1;
        return f;
      }
      function M() {
        var f = this.__wrapped__.value(), S = this.__dir__, V = Dr(f), fe = S < 0, We = V ? f.length : 0, rn = Ble(0, We, this.__views__), bn = rn.start, Mn = rn.end, Xn = Mn - bn, At = fe ? Mn : bn - 1, Rt = this.__iteratees__, qt = Rt.length, vl = 0, Fl = uo(Xn, this.__takeCount__);
        if (!V || !fe && We == Xn && Fl == Xn)
          return ZF(f, this.__actions__);
        var ar = [];
        e:
          for (; Xn-- && vl < Fl; ) {
            At += S;
            for (var Ur = -1, cr = f[At]; ++Ur < qt; ) {
              var ui = Rt[Ur], fi = ui.iteratee, vc = ui.type, pa = fi(cr);
              if (vc == Ye)
                cr = pa;
              else if (!pa) {
                if (vc == Ce)
                  continue e;
                break e;
              }
            }
            ar[vl++] = cr;
          }
        return ar;
      }
      c.prototype = zp(H1.prototype), c.prototype.constructor = c;
      function Q(f) {
        var S = -1, V = f == null ? 0 : f.length;
        for (this.clear(); ++S < V; ) {
          var fe = f[S];
          this.set(fe[0], fe[1]);
        }
      }
      function pe() {
        this.__data__ = zg ? zg(null) : {}, this.size = 0;
      }
      function Ie(f) {
        var S = this.has(f) && delete this.__data__[f];
        return this.size -= S ? 1 : 0, S;
      }
      function nn(f) {
        var S = this.__data__;
        if (zg) {
          var V = S[f];
          return V === h ? t : V;
        }
        return Ti.call(S, f) ? S[f] : t;
      }
      function Xe(f) {
        var S = this.__data__;
        return zg ? S[f] !== t : Ti.call(S, f);
      }
      function cn(f, S) {
        var V = this.__data__;
        return this.size += this.has(f) ? 0 : 1, V[f] = zg && S === t ? h : S, this;
      }
      Q.prototype.clear = pe, Q.prototype.delete = Ie, Q.prototype.get = nn, Q.prototype.has = Xe, Q.prototype.set = cn;
      function kn(f) {
        var S = -1, V = f == null ? 0 : f.length;
        for (this.clear(); ++S < V; ) {
          var fe = f[S];
          this.set(fe[0], fe[1]);
        }
      }
      function jn() {
        this.__data__ = [], this.size = 0;
      }
      function Pn(f) {
        var S = this.__data__, V = J5(S, f);
        if (V < 0)
          return !1;
        var fe = S.length - 1;
        return V == fe ? S.pop() : B1.call(S, V, 1), --this.size, !0;
      }
      function Ct(f) {
        var S = this.__data__, V = J5(S, f);
        return V < 0 ? t : S[V][1];
      }
      function Wt(f) {
        return J5(this.__data__, f) > -1;
      }
      function Mt(f, S) {
        var V = this.__data__, fe = J5(V, f);
        return fe < 0 ? (++this.size, V.push([f, S])) : V[fe][1] = S, this;
      }
      kn.prototype.clear = jn, kn.prototype.delete = Pn, kn.prototype.get = Ct, kn.prototype.has = Wt, kn.prototype.set = Mt;
      function wl(f) {
        var S = -1, V = f == null ? 0 : f.length;
        for (this.clear(); ++S < V; ) {
          var fe = f[S];
          this.set(fe[0], fe[1]);
        }
      }
      function rl() {
        this.size = 0, this.__data__ = {
          hash: new Q(),
          map: new (Dh || kn)(),
          string: new Q()
        };
      }
      function _i(f) {
        var S = hS(this, f).delete(f);
        return this.size -= S ? 1 : 0, S;
      }
      function Ci(f) {
        return hS(this, f).get(f);
      }
      function Is(f) {
        return hS(this, f).has(f);
      }
      function To(f, S) {
        var V = hS(this, f), fe = V.size;
        return V.set(f, S), this.size += V.size == fe ? 0 : 1, this;
      }
      wl.prototype.clear = rl, wl.prototype.delete = _i, wl.prototype.get = Ci, wl.prototype.has = Is, wl.prototype.set = To;
      function Ih(f) {
        var S = -1, V = f == null ? 0 : f.length;
        for (this.__data__ = new wl(); ++S < V; )
          this.add(f[S]);
      }
      function z1(f) {
        return this.__data__.set(f, h), this;
      }
      function K1(f) {
        return this.__data__.has(f);
      }
      Ih.prototype.add = Ih.prototype.push = z1, Ih.prototype.has = K1;
      function Vo(f) {
        var S = this.__data__ = new kn(f);
        this.size = S.size;
      }
      function ha() {
        this.__data__ = new kn(), this.size = 0;
      }
      function wf(f) {
        var S = this.__data__, V = S.delete(f);
        return this.size = S.size, V;
      }
      function Fa(f) {
        return this.__data__.get(f);
      }
      function Sd(f) {
        return this.__data__.has(f);
      }
      function Gg(f, S) {
        var V = this.__data__;
        if (V instanceof kn) {
          var fe = V.__data__;
          if (!Dh || fe.length < r - 1)
            return fe.push([f, S]), this.size = ++V.size, this;
          V = this.__data__ = new wl(fe);
        }
        return V.set(f, S), this.size = V.size, this;
      }
      Vo.prototype.clear = ha, Vo.prototype.delete = wf, Vo.prototype.get = Fa, Vo.prototype.has = Sd, Vo.prototype.set = Gg;
      function G1(f, S) {
        var V = Dr(f), fe = !V && ew(f), We = !V && !fe && Qp(f), rn = !V && !fe && !We && ev(f), bn = V || fe || We || rn, Mn = bn ? gd(f.length, P1) : [], Xn = Mn.length;
        for (var At in f)
          (S || Ti.call(f, At)) && !(bn && // Safari 9 has enumerable `arguments.length` in strict mode.
          (At == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          We && (At == "offset" || At == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          rn && (At == "buffer" || At == "byteLength" || At == "byteOffset") || // Skip index properties.
          bd(At, Xn))) && Mn.push(At);
        return Mn;
      }
      function Z1(f) {
        var S = f.length;
        return S ? f[Nj(0, S - 1)] : t;
      }
      function Zte(f, S) {
        return fS(Va(f), Zg(S, 0, f.length));
      }
      function Xte(f) {
        return fS(Va(f));
      }
      function Ej(f, S, V) {
        (V !== t && !Rh(f[S], V) || V === t && !(S in f)) && Ed(f, S, V);
      }
      function X2(f, S, V) {
        var fe = f[S];
        (!(Ti.call(f, S) && Rh(fe, V)) || V === t && !(S in f)) && Ed(f, S, V);
      }
      function J5(f, S) {
        for (var V = f.length; V--; )
          if (Rh(f[V][0], S))
            return V;
        return -1;
      }
      function Qte(f, S, V, fe) {
        return Kp(f, function(We, rn, bn) {
          S(fe, We, V(We), bn);
        }), fe;
      }
      function AF(f, S) {
        return f && yf(S, so(S), f);
      }
      function Jte(f, S) {
        return f && yf(S, Ua(S), f);
      }
      function Ed(f, S, V) {
        S == "__proto__" && Ug ? Ug(f, S, {
          configurable: !0,
          enumerable: !0,
          value: V,
          writable: !0
        }) : f[S] = V;
      }
      function Oj(f, S) {
        for (var V = -1, fe = S.length, We = pt(fe), rn = f == null; ++V < fe; )
          We[V] = rn ? t : rA(f, S[V]);
        return We;
      }
      function Zg(f, S, V) {
        return f === f && (V !== t && (f = f <= V ? f : V), S !== t && (f = f >= S ? f : S)), f;
      }
      function Xc(f, S, V, fe, We, rn) {
        var bn, Mn = S & p, Xn = S & _, At = S & R;
        if (V && (bn = We ? V(f, fe, We, rn) : V(f)), bn !== t)
          return bn;
        if (!Cu(f))
          return f;
        var Rt = Dr(f);
        if (Rt) {
          if (bn = Vle(f), !Mn)
            return Va(f, bn);
        } else {
          var qt = Yo(f), vl = qt == _e || qt == Ve;
          if (Qp(f))
            return JF(f, Mn);
          if (qt == Vn || qt == xn || vl && !We) {
            if (bn = Xn || vl ? {} : vV(f), !Mn)
              return Xn ? Dle(f, Jte(bn, f)) : Ale(f, AF(bn, f));
          } else {
            if (!ri[qt])
              return We ? f : {};
            bn = Yle(f, qt, Mn);
          }
        }
        rn || (rn = new Vo());
        var Fl = rn.get(f);
        if (Fl)
          return Fl;
        rn.set(f, bn), zV(f) ? f.forEach(function(cr) {
          bn.add(Xc(cr, S, V, cr, f, rn));
        }) : WV(f) && f.forEach(function(cr, ui) {
          bn.set(ui, Xc(cr, S, V, ui, f, rn));
        });
        var ar = At ? Xn ? qj : Uj : Xn ? Ua : so, Ur = Rt ? t : ar(f);
        return ko(Ur || f, function(cr, ui) {
          Ur && (ui = cr, cr = f[ui]), X2(bn, ui, Xc(cr, S, V, ui, f, rn));
        }), bn;
      }
      function ele(f) {
        var S = so(f);
        return function(V) {
          return DF(V, f, S);
        };
      }
      function DF(f, S, V) {
        var fe = V.length;
        if (f == null)
          return !fe;
        for (f = yi(f); fe--; ) {
          var We = V[fe], rn = S[We], bn = f[We];
          if (bn === t && !(We in f) || !rn(bn))
            return !1;
        }
        return !0;
      }
      function IF(f, S, V) {
        if (typeof f != "function")
          throw new ca(o);
        return r_(function() {
          f.apply(t, V);
        }, S);
      }
      function Q2(f, S, V, fe) {
        var We = -1, rn = cd, bn = !0, Mn = f.length, Xn = [], At = S.length;
        if (!Mn)
          return Xn;
        V && (S = Kl(S, Gi(V))), fe ? (rn = bo, bn = !1) : S.length >= r && (rn = xu, bn = !1, S = new Ih(S));
        e:
          for (; ++We < Mn; ) {
            var Rt = f[We], qt = V == null ? Rt : V(Rt);
            if (Rt = fe || Rt !== 0 ? Rt : 0, bn && qt === qt) {
              for (var vl = At; vl--; )
                if (S[vl] === qt)
                  continue e;
              Xn.push(Rt);
            } else rn(S, qt, fe) || Xn.push(Rt);
          }
        return Xn;
      }
      var Kp = rV(vf), RF = rV(bj, !0);
      function nle(f, S) {
        var V = !0;
        return Kp(f, function(fe, We, rn) {
          return V = !!S(fe, We, rn), V;
        }), V;
      }
      function eS(f, S, V) {
        for (var fe = -1, We = f.length; ++fe < We; ) {
          var rn = f[fe], bn = S(rn);
          if (bn != null && (Mn === t ? bn === bn && !wc(bn) : V(bn, Mn)))
            var Mn = bn, Xn = rn;
        }
        return Xn;
      }
      function tle(f, S, V, fe) {
        var We = f.length;
        for (V = Lr(V), V < 0 && (V = -V > We ? 0 : We + V), fe = fe === t || fe > We ? We : Lr(fe), fe < 0 && (fe += We), fe = V > fe ? 0 : GV(fe); V < fe; )
          f[V++] = S;
        return f;
      }
      function NF(f, S) {
        var V = [];
        return Kp(f, function(fe, We, rn) {
          S(fe, We, rn) && V.push(fe);
        }), V;
      }
      function jo(f, S, V, fe, We) {
        var rn = -1, bn = f.length;
        for (V || (V = qle), We || (We = []); ++rn < bn; ) {
          var Mn = f[rn];
          S > 0 && V(Mn) ? S > 1 ? jo(Mn, S - 1, V, fe, We) : Ba(We, Mn) : fe || (We[We.length] = Mn);
        }
        return We;
      }
      var kj = iV(), CF = iV(!0);
      function vf(f, S) {
        return f && kj(f, S, so);
      }
      function bj(f, S) {
        return f && CF(f, S, so);
      }
      function nS(f, S) {
        return Hu(S, function(V) {
          return Td(f[V]);
        });
      }
      function Xg(f, S) {
        S = Zp(S, f);
        for (var V = 0, fe = S.length; f != null && V < fe; )
          f = f[_f(S[V++])];
        return V && V == fe ? f : t;
      }
      function MF(f, S, V) {
        var fe = S(f);
        return Dr(f) ? fe : Ba(fe, V(f));
      }
      function fa(f) {
        return f == null ? f === t ? pr : Qn : yd && yd in yi(f) ? Lle(f) : Xle(f);
      }
      function Tj(f, S) {
        return f > S;
      }
      function lle(f, S) {
        return f != null && Ti.call(f, S);
      }
      function rle(f, S) {
        return f != null && S in yi(f);
      }
      function ile(f, S, V) {
        return f >= uo(S, V) && f < zu(S, V);
      }
      function jj(f, S, V) {
        for (var fe = V ? bo : cd, We = f[0].length, rn = f.length, bn = rn, Mn = pt(rn), Xn = 1 / 0, At = []; bn--; ) {
          var Rt = f[bn];
          bn && S && (Rt = Kl(Rt, Gi(S))), Xn = uo(Rt.length, Xn), Mn[bn] = !V && (S || We >= 120 && Rt.length >= 120) ? new Ih(bn && Rt) : t;
        }
        Rt = f[0];
        var qt = -1, vl = Mn[0];
        e:
          for (; ++qt < We && At.length < Xn; ) {
            var Fl = Rt[qt], ar = S ? S(Fl) : Fl;
            if (Fl = V || Fl !== 0 ? Fl : 0, !(vl ? xu(vl, ar) : fe(At, ar, V))) {
              for (bn = rn; --bn; ) {
                var Ur = Mn[bn];
                if (!(Ur ? xu(Ur, ar) : fe(f[bn], ar, V)))
                  continue e;
              }
              vl && vl.push(ar), At.push(Fl);
            }
          }
        return At;
      }
      function ule(f, S, V, fe) {
        return vf(f, function(We, rn, bn) {
          S(fe, V(We), rn, bn);
        }), fe;
      }
      function J2(f, S, V) {
        S = Zp(S, f), f = SV(f, S);
        var fe = f == null ? f : f[_f(Jc(S))];
        return fe == null ? t : Wu(fe, f, V);
      }
      function PF(f) {
        return Ku(f) && fa(f) == xn;
      }
      function sle(f) {
        return Ku(f) && fa(f) == ql;
      }
      function ole(f) {
        return Ku(f) && fa(f) == jt;
      }
      function e_(f, S, V, fe, We) {
        return f === S ? !0 : f == null || S == null || !Ku(f) && !Ku(S) ? f !== f && S !== S : ale(f, S, V, fe, e_, We);
      }
      function ale(f, S, V, fe, We, rn) {
        var bn = Dr(f), Mn = Dr(S), Xn = bn ? Nn : Yo(f), At = Mn ? Nn : Yo(S);
        Xn = Xn == xn ? Vn : Xn, At = At == xn ? Vn : At;
        var Rt = Xn == Vn, qt = At == Vn, vl = Xn == At;
        if (vl && Qp(f)) {
          if (!Qp(S))
            return !1;
          bn = !0, Rt = !1;
        }
        if (vl && !Rt)
          return rn || (rn = new Vo()), bn || ev(f) ? mV(f, S, V, fe, We, rn) : Ple(f, S, Xn, V, fe, We, rn);
        if (!(V & F)) {
          var Fl = Rt && Ti.call(f, "__wrapped__"), ar = qt && Ti.call(S, "__wrapped__");
          if (Fl || ar) {
            var Ur = Fl ? f.value() : f, cr = ar ? S.value() : S;
            return rn || (rn = new Vo()), We(Ur, cr, V, fe, rn);
          }
        }
        return vl ? (rn || (rn = new Vo()), $le(f, S, V, fe, We, rn)) : !1;
      }
      function cle(f) {
        return Ku(f) && Yo(f) == an;
      }
      function Aj(f, S, V, fe) {
        var We = V.length, rn = We, bn = !fe;
        if (f == null)
          return !rn;
        for (f = yi(f); We--; ) {
          var Mn = V[We];
          if (bn && Mn[2] ? Mn[1] !== f[Mn[0]] : !(Mn[0] in f))
            return !1;
        }
        for (; ++We < rn; ) {
          Mn = V[We];
          var Xn = Mn[0], At = f[Xn], Rt = Mn[1];
          if (bn && Mn[2]) {
            if (At === t && !(Xn in f))
              return !1;
          } else {
            var qt = new Vo();
            if (fe)
              var vl = fe(At, Rt, Xn, f, S, qt);
            if (!(vl === t ? e_(Rt, At, F | L, fe, qt) : vl))
              return !1;
          }
        }
        return !0;
      }
      function $F(f) {
        if (!Cu(f) || Hle(f))
          return !1;
        var S = Td(f) ? yj : gt;
        return S.test(Jg(f));
      }
      function hle(f) {
        return Ku(f) && fa(f) == zt;
      }
      function fle(f) {
        return Ku(f) && Yo(f) == Pt;
      }
      function dle(f) {
        return Ku(f) && vS(f.length) && !!$r[fa(f)];
      }
      function LF(f) {
        return typeof f == "function" ? f : f == null ? qa : typeof f == "object" ? Dr(f) ? VF(f[0], f[1]) : FF(f) : uY(f);
      }
      function Dj(f) {
        if (!l_(f))
          return xj(f);
        var S = [];
        for (var V in yi(f))
          Ti.call(f, V) && V != "constructor" && S.push(V);
        return S;
      }
      function ple(f) {
        if (!Cu(f))
          return Zle(f);
        var S = l_(f), V = [];
        for (var fe in f)
          fe == "constructor" && (S || !Ti.call(f, fe)) || V.push(fe);
        return V;
      }
      function Ij(f, S) {
        return f < S;
      }
      function BF(f, S) {
        var V = -1, fe = Ya(f) ? pt(f.length) : [];
        return Kp(f, function(We, rn, bn) {
          fe[++V] = S(We, rn, bn);
        }), fe;
      }
      function FF(f) {
        var S = Hj(f);
        return S.length == 1 && S[0][2] ? _V(S[0][0], S[0][1]) : function(V) {
          return V === f || Aj(V, f, S);
        };
      }
      function VF(f, S) {
        return Kj(f) && yV(S) ? _V(_f(f), S) : function(V) {
          var fe = rA(V, f);
          return fe === t && fe === S ? iA(V, f) : e_(S, fe, F | L);
        };
      }
      function tS(f, S, V, fe, We) {
        f !== S && kj(S, function(rn, bn) {
          if (We || (We = new Vo()), Cu(rn))
            mle(f, S, bn, V, tS, fe, We);
          else {
            var Mn = fe ? fe(Zj(f, bn), rn, bn + "", f, S, We) : t;
            Mn === t && (Mn = rn), Ej(f, bn, Mn);
          }
        }, Ua);
      }
      function mle(f, S, V, fe, We, rn, bn) {
        var Mn = Zj(f, V), Xn = Zj(S, V), At = bn.get(Xn);
        if (At) {
          Ej(f, V, At);
          return;
        }
        var Rt = rn ? rn(Mn, Xn, V + "", f, S, bn) : t, qt = Rt === t;
        if (qt) {
          var vl = Dr(Xn), Fl = !vl && Qp(Xn), ar = !vl && !Fl && ev(Xn);
          Rt = Xn, vl || Fl || ar ? Dr(Mn) ? Rt = Mn : ps(Mn) ? Rt = Va(Mn) : Fl ? (qt = !1, Rt = JF(Xn, !0)) : ar ? (qt = !1, Rt = eV(Xn, !0)) : Rt = [] : i_(Xn) || ew(Xn) ? (Rt = Mn, ew(Mn) ? Rt = ZV(Mn) : (!Cu(Mn) || Td(Mn)) && (Rt = vV(Xn))) : qt = !1;
        }
        qt && (bn.set(Xn, Rt), We(Rt, Xn, fe, rn, bn), bn.delete(Xn)), Ej(f, V, Rt);
      }
      function YF(f, S) {
        var V = f.length;
        if (V)
          return S += S < 0 ? V : 0, bd(S, V) ? f[S] : t;
      }
      function UF(f, S, V) {
        S.length ? S = Kl(S, function(rn) {
          return Dr(rn) ? function(bn) {
            return Xg(bn, rn.length === 1 ? rn[0] : rn);
          } : rn;
        }) : S = [qa];
        var fe = -1;
        S = Kl(S, Gi(ir()));
        var We = BF(f, function(rn, bn, Mn) {
          var Xn = Kl(S, function(At) {
            return At(rn);
          });
          return { criteria: Xn, index: ++fe, value: rn };
        });
        return $g(We, function(rn, bn) {
          return jle(rn, bn, V);
        });
      }
      function gle(f, S) {
        return qF(f, S, function(V, fe) {
          return iA(f, fe);
        });
      }
      function qF(f, S, V) {
        for (var fe = -1, We = S.length, rn = {}; ++fe < We; ) {
          var bn = S[fe], Mn = Xg(f, bn);
          V(Mn, bn) && n_(rn, Zp(bn, f), Mn);
        }
        return rn;
      }
      function wle(f) {
        return function(S) {
          return Xg(S, f);
        };
      }
      function Rj(f, S, V, fe) {
        var We = fe ? Mg : ds, rn = -1, bn = S.length, Mn = f;
        for (f === S && (S = Va(S)), V && (Mn = Kl(f, Gi(V))); ++rn < bn; )
          for (var Xn = 0, At = S[rn], Rt = V ? V(At) : At; (Xn = We(Mn, Rt, Xn, fe)) > -1; )
            Mn !== f && B1.call(Mn, Xn, 1), B1.call(f, Xn, 1);
        return f;
      }
      function WF(f, S) {
        for (var V = f ? S.length : 0, fe = V - 1; V--; ) {
          var We = S[V];
          if (V == fe || We !== rn) {
            var rn = We;
            bd(We) ? B1.call(f, We, 1) : Pj(f, We);
          }
        }
        return f;
      }
      function Nj(f, S) {
        return f + Y1(Hg() * (S - f + 1));
      }
      function vle(f, S, V, fe) {
        for (var We = -1, rn = zu(V1((S - f) / (V || 1)), 0), bn = pt(rn); rn--; )
          bn[fe ? rn : ++We] = f, f += V;
        return bn;
      }
      function Cj(f, S) {
        var V = "";
        if (!f || S < 1 || S > me)
          return V;
        do
          S % 2 && (V += f), S = Y1(S / 2), S && (f += f);
        while (S);
        return V;
      }
      function zr(f, S) {
        return Xj(xV(f, S, qa), f + "");
      }
      function yle(f) {
        return Z1(nv(f));
      }
      function _le(f, S) {
        var V = nv(f);
        return fS(V, Zg(S, 0, V.length));
      }
      function n_(f, S, V, fe) {
        if (!Cu(f))
          return f;
        S = Zp(S, f);
        for (var We = -1, rn = S.length, bn = rn - 1, Mn = f; Mn != null && ++We < rn; ) {
          var Xn = _f(S[We]), At = V;
          if (Xn === "__proto__" || Xn === "constructor" || Xn === "prototype")
            return f;
          if (We != bn) {
            var Rt = Mn[Xn];
            At = fe ? fe(Rt, Xn, Mn) : t, At === t && (At = Cu(Rt) ? Rt : bd(S[We + 1]) ? [] : {});
          }
          X2(Mn, Xn, At), Mn = Mn[Xn];
        }
        return f;
      }
      var HF = q1 ? function(f, S) {
        return q1.set(f, S), f;
      } : qa, xle = Ug ? function(f, S) {
        return Ug(f, "toString", {
          configurable: !0,
          enumerable: !1,
          value: sA(S),
          writable: !0
        });
      } : qa;
      function Sle(f) {
        return fS(nv(f));
      }
      function Qc(f, S, V) {
        var fe = -1, We = f.length;
        S < 0 && (S = -S > We ? 0 : We + S), V = V > We ? We : V, V < 0 && (V += We), We = S > V ? 0 : V - S >>> 0, S >>>= 0;
        for (var rn = pt(We); ++fe < We; )
          rn[fe] = f[fe + S];
        return rn;
      }
      function Ele(f, S) {
        var V;
        return Kp(f, function(fe, We, rn) {
          return V = S(fe, We, rn), !V;
        }), !!V;
      }
      function lS(f, S, V) {
        var fe = 0, We = f == null ? fe : f.length;
        if (typeof S == "number" && S === S && We <= Ze) {
          for (; fe < We; ) {
            var rn = fe + We >>> 1, bn = f[rn];
            bn !== null && !wc(bn) && (V ? bn <= S : bn < S) ? fe = rn + 1 : We = rn;
          }
          return We;
        }
        return Mj(f, S, qa, V);
      }
      function Mj(f, S, V, fe) {
        var We = 0, rn = f == null ? 0 : f.length;
        if (rn === 0)
          return 0;
        S = V(S);
        for (var bn = S !== S, Mn = S === null, Xn = wc(S), At = S === t; We < rn; ) {
          var Rt = Y1((We + rn) / 2), qt = V(f[Rt]), vl = qt !== t, Fl = qt === null, ar = qt === qt, Ur = wc(qt);
          if (bn)
            var cr = fe || ar;
          else At ? cr = ar && (fe || vl) : Mn ? cr = ar && vl && (fe || !Fl) : Xn ? cr = ar && vl && !Fl && (fe || !Ur) : Fl || Ur ? cr = !1 : cr = fe ? qt <= S : qt < S;
          cr ? We = Rt + 1 : rn = Rt;
        }
        return uo(rn, Be);
      }
      function zF(f, S) {
        for (var V = -1, fe = f.length, We = 0, rn = []; ++V < fe; ) {
          var bn = f[V], Mn = S ? S(bn) : bn;
          if (!V || !Rh(Mn, Xn)) {
            var Xn = Mn;
            rn[We++] = bn === 0 ? 0 : bn;
          }
        }
        return rn;
      }
      function KF(f) {
        return typeof f == "number" ? f : wc(f) ? Fe : +f;
      }
      function gc(f) {
        if (typeof f == "string")
          return f;
        if (Dr(f))
          return Kl(f, gc) + "";
        if (wc(f))
          return Z2 ? Z2.call(f) : "";
        var S = f + "";
        return S == "0" && 1 / f == -q ? "-0" : S;
      }
      function Gp(f, S, V) {
        var fe = -1, We = cd, rn = f.length, bn = !0, Mn = [], Xn = Mn;
        if (V)
          bn = !1, We = bo;
        else if (rn >= r) {
          var At = S ? null : Cle(f);
          if (At)
            return Up(At);
          bn = !1, We = xu, Xn = new Ih();
        } else
          Xn = S ? [] : Mn;
        e:
          for (; ++fe < rn; ) {
            var Rt = f[fe], qt = S ? S(Rt) : Rt;
            if (Rt = V || Rt !== 0 ? Rt : 0, bn && qt === qt) {
              for (var vl = Xn.length; vl--; )
                if (Xn[vl] === qt)
                  continue e;
              S && Xn.push(qt), Mn.push(Rt);
            } else We(Xn, qt, V) || (Xn !== Mn && Xn.push(qt), Mn.push(Rt));
          }
        return Mn;
      }
      function Pj(f, S) {
        return S = Zp(S, f), f = SV(f, S), f == null || delete f[_f(Jc(S))];
      }
      function GF(f, S, V, fe) {
        return n_(f, S, V(Xg(f, S)), fe);
      }
      function rS(f, S, V, fe) {
        for (var We = f.length, rn = fe ? We : -1; (fe ? rn-- : ++rn < We) && S(f[rn], rn, f); )
          ;
        return V ? Qc(f, fe ? 0 : rn, fe ? rn + 1 : We) : Qc(f, fe ? rn + 1 : 0, fe ? We : rn);
      }
      function ZF(f, S) {
        var V = f;
        return V instanceof c && (V = V.value()), hd(S, function(fe, We) {
          return We.func.apply(We.thisArg, Ba([fe], We.args));
        }, V);
      }
      function $j(f, S, V) {
        var fe = f.length;
        if (fe < 2)
          return fe ? Gp(f[0]) : [];
        for (var We = -1, rn = pt(fe); ++We < fe; )
          for (var bn = f[We], Mn = -1; ++Mn < fe; )
            Mn != We && (rn[We] = Q2(rn[We] || bn, f[Mn], S, V));
        return Gp(jo(rn, 1), S, V);
      }
      function XF(f, S, V) {
        for (var fe = -1, We = f.length, rn = S.length, bn = {}; ++fe < We; ) {
          var Mn = fe < rn ? S[fe] : t;
          V(bn, f[fe], Mn);
        }
        return bn;
      }
      function Lj(f) {
        return ps(f) ? f : [];
      }
      function Bj(f) {
        return typeof f == "function" ? f : qa;
      }
      function Zp(f, S) {
        return Dr(f) ? f : Kj(f, S) ? [f] : bV(Fi(f));
      }
      var Ole = zr;
      function Xp(f, S, V) {
        var fe = f.length;
        return V = V === t ? fe : V, !S && V >= fe ? f : Qc(f, S, V);
      }
      var QF = F1 || function(f) {
        return au.clearTimeout(f);
      };
      function JF(f, S) {
        if (S)
          return f.slice();
        var V = f.length, fe = H5 ? H5(V) : new f.constructor(V);
        return f.copy(fe), fe;
      }
      function Fj(f) {
        var S = new f.constructor(f.byteLength);
        return new Vg(S).set(new Vg(f)), S;
      }
      function kle(f, S) {
        var V = S ? Fj(f.buffer) : f.buffer;
        return new f.constructor(V, f.byteOffset, f.byteLength);
      }
      function ble(f) {
        var S = new f.constructor(f.source, gn.exec(f));
        return S.lastIndex = f.lastIndex, S;
      }
      function Tle(f) {
        return Kg ? yi(Kg.call(f)) : {};
      }
      function eV(f, S) {
        var V = S ? Fj(f.buffer) : f.buffer;
        return new f.constructor(V, f.byteOffset, f.length);
      }
      function nV(f, S) {
        if (f !== S) {
          var V = f !== t, fe = f === null, We = f === f, rn = wc(f), bn = S !== t, Mn = S === null, Xn = S === S, At = wc(S);
          if (!Mn && !At && !rn && f > S || rn && bn && Xn && !Mn && !At || fe && bn && Xn || !V && Xn || !We)
            return 1;
          if (!fe && !rn && !At && f < S || At && V && We && !fe && !rn || Mn && V && We || !bn && We || !Xn)
            return -1;
        }
        return 0;
      }
      function jle(f, S, V) {
        for (var fe = -1, We = f.criteria, rn = S.criteria, bn = We.length, Mn = V.length; ++fe < bn; ) {
          var Xn = nV(We[fe], rn[fe]);
          if (Xn) {
            if (fe >= Mn)
              return Xn;
            var At = V[fe];
            return Xn * (At == "desc" ? -1 : 1);
          }
        }
        return f.index - S.index;
      }
      function tV(f, S, V, fe) {
        for (var We = -1, rn = f.length, bn = V.length, Mn = -1, Xn = S.length, At = zu(rn - bn, 0), Rt = pt(Xn + At), qt = !fe; ++Mn < Xn; )
          Rt[Mn] = S[Mn];
        for (; ++We < bn; )
          (qt || We < rn) && (Rt[V[We]] = f[We]);
        for (; At--; )
          Rt[Mn++] = f[We++];
        return Rt;
      }
      function lV(f, S, V, fe) {
        for (var We = -1, rn = f.length, bn = -1, Mn = V.length, Xn = -1, At = S.length, Rt = zu(rn - Mn, 0), qt = pt(Rt + At), vl = !fe; ++We < Rt; )
          qt[We] = f[We];
        for (var Fl = We; ++Xn < At; )
          qt[Fl + Xn] = S[Xn];
        for (; ++bn < Mn; )
          (vl || We < rn) && (qt[Fl + V[bn]] = f[We++]);
        return qt;
      }
      function Va(f, S) {
        var V = -1, fe = f.length;
        for (S || (S = pt(fe)); ++V < fe; )
          S[V] = f[V];
        return S;
      }
      function yf(f, S, V, fe) {
        var We = !V;
        V || (V = {});
        for (var rn = -1, bn = S.length; ++rn < bn; ) {
          var Mn = S[rn], Xn = fe ? fe(V[Mn], f[Mn], Mn, V, f) : t;
          Xn === t && (Xn = f[Mn]), We ? Ed(V, Mn, Xn) : X2(V, Mn, Xn);
        }
        return V;
      }
      function Ale(f, S) {
        return yf(f, zj(f), S);
      }
      function Dle(f, S) {
        return yf(f, gV(f), S);
      }
      function iS(f, S) {
        return function(V, fe) {
          var We = Dr(V) ? Ig : Qte, rn = S ? S() : {};
          return We(V, f, ir(fe, 2), rn);
        };
      }
      function X1(f) {
        return zr(function(S, V) {
          var fe = -1, We = V.length, rn = We > 1 ? V[We - 1] : t, bn = We > 2 ? V[2] : t;
          for (rn = f.length > 3 && typeof rn == "function" ? (We--, rn) : t, bn && da(V[0], V[1], bn) && (rn = We < 3 ? t : rn, We = 1), S = yi(S); ++fe < We; ) {
            var Mn = V[fe];
            Mn && f(S, Mn, fe, rn);
          }
          return S;
        });
      }
      function rV(f, S) {
        return function(V, fe) {
          if (V == null)
            return V;
          if (!Ya(V))
            return f(V, fe);
          for (var We = V.length, rn = S ? We : -1, bn = yi(V); (S ? rn-- : ++rn < We) && fe(bn[rn], rn, bn) !== !1; )
            ;
          return V;
        };
      }
      function iV(f) {
        return function(S, V, fe) {
          for (var We = -1, rn = yi(S), bn = fe(S), Mn = bn.length; Mn--; ) {
            var Xn = bn[f ? Mn : ++We];
            if (V(rn[Xn], Xn, rn) === !1)
              break;
          }
          return S;
        };
      }
      function Ile(f, S, V) {
        var fe = S & G, We = t_(f);
        function rn() {
          var bn = this && this !== au && this instanceof rn ? We : f;
          return bn.apply(fe ? V : this, arguments);
        }
        return rn;
      }
      function uV(f) {
        return function(S) {
          S = Fi(S);
          var V = Yp(S) ? dc(S) : t, fe = V ? V[0] : S.charAt(0), We = V ? Xp(V, 1).join("") : S.slice(1);
          return fe[f]() + We;
        };
      }
      function Q1(f) {
        return function(S) {
          return hd(rY(lY(S).replace(An, "")), f, "");
        };
      }
      function t_(f) {
        return function() {
          var S = arguments;
          switch (S.length) {
            case 0:
              return new f();
            case 1:
              return new f(S[0]);
            case 2:
              return new f(S[0], S[1]);
            case 3:
              return new f(S[0], S[1], S[2]);
            case 4:
              return new f(S[0], S[1], S[2], S[3]);
            case 5:
              return new f(S[0], S[1], S[2], S[3], S[4]);
            case 6:
              return new f(S[0], S[1], S[2], S[3], S[4], S[5]);
            case 7:
              return new f(S[0], S[1], S[2], S[3], S[4], S[5], S[6]);
          }
          var V = zp(f.prototype), fe = f.apply(V, S);
          return Cu(fe) ? fe : V;
        };
      }
      function Rle(f, S, V) {
        var fe = t_(f);
        function We() {
          for (var rn = arguments.length, bn = pt(rn), Mn = rn, Xn = J1(We); Mn--; )
            bn[Mn] = arguments[Mn];
          var At = rn < 3 && bn[0] !== Xn && bn[rn - 1] !== Xn ? [] : fc(bn, Xn);
          if (rn -= At.length, rn < V)
            return hV(
              f,
              S,
              uS,
              We.placeholder,
              t,
              bn,
              At,
              t,
              t,
              V - rn
            );
          var Rt = this && this !== au && this instanceof We ? fe : f;
          return Wu(Rt, this, bn);
        }
        return We;
      }
      function sV(f) {
        return function(S, V, fe) {
          var We = yi(S);
          if (!Ya(S)) {
            var rn = ir(V, 3);
            S = so(S), V = function(Mn) {
              return rn(We[Mn], Mn, We);
            };
          }
          var bn = f(S, V, fe);
          return bn > -1 ? We[rn ? S[bn] : bn] : t;
        };
      }
      function oV(f) {
        return kd(function(S) {
          var V = S.length, fe = V, We = N.prototype.thru;
          for (f && S.reverse(); fe--; ) {
            var rn = S[fe];
            if (typeof rn != "function")
              throw new ca(o);
            if (We && !bn && cS(rn) == "wrapper")
              var bn = new N([], !0);
          }
          for (fe = bn ? fe : V; ++fe < V; ) {
            rn = S[fe];
            var Mn = cS(rn), Xn = Mn == "wrapper" ? Wj(rn) : t;
            Xn && Gj(Xn[0]) && Xn[1] == (E | ce | $e | P) && !Xn[4].length && Xn[9] == 1 ? bn = bn[cS(Xn[0])].apply(bn, Xn[3]) : bn = rn.length == 1 && Gj(rn) ? bn[Mn]() : bn.thru(rn);
          }
          return function() {
            var At = arguments, Rt = At[0];
            if (bn && At.length == 1 && Dr(Rt))
              return bn.plant(Rt).value();
            for (var qt = 0, vl = V ? S[qt].apply(this, At) : Rt; ++qt < V; )
              vl = S[qt].call(this, vl);
            return vl;
          };
        });
      }
      function uS(f, S, V, fe, We, rn, bn, Mn, Xn, At) {
        var Rt = S & E, qt = S & G, vl = S & J, Fl = S & (ce | xe), ar = S & K, Ur = vl ? t : t_(f);
        function cr() {
          for (var ui = arguments.length, fi = pt(ui), vc = ui; vc--; )
            fi[vc] = arguments[vc];
          if (Fl)
            var pa = J1(cr), yc = Ks(fi, pa);
          if (fe && (fi = tV(fi, fe, We, Fl)), rn && (fi = lV(fi, rn, bn, Fl)), ui -= yc, Fl && ui < At) {
            var ms = fc(fi, pa);
            return hV(
              f,
              S,
              uS,
              cr.placeholder,
              V,
              fi,
              ms,
              Mn,
              Xn,
              At - ui
            );
          }
          var Nh = qt ? V : this, Ad = vl ? Nh[f] : f;
          return ui = fi.length, Mn ? fi = Qle(fi, Mn) : ar && ui > 1 && fi.reverse(), Rt && Xn < ui && (fi.length = Xn), this && this !== au && this instanceof cr && (Ad = Ur || t_(Ad)), Ad.apply(Nh, fi);
        }
        return cr;
      }
      function aV(f, S) {
        return function(V, fe) {
          return ule(V, f, S(fe), {});
        };
      }
      function sS(f, S) {
        return function(V, fe) {
          var We;
          if (V === t && fe === t)
            return S;
          if (V !== t && (We = V), fe !== t) {
            if (We === t)
              return fe;
            typeof V == "string" || typeof fe == "string" ? (V = gc(V), fe = gc(fe)) : (V = KF(V), fe = KF(fe)), We = f(V, fe);
          }
          return We;
        };
      }
      function Vj(f) {
        return kd(function(S) {
          return S = Kl(S, Gi(ir())), zr(function(V) {
            var fe = this;
            return f(S, function(We) {
              return Wu(We, fe, V);
            });
          });
        });
      }
      function oS(f, S) {
        S = S === t ? " " : gc(S);
        var V = S.length;
        if (V < 2)
          return V ? Cj(S, f) : S;
        var fe = Cj(S, V1(f / wd(S)));
        return Yp(S) ? Xp(dc(fe), 0, f).join("") : fe.slice(0, f);
      }
      function Nle(f, S, V, fe) {
        var We = S & G, rn = t_(f);
        function bn() {
          for (var Mn = -1, Xn = arguments.length, At = -1, Rt = fe.length, qt = pt(Rt + Xn), vl = this && this !== au && this instanceof bn ? rn : f; ++At < Rt; )
            qt[At] = fe[At];
          for (; Xn--; )
            qt[At++] = arguments[++Mn];
          return Wu(vl, We ? V : this, qt);
        }
        return bn;
      }
      function cV(f) {
        return function(S, V, fe) {
          return fe && typeof fe != "number" && da(S, V, fe) && (V = fe = t), S = jd(S), V === t ? (V = S, S = 0) : V = jd(V), fe = fe === t ? S < V ? 1 : -1 : jd(fe), vle(S, V, fe, f);
        };
      }
      function aS(f) {
        return function(S, V) {
          return typeof S == "string" && typeof V == "string" || (S = eh(S), V = eh(V)), f(S, V);
        };
      }
      function hV(f, S, V, fe, We, rn, bn, Mn, Xn, At) {
        var Rt = S & ce, qt = Rt ? bn : t, vl = Rt ? t : bn, Fl = Rt ? rn : t, ar = Rt ? t : rn;
        S |= Rt ? $e : je, S &= ~(Rt ? je : $e), S & we || (S &= ~(G | J));
        var Ur = [
          f,
          S,
          We,
          Fl,
          qt,
          ar,
          vl,
          Mn,
          Xn,
          At
        ], cr = V.apply(t, Ur);
        return Gj(f) && EV(cr, Ur), cr.placeholder = fe, OV(cr, f, S);
      }
      function Yj(f) {
        var S = Zi[f];
        return function(V, fe) {
          if (V = eh(V), fe = fe == null ? 0 : uo(Lr(fe), 292), fe && U1(V)) {
            var We = (Fi(V) + "e").split("e"), rn = S(We[0] + "e" + (+We[1] + fe));
            return We = (Fi(rn) + "e").split("e"), +(We[0] + "e" + (+We[1] - fe));
          }
          return S(V);
        };
      }
      var Cle = Zc && 1 / Up(new Zc([, -0]))[1] == q ? function(f) {
        return new Zc(f);
      } : cA;
      function fV(f) {
        return function(S) {
          var V = Yo(S);
          return V == an ? M1(S) : V == Pt ? F2(S) : Lg(S, f(S));
        };
      }
      function Od(f, S, V, fe, We, rn, bn, Mn) {
        var Xn = S & J;
        if (!Xn && typeof f != "function")
          throw new ca(o);
        var At = fe ? fe.length : 0;
        if (At || (S &= ~($e | je), fe = We = t), bn = bn === t ? bn : zu(Lr(bn), 0), Mn = Mn === t ? Mn : Lr(Mn), At -= We ? We.length : 0, S & je) {
          var Rt = fe, qt = We;
          fe = We = t;
        }
        var vl = Xn ? t : Wj(f), Fl = [
          f,
          S,
          V,
          fe,
          We,
          Rt,
          qt,
          rn,
          bn,
          Mn
        ];
        if (vl && Gle(Fl, vl), f = Fl[0], S = Fl[1], V = Fl[2], fe = Fl[3], We = Fl[4], Mn = Fl[9] = Fl[9] === t ? Xn ? 0 : f.length : zu(Fl[9] - At, 0), !Mn && S & (ce | xe) && (S &= ~(ce | xe)), !S || S == G)
          var ar = Ile(f, S, V);
        else S == ce || S == xe ? ar = Rle(f, S, Mn) : (S == $e || S == (G | $e)) && !We.length ? ar = Nle(f, S, V, fe) : ar = uS.apply(t, Fl);
        var Ur = vl ? HF : EV;
        return OV(Ur(ar, Fl), f, S);
      }
      function dV(f, S, V, fe) {
        return f === t || Rh(f, qp[V]) && !Ti.call(fe, V) ? S : f;
      }
      function pV(f, S, V, fe, We, rn) {
        return Cu(f) && Cu(S) && (rn.set(S, f), tS(f, S, t, pV, rn), rn.delete(S)), f;
      }
      function Mle(f) {
        return i_(f) ? t : f;
      }
      function mV(f, S, V, fe, We, rn) {
        var bn = V & F, Mn = f.length, Xn = S.length;
        if (Mn != Xn && !(bn && Xn > Mn))
          return !1;
        var At = rn.get(f), Rt = rn.get(S);
        if (At && Rt)
          return At == S && Rt == f;
        var qt = -1, vl = !0, Fl = V & L ? new Ih() : t;
        for (rn.set(f, S), rn.set(S, f); ++qt < Mn; ) {
          var ar = f[qt], Ur = S[qt];
          if (fe)
            var cr = bn ? fe(Ur, ar, qt, S, f, rn) : fe(ar, Ur, qt, f, S, rn);
          if (cr !== t) {
            if (cr)
              continue;
            vl = !1;
            break;
          }
          if (Fl) {
            if (!$p(S, function(ui, fi) {
              if (!xu(Fl, fi) && (ar === ui || We(ar, ui, V, fe, rn)))
                return Fl.push(fi);
            })) {
              vl = !1;
              break;
            }
          } else if (!(ar === Ur || We(ar, Ur, V, fe, rn))) {
            vl = !1;
            break;
          }
        }
        return rn.delete(f), rn.delete(S), vl;
      }
      function Ple(f, S, V, fe, We, rn, bn) {
        switch (V) {
          case Mr:
            if (f.byteLength != S.byteLength || f.byteOffset != S.byteOffset)
              return !1;
            f = f.buffer, S = S.buffer;
          case ql:
            return !(f.byteLength != S.byteLength || !rn(new Vg(f), new Vg(S)));
          case Yt:
          case jt:
          case En:
            return Rh(+f, +S);
          case fn:
            return f.name == S.name && f.message == S.message;
          case zt:
          case ol:
            return f == S + "";
          case an:
            var Mn = M1;
          case Pt:
            var Xn = fe & F;
            if (Mn || (Mn = Up), f.size != S.size && !Xn)
              return !1;
            var At = bn.get(f);
            if (At)
              return At == S;
            fe |= L, bn.set(f, S);
            var Rt = mV(Mn(f), Mn(S), fe, We, rn, bn);
            return bn.delete(f), Rt;
          case St:
            if (Kg)
              return Kg.call(f) == Kg.call(S);
        }
        return !1;
      }
      function $le(f, S, V, fe, We, rn) {
        var bn = V & F, Mn = Uj(f), Xn = Mn.length, At = Uj(S), Rt = At.length;
        if (Xn != Rt && !bn)
          return !1;
        for (var qt = Xn; qt--; ) {
          var vl = Mn[qt];
          if (!(bn ? vl in S : Ti.call(S, vl)))
            return !1;
        }
        var Fl = rn.get(f), ar = rn.get(S);
        if (Fl && ar)
          return Fl == S && ar == f;
        var Ur = !0;
        rn.set(f, S), rn.set(S, f);
        for (var cr = bn; ++qt < Xn; ) {
          vl = Mn[qt];
          var ui = f[vl], fi = S[vl];
          if (fe)
            var vc = bn ? fe(fi, ui, vl, S, f, rn) : fe(ui, fi, vl, f, S, rn);
          if (!(vc === t ? ui === fi || We(ui, fi, V, fe, rn) : vc)) {
            Ur = !1;
            break;
          }
          cr || (cr = vl == "constructor");
        }
        if (Ur && !cr) {
          var pa = f.constructor, yc = S.constructor;
          pa != yc && "constructor" in f && "constructor" in S && !(typeof pa == "function" && pa instanceof pa && typeof yc == "function" && yc instanceof yc) && (Ur = !1);
        }
        return rn.delete(f), rn.delete(S), Ur;
      }
      function kd(f) {
        return Xj(xV(f, t, DV), f + "");
      }
      function Uj(f) {
        return MF(f, so, zj);
      }
      function qj(f) {
        return MF(f, Ua, gV);
      }
      var Wj = q1 ? function(f) {
        return q1.get(f);
      } : cA;
      function cS(f) {
        for (var S = f.name + "", V = xd[S], fe = Ti.call(xd, S) ? V.length : 0; fe--; ) {
          var We = V[fe], rn = We.func;
          if (rn == null || rn == f)
            return We.name;
        }
        return S;
      }
      function J1(f) {
        var S = Ti.call(Je, "placeholder") ? Je : f;
        return S.placeholder;
      }
      function ir() {
        var f = Je.iteratee || oA;
        return f = f === oA ? LF : f, arguments.length ? f(arguments[0], arguments[1]) : f;
      }
      function hS(f, S) {
        var V = f.__data__;
        return Wle(S) ? V[typeof S == "string" ? "string" : "hash"] : V.map;
      }
      function Hj(f) {
        for (var S = so(f), V = S.length; V--; ) {
          var fe = S[V], We = f[fe];
          S[V] = [fe, We, yV(We)];
        }
        return S;
      }
      function Qg(f, S) {
        var V = B2(f, S);
        return $F(V) ? V : t;
      }
      function Lle(f) {
        var S = Ti.call(f, yd), V = f[yd];
        try {
          f[yd] = t;
          var fe = !0;
        } catch {
        }
        var We = vd.call(f);
        return fe && (S ? f[yd] = V : delete f[yd]), We;
      }
      var zj = qg ? function(f) {
        return f == null ? [] : (f = yi(f), Hu(qg(f), function(S) {
          return z5.call(f, S);
        }));
      } : hA, gV = qg ? function(f) {
        for (var S = []; f; )
          Ba(S, zj(f)), f = L1(f);
        return S;
      } : hA, Yo = fa;
      (mc && Yo(new mc(new ArrayBuffer(1))) != Mr || Dh && Yo(new Dh()) != an || K2 && Yo(K2.resolve()) != ot || Zc && Yo(new Zc()) != Pt || _d && Yo(new _d()) != ul) && (Yo = function(f) {
        var S = fa(f), V = S == Vn ? f.constructor : t, fe = V ? Jg(V) : "";
        if (fe)
          switch (fe) {
            case X5:
              return Mr;
            case Q5:
              return an;
            case Hp:
              return ot;
            case G2:
              return Pt;
            case Sj:
              return ul;
          }
        return S;
      });
      function Ble(f, S, V) {
        for (var fe = -1, We = V.length; ++fe < We; ) {
          var rn = V[fe], bn = rn.size;
          switch (rn.type) {
            case "drop":
              f += bn;
              break;
            case "dropRight":
              S -= bn;
              break;
            case "take":
              S = uo(S, f + bn);
              break;
            case "takeRight":
              f = zu(f, S - bn);
              break;
          }
        }
        return { start: f, end: S };
      }
      function Fle(f) {
        var S = f.match(Z);
        return S ? S[1].split(Y) : [];
      }
      function wV(f, S, V) {
        S = Zp(S, f);
        for (var fe = -1, We = S.length, rn = !1; ++fe < We; ) {
          var bn = _f(S[fe]);
          if (!(rn = f != null && V(f, bn)))
            break;
          f = f[bn];
        }
        return rn || ++fe != We ? rn : (We = f == null ? 0 : f.length, !!We && vS(We) && bd(bn, We) && (Dr(f) || ew(f)));
      }
      function Vle(f) {
        var S = f.length, V = new f.constructor(S);
        return S && typeof f[0] == "string" && Ti.call(f, "index") && (V.index = f.index, V.input = f.input), V;
      }
      function vV(f) {
        return typeof f.constructor == "function" && !l_(f) ? zp(L1(f)) : {};
      }
      function Yle(f, S, V) {
        var fe = f.constructor;
        switch (S) {
          case ql:
            return Fj(f);
          case Yt:
          case jt:
            return new fe(+f);
          case Mr:
            return kle(f, V);
          case wi:
          case bl:
          case tl:
          case Zt:
          case Ql:
          case jl:
          case Sl:
          case gl:
          case jr:
            return eV(f, V);
          case an:
            return new fe();
          case En:
          case ol:
            return new fe(f);
          case zt:
            return ble(f);
          case Pt:
            return new fe();
          case St:
            return Tle(f);
        }
      }
      function Ule(f, S) {
        var V = S.length;
        if (!V)
          return f;
        var fe = V - 1;
        return S[fe] = (V > 1 ? "& " : "") + S[fe], S = S.join(V > 2 ? ", " : " "), f.replace(ge, `{
/* [wrapped with ` + S + `] */
`);
      }
      function qle(f) {
        return Dr(f) || ew(f) || !!(K5 && f && f[K5]);
      }
      function bd(f, S) {
        var V = typeof f;
        return S = S ?? me, !!S && (V == "number" || V != "symbol" && zl.test(f)) && f > -1 && f % 1 == 0 && f < S;
      }
      function da(f, S, V) {
        if (!Cu(V))
          return !1;
        var fe = typeof S;
        return (fe == "number" ? Ya(V) && bd(S, V.length) : fe == "string" && S in V) ? Rh(V[S], f) : !1;
      }
      function Kj(f, S) {
        if (Dr(f))
          return !1;
        var V = typeof f;
        return V == "number" || V == "symbol" || V == "boolean" || f == null || wc(f) ? !0 : vn.test(f) || !Ge.test(f) || S != null && f in yi(S);
      }
      function Wle(f) {
        var S = typeof f;
        return S == "string" || S == "number" || S == "symbol" || S == "boolean" ? f !== "__proto__" : f === null;
      }
      function Gj(f) {
        var S = cS(f), V = Je[S];
        if (typeof V != "function" || !(S in c.prototype))
          return !1;
        if (f === V)
          return !0;
        var fe = Wj(V);
        return !!fe && f === fe[0];
      }
      function Hle(f) {
        return !!W5 && W5 in f;
      }
      var zle = Bg ? Td : fA;
      function l_(f) {
        var S = f && f.constructor, V = typeof S == "function" && S.prototype || qp;
        return f === V;
      }
      function yV(f) {
        return f === f && !Cu(f);
      }
      function _V(f, S) {
        return function(V) {
          return V == null ? !1 : V[f] === S && (S !== t || f in yi(V));
        };
      }
      function Kle(f) {
        var S = gS(f, function(fe) {
          return V.size === s && V.clear(), fe;
        }), V = S.cache;
        return S;
      }
      function Gle(f, S) {
        var V = f[1], fe = S[1], We = V | fe, rn = We < (G | J | E), bn = fe == E && V == ce || fe == E && V == P && f[7].length <= S[8] || fe == (E | P) && S[7].length <= S[8] && V == ce;
        if (!(rn || bn))
          return f;
        fe & G && (f[2] = S[2], We |= V & G ? 0 : we);
        var Mn = S[3];
        if (Mn) {
          var Xn = f[3];
          f[3] = Xn ? tV(Xn, Mn, S[4]) : Mn, f[4] = Xn ? fc(f[3], d) : S[4];
        }
        return Mn = S[5], Mn && (Xn = f[5], f[5] = Xn ? lV(Xn, Mn, S[6]) : Mn, f[6] = Xn ? fc(f[5], d) : S[6]), Mn = S[7], Mn && (f[7] = Mn), fe & E && (f[8] = f[8] == null ? S[8] : uo(f[8], S[8])), f[9] == null && (f[9] = S[9]), f[0] = S[0], f[1] = We, f;
      }
      function Zle(f) {
        var S = [];
        if (f != null)
          for (var V in yi(f))
            S.push(V);
        return S;
      }
      function Xle(f) {
        return vd.call(f);
      }
      function xV(f, S, V) {
        return S = zu(S === t ? f.length - 1 : S, 0), function() {
          for (var fe = arguments, We = -1, rn = zu(fe.length - S, 0), bn = pt(rn); ++We < rn; )
            bn[We] = fe[S + We];
          We = -1;
          for (var Mn = pt(S + 1); ++We < S; )
            Mn[We] = fe[We];
          return Mn[S] = V(bn), Wu(f, this, Mn);
        };
      }
      function SV(f, S) {
        return S.length < 2 ? f : Xg(f, Qc(S, 0, -1));
      }
      function Qle(f, S) {
        for (var V = f.length, fe = uo(S.length, V), We = Va(f); fe--; ) {
          var rn = S[fe];
          f[fe] = bd(rn, V) ? We[rn] : t;
        }
        return f;
      }
      function Zj(f, S) {
        if (!(S === "constructor" && typeof f[S] == "function") && S != "__proto__")
          return f[S];
      }
      var EV = kV(HF), r_ = W2 || function(f, S) {
        return au.setTimeout(f, S);
      }, Xj = kV(xle);
      function OV(f, S, V) {
        var fe = S + "";
        return Xj(f, Ule(fe, Jle(Fle(fe), V)));
      }
      function kV(f) {
        var S = 0, V = 0;
        return function() {
          var fe = H2(), We = le - (fe - V);
          if (V = fe, We > 0) {
            if (++S >= Me)
              return arguments[0];
          } else
            S = 0;
          return f.apply(t, arguments);
        };
      }
      function fS(f, S) {
        var V = -1, fe = f.length, We = fe - 1;
        for (S = S === t ? fe : S; ++V < S; ) {
          var rn = Nj(V, We), bn = f[rn];
          f[rn] = f[V], f[V] = bn;
        }
        return f.length = S, f;
      }
      var bV = Kle(function(f) {
        var S = [];
        return f.charCodeAt(0) === 46 && S.push(""), f.replace(Kn, function(V, fe, We, rn) {
          S.push(We ? rn.replace(De, "$1") : fe || V);
        }), S;
      });
      function _f(f) {
        if (typeof f == "string" || wc(f))
          return f;
        var S = f + "";
        return S == "0" && 1 / f == -q ? "-0" : S;
      }
      function Jg(f) {
        if (f != null) {
          try {
            return $1.call(f);
          } catch {
          }
          try {
            return f + "";
          } catch {
          }
        }
        return "";
      }
      function Jle(f, S) {
        return ko(pn, function(V) {
          var fe = "_." + V[0];
          S & V[1] && !cd(f, fe) && f.push(fe);
        }), f.sort();
      }
      function TV(f) {
        if (f instanceof c)
          return f.clone();
        var S = new N(f.__wrapped__, f.__chain__);
        return S.__actions__ = Va(f.__actions__), S.__index__ = f.__index__, S.__values__ = f.__values__, S;
      }
      function ere(f, S, V) {
        (V ? da(f, S, V) : S === t) ? S = 1 : S = zu(Lr(S), 0);
        var fe = f == null ? 0 : f.length;
        if (!fe || S < 1)
          return [];
        for (var We = 0, rn = 0, bn = pt(V1(fe / S)); We < fe; )
          bn[rn++] = Qc(f, We, We += S);
        return bn;
      }
      function nre(f) {
        for (var S = -1, V = f == null ? 0 : f.length, fe = 0, We = []; ++S < V; ) {
          var rn = f[S];
          rn && (We[fe++] = rn);
        }
        return We;
      }
      function tre() {
        var f = arguments.length;
        if (!f)
          return [];
        for (var S = pt(f - 1), V = arguments[0], fe = f; fe--; )
          S[fe - 1] = arguments[fe];
        return Ba(Dr(V) ? Va(V) : [V], jo(S, 1));
      }
      var lre = zr(function(f, S) {
        return ps(f) ? Q2(f, jo(S, 1, ps, !0)) : [];
      }), rre = zr(function(f, S) {
        var V = Jc(S);
        return ps(V) && (V = t), ps(f) ? Q2(f, jo(S, 1, ps, !0), ir(V, 2)) : [];
      }), ire = zr(function(f, S) {
        var V = Jc(S);
        return ps(V) && (V = t), ps(f) ? Q2(f, jo(S, 1, ps, !0), t, V) : [];
      });
      function ure(f, S, V) {
        var fe = f == null ? 0 : f.length;
        return fe ? (S = V || S === t ? 1 : Lr(S), Qc(f, S < 0 ? 0 : S, fe)) : [];
      }
      function sre(f, S, V) {
        var fe = f == null ? 0 : f.length;
        return fe ? (S = V || S === t ? 1 : Lr(S), S = fe - S, Qc(f, 0, S < 0 ? 0 : S)) : [];
      }
      function ore(f, S) {
        return f && f.length ? rS(f, ir(S, 3), !0, !0) : [];
      }
      function are(f, S) {
        return f && f.length ? rS(f, ir(S, 3), !0) : [];
      }
      function cre(f, S, V, fe) {
        var We = f == null ? 0 : f.length;
        return We ? (V && typeof V != "number" && da(f, S, V) && (V = 0, fe = We), tle(f, S, V, fe)) : [];
      }
      function jV(f, S, V) {
        var fe = f == null ? 0 : f.length;
        if (!fe)
          return -1;
        var We = V == null ? 0 : Lr(V);
        return We < 0 && (We = zu(fe + We, 0)), ro(f, ir(S, 3), We);
      }
      function AV(f, S, V) {
        var fe = f == null ? 0 : f.length;
        if (!fe)
          return -1;
        var We = fe - 1;
        return V !== t && (We = Lr(V), We = V < 0 ? zu(fe + We, 0) : uo(We, fe - 1)), ro(f, ir(S, 3), We, !0);
      }
      function DV(f) {
        var S = f == null ? 0 : f.length;
        return S ? jo(f, 1) : [];
      }
      function hre(f) {
        var S = f == null ? 0 : f.length;
        return S ? jo(f, q) : [];
      }
      function fre(f, S) {
        var V = f == null ? 0 : f.length;
        return V ? (S = S === t ? 1 : Lr(S), jo(f, S)) : [];
      }
      function dre(f) {
        for (var S = -1, V = f == null ? 0 : f.length, fe = {}; ++S < V; ) {
          var We = f[S];
          fe[We[0]] = We[1];
        }
        return fe;
      }
      function IV(f) {
        return f && f.length ? f[0] : t;
      }
      function pre(f, S, V) {
        var fe = f == null ? 0 : f.length;
        if (!fe)
          return -1;
        var We = V == null ? 0 : Lr(V);
        return We < 0 && (We = zu(fe + We, 0)), ds(f, S, We);
      }
      function mre(f) {
        var S = f == null ? 0 : f.length;
        return S ? Qc(f, 0, -1) : [];
      }
      var gre = zr(function(f) {
        var S = Kl(f, Lj);
        return S.length && S[0] === f[0] ? jj(S) : [];
      }), wre = zr(function(f) {
        var S = Jc(f), V = Kl(f, Lj);
        return S === Jc(V) ? S = t : V.pop(), V.length && V[0] === f[0] ? jj(V, ir(S, 2)) : [];
      }), vre = zr(function(f) {
        var S = Jc(f), V = Kl(f, Lj);
        return S = typeof S == "function" ? S : t, S && V.pop(), V.length && V[0] === f[0] ? jj(V, t, S) : [];
      });
      function yre(f, S) {
        return f == null ? "" : _j.call(f, S);
      }
      function Jc(f) {
        var S = f == null ? 0 : f.length;
        return S ? f[S - 1] : t;
      }
      function _re(f, S, V) {
        var fe = f == null ? 0 : f.length;
        if (!fe)
          return -1;
        var We = fe;
        return V !== t && (We = Lr(V), We = We < 0 ? zu(fe + We, 0) : uo(We, fe - 1)), S === S ? Y5(f, S, We) : ro(f, Pg, We, !0);
      }
      function xre(f, S) {
        return f && f.length ? YF(f, Lr(S)) : t;
      }
      var Sre = zr(RV);
      function RV(f, S) {
        return f && f.length && S && S.length ? Rj(f, S) : f;
      }
      function Ere(f, S, V) {
        return f && f.length && S && S.length ? Rj(f, S, ir(V, 2)) : f;
      }
      function Ore(f, S, V) {
        return f && f.length && S && S.length ? Rj(f, S, t, V) : f;
      }
      var kre = kd(function(f, S) {
        var V = f == null ? 0 : f.length, fe = Oj(f, S);
        return WF(f, Kl(S, function(We) {
          return bd(We, V) ? +We : We;
        }).sort(nV)), fe;
      });
      function bre(f, S) {
        var V = [];
        if (!(f && f.length))
          return V;
        var fe = -1, We = [], rn = f.length;
        for (S = ir(S, 3); ++fe < rn; ) {
          var bn = f[fe];
          S(bn, fe, f) && (V.push(bn), We.push(fe));
        }
        return WF(f, We), V;
      }
      function Qj(f) {
        return f == null ? f : z2.call(f);
      }
      function Tre(f, S, V) {
        var fe = f == null ? 0 : f.length;
        return fe ? (V && typeof V != "number" && da(f, S, V) ? (S = 0, V = fe) : (S = S == null ? 0 : Lr(S), V = V === t ? fe : Lr(V)), Qc(f, S, V)) : [];
      }
      function jre(f, S) {
        return lS(f, S);
      }
      function Are(f, S, V) {
        return Mj(f, S, ir(V, 2));
      }
      function Dre(f, S) {
        var V = f == null ? 0 : f.length;
        if (V) {
          var fe = lS(f, S);
          if (fe < V && Rh(f[fe], S))
            return fe;
        }
        return -1;
      }
      function Ire(f, S) {
        return lS(f, S, !0);
      }
      function Rre(f, S, V) {
        return Mj(f, S, ir(V, 2), !0);
      }
      function Nre(f, S) {
        var V = f == null ? 0 : f.length;
        if (V) {
          var fe = lS(f, S, !0) - 1;
          if (Rh(f[fe], S))
            return fe;
        }
        return -1;
      }
      function Cre(f) {
        return f && f.length ? zF(f) : [];
      }
      function Mre(f, S) {
        return f && f.length ? zF(f, ir(S, 2)) : [];
      }
      function Pre(f) {
        var S = f == null ? 0 : f.length;
        return S ? Qc(f, 1, S) : [];
      }
      function $re(f, S, V) {
        return f && f.length ? (S = V || S === t ? 1 : Lr(S), Qc(f, 0, S < 0 ? 0 : S)) : [];
      }
      function Lre(f, S, V) {
        var fe = f == null ? 0 : f.length;
        return fe ? (S = V || S === t ? 1 : Lr(S), S = fe - S, Qc(f, S < 0 ? 0 : S, fe)) : [];
      }
      function Bre(f, S) {
        return f && f.length ? rS(f, ir(S, 3), !1, !0) : [];
      }
      function Fre(f, S) {
        return f && f.length ? rS(f, ir(S, 3)) : [];
      }
      var Vre = zr(function(f) {
        return Gp(jo(f, 1, ps, !0));
      }), Yre = zr(function(f) {
        var S = Jc(f);
        return ps(S) && (S = t), Gp(jo(f, 1, ps, !0), ir(S, 2));
      }), Ure = zr(function(f) {
        var S = Jc(f);
        return S = typeof S == "function" ? S : t, Gp(jo(f, 1, ps, !0), t, S);
      });
      function qre(f) {
        return f && f.length ? Gp(f) : [];
      }
      function Wre(f, S) {
        return f && f.length ? Gp(f, ir(S, 2)) : [];
      }
      function Hre(f, S) {
        return S = typeof S == "function" ? S : t, f && f.length ? Gp(f, t, S) : [];
      }
      function Jj(f) {
        if (!(f && f.length))
          return [];
        var S = 0;
        return f = Hu(f, function(V) {
          if (ps(V))
            return S = zu(V.length, S), !0;
        }), gd(S, function(V) {
          return Kl(f, fd(V));
        });
      }
      function NV(f, S) {
        if (!(f && f.length))
          return [];
        var V = Jj(f);
        return S == null ? V : Kl(V, function(fe) {
          return Wu(S, t, fe);
        });
      }
      var zre = zr(function(f, S) {
        return ps(f) ? Q2(f, S) : [];
      }), Kre = zr(function(f) {
        return $j(Hu(f, ps));
      }), Gre = zr(function(f) {
        var S = Jc(f);
        return ps(S) && (S = t), $j(Hu(f, ps), ir(S, 2));
      }), Zre = zr(function(f) {
        var S = Jc(f);
        return S = typeof S == "function" ? S : t, $j(Hu(f, ps), t, S);
      }), Xre = zr(Jj);
      function Qre(f, S) {
        return XF(f || [], S || [], X2);
      }
      function Jre(f, S) {
        return XF(f || [], S || [], n_);
      }
      var eie = zr(function(f) {
        var S = f.length, V = S > 1 ? f[S - 1] : t;
        return V = typeof V == "function" ? (f.pop(), V) : t, NV(f, V);
      });
      function CV(f) {
        var S = Je(f);
        return S.__chain__ = !0, S;
      }
      function nie(f, S) {
        return S(f), f;
      }
      function dS(f, S) {
        return S(f);
      }
      var tie = kd(function(f) {
        var S = f.length, V = S ? f[0] : 0, fe = this.__wrapped__, We = function(rn) {
          return Oj(rn, f);
        };
        return S > 1 || this.__actions__.length || !(fe instanceof c) || !bd(V) ? this.thru(We) : (fe = fe.slice(V, +V + (S ? 1 : 0)), fe.__actions__.push({
          func: dS,
          args: [We],
          thisArg: t
        }), new N(fe, this.__chain__).thru(function(rn) {
          return S && !rn.length && rn.push(t), rn;
        }));
      });
      function lie() {
        return CV(this);
      }
      function rie() {
        return new N(this.value(), this.__chain__);
      }
      function iie() {
        this.__values__ === t && (this.__values__ = KV(this.value()));
        var f = this.__index__ >= this.__values__.length, S = f ? t : this.__values__[this.__index__++];
        return { done: f, value: S };
      }
      function uie() {
        return this;
      }
      function sie(f) {
        for (var S, V = this; V instanceof H1; ) {
          var fe = TV(V);
          fe.__index__ = 0, fe.__values__ = t, S ? We.__wrapped__ = fe : S = fe;
          var We = fe;
          V = V.__wrapped__;
        }
        return We.__wrapped__ = f, S;
      }
      function oie() {
        var f = this.__wrapped__;
        if (f instanceof c) {
          var S = f;
          return this.__actions__.length && (S = new c(this)), S = S.reverse(), S.__actions__.push({
            func: dS,
            args: [Qj],
            thisArg: t
          }), new N(S, this.__chain__);
        }
        return this.thru(Qj);
      }
      function aie() {
        return ZF(this.__wrapped__, this.__actions__);
      }
      var cie = iS(function(f, S, V) {
        Ti.call(f, V) ? ++f[V] : Ed(f, V, 1);
      });
      function hie(f, S, V) {
        var fe = Dr(f) ? ad : nle;
        return V && da(f, S, V) && (S = t), fe(f, ir(S, 3));
      }
      function fie(f, S) {
        var V = Dr(f) ? Hu : NF;
        return V(f, ir(S, 3));
      }
      var die = sV(jV), pie = sV(AV);
      function mie(f, S) {
        return jo(pS(f, S), 1);
      }
      function gie(f, S) {
        return jo(pS(f, S), q);
      }
      function wie(f, S, V) {
        return V = V === t ? 1 : Lr(V), jo(pS(f, S), V);
      }
      function MV(f, S) {
        var V = Dr(f) ? ko : Kp;
        return V(f, ir(S, 3));
      }
      function PV(f, S) {
        var V = Dr(f) ? R1 : RF;
        return V(f, ir(S, 3));
      }
      var vie = iS(function(f, S, V) {
        Ti.call(f, V) ? f[V].push(S) : Ed(f, V, [S]);
      });
      function yie(f, S, V, fe) {
        f = Ya(f) ? f : nv(f), V = V && !fe ? Lr(V) : 0;
        var We = f.length;
        return V < 0 && (V = zu(We + V, 0)), yS(f) ? V <= We && f.indexOf(S, V) > -1 : !!We && ds(f, S, V) > -1;
      }
      var _ie = zr(function(f, S, V) {
        var fe = -1, We = typeof S == "function", rn = Ya(f) ? pt(f.length) : [];
        return Kp(f, function(bn) {
          rn[++fe] = We ? Wu(S, bn, V) : J2(bn, S, V);
        }), rn;
      }), xie = iS(function(f, S, V) {
        Ed(f, V, S);
      });
      function pS(f, S) {
        var V = Dr(f) ? Kl : BF;
        return V(f, ir(S, 3));
      }
      function Sie(f, S, V, fe) {
        return f == null ? [] : (Dr(S) || (S = S == null ? [] : [S]), V = fe ? t : V, Dr(V) || (V = V == null ? [] : [V]), UF(f, S, V));
      }
      var Eie = iS(function(f, S, V) {
        f[V ? 0 : 1].push(S);
      }, function() {
        return [[], []];
      });
      function Oie(f, S, V) {
        var fe = Dr(f) ? hd : pd, We = arguments.length < 3;
        return fe(f, ir(S, 4), V, We, Kp);
      }
      function kie(f, S, V) {
        var fe = Dr(f) ? Rg : pd, We = arguments.length < 3;
        return fe(f, ir(S, 4), V, We, RF);
      }
      function bie(f, S) {
        var V = Dr(f) ? Hu : NF;
        return V(f, wS(ir(S, 3)));
      }
      function Tie(f) {
        var S = Dr(f) ? Z1 : yle;
        return S(f);
      }
      function jie(f, S, V) {
        (V ? da(f, S, V) : S === t) ? S = 1 : S = Lr(S);
        var fe = Dr(f) ? Zte : _le;
        return fe(f, S);
      }
      function Aie(f) {
        var S = Dr(f) ? Xte : Sle;
        return S(f);
      }
      function Die(f) {
        if (f == null)
          return 0;
        if (Ya(f))
          return yS(f) ? wd(f) : f.length;
        var S = Yo(f);
        return S == an || S == Pt ? f.size : Dj(f).length;
      }
      function Iie(f, S, V) {
        var fe = Dr(f) ? $p : Ele;
        return V && da(f, S, V) && (S = t), fe(f, ir(S, 3));
      }
      var Rie = zr(function(f, S) {
        if (f == null)
          return [];
        var V = S.length;
        return V > 1 && da(f, S[0], S[1]) ? S = [] : V > 2 && da(S[0], S[1], S[2]) && (S = [S[0]]), UF(f, jo(S, 1), []);
      }), mS = G5 || function() {
        return au.Date.now();
      };
      function Nie(f, S) {
        if (typeof S != "function")
          throw new ca(o);
        return f = Lr(f), function() {
          if (--f < 1)
            return S.apply(this, arguments);
        };
      }
      function $V(f, S, V) {
        return S = V ? t : S, S = f && S == null ? f.length : S, Od(f, E, t, t, t, t, S);
      }
      function LV(f, S) {
        var V;
        if (typeof S != "function")
          throw new ca(o);
        return f = Lr(f), function() {
          return --f > 0 && (V = S.apply(this, arguments)), f <= 1 && (S = t), V;
        };
      }
      var eA = zr(function(f, S, V) {
        var fe = G;
        if (V.length) {
          var We = fc(V, J1(eA));
          fe |= $e;
        }
        return Od(f, fe, S, V, We);
      }), BV = zr(function(f, S, V) {
        var fe = G | J;
        if (V.length) {
          var We = fc(V, J1(BV));
          fe |= $e;
        }
        return Od(S, fe, f, V, We);
      });
      function FV(f, S, V) {
        S = V ? t : S;
        var fe = Od(f, ce, t, t, t, t, t, S);
        return fe.placeholder = FV.placeholder, fe;
      }
      function VV(f, S, V) {
        S = V ? t : S;
        var fe = Od(f, xe, t, t, t, t, t, S);
        return fe.placeholder = VV.placeholder, fe;
      }
      function YV(f, S, V) {
        var fe, We, rn, bn, Mn, Xn, At = 0, Rt = !1, qt = !1, vl = !0;
        if (typeof f != "function")
          throw new ca(o);
        S = eh(S) || 0, Cu(V) && (Rt = !!V.leading, qt = "maxWait" in V, rn = qt ? zu(eh(V.maxWait) || 0, S) : rn, vl = "trailing" in V ? !!V.trailing : vl);
        function Fl(ms) {
          var Nh = fe, Ad = We;
          return fe = We = t, At = ms, bn = f.apply(Ad, Nh), bn;
        }
        function ar(ms) {
          return At = ms, Mn = r_(ui, S), Rt ? Fl(ms) : bn;
        }
        function Ur(ms) {
          var Nh = ms - Xn, Ad = ms - At, sY = S - Nh;
          return qt ? uo(sY, rn - Ad) : sY;
        }
        function cr(ms) {
          var Nh = ms - Xn, Ad = ms - At;
          return Xn === t || Nh >= S || Nh < 0 || qt && Ad >= rn;
        }
        function ui() {
          var ms = mS();
          if (cr(ms))
            return fi(ms);
          Mn = r_(ui, Ur(ms));
        }
        function fi(ms) {
          return Mn = t, vl && fe ? Fl(ms) : (fe = We = t, bn);
        }
        function vc() {
          Mn !== t && QF(Mn), At = 0, fe = Xn = We = Mn = t;
        }
        function pa() {
          return Mn === t ? bn : fi(mS());
        }
        function yc() {
          var ms = mS(), Nh = cr(ms);
          if (fe = arguments, We = this, Xn = ms, Nh) {
            if (Mn === t)
              return ar(Xn);
            if (qt)
              return QF(Mn), Mn = r_(ui, S), Fl(Xn);
          }
          return Mn === t && (Mn = r_(ui, S)), bn;
        }
        return yc.cancel = vc, yc.flush = pa, yc;
      }
      var Cie = zr(function(f, S) {
        return IF(f, 1, S);
      }), Mie = zr(function(f, S, V) {
        return IF(f, eh(S) || 0, V);
      });
      function Pie(f) {
        return Od(f, K);
      }
      function gS(f, S) {
        if (typeof f != "function" || S != null && typeof S != "function")
          throw new ca(o);
        var V = function() {
          var fe = arguments, We = S ? S.apply(this, fe) : fe[0], rn = V.cache;
          if (rn.has(We))
            return rn.get(We);
          var bn = f.apply(this, fe);
          return V.cache = rn.set(We, bn) || rn, bn;
        };
        return V.cache = new (gS.Cache || wl)(), V;
      }
      gS.Cache = wl;
      function wS(f) {
        if (typeof f != "function")
          throw new ca(o);
        return function() {
          var S = arguments;
          switch (S.length) {
            case 0:
              return !f.call(this);
            case 1:
              return !f.call(this, S[0]);
            case 2:
              return !f.call(this, S[0], S[1]);
            case 3:
              return !f.call(this, S[0], S[1], S[2]);
          }
          return !f.apply(this, S);
        };
      }
      function $ie(f) {
        return LV(2, f);
      }
      var Lie = Ole(function(f, S) {
        S = S.length == 1 && Dr(S[0]) ? Kl(S[0], Gi(ir())) : Kl(jo(S, 1), Gi(ir()));
        var V = S.length;
        return zr(function(fe) {
          for (var We = -1, rn = uo(fe.length, V); ++We < rn; )
            fe[We] = S[We].call(this, fe[We]);
          return Wu(f, this, fe);
        });
      }), nA = zr(function(f, S) {
        var V = fc(S, J1(nA));
        return Od(f, $e, t, S, V);
      }), UV = zr(function(f, S) {
        var V = fc(S, J1(UV));
        return Od(f, je, t, S, V);
      }), Bie = kd(function(f, S) {
        return Od(f, P, t, t, t, S);
      });
      function Fie(f, S) {
        if (typeof f != "function")
          throw new ca(o);
        return S = S === t ? S : Lr(S), zr(f, S);
      }
      function Vie(f, S) {
        if (typeof f != "function")
          throw new ca(o);
        return S = S == null ? 0 : zu(Lr(S), 0), zr(function(V) {
          var fe = V[S], We = Xp(V, 0, S);
          return fe && Ba(We, fe), Wu(f, this, We);
        });
      }
      function Yie(f, S, V) {
        var fe = !0, We = !0;
        if (typeof f != "function")
          throw new ca(o);
        return Cu(V) && (fe = "leading" in V ? !!V.leading : fe, We = "trailing" in V ? !!V.trailing : We), YV(f, S, {
          leading: fe,
          maxWait: S,
          trailing: We
        });
      }
      function Uie(f) {
        return $V(f, 1);
      }
      function qie(f, S) {
        return nA(Bj(S), f);
      }
      function Wie() {
        if (!arguments.length)
          return [];
        var f = arguments[0];
        return Dr(f) ? f : [f];
      }
      function Hie(f) {
        return Xc(f, R);
      }
      function zie(f, S) {
        return S = typeof S == "function" ? S : t, Xc(f, R, S);
      }
      function Kie(f) {
        return Xc(f, p | R);
      }
      function Gie(f, S) {
        return S = typeof S == "function" ? S : t, Xc(f, p | R, S);
      }
      function Zie(f, S) {
        return S == null || DF(f, S, so(S));
      }
      function Rh(f, S) {
        return f === S || f !== f && S !== S;
      }
      var Xie = aS(Tj), Qie = aS(function(f, S) {
        return f >= S;
      }), ew = PF(/* @__PURE__ */ function() {
        return arguments;
      }()) ? PF : function(f) {
        return Ku(f) && Ti.call(f, "callee") && !z5.call(f, "callee");
      }, Dr = pt.isArray, Jie = od ? Gi(od) : sle;
      function Ya(f) {
        return f != null && vS(f.length) && !Td(f);
      }
      function ps(f) {
        return Ku(f) && Ya(f);
      }
      function eue(f) {
        return f === !0 || f === !1 || Ku(f) && fa(f) == Yt;
      }
      var Qp = Wg || fA, nue = Kc ? Gi(Kc) : ole;
      function tue(f) {
        return Ku(f) && f.nodeType === 1 && !i_(f);
      }
      function lue(f) {
        if (f == null)
          return !0;
        if (Ya(f) && (Dr(f) || typeof f == "string" || typeof f.splice == "function" || Qp(f) || ev(f) || ew(f)))
          return !f.length;
        var S = Yo(f);
        if (S == an || S == Pt)
          return !f.size;
        if (l_(f))
          return !Dj(f).length;
        for (var V in f)
          if (Ti.call(f, V))
            return !1;
        return !0;
      }
      function rue(f, S) {
        return e_(f, S);
      }
      function iue(f, S, V) {
        V = typeof V == "function" ? V : t;
        var fe = V ? V(f, S) : t;
        return fe === t ? e_(f, S, t, V) : !!fe;
      }
      function tA(f) {
        if (!Ku(f))
          return !1;
        var S = fa(f);
        return S == fn || S == Cl || typeof f.message == "string" && typeof f.name == "string" && !i_(f);
      }
      function uue(f) {
        return typeof f == "number" && U1(f);
      }
      function Td(f) {
        if (!Cu(f))
          return !1;
        var S = fa(f);
        return S == _e || S == Ve || S == at || S == Nt;
      }
      function qV(f) {
        return typeof f == "number" && f == Lr(f);
      }
      function vS(f) {
        return typeof f == "number" && f > -1 && f % 1 == 0 && f <= me;
      }
      function Cu(f) {
        var S = typeof f;
        return f != null && (S == "object" || S == "function");
      }
      function Ku(f) {
        return f != null && typeof f == "object";
      }
      var WV = Pp ? Gi(Pp) : cle;
      function sue(f, S) {
        return f === S || Aj(f, S, Hj(S));
      }
      function oue(f, S, V) {
        return V = typeof V == "function" ? V : t, Aj(f, S, Hj(S), V);
      }
      function aue(f) {
        return HV(f) && f != +f;
      }
      function cue(f) {
        if (zle(f))
          throw new yr(u);
        return $F(f);
      }
      function hue(f) {
        return f === null;
      }
      function fue(f) {
        return f == null;
      }
      function HV(f) {
        return typeof f == "number" || Ku(f) && fa(f) == En;
      }
      function i_(f) {
        if (!Ku(f) || fa(f) != Vn)
          return !1;
        var S = L1(f);
        if (S === null)
          return !0;
        var V = Ti.call(S, "constructor") && S.constructor;
        return typeof V == "function" && V instanceof V && $1.call(V) == U2;
      }
      var lA = jh ? Gi(jh) : hle;
      function due(f) {
        return qV(f) && f >= -me && f <= me;
      }
      var zV = zs ? Gi(zs) : fle;
      function yS(f) {
        return typeof f == "string" || !Dr(f) && Ku(f) && fa(f) == ol;
      }
      function wc(f) {
        return typeof f == "symbol" || Ku(f) && fa(f) == St;
      }
      var ev = Ah ? Gi(Ah) : dle;
      function pue(f) {
        return f === t;
      }
      function mue(f) {
        return Ku(f) && Yo(f) == ul;
      }
      function gue(f) {
        return Ku(f) && fa(f) == Rr;
      }
      var wue = aS(Ij), vue = aS(function(f, S) {
        return f <= S;
      });
      function KV(f) {
        if (!f)
          return [];
        if (Ya(f))
          return yS(f) ? dc(f) : Va(f);
        if (Yg && f[Yg])
          return C1(f[Yg]());
        var S = Yo(f), V = S == an ? M1 : S == Pt ? Up : nv;
        return V(f);
      }
      function jd(f) {
        if (!f)
          return f === 0 ? f : 0;
        if (f = eh(f), f === q || f === -q) {
          var S = f < 0 ? -1 : 1;
          return S * Ae;
        }
        return f === f ? f : 0;
      }
      function Lr(f) {
        var S = jd(f), V = S % 1;
        return S === S ? V ? S - V : S : 0;
      }
      function GV(f) {
        return f ? Zg(Lr(f), 0, ln) : 0;
      }
      function eh(f) {
        if (typeof f == "number")
          return f;
        if (wc(f))
          return Fe;
        if (Cu(f)) {
          var S = typeof f.valueOf == "function" ? f.valueOf() : f;
          f = Cu(S) ? S + "" : S;
        }
        if (typeof f != "string")
          return f === 0 ? f : +f;
        f = Fp(f);
        var V = ft.test(f);
        return V || Gt.test(f) ? Dg(f.slice(2), V ? 2 : 8) : Tn.test(f) ? Fe : +f;
      }
      function ZV(f) {
        return yf(f, Ua(f));
      }
      function yue(f) {
        return f ? Zg(Lr(f), -me, me) : f === 0 ? f : 0;
      }
      function Fi(f) {
        return f == null ? "" : gc(f);
      }
      var _ue = X1(function(f, S) {
        if (l_(S) || Ya(S)) {
          yf(S, so(S), f);
          return;
        }
        for (var V in S)
          Ti.call(S, V) && X2(f, V, S[V]);
      }), XV = X1(function(f, S) {
        yf(S, Ua(S), f);
      }), _S = X1(function(f, S, V, fe) {
        yf(S, Ua(S), f, fe);
      }), xue = X1(function(f, S, V, fe) {
        yf(S, so(S), f, fe);
      }), Sue = kd(Oj);
      function Eue(f, S) {
        var V = zp(f);
        return S == null ? V : AF(V, S);
      }
      var Oue = zr(function(f, S) {
        f = yi(f);
        var V = -1, fe = S.length, We = fe > 2 ? S[2] : t;
        for (We && da(S[0], S[1], We) && (fe = 1); ++V < fe; )
          for (var rn = S[V], bn = Ua(rn), Mn = -1, Xn = bn.length; ++Mn < Xn; ) {
            var At = bn[Mn], Rt = f[At];
            (Rt === t || Rh(Rt, qp[At]) && !Ti.call(f, At)) && (f[At] = rn[At]);
          }
        return f;
      }), kue = zr(function(f) {
        return f.push(t, pV), Wu(QV, t, f);
      });
      function bue(f, S) {
        return Cg(f, ir(S, 3), vf);
      }
      function Tue(f, S) {
        return Cg(f, ir(S, 3), bj);
      }
      function jue(f, S) {
        return f == null ? f : kj(f, ir(S, 3), Ua);
      }
      function Aue(f, S) {
        return f == null ? f : CF(f, ir(S, 3), Ua);
      }
      function Due(f, S) {
        return f && vf(f, ir(S, 3));
      }
      function Iue(f, S) {
        return f && bj(f, ir(S, 3));
      }
      function Rue(f) {
        return f == null ? [] : nS(f, so(f));
      }
      function Nue(f) {
        return f == null ? [] : nS(f, Ua(f));
      }
      function rA(f, S, V) {
        var fe = f == null ? t : Xg(f, S);
        return fe === t ? V : fe;
      }
      function Cue(f, S) {
        return f != null && wV(f, S, lle);
      }
      function iA(f, S) {
        return f != null && wV(f, S, rle);
      }
      var Mue = aV(function(f, S, V) {
        S != null && typeof S.toString != "function" && (S = vd.call(S)), f[S] = V;
      }, sA(qa)), Pue = aV(function(f, S, V) {
        S != null && typeof S.toString != "function" && (S = vd.call(S)), Ti.call(f, S) ? f[S].push(V) : f[S] = [V];
      }, ir), $ue = zr(J2);
      function so(f) {
        return Ya(f) ? G1(f) : Dj(f);
      }
      function Ua(f) {
        return Ya(f) ? G1(f, !0) : ple(f);
      }
      function Lue(f, S) {
        var V = {};
        return S = ir(S, 3), vf(f, function(fe, We, rn) {
          Ed(V, S(fe, We, rn), fe);
        }), V;
      }
      function Bue(f, S) {
        var V = {};
        return S = ir(S, 3), vf(f, function(fe, We, rn) {
          Ed(V, We, S(fe, We, rn));
        }), V;
      }
      var Fue = X1(function(f, S, V) {
        tS(f, S, V);
      }), QV = X1(function(f, S, V, fe) {
        tS(f, S, V, fe);
      }), Vue = kd(function(f, S) {
        var V = {};
        if (f == null)
          return V;
        var fe = !1;
        S = Kl(S, function(rn) {
          return rn = Zp(rn, f), fe || (fe = rn.length > 1), rn;
        }), yf(f, qj(f), V), fe && (V = Xc(V, p | _ | R, Mle));
        for (var We = S.length; We--; )
          Pj(V, S[We]);
        return V;
      });
      function Yue(f, S) {
        return JV(f, wS(ir(S)));
      }
      var Uue = kd(function(f, S) {
        return f == null ? {} : gle(f, S);
      });
      function JV(f, S) {
        if (f == null)
          return {};
        var V = Kl(qj(f), function(fe) {
          return [fe];
        });
        return S = ir(S), qF(f, V, function(fe, We) {
          return S(fe, We[0]);
        });
      }
      function que(f, S, V) {
        S = Zp(S, f);
        var fe = -1, We = S.length;
        for (We || (We = 1, f = t); ++fe < We; ) {
          var rn = f == null ? t : f[_f(S[fe])];
          rn === t && (fe = We, rn = V), f = Td(rn) ? rn.call(f) : rn;
        }
        return f;
      }
      function Wue(f, S, V) {
        return f == null ? f : n_(f, S, V);
      }
      function Hue(f, S, V, fe) {
        return fe = typeof fe == "function" ? fe : t, f == null ? f : n_(f, S, V, fe);
      }
      var eY = fV(so), nY = fV(Ua);
      function zue(f, S, V) {
        var fe = Dr(f), We = fe || Qp(f) || ev(f);
        if (S = ir(S, 4), V == null) {
          var rn = f && f.constructor;
          We ? V = fe ? new rn() : [] : Cu(f) ? V = Td(rn) ? zp(L1(f)) : {} : V = {};
        }
        return (We ? ko : vf)(f, function(bn, Mn, Xn) {
          return S(V, bn, Mn, Xn);
        }), V;
      }
      function Kue(f, S) {
        return f == null ? !0 : Pj(f, S);
      }
      function Gue(f, S, V) {
        return f == null ? f : GF(f, S, Bj(V));
      }
      function Zue(f, S, V, fe) {
        return fe = typeof fe == "function" ? fe : t, f == null ? f : GF(f, S, Bj(V), fe);
      }
      function nv(f) {
        return f == null ? [] : bi(f, so(f));
      }
      function Xue(f) {
        return f == null ? [] : bi(f, Ua(f));
      }
      function Que(f, S, V) {
        return V === t && (V = S, S = t), V !== t && (V = eh(V), V = V === V ? V : 0), S !== t && (S = eh(S), S = S === S ? S : 0), Zg(eh(f), S, V);
      }
      function Jue(f, S, V) {
        return S = jd(S), V === t ? (V = S, S = 0) : V = jd(V), f = eh(f), ile(f, S, V);
      }
      function ese(f, S, V) {
        if (V && typeof V != "boolean" && da(f, S, V) && (S = V = t), V === t && (typeof S == "boolean" ? (V = S, S = t) : typeof f == "boolean" && (V = f, f = t)), f === t && S === t ? (f = 0, S = 1) : (f = jd(f), S === t ? (S = f, f = 0) : S = jd(S)), f > S) {
          var fe = f;
          f = S, S = fe;
        }
        if (V || f % 1 || S % 1) {
          var We = Hg();
          return uo(f + We * (S - f + sd("1e-" + ((We + "").length - 1))), S);
        }
        return Nj(f, S);
      }
      var nse = Q1(function(f, S, V) {
        return S = S.toLowerCase(), f + (V ? tY(S) : S);
      });
      function tY(f) {
        return uA(Fi(f).toLowerCase());
      }
      function lY(f) {
        return f = Fi(f), f && f.replace(qe, fj).replace(mt, "");
      }
      function tse(f, S, V) {
        f = Fi(f), S = gc(S);
        var fe = f.length;
        V = V === t ? fe : Zg(Lr(V), 0, fe);
        var We = V;
        return V -= S.length, V >= 0 && f.slice(V, We) == S;
      }
      function lse(f) {
        return f = Fi(f), f && Rl.test(f) ? f.replace(Ar, L2) : f;
      }
      function rse(f) {
        return f = Fi(f), f && Pe.test(f) ? f.replace(Un, "\\$&") : f;
      }
      var ise = Q1(function(f, S, V) {
        return f + (V ? "-" : "") + S.toLowerCase();
      }), use = Q1(function(f, S, V) {
        return f + (V ? " " : "") + S.toLowerCase();
      }), sse = uV("toLowerCase");
      function ose(f, S, V) {
        f = Fi(f), S = Lr(S);
        var fe = S ? wd(f) : 0;
        if (!S || fe >= S)
          return f;
        var We = (S - fe) / 2;
        return oS(Y1(We), V) + f + oS(V1(We), V);
      }
      function ase(f, S, V) {
        f = Fi(f), S = Lr(S);
        var fe = S ? wd(f) : 0;
        return S && fe < S ? f + oS(S - fe, V) : f;
      }
      function cse(f, S, V) {
        f = Fi(f), S = Lr(S);
        var fe = S ? wd(f) : 0;
        return S && fe < S ? oS(S - fe, V) + f : f;
      }
      function hse(f, S, V) {
        return V || S == null ? S = 0 : S && (S = +S), Z5(Fi(f).replace(C, ""), S || 0);
      }
      function fse(f, S, V) {
        return (V ? da(f, S, V) : S === t) ? S = 1 : S = Lr(S), Cj(Fi(f), S);
      }
      function dse() {
        var f = arguments, S = Fi(f[0]);
        return f.length < 3 ? S : S.replace(f[1], f[2]);
      }
      var pse = Q1(function(f, S, V) {
        return f + (V ? "_" : "") + S.toLowerCase();
      });
      function mse(f, S, V) {
        return V && typeof V != "number" && da(f, S, V) && (S = V = t), V = V === t ? ln : V >>> 0, V ? (f = Fi(f), f && (typeof S == "string" || S != null && !lA(S)) && (S = gc(S), !S && Yp(f)) ? Xp(dc(f), 0, V) : f.split(S, V)) : [];
      }
      var gse = Q1(function(f, S, V) {
        return f + (V ? " " : "") + uA(S);
      });
      function wse(f, S, V) {
        return f = Fi(f), V = V == null ? 0 : Zg(Lr(V), 0, f.length), S = gc(S), f.slice(V, V + S.length) == S;
      }
      function vse(f, S, V) {
        var fe = Je.templateSettings;
        V && da(f, S, V) && (S = t), f = Fi(f), S = _S({}, S, fe, dV);
        var We = _S({}, S.imports, fe.imports, dV), rn = so(We), bn = bi(We, rn), Mn, Xn, At = 0, Rt = S.interpolate || ae, qt = "__p += '", vl = Y2(
          (S.escape || ae).source + "|" + Rt.source + "|" + (Rt === Ee ? un : ae).source + "|" + (S.evaluate || ae).source + "|$",
          "g"
        ), Fl = "//# sourceURL=" + (Ti.call(S, "sourceURL") ? (S.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++yu + "]") + `
`;
        f.replace(vl, function(cr, ui, fi, vc, pa, yc) {
          return fi || (fi = vc), qt += f.slice(At, yc).replace(Ue, dj), ui && (Mn = !0, qt += `' +
__e(` + ui + `) +
'`), pa && (Xn = !0, qt += `';
` + pa + `;
__p += '`), fi && (qt += `' +
((__t = (` + fi + `)) == null ? '' : __t) +
'`), At = yc + cr.length, cr;
        }), qt += `';
`;
        var ar = Ti.call(S, "variable") && S.variable;
        if (!ar)
          qt = `with (obj) {
` + qt + `
}
`;
        else if (ke.test(ar))
          throw new yr(a);
        qt = (Xn ? qt.replace(Kt, "") : qt).replace(nl, "$1").replace(Pr, "$1;"), qt = "function(" + (ar || "obj") + `) {
` + (ar ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (Mn ? ", __e = _.escape" : "") + (Xn ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + qt + `return __p
}`;
        var Ur = iY(function() {
          return vi(rn, Fl + "return " + qt).apply(t, bn);
        });
        if (Ur.source = qt, tA(Ur))
          throw Ur;
        return Ur;
      }
      function yse(f) {
        return Fi(f).toLowerCase();
      }
      function _se(f) {
        return Fi(f).toUpperCase();
      }
      function xse(f, S, V) {
        if (f = Fi(f), f && (V || S === t))
          return Fp(f);
        if (!f || !(S = gc(S)))
          return f;
        var fe = dc(f), We = dc(S), rn = Vp(fe, We), bn = io(fe, We) + 1;
        return Xp(fe, rn, bn).join("");
      }
      function Sse(f, S, V) {
        if (f = Fi(f), f && (V || S === t))
          return f.slice(0, U5(f) + 1);
        if (!f || !(S = gc(S)))
          return f;
        var fe = dc(f), We = io(fe, dc(S)) + 1;
        return Xp(fe, 0, We).join("");
      }
      function Ese(f, S, V) {
        if (f = Fi(f), f && (V || S === t))
          return f.replace(C, "");
        if (!f || !(S = gc(S)))
          return f;
        var fe = dc(f), We = Vp(fe, dc(S));
        return Xp(fe, We).join("");
      }
      function Ose(f, S) {
        var V = H, fe = U;
        if (Cu(S)) {
          var We = "separator" in S ? S.separator : We;
          V = "length" in S ? Lr(S.length) : V, fe = "omission" in S ? gc(S.omission) : fe;
        }
        f = Fi(f);
        var rn = f.length;
        if (Yp(f)) {
          var bn = dc(f);
          rn = bn.length;
        }
        if (V >= rn)
          return f;
        var Mn = V - wd(fe);
        if (Mn < 1)
          return fe;
        var Xn = bn ? Xp(bn, 0, Mn).join("") : f.slice(0, Mn);
        if (We === t)
          return Xn + fe;
        if (bn && (Mn += Xn.length - Mn), lA(We)) {
          if (f.slice(Mn).search(We)) {
            var At, Rt = Xn;
            for (We.global || (We = Y2(We.source, Fi(gn.exec(We)) + "g")), We.lastIndex = 0; At = We.exec(Rt); )
              var qt = At.index;
            Xn = Xn.slice(0, qt === t ? Mn : qt);
          }
        } else if (f.indexOf(gc(We), Mn) != Mn) {
          var vl = Xn.lastIndexOf(We);
          vl > -1 && (Xn = Xn.slice(0, vl));
        }
        return Xn + fe;
      }
      function kse(f) {
        return f = Fi(f), f && Ml.test(f) ? f.replace(ii, q5) : f;
      }
      var bse = Q1(function(f, S, V) {
        return f + (V ? " " : "") + S.toUpperCase();
      }), uA = uV("toUpperCase");
      function rY(f, S, V) {
        return f = Fi(f), S = V ? t : S, S === t ? B5(f) ? V2(f) : Ng(f) : f.match(S) || [];
      }
      var iY = zr(function(f, S) {
        try {
          return Wu(f, t, S);
        } catch (V) {
          return tA(V) ? V : new yr(V);
        }
      }), Tse = kd(function(f, S) {
        return ko(S, function(V) {
          V = _f(V), Ed(f, V, eA(f[V], f));
        }), f;
      });
      function jse(f) {
        var S = f == null ? 0 : f.length, V = ir();
        return f = S ? Kl(f, function(fe) {
          if (typeof fe[1] != "function")
            throw new ca(o);
          return [V(fe[0]), fe[1]];
        }) : [], zr(function(fe) {
          for (var We = -1; ++We < S; ) {
            var rn = f[We];
            if (Wu(rn[0], this, fe))
              return Wu(rn[1], this, fe);
          }
        });
      }
      function Ase(f) {
        return ele(Xc(f, p));
      }
      function sA(f) {
        return function() {
          return f;
        };
      }
      function Dse(f, S) {
        return f == null || f !== f ? S : f;
      }
      var Ise = oV(), Rse = oV(!0);
      function qa(f) {
        return f;
      }
      function oA(f) {
        return LF(typeof f == "function" ? f : Xc(f, p));
      }
      function Nse(f) {
        return FF(Xc(f, p));
      }
      function Cse(f, S) {
        return VF(f, Xc(S, p));
      }
      var Mse = zr(function(f, S) {
        return function(V) {
          return J2(V, f, S);
        };
      }), Pse = zr(function(f, S) {
        return function(V) {
          return J2(f, V, S);
        };
      });
      function aA(f, S, V) {
        var fe = so(S), We = nS(S, fe);
        V == null && !(Cu(S) && (We.length || !fe.length)) && (V = S, S = f, f = this, We = nS(S, so(S)));
        var rn = !(Cu(V) && "chain" in V) || !!V.chain, bn = Td(f);
        return ko(We, function(Mn) {
          var Xn = S[Mn];
          f[Mn] = Xn, bn && (f.prototype[Mn] = function() {
            var At = this.__chain__;
            if (rn || At) {
              var Rt = f(this.__wrapped__), qt = Rt.__actions__ = Va(this.__actions__);
              return qt.push({ func: Xn, args: arguments, thisArg: f }), Rt.__chain__ = At, Rt;
            }
            return Xn.apply(f, Ba([this.value()], arguments));
          });
        }), f;
      }
      function $se() {
        return au._ === this && (au._ = vj), this;
      }
      function cA() {
      }
      function Lse(f) {
        return f = Lr(f), zr(function(S) {
          return YF(S, f);
        });
      }
      var Bse = Vj(Kl), Fse = Vj(ad), Vse = Vj($p);
      function uY(f) {
        return Kj(f) ? fd(_f(f)) : wle(f);
      }
      function Yse(f) {
        return function(S) {
          return f == null ? t : Xg(f, S);
        };
      }
      var Use = cV(), qse = cV(!0);
      function hA() {
        return [];
      }
      function fA() {
        return !1;
      }
      function Wse() {
        return {};
      }
      function Hse() {
        return "";
      }
      function zse() {
        return !0;
      }
      function Kse(f, S) {
        if (f = Lr(f), f < 1 || f > me)
          return [];
        var V = ln, fe = uo(f, ln);
        S = ir(S), f -= ln;
        for (var We = gd(fe, S); ++V < f; )
          S(V);
        return We;
      }
      function Gse(f) {
        return Dr(f) ? Kl(f, _f) : wc(f) ? [f] : Va(bV(Fi(f)));
      }
      function Zse(f) {
        var S = ++Fg;
        return Fi(f) + S;
      }
      var Xse = sS(function(f, S) {
        return f + S;
      }, 0), Qse = Yj("ceil"), Jse = sS(function(f, S) {
        return f / S;
      }, 1), eoe = Yj("floor");
      function noe(f) {
        return f && f.length ? eS(f, qa, Tj) : t;
      }
      function toe(f, S) {
        return f && f.length ? eS(f, ir(S, 2), Tj) : t;
      }
      function loe(f) {
        return Bp(f, qa);
      }
      function roe(f, S) {
        return Bp(f, ir(S, 2));
      }
      function ioe(f) {
        return f && f.length ? eS(f, qa, Ij) : t;
      }
      function uoe(f, S) {
        return f && f.length ? eS(f, ir(S, 2), Ij) : t;
      }
      var soe = sS(function(f, S) {
        return f * S;
      }, 1), ooe = Yj("round"), aoe = sS(function(f, S) {
        return f - S;
      }, 0);
      function coe(f) {
        return f && f.length ? md(f, qa) : 0;
      }
      function hoe(f, S) {
        return f && f.length ? md(f, ir(S, 2)) : 0;
      }
      return Je.after = Nie, Je.ary = $V, Je.assign = _ue, Je.assignIn = XV, Je.assignInWith = _S, Je.assignWith = xue, Je.at = Sue, Je.before = LV, Je.bind = eA, Je.bindAll = Tse, Je.bindKey = BV, Je.castArray = Wie, Je.chain = CV, Je.chunk = ere, Je.compact = nre, Je.concat = tre, Je.cond = jse, Je.conforms = Ase, Je.constant = sA, Je.countBy = cie, Je.create = Eue, Je.curry = FV, Je.curryRight = VV, Je.debounce = YV, Je.defaults = Oue, Je.defaultsDeep = kue, Je.defer = Cie, Je.delay = Mie, Je.difference = lre, Je.differenceBy = rre, Je.differenceWith = ire, Je.drop = ure, Je.dropRight = sre, Je.dropRightWhile = ore, Je.dropWhile = are, Je.fill = cre, Je.filter = fie, Je.flatMap = mie, Je.flatMapDeep = gie, Je.flatMapDepth = wie, Je.flatten = DV, Je.flattenDeep = hre, Je.flattenDepth = fre, Je.flip = Pie, Je.flow = Ise, Je.flowRight = Rse, Je.fromPairs = dre, Je.functions = Rue, Je.functionsIn = Nue, Je.groupBy = vie, Je.initial = mre, Je.intersection = gre, Je.intersectionBy = wre, Je.intersectionWith = vre, Je.invert = Mue, Je.invertBy = Pue, Je.invokeMap = _ie, Je.iteratee = oA, Je.keyBy = xie, Je.keys = so, Je.keysIn = Ua, Je.map = pS, Je.mapKeys = Lue, Je.mapValues = Bue, Je.matches = Nse, Je.matchesProperty = Cse, Je.memoize = gS, Je.merge = Fue, Je.mergeWith = QV, Je.method = Mse, Je.methodOf = Pse, Je.mixin = aA, Je.negate = wS, Je.nthArg = Lse, Je.omit = Vue, Je.omitBy = Yue, Je.once = $ie, Je.orderBy = Sie, Je.over = Bse, Je.overArgs = Lie, Je.overEvery = Fse, Je.overSome = Vse, Je.partial = nA, Je.partialRight = UV, Je.partition = Eie, Je.pick = Uue, Je.pickBy = JV, Je.property = uY, Je.propertyOf = Yse, Je.pull = Sre, Je.pullAll = RV, Je.pullAllBy = Ere, Je.pullAllWith = Ore, Je.pullAt = kre, Je.range = Use, Je.rangeRight = qse, Je.rearg = Bie, Je.reject = bie, Je.remove = bre, Je.rest = Fie, Je.reverse = Qj, Je.sampleSize = jie, Je.set = Wue, Je.setWith = Hue, Je.shuffle = Aie, Je.slice = Tre, Je.sortBy = Rie, Je.sortedUniq = Cre, Je.sortedUniqBy = Mre, Je.split = mse, Je.spread = Vie, Je.tail = Pre, Je.take = $re, Je.takeRight = Lre, Je.takeRightWhile = Bre, Je.takeWhile = Fre, Je.tap = nie, Je.throttle = Yie, Je.thru = dS, Je.toArray = KV, Je.toPairs = eY, Je.toPairsIn = nY, Je.toPath = Gse, Je.toPlainObject = ZV, Je.transform = zue, Je.unary = Uie, Je.union = Vre, Je.unionBy = Yre, Je.unionWith = Ure, Je.uniq = qre, Je.uniqBy = Wre, Je.uniqWith = Hre, Je.unset = Kue, Je.unzip = Jj, Je.unzipWith = NV, Je.update = Gue, Je.updateWith = Zue, Je.values = nv, Je.valuesIn = Xue, Je.without = zre, Je.words = rY, Je.wrap = qie, Je.xor = Kre, Je.xorBy = Gre, Je.xorWith = Zre, Je.zip = Xre, Je.zipObject = Qre, Je.zipObjectDeep = Jre, Je.zipWith = eie, Je.entries = eY, Je.entriesIn = nY, Je.extend = XV, Je.extendWith = _S, aA(Je, Je), Je.add = Xse, Je.attempt = iY, Je.camelCase = nse, Je.capitalize = tY, Je.ceil = Qse, Je.clamp = Que, Je.clone = Hie, Je.cloneDeep = Kie, Je.cloneDeepWith = Gie, Je.cloneWith = zie, Je.conformsTo = Zie, Je.deburr = lY, Je.defaultTo = Dse, Je.divide = Jse, Je.endsWith = tse, Je.eq = Rh, Je.escape = lse, Je.escapeRegExp = rse, Je.every = hie, Je.find = die, Je.findIndex = jV, Je.findKey = bue, Je.findLast = pie, Je.findLastIndex = AV, Je.findLastKey = Tue, Je.floor = eoe, Je.forEach = MV, Je.forEachRight = PV, Je.forIn = jue, Je.forInRight = Aue, Je.forOwn = Due, Je.forOwnRight = Iue, Je.get = rA, Je.gt = Xie, Je.gte = Qie, Je.has = Cue, Je.hasIn = iA, Je.head = IV, Je.identity = qa, Je.includes = yie, Je.indexOf = pre, Je.inRange = Jue, Je.invoke = $ue, Je.isArguments = ew, Je.isArray = Dr, Je.isArrayBuffer = Jie, Je.isArrayLike = Ya, Je.isArrayLikeObject = ps, Je.isBoolean = eue, Je.isBuffer = Qp, Je.isDate = nue, Je.isElement = tue, Je.isEmpty = lue, Je.isEqual = rue, Je.isEqualWith = iue, Je.isError = tA, Je.isFinite = uue, Je.isFunction = Td, Je.isInteger = qV, Je.isLength = vS, Je.isMap = WV, Je.isMatch = sue, Je.isMatchWith = oue, Je.isNaN = aue, Je.isNative = cue, Je.isNil = fue, Je.isNull = hue, Je.isNumber = HV, Je.isObject = Cu, Je.isObjectLike = Ku, Je.isPlainObject = i_, Je.isRegExp = lA, Je.isSafeInteger = due, Je.isSet = zV, Je.isString = yS, Je.isSymbol = wc, Je.isTypedArray = ev, Je.isUndefined = pue, Je.isWeakMap = mue, Je.isWeakSet = gue, Je.join = yre, Je.kebabCase = ise, Je.last = Jc, Je.lastIndexOf = _re, Je.lowerCase = use, Je.lowerFirst = sse, Je.lt = wue, Je.lte = vue, Je.max = noe, Je.maxBy = toe, Je.mean = loe, Je.meanBy = roe, Je.min = ioe, Je.minBy = uoe, Je.stubArray = hA, Je.stubFalse = fA, Je.stubObject = Wse, Je.stubString = Hse, Je.stubTrue = zse, Je.multiply = soe, Je.nth = xre, Je.noConflict = $se, Je.noop = cA, Je.now = mS, Je.pad = ose, Je.padEnd = ase, Je.padStart = cse, Je.parseInt = hse, Je.random = ese, Je.reduce = Oie, Je.reduceRight = kie, Je.repeat = fse, Je.replace = dse, Je.result = que, Je.round = ooe, Je.runInContext = Hn, Je.sample = Tie, Je.size = Die, Je.snakeCase = pse, Je.some = Iie, Je.sortedIndex = jre, Je.sortedIndexBy = Are, Je.sortedIndexOf = Dre, Je.sortedLastIndex = Ire, Je.sortedLastIndexBy = Rre, Je.sortedLastIndexOf = Nre, Je.startCase = gse, Je.startsWith = wse, Je.subtract = aoe, Je.sum = coe, Je.sumBy = hoe, Je.template = vse, Je.times = Kse, Je.toFinite = jd, Je.toInteger = Lr, Je.toLength = GV, Je.toLower = yse, Je.toNumber = eh, Je.toSafeInteger = yue, Je.toString = Fi, Je.toUpper = _se, Je.trim = xse, Je.trimEnd = Sse, Je.trimStart = Ese, Je.truncate = Ose, Je.unescape = kse, Je.uniqueId = Zse, Je.upperCase = bse, Je.upperFirst = uA, Je.each = MV, Je.eachRight = PV, Je.first = IV, aA(Je, function() {
        var f = {};
        return vf(Je, function(S, V) {
          Ti.call(Je.prototype, V) || (f[V] = S);
        }), f;
      }(), { chain: !1 }), Je.VERSION = l, ko(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(f) {
        Je[f].placeholder = Je;
      }), ko(["drop", "take"], function(f, S) {
        c.prototype[f] = function(V) {
          V = V === t ? 1 : zu(Lr(V), 0);
          var fe = this.__filtered__ && !S ? new c(this) : this.clone();
          return fe.__filtered__ ? fe.__takeCount__ = uo(V, fe.__takeCount__) : fe.__views__.push({
            size: uo(V, ln),
            type: f + (fe.__dir__ < 0 ? "Right" : "")
          }), fe;
        }, c.prototype[f + "Right"] = function(V) {
          return this.reverse()[f](V).reverse();
        };
      }), ko(["filter", "map", "takeWhile"], function(f, S) {
        var V = S + 1, fe = V == Ce || V == B;
        c.prototype[f] = function(We) {
          var rn = this.clone();
          return rn.__iteratees__.push({
            iteratee: ir(We, 3),
            type: V
          }), rn.__filtered__ = rn.__filtered__ || fe, rn;
        };
      }), ko(["head", "last"], function(f, S) {
        var V = "take" + (S ? "Right" : "");
        c.prototype[f] = function() {
          return this[V](1).value()[0];
        };
      }), ko(["initial", "tail"], function(f, S) {
        var V = "drop" + (S ? "" : "Right");
        c.prototype[f] = function() {
          return this.__filtered__ ? new c(this) : this[V](1);
        };
      }), c.prototype.compact = function() {
        return this.filter(qa);
      }, c.prototype.find = function(f) {
        return this.filter(f).head();
      }, c.prototype.findLast = function(f) {
        return this.reverse().find(f);
      }, c.prototype.invokeMap = zr(function(f, S) {
        return typeof f == "function" ? new c(this) : this.map(function(V) {
          return J2(V, f, S);
        });
      }), c.prototype.reject = function(f) {
        return this.filter(wS(ir(f)));
      }, c.prototype.slice = function(f, S) {
        f = Lr(f);
        var V = this;
        return V.__filtered__ && (f > 0 || S < 0) ? new c(V) : (f < 0 ? V = V.takeRight(-f) : f && (V = V.drop(f)), S !== t && (S = Lr(S), V = S < 0 ? V.dropRight(-S) : V.take(S - f)), V);
      }, c.prototype.takeRightWhile = function(f) {
        return this.reverse().takeWhile(f).reverse();
      }, c.prototype.toArray = function() {
        return this.take(ln);
      }, vf(c.prototype, function(f, S) {
        var V = /^(?:filter|find|map|reject)|While$/.test(S), fe = /^(?:head|last)$/.test(S), We = Je[fe ? "take" + (S == "last" ? "Right" : "") : S], rn = fe || /^find/.test(S);
        We && (Je.prototype[S] = function() {
          var bn = this.__wrapped__, Mn = fe ? [1] : arguments, Xn = bn instanceof c, At = Mn[0], Rt = Xn || Dr(bn), qt = function(ui) {
            var fi = We.apply(Je, Ba([ui], Mn));
            return fe && vl ? fi[0] : fi;
          };
          Rt && V && typeof At == "function" && At.length != 1 && (Xn = Rt = !1);
          var vl = this.__chain__, Fl = !!this.__actions__.length, ar = rn && !vl, Ur = Xn && !Fl;
          if (!rn && Rt) {
            bn = Ur ? bn : new c(this);
            var cr = f.apply(bn, Mn);
            return cr.__actions__.push({ func: dS, args: [qt], thisArg: t }), new N(cr, vl);
          }
          return ar && Ur ? f.apply(this, Mn) : (cr = this.thru(qt), ar ? fe ? cr.value()[0] : cr.value() : cr);
        });
      }), ko(["pop", "push", "shift", "sort", "splice", "unshift"], function(f) {
        var S = Gc[f], V = /^(?:push|sort|unshift)$/.test(f) ? "tap" : "thru", fe = /^(?:pop|shift)$/.test(f);
        Je.prototype[f] = function() {
          var We = arguments;
          if (fe && !this.__chain__) {
            var rn = this.value();
            return S.apply(Dr(rn) ? rn : [], We);
          }
          return this[V](function(bn) {
            return S.apply(Dr(bn) ? bn : [], We);
          });
        };
      }), vf(c.prototype, function(f, S) {
        var V = Je[S];
        if (V) {
          var fe = V.name + "";
          Ti.call(xd, fe) || (xd[fe] = []), xd[fe].push({ name: S, func: V });
        }
      }), xd[uS(t, J).name] = [{
        name: "wrapper",
        func: t
      }], c.prototype.clone = m, c.prototype.reverse = k, c.prototype.value = M, Je.prototype.at = tie, Je.prototype.chain = lie, Je.prototype.commit = rie, Je.prototype.next = iie, Je.prototype.plant = sie, Je.prototype.reverse = oie, Je.prototype.toJSON = Je.prototype.valueOf = Je.prototype.value = aie, Je.prototype.first = Je.prototype.head, Yg && (Je.prototype[Yg] = uie), Je;
    }, Hr = gj();
    La ? ((La.exports = Hr)._ = Hr, _u._ = Hr) : au._ = Hr;
  }).call(zd);
})(m4, m4.exports);
var qte = m4.exports;
const A6e = /* @__PURE__ */ mte(qte), jF = cl({
  name: "lp-modal",
  inheritAttrs: !1,
  props: {
    size: { type: String, default: "md" },
    container: { type: String, default: "body" },
    modelValue: { type: Boolean, default: !1 },
    minHeight: { type: String, default: "500px" },
    closableMask: { type: Boolean, default: !0 },
    closeOnEsc: { type: Boolean, default: !0 },
    compact: { type: Boolean, default: !1 },
    closable: { type: Boolean, default: !0 },
    priorityPosition: { type: Boolean },
    autoHeight: { type: Boolean, default: !1 },
    withoutFocusTrap: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue", "modal-close", "after-close-animation"],
  setup(e, { emit: n, slots: t }) {
    const l = dt(), r = ow(t, "header") !== null, u = ow(t, "body") !== null, o = ow(t, "actions") !== null, a = ow(t, "image") !== null, h = dt(), s = dt(), d = dt(0), p = dt(0), _ = dt(0), R = dt(K()), F = dt(K()), L = v4(), { hasFocus: G, activate: J, deactivate: we } = Ute(l);
    function ce() {
      n("update:modelValue", !1), n("modal-close", !0);
    }
    function xe() {
      e.closableMask && ce();
    }
    function $e(H) {
      H.code === "Escape" && ce();
    }
    di(
      () => e.modelValue,
      async (H) => {
        await Ta();
        const U = L.appContext.config.globalProperties.$LpComponents.drawers;
        l.value && (H ? (U.push(h.value), U.slice(0, U.indexOf(h.value)).forEach((Me) => {
          if (Me.style.transform !== "") {
            const le = Me.style.transform.match(/[-+]?[0-9]*\.?[0-9]+/g)?.map((Ce) => parseFloat(Ce));
            Me.style.transform = `scale(${le[0] - 0.05}) translateY(${le[1] - 5}%)`;
          } else
            Me.style.transform = "scale(0.9) translateY(5%)";
        }), Mte(l.value, { reserveScrollBarGap: !0 }), e.closeOnEsc && document.addEventListener("keydown", $e), e.withoutFocusTrap || J()) : (U.splice(U.indexOf(h.value), 1), U.forEach((Me, le) => {
          if (le === U.length - 1) {
            Me.style.transform = "";
            return;
          }
          const Ce = Me.style.transform.match(/[-+]?[0-9]*\.?[0-9]+/g)?.map((Ye) => parseFloat(Ye));
          Me.style.transform = `scale(${Ce[0] + 0.05}) translateY(${Ce[1] + 5}%)`;
        }), h.value && (h.value.style.transform = ""), e.withoutFocusTrap || we(), setTimeout(Pte.bind(this, l.value), 500), document.removeEventListener("keydown", $e)));
      }
    );
    const je = _t(() => a && !r && !u && !o);
    function E(H) {
      n("after-close-animation", H);
    }
    function P() {
      s.value && (d.value = s.value?.scrollHeight, p.value = s.value?.scrollTop, _.value = s.value?.clientHeight, F.value = K() ? Math.abs(
        d.value - _.value - p.value
      ) <= 1 : !1, R.value = p.value !== 0);
    }
    ga(() => {
      d.value = s.value?.scrollHeight, _.value = s.value?.clientHeight, K() && F.value;
    });
    function K() {
      return Ta().then(() => {
        d.value = s.value?.scrollHeight, _.value = s.value?.clientHeight;
      }), d.value > _.value;
    }
    return {
      modalRef: l,
      modalBody: h,
      maskClick: xe,
      hasFocus: G,
      itHasHeader: r,
      itHasBody: u,
      itHasActions: o,
      close: ce,
      onlyImageSlot: je,
      onAfterLeave: E,
      isScrolledTop: R,
      isScrolledBottom: F,
      bodyRef: s,
      bodyRefScrollHeight: d,
      bodyRefScrollTop: p,
      bodyRefClientHeight: _,
      calculateOffset: P,
      canScroll: K
    };
  }
}), dz = () => {
  Ez((e) => ({
    "93675ebe": e.minHeight
  }));
}, pz = jF.setup;
jF.setup = pz ? (e, n) => (dz(), pz(e, n)) : dz;
const D6e = { class: "lp-modal-wrap" };
function I6e(e, n, t, l, r, u) {
  const o = El("lp-icon");
  return Qe(), _l(v3, { to: e.container }, [
    dl(du, {
      name: "fade",
      onAfterLeave: e.onAfterLeave
    }, {
      default: kl(() => [
        pi(qn("div", Ni(e.$attrs, {
          ref: "modalRef",
          class: ["lp-modal-mask", [e.priorityPosition && "lp-modal-mask--priority-position"]],
          "data-ua-unique-id": "unique-modal",
          role: "presentation",
          style: { cursor: e.closableMask ? "pointer" : "default" }
        }), [
          dl(du, { name: "drop-top" }, {
            default: kl(() => [
              pi(qn("div", D6e, [
                qn("div", {
                  class: "lp-modal-wrap-inner",
                  tabindex: "0",
                  "data-testid": "modal-mask",
                  onClick: n[2] || (n[2] = Oi((...a) => e.maskClick && e.maskClick(...a), ["self"]))
                }, [
                  qn("div", {
                    ref: "modalBody",
                    class: xt(["lp-modal-body", [
                      e.size ? `modal-${e.size}` : "",
                      e.onlyImageSlot ? "lp-modal-body-has-image" : ""
                    ]])
                  }, [
                    e.itHasHeader ? (Qe(), yn("div", {
                      key: 0,
                      class: xt([
                        "lp-modal-header ly-row ly-spacebetween-start",
                        e.isScrolledTop && "shadow-lg border-bottom border-gray-light"
                      ])
                    }, [
                      el(e.$slots, "header"),
                      e.closable ? (Qe(), _l(o, {
                        key: 0,
                        name: "close",
                        class: "mt-half cursor-pointer",
                        role: "button",
                        onClick: n[0] || (n[0] = (a) => e.close())
                      })) : st("", !0)
                    ], 2)) : st("", !0),
                    e.itHasBody ? (Qe(), yn("div", {
                      key: 1,
                      ref: "bodyRef",
                      class: xt(["lp-modal-content", [
                        e.compact && "compact",
                        !e.autoHeight && "lp-modal-content-min-height",
                        e.autoHeight && "lp-modal-content-auto-height"
                      ]]),
                      onScroll: n[1] || (n[1] = (...a) => e.calculateOffset && e.calculateOffset(...a))
                    }, [
                      el(e.$slots, "body")
                    ], 34)) : st("", !0),
                    e.itHasActions ? (Qe(), yn("div", {
                      key: 2,
                      class: xt([
                        "lp-modal-footer",
                        e.canScroll() && !e.isScrolledBottom && "shadow-lg-inner border-top border-gray-light"
                      ])
                    }, [
                      el(e.$slots, "actions")
                    ], 2)) : st("", !0)
                  ], 2)
                ])
              ], 512), [
                [Pi, e.modelValue]
              ])
            ]),
            _: 3
          })
        ], 16), [
          [Pi, e.modelValue]
        ])
      ]),
      _: 3
    }, 8, ["onAfterLeave"])
  ], 8, ["to"]);
}
const J_ = /* @__PURE__ */ Cr(jF, [["render", I6e]]);
J_.install = (e) => {
  e.component(J_.name, J_);
};
const R6e = ["src", "alt"], N6e = /* @__PURE__ */ cl({
  name: "lp-guided-tour-step-image",
  __name: "LpGuidedTourStepImage",
  props: {
    image: {},
    alt: {},
    onLoad: { type: Function }
  },
  setup(e) {
    return (n, t) => (Qe(), yn("img", Ni({
      src: n.image,
      alt: n.alt,
      class: "img-fluid"
    }, n.$attrs, {
      onLoad: t[0] || (t[0] = (l) => n.onLoad && n.onLoad())
    }), null, 16, R6e));
  }
});
var Wte = /* @__PURE__ */ ((e) => (e.CLASSIC = "classic", e.NEW_FEATURE = "new-feature", e.NEW_USER = "new-user", e))(Wte || {});
const C6e = cl({
  name: "lp-guided-tour",
  components: {
    LpGuidedTourStepImage: N6e,
    LpModal: J_,
    LpButton: R_
  },
  props: {
    steps: {
      type: Array,
      default: () => [],
      required: !0
    },
    modelValue: {
      type: Boolean,
      default: !1,
      required: !0
    },
    startingStep: {
      type: Number,
      default: 0
    },
    autoposition: {
      type: Boolean,
      default: !0
    },
    dataUaUniqueId: {
      type: String,
      default: "unique-guided-tour"
    },
    withScrim: {
      type: Boolean,
      default: !0
    },
    startTranslation: {
      type: String,
      default: "Next"
    },
    nextTranslation: {
      type: String,
      default: "Next"
    },
    backTranslation: {
      type: String,
      default: "Back"
    },
    skipTranslation: {
      type: String,
      default: "Skip"
    },
    finishTranslation: {
      type: String,
      default: "Finish"
    },
    closeTranslation: {
      type: String,
      default: "Close"
    },
    introductionStyle: {
      type: String,
      default: "classic",
      validation: (e) => [
        "classic",
        "new-feature",
        "new-user"
        /* NEW_USER */
      ].includes(e)
    },
    highlightTargetElement: {
      type: Boolean
    },
    closeWarningTitle: {
      type: String,
      default: void 0
    },
    closeWarningContent: {
      type: String,
      default: void 0
    },
    closeWarningStayButton: {
      type: String,
      default: "Stay"
    },
    closeWarningExitButton: {
      type: String,
      default: "Exit"
    },
    disableTeleport: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["step:next", "previous:next", "finish", "skip"],
  setup(e, { emit: n }) {
    const t = v4(), l = dt(e.steps), r = dt(e.modelValue), u = dt(e.startingStep), o = dt(null), a = dt(!1), h = _t(() => r.value), s = _t(() => e.steps[u.value]), d = _t(
      () => s.value && s.value.selector ? document.querySelector(s.value.selector) : null
    ), p = _t(() => s.value.position), _ = dt(null), { placement: R, position: F, trigger: L, setPopoverPosition: G } = l2({
      ...e,
      trigger: d,
      popover: _,
      placement: p,
      disableSetPosition: !0
    }), J = _t(() => {
      if (!R.value || R.value === sl.C) return "";
      const U = R.value;
      try {
        const [Me, le] = U.split("-");
        return `card-arrow arrow-${oY(Me)}${le ? `-${oY(le)}` : ""}`;
      } catch (Me) {
        return console.error(Me), "";
      }
    });
    di(
      () => L.value,
      () => {
        e.highlightTargetElement && (o.value && (o.value.classList.remove(
          "guided-tour-highlight-element"
        ), o.value = null), L.value && (L.value.classList.add("guided-tour-highlight-element"), o.value = L.value));
      }
    ), di(
      () => s.value,
      () => {
        G();
      }
    );
    const we = _t(() => {
      const U = {
        top: "inherit",
        left: "inherit"
      };
      return F.value && (U.left = `${F.value.x}px`, U.top = `${F.value.y}px`), U;
    }), ce = () => {
      u.value++, n("step:next"), t?.proxy?.$forceUpdate();
    }, xe = () => {
      u.value--, n("previous:next");
    }, $e = () => {
      u.value = 0, r.value = !1, a.value = !1, n("finish");
    }, je = () => {
      !e.closeWarningTitle && !e.closeWarningContent ? (u.value = 0, r.value = !1, a.value = !1, n("finish")) : a.value = !0;
    }, E = () => {
      u.value = 0, r.value = !1, a.value = !1, n("skip");
    };
    function P(U) {
      r.value && (U.key === "ArrowRight" && (u.value === l.value.length - 1 ? $e() : ce()), U.key === "ArrowLeft" && u.value > 0 && xe(), U.key === "Escape" && $e());
    }
    cf(() => {
      document.body.addEventListener("keyup", P);
    }), g4(() => {
      document.body.removeEventListener("keyup", P);
    }), di(
      () => e.modelValue,
      (U) => {
        r.value = U;
      }
    );
    const K = _t(
      () => e.introductionStyle !== "classic"
      /* CLASSIC */
    ), H = _t(
      () => K.value && s.value.img && u.value === 0
    );
    return {
      activeIndex: u,
      currentStep: s,
      isOpen: h,
      nextStep: ce,
      previousStep: xe,
      finish: $e,
      abort: je,
      skip: E,
      currentStepEl: _,
      placement: R,
      arrowPlacement: J,
      currentStepPosition: we,
      setPopoverPosition: G,
      GuidedTourIntroductionStepStyles: Wte,
      isNewLayout: K,
      hasImageAndIsNewLayout: H,
      confirmModalState: a
    };
  },
  methods: { has: qte.has }
}), M6e = { class: "pb-2 d-block" }, P6e = { class: "my-1 ly-row ly-end-center" }, $6e = {
  key: 1,
  class: "guided-tour-scrim"
}, L6e = ["id", "data-ua-unique-id"], B6e = ["aria-label"], F6e = /* @__PURE__ */ qn("i", { class: "lpi-times text-dark-muted" }, null, -1), V6e = [
  F6e
], Y6e = ["innerHTML"], U6e = { class: "guided-tour-step--footer" }, q6e = ["aria-label"], W6e = ["aria-label"], H6e = {
  key: 2,
  class: "ly-row ly-spacebetween-center"
}, z6e = { class: "ly-row" }, K6e = ["aria-label"], G6e = ["aria-label"], Z6e = ["aria-label"], X6e = ["aria-label"];
function Q6e(e, n, t, l, r, u) {
  const o = El("lp-button"), a = El("lp-modal"), h = El("lp-guided-tour-step-image");
  return Qe(), yn(Ii, null, [
    e.closeWarningTitle && e.closeWarningContent ? (Qe(), _l(a, {
      key: 0,
      modelValue: e.confirmModalState,
      "onUpdate:modelValue": n[1] || (n[1] = (s) => e.confirmModalState = s),
      closable: !1,
      size: "sm",
      compact: "",
      "priority-position": ""
    }, {
      header: kl(() => [
        Ir(It(e.closeWarningTitle), 1)
      ]),
      body: kl(() => [
        qn("div", null, [
          qn("span", M6e, It(e.closeWarningContent), 1),
          qn("div", P6e, [
            dl(o, {
              class: "text-dark text-small font-weight-bold border-gunmetal-14",
              onClick: n[0] || (n[0] = (s) => e.confirmModalState = !1)
            }, {
              default: kl(() => [
                Ir(It(e.closeWarningStayButton), 1)
              ]),
              _: 1
            }),
            dl(o, {
              class: "text-dark text-small font-weight-bold border-gunmetal-14",
              onClick: e.finish
            }, {
              default: kl(() => [
                Ir(It(e.closeWarningExitButton), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])) : st("", !0),
    e.isOpen && e.withScrim ? (Qe(), yn("div", $6e)) : st("", !0),
    (Qe(), _l(v3, {
      to: "body",
      disabled: e.disableTeleport
    }, [
      e.isOpen ? (Qe(), yn("div", {
        id: `step${e.activeIndex}`,
        key: e.activeIndex,
        ref: "currentStepEl",
        "data-ua-unique-id": e.dataUaUniqueId,
        class: xt(["guided-tour-step card p-absolute", [
          e.activeIndex !== 0 && e.placement ? `${e.arrowPlacement} ${e.placement}` : "",
          e.activeIndex === 0 ? "initial-step" : "",
          `step-${e.currentStep.size}`,
          e.currentStep.forceSize && "force-size",
          e.isNewLayout && e.activeIndex === 0 && "new-layout"
        ]]),
        style: Hi(
          e.activeIndex === 0 ? "position: fixed; top: 50%;" : `top: ${e.currentStepPosition.top}; left: ${e.currentStepPosition.left}`
        ),
        role: "dialog",
        "aria-modal": "true"
      }, [
        qn("div", {
          class: xt(["guided-tour-step--header", [
            !e.hasImageAndIsNewLayout && "ly-row ly-spacebetween-start",
            e.hasImageAndIsNewLayout && "ly-col"
          ]])
        }, [
          e.hasImageAndIsNewLayout ? (Qe(), _l(h, {
            key: 0,
            class: xt([e.hasImageAndIsNewLayout]),
            image: e.currentStep.img,
            "on-load": e.setPopoverPosition
          }, null, 8, ["class", "image", "on-load"])) : st("", !0),
          qn("p", {
            class: xt(["guided-tour-step--header--title h4", [
              e.isNewLayout && "text-center h5 mb-1",
              !e.isNewLayout && "h4",
              e.hasImageAndIsNewLayout && "mt-2"
            ]])
          }, It(e.currentStep.title), 3),
          e.hasImageAndIsNewLayout ? st("", !0) : (Qe(), yn("a", {
            key: 1,
            role: "button",
            "aria-label": e.closeTranslation,
            onClick: n[2] || (n[2] = (...s) => e.abort && e.abort(...s))
          }, V6e, 8, B6e))
        ], 2),
        e.currentStep.asHtml ? st("", !0) : (Qe(), yn("p", {
          key: 0,
          class: xt(["guided-tour-step--text", [e.isNewLayout && "mb-2"]])
        }, It(e.currentStep.text), 3)),
        e.currentStep.asHtml ? (Qe(), yn("p", {
          key: 1,
          class: xt([e.isNewLayout && "mb-2"]),
          innerHTML: e.currentStep.text
        }, null, 10, Y6e)) : st("", !0),
        e.introductionStyle === e.GuidedTourIntroductionStepStyles.CLASSIC && e.currentStep.img ? (Qe(), _l(h, {
          key: 2,
          image: e.currentStep.img,
          "on-load": e.setPopoverPosition
        }, null, 8, ["image", "on-load"])) : st("", !0),
        qn("div", U6e, [
          e.activeIndex === 0 ? (Qe(), yn("div", {
            key: 0,
            class: xt(["guided-tour-step--footer-actions", [
              e.isNewLayout && "ly-even ly-row-reverse ly-spacearound-center"
            ]])
          }, [
            e.activeIndex === 0 ? (Qe(), yn("a", {
              key: 0,
              class: xt(["btn btn-primary", [e.isNewLayout && "np", !e.isNewLayout && "w-100"]]),
              role: "button",
              tabindex: "0",
              "aria-label": e.startTranslation,
              onClick: n[3] || (n[3] = (...s) => e.nextStep && e.nextStep(...s)),
              onKeyup: [
                n[4] || (n[4] = Ei((...s) => e.nextStep && e.nextStep(...s), ["enter"])),
                n[5] || (n[5] = Ei((...s) => e.nextStep && e.nextStep(...s), ["space"]))
              ]
            }, It(e.startTranslation), 43, q6e)) : st("", !0),
            e.activeIndex === 0 ? (Qe(), yn("a", {
              key: 1,
              class: xt(["d-block text-center", [
                e.isNewLayout && "btn btn-neutral text-dark border-gunmetal-14",
                !e.isNewLayout && "pt-1 text-dark-muted text-hover-blue"
              ]]),
              tabindex: "0",
              role: "button",
              "aria-label": e.skipTranslation,
              onClick: n[6] || (n[6] = (...s) => e.finish && e.finish(...s)),
              onKeyup: [
                n[7] || (n[7] = Ei((...s) => e.finish && e.finish(...s), ["enter"])),
                n[8] || (n[8] = Ei((...s) => e.finish && e.finish(...s), ["space"]))
              ]
            }, It(e.skipTranslation), 43, W6e)) : st("", !0)
          ], 2)) : st("", !0),
          e.activeIndex === 0 && e.isNewLayout ? (Qe(), yn("div", {
            key: 1,
            class: xt([e.isNewLayout && "mt-1 text-center text-gunmetal-52 w-100"])
          }, It(e.activeIndex) + " of " + It(e.steps.length - 1), 3)) : st("", !0),
          e.activeIndex !== 0 ? (Qe(), yn("div", H6e, [
            qn("span", z6e, [
              qn("span", {
                class: xt([e.isNewLayout && "text-gunmetal-52"])
              }, It(e.activeIndex) + "/" + It(e.steps.length - 1), 3),
              e.activeIndex !== 0 && !e.isNewLayout ? (Qe(), yn("a", {
                key: 0,
                class: "d-block text-center text-dark-muted text-hover-blue ml-1",
                tabindex: "0",
                role: "button",
                "aria-label": e.skipTranslation,
                onClick: n[9] || (n[9] = (...s) => e.finish && e.finish(...s)),
                onKeyup: [
                  n[10] || (n[10] = Ei((...s) => e.finish && e.finish(...s), ["enter"])),
                  n[11] || (n[11] = Ei((...s) => e.finish && e.finish(...s), ["space"]))
                ]
              }, It(e.skipTranslation), 41, K6e)) : st("", !0)
            ]),
            qn("div", null, [
              e.activeIndex > 1 ? (Qe(), yn("a", {
                key: 0,
                class: xt(["btn mr-1", [e.isNewLayout && "no-border"]]),
                tabindex: "0",
                role: "button",
                "aria-label": e.backTranslation,
                onKeyup: [
                  n[12] || (n[12] = Ei((...s) => e.previousStep && e.previousStep(...s), ["enter"])),
                  n[13] || (n[13] = Ei((...s) => e.previousStep && e.previousStep(...s), ["space"]))
                ],
                onClick: n[14] || (n[14] = (...s) => e.previousStep && e.previousStep(...s))
              }, It(e.backTranslation), 43, G6e)) : st("", !0),
              e.activeIndex !== e.steps.length - 1 ? (Qe(), yn("a", {
                key: 1,
                class: "btn btn-primary",
                tabindex: "0",
                role: "button",
                "aria-label": e.nextTranslation,
                onClick: n[15] || (n[15] = (...s) => e.nextStep && e.nextStep(...s)),
                onKeyup: [
                  n[16] || (n[16] = Ei((...s) => e.nextStep && e.nextStep(...s), ["enter"])),
                  n[17] || (n[17] = Ei((...s) => e.nextStep && e.nextStep(...s), ["space"]))
                ]
              }, It(e.nextTranslation), 41, Z6e)) : st("", !0),
              e.activeIndex === e.steps.length - 1 ? (Qe(), yn("a", {
                key: 2,
                class: "btn btn-primary",
                tabindex: "0",
                role: "button",
                "aria-label": e.finishTranslation,
                onClick: n[18] || (n[18] = (...s) => e.finish && e.finish(...s)),
                onKeyup: [
                  n[19] || (n[19] = Ei((...s) => e.nextStep && e.nextStep(...s), ["enter"])),
                  n[20] || (n[20] = Ei((...s) => e.nextStep && e.nextStep(...s), ["space"]))
                ]
              }, It(e.finishTranslation), 41, X6e)) : st("", !0)
            ])
          ])) : st("", !0)
        ])
      ], 14, L6e)) : st("", !0)
    ], 8, ["disabled"]))
  ], 64);
}
const eO = /* @__PURE__ */ Cr(C6e, [["render", Q6e]]);
eO.install = (e) => {
  e.component(eO.name, eO);
};
const mz = (e, n) => {
  let t;
  if (typeof e == "string" ? t = document.querySelector(e) : e.nodeType != null && (t = e), t == null)
    throw new Error(
      `Invalid \`${n}\` option provided. Please provide a CSS selector or a plain HTML element.`
    );
  return t;
}, Hte = (e) => {
  const n = [];
  return e.nodeType !== null && Object.values(e.children).forEach((t) => {
    n.push(t);
    const l = Hte(t);
    l.length > 0 && n.push(...l);
  }), n;
}, J6e = () => {
  const e = document.createElement("div");
  return ("draggable" in e || "ondragstart" in e && "ondrop" in e) && "FormData" in window && "FileReader" in window;
}, eDe = (e) => {
  if (e.dataTransfer && e.dataTransfer.types) {
    for (let n = 0; n < e.dataTransfer.types.length; n++)
      if (e.dataTransfer.types[n] === "Files") return !0;
  }
  return !1;
}, gz = (e) => {
  if (eDe(e)) {
    if (e.stopPropagation(), e.preventDefault) {
      e.preventDefault();
      return;
    }
    e.returnValue = !1;
  }
}, wz = 1024, nDe = {
  tb: "TB",
  gb: "GB",
  mb: "MB",
  kb: "KB",
  b: "b"
}, tDe = (e) => {
  let n = 0, t = "b";
  if (e > 0) {
    const l = ["tb", "gb", "mb", "kb", "b"];
    for (let r = 0; r < l.length; r += 1) {
      const u = l[r], o = wz ** (4 - r) / 10;
      if (e >= o) {
        n = e / wz ** (4 - r), t = u;
        break;
      }
    }
    n = Math.round(10 * n) / 10;
  }
  return `<strong>${n}</strong> ${nDe[t]}`;
};
function lDe({
  itemManager: e,
  context: n
}) {
  const t = (o) => {
    if (!o.dataTransfer) return;
    let a;
    try {
      a = o.dataTransfer.effectAllowed;
    } catch {
    }
    gz(o), o.dataTransfer.dropEffect = a === "move" || a === "linkMove" ? "move" : "copy";
  }, l = (o, a, h) => {
    if (o.createReader) {
      const s = o.createReader(), d = (_) => {
        console.log(_);
      }, p = () => s.readEntries((_) => {
        if (_.length > 0) {
          for (let R = 0; R < _.length; R += 1) {
            const F = _[R];
            F.isFile ? F.file((L) => {
              L.fullPath = `${a}/${L.name}`, e.addFile(fm(), L);
            }) : F.isDirectory && l(F, `${a}/${F.name}`);
          }
          p();
        }
        return null;
      }, d);
      return p();
    }
  }, r = (o, a) => {
    for (const h of o) {
      let s = null;
      h.webkitGetAsEntry != null ? (s = h.webkitGetAsEntry(), s.isFile && a ? e.addFile(fm(), h.getAsFile()) : s.isDirectory ? l(s, s.name) : console.warn("addFilesFromItems.webkitGetAsEntry: unknown entry")) : h.getAsFile != null && (h.kind == null || h.kind === "file" ? e.addFile(fm(), h.getAsFile()) : console.warn("dataTransferItem.getAsFile: unknown entry"));
    }
  };
  return {
    handleDragOver: t,
    onDrop: (o) => {
      if (gz(o), !!o.dataTransfer) {
        if (o.dataTransfer.items) {
          const a = o.dataTransfer.items;
          a && a.length && a[0].webkitGetAsEntry != null && r(a, !0);
        } else
          for (let a = 0; a < o.dataTransfer.files.length; a += 1) {
            const h = fm(), s = o.dataTransfer.files[a];
            e.addFile(h, s);
          }
        n.emit("added-all-files", o.dataTransfer.items);
      }
    }
  };
}
function rDe() {
  let e, n = [];
  const t = (a) => !("detail" in a) || !a.detail || "detail" in a && a.detail === 1 ? (n.findIndex((h) => h === a.target) !== -1 && (a.stopPropagation(), e && e.click()), !0) : !1, l = (a) => {
    e && a ? e.setAttribute("multiple", "multiple") : e && !a && e.removeAttribute("multiple");
  }, r = ({
    config: a,
    itemManager: h
  }) => {
    e && e.parentNode && e.parentNode.removeChild(e), e = document.createElement("input"), e.setAttribute("type", "file"), (a.maxFiles === null || a.maxFiles > 1) && l(!0), a.accepts.length > 0 && e.setAttribute("accept", a.accepts.join(",")), e.setAttribute("tabindex", "-1"), e.style.visibility = "hidden", e.style.position = "absolute", e.style.top = "0", e.style.left = "0", e.style.height = "0", e.style.width = "0", mz(a.hiddenInputContainer, "hiddenInputContainer").appendChild(
      e
    ), e.addEventListener("change", () => {
      if (e) {
        const { files: s } = e;
        s && [...s].forEach((p) => {
          h.addFile(fm(), p);
        });
      }
      r({ config: a, itemManager: h });
    });
  };
  return {
    initHiddenFileInput: ({
      config: a,
      dropzone: h,
      itemManager: s
    }) => {
      if (a.clickable) {
        const d = mz(
          `.${a.dropzoneMessageClassName}`,
          a.dropzoneMessageClassName
        ), p = Hte(d);
        n = [h.value], n.push(d), p.length > 0 && n.push(...p), r({ config: a, itemManager: s }), n.forEach((_) => {
          _.classList.add("dropzone-clickable"), _.addEventListener("click", t);
        });
      }
    },
    destroyHiddenFileInput: () => {
      n.forEach((a) => {
        a.removeEventListener("click", t);
      }), e && e.parentElement && (e.parentElement.removeChild(e), e = null);
    },
    setMultiple: l,
    triggerClickOnHiddenFileInput: t
  };
}
const iDe = {
  /**
   * Max files number accepted by the Dropzone
   */
  maxFiles: {
    type: Number,
    default: null
  },
  /**
   * Bytes value for the max upload size allowed
   */
  maxFileSize: {
    type: Number,
    default: 1e6
  },
  /**
   * Element or query selector where the hidden Input it's placed
   */
  hiddenInputContainer: {
    default: "body"
  },
  /**
   * If active enable the dropzone to be clickable and show the files selection
   */
  clickable: {
    type: Boolean,
    default: !0
  },
  /**
   * Array that contain the accepted files, possibile values:
   * ['image', 'doc', 'video', 'png', ... , 'audio' ]
   * for a full list see: TODO - place a link with the full accepted
   */
  acceptedFiles: {
    type: Array,
    default: null
  }
}, zte = {
  data: [
    { mime_type: "application/activemessage" },
    { mime_type: "application/andrew-inset", ext: "ez" },
    { mime_type: "application/applefile" },
    { mime_type: "application/applixware", ext: "aw" },
    { mime_type: "application/atom+xml", ext: "atom" },
    { mime_type: "application/atomcat+xml", ext: "atomcat" },
    { mime_type: "application/atomicmail" },
    { mime_type: "application/atomsvc+xml", ext: "atomsvc" },
    { mime_type: "application/auth-policy+xml" },
    { mime_type: "application/batch-smtp" },
    { mime_type: "application/beep+xml" },
    { mime_type: "application/cals-1840" },
    { mime_type: "application/ccxml+xml", ext: "ccxml" },
    { mime_type: "application/cea-2018+xml" },
    { mime_type: "application/cellml+xml" },
    { mime_type: "application/cnrp+xml" },
    { mime_type: "application/commonground" },
    { mime_type: "application/conference-info+xml" },
    { mime_type: "application/cpl+xml" },
    { mime_type: "application/csta+xml" },
    { mime_type: "application/cstadata+xml" },
    { mime_type: "application/cu-seeme", ext: "cu" },
    { mime_type: "application/cybercash" },
    { mime_type: "application/davmount+xml", ext: "davmount" },
    { mime_type: "application/dca-rft" },
    { mime_type: "application/dec-dx" },
    { mime_type: "application/dialog-info+xml" },
    { mime_type: "application/dicom" },
    { mime_type: "application/dns" },
    { mime_type: "application/dvcs" },
    { mime_type: "application/ecmascript", ext: "ecma" },
    { mime_type: "application/edi-consent" },
    { mime_type: "application/edi-x12" },
    { mime_type: "application/edifact" },
    { mime_type: "application/emma+xml", ext: "emma" },
    { mime_type: "application/epp+xml" },
    { mime_type: "application/epub+zip", ext: "epub" },
    { mime_type: "application/eshop" },
    { mime_type: "application/example" },
    { mime_type: "application/fastinfoset" },
    { mime_type: "application/fastsoap" },
    { mime_type: "application/fits" },
    { mime_type: "application/font-tdpfr", ext: "pfr" },
    { mime_type: "application/h224" },
    { mime_type: "application/http" },
    { mime_type: "application/hyperstudio", ext: "stk" },
    { mime_type: "application/ibe-key-request+xml" },
    { mime_type: "application/ibe-pkg-reply+xml" },
    { mime_type: "application/ibe-pp-data" },
    { mime_type: "application/iges" },
    { mime_type: "application/im-iscomposing+xml" },
    { mime_type: "application/index" },
    { mime_type: "application/index.cmd" },
    { mime_type: "application/index.obj" },
    { mime_type: "application/index.response" },
    { mime_type: "application/index.vnd" },
    { mime_type: "application/iotp" },
    { mime_type: "application/ipp" },
    { mime_type: "application/isup" },
    { mime_type: "application/java-archive", ext: "jar" },
    { mime_type: "application/java-serialized-object", ext: "ser" },
    { mime_type: "application/java-vm", ext: "class" },
    { mime_type: "application/javascript", ext: "js" },
    { mime_type: "application/json", ext: "json" },
    { mime_type: "application/kpml-request+xml" },
    { mime_type: "application/kpml-response+xml" },
    { mime_type: "application/lost+xml", ext: "lostxml" },
    { mime_type: "application/mac-binhex40", ext: "hqx" },
    { mime_type: "application/mac-compactpro", ext: "cpt" },
    { mime_type: "application/macwriteii" },
    { mime_type: "application/marc", ext: "mrc" },
    { mime_type: "application/mathematica", ext: "ma nb mb" },
    { mime_type: "application/mathml+xml", ext: "mathml" },
    { mime_type: "application/mbms-associated-procedure-description+xml" },
    { mime_type: "application/mbms-deregister+xml" },
    { mime_type: "application/mbms-envelope+xml" },
    { mime_type: "application/mbms-msk+xml" },
    { mime_type: "application/mbms-msk-response+xml" },
    { mime_type: "application/mbms-protection-description+xml" },
    { mime_type: "application/mbms-reception-report+xml" },
    { mime_type: "application/mbms-register+xml" },
    { mime_type: "application/mbms-register-response+xml" },
    { mime_type: "application/mbms-user-service-description+xml" },
    { mime_type: "application/mbox", ext: "mbox" },
    { mime_type: "application/media_control+xml" },
    { mime_type: "application/mediaservercontrol+xml", ext: "mscml" },
    { mime_type: "application/mikey" },
    { mime_type: "application/moss-keys" },
    { mime_type: "application/moss-signature" },
    { mime_type: "application/mosskey-data" },
    { mime_type: "application/mosskey-request" },
    { mime_type: "application/mp4", ext: "mp4s" },
    { mime_type: "application/mpeg4-generic" },
    { mime_type: "application/mpeg4-iod" },
    { mime_type: "application/mpeg4-iod-xmt" },
    { mime_type: "application/msword", ext: "doc dot" },
    { mime_type: "application/mxf", ext: "mxf" },
    { mime_type: "application/nasdata" },
    { mime_type: "application/news-checkgroups" },
    { mime_type: "application/news-groupinfo" },
    { mime_type: "application/news-transmission" },
    { mime_type: "application/nss" },
    { mime_type: "application/ocsp-request" },
    { mime_type: "application/ocsp-response" },
    {
      mime_type: "application/octet-stream bin dms lha lrf lzh so iso dmg dist distz pkg bpk dump elc deploy scpt dmgpart"
    },
    { mime_type: "application/oda", ext: "oda" },
    { mime_type: "application/oebps-package+xml", ext: "opf" },
    { mime_type: "application/ogg", ext: "ogx" },
    { mime_type: "application/onenote", ext: "onetoc onetoc2 onetmp onepkg" },
    { mime_type: "application/parityfec" },
    { mime_type: "application/patch-ops-error+xml", ext: "xer" },
    { mime_type: "application/pdf", ext: "pdf" },
    { mime_type: "application/pgp-encrypted", ext: "pgp" },
    { mime_type: "application/pgp-keys" },
    { mime_type: "application/pgp-signature", ext: "asc sig" },
    { mime_type: "application/pics-rules", ext: "prf" },
    { mime_type: "application/pidf+xml" },
    { mime_type: "application/pidf-diff+xml" },
    { mime_type: "application/pkcs10", ext: "p10" },
    { mime_type: "application/pkcs7-mime", ext: "p7m p7c" },
    { mime_type: "application/pkcs7-signature", ext: "p7s" },
    { mime_type: "application/pkix-cert", ext: "cer" },
    { mime_type: "application/pkix-crl", ext: "crl" },
    { mime_type: "application/pkix-pkipath", ext: "pkipath" },
    { mime_type: "application/pkixcmp", ext: "pki" },
    { mime_type: "application/pls+xml", ext: "pls" },
    { mime_type: "application/poc-settings+xml" },
    { mime_type: "application/postscript", ext: "ai eps ps" },
    { mime_type: "application/prs.alvestrand.titrax-sheet" },
    { mime_type: "application/prs.cww", ext: "cww" },
    { mime_type: "application/prs.nprend" },
    { mime_type: "application/prs.plucker" },
    { mime_type: "application/qsig" },
    { mime_type: "application/rdf+xml", ext: "rdf" },
    { mime_type: "application/reginfo+xml", ext: "rif" },
    { mime_type: "application/relax-ng-compact-syntax", ext: "rnc" },
    { mime_type: "application/remote-printing" },
    { mime_type: "application/resource-lists+xml", ext: "rl" },
    { mime_type: "application/resource-lists-diff+xml", ext: "rld" },
    { mime_type: "application/riscos" },
    { mime_type: "application/rlmi+xml" },
    { mime_type: "application/rls-services+xml", ext: "rs" },
    { mime_type: "application/rsd+xml", ext: "rsd" },
    { mime_type: "application/rss+xml", ext: "rss" },
    { mime_type: "application/rtf", ext: "rtf" },
    { mime_type: "application/rtx" },
    { mime_type: "application/samlassertion+xml" },
    { mime_type: "application/samlmetadata+xml" },
    { mime_type: "application/sbml+xml", ext: "sbml" },
    { mime_type: "application/scvp-cv-request", ext: "scq" },
    { mime_type: "application/scvp-cv-response", ext: "scs" },
    { mime_type: "application/scvp-vp-request", ext: "spq" },
    { mime_type: "application/scvp-vp-response", ext: "spp" },
    { mime_type: "application/sdp", ext: "sdp" },
    { mime_type: "application/set-payment" },
    { mime_type: "application/set-payment-initiation", ext: "setpay" },
    { mime_type: "application/set-registration" },
    { mime_type: "application/set-registration-initiation", ext: "setreg" },
    { mime_type: "application/sgml" },
    { mime_type: "application/sgml-open-catalog" },
    { mime_type: "application/shf+xml", ext: "shf" },
    { mime_type: "application/sieve" },
    { mime_type: "application/simple-filter+xml" },
    { mime_type: "application/simple-message-summary" },
    { mime_type: "application/simplesymbolcontainer" },
    { mime_type: "application/slate" },
    { mime_type: "application/smil" },
    { mime_type: "application/smil+xml", ext: "smi smil" },
    { mime_type: "application/soap+fastinfoset" },
    { mime_type: "application/soap+xml" },
    { mime_type: "application/sparql-query", ext: "rq" },
    { mime_type: "application/sparql-results+xml", ext: "srx" },
    { mime_type: "application/spirits-event+xml" },
    { mime_type: "application/srgs", ext: "gram" },
    { mime_type: "application/srgs+xml", ext: "grxml" },
    { mime_type: "application/ssml+xml", ext: "ssml" },
    { mime_type: "application/timestamp-query" },
    { mime_type: "application/timestamp-reply" },
    { mime_type: "application/tve-trigger" },
    { mime_type: "application/ulpfec" },
    { mime_type: "application/vemmi" },
    { mime_type: "application/vividence.scriptfile" },
    { mime_type: "application/vnd.3gpp.bsf+xml" },
    { mime_type: "application/vnd.3gpp.pic-bw-large", ext: "plb" },
    { mime_type: "application/vnd.3gpp.pic-bw-small", ext: "psb" },
    { mime_type: "application/vnd.3gpp.pic-bw-var", ext: "pvb" },
    { mime_type: "application/vnd.3gpp.sms" },
    { mime_type: "application/vnd.3gpp2.bcmcsinfo+xml" },
    { mime_type: "application/vnd.3gpp2.sms" },
    { mime_type: "application/vnd.3gpp2.tcap", ext: "tcap" },
    { mime_type: "application/vnd.3m.post-it-notes", ext: "pwn" },
    { mime_type: "application/vnd.accpac.simply.aso", ext: "aso" },
    { mime_type: "application/vnd.accpac.simply.imp", ext: "imp" },
    { mime_type: "application/vnd.acucobol", ext: "acu" },
    { mime_type: "application/vnd.acucorp", ext: "atc acutc" },
    {
      mime_type: "application/vnd.adobe.air-application-installer-package+zip",
      ext: "air"
    },
    { mime_type: "application/vnd.adobe.xdp+xml", ext: "xdp" },
    { mime_type: "application/vnd.adobe.xfdf", ext: "xfdf" },
    { mime_type: "application/vnd.aether.imp" },
    { mime_type: "application/vnd.airzip.filesecure.azf", ext: "azf" },
    { mime_type: "application/vnd.airzip.filesecure.azs", ext: "azs" },
    { mime_type: "application/vnd.amazon.ebook", ext: "azw" },
    { mime_type: "application/vnd.americandynamics.acc", ext: "acc" },
    { mime_type: "application/vnd.amiga.ami", ext: "ami" },
    { mime_type: "application/vnd.android.package-archive", ext: "apk" },
    {
      mime_type: "application/vnd.anser-web-certificate-issue-initiation",
      ext: "cii"
    },
    {
      mime_type: "application/vnd.anser-web-funds-transfer-initiation",
      ext: "fti"
    },
    { mime_type: "application/vnd.antix.game-component", ext: "atx" },
    { mime_type: "application/vnd.apple.installer+xml", ext: "mpkg" },
    { mime_type: "application/vnd.arastra.swi", ext: "swi" },
    { mime_type: "application/vnd.audiograph", ext: "aep" },
    { mime_type: "application/vnd.autopackage" },
    { mime_type: "application/vnd.avistar+xml" },
    { mime_type: "application/vnd.blueice.multipass", ext: "mpm" },
    { mime_type: "application/vnd.bluetooth.ep.oob" },
    { mime_type: "application/vnd.bmi", ext: "bmi" },
    { mime_type: "application/vnd.businessobjects", ext: "rep" },
    { mime_type: "application/vnd.cab-jscript" },
    { mime_type: "application/vnd.canon-cpdl" },
    { mime_type: "application/vnd.canon-lips" },
    { mime_type: "application/vnd.cendio.thinlinc.clientconf" },
    { mime_type: "application/vnd.chemdraw+xml", ext: "cdxml" },
    { mime_type: "application/vnd.chipnuts.karaoke-mmd", ext: "mmd" },
    { mime_type: "application/vnd.cinderella", ext: "cdy" },
    { mime_type: "application/vnd.cirpack.isdn-ext" },
    { mime_type: "application/vnd.claymore", ext: "cla" },
    { mime_type: "application/vnd.clonk.c4group", ext: "c4g c4d c4f c4p c4u" },
    { mime_type: "application/vnd.commerce-battelle" },
    { mime_type: "application/vnd.commonspace", ext: "csp" },
    { mime_type: "application/vnd.contact.cmsg", ext: "cdbcmsg" },
    { mime_type: "application/vnd.cosmocaller", ext: "cmc" },
    { mime_type: "application/vnd.crick.clicker", ext: "clkx" },
    { mime_type: "application/vnd.crick.clicker.keyboard", ext: "clkk" },
    { mime_type: "application/vnd.crick.clicker.palette", ext: "clkp" },
    { mime_type: "application/vnd.crick.clicker.template", ext: "clkt" },
    { mime_type: "application/vnd.crick.clicker.wordbank", ext: "clkw" },
    { mime_type: "application/vnd.criticaltools.wbs+xml", ext: "wbs" },
    { mime_type: "application/vnd.ctc-posml", ext: "pml" },
    { mime_type: "application/vnd.ctct.ws+xml" },
    { mime_type: "application/vnd.cups-pdf" },
    { mime_type: "application/vnd.cups-postscript" },
    { mime_type: "application/vnd.cups-ppd", ext: "ppd" },
    { mime_type: "application/vnd.cups-raster" },
    { mime_type: "application/vnd.cups-raw" },
    { mime_type: "application/vnd.curl.car", ext: "car" },
    { mime_type: "application/vnd.curl.pcurl", ext: "pcurl" },
    { mime_type: "application/vnd.cybank" },
    { mime_type: "application/vnd.data-vision.rdz", ext: "rdz" },
    { mime_type: "application/vnd.denovo.fcselayout-link", ext: "fe_launch" },
    { mime_type: "application/vnd.dir-bi.plate-dl-nosuffix" },
    { mime_type: "application/vnd.dna", ext: "dna" },
    { mime_type: "application/vnd.dolby.mlp", ext: "mlp" },
    { mime_type: "application/vnd.dolby.mobile.1" },
    { mime_type: "application/vnd.dolby.mobile.2" },
    { mime_type: "application/vnd.dpgraph", ext: "dpg" },
    { mime_type: "application/vnd.dreamfactory", ext: "dfac" },
    { mime_type: "application/vnd.dvb.esgcontainer" },
    { mime_type: "application/vnd.dvb.ipdcdftnotifaccess" },
    { mime_type: "application/vnd.dvb.ipdcesgaccess" },
    { mime_type: "application/vnd.dvb.ipdcroaming" },
    { mime_type: "application/vnd.dvb.iptv.alfec-base" },
    { mime_type: "application/vnd.dvb.iptv.alfec-enhancement" },
    { mime_type: "application/vnd.dvb.notif-aggregate-root+xml" },
    { mime_type: "application/vnd.dvb.notif-container+xml" },
    { mime_type: "application/vnd.dvb.notif-generic+xml" },
    { mime_type: "application/vnd.dvb.notif-ia-msglist+xml" },
    { mime_type: "application/vnd.dvb.notif-ia-registration-request+xml" },
    { mime_type: "application/vnd.dvb.notif-ia-registration-response+xml" },
    { mime_type: "application/vnd.dvb.notif-init+xml" },
    { mime_type: "application/vnd.dxr" },
    { mime_type: "application/vnd.dynageo", ext: "geo" },
    { mime_type: "application/vnd.ecdis-update" },
    { mime_type: "application/vnd.ecowin.chart", ext: "mag" },
    { mime_type: "application/vnd.ecowin.filerequest" },
    { mime_type: "application/vnd.ecowin.fileupdate" },
    { mime_type: "application/vnd.ecowin.series" },
    { mime_type: "application/vnd.ecowin.seriesrequest" },
    { mime_type: "application/vnd.ecowin.seriesupdate" },
    { mime_type: "application/vnd.emclient.accessrequest+xml" },
    { mime_type: "application/vnd.enliven", ext: "nml" },
    { mime_type: "application/vnd.epson.esf", ext: "esf" },
    { mime_type: "application/vnd.epson.msf", ext: "msf" },
    { mime_type: "application/vnd.epson.quickanime", ext: "qam" },
    { mime_type: "application/vnd.epson.salt", ext: "slt" },
    { mime_type: "application/vnd.epson.ssf", ext: "ssf" },
    { mime_type: "application/vnd.ericsson.quickcall" },
    { mime_type: "application/vnd.eszigno3+xml", ext: "es3 et3" },
    { mime_type: "application/vnd.etsi.aoc+xml" },
    { mime_type: "application/vnd.etsi.cug+xml" },
    { mime_type: "application/vnd.etsi.iptvcommand+xml" },
    { mime_type: "application/vnd.etsi.iptvdiscovery+xml" },
    { mime_type: "application/vnd.etsi.iptvprofile+xml" },
    { mime_type: "application/vnd.etsi.iptvsad-bc+xml" },
    { mime_type: "application/vnd.etsi.iptvsad-cod+xml" },
    { mime_type: "application/vnd.etsi.iptvsad-npvr+xml" },
    { mime_type: "application/vnd.etsi.iptvueprofile+xml" },
    { mime_type: "application/vnd.etsi.mcid+xml" },
    { mime_type: "application/vnd.etsi.sci+xml" },
    { mime_type: "application/vnd.etsi.simservs+xml" },
    { mime_type: "application/vnd.eudora.data" },
    { mime_type: "application/vnd.ezpix-album", ext: "ez2" },
    { mime_type: "application/vnd.ezpix-package", ext: "ez3" },
    { mime_type: "application/vnd.f-secure.mobile" },
    { mime_type: "application/vnd.fdf", ext: "fdf" },
    { mime_type: "application/vnd.fdsn.mseed", ext: "mseed" },
    { mime_type: "application/vnd.fdsn.seed", ext: "seed dataless" },
    { mime_type: "application/vnd.ffsns" },
    { mime_type: "application/vnd.fints" },
    { mime_type: "application/vnd.flographit", ext: "gph" },
    { mime_type: "application/vnd.fluxtime.clip", ext: "ftc" },
    { mime_type: "application/vnd.font-fontforge-sfd" },
    { mime_type: "application/vnd.framemaker", ext: "fm frame maker book" },
    { mime_type: "application/vnd.frogans.fnc", ext: "fnc" },
    { mime_type: "application/vnd.frogans.ltf", ext: "ltf" },
    { mime_type: "application/vnd.fsc.weblaunch", ext: "fsc" },
    { mime_type: "application/vnd.fujitsu.oasys", ext: "oas" },
    { mime_type: "application/vnd.fujitsu.oasys2", ext: "oa2" },
    { mime_type: "application/vnd.fujitsu.oasys3", ext: "oa3" },
    { mime_type: "application/vnd.fujitsu.oasysgp", ext: "fg5" },
    { mime_type: "application/vnd.fujitsu.oasysprs", ext: "bh2" },
    { mime_type: "application/vnd.fujixerox.art-ex" },
    { mime_type: "application/vnd.fujixerox.art4" },
    { mime_type: "application/vnd.fujixerox.hbpl" },
    { mime_type: "application/vnd.fujixerox.ddd", ext: "ddd" },
    { mime_type: "application/vnd.fujixerox.docuworks", ext: "xdw" },
    { mime_type: "application/vnd.fujixerox.docuworks.binder", ext: "xbd" },
    { mime_type: "application/vnd.fut-misnet" },
    { mime_type: "application/vnd.fuzzysheet", ext: "fzs" },
    { mime_type: "application/vnd.genomatix.tuxedo", ext: "txd" },
    { mime_type: "application/vnd.geogebra.file", ext: "ggb" },
    { mime_type: "application/vnd.geogebra.tool", ext: "ggt" },
    { mime_type: "application/vnd.geometry-explorer", ext: "gex gre" },
    { mime_type: "application/vnd.gmx", ext: "gmx" },
    { mime_type: "application/vnd.google-earth.kml+xml", ext: "kml" },
    { mime_type: "application/vnd.google-earth.kmz", ext: "kmz" },
    { mime_type: "application/vnd.grafeq", ext: "gqf gqs" },
    { mime_type: "application/vnd.gridmp" },
    { mime_type: "application/vnd.groove-account", ext: "gac" },
    { mime_type: "application/vnd.groove-help", ext: "ghf" },
    { mime_type: "application/vnd.groove-identity-message", ext: "gim" },
    { mime_type: "application/vnd.groove-injector", ext: "grv" },
    { mime_type: "application/vnd.groove-tool-message", ext: "gtm" },
    { mime_type: "application/vnd.groove-tool-template", ext: "tpl" },
    { mime_type: "application/vnd.groove-vcard", ext: "vcg" },
    { mime_type: "application/vnd.handheld-entertainment+xml", ext: "zmm" },
    { mime_type: "application/vnd.hbci", ext: "hbci" },
    { mime_type: "application/vnd.hcl-bireports" },
    { mime_type: "application/vnd.hhe.lesson-player", ext: "les" },
    { mime_type: "application/vnd.hp-hpgl", ext: "hpgl" },
    { mime_type: "application/vnd.hp-hpid", ext: "hpid" },
    { mime_type: "application/vnd.hp-hps", ext: "hps" },
    { mime_type: "application/vnd.hp-jlyt", ext: "jlt" },
    { mime_type: "application/vnd.hp-pcl", ext: "pcl" },
    { mime_type: "application/vnd.hp-pclxl", ext: "pclxl" },
    { mime_type: "application/vnd.httphone" },
    { mime_type: "application/vnd.hydrostatix.sof-data", ext: "sfd-hdstx" },
    { mime_type: "application/vnd.hzn-3d-crossword", ext: "x3d" },
    { mime_type: "application/vnd.ibm.afplinedata" },
    { mime_type: "application/vnd.ibm.electronic-media" },
    { mime_type: "application/vnd.ibm.minipay", ext: "mpy" },
    { mime_type: "application/vnd.ibm.modcap", ext: "afp listafp list3820" },
    { mime_type: "application/vnd.ibm.rights-management", ext: "irm" },
    { mime_type: "application/vnd.ibm.secure-container", ext: "sc" },
    { mime_type: "application/vnd.iccprofile", ext: "icc icm" },
    { mime_type: "application/vnd.igloader", ext: "igl" },
    { mime_type: "application/vnd.immervision-ivp", ext: "ivp" },
    { mime_type: "application/vnd.immervision-ivu", ext: "ivu" },
    { mime_type: "application/vnd.informedcontrol.rms+xml" },
    { mime_type: "application/vnd.informix-visionary" },
    { mime_type: "application/vnd.intercon.formnet", ext: "xpw xpx" },
    { mime_type: "application/vnd.intertrust.digibox" },
    { mime_type: "application/vnd.intertrust.nncp" },
    { mime_type: "application/vnd.intu.qbo", ext: "qbo" },
    { mime_type: "application/vnd.intu.qfx", ext: "qfx" },
    { mime_type: "application/vnd.iptc.g2.conceptitem+xml" },
    { mime_type: "application/vnd.iptc.g2.knowledgeitem+xml" },
    { mime_type: "application/vnd.iptc.g2.newsitem+xml" },
    { mime_type: "application/vnd.iptc.g2.packageitem+xml" },
    { mime_type: "application/vnd.ipunplugged.rcprofile", ext: "rcprofile" },
    { mime_type: "application/vnd.irepository.package+xml", ext: "irp" },
    { mime_type: "application/vnd.is-xpr", ext: "xpr" },
    { mime_type: "application/vnd.jam", ext: "jam" },
    { mime_type: "application/vnd.japannet-directory-service" },
    { mime_type: "application/vnd.japannet-jpnstore-wakeup" },
    { mime_type: "application/vnd.japannet-payment-wakeup" },
    { mime_type: "application/vnd.japannet-registration" },
    { mime_type: "application/vnd.japannet-registration-wakeup" },
    { mime_type: "application/vnd.japannet-setstore-wakeup" },
    { mime_type: "application/vnd.japannet-verification" },
    { mime_type: "application/vnd.japannet-verification-wakeup" },
    { mime_type: "application/vnd.jcp.javame.midlet-rms", ext: "rms" },
    { mime_type: "application/vnd.jisp", ext: "jisp" },
    { mime_type: "application/vnd.joost.joda-archive", ext: "joda" },
    { mime_type: "application/vnd.kahootz", ext: "ktz ktr" },
    { mime_type: "application/vnd.kde.karbon", ext: "karbon" },
    { mime_type: "application/vnd.kde.kchart", ext: "chrt" },
    { mime_type: "application/vnd.kde.kformula", ext: "kfo" },
    { mime_type: "application/vnd.kde.kivio", ext: "flw" },
    { mime_type: "application/vnd.kde.kontour", ext: "kon" },
    { mime_type: "application/vnd.kde.kpresenter", ext: "kpr kpt" },
    { mime_type: "application/vnd.kde.kspread", ext: "ksp" },
    { mime_type: "application/vnd.kde.kword", ext: "kwd kwt" },
    { mime_type: "application/vnd.kenameaapp", ext: "htke" },
    { mime_type: "application/vnd.kidspiration", ext: "kia" },
    { mime_type: "application/vnd.kinar", ext: "kne knp" },
    { mime_type: "application/vnd.koan", ext: "skp skd skt skm" },
    { mime_type: "application/vnd.kodak-descriptor", ext: "sse" },
    { mime_type: "application/vnd.liberty-request+xml" },
    {
      mime_type: "application/vnd.llamagraphics.life-balance.desktop",
      ext: "lbd"
    },
    {
      mime_type: "application/vnd.llamagraphics.life-balance.exchange+xml",
      ext: "lbe"
    },
    { mime_type: "application/vnd.lotus-1-2-3", ext: "123" },
    { mime_type: "application/vnd.lotus-approach", ext: "apr" },
    { mime_type: "application/vnd.lotus-freelance", ext: "pre" },
    { mime_type: "application/vnd.lotus-notes", ext: "nsf" },
    { mime_type: "application/vnd.lotus-organizer", ext: "org" },
    { mime_type: "application/vnd.lotus-screencam", ext: "scm" },
    { mime_type: "application/vnd.lotus-wordpro", ext: "lwp" },
    { mime_type: "application/vnd.macports.portpkg", ext: "portpkg" },
    { mime_type: "application/vnd.marlin.drm.actiontoken+xml" },
    { mime_type: "application/vnd.marlin.drm.conftoken+xml" },
    { mime_type: "application/vnd.marlin.drm.license+xml" },
    { mime_type: "application/vnd.marlin.drm.mdcf" },
    { mime_type: "application/vnd.mcd", ext: "mcd" },
    { mime_type: "application/vnd.medcalcdata", ext: "mc1" },
    { mime_type: "application/vnd.mediastation.cdkey", ext: "cdkey" },
    { mime_type: "application/vnd.meridian-slingshot" },
    { mime_type: "application/vnd.mfer", ext: "mwf" },
    { mime_type: "application/vnd.mfmp", ext: "mfm" },
    { mime_type: "application/vnd.micrografx.flo", ext: "flo" },
    { mime_type: "application/vnd.micrografx.igx", ext: "igx" },
    { mime_type: "application/vnd.mif", ext: "mif" },
    { mime_type: "application/vnd.minisoft-hp3000-save" },
    { mime_type: "application/vnd.mitsubishi.misty-guard.trustweb" },
    { mime_type: "application/vnd.mobius.daf", ext: "daf" },
    { mime_type: "application/vnd.mobius.dis", ext: "dis" },
    { mime_type: "application/vnd.mobius.mbk", ext: "mbk" },
    { mime_type: "application/vnd.mobius.mqy", ext: "mqy" },
    { mime_type: "application/vnd.mobius.msl", ext: "msl" },
    { mime_type: "application/vnd.mobius.plc", ext: "plc" },
    { mime_type: "application/vnd.mobius.txf", ext: "txf" },
    { mime_type: "application/vnd.mophun.application", ext: "mpn" },
    { mime_type: "application/vnd.mophun.certificate", ext: "mpc" },
    { mime_type: "application/vnd.motorola.flexsuite" },
    { mime_type: "application/vnd.motorola.flexsuite.adsi" },
    { mime_type: "application/vnd.motorola.flexsuite.fis" },
    { mime_type: "application/vnd.motorola.flexsuite.gotap" },
    { mime_type: "application/vnd.motorola.flexsuite.kmr" },
    { mime_type: "application/vnd.motorola.flexsuite.ttc" },
    { mime_type: "application/vnd.motorola.flexsuite.wem" },
    { mime_type: "application/vnd.motorola.iprm" },
    { mime_type: "application/vnd.mozilla.xul+xml", ext: "xul" },
    { mime_type: "application/vnd.ms-artgalry", ext: "cil" },
    { mime_type: "application/vnd.ms-asf" },
    { mime_type: "application/vnd.ms-cab-compressed", ext: "cab" },
    { mime_type: "application/vnd.ms-excel", ext: "xls xlm xla xlc xlt xlw" },
    {
      mime_type: "application/vnd.ms-excel.addin.macroenabled.12",
      ext: "xlam"
    },
    {
      mime_type: "application/vnd.ms-excel.sheet.binary.macroenabled.12",
      ext: "xlsb"
    },
    {
      mime_type: "application/vnd.ms-excel.sheet.macroenabled.12",
      ext: "xlsm"
    },
    {
      mime_type: "application/vnd.ms-excel.template.macroenabled.12",
      ext: "xltm"
    },
    { mime_type: "application/vnd.ms-fontobject", ext: "eot" },
    { mime_type: "application/vnd.ms-htmlhelp", ext: "chm" },
    { mime_type: "application/vnd.ms-ims", ext: "ims" },
    { mime_type: "application/vnd.ms-lrm", ext: "lrm" },
    { mime_type: "application/vnd.ms-pki.seccat", ext: "cat" },
    { mime_type: "application/vnd.ms-pki.stl", ext: "stl" },
    { mime_type: "application/vnd.ms-playready.initiator+xml" },
    { mime_type: "application/vnd.ms-powerpoint", ext: "ppt pps pot" },
    {
      mime_type: "application/vnd.ms-powerpoint.addin.macroenabled.12",
      ext: "ppam"
    },
    {
      mime_type: "application/vnd.ms-powerpoint.presentation.macroenabled.12",
      ext: "pptm"
    },
    {
      mime_type: "application/vnd.ms-powerpoint.slide.macroenabled.12",
      ext: "sldm"
    },
    {
      mime_type: "application/vnd.ms-powerpoint.slideshow.macroenabled.12",
      ext: "ppsm"
    },
    {
      mime_type: "application/vnd.ms-powerpoint.template.macroenabled.12",
      ext: "potm"
    },
    { mime_type: "application/vnd.ms-project", ext: "mpp mpt" },
    { mime_type: "application/vnd.ms-tnef" },
    { mime_type: "application/vnd.ms-wmdrm.lic-chlg-req" },
    { mime_type: "application/vnd.ms-wmdrm.lic-resp" },
    { mime_type: "application/vnd.ms-wmdrm.meter-chlg-req" },
    { mime_type: "application/vnd.ms-wmdrm.meter-resp" },
    {
      mime_type: "application/vnd.ms-word.document.macroenabled.12",
      ext: "docm"
    },
    {
      mime_type: "application/vnd.ms-word.template.macroenabled.12",
      ext: "dotm"
    },
    { mime_type: "application/vnd.ms-works", ext: "wps wks wcm wdb" },
    { mime_type: "application/vnd.ms-wpl", ext: "wpl" },
    { mime_type: "application/vnd.ms-xpsdocument", ext: "xps" },
    { mime_type: "application/vnd.mseq", ext: "mseq" },
    { mime_type: "application/vnd.msign" },
    { mime_type: "application/vnd.multiad.creator" },
    { mime_type: "application/vnd.multiad.creator.cif" },
    { mime_type: "application/vnd.music-niff" },
    { mime_type: "application/vnd.musician", ext: "mus" },
    { mime_type: "application/vnd.muvee.style", ext: "msty" },
    { mime_type: "application/vnd.ncd.control" },
    { mime_type: "application/vnd.ncd.reference" },
    { mime_type: "application/vnd.nervana" },
    { mime_type: "application/vnd.netfpx" },
    { mime_type: "application/vnd.neurolanguage.nlu", ext: "nlu" },
    { mime_type: "application/vnd.noblenet-directory", ext: "nnd" },
    { mime_type: "application/vnd.noblenet-sealer", ext: "nns" },
    { mime_type: "application/vnd.noblenet-web", ext: "nnw" },
    { mime_type: "application/vnd.nokia.catalogs" },
    { mime_type: "application/vnd.nokia.conml+wbxml" },
    { mime_type: "application/vnd.nokia.conml+xml" },
    { mime_type: "application/vnd.nokia.isds-radio-presets" },
    { mime_type: "application/vnd.nokia.iptv.config+xml" },
    { mime_type: "application/vnd.nokia.landmark+wbxml" },
    { mime_type: "application/vnd.nokia.landmark+xml" },
    { mime_type: "application/vnd.nokia.landmarkcollection+xml" },
    { mime_type: "application/vnd.nokia.n-gage.ac+xml" },
    { mime_type: "application/vnd.nokia.n-gage.data", ext: "ngdat" },
    {
      mime_type: "application/vnd.nokia.n-gage.symbian.install",
      ext: "n-gage"
    },
    { mime_type: "application/vnd.nokia.ncd" },
    { mime_type: "application/vnd.nokia.pcd+wbxml" },
    { mime_type: "application/vnd.nokia.pcd+xml" },
    { mime_type: "application/vnd.nokia.radio-preset", ext: "rpst" },
    { mime_type: "application/vnd.nokia.radio-presets", ext: "rpss" },
    { mime_type: "application/vnd.novadigm.edm", ext: "edm" },
    { mime_type: "application/vnd.novadigm.edx", ext: "edx" },
    { mime_type: "application/vnd.novadigm.ext", ext: "ext" },
    { mime_type: "application/vnd.oasis.opendocument.chart", ext: "odc" },
    {
      mime_type: "application/vnd.oasis.opendocument.chart-template",
      ext: "otc"
    },
    { mime_type: "application/vnd.oasis.opendocument.database", ext: "odb" },
    { mime_type: "application/vnd.oasis.opendocument.formula", ext: "odf" },
    {
      mime_type: "application/vnd.oasis.opendocument.formula-template",
      ext: "odft"
    },
    { mime_type: "application/vnd.oasis.opendocument.graphics", ext: "odg" },
    {
      mime_type: "application/vnd.oasis.opendocument.graphics-template",
      ext: "otg"
    },
    { mime_type: "application/vnd.oasis.opendocument.image", ext: "odi" },
    {
      mime_type: "application/vnd.oasis.opendocument.image-template",
      ext: "oti"
    },
    {
      mime_type: "application/vnd.oasis.opendocument.presentation",
      ext: "odp"
    },
    {
      mime_type: "application/vnd.oasis.opendocument.presentation-template otp"
    },
    { mime_type: "application/vnd.oasis.opendocument.spreadsheet", ext: "ods" },
    {
      mime_type: "application/vnd.oasis.opendocument.spreadsheet-template",
      ext: "ots"
    },
    { mime_type: "application/vnd.oasis.opendocument.text", ext: "odt" },
    { mime_type: "application/vnd.oasis.opendocument.text-master", ext: "otm" },
    {
      mime_type: "application/vnd.oasis.opendocument.text-template",
      ext: "ott"
    },
    { mime_type: "application/vnd.oasis.opendocument.text-web", ext: "oth" },
    { mime_type: "application/vnd.obn" },
    { mime_type: "application/vnd.olpc-sugar", ext: "xo" },
    { mime_type: "application/vnd.oma-scws-config" },
    { mime_type: "application/vnd.oma-scws-http-request" },
    { mime_type: "application/vnd.oma-scws-http-response" },
    {
      mime_type: "application/vnd.oma.bcast.associated-procedure-parameter+xml"
    },
    { mime_type: "application/vnd.oma.bcast.drm-trigger+xml" },
    { mime_type: "application/vnd.oma.bcast.imd+xml" },
    { mime_type: "application/vnd.oma.bcast.ltkm" },
    { mime_type: "application/vnd.oma.bcast.notification+xml" },
    { mime_type: "application/vnd.oma.bcast.provisioningtrigger" },
    { mime_type: "application/vnd.oma.bcast.sgboot" },
    { mime_type: "application/vnd.oma.bcast.sgdd+xml" },
    { mime_type: "application/vnd.oma.bcast.sgdu" },
    { mime_type: "application/vnd.oma.bcast.simple-symbol-container" },
    { mime_type: "application/vnd.oma.bcast.smartcard-trigger+xml" },
    { mime_type: "application/vnd.oma.bcast.sprov+xml" },
    { mime_type: "application/vnd.oma.bcast.stkm" },
    { mime_type: "application/vnd.oma.dcd" },
    { mime_type: "application/vnd.oma.dcdc" },
    { mime_type: "application/vnd.oma.dd2+xml", ext: "dd2" },
    { mime_type: "application/vnd.oma.drm.risd+xml" },
    { mime_type: "application/vnd.oma.group-usage-list+xml" },
    { mime_type: "application/vnd.oma.poc.detailed-progress-report+xml" },
    { mime_type: "application/vnd.oma.poc.final-report+xml" },
    { mime_type: "application/vnd.oma.poc.groups+xml" },
    { mime_type: "application/vnd.oma.poc.invocation-descriptor+xml" },
    { mime_type: "application/vnd.oma.poc.optimized-progress-report+xml" },
    { mime_type: "application/vnd.oma.xcap-directory+xml" },
    { mime_type: "application/vnd.omads-email+xml" },
    { mime_type: "application/vnd.omads-file+xml" },
    { mime_type: "application/vnd.omads-folder+xml" },
    { mime_type: "application/vnd.omaloc-supl-init" },
    { mime_type: "application/vnd.openofficeorg.extension", ext: "oxt" },
    {
      mime_type: "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      ext: "pptx"
    },
    {
      mime_type: "application/vnd.openxmlformats-officedocument.presentationml.slide",
      ext: "sldx"
    },
    {
      mime_type: "application/vnd.openxmlformats-officedocument.presentationml.slideshow",
      ext: "ppsx"
    },
    {
      mime_type: "application/vnd.openxmlformats-officedocument.presentationml.template",
      ext: "potx"
    },
    {
      mime_type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ext: "xlsx"
    },
    {
      mime_type: "application/vnd.openxmlformats-officedocument.spreadsheetml.template",
      ext: "xltx"
    },
    {
      mime_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ext: "docx"
    },
    {
      mime_type: "application/vnd.openxmlformats-officedocument.wordprocessingml.template",
      ext: "dotx"
    },
    { mime_type: "application/vnd.osa.netdeploy" },
    { mime_type: "application/vnd.osgi.bundle" },
    { mime_type: "application/vnd.osgi.dp", ext: "dp" },
    { mime_type: "application/vnd.otps.ct-kip+xml" },
    { mime_type: "application/vnd.palm", ext: "pdb pqa oprc" },
    { mime_type: "application/vnd.paos.xml" },
    { mime_type: "application/vnd.pg.format", ext: "str" },
    { mime_type: "application/vnd.pg.osasli", ext: "ei6" },
    { mime_type: "application/vnd.piaccess.application-licence" },
    { mime_type: "application/vnd.picsel", ext: "efif" },
    { mime_type: "application/vnd.poc.group-advertisement+xml" },
    { mime_type: "application/vnd.pocketlearn", ext: "plf" },
    { mime_type: "application/vnd.powerbuilder6", ext: "pbd" },
    { mime_type: "application/vnd.powerbuilder6-s" },
    { mime_type: "application/vnd.powerbuilder7" },
    { mime_type: "application/vnd.powerbuilder7-s" },
    { mime_type: "application/vnd.powerbuilder75" },
    { mime_type: "application/vnd.powerbuilder75-s" },
    { mime_type: "application/vnd.preminet" },
    { mime_type: "application/vnd.previewsystems.box", ext: "box" },
    { mime_type: "application/vnd.proteus.magazine", ext: "mgz" },
    { mime_type: "application/vnd.publishare-delta-tree", ext: "qps" },
    { mime_type: "application/vnd.pvi.ptid1", ext: "ptid" },
    { mime_type: "application/vnd.pwg-multiplexed" },
    { mime_type: "application/vnd.pwg-xhtml-print+xml" },
    { mime_type: "application/vnd.qualcomm.brew-app-res" },
    {
      mime_type: "application/vnd.quark.quarkxpress",
      ext: "qxd qxt qwd qwt qxl qxb"
    },
    { mime_type: "application/vnd.rapid" },
    { mime_type: "application/vnd.recordare.musicxml", ext: "mxl" },
    { mime_type: "application/vnd.recordare.musicxml+xml", ext: "musicxml" },
    { mime_type: "application/vnd.renlearn.rlprint" },
    { mime_type: "application/vnd.rim.cod", ext: "cod" },
    { mime_type: "application/vnd.rn-realmedia", ext: "rm" },
    { mime_type: "application/vnd.route66.link66+xml", ext: "link66" },
    { mime_type: "application/vnd.ruckus.download" },
    { mime_type: "application/vnd.s3sms" },
    { mime_type: "application/vnd.sbm.cid" },
    { mime_type: "application/vnd.sbm.mid2" },
    { mime_type: "application/vnd.scribus" },
    { mime_type: "application/vnd.sealed.3df" },
    { mime_type: "application/vnd.sealed.csf" },
    { mime_type: "application/vnd.sealed.doc" },
    { mime_type: "application/vnd.sealed.eml" },
    { mime_type: "application/vnd.sealed.mht" },
    { mime_type: "application/vnd.sealed.net" },
    { mime_type: "application/vnd.sealed.ppt" },
    { mime_type: "application/vnd.sealed.tiff" },
    { mime_type: "application/vnd.sealed.xls" },
    { mime_type: "application/vnd.sealedmedia.softseal.html" },
    { mime_type: "application/vnd.sealedmedia.softseal.pdf" },
    { mime_type: "application/vnd.seemail", ext: "see" },
    { mime_type: "application/vnd.sema", ext: "sema" },
    { mime_type: "application/vnd.semd", ext: "semd" },
    { mime_type: "application/vnd.semf", ext: "semf" },
    { mime_type: "application/vnd.shana.informed.formdata", ext: "ifm" },
    { mime_type: "application/vnd.shana.informed.formtemplate", ext: "itp" },
    { mime_type: "application/vnd.shana.informed.interchange", ext: "iif" },
    { mime_type: "application/vnd.shana.informed.package", ext: "ipk" },
    { mime_type: "application/vnd.simtech-mindmapper", ext: "twd twds" },
    { mime_type: "application/vnd.smaf", ext: "mmf" },
    { mime_type: "application/vnd.smart.teacher", ext: "teacher" },
    { mime_type: "application/vnd.software602.filler.form+xml" },
    { mime_type: "application/vnd.software602.filler.form-xml-zip" },
    { mime_type: "application/vnd.solent.sdkm+xml", ext: "sdkm sdkd" },
    { mime_type: "application/vnd.spotfire.dxp", ext: "dxp" },
    { mime_type: "application/vnd.spotfire.sfs", ext: "sfs" },
    { mime_type: "application/vnd.sss-cod" },
    { mime_type: "application/vnd.sss-dtf" },
    { mime_type: "application/vnd.sss-ntf" },
    { mime_type: "application/vnd.stardivision.calc", ext: "sdc" },
    { mime_type: "application/vnd.stardivision.draw", ext: "sda" },
    { mime_type: "application/vnd.stardivision.impress", ext: "sdd" },
    { mime_type: "application/vnd.stardivision.math", ext: "smf" },
    { mime_type: "application/vnd.stardivision.writer", ext: "sdw" },
    { mime_type: "application/vnd.stardivision.writer", ext: "vor" },
    { mime_type: "application/vnd.stardivision.writer-global", ext: "sgl" },
    { mime_type: "application/vnd.street-stream" },
    { mime_type: "application/vnd.sun.xml.calc", ext: "sxc" },
    { mime_type: "application/vnd.sun.xml.calc.template", ext: "stc" },
    { mime_type: "application/vnd.sun.xml.draw", ext: "sxd" },
    { mime_type: "application/vnd.sun.xml.draw.template", ext: "std" },
    { mime_type: "application/vnd.sun.xml.impress", ext: "sxi" },
    { mime_type: "application/vnd.sun.xml.impress.template", ext: "sti" },
    { mime_type: "application/vnd.sun.xml.math", ext: "sxm" },
    { mime_type: "application/vnd.sun.xml.writer", ext: "sxw" },
    { mime_type: "application/vnd.sun.xml.writer.global", ext: "sxg" },
    { mime_type: "application/vnd.sun.xml.writer.template", ext: "stw" },
    { mime_type: "application/vnd.sun.wadl+xml" },
    { mime_type: "application/vnd.sus-calendar", ext: "sus susp" },
    { mime_type: "application/vnd.svd", ext: "svd" },
    { mime_type: "application/vnd.swiftview-ics" },
    { mime_type: "application/vnd.symbian.install", ext: "sis sisx" },
    { mime_type: "application/vnd.syncml+xml", ext: "xsm" },
    { mime_type: "application/vnd.syncml.dm+wbxml", ext: "bdm" },
    { mime_type: "application/vnd.syncml.dm+xml", ext: "xdm" },
    { mime_type: "application/vnd.syncml.dm.notification" },
    { mime_type: "application/vnd.syncml.ds.notification" },
    { mime_type: "application/vnd.tao.intent-module-archive", ext: "tao" },
    { mime_type: "application/vnd.tmobile-livetv", ext: "tmo" },
    { mime_type: "application/vnd.trid.tpt", ext: "tpt" },
    { mime_type: "application/vnd.triscape.mxs", ext: "mxs" },
    { mime_type: "application/vnd.trueapp", ext: "tra" },
    { mime_type: "application/vnd.truedoc" },
    { mime_type: "application/vnd.ufdl", ext: "ufd ufdl" },
    { mime_type: "application/vnd.uiq.theme", ext: "utz" },
    { mime_type: "application/vnd.umajin", ext: "umj" },
    { mime_type: "application/vnd.unity", ext: "unityweb" },
    { mime_type: "application/vnd.uoml+xml", ext: "uoml" },
    { mime_type: "application/vnd.uplanet.alert" },
    { mime_type: "application/vnd.uplanet.alert-wbxml" },
    { mime_type: "application/vnd.uplanet.bearer-choice" },
    { mime_type: "application/vnd.uplanet.bearer-choice-wbxml" },
    { mime_type: "application/vnd.uplanet.cacheop" },
    { mime_type: "application/vnd.uplanet.cacheop-wbxml" },
    { mime_type: "application/vnd.uplanet.channel" },
    { mime_type: "application/vnd.uplanet.channel-wbxml" },
    { mime_type: "application/vnd.uplanet.list" },
    { mime_type: "application/vnd.uplanet.list-wbxml" },
    { mime_type: "application/vnd.uplanet.listcmd" },
    { mime_type: "application/vnd.uplanet.listcmd-wbxml" },
    { mime_type: "application/vnd.uplanet.signal" },
    { mime_type: "application/vnd.vcx", ext: "vcx" },
    { mime_type: "application/vnd.vd-study" },
    { mime_type: "application/vnd.vectorworks" },
    { mime_type: "application/vnd.vidsoft.vidconference" },
    { mime_type: "application/vnd.visio", ext: "vsd vst vss vsw" },
    { mime_type: "application/vnd.visionary", ext: "vis" },
    { mime_type: "application/vnd.vividence.scriptfile" },
    { mime_type: "application/vnd.vsf", ext: "vsf" },
    { mime_type: "application/vnd.wap.sic" },
    { mime_type: "application/vnd.wap.slc" },
    { mime_type: "application/vnd.wap.wbxml", ext: "wbxml" },
    { mime_type: "application/vnd.wap.wmlc", ext: "wmlc" },
    { mime_type: "application/vnd.wap.wmlscriptc", ext: "wmlsc" },
    { mime_type: "application/vnd.webturbo", ext: "wtb" },
    { mime_type: "application/vnd.wfa.wsc" },
    { mime_type: "application/vnd.wmc" },
    { mime_type: "application/vnd.wmf.bootstrap" },
    { mime_type: "application/vnd.wordperfect", ext: "wpd" },
    { mime_type: "application/vnd.wqd", ext: "wqd" },
    { mime_type: "application/vnd.wrq-hp3000-labelled" },
    { mime_type: "application/vnd.wt.stf", ext: "stf" },
    { mime_type: "application/vnd.wv.csp+wbxml" },
    { mime_type: "application/vnd.wv.csp+xml" },
    { mime_type: "application/vnd.wv.ssp+xml" },
    { mime_type: "application/vnd.xara", ext: "xar" },
    { mime_type: "application/vnd.xfdl", ext: "xfdl" },
    { mime_type: "application/vnd.xfdl.webform" },
    { mime_type: "application/vnd.xmi+xml" },
    { mime_type: "application/vnd.xmpie.cpkg" },
    { mime_type: "application/vnd.xmpie.dpkg" },
    { mime_type: "application/vnd.xmpie.plan" },
    { mime_type: "application/vnd.xmpie.ppkg" },
    { mime_type: "application/vnd.xmpie.xlim" },
    { mime_type: "application/vnd.yamaha.hv-dic", ext: "hvd" },
    { mime_type: "application/vnd.yamaha.hv-script", ext: "hvs" },
    { mime_type: "application/vnd.yamaha.hv-voice", ext: "hvp" },
    { mime_type: "application/vnd.yamaha.openscoreformat", ext: "osf" },
    {
      mime_type: "application/vnd.yamaha.openscoreformat.osfpvg+xml",
      ext: "osfpvg"
    },
    { mime_type: "application/vnd.yamaha.smaf-audio", ext: "saf" },
    { mime_type: "application/vnd.yamaha.smaf-phrase", ext: "spf" },
    { mime_type: "application/vnd.yellowriver-custom-menu", ext: "cmp" },
    { mime_type: "application/vnd.zul", ext: "zir zirz" },
    { mime_type: "application/vnd.zzazz.deck+xml", ext: "zaz" },
    { mime_type: "application/voicexml+xml", ext: "vxml" },
    { mime_type: "application/watcherinfo+xml" },
    { mime_type: "application/whoispp-query" },
    { mime_type: "application/whoispp-response" },
    { mime_type: "application/winhlp", ext: "hlp" },
    { mime_type: "application/wita" },
    { mime_type: "application/wordperfect5.1" },
    { mime_type: "application/wsdl+xml", ext: "wsdl" },
    { mime_type: "application/wspolicy+xml", ext: "wspolicy" },
    { mime_type: "application/x-abiword", ext: "abw" },
    { mime_type: "application/x-ace-compressed", ext: "ace" },
    { mime_type: "application/x-authorware-bin", ext: "aab x32 u32 vox" },
    { mime_type: "application/x-authorware-map", ext: "aam" },
    { mime_type: "application/x-authorware-seg", ext: "aas" },
    { mime_type: "application/x-bcpio", ext: "bcpio" },
    { mime_type: "application/x-bittorrent", ext: "torrent" },
    { mime_type: "application/x-bzip", ext: "bz" },
    { mime_type: "application/x-bzip2", ext: "bz2 boz" },
    { mime_type: "application/x-cdlink", ext: "vcd" },
    { mime_type: "application/x-chat", ext: "chat" },
    { mime_type: "application/x-chess-pgn", ext: "pgn" },
    { mime_type: "application/x-compress" },
    { mime_type: "application/x-cpio", ext: "cpio" },
    { mime_type: "application/x-csh", ext: "csh" },
    { mime_type: "application/x-debian-package", ext: "deb udeb" },
    {
      mime_type: "application/x-director",
      ext: "dir dcr dxr cst cct cxt w3d fgd swa"
    },
    { mime_type: "application/x-doom", ext: "wad" },
    { mime_type: "application/x-dtbncx+xml", ext: "ncx" },
    { mime_type: "application/x-dtbook+xml", ext: "dtb" },
    { mime_type: "application/x-dtbresource+xml", ext: "res" },
    { mime_type: "application/x-dvi", ext: "dvi" },
    { mime_type: "application/x-font-bdf", ext: "bdf" },
    { mime_type: "application/x-font-dos" },
    { mime_type: "application/x-font-framemaker" },
    { mime_type: "application/x-font-ghostscript", ext: "gsf" },
    { mime_type: "application/x-font-libgrx" },
    { mime_type: "application/x-font-linux-psf", ext: "psf" },
    { mime_type: "application/x-font-otf", ext: "otf" },
    { mime_type: "application/x-font-pcf", ext: "pcf" },
    { mime_type: "application/x-font-snf", ext: "snf" },
    { mime_type: "application/x-font-speedo" },
    { mime_type: "application/x-font-sunos-news" },
    { mime_type: "application/x-font-ttf", ext: "ttf ttc" },
    { mime_type: "application/x-font-type1", ext: "pfa pfb pfm afm" },
    { mime_type: "application/x-font-vfont" },
    { mime_type: "application/x-futuresplash", ext: "spl" },
    { mime_type: "application/x-gnumeric", ext: "gnumeric" },
    { mime_type: "application/x-gtar", ext: "gtar" },
    { mime_type: "application/x-gzip" },
    { mime_type: "application/x-hdf", ext: "hdf" },
    { mime_type: "application/x-java-jnlp-file", ext: "jnlp" },
    { mime_type: "application/x-latex", ext: "latex" },
    { mime_type: "application/x-mobipocket-ebook", ext: "prc mobi" },
    { mime_type: "application/x-ms-application", ext: "application" },
    { mime_type: "application/x-ms-wmd", ext: "wmd" },
    { mime_type: "application/x-ms-wmz", ext: "wmz" },
    { mime_type: "application/x-ms-xbap", ext: "xbap" },
    { mime_type: "application/x-msaccess", ext: "mdb" },
    { mime_type: "application/x-msbinder", ext: "obd" },
    { mime_type: "application/x-mscardfile", ext: "crd" },
    { mime_type: "application/x-msclip", ext: "clp" },
    { mime_type: "application/x-msdownload", ext: "exe dll com bat msi" },
    { mime_type: "application/x-msmediaview", ext: "mvb m13 m14" },
    { mime_type: "application/x-msmetafile", ext: "wmf" },
    { mime_type: "application/x-msmoney", ext: "mny" },
    { mime_type: "application/x-mspublisher", ext: "pub" },
    { mime_type: "application/x-msschedule", ext: "scd" },
    { mime_type: "application/x-msterminal", ext: "trm" },
    { mime_type: "application/x-mswrite", ext: "wri" },
    { mime_type: "application/x-netcdf", ext: "nc cdf" },
    { mime_type: "application/x-pkcs12", ext: "p12 pfx" },
    { mime_type: "application/x-pkcs7-certificates", ext: "p7b spc" },
    { mime_type: "application/x-pkcs7-certreqresp", ext: "p7r" },
    { mime_type: "application/x-rar-compressed", ext: "rar" },
    { mime_type: "application/x-sh", ext: "sh" },
    { mime_type: "application/x-shar", ext: "shar" },
    { mime_type: "application/x-shockwave-flash", ext: "swf" },
    { mime_type: "application/x-silverlight-app", ext: "xap" },
    { mime_type: "application/x-stuffit", ext: "sit" },
    { mime_type: "application/x-stuffitx", ext: "sitx" },
    { mime_type: "application/x-sv4cpio", ext: "sv4cpio" },
    { mime_type: "application/x-sv4crc", ext: "sv4crc" },
    { mime_type: "application/x-tar", ext: "tar" },
    { mime_type: "application/x-tcl", ext: "tcl" },
    { mime_type: "application/x-tex", ext: "tex" },
    { mime_type: "application/x-tex-tfm", ext: "tfm" },
    { mime_type: "application/x-texinfo", ext: "texinfo texi" },
    { mime_type: "application/x-ustar", ext: "ustar" },
    { mime_type: "application/x-wais-source", ext: "src" },
    { mime_type: "application/x-x509-ca-cert", ext: "der crt" },
    { mime_type: "application/x-xfig", ext: "fig" },
    { mime_type: "application/x-xpinstall", ext: "xpi" },
    { mime_type: "application/x400-bp" },
    { mime_type: "application/xcap-att+xml" },
    { mime_type: "application/xcap-caps+xml" },
    { mime_type: "application/xcap-el+xml" },
    { mime_type: "application/xcap-error+xml" },
    { mime_type: "application/xcap-ns+xml" },
    { mime_type: "application/xcon-conference-info-diff+xml" },
    { mime_type: "application/xcon-conference-info+xml" },
    { mime_type: "application/xenc+xml", ext: "xenc" },
    { mime_type: "application/xhtml+xml", ext: "xhtml xht" },
    { mime_type: "application/xhtml-voice+xml" },
    { mime_type: "application/xml", ext: "xml xsl" },
    { mime_type: "application/xml-dtd", ext: "dtd" },
    { mime_type: "application/xml-external-parsed-entity" },
    { mime_type: "application/xmpp+xml" },
    { mime_type: "application/xop+xml", ext: "xop" },
    { mime_type: "application/xslt+xml", ext: "xslt" },
    { mime_type: "application/xspf+xml", ext: "xspf" },
    { mime_type: "application/xv+xml", ext: "mxml xhvml xvml xvm" },
    { mime_type: "application/zip", ext: "zip" },
    { mime_type: "audio/32kadpcm" },
    { mime_type: "audio/3gpp" },
    { mime_type: "audio/3gpp2" },
    { mime_type: "audio/ac3" },
    { mime_type: "audio/adpcm", ext: "adp" },
    { mime_type: "audio/amr" },
    { mime_type: "audio/amr-wb" },
    { mime_type: "audio/amr-wb+" },
    { mime_type: "audio/asc" },
    { mime_type: "audio/basic", ext: "au snd" },
    { mime_type: "audio/bv16" },
    { mime_type: "audio/bv32" },
    { mime_type: "audio/clearmode" },
    { mime_type: "audio/cn" },
    { mime_type: "audio/dat12" },
    { mime_type: "audio/dls" },
    { mime_type: "audio/dsr-es201108" },
    { mime_type: "audio/dsr-es202050" },
    { mime_type: "audio/dsr-es202211" },
    { mime_type: "audio/dsr-es202212" },
    { mime_type: "audio/dvi4" },
    { mime_type: "audio/eac3" },
    { mime_type: "audio/evrc" },
    { mime_type: "audio/evrc-qcp" },
    { mime_type: "audio/evrc0" },
    { mime_type: "audio/evrc1" },
    { mime_type: "audio/evrcb" },
    { mime_type: "audio/evrcb0" },
    { mime_type: "audio/evrcb1" },
    { mime_type: "audio/evrcwb" },
    { mime_type: "audio/evrcwb0" },
    { mime_type: "audio/evrcwb1" },
    { mime_type: "audio/example" },
    { mime_type: "audio/g719" },
    { mime_type: "audio/g722" },
    { mime_type: "audio/g7221" },
    { mime_type: "audio/g723" },
    { mime_type: "audio/g726-16" },
    { mime_type: "audio/g726-24" },
    { mime_type: "audio/g726-32" },
    { mime_type: "audio/g726-40" },
    { mime_type: "audio/g728" },
    { mime_type: "audio/g729" },
    { mime_type: "audio/g7291" },
    { mime_type: "audio/g729d" },
    { mime_type: "audio/g729e" },
    { mime_type: "audio/gsm" },
    { mime_type: "audio/gsm-efr" },
    { mime_type: "audio/ilbc" },
    { mime_type: "audio/l16" },
    { mime_type: "audio/l20" },
    { mime_type: "audio/l24" },
    { mime_type: "audio/l8" },
    { mime_type: "audio/lpc" },
    { mime_type: "audio/midi", ext: "mid midi kar rmi" },
    { mime_type: "audio/mobile-xmf" },
    { mime_type: "audio/mp4", ext: "mp4a" },
    { mime_type: "audio/mp4a-latm", ext: "m4a m4p" },
    { mime_type: "audio/mpa" },
    { mime_type: "audio/mpa-robust" },
    { mime_type: "audio/mpeg", ext: "mpga mp2 mp2a mp3 m2a m3a" },
    { mime_type: "audio/mpeg4-generic" },
    { mime_type: "audio/ogg", ext: "oga ogg spx" },
    { mime_type: "audio/parityfec" },
    { mime_type: "audio/pcma" },
    { mime_type: "audio/pcma-wb" },
    { mime_type: "audio/pcmu-wb" },
    { mime_type: "audio/pcmu" },
    { mime_type: "audio/prs.sid" },
    { mime_type: "audio/qcelp" },
    { mime_type: "audio/red" },
    { mime_type: "audio/rtp-enc-aescm128" },
    { mime_type: "audio/rtp-midi" },
    { mime_type: "audio/rtx" },
    { mime_type: "audio/smv" },
    { mime_type: "audio/smv0" },
    { mime_type: "audio/smv-qcp" },
    { mime_type: "audio/sp-midi" },
    { mime_type: "audio/t140c" },
    { mime_type: "audio/t38" },
    { mime_type: "audio/telephone-event" },
    { mime_type: "audio/tone" },
    { mime_type: "audio/ulpfec" },
    { mime_type: "audio/vdvi" },
    { mime_type: "audio/vmr-wb" },
    { mime_type: "audio/vnd.3gpp.iufp" },
    { mime_type: "audio/vnd.4sb" },
    { mime_type: "audio/vnd.audiokoz" },
    { mime_type: "audio/vnd.celp" },
    { mime_type: "audio/vnd.cisco.nse" },
    { mime_type: "audio/vnd.cmles.radio-events" },
    { mime_type: "audio/vnd.cns.anp1" },
    { mime_type: "audio/vnd.cns.inf1" },
    { mime_type: "audio/vnd.digital-winds", ext: "eol" },
    { mime_type: "audio/vnd.dlna.adts" },
    { mime_type: "audio/vnd.dolby.heaac.1" },
    { mime_type: "audio/vnd.dolby.heaac.2" },
    { mime_type: "audio/vnd.dolby.mlp" },
    { mime_type: "audio/vnd.dolby.mps" },
    { mime_type: "audio/vnd.dolby.pl2" },
    { mime_type: "audio/vnd.dolby.pl2x" },
    { mime_type: "audio/vnd.dolby.pl2z" },
    { mime_type: "audio/vnd.dts", ext: "dts" },
    { mime_type: "audio/vnd.dts.hd", ext: "dtshd" },
    { mime_type: "audio/vnd.everad.plj" },
    { mime_type: "audio/vnd.hns.audio" },
    { mime_type: "audio/vnd.lucent.voice", ext: "lvp" },
    { mime_type: "audio/vnd.ms-playready.media.pya", ext: "pya" },
    { mime_type: "audio/vnd.nokia.mobile-xmf" },
    { mime_type: "audio/vnd.nortel.vbk" },
    { mime_type: "audio/vnd.nuera.ecelp4800", ext: "ecelp4800" },
    { mime_type: "audio/vnd.nuera.ecelp7470", ext: "ecelp7470" },
    { mime_type: "audio/vnd.nuera.ecelp9600", ext: "ecelp9600" },
    { mime_type: "audio/vnd.octel.sbc" },
    { mime_type: "audio/vnd.qcelp" },
    { mime_type: "audio/vnd.rhetorex.32kadpcm" },
    { mime_type: "audio/vnd.sealedmedia.softseal.mpeg" },
    { mime_type: "audio/vnd.vmx.cvsd" },
    { mime_type: "audio/vorbis" },
    { mime_type: "audio/vorbis-config" },
    { mime_type: "audio/x-aac", ext: "aac" },
    { mime_type: "audio/x-aiff", ext: "aif aiff aifc" },
    { mime_type: "audio/x-mpegurl", ext: "m3u" },
    { mime_type: "audio/x-ms-wax", ext: "wax" },
    { mime_type: "audio/x-ms-wma", ext: "wma" },
    { mime_type: "audio/x-pn-realaudio", ext: "ram ra" },
    { mime_type: "audio/x-pn-realaudio-plugin", ext: "rmp" },
    { mime_type: "audio/x-wav", ext: "wav" },
    { mime_type: "chemical/x-cdx", ext: "cdx" },
    { mime_type: "chemical/x-cif", ext: "cif" },
    { mime_type: "chemical/x-cmdf", ext: "cmdf" },
    { mime_type: "chemical/x-cml", ext: "cml" },
    { mime_type: "chemical/x-csml", ext: "csml" },
    { mime_type: "chemical/x-pdb" },
    { mime_type: "chemical/x-xyz", ext: "xyz" },
    { mime_type: "image/bmp", ext: "bmp" },
    { mime_type: "image/cgm", ext: "cgm" },
    { mime_type: "image/example" },
    { mime_type: "image/fits" },
    { mime_type: "image/g3fax", ext: "g3" },
    { mime_type: "image/gif", ext: "gif" },
    { mime_type: "image/ief", ext: "ief" },
    { mime_type: "image/jp2", ext: "jp2" },
    { mime_type: "image/jpeg", ext: "jpeg jpg jpe" },
    { mime_type: "image/jpm" },
    { mime_type: "image/jpx" },
    { mime_type: "image/naplps" },
    { mime_type: "image/pict", ext: "pict pic pct" },
    { mime_type: "image/png", ext: "png" },
    { mime_type: "image/prs.btif", ext: "btif" },
    { mime_type: "image/prs.pti" },
    { mime_type: "image/svg+xml", ext: "svg svgz" },
    { mime_type: "image/t38" },
    { mime_type: "image/tiff", ext: "tiff tif" },
    { mime_type: "image/tiff-fx" },
    { mime_type: "image/vnd.adobe.photoshop", ext: "psd" },
    { mime_type: "image/vnd.cns.inf2" },
    { mime_type: "image/vnd.djvu", ext: "djvu djv" },
    { mime_type: "image/vnd.dwg", ext: "dwg" },
    { mime_type: "image/vnd.dxf", ext: "dxf" },
    { mime_type: "image/vnd.fastbidsheet", ext: "fbs" },
    { mime_type: "image/vnd.fpx", ext: "fpx" },
    { mime_type: "image/vnd.fst", ext: "fst" },
    { mime_type: "image/vnd.fujixerox.edmics-mmr", ext: "mmr" },
    { mime_type: "image/vnd.fujixerox.edmics-rlc", ext: "rlc" },
    { mime_type: "image/vnd.globalgraphics.pgb" },
    { mime_type: "image/vnd.microsoft.icon" },
    { mime_type: "image/vnd.mix" },
    { mime_type: "image/vnd.ms-modi", ext: "mdi" },
    { mime_type: "image/vnd.net-fpx", ext: "npx" },
    { mime_type: "image/vnd.radiance" },
    { mime_type: "image/vnd.sealed.png" },
    { mime_type: "image/vnd.sealedmedia.softseal.gif" },
    { mime_type: "image/vnd.sealedmedia.softseal.jpg" },
    { mime_type: "image/vnd.svf" },
    { mime_type: "image/vnd.wap.wbmp", ext: "wbmp" },
    { mime_type: "image/vnd.xiff", ext: "xif" },
    { mime_type: "image/x-cmu-raster", ext: "ras" },
    { mime_type: "image/x-cmx", ext: "cmx" },
    { mime_type: "image/x-freehand", ext: "fh fhc fh4 fh5 fh7" },
    { mime_type: "image/x-icon", ext: "ico" },
    { mime_type: "image/x-macpaint", ext: "pntg pnt mac" },
    { mime_type: "image/x-pcx", ext: "pcx" },
    // {"mime_type":"image/x-pict", "ext":"pic pct"},
    { mime_type: "image/x-portable-anymap", ext: "pnm" },
    { mime_type: "image/x-portable-bitmap", ext: "pbm" },
    { mime_type: "image/x-portable-graymap", ext: "pgm" },
    { mime_type: "image/x-portable-pixmap", ext: "ppm" },
    { mime_type: "image/x-quicktime", ext: "qtif qti" },
    { mime_type: "image/x-rgb", ext: "rgb" },
    { mime_type: "image/x-xbitmap", ext: "xbm" },
    { mime_type: "image/x-xpixmap", ext: "xpm" },
    { mime_type: "image/x-xwindowdump", ext: "xwd" },
    { mime_type: "message/cpim" },
    { mime_type: "message/delivery-status" },
    { mime_type: "message/disposition-notification" },
    { mime_type: "message/example" },
    { mime_type: "message/external-body" },
    { mime_type: "message/global" },
    { mime_type: "message/global-delivery-status" },
    { mime_type: "message/global-disposition-notification" },
    { mime_type: "message/global-headers" },
    { mime_type: "message/http" },
    { mime_type: "message/imdn+xml" },
    { mime_type: "message/news" },
    { mime_type: "message/partial" },
    { mime_type: "message/rfc822", ext: "eml mime" },
    { mime_type: "message/s-http" },
    { mime_type: "message/sip" },
    { mime_type: "message/sipfrag" },
    { mime_type: "message/tracking-status" },
    { mime_type: "message/vnd.si.simp" },
    { mime_type: "model/example" },
    { mime_type: "model/iges", ext: "igs iges" },
    { mime_type: "model/mesh", ext: "msh mesh silo" },
    { mime_type: "model/vnd.dwf", ext: "dwf" },
    { mime_type: "model/vnd.flatland.3dml" },
    { mime_type: "model/vnd.gdl", ext: "gdl" },
    { mime_type: "model/vnd.gs-gdl" },
    { mime_type: "model/vnd.gs.gdl" },
    { mime_type: "model/vnd.gtw", ext: "gtw" },
    { mime_type: "model/vnd.moml+xml" },
    { mime_type: "model/vnd.mts", ext: "mts" },
    { mime_type: "model/vnd.parasolid.transmit.binary" },
    { mime_type: "model/vnd.parasolid.transmit.text" },
    { mime_type: "model/vnd.vtu", ext: "vtu" },
    { mime_type: "model/vrml", ext: "wrl vrml" },
    { mime_type: "multipart/alternative" },
    { mime_type: "multipart/appledouble" },
    { mime_type: "multipart/byteranges" },
    { mime_type: "multipart/digest" },
    { mime_type: "multipart/encrypted" },
    { mime_type: "multipart/example" },
    { mime_type: "multipart/form-data" },
    { mime_type: "multipart/header-set" },
    { mime_type: "multipart/mixed" },
    { mime_type: "multipart/parallel" },
    { mime_type: "multipart/related" },
    { mime_type: "multipart/report" },
    { mime_type: "multipart/signed" },
    { mime_type: "multipart/voice-message" },
    { mime_type: "text/calendar", ext: "ics ifb" },
    { mime_type: "text/css", ext: "css" },
    { mime_type: "text/csv", ext: "csv" },
    { mime_type: "text/directory" },
    { mime_type: "text/dns" },
    { mime_type: "text/ecmascript" },
    { mime_type: "text/enriched" },
    { mime_type: "text/example" },
    { mime_type: "text/html", ext: "html htm" },
    { mime_type: "text/javascript" },
    { mime_type: "text/parityfec" },
    { mime_type: "text/plain", ext: "txt text conf def list log in" },
    { mime_type: "text/prs.fallenstein.rst" },
    { mime_type: "text/prs.lines.tag", ext: "dsc" },
    { mime_type: "text/red" },
    { mime_type: "text/rfc822-headers" },
    { mime_type: "text/richtext", ext: "rtx" },
    { mime_type: "text/rtf" },
    { mime_type: "text/rtp-enc-aescm128" },
    { mime_type: "text/rtx" },
    { mime_type: "text/sgml", ext: "sgml sgm" },
    { mime_type: "text/t140" },
    { mime_type: "text/tab-separated-values", ext: "tsv" },
    { mime_type: "text/troff", ext: "t tr roff man me ms" },
    { mime_type: "text/ulpfec" },
    { mime_type: "text/uri-list", ext: "uri uris urls" },
    { mime_type: "text/vnd.abc" },
    { mime_type: "text/vnd.curl", ext: "curl" },
    { mime_type: "text/vnd.curl.dcurl", ext: "dcurl" },
    { mime_type: "text/vnd.curl.scurl", ext: "scurl" },
    { mime_type: "text/vnd.curl.mcurl", ext: "mcurl" },
    { mime_type: "text/vnd.dmclientscript" },
    { mime_type: "text/vnd.esmertec.theme-descriptor" },
    { mime_type: "text/vnd.fly", ext: "fly" },
    { mime_type: "text/vnd.fmi.flexstor", ext: "flx" },
    { mime_type: "text/vnd.graphviz", ext: "gv" },
    { mime_type: "text/vnd.in3d.3dml", ext: "3dml" },
    { mime_type: "text/vnd.in3d.spot", ext: "spot" },
    { mime_type: "text/vnd.iptc.newsml" },
    { mime_type: "text/vnd.iptc.nitf" },
    { mime_type: "text/vnd.latex-z" },
    { mime_type: "text/vnd.motorola.reflex" },
    { mime_type: "text/vnd.ms-mediapackage" },
    { mime_type: "text/vnd.net2phone.commcenter.command" },
    { mime_type: "text/vnd.si.uricatalogue" },
    { mime_type: "text/vnd.sun.j2me.app-descriptor", ext: "jad" },
    { mime_type: "text/vnd.trolltech.linguist" },
    { mime_type: "text/vnd.wap.si" },
    { mime_type: "text/vnd.wap.sl" },
    { mime_type: "text/vnd.wap.wml", ext: "wml" },
    { mime_type: "text/vnd.wap.wmlscript", ext: "wmls" },
    { mime_type: "text/x-asm", ext: "s asm" },
    { mime_type: "text/x-c", ext: "c cc cxx cpp h hh dic" },
    { mime_type: "text/x-fortran", ext: "f for f77 f90" },
    { mime_type: "text/x-pascal", ext: "p pas" },
    { mime_type: "text/x-java-source", ext: "java" },
    { mime_type: "text/x-setext", ext: "etx" },
    { mime_type: "text/x-uuencode", ext: "uu" },
    { mime_type: "text/x-vcalendar", ext: "vcs" },
    { mime_type: "text/x-vcard", ext: "vcf" },
    { mime_type: "text/xml" },
    { mime_type: "text/xml-external-parsed-entity" },
    { mime_type: "video/3gpp", ext: "3gp" },
    { mime_type: "video/3gpp-tt" },
    { mime_type: "video/3gpp2", ext: "3g2" },
    { mime_type: "video/bmpeg" },
    { mime_type: "video/bt656" },
    { mime_type: "video/celb" },
    { mime_type: "video/dv" },
    { mime_type: "video/example" },
    { mime_type: "video/h261", ext: "h261" },
    { mime_type: "video/h263", ext: "h263" },
    { mime_type: "video/h263-1998" },
    { mime_type: "video/h263-2000" },
    { mime_type: "video/h264", ext: "h264" },
    { mime_type: "video/jpeg", ext: "jpgv" },
    { mime_type: "video/jpeg2000" },
    { mime_type: "video/jpm", ext: "jpm jpgm" },
    { mime_type: "video/mj2", ext: "mj2 mjp2" },
    { mime_type: "video/mp1s" },
    { mime_type: "video/mp2p" },
    { mime_type: "video/mp2t" },
    { mime_type: "video/mp4", ext: "mp4 mp4v mpg4 m4v" },
    { mime_type: "video/mp4v-es" },
    { mime_type: "video/mpeg", ext: "mpeg mpg mpe m1v m2v" },
    { mime_type: "video/mpeg4-generic" },
    { mime_type: "video/mpv" },
    { mime_type: "video/nv" },
    { mime_type: "video/ogg", ext: "ogv" },
    { mime_type: "video/parityfec" },
    { mime_type: "video/pointer" },
    { mime_type: "video/quicktime", ext: "qt mov" },
    { mime_type: "video/raw" },
    { mime_type: "video/rtp-enc-aescm128" },
    { mime_type: "video/rtx" },
    { mime_type: "video/smpte292m" },
    { mime_type: "video/ulpfec" },
    { mime_type: "video/vc1" },
    { mime_type: "video/vnd.cctv" },
    { mime_type: "video/vnd.dlna.mpeg-tts" },
    { mime_type: "video/vnd.fvt", ext: "fvt" },
    { mime_type: "video/vnd.hns.video" },
    { mime_type: "video/vnd.iptvforum.1dparityfec-1010" },
    { mime_type: "video/vnd.iptvforum.1dparityfec-2005" },
    { mime_type: "video/vnd.iptvforum.2dparityfec-1010" },
    { mime_type: "video/vnd.iptvforum.2dparityfec-2005" },
    { mime_type: "video/vnd.iptvforum.ttsavc" },
    { mime_type: "video/vnd.iptvforum.ttsmpeg2" },
    { mime_type: "video/vnd.motorola.video" },
    { mime_type: "video/vnd.motorola.videop" },
    { mime_type: "video/vnd.mpegurl", ext: "mxu m4u" },
    { mime_type: "video/vnd.ms-playready.media.pyv", ext: "pyv" },
    { mime_type: "video/vnd.nokia.interleaved-multimedia" },
    { mime_type: "video/vnd.nokia.videovoip" },
    { mime_type: "video/vnd.objectvideo" },
    { mime_type: "video/vnd.sealed.mpeg1" },
    { mime_type: "video/vnd.sealed.mpeg4" },
    { mime_type: "video/vnd.sealed.swf" },
    { mime_type: "video/vnd.sealedmedia.softseal.mov" },
    { mime_type: "video/vnd.vivo", ext: "viv" },
    { mime_type: "video/x-dv", ext: "dv dif" },
    { mime_type: "video/x-f4v", ext: "f4v" },
    { mime_type: "video/x-fli", ext: "fli" },
    { mime_type: "video/x-flv", ext: "flv" },
    // {"mime_type":"video/x-m4v", "ext":"m4v"},
    { mime_type: "video/x-ms-asf", ext: "asf asx" },
    { mime_type: "video/x-ms-wm", ext: "wm" },
    { mime_type: "video/x-ms-wmv", ext: "wmv" },
    { mime_type: "video/x-ms-wmx", ext: "wmx" },
    { mime_type: "video/x-ms-wvx", ext: "wvx" },
    { mime_type: "video/x-msvideo", ext: "avi" },
    { mime_type: "video/x-sgi-movie", ext: "movie" },
    { mime_type: "x-conference/x-cooltalk", ext: "ice" }
  ]
};
function uDe({
  props: e,
  context: n,
  setMultiple: t
}) {
  const l = p1({
    maxFiles: e.maxFiles,
    maxFileSize: e.maxFileSize,
    hiddenInputContainer: e.hiddenInputContainer,
    clickable: e.clickable,
    acceptedFiles: e.acceptedFiles,
    dropzoneMessageClassName: e.dropzoneMessageClassName,
    accepts: []
  }), r = () => {
    const o = [];
    e.acceptedFiles !== null && e.acceptedFiles.forEach((a) => {
      zte.data.filter(
        (h) => h.ext && !!h.ext.split(/\s/).find((s) => a === s) || h.mime_type.startsWith(a)
      ).forEach((h) => {
        o.push(h.mime_type), h.ext && o.push(...h.ext.split(/\s/).map((s) => `.${s}`));
      });
    }), l.accepts = [...o];
  }, u = () => {
    n.emit("config-update", { ...l });
  };
  return r(), u(), di(
    () => e.acceptedFiles,
    (o) => {
      l.acceptedFiles.every((a) => o.includes(a)) || (l.acceptedFiles = [...o], r(), u());
    }
  ), di(
    () => e.maxFiles,
    (o) => {
      l.maxFiles !== o && (l.maxFiles = o, u());
    }
  ), di(
    () => e.maxFileSize,
    (o) => {
      l.maxFileSize !== o && (l.maxFileSize = o, u(), l.maxFileSize > 1 ? t(!0) : t(!1));
    }
  ), di(
    () => e.hiddenInputContainer,
    (o) => {
      l.hiddenInputContainer !== o && (l.hiddenInputContainer = o, u());
    }
  ), di(
    () => e.clickable,
    (o) => {
      l.clickable !== o && (l.clickable = o, u());
    }
  ), { config: l };
}
const sDe = Object.freeze({
  ADDED: "ADDED",
  QUEUED: "QUEUED",
  UPLOADING: "UPLOADING",
  ERROR: "ERROR",
  DONE: "DONE"
}), RD = [];
let ND = !1;
function oDe(e) {
  const n = (r) => {
    const u = new FileReader();
    u.addEventListener(
      "load",
      () => {
        e(r.id, u.result);
      },
      !1
    ), u.readAsDataURL(r.file);
  }, t = () => {
    if (ND || RD.length === 0)
      return;
    ND = !0;
    const r = RD.shift();
    r && n(r), ND = !1;
  };
  return { enqueueThumbnail: (r, u) => {
    (/\.(jpe?g|png|gif)$/i.test(u.name) || u.type.match("image.*")) && (RD.push({ id: r, file: u }), setTimeout(() => t(), 0));
  } };
}
function aDe({
  config: e,
  context: n
}) {
  const t = p1({
    ids: [],
    all: {}
  }), l = (s, d) => {
    t.all[s] && (t.all[s].thumbnail = d);
  }, { enqueueThumbnail: r } = oDe(l), u = (s) => {
    const d = t.ids.findIndex((_) => _ === s);
    if (d < 0)
      return;
    t.ids.splice(d, 1);
    const p = t.all[s];
    delete t.all[s], n.emit("removed-file", {
      file: p.file,
      status: p.status,
      id: s
    });
  }, o = (s) => {
    if (e.accepts === null || e.accepts.length === 0)
      return !0;
    const d = s.type;
    let p = e.accepts.findIndex(
      (_) => _.trim() === d.trim()
    ) !== -1;
    if (!p) {
      const _ = s.name.split(".");
      if (_.length > 1) {
        const R = _[_.length - 1], F = zte.data.filter(
          (L) => L.ext && !!L.ext.split(/\s/).find((G) => R === G)
        ).map((L) => L.mime_type);
        p = !!e.accepts.find(
          (L) => F.find((G) => G === L)
        );
      }
    }
    return p;
  };
  return { itemManager: {
    getItems: () => t,
    removeFile: u,
    addFile: (s, d) => {
      if (e.maxFileSize && d.size > e.maxFileSize) {
        n.emit("error-add", { files: [d], error: "MAX_FILE_SIZE" });
        return;
      }
      if (!o(d)) {
        n.emit("error-add", { files: [d], error: "INVALID_TYPE" });
        return;
      }
      if (e.maxFiles && t.ids.length + 1 > e.maxFiles) {
        n.emit("error-add", { files: [d], error: "MAX_FILE" });
        return;
      }
      t.ids.push(s), t.all[s] = {
        file: d,
        thumbnail: null,
        upload: { progress: 0 },
        status: sDe.ADDED,
        accepted: !0,
        id: s
      }, r(s, d), n.emit("added-file", { file: t.all[s].file, id: s });
    }
  } };
}
const cDe = cl({
  name: "lp-file-picker",
  props: {
    ...iDe,
    dropzoneRef: {
      type: String,
      default: "dropzone"
    },
    dropzoneClassName: {
      type: String,
      default: "dropzone__box"
    },
    dropzoneMessageClassName: {
      type: String,
      default: "dropzone__message--style"
    },
    dropzoneItemClassName: {
      type: String,
      default: "dropzone__item--style"
    },
    dropzoneDetailsClassName: {
      type: String,
      default: "dropzone__details--style"
    },
    dataUaUniqueId: {
      type: String,
      default: "unique-file-picker"
    }
  },
  emits: [
    "config-update",
    "added-file",
    "added-all-files",
    "removed-file",
    "error-upload",
    "uploaded",
    "uploaded-all",
    "sending",
    "error-add"
  ],
  setup(e, n) {
    const t = dt();
    dt(), dt(e.hiddenInputContainer);
    const l = dt(!0), {
      // Create the hidden input file
      initHiddenFileInput: r,
      // Destroy from the dom the hidden input file
      destroyHiddenFileInput: u,
      // set multiple attribute
      setMultiple: o,
      triggerClickOnHiddenFileInput: a
    } = rDe(), { config: h } = uDe({ props: e, context: n, setMultiple: o }), { itemManager: s } = aDe({ config: h, context: n }), { handleDragOver: d, onDrop: p } = lDe({
      itemManager: s,
      context: n
    }), _ = (R) => {
      n.emit("added-all-files", R.target.files);
    };
    return di(
      () => s.getItems(),
      (R) => {
        R.ids.length === 0 && Ta(() => {
          u(), r({
            config: h,
            dropzone: t,
            itemManager: s
          });
        });
      },
      { deep: !0 }
    ), di(
      () => e.clickable,
      (R) => {
        R || Ta(() => {
          u();
        });
      },
      { deep: !0 }
    ), cf(() => {
      l.value = J6e(), h.hiddenInputContainer = t.value, r({
        config: h,
        dropzone: t,
        itemManager: s
      });
    }), g4(() => {
      u();
    }), {
      ...w3(s.getItems()),
      accepts: h.accepts,
      onDrop: p,
      handleDragOver: d,
      removeFile: s.removeFile,
      filesize: tDe,
      dropzone: t,
      onChange: _
    };
  }
}), hDe = ["data-ua-unique-id"], fDe = { class: "dropzone__item-thumbnail" }, dDe = ["src"], pDe = { class: "dropzone__item-controls" }, mDe = ["onClick"], gDe = /* @__PURE__ */ qn("i", { class: "gg-close" }, null, -1), wDe = { class: "dropzone__success-mark" }, vDe = /* @__PURE__ */ qn("i", { class: "gg-check-o" }, null, -1), yDe = { class: "dropzone__error-mark" }, _De = /* @__PURE__ */ qn("i", { class: "gg-danger" }, null, -1), xDe = { class: "dropzone__file-size" }, SDe = ["innerHTML"], EDe = { class: "dropzone__filename" };
function ODe(e, n, t, l, r, u) {
  return Qe(), yn("form", {
    ref: e.dropzoneRef,
    class: xt(["dropzone", [e.dropzoneClassName]]),
    "data-ua-unique-id": e.dataUaUniqueId,
    onDrop: n[0] || (n[0] = (...o) => e.onDrop && e.onDrop(...o)),
    onChange: n[1] || (n[1] = (...o) => e.onChange && e.onChange(...o)),
    onDragover: n[2] || (n[2] = (...o) => e.handleDragOver && e.handleDragOver(...o))
  }, [
    e.ids.length === 0 ? (Qe(), yn("div", {
      key: 0,
      class: xt(["dropzone__message", [e.dropzoneMessageClassName]])
    }, [
      el(e.$slots, "message", {}, () => [
        Ir("Drag and Drop file here")
      ])
    ], 2)) : st("", !0),
    (Qe(!0), yn(Ii, null, ru(e.all, (o, a) => (Qe(), yn("div", {
      key: a,
      class: xt(["dropzone__item", [
        {
          "dropzone--has-thumbnail": !!o.thumbnail,
          "dropzone--added": o.status === "ADDED",
          "dropzone--processing": o.status === "UPLOADING",
          "dropzone--success": o.status === "DONE",
          "dropzone--has-error": o.status === "ERROR"
        },
        e.dropzoneItemClassName
      ]])
    }, [
      qn("div", fDe, [
        o.thumbnail ? (Qe(), yn("img", {
          key: 0,
          src: o.thumbnail
        }, null, 8, dDe)) : st("", !0)
      ]),
      qn("div", pDe, [
        qn("div", {
          class: "dropzone__item-control",
          onClick: (h) => e.removeFile(a)
        }, [
          el(e.$slots, "remove", {}, () => [
            gDe
          ])
        ], 8, mDe)
      ]),
      qn("div", wDe, [
        el(e.$slots, "success", {}, () => [
          vDe
        ])
      ]),
      qn("div", yDe, [
        el(e.$slots, "error", {}, () => [
          _De
        ])
      ]),
      qn("div", {
        class: xt(["dropzone__details", [e.dropzoneDetailsClassName]])
      }, [
        qn("div", xDe, [
          qn("span", {
            innerHTML: e.filesize(o.file.size)
          }, null, 8, SDe)
        ]),
        qn("div", EDe, [
          qn("span", null, It(o.file.name), 1)
        ])
      ], 2)
    ], 2))), 128))
  ], 42, hDe);
}
const nO = /* @__PURE__ */ Cr(cDe, [["render", ODe]]);
nO.install = (e) => {
  e.component(nO.name, nO);
};
const kDe = { class: "lp-input-mask" }, bDe = {
  key: 0,
  class: "text-blue"
}, TDe = {
  key: 0,
  class: "lp-input-icon-wrapper"
}, jDe = {
  key: 1,
  class: "lp-input-preview"
}, ADe = ["data-ua-unique-id", "type", "disabled", "value", "placeholder", "maxlength", "aria-label"], DDe = { class: "ly-row ly-spacebetween-center" }, IDe = {
  key: 1,
  class: "lp-input-message mt-half d-flex text-gray"
}, RDe = {
  name: "lp-input",
  inheritAttrs: !1
}, tO = /* @__PURE__ */ cl({
  ...RDe,
  props: {
    status: { default: _r.NEUTRAL },
    type: { default: "text" },
    showCount: { type: Boolean, default: !1 },
    maxLength: { default: 1 / 0 },
    size: { default: "default" },
    message: { default: null },
    helper: { default: null },
    placeholder: { default: null },
    disabled: { type: Boolean, default: !1 },
    labelTop: { default: null },
    modelValue: { default: null },
    prefix: { default: null },
    suffix: { default: null },
    prefixIcon: { default: null },
    suffixIcon: { default: null },
    required: { type: [Boolean, null], default: !1 },
    mask: { type: [Boolean, null], default: !1 },
    compact: { type: [Boolean, null], default: !1 },
    preview: { type: [Boolean, null], default: !1 },
    forcePrefix: { type: [Boolean, null], default: !1 },
    forcePrefixIcon: { type: [Boolean, null], default: !1 },
    forceSuffixIcon: { type: [Boolean, null], default: !1 },
    forceSuffix: { type: [Boolean, null], default: !1 },
    forceMessage: { type: [Boolean, null], default: !1 },
    dataUaUniqueId: { default: "unique-input" },
    prefixIconAriaHidden: { default: "false" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, l = dt(!1), r = dt(null), u = dt(0);
    function o(h) {
      t("update:modelValue", h.target.value), u.value = h.target.value.length;
    }
    async function a() {
      await Ta(() => {
        const h = r.value;
        h && h.focus();
      });
    }
    return (h, s) => {
      const d = El("lp-icon");
      return Qe(), yn("div", null, [
        dl(du, { name: "fade" }, {
          default: kl(() => [
            pi(qn("div", kDe, null, 512), [
              [Pi, l.value && h.mask]
            ])
          ]),
          _: 1
        }),
        h.labelTop ? (Qe(), yn("span", {
          key: 0,
          class: xt(["lp-input-label font-weight-medium", !h.preview && h.message ? "text-error" : ""])
        }, [
          Ir(It(h.labelTop) + " ", 1),
          !h.preview && h.required ? (Qe(), yn("span", bDe, "*")) : st("", !0)
        ], 2)) : st("", !0),
        qn("div", {
          class: "lp-input-prefix-wrapper",
          style: Hi(
            h.showCount || h.message || h.helper || h.size === "compact" || h.compact ? "" : "padding-bottom: 22px;"
          )
        }, [
          h.forcePrefix || !h.preview && h.prefix ? (Qe(), yn("div", {
            key: 0,
            class: xt(["lp-input-prefix", [h.preview && "lp-input-prefix-preview"]])
          }, It(h.prefix), 3)) : st("", !0),
          qn("div", {
            class: xt(["lp-input-wrapper", [
              !h.preview && h.message && `lp-input-wrapper-${h.message ? "danger" : h.status}`,
              h.disabled && "lp-input-wrapper-disabled",
              h.preview && "lp-input-wrapper-preview"
            ]])
          }, [
            h.forcePrefixIcon || !h.preview && h.prefixIcon ? (Qe(), yn("span", TDe, [
              h.prefixIcon ? (Qe(), _l(d, {
                key: 0,
                class: "lp-input-icon",
                "aria-hidden": h.prefixIconAriaHidden,
                name: h.prefixIcon
              }, null, 8, ["aria-hidden", "name"])) : st("", !0)
            ])) : st("", !0),
            h.preview ? (Qe(), yn("span", jDe, It(h.modelValue), 1)) : (Qe(), yn("input", Ni({
              key: 2,
              ref_key: "inputElement",
              ref: r,
              "data-ua-unique-id": h.dataUaUniqueId
            }, h.$attrs, {
              type: h.type,
              class: "lp-input",
              disabled: h.disabled,
              value: h.modelValue,
              placeholder: h.placeholder,
              maxlength: h.maxLength,
              "aria-label": h.placeholder,
              onInput: o,
              onFocus: s[0] || (s[0] = (p) => l.value = !0),
              onBlur: s[1] || (s[1] = (p) => l.value = !1)
            }), null, 16, ADe)),
            el(h.$slots, "clear"),
            h.forceSuffixIcon || !h.preview && h.suffixIcon ? (Qe(), yn("span", {
              key: 3,
              ref: "inputSuffixIcon",
              class: "lp-input-icon-wrapper",
              onClick: a
            }, [
              h.suffixIcon ? (Qe(), _l(d, {
                key: 0,
                class: "lp-input-icon",
                name: h.suffixIcon
              }, null, 8, ["name"])) : st("", !0)
            ], 512)) : st("", !0)
          ], 2),
          h.forceSuffix || !h.preview && h.suffix ? (Qe(), yn("div", {
            key: 1,
            class: xt(["lp-input-suffix", [h.preview && "lp-input-suffix-preview"]])
          }, It(h.suffix), 3)) : st("", !0)
        ], 4),
        dl(du, { name: "fade-bottom" }, {
          default: kl(() => [
            qn("div", DDe, [
              h.forceMessage || !h.preview && h.message ? (Qe(), yn("span", {
                key: 0,
                class: xt(["lp-input-message mt-half d-flex", [
                  h.message && `lp-input-message-${h.message ? "danger" : h.status}`,
                  h.disabled && "lp-input-message-disabled"
                ]])
              }, [
                !h.preview && h.message ? (Qe(), _l(d, {
                  key: 0,
                  name: "info",
                  class: "mr-half"
                })) : st("", !0),
                Ir(" " + It(h.message), 1)
              ], 2)) : st("", !0),
              h.message ? st("", !0) : (Qe(), yn("span", IDe, It(h.helper), 1)),
              !h.preview && h.showCount && h.maxLength !== 1 / 0 ? (Qe(), yn("span", {
                key: 2,
                class: xt(["lp-input-message mt-half d-flex", [
                  h.message && `lp-input-message-${h.message ? "danger" : h.status}`,
                  h.disabled && "lp-input-message-disabled"
                ]])
              }, It(`${u.value}/${h.maxLength}`), 3)) : st("", !0)
            ])
          ]),
          _: 1
        })
      ]);
    };
  }
});
tO.install = (e) => {
  e.component(tO.name, tO);
};
var Kte = /* @__PURE__ */ ((e) => (e.TEXT = "lp-input", e.NUMBER = "lp-number-input", e.PHONE = "lp-phone-input", e.URL = "lp-url-input", e.ZIP = "lp-zip-input", e.EMAIL = "lp-email-input", e))(Kte || {});
const NDe = ["data-ua-unique-id"], CDe = { class: "lp-input-label font-weight-medium" }, MDe = {
  key: 0,
  class: "text-blue"
}, PDe = { class: "ly-col" }, $De = {
  key: 0,
  class: "ly-row"
}, LDe = {
  key: 1,
  class: "lp-input-message mt-half d-flex text-gray"
}, BDe = /* @__PURE__ */ cl({
  name: "lp-input-list",
  inheritAttrs: !1,
  __name: "LpInputList",
  props: {
    status: { default: "neutral" },
    message: { default: null },
    helper: { default: null },
    disabled: { type: Boolean, default: !1 },
    labelTop: {},
    modelValue: { default: void 0 },
    options: {},
    prefixIcon: { default: null },
    format: { default: nh.Decimal },
    trackBy: { default: "value" },
    typeBy: { default: "type" },
    optionsLabel: { default: "label" },
    optionsValue: { default: "value" },
    primaryBy: { default: "isPrimary" },
    categoryBy: {},
    required: { type: [Boolean, null], default: !1 },
    inputType: { default: "TEXT" },
    preview: { type: [Boolean, null], default: !1 },
    dataUaUniqueId: { default: "unique-input-list" },
    uaIdSelect: { type: [String, null, Boolean], default: "select" },
    uaIdInput: { type: [String, null, Boolean], default: "input" },
    uaIdRemoveButton: { type: [String, null, Boolean], default: "remove-button" },
    uaIdPrimaryButton: { type: [String, null, Boolean], default: "make-primary-button" }
  },
  setup(e) {
    const n = e;
    dt(null);
    const t = dt(n.modelValue), l = dt(
      n.inputType.toUpperCase()
    ), r = Kte[l.value];
    cf(() => {
    });
    const u = () => {
      t.value.push({
        [n.trackBy]: null,
        [n.typeBy]: null,
        [n.primaryBy]: !1,
        [n.typeBy]: null
      });
    }, o = (h) => {
      t.value.splice(h, 1);
    }, a = (h) => {
      t.value.forEach((s) => {
        s[n.primaryBy] = !1;
      }), t.value[h][n.primaryBy] = !0;
    };
    return dt(null), (h, s) => {
      const d = El("lp-select"), p = El("lp-button");
      return Qe(), yn("div", {
        class: xt([h.preview && "lp-input-list-preview"]),
        "data-ua-unique-id": h.dataUaUniqueId
      }, [
        qn("span", CDe, [
          Ir(It(h.labelTop) + " ", 1),
          !h.preview && h.required ? (Qe(), yn("span", MDe, "*")) : st("", !0)
        ]),
        qn("div", PDe, [
          (Qe(!0), yn(Ii, null, ru(t.value, (_, R) => (Qe(), yn("div", {
            key: R,
            class: "ly-row"
          }, [
            h.options ? (Qe(), _l(d, {
              key: 0,
              modelValue: _[h.typeBy],
              "onUpdate:modelValue": (F) => _[h.typeBy] = F,
              options: h.options,
              "label-by": h.optionsLabel,
              "track-by": h.optionsValue,
              "data-ua-multiple-id": `${h.uaIdSelect ? `${h.uaIdSelect}-${R}` : void 0}`,
              preview: h.preview || !1,
              style: { "max-width": "10rem" },
              class: "w-100",
              compact: ""
            }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "label-by", "track-by", "data-ua-multiple-id", "preview"])) : st("", !0),
            (Qe(), _l(ap(Zr(r)), {
              key: R,
              ref_for: !0,
              ref: "componentWrapper",
              modelValue: _[h.trackBy],
              "onUpdate:modelValue": (F) => _[h.trackBy] = F,
              disabled: h.disabled,
              "prefix-icon": h.prefixIcon,
              format: h.format,
              "data-ua-multiple-id": `${h.uaIdInput ? `${h.uaIdInput}-${R}` : void 0}`,
              preview: h.preview
            }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled", "prefix-icon", "format", "data-ua-multiple-id", "preview"])),
            !h.preview && t.value.length > 1 ? (Qe(), _l(p, {
              key: 1,
              type: "error",
              icon: "trash",
              text: "",
              class: "text-error",
              "data-ua-multiple-id": `${h.uaIdRemoveButton ? `${h.uaIdRemoveButton}-${R}` : void 0}`,
              onClick: (F) => o(R)
            }, null, 8, ["data-ua-multiple-id", "onClick"])) : st("", !0),
            h.preview ? st("", !0) : (Qe(), _l(p, {
              key: 2,
              type: "neutral",
              icon: "star",
              text: "",
              class: xt(_[h.primaryBy] ? "text-blue" : "text-gray"),
              "data-ua-multiple-id": `${h.uaIdPrimaryButton ? `${h.uaIdPrimaryButton}-${R}` : void 0}`,
              onClick: (F) => a(R)
            }, null, 8, ["class", "data-ua-multiple-id", "onClick"]))
          ]))), 128)),
          h.preview ? st("", !0) : (Qe(), yn("div", $De, [
            dl(p, {
              type: "neutral",
              icon: "plus",
              text: "",
              onClick: s[0] || (s[0] = (_) => u())
            }, {
              default: kl(() => [
                Ir(" Add new ")
              ]),
              _: 1
            })
          ]))
        ]),
        h.message ? (Qe(), yn("span", {
          key: 0,
          class: xt(["lp-input-message mt-half d-flex", [
            h.status ? `lp-input-message-${h.status}` : "lp-input-message-danger",
            h.disabled && "lp-input-message-disabled"
          ]])
        }, It(h.message), 3)) : st("", !0),
        h.message ? st("", !0) : (Qe(), yn("span", LDe, It(h.helper), 1))
      ], 10, NDe);
    };
  }
}), lO = /* @__PURE__ */ Cr(BDe, [["__scopeId", "data-v-6fbbb11d"]]);
lO.install = (e) => {
  e.component(lO.name, lO);
};
const FDe = {
  key: 0,
  class: "lp-list-label font-weight-medium"
}, VDe = {
  key: 0,
  class: "text-blue"
}, YDe = { key: 1 }, UDe = {
  key: 2,
  class: "lp-list-wrapper",
  "data-ua-unique-id": "unique-list"
}, qDe = { class: "lp-list mt-1" }, rO = /* @__PURE__ */ cl({
  name: "lp-list",
  __name: "LpList",
  props: {
    labelBy: { default: "label" },
    trackBy: { default: "id" },
    search: { type: Boolean, default: !1 },
    options: { default: () => [] },
    modelValue: { default: () => [] },
    preview: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    labelTop: { default: null }
  },
  emits: ["search-emit", "list-updated"],
  setup(e, { emit: n }) {
    const t = e, l = n, r = dt([...t.modelValue]), u = p1({
      value: ""
    });
    di(
      () => t.modelValue,
      () => {
        r.value = [...t.modelValue];
      }
    ), vs(
      "searchEmitValue",
      _t(() => u.value?.toLowerCase())
    );
    const o = () => r.value.flatMap(
      (s) => t.options.filter(
        (d) => d[t.trackBy] === s
      )
    ), a = (s) => {
      const d = r.value.indexOf(s[t.trackBy]);
      d !== -1 ? r.value.splice(d, 1) : r.value.push(s[t.trackBy]), h(s), l("list-updated", r.value, o());
    }, h = (s) => r.value.indexOf(s[t.trackBy]) !== -1;
    return (s, d) => {
      const p = El("lp-input"), _ = El("lp-checkbox");
      return Qe(), yn("div", null, [
        s.labelTop ? (Qe(), yn("span", FDe, [
          Ir(It(s.labelTop) + " ", 1),
          !s.preview && s.required ? (Qe(), yn("span", VDe, "*")) : st("", !0)
        ])) : st("", !0),
        s.preview ? (Qe(), yn("span", YDe, It(s.options.filter((R) => h(R)).map((R) => R[s.labelBy]).join(", ")), 1)) : (Qe(), yn("div", UDe, [
          s.search ? (Qe(), _l(p, {
            key: 0,
            modelValue: u.value,
            "onUpdate:modelValue": d[0] || (d[0] = (R) => u.value = R),
            placeholder: "Filter options...",
            "prefix-icon": "search",
            size: "compact"
          }, null, 8, ["modelValue"])) : st("", !0),
          qn("div", qDe, [
            (Qe(!0), yn(Ii, null, ru(s.options, (R, F) => (Qe(), _l(_, {
              id: R[s.trackBy],
              key: F,
              "model-value": h(R),
              label: R[s.labelBy],
              disabled: R.disabled,
              "onUpdate:modelValue": (L) => a(R)
            }, null, 8, ["id", "model-value", "label", "disabled", "onUpdate:modelValue"]))), 128))
          ])
        ]))
      ]);
    };
  }
});
rO.install = (e) => {
  e.component(rO.name, rO);
};
const WDe = cl({
  name: "lp-loading",
  props: {
    stroke: { default: 6, type: Number },
    radius: { default: 32, type: Number },
    color: { default: "#1A62FF", type: String }
  },
  setup(e) {
    return { normalizedRadius: _t(() => e.radius - e.stroke / 2) };
  }
}), HDe = ["stroke", "stroke-width", "r", "cx", "cy"];
function zDe(e, n, t, l, r, u) {
  return Qe(), yn("svg", {
    class: "lp-loading",
    style: Hi({
      "max-width": `${e.radius * 2}px`,
      "max-height": `${e.radius * 2}px`
    })
  }, [
    qn("circle", {
      class: "lp-loading-circle",
      stroke: e.color,
      "stroke-width": e.stroke,
      "stroke-linecap": "round",
      fill: "none",
      r: e.normalizedRadius,
      cx: e.radius,
      cy: e.radius,
      pathLength: "100"
    }, null, 8, HDe)
  ], 4);
}
const iO = /* @__PURE__ */ Cr(WDe, [["render", zDe]]);
iO.install = (e) => {
  e.component(iO.name, iO);
};
const KDe = cl({
  name: "lp-loading-bar",
  data() {
    return {
      progress: 0,
      height: 2,
      start: !1
    };
  },
  watch: {
    progress(e) {
      e === 100 && setTimeout(() => {
        this.progress = 0, this.height = 2;
      }, 600);
    }
  }
});
function GDe(e, n, t, l, r, u) {
  return Qe(), yn("div", {
    class: xt(["lp-loadingbar", {
      "lp-loadingbar-start": e.start
    }]),
    style: Hi({
      width: e.progress + "%",
      height: e.height + "px"
    })
  }, null, 6);
}
const ZDe = /* @__PURE__ */ Cr(KDe, [["render", GDe]]);
class XDe {
  loadingInstance = rL(ZDe);
  loadEl;
  constructor() {
    const n = this.loadingInstance.mount(document.createElement("div"));
    document.body.appendChild(n.$el), this.loadEl = n;
  }
  start() {
    this.loadEl.$data.start = !0, this.loadEl.$data.progress = 90;
  }
  update(n) {
    this.loadEl.$data.start = !1, this.loadEl.$data.progress = n;
  }
  finish() {
    this.loadEl.$data.start = !1, this.loadEl.$data.progress = 100, this.loadEl.$data.height = 0;
  }
}
const QDe = new XDe(), Gte = (e, n = 0, t = 1) => e > t ? t : e < n ? n : e, JDe = cl({
  name: "lp-loading-circle",
  props: {
    strokeWidth: { default: 6, type: Number },
    size: { default: 32, type: Number },
    color: { default: "#1A62FF", type: String },
    progress: { default: 0, type: Number },
    progressWidth: { default: 6, type: Number },
    showPercentage: { default: !1, type: Boolean }
  },
  setup(e) {
    const n = _t(() => 3.14 * (e.size / 2 - 10) * 2), t = _t(() => `${n.value}px`), l = _t(
      () => `${Math.round(
        n.value * ((100 - e.progress) / 100)
      )}px`
    ), r = dt(null), u = _t(
      () => r.value ? r.value?.getBoundingClientRect() : 0
    ), o = _t(
      () => `${Math.round(
        e.size / 2 - u.value.width / (e.showPercentage ? 1.75 : 1.5)
      )}px`
    ), a = _t(
      () => `${Math.round(e.size / 2 + u.value.width / 2 + 10)}px`
    ), h = _t(
      () => `${Math.round(e.size / 2 + u.value.height / 3.25)}px`
    ), s = _t(
      () => `${Gte(
        e.size * 0.4,
        e.size * 0.1,
        e.showPercentage ? e.size * 0.3 : e.size * 0.4
      )}px`
    ), d = _t(() => e.size / 2);
    return cf(() => {
      console.log();
    }), {
      circumferenceValue: n,
      circumferenceText: t,
      percentage: l,
      percentageTextX: a,
      textX: o,
      textY: h,
      textRef: r,
      textDimensions: u,
      fontSize: s,
      radius: d
    };
  }
}), eIe = ["width", "height", "viewBox"], nIe = ["r", "cx", "cy", "stroke-width", "stroke-dasharray"], tIe = ["r", "cx", "cy", "stroke", "stroke-width", "stroke-dashoffset", "stroke-dasharray"], lIe = ["x", "y", "fill", "font-size"];
function rIe(e, n, t, l, r, u) {
  return Qe(), yn("svg", {
    width: e.size,
    height: e.size,
    viewBox: `-${e.size * 0.125} -${e.size * 0.125} ${e.size * 1.25} ${e.size * 1.25}`,
    xmlns: "http://www.w3.org/2000/svg",
    style: { transform: "rotate(-90deg)" }
  }, [
    qn("circle", {
      r: e.radius - 10,
      cx: e.radius,
      cy: e.radius,
      fill: "transparent",
      stroke: "#ccc",
      "stroke-width": e.strokeWidth,
      "stroke-dasharray": e.circumferenceText,
      "stroke-dashoffset": "0"
    }, null, 8, nIe),
    qn("circle", {
      r: e.radius - 10,
      cx: e.radius,
      cy: e.radius,
      stroke: e.color,
      "stroke-width": e.strokeWidth,
      fill: "transparent",
      "stroke-linecap": "round",
      "stroke-dashoffset": e.percentage,
      "stroke-dasharray": e.circumferenceText
    }, null, 8, tIe),
    qn("text", {
      ref: "textRef",
      x: e.textX,
      y: e.textY,
      fill: e.color,
      "font-size": e.fontSize,
      "font-weight": "bold",
      style: Hi(`transform: rotate(90deg) translate(0px, -${e.size - 4}px)`)
    }, It(e.progress) + It(e.showPercentage ? "%" : ""), 13, lIe)
  ], 8, eIe);
}
const uO = /* @__PURE__ */ Cr(JDe, [["render", rIe]]);
uO.install = (e) => {
  e.component(uO.name, uO);
};
const iIe = cl({
  name: "msg",
  components: {
    LpIcon: Af
  },
  data() {
    return {
      id: null,
      show: !1,
      text: "",
      duration: 4e3,
      onClose: () => {
      },
      top: 6,
      type: "info",
      timer: null
    };
  },
  mounted() {
    this.show || this.startTimer();
  },
  methods: {
    destroy() {
      this.$el.parentNode.removeChild(this.$el);
    },
    startTimer() {
      this.duration > 0 && (this.timer = setTimeout(() => {
        this.show = !1, this.onClose && this.onClose();
      }, this.duration));
    },
    clearTimer() {
      clearTimeout(this.timer);
    }
  }
});
function uIe(e, n, t, l, r, u) {
  const o = El("lp-icon");
  return Qe(), _l(du, {
    name: "fade-bottom",
    onAfterLeave: e.destroy
  }, {
    default: kl(() => [
      pi(qn("div", {
        style: Hi({ top: `${e.top}px` }),
        class: xt(["msg msg-fixed", [`msg-${e.type}`]]),
        onMouseleave: n[0] || (n[0] = (...a) => e.startTimer && e.startTimer(...a)),
        onMouseenter: n[1] || (n[1] = (...a) => e.clearTimer && e.clearTimer(...a))
      }, [
        qn("span", null, [
          dl(o, {
            class: "mr-half",
            name: e.type
          }, null, 8, ["name"])
        ]),
        Ir(" " + It(e.text), 1)
      ], 38), [
        [Pi, e.show]
      ])
    ]),
    _: 1
  }, 8, ["onAfterLeave"]);
}
const sIe = /* @__PURE__ */ Cr(iIe, [["render", uIe]]), oIe = [
  _r.PRIMARY,
  _r.SUCCESS,
  _r.ERROR,
  _r.WARNING
], jv = [];
let aIe = 0;
const m3 = (e = {}) => {
  const n = e.onClose, t = aIe++;
  e.onClose = () => {
    m3.close(t, n);
  };
  const l = document.createElement("div"), r = rL(sIe).mount(l), u = Object.assign(e, { id: t });
  for (const [a, h] of Object.entries(u))
    r.$data[a] = h;
  document.body.appendChild(r.$el), r.$data.show = !0;
  let o = 0;
  return jv.forEach((a) => {
    o += a.$el.offsetHeight + 6;
  }), r.$data.top = o + 6, jv.push(r), r;
};
m3.close = (e, n) => {
  const t = jv.findIndex((r) => r.$data.id === e), l = jv[t].$el.offsetHeight;
  jv.splice(t, 1), n && n(), jv.forEach((r) => {
    r.$data.id > e && (r.top -= l + 6);
  });
};
oIe.forEach((e) => {
  m3[e] = (n) => m3({ type: e, ...n });
});
const cIe = {
  [_r.PRIMARY]: "sms",
  [_r.SUCCESS]: "success",
  [_r.WARNING]: "warning",
  [_r.DANGER]: "error"
}, hIe = {
  [_r.PRIMARY]: "#1A62FF",
  [_r.SUCCESS]: "#07d85b",
  [_r.DANGER]: "#F93155",
  [_r.WARNING]: "#ffba00"
}, fIe = cl({
  name: "lp-notification",
  components: {
    "lp-alert": I_
  },
  data() {
    return {
      id: null,
      show: !1,
      text: "",
      title: "",
      icon: "",
      emoji: "",
      image: "",
      duration: 5e3,
      position: {},
      placement: sl.TR,
      type: _r.PRIMARY,
      timer: null,
      onClose: () => {
      }
    };
  },
  computed: {
    backgroundImage() {
      return this.image ? `url(${this.image})` : "";
    },
    typeColor() {
      return this.emoji ? "#fbfbfb" : hIe[this.type];
    },
    positionPx() {
      const e = {};
      for (const n in this.position)
        this.position.hasOwnProperty(n) && (e[n] = this.position[n] + "px");
      return e;
    },
    typeIcon() {
      return cIe[this.type];
    }
  },
  mounted() {
    this.startTimer();
  },
  methods: {
    destroy() {
      this.$el.parentNode.removeChild(this.$el);
    },
    startTimer() {
      this.duration > 0 && (this.timer = setTimeout(() => {
        this.show = !1, this.onClose && this.onClose();
      }, this.duration));
    },
    clearTimer() {
      clearTimeout(this.timer);
    }
  }
});
function dIe(e, n, t, l, r, u) {
  const o = El("lp-alert");
  return Qe(), _l(du, {
    name: "fade-bottom",
    onAfterLeave: e.destroy
  }, {
    default: kl(() => [
      pi(qn("div", {
        style: Hi(e.positionPx),
        class: xt(["lp-notification", [`lp-notification--${e.type}`]]),
        onMouseleave: n[0] || (n[0] = (...a) => e.startTimer && e.startTimer(...a)),
        onMouseenter: n[1] || (n[1] = (...a) => e.clearTimer && e.clearTimer(...a))
      }, [
        dl(o, {
          type: e.type,
          title: e.title ? e.title : "",
          body: e.text ? e.text : ""
        }, null, 8, ["type", "title", "body"])
      ], 38), [
        [Pi, e.show]
      ])
    ]),
    _: 1
  }, 8, ["onAfterLeave"]);
}
const pIe = /* @__PURE__ */ Cr(fIe, [["render", dIe]]), uw = [];
let mIe = 0;
const g3 = (e = {}) => {
  e.placement = e.placement || sl.TR;
  const n = e.onClose, t = mIe++;
  e.onClose = () => {
    g3.close(t, n);
  };
  const l = document.createElement("div"), r = rL(pIe).mount(l), u = Object.assign(e, { id: t });
  for (const [a, h] of Object.entries(u))
    r.$data[a] = h;
  document.body.appendChild(r.$el), r.$data.show = !0;
  const o = {
    [sl.TR]: 0,
    [sl.TL]: 0,
    [sl.BR]: 0,
    [sl.BL]: 0
  };
  return uw.filter(
    (a) => a.$data.placement === e.placement
  ).forEach((a) => {
    o[e.placement] += a.$el.offsetHeight + 6;
  }), r.$data.position = {
    [e.placement.split("-")[0]]: o[e.placement] + 6,
    [e.placement.split("-")[1]]: 10
  }, uw.push(r), r;
};
g3.close = (e, n) => {
  const t = uw.findIndex(
    (r) => r.$data.id === e
  ), l = uw[t].$el.offsetHeight;
  n && n(), uw.filter(
    (r) => r.$data.placement === uw[t].$data.placement
  ).forEach((r) => {
    const u = r.$data;
    if (u.id > e) {
      const o = u.placement.split("-");
      u.position = {
        [o[0]]: u.position[o[0]] - (l + 6),
        [o[1]]: 10
      };
    }
  }), uw.splice(t, 1);
};
[_r.PRIMARY, _r.SUCCESS, _r.DANGER, _r.WARNING].forEach(
  (e) => {
    g3[e] = (n) => g3({ ...n, type: e });
  }
);
C_.install = (e) => {
  e.component(C_.name, C_);
};
const gIe = {
  key: 0,
  class: "lp-daterangepicker lp-daterangepicker-preview"
}, wIe = {
  key: 0,
  class: "lp-daterangepicker-label font-weight-medium"
}, vIe = {
  key: 0,
  class: "text-blue"
}, yIe = {
  key: 1,
  class: "lp-daterangepicker"
}, _Ie = { style: { margin: "0" } }, xIe = {
  key: 0,
  class: "mt-1 text-red"
}, sO = /* @__PURE__ */ cl({
  name: "lp-numberrangepicker",
  inheritAttrs: !1,
  __name: "LpNumberRangePicker",
  props: {
    modelValue: { default: null },
    format: { default: nh.Decimal },
    start: { default: null },
    end: { default: null },
    status: { default: "neutral" },
    labelTop: { default: null },
    placeholder: { default: null },
    message: { default: null },
    labelBy: { default: "name" },
    trackBy: { default: "value" },
    customRangeLabel: { default: "Custom Range" },
    disabled: { type: Boolean, default: !1 },
    required: { type: [Boolean, null], default: !1 },
    preview: { type: [Boolean, null], default: !1 },
    previewSeparator: { default: "" },
    options: { default: () => [] }
  },
  emits: ["update-range", "update-selection"],
  setup(e, { emit: n }) {
    const t = n, l = e, r = _t(() => {
      let J = l.customRangeLabel;
      return p.value === _.value ? J += ` (${gY(
        [p.value, _.value],
        l.format
      )})` : (p.value || _.value) && (J += ` (${gY(
        [p.value, _.value],
        l.format
      )})`), { name: J, value: o };
    }), u = _t(() => [...l.options, r.value]), {
      CUSTOM_RANGE: o,
      selected: a,
      modal: h,
      updateSelection: s,
      updateRange: d,
      startValue: p,
      endValue: _,
      labelValue: R,
      validRange: F,
      validationMessage: L,
      onCancel: G
    } = Ite(l, t);
    return di(
      () => l.modelValue,
      (J) => {
        a.value = J;
      }
    ), di(
      () => l.start,
      (J) => {
        p.value = J, J !== null ? a.value = o : a.value = l.modelValue || null;
      },
      { immediate: !0 }
    ), di(
      () => l.end,
      (J) => {
        _.value = J, J !== null ? a.value = o : a.value = l.modelValue || null;
      },
      { immediate: !0 }
    ), (J, we) => {
      const ce = El("lp-number-input"), xe = El("lp-select"), $e = El("lp-button"), je = El("lp-modal");
      return J.preview ? (Qe(), yn("div", gIe, [
        J.labelTop ? (Qe(), yn("span", wIe, [
          el(J.$slots, "label-top", { props: l }, () => [
            Ir(It(J.labelTop) + " ", 1),
            !J.preview && J.required ? (Qe(), yn("span", vIe, "*")) : st("", !0)
          ])
        ])) : st("", !0),
        dl(ce, {
          modelValue: Zr(p),
          "onUpdate:modelValue": we[0] || (we[0] = (E) => om(p) ? p.value = E : null),
          "label-top": "Start value",
          "hide-controls": "",
          preview: J.preview
        }, null, 8, ["modelValue", "preview"]),
        Ir(" " + It(J.previewSeparator) + " ", 1),
        dl(ce, {
          modelValue: Zr(_),
          "onUpdate:modelValue": we[1] || (we[1] = (E) => om(_) ? _.value = E : null),
          "label-top": "End value",
          "hide-controls": "",
          preview: J.preview
        }, null, 8, ["modelValue", "preview"])
      ])) : (Qe(), yn("div", yIe, [
        dl(xe, Ni({
          modelValue: Zr(a),
          "onUpdate:modelValue": we[2] || (we[2] = (E) => om(a) ? a.value = E : null),
          options: u.value,
          "label-by": J.labelBy,
          "track-by": J.trackBy,
          status: J.status,
          message: J.message,
          placement: "bottom",
          placeholder: J.placeholder,
          class: "w-100",
          "label-top": Zr(R),
          required: J.required,
          disabled: J.disabled
        }, J.$attrs, { "onUpdate:modelValue": Zr(s) }), null, 16, ["modelValue", "options", "label-by", "track-by", "status", "message", "placeholder", "label-top", "required", "disabled", "onUpdate:modelValue"]),
        dl(je, {
          modelValue: Zr(h),
          "onUpdate:modelValue": we[5] || (we[5] = (E) => om(h) ? h.value = E : null),
          size: "sm",
          compact: "",
          onModalClose: Zr(G)
        }, {
          header: kl(() => [
            qn("h3", _Ie, It(J.customRangeLabel), 1)
          ]),
          body: kl(() => [
            dl(ce, {
              modelValue: Zr(p),
              "onUpdate:modelValue": we[3] || (we[3] = (E) => om(p) ? p.value = E : null),
              "label-top": "Start value",
              "hide-controls": ""
            }, null, 8, ["modelValue"]),
            dl(ce, {
              modelValue: Zr(_),
              "onUpdate:modelValue": we[4] || (we[4] = (E) => om(_) ? _.value = E : null),
              "label-top": "End value",
              "hide-controls": ""
            }, null, 8, ["modelValue"]),
            Zr(L) ? (Qe(), yn("div", xIe, It(Zr(L)), 1)) : st("", !0)
          ]),
          actions: kl(() => [
            dl($e, { onClick: Zr(G) }, {
              default: kl(() => [
                Ir("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"]),
            dl($e, {
              type: "primary",
              onClick: Zr(d)
            }, {
              default: kl(() => [
                Ir("Confirm")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        }, 8, ["modelValue", "onModalClose"])
      ]));
    };
  }
});
sO.install = (e) => {
  e.component(sO.name, sO);
};
const SIe = { class: "lp-options-group-wrapper pt-1 border-gray-medium" }, EIe = { class: "pl-1 m-0 font-weight-bold text-dark-muted text-uppercase" }, OIe = ["data-ua-multiple-id", "data-ua-value", "onClick"], kIe = ["innerHTML"], bIe = { class: "lp-select-option-label" }, TIe = ["innerHTML"], jIe = ["innerHTML"], oO = /* @__PURE__ */ cl({
  name: "lp-options-group",
  __name: "LpOptionsGroup",
  props: {
    label: { default: "All" },
    options: { default: () => [] },
    groupId: { default: null },
    labelBy: { default: "name" },
    trackBy: { default: "value" },
    disabled: { type: Boolean, default: !1 },
    uaLocatorOption: { default: "ua-optionsgroup-option" },
    prefix: { default: "prefix" },
    suffix: { default: "suffix" },
    maxLabelLength: { default: 1 / 0 }
  },
  emits: ["update:model-value"],
  setup(e, { emit: n }) {
    const t = n, l = e, r = Ga(l, "options"), u = _s("toggleShow", () => {
    }), o = _s("emitHandlers", () => {
    }), a = dt(_s("wrapperValue", null)), h = dt(_s("modelGroupValue", null)), s = _t(() => h.value ? l.groupId === h.value : !0), d = dt(null);
    ga(() => {
      if (d.value = s.value ? a.value : null, d.value) {
        const K = l.options.find(
          (H) => H[l.trackBy] === d.value
        );
        K && o.handleLabelChange(K[l.labelBy]);
      }
    });
    const {
      wrappedValue: p,
      getOptionName: _,
      getOptionValue: R,
      setOptionRef: F,
      indexFocusedOption: L,
      optionsRefs: G,
      show: J,
      handleEnterKey: we,
      setOpen: ce,
      setSelectListRef: xe,
      toggleDropdown: $e,
      selectOption: je,
      handleKey: E
    } = hL(
      p1({
        disabled: Ga(l, "disabled"),
        modelValue: d,
        trackBy: l.trackBy,
        labelBy: l.labelBy,
        options: Ga(l, "options")
      }),
      t,
      o
    ), P = _s("searchEmitValue", "");
    return (K, H) => (Qe(), yn("div", SIe, [
      qn("p", EIe, It(K.label), 1),
      qn("div", {
        ref: (U) => Zr(xe)(U),
        class: "lp-options-group"
      }, [
        (Qe(!0), yn(Ii, null, ru(r.value, (U, Me) => pi((Qe(), yn("li", {
          key: Me,
          ref_for: !0,
          ref: (le) => Zr(F)(le, Me),
          class: xt(["lp-select-option ly-col", [
            Zr(p)[K.trackBy] === Zr(R)(U) && "lp-select-option-selected"
          ]]),
          "data-ua-multiple-id": K.uaLocatorOption,
          "data-ua-value": `${K.groupId}-${Zr(R)(U)}`,
          onClick: () => {
            Zr(je)(Me, K.groupId), Zr(u)(U);
          }
        }, [
          qn("div", {
            class: xt(["ly-row ly-start-center", U.helper && "mb-half"])
          }, [
            typeof U[K.prefix] == "string" && U[K.prefix] ? (Qe(), yn("span", {
              key: 0,
              class: "lp-select-option-prefix",
              innerHTML: U[K.prefix]
            }, null, 8, kIe)) : (Qe(), _l(ap(U[K.prefix]), { key: 1 })),
            el(K.$slots, "option", {
              props: l,
              option: U
            }, () => [
              qn("span", bIe, It(Zr(_)(U)), 1)
            ]),
            typeof U[K.suffix] == "string" && U[K.suffix] ? (Qe(), yn("span", {
              key: 2,
              class: "lp-select-option-suffix",
              innerHTML: U[K.suffix]
            }, null, 8, TIe)) : (Qe(), _l(ap(U[K.suffix]), { key: 3 }))
          ], 2),
          U.helper ? (Qe(), yn("p", {
            key: 0,
            innerHTML: U.helper
          }, null, 8, jIe)) : st("", !0)
        ], 10, OIe)), [
          [
            Pi,
            Zr(P) === void 0 || String(Zr(_)(U)).toLowerCase().includes(Zr(P))
          ]
        ])), 128))
      ], 512)
    ]));
  }
});
oO.install = (e) => {
  e.component(oO.name, oO);
};
const AIe = {
  key: 0,
  class: "lp-input-label font-weight-medium"
}, DIe = {
  key: 0,
  class: "text-blue"
}, IIe = { class: "lp-phone-input" }, RIe = ["value", "disabled", "placeholder", "maxlength"], NIe = {
  key: 1,
  class: "lp-input-message mt-half d-flex text-gray"
}, vz = 15, aO = /* @__PURE__ */ cl({
  name: "lp-phone-input",
  inheritAttrs: !1,
  __name: "LpPhoneInput",
  props: {
    modelValue: { default: null },
    maxLength: { default: 15 },
    status: { default: "neutral" },
    message: { default: null },
    helper: { default: null },
    disabled: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    labelTop: { default: null },
    placeholder: { default: null },
    preview: { type: [Boolean, null], default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, l = e, r = dt(null), u = dt(!1), o = dt(Number), a = (d) => {
      const p = d.target.value, _ = Number(p), R = p.trim() === "" ? null : p.length < l.maxLength ? _ : Number(p.toString().slice(0, l.maxLength));
      t("update:modelValue", R?.toString()), o.value = R;
    }, h = _t(() => s(l.modelValue)), s = (d) => {
      if (!d) return d;
      const p = d.toString().replace(/[^\d]/g, ""), _ = p.length;
      return _ < 4 ? p : _ < 7 ? `(${p.slice(0, 3)}) ${p.slice(3)}` : _ <= 10 ? `(${p.slice(0, 3)}) ${p.slice(
        3,
        6
      )}-${p.slice(6, vz + 1)}` : `(${p.slice(0, 3)}) ${p.slice(
        3,
        6
      )}-${p.slice(6, 10)}-${p.slice(10, vz + 1)}`;
    };
    return (d, p) => (Qe(), yn("div", null, [
      d.labelTop ? (Qe(), yn("span", AIe, [
        qn("span", null, It(d.labelTop), 1),
        !d.preview && d.required ? (Qe(), yn("span", DIe, "*")) : st("", !0)
      ])) : st("", !0),
      qn("div", IIe, [
        qn("div", {
          class: xt(["lp-number-input lp-input-wrapper", [
            d.disabled && "lp-number-input-disabled",
            d.message ? "lp-input-wrapper-danger" : d.status && `lp-input-wrapper-${d.status}`,
            d.disabled && "lp-input-wrapper-disabled",
            d.preview && "lp-number-input-preview"
          ]])
        }, [
          d.preview ? st("", !0) : (Qe(), yn("input", Ni({
            key: 0,
            ref_key: "input",
            ref: o,
            type: "number",
            value: d.modelValue,
            class: "lp-number-input-original",
            disabled: d.disabled,
            placeholder: d.placeholder,
            max: "999999999999999",
            maxlength: d.maxLength
          }, d.$attrs, {
            onInput: a,
            onFocus: p[0] || (p[0] = (_) => u.value = !0),
            onBlur: p[1] || (p[1] = (_) => u.value = !1)
          }), null, 16, RIe)),
          d.preview || !u.value ? (Qe(), yn("div", {
            key: 1,
            ref_key: "buffer",
            ref: r,
            class: "lp-number-input-buffer"
          }, It(h.value), 513)) : st("", !0)
        ], 2)
      ]),
      dl(du, { name: "fade-bottom" }, {
        default: kl(() => [
          qn("div", null, [
            d.message ? (Qe(), yn("span", {
              key: 0,
              class: xt(["lp-input-message mt-half d-flex", [
                d.message ? "lp-input-message-danger" : d.status && `lp-input-message-${d.status}`,
                d.disabled && "lp-input-message-disabled"
              ]])
            }, It(d.message), 3)) : st("", !0),
            d.message ? st("", !0) : (Qe(), yn("span", NIe, It(d.helper), 1))
          ])
        ]),
        _: 1
      })
    ]));
  }
});
aO.install = (e) => {
  e.component(aO.name, aO);
};
const CIe = cl({
  name: "lp-popover",
  directives: {
    clickoutside: S4
  },
  props: {
    disabled: Boolean,
    borderless: Boolean,
    placement: {
      type: String,
      default: sl.T,
      validator: (e) => [sl.B, sl.L, sl.R, sl.T].includes(e)
    },
    autoposition: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = dt(null), t = dt(null), {
      show: l,
      placement: r,
      disabled: u,
      clickable: o,
      transition: a,
      position: h,
      hidePopover: s,
      showPopover: d,
      setPopoverPosition: p
    } = l2({
      ...e,
      popover: n,
      trigger: t,
      arrowCalculation: !1
    });
    return {
      show: l,
      placement: r,
      disabled: u,
      clickable: o,
      transition: a,
      popover: n,
      trigger: t,
      position: h,
      hidePopover: s,
      showPopover: d,
      setPopoverPosition: p
    };
  }
}), MIe = {
  class: "lp-tooltip",
  "data-ua-unique-id": "unique-popover"
};
function PIe(e, n, t, l, r, u) {
  const o = w4("clickoutside");
  return pi((Qe(), yn("div", MIe, [
    qn("span", {
      ref: "trigger",
      class: "lp-tooltip-trigger",
      onClick: n[0] || (n[0] = (...a) => e.showPopover && e.showPopover(...a))
    }, [
      el(e.$slots, "default")
    ], 512),
    dl(du, { name: e.transition }, {
      default: kl(() => [
        pi(qn("div", {
          ref: "popover",
          class: xt(["lp-tooltip-popper", [e.placement && `lp-tooltip-${e.placement}`]])
        }, [
          qn("div", {
            class: xt(["lp-tooltip-content", {
              "lp-tooltip-content-borderless": e.borderless
            }])
          }, [
            el(e.$slots, "content")
          ], 2)
        ], 2), [
          [Pi, e.show && !e.disabled]
        ])
      ]),
      _: 3
    }, 8, ["name"])
  ])), [
    [o, e.hidePopover]
  ]);
}
const cO = /* @__PURE__ */ Cr(CIe, [["render", PIe]]);
cO.install = (e) => {
  e.component(cO.name, cO);
};
const $Ie = cl({
  name: "lp-tooltip",
  props: {
    content: [String, Number],
    disabled: Boolean,
    hoverable: Boolean,
    placement: {
      type: String,
      default: sl.T,
      validator: (e) => Object.values(sl).includes(e)
    },
    permanent: Boolean,
    autoposition: { type: Boolean, default: !0 }
  },
  setup(e) {
    const n = dt(null), t = dt(null), {
      show: l,
      placement: r,
      disabled: u,
      clickable: o,
      transition: a,
      visionTimer: h,
      permanent: s,
      position: d,
      handleMouseEnter: p,
      handleMouseLeave: _,
      hidePopover: R,
      showPopover: F,
      setPopoverPosition: L
    } = l2({
      ...e,
      popover: n,
      trigger: t,
      arrowCalculation: !1,
      disableSetPosition: !1
    });
    return cf(() => {
      s.value && F();
    }), {
      show: l,
      placementValue: r,
      disabledValue: u,
      clickable: o,
      transition: a,
      visionTimer: h,
      popover: n,
      trigger: t,
      position: d,
      handleMouseEnter: p,
      handleMouseLeave: _,
      hidePopover: R,
      showPopover: F,
      setPopoverPosition: L
    };
  }
}), LIe = { class: "lp-tooltip" }, BIe = { class: "lp-tooltip-content tooltip" }, FIe = ["innerHTML"];
function VIe(e, n, t, l, r, u) {
  return Qe(), yn("div", LIe, [
    qn("span", {
      ref: "trigger",
      class: "lp-tooltip-trigger",
      onMouseenter: n[0] || (n[0] = (...o) => e.handleMouseEnter && e.handleMouseEnter(...o)),
      onMouseleave: n[1] || (n[1] = (...o) => e.handleMouseLeave && e.handleMouseLeave(...o))
    }, [
      el(e.$slots, "default")
    ], 544),
    (Qe(), _l(v3, { to: "body" }, [
      dl(du, { name: e.transition }, {
        default: kl(() => [
          pi(qn("div", {
            ref: "popover",
            class: xt(["lp-tooltip-popper", [e.placement && `lp-tooltip-${e.placement.split("-")[0]}`]]),
            onMouseenter: n[2] || (n[2] = (...o) => e.handleMouseEnter && e.handleMouseEnter(...o)),
            onMouseleave: n[3] || (n[3] = (...o) => e.handleMouseLeave && e.handleMouseLeave(...o))
          }, [
            qn("div", BIe, [
              el(e.$slots, "content", {}, () => [
                qn("div", { innerHTML: e.content }, null, 8, FIe)
              ])
            ])
          ], 34), [
            [Pi, e.show]
          ])
        ]),
        _: 3
      }, 8, ["name"])
    ]))
  ]);
}
const cy = /* @__PURE__ */ Cr($Ie, [["render", VIe]]), YIe = cl({
  name: "lp-progressbar",
  components: { LpTooltip: cy },
  props: {
    infinite: {
      type: Boolean,
      default: !1
    },
    data: {
      type: Object,
      default: null
    },
    progress: {
      type: Number,
      default: 0,
      validator: (e) => e >= 0 && e <= 100
    },
    height: { type: Number, default: 7, validator: (e) => e > 0 },
    tooltip: {
      default: sl.T,
      validator: (e) => [sl.T, sl.B].includes(e)
    },
    showTooltip: {
      type: Boolean,
      default: !0
    },
    isNegative: {
      type: Boolean,
      default: !1
    },
    isCurrency: {
      type: Boolean,
      default: !0
    }
  },
  setup(e) {
    const n = _t(() => {
      if (e.data)
        return e.data.reduce(
          (l, r) => l + r.value,
          0
        );
    }), t = _t(() => {
      if (e.data)
        return e.data.reduce((l, r) => l + `<span class="h2 pr-half text-${r.color}" style="line-height: 1;
          vertical-align: middle;">• </span> ${r.label}: ${e.isCurrency ? RO(r.value) : r.value}</br>`, "");
    });
    return { totalValue: n, tooltipContent: t, formatCurrency: RO };
  }
}), UIe = { class: "lp-progress-wrapper" }, qIe = ["innerHTML"];
function WIe(e, n, t, l, r, u) {
  const o = El("lp-tooltip");
  return Qe(), yn("div", UIe, [
    qn("div", {
      class: xt(["lp-progress-bar", [
        e.infinite && "lp-progress-bar-infinite",
        e.isNegative && "bg-error"
      ]]),
      style: Hi({ height: `${e.height}px` })
    }, [
      !e.isNegative && !e.data ? (Qe(), yn("div", {
        key: 0,
        class: "lp-progress-line",
        style: Hi(!e.infinite && { width: `${e.progress}%` })
      }, [
        e.showTooltip && !e.infinite ? (Qe(), yn("span", {
          key: 0,
          class: xt(["lp-progress-tooltip", [`lp-progress-tooltip-${e.tooltip}`]]),
          innerHTML: `${e.progress}%`
        }, null, 10, qIe)) : st("", !0)
      ], 4)) : (Qe(), yn("div", {
        key: 1,
        class: "lp-progress-bar-multiple",
        style: Hi({ height: `${e.height}px` })
      }, [
        dl(o, {
          class: "w-100",
          content: e.tooltipContent,
          placement: "top"
        }, {
          default: kl(() => [
            (Qe(!0), yn(Ii, null, ru(e.data, (a) => (Qe(), yn("div", {
              key: a.label,
              class: xt(["lp-progress-line", a.color && `bg-${a.color}`]),
              style: Hi({ width: `${a.value * 100 / e.totalValue}%` })
            }, null, 6))), 128))
          ]),
          _: 1
        }, 8, ["content"])
      ], 4))
    ], 6)
  ]);
}
const hO = /* @__PURE__ */ Cr(YIe, [["render", WIe]]);
hO.install = (e) => {
  e.component(hO.name, hO);
};
const HIe = cl({
  name: "lp-radio",
  inheritAttrs: !1,
  props: {
    type: {
      default: _r.PRIMARY,
      type: String,
      validator: (e) => [
        _r.NEUTRAL,
        _r.PRIMARY,
        _r.SECONDARY,
        _r.SUCCESS,
        _r.DANGER,
        _r.ERROR,
        _r.WARNING,
        _r.BLACK
      ].includes(e)
    },
    label: { type: String },
    subLabel: { type: String },
    pulse: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: {},
    value: {},
    card: { type: Boolean, default: !1 },
    icon: { type: String, default: null }
  },
  setup(e, { emit: n }) {
    function t() {
      e.disabled || n("update:modelValue", e.value);
    }
    const l = _t(() => e.modelValue === e.value);
    return { check: t, isChecked: l };
  }
}), zIe = ["disabled", "checked", "value"], KIe = /* @__PURE__ */ qn("span", { class: "lp-radio-circle" }, null, -1), GIe = [
  KIe
], ZIe = { class: "lp-radio-label-group" };
function XIe(e, n, t, l, r, u) {
  const o = El("lp-icon");
  return Qe(), yn("label", {
    class: xt(["lp-radio-wrapper", [
      e.isChecked && `lp-radio-wrapper-${e.type}-checked`,
      `lp-radio-wrapper-${e.type}`,
      e.disabled && "lp-radio-wrapper-disabled",
      e.card && "radio-card"
    ]])
  }, [
    qn("input", Ni({
      class: "lp-radio-input",
      disabled: e.disabled,
      type: "radio",
      checked: e.isChecked,
      value: e.modelValue
    }, e.$attrs, {
      onChange: n[0] || (n[0] = (...a) => e.check && e.check(...a))
    }), null, 16, zIe),
    qn("span", {
      class: xt(["lp-radio-border", e.pulse && !e.disabled && "pulse"])
    }, GIe, 2),
    e.icon && e.card ? (Qe(), _l(o, {
      key: 0,
      name: e.icon
    }, null, 8, ["name"])) : st("", !0),
    qn("span", ZIe, [
      e.label && !e.$slots.default ? (Qe(), yn("span", {
        key: 0,
        class: xt(["lp-radio-label", [e.disabled && "lp-radio-label-disabled"]])
      }, It(e.label), 3)) : st("", !0),
      e.subLabel && !e.$slots.sublabel ? (Qe(), yn("span", {
        key: 1,
        class: xt(["lp-radio-label lp-radio-label-sub", [e.disabled && "lp-radio-label-disabled"]])
      }, It(e.subLabel), 3)) : st("", !0),
      e.$slots.default ? (Qe(), yn("span", {
        key: 2,
        class: xt(["lp-radio-label", [e.disabled && "lp-radio-label-disabled"]])
      }, [
        el(e.$slots, "default")
      ], 2)) : st("", !0),
      e.$slots.sublabel ? (Qe(), yn("span", {
        key: 3,
        class: xt(["lp-radio-label lp-radio-label-sub", [e.disabled && "lp-radio-label-disabled"]])
      }, [
        el(e.$slots, "sublabel")
      ], 2)) : st("", !0)
    ])
  ], 2);
}
const fO = /* @__PURE__ */ Cr(HIe, [["render", XIe]]);
fO.install = (e) => {
  e.component(fO.name, fO);
};
const QIe = {
  key: 0,
  class: "lp-input-label font-weight-medium"
}, JIe = {
  key: 0,
  class: "text-blue"
}, dO = /* @__PURE__ */ cl({
  name: "lp-radio-group",
  __name: "LpRadioGroup",
  props: {
    required: { type: Boolean, default: !1 },
    even: { type: Boolean, default: !1 },
    labelTop: { default: null },
    direction: { default: "vertical" }
  },
  setup(e) {
    const n = e;
    return (t, l) => (Qe(), yn(Ii, null, [
      t.labelTop ? (Qe(), yn("span", QIe, [
        el(t.$slots, "label-top", { props: n }, () => [
          qn("span", null, It(t.labelTop), 1),
          t.required ? (Qe(), yn("span", JIe, "*")) : st("", !0)
        ])
      ])) : st("", !0),
      qn("div", {
        class: xt(["lp-radio-group-wrapper", [
          t.direction === "horizontal" ? "ly-row" : "ly-col",
          t.even && "ly-even"
        ]])
      }, [
        el(t.$slots, "default")
      ], 2)
    ], 64));
  }
});
dO.install = (e) => {
  e.component(dO.name, dO);
};
const eRe = cl({
  name: "lp-base-select",
  directives: {
    clickoutside: S4
  },
  props: {
    id: {
      type: String,
      default: fm("select")
    },
    placement: {
      type: String,
      default: sl.B,
      validator: (e) => Kz.includes(e)
    },
    disabled: { type: Boolean, default: !1 },
    divided: { type: Boolean, default: !1 },
    labelTop: { type: String, default: null },
    search: { type: Boolean, default: !0 },
    isOptionsGroup: { type: Boolean, default: null },
    placeholder: { type: String, default: "Select option" },
    required: { type: Boolean, default: !1 },
    clearable: { type: Boolean, default: !1 },
    status: { type: String, default: "neutral" },
    message: { type: String, default: null },
    helper: { type: String, default: null },
    searchPlaceholder: { type: String, default: "Filter options..." }
  },
  emits: ["search-emit", "update:modelValue"],
  setup(e, { emit: n, slots: t }) {
    const l = ow(t, "label-top") !== null, r = dt(null), u = dt(e.disabled), {
      show: o,
      handleEnterKey: a,
      setOpen: h,
      setSelectListRef: s,
      toggleDropdown: d,
      handleKey: p
    } = hL(e, n);
    vs("toggleShow", (J) => {
      o.value = !o.value, n("update:modelValue", J, !0);
    });
    const R = _t(() => ({
      "lp-select-selection-disabled": e.disabled,
      "lp-select-selection-active": o.value
    })), F = _t(() => ({
      [e.placement ? `lp-select-dropdown-${e.placement}` : `lp-select-dropdown-${sl.B}`]: !0,
      "lp-select-dropdown-divided": e.divided
    })), L = () => {
      n("search-emit", r.value);
    }, G = () => {
      r.value = void 0, L();
    };
    return di(
      () => o.value,
      () => {
        o.value || (r.value = void 0, L());
      },
      { immediate: !0 }
    ), {
      labelTopSlotExist: l,
      show: o,
      handleEnterKey: a,
      setOpen: h,
      setSelectListRef: s,
      toggleDropdown: d,
      handleKey: p,
      selectionClasses: R,
      dropdownClasses: F,
      props: e,
      EDirections: ex,
      searchField: r,
      searchEmit: L,
      disabled: u,
      clearModelValue: G
    };
  }
}), nRe = { class: "lp-select" }, tRe = {
  key: 0,
  class: "lp-input-label font-weight-medium ly-row ly-spacebetween-center"
}, lRe = {
  key: 0,
  class: "text-blue"
}, rRe = ["tabindex", "aria-label"], iRe = { class: "clearable" }, uRe = { class: "ly-row" }, sRe = {
  key: 1,
  class: "lp-input-message mt-half text-gray"
};
function oRe(e, n, t, l, r, u) {
  const o = El("lp-icon"), a = El("lp-input"), h = w4("clickoutside");
  return pi((Qe(), yn("div", nRe, [
    e.labelTop || e.labelTopSlotExist ? (Qe(), yn("span", tRe, [
      el(e.$slots, "label-top", { props: e.props }, () => [
        qn("span", null, [
          qn("span", null, It(e.labelTop), 1),
          e.required ? (Qe(), yn("span", lRe, "*")) : st("", !0)
        ])
      ])
    ])) : st("", !0),
    qn("div", {
      class: xt(["lp-select-inner", [
        e.message ? "lp-input-wrapper-danger" : e.status && `lp-input-wrapper-${e.status}`,
        e.disabled && "lp-input-wrapper-disabled"
      ]]),
      style: Hi(e.message ? "" : "margin-bottom: 22px;")
    }, [
      qn("div", {
        ref: "trigger",
        tabindex: e.disabled ? -1 : 0,
        class: xt(["lp-select-selection form-faux-select", e.selectionClasses]),
        role: "listbox",
        "aria-label": e.placeholder,
        onClick: n[0] || (n[0] = (...s) => e.toggleDropdown && e.toggleDropdown(...s)),
        onKeydown: [
          n[1] || (n[1] = Ei(() => e.setOpen(!1), ["tab"])),
          n[2] || (n[2] = Ei(Oi((s) => e.handleKey(e.EDirections.DOWN), ["stop", "prevent"]), ["down"])),
          n[3] || (n[3] = Ei(Oi((s) => e.handleKey(e.EDirections.UP), ["stop", "prevent"]), ["up"])),
          n[4] || (n[4] = Ei(Oi(() => e.setOpen(!1), ["stop", "prevent"]), ["esc"])),
          n[5] || (n[5] = Ei(Oi((...s) => e.handleEnterKey && e.handleEnterKey(...s), ["stop", "prevent"]), ["enter"]))
        ]
      }, [
        qn("span", {
          class: xt(
            e.isOptionsGroup ? "lp-select-selected" : "lp-select-placeholder"
          )
        }, [
          el(e.$slots, "placeholder", { props: e.props }, () => [
            Ir(It(e.placeholder), 1)
          ]),
          el(e.$slots, "selection", { props: e.props })
        ], 2),
        el(e.$slots, "icon", { props: e.props }, () => [
          dl(o, {
            name: "chevron-down",
            class: xt(e.show && "lp-select-arrow--active")
          }, null, 8, ["class"])
        ])
      ], 42, rRe),
      dl(du, { name: "drop-bottom" }, {
        default: kl(() => [
          pi(qn("div", {
            class: xt(["lp-select-dropdown", e.dropdownClasses])
          }, [
            qn("div", {
              ref: (s) => e.setSelectListRef(s),
              class: "lp-select-list menu-pop-up"
            }, [
              qn("div", {
                class: xt(e.search && "lp-select-search-wrapper")
              }, [
                e.search ? (Qe(), _l(a, {
                  key: 0,
                  modelValue: e.searchField,
                  "onUpdate:modelValue": n[7] || (n[7] = (s) => e.searchField = s),
                  placeholder: e.searchPlaceholder,
                  "prefix-icon": "search",
                  "prefix-icon-aria-hidden": "true",
                  size: "compact",
                  onKeyup: e.searchEmit
                }, {
                  clear: kl(() => [
                    pi(qn("div", iRe, [
                      el(e.$slots, "clear", { onClear: e.clearModelValue }, () => [
                        dl(o, {
                          class: "lp-input-icon-wrapper",
                          name: "close",
                          role: "button",
                          onClick: n[6] || (n[6] = (s) => e.clearModelValue())
                        })
                      ])
                    ], 512), [
                      [Pi, e.clearable && e.searchField]
                    ])
                  ]),
                  _: 3
                }, 8, ["modelValue", "placeholder", "onKeyup"])) : st("", !0)
              ], 2),
              e.$slots.default ? (Qe(), yn("div", {
                key: 0,
                class: xt(e.search && "search-active")
              }, [
                el(e.$slots, "default", { show: e.show })
              ], 2)) : st("", !0)
            ], 512)
          ], 2), [
            [Pi, e.show]
          ])
        ]),
        _: 3
      })
    ], 6),
    dl(du, { name: "fade-bottom" }, {
      default: kl(() => [
        qn("div", uRe, [
          e.message ? (Qe(), yn("span", {
            key: 0,
            class: xt(["lp-input-message mt-half d-flex", [
              e.message ? "lp-input-message-danger" : e.status && `lp-input-message-${e.status}`,
              e.disabled && "lp-input-message-disabled"
            ]])
          }, It(e.message), 3)) : (Qe(), yn("span", sRe, It(e.helper), 1))
        ])
      ]),
      _: 1
    })
  ])), [
    [h, () => e.setOpen(!1)]
  ]);
}
const aRe = /* @__PURE__ */ Cr(eRe, [["render", oRe]]), pO = {
  Select: fL,
  BaseSelect: aRe
};
for (const e in pO)
  if (pO.hasOwnProperty(e)) {
    const n = pO[e];
    n.install = (t) => {
      t.component(n.name, n);
    };
  }
const cRe = 8, Av = {
  MIN: 0,
  MAX: 100,
  STEP: 1,
  VALUE: 0
}, eL = ({
  value: e,
  min: n,
  max: t
}) => (e - n) * 100 / (t - n), CD = ({
  changedTouches: e,
  clientX: n,
  clientY: t
}) => {
  const l = e ? e[0] : null;
  return l ? { clientX: l.clientX, clientY: l.clientY } : { clientX: n, clientY: t };
}, hRe = (e, { max: n, min: t, step: l, valuePosition: r }) => _t(() => {
  const u = [...e], o = (n - t) / l;
  let a = 0;
  const h = 100 / (n / l);
  for (let s = 0; s < o; s++) {
    a += h;
    const d = a <= r.value;
    u.push({ left: a, active: d });
  }
  return u;
}), fRe = (e, n) => {
  const t = eL({
    value: e.modelValue,
    min: e.min,
    max: e.max
  }), l = dt(t);
  return [l, (u) => {
    u = Gte(u, Av.MIN, Av.MAX);
    const o = 100 / ((e.max - e.min) / e.step);
    let h = Math.round(u / o) * o * (e.max - e.min) * 0.01 + e.min;
    h = parseFloat(h.toFixed(0)), h = h > e.max ? e.max : h, n("update:modelValue", h), l.value = eL({
      value: h,
      min: e.min,
      max: e.max
    });
  }];
}, dRe = cl({
  name: "lp-slider",
  components: {
    "lp-tooltip": cy
  },
  props: {
    labelTop: String,
    disabled: Boolean,
    stepPoints: Boolean,
    numbers: Boolean,
    preview: Boolean,
    min: { type: Number, default: Av.MIN },
    max: { type: Number, default: Av.MAX },
    step: { type: Number, default: Av.STEP },
    modelValue: { type: Number, default: Av.VALUE }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = dt(null), l = dt(null), r = dt(0), u = dt(0), o = dt(0), a = dt(0), h = dt(!1), [s, d] = fRe(e, n), p = hRe(
      [{ left: 0, active: !0 }],
      {
        min: e.min,
        max: e.max,
        step: e.step,
        valuePosition: s
      }
    );
    di(
      () => e.modelValue,
      ($e) => {
        if (e.disabled) return;
        const je = eL({
          value: $e,
          min: e.min,
          max: e.max
        });
        d(je);
      }
    );
    function _($e) {
      if (e.disabled) return;
      l.value.showPopover();
      const je = [sl.T, sl.R].includes($e), E = [sl.B, sl.L].includes($e), P = je ? e.modelValue + e.step : E ? e.modelValue - e.step : e.modelValue;
      (je || E) && n("update:modelValue", P);
    }
    function R($e) {
      e.disabled || (F($e), window.addEventListener("mousemove", L), window.addEventListener("mouseup", G), window.addEventListener("touchmove", L), window.addEventListener("touchend", G));
    }
    function F($e) {
      h.value = !0, r.value = CD($e).clientX, o.value = s.value, l.value.showPopover();
    }
    function L($e) {
      if (h.value) {
        let je = 0;
        u.value = CD($e).clientX, je = (u.value - r.value) * 100 / t.value.offsetWidth, a.value = o.value + je, d(a.value);
      }
    }
    function G() {
      h.value && (h.value = !1, d(a.value), window.removeEventListener("mousemove", L), window.removeEventListener("mouseup", G), window.removeEventListener("touchmove", L), window.removeEventListener("touchend", G));
    }
    function J($e) {
      if (e.disabled || h.value) return;
      const je = t.value.getBoundingClientRect().left, P = (CD($e).clientX - je) / t.value.offsetWidth * 100;
      d(P);
    }
    function we($e) {
      l.value.handleMouseEnter($e);
    }
    function ce() {
      h.value || l.value.handleMouseLeave();
    }
    function xe({
      step: $e,
      index: je
    }) {
      const E = {
        left: `${$e.left}%`,
        height: null
      };
      return (je === 0 || je === p.value.length - 1) && (E.height = `${cRe}px`), E;
    }
    return {
      valuePosition: s,
      stepsPoints: p,
      sliderLineRef: t,
      tooltipRef: l,
      keyEvent: _,
      onMouseOrTouchDown: R,
      onSliderClick: J,
      handleMouseEnter: we,
      handleMouseLeave: ce,
      getStepPointStyles: xe,
      Positions: sl
    };
  }
}), pRe = { key: 0 }, mRe = {
  key: 0,
  class: "lp-slider-label font-weight-medium"
}, gRe = ["tabindex"], wRe = {
  key: 0,
  class: "lp-slider-label"
}, vRe = /* @__PURE__ */ qn("div", { class: "lp-slider-controller" }, null, -1), yRe = {
  key: 1,
  class: "lp-slider-wrap-points"
}, _Re = {
  key: 2,
  class: "lp-slider-numbers"
}, xRe = { style: { left: "100%" } };
function SRe(e, n, t, l, r, u) {
  const o = El("lp-tooltip");
  return e.preview ? (Qe(), yn("div", pRe, [
    e.labelTop ? (Qe(), yn("span", mRe, It(e.labelTop), 1)) : st("", !0),
    qn("span", null, It(e.modelValue), 1)
  ])) : (Qe(), yn("div", {
    key: 1,
    class: xt(["lp-slider", { "lp-slider-disabled": e.disabled }]),
    tabindex: e.disabled ? -1 : 0,
    onKeydown: [
      n[6] || (n[6] = Ei(Oi((a) => e.keyEvent(e.Positions.L), ["stop", "prevent"]), ["down", "left"])),
      n[7] || (n[7] = Ei(Oi((a) => e.keyEvent(e.Positions.R), ["stop", "prevent"]), ["up", "right"]))
    ]
  }, [
    e.labelTop ? (Qe(), yn("span", wRe, It(e.labelTop), 1)) : st("", !0),
    qn("div", {
      ref: "sliderLineRef",
      class: "lp-slider-line",
      onMouseenter: n[2] || (n[2] = (...a) => e.handleMouseEnter && e.handleMouseEnter(...a)),
      onMouseleave: n[3] || (n[3] = (...a) => e.handleMouseLeave && e.handleMouseLeave(...a)),
      onClick: n[4] || (n[4] = (...a) => e.onSliderClick && e.onSliderClick(...a)),
      onTouchend: n[5] || (n[5] = (...a) => e.onSliderClick && e.onSliderClick(...a))
    }, [
      qn("div", {
        class: "lp-slider-bar",
        style: Hi({ width: `${e.valuePosition}%` })
      }, null, 4),
      qn("div", {
        class: "lp-slider-controller-wrapper",
        style: Hi({ left: `${e.valuePosition}%` }),
        onMousedown: n[0] || (n[0] = (...a) => e.onMouseOrTouchDown && e.onMouseOrTouchDown(...a)),
        onTouchstart: n[1] || (n[1] = Oi((...a) => e.onMouseOrTouchDown && e.onMouseOrTouchDown(...a), ["prevent"]))
      }, [
        dl(o, {
          ref: "tooltipRef",
          content: e.modelValue
        }, {
          default: kl(() => [
            vRe
          ]),
          _: 1
        }, 8, ["content"])
      ], 36)
    ], 544),
    e.stepPoints && e.stepsPoints.length ? (Qe(), yn("div", yRe, [
      (Qe(!0), yn(Ii, null, ru(e.stepsPoints, (a, h) => (Qe(), yn("div", {
        key: a.left,
        class: xt(["lp-slider-point", { "lp-slider-point-active": a.active }]),
        style: Hi(e.getStepPointStyles({ step: a, index: h }))
      }, null, 6))), 128))
    ])) : st("", !0),
    e.numbers ? (Qe(), yn("div", _Re, [
      qn("div", null, It(e.min), 1),
      qn("div", xRe, It(e.max), 1)
    ])) : st("", !0)
  ], 42, gRe));
}
const mO = /* @__PURE__ */ Cr(dRe, [["render", SRe]]);
mO.install = (e) => {
  e.component(mO.name, mO);
};
const gO = /* @__PURE__ */ cl({
  name: "lp-ssn-input",
  __name: "LpSocialSecurityInput",
  props: {
    modelValue: { default: null },
    labelTop: { default: null },
    placeholder: { default: null },
    status: { default: "neutral" },
    message: { default: null },
    required: { type: Boolean, default: !1 },
    preview: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, l = e, r = dt(l.modelValue), u = () => {
      t("update:modelValue", r.value);
    };
    return di(
      () => l.modelValue,
      (o) => {
        r.value = o;
      },
      { immediate: !0 }
    ), (o, a) => {
      const h = El("lp-number-input");
      return Qe(), _l(h, {
        modelValue: r.value,
        "onUpdate:modelValue": a[0] || (a[0] = (s) => r.value = s),
        "label-top": o.labelTop,
        placeholder: o.placeholder,
        status: o.status,
        message: o.message,
        required: o.required,
        preview: o.preview,
        format: "ssn",
        onKeyup: u
      }, null, 8, ["modelValue", "label-top", "placeholder", "status", "message", "required", "preview"]);
    };
  }
});
gO.install = (e) => {
  e.component(gO.name, gO);
};
const ERe = cl({
  name: "lp-spinner",
  props: { type: { type: String, default: "inline" } }
}), ORe = /* @__PURE__ */ qn("div", null, [
  /* @__PURE__ */ qn("span"),
  /* @__PURE__ */ qn("span"),
  /* @__PURE__ */ qn("span"),
  /* @__PURE__ */ qn("span"),
  /* @__PURE__ */ qn("span"),
  /* @__PURE__ */ qn("span"),
  /* @__PURE__ */ qn("span")
], -1), kRe = [
  ORe
];
function bRe(e, n, t, l, r, u) {
  return Qe(), yn("div", {
    class: xt(e.type ? `spinner spinner-${e.type}` : "spinner spinner-inline")
  }, kRe, 2);
}
const wO = /* @__PURE__ */ Cr(ERe, [["render", bRe]]);
wO.install = (e) => {
  e.component(wO.name, wO);
};
const TRe = cl({
  name: "lp-switch",
  inheritAttrs: !1,
  props: {
    type: {
      default: _r.PRIMARY,
      type: String,
      validator: (e) => [
        _r.PRIMARY,
        _r.SUCCESS,
        _r.DANGER,
        _r.WARNING,
        _r.BLACK
      ].includes(e)
    },
    label: { type: String },
    subLabel: { type: String },
    pulse: { type: Boolean },
    disabled: { type: Boolean },
    modelValue: { type: Boolean, default: !1 },
    required: { type: Boolean, required: !1, default: !1 },
    preview: { type: Boolean, required: !1, default: !1 },
    onText: { type: String, required: !1, default: "Yes" },
    offText: { type: String, required: !1, default: "No" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    function t() {
      if (e.disabled)
        return;
      const l = !e.modelValue;
      n("update:modelValue", l);
    }
    return { toggle: t };
  }
}), jRe = { key: 0 }, ARe = ["disabled"], DRe = {
  key: 2,
  class: "lp-switch-circle"
}, IRe = { class: "lp-switch-label-group" }, RRe = {
  key: 0,
  class: "text-blue"
};
function NRe(e, n, t, l, r, u) {
  return Qe(), yn("label", {
    class: xt(["lp-switch-wrapper", [e.preview && "lp-switch-wrapper-preview"]])
  }, [
    qn("span", {
      class: xt(["lp-switch", [
        `lp-switch-${e.type}`,
        e.modelValue && `lp-switch-${e.type}-checked`,
        e.disabled && `lp-switch-${e.type}-disabled`,
        !e.preview && e.pulse && !e.disabled && "pulse"
      ]])
    }, [
      e.preview ? (Qe(), yn("span", jRe, It(e.modelValue ? e.onText : e.offText), 1)) : (Qe(), yn("input", Ni({
        key: 1,
        type: "checkbox",
        class: "lp-switch-input",
        disabled: e.disabled
      }, e.$attrs, {
        onChange: n[0] || (n[0] = (...o) => e.toggle && e.toggle(...o))
      }), null, 16, ARe)),
      e.preview ? st("", !0) : (Qe(), yn("span", DRe))
    ], 2),
    qn("span", IRe, [
      e.label && !e.$slots.default ? (Qe(), yn("span", {
        key: 0,
        class: xt(["lp-switch-label", [e.disabled && "lp-switch-label-disabled"]])
      }, [
        Ir(It(e.label) + " ", 1),
        !e.preview && e.required ? (Qe(), yn("span", RRe, "*")) : st("", !0)
      ], 2)) : st("", !0),
      e.subLabel && !e.$slots.sublabel ? (Qe(), yn("span", {
        key: 1,
        class: xt(["lp-switch-label it-switch-label-sub", [e.disabled && "lp-switch-label-disabled"]])
      }, It(e.subLabel), 3)) : st("", !0),
      e.$slots.default ? (Qe(), yn("span", {
        key: 2,
        class: xt(["lp-switch-label", [e.disabled && "lp-switch-label-disabled"]])
      }, [
        el(e.$slots, "default")
      ], 2)) : st("", !0),
      e.$slots.sublabel ? (Qe(), yn("span", {
        key: 3,
        class: xt(["lp-switch-label it-switch-label-sub", [e.disabled && "lp-switch-label-disabled"]])
      }, [
        el(e.$slots, "sublabel")
      ], 2)) : st("", !0)
    ])
  ], 2);
}
const vO = /* @__PURE__ */ Cr(TRe, [["render", NRe]]);
vO.install = (e) => {
  e.component(vO.name, vO);
};
const CRe = cl({
  name: "lp-tabs",
  props: {
    activeTab: { type: Number, default: 0 },
    vertical: Boolean,
    box: Boolean
  },
  emits: ["click", "onActiveTabChange"],
  setup(e, { slots: n, emit: t }) {
    const l = dt(e.activeTab), r = dt([]), u = dt([]);
    vs("tabs", r), cf(async () => {
      await Ta(), o(l.value);
    }), di(
      () => e.activeTab,
      (s, d) => {
        s !== d && (l.value = s, o(s));
      }
    );
    function o(s) {
      r.value[s].disabled || (l.value = s, r.value.forEach((d, p) => {
        d.isActive = p === s, p === s && typeof d.onClick == "function" && d.onClick();
      }), t("click", !0), t("onActiveTabChange", l.value));
    }
    function a(s) {
      if (!r.value[s]) {
        a(0);
        return;
      }
      if (r.value[s].disabled) {
        a(s + 1);
        return;
      }
      u.value[s].focus();
    }
    function h(s) {
      if (!r.value[s]) {
        h(u.value.length - 1);
        return;
      }
      if (r.value[s].disabled) {
        h(s - 1);
        return;
      }
      u.value[s].focus();
    }
    return {
      selectedIndex: l,
      tabs: r,
      selectTab: o,
      tabsRefs: u,
      focusNextTab: a,
      focusPrevTab: h
    };
  }
}), MRe = { class: "lp-tabs-wrapper ly-row ly-spacebetween-center" }, PRe = ["aria-orientation"], $Re = ["aria-selected", "tabindex", "disabled", "data-content", "onKeydown", "onClick"], LRe = { key: 0 };
function BRe(e, n, t, l, r, u) {
  return Qe(), yn("div", {
    role: "tablist",
    class: xt(["lp-tabs", { "lp-tabs-v": e.vertical, "lp-tabs-boxed": e.box }])
  }, [
    qn("div", MRe, [
      qn("div", {
        class: xt(["lp-tabs-header", { "lp-tabs-header-v": e.vertical }]),
        "aria-orientation": e.vertical ? "vertical" : "horizontal"
      }, [
        (Qe(!0), yn(Ii, null, ru(e.tabs, (o, a) => (Qe(), yn("div", {
          ref_for: !0,
          ref: (h) => {
            h && (e.tabsRefs[a] = h);
          },
          key: a,
          role: "tab",
          "aria-selected": e.selectedIndex === a,
          tabindex: e.selectedIndex === a ? null : -1,
          class: xt(["lp-tabs-tab py-2 px-1 font-weight-medium", {
            "lp-tabs-tab-active text-blue": e.selectedIndex === a,
            "lp-tabs-tab-disabled": o.disabled
          }]),
          disabled: o.disabled,
          "data-content": o.title,
          onKeydown: [
            Ei(Oi((h) => e.vertical ? null : e.focusNextTab(a + 1), ["prevent"]), ["right"]),
            Ei(Oi((h) => e.vertical ? null : e.focusPrevTab(a - 1), ["prevent"]), ["left"]),
            Ei(Oi((h) => e.vertical ? e.focusNextTab(a + 1) : null, ["prevent"]), ["down"]),
            Ei(Oi((h) => e.vertical ? e.focusPrevTab(a - 1) : null, ["prevent"]), ["up"])
          ],
          onClick: (h) => e.selectTab(a)
        }, It(o.title), 43, $Re))), 128))
      ], 10, PRe),
      e.$slots.actions ? (Qe(), yn("div", LRe, [
        el(e.$slots, "actions")
      ])) : st("", !0)
    ]),
    el(e.$slots, "default")
  ], 2);
}
const yO = /* @__PURE__ */ Cr(CRe, [["render", BRe]]);
yO.install = (e) => {
  e.component(yO.name, yO);
};
const FRe = cl({
  name: "lp-tab",
  props: {
    title: {
      type: String,
      default: ""
    },
    disabled: Boolean,
    onClick: Function
  },
  setup(e) {
    const n = _s("tabs", []), t = dt(!1);
    return n.value.push({ ...w3(e), isActive: t }), { isActive: t };
  }
});
function VRe(e, n, t, l, r, u) {
  return pi((Qe(), yn("div", {
    key: e.title,
    class: "lp-tabs-body"
  }, [
    el(e.$slots, "default")
  ])), [
    [Pi, e.isActive]
  ]);
}
const _O = /* @__PURE__ */ Cr(FRe, [["render", VRe]]);
_O.install = (e) => {
  e.component(_O.name, _O);
};
const YRe = cl({
  name: "lp-tag",
  props: {
    type: {
      default: _r.NEUTRAL
    },
    closable: { type: Boolean }
  },
  emits: ["close"],
  setup(e, { emit: n }) {
    function t() {
      e.closable && n("close");
    }
    return { close: t };
  }
});
function URe(e, n, t, l, r, u) {
  const o = El("lp-icon");
  return Qe(), yn("span", {
    class: xt(["tag", e.type && `tag-${e.type}`])
  }, [
    el(e.$slots, "default"),
    e.closable ? (Qe(), _l(o, {
      key: 0,
      name: "close",
      class: "tag-close",
      onClick: e.close
    }, null, 8, ["onClick"])) : st("", !0)
  ], 2);
}
const xO = /* @__PURE__ */ Cr(YRe, [["render", URe]]);
xO.install = (e) => {
  e.component(xO.name, xO);
};
const qRe = { class: "lp-textarea-mask" }, WRe = {
  key: 0,
  class: "lp-input-label font-weight-medium"
}, HRe = {
  key: 0,
  class: "text-blue"
}, zRe = ["title"], KRe = ["value", "disabled", "placeholder", "rows"], SO = /* @__PURE__ */ cl({
  name: "lp-textarea",
  __name: "LpTextarea",
  props: {
    placeholder: { default: "" },
    disabled: { type: Boolean, default: !1 },
    resizable: { type: Boolean, default: !1 },
    resizeOnWrite: { type: Boolean, default: !1 },
    labelTop: { default: "" },
    rows: { default: 4 },
    status: { default: "neutral" },
    message: { default: null },
    modelValue: { default: null },
    mask: { type: Boolean, default: !1 },
    required: { type: Boolean, default: !1 },
    preview: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, l = n, r = dt(), u = dt(!1), o = _t(() => t.resizable ? "vertical" : "none");
    function a(h) {
      const s = h.target;
      l("update:modelValue", s.value), t.resizeOnWrite && (s.style.height = "auto", s.style.height = s.scrollHeight + "px");
    }
    return cf(async () => {
      t.resizeOnWrite && r.value && (await Ta(), r.value.style.height = r.value.scrollHeight + "px");
    }), (h, s) => (Qe(), yn("div", null, [
      dl(du, { name: "fade" }, {
        default: kl(() => [
          pi(qn("div", qRe, null, 512), [
            [Pi, u.value && h.mask]
          ])
        ]),
        _: 1
      }),
      h.labelTop ? (Qe(), yn("span", WRe, [
        Ir(It(h.labelTop) + " ", 1),
        !h.preview && h.required ? (Qe(), yn("span", HRe, "*")) : st("", !0)
      ])) : st("", !0),
      h.preview ? (Qe(), yn("span", {
        key: 1,
        class: "lp-textarea-preview",
        title: h.modelValue
      }, It(h.modelValue), 9, zRe)) : (Qe(), yn("textarea", {
        key: 2,
        ref_key: "textarea",
        ref: r,
        value: h.modelValue,
        style: Hi({ resize: o.value, "z-index": h.mask ? "100" : null }),
        disabled: h.disabled,
        class: xt(["lp-textarea", [
          h.status && `lp-input-wrapper-${h.status}`,
          h.disabled && "lp-input-wrapper-disabled"
        ]]),
        placeholder: h.placeholder,
        rows: h.rows,
        onInput: a,
        onFocus: s[0] || (s[0] = (d) => u.value = !0),
        onBlur: s[1] || (s[1] = (d) => u.value = !1)
      }, null, 46, KRe)),
      dl(du, { name: "fade-bottom" }, {
        default: kl(() => [
          h.message ? (Qe(), yn("span", {
            key: 0,
            class: xt(["lp-input-message mt-half d-flex", [
              h.status && `lp-input-message-${h.status}`,
              h.disabled && "lp-input-message-disabled"
            ]])
          }, It(h.message), 3)) : st("", !0)
        ]),
        _: 1
      })
    ]));
  }
});
SO.install = (e) => {
  e.component(SO.name, SO);
};
const EO = /* @__PURE__ */ cl({
  name: "lp-theme",
  __name: "LpTheme",
  props: {
    fontFamily: { default: "'Roboto', 'Helvetica Neue', sans-serif" },
    remSize: { default: "13px" },
    primary: { default: "--blue-100" },
    primaryHover: { default: "--blue-110" },
    primaryActive: { default: "--blue-130" },
    primary80: { default: "--blue-90" },
    primary60: { default: "--blue-50" },
    primary40: { default: "--blue-9" },
    primary30: { default: "--blue-6" },
    primary20: { default: "--blue-4" },
    primary10: { default: "--blue-2" },
    secondary: { default: "--orange-100" },
    secondaryHover: { default: "--orange-130" },
    secondaryActive: { default: "--orange-130" },
    secondary60: { default: "--orange-50" },
    buttonBackground: { default: "--white" },
    buttonBorder: { default: "--blue-100" },
    buttonText: { default: "--blue-100" },
    buttonBackgroundHover: { default: "--white" },
    buttonBorderHover: { default: "--blue-110" },
    buttonTextHover: { default: "--blue-110" },
    buttonBackgroundActive: { default: "--white" },
    buttonBorderActive: { default: "--blue-130" },
    buttonTextActive: { default: "--blue-130" },
    buttonBackgroundDisabled: { default: "--white" },
    buttonBorderDisabled: { default: "--black-20" },
    buttonTextDisabled: { default: "--black-30" },
    buttonPrimaryBackground: { default: "--primary" },
    buttonPrimaryBorder: { default: "--primary" },
    buttonPrimaryText: { default: "--white" },
    buttonPrimaryBackgroundHover: { default: "--primary-hover" },
    buttonPrimaryBorderHover: { default: "--primary-hover" },
    buttonPrimaryTextHover: { default: "--white" },
    buttonPrimaryBackgroundActive: { default: "--primary-active" },
    buttonPrimaryBorderActive: { default: "--primary-active" },
    buttonPrimaryTextActive: { default: "--white" },
    buttonPrimaryBackgroundDisabled: { default: "--blue-50" },
    buttonPrimaryBorderDisabled: { default: "--blue-50" },
    buttonPrimaryTextDisabled: { default: "--white" },
    buttonSecondaryBackground: { default: "--orange-100" },
    buttonSecondaryBorder: { default: "--orange-100" },
    buttonSecondaryText: { default: "--white" },
    buttonSecondaryBackgroundHover: { default: "--orange-130" },
    buttonSecondaryBorderHover: { default: "--orange-130" },
    buttonSecondaryTextHover: { default: "--white" },
    buttonSecondaryBackgroundActive: { default: "--orange-130" },
    buttonSecondaryBorderActive: { default: "--orange-130" },
    buttonSecondaryTextActive: { default: "--white" },
    buttonSecondaryBackgroundDisabled: { default: "--orange-50" },
    buttonSecondaryBorderDisabled: { default: "--orange-50" },
    buttonSecondaryTextDisabled: { default: "--white" },
    radioColor: { default: "--blue-100" },
    checkboxColor: { default: "--blue-100" },
    switchColor: { default: "--green-100" },
    switchColorHover: { default: "--green-120" }
  },
  setup(e) {
    const n = e, t = dt(null);
    return cf(() => {
      for (const [l, r] of Object.entries(n)) {
        const u = `--${A6e.kebabCase(l)}`;
        Ta().then(() => {
          t.value?.style.setProperty(
            u,
            r.startsWith("--") ? `var(${r})` : r
          );
        });
      }
    }), (l, r) => (Qe(), yn("div", {
      ref_key: "themeWrapper",
      ref: t,
      class: "lp"
    }, [
      el(l.$slots, "default")
    ], 512));
  }
});
EO.install = (e) => {
  e.component(EO.name, EO);
};
const yz = 30, OO = /* @__PURE__ */ cl({
  name: "lp-time-picker",
  inheritAttrs: !1,
  __name: "LpTimePicker",
  props: {
    modelValue: { default: null },
    default: { default: null },
    interval: { default: 5 },
    labelTop: { default: "Select time" },
    placeholder: { default: "Select time" },
    format: { default: "hh:mm a" },
    status: { default: "neutral" },
    message: { default: null },
    required: { type: Boolean, default: !1 },
    preview: { type: Boolean, default: !1 },
    dataUaUniqueId: { default: "ua-timepicker" }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, l = e, r = {
      configSlotMinutes: l.interval,
      timeArr: [{ startTime: "00:00", endTime: "24:00" }]
    }, u = _t(() => {
      const { configSlotMinutes: s, timeArr: d } = r, p = (/* @__PURE__ */ new Date()).toLocaleDateString("en-US").replace(/\//g, "-"), _ = [{ value: null, name: "Select a time" }];
      let R, F, L, G;
      for (let J = 0; J < d.length; J++)
        for (R = /* @__PURE__ */ new Date(p + " " + d[J].startTime), F = /* @__PURE__ */ new Date(p + " " + d[J].endTime), L = R; new Date(L) < new Date(che(F, parseInt(s))); )
          G = new Date(L), L = L !== R ? jz(G, parseInt(s)) : G, new Date(L) <= new Date(F) && _.push({
            value: new Date(L).toISOString(),
            name: Wo(L, l.format)
          });
      return _;
    }), o = (s) => s === null ? null : Wo(
      ohe(s, {
        nearestTo: Number(
          l.interval > yz ? yz : l.interval
        )
      }),
      l.format
    ), a = dt(o(l.modelValue)), h = () => {
      t(
        "update:modelValue",
        a.value === null ? null : Hce(a.value)
      );
    };
    return ga(() => {
      a.value = o(l.modelValue);
    }), (s, d) => {
      const p = El("lp-select");
      return Qe(), _l(p, Ni({
        modelValue: a.value,
        "onUpdate:modelValue": d[0] || (d[0] = (_) => a.value = _),
        options: u.value,
        "track-by": "value",
        "label-by": "name",
        "label-top": s.labelTop,
        placeholder: s.placeholder,
        status: s.status,
        message: s.message,
        required: s.required,
        preview: s.preview,
        "data-ua-unique-id": s.dataUaUniqueId
      }, s.$attrs, { "onUpdate:modelValue": h }), null, 16, ["modelValue", "options", "label-top", "placeholder", "status", "message", "required", "preview", "data-ua-unique-id"]);
    };
  }
});
OO.install = (e) => {
  e.component(OO.name, OO);
};
const GRe = cl({
  name: "lp-toggle",
  components: {
    ItIcon: Af
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    round: Boolean,
    icons: Boolean,
    modelValue: {
      type: [String, Number],
      required: !0
    },
    dataUaUniqueId: {
      type: String,
      default: "unique-toggle"
    },
    preview: Boolean,
    required: Boolean,
    labelTop: {
      type: String,
      required: !1,
      default: null
    }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = dt(0);
    function l(s) {
      t.value = s, n("update:modelValue", e.options[s]);
    }
    function r() {
      if (!e.options[t.value + 1]) {
        l(0);
        return;
      }
      l(t.value + 1);
    }
    function u() {
      if (!e.options[t.value - 1]) {
        l(e.options.length - 1);
        return;
      }
      l(t.value - 1);
    }
    const o = _t(() => (100 / e.options.length).toFixed(2)), a = _t(
      () => e.options.includes(e.modelValue) ? 1 : 0
    ), h = _t(() => {
      const s = e.options.findIndex((d) => d === e.modelValue);
      return (s === -1 ? 0 : s) * 100;
    });
    return {
      selectValue: l,
      selectNext: r,
      selectPrev: u,
      width: o,
      sliderPosition: h,
      opacity: a
    };
  }
}), ZRe = {
  key: 0,
  class: "lp-toggle-label font-weight-medium"
}, XRe = {
  key: 0,
  class: "text-blue"
}, QRe = ["data-ua-unique-id"], JRe = ["data-ua-unique-id"], eNe = ["onClick"], nNe = { key: 0 };
function tNe(e, n, t, l, r, u) {
  const o = El("ItIcon");
  return Qe(), yn("div", null, [
    e.labelTop ? (Qe(), yn("span", ZRe, [
      Ir(It(e.labelTop) + " ", 1),
      !e.preview && e.required ? (Qe(), yn("span", XRe, "*")) : st("", !0)
    ])) : st("", !0),
    e.preview ? (Qe(), yn("span", {
      key: 1,
      class: "lp-toggle lp-toggle-preview",
      "data-ua-unique-id": e.dataUaUniqueId
    }, It(e.modelValue), 9, QRe)) : (Qe(), yn("div", {
      key: 2,
      class: xt(["lp-toggle", { "lp-toggle-round": e.round }]),
      "data-ua-unique-id": e.dataUaUniqueId,
      tabindex: "0",
      onKeyup: [
        n[0] || (n[0] = Ei(Oi((...a) => e.selectPrev && e.selectPrev(...a), ["prevent"]), ["left"])),
        n[1] || (n[1] = Ei(Oi((...a) => e.selectNext && e.selectNext(...a), ["prevent"]), ["right"]))
      ]
    }, [
      (Qe(!0), yn(Ii, null, ru(e.options, (a, h) => (Qe(), yn("label", {
        key: h,
        class: xt(["lp-toggle-value", {
          "lp-toggle-value-selected": a === e.modelValue
        }]),
        onClick: (s) => e.selectValue(h)
      }, [
        e.icons ? (Qe(), _l(o, {
          key: 1,
          name: String(a)
        }, null, 8, ["name"])) : (Qe(), yn("span", nNe, It(a), 1))
      ], 10, eNe))), 128)),
      qn("div", {
        class: "lp-toggle-slider",
        style: Hi({
          width: e.width + "%",
          transform: `translateX(${e.sliderPosition}%)`,
          opacity: e.opacity
        })
      }, null, 4)
    ], 42, JRe))
  ]);
}
const kO = /* @__PURE__ */ Cr(GRe, [["render", tNe]]);
kO.install = (e) => {
  e.component(kO.name, kO);
};
cy.install = (e) => {
  e.component(cy.name, cy);
};
const lNe = { class: "row lp-tree-item-parent" }, rNe = { class: "lp-tree" }, iNe = {
  name: "lp-tree-node"
}, uNe = /* @__PURE__ */ cl({
  ...iNe,
  props: {
    children: { default: null },
    disabled: { type: Boolean, default: !1 }
  },
  setup(e) {
    const n = e, t = (u, o) => {
      for (const a of u.children)
        a.checked = o, a.hasChildren && t(a, o);
    }, l = (u) => {
      const o = u.children.every((d) => d.checked === !0), a = u.children.every(
        (d) => d.checked === !1
      ), h = u.children.some((d) => d.checked === !0), s = u.children.some((d) => {
        if (d.children.length)
          return l(d) === !0;
      });
      if (o || a)
        return u.checked = o, !!s;
      if (h)
        return u.checked = !0, !0;
    }, r = dt(n.children);
    return (u, o) => {
      const a = El("lp-button"), h = El("lp-checkbox"), s = El("lp-tree-node", !0);
      return Qe(!0), yn(Ii, null, ru(r.value, (d, p) => (Qe(), yn("div", {
        key: p,
        class: "lp-tree-item"
      }, [
        qn("div", {
          class: xt(["d-flex row lp-tree-item-inner", [!d.children.length && "lp-tree-item-single"]])
        }, [
          d.hasChildren ? (Qe(), _l(a, {
            key: 0,
            icon: d.isExpanded ? "chevron-down" : "chevron-right",
            text: "",
            size: "sm",
            onClick: (_) => d.isExpanded = !d.isExpanded
          }, null, 8, ["icon", "onClick"])) : st("", !0),
          dl(h, {
            modelValue: d.checked,
            "onUpdate:modelValue": [(_) => d.checked = _, (_) => d.children.length && t(d, d.checked)],
            label: d.label,
            indeterminate: d.children.length ? l(d) : !1
          }, null, 8, ["modelValue", "onUpdate:modelValue", "label", "indeterminate"])
        ], 2),
        pi(qn("div", lNe, [
          qn("div", rNe, [
            d.children.length ? (Qe(), _l(s, {
              key: 0,
              children: d.children
            }, null, 8, ["children"])) : st("", !0)
          ])
        ], 512), [
          [Pi, d.isExpanded]
        ])
      ]))), 128);
    };
  }
});
class _z {
  constructor(n, t, l = n, r = !1, u) {
    for (const o in u)
      this[o] = u[o];
    this.key = n, this.value = n, this.label = t, this.children = [], this.isExpanded = !1, this.checked = r;
  }
  get isLeaf() {
    return this.children.length === 0;
  }
  get hasChildren() {
    return !this.isLeaf;
  }
  // toggleCheck = () => {
  //   // debugger
  //   this.checked = !this.checked
  // }
  // toggleExpand = () => {
  //   // debugger
  //   this.isExpanded = !this.isExpanded
  // }
  expand = () => {
    this.isExpanded = !0;
  };
  collapse = () => {
    this.isExpanded = !1;
  };
}
class sNe {
  constructor(n, t = n) {
    this.root = new _z(n, t);
  }
  *preOrderTraversal(n = this.root) {
    if (yield n, n.children.length)
      for (const t of n.children)
        yield* this.preOrderTraversal(t);
  }
  // *postOrderTraversal(node = this.root) {
  //   if (node.children.length) {
  //     for (const child of node.children) {
  //       yield* this.postOrderTraversal(child)
  //     }
  //   }
  //   yield node
  // }
  insert(n, t, l, r = t, u, o) {
    for (const a of this.preOrderTraversal())
      if (a.key === n)
        return a.children.push(new _z(t, r, l, u, o)), !0;
    return !1;
  }
  // remove(key) {
  //   for (const node of this.preOrderTraversal()) {
  //     const filtered = node.children.filter((c) => c.key !== key)
  //     if (filtered.length !== node.children.length) {
  //       node.children = filtered
  //       return true
  //     }
  //   }
  //   return false
  // }
  collapseAll() {
    for (const n of this.preOrderTraversal())
      n.isExpanded = !1;
  }
  expandAll() {
    for (const n of this.preOrderTraversal())
      n.isExpanded = !0;
  }
  findKey(n) {
    for (const t of this.preOrderTraversal())
      if (t.key === n) return t;
  }
  // findValue(value) {
  //   for (const node of this.preOrderTraversal()) {
  //     if (node.value === value) return node
  //   }
  //   return undefined
  // }
  findFuzzy(n) {
    const t = [];
    for (const l of this.preOrderTraversal())
      l.label.toLowerCase().includes(n) && t.push(l);
    return t;
  }
}
const oNe = { class: "lp-tree" }, aNe = {
  key: 0,
  class: "mb-1"
}, cNe = {
  key: 1,
  class: "mb-1"
}, hNe = { key: 2 }, fNe = {
  name: "lp-tree",
  inheritAttrs: !1
}, bO = /* @__PURE__ */ cl({
  ...fNe,
  props: {
    modelValue: { default: null },
    children: { default: null },
    disabled: { type: Boolean, default: !1 },
    trackBy: { default: "value" },
    labelBy: { default: "name" },
    childrenBy: { default: "children" },
    showToggle: { type: Boolean, default: !1 },
    showSearch: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = e, l = n, r = (G, J) => {
      for (const we of G)
        J.insert(
          we.parentId,
          we.id,
          we[t.trackBy],
          we[t.labelBy],
          we.checked,
          we
        ), we[t.childrenBy]?.length && r(we[t.childrenBy], J);
    }, o = dt(((G) => {
      const J = new sNe(null, "_root");
      return r(G, J), J;
    })(t.children)), a = p1({
      value: _s("searchEmitValue", "") || ""
    }), h = dt(null), s = (G) => {
      a.value !== "" && (h.value = o.value.findFuzzy(a.value?.toLowerCase()), F());
    }, d = () => a.value = "", p = dt(!1), _ = (G, J) => {
      for (const we of G[t.childrenBy])
        we.checked = J, we.hasChildren && _(we, J);
    }, R = (G) => G.parentId !== null ? `${R(o.value.findKey(G.parentId))} > ${G.label}` : G.label, F = () => {
      o.value.expandAll(), p.value = !0;
    }, L = () => {
      o.value.collapseAll(), p.value = !1;
    };
    return ga(() => {
      (a.value === "" || a.value === null) && (h.value = null);
    }), di(
      () => o.value.root[t.childrenBy],
      () => {
        l("update:modelValue", o.value.root[t.childrenBy]);
      },
      { deep: !0 }
    ), (G, J) => {
      const we = El("lp-button"), ce = El("lp-input"), xe = El("lp-checkbox");
      return Qe(), yn("div", oNe, [
        G.showToggle ? (Qe(), yn("div", aNe, [
          p.value ? st("", !0) : (Qe(), _l(we, {
            key: 0,
            text: "",
            onClick: F
          }, {
            default: kl(() => [
              Ir(" Expand All ")
            ]),
            _: 1
          })),
          p.value ? (Qe(), _l(we, {
            key: 1,
            text: "",
            onClick: L
          }, {
            default: kl(() => [
              Ir(" Collapse All ")
            ]),
            _: 1
          })) : st("", !0)
        ])) : st("", !0),
        G.showSearch ? (Qe(), yn("div", cNe, [
          dl(ce, {
            modelValue: a.value,
            "onUpdate:modelValue": J[0] || (J[0] = ($e) => a.value = $e),
            placeholder: "Filter options...",
            "prefix-icon": "search",
            size: "compact",
            onKeyup: s
          }, {
            clear: kl(() => [
              a.value ? (Qe(), _l(we, {
                key: 0,
                icon: "close",
                text: "",
                onClick: d
              })) : st("", !0)
            ]),
            _: 1
          }, 8, ["modelValue"])
        ])) : st("", !0),
        pi(qn("div", null, [
          dl(uNe, {
            children: o.value.root[G.childrenBy] ?? null
          }, null, 8, ["children"])
        ], 512), [
          [Pi, h.value === null]
        ]),
        h.value ? (Qe(), yn("div", hNe, [
          (Qe(!0), yn(Ii, null, ru(h.value, ($e, je) => (Qe(), yn("div", {
            key: je,
            class: "mt-1"
          }, [
            (Qe(), _l(xe, {
              id: $e.key,
              key: $e.key,
              modelValue: $e.checked,
              "onUpdate:modelValue": [(E) => $e.checked = E, (E) => $e[G.childrenBy].length && _($e, $e.checked)],
              label: R($e),
              disabled: $e.disabled
            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "label", "disabled"]))
          ]))), 128))
        ])) : st("", !0)
      ]);
    };
  }
});
bO.install = (e) => {
  e.component(bO.name, bO);
};
const TO = /* @__PURE__ */ cl({
  name: "lp-url-input",
  inheritAttrs: !1,
  __name: "LpUrlInput",
  props: {
    modelValue: { default: null },
    preview: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, l = e, r = dt(l.modelValue), u = _t(() => {
      const a = new RegExp(
        "^(https?:\\/\\/)?((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|((\\d{1,3}\\.){3}\\d{1,3}))(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*(\\?[;&a-z\\d%_.~+=-]*)?(\\#[-a-z\\d_]*)?$",
        "i"
      );
      return r.value === "" || r.value === null ? !0 : !!a.test(r.value);
    }), o = () => {
      t("update:modelValue", r.value);
    };
    return di(
      () => l.modelValue,
      (a) => {
        r.value = a;
      },
      { immediate: !0 }
    ), (a, h) => {
      const s = El("lp-input");
      return Qe(), _l(s, Ni(a.$attrs, {
        modelValue: r.value,
        "onUpdate:modelValue": h[0] || (h[0] = (d) => r.value = d),
        status: u.value ? "neutral" : "danger",
        message: u.value ? "" : "URL is invalid",
        preview: a.preview,
        onKeyup: o
      }), null, 16, ["modelValue", "status", "message", "preview"]);
    };
  }
});
TO.install = (e) => {
  e.component(TO.name, TO);
};
const jO = /* @__PURE__ */ cl({
  name: "lp-zip-input",
  __name: "LpZipInput",
  props: {
    modelValue: { default: null },
    labelTop: { default: null },
    placeholder: { default: null },
    status: { default: "neutral" },
    message: { default: null },
    required: { type: Boolean, default: !1 },
    preview: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(e, { emit: n }) {
    const t = n, l = e, r = dt(l.modelValue), u = () => {
      t("update:modelValue", r.value);
    };
    return di(
      () => l.modelValue,
      (o) => {
        r.value = o;
      },
      { immediate: !0 }
    ), (o, a) => {
      const h = El("lp-number-input");
      return Qe(), _l(h, Ni({
        modelValue: r.value,
        "onUpdate:modelValue": a[0] || (a[0] = (s) => r.value = s),
        "label-top": o.labelTop,
        placeholder: o.placeholder,
        status: o.status,
        message: o.message,
        required: o.required,
        preview: o.preview,
        format: "zip"
      }, o.$attrs, { onKeyup: u }), null, 16, ["modelValue", "label-top", "placeholder", "status", "message", "required", "preview"]);
    };
  }
});
jO.install = (e) => {
  e.component(jO.name, jO);
};
function dNe() {
  const e = dt(300), n = dt(100), t = dt("lp-load-fadein"), l = (o) => {
    o.querySelectorAll(`.${t.value}`).forEach((h, s) => {
      setTimeout(() => {
        h.animate(
          {
            translate: "0 0",
            opacity: "1"
          },
          { duration: e.value, fill: "forwards" }
        );
      }, s * n.value);
    });
  }, r = (o) => {
    for (const a of o)
      a.type === "childList" && a.addedNodes.length && l(a.target);
  }, u = new MutationObserver(r);
  return {
    created(o, a) {
      const h = a.value, { delay: s, timeBetween: d } = h ?? {};
      s && (e.value = s), d && (n.value = d), h?.class && (t.value = h.class);
    },
    mounted(o) {
      l(o), u.observe(o, { childList: !0, subtree: !0 });
    },
    updated(o) {
      l(o);
    },
    beforeUnmount() {
      u.disconnect();
    }
  };
}
const MD = {
  Alert: I_,
  Avatar: GS,
  AvatarGroup: ZS,
  Badge: eE,
  Blueprint: XS,
  Breadcrumbs: QS,
  Button: R_,
  ButtonGroup: JS,
  Calendar: nE,
  Card: tE,
  Checkbox: lE,
  ...rE,
  RuleEditor: FE,
  Collapse: VE,
  CollapseItem: YE,
  // ColorPicker,
  ...UE,
  DatePicker: qE,
  DateRangePicker: WE,
  DateTimePicker: HE,
  Divider: zE,
  Drawer: KE,
  ...GE,
  Editor: ZE,
  EmailInput: XE,
  FlipCard: QE,
  Grid: JE,
  GuidedTour: eO,
  FilePicker: nO,
  Icon: Af,
  Input: tO,
  InputList: lO,
  List: rO,
  Loading: iO,
  LoadingCircle: uO,
  Modal: J_,
  NumberInput: C_,
  NumberRangePicker: sO,
  OptionsGroup: oO,
  PhoneInput: aO,
  Popover: cO,
  Progressbar: hO,
  Radio: fO,
  RadioGroup: dO,
  ...pO,
  Slider: mO,
  SocialSecurityInput: gO,
  Spinner: wO,
  Switch: vO,
  Tabs: yO,
  Tab: _O,
  Tag: xO,
  Textarea: SO,
  Theme: EO,
  TimePicker: OO,
  Toggle: kO,
  Tooltip: cy,
  Tree: bO,
  UrlInput: TO,
  ZipInput: jO
};
function pNe(e, n) {
  for (const l in MD)
    e.component(MD[l].name, MD[l]);
  e.config.globalProperties.$Theme = n, e.config.globalProperties.$Message = m3, e.config.globalProperties.$Notification = g3, e.config.globalProperties.$Loading = QDe, e.config.globalProperties.$LpComponents = {
    drawers: [],
    modals: []
  }, e.provide("customTheme", n ?? null), e.config.globalProperties.$Theme = n ?? null;
  const t = dNe();
  e.directive("load-fade-in", t);
}
const vNe = { install: pNe }, mNe = '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="162" height="27"><defs><path id="a" d="M0 0h18.319v26.242H0z"/><path id="c" d="M0 0h4.335v4.569H0z"/></defs><g fill="none" fill-rule="evenodd"><path fill="#FF9100" d="M22.989.326a3.27 3.27 0 1 1-.001 6.539 3.27 3.27 0 0 1 0-6.539M13.13.326a3.27 3.27 0 1 1-.001 6.54 3.27 3.27 0 0 1 0-6.54M3.27.326a3.27 3.27 0 1 1 0 6.54 3.27 3.27 0 0 1 0-6.54"/><path fill="#FF9100" d="M37.466 22.43V.284h-4.643v26.242h14.596V22.43zM56.906 26.82c-5.368 0-9.177-4.02-9.177-9.977 0-5.958 3.809-9.978 9.177-9.978 5.368 0 9.178 4.02 9.178 9.978s-3.81 9.977-9.178 9.977m0-3.691c2.94 0 4.788-2.376 4.788-6.286 0-3.91-1.849-6.287-4.788-6.287-2.938 0-4.787 2.376-4.787 6.287 0 3.91 1.849 6.286 4.787 6.286M87.67 7.34h4.352v2.047c1.089-1.279 2.793-2.412 5.26-2.412 3.99 0 6.383 2.777 6.383 6.907v12.646h-4.352V15.161c0-2.374-.943-4.093-3.336-4.093-1.96 0-3.955 1.463-3.955 4.203v11.257H87.67V7.34ZM138.215 11.69c-.544-.074-.98-.11-1.596-.11-2.757 0-4.86 1.79-4.86 4.86v10.088h-4.354V7.34h4.354v2.85c.834-1.79 2.792-2.96 5.223-2.96.507 0 .906.038 1.233.074v4.385ZM148.428 26.82c-5.337 0-9.123-4.02-9.123-9.977 0-5.958 3.786-9.978 9.123-9.978s9.122 4.02 9.122 9.978-3.785 9.977-9.122 9.977m0-3.691c2.92 0 4.76-2.376 4.76-6.286 0-3.91-1.84-6.287-4.76-6.287-2.921 0-4.76 2.376-4.76 6.287 0 3.91 1.839 6.286 4.76 6.286"/><g transform="translate(106.621 .283)"><mask id="b" fill="#fff"><use xlink:href="#a"/></mask><path fill="#FF9100" d="M8.89 0H0v26.242h4.643V15.194H8.89c5.803 0 9.43-2.37 9.43-7.597C18.32 2.297 14.692 0 8.89 0m-.254 11.174H4.643V4.02h3.993c3.336 0 5.113.983 5.113 3.577 0 2.558-1.777 3.577-5.113 3.577" mask="url(#b)"/></g><path fill="#FF9100" d="M67.509 21.119c0-3.655 2.72-5.263 6.384-6.031l5.26-1.096v-.329c0-1.828-.944-2.96-3.265-2.96-2.067 0-3.156.95-3.663 2.814l-4.1-.95c.944-3.18 3.737-5.665 7.944-5.665 4.57 0 7.327 2.192 7.327 6.615v8.26c0 1.097.472 1.425 1.669 1.28v3.397c-3.156.367-4.824-.255-5.478-1.827-1.196 1.352-3.192 2.156-5.658 2.156-3.626 0-6.42-2.23-6.42-5.664Zm11.644-4.02-4.1.877c-1.849.402-3.228.987-3.228 2.705 0 1.498 1.088 2.34 2.758 2.34 2.32 0 4.57-1.244 4.57-3.584v-2.339Z"/><path fill="#FF9100" d="M13.076 20.014a3.255 3.255 0 1 1 0 6.509 3.255 3.255 0 0 1 0-6.51M3.263 20.014a3.255 3.255 0 1 1 0 6.509 3.255 3.255 0 0 1 0-6.51M13.13 10.185a3.27 3.27 0 1 1-.001 6.54 3.27 3.27 0 0 1 0-6.54M3.27 10.185a3.27 3.27 0 1 1 0 6.54 3.27 3.27 0 0 1 0-6.54"/><g transform="translate(157.592 22.25)"><mask id="d" fill="#fff"><use xlink:href="#c"/></mask><path fill="#27313F" d="M1.627 2.266h.625a.693.693 0 0 0 .473-.156.511.511 0 0 0 .178-.405c0-.2-.052-.343-.157-.428-.104-.086-.276-.13-.514-.135h-.605v1.124Zm0 .17v1.075h-.168V.977h.73c.587 0 .882.244.882.733 0 .293-.156.502-.466.629.268.079.402.29.402.634 0 .227.017.389.052.49v.048h-.18c-.03-.074-.043-.252-.043-.538 0-.187-.04-.322-.118-.405-.078-.084-.213-.127-.404-.132h-.687Zm-1.46-.155c0 .378.089.732.266 1.059.176.327.42.587.73.778.308.192.644.287 1.004.287.358 0 .693-.095 1.001-.287.31-.19.554-.451.73-.778a2.19 2.19 0 0 0 .266-1.06c0-.38-.089-.733-.266-1.06a2.014 2.014 0 0 0-.731-.77 1.89 1.89 0 0 0-1-.285c-.358 0-.692.095-1.003.285-.31.189-.555.446-.73.77a2.181 2.181 0 0 0-.267 1.06ZM0 2.28c0-.411.095-.793.284-1.145.19-.352.454-.63.791-.832A2.077 2.077 0 0 1 2.167 0c.392 0 .755.1 1.092.304.337.203.6.48.79.832.191.352.286.734.286 1.145 0 .405-.093.782-.278 1.132-.184.35-.447.63-.783.841a2.045 2.045 0 0 1-1.107.315c-.4 0-.77-.103-1.107-.315a2.182 2.182 0 0 1-.782-.84A2.389 2.389 0 0 1 0 2.28Z" mask="url(#d)"/></g></g></svg>', gNe = `data:image/svg+xml;base64,${btoa(mNe)}`;
console.info(
  // `%cLoanPro UI ${import.meta.env.PACKAGE_VERSION}`,
  "%c UI 1.11.11",
  `background-size: 50% ;background-position: left center;background-repeat: no-repeat;color: #FF9100; background-image: url(${gNe}); font-family: Roboto, sans-serif; font-weigth: 700; font-size: 1rem; padding: 1rem 2rem 1rem 7rem;`
);
export {
  I_ as Alert,
  GS as Avatar,
  ZS as AvatarGroup,
  eE as Badge,
  XS as Blueprint,
  QS as Breadcrumbs,
  R_ as Button,
  JS as ButtonGroup,
  nE as Calendar,
  tE as Card,
  lE as Checkbox,
  rE as CheckboxGroup,
  VE as Collapse,
  YE as CollapseItem,
  UE as DataTable,
  qE as DatePicker,
  WE as DateRangePicker,
  HE as DateTimePicker,
  zE as Divider,
  KE as Drawer,
  GE as Dropdown,
  ZE as Editor,
  XE as EmailInput,
  nO as FilePicker,
  JE as Grid,
  eO as GuidedTour,
  Af as Icon,
  tO as Input,
  lO as InputList,
  rO as List,
  iO as Loading,
  uO as LoadingCircle,
  QDe as Loadingbar,
  m3 as Message,
  J_ as Modal,
  g3 as Notification,
  C_ as NumberInput,
  sO as NumberRangePicker,
  oO as OptionsGroup,
  aO as PhoneInput,
  cO as Popover,
  hO as Progressbar,
  fO as Radio,
  dO as RadioGroup,
  FE as RuleEditor,
  pO as Select,
  mO as Slider,
  gO as SocialSecurityInput,
  wO as Spinner,
  vO as Switch,
  _O as Tab,
  yO as Tabs,
  xO as Tag,
  SO as Textarea,
  EO as Theme,
  OO as TimePicker,
  kO as Toggle,
  cy as Tooltip,
  bO as Tree,
  TO as UrlInput,
  jO as ZipInput,
  vNe as default
};
